import * as w from "react";
import K, { useContext as oi, useState as se, useMemo as v, createContext as Ot, Component as L9, createElement as au, useCallback as I, useRef as Ye, useEffect as be, useId as ul, useInsertionEffect as $9, Children as O8, isValidElement as jc, useLayoutEffect as as, forwardRef as Li, Fragment as Xs, memo as g, Suspense as E8 } from "react";
import * as Gu from "react-dom";
import pf from "react-dom";
function J8(e, n) {
  for (var i = 0; i < n.length; i++) {
    const t = n[i];
    if (typeof t != "string" && !Array.isArray(t)) {
      for (const a in t)
        if (a !== "default" && !(a in e)) {
          const s = Object.getOwnPropertyDescriptor(t, a);
          s && Object.defineProperty(e, a, s.get ? s : {
            enumerable: !0,
            get: () => t[a]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var Be = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ls(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function _8(e) {
  if (e.__esModule) return e;
  var n = e.default;
  if (typeof n == "function") {
    var i = function t() {
      return this instanceof t ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    i.prototype = n.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(t) {
    var a = Object.getOwnPropertyDescriptor(e, t);
    Object.defineProperty(i, t, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[t];
      }
    });
  }), i;
}
var P3 = { exports: {} }, Wr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dp;
function Q8() {
  if (Dp) return Wr;
  Dp = 1;
  var e = K, n = Symbol.for("react.element"), i = Symbol.for("react.fragment"), t = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function r(o, d, c) {
    var u, k = {}, m = null, f = null;
    c !== void 0 && (m = "" + c), d.key !== void 0 && (m = "" + d.key), d.ref !== void 0 && (f = d.ref);
    for (u in d) t.call(d, u) && !s.hasOwnProperty(u) && (k[u] = d[u]);
    if (o && o.defaultProps) for (u in d = o.defaultProps, d) k[u] === void 0 && (k[u] = d[u]);
    return { $$typeof: n, type: o, key: m, ref: f, props: k, _owner: a.current };
  }
  return Wr.Fragment = i, Wr.jsx = r, Wr.jsxs = r, Wr;
}
var Kr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wp;
function M8() {
  return wp || (wp = 1, process.env.NODE_ENV !== "production" && function() {
    var e = K, n = Symbol.for("react.element"), i = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), o = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), k = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), p = Symbol.iterator, h = "@@iterator";
    function N(U) {
      if (U === null || typeof U != "object")
        return null;
      var de = p && U[p] || U[h];
      return typeof de == "function" ? de : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function F(U) {
      {
        for (var de = arguments.length, Pe = new Array(de > 1 ? de - 1 : 0), qe = 1; qe < de; qe++)
          Pe[qe - 1] = arguments[qe];
        y("error", U, Pe);
      }
    }
    function y(U, de, Pe) {
      {
        var qe = S.ReactDebugCurrentFrame, xn = qe.getStackAddendum();
        xn !== "" && (de += "%s", Pe = Pe.concat([xn]));
        var On = Pe.map(function(bn) {
          return String(bn);
        });
        On.unshift("Warning: " + de), Function.prototype.apply.call(console[U], console, On);
      }
    }
    var x = !1, R = !1, T = !1, j = !1, A = !1, B;
    B = Symbol.for("react.module.reference");
    function W(U) {
      return !!(typeof U == "string" || typeof U == "function" || U === t || U === s || A || U === a || U === c || U === u || j || U === f || x || R || T || typeof U == "object" && U !== null && (U.$$typeof === m || U.$$typeof === k || U.$$typeof === r || U.$$typeof === o || U.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      U.$$typeof === B || U.getModuleId !== void 0));
    }
    function E(U, de, Pe) {
      var qe = U.displayName;
      if (qe)
        return qe;
      var xn = de.displayName || de.name || "";
      return xn !== "" ? Pe + "(" + xn + ")" : Pe;
    }
    function $(U) {
      return U.displayName || "Context";
    }
    function V(U) {
      if (U == null)
        return null;
      if (typeof U.tag == "number" && F("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof U == "function")
        return U.displayName || U.name || null;
      if (typeof U == "string")
        return U;
      switch (U) {
        case t:
          return "Fragment";
        case i:
          return "Portal";
        case s:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof U == "object")
        switch (U.$$typeof) {
          case o:
            var de = U;
            return $(de) + ".Consumer";
          case r:
            var Pe = U;
            return $(Pe._context) + ".Provider";
          case d:
            return E(U, U.render, "ForwardRef");
          case k:
            var qe = U.displayName || null;
            return qe !== null ? qe : V(U.type) || "Memo";
          case m: {
            var xn = U, On = xn._payload, bn = xn._init;
            try {
              return V(bn(On));
            } catch (un) {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, O = 0, M, L, _, z, ne, Se, he;
    function ue() {
    }
    ue.__reactDisabledLog = !0;
    function oe() {
      {
        if (O === 0) {
          M = console.log, L = console.info, _ = console.warn, z = console.error, ne = console.group, Se = console.groupCollapsed, he = console.groupEnd;
          var U = {
            configurable: !0,
            enumerable: !0,
            value: ue,
            writable: !0
          };
          Object.defineProperties(console, {
            info: U,
            log: U,
            warn: U,
            error: U,
            group: U,
            groupCollapsed: U,
            groupEnd: U
          });
        }
        O++;
      }
    }
    function $e() {
      {
        if (O--, O === 0) {
          var U = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, U, {
              value: M
            }),
            info: H({}, U, {
              value: L
            }),
            warn: H({}, U, {
              value: _
            }),
            error: H({}, U, {
              value: z
            }),
            group: H({}, U, {
              value: ne
            }),
            groupCollapsed: H({}, U, {
              value: Se
            }),
            groupEnd: H({}, U, {
              value: he
            })
          });
        }
        O < 0 && F("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var we = S.ReactCurrentDispatcher, ie;
    function De(U, de, Pe) {
      {
        if (ie === void 0)
          try {
            throw Error();
          } catch (xn) {
            var qe = xn.stack.trim().match(/\n( *(at )?)/);
            ie = qe && qe[1] || "";
          }
        return `
` + ie + U;
      }
    }
    var _e = !1, Ie;
    {
      var Fe = typeof WeakMap == "function" ? WeakMap : Map;
      Ie = new Fe();
    }
    function re(U, de) {
      if (!U || _e)
        return "";
      {
        var Pe = Ie.get(U);
        if (Pe !== void 0)
          return Pe;
      }
      var qe;
      _e = !0;
      var xn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var On;
      On = we.current, we.current = null, oe();
      try {
        if (de) {
          var bn = function() {
            throw Error();
          };
          if (Object.defineProperty(bn.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(bn, []);
            } catch (Ki) {
              qe = Ki;
            }
            Reflect.construct(U, [], bn);
          } else {
            try {
              bn.call();
            } catch (Ki) {
              qe = Ki;
            }
            U.call(bn.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ki) {
            qe = Ki;
          }
          U();
        }
      } catch (Ki) {
        if (Ki && qe && typeof Ki.stack == "string") {
          for (var un = Ki.stack.split(`
`), Ri = qe.stack.split(`
`), ai = un.length - 1, mi = Ri.length - 1; ai >= 1 && mi >= 0 && un[ai] !== Ri[mi]; )
            mi--;
          for (; ai >= 1 && mi >= 0; ai--, mi--)
            if (un[ai] !== Ri[mi]) {
              if (ai !== 1 || mi !== 1)
                do
                  if (ai--, mi--, mi < 0 || un[ai] !== Ri[mi]) {
                    var ft = `
` + un[ai].replace(" at new ", " at ");
                    return U.displayName && ft.includes("<anonymous>") && (ft = ft.replace("<anonymous>", U.displayName)), typeof U == "function" && Ie.set(U, ft), ft;
                  }
                while (ai >= 1 && mi >= 0);
              break;
            }
        }
      } finally {
        _e = !1, we.current = On, $e(), Error.prepareStackTrace = xn;
      }
      var Ba = U ? U.displayName || U.name : "", qa = Ba ? De(Ba) : "";
      return typeof U == "function" && Ie.set(U, qa), qa;
    }
    function Me(U, de, Pe) {
      return re(U, !1);
    }
    function ge(U) {
      var de = U.prototype;
      return !!(de && de.isReactComponent);
    }
    function rn(U, de, Pe) {
      if (U == null)
        return "";
      if (typeof U == "function")
        return re(U, ge(U));
      if (typeof U == "string")
        return De(U);
      switch (U) {
        case c:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof U == "object")
        switch (U.$$typeof) {
          case d:
            return Me(U.render);
          case k:
            return rn(U.type, de, Pe);
          case m: {
            var qe = U, xn = qe._payload, On = qe._init;
            try {
              return rn(On(xn), de, Pe);
            } catch (bn) {
            }
          }
        }
      return "";
    }
    var Sn = Object.prototype.hasOwnProperty, Jn = {}, Xn = S.ReactDebugCurrentFrame;
    function Mn(U) {
      if (U) {
        var de = U._owner, Pe = rn(U.type, U._source, de ? de.type : null);
        Xn.setExtraStackFrame(Pe);
      } else
        Xn.setExtraStackFrame(null);
    }
    function Zn(U, de, Pe, qe, xn) {
      {
        var On = Function.call.bind(Sn);
        for (var bn in U)
          if (On(U, bn)) {
            var un = void 0;
            try {
              if (typeof U[bn] != "function") {
                var Ri = Error((qe || "React class") + ": " + Pe + " type `" + bn + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof U[bn] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ri.name = "Invariant Violation", Ri;
              }
              un = U[bn](de, bn, qe, Pe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ai) {
              un = ai;
            }
            un && !(un instanceof Error) && (Mn(xn), F("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", qe || "React class", Pe, bn, typeof un), Mn(null)), un instanceof Error && !(un.message in Jn) && (Jn[un.message] = !0, Mn(xn), F("Failed %s type: %s", Pe, un.message), Mn(null));
          }
      }
    }
    var mn = Array.isArray;
    function We(U) {
      return mn(U);
    }
    function pi(U) {
      {
        var de = typeof Symbol == "function" && Symbol.toStringTag, Pe = de && U[Symbol.toStringTag] || U.constructor.name || "Object";
        return Pe;
      }
    }
    function Fi(U) {
      try {
        return ut(U), !1;
      } catch (de) {
        return !0;
      }
    }
    function ut(U) {
      return "" + U;
    }
    function ti(U) {
      if (Fi(U))
        return F("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pi(U)), ut(U);
    }
    var Ui = S.ReactCurrentOwner, Ct = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xt, Di;
    function Bt(U) {
      if (Sn.call(U, "ref")) {
        var de = Object.getOwnPropertyDescriptor(U, "ref").get;
        if (de && de.isReactWarning)
          return !1;
      }
      return U.ref !== void 0;
    }
    function wi(U) {
      if (Sn.call(U, "key")) {
        var de = Object.getOwnPropertyDescriptor(U, "key").get;
        if (de && de.isReactWarning)
          return !1;
      }
      return U.key !== void 0;
    }
    function Pi(U, de) {
      typeof U.ref == "string" && Ui.current;
    }
    function Vi(U, de) {
      {
        var Pe = function() {
          xt || (xt = !0, F("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", de));
        };
        Pe.isReactWarning = !0, Object.defineProperty(U, "key", {
          get: Pe,
          configurable: !0
        });
      }
    }
    function mt(U, de) {
      {
        var Pe = function() {
          Di || (Di = !0, F("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", de));
        };
        Pe.isReactWarning = !0, Object.defineProperty(U, "ref", {
          get: Pe,
          configurable: !0
        });
      }
    }
    var ot = function(U, de, Pe, qe, xn, On, bn) {
      var un = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: U,
        key: de,
        ref: Pe,
        props: bn,
        // Record the component responsible for creating this element.
        _owner: On
      };
      return un._store = {}, Object.defineProperty(un._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(un, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: qe
      }), Object.defineProperty(un, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xn
      }), Object.freeze && (Object.freeze(un.props), Object.freeze(un)), un;
    };
    function qt(U, de, Pe, qe, xn) {
      {
        var On, bn = {}, un = null, Ri = null;
        Pe !== void 0 && (ti(Pe), un = "" + Pe), wi(de) && (ti(de.key), un = "" + de.key), Bt(de) && (Ri = de.ref, Pi(de, xn));
        for (On in de)
          Sn.call(de, On) && !Ct.hasOwnProperty(On) && (bn[On] = de[On]);
        if (U && U.defaultProps) {
          var ai = U.defaultProps;
          for (On in ai)
            bn[On] === void 0 && (bn[On] = ai[On]);
        }
        if (un || Ri) {
          var mi = typeof U == "function" ? U.displayName || U.name || "Unknown" : U;
          un && Vi(bn, mi), Ri && mt(bn, mi);
        }
        return ot(U, un, Ri, xn, qe, Ui.current, bn);
      }
    }
    var Gt = S.ReactCurrentOwner, Le = S.ReactDebugCurrentFrame;
    function Xe(U) {
      if (U) {
        var de = U._owner, Pe = rn(U.type, U._source, de ? de.type : null);
        Le.setExtraStackFrame(Pe);
      } else
        Le.setExtraStackFrame(null);
    }
    var gn;
    gn = !1;
    function Ze(U) {
      return typeof U == "object" && U !== null && U.$$typeof === n;
    }
    function vn() {
      {
        if (Gt.current) {
          var U = V(Gt.current.type);
          if (U)
            return `

Check the render method of \`` + U + "`.";
        }
        return "";
      }
    }
    function zn(U) {
      return "";
    }
    var je = {};
    function He(U) {
      {
        var de = vn();
        if (!de) {
          var Pe = typeof U == "string" ? U : U.displayName || U.name;
          Pe && (de = `

Check the top-level render call using <` + Pe + ">.");
        }
        return de;
      }
    }
    function sn(U, de) {
      {
        if (!U._store || U._store.validated || U.key != null)
          return;
        U._store.validated = !0;
        var Pe = He(de);
        if (je[Pe])
          return;
        je[Pe] = !0;
        var qe = "";
        U && U._owner && U._owner !== Gt.current && (qe = " It was passed a child from " + V(U._owner.type) + "."), Xe(U), F('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Pe, qe), Xe(null);
      }
    }
    function ei(U, de) {
      {
        if (typeof U != "object")
          return;
        if (We(U))
          for (var Pe = 0; Pe < U.length; Pe++) {
            var qe = U[Pe];
            Ze(qe) && sn(qe, de);
          }
        else if (Ze(U))
          U._store && (U._store.validated = !0);
        else if (U) {
          var xn = N(U);
          if (typeof xn == "function" && xn !== U.entries)
            for (var On = xn.call(U), bn; !(bn = On.next()).done; )
              Ze(bn.value) && sn(bn.value, de);
        }
      }
    }
    function hn(U) {
      {
        var de = U.type;
        if (de == null || typeof de == "string")
          return;
        var Pe;
        if (typeof de == "function")
          Pe = de.propTypes;
        else if (typeof de == "object" && (de.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        de.$$typeof === k))
          Pe = de.propTypes;
        else
          return;
        if (Pe) {
          var qe = V(de);
          Zn(Pe, U.props, "prop", qe, U);
        } else if (de.PropTypes !== void 0 && !gn) {
          gn = !0;
          var xn = V(de);
          F("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", xn || "Unknown");
        }
        typeof de.getDefaultProps == "function" && !de.getDefaultProps.isReactClassApproved && F("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ni(U) {
      {
        for (var de = Object.keys(U.props), Pe = 0; Pe < de.length; Pe++) {
          var qe = de[Pe];
          if (qe !== "children" && qe !== "key") {
            Xe(U), F("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", qe), Xe(null);
            break;
          }
        }
        U.ref !== null && (Xe(U), F("Invalid attribute `ref` supplied to `React.Fragment`."), Xe(null));
      }
    }
    var _i = {};
    function ui(U, de, Pe, qe, xn, On) {
      {
        var bn = W(U);
        if (!bn) {
          var un = "";
          (U === void 0 || typeof U == "object" && U !== null && Object.keys(U).length === 0) && (un += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ri = zn();
          Ri ? un += Ri : un += vn();
          var ai;
          U === null ? ai = "null" : We(U) ? ai = "array" : U !== void 0 && U.$$typeof === n ? (ai = "<" + (V(U.type) || "Unknown") + " />", un = " Did you accidentally export a JSX literal instead of a component?") : ai = typeof U, F("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ai, un);
        }
        var mi = qt(U, de, Pe, xn, On);
        if (mi == null)
          return mi;
        if (bn) {
          var ft = de.children;
          if (ft !== void 0)
            if (qe)
              if (We(ft)) {
                for (var Ba = 0; Ba < ft.length; Ba++)
                  ei(ft[Ba], U);
                Object.freeze && Object.freeze(ft);
              } else
                F("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ei(ft, U);
        }
        if (Sn.call(de, "key")) {
          var qa = V(U), Ki = Object.keys(de).filter(function(i0) {
            return i0 !== "key";
          }), zr = Ki.length > 0 ? "{key: someKey, " + Ki.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!_i[qa + zr]) {
            var n0 = Ki.length > 0 ? "{" + Ki.join(": ..., ") + ": ...}" : "{}";
            F(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, zr, qa, n0, qa), _i[qa + zr] = !0;
          }
        }
        return U === t ? ni(mi) : hn(mi), mi;
      }
    }
    function kt(U, de, Pe) {
      return ui(U, de, Pe, !0);
    }
    function e0(U, de, Pe) {
      return ui(U, de, Pe, !1);
    }
    var Hr = e0, Kd = kt;
    Kr.Fragment = t, Kr.jsx = Hr, Kr.jsxs = Kd;
  }()), Kr;
}
process.env.NODE_ENV === "production" ? P3.exports = Q8() : P3.exports = M8();
var l = P3.exports;
const U9 = Ot(null), d0 = {
  didCatch: !1,
  error: null
};
class Nf extends L9 {
  constructor(n) {
    super(n), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = d0;
  }
  static getDerivedStateFromError(n) {
    return {
      didCatch: !0,
      error: n
    };
  }
  resetErrorBoundary() {
    const {
      error: n
    } = this.state;
    if (n !== null) {
      for (var i, t, a = arguments.length, s = new Array(a), r = 0; r < a; r++)
        s[r] = arguments[r];
      (i = (t = this.props).onReset) === null || i === void 0 || i.call(t, {
        args: s,
        reason: "imperative-api"
      }), this.setState(d0);
    }
  }
  componentDidCatch(n, i) {
    var t, a;
    (t = (a = this.props).onError) === null || t === void 0 || t.call(a, n, i);
  }
  componentDidUpdate(n, i) {
    const {
      didCatch: t
    } = this.state, {
      resetKeys: a
    } = this.props;
    if (t && i.error !== null && L8(n.resetKeys, a)) {
      var s, r;
      (s = (r = this.props).onReset) === null || s === void 0 || s.call(r, {
        next: a,
        prev: n.resetKeys,
        reason: "keys"
      }), this.setState(d0);
    }
  }
  render() {
    const {
      children: n,
      fallbackRender: i,
      FallbackComponent: t,
      fallback: a
    } = this.props, {
      didCatch: s,
      error: r
    } = this.state;
    let o = n;
    if (s) {
      const d = {
        error: r,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof i == "function")
        o = i(d);
      else if (t)
        o = au(t, d);
      else if (a !== void 0)
        o = a;
      else
        throw r;
    }
    return au(U9.Provider, {
      value: {
        didCatch: s,
        error: r,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, o);
  }
}
function L8() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== n.length || e.some((i, t) => !Object.is(i, n[t]));
}
function $8(e) {
  if (e == null || typeof e.didCatch != "boolean" || typeof e.resetErrorBoundary != "function")
    throw new Error("ErrorBoundaryContext not found");
}
function hr() {
  const e = oi(U9);
  $8(e);
  const [n, i] = se({
    error: null,
    hasError: !1
  }), t = v(() => ({
    resetBoundary: () => {
      e.resetErrorBoundary(), i({
        error: null,
        hasError: !1
      });
    },
    showBoundary: (a) => i({
      error: a,
      hasError: !0
    })
  }), [e.resetErrorBoundary]);
  if (n.hasError)
    throw n.error;
  return t;
}
const U8 = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), V8 = () => ({
  kind: "Initialized"
}), H8 = (e) => {
  const { showBoundary: n } = hr(), [i, t] = se(U8(e)), a = I((r) => {
    t(r);
  }, []), s = Ye(!1);
  return be(() => {
    s.current || i.kind !== "NotInitialized" || (s.current = !0, i.onInitialize().then(() => {
      const r = V8();
      a(r);
    }).catch(() => {
      n(new Error());
    }));
  }, [a, e, i, n]), {
    state: i
  };
};
function Wu(e, n) {
  return n;
}
var $l = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.Room = "ROOM", e))($l || {}), Qt = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.PersonOnlyKids = "PERSON_ONLY_KIDS", e.Room = "ROOM", e))(Qt || {}), nt = /* @__PURE__ */ ((e) => (e.PerDate = "PER_DATE", e.PerReservation = "PER_RESERVATION", e))(nt || {}), Ku = /* @__PURE__ */ ((e) => (e.Jpy = "jpy", e))(Ku || {}), Rt = /* @__PURE__ */ ((e) => (e.Cin = "CIN", e.MiddleDay = "MIDDLE_DAY", e.NotSelected = "NOT_SELECTED", e))(Rt || {}), Un = /* @__PURE__ */ ((e) => (e.Cin = "CIN", e.Cout = "COUT", e.DayTripSelected = "DAY_TRIP_SELECTED", e.MiddleDay = "MIDDLE_DAY", e.NotSelected = "NOT_SELECTED", e))(Un || {}), _a = /* @__PURE__ */ ((e) => (e.Building = "Building", e.Cottage = "Cottage", e.Room = "Room", e.Space = "Space", e.Tent = "Tent", e))(_a || {}), Qs = /* @__PURE__ */ ((e) => (e.Minus = "minus", e.NotAvailable = "not_available", e.Ratio = "ratio", e.Static = "static", e))(Qs || {}), D = /* @__PURE__ */ ((e) => (e.Default = "default", e.En = "en", e))(D || {}), _l = /* @__PURE__ */ ((e) => (e.Breakfast = "BREAKFAST", e.Dinner = "DINNER", e.Lunch = "LUNCH", e.RoomOnly = "ROOM_ONLY", e))(_l || {}), Z = /* @__PURE__ */ ((e) => (e.None = "None", e.RegularOnly = "RegularOnly", e.TimeSlotAndRegular = "TimeSlotAndRegular", e.TimeSlotOnly = "TimeSlotOnly", e))(Z || {}), Zs = /* @__PURE__ */ ((e) => (e.Goods = "GOODS", e.Service = "SERVICE", e))(Zs || {}), Yu = /* @__PURE__ */ ((e) => (e.Credit = "CREDIT", e.Free = "FREE", e.Local = "LOCAL", e.Test = "TEST", e))(Yu || {}), It = /* @__PURE__ */ ((e) => (e.AllPlans = "ALL_PLANS", e.OnlyAccommodationPlans = "ONLY_ACCOMMODATION_PLANS", e.OnlyDayTripPlans = "ONLY_DAY_TRIP_PLANS", e))(It || {}), Ms = /* @__PURE__ */ ((e) => (e.Check = "CHECK", e.Free = "FREE", e.Radio = "RADIO", e.Select = "SELECT", e))(Ms || {}), X = /* @__PURE__ */ ((e) => (e.EditReservation = "EDIT_RESERVATION", e.EditReservationAuthorizedFailed = "EDIT_RESERVATION_AUTHORIZED_FAILED", e.EditReservationCreditCardOnly = "EDIT_RESERVATION_CREDIT_CARD_ONLY", e.EditReservationOptionUpdateOnly = "EDIT_RESERVATION_OPTION_UPDATE_ONLY", e.NewReservation = "NEW_RESERVATION", e))(X || {}), ml = /* @__PURE__ */ ((e) => (e.PaymentFailed = "PAYMENT_FAILED", e.StockIsNotAvailable = "STOCK_IS_NOT_AVAILABLE", e))(ml || {}), pn = /* @__PURE__ */ ((e) => (e.CreditCardContinuedUse = "CREDIT_CARD_CONTINUED_USE", e.CreditCardNewlyRegistration = "CREDIT_CARD_NEWLY_REGISTRATION", e.Free = "FREE", e.Local = "LOCAL", e.Test = "TEST", e))(pn || {}), Ul = /* @__PURE__ */ ((e) => (e.Available = "AVAILABLE", e.Few = "FEW", e.Full = "FULL", e))(Ul || {});
const V9 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, H9 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "SelectOptionAvailableOptionsFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AvailableOptionsResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableOptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTerm" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTarget" } }, { kind: "Field", name: { kind: "Name", value: "optionType" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "isRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDateTabbedTimeSelectionEnabled" } }, { kind: "Field", name: { kind: "Name", value: "isDateTabbedTimeSelectionTarget" } }, { kind: "Field", name: { kind: "Name", value: "isOneOfRequired" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "detail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionBillingPerDate" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isNextMorning" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionBillingPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubOptionBillingPerDate" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multiSelectAvailable" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "maxSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "subOptionItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }, { kind: "Field", name: { kind: "Name", value: "isNextMorning" } }, { kind: "Field", name: { kind: "Name", value: "startAt" } }, { kind: "Field", name: { kind: "Name", value: "endAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowTimeSchedule" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubOptionBillingPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multiSelectAvailable" } }, { kind: "Field", name: { kind: "Name", value: "maxSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }, { kind: "Field", name: { kind: "Name", value: "startAt" } }, { kind: "Field", name: { kind: "Name", value: "endAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowTimeSchedule" } }] } }] } }] } }] } }] } }] }, z9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCReservationInitialSessionState" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lang" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LangCode" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationIdOfReplicationSource" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } }, type: { kind: "NamedType", name: { kind: "Name", value: "SessionInitializeOptionInfoInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationInitialSessionState" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "lang" }, value: { kind: "Variable", name: { kind: "Name", value: "lang" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationIDOfReplicationSource" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationIdOfReplicationSource" } } }, { kind: "Argument", name: { kind: "Name", value: "optionInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, B9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "InputAOTOSAOTOSUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "isAgree" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfServiceSet" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "isAgree" }, value: { kind: "Variable", name: { kind: "Name", value: "isAgree" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, q9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "InputDiscountDiscountUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "discountInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DiscountUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "discountInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "discountInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, G9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "InputGuestInfoGuestInfoUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "guestInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GuestInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "guestInfoSet" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "guestInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "guestInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, W9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCReserveWithCreditPaymentEncodeCallBackUrlForExistingReservation" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "creditCardInfoInput" } }, type: { kind: "NamedType", name: { kind: "Name", value: "CreditCardInfoInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveWithCreditPaymentEncodeCallBackUrlForExistingReservation" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } } }, { kind: "Argument", name: { kind: "Name", value: "creditCardInfoInput" }, value: { kind: "Variable", name: { kind: "Name", value: "creditCardInfoInput" } } }] }] } }] }, K9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCReserveWithCreditPaymentEncodeCallBackForNewReservation" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "creditCardInfoInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "CreditCardInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveWithCreditPaymentEncodeCallBackUrlForNewReservation" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } } }, { kind: "Argument", name: { kind: "Name", value: "creditCardInfoInput" }, value: { kind: "Variable", name: { kind: "Name", value: "creditCardInfoInput" } } }] }] } }] }, Y9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCReserveWithFreePayment" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveWithFreePayment" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }] } }] } }] }, X9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCReserveWithLocalPayment" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveWithLocalPayment" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }] } }] } }] }, Z9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCReserveWithTestPayment" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveWithTestPayment" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }] } }] } }] }, eF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "InputQAAAQAAUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "questionAndAnswerInfo" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "QuestionAndAnswerUpdateInput" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionAndAnswerUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "questionAndAnswerInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "questionAndAnswerInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, nF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "InputVoucherVoucherRemove" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "voucherInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "VoucherInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherRemove" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "voucherInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "voucherInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, iF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "InputVoucherVoucherUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "voucherInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "VoucherInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherSet" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "voucherInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "voucherInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, tF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCSelectDateDateUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dataUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "dateInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, aF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SelectDateDateCoutAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateCoutAvailableInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateCoutAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "dateInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableCoutDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "currentViewState" } }, { kind: "Field", name: { kind: "Name", value: "selectable" } }, { kind: "Field", name: { kind: "Name", value: "available" } }, { kind: "Field", name: { kind: "Name", value: "dailyMinimumPrice" } }] } }] } }] } }] }, lF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SelectDateDateStayStartAvailableInitial" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateStayStartAvailableInitial" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableStayStartDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "currentViewState" } }, { kind: "Field", name: { kind: "Name", value: "selectable" } }, { kind: "Field", name: { kind: "Name", value: "available" } }, { kind: "Field", name: { kind: "Name", value: "dailyMinimumPrice" } }] } }] } }] } }] }, sF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SelectDateDateStayStartAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateStayStartAvailableInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateStayStartAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "dateInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableStayStartDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "currentViewState" } }, { kind: "Field", name: { kind: "Name", value: "selectable" } }, { kind: "Field", name: { kind: "Name", value: "available" } }, { kind: "Field", name: { kind: "Name", value: "dailyMinimumPrice" } }] } }] } }] } }] }, rF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCGroupAdd" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupAdd" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, oF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCGroupUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "groupInfo" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GroupUpdateInput" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "groupInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "groupInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, dF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCGroupAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableGroup" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "minimumGroupNum" } }, { kind: "Field", name: { kind: "Name", value: "maximumGroupNum" } }, { kind: "Field", name: { kind: "Name", value: "maximumTotalNumPerGroup" } }, { kind: "Field", name: { kind: "Name", value: "maximumAdultNumPerGroup" } }, { kind: "Field", name: { kind: "Name", value: "maximumChildNumPerGroup" } }, { kind: "Field", name: { kind: "Name", value: "maximumChildAge" } }, { kind: "Field", name: { kind: "Name", value: "selectableChildAges" } }, { kind: "Field", name: { kind: "Name", value: "maximumCoSleepingAge" } }] } }] } }] } }] }, cF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "EditDateDateRemove" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateRemove" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, uF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "EditDateDateUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dataUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "dateInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, mF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SelectInlineDateDateCoutAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateCoutAvailableInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateCoutAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "dateInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableCoutDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "currentViewState" } }, { kind: "Field", name: { kind: "Name", value: "selectable" } }, { kind: "Field", name: { kind: "Name", value: "available" } }, { kind: "Field", name: { kind: "Name", value: "dailyMinimumPrice" } }] } }] } }] } }] }, kF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SelectInlineDateDateStayStartAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateStayStartAvailableInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateStayStartAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "dateInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableStayStartDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "currentViewState" } }, { kind: "Field", name: { kind: "Name", value: "selectable" } }, { kind: "Field", name: { kind: "Name", value: "available" } }, { kind: "Field", name: { kind: "Name", value: "dailyMinimumPrice" } }] } }] } }] } }] }, fF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "SelectInlineDateInitialize" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "metaData" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "metaData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isDayTrip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "staticPriceDataAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableStaticPriceData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planBillingPricePerDate" } }, { kind: "Field", name: { kind: "Name", value: "planBillingPricePerReservation" } }, { kind: "Field", name: { kind: "Name", value: "requiredOptionBillingMinimumPricePerDate" } }, { kind: "Field", name: { kind: "Name", value: "requiredOptionBillingMinimumPricePerReservation" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateStayStartAvailableInitial" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableStayStartDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "currentViewState" } }, { kind: "Field", name: { kind: "Name", value: "selectable" } }, { kind: "Field", name: { kind: "Name", value: "available" } }, { kind: "Field", name: { kind: "Name", value: "dailyMinimumPrice" } }] } }] } }] } }] }, vF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "SelectOptionOptionUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OptionUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "optionInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, hF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCPlanUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "planInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PlanUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "planInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "planInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, pF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCPlanAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availablePlans" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "includedMeals" } }, { kind: "Field", name: { kind: "Name", value: "isUnCancelable" } }, { kind: "Field", name: { kind: "Name", value: "requiredOptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "optionType" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "minimumPrice" } }, { kind: "Field", name: { kind: "Name", value: "priceType" } }, { kind: "Field", name: { kind: "Name", value: "priceTarget" } }, { kind: "Field", name: { kind: "Name", value: "isOneOfRequired" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceType" } }, { kind: "Field", name: { kind: "Name", value: "priceTarget" } }, { kind: "Field", name: { kind: "Name", value: "article" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStartTime" } }, { kind: "Field", name: { kind: "Name", value: "checkInEndTime" } }, { kind: "Field", name: { kind: "Name", value: "checkOutEndTime" } }] } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "kidsPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsMaxAge" } }, { kind: "Field", name: { kind: "Name", value: "kidsDiscountType" } }, { kind: "Field", name: { kind: "Name", value: "unavailable" } }, { kind: "Field", name: { kind: "Name", value: "ratio" } }, { kind: "Field", name: { kind: "Name", value: "static" } }] } }, { kind: "Field", name: { kind: "Name", value: "minRoomNum" } }] } }] } }] } }] }, NF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCRoomBaseUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "roomBaseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RoomBaseUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomBaseUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "roomBaseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "roomBaseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, SF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCRoomEachUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "roomEachInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RoomEachUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomEachUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "roomEachInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "roomEachInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, gF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCRoomBaseAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "roomInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RoomAvailableInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomBaseAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "roomInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "roomInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableRooms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "isDormitory" } }, { kind: "Field", name: { kind: "Name", value: "minimumDailyPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" } }, { kind: "Field", name: { kind: "Name", value: "isRoomChangeRequired" } }, { kind: "Field", name: { kind: "Name", value: "amenities" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bathrooms" } }, { kind: "Field", name: { kind: "Name", value: "roomAmenities" } }, { kind: "Field", name: { kind: "Name", value: "roomFacilities" } }] } }, { kind: "Field", name: { kind: "Name", value: "catchCopy" } }, { kind: "Field", name: { kind: "Name", value: "beds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bedType" } }, { kind: "Field", name: { kind: "Name", value: "bedNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "capacityPeopleMaximum" } }, { kind: "Field", name: { kind: "Name", value: "roomSize" } }, { kind: "Field", name: { kind: "Name", value: "stockPreview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "remainingStock" } }, { kind: "Field", name: { kind: "Name", value: "grade" } }] } }] } }] } }] } }] }, FF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCRoomEachAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "roomInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RoomAvailableInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomEachAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "roomInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "roomInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableRoomsList" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "availableRooms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "isDormitory" } }, { kind: "Field", name: { kind: "Name", value: "capacityPeopleMaximum" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "beds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bedType" } }, { kind: "Field", name: { kind: "Name", value: "bedNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "capacityPeopleMaximum" } }, { kind: "Field", name: { kind: "Name", value: "roomSize" } }] } }] } }] } }] } }] }, IF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCSelectDateDateRemove" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateRemove" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, yF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCPlanSetQueryFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "filterType" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PlanQueryFilterType" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planSetQueryFilter" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "filterType" }, value: { kind: "Variable", name: { kind: "Name", value: "filterType" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, bF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCScreen2Initialize" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SelectOptionAvailableOptionsFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "SelectOptionAvailableOptionsFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AvailableOptionsResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableOptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTerm" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTarget" } }, { kind: "Field", name: { kind: "Name", value: "optionType" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "isRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDateTabbedTimeSelectionEnabled" } }, { kind: "Field", name: { kind: "Name", value: "isDateTabbedTimeSelectionTarget" } }, { kind: "Field", name: { kind: "Name", value: "isOneOfRequired" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "detail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionBillingPerDate" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isNextMorning" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionBillingPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubOptionBillingPerDate" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multiSelectAvailable" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "maxSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "subOptionItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }, { kind: "Field", name: { kind: "Name", value: "isNextMorning" } }, { kind: "Field", name: { kind: "Name", value: "startAt" } }, { kind: "Field", name: { kind: "Name", value: "endAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowTimeSchedule" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubOptionBillingPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multiSelectAvailable" } }, { kind: "Field", name: { kind: "Name", value: "maxSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }, { kind: "Field", name: { kind: "Name", value: "startAt" } }, { kind: "Field", name: { kind: "Name", value: "endAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowTimeSchedule" } }] } }] } }] } }] } }] } }] }, CF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCScreen3InitializeQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionAndAnswerAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableQuestionAndAnswers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "isRequired" } }, { kind: "Field", name: { kind: "Name", value: "questionText" } }, { kind: "Field", name: { kind: "Name", value: "questionType" } }, { kind: "Field", name: { kind: "Name", value: "answerChoices" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "hotelInfo" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "notes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }, { kind: "Field", name: { kind: "Name", value: "keyVisual" } }] } }] } }] } }] }, xF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCScreen4Initialize" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "paymentMethodAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableMethods" } }] } }] } }] }, DF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCScreen2TestInitialize" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "SelectOptionAvailableOptionsFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "SelectOptionAvailableOptionsFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AvailableOptionsResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableOptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTerm" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTarget" } }, { kind: "Field", name: { kind: "Name", value: "optionType" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "isRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDateTabbedTimeSelectionEnabled" } }, { kind: "Field", name: { kind: "Name", value: "isDateTabbedTimeSelectionTarget" } }, { kind: "Field", name: { kind: "Name", value: "isOneOfRequired" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "detail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionBillingPerDate" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isNextMorning" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionBillingPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubOptionBillingPerDate" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multiSelectAvailable" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "maxSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "subOptionItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }, { kind: "Field", name: { kind: "Name", value: "isNextMorning" } }, { kind: "Field", name: { kind: "Name", value: "startAt" } }, { kind: "Field", name: { kind: "Name", value: "endAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowTimeSchedule" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubOptionBillingPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multiSelectAvailable" } }, { kind: "Field", name: { kind: "Name", value: "maxSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }, { kind: "Field", name: { kind: "Name", value: "startAt" } }, { kind: "Field", name: { kind: "Name", value: "endAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowTimeSchedule" } }] } }] } }] } }] } }] } }] }, wF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCScreen3TestInitializeQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionAndAnswerAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableQuestionAndAnswers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "isRequired" } }, { kind: "Field", name: { kind: "Name", value: "questionText" } }, { kind: "Field", name: { kind: "Name", value: "questionType" } }, { kind: "Field", name: { kind: "Name", value: "answerChoices" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "hotelInfo" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "notes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }, { kind: "Field", name: { kind: "Name", value: "keyVisual" } }] } }] } }] } }] }, PF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCScreen4TestInitialize" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "paymentMethodAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableMethods" } }] } }] } }] }, RF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCReservationDetailQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currentStateViewModel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "guestCurrentStateViewModel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "footerSectionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priceLabelText" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestChargePriceText" } }, { kind: "Field", name: { kind: "Name", value: "beforeDiscountPriceText" } }] } }, { kind: "Field", name: { kind: "Name", value: "headerSectionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }] } }, { kind: "Field", name: { kind: "Name", value: "scheduleSectionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sectionTitle" } }, { kind: "Field", name: { kind: "Name", value: "sectionContent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelScheduleSectionInfoContentForDayTrip" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayDateLabel" } }, { kind: "Field", name: { kind: "Name", value: "stayDateText" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelScheduleSectionInfoContentForOverNightTrip" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInDateLabel" } }, { kind: "Field", name: { kind: "Name", value: "checkInDateText" } }, { kind: "Field", name: { kind: "Name", value: "checkInTimeText" } }, { kind: "Field", name: { kind: "Name", value: "checkOutDateLabel" } }, { kind: "Field", name: { kind: "Name", value: "checkOutDateText" } }, { kind: "Field", name: { kind: "Name", value: "checkOutTimeText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "resourceReserveSectionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sectionTitle" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }] } }, { kind: "Field", name: { kind: "Name", value: "sectionContent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }, { kind: "Field", name: { kind: "Name", value: "totalPlanPriceText" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "mainKeyVisual" } }, { kind: "Field", name: { kind: "Name", value: "scheduleText" } }, { kind: "Field", name: { kind: "Name", value: "planPriceText" } }, { kind: "Field", name: { kind: "Name", value: "planNameText" } }, { kind: "Field", name: { kind: "Name", value: "detail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planNameText" } }, { kind: "Field", name: { kind: "Name", value: "detailTriggerText" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "article" } }, { kind: "Field", name: { kind: "Name", value: "policies" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "checkInLabel" } }, { kind: "Field", name: { kind: "Name", value: "checkInTimeText" } }, { kind: "Field", name: { kind: "Name", value: "checkOutLabel" } }, { kind: "Field", name: { kind: "Name", value: "checkOutTimeText" } }] } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelCancelPolicyUnCancelable" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "text" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelCancelPolicyNoCharge" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "text" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelCancelPolicyItems" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDaysText" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatioText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "kidsPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelKidsPolicyNotExist" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "text" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelKidsPolicyItems" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "agesText" } }, { kind: "Field", name: { kind: "Name", value: "detailText" } }] } }] } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }, { kind: "Field", name: { kind: "Name", value: "totalRoomPriceText" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomInfoPerGroup" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }, { kind: "Field", name: { kind: "Name", value: "groupTotalRoomPriceText" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "numberOfGuestsText" } }, { kind: "Field", name: { kind: "Name", value: "roomInfoPerDay" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RoomInfoPerDayNotExists" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "text" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RoomInfoPerDayExists" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "mainKeyVisual" } }, { kind: "Field", name: { kind: "Name", value: "roomNameText" } }, { kind: "Field", name: { kind: "Name", value: "roomDateText" } }, { kind: "Field", name: { kind: "Name", value: "roomPriceText" } }, { kind: "Field", name: { kind: "Name", value: "detail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomNameText" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "article" } }, { kind: "Field", name: { kind: "Name", value: "detailTriggerText" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "notes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amenityRoom" } }, { kind: "Field", name: { kind: "Name", value: "amenityBathroom" } }, { kind: "Field", name: { kind: "Name", value: "facility" } }] } }] } }] } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }, { kind: "Field", name: { kind: "Name", value: "totalOptionPriceText" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "keyVisual" } }, { kind: "Field", name: { kind: "Name", value: "optionNameText" } }, { kind: "Field", name: { kind: "Name", value: "detail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionInfoPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priceText" } }, { kind: "Field", name: { kind: "Name", value: "countText" } }, { kind: "Field", name: { kind: "Name", value: "subOptionNameText" } }, { kind: "Field", name: { kind: "Name", value: "timeText" } }, { kind: "Field", name: { kind: "Name", value: "nextMorningText" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionInfoPerDay" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateText" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priceText" } }, { kind: "Field", name: { kind: "Name", value: "countText" } }, { kind: "Field", name: { kind: "Name", value: "subOptionNameText" } }, { kind: "Field", name: { kind: "Name", value: "timeText" } }, { kind: "Field", name: { kind: "Name", value: "nextMorningText" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionDetail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "detailTriggerText" } }, { kind: "Field", name: { kind: "Name", value: "optionName" } }, { kind: "Field", name: { kind: "Name", value: "optionDescription" } }, { kind: "Field", name: { kind: "Name", value: "notes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelCancelPolicyUnCancelable" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "text" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelCancelPolicyNoCharge" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "text" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelCancelPolicyItems" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDaysText" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatioText" } }] } }] } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "timeSlotOptionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }, { kind: "Field", name: { kind: "Name", value: "totalOptionPriceText" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "keyVisual" } }, { kind: "Field", name: { kind: "Name", value: "optionNameText" } }, { kind: "Field", name: { kind: "Name", value: "detail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionInfoPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priceText" } }, { kind: "Field", name: { kind: "Name", value: "countText" } }, { kind: "Field", name: { kind: "Name", value: "subOptionNameText" } }, { kind: "Field", name: { kind: "Name", value: "timeText" } }, { kind: "Field", name: { kind: "Name", value: "nextMorningText" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionInfoPerDay" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateText" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priceText" } }, { kind: "Field", name: { kind: "Name", value: "countText" } }, { kind: "Field", name: { kind: "Name", value: "subOptionNameText" } }, { kind: "Field", name: { kind: "Name", value: "timeText" } }, { kind: "Field", name: { kind: "Name", value: "nextMorningText" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionDetail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "detailTriggerText" } }, { kind: "Field", name: { kind: "Name", value: "optionName" } }, { kind: "Field", name: { kind: "Name", value: "optionDescription" } }, { kind: "Field", name: { kind: "Name", value: "notes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelCancelPolicyUnCancelable" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "text" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelCancelPolicyNoCharge" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "text" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelCancelPolicyItems" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDaysText" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatioText" } }] } }] } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }, { kind: "Field", name: { kind: "Name", value: "totalAdditionalPriceText" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nameText" } }, { kind: "Field", name: { kind: "Name", value: "priceText" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "resourceCancelSectionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sectionTitleText" } }, { kind: "Field", name: { kind: "Name", value: "sectionContent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "canceledPlanInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }, { kind: "Field", name: { kind: "Name", value: "totalCanceledPlanPriceText" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "scheduleText" } }, { kind: "Field", name: { kind: "Name", value: "canceledPlanNameText" } }, { kind: "Field", name: { kind: "Name", value: "canceledPlanPriceText" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceledRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }, { kind: "Field", name: { kind: "Name", value: "totalCanceledRoomPriceText" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateText" } }, { kind: "Field", name: { kind: "Name", value: "canceledRoomNameText" } }, { kind: "Field", name: { kind: "Name", value: "canceledRoomPriceText" } }, { kind: "Field", name: { kind: "Name", value: "numberOfGuestsText" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceledOptionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "titleText" } }, { kind: "Field", name: { kind: "Name", value: "totalCanceledOptionPriceText" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelResourceCancelSectionCanceledOptionInfoContentItemPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nameText" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "scheduleText" } }, { kind: "Field", name: { kind: "Name", value: "priceText" } }, { kind: "Field", name: { kind: "Name", value: "countText" } }, { kind: "Field", name: { kind: "Name", value: "subOptionNameText" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GuestCurrentStateViewModelResourceCancelSectionCanceledOptionInfoContentItemPerDay" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nameText" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateText" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priceText" } }, { kind: "Field", name: { kind: "Name", value: "countText" } }, { kind: "Field", name: { kind: "Name", value: "subOptionNameText" } }, { kind: "Field", name: { kind: "Name", value: "timeText" } }, { kind: "Field", name: { kind: "Name", value: "nextMorningText" } }] } }] } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "discountSectionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sectionTitleText" } }, { kind: "Field", name: { kind: "Name", value: "sectionContent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountNameText" } }, { kind: "Field", name: { kind: "Name", value: "discountPriceText" } }] } }] } }] } }] } }] } }] }, TF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCFullReservationCurrentSessionState" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationCurrentSessionState" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, jF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCFullReservationInitialSessionState" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lang" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LangCode" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationIdOfReplicationSource" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } }, type: { kind: "NamedType", name: { kind: "Name", value: "SessionInitializeOptionInfoInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationInitialSessionState" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "lang" }, value: { kind: "Variable", name: { kind: "Name", value: "lang" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationIDOfReplicationSource" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationIdOfReplicationSource" } } }, { kind: "Argument", name: { kind: "Name", value: "optionInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, AF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCICReservationCurrentSessionState" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationCurrentSessionState" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, OF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCICReservationInitialSessionState" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lang" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LangCode" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationIdOfReplicationSource" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } }, type: { kind: "NamedType", name: { kind: "Name", value: "SessionInitializeOptionInfoInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationInitialSessionState" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "lang" }, value: { kind: "Variable", name: { kind: "Name", value: "lang" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationIDOfReplicationSource" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationIdOfReplicationSource" } } }, { kind: "Argument", name: { kind: "Name", value: "optionInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, EF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCIReservationCurrentSessionState" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationCurrentSessionState" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, JF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCIReservationInitialSessionState" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lang" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LangCode" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationIdOfReplicationSource" } }, type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } }, type: { kind: "NamedType", name: { kind: "Name", value: "SessionInitializeOptionInfoInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationInitialSessionState" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "lang" }, value: { kind: "Variable", name: { kind: "Name", value: "lang" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationIDOfReplicationSource" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationIdOfReplicationSource" } } }, { kind: "Argument", name: { kind: "Name", value: "optionInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "firstNameKana" } }, { kind: "Field", name: { kind: "Name", value: "lastNameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, _F = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "TDSCReserveWithCreditPaymentForConfirm" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveWithCreditPaymentForConfirm" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfoInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }] } }] } }] };
var $l = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.Room = "ROOM", e))($l || {}), Qt = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.PersonOnlyKids = "PERSON_ONLY_KIDS", e.Room = "ROOM", e))(Qt || {}), nt = /* @__PURE__ */ ((e) => (e.PerDate = "PER_DATE", e.PerReservation = "PER_RESERVATION", e))(nt || {}), Ku = /* @__PURE__ */ ((e) => (e.Jpy = "jpy", e))(Ku || {}), Rt = /* @__PURE__ */ ((e) => (e.Cin = "CIN", e.MiddleDay = "MIDDLE_DAY", e.NotSelected = "NOT_SELECTED", e))(Rt || {}), Un = /* @__PURE__ */ ((e) => (e.Cin = "CIN", e.Cout = "COUT", e.DayTripSelected = "DAY_TRIP_SELECTED", e.MiddleDay = "MIDDLE_DAY", e.NotSelected = "NOT_SELECTED", e))(Un || {}), _a = /* @__PURE__ */ ((e) => (e.Building = "Building", e.Cottage = "Cottage", e.Room = "Room", e.Space = "Space", e.Tent = "Tent", e))(_a || {}), Qs = /* @__PURE__ */ ((e) => (e.Minus = "minus", e.NotAvailable = "not_available", e.Ratio = "ratio", e.Static = "static", e))(Qs || {}), D = /* @__PURE__ */ ((e) => (e.Default = "default", e.En = "en", e))(D || {}), _l = /* @__PURE__ */ ((e) => (e.Breakfast = "BREAKFAST", e.Dinner = "DINNER", e.Lunch = "LUNCH", e.RoomOnly = "ROOM_ONLY", e))(_l || {}), Z = /* @__PURE__ */ ((e) => (e.None = "None", e.RegularOnly = "RegularOnly", e.TimeSlotAndRegular = "TimeSlotAndRegular", e.TimeSlotOnly = "TimeSlotOnly", e))(Z || {}), Zs = /* @__PURE__ */ ((e) => (e.Goods = "GOODS", e.Service = "SERVICE", e))(Zs || {}), Yu = /* @__PURE__ */ ((e) => (e.Credit = "CREDIT", e.Free = "FREE", e.Local = "LOCAL", e.Test = "TEST", e))(Yu || {}), It = /* @__PURE__ */ ((e) => (e.AllPlans = "ALL_PLANS", e.OnlyAccommodationPlans = "ONLY_ACCOMMODATION_PLANS", e.OnlyDayTripPlans = "ONLY_DAY_TRIP_PLANS", e))(It || {}), Ms = /* @__PURE__ */ ((e) => (e.Check = "CHECK", e.Free = "FREE", e.Radio = "RADIO", e.Select = "SELECT", e))(Ms || {}), X = /* @__PURE__ */ ((e) => (e.EditReservation = "EDIT_RESERVATION", e.EditReservationAuthorizedFailed = "EDIT_RESERVATION_AUTHORIZED_FAILED", e.EditReservationCreditCardOnly = "EDIT_RESERVATION_CREDIT_CARD_ONLY", e.EditReservationOptionUpdateOnly = "EDIT_RESERVATION_OPTION_UPDATE_ONLY", e.NewReservation = "NEW_RESERVATION", e))(X || {}), ml = /* @__PURE__ */ ((e) => (e.PaymentFailed = "PAYMENT_FAILED", e.StockIsNotAvailable = "STOCK_IS_NOT_AVAILABLE", e))(ml || {}), pn = /* @__PURE__ */ ((e) => (e.CreditCardContinuedUse = "CREDIT_CARD_CONTINUED_USE", e.CreditCardNewlyRegistration = "CREDIT_CARD_NEWLY_REGISTRATION", e.Free = "FREE", e.Local = "LOCAL", e.Test = "TEST", e))(pn || {}), Ul = /* @__PURE__ */ ((e) => (e.Available = "AVAILABLE", e.Few = "FEW", e.Full = "FULL", e))(Ul || {});
const z8 = {
  "\n	query RCReservationInitialSessionState(\n		$hotelId: ID!\n		$lang: LangCode!\n		$reservationId: ID\n		$reservationIdOfReplicationSource: ID\n		$optionInfo: SessionInitializeOptionInfoInput\n	) {\n		reservationInitialSessionState(\n			hotelID: $hotelId\n			lang: $lang\n			reservationID: $reservationId\n			reservationIDOfReplicationSource: $reservationIdOfReplicationSource\n			optionInfo: $optionInfo\n		) {\n			...ReservationSessionStateFragment\n		}\n	}\n": z9,
  "\n	fragment ReservationSessionStateFragment on ReservationSessionState {\n		id\n		hotelID\n		sessionID\n		reservationID\n		lang\n		hotelName\n		isShowBestRateNotice\n		clientContext {\n			reserveFailedReason\n			planQueryFilter\n		}\n		prevState {\n			groupInfo {\n				uniqueRoomID\n				adultNum\n				kidsNum {\n					age\n					asCosleeping\n				}\n			}\n			dateInfo {\n				stayStartDt\n				stayLastDt\n			}\n			defaultCancelPolicy {\n				beforeDays\n				chargeRatio\n			}\n			planInfo {\n				reserved {\n					planID\n					cancelPolicy {\n						beforeDays\n						chargeRatio\n					}\n					amount\n					price\n					priceDiscounted\n					priceHostInserted\n					sessionResourceUUID\n				}\n				canceled {\n					planID\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n					name\n					sessionResourceUUID\n				}\n			}\n			roomInfo {\n				reserved {\n					uniqueGroupID\n					dailyInfo {\n						sessionResourceUUID\n						roomID\n						date\n						reservedStock\n						price\n						priceDiscounted\n						priceHostInserted\n					}\n				}\n				canceled {\n					roomID\n					date\n					name\n					roomGroupID\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n					sessionResourceUUID\n				}\n			}\n			optionPerDateInfo {\n				reserved {\n					optionID\n					subOptionID\n					amount\n					date\n					price\n					priceDiscounted\n					priceHostInserted\n					sessionResourceUUID\n					cancelPolicy {\n						beforeDays\n						chargeRatio\n					}\n				}\n				canceled {\n					sessionResourceUUID\n					optionID\n					subOptionID\n					amount\n					date\n					name\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n				}\n			}\n			optionPerReservationInfo {\n				reserved {\n					optionID\n					subOptionID\n					amount\n					price\n					priceDiscounted\n					priceHostInserted\n					sessionResourceUUID\n					cancelPolicy {\n						beforeDays\n						chargeRatio\n					}\n				}\n				canceled {\n					sessionResourceUUID\n					optionID\n					subOptionID\n					amount\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n					name\n				}\n			}\n			guestInfo {\n				name\n				nameKana\n				email\n				postalCode\n				address\n				tel\n			}\n			discountInfo {\n				discountID\n				discountPrice\n				name\n			}\n			voucherInfo {\n				voucherCode\n				discountPrice\n			}\n			questionAnswerInfo {\n				questionID\n				question\n				answers\n			}\n		}\n		currentState {\n			planInfo {\n				willReserve {\n					planID\n					name\n					cancelPolicy {\n						beforeDays\n						chargeRatio\n					}\n					sessionResourceUUID\n					price\n					priceDiscounted\n					priceHostInserted\n				}\n				willCancel {\n					planID\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					sessionResourceUUID\n					cancelPriceHostInserted\n					name\n				}\n			}\n			roomInfo {\n				willReserve {\n					baseRoomInfo {\n						baseRoomID\n						baseRoomName\n					}\n					uniqueRoomID\n					dailyItems {\n						date\n						roomInfo {\n							roomID\n							name\n							consumedStock\n							name\n							price\n							priceDiscounted\n							sessionResourceUUID\n							priceHostInserted\n						}\n					}\n				}\n				willCancel {\n					roomID\n					uniqueGroupID\n					date\n					name\n					cancelPrice\n					sessionResourceUUID\n					cancelPriceHostInserted\n				}\n			}\n			optionPerDateInfo {\n				willReserve {\n					optionID\n					subOptionID\n					amount\n					date\n					name\n					price\n					priceDiscounted\n					priceHostInserted\n					name\n					sessionResourceUUID\n				}\n				willCancel {\n					optionID\n					subOptionID\n					amount\n					date\n					name\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n					sessionResourceUUID\n				}\n			}\n			optionPerReservationInfo {\n				willReserve {\n					optionID\n					subOptionID\n					amount\n					name\n					price\n					priceDiscounted\n					priceHostInserted\n					name\n					sessionResourceUUID\n				}\n				willCancel {\n					optionID\n					subOptionID\n					amount\n					stayDates {\n						stayStartDt\n						stayLastDt\n					}\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n					name\n					sessionResourceUUID\n				}\n			}\n			dateInfo {\n				stayStartDt\n				stayLastDt\n			}\n			groupInfo {\n				kidsNum {\n					age\n					asCosleeping\n				}\n				uniqueRoomID\n				adultNum\n			}\n			guestInfo {\n				name\n				nameKana\n				firstName\n				lastName\n				firstNameKana\n				lastNameKana\n				email\n				postalCode\n				address\n				tel\n			}\n			discountInfo {\n				discountID\n				name\n				discountPrice\n			}\n			voucherInfo {\n				voucherCode\n				discountPrice\n				name\n			}\n			questionAnswerInfo {\n				questionID\n				question\n				answers\n			}\n			additionalFeeInfo {\n				additionalFeeID\n				name\n				price\n				priceDiscounted\n				priceHostInserted\n				sessionResourceUUID\n			}\n			agreementOfTermsOfService\n			isMailMagazineAccept\n		}\n		priceInfo {\n			totalPriceBeforeDiscount\n			totalPriceDiscounted\n			voucherDiscountPrice\n			totalGuestCharge\n			rawPricePlan\n			rawPriceRoom\n			rawPriceOption\n			rawPriceAdditionalFee\n		}\n		reservationContext {\n			isTestReservation\n			reservationEditMode\n		}\n		reserveStatus {\n			isCompleteDate\n			isCompleteGroup\n			isCompletePlan\n			isCompleteRoom\n			isCompleteOption\n			isCompleteDateTabbedTimeSelectionOption\n			isCompleteRequiredOptionGroup\n			isCompleteGuestInfo\n			isCompleteQuestionAndAnswer\n			isCompleteAgreementOfTermsOfService\n		}\n		reservationPolicy {\n			isPlanSelectRequired\n			isDayTrip\n			isShowRoomSelect\n			isShowRoomForGuest\n			isShowDiscountInput\n			isShowOptionSelect\n			optionSelectionMode\n			isRequiredOptionGroupSatisfiableWithRegularOption\n			isAddressInputRequired\n			isShowPlanFilter\n			isShowPlanSelect\n			isShowCalendarPrice\n			isShowPlanIncludedPrice\n			isRequestReservation\n			canCancelReservation\n			canUpdateReservation\n			canUpdateOnlyOptionReservation\n			customTypeRoomTitle\n			checkInOutPolicy {\n				checkInStart\n				checkInEnd\n				checkOut\n			}\n			defaultCancelPolicy {\n				beforeDays\n				chargeRatio\n			}\n		}\n		lastUpdatedAt\n	}\n": V9,
  "\n	mutation InputAOTOSAOTOSUpdate($baseInfo: BaseInfoInput!, $isAgree: Boolean!) {\n		agreementOfTermsOfServiceSet(baseInfo: $baseInfo, isAgree: $isAgree) {\n			...ReservationSessionStateFragment\n		}\n	}\n": B9,
  "\n	mutation InputDiscountDiscountUpdate($baseInfo: BaseInfoInput!, $discountInfo: DiscountUpdateInput!) {\n		discountUpdate(baseInfo: $baseInfo, discountInfo: $discountInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": q9,
  "\n	mutation InputGuestInfoGuestInfoUpdate($baseInfo: BaseInfoInput!, $guestInfo: GuestInfoInput!) {\n		guestInfoSet(baseInfo: $baseInfo, guestInfo: $guestInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": G9,
  "\n	mutation RCReserveWithCreditPaymentEncodeCallBackUrlForExistingReservation(\n		$baseInfoInput: BaseInfoInput!\n		$creditCardInfoInput: CreditCardInfoInput\n	) {\n		reserveWithCreditPaymentEncodeCallBackUrlForExistingReservation(\n			baseInfo: $baseInfoInput\n			creditCardInfoInput: $creditCardInfoInput\n		)\n	}\n": W9,
  "\n	mutation RCReserveWithCreditPaymentEncodeCallBackForNewReservation(\n		$baseInfoInput: BaseInfoInput!\n		$creditCardInfoInput: CreditCardInfoInput!\n	) {\n		reserveWithCreditPaymentEncodeCallBackUrlForNewReservation(\n			baseInfo: $baseInfoInput\n			creditCardInfoInput: $creditCardInfoInput\n		)\n	}\n": K9,
  "\n	mutation RCReserveWithFreePayment($baseInfoInput: BaseInfoInput!) {\n		reserveWithFreePayment(baseInfo: $baseInfoInput) {\n			hotelID\n			reservationID\n		}\n	}\n": Y9,
  "\n	mutation RCReserveWithLocalPayment($baseInfoInput: BaseInfoInput!) {\n		reserveWithLocalPayment(baseInfo: $baseInfoInput) {\n			hotelID\n			reservationID\n		}\n	}\n": X9,
  "\n	mutation RCReserveWithTestPayment($baseInfoInput: BaseInfoInput!) {\n		reserveWithTestPayment(baseInfo: $baseInfoInput) {\n			hotelID\n			reservationID\n		}\n	}\n": Z9,
  "\n	mutation InputQAAAQAAUpdate($baseInfo: BaseInfoInput!, $questionAndAnswerInfo: [QuestionAndAnswerUpdateInput!]!) {\n		questionAndAnswerUpdate(baseInfo: $baseInfo, questionAndAnswerInfo: $questionAndAnswerInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": eF,
  "\n	mutation InputVoucherVoucherRemove($baseInfo: BaseInfoInput!, $voucherInfo: VoucherInput!) {\n		voucherRemove(baseInfo: $baseInfo, voucherInfo: $voucherInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": nF,
  "\n	mutation InputVoucherVoucherUpdate($baseInfo: BaseInfoInput!, $voucherInfo: VoucherInput!) {\n		voucherSet(baseInfo: $baseInfo, voucherInfo: $voucherInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": iF,
  "\n	mutation RCSelectDateDateUpdate($baseInfo: BaseInfoInput!, $dateInfo: DateUpdateInput!) {\n		dataUpdate(baseInfo: $baseInfo, dateInfo: $dateInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": tF,
  "\n	query SelectDateDateCoutAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateCoutAvailableInput!) {\n		dateCoutAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {\n			availableCoutDates {\n				date\n				currentViewState\n				selectable\n				available\n				dailyMinimumPrice\n			}\n		}\n	}\n": aF,
  "\n	query SelectDateDateStayStartAvailableInitial($baseInfo: BaseInfoInput!) {\n		dateStayStartAvailableInitial(baseInfo: $baseInfo) {\n			availableStayStartDates {\n				date\n				currentViewState\n				selectable\n				available\n				dailyMinimumPrice\n			}\n		}\n	}\n": lF,
  "\n	query SelectDateDateStayStartAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateStayStartAvailableInput!) {\n		dateStayStartAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {\n			availableStayStartDates {\n				date\n				currentViewState\n				selectable\n				available\n				dailyMinimumPrice\n			}\n		}\n	}\n": sF,
  "\n	mutation RCGroupAdd($baseInfo: BaseInfoInput!) {\n		groupAdd(baseInfo: $baseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": rF,
  "\n	mutation RCGroupUpdate($baseInfo: BaseInfoInput!, $groupInfo: [GroupUpdateInput!]!) {\n		groupUpdate(baseInfo: $baseInfo, groupInfo: $groupInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": oF,
  "\n	query RCGroupAvailable($baseInfo: BaseInfoInput!) {\n		groupAvailable(baseInfo: $baseInfo) {\n			availableGroup {\n				minimumGroupNum\n				maximumGroupNum\n				maximumTotalNumPerGroup\n				maximumAdultNumPerGroup\n				maximumChildNumPerGroup\n				maximumChildAge\n				selectableChildAges\n				maximumCoSleepingAge\n			}\n		}\n	}\n": dF,
  "\n	mutation EditDateDateRemove($baseInfo: BaseInfoInput!) {\n		dateRemove(baseInfo: $baseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": cF,
  "\n	mutation EditDateDateUpdate($baseInfo: BaseInfoInput!, $dateInfo: DateUpdateInput!) {\n		dataUpdate(baseInfo: $baseInfo, dateInfo: $dateInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": uF,
  "\n	query SelectInlineDateDateCoutAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateCoutAvailableInput!) {\n		dateCoutAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {\n			availableCoutDates {\n				date\n				currentViewState\n				selectable\n				available\n				dailyMinimumPrice\n			}\n		}\n	}\n": mF,
  "\n	query SelectInlineDateDateStayStartAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateStayStartAvailableInput!) {\n		dateStayStartAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {\n			availableStayStartDates {\n				date\n				currentViewState\n				selectable\n				available\n				dailyMinimumPrice\n			}\n		}\n	}\n": kF,
  "\n	query SelectInlineDateInitialize($baseInfo: BaseInfoInput!) {\n		metaData(baseInfo: $baseInfo) {\n			metaData {\n				isDayTrip\n			}\n		}\n		staticPriceDataAvailable(baseInfo: $baseInfo) {\n			availableStaticPriceData {\n				planBillingPricePerDate\n				planBillingPricePerReservation\n				requiredOptionBillingMinimumPricePerDate\n				requiredOptionBillingMinimumPricePerReservation\n			}\n		}\n		dateStayStartAvailableInitial(baseInfo: $baseInfo) {\n			availableStayStartDates {\n				date\n				currentViewState\n				selectable\n				available\n				dailyMinimumPrice\n			}\n		}\n	}\n": fF,
  "\n	mutation SelectOptionOptionUpdate($baseInfo: BaseInfoInput!, $optionInfo: OptionUpdateInput!) {\n		optionUpdate(baseInfo: $baseInfo, optionInfo: $optionInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": vF,
  "\n	fragment SelectOptionAvailableOptionsFragment on AvailableOptionsResponse {\n		availableOptions {\n			optionID\n			billingTypeTerm\n			billingTypeTarget\n			optionType\n			name\n			description\n			isRequired\n			isDateTabbedTimeSelectionEnabled\n			isDateTabbedTimeSelectionTarget\n			isOneOfRequired\n			keyVisuals\n			cancelPolicy {\n				beforeDays\n				chargeRatio\n			}\n			detail {\n				... on OptionBillingPerDate {\n					isNextMorning\n					price\n					minimumSoldAmount\n					dailyItems {\n						date\n						availableChoices\n					}\n				}\n				... on OptionBillingPerReservation {\n					price\n					minimumSoldAmount\n					availableChoices\n				}\n				... on SubOptionBillingPerDate {\n					multiSelectAvailable\n					minimumSoldAmount\n					dailyItems {\n						date\n						maxSoldAmount\n						subOptionItems {\n							subOptionID\n							name\n							price\n							availableChoices\n							isNextMorning\n							startAt\n							endAt\n							isShowTimeSchedule\n						}\n					}\n				}\n				... on SubOptionBillingPerReservation {\n					multiSelectAvailable\n					maxSoldAmount\n					minimumSoldAmount\n					items {\n						subOptionID\n						name\n						price\n						availableChoices\n						startAt\n						endAt\n						isShowTimeSchedule\n					}\n				}\n			}\n		}\n	}\n": H9,
  "\n	mutation RCPlanUpdate($baseInfo: BaseInfoInput!, $planInfo: PlanUpdateInput!) {\n		planUpdate(baseInfo: $baseInfo, planInfo: $planInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": hF,
  "\n	query RCPlanAvailable($baseInfo: BaseInfoInput!) {\n		planAvailable(baseInfo: $baseInfo) {\n			availablePlans {\n				planID\n				name\n				description\n				keyVisuals\n				isDayTrip\n				includedMeals\n				isUnCancelable\n				requiredOptions {\n					optionID\n					optionType\n					name\n					minimumPrice\n					priceType\n					priceTarget\n					isOneOfRequired\n				}\n				price\n				priceType\n				priceTarget\n				article\n				checkInOutPolicy {\n					checkInStartTime\n					checkInEndTime\n					checkOutEndTime\n				}\n				cancelPolicy {\n					beforeDays\n					chargeRatio\n				}\n				kidsPolicy {\n					kidsMaxAge\n					kidsDiscountType\n					unavailable\n					ratio\n					static\n				}\n				minRoomNum\n			}\n		}\n	}\n": pF,
  "\n	mutation RCRoomBaseUpdate($baseInfo: BaseInfoInput!, $roomBaseInfo: RoomBaseUpdateInput!) {\n		roomBaseUpdate(baseInfo: $baseInfo, roomBaseInfo: $roomBaseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": NF,
  "\n	mutation RCRoomEachUpdate($baseInfo: BaseInfoInput!, $roomEachInfo: RoomEachUpdateInput!) {\n		roomEachUpdate(baseInfo: $baseInfo, roomEachInfo: $roomEachInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": SF,
  "\n	query RCRoomBaseAvailable($baseInfo: BaseInfoInput!, $roomInfo: RoomAvailableInput!) {\n		roomBaseAvailable(baseInfo: $baseInfo, roomInfo: $roomInfo) {\n			availableRooms {\n				roomID\n				name\n				keyVisuals\n				isDormitory\n				minimumDailyPrice\n				article\n				isRoomChangeRequired\n				amenities {\n					bathrooms\n					roomAmenities\n					roomFacilities\n				}\n				catchCopy\n				beds {\n					bedType\n					bedNum\n				}\n				capacityPeopleMaximum\n				roomSize\n				stockPreview {\n					remainingStock\n					grade\n				}\n			}\n		}\n	}\n": gF,
  "\n	query RCRoomEachAvailable($baseInfo: BaseInfoInput!, $roomInfo: RoomAvailableInput!) {\n		roomEachAvailable(baseInfo: $baseInfo, roomInfo: $roomInfo) {\n			availableRoomsList {\n				date\n				availableRooms {\n					roomID\n					name\n					isDormitory\n					capacityPeopleMaximum\n					keyVisuals\n					price\n					beds {\n						bedType\n						bedNum\n					}\n					capacityPeopleMaximum\n					roomSize\n				}\n			}\n		}\n	}\n": FF,
  "\n	mutation RCSelectDateDateRemove($baseInfo: BaseInfoInput!) {\n		dateRemove(baseInfo: $baseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": IF,
  "\n	mutation RCPlanSetQueryFilter($baseInfo: BaseInfoInput!, $filterType: PlanQueryFilterType!) {\n		planSetQueryFilter(baseInfo: $baseInfo, filterType: $filterType) {\n			...ReservationSessionStateFragment\n		}\n	}\n": yF,
  "\n	query RCScreen2Initialize($baseInfo: BaseInfoInput!) {\n		optionAvailable(baseInfo: $baseInfo) {\n			...SelectOptionAvailableOptionsFragment\n		}\n	}\n": bF,
  "\n	query RCScreen3InitializeQuery($baseInfo: BaseInfoInput!) {\n		questionAndAnswerAvailable(baseInfo: $baseInfo) {\n			availableQuestionAndAnswers {\n				questionID\n				isRequired\n				questionText\n				questionType\n				answerChoices\n			}\n		}\n		hotelInfo(baseInfo: $baseInfo) {\n			hotelInfo {\n				notes {\n					title\n					description\n				}\n				keyVisual\n			}\n		}\n	}\n": CF,
  "\n	query RCScreen4Initialize($baseInfo: BaseInfoInput!) {\n		paymentMethodAvailable(baseInfo: $baseInfo) {\n			availableMethods\n		}\n	}\n": xF,
  "\n	query RCScreen2TestInitialize($baseInfo: BaseInfoInput!) {\n		optionAvailable(baseInfo: $baseInfo) {\n			...SelectOptionAvailableOptionsFragment\n		}\n	}\n": DF,
  "\n	query RCScreen3TestInitializeQuery($baseInfo: BaseInfoInput!) {\n		questionAndAnswerAvailable(baseInfo: $baseInfo) {\n			availableQuestionAndAnswers {\n				questionID\n				isRequired\n				questionText\n				questionType\n				answerChoices\n			}\n		}\n		hotelInfo(baseInfo: $baseInfo) {\n			hotelInfo {\n				notes {\n					title\n					description\n				}\n				keyVisual\n			}\n		}\n	}\n": wF,
  "\n	query RCScreen4TestInitialize($baseInfo: BaseInfoInput!) {\n		paymentMethodAvailable(baseInfo: $baseInfo) {\n			availableMethods\n		}\n	}\n": PF,
  "\n	query RCReservationDetailQuery($baseInfo: BaseInfoInput!) {\n		currentStateViewModel(baseInfo: $baseInfo) {\n			guestCurrentStateViewModel {\n				hotelID\n				reservationID\n				sessionID\n				footerSectionInfo {\n					priceLabelText\n					totalGuestChargePriceText\n					beforeDiscountPriceText\n				}\n				headerSectionInfo {\n					titleText\n				}\n				scheduleSectionInfo {\n					sectionTitle\n					sectionContent {\n						... on GuestCurrentStateViewModelScheduleSectionInfoContentForDayTrip {\n							stayDateLabel\n							stayDateText\n						}\n						... on GuestCurrentStateViewModelScheduleSectionInfoContentForOverNightTrip {\n							checkInDateLabel\n							checkInDateText\n							checkInTimeText\n							checkOutDateLabel\n							checkOutDateText\n							checkOutTimeText\n						}\n					}\n				}\n				resourceReserveSectionInfo {\n					sectionTitle {\n						titleText\n					}\n					sectionContent {\n						planInfo {\n							title {\n								titleText\n								totalPlanPriceText\n							}\n							content {\n								mainKeyVisual\n								scheduleText\n								planPriceText\n								planNameText\n								detail {\n									planNameText\n									detailTriggerText\n									lang\n									keyVisuals\n									article\n									policies {\n										planPolicy {\n											label\n											checkInLabel\n											checkInTimeText\n											checkOutLabel\n											checkOutTimeText\n										}\n										cancelPolicy {\n											... on GuestCurrentStateViewModelCancelPolicyUnCancelable {\n												label\n												text\n											}\n											... on GuestCurrentStateViewModelCancelPolicyNoCharge {\n												label\n												text\n											}\n											... on GuestCurrentStateViewModelCancelPolicyItems {\n												label\n												items {\n													beforeDaysText\n													chargeRatioText\n												}\n											}\n										}\n										kidsPolicy {\n											... on GuestCurrentStateViewModelKidsPolicyNotExist {\n												label\n												text\n											}\n											... on GuestCurrentStateViewModelKidsPolicyItems {\n												label\n												items {\n													agesText\n													detailText\n												}\n											}\n										}\n									}\n								}\n							}\n						}\n						roomInfo {\n							title {\n								titleText\n								totalRoomPriceText\n							}\n							content {\n								roomInfoPerGroup {\n									title {\n										titleText\n										groupTotalRoomPriceText\n									}\n									content {\n										numberOfGuestsText\n										roomInfoPerDay {\n											... on RoomInfoPerDayNotExists {\n												text\n											}\n											... on RoomInfoPerDayExists {\n												mainKeyVisual\n												roomNameText\n												roomDateText\n												roomPriceText\n												detail {\n													roomNameText\n													keyVisuals\n													article\n													detailTriggerText\n													lang\n													notes {\n														amenityRoom\n														amenityBathroom\n														facility\n													}\n												}\n											}\n										}\n									}\n								}\n							}\n						}\n						optionInfo {\n							title {\n								titleText\n								totalOptionPriceText\n							}\n							content {\n								optionInfo {\n									keyVisual\n									optionNameText\n									detail {\n										... on OptionInfoPerReservation {\n											items {\n												priceText\n												countText\n												subOptionNameText\n												timeText\n												nextMorningText\n											}\n										}\n										... on OptionInfoPerDay {\n											items {\n												dateText\n												items {\n													priceText\n													countText\n													subOptionNameText\n													timeText\n													nextMorningText\n												}\n											}\n										}\n									}\n								}\n								optionDetail {\n									detailTriggerText\n									optionName\n									optionDescription\n									notes {\n										cancelPolicy {\n											... on GuestCurrentStateViewModelCancelPolicyUnCancelable {\n												label\n												text\n											}\n											... on GuestCurrentStateViewModelCancelPolicyNoCharge {\n												label\n												text\n											}\n											... on GuestCurrentStateViewModelCancelPolicyItems {\n												label\n												items {\n													beforeDaysText\n													chargeRatioText\n												}\n											}\n										}\n									}\n								}\n							}\n						}\n						timeSlotOptionInfo {\n							title {\n								titleText\n								totalOptionPriceText\n							}\n							content {\n								optionInfo {\n									keyVisual\n									optionNameText\n									detail {\n										... on OptionInfoPerReservation {\n											items {\n												priceText\n												countText\n												subOptionNameText\n												timeText\n												nextMorningText\n											}\n										}\n										... on OptionInfoPerDay {\n											items {\n												dateText\n												items {\n													priceText\n													countText\n													subOptionNameText\n													timeText\n													nextMorningText\n												}\n											}\n										}\n									}\n								}\n								optionDetail {\n									detailTriggerText\n									optionName\n									optionDescription\n									notes {\n										cancelPolicy {\n											... on GuestCurrentStateViewModelCancelPolicyUnCancelable {\n												label\n												text\n											}\n											... on GuestCurrentStateViewModelCancelPolicyNoCharge {\n												label\n												text\n											}\n											... on GuestCurrentStateViewModelCancelPolicyItems {\n												label\n												items {\n													beforeDaysText\n													chargeRatioText\n												}\n											}\n										}\n									}\n								}\n							}\n						}\n						additionalFeeInfo {\n							title {\n								titleText\n								totalAdditionalPriceText\n							}\n							content {\n								items {\n									nameText\n									priceText\n								}\n							}\n						}\n					}\n				}\n				resourceCancelSectionInfo {\n					sectionTitleText\n					sectionContent {\n						canceledPlanInfo {\n							title {\n								titleText\n								totalCanceledPlanPriceText\n							}\n							content {\n								scheduleText\n								canceledPlanNameText\n								canceledPlanPriceText\n							}\n						}\n						canceledRoomInfo {\n							title {\n								titleText\n								totalCanceledRoomPriceText\n							}\n							content {\n								dateText\n								canceledRoomNameText\n								canceledRoomPriceText\n								numberOfGuestsText\n							}\n						}\n						canceledOptionInfo {\n							title {\n								titleText\n								totalCanceledOptionPriceText\n							}\n							content {\n								... on GuestCurrentStateViewModelResourceCancelSectionCanceledOptionInfoContentItemPerReservation {\n									nameText\n									items {\n										scheduleText\n										priceText\n										countText\n										subOptionNameText\n									}\n								}\n								... on GuestCurrentStateViewModelResourceCancelSectionCanceledOptionInfoContentItemPerDay {\n									nameText\n									items {\n										dateText\n										items {\n											priceText\n											countText\n											subOptionNameText\n											timeText\n											nextMorningText\n										}\n									}\n								}\n							}\n						}\n					}\n				}\n				discountSectionInfo {\n					sectionTitleText\n					sectionContent {\n						discountNameText\n						discountPriceText\n					}\n				}\n			}\n		}\n	}\n": RF,
  "\n	query RCFullReservationCurrentSessionState($baseInfo: BaseInfoInput!) {\n		reservationCurrentSessionState(baseInfo: $baseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": TF,
  "\n	query RCFullReservationInitialSessionState(\n		$hotelId: ID!\n		$lang: LangCode!\n		$reservationId: ID\n		$reservationIdOfReplicationSource: ID\n		$optionInfo: SessionInitializeOptionInfoInput\n	) {\n		reservationInitialSessionState(\n			hotelID: $hotelId\n			lang: $lang\n			reservationID: $reservationId\n			reservationIDOfReplicationSource: $reservationIdOfReplicationSource\n			optionInfo: $optionInfo\n		) {\n			...ReservationSessionStateFragment\n		}\n	}\n": jF,
  "\n	query RCICReservationCurrentSessionState($baseInfo: BaseInfoInput!) {\n		reservationCurrentSessionState(baseInfo: $baseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": AF,
  "\n	query RCICReservationInitialSessionState(\n		$hotelId: ID!\n		$lang: LangCode!\n		$reservationId: ID\n		$reservationIdOfReplicationSource: ID\n		$optionInfo: SessionInitializeOptionInfoInput\n	) {\n		reservationInitialSessionState(\n			hotelID: $hotelId\n			lang: $lang\n			reservationID: $reservationId\n			reservationIDOfReplicationSource: $reservationIdOfReplicationSource\n			optionInfo: $optionInfo\n		) {\n			...ReservationSessionStateFragment\n		}\n	}\n": OF,
  "\n	query RCIReservationCurrentSessionState($baseInfo: BaseInfoInput!) {\n		reservationCurrentSessionState(baseInfo: $baseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": EF,
  "\n	query RCIReservationInitialSessionState(\n		$hotelId: ID!\n		$lang: LangCode!\n		$reservationId: ID\n		$reservationIdOfReplicationSource: ID\n		$optionInfo: SessionInitializeOptionInfoInput\n	) {\n		reservationInitialSessionState(\n			hotelID: $hotelId\n			lang: $lang\n			reservationID: $reservationId\n			reservationIDOfReplicationSource: $reservationIdOfReplicationSource\n			optionInfo: $optionInfo\n		) {\n			...ReservationSessionStateFragment\n		}\n	}\n": JF,
  "\n	mutation TDSCReserveWithCreditPaymentForConfirm($baseInfoInput: BaseInfoInput!) {\n		reserveWithCreditPaymentForConfirm(baseInfo: $baseInfoInput) {\n			hotelID\n			reservationID\n		}\n	}\n": _F
};
function Ve(e) {
  var n;
  return (n = z8[e]) != null ? n : {};
}
const B8 = Ve(
  /* GraphQL */
  `
	query RCFullReservationCurrentSessionState($baseInfo: BaseInfoInput!) {
		reservationCurrentSessionState(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), q8 = Ve(
  /* GraphQL */
  `
	query RCFullReservationInitialSessionState(
		$hotelId: ID!
		$lang: LangCode!
		$reservationId: ID
		$reservationIdOfReplicationSource: ID
		$optionInfo: SessionInitializeOptionInfoInput
	) {
		reservationInitialSessionState(
			hotelID: $hotelId
			lang: $lang
			reservationID: $reservationId
			reservationIDOfReplicationSource: $reservationIdOfReplicationSource
			optionInfo: $optionInfo
		) {
			...ReservationSessionStateFragment
		}
	}
`
);
function G8(e, n) {
  const i = w.createContext(n), t = (s) => {
    const { children: r, ...o } = s, d = w.useMemo(() => o, Object.values(o));
    return /* @__PURE__ */ l.jsx(i.Provider, { value: d, children: r });
  };
  t.displayName = e + "Provider";
  function a(s) {
    const r = w.useContext(i);
    if (r) return r;
    if (n !== void 0) return n;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return [t, a];
}
function $t(e, n = []) {
  let i = [];
  function t(s, r) {
    const o = w.createContext(r), d = i.length;
    i = [...i, r];
    const c = (k) => {
      var S;
      const { scope: m, children: f, ...p } = k, h = ((S = m == null ? void 0 : m[e]) == null ? void 0 : S[d]) || o, N = w.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ l.jsx(h.Provider, { value: N, children: f });
    };
    c.displayName = s + "Provider";
    function u(k, m) {
      var h;
      const f = ((h = m == null ? void 0 : m[e]) == null ? void 0 : h[d]) || o, p = w.useContext(f);
      if (p) return p;
      if (r !== void 0) return r;
      throw new Error(`\`${k}\` must be used within \`${s}\``);
    }
    return [c, u];
  }
  const a = () => {
    const s = i.map((r) => w.createContext(r));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return w.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return a.scopeName = e, [t, W8(a, ...n)];
}
function W8(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const i = () => {
    const t = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(s) {
      const r = t.reduce((o, { useScope: d, scopeName: c }) => {
        const k = d(s)[`__scope${c}`];
        return { ...o, ...k };
      }, {});
      return w.useMemo(() => ({ [`__scope${n.scopeName}`]: r }), [r]);
    };
  };
  return i.scopeName = n.scopeName, i;
}
function Pp(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Sf(...e) {
  return (n) => {
    let i = !1;
    const t = e.map((a) => {
      const s = Pp(a, n);
      return !i && typeof s == "function" && (i = !0), s;
    });
    if (i)
      return () => {
        for (let a = 0; a < t.length; a++) {
          const s = t[a];
          typeof s == "function" ? s() : Pp(e[a], null);
        }
      };
  };
}
function Rn(...e) {
  return w.useCallback(Sf(...e), e);
}
// @__NO_SIDE_EFFECTS__
function B1(e) {
  const n = /* @__PURE__ */ K8(e), i = w.forwardRef((t, a) => {
    const { children: s, ...r } = t, o = w.Children.toArray(s), d = o.find(X8);
    if (d) {
      const c = d.props.children, u = o.map((k) => k === d ? w.Children.count(c) > 1 ? w.Children.only(null) : w.isValidElement(c) ? c.props.children : null : k);
      return /* @__PURE__ */ l.jsx(n, { ...r, ref: a, children: w.isValidElement(c) ? w.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ l.jsx(n, { ...r, ref: a, children: s });
  });
  return i.displayName = `${e}.Slot`, i;
}
// @__NO_SIDE_EFFECTS__
function K8(e) {
  const n = w.forwardRef((i, t) => {
    const { children: a, ...s } = i;
    if (w.isValidElement(a)) {
      const r = eP(a), o = Z8(s, a.props);
      return a.type !== w.Fragment && (o.ref = t ? Sf(t, r) : r), w.cloneElement(a, o);
    }
    return w.Children.count(a) > 1 ? w.Children.only(null) : null;
  });
  return n.displayName = `${e}.SlotClone`, n;
}
var Y8 = Symbol("radix.slottable");
function X8(e) {
  return w.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Y8;
}
function Z8(e, n) {
  const i = { ...n };
  for (const t in n) {
    const a = e[t], s = n[t];
    /^on[A-Z]/.test(t) ? a && s ? i[t] = (...o) => {
      const d = s(...o);
      return a(...o), d;
    } : a && (i[t] = a) : t === "style" ? i[t] = { ...a, ...s } : t === "className" && (i[t] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...i };
}
function eP(e) {
  var t, a;
  let n = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = n && "isReactWarning" in n && n.isReactWarning;
  return i ? e.ref : (n = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, i = n && "isReactWarning" in n && n.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
function gf(e) {
  const n = e + "CollectionProvider", [i, t] = $t(n), [a, s] = i(
    n,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), r = (h) => {
    const { scope: N, children: S } = h, F = K.useRef(null), y = K.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l.jsx(a, { scope: N, itemMap: y, collectionRef: F, children: S });
  };
  r.displayName = n;
  const o = e + "CollectionSlot", d = /* @__PURE__ */ B1(o), c = K.forwardRef(
    (h, N) => {
      const { scope: S, children: F } = h, y = s(o, S), x = Rn(N, y.collectionRef);
      return /* @__PURE__ */ l.jsx(d, { ref: x, children: F });
    }
  );
  c.displayName = o;
  const u = e + "CollectionItemSlot", k = "data-radix-collection-item", m = /* @__PURE__ */ B1(u), f = K.forwardRef(
    (h, N) => {
      const { scope: S, children: F, ...y } = h, x = K.useRef(null), R = Rn(N, x), T = s(u, S);
      return K.useEffect(() => (T.itemMap.set(x, { ref: x, ...y }), () => void T.itemMap.delete(x))), /* @__PURE__ */ l.jsx(m, { [k]: "", ref: R, children: F });
    }
  );
  f.displayName = u;
  function p(h) {
    const N = s(e + "CollectionConsumer", h);
    return K.useCallback(() => {
      const F = N.collectionRef.current;
      if (!F) return [];
      const y = Array.from(F.querySelectorAll(`[${k}]`));
      return Array.from(N.itemMap.values()).sort(
        (T, j) => y.indexOf(T.ref.current) - y.indexOf(j.ref.current)
      );
    }, [N.collectionRef, N.itemMap]);
  }
  return [
    { Provider: r, Slot: c, ItemSlot: f },
    p,
    t
  ];
}
function nn(e, n, { checkForDefaultPrevented: i = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), i === !1 || !a.defaultPrevented)
      return n == null ? void 0 : n(a);
  };
}
var Mi = globalThis != null && globalThis.document ? w.useLayoutEffect : () => {
}, nP = w[" useInsertionEffect ".trim().toString()] || Mi;
function Oa({
  prop: e,
  defaultProp: n,
  onChange: i = () => {
  },
  caller: t
}) {
  const [a, s, r] = iP({
    defaultProp: n,
    onChange: i
  }), o = e !== void 0, d = o ? e : a;
  {
    const u = w.useRef(e !== void 0);
    w.useEffect(() => {
      const k = u.current;
      k !== o && console.warn(
        `${t} is changing from ${k ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = o;
    }, [o, t]);
  }
  const c = w.useCallback(
    (u) => {
      var k;
      if (o) {
        const m = tP(u) ? u(e) : u;
        m !== e && ((k = r.current) == null || k.call(r, m));
      } else
        s(u);
    },
    [o, e, s, r]
  );
  return [d, c];
}
function iP({
  defaultProp: e,
  onChange: n
}) {
  const [i, t] = w.useState(e), a = w.useRef(i), s = w.useRef(n);
  return nP(() => {
    s.current = n;
  }, [n]), w.useEffect(() => {
    var r;
    a.current !== i && ((r = s.current) == null || r.call(s, i), a.current = i);
  }, [i, a]), [i, t, s];
}
function tP(e) {
  return typeof e == "function";
}
var aP = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ln = aP.reduce((e, n) => {
  const i = /* @__PURE__ */ B1(`Primitive.${n}`), t = w.forwardRef((a, s) => {
    const { asChild: r, ...o } = a, d = r ? i : n;
    return typeof window != "undefined" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(d, { ...o, ref: s });
  });
  return t.displayName = `Primitive.${n}`, { ...e, [n]: t };
}, {});
function lP(e, n) {
  e && Gu.flushSync(() => e.dispatchEvent(n));
}
function sP(e, n) {
  return w.useReducer((i, t) => {
    const a = n[i][t];
    return a != null ? a : i;
  }, e);
}
var kl = (e) => {
  const { present: n, children: i } = e, t = rP(n), a = typeof i == "function" ? i({ present: t.isPresent }) : w.Children.only(i), s = Rn(t.ref, oP(a));
  return typeof i == "function" || t.isPresent ? w.cloneElement(a, { ref: s }) : null;
};
kl.displayName = "Presence";
function rP(e) {
  const [n, i] = w.useState(), t = w.useRef(null), a = w.useRef(e), s = w.useRef("none"), r = e ? "mounted" : "unmounted", [o, d] = sP(r, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return w.useEffect(() => {
    const c = Zd(t.current);
    s.current = o === "mounted" ? c : "none";
  }, [o]), Mi(() => {
    const c = t.current, u = a.current;
    if (u !== e) {
      const m = s.current, f = Zd(c);
      e ? d("MOUNT") : f === "none" || (c == null ? void 0 : c.display) === "none" ? d("UNMOUNT") : d(u && m !== f ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, d]), Mi(() => {
    var c;
    if (n) {
      let u;
      const k = (c = n.ownerDocument.defaultView) != null ? c : window, m = (p) => {
        const N = Zd(t.current).includes(CSS.escape(p.animationName));
        if (p.target === n && N && (d("ANIMATION_END"), !a.current)) {
          const S = n.style.animationFillMode;
          n.style.animationFillMode = "forwards", u = k.setTimeout(() => {
            n.style.animationFillMode === "forwards" && (n.style.animationFillMode = S);
          });
        }
      }, f = (p) => {
        p.target === n && (s.current = Zd(t.current));
      };
      return n.addEventListener("animationstart", f), n.addEventListener("animationcancel", m), n.addEventListener("animationend", m), () => {
        k.clearTimeout(u), n.removeEventListener("animationstart", f), n.removeEventListener("animationcancel", m), n.removeEventListener("animationend", m);
      };
    } else
      d("ANIMATION_END");
  }, [n, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: w.useCallback((c) => {
      t.current = c ? getComputedStyle(c) : null, i(c);
    }, [])
  };
}
function Zd(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function oP(e) {
  var t, a;
  let n = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = n && "isReactWarning" in n && n.isReactWarning;
  return i ? e.ref : (n = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, i = n && "isReactWarning" in n && n.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
var dP = w[" useId ".trim().toString()] || (() => {
}), cP = 0;
function Za(e) {
  const [n, i] = w.useState(dP());
  return Mi(() => {
    i((t) => t != null ? t : String(cP++));
  }, [e]), n ? `radix-${n}` : "";
}
var Xu = "Collapsible", [uP, QF] = $t(Xu), [mP, Ff] = uP(Xu), MF = w.forwardRef(
  (e, n) => {
    const {
      __scopeCollapsible: i,
      open: t,
      defaultOpen: a,
      disabled: s,
      onOpenChange: r,
      ...o
    } = e, [d, c] = Oa({
      prop: t,
      defaultProp: a != null ? a : !1,
      onChange: r,
      caller: Xu
    });
    return /* @__PURE__ */ l.jsx(
      mP,
      {
        scope: i,
        disabled: s,
        contentId: Za(),
        open: d,
        onOpenToggle: w.useCallback(() => c((u) => !u), [c]),
        children: /* @__PURE__ */ l.jsx(
          ln.div,
          {
            "data-state": yf(d),
            "data-disabled": s ? "" : void 0,
            ...o,
            ref: n
          }
        )
      }
    );
  }
);
MF.displayName = Xu;
var LF = "CollapsibleTrigger", $F = w.forwardRef(
  (e, n) => {
    const { __scopeCollapsible: i, ...t } = e, a = Ff(LF, i);
    return /* @__PURE__ */ l.jsx(
      ln.button,
      {
        type: "button",
        "aria-controls": a.contentId,
        "aria-expanded": a.open || !1,
        "data-state": yf(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        disabled: a.disabled,
        ...t,
        ref: n,
        onClick: nn(e.onClick, a.onOpenToggle)
      }
    );
  }
);
$F.displayName = LF;
var If = "CollapsibleContent", UF = w.forwardRef(
  (e, n) => {
    const { forceMount: i, ...t } = e, a = Ff(If, e.__scopeCollapsible);
    return /* @__PURE__ */ l.jsx(kl, { present: i || a.open, children: ({ present: s }) => /* @__PURE__ */ l.jsx(kP, { ...t, ref: n, present: s }) });
  }
);
UF.displayName = If;
var kP = w.forwardRef((e, n) => {
  const { __scopeCollapsible: i, present: t, children: a, ...s } = e, r = Ff(If, i), [o, d] = w.useState(t), c = w.useRef(null), u = Rn(n, c), k = w.useRef(0), m = k.current, f = w.useRef(0), p = f.current, h = r.open || o, N = w.useRef(h), S = w.useRef(void 0);
  return w.useEffect(() => {
    const F = requestAnimationFrame(() => N.current = !1);
    return () => cancelAnimationFrame(F);
  }, []), Mi(() => {
    const F = c.current;
    if (F) {
      S.current = S.current || {
        transitionDuration: F.style.transitionDuration,
        animationName: F.style.animationName
      }, F.style.transitionDuration = "0s", F.style.animationName = "none";
      const y = F.getBoundingClientRect();
      k.current = y.height, f.current = y.width, N.current || (F.style.transitionDuration = S.current.transitionDuration, F.style.animationName = S.current.animationName), d(t);
    }
  }, [r.open, t]), /* @__PURE__ */ l.jsx(
    ln.div,
    {
      "data-state": yf(r.open),
      "data-disabled": r.disabled ? "" : void 0,
      id: r.contentId,
      hidden: !h,
      ...s,
      ref: u,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": p ? `${p}px` : void 0,
        ...e.style
      },
      children: h && a
    }
  );
});
function yf(e) {
  return e ? "open" : "closed";
}
var fP = MF, vP = $F, hP = UF, pP = w.createContext(void 0);
function Zu(e) {
  const n = w.useContext(pP);
  return e || n || "ltr";
}
var da = "Accordion", NP = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [bf, SP, gP] = gf(da), [em] = $t(da, [
  gP,
  QF
]), Cf = QF(), VF = K.forwardRef(
  (e, n) => {
    const { type: i, ...t } = e, a = t, s = t;
    return /* @__PURE__ */ l.jsx(bf.Provider, { scope: e.__scopeAccordion, children: i === "multiple" ? /* @__PURE__ */ l.jsx(bP, { ...s, ref: n }) : /* @__PURE__ */ l.jsx(yP, { ...a, ref: n }) });
  }
);
VF.displayName = da;
var [HF, FP] = em(da), [zF, IP] = em(
  da,
  { collapsible: !1 }
), yP = K.forwardRef(
  (e, n) => {
    const {
      value: i,
      defaultValue: t,
      onValueChange: a = () => {
      },
      collapsible: s = !1,
      ...r
    } = e, [o, d] = Oa({
      prop: i,
      defaultProp: t != null ? t : "",
      onChange: a,
      caller: da
    });
    return /* @__PURE__ */ l.jsx(
      HF,
      {
        scope: e.__scopeAccordion,
        value: K.useMemo(() => o ? [o] : [], [o]),
        onItemOpen: d,
        onItemClose: K.useCallback(() => s && d(""), [s, d]),
        children: /* @__PURE__ */ l.jsx(zF, { scope: e.__scopeAccordion, collapsible: s, children: /* @__PURE__ */ l.jsx(BF, { ...r, ref: n }) })
      }
    );
  }
), bP = K.forwardRef((e, n) => {
  const {
    value: i,
    defaultValue: t,
    onValueChange: a = () => {
    },
    ...s
  } = e, [r, o] = Oa({
    prop: i,
    defaultProp: t != null ? t : [],
    onChange: a,
    caller: da
  }), d = K.useCallback(
    (u) => o((k = []) => [...k, u]),
    [o]
  ), c = K.useCallback(
    (u) => o((k = []) => k.filter((m) => m !== u)),
    [o]
  );
  return /* @__PURE__ */ l.jsx(
    HF,
    {
      scope: e.__scopeAccordion,
      value: r,
      onItemOpen: d,
      onItemClose: c,
      children: /* @__PURE__ */ l.jsx(zF, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ l.jsx(BF, { ...s, ref: n }) })
    }
  );
}), [CP, nm] = em(da), BF = K.forwardRef(
  (e, n) => {
    const { __scopeAccordion: i, disabled: t, dir: a, orientation: s = "vertical", ...r } = e, o = K.useRef(null), d = Rn(o, n), c = SP(i), k = Zu(a) === "ltr", m = nn(e.onKeyDown, (f) => {
      var A;
      if (!NP.includes(f.key)) return;
      const p = f.target, h = c().filter((B) => {
        var W;
        return !((W = B.ref.current) != null && W.disabled);
      }), N = h.findIndex((B) => B.ref.current === p), S = h.length;
      if (N === -1) return;
      f.preventDefault();
      let F = N;
      const y = 0, x = S - 1, R = () => {
        F = N + 1, F > x && (F = y);
      }, T = () => {
        F = N - 1, F < y && (F = x);
      };
      switch (f.key) {
        case "Home":
          F = y;
          break;
        case "End":
          F = x;
          break;
        case "ArrowRight":
          s === "horizontal" && (k ? R() : T());
          break;
        case "ArrowDown":
          s === "vertical" && R();
          break;
        case "ArrowLeft":
          s === "horizontal" && (k ? T() : R());
          break;
        case "ArrowUp":
          s === "vertical" && T();
          break;
      }
      const j = F % S;
      (A = h[j].ref.current) == null || A.focus();
    });
    return /* @__PURE__ */ l.jsx(
      CP,
      {
        scope: i,
        disabled: t,
        direction: a,
        orientation: s,
        children: /* @__PURE__ */ l.jsx(bf.Slot, { scope: i, children: /* @__PURE__ */ l.jsx(
          ln.div,
          {
            ...r,
            "data-orientation": s,
            ref: d,
            onKeyDown: t ? void 0 : m
          }
        ) })
      }
    );
  }
), lu = "AccordionItem", [xP, xf] = em(lu), qF = K.forwardRef(
  (e, n) => {
    const { __scopeAccordion: i, value: t, ...a } = e, s = nm(lu, i), r = FP(lu, i), o = Cf(i), d = Za(), c = t && r.value.includes(t) || !1, u = s.disabled || e.disabled;
    return /* @__PURE__ */ l.jsx(
      xP,
      {
        scope: i,
        open: c,
        disabled: u,
        triggerId: d,
        children: /* @__PURE__ */ l.jsx(
          fP,
          {
            "data-orientation": s.orientation,
            "data-state": ZF(c),
            ...o,
            ...a,
            ref: n,
            disabled: u,
            open: c,
            onOpenChange: (k) => {
              k ? r.onItemOpen(t) : r.onItemClose(t);
            }
          }
        )
      }
    );
  }
);
qF.displayName = lu;
var GF = "AccordionHeader", WF = K.forwardRef(
  (e, n) => {
    const { __scopeAccordion: i, ...t } = e, a = nm(da, i), s = xf(GF, i);
    return /* @__PURE__ */ l.jsx(
      ln.h3,
      {
        "data-orientation": a.orientation,
        "data-state": ZF(s.open),
        "data-disabled": s.disabled ? "" : void 0,
        ...t,
        ref: n
      }
    );
  }
);
WF.displayName = GF;
var R3 = "AccordionTrigger", KF = K.forwardRef(
  (e, n) => {
    const { __scopeAccordion: i, ...t } = e, a = nm(da, i), s = xf(R3, i), r = IP(R3, i), o = Cf(i);
    return /* @__PURE__ */ l.jsx(bf.ItemSlot, { scope: i, children: /* @__PURE__ */ l.jsx(
      vP,
      {
        "aria-disabled": s.open && !r.collapsible || void 0,
        "data-orientation": a.orientation,
        id: s.triggerId,
        ...o,
        ...t,
        ref: n
      }
    ) });
  }
);
KF.displayName = R3;
var YF = "AccordionContent", XF = K.forwardRef(
  (e, n) => {
    const { __scopeAccordion: i, ...t } = e, a = nm(da, i), s = xf(YF, i), r = Cf(i);
    return /* @__PURE__ */ l.jsx(
      hP,
      {
        role: "region",
        "aria-labelledby": s.triggerId,
        "data-orientation": a.orientation,
        ...r,
        ...t,
        ref: n,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
XF.displayName = YF;
function ZF(e) {
  return e ? "open" : "closed";
}
var DP = VF, wP = qF, PP = WF, T3 = KF, eI = XF;
const RP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M445.93-445.93H228.09q-14.43 0-24.25-9.88-9.82-9.87-9.82-24.37 0-14.49 9.82-24.19 9.82-9.7 24.25-9.7h217.84v-217.84q0-14.4 9.88-24.35 9.87-9.96 24.37-9.96 14.49 0 24.19 9.96 9.7 9.95 9.7 24.35v217.84h217.84q14.4 0 24.35 9.88 9.96 9.87 9.96 24.37 0 14.49-9.96 24.19-9.95 9.7-24.35 9.7H514.07v217.84q0 14.43-9.88 24.25-9.87 9.82-24.37 9.82-14.49 0-24.19-9.82-9.7-9.82-9.7-24.25v-217.84Z" }));
function nI(e) {
  var n, i, t = "";
  if (typeof e == "string" || typeof e == "number") t += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (n = 0; n < a; n++) e[n] && (i = nI(e[n])) && (t && (t += " "), t += i);
  } else for (i in e) e[i] && (t && (t += " "), t += i);
  return t;
}
function iI() {
  for (var e, n, i = 0, t = "", a = arguments.length; i < a; i++) (e = arguments[i]) && (n = nI(e)) && (t && (t += " "), t += n);
  return t;
}
const Rp = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Tp = iI, Df = (e, n) => (i) => {
  var t;
  if ((n == null ? void 0 : n.variants) == null) return Tp(e, i == null ? void 0 : i.class, i == null ? void 0 : i.className);
  const { variants: a, defaultVariants: s } = n, r = Object.keys(a).map((c) => {
    const u = i == null ? void 0 : i[c], k = s == null ? void 0 : s[c];
    if (u === null) return null;
    const m = Rp(u) || Rp(k);
    return a[c][m];
  }), o = i && Object.entries(i).reduce((c, u) => {
    let [k, m] = u;
    return m === void 0 || (c[k] = m), c;
  }, {}), d = n == null || (t = n.compoundVariants) === null || t === void 0 ? void 0 : t.reduce((c, u) => {
    let { class: k, className: m, ...f } = u;
    return Object.entries(f).every((p) => {
      let [h, N] = p;
      return Array.isArray(N) ? N.includes({
        ...s,
        ...o
      }[h]) : {
        ...s,
        ...o
      }[h] === N;
    }) ? [
      ...c,
      k,
      m
    ] : c;
  }, []);
  return Tp(e, r, d, i == null ? void 0 : i.class, i == null ? void 0 : i.className);
}, TP = Df("", {
  variants: {
    svgColor: {
      current: "ch-fill-current"
    },
    size: {
      "3xs": "ch-h-2 ch-w-2",
      "2xs": "ch-h-3 ch-w-3",
      xs: "ch-h-4 ch-w-4",
      sm: "ch-h-5 ch-w-5",
      md: "ch-h-6 ch-w-6",
      lg: "ch-h-8 ch-w-8"
    }
  },
  defaultVariants: {
    svgColor: "current",
    size: "md"
  }
}), gi = ({ svgIcon: e, className: n, svgColor: i, size: t }) => /* @__PURE__ */ l.jsx(e, { className: ce("ch-shrink-0", TP({ svgColor: i, size: t }), n) }), jp = (e) => {
  const n = () => gi({ ...e, svgIcon: RP });
  return /* @__PURE__ */ l.jsx(n, {});
}, jP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M451.57-444.57V-310q0 13.36 8.98 22.4 8.99 9.03 22.63 9.03 13.63 0 22.44-8.93 8.81-8.94 8.81-22.56v-134.51H650q13.36 0 22.4-8.98 9.03-8.99 9.03-22.63 0-13.63-8.93-22.44-8.94-8.81-22.56-8.81H514.43V-650q0-13.36-8.98-22.4-8.99-9.03-22.63-9.03-13.63 0-22.44 8.93-8.81 8.94-8.81 22.56v142.51H310q-13.36 0-22.4 8.98-9.03 8.99-9.03 22.63 0 13.63 8.93 22.44 8.94 8.81 22.56 8.81h141.51ZM480.3-74.02q-84.2 0-158.04-31.88-73.84-31.88-129.16-87.2-55.32-55.32-87.2-129.2-31.88-73.88-31.88-158.17 0-84.28 31.88-158.2 31.88-73.91 87.16-128.74 55.28-54.84 129.18-86.82 73.9-31.99 158.21-31.99 84.3 0 158.25 31.97 73.94 31.97 128.75 86.77 54.82 54.8 86.79 128.88 31.98 74.08 31.98 158.33 0 84.24-31.99 158.07-31.98 73.84-86.82 128.95-54.83 55.1-128.87 87.17Q564.5-74.02 480.3-74.02Zm.2-68.13q140.54 0 238.95-98.75 98.4-98.76 98.4-239.6 0-140.54-98.22-238.95-98.21-98.4-239.75-98.4-140.16 0-238.95 98.22-98.78 98.21-98.78 239.75 0 140.16 98.75 238.95 98.76 98.78 239.6 98.78ZM480-480Z" })), AP = (e) => {
  const n = () => gi({ ...e, svgIcon: jP });
  return /* @__PURE__ */ l.jsx(n, {});
}, OP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M676.2-445.93H188.09q-14.68 0-24.37-9.7-9.7-9.7-9.7-24.37 0-14.67 9.7-24.37 9.69-9.7 24.37-9.7H676.2L456.13-734.13q-10.2-10.2-10.33-24.03-.14-13.84 10.07-24.09 10.22-10.29 24.09-10.17 13.87.12 24.15 10.31l278 278q5.46 5.52 7.94 11.48 2.49 5.97 2.49 12.66t-2.49 12.63q-2.48 5.95-7.94 11.45l-278.24 278q-10.55 10.43-24.17 10.43-13.61 0-23.81-10.49-10.19-10.21-10.19-23.85 0-13.63 10.19-23.83l220.31-220.3Z" })), Ap = (e) => {
  const n = () => gi({ ...e, svgIcon: OP });
  return /* @__PURE__ */ l.jsx(n, {});
}, EP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M272.39-609.04q-31.06 0-52.92-21.88-21.86-21.88-21.86-52.96 0-30.79 21.82-52.77 21.82-21.98 52.81-21.98 31 0 52.98 21.9 21.98 21.9 21.98 52.81 0 30.92-21.87 52.9-21.87 21.98-52.94 21.98ZM190.37-74.02q-18.94 0-33.7-12.1-14.76-12.1-14.76-30.05-28.09 0-47.99-20.02-19.9-20.01-19.9-48.11v-231.44q0-14.42 9.82-24.24 9.82-9.82 24.25-9.82h89.52v-25.89q0-36.64 26.07-62.59 26.08-25.96 62.89-25.96 20.01 0 38.35 7.72t32.3 23.15l51.76 57.74q6.76 7.79 14.26 14.19 7.5 6.4 15.25 11.64h299.36v-322.77q0-18.74-12.48-32.13-12.48-13.39-31.04-13.39-9.87 0-18.7 2.06t-15.59 8.7l-49.13 48.18q5.24 18.91.07 37.97-5.18 19.05-15.85 36.01l-108.7-103.46q17.4-12.84 37.61-17.31 20.22-4.47 40.37 2.05l51.76-50.04q15.24-15.24 35.5-23.77 20.26-8.52 42.66-8.52 46.98 0 79.44 33.31 32.45 33.31 32.45 80.34v322.77h45.69q14.4 0 24.35 9.82 9.96 9.82 9.96 24.24v231.44q0 28.1-20.02 48.11-20.01 20.02-48.11 20.02 0 17.95-14.76 30.05-14.76 12.1-34.87 12.1H190.37Zm-48.22-110.52h675.7v-197.13h-675.7v197.13Zm0 0h675.7-675.7Z" })), tI = (e) => {
  const n = () => gi({ ...e, svgIcon: EP });
  return /* @__PURE__ */ l.jsx(n, {});
}, JP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M74.02-224.5v-226.91q0-25.69 9.88-48.66 9.88-22.97 30.12-36.63v-113.71q0-47.31 32.3-79.77 32.29-32.45 79.68-32.45h180q21.76 0 40.8 9.77 19.03 9.77 33.2 26.03 14.17-16.26 32.7-26.03 18.54-9.77 40.3-9.77h180q47.31 0 80.26 32.45 32.96 32.46 32.96 79.77v113.71q20 13.66 30 36.63 10 22.97 10 48.66v226.91q0 14.67-9.84 24.37-9.83 9.7-24.49 9.7-14.65 0-24.35-9.7-9.69-9.7-9.69-24.37v-45.93h-675.7v45.93q0 14.67-9.69 24.37-9.7 9.7-24.37 9.7-14.68 0-24.37-9.7-9.7-9.7-9.7-24.37ZM510-551.41h267.85v-99q0-19.11-12.88-31.48-12.88-12.37-31.97-12.37H547.85q-16.26 0-27.06 13.29Q510-667.67 510-650.41v99Zm-327.85 0H450v-99q0-17.29-10.79-30.57-10.8-13.28-27.06-13.28H226q-18.09 0-30.97 12.88-12.88 12.88-12.88 30.97v99Zm-40 212.84h675.7v-115q0-16.04-10.88-26.94-10.88-10.9-26.97-10.9H180q-16.09 0-26.97 10.88-10.88 10.88-10.88 26.96v115Zm675.7 0h-675.7 675.7Z" })), im = (e) => {
  const n = () => gi({ ...e, svgIcon: JP });
  return /* @__PURE__ */ l.jsx(n, {});
}, _P = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "m378-338.22 359.89-359.65q10.49-10.2 24.64-10.2 14.14 0 24.34 10.25t10.2 24.44q0 14.2-10.2 24.49L402.11-264.37q-10.28 10.2-24.15 10.2t-24.07-10.2L172.37-445.89q-10.2-10.36-9.82-24.57.38-14.21 10.63-24.41t24.44-10.2q14.2 0 24.49 10.2L378-338.22Z" })), aI = (e) => {
  const n = () => gi({ ...e, svgIcon: _P });
  return /* @__PURE__ */ l.jsx(n, {});
}, QP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "m420.52-395.22-93.45-93.45q-9.96-9.96-24.42-9.96t-25.61 10.96q-9.95 10.19-9.95 24.63 0 14.43 10.19 24.39l119.13 120.13q10.31 10.19 24.05 10.19t24.17-10.19l236.13-236.37q11.2-10.96 11.2-25.3t-11.2-25.48q-10.96-9.96-25.92-9.46t-25.1 10.46L420.52-395.22Zm59.51 321.2q-83.46 0-157.54-31.88-74.07-31.88-129.39-87.2-55.32-55.32-87.2-129.36-31.88-74.04-31.88-157.51 0-84.46 31.88-158.54 31.88-74.07 87.16-128.9 55.28-54.84 129.34-86.82 74.06-31.99 157.55-31.99 84.48 0 158.59 31.97 74.1 31.97 128.91 86.77 54.82 54.8 86.79 128.88 31.98 74.08 31.98 158.6 0 83.5-31.99 157.57-31.98 74.07-86.82 129.36-54.83 55.29-128.87 87.17-74.04 31.88-158.51 31.88Z" })), tm = (e) => {
  const n = () => gi({ ...e, svgIcon: QP });
  return /* @__PURE__ */ l.jsx(n, {});
}, MP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M480.03-74.02q-83.46 0-157.54-31.88-74.07-31.88-129.39-87.2-55.32-55.32-87.2-129.36-31.88-74.04-31.88-157.51 0-84.46 31.88-158.54 31.88-74.07 87.16-128.9 55.28-54.84 129.34-86.82 74.06-31.99 157.55-31.99 84.48 0 158.59 31.97 74.1 31.97 128.91 86.77 54.82 54.8 86.79 128.88 31.98 74.08 31.98 158.6 0 83.5-31.99 157.57-31.98 74.07-86.82 129.36-54.83 55.29-128.87 87.17-74.04 31.88-158.51 31.88Zm-.03-68.13q141.04 0 239.45-98.75 98.4-98.76 98.4-239.1 0-141.04-98.4-239.45-98.41-98.4-239.57-98.4-140.16 0-238.95 98.4-98.78 98.41-98.78 239.57 0 140.16 98.75 238.95 98.76 98.78 239.1 98.78ZM480-480Z" })), am = (e) => {
  const n = () => gi({ ...e, svgIcon: MP });
  return /* @__PURE__ */ l.jsx(n, {});
}, LP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M480-432.26 272.87-225.13q-10.2 10.2-23.87 10.2-13.67 0-23.87-10.2-10.2-10.2-10.2-23.87 0-13.67 10.2-23.87L432.26-480 225.13-687.13q-10.2-10.2-10.2-23.87 0-13.67 10.2-23.87 10.2-10.2 23.87-10.2 13.67 0 23.87 10.2L480-527.74l207.13-207.13q10.2-10.2 23.87-10.2 13.67 0 23.87 10.2 10.2 10.2 10.2 23.87 0 13.67-10.2 23.87L527.74-480l207.13 207.13q10.2 10.2 10.2 23.87 0 13.67-10.2 23.87-10.2 10.2-23.87 10.2-13.67 0-23.87-10.2L480-432.26Z" })), Ei = (e) => {
  const n = () => gi({ ...e, svgIcon: LP });
  return /* @__PURE__ */ l.jsx(n, {});
}, $P = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M259.09-114.02q-28.45 0-48.41-19.89-19.96-19.89-19.96-48.24v-565.94h-11q-14.43 0-24.25-9.87t-9.82-24.37q0-14.5 9.82-24.19 9.82-9.7 24.25-9.7h164.21q0-14.67 9.83-24.49 9.82-9.81 24.24-9.81h203.76q14.42 0 24.25 9.95 9.82 9.96 9.82 24.35h164.45q14.43 0 24.25 9.87t9.82 24.37q0 14.5-9.82 24.2-9.82 9.69-24.25 9.69h-11v565.94q0 28.35-19.96 48.24t-48.41 19.89H259.09Zm441.82-634.07H259.09v565.94h441.82v-565.94ZM396.1-266.24q13.66 0 22.76-9.25 9.1-9.26 9.1-22.66v-335.18q0-13.4-9.31-22.65-9.31-9.26-22.78-9.26-13.78 0-22.88 9.26-9.1 9.25-9.1 22.65v335.18q0 13.4 9.27 22.66 9.28 9.25 22.94 9.25Zm168.32 0q13.49 0 22.71-9.25 9.22-9.26 9.22-22.66v-335.18q0-13.4-9.37-22.65-9.37-9.26-22.93-9.26-13.57 0-22.79 9.26-9.22 9.25-9.22 22.65v335.18q0 13.4 9.44 22.66 9.44 9.25 22.94 9.25ZM259.09-748.09v565.94-565.94Z" })), UP = (e) => {
  const n = () => gi({ ...e, svgIcon: $P });
  return /* @__PURE__ */ l.jsx(n, {});
}, VP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M479.93-274.02q16.46 0 27.4-10.74 10.93-10.75 10.93-27.21t-10.86-27.52q-10.86-11.05-27.33-11.05-16.46 0-27.4 11.03-10.93 11.04-10.93 27.5 0 16.47 10.86 27.23 10.86 10.76 27.33 10.76Zm3.25-158.74q14.49 0 24.19-9.82 9.7-9.82 9.7-24.25v-188.93q0-14.42-9.88-24.25-9.87-9.82-24.37-9.82-14.49 0-24.19 9.82-9.7 9.83-9.7 24.25v188.93q0 14.43 9.88 24.25 9.87 9.82 24.37 9.82ZM480.3-74.02q-84.2 0-158.04-31.88-73.84-31.88-129.16-87.2-55.32-55.32-87.2-129.2-31.88-73.88-31.88-158.17 0-84.28 31.88-158.2 31.88-73.91 87.16-128.74 55.28-54.84 129.18-86.82 73.9-31.99 158.21-31.99 84.3 0 158.25 31.97 73.94 31.97 128.75 86.77 54.82 54.8 86.79 128.88 31.98 74.08 31.98 158.33 0 84.24-31.99 158.07-31.98 73.84-86.82 128.95-54.83 55.1-128.87 87.17Q564.5-74.02 480.3-74.02Z" })), lI = (e) => {
  const n = () => gi({ ...e, svgIcon: VP });
  return /* @__PURE__ */ l.jsx(n, {});
}, HP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M483.13-277.37q13.92 0 23.21-9.38 9.29-9.38 9.29-23.25v-177.37q0-13.87-9.42-23.25-9.41-9.38-23.34-9.38-13.92 0-23.21 9.38-9.29 9.38-9.29 23.25V-310q0 13.87 9.42 23.25 9.41 9.38 23.34 9.38ZM480-590.41q15.55 0 26.07-10.23 10.52-10.24 10.52-25.36 0-16.24-10.52-26.92-10.51-10.67-26.05-10.67-15.81 0-26.21 10.67-10.4 10.68-10.4 26.8 0 15.27 10.52 25.49 10.52 10.22 26.07 10.22Zm.3 516.39q-84.2 0-158.04-31.88-73.84-31.88-129.16-87.2-55.32-55.32-87.2-129.2-31.88-73.88-31.88-158.17 0-84.28 31.88-158.2 31.88-73.91 87.16-128.74 55.28-54.84 129.18-86.82 73.9-31.99 158.21-31.99 84.3 0 158.25 31.97 73.94 31.97 128.75 86.77 54.82 54.8 86.79 128.88 31.98 74.08 31.98 158.33 0 84.24-31.99 158.07-31.98 73.84-86.82 128.95-54.83 55.1-128.87 87.17Q564.5-74.02 480.3-74.02Zm.2-68.13q140.54 0 238.95-98.75 98.4-98.76 98.4-239.6 0-140.54-98.22-238.95-98.21-98.4-239.75-98.4-140.16 0-238.95 98.22-98.78 98.21-98.78 239.75 0 140.16 98.75 238.95 98.76 98.78 239.6 98.78ZM480-480Z" })), zP = (e) => {
  const n = () => gi({ ...e, svgIcon: HP });
  return /* @__PURE__ */ l.jsx(n, {});
}, BP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M480-351.93q-6.72 0-12.67-2.48-5.96-2.48-11.44-7.96L258.13-560.13q-10.2-10.2-9.7-24.37.5-14.17 10.7-24.37 10.2-10.2 24.37-10.2 14.17 0 24.37 10.2L480-435.74l173.13-173.13q10.2-10.2 23.87-9.7 13.67.5 23.87 10.7 10.2 10.2 10.2 24.37 0 14.17-10.2 24.37L504.11-362.37q-5.48 5.48-11.44 7.96-5.95 2.48-12.67 2.48Z" })), qP = (e) => {
  const n = () => gi({ ...e, svgIcon: BP });
  return /* @__PURE__ */ l.jsx(n, {});
}, GP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "m411.74-481 174.13 174.13q10.2 10.2 9.7 23.87-.5 13.67-10.7 23.87-10.2 10.2-24.37 10.2-14.17 0-24.37-10.2L338.37-456.89q-5.48-5.48-7.96-11.44-2.48-5.95-2.48-12.67t2.48-12.67q2.48-5.96 7.96-11.44l198.76-198.76q10.2-10.2 24.37-10.2 14.17 0 24.37 10.2 10.2 10.2 10.2 24.37 0 14.17-10.2 24.37L411.74-481Z" })), lm = (e) => {
  const n = () => gi({ ...e, svgIcon: GP });
  return /* @__PURE__ */ l.jsx(n, {});
}, WP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M524.26-481 350.13-655.13q-10.2-10.2-9.7-23.87.5-13.67 10.7-23.87 10.2-10.2 24.37-10.2 14.17 0 24.37 10.2l197.76 197.76q5.48 5.48 7.96 11.44 2.48 5.95 2.48 12.67t-2.48 12.67q-2.48 5.96-7.96 11.44L398.87-258.13q-10.2 10.2-23.87 9.7-13.67-.5-23.87-10.7-10.2-10.2-10.2-24.37 0-14.17 10.2-24.37L524.26-481Z" })), zl = (e) => {
  const n = () => gi({ ...e, svgIcon: WP });
  return /* @__PURE__ */ l.jsx(n, {});
}, KP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M480-548.26 306.87-375.13q-10.2 10.2-23.87 9.7-13.67-.5-23.87-10.7-10.2-10.2-10.2-24.37 0-14.17 10.2-24.37l196.76-196.76q10.2-10.2 24.11-10.2t24.11 10.2l197.76 197.76q10.2 10.2 10.2 23.87 0 13.67-10.2 23.87-10.2 10.2-24.37 10.2-14.17 0-24.37-10.2L480-548.26Z" })), sI = (e) => {
  const n = () => gi({ ...e, svgIcon: KP });
  return /* @__PURE__ */ l.jsx(n, {});
}, YP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M196.13-196.1q-7.2-7.16-7.2-16.82 0-9.67 7.2-16.95l534-534q7.24-7.2 16.89-7.2t16.85 7.17q7.2 7.16 7.2 16.82 0 9.67-7.2 16.95l-534 534q-7.24 7.2-16.89 7.2t-16.85-7.17Z" })), XP = (e) => {
  const n = () => gi({ ...e, svgIcon: YP });
  return /* @__PURE__ */ l.jsx(n, {});
}, ZP = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M228.09-445.93q-14.43 0-24.25-9.88-9.82-9.87-9.82-24.37 0-14.49 9.82-24.19 9.82-9.7 24.25-9.7h503.82q14.43 0 24.37 9.88 9.94 9.87 9.94 24.37 0 14.49-9.94 24.19-9.94 9.7-24.37 9.7H228.09Z" })), eR = (e) => {
  const n = () => gi({ ...e, svgIcon: ZP });
  return /* @__PURE__ */ l.jsx(n, {});
}, nR = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M420.02-191.91v-183.81L260.54-283.7q-22.15 12.2-45.54 6.6t-35.83-27.75q-12.19-22.15-6.47-46.04 5.71-23.89 27.87-36.33L360.28-480 201.8-572.02q-22.15-12.2-28.48-35.97-6.34-23.77 5.85-45.92 12.44-21.92 35.95-27.75 23.51-5.84 45.66 6.59l159.24 91.79v-185.05q0-25.15 17.3-42.44 17.29-17.3 42.68-17.3t42.68 17.3q17.3 17.29 17.3 42.44v185.05l159.48-92.02q22.15-12.2 45.54-6.48 23.39 5.71 35.59 27.87 12.43 22.15 6.21 45.92-6.21 23.77-28.37 35.97L599.96-480l159.47 92.78q22.16 12.44 27.87 36.33 5.72 23.89-6.71 45.8-12.2 22.16-35.59 27.87-23.39 5.72-45.54-6.48l-159.48-92.02v183.81q0 25.39-17.3 42.68-17.29 17.3-42.68 17.3t-42.68-17.3q-17.3-17.29-17.3-42.68Z" })), sm = (e) => {
  const n = () => gi({ ...e, svgIcon: nR });
  return /* @__PURE__ */ l.jsx(n, {});
}, iR = (e) => /* @__PURE__ */ l.jsx("svg", { viewBox: "0 0 18 20", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ l.jsx("path", { d: "M13 4V12H16V20H18V0C15.24 0 13 2.24 13 4ZM8 7H6V0H4V7H2V0H0V7C0 9.21 1.79 11 4 11V20H6V11C8.21 11 10 9.21 10 7V0H8V7Z" }) }), tR = (e) => {
  const n = () => gi({ ...e, svgIcon: iR });
  return /* @__PURE__ */ l.jsx(n, {});
}, aR = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 48, height: 48, viewBox: "0 -960 960 960", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M663.59-32.83q-9.22 0-15.45-6.22-6.23-6.23-6.23-15.69 0-9.22 6.23-15.44 6.23-6.23 15.45-6.23h134.74v-60H663.59q-9.22 0-15.45-6.23-6.23-6.23-6.23-15.69 0-9.21 6.23-15.44 6.23-6.23 15.45-6.23h134.74v-60H663.59q-9.22 0-15.45-6.23-6.23-6.23-6.23-15.68 0-9.22 6.23-15.45 6.23-6.23 15.45-6.23h134.74v-60H663.59q-9.22 0-15.45-6.23-6.23-6.22-6.23-15.68 0-9.22 6.23-15.45 6.23-6.22 15.45-6.22h134.74v-60H663.59q-9.22 0-15.45-6.23-6.23-6.23-6.23-15.69 0-9.21 6.23-15.44 6.23-6.23 15.45-6.23h134.74v-60H663.59q-9.22 0-15.45-6.23-6.23-6.23-6.23-15.68 0-9.22 6.23-15.45 6.23-6.23 15.45-6.23h158.32q25.47 0 43.57 18.11 18.11 18.1 18.11 43.57v437.93q0 25.47-18.11 43.69-18.1 18.22-43.57 18.22H663.59ZM319.82-346.46q72.27 0 123.95-69.43 51.69-69.44 51.69-165.89 0-96.22-51.51-165.79-51.51-69.56-123.77-69.56-72.27 0-123.83 69.44-51.57 69.43-51.57 165.65 0 96.45 51.39 166.02 51.39 69.56 123.65 69.56ZM320-32.83q-41.15 0-66.61-30.43-25.46-30.44-20.46-70.35l17.24-157.15q-76-27.96-124.88-107.82-48.88-79.85-48.88-183.33 0-126.44 71.08-215.01Q218.57-885.5 320-885.5q101.43 0 172.51 88.58 71.08 88.57 71.08 215.01 0 103.48-49.38 183.33-49.38 79.86-125.38 107.82l18.24 157.39q5 39.91-20.58 70.23Q360.91-32.83 320-32.83Z" })), wf = (e) => {
  const n = () => gi({ ...e, svgIcon: aR });
  return /* @__PURE__ */ l.jsx(n, {});
}, qi = DP, it = w.forwardRef(({ className: e, borderBottom: n = !0, ...i }, t) => /* @__PURE__ */ l.jsx(
  wP,
  {
    ref: t,
    className: ce(n && "ch-border-b ch-border-b-zinc-200", e),
    ...i
  }
));
it.displayName = "AccordionItem";
const tt = w.forwardRef(({ className: e, children: n, arrowLeft: i = !1, hideArrow: t = !1, hover: a = !0, size: s = "medium", ...r }, o) => {
  const d = "ch-flex ch-flex-1 ch-rounded-md ch-items-center ch-text-left ch-font-medium ch-transition-all [&[data-state=open]>svg]:-ch-rotate-90 focus-visible:ch-outline-none focus-visible:ch-ring-2 focus-visible:ch-ring-focus-600 focus-visible:ch-ring-offset-2" + (s === "small" ? " ch-py-1" : " ch-p-4") + (a ? " hover:ch-underline" : ""), c = "ch-shrink-0 ch-transition-transform ch-duration-200 ch-rotate-90";
  return /* @__PURE__ */ l.jsx(PP, { className: "ch-flex", children: i ? (
    // arrowを「左」に表示する場合
    /* @__PURE__ */ l.jsxs(
      T3,
      {
        ref: o,
        className: ce(
          s === "medium" ? "ch-gap-x-4" : "ch-gap-x-1",
          d,
          e
        ),
        ...r,
        children: [
          t ? null : /* @__PURE__ */ l.jsx(zl, { className: c, size: "xs" }),
          n
        ]
      }
    )
  ) : (
    // arrowを「右」に表示する場合
    /* @__PURE__ */ l.jsxs(
      T3,
      {
        ref: o,
        className: ce("ch-justify-between", d, e),
        ...r,
        children: [
          n,
          t ? null : /* @__PURE__ */ l.jsx(zl, { className: c, size: "xs" })
        ]
      }
    )
  ) });
});
tt.displayName = T3.displayName;
const at = w.forwardRef(({ className: e, children: n, ...i }, t) => /* @__PURE__ */ l.jsx(
  eI,
  {
    ref: t,
    className: ce(
      "ch-overflow-hidden ch-text-sm ch-transition-all data-[state=closed]:ch-animate-accordion-up data-[state=open]:ch-animate-accordion-down",
      "ch-p-2 tablet:ch-p-4",
      e
    ),
    ...i,
    children: n
  }
));
at.displayName = eI.displayName;
const Pf = Ot({});
function Rf(e) {
  const n = Ye(null);
  return n.current === null && (n.current = e()), n.current;
}
const rm = Ot(null), Tf = Ot({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
class lR extends w.Component {
  getSnapshotBeforeUpdate(n) {
    const i = this.props.childRef.current;
    if (i && n.isPresent && !this.props.isPresent) {
      const t = this.props.sizeRef.current;
      t.height = i.offsetHeight || 0, t.width = i.offsetWidth || 0, t.top = i.offsetTop, t.left = i.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function sR({ children: e, isPresent: n }) {
  const i = ul(), t = Ye(null), a = Ye({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: s } = oi(Tf);
  return $9(() => {
    const { width: r, height: o, top: d, left: c } = a.current;
    if (n || !t.current || !r || !o)
      return;
    t.current.dataset.motionPopId = i;
    const u = document.createElement("style");
    return s && (u.nonce = s), document.head.appendChild(u), u.sheet && u.sheet.insertRule(`
          [data-motion-pop-id="${i}"] {
            position: absolute !important;
            width: ${r}px !important;
            height: ${o}px !important;
            top: ${d}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(u);
    };
  }, [n]), l.jsx(lR, { isPresent: n, childRef: t, sizeRef: a, children: w.cloneElement(e, { ref: t }) });
}
const rR = ({ children: e, initial: n, isPresent: i, onExitComplete: t, custom: a, presenceAffectsLayout: s, mode: r }) => {
  const o = Rf(oR), d = ul(), c = I((k) => {
    o.set(k, !0);
    for (const m of o.values())
      if (!m)
        return;
    t && t();
  }, [o, t]), u = v(
    () => ({
      id: d,
      initial: n,
      isPresent: i,
      custom: a,
      onExitComplete: c,
      register: (k) => (o.set(k, !1), () => o.delete(k))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    s ? [Math.random(), c] : [i, c]
  );
  return v(() => {
    o.forEach((k, m) => o.set(m, !1));
  }, [i]), w.useEffect(() => {
    !i && !o.size && t && t();
  }, [i]), r === "popLayout" && (e = l.jsx(sR, { isPresent: i, children: e })), l.jsx(rm.Provider, { value: u, children: e });
};
function oR() {
  return /* @__PURE__ */ new Map();
}
function rI(e = !0) {
  const n = oi(rm);
  if (n === null)
    return [!0, null];
  const { isPresent: i, onExitComplete: t, register: a } = n, s = ul();
  be(() => {
    e && a(s);
  }, [e]);
  const r = I(() => e && t && t(s), [s, t, e]);
  return !i && t ? [!1, r] : [!0];
}
const ec = (e) => e.key || "";
function Op(e) {
  const n = [];
  return O8.forEach(e, (i) => {
    jc(i) && n.push(i);
  }), n;
}
const jf = typeof window != "undefined", oI = jf ? as : be, dR = ({ children: e, custom: n, initial: i = !0, onExitComplete: t, presenceAffectsLayout: a = !0, mode: s = "sync", propagate: r = !1 }) => {
  const [o, d] = rI(r), c = v(() => Op(e), [e]), u = r && !o ? [] : c.map(ec), k = Ye(!0), m = Ye(c), f = Rf(() => /* @__PURE__ */ new Map()), [p, h] = se(c), [N, S] = se(c);
  oI(() => {
    k.current = !1, m.current = c;
    for (let x = 0; x < N.length; x++) {
      const R = ec(N[x]);
      u.includes(R) ? f.delete(R) : f.get(R) !== !0 && f.set(R, !1);
    }
  }, [N, u.length, u.join("-")]);
  const F = [];
  if (c !== p) {
    let x = [...c];
    for (let R = 0; R < N.length; R++) {
      const T = N[R], j = ec(T);
      u.includes(j) || (x.splice(R, 0, T), F.push(T));
    }
    s === "wait" && F.length && (x = F), S(Op(x)), h(c);
    return;
  }
  process.env.NODE_ENV !== "production" && s === "wait" && N.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: y } = oi(Pf);
  return l.jsx(l.Fragment, { children: N.map((x) => {
    const R = ec(x), T = r && !o ? !1 : c === N || u.includes(R), j = () => {
      if (f.has(R))
        f.set(R, !0);
      else
        return;
      let A = !0;
      f.forEach((B) => {
        B || (A = !1);
      }), A && (y == null || y(), S(m.current), r && (d == null || d()), t && t());
    };
    return l.jsx(rR, { isPresent: T, initial: !k.current || i ? void 0 : !1, custom: T ? void 0 : n, presenceAffectsLayout: a, mode: s, onExitComplete: T ? void 0 : j, children: x }, R);
  }) });
}, St = /* @__NO_SIDE_EFFECTS__ */ (e) => e;
let pr = St, Bl = St;
process.env.NODE_ENV !== "production" && (pr = (e, n) => {
  !e && typeof console != "undefined" && console.warn(n);
}, Bl = (e, n) => {
  if (!e)
    throw new Error(n);
});
// @__NO_SIDE_EFFECTS__
function Af(e) {
  let n;
  return () => (n === void 0 && (n = e()), n);
}
const q1 = /* @__NO_SIDE_EFFECTS__ */ (e, n, i) => {
  const t = n - e;
  return t === 0 ? 1 : (i - e) / t;
}, xa = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, el = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, cR = {
  useManualTiming: !1
};
function uR(e) {
  let n = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), t = !1, a = !1;
  const s = /* @__PURE__ */ new WeakSet();
  let r = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function o(c) {
    s.has(c) && (d.schedule(c), e()), c(r);
  }
  const d = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, u = !1, k = !1) => {
      const f = k && t ? n : i;
      return u && s.add(c), f.has(c) || f.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      i.delete(c), s.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (r = c, t) {
        a = !0;
        return;
      }
      t = !0, [n, i] = [i, n], n.forEach(o), n.clear(), t = !1, a && (a = !1, d.process(c));
    }
  };
  return d;
}
const nc = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], mR = 40;
function dI(e, n) {
  let i = !1, t = !0;
  const a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, s = () => i = !0, r = nc.reduce((S, F) => (S[F] = uR(s), S), {}), { read: o, resolveKeyframes: d, update: c, preRender: u, render: k, postRender: m } = r, f = () => {
    const S = performance.now();
    i = !1, a.delta = t ? 1e3 / 60 : Math.max(Math.min(S - a.timestamp, mR), 1), a.timestamp = S, a.isProcessing = !0, o.process(a), d.process(a), c.process(a), u.process(a), k.process(a), m.process(a), a.isProcessing = !1, i && n && (t = !1, e(f));
  }, p = () => {
    i = !0, t = !0, a.isProcessing || e(f);
  };
  return { schedule: nc.reduce((S, F) => {
    const y = r[F];
    return S[F] = (x, R = !1, T = !1) => (i || p(), y.schedule(x, R, T)), S;
  }, {}), cancel: (S) => {
    for (let F = 0; F < nc.length; F++)
      r[nc[F]].cancel(S);
  }, state: a, steps: r };
}
const { schedule: Yn, cancel: ql, state: zi, steps: c0 } = dI(typeof requestAnimationFrame != "undefined" ? requestAnimationFrame : St, !0), cI = Ot({ strict: !1 }), Ep = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, G1 = {};
for (const e in Ep)
  G1[e] = {
    isEnabled: (n) => Ep[e].some((i) => !!n[i])
  };
function kR(e) {
  for (const n in e)
    G1[n] = {
      ...G1[n],
      ...e[n]
    };
}
const fR = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function su(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || fR.has(e);
}
let uI = (e) => !su(e);
function vR(e) {
  e && (uI = (n) => n.startsWith("on") ? !su(n) : e(n));
}
try {
  vR(require("@emotion/is-prop-valid").default);
} catch (e) {
}
function hR(e, n, i) {
  const t = {};
  for (const a in e)
    a === "values" && typeof e.values == "object" || (uI(a) || i === !0 && su(a) || !n && !su(a) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && a.startsWith("onDrag")) && (t[a] = e[a]);
  return t;
}
const Jp = /* @__PURE__ */ new Set();
function om(e, n, i) {
  e || Jp.has(n) || (console.warn(n), Jp.add(n));
}
function pR(e) {
  if (typeof Proxy == "undefined")
    return e;
  const n = /* @__PURE__ */ new Map(), i = (...t) => (process.env.NODE_ENV !== "production" && om(!1, "motion() is deprecated. Use motion.create() instead."), e(...t));
  return new Proxy(i, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (t, a) => a === "create" ? e : (n.has(a) || n.set(a, e(a)), n.get(a))
  });
}
const dm = Ot({});
function Ao(e) {
  return typeof e == "string" || Array.isArray(e);
}
function cm(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const Of = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Ef = ["initial", ...Of];
function um(e) {
  return cm(e.animate) || Ef.some((n) => Ao(e[n]));
}
function mI(e) {
  return !!(um(e) || e.variants);
}
function NR(e, n) {
  if (um(e)) {
    const { initial: i, animate: t } = e;
    return {
      initial: i === !1 || Ao(i) ? i : void 0,
      animate: Ao(t) ? t : void 0
    };
  }
  return e.inherit !== !1 ? n : {};
}
function SR(e) {
  const { initial: n, animate: i } = NR(e, oi(dm));
  return v(() => ({ initial: n, animate: i }), [_p(n), _p(i)]);
}
function _p(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const gR = Symbol.for("motionComponentSymbol");
function P1(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function FR(e, n, i) {
  return I(
    (t) => {
      t && e.onMount && e.onMount(t), n && (t ? n.mount(t) : n.unmount()), i && (typeof i == "function" ? i(t) : P1(i) && (i.current = t));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [n]
  );
}
const Jf = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), IR = "framerAppearId", kI = "data-" + Jf(IR), { schedule: _f } = dI(queueMicrotask, !1), fI = Ot({});
function yR(e, n, i, t, a) {
  var s, r;
  const { visualElement: o } = oi(dm), d = oi(cI), c = oi(rm), u = oi(Tf).reducedMotion, k = Ye(null);
  t = t || d.renderer, !k.current && t && (k.current = t(e, {
    visualState: n,
    parent: o,
    props: i,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const m = k.current, f = oi(fI);
  m && !m.projection && a && (m.type === "html" || m.type === "svg") && bR(k.current, i, a, f);
  const p = Ye(!1);
  $9(() => {
    m && p.current && m.update(i, c);
  });
  const h = i[kI], N = Ye(!!h && !(!((s = window.MotionHandoffIsComplete) === null || s === void 0) && s.call(window, h)) && ((r = window.MotionHasOptimisedAnimation) === null || r === void 0 ? void 0 : r.call(window, h)));
  return oI(() => {
    m && (p.current = !0, window.MotionIsMounted = !0, m.updateFeatures(), _f.render(m.render), N.current && m.animationState && m.animationState.animateChanges());
  }), be(() => {
    m && (!N.current && m.animationState && m.animationState.animateChanges(), N.current && (queueMicrotask(() => {
      var S;
      (S = window.MotionHandoffMarkAsComplete) === null || S === void 0 || S.call(window, h);
    }), N.current = !1));
  }), m;
}
function bR(e, n, i, t) {
  const { layoutId: a, layout: s, drag: r, dragConstraints: o, layoutScroll: d, layoutRoot: c } = n;
  e.projection = new i(e.latestValues, n["data-framer-portal-id"] ? void 0 : vI(e.parent)), e.projection.setOptions({
    layoutId: a,
    layout: s,
    alwaysMeasureLayout: !!r || o && P1(o),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof s == "string" ? s : "both",
    initialPromotionConfig: t,
    layoutScroll: d,
    layoutRoot: c
  });
}
function vI(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : vI(e.parent);
}
function CR({ preloadedFeatures: e, createVisualElement: n, useRender: i, useVisualState: t, Component: a }) {
  var s, r;
  e && kR(e);
  function o(c, u) {
    let k;
    const m = {
      ...oi(Tf),
      ...c,
      layoutId: xR(c)
    }, { isStatic: f } = m, p = SR(c), h = t(c, f);
    if (!f && jf) {
      DR(m, e);
      const N = wR(m);
      k = N.MeasureLayout, p.visualElement = yR(a, h, m, n, N.ProjectionNode);
    }
    return l.jsxs(dm.Provider, { value: p, children: [k && p.visualElement ? l.jsx(k, { visualElement: p.visualElement, ...m }) : null, i(a, c, FR(h, p.visualElement, u), h, f, p.visualElement)] });
  }
  o.displayName = `motion.${typeof a == "string" ? a : `create(${(r = (s = a.displayName) !== null && s !== void 0 ? s : a.name) !== null && r !== void 0 ? r : ""})`}`;
  const d = Li(o);
  return d[gR] = a, d;
}
function xR({ layoutId: e }) {
  const n = oi(Pf).id;
  return n && e !== void 0 ? n + "-" + e : e;
}
function DR(e, n) {
  const i = oi(cI).strict;
  if (process.env.NODE_ENV !== "production" && n && i) {
    const t = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? pr(!1, t) : Bl(!1, t);
  }
}
function wR(e) {
  const { drag: n, layout: i } = G1;
  if (!n && !i)
    return {};
  const t = { ...n, ...i };
  return {
    MeasureLayout: n != null && n.isEnabled(e) || i != null && i.isEnabled(e) ? t.MeasureLayout : void 0,
    ProjectionNode: t.ProjectionNode
  };
}
const PR = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Qf(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(PR.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function Qp(e) {
  const n = [{}, {}];
  return e == null || e.values.forEach((i, t) => {
    n[0][t] = i.get(), n[1][t] = i.getVelocity();
  }), n;
}
function Mf(e, n, i, t) {
  if (typeof n == "function") {
    const [a, s] = Qp(t);
    n = n(i !== void 0 ? i : e.custom, a, s);
  }
  if (typeof n == "string" && (n = e.variants && e.variants[n]), typeof n == "function") {
    const [a, s] = Qp(t);
    n = n(i !== void 0 ? i : e.custom, a, s);
  }
  return n;
}
const j3 = (e) => Array.isArray(e), RR = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), TR = (e) => j3(e) ? e[e.length - 1] || 0 : e, et = (e) => !!(e && e.getVelocity);
function Ac(e) {
  const n = et(e) ? e.get() : e;
  return RR(n) ? n.toValue() : n;
}
function jR({ scrapeMotionValuesFromProps: e, createRenderState: n, onUpdate: i }, t, a, s) {
  const r = {
    latestValues: AR(t, a, s, e),
    renderState: n()
  };
  return i && (r.onMount = (o) => i({ props: t, current: o, ...r }), r.onUpdate = (o) => i(o)), r;
}
const hI = (e) => (n, i) => {
  const t = oi(dm), a = oi(rm), s = () => jR(e, n, t, a);
  return i ? s() : Rf(s);
};
function AR(e, n, i, t) {
  const a = {}, s = t(e, {});
  for (const m in s)
    a[m] = Ac(s[m]);
  let { initial: r, animate: o } = e;
  const d = um(e), c = mI(e);
  n && c && !d && e.inherit !== !1 && (r === void 0 && (r = n.initial), o === void 0 && (o = n.animate));
  let u = i ? i.initial === !1 : !1;
  u = u || r === !1;
  const k = u ? o : r;
  if (k && typeof k != "boolean" && !cm(k)) {
    const m = Array.isArray(k) ? k : [k];
    for (let f = 0; f < m.length; f++) {
      const p = Mf(e, m[f]);
      if (p) {
        const { transitionEnd: h, transition: N, ...S } = p;
        for (const F in S) {
          let y = S[F];
          if (Array.isArray(y)) {
            const x = u ? y.length - 1 : 0;
            y = y[x];
          }
          y !== null && (a[F] = y);
        }
        for (const F in h)
          a[F] = h[F];
      }
    }
  }
  return a;
}
const Nr = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], e1 = new Set(Nr), pI = (e) => (n) => typeof n == "string" && n.startsWith(e), NI = /* @__PURE__ */ pI("--"), OR = /* @__PURE__ */ pI("var(--"), Lf = (e) => OR(e) ? ER.test(e.split("/*")[0].trim()) : !1, ER = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, SI = (e, n) => n && typeof e == "number" ? n.transform(e) : e, tl = (e, n, i) => i > n ? n : i < e ? e : i, Sr = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Oo = {
  ...Sr,
  transform: (e) => tl(0, 1, e)
}, ic = {
  ...Sr,
  default: 1
}, dd = (e) => ({
  test: (n) => typeof n == "string" && n.endsWith(e) && n.split(" ").length === 1,
  parse: parseFloat,
  transform: (n) => `${n}${e}`
}), Pl = /* @__PURE__ */ dd("deg"), Da = /* @__PURE__ */ dd("%"), Ge = /* @__PURE__ */ dd("px"), JR = /* @__PURE__ */ dd("vh"), _R = /* @__PURE__ */ dd("vw"), Mp = {
  ...Da,
  parse: (e) => Da.parse(e) / 100,
  transform: (e) => Da.transform(e * 100)
}, QR = {
  // Border props
  borderWidth: Ge,
  borderTopWidth: Ge,
  borderRightWidth: Ge,
  borderBottomWidth: Ge,
  borderLeftWidth: Ge,
  borderRadius: Ge,
  radius: Ge,
  borderTopLeftRadius: Ge,
  borderTopRightRadius: Ge,
  borderBottomRightRadius: Ge,
  borderBottomLeftRadius: Ge,
  // Positioning props
  width: Ge,
  maxWidth: Ge,
  height: Ge,
  maxHeight: Ge,
  top: Ge,
  right: Ge,
  bottom: Ge,
  left: Ge,
  // Spacing props
  padding: Ge,
  paddingTop: Ge,
  paddingRight: Ge,
  paddingBottom: Ge,
  paddingLeft: Ge,
  margin: Ge,
  marginTop: Ge,
  marginRight: Ge,
  marginBottom: Ge,
  marginLeft: Ge,
  // Misc
  backgroundPositionX: Ge,
  backgroundPositionY: Ge
}, MR = {
  rotate: Pl,
  rotateX: Pl,
  rotateY: Pl,
  rotateZ: Pl,
  scale: ic,
  scaleX: ic,
  scaleY: ic,
  scaleZ: ic,
  skew: Pl,
  skewX: Pl,
  skewY: Pl,
  distance: Ge,
  translateX: Ge,
  translateY: Ge,
  translateZ: Ge,
  x: Ge,
  y: Ge,
  z: Ge,
  perspective: Ge,
  transformPerspective: Ge,
  opacity: Oo,
  originX: Mp,
  originY: Mp,
  originZ: Ge
}, Lp = {
  ...Sr,
  transform: Math.round
}, $f = {
  ...QR,
  ...MR,
  zIndex: Lp,
  size: Ge,
  // SVG
  fillOpacity: Oo,
  strokeOpacity: Oo,
  numOctaves: Lp
}, LR = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, $R = Nr.length;
function UR(e, n, i) {
  let t = "", a = !0;
  for (let s = 0; s < $R; s++) {
    const r = Nr[s], o = e[r];
    if (o === void 0)
      continue;
    let d = !0;
    if (typeof o == "number" ? d = o === (r.startsWith("scale") ? 1 : 0) : d = parseFloat(o) === 0, !d || i) {
      const c = SI(o, $f[r]);
      if (!d) {
        a = !1;
        const u = LR[r] || r;
        t += `${u}(${c}) `;
      }
      i && (n[r] = c);
    }
  }
  return t = t.trim(), i ? t = i(n, a ? "" : t) : a && (t = "none"), t;
}
function Uf(e, n, i) {
  const { style: t, vars: a, transformOrigin: s } = e;
  let r = !1, o = !1;
  for (const d in n) {
    const c = n[d];
    if (e1.has(d)) {
      r = !0;
      continue;
    } else if (NI(d)) {
      a[d] = c;
      continue;
    } else {
      const u = SI(c, $f[d]);
      d.startsWith("origin") ? (o = !0, s[d] = u) : t[d] = u;
    }
  }
  if (n.transform || (r || i ? t.transform = UR(n, e.transform, i) : t.transform && (t.transform = "none")), o) {
    const { originX: d = "50%", originY: c = "50%", originZ: u = 0 } = s;
    t.transformOrigin = `${d} ${c} ${u}`;
  }
}
const VR = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, HR = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function zR(e, n, i = 1, t = 0, a = !0) {
  e.pathLength = 1;
  const s = a ? VR : HR;
  e[s.offset] = Ge.transform(-t);
  const r = Ge.transform(n), o = Ge.transform(i);
  e[s.array] = `${r} ${o}`;
}
function $p(e, n, i) {
  return typeof e == "string" ? e : Ge.transform(n + i * e);
}
function BR(e, n, i) {
  const t = $p(n, e.x, e.width), a = $p(i, e.y, e.height);
  return `${t} ${a}`;
}
function Vf(e, {
  attrX: n,
  attrY: i,
  attrScale: t,
  originX: a,
  originY: s,
  pathLength: r,
  pathSpacing: o = 1,
  pathOffset: d = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, u, k) {
  if (Uf(e, c, k), u) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: m, style: f, dimensions: p } = e;
  m.transform && (p && (f.transform = m.transform), delete m.transform), p && (a !== void 0 || s !== void 0 || f.transform) && (f.transformOrigin = BR(p, a !== void 0 ? a : 0.5, s !== void 0 ? s : 0.5)), n !== void 0 && (m.x = n), i !== void 0 && (m.y = i), t !== void 0 && (m.scale = t), r !== void 0 && zR(m, r, o, d, !1);
}
const Hf = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), gI = () => ({
  ...Hf(),
  attrs: {}
}), zf = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function FI(e, { style: n, vars: i }, t, a) {
  Object.assign(e.style, n, a && a.getProjectionStyles(t));
  for (const s in i)
    e.style.setProperty(s, i[s]);
}
const II = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function yI(e, n, i, t) {
  FI(e, n, void 0, t);
  for (const a in n.attrs)
    e.setAttribute(II.has(a) ? a : Jf(a), n.attrs[a]);
}
const ru = {};
function qR(e) {
  Object.assign(ru, e);
}
function bI(e, { layout: n, layoutId: i }) {
  return e1.has(e) || e.startsWith("origin") || (n || i !== void 0) && (!!ru[e] || e === "opacity");
}
function Bf(e, n, i) {
  var t;
  const { style: a } = e, s = {};
  for (const r in a)
    (et(a[r]) || n.style && et(n.style[r]) || bI(r, e) || ((t = i == null ? void 0 : i.getValue(r)) === null || t === void 0 ? void 0 : t.liveStyle) !== void 0) && (s[r] = a[r]);
  return s;
}
function CI(e, n, i) {
  const t = Bf(e, n, i);
  for (const a in e)
    if (et(e[a]) || et(n[a])) {
      const s = Nr.indexOf(a) !== -1 ? "attr" + a.charAt(0).toUpperCase() + a.substring(1) : a;
      t[s] = e[a];
    }
  return t;
}
function GR(e, n) {
  try {
    n.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
  } catch (i) {
    n.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
const Up = ["x", "y", "width", "height", "cx", "cy", "r"], WR = {
  useVisualState: hI({
    scrapeMotionValuesFromProps: CI,
    createRenderState: gI,
    onUpdate: ({ props: e, prevProps: n, current: i, renderState: t, latestValues: a }) => {
      if (!i)
        return;
      let s = !!e.drag;
      if (!s) {
        for (const o in a)
          if (e1.has(o)) {
            s = !0;
            break;
          }
      }
      if (!s)
        return;
      let r = !n;
      if (n)
        for (let o = 0; o < Up.length; o++) {
          const d = Up[o];
          e[d] !== n[d] && (r = !0);
        }
      r && Yn.read(() => {
        GR(i, t), Yn.render(() => {
          Vf(t, a, zf(i.tagName), e.transformTemplate), yI(i, t);
        });
      });
    }
  })
}, KR = {
  useVisualState: hI({
    scrapeMotionValuesFromProps: Bf,
    createRenderState: Hf
  })
};
function xI(e, n, i) {
  for (const t in n)
    !et(n[t]) && !bI(t, i) && (e[t] = n[t]);
}
function YR({ transformTemplate: e }, n) {
  return v(() => {
    const i = Hf();
    return Uf(i, n, e), Object.assign({}, i.vars, i.style);
  }, [n]);
}
function XR(e, n) {
  const i = e.style || {}, t = {};
  return xI(t, i, e), Object.assign(t, YR(e, n)), t;
}
function ZR(e, n) {
  const i = {}, t = XR(e, n);
  return e.drag && e.dragListener !== !1 && (i.draggable = !1, t.userSelect = t.WebkitUserSelect = t.WebkitTouchCallout = "none", t.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (i.tabIndex = 0), i.style = t, i;
}
function eT(e, n, i, t) {
  const a = v(() => {
    const s = gI();
    return Vf(s, n, zf(t), e.transformTemplate), {
      ...s.attrs,
      style: { ...s.style }
    };
  }, [n]);
  if (e.style) {
    const s = {};
    xI(s, e.style, e), a.style = { ...s, ...a.style };
  }
  return a;
}
function nT(e = !1) {
  return (i, t, a, { latestValues: s }, r) => {
    const d = (Qf(i) ? eT : ZR)(t, s, r, i), c = hR(t, typeof i == "string", e), u = i !== Xs ? { ...c, ...d, ref: a } : {}, { children: k } = t, m = v(() => et(k) ? k.get() : k, [k]);
    return au(i, {
      ...u,
      children: m
    });
  };
}
function iT(e, n) {
  return function(t, { forwardMotionProps: a } = { forwardMotionProps: !1 }) {
    const r = {
      ...Qf(t) ? WR : KR,
      preloadedFeatures: e,
      useRender: nT(a),
      createVisualElement: n,
      Component: t
    };
    return CR(r);
  };
}
function DI(e, n) {
  if (!Array.isArray(n))
    return !1;
  const i = n.length;
  if (i !== e.length)
    return !1;
  for (let t = 0; t < i; t++)
    if (n[t] !== e[t])
      return !1;
  return !0;
}
function mm(e, n, i) {
  const t = e.getProps();
  return Mf(t, n, i !== void 0 ? i : t.custom, e);
}
const tT = /* @__PURE__ */ Af(() => window.ScrollTimeline !== void 0);
class aT {
  constructor(n) {
    this.stop = () => this.runAll("stop"), this.animations = n.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((n) => "finished" in n ? n.finished : n));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(n) {
    return this.animations[0][n];
  }
  setAll(n, i) {
    for (let t = 0; t < this.animations.length; t++)
      this.animations[t][n] = i;
  }
  attachTimeline(n, i) {
    const t = this.animations.map((a) => {
      if (tT() && a.attachTimeline)
        return a.attachTimeline(n);
      if (typeof i == "function")
        return i(a);
    });
    return () => {
      t.forEach((a, s) => {
        a && a(), this.animations[s].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(n) {
    this.setAll("time", n);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(n) {
    this.setAll("speed", n);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let n = 0;
    for (let i = 0; i < this.animations.length; i++)
      n = Math.max(n, this.animations[i].duration);
    return n;
  }
  runAll(n) {
    this.animations.forEach((i) => i[n]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class lT extends aT {
  then(n, i) {
    return Promise.all(this.animations).then(n).catch(i);
  }
}
function qf(e, n) {
  return e ? e[n] || e.default || e : void 0;
}
const A3 = 2e4;
function wI(e) {
  let n = 0;
  const i = 50;
  let t = e.next(n);
  for (; !t.done && n < A3; )
    n += i, t = e.next(n);
  return n >= A3 ? 1 / 0 : n;
}
function Gf(e) {
  return typeof e == "function";
}
function Vp(e, n) {
  e.timeline = n, e.onfinish = null;
}
const Wf = (e) => Array.isArray(e) && typeof e[0] == "number", sT = {
  linearEasing: void 0
};
function rT(e, n) {
  const i = /* @__PURE__ */ Af(e);
  return () => {
    var t;
    return (t = sT[n]) !== null && t !== void 0 ? t : i();
  };
}
const ou = /* @__PURE__ */ rT(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch (e) {
    return !1;
  }
  return !0;
}, "linearEasing"), PI = (e, n, i = 10) => {
  let t = "";
  const a = Math.max(Math.round(n / i), 2);
  for (let s = 0; s < a; s++)
    t += e(/* @__PURE__ */ q1(0, a - 1, s)) + ", ";
  return `linear(${t.substring(0, t.length - 2)})`;
};
function RI(e) {
  return !!(typeof e == "function" && ou() || !e || typeof e == "string" && (e in O3 || ou()) || Wf(e) || Array.isArray(e) && e.every(RI));
}
const mo = ([e, n, i, t]) => `cubic-bezier(${e}, ${n}, ${i}, ${t})`, O3 = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ mo([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ mo([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ mo([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ mo([0.33, 1.53, 0.69, 0.99])
};
function TI(e, n) {
  if (e)
    return typeof e == "function" && ou() ? PI(e, n) : Wf(e) ? mo(e) : Array.isArray(e) ? e.map((i) => TI(i, n) || O3.easeOut) : O3[e];
}
const Zt = {
  x: !1,
  y: !1
};
function jI() {
  return Zt.x || Zt.y;
}
function oT(e, n, i) {
  var t;
  if (e instanceof Element)
    return [e];
  if (typeof e == "string") {
    let a = document;
    const s = (t = void 0) !== null && t !== void 0 ? t : a.querySelectorAll(e);
    return s ? Array.from(s) : [];
  }
  return Array.from(e);
}
function AI(e, n) {
  const i = oT(e), t = new AbortController(), a = {
    passive: !0,
    ...n,
    signal: t.signal
  };
  return [i, a, () => t.abort()];
}
function Hp(e) {
  return (n) => {
    n.pointerType === "touch" || jI() || e(n);
  };
}
function dT(e, n, i = {}) {
  const [t, a, s] = AI(e, i), r = Hp((o) => {
    const { target: d } = o, c = n(o);
    if (typeof c != "function" || !d)
      return;
    const u = Hp((k) => {
      c(k), d.removeEventListener("pointerleave", u);
    });
    d.addEventListener("pointerleave", u, a);
  });
  return t.forEach((o) => {
    o.addEventListener("pointerenter", r, a);
  }), s;
}
const OI = (e, n) => n ? e === n ? !0 : OI(e, n.parentElement) : !1, Kf = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, cT = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function uT(e) {
  return cT.has(e.tagName) || e.tabIndex !== -1;
}
const ko = /* @__PURE__ */ new WeakSet();
function zp(e) {
  return (n) => {
    n.key === "Enter" && e(n);
  };
}
function u0(e, n) {
  e.dispatchEvent(new PointerEvent("pointer" + n, { isPrimary: !0, bubbles: !0 }));
}
const mT = (e, n) => {
  const i = e.currentTarget;
  if (!i)
    return;
  const t = zp(() => {
    if (ko.has(i))
      return;
    u0(i, "down");
    const a = zp(() => {
      u0(i, "up");
    }), s = () => u0(i, "cancel");
    i.addEventListener("keyup", a, n), i.addEventListener("blur", s, n);
  });
  i.addEventListener("keydown", t, n), i.addEventListener("blur", () => i.removeEventListener("keydown", t), n);
};
function Bp(e) {
  return Kf(e) && !jI();
}
function kT(e, n, i = {}) {
  const [t, a, s] = AI(e, i), r = (o) => {
    const d = o.currentTarget;
    if (!Bp(o) || ko.has(d))
      return;
    ko.add(d);
    const c = n(o), u = (f, p) => {
      window.removeEventListener("pointerup", k), window.removeEventListener("pointercancel", m), !(!Bp(f) || !ko.has(d)) && (ko.delete(d), typeof c == "function" && c(f, { success: p }));
    }, k = (f) => {
      u(f, i.useGlobalTarget || OI(d, f.target));
    }, m = (f) => {
      u(f, !1);
    };
    window.addEventListener("pointerup", k, a), window.addEventListener("pointercancel", m, a);
  };
  return t.forEach((o) => {
    !uT(o) && o.getAttribute("tabindex") === null && (o.tabIndex = 0), (i.useGlobalTarget ? window : o).addEventListener("pointerdown", r, a), o.addEventListener("focus", (c) => mT(c, a), a);
  }), s;
}
function fT(e) {
  return e === "x" || e === "y" ? Zt[e] ? null : (Zt[e] = !0, () => {
    Zt[e] = !1;
  }) : Zt.x || Zt.y ? null : (Zt.x = Zt.y = !0, () => {
    Zt.x = Zt.y = !1;
  });
}
const EI = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Nr
]);
let Oc;
function vT() {
  Oc = void 0;
}
const wa = {
  now: () => (Oc === void 0 && wa.set(zi.isProcessing || cR.useManualTiming ? zi.timestamp : performance.now()), Oc),
  set: (e) => {
    Oc = e, queueMicrotask(vT);
  }
};
function Yf(e, n) {
  e.indexOf(n) === -1 && e.push(n);
}
function Xf(e, n) {
  const i = e.indexOf(n);
  i > -1 && e.splice(i, 1);
}
class Zf {
  constructor() {
    this.subscriptions = [];
  }
  add(n) {
    return Yf(this.subscriptions, n), () => Xf(this.subscriptions, n);
  }
  notify(n, i, t) {
    const a = this.subscriptions.length;
    if (a)
      if (a === 1)
        this.subscriptions[0](n, i, t);
      else
        for (let s = 0; s < a; s++) {
          const r = this.subscriptions[s];
          r && r(n, i, t);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function JI(e, n) {
  return n ? e * (1e3 / n) : 0;
}
const qp = 30, hT = (e) => !isNaN(parseFloat(e));
class pT {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(n, i = {}) {
    this.version = "11.18.2", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (t, a = !0) => {
      const s = wa.now();
      this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(t), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), a && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(n), this.owner = i.owner;
  }
  setCurrent(n) {
    this.current = n, this.updatedAt = wa.now(), this.canTrackVelocity === null && n !== void 0 && (this.canTrackVelocity = hT(this.current));
  }
  setPrevFrameValue(n = this.current) {
    this.prevFrameValue = n, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(n) {
    return process.env.NODE_ENV !== "production" && om(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", n);
  }
  on(n, i) {
    this.events[n] || (this.events[n] = new Zf());
    const t = this.events[n].add(i);
    return n === "change" ? () => {
      t(), Yn.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : t;
  }
  clearListeners() {
    for (const n in this.events)
      this.events[n].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(n, i) {
    this.passiveEffect = n, this.stopPassiveEffect = i;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(n, i = !0) {
    !i || !this.passiveEffect ? this.updateAndNotify(n, i) : this.passiveEffect(n, this.updateAndNotify);
  }
  setWithVelocity(n, i, t) {
    this.set(i), this.prev = void 0, this.prevFrameValue = n, this.prevUpdatedAt = this.updatedAt - t;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(n, i = !0) {
    this.updateAndNotify(n), this.prev = n, this.prevUpdatedAt = this.prevFrameValue = void 0, i && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const n = wa.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || n - this.updatedAt > qp)
      return 0;
    const i = Math.min(this.updatedAt - this.prevUpdatedAt, qp);
    return JI(parseFloat(this.current) - parseFloat(this.prevFrameValue), i);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(n) {
    return this.stop(), new Promise((i) => {
      this.hasAnimated = !0, this.animation = n(i), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Eo(e, n) {
  return new pT(e, n);
}
function NT(e, n, i) {
  e.hasValue(n) ? e.getValue(n).set(i) : e.addValue(n, Eo(i));
}
function ST(e, n) {
  const i = mm(e, n);
  let { transitionEnd: t = {}, transition: a = {}, ...s } = i || {};
  s = { ...s, ...t };
  for (const r in s) {
    const o = TR(s[r]);
    NT(e, r, o);
  }
}
function gT(e) {
  return !!(et(e) && e.add);
}
function E3(e, n) {
  const i = e.getValue("willChange");
  if (gT(i))
    return i.add(n);
}
function _I(e) {
  return e.props[kI];
}
const QI = (e, n, i) => (((1 - 3 * i + 3 * n) * e + (3 * i - 6 * n)) * e + 3 * n) * e, FT = 1e-7, IT = 12;
function yT(e, n, i, t, a) {
  let s, r, o = 0;
  do
    r = n + (i - n) / 2, s = QI(r, t, a) - e, s > 0 ? i = r : n = r;
  while (Math.abs(s) > FT && ++o < IT);
  return r;
}
function cd(e, n, i, t) {
  if (e === n && i === t)
    return St;
  const a = (s) => yT(s, 0, 1, e, i);
  return (s) => s === 0 || s === 1 ? s : QI(a(s), n, t);
}
const MI = (e) => (n) => n <= 0.5 ? e(2 * n) / 2 : (2 - e(2 * (1 - n))) / 2, LI = (e) => (n) => 1 - e(1 - n), $I = /* @__PURE__ */ cd(0.33, 1.53, 0.69, 0.99), ev = /* @__PURE__ */ LI($I), UI = /* @__PURE__ */ MI(ev), VI = (e) => (e *= 2) < 1 ? 0.5 * ev(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), nv = (e) => 1 - Math.sin(Math.acos(e)), HI = LI(nv), zI = MI(nv), BI = (e) => /^0[^.\s]+$/u.test(e);
function bT(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || BI(e) : !0;
}
const Fo = (e) => Math.round(e * 1e5) / 1e5, iv = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function CT(e) {
  return e == null;
}
const xT = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, tv = (e, n) => (i) => !!(typeof i == "string" && xT.test(i) && i.startsWith(e) || n && !CT(i) && Object.prototype.hasOwnProperty.call(i, n)), qI = (e, n, i) => (t) => {
  if (typeof t != "string")
    return t;
  const [a, s, r, o] = t.match(iv);
  return {
    [e]: parseFloat(a),
    [n]: parseFloat(s),
    [i]: parseFloat(r),
    alpha: o !== void 0 ? parseFloat(o) : 1
  };
}, DT = (e) => tl(0, 255, e), m0 = {
  ...Sr,
  transform: (e) => Math.round(DT(e))
}, Os = {
  test: /* @__PURE__ */ tv("rgb", "red"),
  parse: /* @__PURE__ */ qI("red", "green", "blue"),
  transform: ({ red: e, green: n, blue: i, alpha: t = 1 }) => "rgba(" + m0.transform(e) + ", " + m0.transform(n) + ", " + m0.transform(i) + ", " + Fo(Oo.transform(t)) + ")"
};
function wT(e) {
  let n = "", i = "", t = "", a = "";
  return e.length > 5 ? (n = e.substring(1, 3), i = e.substring(3, 5), t = e.substring(5, 7), a = e.substring(7, 9)) : (n = e.substring(1, 2), i = e.substring(2, 3), t = e.substring(3, 4), a = e.substring(4, 5), n += n, i += i, t += t, a += a), {
    red: parseInt(n, 16),
    green: parseInt(i, 16),
    blue: parseInt(t, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
const J3 = {
  test: /* @__PURE__ */ tv("#"),
  parse: wT,
  transform: Os.transform
}, R1 = {
  test: /* @__PURE__ */ tv("hsl", "hue"),
  parse: /* @__PURE__ */ qI("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: n, lightness: i, alpha: t = 1 }) => "hsla(" + Math.round(e) + ", " + Da.transform(Fo(n)) + ", " + Da.transform(Fo(i)) + ", " + Fo(Oo.transform(t)) + ")"
}, Yi = {
  test: (e) => Os.test(e) || J3.test(e) || R1.test(e),
  parse: (e) => Os.test(e) ? Os.parse(e) : R1.test(e) ? R1.parse(e) : J3.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Os.transform(e) : R1.transform(e)
}, PT = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function RT(e) {
  var n, i;
  return isNaN(e) && typeof e == "string" && (((n = e.match(iv)) === null || n === void 0 ? void 0 : n.length) || 0) + (((i = e.match(PT)) === null || i === void 0 ? void 0 : i.length) || 0) > 0;
}
const GI = "number", WI = "color", TT = "var", jT = "var(", Gp = "${}", AT = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Jo(e) {
  const n = e.toString(), i = [], t = {
    color: [],
    number: [],
    var: []
  }, a = [];
  let s = 0;
  const o = n.replace(AT, (d) => (Yi.test(d) ? (t.color.push(s), a.push(WI), i.push(Yi.parse(d))) : d.startsWith(jT) ? (t.var.push(s), a.push(TT), i.push(d)) : (t.number.push(s), a.push(GI), i.push(parseFloat(d))), ++s, Gp)).split(Gp);
  return { values: i, split: o, indexes: t, types: a };
}
function KI(e) {
  return Jo(e).values;
}
function YI(e) {
  const { split: n, types: i } = Jo(e), t = n.length;
  return (a) => {
    let s = "";
    for (let r = 0; r < t; r++)
      if (s += n[r], a[r] !== void 0) {
        const o = i[r];
        o === GI ? s += Fo(a[r]) : o === WI ? s += Yi.transform(a[r]) : s += a[r];
      }
    return s;
  };
}
const OT = (e) => typeof e == "number" ? 0 : e;
function ET(e) {
  const n = KI(e);
  return YI(e)(n.map(OT));
}
const Gl = {
  test: RT,
  parse: KI,
  createTransformer: YI,
  getAnimatableNone: ET
}, JT = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function _T(e) {
  const [n, i] = e.slice(0, -1).split("(");
  if (n === "drop-shadow")
    return e;
  const [t] = i.match(iv) || [];
  if (!t)
    return e;
  const a = i.replace(t, "");
  let s = JT.has(n) ? 1 : 0;
  return t !== i && (s *= 100), n + "(" + s + a + ")";
}
const QT = /\b([a-z-]*)\(.*?\)/gu, _3 = {
  ...Gl,
  getAnimatableNone: (e) => {
    const n = e.match(QT);
    return n ? n.map(_T).join(" ") : e;
  }
}, MT = {
  ...$f,
  // Color props
  color: Yi,
  backgroundColor: Yi,
  outlineColor: Yi,
  fill: Yi,
  stroke: Yi,
  // Border props
  borderColor: Yi,
  borderTopColor: Yi,
  borderRightColor: Yi,
  borderBottomColor: Yi,
  borderLeftColor: Yi,
  filter: _3,
  WebkitFilter: _3
}, av = (e) => MT[e];
function XI(e, n) {
  let i = av(e);
  return i !== _3 && (i = Gl), i.getAnimatableNone ? i.getAnimatableNone(n) : void 0;
}
const LT = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function $T(e, n, i) {
  let t = 0, a;
  for (; t < e.length && !a; ) {
    const s = e[t];
    typeof s == "string" && !LT.has(s) && Jo(s).values.length && (a = e[t]), t++;
  }
  if (a && i)
    for (const s of n)
      e[s] = XI(i, a);
}
const Wp = (e) => e === Sr || e === Ge, Kp = (e, n) => parseFloat(e.split(", ")[n]), Yp = (e, n) => (i, { transform: t }) => {
  if (t === "none" || !t)
    return 0;
  const a = t.match(/^matrix3d\((.+)\)$/u);
  if (a)
    return Kp(a[1], n);
  {
    const s = t.match(/^matrix\((.+)\)$/u);
    return s ? Kp(s[1], e) : 0;
  }
}, UT = /* @__PURE__ */ new Set(["x", "y", "z"]), VT = Nr.filter((e) => !UT.has(e));
function HT(e) {
  const n = [];
  return VT.forEach((i) => {
    const t = e.getValue(i);
    t !== void 0 && (n.push([i, t.get()]), t.set(i.startsWith("scale") ? 1 : 0));
  }), n;
}
const W1 = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: n = "0", paddingRight: i = "0" }) => e.max - e.min - parseFloat(n) - parseFloat(i),
  height: ({ y: e }, { paddingTop: n = "0", paddingBottom: i = "0" }) => e.max - e.min - parseFloat(n) - parseFloat(i),
  top: (e, { top: n }) => parseFloat(n),
  left: (e, { left: n }) => parseFloat(n),
  bottom: ({ y: e }, { top: n }) => parseFloat(n) + (e.max - e.min),
  right: ({ x: e }, { left: n }) => parseFloat(n) + (e.max - e.min),
  // Transform
  x: Yp(4, 13),
  y: Yp(5, 14)
};
W1.translateX = W1.x;
W1.translateY = W1.y;
const Ls = /* @__PURE__ */ new Set();
let Q3 = !1, M3 = !1;
function ZI() {
  if (M3) {
    const e = Array.from(Ls).filter((t) => t.needsMeasurement), n = new Set(e.map((t) => t.element)), i = /* @__PURE__ */ new Map();
    n.forEach((t) => {
      const a = HT(t);
      a.length && (i.set(t, a), t.render());
    }), e.forEach((t) => t.measureInitialState()), n.forEach((t) => {
      t.render();
      const a = i.get(t);
      a && a.forEach(([s, r]) => {
        var o;
        (o = t.getValue(s)) === null || o === void 0 || o.set(r);
      });
    }), e.forEach((t) => t.measureEndState()), e.forEach((t) => {
      t.suspendedScrollY !== void 0 && window.scrollTo(0, t.suspendedScrollY);
    });
  }
  M3 = !1, Q3 = !1, Ls.forEach((e) => e.complete()), Ls.clear();
}
function ey() {
  Ls.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (M3 = !0);
  });
}
function zT() {
  ey(), ZI();
}
class lv {
  constructor(n, i, t, a, s, r = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...n], this.onComplete = i, this.name = t, this.motionValue = a, this.element = s, this.isAsync = r;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Ls.add(this), Q3 || (Q3 = !0, Yn.read(ey), Yn.resolveKeyframes(ZI))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: n, name: i, element: t, motionValue: a } = this;
    for (let s = 0; s < n.length; s++)
      if (n[s] === null)
        if (s === 0) {
          const r = a == null ? void 0 : a.get(), o = n[n.length - 1];
          if (r !== void 0)
            n[0] = r;
          else if (t && i) {
            const d = t.readValue(i, o);
            d != null && (n[0] = d);
          }
          n[0] === void 0 && (n[0] = o), a && r === void 0 && a.set(n[0]);
        } else
          n[s] = n[s - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), Ls.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Ls.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const ny = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), BT = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function qT(e) {
  const n = BT.exec(e);
  if (!n)
    return [,];
  const [, i, t, a] = n;
  return [`--${i != null ? i : t}`, a];
}
const GT = 4;
function iy(e, n, i = 1) {
  Bl(i <= GT, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [t, a] = qT(e);
  if (!t)
    return;
  const s = window.getComputedStyle(n).getPropertyValue(t);
  if (s) {
    const r = s.trim();
    return ny(r) ? parseFloat(r) : r;
  }
  return Lf(a) ? iy(a, n, i + 1) : a;
}
const ty = (e) => (n) => n.test(e), WT = {
  test: (e) => e === "auto",
  parse: (e) => e
}, ay = [Sr, Ge, Da, Pl, _R, JR, WT], Xp = (e) => ay.find(ty(e));
class ly extends lv {
  constructor(n, i, t, a, s) {
    super(n, i, t, a, s, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: n, element: i, name: t } = this;
    if (!i || !i.current)
      return;
    super.readKeyframes();
    for (let d = 0; d < n.length; d++) {
      let c = n[d];
      if (typeof c == "string" && (c = c.trim(), Lf(c))) {
        const u = iy(c, i.current);
        u !== void 0 && (n[d] = u), d === n.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !EI.has(t) || n.length !== 2)
      return;
    const [a, s] = n, r = Xp(a), o = Xp(s);
    if (r !== o)
      if (Wp(r) && Wp(o))
        for (let d = 0; d < n.length; d++) {
          const c = n[d];
          typeof c == "string" && (n[d] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: n, name: i } = this, t = [];
    for (let a = 0; a < n.length; a++)
      bT(n[a]) && t.push(a);
    t.length && $T(n, t, i);
  }
  measureInitialState() {
    const { element: n, unresolvedKeyframes: i, name: t } = this;
    if (!n || !n.current)
      return;
    t === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = W1[t](n.measureViewportBox(), window.getComputedStyle(n.current)), i[0] = this.measuredOrigin;
    const a = i[i.length - 1];
    a !== void 0 && n.getValue(t, a).jump(a, !1);
  }
  measureEndState() {
    var n;
    const { element: i, name: t, unresolvedKeyframes: a } = this;
    if (!i || !i.current)
      return;
    const s = i.getValue(t);
    s && s.jump(this.measuredOrigin, !1);
    const r = a.length - 1, o = a[r];
    a[r] = W1[t](i.measureViewportBox(), window.getComputedStyle(i.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), !((n = this.removedTransforms) === null || n === void 0) && n.length && this.removedTransforms.forEach(([d, c]) => {
      i.getValue(d).set(c);
    }), this.resolveNoneKeyframes();
  }
}
const Zp = (e, n) => n === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(Gl.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function KT(e) {
  const n = e[0];
  if (e.length === 1)
    return !0;
  for (let i = 0; i < e.length; i++)
    if (e[i] !== n)
      return !0;
}
function YT(e, n, i, t) {
  const a = e[0];
  if (a === null)
    return !1;
  if (n === "display" || n === "visibility")
    return !0;
  const s = e[e.length - 1], r = Zp(a, n), o = Zp(s, n);
  return pr(r === o, `You are trying to animate ${n} from "${a}" to "${s}". ${a} is not an animatable value - to enable this animation set ${a} to a value animatable to ${s} via the \`style\` property.`), !r || !o ? !1 : KT(e) || (i === "spring" || Gf(i)) && t;
}
const XT = (e) => e !== null;
function km(e, { repeat: n, repeatType: i = "loop" }, t) {
  const a = e.filter(XT), s = n && i !== "loop" && n % 2 === 1 ? 0 : a.length - 1;
  return !s || t === void 0 ? a[s] : t;
}
const ZT = 40;
class sy {
  constructor({ autoplay: n = !0, delay: i = 0, type: t = "keyframes", repeat: a = 0, repeatDelay: s = 0, repeatType: r = "loop", ...o }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = wa.now(), this.options = {
      autoplay: n,
      delay: i,
      type: t,
      repeat: a,
      repeatDelay: s,
      repeatType: r,
      ...o
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > ZT ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && zT(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(n, i) {
    this.resolvedAt = wa.now(), this.hasAttemptedResolve = !0;
    const { name: t, type: a, velocity: s, delay: r, onComplete: o, onUpdate: d, isGenerator: c } = this.options;
    if (!c && !YT(n, t, a, s))
      if (r)
        this.options.duration = 0;
      else {
        d && d(km(n, this.options, i)), o && o(), this.resolveFinishedPromise();
        return;
      }
    const u = this.initPlayback(n, i);
    u !== !1 && (this._resolved = {
      keyframes: n,
      finalKeyframe: i,
      ...u
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(n, i) {
    return this.currentFinishedPromise.then(n, i);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((n) => {
      this.resolveFinishedPromise = n;
    });
  }
}
const di = (e, n, i) => e + (n - e) * i;
function k0(e, n, i) {
  return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? e + (n - e) * 6 * i : i < 1 / 2 ? n : i < 2 / 3 ? e + (n - e) * (2 / 3 - i) * 6 : e;
}
function ej({ hue: e, saturation: n, lightness: i, alpha: t }) {
  e /= 360, n /= 100, i /= 100;
  let a = 0, s = 0, r = 0;
  if (!n)
    a = s = r = i;
  else {
    const o = i < 0.5 ? i * (1 + n) : i + n - i * n, d = 2 * i - o;
    a = k0(d, o, e + 1 / 3), s = k0(d, o, e), r = k0(d, o, e - 1 / 3);
  }
  return {
    red: Math.round(a * 255),
    green: Math.round(s * 255),
    blue: Math.round(r * 255),
    alpha: t
  };
}
function du(e, n) {
  return (i) => i > 0 ? n : e;
}
const f0 = (e, n, i) => {
  const t = e * e, a = i * (n * n - t) + t;
  return a < 0 ? 0 : Math.sqrt(a);
}, nj = [J3, Os, R1], ij = (e) => nj.find((n) => n.test(e));
function eN(e) {
  const n = ij(e);
  if (pr(!!n, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !n)
    return !1;
  let i = n.parse(e);
  return n === R1 && (i = ej(i)), i;
}
const nN = (e, n) => {
  const i = eN(e), t = eN(n);
  if (!i || !t)
    return du(e, n);
  const a = { ...i };
  return (s) => (a.red = f0(i.red, t.red, s), a.green = f0(i.green, t.green, s), a.blue = f0(i.blue, t.blue, s), a.alpha = di(i.alpha, t.alpha, s), Os.transform(a));
}, tj = (e, n) => (i) => n(e(i)), ud = (...e) => e.reduce(tj), L3 = /* @__PURE__ */ new Set(["none", "hidden"]);
function aj(e, n) {
  return L3.has(e) ? (i) => i <= 0 ? e : n : (i) => i >= 1 ? n : e;
}
function lj(e, n) {
  return (i) => di(e, n, i);
}
function sv(e) {
  return typeof e == "number" ? lj : typeof e == "string" ? Lf(e) ? du : Yi.test(e) ? nN : oj : Array.isArray(e) ? ry : typeof e == "object" ? Yi.test(e) ? nN : sj : du;
}
function ry(e, n) {
  const i = [...e], t = i.length, a = e.map((s, r) => sv(s)(s, n[r]));
  return (s) => {
    for (let r = 0; r < t; r++)
      i[r] = a[r](s);
    return i;
  };
}
function sj(e, n) {
  const i = { ...e, ...n }, t = {};
  for (const a in i)
    e[a] !== void 0 && n[a] !== void 0 && (t[a] = sv(e[a])(e[a], n[a]));
  return (a) => {
    for (const s in t)
      i[s] = t[s](a);
    return i;
  };
}
function rj(e, n) {
  var i;
  const t = [], a = { color: 0, var: 0, number: 0 };
  for (let s = 0; s < n.values.length; s++) {
    const r = n.types[s], o = e.indexes[r][a[r]], d = (i = e.values[o]) !== null && i !== void 0 ? i : 0;
    t[s] = d, a[r]++;
  }
  return t;
}
const oj = (e, n) => {
  const i = Gl.createTransformer(n), t = Jo(e), a = Jo(n);
  return t.indexes.var.length === a.indexes.var.length && t.indexes.color.length === a.indexes.color.length && t.indexes.number.length >= a.indexes.number.length ? L3.has(e) && !a.values.length || L3.has(n) && !t.values.length ? aj(e, n) : ud(ry(rj(t, a), a.values), i) : (pr(!0, `Complex values '${e}' and '${n}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), du(e, n));
};
function oy(e, n, i) {
  return typeof e == "number" && typeof n == "number" && typeof i == "number" ? di(e, n, i) : sv(e)(e, n);
}
const dj = 5;
function dy(e, n, i) {
  const t = Math.max(n - dj, 0);
  return JI(i - e(t), n - t);
}
const ri = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, v0 = 1e-3;
function cj({ duration: e = ri.duration, bounce: n = ri.bounce, velocity: i = ri.velocity, mass: t = ri.mass }) {
  let a, s;
  pr(e <= /* @__PURE__ */ xa(ri.maxDuration), "Spring duration must be 10 seconds or less");
  let r = 1 - n;
  r = tl(ri.minDamping, ri.maxDamping, r), e = tl(ri.minDuration, ri.maxDuration, /* @__PURE__ */ el(e)), r < 1 ? (a = (c) => {
    const u = c * r, k = u * e, m = u - i, f = $3(c, r), p = Math.exp(-k);
    return v0 - m / f * p;
  }, s = (c) => {
    const k = c * r * e, m = k * i + i, f = Math.pow(r, 2) * Math.pow(c, 2) * e, p = Math.exp(-k), h = $3(Math.pow(c, 2), r);
    return (-a(c) + v0 > 0 ? -1 : 1) * ((m - f) * p) / h;
  }) : (a = (c) => {
    const u = Math.exp(-c * e), k = (c - i) * e + 1;
    return -v0 + u * k;
  }, s = (c) => {
    const u = Math.exp(-c * e), k = (i - c) * (e * e);
    return u * k;
  });
  const o = 5 / e, d = mj(a, s, o);
  if (e = /* @__PURE__ */ xa(e), isNaN(d))
    return {
      stiffness: ri.stiffness,
      damping: ri.damping,
      duration: e
    };
  {
    const c = Math.pow(d, 2) * t;
    return {
      stiffness: c,
      damping: r * 2 * Math.sqrt(t * c),
      duration: e
    };
  }
}
const uj = 12;
function mj(e, n, i) {
  let t = i;
  for (let a = 1; a < uj; a++)
    t = t - e(t) / n(t);
  return t;
}
function $3(e, n) {
  return e * Math.sqrt(1 - n * n);
}
const kj = ["duration", "bounce"], fj = ["stiffness", "damping", "mass"];
function iN(e, n) {
  return n.some((i) => e[i] !== void 0);
}
function vj(e) {
  let n = {
    velocity: ri.velocity,
    stiffness: ri.stiffness,
    damping: ri.damping,
    mass: ri.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!iN(e, fj) && iN(e, kj))
    if (e.visualDuration) {
      const i = e.visualDuration, t = 2 * Math.PI / (i * 1.2), a = t * t, s = 2 * tl(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(a);
      n = {
        ...n,
        mass: ri.mass,
        stiffness: a,
        damping: s
      };
    } else {
      const i = cj(e);
      n = {
        ...n,
        ...i,
        mass: ri.mass
      }, n.isResolvedFromDuration = !0;
    }
  return n;
}
function cy(e = ri.visualDuration, n = ri.bounce) {
  const i = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: n
  } : e;
  let { restSpeed: t, restDelta: a } = i;
  const s = i.keyframes[0], r = i.keyframes[i.keyframes.length - 1], o = { done: !1, value: s }, { stiffness: d, damping: c, mass: u, duration: k, velocity: m, isResolvedFromDuration: f } = vj({
    ...i,
    velocity: -/* @__PURE__ */ el(i.velocity || 0)
  }), p = m || 0, h = c / (2 * Math.sqrt(d * u)), N = r - s, S = /* @__PURE__ */ el(Math.sqrt(d / u)), F = Math.abs(N) < 5;
  t || (t = F ? ri.restSpeed.granular : ri.restSpeed.default), a || (a = F ? ri.restDelta.granular : ri.restDelta.default);
  let y;
  if (h < 1) {
    const R = $3(S, h);
    y = (T) => {
      const j = Math.exp(-h * S * T);
      return r - j * ((p + h * S * N) / R * Math.sin(R * T) + N * Math.cos(R * T));
    };
  } else if (h === 1)
    y = (R) => r - Math.exp(-S * R) * (N + (p + S * N) * R);
  else {
    const R = S * Math.sqrt(h * h - 1);
    y = (T) => {
      const j = Math.exp(-h * S * T), A = Math.min(R * T, 300);
      return r - j * ((p + h * S * N) * Math.sinh(A) + R * N * Math.cosh(A)) / R;
    };
  }
  const x = {
    calculatedDuration: f && k || null,
    next: (R) => {
      const T = y(R);
      if (f)
        o.done = R >= k;
      else {
        let j = 0;
        h < 1 && (j = R === 0 ? /* @__PURE__ */ xa(p) : dy(y, R, T));
        const A = Math.abs(j) <= t, B = Math.abs(r - T) <= a;
        o.done = A && B;
      }
      return o.value = o.done ? r : T, o;
    },
    toString: () => {
      const R = Math.min(wI(x), A3), T = PI((j) => x.next(R * j).value, R, 30);
      return R + "ms " + T;
    }
  };
  return x;
}
function tN({ keyframes: e, velocity: n = 0, power: i = 0.8, timeConstant: t = 325, bounceDamping: a = 10, bounceStiffness: s = 500, modifyTarget: r, min: o, max: d, restDelta: c = 0.5, restSpeed: u }) {
  const k = e[0], m = {
    done: !1,
    value: k
  }, f = (A) => o !== void 0 && A < o || d !== void 0 && A > d, p = (A) => o === void 0 ? d : d === void 0 || Math.abs(o - A) < Math.abs(d - A) ? o : d;
  let h = i * n;
  const N = k + h, S = r === void 0 ? N : r(N);
  S !== N && (h = S - k);
  const F = (A) => -h * Math.exp(-A / t), y = (A) => S + F(A), x = (A) => {
    const B = F(A), W = y(A);
    m.done = Math.abs(B) <= c, m.value = m.done ? S : W;
  };
  let R, T;
  const j = (A) => {
    f(m.value) && (R = A, T = cy({
      keyframes: [m.value, p(m.value)],
      velocity: dy(y, A, m.value),
      // TODO: This should be passing * 1000
      damping: a,
      stiffness: s,
      restDelta: c,
      restSpeed: u
    }));
  };
  return j(0), {
    calculatedDuration: null,
    next: (A) => {
      let B = !1;
      return !T && R === void 0 && (B = !0, x(A), j(A)), R !== void 0 && A >= R ? T.next(A - R) : (!B && x(A), m);
    }
  };
}
const hj = /* @__PURE__ */ cd(0.42, 0, 1, 1), pj = /* @__PURE__ */ cd(0, 0, 0.58, 1), uy = /* @__PURE__ */ cd(0.42, 0, 0.58, 1), Nj = (e) => Array.isArray(e) && typeof e[0] != "number", aN = {
  linear: St,
  easeIn: hj,
  easeInOut: uy,
  easeOut: pj,
  circIn: nv,
  circInOut: zI,
  circOut: HI,
  backIn: ev,
  backInOut: UI,
  backOut: $I,
  anticipate: VI
}, lN = (e) => {
  if (Wf(e)) {
    Bl(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [n, i, t, a] = e;
    return cd(n, i, t, a);
  } else if (typeof e == "string")
    return Bl(aN[e] !== void 0, `Invalid easing type '${e}'`), aN[e];
  return e;
};
function Sj(e, n, i) {
  const t = [], a = i || oy, s = e.length - 1;
  for (let r = 0; r < s; r++) {
    let o = a(e[r], e[r + 1]);
    if (n) {
      const d = Array.isArray(n) ? n[r] || St : n;
      o = ud(d, o);
    }
    t.push(o);
  }
  return t;
}
function gj(e, n, { clamp: i = !0, ease: t, mixer: a } = {}) {
  const s = e.length;
  if (Bl(s === n.length, "Both input and output ranges must be the same length"), s === 1)
    return () => n[0];
  if (s === 2 && n[0] === n[1])
    return () => n[1];
  const r = e[0] === e[1];
  e[0] > e[s - 1] && (e = [...e].reverse(), n = [...n].reverse());
  const o = Sj(n, t, a), d = o.length, c = (u) => {
    if (r && u < e[0])
      return n[0];
    let k = 0;
    if (d > 1)
      for (; k < e.length - 2 && !(u < e[k + 1]); k++)
        ;
    const m = /* @__PURE__ */ q1(e[k], e[k + 1], u);
    return o[k](m);
  };
  return i ? (u) => c(tl(e[0], e[s - 1], u)) : c;
}
function Fj(e, n) {
  const i = e[e.length - 1];
  for (let t = 1; t <= n; t++) {
    const a = /* @__PURE__ */ q1(0, n, t);
    e.push(di(i, 1, a));
  }
}
function Ij(e) {
  const n = [0];
  return Fj(n, e.length - 1), n;
}
function yj(e, n) {
  return e.map((i) => i * n);
}
function bj(e, n) {
  return e.map(() => n || uy).splice(0, e.length - 1);
}
function cu({ duration: e = 300, keyframes: n, times: i, ease: t = "easeInOut" }) {
  const a = Nj(t) ? t.map(lN) : lN(t), s = {
    done: !1,
    value: n[0]
  }, r = yj(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    i && i.length === n.length ? i : Ij(n),
    e
  ), o = gj(r, n, {
    ease: Array.isArray(a) ? a : bj(n, a)
  });
  return {
    calculatedDuration: e,
    next: (d) => (s.value = o(d), s.done = d >= e, s)
  };
}
const Cj = (e) => {
  const n = ({ timestamp: i }) => e(i);
  return {
    start: () => Yn.update(n, !0),
    stop: () => ql(n),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => zi.isProcessing ? zi.timestamp : wa.now()
  };
}, xj = {
  decay: tN,
  inertia: tN,
  tween: cu,
  keyframes: cu,
  spring: cy
}, Dj = (e) => e / 100;
class rv extends sy {
  constructor(n) {
    super(n), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: d } = this.options;
      d && d();
    };
    const { name: i, motionValue: t, element: a, keyframes: s } = this.options, r = (a == null ? void 0 : a.KeyframeResolver) || lv, o = (d, c) => this.onKeyframesResolved(d, c);
    this.resolver = new r(s, o, i, t, a), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(n) {
    const { type: i = "keyframes", repeat: t = 0, repeatDelay: a = 0, repeatType: s, velocity: r = 0 } = this.options, o = Gf(i) ? i : xj[i] || cu;
    let d, c;
    o !== cu && typeof n[0] != "number" && (process.env.NODE_ENV !== "production" && Bl(n.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${n}`), d = ud(Dj, oy(n[0], n[1])), n = [0, 100]);
    const u = o({ ...this.options, keyframes: n });
    s === "mirror" && (c = o({
      ...this.options,
      keyframes: [...n].reverse(),
      velocity: -r
    })), u.calculatedDuration === null && (u.calculatedDuration = wI(u));
    const { calculatedDuration: k } = u, m = k + a, f = m * (t + 1) - a;
    return {
      generator: u,
      mirroredGenerator: c,
      mapPercentToKeyframes: d,
      calculatedDuration: k,
      resolvedDuration: m,
      totalDuration: f
    };
  }
  onPostResolved() {
    const { autoplay: n = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !n ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(n, i = !1) {
    const { resolved: t } = this;
    if (!t) {
      const { keyframes: A } = this.options;
      return { done: !0, value: A[A.length - 1] };
    }
    const { finalKeyframe: a, generator: s, mirroredGenerator: r, mapPercentToKeyframes: o, keyframes: d, calculatedDuration: c, totalDuration: u, resolvedDuration: k } = t;
    if (this.startTime === null)
      return s.next(0);
    const { delay: m, repeat: f, repeatType: p, repeatDelay: h, onUpdate: N } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, n) : this.speed < 0 && (this.startTime = Math.min(n - u / this.speed, this.startTime)), i ? this.currentTime = n : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(n - this.startTime) * this.speed;
    const S = this.currentTime - m * (this.speed >= 0 ? 1 : -1), F = this.speed >= 0 ? S < 0 : S > u;
    this.currentTime = Math.max(S, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = u);
    let y = this.currentTime, x = s;
    if (f) {
      const A = Math.min(this.currentTime, u) / k;
      let B = Math.floor(A), W = A % 1;
      !W && A >= 1 && (W = 1), W === 1 && B--, B = Math.min(B, f + 1), !!(B % 2) && (p === "reverse" ? (W = 1 - W, h && (W -= h / k)) : p === "mirror" && (x = r)), y = tl(0, 1, W) * k;
    }
    const R = F ? { done: !1, value: d[0] } : x.next(y);
    o && (R.value = o(R.value));
    let { done: T } = R;
    !F && c !== null && (T = this.speed >= 0 ? this.currentTime >= u : this.currentTime <= 0);
    const j = this.holdTime === null && (this.state === "finished" || this.state === "running" && T);
    return j && a !== void 0 && (R.value = km(d, this.options, a)), N && N(R.value), j && this.finish(), R;
  }
  get duration() {
    const { resolved: n } = this;
    return n ? /* @__PURE__ */ el(n.calculatedDuration) : 0;
  }
  get time() {
    return /* @__PURE__ */ el(this.currentTime);
  }
  set time(n) {
    n = /* @__PURE__ */ xa(n), this.currentTime = n, this.holdTime !== null || this.speed === 0 ? this.holdTime = n : this.driver && (this.startTime = this.driver.now() - n / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(n) {
    const i = this.playbackSpeed !== n;
    this.playbackSpeed = n, i && (this.time = /* @__PURE__ */ el(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: n = Cj, onPlay: i, startTime: t } = this.options;
    this.driver || (this.driver = n((s) => this.tick(s))), i && i();
    const a = this.driver.now();
    this.holdTime !== null ? this.startTime = a - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = a) : this.startTime = t != null ? t : this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var n;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (n = this.currentTime) !== null && n !== void 0 ? n : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: n } = this.options;
    n && n();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(n) {
    return this.startTime = 0, this.tick(n, !0);
  }
}
const wj = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function Pj(e, n, i, { delay: t = 0, duration: a = 300, repeat: s = 0, repeatType: r = "loop", ease: o = "easeInOut", times: d } = {}) {
  const c = { [n]: i };
  d && (c.offset = d);
  const u = TI(o, a);
  return Array.isArray(u) && (c.easing = u), e.animate(c, {
    delay: t,
    duration: a,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: s + 1,
    direction: r === "reverse" ? "alternate" : "normal"
  });
}
const Rj = /* @__PURE__ */ Af(() => Object.hasOwnProperty.call(Element.prototype, "animate")), uu = 10, Tj = 2e4;
function jj(e) {
  return Gf(e.type) || e.type === "spring" || !RI(e.ease);
}
function Aj(e, n) {
  const i = new rv({
    ...n,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let t = { done: !1, value: e[0] };
  const a = [];
  let s = 0;
  for (; !t.done && s < Tj; )
    t = i.sample(s), a.push(t.value), s += uu;
  return {
    times: void 0,
    keyframes: a,
    duration: s - uu,
    ease: "linear"
  };
}
const my = {
  anticipate: VI,
  backInOut: UI,
  circInOut: zI
};
function Oj(e) {
  return e in my;
}
class sN extends sy {
  constructor(n) {
    super(n);
    const { name: i, motionValue: t, element: a, keyframes: s } = this.options;
    this.resolver = new ly(s, (r, o) => this.onKeyframesResolved(r, o), i, t, a), this.resolver.scheduleResolve();
  }
  initPlayback(n, i) {
    let { duration: t = 300, times: a, ease: s, type: r, motionValue: o, name: d, startTime: c } = this.options;
    if (!o.owner || !o.owner.current)
      return !1;
    if (typeof s == "string" && ou() && Oj(s) && (s = my[s]), jj(this.options)) {
      const { onComplete: k, onUpdate: m, motionValue: f, element: p, ...h } = this.options, N = Aj(n, h);
      n = N.keyframes, n.length === 1 && (n[1] = n[0]), t = N.duration, a = N.times, s = N.ease, r = "keyframes";
    }
    const u = Pj(o.owner.current, d, n, { ...this.options, duration: t, times: a, ease: s });
    return u.startTime = c != null ? c : this.calcStartTime(), this.pendingTimeline ? (Vp(u, this.pendingTimeline), this.pendingTimeline = void 0) : u.onfinish = () => {
      const { onComplete: k } = this.options;
      o.set(km(n, this.options, i)), k && k(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: u,
      duration: t,
      times: a,
      type: r,
      ease: s,
      keyframes: n
    };
  }
  get duration() {
    const { resolved: n } = this;
    if (!n)
      return 0;
    const { duration: i } = n;
    return /* @__PURE__ */ el(i);
  }
  get time() {
    const { resolved: n } = this;
    if (!n)
      return 0;
    const { animation: i } = n;
    return /* @__PURE__ */ el(i.currentTime || 0);
  }
  set time(n) {
    const { resolved: i } = this;
    if (!i)
      return;
    const { animation: t } = i;
    t.currentTime = /* @__PURE__ */ xa(n);
  }
  get speed() {
    const { resolved: n } = this;
    if (!n)
      return 1;
    const { animation: i } = n;
    return i.playbackRate;
  }
  set speed(n) {
    const { resolved: i } = this;
    if (!i)
      return;
    const { animation: t } = i;
    t.playbackRate = n;
  }
  get state() {
    const { resolved: n } = this;
    if (!n)
      return "idle";
    const { animation: i } = n;
    return i.playState;
  }
  get startTime() {
    const { resolved: n } = this;
    if (!n)
      return null;
    const { animation: i } = n;
    return i.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(n) {
    if (!this._resolved)
      this.pendingTimeline = n;
    else {
      const { resolved: i } = this;
      if (!i)
        return St;
      const { animation: t } = i;
      Vp(t, n);
    }
    return St;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: i } = n;
    i.playState === "finished" && this.updateFinishedPromise(), i.play();
  }
  pause() {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: i } = n;
    i.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: i, keyframes: t, duration: a, type: s, ease: r, times: o } = n;
    if (i.playState === "idle" || i.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: u, onComplete: k, element: m, ...f } = this.options, p = new rv({
        ...f,
        keyframes: t,
        duration: a,
        type: s,
        ease: r,
        times: o,
        isGenerator: !0
      }), h = /* @__PURE__ */ xa(this.time);
      c.setWithVelocity(p.sample(h - uu).value, p.sample(h).value, uu);
    }
    const { onStop: d } = this.options;
    d && d(), this.cancel();
  }
  complete() {
    const { resolved: n } = this;
    n && n.animation.finish();
  }
  cancel() {
    const { resolved: n } = this;
    n && n.animation.cancel();
  }
  static supports(n) {
    const { motionValue: i, name: t, repeatDelay: a, repeatType: s, damping: r, type: o } = n;
    if (!i || !i.owner || !(i.owner.current instanceof HTMLElement))
      return !1;
    const { onUpdate: d, transformTemplate: c } = i.owner.getProps();
    return Rj() && t && wj.has(t) && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !d && !c && !a && s !== "mirror" && r !== 0 && o !== "inertia";
  }
}
const Ej = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Jj = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), _j = {
  type: "keyframes",
  duration: 0.8
}, Qj = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Mj = (e, { keyframes: n }) => n.length > 2 ? _j : e1.has(e) ? e.startsWith("scale") ? Jj(n[1]) : Ej : Qj;
function Lj({ when: e, delay: n, delayChildren: i, staggerChildren: t, staggerDirection: a, repeat: s, repeatType: r, repeatDelay: o, from: d, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
const ov = (e, n, i, t = {}, a, s) => (r) => {
  const o = qf(t, e) || {}, d = o.delay || t.delay || 0;
  let { elapsed: c = 0 } = t;
  c = c - /* @__PURE__ */ xa(d);
  let u = {
    keyframes: Array.isArray(i) ? i : [null, i],
    ease: "easeOut",
    velocity: n.getVelocity(),
    ...o,
    delay: -c,
    onUpdate: (m) => {
      n.set(m), o.onUpdate && o.onUpdate(m);
    },
    onComplete: () => {
      r(), o.onComplete && o.onComplete();
    },
    name: e,
    motionValue: n,
    element: s ? void 0 : a
  };
  Lj(o) || (u = {
    ...u,
    ...Mj(e, u)
  }), u.duration && (u.duration = /* @__PURE__ */ xa(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ xa(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let k = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (u.duration = 0, u.delay === 0 && (k = !0)), k && !s && n.get() !== void 0) {
    const m = km(u.keyframes, o);
    if (m !== void 0)
      return Yn.update(() => {
        u.onUpdate(m), u.onComplete();
      }), new lT([]);
  }
  return !s && sN.supports(u) ? new sN(u) : new rv(u);
};
function $j({ protectedKeys: e, needsAnimating: n }, i) {
  const t = e.hasOwnProperty(i) && n[i] !== !0;
  return n[i] = !1, t;
}
function ky(e, n, { delay: i = 0, transitionOverride: t, type: a } = {}) {
  var s;
  let { transition: r = e.getDefaultTransition(), transitionEnd: o, ...d } = n;
  t && (r = t);
  const c = [], u = a && e.animationState && e.animationState.getState()[a];
  for (const k in d) {
    const m = e.getValue(k, (s = e.latestValues[k]) !== null && s !== void 0 ? s : null), f = d[k];
    if (f === void 0 || u && $j(u, k))
      continue;
    const p = {
      delay: i,
      ...qf(r || {}, k)
    };
    let h = !1;
    if (window.MotionHandoffAnimation) {
      const S = _I(e);
      if (S) {
        const F = window.MotionHandoffAnimation(S, k, Yn);
        F !== null && (p.startTime = F, h = !0);
      }
    }
    E3(e, k), m.start(ov(k, m, f, e.shouldReduceMotion && EI.has(k) ? { type: !1 } : p, e, h));
    const N = m.animation;
    N && c.push(N);
  }
  return o && Promise.all(c).then(() => {
    Yn.update(() => {
      o && ST(e, o);
    });
  }), c;
}
function U3(e, n, i = {}) {
  var t;
  const a = mm(e, n, i.type === "exit" ? (t = e.presenceContext) === null || t === void 0 ? void 0 : t.custom : void 0);
  let { transition: s = e.getDefaultTransition() || {} } = a || {};
  i.transitionOverride && (s = i.transitionOverride);
  const r = a ? () => Promise.all(ky(e, a, i)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: k, staggerDirection: m } = s;
    return Uj(e, n, u + c, k, m, i);
  } : () => Promise.resolve(), { when: d } = s;
  if (d) {
    const [c, u] = d === "beforeChildren" ? [r, o] : [o, r];
    return c().then(() => u());
  } else
    return Promise.all([r(), o(i.delay)]);
}
function Uj(e, n, i = 0, t = 0, a = 1, s) {
  const r = [], o = (e.variantChildren.size - 1) * t, d = a === 1 ? (c = 0) => c * t : (c = 0) => o - c * t;
  return Array.from(e.variantChildren).sort(Vj).forEach((c, u) => {
    c.notify("AnimationStart", n), r.push(U3(c, n, {
      ...s,
      delay: i + d(u)
    }).then(() => c.notify("AnimationComplete", n)));
  }), Promise.all(r);
}
function Vj(e, n) {
  return e.sortNodePosition(n);
}
function Hj(e, n, i = {}) {
  e.notify("AnimationStart", n);
  let t;
  if (Array.isArray(n)) {
    const a = n.map((s) => U3(e, s, i));
    t = Promise.all(a);
  } else if (typeof n == "string")
    t = U3(e, n, i);
  else {
    const a = typeof n == "function" ? mm(e, n, i.custom) : n;
    t = Promise.all(ky(e, a, i));
  }
  return t.then(() => {
    e.notify("AnimationComplete", n);
  });
}
const zj = Ef.length;
function fy(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const i = e.parent ? fy(e.parent) || {} : {};
    return e.props.initial !== void 0 && (i.initial = e.props.initial), i;
  }
  const n = {};
  for (let i = 0; i < zj; i++) {
    const t = Ef[i], a = e.props[t];
    (Ao(a) || a === !1) && (n[t] = a);
  }
  return n;
}
const Bj = [...Of].reverse(), qj = Of.length;
function Gj(e) {
  return (n) => Promise.all(n.map(({ animation: i, options: t }) => Hj(e, i, t)));
}
function Wj(e) {
  let n = Gj(e), i = rN(), t = !0;
  const a = (d) => (c, u) => {
    var k;
    const m = mm(e, u, d === "exit" ? (k = e.presenceContext) === null || k === void 0 ? void 0 : k.custom : void 0);
    if (m) {
      const { transition: f, transitionEnd: p, ...h } = m;
      c = { ...c, ...h, ...p };
    }
    return c;
  };
  function s(d) {
    n = d(e);
  }
  function r(d) {
    const { props: c } = e, u = fy(e.parent) || {}, k = [], m = /* @__PURE__ */ new Set();
    let f = {}, p = 1 / 0;
    for (let N = 0; N < qj; N++) {
      const S = Bj[N], F = i[S], y = c[S] !== void 0 ? c[S] : u[S], x = Ao(y), R = S === d ? F.isActive : null;
      R === !1 && (p = N);
      let T = y === u[S] && y !== c[S] && x;
      if (T && t && e.manuallyAnimateOnMount && (T = !1), F.protectedKeys = { ...f }, // If it isn't active and hasn't *just* been set as inactive
      !F.isActive && R === null || // If we didn't and don't have any defined prop for this animation type
      !y && !F.prevProp || // Or if the prop doesn't define an animation
      cm(y) || typeof y == "boolean")
        continue;
      const j = Kj(F.prevProp, y);
      let A = j || // If we're making this variant active, we want to always make it active
      S === d && F.isActive && !T && x || // If we removed a higher-priority variant (i is in reverse order)
      N > p && x, B = !1;
      const W = Array.isArray(y) ? y : [y];
      let E = W.reduce(a(S), {});
      R === !1 && (E = {});
      const { prevResolvedValues: $ = {} } = F, V = {
        ...$,
        ...E
      }, H = (L) => {
        A = !0, m.has(L) && (B = !0, m.delete(L)), F.needsAnimating[L] = !0;
        const _ = e.getValue(L);
        _ && (_.liveStyle = !1);
      };
      for (const L in V) {
        const _ = E[L], z = $[L];
        if (f.hasOwnProperty(L))
          continue;
        let ne = !1;
        j3(_) && j3(z) ? ne = !DI(_, z) : ne = _ !== z, ne ? _ != null ? H(L) : m.add(L) : _ !== void 0 && m.has(L) ? H(L) : F.protectedKeys[L] = !0;
      }
      F.prevProp = y, F.prevResolvedValues = E, F.isActive && (f = { ...f, ...E }), t && e.blockInitialAnimation && (A = !1), A && (!(T && j) || B) && k.push(...W.map((L) => ({
        animation: L,
        options: { type: S }
      })));
    }
    if (m.size) {
      const N = {};
      m.forEach((S) => {
        const F = e.getBaseTarget(S), y = e.getValue(S);
        y && (y.liveStyle = !0), N[S] = F != null ? F : null;
      }), k.push({ animation: N });
    }
    let h = !!k.length;
    return t && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (h = !1), t = !1, h ? n(k) : Promise.resolve();
  }
  function o(d, c) {
    var u;
    if (i[d].isActive === c)
      return Promise.resolve();
    (u = e.variantChildren) === null || u === void 0 || u.forEach((m) => {
      var f;
      return (f = m.animationState) === null || f === void 0 ? void 0 : f.setActive(d, c);
    }), i[d].isActive = c;
    const k = r(d);
    for (const m in i)
      i[m].protectedKeys = {};
    return k;
  }
  return {
    animateChanges: r,
    setActive: o,
    setAnimateFunction: s,
    getState: () => i,
    reset: () => {
      i = rN(), t = !0;
    }
  };
}
function Kj(e, n) {
  return typeof n == "string" ? n !== e : Array.isArray(n) ? !DI(n, e) : !1;
}
function bs(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function rN() {
  return {
    animate: bs(!0),
    whileInView: bs(),
    whileHover: bs(),
    whileTap: bs(),
    whileDrag: bs(),
    whileFocus: bs(),
    exit: bs()
  };
}
class ss {
  constructor(n) {
    this.isMounted = !1, this.node = n;
  }
  update() {
  }
}
class Yj extends ss {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(n) {
    super(n), n.animationState || (n.animationState = Wj(n));
  }
  updateAnimationControlsSubscription() {
    const { animate: n } = this.node.getProps();
    cm(n) && (this.unmountControls = n.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: n } = this.node.getProps(), { animate: i } = this.node.prevProps || {};
    n !== i && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var n;
    this.node.animationState.reset(), (n = this.unmountControls) === null || n === void 0 || n.call(this);
  }
}
let Xj = 0;
class Zj extends ss {
  constructor() {
    super(...arguments), this.id = Xj++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: n, onExitComplete: i } = this.node.presenceContext, { isPresent: t } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || n === t)
      return;
    const a = this.node.animationState.setActive("exit", !n);
    i && !n && a.then(() => i(this.id));
  }
  mount() {
    const { register: n } = this.node.presenceContext || {};
    n && (this.unmount = n(this.id));
  }
  unmount() {
  }
}
const eA = {
  animation: {
    Feature: Yj
  },
  exit: {
    Feature: Zj
  }
};
function _o(e, n, i, t = { passive: !0 }) {
  return e.addEventListener(n, i, t), () => e.removeEventListener(n, i);
}
function md(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const nA = (e) => (n) => Kf(n) && e(n, md(n));
function Io(e, n, i, t) {
  return _o(e, n, nA(i), t);
}
const oN = (e, n) => Math.abs(e - n);
function iA(e, n) {
  const i = oN(e.x, n.x), t = oN(e.y, n.y);
  return Math.sqrt(i ** 2 + t ** 2);
}
class vy {
  constructor(n, i, { transformPagePoint: t, contextWindow: a, dragSnapToOrigin: s = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const k = p0(this.lastMoveEventInfo, this.history), m = this.startEvent !== null, f = iA(k.offset, { x: 0, y: 0 }) >= 3;
      if (!m && !f)
        return;
      const { point: p } = k, { timestamp: h } = zi;
      this.history.push({ ...p, timestamp: h });
      const { onStart: N, onMove: S } = this.handlers;
      m || (N && N(this.lastMoveEvent, k), this.startEvent = this.lastMoveEvent), S && S(this.lastMoveEvent, k);
    }, this.handlePointerMove = (k, m) => {
      this.lastMoveEvent = k, this.lastMoveEventInfo = h0(m, this.transformPagePoint), Yn.update(this.updatePoint, !0);
    }, this.handlePointerUp = (k, m) => {
      this.end();
      const { onEnd: f, onSessionEnd: p, resumeAnimation: h } = this.handlers;
      if (this.dragSnapToOrigin && h && h(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const N = p0(k.type === "pointercancel" ? this.lastMoveEventInfo : h0(m, this.transformPagePoint), this.history);
      this.startEvent && f && f(k, N), p && p(k, N);
    }, !Kf(n))
      return;
    this.dragSnapToOrigin = s, this.handlers = i, this.transformPagePoint = t, this.contextWindow = a || window;
    const r = md(n), o = h0(r, this.transformPagePoint), { point: d } = o, { timestamp: c } = zi;
    this.history = [{ ...d, timestamp: c }];
    const { onSessionStart: u } = i;
    u && u(n, p0(o, this.history)), this.removeListeners = ud(Io(this.contextWindow, "pointermove", this.handlePointerMove), Io(this.contextWindow, "pointerup", this.handlePointerUp), Io(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(n) {
    this.handlers = n;
  }
  end() {
    this.removeListeners && this.removeListeners(), ql(this.updatePoint);
  }
}
function h0(e, n) {
  return n ? { point: n(e.point) } : e;
}
function dN(e, n) {
  return { x: e.x - n.x, y: e.y - n.y };
}
function p0({ point: e }, n) {
  return {
    point: e,
    delta: dN(e, hy(n)),
    offset: dN(e, tA(n)),
    velocity: aA(n, 0.1)
  };
}
function tA(e) {
  return e[0];
}
function hy(e) {
  return e[e.length - 1];
}
function aA(e, n) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let i = e.length - 1, t = null;
  const a = hy(e);
  for (; i >= 0 && (t = e[i], !(a.timestamp - t.timestamp > /* @__PURE__ */ xa(n))); )
    i--;
  if (!t)
    return { x: 0, y: 0 };
  const s = /* @__PURE__ */ el(a.timestamp - t.timestamp);
  if (s === 0)
    return { x: 0, y: 0 };
  const r = {
    x: (a.x - t.x) / s,
    y: (a.y - t.y) / s
  };
  return r.x === 1 / 0 && (r.x = 0), r.y === 1 / 0 && (r.y = 0), r;
}
const py = 1e-4, lA = 1 - py, sA = 1 + py, Ny = 0.01, rA = 0 - Ny, oA = 0 + Ny;
function jt(e) {
  return e.max - e.min;
}
function dA(e, n, i) {
  return Math.abs(e - n) <= i;
}
function cN(e, n, i, t = 0.5) {
  e.origin = t, e.originPoint = di(n.min, n.max, e.origin), e.scale = jt(i) / jt(n), e.translate = di(i.min, i.max, e.origin) - e.originPoint, (e.scale >= lA && e.scale <= sA || isNaN(e.scale)) && (e.scale = 1), (e.translate >= rA && e.translate <= oA || isNaN(e.translate)) && (e.translate = 0);
}
function yo(e, n, i, t) {
  cN(e.x, n.x, i.x, t ? t.originX : void 0), cN(e.y, n.y, i.y, t ? t.originY : void 0);
}
function uN(e, n, i) {
  e.min = i.min + n.min, e.max = e.min + jt(n);
}
function cA(e, n, i) {
  uN(e.x, n.x, i.x), uN(e.y, n.y, i.y);
}
function mN(e, n, i) {
  e.min = n.min - i.min, e.max = e.min + jt(n);
}
function bo(e, n, i) {
  mN(e.x, n.x, i.x), mN(e.y, n.y, i.y);
}
function uA(e, { min: n, max: i }, t) {
  return n !== void 0 && e < n ? e = t ? di(n, e, t.min) : Math.max(e, n) : i !== void 0 && e > i && (e = t ? di(i, e, t.max) : Math.min(e, i)), e;
}
function kN(e, n, i) {
  return {
    min: n !== void 0 ? e.min + n : void 0,
    max: i !== void 0 ? e.max + i - (e.max - e.min) : void 0
  };
}
function mA(e, { top: n, left: i, bottom: t, right: a }) {
  return {
    x: kN(e.x, i, a),
    y: kN(e.y, n, t)
  };
}
function fN(e, n) {
  let i = n.min - e.min, t = n.max - e.max;
  return n.max - n.min < e.max - e.min && ([i, t] = [t, i]), { min: i, max: t };
}
function kA(e, n) {
  return {
    x: fN(e.x, n.x),
    y: fN(e.y, n.y)
  };
}
function fA(e, n) {
  let i = 0.5;
  const t = jt(e), a = jt(n);
  return a > t ? i = /* @__PURE__ */ q1(n.min, n.max - t, e.min) : t > a && (i = /* @__PURE__ */ q1(e.min, e.max - a, n.min)), tl(0, 1, i);
}
function vA(e, n) {
  const i = {};
  return n.min !== void 0 && (i.min = n.min - e.min), n.max !== void 0 && (i.max = n.max - e.min), i;
}
const V3 = 0.35;
function hA(e = V3) {
  return e === !1 ? e = 0 : e === !0 && (e = V3), {
    x: vN(e, "left", "right"),
    y: vN(e, "top", "bottom")
  };
}
function vN(e, n, i) {
  return {
    min: hN(e, n),
    max: hN(e, i)
  };
}
function hN(e, n) {
  return typeof e == "number" ? e : e[n] || 0;
}
const pN = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), T1 = () => ({
  x: pN(),
  y: pN()
}), NN = () => ({ min: 0, max: 0 }), Si = () => ({
  x: NN(),
  y: NN()
});
function _t(e) {
  return [e("x"), e("y")];
}
function Sy({ top: e, left: n, right: i, bottom: t }) {
  return {
    x: { min: n, max: i },
    y: { min: e, max: t }
  };
}
function pA({ x: e, y: n }) {
  return { top: n.min, right: e.max, bottom: n.max, left: e.min };
}
function NA(e, n) {
  if (!n)
    return e;
  const i = n({ x: e.left, y: e.top }), t = n({ x: e.right, y: e.bottom });
  return {
    top: i.y,
    left: i.x,
    bottom: t.y,
    right: t.x
  };
}
function N0(e) {
  return e === void 0 || e === 1;
}
function H3({ scale: e, scaleX: n, scaleY: i }) {
  return !N0(e) || !N0(n) || !N0(i);
}
function Ds(e) {
  return H3(e) || gy(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function gy(e) {
  return SN(e.x) || SN(e.y);
}
function SN(e) {
  return e && e !== "0%";
}
function mu(e, n, i) {
  const t = e - i, a = n * t;
  return i + a;
}
function gN(e, n, i, t, a) {
  return a !== void 0 && (e = mu(e, a, t)), mu(e, i, t) + n;
}
function z3(e, n = 0, i = 1, t, a) {
  e.min = gN(e.min, n, i, t, a), e.max = gN(e.max, n, i, t, a);
}
function Fy(e, { x: n, y: i }) {
  z3(e.x, n.translate, n.scale, n.originPoint), z3(e.y, i.translate, i.scale, i.originPoint);
}
const FN = 0.999999999999, IN = 1.0000000000001;
function SA(e, n, i, t = !1) {
  const a = i.length;
  if (!a)
    return;
  n.x = n.y = 1;
  let s, r;
  for (let o = 0; o < a; o++) {
    s = i[o], r = s.projectionDelta;
    const { visualElement: d } = s.options;
    d && d.props.style && d.props.style.display === "contents" || (t && s.options.layoutScroll && s.scroll && s !== s.root && A1(e, {
      x: -s.scroll.offset.x,
      y: -s.scroll.offset.y
    }), r && (n.x *= r.x.scale, n.y *= r.y.scale, Fy(e, r)), t && Ds(s.latestValues) && A1(e, s.latestValues));
  }
  n.x < IN && n.x > FN && (n.x = 1), n.y < IN && n.y > FN && (n.y = 1);
}
function j1(e, n) {
  e.min = e.min + n, e.max = e.max + n;
}
function yN(e, n, i, t, a = 0.5) {
  const s = di(e.min, e.max, a);
  z3(e, n, i, s, t);
}
function A1(e, n) {
  yN(e.x, n.x, n.scaleX, n.scale, n.originX), yN(e.y, n.y, n.scaleY, n.scale, n.originY);
}
function Iy(e, n) {
  return Sy(NA(e.getBoundingClientRect(), n));
}
function gA(e, n, i) {
  const t = Iy(e, i), { scroll: a } = n;
  return a && (j1(t.x, a.offset.x), j1(t.y, a.offset.y)), t;
}
const yy = ({ current: e }) => e ? e.ownerDocument.defaultView : null, FA = /* @__PURE__ */ new WeakMap();
class IA {
  constructor(n) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Si(), this.visualElement = n;
  }
  start(n, { snapToCursor: i = !1 } = {}) {
    const { presenceContext: t } = this.visualElement;
    if (t && t.isPresent === !1)
      return;
    const a = (u) => {
      const { dragSnapToOrigin: k } = this.getProps();
      k ? this.pauseAnimation() : this.stopAnimation(), i && this.snapToCursor(md(u).point);
    }, s = (u, k) => {
      const { drag: m, dragPropagation: f, onDragStart: p } = this.getProps();
      if (m && !f && (this.openDragLock && this.openDragLock(), this.openDragLock = fT(m), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), _t((N) => {
        let S = this.getAxisMotionValue(N).get() || 0;
        if (Da.test(S)) {
          const { projection: F } = this.visualElement;
          if (F && F.layout) {
            const y = F.layout.layoutBox[N];
            y && (S = jt(y) * (parseFloat(S) / 100));
          }
        }
        this.originPoint[N] = S;
      }), p && Yn.postRender(() => p(u, k)), E3(this.visualElement, "transform");
      const { animationState: h } = this.visualElement;
      h && h.setActive("whileDrag", !0);
    }, r = (u, k) => {
      const { dragPropagation: m, dragDirectionLock: f, onDirectionLock: p, onDrag: h } = this.getProps();
      if (!m && !this.openDragLock)
        return;
      const { offset: N } = k;
      if (f && this.currentDirection === null) {
        this.currentDirection = yA(N), this.currentDirection !== null && p && p(this.currentDirection);
        return;
      }
      this.updateAxis("x", k.point, N), this.updateAxis("y", k.point, N), this.visualElement.render(), h && h(u, k);
    }, o = (u, k) => this.stop(u, k), d = () => _t((u) => {
      var k;
      return this.getAnimationState(u) === "paused" && ((k = this.getAxisMotionValue(u).animation) === null || k === void 0 ? void 0 : k.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new vy(n, {
      onSessionStart: a,
      onStart: s,
      onMove: r,
      onSessionEnd: o,
      resumeAnimation: d
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: yy(this.visualElement)
    });
  }
  stop(n, i) {
    const t = this.isDragging;
    if (this.cancel(), !t)
      return;
    const { velocity: a } = i;
    this.startAnimation(a);
    const { onDragEnd: s } = this.getProps();
    s && Yn.postRender(() => s(n, i));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: n, animationState: i } = this.visualElement;
    n && (n.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: t } = this.getProps();
    !t && this.openDragLock && (this.openDragLock(), this.openDragLock = null), i && i.setActive("whileDrag", !1);
  }
  updateAxis(n, i, t) {
    const { drag: a } = this.getProps();
    if (!t || !tc(n, a, this.currentDirection))
      return;
    const s = this.getAxisMotionValue(n);
    let r = this.originPoint[n] + t[n];
    this.constraints && this.constraints[n] && (r = uA(r, this.constraints[n], this.elastic[n])), s.set(r);
  }
  resolveConstraints() {
    var n;
    const { dragConstraints: i, dragElastic: t } = this.getProps(), a = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (n = this.visualElement.projection) === null || n === void 0 ? void 0 : n.layout, s = this.constraints;
    i && P1(i) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : i && a ? this.constraints = mA(a.layoutBox, i) : this.constraints = !1, this.elastic = hA(t), s !== this.constraints && a && this.constraints && !this.hasMutatedConstraints && _t((r) => {
      this.constraints !== !1 && this.getAxisMotionValue(r) && (this.constraints[r] = vA(a.layoutBox[r], this.constraints[r]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: n, onMeasureDragConstraints: i } = this.getProps();
    if (!n || !P1(n))
      return !1;
    const t = n.current;
    Bl(t !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: a } = this.visualElement;
    if (!a || !a.layout)
      return !1;
    const s = gA(t, a.root, this.visualElement.getTransformPagePoint());
    let r = kA(a.layout.layoutBox, s);
    if (i) {
      const o = i(pA(r));
      this.hasMutatedConstraints = !!o, o && (r = Sy(o));
    }
    return r;
  }
  startAnimation(n) {
    const { drag: i, dragMomentum: t, dragElastic: a, dragTransition: s, dragSnapToOrigin: r, onDragTransitionEnd: o } = this.getProps(), d = this.constraints || {}, c = _t((u) => {
      if (!tc(u, i, this.currentDirection))
        return;
      let k = d && d[u] || {};
      r && (k = { min: 0, max: 0 });
      const m = a ? 200 : 1e6, f = a ? 40 : 1e7, p = {
        type: "inertia",
        velocity: t ? n[u] : 0,
        bounceStiffness: m,
        bounceDamping: f,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...s,
        ...k
      };
      return this.startAxisValueAnimation(u, p);
    });
    return Promise.all(c).then(o);
  }
  startAxisValueAnimation(n, i) {
    const t = this.getAxisMotionValue(n);
    return E3(this.visualElement, n), t.start(ov(n, t, 0, i, this.visualElement, !1));
  }
  stopAnimation() {
    _t((n) => this.getAxisMotionValue(n).stop());
  }
  pauseAnimation() {
    _t((n) => {
      var i;
      return (i = this.getAxisMotionValue(n).animation) === null || i === void 0 ? void 0 : i.pause();
    });
  }
  getAnimationState(n) {
    var i;
    return (i = this.getAxisMotionValue(n).animation) === null || i === void 0 ? void 0 : i.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(n) {
    const i = `_drag${n.toUpperCase()}`, t = this.visualElement.getProps(), a = t[i];
    return a || this.visualElement.getValue(n, (t.initial ? t.initial[n] : void 0) || 0);
  }
  snapToCursor(n) {
    _t((i) => {
      const { drag: t } = this.getProps();
      if (!tc(i, t, this.currentDirection))
        return;
      const { projection: a } = this.visualElement, s = this.getAxisMotionValue(i);
      if (a && a.layout) {
        const { min: r, max: o } = a.layout.layoutBox[i];
        s.set(n[i] - di(r, o, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: n, dragConstraints: i } = this.getProps(), { projection: t } = this.visualElement;
    if (!P1(i) || !t || !this.constraints)
      return;
    this.stopAnimation();
    const a = { x: 0, y: 0 };
    _t((r) => {
      const o = this.getAxisMotionValue(r);
      if (o && this.constraints !== !1) {
        const d = o.get();
        a[r] = fA({ min: d, max: d }, this.constraints[r]);
      }
    });
    const { transformTemplate: s } = this.visualElement.getProps();
    this.visualElement.current.style.transform = s ? s({}, "") : "none", t.root && t.root.updateScroll(), t.updateLayout(), this.resolveConstraints(), _t((r) => {
      if (!tc(r, n, null))
        return;
      const o = this.getAxisMotionValue(r), { min: d, max: c } = this.constraints[r];
      o.set(di(d, c, a[r]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    FA.set(this.visualElement, this);
    const n = this.visualElement.current, i = Io(n, "pointerdown", (d) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(d);
    }), t = () => {
      const { dragConstraints: d } = this.getProps();
      P1(d) && d.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: a } = this.visualElement, s = a.addEventListener("measure", t);
    a && !a.layout && (a.root && a.root.updateScroll(), a.updateLayout()), Yn.read(t);
    const r = _o(window, "resize", () => this.scalePositionWithinConstraints()), o = a.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: c }) => {
      this.isDragging && c && (_t((u) => {
        const k = this.getAxisMotionValue(u);
        k && (this.originPoint[u] += d[u].translate, k.set(k.get() + d[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      r(), i(), s(), o && o();
    };
  }
  getProps() {
    const n = this.visualElement.getProps(), { drag: i = !1, dragDirectionLock: t = !1, dragPropagation: a = !1, dragConstraints: s = !1, dragElastic: r = V3, dragMomentum: o = !0 } = n;
    return {
      ...n,
      drag: i,
      dragDirectionLock: t,
      dragPropagation: a,
      dragConstraints: s,
      dragElastic: r,
      dragMomentum: o
    };
  }
}
function tc(e, n, i) {
  return (n === !0 || n === e) && (i === null || i === e);
}
function yA(e, n = 10) {
  let i = null;
  return Math.abs(e.y) > n ? i = "y" : Math.abs(e.x) > n && (i = "x"), i;
}
class bA extends ss {
  constructor(n) {
    super(n), this.removeGroupControls = St, this.removeListeners = St, this.controls = new IA(n);
  }
  mount() {
    const { dragControls: n } = this.node.getProps();
    n && (this.removeGroupControls = n.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || St;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const bN = (e) => (n, i) => {
  e && Yn.postRender(() => e(n, i));
};
class CA extends ss {
  constructor() {
    super(...arguments), this.removePointerDownListener = St;
  }
  onPointerDown(n) {
    this.session = new vy(n, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: yy(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: n, onPanStart: i, onPan: t, onPanEnd: a } = this.node.getProps();
    return {
      onSessionStart: bN(n),
      onStart: bN(i),
      onMove: t,
      onEnd: (s, r) => {
        delete this.session, a && Yn.postRender(() => a(s, r));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Io(this.node.current, "pointerdown", (n) => this.onPointerDown(n));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Ec = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function CN(e, n) {
  return n.max === n.min ? 0 : e / (n.max - n.min) * 100;
}
const Yr = {
  correct: (e, n) => {
    if (!n.target)
      return e;
    if (typeof e == "string")
      if (Ge.test(e))
        e = parseFloat(e);
      else
        return e;
    const i = CN(e, n.target.x), t = CN(e, n.target.y);
    return `${i}% ${t}%`;
  }
}, xA = {
  correct: (e, { treeScale: n, projectionDelta: i }) => {
    const t = e, a = Gl.parse(e);
    if (a.length > 5)
      return t;
    const s = Gl.createTransformer(e), r = typeof a[0] != "number" ? 1 : 0, o = i.x.scale * n.x, d = i.y.scale * n.y;
    a[0 + r] /= o, a[1 + r] /= d;
    const c = di(o, d, 0.5);
    return typeof a[2 + r] == "number" && (a[2 + r] /= c), typeof a[3 + r] == "number" && (a[3 + r] /= c), s(a);
  }
};
class DA extends L9 {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: n, layoutGroup: i, switchLayoutGroup: t, layoutId: a } = this.props, { projection: s } = n;
    qR(wA), s && (i.group && i.group.add(s), t && t.register && a && t.register(s), s.root.didUpdate(), s.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), s.setOptions({
      ...s.options,
      onExitComplete: () => this.safeToRemove()
    })), Ec.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(n) {
    const { layoutDependency: i, visualElement: t, drag: a, isPresent: s } = this.props, r = t.projection;
    return r && (r.isPresent = s, a || n.layoutDependency !== i || i === void 0 ? r.willUpdate() : this.safeToRemove(), n.isPresent !== s && (s ? r.promote() : r.relegate() || Yn.postRender(() => {
      const o = r.getStack();
      (!o || !o.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: n } = this.props.visualElement;
    n && (n.root.didUpdate(), _f.postRender(() => {
      !n.currentAnimation && n.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: n, layoutGroup: i, switchLayoutGroup: t } = this.props, { projection: a } = n;
    a && (a.scheduleCheckAfterUnmount(), i && i.group && i.group.remove(a), t && t.deregister && t.deregister(a));
  }
  safeToRemove() {
    const { safeToRemove: n } = this.props;
    n && n();
  }
  render() {
    return null;
  }
}
function by(e) {
  const [n, i] = rI(), t = oi(Pf);
  return l.jsx(DA, { ...e, layoutGroup: t, switchLayoutGroup: oi(fI), isPresent: n, safeToRemove: i });
}
const wA = {
  borderRadius: {
    ...Yr,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Yr,
  borderTopRightRadius: Yr,
  borderBottomLeftRadius: Yr,
  borderBottomRightRadius: Yr,
  boxShadow: xA
};
function PA(e, n, i) {
  const t = et(e) ? e : Eo(e);
  return t.start(ov("", t, n, i)), t.animation;
}
function RA(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
const TA = (e, n) => e.depth - n.depth;
class jA {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(n) {
    Yf(this.children, n), this.isDirty = !0;
  }
  remove(n) {
    Xf(this.children, n), this.isDirty = !0;
  }
  forEach(n) {
    this.isDirty && this.children.sort(TA), this.isDirty = !1, this.children.forEach(n);
  }
}
function AA(e, n) {
  const i = wa.now(), t = ({ timestamp: a }) => {
    const s = a - i;
    s >= n && (ql(t), e(s - n));
  };
  return Yn.read(t, !0), () => ql(t);
}
const Cy = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], OA = Cy.length, xN = (e) => typeof e == "string" ? parseFloat(e) : e, DN = (e) => typeof e == "number" || Ge.test(e);
function EA(e, n, i, t, a, s) {
  a ? (e.opacity = di(
    0,
    // TODO Reinstate this if only child
    i.opacity !== void 0 ? i.opacity : 1,
    JA(t)
  ), e.opacityExit = di(n.opacity !== void 0 ? n.opacity : 1, 0, _A(t))) : s && (e.opacity = di(n.opacity !== void 0 ? n.opacity : 1, i.opacity !== void 0 ? i.opacity : 1, t));
  for (let r = 0; r < OA; r++) {
    const o = `border${Cy[r]}Radius`;
    let d = wN(n, o), c = wN(i, o);
    if (d === void 0 && c === void 0)
      continue;
    d || (d = 0), c || (c = 0), d === 0 || c === 0 || DN(d) === DN(c) ? (e[o] = Math.max(di(xN(d), xN(c), t), 0), (Da.test(c) || Da.test(d)) && (e[o] += "%")) : e[o] = c;
  }
  (n.rotate || i.rotate) && (e.rotate = di(n.rotate || 0, i.rotate || 0, t));
}
function wN(e, n) {
  return e[n] !== void 0 ? e[n] : e.borderRadius;
}
const JA = /* @__PURE__ */ xy(0, 0.5, HI), _A = /* @__PURE__ */ xy(0.5, 0.95, St);
function xy(e, n, i) {
  return (t) => t < e ? 0 : t > n ? 1 : i(/* @__PURE__ */ q1(e, n, t));
}
function PN(e, n) {
  e.min = n.min, e.max = n.max;
}
function Jt(e, n) {
  PN(e.x, n.x), PN(e.y, n.y);
}
function RN(e, n) {
  e.translate = n.translate, e.scale = n.scale, e.originPoint = n.originPoint, e.origin = n.origin;
}
function TN(e, n, i, t, a) {
  return e -= n, e = mu(e, 1 / i, t), a !== void 0 && (e = mu(e, 1 / a, t)), e;
}
function QA(e, n = 0, i = 1, t = 0.5, a, s = e, r = e) {
  if (Da.test(n) && (n = parseFloat(n), n = di(r.min, r.max, n / 100) - r.min), typeof n != "number")
    return;
  let o = di(s.min, s.max, t);
  e === s && (o -= n), e.min = TN(e.min, n, i, o, a), e.max = TN(e.max, n, i, o, a);
}
function jN(e, n, [i, t, a], s, r) {
  QA(e, n[i], n[t], n[a], n.scale, s, r);
}
const MA = ["x", "scaleX", "originX"], LA = ["y", "scaleY", "originY"];
function AN(e, n, i, t) {
  jN(e.x, n, MA, i ? i.x : void 0, t ? t.x : void 0), jN(e.y, n, LA, i ? i.y : void 0, t ? t.y : void 0);
}
function ON(e) {
  return e.translate === 0 && e.scale === 1;
}
function Dy(e) {
  return ON(e.x) && ON(e.y);
}
function EN(e, n) {
  return e.min === n.min && e.max === n.max;
}
function $A(e, n) {
  return EN(e.x, n.x) && EN(e.y, n.y);
}
function JN(e, n) {
  return Math.round(e.min) === Math.round(n.min) && Math.round(e.max) === Math.round(n.max);
}
function wy(e, n) {
  return JN(e.x, n.x) && JN(e.y, n.y);
}
function _N(e) {
  return jt(e.x) / jt(e.y);
}
function QN(e, n) {
  return e.translate === n.translate && e.scale === n.scale && e.originPoint === n.originPoint;
}
class UA {
  constructor() {
    this.members = [];
  }
  add(n) {
    Yf(this.members, n), n.scheduleRender();
  }
  remove(n) {
    if (Xf(this.members, n), n === this.prevLead && (this.prevLead = void 0), n === this.lead) {
      const i = this.members[this.members.length - 1];
      i && this.promote(i);
    }
  }
  relegate(n) {
    const i = this.members.findIndex((a) => n === a);
    if (i === 0)
      return !1;
    let t;
    for (let a = i; a >= 0; a--) {
      const s = this.members[a];
      if (s.isPresent !== !1) {
        t = s;
        break;
      }
    }
    return t ? (this.promote(t), !0) : !1;
  }
  promote(n, i) {
    const t = this.lead;
    if (n !== t && (this.prevLead = t, this.lead = n, n.show(), t)) {
      t.instance && t.scheduleRender(), n.scheduleRender(), n.resumeFrom = t, i && (n.resumeFrom.preserveOpacity = !0), t.snapshot && (n.snapshot = t.snapshot, n.snapshot.latestValues = t.animationValues || t.latestValues), n.root && n.root.isUpdating && (n.isLayoutDirty = !0);
      const { crossfade: a } = n.options;
      a === !1 && t.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((n) => {
      const { options: i, resumingFrom: t } = n;
      i.onExitComplete && i.onExitComplete(), t && t.options.onExitComplete && t.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((n) => {
      n.instance && n.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function VA(e, n, i) {
  let t = "";
  const a = e.x.translate / n.x, s = e.y.translate / n.y, r = (i == null ? void 0 : i.z) || 0;
  if ((a || s || r) && (t = `translate3d(${a}px, ${s}px, ${r}px) `), (n.x !== 1 || n.y !== 1) && (t += `scale(${1 / n.x}, ${1 / n.y}) `), i) {
    const { transformPerspective: c, rotate: u, rotateX: k, rotateY: m, skewX: f, skewY: p } = i;
    c && (t = `perspective(${c}px) ${t}`), u && (t += `rotate(${u}deg) `), k && (t += `rotateX(${k}deg) `), m && (t += `rotateY(${m}deg) `), f && (t += `skewX(${f}deg) `), p && (t += `skewY(${p}deg) `);
  }
  const o = e.x.scale * n.x, d = e.y.scale * n.y;
  return (o !== 1 || d !== 1) && (t += `scale(${o}, ${d})`), t || "none";
}
const ws = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, fo = typeof window != "undefined" && window.MotionDebug !== void 0, S0 = ["", "X", "Y", "Z"], HA = { visibility: "hidden" }, MN = 1e3;
let zA = 0;
function g0(e, n, i, t) {
  const { latestValues: a } = n;
  a[e] && (i[e] = a[e], n.setStaticValue(e, 0), t && (t[e] = 0));
}
function Py(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: n } = e.options;
  if (!n)
    return;
  const i = _I(n);
  if (window.MotionHasOptimisedAnimation(i, "transform")) {
    const { layout: a, layoutId: s } = e.options;
    window.MotionCancelOptimisedAnimation(i, "transform", Yn, !(a || s));
  }
  const { parent: t } = e;
  t && !t.hasCheckedOptimisedAppear && Py(t);
}
function Ry({ attachResizeListener: e, defaultParent: n, measureScroll: i, checkIsScrollRoot: t, resetTransform: a }) {
  return class {
    constructor(r = {}, o = n == null ? void 0 : n()) {
      this.id = zA++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, fo && (ws.totalNodes = ws.resolvedTargetDeltas = ws.recalculatedProjection = 0), this.nodes.forEach(GA), this.nodes.forEach(ZA), this.nodes.forEach(eO), this.nodes.forEach(WA), fo && window.MotionDebug.record(ws);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = r, this.root = o ? o.root || o : this, this.path = o ? [...o.path, o] : [], this.parent = o, this.depth = o ? o.depth + 1 : 0;
      for (let d = 0; d < this.path.length; d++)
        this.path[d].shouldResetTransform = !0;
      this.root === this && (this.nodes = new jA());
    }
    addEventListener(r, o) {
      return this.eventHandlers.has(r) || this.eventHandlers.set(r, new Zf()), this.eventHandlers.get(r).add(o);
    }
    notifyListeners(r, ...o) {
      const d = this.eventHandlers.get(r);
      d && d.notify(...o);
    }
    hasListeners(r) {
      return this.eventHandlers.has(r);
    }
    /**
     * Lifecycles
     */
    mount(r, o = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = RA(r), this.instance = r;
      const { layoutId: d, layout: c, visualElement: u } = this.options;
      if (u && !u.current && u.mount(r), this.root.nodes.add(this), this.parent && this.parent.children.add(this), o && (c || d) && (this.isLayoutDirty = !0), e) {
        let k;
        const m = () => this.root.updateBlockedByResize = !1;
        e(r, () => {
          this.root.updateBlockedByResize = !0, k && k(), k = AA(m, 250), Ec.hasAnimatedSinceResize && (Ec.hasAnimatedSinceResize = !1, this.nodes.forEach($N));
        });
      }
      d && this.root.registerSharedNode(d, this), this.options.animate !== !1 && u && (d || c) && this.addEventListener("didUpdate", ({ delta: k, hasLayoutChanged: m, hasRelativeTargetChanged: f, layout: p }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const h = this.options.transition || u.getDefaultTransition() || lO, { onLayoutAnimationStart: N, onLayoutAnimationComplete: S } = u.getProps(), F = !this.targetLayout || !wy(this.targetLayout, p) || f, y = !m && f;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || y || m && (F || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(k, y);
          const x = {
            ...qf(h, "layout"),
            onPlay: N,
            onComplete: S
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (x.delay = 0, x.type = !1), this.startAnimation(x);
        } else
          m || $N(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = p;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const r = this.getStack();
      r && r.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, ql(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(nO), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: r } = this.options;
      return r && r.getProps().transformTemplate;
    }
    willUpdate(r = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Py(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const k = this.path[u];
        k.shouldResetTransform = !0, k.updateScroll("snapshot"), k.options.layoutRoot && k.willUpdate(!1);
      }
      const { layoutId: o, layout: d } = this.options;
      if (o === void 0 && !d)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), r && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(LN);
        return;
      }
      this.isUpdating || this.nodes.forEach(YA), this.isUpdating = !1, this.nodes.forEach(XA), this.nodes.forEach(BA), this.nodes.forEach(qA), this.clearAllSnapshots();
      const o = wa.now();
      zi.delta = tl(0, 1e3 / 60, o - zi.timestamp), zi.timestamp = o, zi.isProcessing = !0, c0.update.process(zi), c0.preRender.process(zi), c0.render.process(zi), zi.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, _f.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(KA), this.sharedNodes.forEach(iO);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Yn.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Yn.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let d = 0; d < this.path.length; d++)
          this.path[d].updateScroll();
      const r = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Si(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: o } = this.options;
      o && o.notify("LayoutMeasure", this.layout.layoutBox, r ? r.layoutBox : void 0);
    }
    updateScroll(r = "measure") {
      let o = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === r && (o = !1), o) {
        const d = t(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: r,
          isRoot: d,
          offset: i(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : d
        };
      }
    }
    resetTransform() {
      if (!a)
        return;
      const r = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, o = this.projectionDelta && !Dy(this.projectionDelta), d = this.getTransformTemplate(), c = d ? d(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      r && (o || Ds(this.latestValues) || u) && (a(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(r = !0) {
      const o = this.measurePageBox();
      let d = this.removeElementScroll(o);
      return r && (d = this.removeTransform(d)), sO(d), {
        animationId: this.root.animationId,
        measuredBox: o,
        layoutBox: d,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var r;
      const { visualElement: o } = this.options;
      if (!o)
        return Si();
      const d = o.measureViewportBox();
      if (!(((r = this.scroll) === null || r === void 0 ? void 0 : r.wasRoot) || this.path.some(rO))) {
        const { scroll: u } = this.root;
        u && (j1(d.x, u.offset.x), j1(d.y, u.offset.y));
      }
      return d;
    }
    removeElementScroll(r) {
      var o;
      const d = Si();
      if (Jt(d, r), !((o = this.scroll) === null || o === void 0) && o.wasRoot)
        return d;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: k, options: m } = u;
        u !== this.root && k && m.layoutScroll && (k.wasRoot && Jt(d, r), j1(d.x, k.offset.x), j1(d.y, k.offset.y));
      }
      return d;
    }
    applyTransform(r, o = !1) {
      const d = Si();
      Jt(d, r);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        !o && u.options.layoutScroll && u.scroll && u !== u.root && A1(d, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), Ds(u.latestValues) && A1(d, u.latestValues);
      }
      return Ds(this.latestValues) && A1(d, this.latestValues), d;
    }
    removeTransform(r) {
      const o = Si();
      Jt(o, r);
      for (let d = 0; d < this.path.length; d++) {
        const c = this.path[d];
        if (!c.instance || !Ds(c.latestValues))
          continue;
        H3(c.latestValues) && c.updateSnapshot();
        const u = Si(), k = c.measurePageBox();
        Jt(u, k), AN(o, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, u);
      }
      return Ds(this.latestValues) && AN(o, this.latestValues), o;
    }
    setTargetDelta(r) {
      this.targetDelta = r, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(r) {
      this.options = {
        ...this.options,
        ...r,
        crossfade: r.crossfade !== void 0 ? r.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== zi.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(r = !1) {
      var o;
      const d = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = d.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = d.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = d.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== d;
      if (!(r || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: k, layoutId: m } = this.options;
      if (!(!this.layout || !(k || m))) {
        if (this.resolvedRelativeTargetAt = zi.timestamp, !this.targetDelta && !this.relativeTarget) {
          const f = this.getClosestProjectingParent();
          f && f.layout && this.animationProgress !== 1 ? (this.relativeParent = f, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Si(), this.relativeTargetOrigin = Si(), bo(this.relativeTargetOrigin, this.layout.layoutBox, f.layout.layoutBox), Jt(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = Si(), this.targetWithTransforms = Si()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), cA(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Jt(this.target, this.layout.layoutBox), Fy(this.target, this.targetDelta)) : Jt(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const f = this.getClosestProjectingParent();
            f && !!f.resumingFrom == !!this.resumingFrom && !f.options.layoutScroll && f.target && this.animationProgress !== 1 ? (this.relativeParent = f, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Si(), this.relativeTargetOrigin = Si(), bo(this.relativeTargetOrigin, this.target, f.target), Jt(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          fo && ws.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || H3(this.parent.latestValues) || gy(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var r;
      const o = this.getLead(), d = !!this.resumingFrom || this !== o;
      let c = !0;
      if ((this.isProjectionDirty || !((r = this.parent) === null || r === void 0) && r.isProjectionDirty) && (c = !1), d && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === zi.timestamp && (c = !1), c)
        return;
      const { layout: u, layoutId: k } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || k))
        return;
      Jt(this.layoutCorrected, this.layout.layoutBox);
      const m = this.treeScale.x, f = this.treeScale.y;
      SA(this.layoutCorrected, this.treeScale, this.path, d), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = Si());
      const { target: p } = o;
      if (!p) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (RN(this.prevProjectionDelta.x, this.projectionDelta.x), RN(this.prevProjectionDelta.y, this.projectionDelta.y)), yo(this.projectionDelta, this.layoutCorrected, p, this.latestValues), (this.treeScale.x !== m || this.treeScale.y !== f || !QN(this.projectionDelta.x, this.prevProjectionDelta.x) || !QN(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", p)), fo && ws.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(r = !0) {
      var o;
      if ((o = this.options.visualElement) === null || o === void 0 || o.scheduleRender(), r) {
        const d = this.getStack();
        d && d.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = T1(), this.projectionDelta = T1(), this.projectionDeltaWithTransform = T1();
    }
    setAnimationOrigin(r, o = !1) {
      const d = this.snapshot, c = d ? d.latestValues : {}, u = { ...this.latestValues }, k = T1();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !o;
      const m = Si(), f = d ? d.source : void 0, p = this.layout ? this.layout.source : void 0, h = f !== p, N = this.getStack(), S = !N || N.members.length <= 1, F = !!(h && !S && this.options.crossfade === !0 && !this.path.some(aO));
      this.animationProgress = 0;
      let y;
      this.mixTargetDelta = (x) => {
        const R = x / 1e3;
        UN(k.x, r.x, R), UN(k.y, r.y, R), this.setTargetDelta(k), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (bo(m, this.layout.layoutBox, this.relativeParent.layout.layoutBox), tO(this.relativeTarget, this.relativeTargetOrigin, m, R), y && $A(this.relativeTarget, y) && (this.isProjectionDirty = !1), y || (y = Si()), Jt(y, this.relativeTarget)), h && (this.animationValues = u, EA(u, c, this.latestValues, R, F, S)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = R;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(r) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (ql(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Yn.update(() => {
        Ec.hasAnimatedSinceResize = !0, this.currentAnimation = PA(0, MN, {
          ...r,
          onUpdate: (o) => {
            this.mixTargetDelta(o), r.onUpdate && r.onUpdate(o);
          },
          onComplete: () => {
            r.onComplete && r.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const r = this.getStack();
      r && r.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(MN), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const r = this.getLead();
      let { targetWithTransforms: o, target: d, layout: c, latestValues: u } = r;
      if (!(!o || !d || !c)) {
        if (this !== r && this.layout && c && Ty(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          d = this.target || Si();
          const k = jt(this.layout.layoutBox.x);
          d.x.min = r.target.x.min, d.x.max = d.x.min + k;
          const m = jt(this.layout.layoutBox.y);
          d.y.min = r.target.y.min, d.y.max = d.y.min + m;
        }
        Jt(o, d), A1(o, u), yo(this.projectionDeltaWithTransform, this.layoutCorrected, o, u);
      }
    }
    registerSharedNode(r, o) {
      this.sharedNodes.has(r) || this.sharedNodes.set(r, new UA()), this.sharedNodes.get(r).add(o);
      const c = o.options.initialPromotionConfig;
      o.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(o) : void 0
      });
    }
    isLead() {
      const r = this.getStack();
      return r ? r.lead === this : !0;
    }
    getLead() {
      var r;
      const { layoutId: o } = this.options;
      return o ? ((r = this.getStack()) === null || r === void 0 ? void 0 : r.lead) || this : this;
    }
    getPrevLead() {
      var r;
      const { layoutId: o } = this.options;
      return o ? (r = this.getStack()) === null || r === void 0 ? void 0 : r.prevLead : void 0;
    }
    getStack() {
      const { layoutId: r } = this.options;
      if (r)
        return this.root.sharedNodes.get(r);
    }
    promote({ needsReset: r, transition: o, preserveFollowOpacity: d } = {}) {
      const c = this.getStack();
      c && c.promote(this, d), r && (this.projectionDelta = void 0, this.needsReset = !0), o && this.setOptions({ transition: o });
    }
    relegate() {
      const r = this.getStack();
      return r ? r.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: r } = this.options;
      if (!r)
        return;
      let o = !1;
      const { latestValues: d } = r;
      if ((d.z || d.rotate || d.rotateX || d.rotateY || d.rotateZ || d.skewX || d.skewY) && (o = !0), !o)
        return;
      const c = {};
      d.z && g0("z", r, c, this.animationValues);
      for (let u = 0; u < S0.length; u++)
        g0(`rotate${S0[u]}`, r, c, this.animationValues), g0(`skew${S0[u]}`, r, c, this.animationValues);
      r.render();
      for (const u in c)
        r.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      r.scheduleRender();
    }
    getProjectionStyles(r) {
      var o, d;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return HA;
      const c = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = Ac(r == null ? void 0 : r.pointerEvents) || "", c.transform = u ? u(this.latestValues, "") : "none", c;
      const k = this.getLead();
      if (!this.projectionDelta || !this.layout || !k.target) {
        const h = {};
        return this.options.layoutId && (h.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, h.pointerEvents = Ac(r == null ? void 0 : r.pointerEvents) || ""), this.hasProjected && !Ds(this.latestValues) && (h.transform = u ? u({}, "") : "none", this.hasProjected = !1), h;
      }
      const m = k.animationValues || k.latestValues;
      this.applyTransformsToTarget(), c.transform = VA(this.projectionDeltaWithTransform, this.treeScale, m), u && (c.transform = u(m, c.transform));
      const { x: f, y: p } = this.projectionDelta;
      c.transformOrigin = `${f.origin * 100}% ${p.origin * 100}% 0`, k.animationValues ? c.opacity = k === this ? (d = (o = m.opacity) !== null && o !== void 0 ? o : this.latestValues.opacity) !== null && d !== void 0 ? d : 1 : this.preserveOpacity ? this.latestValues.opacity : m.opacityExit : c.opacity = k === this ? m.opacity !== void 0 ? m.opacity : "" : m.opacityExit !== void 0 ? m.opacityExit : 0;
      for (const h in ru) {
        if (m[h] === void 0)
          continue;
        const { correct: N, applyTo: S } = ru[h], F = c.transform === "none" ? m[h] : N(m[h], k);
        if (S) {
          const y = S.length;
          for (let x = 0; x < y; x++)
            c[S[x]] = F;
        } else
          c[h] = F;
      }
      return this.options.layoutId && (c.pointerEvents = k === this ? Ac(r == null ? void 0 : r.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((r) => {
        var o;
        return (o = r.currentAnimation) === null || o === void 0 ? void 0 : o.stop();
      }), this.root.nodes.forEach(LN), this.root.sharedNodes.clear();
    }
  };
}
function BA(e) {
  e.updateLayout();
}
function qA(e) {
  var n;
  const i = ((n = e.resumeFrom) === null || n === void 0 ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && i && e.hasListeners("didUpdate")) {
    const { layoutBox: t, measuredBox: a } = e.layout, { animationType: s } = e.options, r = i.source !== e.layout.source;
    s === "size" ? _t((k) => {
      const m = r ? i.measuredBox[k] : i.layoutBox[k], f = jt(m);
      m.min = t[k].min, m.max = m.min + f;
    }) : Ty(s, i.layoutBox, t) && _t((k) => {
      const m = r ? i.measuredBox[k] : i.layoutBox[k], f = jt(t[k]);
      m.max = m.min + f, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[k].max = e.relativeTarget[k].min + f);
    });
    const o = T1();
    yo(o, t, i.layoutBox);
    const d = T1();
    r ? yo(d, e.applyTransform(a, !0), i.measuredBox) : yo(d, t, i.layoutBox);
    const c = !Dy(o);
    let u = !1;
    if (!e.resumeFrom) {
      const k = e.getClosestProjectingParent();
      if (k && !k.resumeFrom) {
        const { snapshot: m, layout: f } = k;
        if (m && f) {
          const p = Si();
          bo(p, i.layoutBox, m.layoutBox);
          const h = Si();
          bo(h, t, f.layoutBox), wy(p, h) || (u = !0), k.options.layoutRoot && (e.relativeTarget = h, e.relativeTargetOrigin = p, e.relativeParent = k);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: t,
      snapshot: i,
      delta: d,
      layoutDelta: o,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: t } = e.options;
    t && t();
  }
  e.options.transition = void 0;
}
function GA(e) {
  fo && ws.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function WA(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function KA(e) {
  e.clearSnapshot();
}
function LN(e) {
  e.clearMeasurements();
}
function YA(e) {
  e.isLayoutDirty = !1;
}
function XA(e) {
  const { visualElement: n } = e.options;
  n && n.getProps().onBeforeLayoutMeasure && n.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function $N(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function ZA(e) {
  e.resolveTargetDelta();
}
function eO(e) {
  e.calcProjection();
}
function nO(e) {
  e.resetSkewAndRotation();
}
function iO(e) {
  e.removeLeadSnapshot();
}
function UN(e, n, i) {
  e.translate = di(n.translate, 0, i), e.scale = di(n.scale, 1, i), e.origin = n.origin, e.originPoint = n.originPoint;
}
function VN(e, n, i, t) {
  e.min = di(n.min, i.min, t), e.max = di(n.max, i.max, t);
}
function tO(e, n, i, t) {
  VN(e.x, n.x, i.x, t), VN(e.y, n.y, i.y, t);
}
function aO(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const lO = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, HN = (e) => typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), zN = HN("applewebkit/") && !HN("chrome/") ? Math.round : St;
function BN(e) {
  e.min = zN(e.min), e.max = zN(e.max);
}
function sO(e) {
  BN(e.x), BN(e.y);
}
function Ty(e, n, i) {
  return e === "position" || e === "preserve-aspect" && !dA(_N(n), _N(i), 0.2);
}
function rO(e) {
  var n;
  return e !== e.root && ((n = e.scroll) === null || n === void 0 ? void 0 : n.wasRoot);
}
const oO = Ry({
  attachResizeListener: (e, n) => _o(e, "resize", n),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), F0 = {
  current: void 0
}, jy = Ry({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!F0.current) {
      const e = new oO({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), F0.current = e;
    }
    return F0.current;
  },
  resetTransform: (e, n) => {
    e.style.transform = n !== void 0 ? n : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), dO = {
  pan: {
    Feature: CA
  },
  drag: {
    Feature: bA,
    ProjectionNode: jy,
    MeasureLayout: by
  }
};
function qN(e, n, i) {
  const { props: t } = e;
  e.animationState && t.whileHover && e.animationState.setActive("whileHover", i === "Start");
  const a = "onHover" + i, s = t[a];
  s && Yn.postRender(() => s(n, md(n)));
}
class cO extends ss {
  mount() {
    const { current: n } = this.node;
    n && (this.unmount = dT(n, (i) => (qN(this.node, i, "Start"), (t) => qN(this.node, t, "End"))));
  }
  unmount() {
  }
}
class uO extends ss {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let n = !1;
    try {
      n = this.node.current.matches(":focus-visible");
    } catch (i) {
      n = !0;
    }
    !n || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = ud(_o(this.node.current, "focus", () => this.onFocus()), _o(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function GN(e, n, i) {
  const { props: t } = e;
  e.animationState && t.whileTap && e.animationState.setActive("whileTap", i === "Start");
  const a = "onTap" + (i === "End" ? "" : i), s = t[a];
  s && Yn.postRender(() => s(n, md(n)));
}
class mO extends ss {
  mount() {
    const { current: n } = this.node;
    n && (this.unmount = kT(n, (i) => (GN(this.node, i, "Start"), (t, { success: a }) => GN(this.node, t, a ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const B3 = /* @__PURE__ */ new WeakMap(), I0 = /* @__PURE__ */ new WeakMap(), kO = (e) => {
  const n = B3.get(e.target);
  n && n(e);
}, fO = (e) => {
  e.forEach(kO);
};
function vO({ root: e, ...n }) {
  const i = e || document;
  I0.has(i) || I0.set(i, {});
  const t = I0.get(i), a = JSON.stringify(n);
  return t[a] || (t[a] = new IntersectionObserver(fO, { root: e, ...n })), t[a];
}
function hO(e, n, i) {
  const t = vO(n);
  return B3.set(e, i), t.observe(e), () => {
    B3.delete(e), t.unobserve(e);
  };
}
const pO = {
  some: 0,
  all: 1
};
class NO extends ss {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: n = {} } = this.node.getProps(), { root: i, margin: t, amount: a = "some", once: s } = n, r = {
      root: i ? i.current : void 0,
      rootMargin: t,
      threshold: typeof a == "number" ? a : pO[a]
    }, o = (d) => {
      const { isIntersecting: c } = d;
      if (this.isInView === c || (this.isInView = c, s && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: k } = this.node.getProps(), m = c ? u : k;
      m && m(d);
    };
    return hO(this.node.current, r, o);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver == "undefined")
      return;
    const { props: n, prevProps: i } = this.node;
    ["amount", "margin", "root"].some(SO(n, i)) && this.startObserver();
  }
  unmount() {
  }
}
function SO({ viewport: e = {} }, { viewport: n = {} } = {}) {
  return (i) => e[i] !== n[i];
}
const gO = {
  inView: {
    Feature: NO
  },
  tap: {
    Feature: mO
  },
  focus: {
    Feature: uO
  },
  hover: {
    Feature: cO
  }
}, FO = {
  layout: {
    ProjectionNode: jy,
    MeasureLayout: by
  }
}, q3 = { current: null }, Ay = { current: !1 };
function IO() {
  if (Ay.current = !0, !!jf)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), n = () => q3.current = e.matches;
      e.addListener(n), n();
    } else
      q3.current = !1;
}
const yO = [...ay, Yi, Gl], bO = (e) => yO.find(ty(e)), WN = /* @__PURE__ */ new WeakMap();
function CO(e, n, i) {
  for (const t in n) {
    const a = n[t], s = i[t];
    if (et(a))
      e.addValue(t, a), process.env.NODE_ENV === "development" && om(a.version === "11.18.2", `Attempting to mix Motion versions ${a.version} with 11.18.2 may not work as expected.`);
    else if (et(s))
      e.addValue(t, Eo(a, { owner: e }));
    else if (s !== a)
      if (e.hasValue(t)) {
        const r = e.getValue(t);
        r.liveStyle === !0 ? r.jump(a) : r.hasAnimated || r.set(a);
      } else {
        const r = e.getStaticValue(t);
        e.addValue(t, Eo(r !== void 0 ? r : a, { owner: e }));
      }
  }
  for (const t in i)
    n[t] === void 0 && e.removeValue(t);
  return n;
}
const KN = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class xO {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(n, i, t) {
    return {};
  }
  constructor({ parent: n, props: i, presenceContext: t, reducedMotionConfig: a, blockInitialAnimation: s, visualState: r }, o = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = lv, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const f = wa.now();
      this.renderScheduledAt < f && (this.renderScheduledAt = f, Yn.render(this.render, !1, !0));
    };
    const { latestValues: d, renderState: c, onUpdate: u } = r;
    this.onUpdate = u, this.latestValues = d, this.baseTarget = { ...d }, this.initialValues = i.initial ? { ...d } : {}, this.renderState = c, this.parent = n, this.props = i, this.presenceContext = t, this.depth = n ? n.depth + 1 : 0, this.reducedMotionConfig = a, this.options = o, this.blockInitialAnimation = !!s, this.isControllingVariants = um(i), this.isVariantNode = mI(i), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(n && n.current);
    const { willChange: k, ...m } = this.scrapeMotionValuesFromProps(i, {}, this);
    for (const f in m) {
      const p = m[f];
      d[f] !== void 0 && et(p) && p.set(d[f], !1);
    }
  }
  mount(n) {
    this.current = n, WN.set(n, this), this.projection && !this.projection.instance && this.projection.mount(n), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((i, t) => this.bindToMotionValue(t, i)), Ay.current || IO(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : q3.current, process.env.NODE_ENV !== "production" && om(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    WN.delete(this.current), this.projection && this.projection.unmount(), ql(this.notifyUpdate), ql(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const i = this.features[n];
      i && (i.unmount(), i.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(n, i) {
    this.valueSubscriptions.has(n) && this.valueSubscriptions.get(n)();
    const t = e1.has(n), a = i.on("change", (o) => {
      this.latestValues[n] = o, this.props.onUpdate && Yn.preRender(this.notifyUpdate), t && this.projection && (this.projection.isTransformDirty = !0);
    }), s = i.on("renderRequest", this.scheduleRender);
    let r;
    window.MotionCheckAppearSync && (r = window.MotionCheckAppearSync(this, n, i)), this.valueSubscriptions.set(n, () => {
      a(), s(), r && r(), i.owner && i.stop();
    });
  }
  sortNodePosition(n) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== n.type ? 0 : this.sortInstanceNodePosition(this.current, n.current);
  }
  updateFeatures() {
    let n = "animation";
    for (n in G1) {
      const i = G1[n];
      if (!i)
        continue;
      const { isEnabled: t, Feature: a } = i;
      if (!this.features[n] && a && t(this.props) && (this.features[n] = new a(this)), this.features[n]) {
        const s = this.features[n];
        s.isMounted ? s.update() : (s.mount(), s.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Si();
  }
  getStaticValue(n) {
    return this.latestValues[n];
  }
  setStaticValue(n, i) {
    this.latestValues[n] = i;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(n, i) {
    (n.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = n, this.prevPresenceContext = this.presenceContext, this.presenceContext = i;
    for (let t = 0; t < KN.length; t++) {
      const a = KN[t];
      this.propEventSubscriptions[a] && (this.propEventSubscriptions[a](), delete this.propEventSubscriptions[a]);
      const s = "on" + a, r = n[s];
      r && (this.propEventSubscriptions[a] = this.on(a, r));
    }
    this.prevMotionValues = CO(this, this.scrapeMotionValuesFromProps(n, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue(), this.onUpdate && this.onUpdate(this);
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(n) {
    return this.props.variants ? this.props.variants[n] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(n) {
    const i = this.getClosestVariantNode();
    if (i)
      return i.variantChildren && i.variantChildren.add(n), () => i.variantChildren.delete(n);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(n, i) {
    const t = this.values.get(n);
    i !== t && (t && this.removeValue(n), this.bindToMotionValue(n, i), this.values.set(n, i), this.latestValues[n] = i.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(n) {
    this.values.delete(n);
    const i = this.valueSubscriptions.get(n);
    i && (i(), this.valueSubscriptions.delete(n)), delete this.latestValues[n], this.removeValueFromRenderState(n, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(n) {
    return this.values.has(n);
  }
  getValue(n, i) {
    if (this.props.values && this.props.values[n])
      return this.props.values[n];
    let t = this.values.get(n);
    return t === void 0 && i !== void 0 && (t = Eo(i === null ? void 0 : i, { owner: this }), this.addValue(n, t)), t;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(n, i) {
    var t;
    let a = this.latestValues[n] !== void 0 || !this.current ? this.latestValues[n] : (t = this.getBaseTargetFromProps(this.props, n)) !== null && t !== void 0 ? t : this.readValueFromInstance(this.current, n, this.options);
    return a != null && (typeof a == "string" && (ny(a) || BI(a)) ? a = parseFloat(a) : !bO(a) && Gl.test(i) && (a = XI(n, i)), this.setBaseTarget(n, et(a) ? a.get() : a)), et(a) ? a.get() : a;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(n, i) {
    this.baseTarget[n] = i;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(n) {
    var i;
    const { initial: t } = this.props;
    let a;
    if (typeof t == "string" || typeof t == "object") {
      const r = Mf(this.props, t, (i = this.presenceContext) === null || i === void 0 ? void 0 : i.custom);
      r && (a = r[n]);
    }
    if (t && a !== void 0)
      return a;
    const s = this.getBaseTargetFromProps(this.props, n);
    return s !== void 0 && !et(s) ? s : this.initialValues[n] !== void 0 && a === void 0 ? void 0 : this.baseTarget[n];
  }
  on(n, i) {
    return this.events[n] || (this.events[n] = new Zf()), this.events[n].add(i);
  }
  notify(n, ...i) {
    this.events[n] && this.events[n].notify(...i);
  }
}
class Oy extends xO {
  constructor() {
    super(...arguments), this.KeyframeResolver = ly;
  }
  sortInstanceNodePosition(n, i) {
    return n.compareDocumentPosition(i) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(n, i) {
    return n.style ? n.style[i] : void 0;
  }
  removeValueFromRenderState(n, { vars: i, style: t }) {
    delete i[n], delete t[n];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: n } = this.props;
    et(n) && (this.childSubscription = n.on("change", (i) => {
      this.current && (this.current.textContent = `${i}`);
    }));
  }
}
function DO(e) {
  return window.getComputedStyle(e);
}
class wO extends Oy {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = FI;
  }
  readValueFromInstance(n, i) {
    if (e1.has(i)) {
      const t = av(i);
      return t && t.default || 0;
    } else {
      const t = DO(n), a = (NI(i) ? t.getPropertyValue(i) : t[i]) || 0;
      return typeof a == "string" ? a.trim() : a;
    }
  }
  measureInstanceViewportBox(n, { transformPagePoint: i }) {
    return Iy(n, i);
  }
  build(n, i, t) {
    Uf(n, i, t.transformTemplate);
  }
  scrapeMotionValuesFromProps(n, i, t) {
    return Bf(n, i, t);
  }
}
class PO extends Oy {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = Si;
  }
  getBaseTargetFromProps(n, i) {
    return n[i];
  }
  readValueFromInstance(n, i) {
    if (e1.has(i)) {
      const t = av(i);
      return t && t.default || 0;
    }
    return i = II.has(i) ? i : Jf(i), n.getAttribute(i);
  }
  scrapeMotionValuesFromProps(n, i, t) {
    return CI(n, i, t);
  }
  build(n, i, t) {
    Vf(n, i, this.isSVGTag, t.transformTemplate);
  }
  renderInstance(n, i, t, a) {
    yI(n, i, t, a);
  }
  mount(n) {
    this.isSVGTag = zf(n.tagName), super.mount(n);
  }
}
const RO = (e, n) => Qf(e) ? new PO(n) : new wO(n, {
  allowProjection: e !== Xs
}), TO = /* @__PURE__ */ iT({
  ...eA,
  ...gO,
  ...dO,
  ...FO
}, RO), jO = /* @__PURE__ */ pR(TO), rs = ({ className: e, initial: n, animate: i, exit: t, slideUp: a, children: s }) => {
  const r = ul();
  return /* @__PURE__ */ l.jsx(dR, { children: a ? /* @__PURE__ */ l.jsx(
    jO.div,
    {
      className: ce(e),
      initial: n,
      animate: i,
      exit: t,
      children: s
    },
    r
  ) : null });
};
rs.displayName = "SlideUp";
const Ey = (e) => () => ({
  kind: "Errored",
  lang: e.lang,
  articleUrl: e.articleUrl
}), AO = (e) => ({
  kind: "Initialize",
  articleUrl: e.articleUrl
}), Jy = (e) => () => ({
  kind: "Initialized",
  articleHtml: e.articleHtml
}), OO = /(<img\b[^>]*?\ssrc\s*=\s*)(["'])(.*?)\2/gis, EO = ["jpg", "jpeg", "png"], JO = (e) => {
  const n = e.lastIndexOf(".");
  return n === -1 || n < e.lastIndexOf("/") ? !1 : EO.includes(e.slice(n + 1).toLowerCase());
}, _O = (e) => !e.startsWith("public/") || e.includes("..") || e.includes("//") ? !1 : !/[\u0000-\u001f\u007f]/.test(e), QO = (e, n) => {
  if (e.includes("?") || e.includes("#"))
    return;
  const i = e.replace(/^(?:https?:)?\/\//i, "");
  if (i.startsWith(`${n}/`))
    try {
      return decodeURIComponent(i.slice(n.length + 1));
    } catch (t) {
      return;
    }
};
function MO(e, n) {
  let i;
  try {
    i = new URL(n);
  } catch (t) {
    return e;
  }
  return e.replace(OO, (t, a, s, r) => {
    const o = QO(r.trim(), i.host);
    if (o === void 0 || !JO(o) || !_O(o))
      return t;
    const d = o.split("/").map(encodeURIComponent).join("/");
    return `${a}${s}${i.origin}/_img/${d}${s}`;
  });
}
const LO = (e) => e.replace(/<p><\/p>/g, "<p><br/></p>").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/d3bh749m5kndq3.cloudfront.net/g, "prd-assets.chillnn.com").replace(/d1hqi8w8ce2qmn.cloudfront.net/g, "dev-assets.chillnn.com");
async function _y(e) {
  const i = await (await fetch(e)).text();
  return MO(LO(i), e);
}
const $O = (e) => {
  const n = Ye(!1);
  be(() => {
    var i;
    n.current || e.state.kind !== "Initialize" || _y((i = e.state.articleUrl) != null ? i : "").then((t) => {
      if (e.state.kind === "Initialize") {
        const a = Jy({ articleHtml: t })(e.state);
        e.onChangeState(a);
      }
    }).catch(() => {
      if (e.state.kind === "Initialize") {
        const t = Ey(e.erroredInputContext)(e.state);
        e.onChangeState(t);
      }
    });
  }, [e]);
}, UO = (e) => ({
  onRefetch: I(
    (i) => async () => {
      var t;
      try {
        const a = await _y((t = e.erroredInputContext.articleUrl) != null ? t : ""), s = Jy({ articleHtml: a })(i);
        e.onChangeState(s);
      } catch (a) {
        const s = Ey(e.erroredInputContext)(i);
        throw e.onChangeState(s), a;
      }
    },
    [e]
  )
}), VO = (e) => {
  const [n, i] = se(AO(e)), t = I((s) => {
    i(s);
  }, []);
  $O({ state: n, onChangeState: t, erroredInputContext: e });
  const { onRefetch: a } = UO({ onChangeState: t, erroredInputContext: e });
  return {
    state: n,
    onRefetch: a
  };
}, HO = (e) => {
  const n = I(async () => {
    await e.onRefetch();
  }, [e]), i = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: n, children: i });
}, zO = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "データを正しく取得できませんでした。" : "Failed to fetch data.", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, BO = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-py-8 ch-text-center", children: [
  /* @__PURE__ */ l.jsx(zO, { lang: e.state.lang }),
  /* @__PURE__ */ l.jsx(HO, { lang: e.state.lang, onRefetch: e.onRefetch })
] })), qO = g(() => /* @__PURE__ */ l.jsx("div", { className: "ch-w-full", children: /* @__PURE__ */ l.jsx("div", { className: "ch-h-40 ch-w-full ch-animate-pulse ch-rounded-md ch-bg-gray-200" }) })), GO = g((e) => /* @__PURE__ */ l.jsx(
  "article",
  {
    dangerouslySetInnerHTML: { __html: Kq(e.state.articleHtml) },
    className: "prose"
  }
)), fm = g((e) => {
  const { state: n, onRefetch: i } = VO(e);
  switch (n.kind) {
    case "Initialized":
      return /* @__PURE__ */ l.jsx(GO, { state: n });
    case "Errored":
      return /* @__PURE__ */ l.jsx(BO, { state: n, onRefetch: i(n) });
    default:
      return /* @__PURE__ */ l.jsx(qO, {});
  }
});
var WO = Symbol.for("react.lazy"), ku = w[" use ".trim().toString()];
function KO(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function Qy(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === WO && "_payload" in e && KO(e._payload);
}
// @__NO_SIDE_EFFECTS__
function My(e) {
  const n = /* @__PURE__ */ XO(e), i = w.forwardRef((t, a) => {
    let { children: s, ...r } = t;
    Qy(s) && typeof ku == "function" && (s = ku(s._payload));
    const o = w.Children.toArray(s), d = o.find(eE);
    if (d) {
      const c = d.props.children, u = o.map((k) => k === d ? w.Children.count(c) > 1 ? w.Children.only(null) : w.isValidElement(c) ? c.props.children : null : k);
      return /* @__PURE__ */ l.jsx(n, { ...r, ref: a, children: w.isValidElement(c) ? w.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ l.jsx(n, { ...r, ref: a, children: s });
  });
  return i.displayName = `${e}.Slot`, i;
}
var YO = /* @__PURE__ */ My("Slot");
// @__NO_SIDE_EFFECTS__
function XO(e) {
  const n = w.forwardRef((i, t) => {
    let { children: a, ...s } = i;
    if (Qy(a) && typeof ku == "function" && (a = ku(a._payload)), w.isValidElement(a)) {
      const r = iE(a), o = nE(s, a.props);
      return a.type !== w.Fragment && (o.ref = t ? Sf(t, r) : r), w.cloneElement(a, o);
    }
    return w.Children.count(a) > 1 ? w.Children.only(null) : null;
  });
  return n.displayName = `${e}.SlotClone`, n;
}
var ZO = Symbol("radix.slottable");
function eE(e) {
  return w.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === ZO;
}
function nE(e, n) {
  const i = { ...n };
  for (const t in n) {
    const a = e[t], s = n[t];
    /^on[A-Z]/.test(t) ? a && s ? i[t] = (...o) => {
      const d = s(...o);
      return a(...o), d;
    } : a && (i[t] = a) : t === "style" ? i[t] = { ...a, ...s } : t === "className" && (i[t] = [a, s].filter(Boolean).join(" "));
  }
  return { ...e, ...i };
}
function iE(e) {
  var t, a;
  let n = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, i = n && "isReactWarning" in n && n.isReactWarning;
  return i ? e.ref : (n = (a = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : a.get, i = n && "isReactWarning" in n && n.isReactWarning, i ? e.props.ref : e.props.ref || e.ref);
}
const tE = Df(
  "ch-inline-flex ch-shrink-0 ch-items-center ch-justify-center ch-whitespace-nowrap ch-ring-offset-white ch-transition-colors ch-duration-200 ch-ease-in focus-visible:ch-outline-none focus-visible:ch-ring-2 focus-visible:ch-ring-focus-600 focus-visible:ch-ring-offset-2 disabled:ch-pointer-events-none",
  {
    variants: {
      variant: {
        default: "ch-bg-primary ch-text-white hover:ch-opacity-70 disabled:ch-bg-gray-300 disabled:ch-text-gray-400",
        minimal: "ch-rounded-md ch-bg-transparent ch-text-black hover:ch-bg-gray-100 disabled:ch-text-gray-300",
        float: "ch-bg-transparent ch-text-black ch-opacity-90 ch-backdrop-blur-xl hover:ch-text-gray-400 disabled:ch-text-gray-300",
        outline: "ch-border ch-border-black ch-bg-white hover:ch-border-gray-400 hover:ch-text-gray-400 disabled:ch-border-gray-300 disabled:ch-text-gray-300",
        underline: "ch-text-black ch-underline ch-underline-offset-4 hover:ch-text-gray-400 disabled:ch-text-gray-300",
        link: "ch-text-black ch-underline-offset-4 hover:ch-underline disabled:ch-text-gray-300",
        icon: "ch-h-4 ch-w-4 ch-bg-white ch-text-black hover:ch-bg-zinc-100 disabled:ch-text-gray-300"
      },
      size: {
        default: "ch-rounded-lg ch-px-[18px] ch-py-3 ch-text-sm ch-font-semibold ch-leading-5",
        xs: "ch-rounded-md ch-px-1.5 ch-py-1 ch-text-xs ch-font-semibold ch-leading-4",
        sm: "ch-rounded-lg ch-px-3.5 ch-py-2.5 ch-text-sm ch-font-semibold ch-leading-5",
        md: "ch-rounded-lg ch-px-[18px] ch-py-3 ch-text-base",
        icon: "ch-rounded-md ch-p-1"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), ae = w.forwardRef(
  ({ variant: e, size: n, type: i = "button", asChild: t = !1, className: a, ...s }, r) => {
    const o = t ? YO : "button";
    return /* @__PURE__ */ l.jsx(
      o,
      {
        type: i,
        className: ce(tE({ variant: e, size: n }), a),
        ref: r,
        ...s
      }
    );
  }
);
ae.displayName = "Button";
const aE = Li(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  "div",
  {
    ref: i,
    className: ce("ch-bg-card ch-text-card-foreground ch-rounded-xl ch-border ch-shadow", e),
    ...n
  }
));
aE.displayName = "Card";
const lE = Li(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx("div", { ref: i, className: ce("ch-flex ch-flex-col ch-space-y-1.5 ch-p-6", e), ...n }));
lE.displayName = "CardHeader";
const sE = Li(
  ({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
    "h3",
    {
      ref: i,
      className: ce("ch-font-semibold ch-leading-none ch-tracking-tight", e),
      ...n
    }
  )
);
sE.displayName = "CardTitle";
const rE = Li(
  ({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx("p", { ref: i, className: ce("ch-text-muted-foreground ch-text-sm", e), ...n })
);
rE.displayName = "CardDescription";
const oE = Li(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx("div", { ref: i, className: ce("ch-p-6 ch-pt-0", e), ...n }));
oE.displayName = "CardContent";
const dE = Li(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx("div", { ref: i, className: ce("ch-flex ch-items-center ch-p-6 ch-pt-0", e), ...n }));
dE.displayName = "CardFooter";
function cE(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function YN(e) {
  return cE(e) || Array.isArray(e);
}
function uE() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
function dv(e, n) {
  const i = Object.keys(e), t = Object.keys(n);
  if (i.length !== t.length) return !1;
  const a = JSON.stringify(Object.keys(e.breakpoints || {})), s = JSON.stringify(Object.keys(n.breakpoints || {}));
  return a !== s ? !1 : i.every((r) => {
    const o = e[r], d = n[r];
    return typeof o == "function" ? `${o}` == `${d}` : !YN(o) || !YN(d) ? o === d : dv(o, d);
  });
}
function XN(e) {
  return e.concat().sort((n, i) => n.name > i.name ? 1 : -1).map((n) => n.options);
}
function mE(e, n) {
  if (e.length !== n.length) return !1;
  const i = XN(e), t = XN(n);
  return i.every((a, s) => {
    const r = t[s];
    return dv(a, r);
  });
}
function cv(e) {
  return typeof e == "number";
}
function G3(e) {
  return typeof e == "string";
}
function vm(e) {
  return typeof e == "boolean";
}
function ZN(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ci(e) {
  return Math.abs(e);
}
function uv(e) {
  return Math.sign(e);
}
function Co(e, n) {
  return ci(e - n);
}
function kE(e, n) {
  if (e === 0 || n === 0 || ci(e) <= ci(n)) return 0;
  const i = Co(ci(e), ci(n));
  return ci(i / e);
}
function fE(e) {
  return Math.round(e * 100) / 100;
}
function Qo(e) {
  return Mo(e).map(Number);
}
function ta(e) {
  return e[kd(e)];
}
function kd(e) {
  return Math.max(0, e.length - 1);
}
function mv(e, n) {
  return n === kd(e);
}
function e4(e, n = 0) {
  return Array.from(Array(e), (i, t) => n + t);
}
function Mo(e) {
  return Object.keys(e);
}
function Ly(e, n) {
  return [e, n].reduce((i, t) => (Mo(t).forEach((a) => {
    const s = i[a], r = t[a], o = ZN(s) && ZN(r);
    i[a] = o ? Ly(s, r) : r;
  }), i), {});
}
function W3(e, n) {
  return typeof n.MouseEvent != "undefined" && e instanceof n.MouseEvent;
}
function vE(e, n) {
  const i = {
    start: t,
    center: a,
    end: s
  };
  function t() {
    return 0;
  }
  function a(d) {
    return s(d) / 2;
  }
  function s(d) {
    return n - d;
  }
  function r(d, c) {
    return G3(e) ? i[e](d) : e(n, d, c);
  }
  return {
    measure: r
  };
}
function Lo() {
  let e = [];
  function n(a, s, r, o = {
    passive: !0
  }) {
    let d;
    if ("addEventListener" in a)
      a.addEventListener(s, r, o), d = () => a.removeEventListener(s, r, o);
    else {
      const c = a;
      c.addListener(r), d = () => c.removeListener(r);
    }
    return e.push(d), t;
  }
  function i() {
    e = e.filter((a) => a());
  }
  const t = {
    add: n,
    clear: i
  };
  return t;
}
function hE(e, n, i, t) {
  const a = Lo(), s = 1e3 / 60;
  let r = null, o = 0, d = 0;
  function c() {
    a.add(e, "visibilitychange", () => {
      e.hidden && p();
    });
  }
  function u() {
    f(), a.clear();
  }
  function k(N) {
    if (!d) return;
    r || (r = N, i(), i());
    const S = N - r;
    for (r = N, o += S; o >= s; )
      i(), o -= s;
    const F = o / s;
    t(F), d && (d = n.requestAnimationFrame(k));
  }
  function m() {
    d || (d = n.requestAnimationFrame(k));
  }
  function f() {
    n.cancelAnimationFrame(d), r = null, o = 0, d = 0;
  }
  function p() {
    r = null, o = 0;
  }
  return {
    init: c,
    destroy: u,
    start: m,
    stop: f,
    update: i,
    render: t
  };
}
function pE(e, n) {
  const i = n === "rtl", t = e === "y", a = t ? "y" : "x", s = t ? "x" : "y", r = !t && i ? -1 : 1, o = u(), d = k();
  function c(p) {
    const {
      height: h,
      width: N
    } = p;
    return t ? h : N;
  }
  function u() {
    return t ? "top" : i ? "right" : "left";
  }
  function k() {
    return t ? "bottom" : i ? "left" : "right";
  }
  function m(p) {
    return p * r;
  }
  return {
    scroll: a,
    cross: s,
    startEdge: o,
    endEdge: d,
    measureSize: c,
    direction: m
  };
}
function Us(e = 0, n = 0) {
  const i = ci(e - n);
  function t(c) {
    return c < e;
  }
  function a(c) {
    return c > n;
  }
  function s(c) {
    return t(c) || a(c);
  }
  function r(c) {
    return s(c) ? t(c) ? e : n : c;
  }
  function o(c) {
    return i ? c - i * Math.ceil((c - n) / i) : c;
  }
  return {
    length: i,
    max: n,
    min: e,
    constrain: r,
    reachedAny: s,
    reachedMax: a,
    reachedMin: t,
    removeOffset: o
  };
}
function $y(e, n, i) {
  const {
    constrain: t
  } = Us(0, e), a = e + 1;
  let s = r(n);
  function r(m) {
    return i ? ci((a + m) % a) : t(m);
  }
  function o() {
    return s;
  }
  function d(m) {
    return s = r(m), k;
  }
  function c(m) {
    return u().set(o() + m);
  }
  function u() {
    return $y(e, o(), i);
  }
  const k = {
    get: o,
    set: d,
    add: c,
    clone: u
  };
  return k;
}
function NE(e, n, i, t, a, s, r, o, d, c, u, k, m, f, p, h, N, S, F) {
  const {
    cross: y,
    direction: x
  } = e, R = ["INPUT", "SELECT", "TEXTAREA"], T = {
    passive: !1
  }, j = Lo(), A = Lo(), B = Us(50, 225).constrain(f.measure(20)), W = {
    mouse: 300,
    touch: 400
  }, E = {
    mouse: 500,
    touch: 600
  }, $ = p ? 43 : 25;
  let V = !1, H = 0, O = 0, M = !1, L = !1, _ = !1, z = !1;
  function ne(re) {
    if (!F) return;
    function Me(rn) {
      (vm(F) || F(re, rn)) && we(rn);
    }
    const ge = n;
    j.add(ge, "dragstart", (rn) => rn.preventDefault(), T).add(ge, "touchmove", () => {
    }, T).add(ge, "touchend", () => {
    }).add(ge, "touchstart", Me).add(ge, "mousedown", Me).add(ge, "touchcancel", De).add(ge, "contextmenu", De).add(ge, "click", _e, !0);
  }
  function Se() {
    j.clear(), A.clear();
  }
  function he() {
    const re = z ? i : n;
    A.add(re, "touchmove", ie, T).add(re, "touchend", De).add(re, "mousemove", ie, T).add(re, "mouseup", De);
  }
  function ue(re) {
    const Me = re.nodeName || "";
    return R.includes(Me);
  }
  function oe() {
    return (p ? E : W)[z ? "mouse" : "touch"];
  }
  function $e(re, Me) {
    const ge = k.add(uv(re) * -1), rn = u.byDistance(re, !p).distance;
    return p || ci(re) < B ? rn : N && Me ? rn * 0.5 : u.byIndex(ge.get(), 0).distance;
  }
  function we(re) {
    const Me = W3(re, t);
    z = Me, _ = p && Me && !re.buttons && V, V = Co(a.get(), r.get()) >= 2, !(Me && re.button !== 0) && (ue(re.target) || (M = !0, s.pointerDown(re), c.useFriction(0).useDuration(0), a.set(r), he(), H = s.readPoint(re), O = s.readPoint(re, y), m.emit("pointerDown")));
  }
  function ie(re) {
    if (!W3(re, t) && re.touches.length >= 2) return De(re);
    const ge = s.readPoint(re), rn = s.readPoint(re, y), Sn = Co(ge, H), Jn = Co(rn, O);
    if (!L && !z && (!re.cancelable || (L = Sn > Jn, !L)))
      return De(re);
    const Xn = s.pointerMove(re);
    Sn > h && (_ = !0), c.useFriction(0.3).useDuration(0.75), o.start(), a.add(x(Xn)), re.preventDefault();
  }
  function De(re) {
    const ge = u.byDistance(0, !1).index !== k.get(), rn = s.pointerUp(re) * oe(), Sn = $e(x(rn), ge), Jn = kE(rn, Sn), Xn = $ - 10 * Jn, Mn = S + Jn / 50;
    L = !1, M = !1, A.clear(), c.useDuration(Xn).useFriction(Mn), d.distance(Sn, !p), z = !1, m.emit("pointerUp");
  }
  function _e(re) {
    _ && (re.stopPropagation(), re.preventDefault(), _ = !1);
  }
  function Ie() {
    return M;
  }
  return {
    init: ne,
    destroy: Se,
    pointerDown: Ie
  };
}
function SE(e, n) {
  let t, a;
  function s(k) {
    return k.timeStamp;
  }
  function r(k, m) {
    const p = `client${(m || e.scroll) === "x" ? "X" : "Y"}`;
    return (W3(k, n) ? k : k.touches[0])[p];
  }
  function o(k) {
    return t = k, a = k, r(k);
  }
  function d(k) {
    const m = r(k) - r(a), f = s(k) - s(t) > 170;
    return a = k, f && (t = k), m;
  }
  function c(k) {
    if (!t || !a) return 0;
    const m = r(a) - r(t), f = s(k) - s(t), p = s(k) - s(a) > 170, h = m / f;
    return f && !p && ci(h) > 0.1 ? h : 0;
  }
  return {
    pointerDown: o,
    pointerMove: d,
    pointerUp: c,
    readPoint: r
  };
}
function gE() {
  function e(i) {
    const {
      offsetTop: t,
      offsetLeft: a,
      offsetWidth: s,
      offsetHeight: r
    } = i;
    return {
      top: t,
      right: a + s,
      bottom: t + r,
      left: a,
      width: s,
      height: r
    };
  }
  return {
    measure: e
  };
}
function FE(e) {
  function n(t) {
    return e * (t / 100);
  }
  return {
    measure: n
  };
}
function IE(e, n, i, t, a, s, r) {
  const o = [e].concat(t);
  let d, c, u = [], k = !1;
  function m(N) {
    return a.measureSize(r.measure(N));
  }
  function f(N) {
    if (!s) return;
    c = m(e), u = t.map(m);
    function S(F) {
      for (const y of F) {
        if (k) return;
        const x = y.target === e, R = t.indexOf(y.target), T = x ? c : u[R], j = m(x ? e : t[R]);
        if (ci(j - T) >= 0.5) {
          N.reInit(), n.emit("resize");
          break;
        }
      }
    }
    d = new ResizeObserver((F) => {
      (vm(s) || s(N, F)) && S(F);
    }), i.requestAnimationFrame(() => {
      o.forEach((F) => d.observe(F));
    });
  }
  function p() {
    k = !0, d && d.disconnect();
  }
  return {
    init: f,
    destroy: p
  };
}
function yE(e, n, i, t, a, s) {
  let r = 0, o = 0, d = a, c = s, u = e.get(), k = 0;
  function m() {
    const T = t.get() - e.get(), j = !d;
    let A = 0;
    return j ? (r = 0, i.set(t), e.set(t), A = T) : (i.set(e), r += T / d, r *= c, u += r, e.add(r), A = u - k), o = uv(A), k = u, R;
  }
  function f() {
    const T = t.get() - n.get();
    return ci(T) < 1e-3;
  }
  function p() {
    return d;
  }
  function h() {
    return o;
  }
  function N() {
    return r;
  }
  function S() {
    return y(a);
  }
  function F() {
    return x(s);
  }
  function y(T) {
    return d = T, R;
  }
  function x(T) {
    return c = T, R;
  }
  const R = {
    direction: h,
    duration: p,
    velocity: N,
    seek: m,
    settled: f,
    useBaseFriction: F,
    useBaseDuration: S,
    useFriction: x,
    useDuration: y
  };
  return R;
}
function bE(e, n, i, t, a) {
  const s = a.measure(10), r = a.measure(50), o = Us(0.1, 0.99);
  let d = !1;
  function c() {
    return !(d || !e.reachedAny(i.get()) || !e.reachedAny(n.get()));
  }
  function u(f) {
    if (!c()) return;
    const p = e.reachedMin(n.get()) ? "min" : "max", h = ci(e[p] - n.get()), N = i.get() - n.get(), S = o.constrain(h / r);
    i.subtract(N * S), !f && ci(N) < s && (i.set(e.constrain(i.get())), t.useDuration(25).useBaseFriction());
  }
  function k(f) {
    d = !f;
  }
  return {
    shouldConstrain: c,
    constrain: u,
    toggleActive: k
  };
}
function CE(e, n, i, t, a) {
  const s = Us(-n + e, 0), r = k(), o = u(), d = m();
  function c(p, h) {
    return Co(p, h) <= 1;
  }
  function u() {
    const p = r[0], h = ta(r), N = r.lastIndexOf(p), S = r.indexOf(h) + 1;
    return Us(N, S);
  }
  function k() {
    return i.map((p, h) => {
      const {
        min: N,
        max: S
      } = s, F = s.constrain(p), y = !h, x = mv(i, h);
      return y ? S : x || c(N, F) ? N : c(S, F) ? S : F;
    }).map((p) => parseFloat(p.toFixed(3)));
  }
  function m() {
    if (n <= e + a) return [s.max];
    if (t === "keepSnaps") return r;
    const {
      min: p,
      max: h
    } = o;
    return r.slice(p, h);
  }
  return {
    snapsContained: d,
    scrollContainLimit: o
  };
}
function xE(e, n, i) {
  const t = n[0], a = i ? t - e : ta(n);
  return {
    limit: Us(a, t)
  };
}
function DE(e, n, i, t) {
  const s = n.min + 0.1, r = n.max + 0.1, {
    reachedMin: o,
    reachedMax: d
  } = Us(s, r);
  function c(m) {
    return m === 1 ? d(i.get()) : m === -1 ? o(i.get()) : !1;
  }
  function u(m) {
    if (!c(m)) return;
    const f = e * (m * -1);
    t.forEach((p) => p.add(f));
  }
  return {
    loop: u
  };
}
function wE(e) {
  const {
    max: n,
    length: i
  } = e;
  function t(s) {
    const r = s - n;
    return i ? r / -i : 0;
  }
  return {
    get: t
  };
}
function PE(e, n, i, t, a) {
  const {
    startEdge: s,
    endEdge: r
  } = e, {
    groupSlides: o
  } = a, d = k().map(n.measure), c = m(), u = f();
  function k() {
    return o(t).map((h) => ta(h)[r] - h[0][s]).map(ci);
  }
  function m() {
    return t.map((h) => i[s] - h[s]).map((h) => -ci(h));
  }
  function f() {
    return o(c).map((h) => h[0]).map((h, N) => h + d[N]);
  }
  return {
    snaps: c,
    snapsAligned: u
  };
}
function RE(e, n, i, t, a, s) {
  const {
    groupSlides: r
  } = a, {
    min: o,
    max: d
  } = t, c = u();
  function u() {
    const m = r(s), f = !e || n === "keepSnaps";
    return i.length === 1 ? [s] : f ? m : m.slice(o, d).map((p, h, N) => {
      const S = !h, F = mv(N, h);
      if (S) {
        const y = ta(N[0]) + 1;
        return e4(y);
      }
      if (F) {
        const y = kd(s) - ta(N)[0] + 1;
        return e4(y, ta(N)[0]);
      }
      return p;
    });
  }
  return {
    slideRegistry: c
  };
}
function TE(e, n, i, t, a) {
  const {
    reachedAny: s,
    removeOffset: r,
    constrain: o
  } = t;
  function d(p) {
    return p.concat().sort((h, N) => ci(h) - ci(N))[0];
  }
  function c(p) {
    const h = e ? r(p) : o(p), N = n.map((F, y) => ({
      diff: u(F - h, 0),
      index: y
    })).sort((F, y) => ci(F.diff) - ci(y.diff)), {
      index: S
    } = N[0];
    return {
      index: S,
      distance: h
    };
  }
  function u(p, h) {
    const N = [p, p + i, p - i];
    if (!e) return p;
    if (!h) return d(N);
    const S = N.filter((F) => uv(F) === h);
    return S.length ? d(S) : ta(N) - i;
  }
  function k(p, h) {
    const N = n[p] - a.get(), S = u(N, h);
    return {
      index: p,
      distance: S
    };
  }
  function m(p, h) {
    const N = a.get() + p, {
      index: S,
      distance: F
    } = c(N), y = !e && s(N);
    if (!h || y) return {
      index: S,
      distance: p
    };
    const x = n[S] - F, R = p + u(x, 0);
    return {
      index: S,
      distance: R
    };
  }
  return {
    byDistance: m,
    byIndex: k,
    shortcut: u
  };
}
function jE(e, n, i, t, a, s, r) {
  function o(k) {
    const m = k.distance, f = k.index !== n.get();
    s.add(m), m && (t.duration() ? e.start() : (e.update(), e.render(1), e.update())), f && (i.set(n.get()), n.set(k.index), r.emit("select"));
  }
  function d(k, m) {
    const f = a.byDistance(k, m);
    o(f);
  }
  function c(k, m) {
    const f = n.clone().set(k), p = a.byIndex(f.get(), m);
    o(p);
  }
  return {
    distance: d,
    index: c
  };
}
function AE(e, n, i, t, a, s, r, o) {
  const d = {
    passive: !0,
    capture: !0
  };
  let c = 0;
  function u(f) {
    if (!o) return;
    function p(h) {
      if ((/* @__PURE__ */ new Date()).getTime() - c > 10) return;
      r.emit("slideFocusStart"), e.scrollLeft = 0;
      const F = i.findIndex((y) => y.includes(h));
      cv(F) && (a.useDuration(0), t.index(F, 0), r.emit("slideFocus"));
    }
    s.add(document, "keydown", k, !1), n.forEach((h, N) => {
      s.add(h, "focus", (S) => {
        (vm(o) || o(f, S)) && p(N);
      }, d);
    });
  }
  function k(f) {
    f.code === "Tab" && (c = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: u
  };
}
function vo(e) {
  let n = e;
  function i() {
    return n;
  }
  function t(d) {
    n = r(d);
  }
  function a(d) {
    n += r(d);
  }
  function s(d) {
    n -= r(d);
  }
  function r(d) {
    return cv(d) ? d : d.get();
  }
  return {
    get: i,
    set: t,
    add: a,
    subtract: s
  };
}
function Uy(e, n) {
  const i = e.scroll === "x" ? r : o, t = n.style;
  let a = null, s = !1;
  function r(m) {
    return `translate3d(${m}px,0px,0px)`;
  }
  function o(m) {
    return `translate3d(0px,${m}px,0px)`;
  }
  function d(m) {
    if (s) return;
    const f = fE(e.direction(m));
    f !== a && (t.transform = i(f), a = f);
  }
  function c(m) {
    s = !m;
  }
  function u() {
    s || (t.transform = "", n.getAttribute("style") || n.removeAttribute("style"));
  }
  return {
    clear: u,
    to: d,
    toggleActive: c
  };
}
function OE(e, n, i, t, a, s, r, o, d) {
  const u = Qo(a), k = Qo(a).reverse(), m = S().concat(F());
  function f(j, A) {
    return j.reduce((B, W) => B - a[W], A);
  }
  function p(j, A) {
    return j.reduce((B, W) => f(B, A) > 0 ? B.concat([W]) : B, []);
  }
  function h(j) {
    return s.map((A, B) => ({
      start: A - t[B] + 0.5 + j,
      end: A + n - 0.5 + j
    }));
  }
  function N(j, A, B) {
    const W = h(A);
    return j.map((E) => {
      const $ = B ? 0 : -i, V = B ? i : 0, H = B ? "end" : "start", O = W[E][H];
      return {
        index: E,
        loopPoint: O,
        slideLocation: vo(-1),
        translate: Uy(e, d[E]),
        target: () => o.get() > O ? $ : V
      };
    });
  }
  function S() {
    const j = r[0], A = p(k, j);
    return N(A, i, !1);
  }
  function F() {
    const j = n - r[0] - 1, A = p(u, j);
    return N(A, -i, !0);
  }
  function y() {
    return m.every(({
      index: j
    }) => {
      const A = u.filter((B) => B !== j);
      return f(A, n) <= 0.1;
    });
  }
  function x() {
    m.forEach((j) => {
      const {
        target: A,
        translate: B,
        slideLocation: W
      } = j, E = A();
      E !== W.get() && (B.to(E), W.set(E));
    });
  }
  function R() {
    m.forEach((j) => j.translate.clear());
  }
  return {
    canLoop: y,
    clear: R,
    loop: x,
    loopPoints: m
  };
}
function EE(e, n, i) {
  let t, a = !1;
  function s(d) {
    if (!i) return;
    function c(u) {
      for (const k of u)
        if (k.type === "childList") {
          d.reInit(), n.emit("slidesChanged");
          break;
        }
    }
    t = new MutationObserver((u) => {
      a || (vm(i) || i(d, u)) && c(u);
    }), t.observe(e, {
      childList: !0
    });
  }
  function r() {
    t && t.disconnect(), a = !0;
  }
  return {
    init: s,
    destroy: r
  };
}
function JE(e, n, i, t) {
  const a = {};
  let s = null, r = null, o, d = !1;
  function c() {
    o = new IntersectionObserver((p) => {
      d || (p.forEach((h) => {
        const N = n.indexOf(h.target);
        a[N] = h;
      }), s = null, r = null, i.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: t
    }), n.forEach((p) => o.observe(p));
  }
  function u() {
    o && o.disconnect(), d = !0;
  }
  function k(p) {
    return Mo(a).reduce((h, N) => {
      const S = parseInt(N), {
        isIntersecting: F
      } = a[S];
      return (p && F || !p && !F) && h.push(S), h;
    }, []);
  }
  function m(p = !0) {
    if (p && s) return s;
    if (!p && r) return r;
    const h = k(p);
    return p && (s = h), p || (r = h), h;
  }
  return {
    init: c,
    destroy: u,
    get: m
  };
}
function _E(e, n, i, t, a, s) {
  const {
    measureSize: r,
    startEdge: o,
    endEdge: d
  } = e, c = i[0] && a, u = p(), k = h(), m = i.map(r), f = N();
  function p() {
    if (!c) return 0;
    const F = i[0];
    return ci(n[o] - F[o]);
  }
  function h() {
    if (!c) return 0;
    const F = s.getComputedStyle(ta(t));
    return parseFloat(F.getPropertyValue(`margin-${d}`));
  }
  function N() {
    return i.map((F, y, x) => {
      const R = !y, T = mv(x, y);
      return R ? m[y] + u : T ? m[y] + k : x[y + 1][o] - F[o];
    }).map(ci);
  }
  return {
    slideSizes: m,
    slideSizesWithGaps: f,
    startGap: u,
    endGap: k
  };
}
function QE(e, n, i, t, a, s, r, o, d) {
  const {
    startEdge: c,
    endEdge: u,
    direction: k
  } = e, m = cv(i);
  function f(S, F) {
    return Qo(S).filter((y) => y % F === 0).map((y) => S.slice(y, y + F));
  }
  function p(S) {
    return S.length ? Qo(S).reduce((F, y, x) => {
      const R = ta(F) || 0, T = R === 0, j = y === kd(S), A = a[c] - s[R][c], B = a[c] - s[y][u], W = !t && T ? k(r) : 0, E = !t && j ? k(o) : 0, $ = ci(B - E - (A + W));
      return x && $ > n + d && F.push(y), j && F.push(S.length), F;
    }, []).map((F, y, x) => {
      const R = Math.max(x[y - 1] || 0);
      return S.slice(R, F);
    }) : [];
  }
  function h(S) {
    return m ? f(S, i) : p(S);
  }
  return {
    groupSlides: h
  };
}
function ME(e, n, i, t, a, s, r) {
  const {
    align: o,
    axis: d,
    direction: c,
    startIndex: u,
    loop: k,
    duration: m,
    dragFree: f,
    dragThreshold: p,
    inViewThreshold: h,
    slidesToScroll: N,
    skipSnaps: S,
    containScroll: F,
    watchResize: y,
    watchSlides: x,
    watchDrag: R,
    watchFocus: T
  } = s, j = 2, A = gE(), B = A.measure(n), W = i.map(A.measure), E = pE(d, c), $ = E.measureSize(B), V = FE($), H = vE(o, $), O = !k && !!F, M = k || !!F, {
    slideSizes: L,
    slideSizesWithGaps: _,
    startGap: z,
    endGap: ne
  } = _E(E, B, W, i, M, a), Se = QE(E, $, N, k, B, W, z, ne, j), {
    snaps: he,
    snapsAligned: ue
  } = PE(E, H, B, W, Se), oe = -ta(he) + ta(_), {
    snapsContained: $e,
    scrollContainLimit: we
  } = CE($, oe, ue, F, j), ie = O ? $e : ue, {
    limit: De
  } = xE(oe, ie, k), _e = $y(kd(ie), u, k), Ie = _e.clone(), Fe = Qo(i), re = ({
    dragHandler: Di,
    scrollBody: Bt,
    scrollBounds: wi,
    options: {
      loop: Pi
    }
  }) => {
    Pi || wi.constrain(Di.pointerDown()), Bt.seek();
  }, Me = ({
    scrollBody: Di,
    translate: Bt,
    location: wi,
    offsetLocation: Pi,
    previousLocation: Vi,
    scrollLooper: mt,
    slideLooper: ot,
    dragHandler: qt,
    animation: Gt,
    eventHandler: Le,
    scrollBounds: Xe,
    options: {
      loop: gn
    }
  }, Ze) => {
    const vn = Di.settled(), zn = !Xe.shouldConstrain(), je = gn ? vn : vn && zn, He = je && !qt.pointerDown();
    He && Gt.stop();
    const sn = wi.get() * Ze + Vi.get() * (1 - Ze);
    Pi.set(sn), gn && (mt.loop(Di.direction()), ot.loop()), Bt.to(Pi.get()), He && Le.emit("settle"), je || Le.emit("scroll");
  }, ge = hE(t, a, () => re(xt), (Di) => Me(xt, Di)), rn = 0.68, Sn = ie[_e.get()], Jn = vo(Sn), Xn = vo(Sn), Mn = vo(Sn), Zn = vo(Sn), mn = yE(Jn, Mn, Xn, Zn, m, rn), We = TE(k, ie, oe, De, Zn), pi = jE(ge, _e, Ie, mn, We, Zn, r), Fi = wE(De), ut = Lo(), ti = JE(n, i, r, h), {
    slideRegistry: Ui
  } = RE(O, F, ie, we, Se, Fe), Ct = AE(e, i, Ui, pi, mn, ut, r, T), xt = {
    ownerDocument: t,
    ownerWindow: a,
    eventHandler: r,
    containerRect: B,
    slideRects: W,
    animation: ge,
    axis: E,
    dragHandler: NE(E, e, t, a, Zn, SE(E, a), Jn, ge, pi, mn, We, _e, r, V, f, p, S, rn, R),
    eventStore: ut,
    percentOfView: V,
    index: _e,
    indexPrevious: Ie,
    limit: De,
    location: Jn,
    offsetLocation: Mn,
    previousLocation: Xn,
    options: s,
    resizeHandler: IE(n, r, a, i, E, y, A),
    scrollBody: mn,
    scrollBounds: bE(De, Mn, Zn, mn, V),
    scrollLooper: DE(oe, De, Mn, [Jn, Mn, Xn, Zn]),
    scrollProgress: Fi,
    scrollSnapList: ie.map(Fi.get),
    scrollSnaps: ie,
    scrollTarget: We,
    scrollTo: pi,
    slideLooper: OE(E, $, oe, L, _, he, ie, Mn, i),
    slideFocus: Ct,
    slidesHandler: EE(n, r, x),
    slidesInView: ti,
    slideIndexes: Fe,
    slideRegistry: Ui,
    slidesToScroll: Se,
    target: Zn,
    translate: Uy(E, n)
  };
  return xt;
}
function LE() {
  let e = {}, n;
  function i(c) {
    n = c;
  }
  function t(c) {
    return e[c] || [];
  }
  function a(c) {
    return t(c).forEach((u) => u(n, c)), d;
  }
  function s(c, u) {
    return e[c] = t(c).concat([u]), d;
  }
  function r(c, u) {
    return e[c] = t(c).filter((k) => k !== u), d;
  }
  function o() {
    e = {};
  }
  const d = {
    init: i,
    emit: a,
    off: r,
    on: s,
    clear: o
  };
  return d;
}
const $E = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function UE(e) {
  function n(s, r) {
    return Ly(s, r || {});
  }
  function i(s) {
    const r = s.breakpoints || {}, o = Mo(r).filter((d) => e.matchMedia(d).matches).map((d) => r[d]).reduce((d, c) => n(d, c), {});
    return n(s, o);
  }
  function t(s) {
    return s.map((r) => Mo(r.breakpoints || {})).reduce((r, o) => r.concat(o), []).map(e.matchMedia);
  }
  return {
    mergeOptions: n,
    optionsAtMedia: i,
    optionsMediaQueries: t
  };
}
function VE(e) {
  let n = [];
  function i(s, r) {
    return n = r.filter(({
      options: o
    }) => e.optionsAtMedia(o).active !== !1), n.forEach((o) => o.init(s, e)), r.reduce((o, d) => Object.assign(o, {
      [d.name]: d
    }), {});
  }
  function t() {
    n = n.filter((s) => s.destroy());
  }
  return {
    init: i,
    destroy: t
  };
}
function fu(e, n, i) {
  const t = e.ownerDocument, a = t.defaultView, s = UE(a), r = VE(s), o = Lo(), d = LE(), {
    mergeOptions: c,
    optionsAtMedia: u,
    optionsMediaQueries: k
  } = s, {
    on: m,
    off: f,
    emit: p
  } = d, h = E;
  let N = !1, S, F = c($E, fu.globalOptions), y = c(F), x = [], R, T, j;
  function A() {
    const {
      container: Fe,
      slides: re
    } = y;
    T = (G3(Fe) ? e.querySelector(Fe) : Fe) || e.children[0];
    const ge = G3(re) ? T.querySelectorAll(re) : re;
    j = [].slice.call(ge || T.children);
  }
  function B(Fe) {
    const re = ME(e, T, j, t, a, Fe, d);
    if (Fe.loop && !re.slideLooper.canLoop()) {
      const Me = Object.assign({}, Fe, {
        loop: !1
      });
      return B(Me);
    }
    return re;
  }
  function W(Fe, re) {
    N || (F = c(F, Fe), y = u(F), x = re || x, A(), S = B(y), k([F, ...x.map(({
      options: Me
    }) => Me)]).forEach((Me) => o.add(Me, "change", E)), y.active && (S.translate.to(S.location.get()), S.animation.init(), S.slidesInView.init(), S.slideFocus.init(Ie), S.eventHandler.init(Ie), S.resizeHandler.init(Ie), S.slidesHandler.init(Ie), S.options.loop && S.slideLooper.loop(), T.offsetParent && j.length && S.dragHandler.init(Ie), R = r.init(Ie, x)));
  }
  function E(Fe, re) {
    const Me = Se();
    $(), W(c({
      startIndex: Me
    }, Fe), re), d.emit("reInit");
  }
  function $() {
    S.dragHandler.destroy(), S.eventStore.clear(), S.translate.clear(), S.slideLooper.clear(), S.resizeHandler.destroy(), S.slidesHandler.destroy(), S.slidesInView.destroy(), S.animation.destroy(), r.destroy(), o.clear();
  }
  function V() {
    N || (N = !0, o.clear(), $(), d.emit("destroy"), d.clear());
  }
  function H(Fe, re, Me) {
    !y.active || N || (S.scrollBody.useBaseFriction().useDuration(re === !0 ? 0 : y.duration), S.scrollTo.index(Fe, Me || 0));
  }
  function O(Fe) {
    const re = S.index.add(1).get();
    H(re, Fe, -1);
  }
  function M(Fe) {
    const re = S.index.add(-1).get();
    H(re, Fe, 1);
  }
  function L() {
    return S.index.add(1).get() !== Se();
  }
  function _() {
    return S.index.add(-1).get() !== Se();
  }
  function z() {
    return S.scrollSnapList;
  }
  function ne() {
    return S.scrollProgress.get(S.offsetLocation.get());
  }
  function Se() {
    return S.index.get();
  }
  function he() {
    return S.indexPrevious.get();
  }
  function ue() {
    return S.slidesInView.get();
  }
  function oe() {
    return S.slidesInView.get(!1);
  }
  function $e() {
    return R;
  }
  function we() {
    return S;
  }
  function ie() {
    return e;
  }
  function De() {
    return T;
  }
  function _e() {
    return j;
  }
  const Ie = {
    canScrollNext: L,
    canScrollPrev: _,
    containerNode: De,
    internalEngine: we,
    destroy: V,
    off: f,
    on: m,
    emit: p,
    plugins: $e,
    previousScrollSnap: he,
    reInit: h,
    rootNode: ie,
    scrollNext: O,
    scrollPrev: M,
    scrollProgress: ne,
    scrollSnapList: z,
    scrollTo: H,
    selectedScrollSnap: Se,
    slideNodes: _e,
    slidesInView: ue,
    slidesNotInView: oe
  };
  return W(n, i), setTimeout(() => d.emit("init"), 0), Ie;
}
fu.globalOptions = void 0;
function kv(e = {}, n = []) {
  const i = Ye(e), t = Ye(n), [a, s] = se(), [r, o] = se(), d = I(() => {
    a && a.reInit(i.current, t.current);
  }, [a]);
  return be(() => {
    dv(i.current, e) || (i.current = e, d());
  }, [e, d]), be(() => {
    mE(t.current, n) || (t.current = n, d());
  }, [n, d]), be(() => {
    if (uE() && r) {
      fu.globalOptions = kv.globalOptions;
      const c = fu(r, i.current, t.current);
      return s(c), () => c.destroy();
    } else
      s(void 0);
  }, [r, s]), [o, a];
}
kv.globalOptions = void 0;
const Vy = w.createContext(null);
function hm() {
  const e = w.useContext(Vy);
  if (!e)
    throw new Error("useCarousel must be used within a <Carousel />");
  return e;
}
function HE() {
  const [e, n] = w.useState(), [i, t] = w.useState(0), [a, s] = w.useState(0);
  return w.useEffect(() => {
    if (e)
      return s(e.scrollSnapList().length), t(e.selectedScrollSnap() + 1), e.on("select", () => {
        t(e.selectedScrollSnap() + 1);
      }), () => {
        s(0), t(0);
      };
  }, [e]), {
    api: e,
    setApi: n,
    current: i,
    count: a
  };
}
const Hy = w.forwardRef(
  ({ orientation: e = "horizontal", opts: n, setApi: i, plugins: t, className: a, children: s, ...r }, o) => {
    const [d, c] = kv(
      {
        ...n,
        axis: e === "horizontal" ? "x" : "y"
      },
      t
    ), [u, k] = w.useState(!1), [m, f] = w.useState(!1), p = w.useCallback((F) => {
      F && (k(F.canScrollPrev()), f(F.canScrollNext()));
    }, []), h = w.useCallback(() => {
      c == null || c.scrollPrev();
    }, [c]), N = w.useCallback(() => {
      c == null || c.scrollNext();
    }, [c]), S = w.useCallback(
      (F) => {
        F.key === "ArrowLeft" ? (F.preventDefault(), h()) : F.key === "ArrowRight" && (F.preventDefault(), N());
      },
      [h, N]
    );
    return w.useEffect(() => {
      !c || !i || i(c);
    }, [c, i]), w.useEffect(() => {
      if (c)
        return p(c), c.on("reInit", p), c.on("select", p), () => {
          c == null || c.off("select", p);
        };
    }, [c, p]), /* @__PURE__ */ l.jsx(
      Vy.Provider,
      {
        value: {
          carouselRef: d,
          api: c,
          opts: n,
          orientation: e || ((n == null ? void 0 : n.axis) === "y" ? "vertical" : "horizontal"),
          scrollPrev: h,
          scrollNext: N,
          canScrollPrev: u,
          canScrollNext: m
        },
        children: /* @__PURE__ */ l.jsx(
          "div",
          {
            ref: o,
            onKeyDownCapture: S,
            className: ce("ch-relative", a),
            role: "region",
            "aria-roledescription": "carousel",
            ...r,
            children: s
          }
        )
      }
    );
  }
);
Hy.displayName = "Carousel";
const zy = w.forwardRef(
  ({ className: e, ...n }, i) => {
    const { carouselRef: t, orientation: a } = hm();
    return /* @__PURE__ */ l.jsx("div", { ref: t, className: "ch-overflow-hidden", children: /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: i,
        className: ce(
          "ch-flex",
          a === "horizontal" ? "ch--ml-4" : "ch--mt-4 ch-flex-col",
          e
        ),
        ...n
      }
    ) });
  }
);
zy.displayName = "CarouselContent";
const By = w.forwardRef(
  ({ className: e, ...n }, i) => {
    const { orientation: t } = hm();
    return /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: i,
        role: "group",
        "aria-roledescription": "slide",
        className: ce(
          "ch-min-w-0 ch-shrink-0 ch-grow-0 ch-basis-full",
          t === "horizontal" ? "ch-pl-4" : "ch-pt-4",
          e
        ),
        ...n
      }
    );
  }
);
By.displayName = "CarouselItem";
const zE = w.forwardRef(
  ({ className: e, variant: n = "outline", size: i = "icon", ...t }, a) => {
    const { orientation: s, scrollPrev: r, canScrollPrev: o } = hm();
    return /* @__PURE__ */ l.jsxs(
      ae,
      {
        ref: a,
        variant: n,
        size: i,
        className: ce(
          "ch-absolute ch-h-8 ch-w-8 ch-rounded-full ch-border-none hover:ch-bg-gray-100",
          s === "horizontal" ? "ch--left-12 ch-top-1/2 ch--translate-y-1/2" : "ch--top-12 ch-left-1/2 ch--translate-x-1/2 ch-rotate-90",
          e
        ),
        disabled: !o,
        onClick: r,
        ...t,
        children: [
          /* @__PURE__ */ l.jsx(lm, { size: "sm" }),
          /* @__PURE__ */ l.jsx("span", { className: "ch-sr-only", children: "Previous slide" })
        ]
      }
    );
  }
);
zE.displayName = "CarouselPrevious";
const BE = w.forwardRef(
  ({ className: e, variant: n = "outline", size: i = "icon", ...t }, a) => {
    const { orientation: s, scrollNext: r, canScrollNext: o } = hm();
    return /* @__PURE__ */ l.jsxs(
      ae,
      {
        ref: a,
        variant: n,
        size: i,
        className: ce(
          "ch-absolute ch-h-8 ch-w-8 ch-rounded-full ch-border-none hover:ch-bg-gray-100",
          s === "horizontal" ? "ch--right-12 ch-top-1/2 ch--translate-y-1/2" : "ch--bottom-12 ch-left-1/2 ch--translate-x-1/2 ch-rotate-90",
          e
        ),
        disabled: !o,
        onClick: r,
        ...t,
        children: [
          /* @__PURE__ */ l.jsx(zl, { size: "sm" }),
          /* @__PURE__ */ l.jsx("span", { className: "ch-sr-only", children: "Next slide" })
        ]
      }
    );
  }
);
BE.displayName = "CarouselNext";
function pm(e) {
  const n = w.useRef({ value: e, previous: e });
  return w.useMemo(() => (n.current.value !== e && (n.current.previous = n.current.value, n.current.value = e), n.current.previous), [e]);
}
function Nm(e) {
  const [n, i] = w.useState(void 0);
  return Mi(() => {
    if (e) {
      i({ width: e.offsetWidth, height: e.offsetHeight });
      const t = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const s = a[0];
        let r, o;
        if ("borderBoxSize" in s) {
          const d = s.borderBoxSize, c = Array.isArray(d) ? d[0] : d;
          r = c.inlineSize, o = c.blockSize;
        } else
          r = e.offsetWidth, o = e.offsetHeight;
        i({ width: r, height: o });
      });
      return t.observe(e, { box: "border-box" }), () => t.unobserve(e);
    } else
      i(void 0);
  }, [e]), n;
}
var Sm = "Checkbox", [qE] = $t(Sm), [GE, fv] = qE(Sm);
function WE(e) {
  const {
    __scopeCheckbox: n,
    checked: i,
    children: t,
    defaultChecked: a,
    disabled: s,
    form: r,
    name: o,
    onCheckedChange: d,
    required: c,
    value: u = "on",
    // @ts-expect-error
    internal_do_not_use_render: k
  } = e, [m, f] = Oa({
    prop: i,
    defaultProp: a != null ? a : !1,
    onChange: d,
    caller: Sm
  }), [p, h] = w.useState(null), [N, S] = w.useState(null), F = w.useRef(!1), y = p ? !!r || !!p.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), x = {
    checked: m,
    disabled: s,
    setChecked: f,
    control: p,
    setControl: h,
    name: o,
    form: r,
    value: u,
    hasConsumerStoppedPropagationRef: F,
    required: c,
    defaultChecked: Vl(a) ? !1 : a,
    isFormControl: y,
    bubbleInput: N,
    setBubbleInput: S
  };
  return /* @__PURE__ */ l.jsx(
    GE,
    {
      scope: n,
      ...x,
      children: KE(k) ? k(x) : t
    }
  );
}
var qy = "CheckboxTrigger", Gy = w.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: n, onClick: i, ...t }, a) => {
    const {
      control: s,
      value: r,
      disabled: o,
      checked: d,
      required: c,
      setControl: u,
      setChecked: k,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: f,
      bubbleInput: p
    } = fv(qy, e), h = Rn(a, u), N = w.useRef(d);
    return w.useEffect(() => {
      const S = s == null ? void 0 : s.form;
      if (S) {
        const F = () => k(N.current);
        return S.addEventListener("reset", F), () => S.removeEventListener("reset", F);
      }
    }, [s, k]), /* @__PURE__ */ l.jsx(
      ln.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": Vl(d) ? "mixed" : d,
        "aria-required": c,
        "data-state": Zy(d),
        "data-disabled": o ? "" : void 0,
        disabled: o,
        value: r,
        ...t,
        ref: h,
        onKeyDown: nn(n, (S) => {
          S.key === "Enter" && S.preventDefault();
        }),
        onClick: nn(i, (S) => {
          k((F) => Vl(F) ? !0 : !F), p && f && (m.current = S.isPropagationStopped(), m.current || S.stopPropagation());
        })
      }
    );
  }
);
Gy.displayName = qy;
var vv = w.forwardRef(
  (e, n) => {
    const {
      __scopeCheckbox: i,
      name: t,
      checked: a,
      defaultChecked: s,
      required: r,
      disabled: o,
      value: d,
      onCheckedChange: c,
      form: u,
      ...k
    } = e;
    return /* @__PURE__ */ l.jsx(
      WE,
      {
        __scopeCheckbox: i,
        checked: a,
        defaultChecked: s,
        disabled: o,
        required: r,
        onCheckedChange: c,
        name: t,
        form: u,
        value: d,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(
            Gy,
            {
              ...k,
              ref: n,
              __scopeCheckbox: i
            }
          ),
          m && /* @__PURE__ */ l.jsx(
            Xy,
            {
              __scopeCheckbox: i
            }
          )
        ] })
      }
    );
  }
);
vv.displayName = Sm;
var Wy = "CheckboxIndicator", Ky = w.forwardRef(
  (e, n) => {
    const { __scopeCheckbox: i, forceMount: t, ...a } = e, s = fv(Wy, i);
    return /* @__PURE__ */ l.jsx(
      kl,
      {
        present: t || Vl(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ l.jsx(
          ln.span,
          {
            "data-state": Zy(s.checked),
            "data-disabled": s.disabled ? "" : void 0,
            ...a,
            ref: n,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
Ky.displayName = Wy;
var Yy = "CheckboxBubbleInput", Xy = w.forwardRef(
  ({ __scopeCheckbox: e, ...n }, i) => {
    const {
      control: t,
      hasConsumerStoppedPropagationRef: a,
      checked: s,
      defaultChecked: r,
      required: o,
      disabled: d,
      name: c,
      value: u,
      form: k,
      bubbleInput: m,
      setBubbleInput: f
    } = fv(Yy, e), p = Rn(i, f), h = pm(s), N = Nm(t);
    w.useEffect(() => {
      const F = m;
      if (!F) return;
      const y = window.HTMLInputElement.prototype, R = Object.getOwnPropertyDescriptor(
        y,
        "checked"
      ).set, T = !a.current;
      if (h !== s && R) {
        const j = new Event("click", { bubbles: T });
        F.indeterminate = Vl(s), R.call(F, Vl(s) ? !1 : s), F.dispatchEvent(j);
      }
    }, [m, h, s, a]);
    const S = w.useRef(Vl(s) ? !1 : s);
    return /* @__PURE__ */ l.jsx(
      ln.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: r != null ? r : S.current,
        required: o,
        disabled: d,
        name: c,
        value: u,
        form: k,
        ...n,
        tabIndex: -1,
        ref: p,
        style: {
          ...n.style,
          ...N,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Xy.displayName = Yy;
function KE(e) {
  return typeof e == "function";
}
function Vl(e) {
  return e === "indeterminate";
}
function Zy(e) {
  return Vl(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const hv = Li(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  vv,
  {
    ref: i,
    className: ce(
      "ch-peer ch-h-6 ch-min-h-6 ch-w-6 ch-min-w-6 ch-shrink-0 ch-rounded ch-border ch-border-gray-200 focus-visible:ch-outline-none focus-visible:ch-ring-2 focus-visible:ch-ring-focus-600 focus-visible:ch-ring-offset-2 disabled:ch-cursor-not-allowed disabled:ch-opacity-50 data-[state=checked]:ch-border-primary data-[state=checked]:ch-bg-primary data-[state=checked]:ch-text-white",
      e
    ),
    ...n,
    children: /* @__PURE__ */ l.jsx(
      Ky,
      {
        className: ce("ch-flex ch-items-center ch-justify-center ch-text-current"),
        children: /* @__PURE__ */ l.jsx(aI, { size: "sm" })
      }
    )
  }
));
hv.displayName = vv.displayName;
const Qa = w.forwardRef(({ type: e, className: n, ...i }, t) => /* @__PURE__ */ l.jsx(
  "input",
  {
    type: e,
    className: ce(
      "ch-flex ch-h-full ch-w-full ch-rounded-lg ch-border ch-border-zinc-300 ch-px-3 ch-py-4 ch-text-base",
      "placeholder:ch-text-base placeholder:ch-text-zinc-300",
      "focus-visible:ch-outline-none focus-visible:ch-ring-2 focus-visible:ch-ring-focus-600 focus-visible:ch-ring-offset-2",
      "disabled:ch-cursor-not-allowed disabled:ch-opacity-50",
      n
    ),
    ref: t,
    ...i
  }
));
Qa.displayName = "Input";
var YE = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], e6 = YE.reduce((e, n) => {
  const i = /* @__PURE__ */ My(`Primitive.${n}`), t = w.forwardRef((a, s) => {
    const { asChild: r, ...o } = a, d = r ? i : n;
    return typeof window != "undefined" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(d, { ...o, ref: s });
  });
  return t.displayName = `Primitive.${n}`, { ...e, [n]: t };
}, {}), XE = "Label", n6 = w.forwardRef((e, n) => /* @__PURE__ */ l.jsx(
  e6.label,
  {
    ...e,
    ref: n,
    onMouseDown: (i) => {
      var a;
      i.target.closest("button, input, select, textarea") || ((a = e.onMouseDown) == null || a.call(e, i), !i.defaultPrevented && i.detail > 1 && i.preventDefault());
    }
  }
));
n6.displayName = XE;
var i6 = n6;
const ZE = Df(
  "ch-text-sm ch-font-medium ch-leading-none peer-disabled:ch-cursor-not-allowed peer-disabled:ch-opacity-70"
), Qn = Li(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(i6, { ref: i, className: ce(ZE(), e), ...n }));
Qn.displayName = i6.displayName;
var gm = "Switch", [eJ] = $t(gm), [nJ, iJ] = eJ(gm), t6 = w.forwardRef(
  (e, n) => {
    const {
      __scopeSwitch: i,
      name: t,
      checked: a,
      defaultChecked: s,
      required: r,
      disabled: o,
      value: d = "on",
      onCheckedChange: c,
      form: u,
      ...k
    } = e, [m, f] = w.useState(null), p = Rn(n, (y) => f(y)), h = w.useRef(!1), N = m ? u || !!m.closest("form") : !0, [S, F] = Oa({
      prop: a,
      defaultProp: s != null ? s : !1,
      onChange: c,
      caller: gm
    });
    return /* @__PURE__ */ l.jsxs(nJ, { scope: i, checked: S, disabled: o, children: [
      /* @__PURE__ */ l.jsx(
        ln.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": S,
          "aria-required": r,
          "data-state": r6(S),
          "data-disabled": o ? "" : void 0,
          disabled: o,
          value: d,
          ...k,
          ref: p,
          onClick: nn(e.onClick, (y) => {
            F((x) => !x), N && (h.current = y.isPropagationStopped(), h.current || y.stopPropagation());
          })
        }
      ),
      N && /* @__PURE__ */ l.jsx(
        s6,
        {
          control: m,
          bubbles: !h.current,
          name: t,
          value: d,
          checked: S,
          required: r,
          disabled: o,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
t6.displayName = gm;
var a6 = "SwitchThumb", l6 = w.forwardRef(
  (e, n) => {
    const { __scopeSwitch: i, ...t } = e, a = iJ(a6, i);
    return /* @__PURE__ */ l.jsx(
      ln.span,
      {
        "data-state": r6(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...t,
        ref: n
      }
    );
  }
);
l6.displayName = a6;
var tJ = "SwitchBubbleInput", s6 = w.forwardRef(
  ({
    __scopeSwitch: e,
    control: n,
    checked: i,
    bubbles: t = !0,
    ...a
  }, s) => {
    const r = w.useRef(null), o = Rn(r, s), d = pm(i), c = Nm(n);
    return w.useEffect(() => {
      const u = r.current;
      if (!u) return;
      const k = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(
        k,
        "checked"
      ).set;
      if (d !== i && f) {
        const p = new Event("click", { bubbles: t });
        f.call(u, i), u.dispatchEvent(p);
      }
    }, [d, i, t]), /* @__PURE__ */ l.jsx(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i,
        ...a,
        tabIndex: -1,
        ref: o,
        style: {
          ...a.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
s6.displayName = tJ;
function r6(e) {
  return e ? "checked" : "unchecked";
}
var o6 = t6, aJ = l6;
const pv = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  o6,
  {
    className: ce(
      "ch-peer",
      "ch-inline-flex ch-h-[24px] ch-w-[44px] ch-shrink-0 ch-cursor-pointer ch-items-center ch-rounded-full ch-border-2 ch-border-transparent ch-transition-colors",
      "focus-visible:ch-outline-none focus-visible:ch-ring-2 focus-visible:ch-ring-zinc-950 focus-visible:ch-ring-offset-2 focus-visible:ch-ring-offset-white",
      "disabled:ch-cursor-not-allowed disabled:ch-opacity-50",
      "data-[state=checked]:ch-bg-zinc-900 data-[state=unchecked]:ch-bg-zinc-200",
      e
    ),
    ...n,
    ref: i,
    children: /* @__PURE__ */ l.jsx(
      aJ,
      {
        className: ce(
          "ch-pointer-events-none ch-block ch-h-5 ch-w-5 ch-rounded-full ch-bg-white ch-shadow-lg ch-ring-0 ch-transition-transform",
          "data-[state=checked]:ch-translate-x-5 data-[state=unchecked]:ch-translate-x-0"
        )
      }
    )
  }
));
pv.displayName = o6.displayName;
function n4(e, [n, i]) {
  return Math.min(i, Math.max(n, e));
}
function Wl(e) {
  const n = w.useRef(e);
  return w.useEffect(() => {
    n.current = e;
  }), w.useMemo(() => (...i) => {
    var t;
    return (t = n.current) == null ? void 0 : t.call(n, ...i);
  }, []);
}
function lJ(e, n = globalThis == null ? void 0 : globalThis.document) {
  const i = Wl(e);
  w.useEffect(() => {
    const t = (a) => {
      a.key === "Escape" && i(a);
    };
    return n.addEventListener("keydown", t, { capture: !0 }), () => n.removeEventListener("keydown", t, { capture: !0 });
  }, [i, n]);
}
var sJ = "DismissableLayer", K3 = "dismissableLayer.update", rJ = "dismissableLayer.pointerDownOutside", oJ = "dismissableLayer.focusOutside", i4, d6 = w.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Fm = w.forwardRef(
  (e, n) => {
    var j;
    const {
      disableOutsidePointerEvents: i = !1,
      onEscapeKeyDown: t,
      onPointerDownOutside: a,
      onFocusOutside: s,
      onInteractOutside: r,
      onDismiss: o,
      ...d
    } = e, c = w.useContext(d6), [u, k] = w.useState(null), m = (j = u == null ? void 0 : u.ownerDocument) != null ? j : globalThis == null ? void 0 : globalThis.document, [, f] = w.useState({}), p = Rn(n, (A) => k(A)), h = Array.from(c.layers), [N] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), S = h.indexOf(N), F = u ? h.indexOf(u) : -1, y = c.layersWithOutsidePointerEventsDisabled.size > 0, x = F >= S, R = uJ((A) => {
      const B = A.target, W = [...c.branches].some((E) => E.contains(B));
      !x || W || (a == null || a(A), r == null || r(A), A.defaultPrevented || o == null || o());
    }, m), T = mJ((A) => {
      const B = A.target;
      [...c.branches].some((E) => E.contains(B)) || (s == null || s(A), r == null || r(A), A.defaultPrevented || o == null || o());
    }, m);
    return lJ((A) => {
      F === c.layers.size - 1 && (t == null || t(A), !A.defaultPrevented && o && (A.preventDefault(), o()));
    }, m), w.useEffect(() => {
      if (u)
        return i && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (i4 = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), t4(), () => {
          i && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = i4);
        };
    }, [u, m, i, c]), w.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), t4());
    }, [u, c]), w.useEffect(() => {
      const A = () => f({});
      return document.addEventListener(K3, A), () => document.removeEventListener(K3, A);
    }, []), /* @__PURE__ */ l.jsx(
      ln.div,
      {
        ...d,
        ref: p,
        style: {
          pointerEvents: y ? x ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: nn(e.onFocusCapture, T.onFocusCapture),
        onBlurCapture: nn(e.onBlurCapture, T.onBlurCapture),
        onPointerDownCapture: nn(
          e.onPointerDownCapture,
          R.onPointerDownCapture
        )
      }
    );
  }
);
Fm.displayName = sJ;
var dJ = "DismissableLayerBranch", cJ = w.forwardRef((e, n) => {
  const i = w.useContext(d6), t = w.useRef(null), a = Rn(n, t);
  return w.useEffect(() => {
    const s = t.current;
    if (s)
      return i.branches.add(s), () => {
        i.branches.delete(s);
      };
  }, [i.branches]), /* @__PURE__ */ l.jsx(ln.div, { ...e, ref: a });
});
cJ.displayName = dJ;
function uJ(e, n = globalThis == null ? void 0 : globalThis.document) {
  const i = Wl(e), t = w.useRef(!1), a = w.useRef(() => {
  });
  return w.useEffect(() => {
    const s = (o) => {
      if (o.target && !t.current) {
        let d = function() {
          c6(
            rJ,
            i,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: o };
        o.pointerType === "touch" ? (n.removeEventListener("click", a.current), a.current = d, n.addEventListener("click", a.current, { once: !0 })) : d();
      } else
        n.removeEventListener("click", a.current);
      t.current = !1;
    }, r = window.setTimeout(() => {
      n.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(r), n.removeEventListener("pointerdown", s), n.removeEventListener("click", a.current);
    };
  }, [n, i]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => t.current = !0
  };
}
function mJ(e, n = globalThis == null ? void 0 : globalThis.document) {
  const i = Wl(e), t = w.useRef(!1);
  return w.useEffect(() => {
    const a = (s) => {
      s.target && !t.current && c6(oJ, i, { originalEvent: s }, {
        discrete: !1
      });
    };
    return n.addEventListener("focusin", a), () => n.removeEventListener("focusin", a);
  }, [n, i]), {
    onFocusCapture: () => t.current = !0,
    onBlurCapture: () => t.current = !1
  };
}
function t4() {
  const e = new CustomEvent(K3);
  document.dispatchEvent(e);
}
function c6(e, n, i, { discrete: t }) {
  const a = i.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: i });
  n && a.addEventListener(e, n, { once: !0 }), t ? lP(a, s) : a.dispatchEvent(s);
}
var y0 = 0;
function Nv() {
  w.useEffect(() => {
    var n, i;
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (n = e[0]) != null ? n : a4()), document.body.insertAdjacentElement("beforeend", (i = e[1]) != null ? i : a4()), y0++, () => {
      y0 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), y0--;
    };
  }, []);
}
function a4() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var b0 = "focusScope.autoFocusOnMount", C0 = "focusScope.autoFocusOnUnmount", l4 = { bubbles: !1, cancelable: !0 }, kJ = "FocusScope", Im = w.forwardRef((e, n) => {
  const {
    loop: i = !1,
    trapped: t = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: s,
    ...r
  } = e, [o, d] = w.useState(null), c = Wl(a), u = Wl(s), k = w.useRef(null), m = Rn(n, (h) => d(h)), f = w.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  w.useEffect(() => {
    if (t) {
      let h = function(y) {
        if (f.paused || !o) return;
        const x = y.target;
        o.contains(x) ? k.current = x : Rl(k.current, { select: !0 });
      }, N = function(y) {
        if (f.paused || !o) return;
        const x = y.relatedTarget;
        x !== null && (o.contains(x) || Rl(k.current, { select: !0 }));
      }, S = function(y) {
        if (document.activeElement === document.body)
          for (const R of y)
            R.removedNodes.length > 0 && Rl(o);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", N);
      const F = new MutationObserver(S);
      return o && F.observe(o, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", N), F.disconnect();
      };
    }
  }, [t, o, f.paused]), w.useEffect(() => {
    if (o) {
      r4.add(f);
      const h = document.activeElement;
      if (!o.contains(h)) {
        const S = new CustomEvent(b0, l4);
        o.addEventListener(b0, c), o.dispatchEvent(S), S.defaultPrevented || (fJ(SJ(u6(o)), { select: !0 }), document.activeElement === h && Rl(o));
      }
      return () => {
        o.removeEventListener(b0, c), setTimeout(() => {
          const S = new CustomEvent(C0, l4);
          o.addEventListener(C0, u), o.dispatchEvent(S), S.defaultPrevented || Rl(h != null ? h : document.body, { select: !0 }), o.removeEventListener(C0, u), r4.remove(f);
        }, 0);
      };
    }
  }, [o, c, u, f]);
  const p = w.useCallback(
    (h) => {
      if (!i && !t || f.paused) return;
      const N = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, S = document.activeElement;
      if (N && S) {
        const F = h.currentTarget, [y, x] = vJ(F);
        y && x ? !h.shiftKey && S === x ? (h.preventDefault(), i && Rl(y, { select: !0 })) : h.shiftKey && S === y && (h.preventDefault(), i && Rl(x, { select: !0 })) : S === F && h.preventDefault();
      }
    },
    [i, t, f.paused]
  );
  return /* @__PURE__ */ l.jsx(ln.div, { tabIndex: -1, ...r, ref: m, onKeyDown: p });
});
Im.displayName = kJ;
function fJ(e, { select: n = !1 } = {}) {
  const i = document.activeElement;
  for (const t of e)
    if (Rl(t, { select: n }), document.activeElement !== i) return;
}
function vJ(e) {
  const n = u6(e), i = s4(n, e), t = s4(n.reverse(), e);
  return [i, t];
}
function u6(e) {
  const n = [], i = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (t) => {
      const a = t.tagName === "INPUT" && t.type === "hidden";
      return t.disabled || t.hidden || a ? NodeFilter.FILTER_SKIP : t.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; i.nextNode(); ) n.push(i.currentNode);
  return n;
}
function s4(e, n) {
  for (const i of e)
    if (!hJ(i, { upTo: n })) return i;
}
function hJ(e, { upTo: n }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (n !== void 0 && e === n) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function pJ(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Rl(e, { select: n = !1 } = {}) {
  if (e && e.focus) {
    const i = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== i && pJ(e) && n && e.select();
  }
}
var r4 = NJ();
function NJ() {
  let e = [];
  return {
    add(n) {
      const i = e[0];
      n !== i && (i == null || i.pause()), e = o4(e, n), e.unshift(n);
    },
    remove(n) {
      var i;
      e = o4(e, n), (i = e[0]) == null || i.resume();
    }
  };
}
function o4(e, n) {
  const i = [...e], t = i.indexOf(n);
  return t !== -1 && i.splice(t, 1), i;
}
function SJ(e) {
  return e.filter((n) => n.tagName !== "A");
}
const gJ = ["top", "right", "bottom", "left"], Kl = Math.min, Pt = Math.max, vu = Math.round, ac = Math.floor, Pa = (e) => ({
  x: e,
  y: e
}), FJ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, IJ = {
  start: "end",
  end: "start"
};
function Y3(e, n, i) {
  return Pt(e, Kl(n, i));
}
function al(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function ll(e) {
  return e.split("-")[0];
}
function gr(e) {
  return e.split("-")[1];
}
function Sv(e) {
  return e === "x" ? "y" : "x";
}
function gv(e) {
  return e === "y" ? "height" : "width";
}
const yJ = /* @__PURE__ */ new Set(["top", "bottom"]);
function Ia(e) {
  return yJ.has(ll(e)) ? "y" : "x";
}
function Fv(e) {
  return Sv(Ia(e));
}
function bJ(e, n, i) {
  i === void 0 && (i = !1);
  const t = gr(e), a = Fv(e), s = gv(a);
  let r = a === "x" ? t === (i ? "end" : "start") ? "right" : "left" : t === "start" ? "bottom" : "top";
  return n.reference[s] > n.floating[s] && (r = hu(r)), [r, hu(r)];
}
function CJ(e) {
  const n = hu(e);
  return [X3(e), n, X3(n)];
}
function X3(e) {
  return e.replace(/start|end/g, (n) => IJ[n]);
}
const d4 = ["left", "right"], c4 = ["right", "left"], xJ = ["top", "bottom"], DJ = ["bottom", "top"];
function wJ(e, n, i) {
  switch (e) {
    case "top":
    case "bottom":
      return i ? n ? c4 : d4 : n ? d4 : c4;
    case "left":
    case "right":
      return n ? xJ : DJ;
    default:
      return [];
  }
}
function PJ(e, n, i, t) {
  const a = gr(e);
  let s = wJ(ll(e), i === "start", t);
  return a && (s = s.map((r) => r + "-" + a), n && (s = s.concat(s.map(X3)))), s;
}
function hu(e) {
  return e.replace(/left|right|bottom|top/g, (n) => FJ[n]);
}
function RJ(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function m6(e) {
  return typeof e != "number" ? RJ(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function pu(e) {
  const {
    x: n,
    y: i,
    width: t,
    height: a
  } = e;
  return {
    width: t,
    height: a,
    top: i,
    left: n,
    right: n + t,
    bottom: i + a,
    x: n,
    y: i
  };
}
function u4(e, n, i) {
  let {
    reference: t,
    floating: a
  } = e;
  const s = Ia(n), r = Fv(n), o = gv(r), d = ll(n), c = s === "y", u = t.x + t.width / 2 - a.width / 2, k = t.y + t.height / 2 - a.height / 2, m = t[o] / 2 - a[o] / 2;
  let f;
  switch (d) {
    case "top":
      f = {
        x: u,
        y: t.y - a.height
      };
      break;
    case "bottom":
      f = {
        x: u,
        y: t.y + t.height
      };
      break;
    case "right":
      f = {
        x: t.x + t.width,
        y: k
      };
      break;
    case "left":
      f = {
        x: t.x - a.width,
        y: k
      };
      break;
    default:
      f = {
        x: t.x,
        y: t.y
      };
  }
  switch (gr(n)) {
    case "start":
      f[r] -= m * (i && c ? -1 : 1);
      break;
    case "end":
      f[r] += m * (i && c ? -1 : 1);
      break;
  }
  return f;
}
async function TJ(e, n) {
  var i;
  n === void 0 && (n = {});
  const {
    x: t,
    y: a,
    platform: s,
    rects: r,
    elements: o,
    strategy: d
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: k = "floating",
    altBoundary: m = !1,
    padding: f = 0
  } = al(n, e), p = m6(f), N = o[m ? k === "floating" ? "reference" : "floating" : k], S = pu(await s.getClippingRect({
    element: (i = await (s.isElement == null ? void 0 : s.isElement(N))) == null || i ? N : N.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(o.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: d
  })), F = k === "floating" ? {
    x: t,
    y: a,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, y = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(o.floating)), x = await (s.isElement == null ? void 0 : s.isElement(y)) ? await (s.getScale == null ? void 0 : s.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = pu(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: F,
    offsetParent: y,
    strategy: d
  }) : F);
  return {
    top: (S.top - R.top + p.top) / x.y,
    bottom: (R.bottom - S.bottom + p.bottom) / x.y,
    left: (S.left - R.left + p.left) / x.x,
    right: (R.right - S.right + p.right) / x.x
  };
}
const jJ = async (e, n, i) => {
  const {
    placement: t = "bottom",
    strategy: a = "absolute",
    middleware: s = [],
    platform: r
  } = i, o = s.filter(Boolean), d = await (r.isRTL == null ? void 0 : r.isRTL(n));
  let c = await r.getElementRects({
    reference: e,
    floating: n,
    strategy: a
  }), {
    x: u,
    y: k
  } = u4(c, t, d), m = t, f = {}, p = 0;
  for (let N = 0; N < o.length; N++) {
    var h;
    const {
      name: S,
      fn: F
    } = o[N], {
      x: y,
      y: x,
      data: R,
      reset: T
    } = await F({
      x: u,
      y: k,
      initialPlacement: t,
      placement: m,
      strategy: a,
      middlewareData: f,
      rects: c,
      platform: {
        ...r,
        detectOverflow: (h = r.detectOverflow) != null ? h : TJ
      },
      elements: {
        reference: e,
        floating: n
      }
    });
    u = y != null ? y : u, k = x != null ? x : k, f = {
      ...f,
      [S]: {
        ...f[S],
        ...R
      }
    }, T && p <= 50 && (p++, typeof T == "object" && (T.placement && (m = T.placement), T.rects && (c = T.rects === !0 ? await r.getElementRects({
      reference: e,
      floating: n,
      strategy: a
    }) : T.rects), {
      x: u,
      y: k
    } = u4(c, m, d)), N = -1);
  }
  return {
    x: u,
    y: k,
    placement: m,
    strategy: a,
    middlewareData: f
  };
}, AJ = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: i,
      y: t,
      placement: a,
      rects: s,
      platform: r,
      elements: o,
      middlewareData: d
    } = n, {
      element: c,
      padding: u = 0
    } = al(e, n) || {};
    if (c == null)
      return {};
    const k = m6(u), m = {
      x: i,
      y: t
    }, f = Fv(a), p = gv(f), h = await r.getDimensions(c), N = f === "y", S = N ? "top" : "left", F = N ? "bottom" : "right", y = N ? "clientHeight" : "clientWidth", x = s.reference[p] + s.reference[f] - m[f] - s.floating[p], R = m[f] - s.reference[f], T = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(c));
    let j = T ? T[y] : 0;
    (!j || !await (r.isElement == null ? void 0 : r.isElement(T))) && (j = o.floating[y] || s.floating[p]);
    const A = x / 2 - R / 2, B = j / 2 - h[p] / 2 - 1, W = Kl(k[S], B), E = Kl(k[F], B), $ = W, V = j - h[p] - E, H = j / 2 - h[p] / 2 + A, O = Y3($, H, V), M = !d.arrow && gr(a) != null && H !== O && s.reference[p] / 2 - (H < $ ? W : E) - h[p] / 2 < 0, L = M ? H < $ ? H - $ : H - V : 0;
    return {
      [f]: m[f] + L,
      data: {
        [f]: O,
        centerOffset: H - O - L,
        ...M && {
          alignmentOffset: L
        }
      },
      reset: M
    };
  }
}), OJ = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var i, t;
      const {
        placement: a,
        middlewareData: s,
        rects: r,
        initialPlacement: o,
        platform: d,
        elements: c
      } = n, {
        mainAxis: u = !0,
        crossAxis: k = !0,
        fallbackPlacements: m,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: h = !0,
        ...N
      } = al(e, n);
      if ((i = s.arrow) != null && i.alignmentOffset)
        return {};
      const S = ll(a), F = Ia(o), y = ll(o) === o, x = await (d.isRTL == null ? void 0 : d.isRTL(c.floating)), R = m || (y || !h ? [hu(o)] : CJ(o)), T = p !== "none";
      !m && T && R.push(...PJ(o, h, p, x));
      const j = [o, ...R], A = await d.detectOverflow(n, N), B = [];
      let W = ((t = s.flip) == null ? void 0 : t.overflows) || [];
      if (u && B.push(A[S]), k) {
        const H = bJ(a, r, x);
        B.push(A[H[0]], A[H[1]]);
      }
      if (W = [...W, {
        placement: a,
        overflows: B
      }], !B.every((H) => H <= 0)) {
        var E, $;
        const H = (((E = s.flip) == null ? void 0 : E.index) || 0) + 1, O = j[H];
        if (O && (!(k === "alignment" ? F !== Ia(O) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        W.every((_) => Ia(_.placement) === F ? _.overflows[0] > 0 : !0)))
          return {
            data: {
              index: H,
              overflows: W
            },
            reset: {
              placement: O
            }
          };
        let M = ($ = W.filter((L) => L.overflows[0] <= 0).sort((L, _) => L.overflows[1] - _.overflows[1])[0]) == null ? void 0 : $.placement;
        if (!M)
          switch (f) {
            case "bestFit": {
              var V;
              const L = (V = W.filter((_) => {
                if (T) {
                  const z = Ia(_.placement);
                  return z === F || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  z === "y";
                }
                return !0;
              }).map((_) => [_.placement, _.overflows.filter((z) => z > 0).reduce((z, ne) => z + ne, 0)]).sort((_, z) => _[1] - z[1])[0]) == null ? void 0 : V[0];
              L && (M = L);
              break;
            }
            case "initialPlacement":
              M = o;
              break;
          }
        if (a !== M)
          return {
            reset: {
              placement: M
            }
          };
      }
      return {};
    }
  };
};
function m4(e, n) {
  return {
    top: e.top - n.height,
    right: e.right - n.width,
    bottom: e.bottom - n.height,
    left: e.left - n.width
  };
}
function k4(e) {
  return gJ.some((n) => e[n] >= 0);
}
const EJ = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(n) {
      const {
        rects: i,
        platform: t
      } = n, {
        strategy: a = "referenceHidden",
        ...s
      } = al(e, n);
      switch (a) {
        case "referenceHidden": {
          const r = await t.detectOverflow(n, {
            ...s,
            elementContext: "reference"
          }), o = m4(r, i.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: k4(o)
            }
          };
        }
        case "escaped": {
          const r = await t.detectOverflow(n, {
            ...s,
            altBoundary: !0
          }), o = m4(r, i.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: k4(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, k6 = /* @__PURE__ */ new Set(["left", "top"]);
async function JJ(e, n) {
  const {
    placement: i,
    platform: t,
    elements: a
  } = e, s = await (t.isRTL == null ? void 0 : t.isRTL(a.floating)), r = ll(i), o = gr(i), d = Ia(i) === "y", c = k6.has(r) ? -1 : 1, u = s && d ? -1 : 1, k = al(n, e);
  let {
    mainAxis: m,
    crossAxis: f,
    alignmentAxis: p
  } = typeof k == "number" ? {
    mainAxis: k,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: k.mainAxis || 0,
    crossAxis: k.crossAxis || 0,
    alignmentAxis: k.alignmentAxis
  };
  return o && typeof p == "number" && (f = o === "end" ? p * -1 : p), d ? {
    x: f * u,
    y: m * c
  } : {
    x: m * c,
    y: f * u
  };
}
const _J = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var i, t;
      const {
        x: a,
        y: s,
        placement: r,
        middlewareData: o
      } = n, d = await JJ(n, e);
      return r === ((i = o.offset) == null ? void 0 : i.placement) && (t = o.arrow) != null && t.alignmentOffset ? {} : {
        x: a + d.x,
        y: s + d.y,
        data: {
          ...d,
          placement: r
        }
      };
    }
  };
}, QJ = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: i,
        y: t,
        placement: a,
        platform: s
      } = n, {
        mainAxis: r = !0,
        crossAxis: o = !1,
        limiter: d = {
          fn: (S) => {
            let {
              x: F,
              y
            } = S;
            return {
              x: F,
              y
            };
          }
        },
        ...c
      } = al(e, n), u = {
        x: i,
        y: t
      }, k = await s.detectOverflow(n, c), m = Ia(ll(a)), f = Sv(m);
      let p = u[f], h = u[m];
      if (r) {
        const S = f === "y" ? "top" : "left", F = f === "y" ? "bottom" : "right", y = p + k[S], x = p - k[F];
        p = Y3(y, p, x);
      }
      if (o) {
        const S = m === "y" ? "top" : "left", F = m === "y" ? "bottom" : "right", y = h + k[S], x = h - k[F];
        h = Y3(y, h, x);
      }
      const N = d.fn({
        ...n,
        [f]: p,
        [m]: h
      });
      return {
        ...N,
        data: {
          x: N.x - i,
          y: N.y - t,
          enabled: {
            [f]: r,
            [m]: o
          }
        }
      };
    }
  };
}, MJ = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(n) {
      const {
        x: i,
        y: t,
        placement: a,
        rects: s,
        middlewareData: r
      } = n, {
        offset: o = 0,
        mainAxis: d = !0,
        crossAxis: c = !0
      } = al(e, n), u = {
        x: i,
        y: t
      }, k = Ia(a), m = Sv(k);
      let f = u[m], p = u[k];
      const h = al(o, n), N = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (d) {
        const y = m === "y" ? "height" : "width", x = s.reference[m] - s.floating[y] + N.mainAxis, R = s.reference[m] + s.reference[y] - N.mainAxis;
        f < x ? f = x : f > R && (f = R);
      }
      if (c) {
        var S, F;
        const y = m === "y" ? "width" : "height", x = k6.has(ll(a)), R = s.reference[k] - s.floating[y] + (x && ((S = r.offset) == null ? void 0 : S[k]) || 0) + (x ? 0 : N.crossAxis), T = s.reference[k] + s.reference[y] + (x ? 0 : ((F = r.offset) == null ? void 0 : F[k]) || 0) - (x ? N.crossAxis : 0);
        p < R ? p = R : p > T && (p = T);
      }
      return {
        [m]: f,
        [k]: p
      };
    }
  };
}, LJ = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(n) {
      var i, t;
      const {
        placement: a,
        rects: s,
        platform: r,
        elements: o
      } = n, {
        apply: d = () => {
        },
        ...c
      } = al(e, n), u = await r.detectOverflow(n, c), k = ll(a), m = gr(a), f = Ia(a) === "y", {
        width: p,
        height: h
      } = s.floating;
      let N, S;
      k === "top" || k === "bottom" ? (N = k, S = m === (await (r.isRTL == null ? void 0 : r.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (S = k, N = m === "end" ? "top" : "bottom");
      const F = h - u.top - u.bottom, y = p - u.left - u.right, x = Kl(h - u[N], F), R = Kl(p - u[S], y), T = !n.middlewareData.shift;
      let j = x, A = R;
      if ((i = n.middlewareData.shift) != null && i.enabled.x && (A = y), (t = n.middlewareData.shift) != null && t.enabled.y && (j = F), T && !m) {
        const W = Pt(u.left, 0), E = Pt(u.right, 0), $ = Pt(u.top, 0), V = Pt(u.bottom, 0);
        f ? A = p - 2 * (W !== 0 || E !== 0 ? W + E : Pt(u.left, u.right)) : j = h - 2 * ($ !== 0 || V !== 0 ? $ + V : Pt(u.top, u.bottom));
      }
      await d({
        ...n,
        availableWidth: A,
        availableHeight: j
      });
      const B = await r.getDimensions(o.floating);
      return p !== B.width || h !== B.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ym() {
  return typeof window != "undefined";
}
function Fr(e) {
  return f6(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Tt(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function Ma(e) {
  var n;
  return (n = (f6(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function f6(e) {
  return ym() ? e instanceof Node || e instanceof Tt(e).Node : !1;
}
function aa(e) {
  return ym() ? e instanceof Element || e instanceof Tt(e).Element : !1;
}
function Ea(e) {
  return ym() ? e instanceof HTMLElement || e instanceof Tt(e).HTMLElement : !1;
}
function f4(e) {
  return !ym() || typeof ShadowRoot == "undefined" ? !1 : e instanceof ShadowRoot || e instanceof Tt(e).ShadowRoot;
}
const $J = /* @__PURE__ */ new Set(["inline", "contents"]);
function fd(e) {
  const {
    overflow: n,
    overflowX: i,
    overflowY: t,
    display: a
  } = la(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + t + i) && !$J.has(a);
}
const UJ = /* @__PURE__ */ new Set(["table", "td", "th"]);
function VJ(e) {
  return UJ.has(Fr(e));
}
const HJ = [":popover-open", ":modal"];
function bm(e) {
  return HJ.some((n) => {
    try {
      return e.matches(n);
    } catch (i) {
      return !1;
    }
  });
}
const zJ = ["transform", "translate", "scale", "rotate", "perspective"], BJ = ["transform", "translate", "scale", "rotate", "perspective", "filter"], qJ = ["paint", "layout", "strict", "content"];
function Iv(e) {
  const n = yv(), i = aa(e) ? la(e) : e;
  return zJ.some((t) => i[t] ? i[t] !== "none" : !1) || (i.containerType ? i.containerType !== "normal" : !1) || !n && (i.backdropFilter ? i.backdropFilter !== "none" : !1) || !n && (i.filter ? i.filter !== "none" : !1) || BJ.some((t) => (i.willChange || "").includes(t)) || qJ.some((t) => (i.contain || "").includes(t));
}
function GJ(e) {
  let n = Yl(e);
  for (; Ea(n) && !K1(n); ) {
    if (Iv(n))
      return n;
    if (bm(n))
      return null;
    n = Yl(n);
  }
  return null;
}
function yv() {
  return typeof CSS == "undefined" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const WJ = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function K1(e) {
  return WJ.has(Fr(e));
}
function la(e) {
  return Tt(e).getComputedStyle(e);
}
function Cm(e) {
  return aa(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Yl(e) {
  if (Fr(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    f4(e) && e.host || // Fallback.
    Ma(e)
  );
  return f4(n) ? n.host : n;
}
function v6(e) {
  const n = Yl(e);
  return K1(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ea(n) && fd(n) ? n : v6(n);
}
function $o(e, n, i) {
  var t;
  n === void 0 && (n = []), i === void 0 && (i = !0);
  const a = v6(e), s = a === ((t = e.ownerDocument) == null ? void 0 : t.body), r = Tt(a);
  if (s) {
    const o = Z3(r);
    return n.concat(r, r.visualViewport || [], fd(a) ? a : [], o && i ? $o(o) : []);
  }
  return n.concat(a, $o(a, [], i));
}
function Z3(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function h6(e) {
  const n = la(e);
  let i = parseFloat(n.width) || 0, t = parseFloat(n.height) || 0;
  const a = Ea(e), s = a ? e.offsetWidth : i, r = a ? e.offsetHeight : t, o = vu(i) !== s || vu(t) !== r;
  return o && (i = s, t = r), {
    width: i,
    height: t,
    $: o
  };
}
function bv(e) {
  return aa(e) ? e : e.contextElement;
}
function M1(e) {
  const n = bv(e);
  if (!Ea(n))
    return Pa(1);
  const i = n.getBoundingClientRect(), {
    width: t,
    height: a,
    $: s
  } = h6(n);
  let r = (s ? vu(i.width) : i.width) / t, o = (s ? vu(i.height) : i.height) / a;
  return (!r || !Number.isFinite(r)) && (r = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: r,
    y: o
  };
}
const KJ = /* @__PURE__ */ Pa(0);
function p6(e) {
  const n = Tt(e);
  return !yv() || !n.visualViewport ? KJ : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function YJ(e, n, i) {
  return n === void 0 && (n = !1), !i || n && i !== Tt(e) ? !1 : n;
}
function Vs(e, n, i, t) {
  n === void 0 && (n = !1), i === void 0 && (i = !1);
  const a = e.getBoundingClientRect(), s = bv(e);
  let r = Pa(1);
  n && (t ? aa(t) && (r = M1(t)) : r = M1(e));
  const o = YJ(s, i, t) ? p6(s) : Pa(0);
  let d = (a.left + o.x) / r.x, c = (a.top + o.y) / r.y, u = a.width / r.x, k = a.height / r.y;
  if (s) {
    const m = Tt(s), f = t && aa(t) ? Tt(t) : t;
    let p = m, h = Z3(p);
    for (; h && t && f !== p; ) {
      const N = M1(h), S = h.getBoundingClientRect(), F = la(h), y = S.left + (h.clientLeft + parseFloat(F.paddingLeft)) * N.x, x = S.top + (h.clientTop + parseFloat(F.paddingTop)) * N.y;
      d *= N.x, c *= N.y, u *= N.x, k *= N.y, d += y, c += x, p = Tt(h), h = Z3(p);
    }
  }
  return pu({
    width: u,
    height: k,
    x: d,
    y: c
  });
}
function xm(e, n) {
  const i = Cm(e).scrollLeft;
  return n ? n.left + i : Vs(Ma(e)).left + i;
}
function N6(e, n) {
  const i = e.getBoundingClientRect(), t = i.left + n.scrollLeft - xm(e, i), a = i.top + n.scrollTop;
  return {
    x: t,
    y: a
  };
}
function XJ(e) {
  let {
    elements: n,
    rect: i,
    offsetParent: t,
    strategy: a
  } = e;
  const s = a === "fixed", r = Ma(t), o = n ? bm(n.floating) : !1;
  if (t === r || o && s)
    return i;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Pa(1);
  const u = Pa(0), k = Ea(t);
  if ((k || !k && !s) && ((Fr(t) !== "body" || fd(r)) && (d = Cm(t)), Ea(t))) {
    const f = Vs(t);
    c = M1(t), u.x = f.x + t.clientLeft, u.y = f.y + t.clientTop;
  }
  const m = r && !k && !s ? N6(r, d) : Pa(0);
  return {
    width: i.width * c.x,
    height: i.height * c.y,
    x: i.x * c.x - d.scrollLeft * c.x + u.x + m.x,
    y: i.y * c.y - d.scrollTop * c.y + u.y + m.y
  };
}
function ZJ(e) {
  return Array.from(e.getClientRects());
}
function e_(e) {
  const n = Ma(e), i = Cm(e), t = e.ownerDocument.body, a = Pt(n.scrollWidth, n.clientWidth, t.scrollWidth, t.clientWidth), s = Pt(n.scrollHeight, n.clientHeight, t.scrollHeight, t.clientHeight);
  let r = -i.scrollLeft + xm(e);
  const o = -i.scrollTop;
  return la(t).direction === "rtl" && (r += Pt(n.clientWidth, t.clientWidth) - a), {
    width: a,
    height: s,
    x: r,
    y: o
  };
}
const v4 = 25;
function n_(e, n) {
  const i = Tt(e), t = Ma(e), a = i.visualViewport;
  let s = t.clientWidth, r = t.clientHeight, o = 0, d = 0;
  if (a) {
    s = a.width, r = a.height;
    const u = yv();
    (!u || u && n === "fixed") && (o = a.offsetLeft, d = a.offsetTop);
  }
  const c = xm(t);
  if (c <= 0) {
    const u = t.ownerDocument, k = u.body, m = getComputedStyle(k), f = u.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, p = Math.abs(t.clientWidth - k.clientWidth - f);
    p <= v4 && (s -= p);
  } else c <= v4 && (s += c);
  return {
    width: s,
    height: r,
    x: o,
    y: d
  };
}
const i_ = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function t_(e, n) {
  const i = Vs(e, !0, n === "fixed"), t = i.top + e.clientTop, a = i.left + e.clientLeft, s = Ea(e) ? M1(e) : Pa(1), r = e.clientWidth * s.x, o = e.clientHeight * s.y, d = a * s.x, c = t * s.y;
  return {
    width: r,
    height: o,
    x: d,
    y: c
  };
}
function h4(e, n, i) {
  let t;
  if (n === "viewport")
    t = n_(e, i);
  else if (n === "document")
    t = e_(Ma(e));
  else if (aa(n))
    t = t_(n, i);
  else {
    const a = p6(e);
    t = {
      x: n.x - a.x,
      y: n.y - a.y,
      width: n.width,
      height: n.height
    };
  }
  return pu(t);
}
function S6(e, n) {
  const i = Yl(e);
  return i === n || !aa(i) || K1(i) ? !1 : la(i).position === "fixed" || S6(i, n);
}
function a_(e, n) {
  const i = n.get(e);
  if (i)
    return i;
  let t = $o(e, [], !1).filter((o) => aa(o) && Fr(o) !== "body"), a = null;
  const s = la(e).position === "fixed";
  let r = s ? Yl(e) : e;
  for (; aa(r) && !K1(r); ) {
    const o = la(r), d = Iv(r);
    !d && o.position === "fixed" && (a = null), (s ? !d && !a : !d && o.position === "static" && !!a && i_.has(a.position) || fd(r) && !d && S6(e, r)) ? t = t.filter((u) => u !== r) : a = o, r = Yl(r);
  }
  return n.set(e, t), t;
}
function l_(e) {
  let {
    element: n,
    boundary: i,
    rootBoundary: t,
    strategy: a
  } = e;
  const r = [...i === "clippingAncestors" ? bm(n) ? [] : a_(n, this._c) : [].concat(i), t], o = r[0], d = r.reduce((c, u) => {
    const k = h4(n, u, a);
    return c.top = Pt(k.top, c.top), c.right = Kl(k.right, c.right), c.bottom = Kl(k.bottom, c.bottom), c.left = Pt(k.left, c.left), c;
  }, h4(n, o, a));
  return {
    width: d.right - d.left,
    height: d.bottom - d.top,
    x: d.left,
    y: d.top
  };
}
function s_(e) {
  const {
    width: n,
    height: i
  } = h6(e);
  return {
    width: n,
    height: i
  };
}
function r_(e, n, i) {
  const t = Ea(n), a = Ma(n), s = i === "fixed", r = Vs(e, !0, s, n);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = Pa(0);
  function c() {
    d.x = xm(a);
  }
  if (t || !t && !s)
    if ((Fr(n) !== "body" || fd(a)) && (o = Cm(n)), t) {
      const f = Vs(n, !0, s, n);
      d.x = f.x + n.clientLeft, d.y = f.y + n.clientTop;
    } else a && c();
  s && !t && a && c();
  const u = a && !t && !s ? N6(a, o) : Pa(0), k = r.left + o.scrollLeft - d.x - u.x, m = r.top + o.scrollTop - d.y - u.y;
  return {
    x: k,
    y: m,
    width: r.width,
    height: r.height
  };
}
function x0(e) {
  return la(e).position === "static";
}
function p4(e, n) {
  if (!Ea(e) || la(e).position === "fixed")
    return null;
  if (n)
    return n(e);
  let i = e.offsetParent;
  return Ma(e) === i && (i = i.ownerDocument.body), i;
}
function g6(e, n) {
  const i = Tt(e);
  if (bm(e))
    return i;
  if (!Ea(e)) {
    let a = Yl(e);
    for (; a && !K1(a); ) {
      if (aa(a) && !x0(a))
        return a;
      a = Yl(a);
    }
    return i;
  }
  let t = p4(e, n);
  for (; t && VJ(t) && x0(t); )
    t = p4(t, n);
  return t && K1(t) && x0(t) && !Iv(t) ? i : t || GJ(e) || i;
}
const o_ = async function(e) {
  const n = this.getOffsetParent || g6, i = this.getDimensions, t = await i(e.floating);
  return {
    reference: r_(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: t.width,
      height: t.height
    }
  };
};
function d_(e) {
  return la(e).direction === "rtl";
}
const c_ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: XJ,
  getDocumentElement: Ma,
  getClippingRect: l_,
  getOffsetParent: g6,
  getElementRects: o_,
  getClientRects: ZJ,
  getDimensions: s_,
  getScale: M1,
  isElement: aa,
  isRTL: d_
};
function F6(e, n) {
  return e.x === n.x && e.y === n.y && e.width === n.width && e.height === n.height;
}
function u_(e, n) {
  let i = null, t;
  const a = Ma(e);
  function s() {
    var o;
    clearTimeout(t), (o = i) == null || o.disconnect(), i = null;
  }
  function r(o, d) {
    o === void 0 && (o = !1), d === void 0 && (d = 1), s();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: k,
      width: m,
      height: f
    } = c;
    if (o || n(), !m || !f)
      return;
    const p = ac(k), h = ac(a.clientWidth - (u + m)), N = ac(a.clientHeight - (k + f)), S = ac(u), y = {
      rootMargin: -p + "px " + -h + "px " + -N + "px " + -S + "px",
      threshold: Pt(0, Kl(1, d)) || 1
    };
    let x = !0;
    function R(T) {
      const j = T[0].intersectionRatio;
      if (j !== d) {
        if (!x)
          return r();
        j ? r(!1, j) : t = setTimeout(() => {
          r(!1, 1e-7);
        }, 1e3);
      }
      j === 1 && !F6(c, e.getBoundingClientRect()) && r(), x = !1;
    }
    try {
      i = new IntersectionObserver(R, {
        ...y,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch (T) {
      i = new IntersectionObserver(R, y);
    }
    i.observe(e);
  }
  return r(!0), s;
}
function m_(e, n, i, t) {
  t === void 0 && (t = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: s = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = t, c = bv(e), u = a || s ? [...c ? $o(c) : [], ...$o(n)] : [];
  u.forEach((S) => {
    a && S.addEventListener("scroll", i, {
      passive: !0
    }), s && S.addEventListener("resize", i);
  });
  const k = c && o ? u_(c, i) : null;
  let m = -1, f = null;
  r && (f = new ResizeObserver((S) => {
    let [F] = S;
    F && F.target === c && f && (f.unobserve(n), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var y;
      (y = f) == null || y.observe(n);
    })), i();
  }), c && !d && f.observe(c), f.observe(n));
  let p, h = d ? Vs(e) : null;
  d && N();
  function N() {
    const S = Vs(e);
    h && !F6(h, S) && i(), h = S, p = requestAnimationFrame(N);
  }
  return i(), () => {
    var S;
    u.forEach((F) => {
      a && F.removeEventListener("scroll", i), s && F.removeEventListener("resize", i);
    }), k == null || k(), (S = f) == null || S.disconnect(), f = null, d && cancelAnimationFrame(p);
  };
}
const k_ = _J, f_ = QJ, v_ = OJ, h_ = LJ, p_ = EJ, N4 = AJ, N_ = MJ, S_ = (e, n, i) => {
  const t = /* @__PURE__ */ new Map(), a = {
    platform: c_,
    ...i
  }, s = {
    ...a.platform,
    _c: t
  };
  return jJ(e, n, {
    ...a,
    platform: s
  });
};
var g_ = typeof document != "undefined", F_ = function() {
}, Jc = g_ ? as : F_;
function Nu(e, n) {
  if (e === n)
    return !0;
  if (typeof e != typeof n)
    return !1;
  if (typeof e == "function" && e.toString() === n.toString())
    return !0;
  let i, t, a;
  if (e && n && typeof e == "object") {
    if (Array.isArray(e)) {
      if (i = e.length, i !== n.length) return !1;
      for (t = i; t-- !== 0; )
        if (!Nu(e[t], n[t]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), i = a.length, i !== Object.keys(n).length)
      return !1;
    for (t = i; t-- !== 0; )
      if (!{}.hasOwnProperty.call(n, a[t]))
        return !1;
    for (t = i; t-- !== 0; ) {
      const s = a[t];
      if (!(s === "_owner" && e.$$typeof) && !Nu(e[s], n[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}
function I6(e) {
  return typeof window == "undefined" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function S4(e, n) {
  const i = I6(e);
  return Math.round(n * i) / i;
}
function D0(e) {
  const n = w.useRef(e);
  return Jc(() => {
    n.current = e;
  }), n;
}
function I_(e) {
  e === void 0 && (e = {});
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: t = [],
    platform: a,
    elements: {
      reference: s,
      floating: r
    } = {},
    transform: o = !0,
    whileElementsMounted: d,
    open: c
  } = e, [u, k] = w.useState({
    x: 0,
    y: 0,
    strategy: i,
    placement: n,
    middlewareData: {},
    isPositioned: !1
  }), [m, f] = w.useState(t);
  Nu(m, t) || f(t);
  const [p, h] = w.useState(null), [N, S] = w.useState(null), F = w.useCallback((_) => {
    _ !== T.current && (T.current = _, h(_));
  }, []), y = w.useCallback((_) => {
    _ !== j.current && (j.current = _, S(_));
  }, []), x = s || p, R = r || N, T = w.useRef(null), j = w.useRef(null), A = w.useRef(u), B = d != null, W = D0(d), E = D0(a), $ = D0(c), V = w.useCallback(() => {
    if (!T.current || !j.current)
      return;
    const _ = {
      placement: n,
      strategy: i,
      middleware: m
    };
    E.current && (_.platform = E.current), S_(T.current, j.current, _).then((z) => {
      const ne = {
        ...z,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: $.current !== !1
      };
      H.current && !Nu(A.current, ne) && (A.current = ne, Gu.flushSync(() => {
        k(ne);
      }));
    });
  }, [m, n, i, E, $]);
  Jc(() => {
    c === !1 && A.current.isPositioned && (A.current.isPositioned = !1, k((_) => ({
      ..._,
      isPositioned: !1
    })));
  }, [c]);
  const H = w.useRef(!1);
  Jc(() => (H.current = !0, () => {
    H.current = !1;
  }), []), Jc(() => {
    if (x && (T.current = x), R && (j.current = R), x && R) {
      if (W.current)
        return W.current(x, R, V);
      V();
    }
  }, [x, R, V, W, B]);
  const O = w.useMemo(() => ({
    reference: T,
    floating: j,
    setReference: F,
    setFloating: y
  }), [F, y]), M = w.useMemo(() => ({
    reference: x,
    floating: R
  }), [x, R]), L = w.useMemo(() => {
    const _ = {
      position: i,
      left: 0,
      top: 0
    };
    if (!M.floating)
      return _;
    const z = S4(M.floating, u.x), ne = S4(M.floating, u.y);
    return o ? {
      ..._,
      transform: "translate(" + z + "px, " + ne + "px)",
      ...I6(M.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: i,
      left: z,
      top: ne
    };
  }, [i, o, M.floating, u.x, u.y]);
  return w.useMemo(() => ({
    ...u,
    update: V,
    refs: O,
    elements: M,
    floatingStyles: L
  }), [u, V, O, M, L]);
}
const y_ = (e) => {
  function n(i) {
    return {}.hasOwnProperty.call(i, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(i) {
      const {
        element: t,
        padding: a
      } = typeof e == "function" ? e(i) : e;
      return t && n(t) ? t.current != null ? N4({
        element: t.current,
        padding: a
      }).fn(i) : {} : t ? N4({
        element: t,
        padding: a
      }).fn(i) : {};
    }
  };
}, b_ = (e, n) => ({
  ...k_(e),
  options: [e, n]
}), C_ = (e, n) => ({
  ...f_(e),
  options: [e, n]
}), x_ = (e, n) => ({
  ...N_(e),
  options: [e, n]
}), D_ = (e, n) => ({
  ...v_(e),
  options: [e, n]
}), w_ = (e, n) => ({
  ...h_(e),
  options: [e, n]
}), P_ = (e, n) => ({
  ...p_(e),
  options: [e, n]
}), R_ = (e, n) => ({
  ...y_(e),
  options: [e, n]
});
var T_ = "Arrow", y6 = w.forwardRef((e, n) => {
  const { children: i, width: t = 10, height: a = 5, ...s } = e;
  return /* @__PURE__ */ l.jsx(
    ln.svg,
    {
      ...s,
      ref: n,
      width: t,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? i : /* @__PURE__ */ l.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
y6.displayName = T_;
var j_ = y6, Cv = "Popper", [b6, Dm] = $t(Cv), [A_, C6] = b6(Cv), x6 = (e) => {
  const { __scopePopper: n, children: i } = e, [t, a] = w.useState(null);
  return /* @__PURE__ */ l.jsx(A_, { scope: n, anchor: t, onAnchorChange: a, children: i });
};
x6.displayName = Cv;
var D6 = "PopperAnchor", w6 = w.forwardRef(
  (e, n) => {
    const { __scopePopper: i, virtualRef: t, ...a } = e, s = C6(D6, i), r = w.useRef(null), o = Rn(n, r), d = w.useRef(null);
    return w.useEffect(() => {
      const c = d.current;
      d.current = (t == null ? void 0 : t.current) || r.current, c !== d.current && s.onAnchorChange(d.current);
    }), t ? null : /* @__PURE__ */ l.jsx(ln.div, { ...a, ref: o });
  }
);
w6.displayName = D6;
var xv = "PopperContent", [O_, E_] = b6(xv), P6 = w.forwardRef(
  (e, n) => {
    var ie, De, _e, Ie, Fe, re, Me, ge;
    const {
      __scopePopper: i,
      side: t = "bottom",
      sideOffset: a = 0,
      align: s = "center",
      alignOffset: r = 0,
      arrowPadding: o = 0,
      avoidCollisions: d = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: k = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: f = "optimized",
      onPlaced: p,
      ...h
    } = e, N = C6(xv, i), [S, F] = w.useState(null), y = Rn(n, (rn) => F(rn)), [x, R] = w.useState(null), T = Nm(x), j = (ie = T == null ? void 0 : T.width) != null ? ie : 0, A = (De = T == null ? void 0 : T.height) != null ? De : 0, B = t + (s !== "center" ? "-" + s : ""), W = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, E = Array.isArray(c) ? c : [c], $ = E.length > 0, V = {
      padding: W,
      boundary: E.filter(__),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: $
    }, { refs: H, floatingStyles: O, placement: M, isPositioned: L, middlewareData: _ } = I_({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: B,
      whileElementsMounted: (...rn) => m_(...rn, {
        animationFrame: f === "always"
      }),
      elements: {
        reference: N.anchor
      },
      middleware: [
        b_({ mainAxis: a + A, alignmentAxis: r }),
        d && C_({
          mainAxis: !0,
          crossAxis: !1,
          limiter: k === "partial" ? x_() : void 0,
          ...V
        }),
        d && D_({ ...V }),
        w_({
          ...V,
          apply: ({ elements: rn, rects: Sn, availableWidth: Jn, availableHeight: Xn }) => {
            const { width: Mn, height: Zn } = Sn.reference, mn = rn.floating.style;
            mn.setProperty("--radix-popper-available-width", `${Jn}px`), mn.setProperty("--radix-popper-available-height", `${Xn}px`), mn.setProperty("--radix-popper-anchor-width", `${Mn}px`), mn.setProperty("--radix-popper-anchor-height", `${Zn}px`);
          }
        }),
        x && R_({ element: x, padding: o }),
        Q_({ arrowWidth: j, arrowHeight: A }),
        m && P_({ strategy: "referenceHidden", ...V })
      ]
    }), [z, ne] = j6(M), Se = Wl(p);
    Mi(() => {
      L && (Se == null || Se());
    }, [L, Se]);
    const he = (_e = _.arrow) == null ? void 0 : _e.x, ue = (Ie = _.arrow) == null ? void 0 : Ie.y, oe = ((Fe = _.arrow) == null ? void 0 : Fe.centerOffset) !== 0, [$e, we] = w.useState();
    return Mi(() => {
      S && we(window.getComputedStyle(S).zIndex);
    }, [S]), /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...O,
          transform: L ? O.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: $e,
          "--radix-popper-transform-origin": [
            (re = _.transformOrigin) == null ? void 0 : re.x,
            (Me = _.transformOrigin) == null ? void 0 : Me.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ge = _.hide) == null ? void 0 : ge.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ l.jsx(
          O_,
          {
            scope: i,
            placedSide: z,
            onArrowChange: R,
            arrowX: he,
            arrowY: ue,
            shouldHideArrow: oe,
            children: /* @__PURE__ */ l.jsx(
              ln.div,
              {
                "data-side": z,
                "data-align": ne,
                ...h,
                ref: y,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: L ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
P6.displayName = xv;
var R6 = "PopperArrow", J_ = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, T6 = w.forwardRef(function(n, i) {
  const { __scopePopper: t, ...a } = n, s = E_(R6, t), r = J_[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ l.jsx(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [r]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ l.jsx(
          j_,
          {
            ...a,
            ref: i,
            style: {
              ...a.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
T6.displayName = R6;
function __(e) {
  return e !== null;
}
var Q_ = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(n) {
    var N, S, F, y, x;
    const { placement: i, rects: t, middlewareData: a } = n, r = ((N = a.arrow) == null ? void 0 : N.centerOffset) !== 0, o = r ? 0 : e.arrowWidth, d = r ? 0 : e.arrowHeight, [c, u] = j6(i), k = { start: "0%", center: "50%", end: "100%" }[u], m = ((F = (S = a.arrow) == null ? void 0 : S.x) != null ? F : 0) + o / 2, f = ((x = (y = a.arrow) == null ? void 0 : y.y) != null ? x : 0) + d / 2;
    let p = "", h = "";
    return c === "bottom" ? (p = r ? k : `${m}px`, h = `${-d}px`) : c === "top" ? (p = r ? k : `${m}px`, h = `${t.floating.height + d}px`) : c === "right" ? (p = `${-d}px`, h = r ? k : `${f}px`) : c === "left" && (p = `${t.floating.width + d}px`, h = r ? k : `${f}px`), { data: { x: p, y: h } };
  }
});
function j6(e) {
  const [n, i = "center"] = e.split("-");
  return [n, i];
}
var M_ = x6, Dv = w6, A6 = P6, O6 = T6, L_ = "Portal", wv = w.forwardRef((e, n) => {
  var o;
  const { container: i, ...t } = e, [a, s] = w.useState(!1);
  Mi(() => s(!0), []);
  const r = i || a && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return r ? pf.createPortal(/* @__PURE__ */ l.jsx(ln.div, { ...t, ref: n }), r) : null;
});
wv.displayName = L_;
var E6 = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), $_ = "VisuallyHidden", U_ = w.forwardRef(
  (e, n) => /* @__PURE__ */ l.jsx(
    ln.span,
    {
      ...e,
      ref: n,
      style: { ...E6, ...e.style }
    }
  )
);
U_.displayName = $_;
var V_ = function(e) {
  if (typeof document == "undefined")
    return null;
  var n = Array.isArray(e) ? e[0] : e;
  return n.ownerDocument.body;
}, p1 = /* @__PURE__ */ new WeakMap(), lc = /* @__PURE__ */ new WeakMap(), sc = {}, w0 = 0, J6 = function(e) {
  return e && (e.host || J6(e.parentNode));
}, H_ = function(e, n) {
  return n.map(function(i) {
    if (e.contains(i))
      return i;
    var t = J6(i);
    return t && e.contains(t) ? t : (console.error("aria-hidden", i, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(i) {
    return !!i;
  });
}, z_ = function(e, n, i, t) {
  var a = H_(n, Array.isArray(e) ? e : [e]);
  sc[i] || (sc[i] = /* @__PURE__ */ new WeakMap());
  var s = sc[i], r = [], o = /* @__PURE__ */ new Set(), d = new Set(a), c = function(k) {
    !k || o.has(k) || (o.add(k), c(k.parentNode));
  };
  a.forEach(c);
  var u = function(k) {
    !k || d.has(k) || Array.prototype.forEach.call(k.children, function(m) {
      if (o.has(m))
        u(m);
      else
        try {
          var f = m.getAttribute(t), p = f !== null && f !== "false", h = (p1.get(m) || 0) + 1, N = (s.get(m) || 0) + 1;
          p1.set(m, h), s.set(m, N), r.push(m), h === 1 && p && lc.set(m, !0), N === 1 && m.setAttribute(i, "true"), p || m.setAttribute(t, "true");
        } catch (S) {
          console.error("aria-hidden: cannot operate on ", m, S);
        }
    });
  };
  return u(n), o.clear(), w0++, function() {
    r.forEach(function(k) {
      var m = p1.get(k) - 1, f = s.get(k) - 1;
      p1.set(k, m), s.set(k, f), m || (lc.has(k) || k.removeAttribute(t), lc.delete(k)), f || k.removeAttribute(i);
    }), w0--, w0 || (p1 = /* @__PURE__ */ new WeakMap(), p1 = /* @__PURE__ */ new WeakMap(), lc = /* @__PURE__ */ new WeakMap(), sc = {});
  };
}, Pv = function(e, n, i) {
  i === void 0 && (i = "data-aria-hidden");
  var t = Array.from(Array.isArray(e) ? e : [e]), a = V_(e);
  return a ? (t.push.apply(t, Array.from(a.querySelectorAll("[aria-live], script"))), z_(t, a, i, "aria-hidden")) : function() {
    return null;
  };
}, ek = function(e, n) {
  return ek = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, t) {
    i.__proto__ = t;
  } || function(i, t) {
    for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (i[a] = t[a]);
  }, ek(e, n);
};
function ca(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  ek(e, n);
  function i() {
    this.constructor = e;
  }
  e.prototype = n === null ? Object.create(n) : (i.prototype = n.prototype, new i());
}
var G = function() {
  return G = Object.assign || function(n) {
    for (var i, t = 1, a = arguments.length; t < a; t++) {
      i = arguments[t];
      for (var s in i) Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }
    return n;
  }, G.apply(this, arguments);
};
function Mt(e, n) {
  var i = {};
  for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && n.indexOf(t) < 0 && (i[t] = e[t]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, t = Object.getOwnPropertySymbols(e); a < t.length; a++)
      n.indexOf(t[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[a]) && (i[t[a]] = e[t[a]]);
  return i;
}
function jl(e, n, i, t) {
  function a(s) {
    return s instanceof i ? s : new i(function(r) {
      r(s);
    });
  }
  return new (i || (i = Promise))(function(s, r) {
    function o(u) {
      try {
        c(t.next(u));
      } catch (k) {
        r(k);
      }
    }
    function d(u) {
      try {
        c(t.throw(u));
      } catch (k) {
        r(k);
      }
    }
    function c(u) {
      u.done ? s(u.value) : a(u.value).then(o, d);
    }
    c((t = t.apply(e, n || [])).next());
  });
}
function Al(e, n) {
  var i = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, t, a, s, r = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return r.next = o(0), r.throw = o(1), r.return = o(2), typeof Symbol == "function" && (r[Symbol.iterator] = function() {
    return this;
  }), r;
  function o(c) {
    return function(u) {
      return d([c, u]);
    };
  }
  function d(c) {
    if (t) throw new TypeError("Generator is already executing.");
    for (; r && (r = 0, c[0] && (i = 0)), i; ) try {
      if (t = 1, a && (s = c[0] & 2 ? a.return : c[0] ? a.throw || ((s = a.return) && s.call(a), 0) : a.next) && !(s = s.call(a, c[1])).done) return s;
      switch (a = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
        case 0:
        case 1:
          s = c;
          break;
        case 4:
          return i.label++, { value: c[1], done: !1 };
        case 5:
          i.label++, a = c[1], c = [0];
          continue;
        case 7:
          c = i.ops.pop(), i.trys.pop();
          continue;
        default:
          if (s = i.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            i = 0;
            continue;
          }
          if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
            i.label = c[1];
            break;
          }
          if (c[0] === 6 && i.label < s[1]) {
            i.label = s[1], s = c;
            break;
          }
          if (s && i.label < s[2]) {
            i.label = s[2], i.ops.push(c);
            break;
          }
          s[2] && i.ops.pop(), i.trys.pop();
          continue;
      }
      c = n.call(e, i);
    } catch (u) {
      c = [6, u], a = 0;
    } finally {
      t = s = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Oi(e, n, i) {
  if (i || arguments.length === 2) for (var t = 0, a = n.length, s; t < a; t++)
    (s || !(t in n)) && (s || (s = Array.prototype.slice.call(n, 0, t)), s[t] = n[t]);
  return e.concat(s || Array.prototype.slice.call(n));
}
var _c = "right-scroll-bar-position", Qc = "width-before-scroll-bar", B_ = "with-scroll-bars-hidden", q_ = "--removed-body-scroll-bar-size";
function P0(e, n) {
  return typeof e == "function" ? e(n) : e && (e.current = n), e;
}
function G_(e, n) {
  var i = se(function() {
    return {
      // value
      value: e,
      // last callback
      callback: n,
      // "memoized" public interface
      facade: {
        get current() {
          try {
            return i.value;
          } catch (t) {
            return null;
          }
        },
        set current(t) {
          var a = i.value;
          a !== t && (i.value = t, i.callback(t, a));
        }
      }
    };
  })[0];
  return i.callback = n, i.facade;
}
var W_ = typeof window != "undefined" ? w.useLayoutEffect : w.useEffect, g4 = /* @__PURE__ */ new WeakMap();
function K_(e, n) {
  var i = G_(null, function(t) {
    return e.forEach(function(a) {
      return P0(a, t);
    });
  });
  return W_(function() {
    var t = g4.get(i);
    if (t) {
      var a = new Set(t), s = new Set(e), r = i.current;
      a.forEach(function(o) {
        s.has(o) || P0(o, null);
      }), s.forEach(function(o) {
        a.has(o) || P0(o, r);
      });
    }
    g4.set(i, e);
  }, [e]), i;
}
function Y_(e) {
  return e;
}
function X_(e, n) {
  n === void 0 && (n = Y_);
  var i = [], t = !1, a = {
    read: function() {
      if (t)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return i.length ? i[i.length - 1] : e;
    },
    useMedium: function(s) {
      var r = n(s, t);
      return i.push(r), function() {
        i = i.filter(function(o) {
          return o !== r;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (t = !0; i.length; ) {
        var r = i;
        i = [], r.forEach(s);
      }
      i = {
        push: function(o) {
          return s(o);
        },
        filter: function() {
          return i;
        }
      };
    },
    assignMedium: function(s) {
      t = !0;
      var r = [];
      if (i.length) {
        var o = i;
        i = [], o.forEach(s), r = i;
      }
      var d = function() {
        var u = r;
        r = [], u.forEach(s);
      }, c = function() {
        return Promise.resolve().then(d);
      };
      c(), i = {
        push: function(u) {
          r.push(u), c();
        },
        filter: function(u) {
          return r = r.filter(u), i;
        }
      };
    }
  };
  return a;
}
function Z_(e) {
  e === void 0 && (e = {});
  var n = X_(null);
  return n.options = G({ async: !0, ssr: !1 }, e), n;
}
var _6 = function(e) {
  var n = e.sideCar, i = Mt(e, ["sideCar"]);
  if (!n)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var t = n.read();
  if (!t)
    throw new Error("Sidecar medium not found");
  return w.createElement(t, G({}, i));
};
_6.isSideCarExport = !0;
function eQ(e, n) {
  return e.useMedium(n), _6;
}
var Q6 = Z_(), R0 = function() {
}, wm = w.forwardRef(function(e, n) {
  var i = w.useRef(null), t = w.useState({
    onScrollCapture: R0,
    onWheelCapture: R0,
    onTouchMoveCapture: R0
  }), a = t[0], s = t[1], r = e.forwardProps, o = e.children, d = e.className, c = e.removeScrollBar, u = e.enabled, k = e.shards, m = e.sideCar, f = e.noRelative, p = e.noIsolation, h = e.inert, N = e.allowPinchZoom, S = e.as, F = S === void 0 ? "div" : S, y = e.gapMode, x = Mt(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), R = m, T = K_([i, n]), j = G(G({}, x), a);
  return w.createElement(
    w.Fragment,
    null,
    u && w.createElement(R, { sideCar: Q6, removeScrollBar: c, shards: k, noRelative: f, noIsolation: p, inert: h, setCallbacks: s, allowPinchZoom: !!N, lockRef: i, gapMode: y }),
    r ? w.cloneElement(w.Children.only(o), G(G({}, j), { ref: T })) : w.createElement(F, G({}, j, { className: d, ref: T }), o)
  );
});
wm.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
wm.classNames = {
  fullWidth: Qc,
  zeroRight: _c
};
var nQ = function() {
  if (typeof __webpack_nonce__ != "undefined")
    return __webpack_nonce__;
};
function iQ() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var n = nQ();
  return n && e.setAttribute("nonce", n), e;
}
function tQ(e, n) {
  e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n));
}
function aQ(e) {
  var n = document.head || document.getElementsByTagName("head")[0];
  n.appendChild(e);
}
var lQ = function() {
  var e = 0, n = null;
  return {
    add: function(i) {
      e == 0 && (n = iQ()) && (tQ(n, i), aQ(n)), e++;
    },
    remove: function() {
      e--, !e && n && (n.parentNode && n.parentNode.removeChild(n), n = null);
    }
  };
}, sQ = function() {
  var e = lQ();
  return function(n, i) {
    w.useEffect(function() {
      return e.add(n), function() {
        e.remove();
      };
    }, [n && i]);
  };
}, M6 = function() {
  var e = sQ(), n = function(i) {
    var t = i.styles, a = i.dynamic;
    return e(t, a), null;
  };
  return n;
}, rQ = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, T0 = function(e) {
  return parseInt(e || "", 10) || 0;
}, oQ = function(e) {
  var n = window.getComputedStyle(document.body), i = n[e === "padding" ? "paddingLeft" : "marginLeft"], t = n[e === "padding" ? "paddingTop" : "marginTop"], a = n[e === "padding" ? "paddingRight" : "marginRight"];
  return [T0(i), T0(t), T0(a)];
}, dQ = function(e) {
  if (e === void 0 && (e = "margin"), typeof window == "undefined")
    return rQ;
  var n = oQ(e), i = document.documentElement.clientWidth, t = window.innerWidth;
  return {
    left: n[0],
    top: n[1],
    right: n[2],
    gap: Math.max(0, t - i + n[2] - n[0])
  };
}, cQ = M6(), L1 = "data-scroll-locked", uQ = function(e, n, i, t) {
  var a = e.left, s = e.top, r = e.right, o = e.gap;
  return i === void 0 && (i = "margin"), `
  .`.concat(B_, ` {
   overflow: hidden `).concat(t, `;
   padding-right: `).concat(o, "px ").concat(t, `;
  }
  body[`).concat(L1, `] {
    overflow: hidden `).concat(t, `;
    overscroll-behavior: contain;
    `).concat([
    n && "position: relative ".concat(t, ";"),
    i === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(r, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(t, `;
    `),
    i === "padding" && "padding-right: ".concat(o, "px ").concat(t, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(_c, ` {
    right: `).concat(o, "px ").concat(t, `;
  }
  
  .`).concat(Qc, ` {
    margin-right: `).concat(o, "px ").concat(t, `;
  }
  
  .`).concat(_c, " .").concat(_c, ` {
    right: 0 `).concat(t, `;
  }
  
  .`).concat(Qc, " .").concat(Qc, ` {
    margin-right: 0 `).concat(t, `;
  }
  
  body[`).concat(L1, `] {
    `).concat(q_, ": ").concat(o, `px;
  }
`);
}, F4 = function() {
  var e = parseInt(document.body.getAttribute(L1) || "0", 10);
  return isFinite(e) ? e : 0;
}, mQ = function() {
  w.useEffect(function() {
    return document.body.setAttribute(L1, (F4() + 1).toString()), function() {
      var e = F4() - 1;
      e <= 0 ? document.body.removeAttribute(L1) : document.body.setAttribute(L1, e.toString());
    };
  }, []);
}, kQ = function(e) {
  var n = e.noRelative, i = e.noImportant, t = e.gapMode, a = t === void 0 ? "margin" : t;
  mQ();
  var s = w.useMemo(function() {
    return dQ(a);
  }, [a]);
  return w.createElement(cQ, { styles: uQ(s, !n, a, i ? "" : "!important") });
}, nk = !1;
if (typeof window != "undefined")
  try {
    var rc = Object.defineProperty({}, "passive", {
      get: function() {
        return nk = !0, !0;
      }
    });
    window.addEventListener("test", rc, rc), window.removeEventListener("test", rc, rc);
  } catch (e) {
    nk = !1;
  }
var N1 = nk ? { passive: !1 } : !1, fQ = function(e) {
  return e.tagName === "TEXTAREA";
}, L6 = function(e, n) {
  if (!(e instanceof Element))
    return !1;
  var i = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    i[n] !== "hidden" && // contains scroll inside self
    !(i.overflowY === i.overflowX && !fQ(e) && i[n] === "visible")
  );
}, vQ = function(e) {
  return L6(e, "overflowY");
}, hQ = function(e) {
  return L6(e, "overflowX");
}, I4 = function(e, n) {
  var i = n.ownerDocument, t = n;
  do {
    typeof ShadowRoot != "undefined" && t instanceof ShadowRoot && (t = t.host);
    var a = $6(e, t);
    if (a) {
      var s = U6(e, t), r = s[1], o = s[2];
      if (r > o)
        return !0;
    }
    t = t.parentNode;
  } while (t && t !== i.body);
  return !1;
}, pQ = function(e) {
  var n = e.scrollTop, i = e.scrollHeight, t = e.clientHeight;
  return [
    n,
    i,
    t
  ];
}, NQ = function(e) {
  var n = e.scrollLeft, i = e.scrollWidth, t = e.clientWidth;
  return [
    n,
    i,
    t
  ];
}, $6 = function(e, n) {
  return e === "v" ? vQ(n) : hQ(n);
}, U6 = function(e, n) {
  return e === "v" ? pQ(n) : NQ(n);
}, SQ = function(e, n) {
  return e === "h" && n === "rtl" ? -1 : 1;
}, gQ = function(e, n, i, t, a) {
  var s = SQ(e, window.getComputedStyle(n).direction), r = s * t, o = i.target, d = n.contains(o), c = !1, u = r > 0, k = 0, m = 0;
  do {
    if (!o)
      break;
    var f = U6(e, o), p = f[0], h = f[1], N = f[2], S = h - N - s * p;
    (p || S) && $6(e, o) && (k += S, m += p);
    var F = o.parentNode;
    o = F && F.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? F.host : F;
  } while (
    // portaled content
    !d && o !== document.body || // self content
    d && (n.contains(o) || n === o)
  );
  return (u && Math.abs(k) < 1 || !u && Math.abs(m) < 1) && (c = !0), c;
}, oc = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, y4 = function(e) {
  return [e.deltaX, e.deltaY];
}, b4 = function(e) {
  return e && "current" in e ? e.current : e;
}, FQ = function(e, n) {
  return e[0] === n[0] && e[1] === n[1];
}, IQ = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, yQ = 0, S1 = [];
function bQ(e) {
  var n = w.useRef([]), i = w.useRef([0, 0]), t = w.useRef(), a = w.useState(yQ++)[0], s = w.useState(M6)[0], r = w.useRef(e);
  w.useEffect(function() {
    r.current = e;
  }, [e]), w.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var h = Oi([e.lockRef.current], (e.shards || []).map(b4), !0).filter(Boolean);
      return h.forEach(function(N) {
        return N.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), h.forEach(function(N) {
          return N.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = w.useCallback(function(h, N) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !r.current.allowPinchZoom;
    var S = oc(h), F = i.current, y = "deltaX" in h ? h.deltaX : F[0] - S[0], x = "deltaY" in h ? h.deltaY : F[1] - S[1], R, T = h.target, j = Math.abs(y) > Math.abs(x) ? "h" : "v";
    if ("touches" in h && j === "h" && T.type === "range")
      return !1;
    var A = window.getSelection(), B = A && A.anchorNode, W = B ? B === T || B.contains(T) : !1;
    if (W)
      return !1;
    var E = I4(j, T);
    if (!E)
      return !0;
    if (E ? R = j : (R = j === "v" ? "h" : "v", E = I4(j, T)), !E)
      return !1;
    if (!t.current && "changedTouches" in h && (y || x) && (t.current = R), !R)
      return !0;
    var $ = t.current || R;
    return gQ($, N, h, $ === "h" ? y : x);
  }, []), d = w.useCallback(function(h) {
    var N = h;
    if (!(!S1.length || S1[S1.length - 1] !== s)) {
      var S = "deltaY" in N ? y4(N) : oc(N), F = n.current.filter(function(R) {
        return R.name === N.type && (R.target === N.target || N.target === R.shadowParent) && FQ(R.delta, S);
      })[0];
      if (F && F.should) {
        N.cancelable && N.preventDefault();
        return;
      }
      if (!F) {
        var y = (r.current.shards || []).map(b4).filter(Boolean).filter(function(R) {
          return R.contains(N.target);
        }), x = y.length > 0 ? o(N, y[0]) : !r.current.noIsolation;
        x && N.cancelable && N.preventDefault();
      }
    }
  }, []), c = w.useCallback(function(h, N, S, F) {
    var y = { name: h, delta: N, target: S, should: F, shadowParent: CQ(S) };
    n.current.push(y), setTimeout(function() {
      n.current = n.current.filter(function(x) {
        return x !== y;
      });
    }, 1);
  }, []), u = w.useCallback(function(h) {
    i.current = oc(h), t.current = void 0;
  }, []), k = w.useCallback(function(h) {
    c(h.type, y4(h), h.target, o(h, e.lockRef.current));
  }, []), m = w.useCallback(function(h) {
    c(h.type, oc(h), h.target, o(h, e.lockRef.current));
  }, []);
  w.useEffect(function() {
    return S1.push(s), e.setCallbacks({
      onScrollCapture: k,
      onWheelCapture: k,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", d, N1), document.addEventListener("touchmove", d, N1), document.addEventListener("touchstart", u, N1), function() {
      S1 = S1.filter(function(h) {
        return h !== s;
      }), document.removeEventListener("wheel", d, N1), document.removeEventListener("touchmove", d, N1), document.removeEventListener("touchstart", u, N1);
    };
  }, []);
  var f = e.removeScrollBar, p = e.inert;
  return w.createElement(
    w.Fragment,
    null,
    p ? w.createElement(s, { styles: IQ(a) }) : null,
    f ? w.createElement(kQ, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function CQ(e) {
  for (var n = null; e !== null; )
    e instanceof ShadowRoot && (n = e.host, e = e.host), e = e.parentNode;
  return n;
}
const xQ = eQ(Q6, bQ);
var Pm = w.forwardRef(function(e, n) {
  return w.createElement(wm, G({}, e, { ref: n, sideCar: xQ }));
});
Pm.classNames = wm.classNames;
var DQ = [" ", "Enter", "ArrowUp", "ArrowDown"], wQ = [" ", "Enter"], Hs = "Select", [Rm, Tm, PQ] = gf(Hs), [Ir] = $t(Hs, [
  PQ,
  Dm
]), jm = Dm(), [RQ, os] = Ir(Hs), [TQ, jQ] = Ir(Hs), V6 = (e) => {
  const {
    __scopeSelect: n,
    children: i,
    open: t,
    defaultOpen: a,
    onOpenChange: s,
    value: r,
    defaultValue: o,
    onValueChange: d,
    dir: c,
    name: u,
    autoComplete: k,
    disabled: m,
    required: f,
    form: p
  } = e, h = jm(n), [N, S] = w.useState(null), [F, y] = w.useState(null), [x, R] = w.useState(!1), T = Zu(c), [j, A] = Oa({
    prop: t,
    defaultProp: a != null ? a : !1,
    onChange: s,
    caller: Hs
  }), [B, W] = Oa({
    prop: r,
    defaultProp: o,
    onChange: d,
    caller: Hs
  }), E = w.useRef(null), $ = N ? p || !!N.closest("form") : !0, [V, H] = w.useState(/* @__PURE__ */ new Set()), O = Array.from(V).map((M) => M.props.value).join(";");
  return /* @__PURE__ */ l.jsx(M_, { ...h, children: /* @__PURE__ */ l.jsxs(
    RQ,
    {
      required: f,
      scope: n,
      trigger: N,
      onTriggerChange: S,
      valueNode: F,
      onValueNodeChange: y,
      valueNodeHasChildren: x,
      onValueNodeHasChildrenChange: R,
      contentId: Za(),
      value: B,
      onValueChange: W,
      open: j,
      onOpenChange: A,
      dir: T,
      triggerPointerDownPosRef: E,
      disabled: m,
      children: [
        /* @__PURE__ */ l.jsx(Rm.Provider, { scope: n, children: /* @__PURE__ */ l.jsx(
          TQ,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: w.useCallback((M) => {
              H((L) => new Set(L).add(M));
            }, []),
            onNativeOptionRemove: w.useCallback((M) => {
              H((L) => {
                const _ = new Set(L);
                return _.delete(M), _;
              });
            }, []),
            children: i
          }
        ) }),
        $ ? /* @__PURE__ */ l.jsxs(
          ub,
          {
            "aria-hidden": !0,
            required: f,
            tabIndex: -1,
            name: u,
            autoComplete: k,
            value: B,
            onChange: (M) => W(M.target.value),
            disabled: m,
            form: p,
            children: [
              B === void 0 ? /* @__PURE__ */ l.jsx("option", { value: "" }) : null,
              Array.from(V)
            ]
          },
          O
        ) : null
      ]
    }
  ) });
};
V6.displayName = Hs;
var H6 = "SelectTrigger", z6 = w.forwardRef(
  (e, n) => {
    const { __scopeSelect: i, disabled: t = !1, ...a } = e, s = jm(i), r = os(H6, i), o = r.disabled || t, d = Rn(n, r.onTriggerChange), c = Tm(i), u = w.useRef("touch"), [k, m, f] = kb((h) => {
      const N = c().filter((y) => !y.disabled), S = N.find((y) => y.value === r.value), F = fb(N, h, S);
      F !== void 0 && r.onValueChange(F.value);
    }), p = (h) => {
      o || (r.onOpenChange(!0), f()), h && (r.triggerPointerDownPosRef.current = {
        x: Math.round(h.pageX),
        y: Math.round(h.pageY)
      });
    };
    return /* @__PURE__ */ l.jsx(Dv, { asChild: !0, ...s, children: /* @__PURE__ */ l.jsx(
      ln.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": r.contentId,
        "aria-expanded": r.open,
        "aria-required": r.required,
        "aria-autocomplete": "none",
        dir: r.dir,
        "data-state": r.open ? "open" : "closed",
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-placeholder": mb(r.value) ? "" : void 0,
        ...a,
        ref: d,
        onClick: nn(a.onClick, (h) => {
          h.currentTarget.focus(), u.current !== "mouse" && p(h);
        }),
        onPointerDown: nn(a.onPointerDown, (h) => {
          u.current = h.pointerType;
          const N = h.target;
          N.hasPointerCapture(h.pointerId) && N.releasePointerCapture(h.pointerId), h.button === 0 && h.ctrlKey === !1 && h.pointerType === "mouse" && (p(h), h.preventDefault());
        }),
        onKeyDown: nn(a.onKeyDown, (h) => {
          const N = k.current !== "";
          !(h.ctrlKey || h.altKey || h.metaKey) && h.key.length === 1 && m(h.key), !(N && h.key === " ") && DQ.includes(h.key) && (p(), h.preventDefault());
        })
      }
    ) });
  }
);
z6.displayName = H6;
var B6 = "SelectValue", AQ = w.forwardRef(
  (e, n) => {
    const { __scopeSelect: i, className: t, style: a, children: s, placeholder: r = "", ...o } = e, d = os(B6, i), { onValueNodeHasChildrenChange: c } = d, u = s !== void 0, k = Rn(n, d.onValueNodeChange);
    return Mi(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ l.jsx(
      ln.span,
      {
        ...o,
        ref: k,
        style: { pointerEvents: "none" },
        children: mb(d.value) ? /* @__PURE__ */ l.jsx(l.Fragment, { children: r }) : s
      }
    );
  }
);
AQ.displayName = B6;
var OQ = "SelectIcon", q6 = w.forwardRef(
  (e, n) => {
    const { __scopeSelect: i, children: t, ...a } = e;
    return /* @__PURE__ */ l.jsx(ln.span, { "aria-hidden": !0, ...a, ref: n, children: t || "▼" });
  }
);
q6.displayName = OQ;
var zs = "SelectContent", G6 = w.forwardRef(
  (e, n) => {
    const i = os(zs, e.__scopeSelect), [t, a] = w.useState();
    if (Mi(() => {
      a(new DocumentFragment());
    }, []), !i.open) {
      const s = t;
      return s ? Gu.createPortal(
        /* @__PURE__ */ l.jsx(W6, { scope: e.__scopeSelect, children: /* @__PURE__ */ l.jsx(Rm.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ l.jsx("div", { children: e.children }) }) }),
        s
      ) : null;
    }
    return /* @__PURE__ */ l.jsx(K6, { ...e, ref: n });
  }
);
G6.displayName = zs;
var ea = 10, [W6, ds] = Ir(zs), EQ = "SelectContentImpl", JQ = /* @__PURE__ */ B1("SelectContent.RemoveScroll"), K6 = w.forwardRef(
  (e, n) => {
    const {
      __scopeSelect: i,
      position: t = "item-aligned",
      onCloseAutoFocus: a,
      onEscapeKeyDown: s,
      onPointerDownOutside: r,
      //
      // PopperContent props
      side: o,
      sideOffset: d,
      align: c,
      alignOffset: u,
      arrowPadding: k,
      collisionBoundary: m,
      collisionPadding: f,
      sticky: p,
      hideWhenDetached: h,
      avoidCollisions: N,
      //
      ...S
    } = e, F = os(zs, i), [y, x] = w.useState(null), [R, T] = w.useState(null), j = Rn(n, (ie) => x(ie)), [A, B] = w.useState(null), [W, E] = w.useState(
      null
    ), $ = Tm(i), [V, H] = w.useState(!1), O = w.useRef(!1);
    w.useEffect(() => {
      if (y) return Pv(y);
    }, [y]), Nv();
    const M = w.useCallback(
      (ie) => {
        const [De, ..._e] = $().map((re) => re.ref.current), [Ie] = _e.slice(-1), Fe = document.activeElement;
        for (const re of ie)
          if (re === Fe || (re == null || re.scrollIntoView({ block: "nearest" }), re === De && R && (R.scrollTop = 0), re === Ie && R && (R.scrollTop = R.scrollHeight), re == null || re.focus(), document.activeElement !== Fe)) return;
      },
      [$, R]
    ), L = w.useCallback(
      () => M([A, y]),
      [M, A, y]
    );
    w.useEffect(() => {
      V && L();
    }, [V, L]);
    const { onOpenChange: _, triggerPointerDownPosRef: z } = F;
    w.useEffect(() => {
      if (y) {
        let ie = { x: 0, y: 0 };
        const De = (Ie) => {
          var Fe, re, Me, ge;
          ie = {
            x: Math.abs(Math.round(Ie.pageX) - ((re = (Fe = z.current) == null ? void 0 : Fe.x) != null ? re : 0)),
            y: Math.abs(Math.round(Ie.pageY) - ((ge = (Me = z.current) == null ? void 0 : Me.y) != null ? ge : 0))
          };
        }, _e = (Ie) => {
          ie.x <= 10 && ie.y <= 10 ? Ie.preventDefault() : y.contains(Ie.target) || _(!1), document.removeEventListener("pointermove", De), z.current = null;
        };
        return z.current !== null && (document.addEventListener("pointermove", De), document.addEventListener("pointerup", _e, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", De), document.removeEventListener("pointerup", _e, { capture: !0 });
        };
      }
    }, [y, _, z]), w.useEffect(() => {
      const ie = () => _(!1);
      return window.addEventListener("blur", ie), window.addEventListener("resize", ie), () => {
        window.removeEventListener("blur", ie), window.removeEventListener("resize", ie);
      };
    }, [_]);
    const [ne, Se] = kb((ie) => {
      const De = $().filter((Fe) => !Fe.disabled), _e = De.find((Fe) => Fe.ref.current === document.activeElement), Ie = fb(De, ie, _e);
      Ie && setTimeout(() => Ie.ref.current.focus());
    }), he = w.useCallback(
      (ie, De, _e) => {
        const Ie = !O.current && !_e;
        (F.value !== void 0 && F.value === De || Ie) && (B(ie), Ie && (O.current = !0));
      },
      [F.value]
    ), ue = w.useCallback(() => y == null ? void 0 : y.focus(), [y]), oe = w.useCallback(
      (ie, De, _e) => {
        const Ie = !O.current && !_e;
        (F.value !== void 0 && F.value === De || Ie) && E(ie);
      },
      [F.value]
    ), $e = t === "popper" ? ik : Y6, we = $e === ik ? {
      side: o,
      sideOffset: d,
      align: c,
      alignOffset: u,
      arrowPadding: k,
      collisionBoundary: m,
      collisionPadding: f,
      sticky: p,
      hideWhenDetached: h,
      avoidCollisions: N
    } : {};
    return /* @__PURE__ */ l.jsx(
      W6,
      {
        scope: i,
        content: y,
        viewport: R,
        onViewportChange: T,
        itemRefCallback: he,
        selectedItem: A,
        onItemLeave: ue,
        itemTextRefCallback: oe,
        focusSelectedItem: L,
        selectedItemText: W,
        position: t,
        isPositioned: V,
        searchRef: ne,
        children: /* @__PURE__ */ l.jsx(Pm, { as: JQ, allowPinchZoom: !0, children: /* @__PURE__ */ l.jsx(
          Im,
          {
            asChild: !0,
            trapped: F.open,
            onMountAutoFocus: (ie) => {
              ie.preventDefault();
            },
            onUnmountAutoFocus: nn(a, (ie) => {
              var De;
              (De = F.trigger) == null || De.focus({ preventScroll: !0 }), ie.preventDefault();
            }),
            children: /* @__PURE__ */ l.jsx(
              Fm,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: s,
                onPointerDownOutside: r,
                onFocusOutside: (ie) => ie.preventDefault(),
                onDismiss: () => F.onOpenChange(!1),
                children: /* @__PURE__ */ l.jsx(
                  $e,
                  {
                    role: "listbox",
                    id: F.contentId,
                    "data-state": F.open ? "open" : "closed",
                    dir: F.dir,
                    onContextMenu: (ie) => ie.preventDefault(),
                    ...S,
                    ...we,
                    onPlaced: () => H(!0),
                    ref: j,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...S.style
                    },
                    onKeyDown: nn(S.onKeyDown, (ie) => {
                      const De = ie.ctrlKey || ie.altKey || ie.metaKey;
                      if (ie.key === "Tab" && ie.preventDefault(), !De && ie.key.length === 1 && Se(ie.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(ie.key)) {
                        let Ie = $().filter((Fe) => !Fe.disabled).map((Fe) => Fe.ref.current);
                        if (["ArrowUp", "End"].includes(ie.key) && (Ie = Ie.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(ie.key)) {
                          const Fe = ie.target, re = Ie.indexOf(Fe);
                          Ie = Ie.slice(re + 1);
                        }
                        setTimeout(() => M(Ie)), ie.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
K6.displayName = EQ;
var _Q = "SelectItemAlignedPosition", Y6 = w.forwardRef((e, n) => {
  const { __scopeSelect: i, onPlaced: t, ...a } = e, s = os(zs, i), r = ds(zs, i), [o, d] = w.useState(null), [c, u] = w.useState(null), k = Rn(n, (j) => u(j)), m = Tm(i), f = w.useRef(!1), p = w.useRef(!0), { viewport: h, selectedItem: N, selectedItemText: S, focusSelectedItem: F } = r, y = w.useCallback(() => {
    if (s.trigger && s.valueNode && o && c && h && N && S) {
      const j = s.trigger.getBoundingClientRect(), A = c.getBoundingClientRect(), B = s.valueNode.getBoundingClientRect(), W = S.getBoundingClientRect();
      if (s.dir !== "rtl") {
        const Fe = W.left - A.left, re = B.left - Fe, Me = j.left - re, ge = j.width + Me, rn = Math.max(ge, A.width), Sn = window.innerWidth - ea, Jn = n4(re, [
          ea,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(ea, Sn - rn)
        ]);
        o.style.minWidth = ge + "px", o.style.left = Jn + "px";
      } else {
        const Fe = A.right - W.right, re = window.innerWidth - B.right - Fe, Me = window.innerWidth - j.right - re, ge = j.width + Me, rn = Math.max(ge, A.width), Sn = window.innerWidth - ea, Jn = n4(re, [
          ea,
          Math.max(ea, Sn - rn)
        ]);
        o.style.minWidth = ge + "px", o.style.right = Jn + "px";
      }
      const E = m(), $ = window.innerHeight - ea * 2, V = h.scrollHeight, H = window.getComputedStyle(c), O = parseInt(H.borderTopWidth, 10), M = parseInt(H.paddingTop, 10), L = parseInt(H.borderBottomWidth, 10), _ = parseInt(H.paddingBottom, 10), z = O + M + V + _ + L, ne = Math.min(N.offsetHeight * 5, z), Se = window.getComputedStyle(h), he = parseInt(Se.paddingTop, 10), ue = parseInt(Se.paddingBottom, 10), oe = j.top + j.height / 2 - ea, $e = $ - oe, we = N.offsetHeight / 2, ie = N.offsetTop + we, De = O + M + ie, _e = z - De;
      if (De <= oe) {
        const Fe = E.length > 0 && N === E[E.length - 1].ref.current;
        o.style.bottom = "0px";
        const re = c.clientHeight - h.offsetTop - h.offsetHeight, Me = Math.max(
          $e,
          we + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Fe ? ue : 0) + re + L
        ), ge = De + Me;
        o.style.height = ge + "px";
      } else {
        const Fe = E.length > 0 && N === E[0].ref.current;
        o.style.top = "0px";
        const Me = Math.max(
          oe,
          O + h.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Fe ? he : 0) + we
        ) + _e;
        o.style.height = Me + "px", h.scrollTop = De - oe + h.offsetTop;
      }
      o.style.margin = `${ea}px 0`, o.style.minHeight = ne + "px", o.style.maxHeight = $ + "px", t == null || t(), requestAnimationFrame(() => f.current = !0);
    }
  }, [
    m,
    s.trigger,
    s.valueNode,
    o,
    c,
    h,
    N,
    S,
    s.dir,
    t
  ]);
  Mi(() => y(), [y]);
  const [x, R] = w.useState();
  Mi(() => {
    c && R(window.getComputedStyle(c).zIndex);
  }, [c]);
  const T = w.useCallback(
    (j) => {
      j && p.current === !0 && (y(), F == null || F(), p.current = !1);
    },
    [y, F]
  );
  return /* @__PURE__ */ l.jsx(
    MQ,
    {
      scope: i,
      contentWrapper: o,
      shouldExpandOnScrollRef: f,
      onScrollButtonChange: T,
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          ref: d,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: x
          },
          children: /* @__PURE__ */ l.jsx(
            ln.div,
            {
              ...a,
              ref: k,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...a.style
              }
            }
          )
        }
      )
    }
  );
});
Y6.displayName = _Q;
var QQ = "SelectPopperPosition", ik = w.forwardRef((e, n) => {
  const {
    __scopeSelect: i,
    align: t = "start",
    collisionPadding: a = ea,
    ...s
  } = e, r = jm(i);
  return /* @__PURE__ */ l.jsx(
    A6,
    {
      ...r,
      ...s,
      ref: n,
      align: t,
      collisionPadding: a,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...s.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
ik.displayName = QQ;
var [MQ, Rv] = Ir(zs, {}), tk = "SelectViewport", X6 = w.forwardRef(
  (e, n) => {
    const { __scopeSelect: i, nonce: t, ...a } = e, s = ds(tk, i), r = Rv(tk, i), o = Rn(n, s.onViewportChange), d = w.useRef(0);
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: t
        }
      ),
      /* @__PURE__ */ l.jsx(Rm.Slot, { scope: i, children: /* @__PURE__ */ l.jsx(
        ln.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...a,
          ref: o,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...a.style
          },
          onScroll: nn(a.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: k, shouldExpandOnScrollRef: m } = r;
            if (m != null && m.current && k) {
              const f = Math.abs(d.current - u.scrollTop);
              if (f > 0) {
                const p = window.innerHeight - ea * 2, h = parseFloat(k.style.minHeight), N = parseFloat(k.style.height), S = Math.max(h, N);
                if (S < p) {
                  const F = S + f, y = Math.min(p, F), x = F - y;
                  k.style.height = y + "px", k.style.bottom === "0px" && (u.scrollTop = x > 0 ? x : 0, k.style.justifyContent = "flex-end");
                }
              }
            }
            d.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
X6.displayName = tk;
var Z6 = "SelectGroup", [LQ, $Q] = Ir(Z6), UQ = w.forwardRef(
  (e, n) => {
    const { __scopeSelect: i, ...t } = e, a = Za();
    return /* @__PURE__ */ l.jsx(LQ, { scope: i, id: a, children: /* @__PURE__ */ l.jsx(ln.div, { role: "group", "aria-labelledby": a, ...t, ref: n }) });
  }
);
UQ.displayName = Z6;
var eb = "SelectLabel", nb = w.forwardRef(
  (e, n) => {
    const { __scopeSelect: i, ...t } = e, a = $Q(eb, i);
    return /* @__PURE__ */ l.jsx(ln.div, { id: a.id, ...t, ref: n });
  }
);
nb.displayName = eb;
var Su = "SelectItem", [VQ, ib] = Ir(Su), tb = w.forwardRef(
  (e, n) => {
    const {
      __scopeSelect: i,
      value: t,
      disabled: a = !1,
      textValue: s,
      ...r
    } = e, o = os(Su, i), d = ds(Su, i), c = o.value === t, [u, k] = w.useState(s != null ? s : ""), [m, f] = w.useState(!1), p = Rn(
      n,
      (F) => {
        var y;
        return (y = d.itemRefCallback) == null ? void 0 : y.call(d, F, t, a);
      }
    ), h = Za(), N = w.useRef("touch"), S = () => {
      a || (o.onValueChange(t), o.onOpenChange(!1));
    };
    if (t === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ l.jsx(
      VQ,
      {
        scope: i,
        value: t,
        disabled: a,
        textId: h,
        isSelected: c,
        onItemTextChange: w.useCallback((F) => {
          k((y) => {
            var x;
            return y || ((x = F == null ? void 0 : F.textContent) != null ? x : "").trim();
          });
        }, []),
        children: /* @__PURE__ */ l.jsx(
          Rm.ItemSlot,
          {
            scope: i,
            value: t,
            disabled: a,
            textValue: u,
            children: /* @__PURE__ */ l.jsx(
              ln.div,
              {
                role: "option",
                "aria-labelledby": h,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": c && m,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": a || void 0,
                "data-disabled": a ? "" : void 0,
                tabIndex: a ? void 0 : -1,
                ...r,
                ref: p,
                onFocus: nn(r.onFocus, () => f(!0)),
                onBlur: nn(r.onBlur, () => f(!1)),
                onClick: nn(r.onClick, () => {
                  N.current !== "mouse" && S();
                }),
                onPointerUp: nn(r.onPointerUp, () => {
                  N.current === "mouse" && S();
                }),
                onPointerDown: nn(r.onPointerDown, (F) => {
                  N.current = F.pointerType;
                }),
                onPointerMove: nn(r.onPointerMove, (F) => {
                  var y;
                  N.current = F.pointerType, a ? (y = d.onItemLeave) == null || y.call(d) : N.current === "mouse" && F.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: nn(r.onPointerLeave, (F) => {
                  var y;
                  F.currentTarget === document.activeElement && ((y = d.onItemLeave) == null || y.call(d));
                }),
                onKeyDown: nn(r.onKeyDown, (F) => {
                  var x;
                  ((x = d.searchRef) == null ? void 0 : x.current) !== "" && F.key === " " || (wQ.includes(F.key) && S(), F.key === " " && F.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
tb.displayName = Su;
var ho = "SelectItemText", ab = w.forwardRef(
  (e, n) => {
    const { __scopeSelect: i, className: t, style: a, ...s } = e, r = os(ho, i), o = ds(ho, i), d = ib(ho, i), c = jQ(ho, i), [u, k] = w.useState(null), m = Rn(
      n,
      (S) => k(S),
      d.onItemTextChange,
      (S) => {
        var F;
        return (F = o.itemTextRefCallback) == null ? void 0 : F.call(o, S, d.value, d.disabled);
      }
    ), f = u == null ? void 0 : u.textContent, p = w.useMemo(
      () => /* @__PURE__ */ l.jsx("option", { value: d.value, disabled: d.disabled, children: f }, d.value),
      [d.disabled, d.value, f]
    ), { onNativeOptionAdd: h, onNativeOptionRemove: N } = c;
    return Mi(() => (h(p), () => N(p)), [h, N, p]), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(ln.span, { id: d.textId, ...s, ref: m }),
      d.isSelected && r.valueNode && !r.valueNodeHasChildren ? Gu.createPortal(s.children, r.valueNode) : null
    ] });
  }
);
ab.displayName = ho;
var lb = "SelectItemIndicator", sb = w.forwardRef(
  (e, n) => {
    const { __scopeSelect: i, ...t } = e;
    return ib(lb, i).isSelected ? /* @__PURE__ */ l.jsx(ln.span, { "aria-hidden": !0, ...t, ref: n }) : null;
  }
);
sb.displayName = lb;
var ak = "SelectScrollUpButton", rb = w.forwardRef((e, n) => {
  const i = ds(ak, e.__scopeSelect), t = Rv(ak, e.__scopeSelect), [a, s] = w.useState(!1), r = Rn(n, t.onScrollButtonChange);
  return Mi(() => {
    if (i.viewport && i.isPositioned) {
      let o = function() {
        const c = d.scrollTop > 0;
        s(c);
      };
      const d = i.viewport;
      return o(), d.addEventListener("scroll", o), () => d.removeEventListener("scroll", o);
    }
  }, [i.viewport, i.isPositioned]), a ? /* @__PURE__ */ l.jsx(
    db,
    {
      ...e,
      ref: r,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: d } = i;
        o && d && (o.scrollTop = o.scrollTop - d.offsetHeight);
      }
    }
  ) : null;
});
rb.displayName = ak;
var lk = "SelectScrollDownButton", ob = w.forwardRef((e, n) => {
  const i = ds(lk, e.__scopeSelect), t = Rv(lk, e.__scopeSelect), [a, s] = w.useState(!1), r = Rn(n, t.onScrollButtonChange);
  return Mi(() => {
    if (i.viewport && i.isPositioned) {
      let o = function() {
        const c = d.scrollHeight - d.clientHeight, u = Math.ceil(d.scrollTop) < c;
        s(u);
      };
      const d = i.viewport;
      return o(), d.addEventListener("scroll", o), () => d.removeEventListener("scroll", o);
    }
  }, [i.viewport, i.isPositioned]), a ? /* @__PURE__ */ l.jsx(
    db,
    {
      ...e,
      ref: r,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: d } = i;
        o && d && (o.scrollTop = o.scrollTop + d.offsetHeight);
      }
    }
  ) : null;
});
ob.displayName = lk;
var db = w.forwardRef((e, n) => {
  const { __scopeSelect: i, onAutoScroll: t, ...a } = e, s = ds("SelectScrollButton", i), r = w.useRef(null), o = Tm(i), d = w.useCallback(() => {
    r.current !== null && (window.clearInterval(r.current), r.current = null);
  }, []);
  return w.useEffect(() => () => d(), [d]), Mi(() => {
    var u;
    const c = o().find((k) => k.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [o]), /* @__PURE__ */ l.jsx(
    ln.div,
    {
      "aria-hidden": !0,
      ...a,
      ref: n,
      style: { flexShrink: 0, ...a.style },
      onPointerDown: nn(a.onPointerDown, () => {
        r.current === null && (r.current = window.setInterval(t, 50));
      }),
      onPointerMove: nn(a.onPointerMove, () => {
        var c;
        (c = s.onItemLeave) == null || c.call(s), r.current === null && (r.current = window.setInterval(t, 50));
      }),
      onPointerLeave: nn(a.onPointerLeave, () => {
        d();
      })
    }
  );
}), HQ = "SelectSeparator", cb = w.forwardRef(
  (e, n) => {
    const { __scopeSelect: i, ...t } = e;
    return /* @__PURE__ */ l.jsx(ln.div, { "aria-hidden": !0, ...t, ref: n });
  }
);
cb.displayName = HQ;
var sk = "SelectArrow", zQ = w.forwardRef(
  (e, n) => {
    const { __scopeSelect: i, ...t } = e, a = jm(i), s = os(sk, i), r = ds(sk, i);
    return s.open && r.position === "popper" ? /* @__PURE__ */ l.jsx(O6, { ...a, ...t, ref: n }) : null;
  }
);
zQ.displayName = sk;
var BQ = "SelectBubbleInput", ub = w.forwardRef(
  ({ __scopeSelect: e, value: n, ...i }, t) => {
    const a = w.useRef(null), s = Rn(t, a), r = pm(n);
    return w.useEffect(() => {
      const o = a.current;
      if (!o) return;
      const d = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        d,
        "value"
      ).set;
      if (r !== n && u) {
        const k = new Event("change", { bubbles: !0 });
        u.call(o, n), o.dispatchEvent(k);
      }
    }, [r, n]), /* @__PURE__ */ l.jsx(
      ln.select,
      {
        ...i,
        style: { ...E6, ...i.style },
        ref: s,
        defaultValue: n
      }
    );
  }
);
ub.displayName = BQ;
function mb(e) {
  return e === "" || e === void 0;
}
function kb(e) {
  const n = Wl(e), i = w.useRef(""), t = w.useRef(0), a = w.useCallback(
    (r) => {
      const o = i.current + r;
      n(o), function d(c) {
        i.current = c, window.clearTimeout(t.current), c !== "" && (t.current = window.setTimeout(() => d(""), 1e3));
      }(o);
    },
    [n]
  ), s = w.useCallback(() => {
    i.current = "", window.clearTimeout(t.current);
  }, []);
  return w.useEffect(() => () => window.clearTimeout(t.current), []), [i, a, s];
}
function fb(e, n, i) {
  const a = n.length > 1 && Array.from(n).every((c) => c === n[0]) ? n[0] : n, s = i ? e.indexOf(i) : -1;
  let r = qQ(e, Math.max(s, 0));
  a.length === 1 && (r = r.filter((c) => c !== i));
  const d = r.find(
    (c) => c.textValue.toLowerCase().startsWith(a.toLowerCase())
  );
  return d !== i ? d : void 0;
}
function qQ(e, n) {
  return e.map((i, t) => e[(n + t) % e.length]);
}
var GQ = V6, vb = z6, WQ = q6, hb = G6, KQ = X6, pb = nb, Nb = tb, YQ = ab, XQ = sb, Sb = rb, gb = ob, Fb = cb;
const n1 = GQ, cs = w.forwardRef(({ className: e, children: n, ...i }, t) => /* @__PURE__ */ l.jsxs(
  vb,
  {
    ref: t,
    className: ce(
      "ch-flex ch-h-10 ch-w-full ch-min-w-[72px] ch-items-center ch-justify-between ch-gap-x-2 ch-rounded-md ch-border ch-border-gray-200 ch-bg-white ch-px-3 ch-py-2 ch-text-sm ch-ring-offset-white placeholder:ch-text-zinc-500/90 focus:ch-outline-none focus:ch-ring-2 focus:ch-ring-focus-600 focus:ch-ring-offset-2 disabled:ch-cursor-not-allowed disabled:ch-opacity-50",
      e
    ),
    ...i,
    children: [
      n,
      /* @__PURE__ */ l.jsx(WQ, { asChild: !0, children: /* @__PURE__ */ l.jsx(zl, { size: "2xs", className: "ch-h-3 ch-w-3 ch-rotate-90 ch-text-black" }) })
    ]
  }
));
cs.displayName = vb.displayName;
const ZQ = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  Sb,
  {
    ref: i,
    className: ce("ch-flex ch-cursor-default ch-items-center ch-justify-center ch-py-1", e),
    ...n,
    children: /* @__PURE__ */ l.jsx(sI, { size: "sm" })
  }
));
ZQ.displayName = Sb.displayName;
const eM = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  gb,
  {
    ref: i,
    className: ce("ch-flex ch-cursor-default ch-items-center ch-justify-center ch-py-1", e),
    ...n,
    children: /* @__PURE__ */ l.jsx(qP, { size: "sm" })
  }
));
eM.displayName = gb.displayName;
const us = w.forwardRef(({ className: e, children: n, position: i = "popper", ...t }, a) => /* @__PURE__ */ l.jsx(
  hb,
  {
    ref: a,
    className: ce(
      /**
       * z-index に 200を当てている理由
       * - dialog, drawer 内にselect-boxをおいた時にdialog,drawerの下に選択肢が表示されてしまうため
       * - 他に良い方法があれば修正してください！
       */
      "ch-relative ch-z-[200] ch-max-h-80 ch-min-w-[8rem] ch-overflow-hidden ch-overflow-y-scroll ch-rounded-md ch-border ch-border-zinc-200 ch-bg-white ch-text-zinc-950 ch-shadow-md data-[state=open]:ch-animate-in data-[state=closed]:ch-animate-out data-[state=closed]:ch-fade-out-0 data-[state=open]:ch-fade-in-0 data-[state=closed]:ch-zoom-out-95 data-[state=open]:ch-zoom-in-95 data-[side=bottom]:ch-slide-in-from-top-2 data-[side=left]:ch-slide-in-from-right-2 data-[side=right]:ch-slide-in-from-left-2 data-[side=top]:ch-slide-in-from-bottom-2",
      i === "popper" && "data-[side=bottom]:ch-translate-y-1 data-[side=left]:-ch-translate-x-1 data-[side=right]:ch-translate-x-1 data-[side=top]:-ch-translate-y-1",
      e
    ),
    position: i,
    ...t,
    children: /* @__PURE__ */ l.jsx(
      KQ,
      {
        className: ce(
          "ch-p-1",
          i === "popper" && "ch-h-[var(--radix-select-trigger-height)] ch-w-full ch-min-w-[var(--radix-select-trigger-width)]"
        ),
        children: n
      }
    )
  }
));
us.displayName = hb.displayName;
const nM = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  pb,
  {
    ref: i,
    className: ce("ch-py-1.5 ch-pl-8 ch-pr-2 ch-text-sm ch-font-semibold", e),
    ...n
  }
));
nM.displayName = pb.displayName;
const ms = w.forwardRef(({ className: e, children: n, ...i }, t) => /* @__PURE__ */ l.jsxs(
  Nb,
  {
    ref: t,
    className: ce(
      "ch-relative ch-flex ch-w-full ch-cursor-default ch-select-none ch-items-center ch-rounded-sm ch-py-1.5 ch-pl-8 ch-pr-2 ch-text-sm ch-outline-none focus:ch-bg-zinc-100 focus:ch-text-zinc-900 data-[disabled]:ch-pointer-events-none data-[disabled]:ch-opacity-50",
      e
    ),
    ...i,
    children: [
      /* @__PURE__ */ l.jsx("span", { className: "ch-absolute ch-left-2 ch-flex ch-h-3.5 ch-w-3.5 ch-items-center ch-justify-center", children: /* @__PURE__ */ l.jsx(XQ, { children: /* @__PURE__ */ l.jsx(aI, { className: "ch-h-4 ch-w-4" }) }) }),
      /* @__PURE__ */ l.jsx(YQ, { children: n })
    ]
  }
));
ms.displayName = Nb.displayName;
const iM = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  Fb,
  {
    ref: i,
    className: ce("-ch-mx-1 ch-my-1 ch-h-px ch-bg-zinc-100", e),
    ...n
  }
));
iM.displayName = Fb.displayName;
var j0 = "rovingFocusGroup.onEntryFocus", tM = { bubbles: !1, cancelable: !0 }, vd = "RovingFocusGroup", [rk, Ib, aM] = gf(vd), [lM, yb] = $t(
  vd,
  [aM]
), [sM, rM] = lM(vd), bb = w.forwardRef(
  (e, n) => /* @__PURE__ */ l.jsx(rk.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l.jsx(rk.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l.jsx(oM, { ...e, ref: n }) }) })
);
bb.displayName = vd;
var oM = w.forwardRef((e, n) => {
  const {
    __scopeRovingFocusGroup: i,
    orientation: t,
    loop: a = !1,
    dir: s,
    currentTabStopId: r,
    defaultCurrentTabStopId: o,
    onCurrentTabStopIdChange: d,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...k
  } = e, m = w.useRef(null), f = Rn(n, m), p = Zu(s), [h, N] = Oa({
    prop: r,
    defaultProp: o != null ? o : null,
    onChange: d,
    caller: vd
  }), [S, F] = w.useState(!1), y = Wl(c), x = Ib(i), R = w.useRef(!1), [T, j] = w.useState(0);
  return w.useEffect(() => {
    const A = m.current;
    if (A)
      return A.addEventListener(j0, y), () => A.removeEventListener(j0, y);
  }, [y]), /* @__PURE__ */ l.jsx(
    sM,
    {
      scope: i,
      orientation: t,
      dir: p,
      loop: a,
      currentTabStopId: h,
      onItemFocus: w.useCallback(
        (A) => N(A),
        [N]
      ),
      onItemShiftTab: w.useCallback(() => F(!0), []),
      onFocusableItemAdd: w.useCallback(
        () => j((A) => A + 1),
        []
      ),
      onFocusableItemRemove: w.useCallback(
        () => j((A) => A - 1),
        []
      ),
      children: /* @__PURE__ */ l.jsx(
        ln.div,
        {
          tabIndex: S || T === 0 ? -1 : 0,
          "data-orientation": t,
          ...k,
          ref: f,
          style: { outline: "none", ...e.style },
          onMouseDown: nn(e.onMouseDown, () => {
            R.current = !0;
          }),
          onFocus: nn(e.onFocus, (A) => {
            const B = !R.current;
            if (A.target === A.currentTarget && B && !S) {
              const W = new CustomEvent(j0, tM);
              if (A.currentTarget.dispatchEvent(W), !W.defaultPrevented) {
                const E = x().filter((M) => M.focusable), $ = E.find((M) => M.active), V = E.find((M) => M.id === h), O = [$, V, ...E].filter(
                  Boolean
                ).map((M) => M.ref.current);
                Db(O, u);
              }
            }
            R.current = !1;
          }),
          onBlur: nn(e.onBlur, () => F(!1))
        }
      )
    }
  );
}), Cb = "RovingFocusGroupItem", xb = w.forwardRef(
  (e, n) => {
    const {
      __scopeRovingFocusGroup: i,
      focusable: t = !0,
      active: a = !1,
      tabStopId: s,
      children: r,
      ...o
    } = e, d = Za(), c = s || d, u = rM(Cb, i), k = u.currentTabStopId === c, m = Ib(i), { onFocusableItemAdd: f, onFocusableItemRemove: p, currentTabStopId: h } = u;
    return w.useEffect(() => {
      if (t)
        return f(), () => p();
    }, [t, f, p]), /* @__PURE__ */ l.jsx(
      rk.ItemSlot,
      {
        scope: i,
        id: c,
        focusable: t,
        active: a,
        children: /* @__PURE__ */ l.jsx(
          ln.span,
          {
            tabIndex: k ? 0 : -1,
            "data-orientation": u.orientation,
            ...o,
            ref: n,
            onMouseDown: nn(e.onMouseDown, (N) => {
              t ? u.onItemFocus(c) : N.preventDefault();
            }),
            onFocus: nn(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: nn(e.onKeyDown, (N) => {
              if (N.key === "Tab" && N.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (N.target !== N.currentTarget) return;
              const S = uM(N, u.orientation, u.dir);
              if (S !== void 0) {
                if (N.metaKey || N.ctrlKey || N.altKey || N.shiftKey) return;
                N.preventDefault();
                let y = m().filter((x) => x.focusable).map((x) => x.ref.current);
                if (S === "last") y.reverse();
                else if (S === "prev" || S === "next") {
                  S === "prev" && y.reverse();
                  const x = y.indexOf(N.currentTarget);
                  y = u.loop ? mM(y, x + 1) : y.slice(x + 1);
                }
                setTimeout(() => Db(y));
              }
            }),
            children: typeof r == "function" ? r({ isCurrentTabStop: k, hasTabStop: h != null }) : r
          }
        )
      }
    );
  }
);
xb.displayName = Cb;
var dM = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function cM(e, n) {
  return n !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function uM(e, n, i) {
  const t = cM(e.key, i);
  if (!(n === "vertical" && ["ArrowLeft", "ArrowRight"].includes(t)) && !(n === "horizontal" && ["ArrowUp", "ArrowDown"].includes(t)))
    return dM[t];
}
function Db(e, n = !1) {
  const i = document.activeElement;
  for (const t of e)
    if (t === i || (t.focus({ preventScroll: n }), document.activeElement !== i)) return;
}
function mM(e, n) {
  return e.map((i, t) => e[(n + t) % e.length]);
}
var kM = bb, fM = xb, Tv = "Radio", [vM, wb] = $t(Tv), [hM, pM] = vM(Tv), Pb = w.forwardRef(
  (e, n) => {
    const {
      __scopeRadio: i,
      name: t,
      checked: a = !1,
      required: s,
      disabled: r,
      value: o = "on",
      onCheck: d,
      form: c,
      ...u
    } = e, [k, m] = w.useState(null), f = Rn(n, (N) => m(N)), p = w.useRef(!1), h = k ? c || !!k.closest("form") : !0;
    return /* @__PURE__ */ l.jsxs(hM, { scope: i, checked: a, disabled: r, children: [
      /* @__PURE__ */ l.jsx(
        ln.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": a,
          "data-state": Ab(a),
          "data-disabled": r ? "" : void 0,
          disabled: r,
          value: o,
          ...u,
          ref: f,
          onClick: nn(e.onClick, (N) => {
            a || d == null || d(), h && (p.current = N.isPropagationStopped(), p.current || N.stopPropagation());
          })
        }
      ),
      h && /* @__PURE__ */ l.jsx(
        jb,
        {
          control: k,
          bubbles: !p.current,
          name: t,
          value: o,
          checked: a,
          required: s,
          disabled: r,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Pb.displayName = Tv;
var Rb = "RadioIndicator", Tb = w.forwardRef(
  (e, n) => {
    const { __scopeRadio: i, forceMount: t, ...a } = e, s = pM(Rb, i);
    return /* @__PURE__ */ l.jsx(kl, { present: t || s.checked, children: /* @__PURE__ */ l.jsx(
      ln.span,
      {
        "data-state": Ab(s.checked),
        "data-disabled": s.disabled ? "" : void 0,
        ...a,
        ref: n
      }
    ) });
  }
);
Tb.displayName = Rb;
var NM = "RadioBubbleInput", jb = w.forwardRef(
  ({
    __scopeRadio: e,
    control: n,
    checked: i,
    bubbles: t = !0,
    ...a
  }, s) => {
    const r = w.useRef(null), o = Rn(r, s), d = pm(i), c = Nm(n);
    return w.useEffect(() => {
      const u = r.current;
      if (!u) return;
      const k = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(
        k,
        "checked"
      ).set;
      if (d !== i && f) {
        const p = new Event("click", { bubbles: t });
        f.call(u, i), u.dispatchEvent(p);
      }
    }, [d, i, t]), /* @__PURE__ */ l.jsx(
      ln.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: i,
        ...a,
        tabIndex: -1,
        ref: o,
        style: {
          ...a.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
jb.displayName = NM;
function Ab(e) {
  return e ? "checked" : "unchecked";
}
var SM = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Am = "RadioGroup", [gM] = $t(Am, [
  yb,
  wb
]), Ob = yb(), Eb = wb(), [FM, IM] = gM(Am), Jb = w.forwardRef(
  (e, n) => {
    const {
      __scopeRadioGroup: i,
      name: t,
      defaultValue: a,
      value: s,
      required: r = !1,
      disabled: o = !1,
      orientation: d,
      dir: c,
      loop: u = !0,
      onValueChange: k,
      ...m
    } = e, f = Ob(i), p = Zu(c), [h, N] = Oa({
      prop: s,
      defaultProp: a != null ? a : null,
      onChange: k,
      caller: Am
    });
    return /* @__PURE__ */ l.jsx(
      FM,
      {
        scope: i,
        name: t,
        required: r,
        disabled: o,
        value: h,
        onValueChange: N,
        children: /* @__PURE__ */ l.jsx(
          kM,
          {
            asChild: !0,
            ...f,
            orientation: d,
            dir: p,
            loop: u,
            children: /* @__PURE__ */ l.jsx(
              ln.div,
              {
                role: "radiogroup",
                "aria-required": r,
                "aria-orientation": d,
                "data-disabled": o ? "" : void 0,
                dir: p,
                ...m,
                ref: n
              }
            )
          }
        )
      }
    );
  }
);
Jb.displayName = Am;
var _b = "RadioGroupItem", Qb = w.forwardRef(
  (e, n) => {
    const { __scopeRadioGroup: i, disabled: t, ...a } = e, s = IM(_b, i), r = s.disabled || t, o = Ob(i), d = Eb(i), c = w.useRef(null), u = Rn(n, c), k = s.value === a.value, m = w.useRef(!1);
    return w.useEffect(() => {
      const f = (h) => {
        SM.includes(h.key) && (m.current = !0);
      }, p = () => m.current = !1;
      return document.addEventListener("keydown", f), document.addEventListener("keyup", p), () => {
        document.removeEventListener("keydown", f), document.removeEventListener("keyup", p);
      };
    }, []), /* @__PURE__ */ l.jsx(
      fM,
      {
        asChild: !0,
        ...o,
        focusable: !r,
        active: k,
        children: /* @__PURE__ */ l.jsx(
          Pb,
          {
            disabled: r,
            required: s.required,
            checked: k,
            ...d,
            ...a,
            name: s.name,
            ref: u,
            onCheck: () => s.onValueChange(a.value),
            onKeyDown: nn((f) => {
              f.key === "Enter" && f.preventDefault();
            }),
            onFocus: nn(a.onFocus, () => {
              var f;
              m.current && ((f = c.current) == null || f.click());
            })
          }
        )
      }
    );
  }
);
Qb.displayName = _b;
var yM = "RadioGroupIndicator", Mb = w.forwardRef(
  (e, n) => {
    const { __scopeRadioGroup: i, ...t } = e, a = Eb(i);
    return /* @__PURE__ */ l.jsx(Tb, { ...a, ...t, ref: n });
  }
);
Mb.displayName = yM;
var Lb = Jb, $b = Qb, bM = Mb;
const Om = Li(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(Lb, { className: ce("ch-grid ch-gap-2", e), ...n, ref: i }));
Om.displayName = Lb.displayName;
const i1 = Li(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  $b,
  {
    ref: i,
    className: ce(
      "ch-aspect-square ch-min-h-6 ch-min-w-6 ch-rounded-full ch-border ch-border-gray-200 ch-text-gray-200",
      "focus-visible:ch-outline-none focus-visible:ch-ring-2 focus-visible:ch-ring-focus-600 focus-visible:ch-ring-offset-2",
      "disabled:ch-cursor-not-allowed disabled:ch-opacity-50",
      e
    ),
    ...n,
    children: /* @__PURE__ */ l.jsx(bM, { className: "ch-flex ch-h-full ch-w-full ch-items-center ch-justify-center ch-rounded-full ch-bg-primary", children: /* @__PURE__ */ l.jsx("div", { className: "ch-h-3 ch-w-3 ch-rounded-full ch-border ch-border-primary ch-bg-white" }) })
  }
));
i1.displayName = $b.displayName;
const Ub = Li(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  "textarea",
  {
    className: ce(
      "ch-flex ch-min-h-[104px] ch-w-full ch-rounded-md ch-border ch-border-gray-200 ch-bg-transparent ch-p-2.5 ch-text-sm",
      "placeholder:ch-text-base placeholder:ch-text-zinc-300",
      "focus-visible:ch-outline-none focus-visible:ch-ring-2 focus-visible:ch-ring-focus-600 focus-visible:ch-ring-offset-2",
      "disabled:ch-cursor-not-allowed disabled:ch-opacity-50",
      e
    ),
    ref: i,
    ...n
  }
));
Ub.displayName = "Textarea";
const CM = {
  warning: {
    background: "ch-bg-yellow-50",
    iconColor: "ch-text-yellow-400",
    icon: /* @__PURE__ */ l.jsx(lI, {})
  }
}, hd = Li(
  ({ children: e, variant: n = "warning", icon: i, className: t, ...a }, s) => {
    const r = CM[n], o = i != null ? i : r.icon;
    return /* @__PURE__ */ l.jsxs(
      "div",
      {
        ref: s,
        className: ce(
          "ch-flex ch-items-center ch-gap-x-4 ch-rounded-md ch-p-4 ch-text-left",
          r.background,
          t
        ),
        ...a,
        children: [
          /* @__PURE__ */ l.jsx("div", { className: ce(r.iconColor, "ch-flex-shrink-0"), children: o }),
          /* @__PURE__ */ l.jsx("div", { className: "ch-text-sm", children: e })
        ]
      }
    );
  }
);
hd.displayName = "Callout";
const xM = (e) => {
  var t;
  return P(e.imageUrls.at(0)) ? {
    kind: "ImageNotDisplayable"
  } : P(e.imageUrls.at(1)) ? {
    kind: "SingleImageDisplayable",
    imageUrl: (t = e.imageUrls.at(0)) != null ? t : ""
  } : {
    kind: "MultipleImagesDisplayable",
    imageUrls: e.imageUrls
  };
}, DM = (e) => ({
  state: v(() => xM(e), [e])
}), wM = ({ displayContext: e, styleContext: n }) => /* @__PURE__ */ l.jsx("div", { className: "ch-aspect-image ch-w-full", style: n, children: /* @__PURE__ */ l.jsx("img", { src: e.imageUrl, className: "ch-h-full ch-w-full ch-object-cover", style: n }) }), PM = 5, Xr = {
  MAXIMUM_DISPLAYABLE_NUMBER_OF_DOTS: PM
}, RM = (e) => {
  const n = e.index + 1, i = e.carouselApi.current;
  if (e.carouselApi.count <= Xr.MAXIMUM_DISPLAYABLE_NUMBER_OF_DOTS)
    return !0;
  if (i <= 3)
    return ja(
      Xr.MAXIMUM_DISPLAYABLE_NUMBER_OF_DOTS
    ).map((o) => 1 + o).includes(n);
  if (e.carouselApi.count - 2 <= i) {
    const s = e.carouselApi.count - (Xr.MAXIMUM_DISPLAYABLE_NUMBER_OF_DOTS - 1);
    return ja(
      Xr.MAXIMUM_DISPLAYABLE_NUMBER_OF_DOTS
    ).map((o) => s + o).includes(n);
  }
  const t = i - 2;
  return ja(Xr.MAXIMUM_DISPLAYABLE_NUMBER_OF_DOTS).map(
    (s) => t + s
  ).includes(n);
}, TM = (e) => {
  const n = e.index + 1, i = e.carouselApi.current, t = n === i;
  return RM(e) ? {
    kind: "Displayable",
    isCurrent: t
  } : {
    kind: "NotDisplayable"
  };
}, jM = (e) => ({
  state: v(() => TM(e), [e])
}), AM = ({ modelContext: e }) => {
  const { state: n } = jM(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx(
    "span",
    {
      className: ce(
        "ch-mx-1 ch-inline-block ch-h-2 ch-w-2 ch-shrink-0 ch-rounded-full",
        n.isCurrent ? "ch-bg-white" : "ch-scale-75 ch-bg-white/70"
      )
    }
  ) : null;
}, OM = ({ displayContext: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-absolute ch-inset-x-2 ch-bottom-2 ch-flex ch-justify-center", children: e.imageUrls.map((n, i) => /* @__PURE__ */ l.jsx(AM, { modelContext: { index: i, carouselApi: e.carouselApi } }, i)) }), EM = ({ displayContext: e, styleContext: n }) => {
  const i = HE();
  return /* @__PURE__ */ l.jsxs(Hy, { setApi: i.setApi, children: [
    /* @__PURE__ */ l.jsx(zy, { className: "ch-ml-0", children: e.imageUrls.map((t, a) => /* @__PURE__ */ l.jsx(
      By,
      {
        className: "ch-aspect-image ch-pl-[0px]",
        style: n,
        children: /* @__PURE__ */ l.jsx("img", { src: t, className: "ch-h-full ch-w-full ch-object-cover", style: n })
      },
      a
    )) }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-absolute ch-bottom-2 ch-right-4 ch-flex ch-items-center ch-justify-center ch-gap-x-1 ch-rounded ch-bg-black/70 ch-px-1 ch-py-0.5 ch-tabular-nums", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-font-extralight ch-text-white", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: i.current }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: "/" }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: i.count })
    ] }) }),
    /* @__PURE__ */ l.jsx(OM, { displayContext: { carouselApi: i, imageUrls: e.imageUrls } })
  ] });
}, Ut = ({ modelContext: e, styleContext: n }) => {
  const { state: i } = DM(e);
  switch (i.kind) {
    case "SingleImageDisplayable":
      return /* @__PURE__ */ l.jsx(
        wM,
        {
          displayContext: { imageUrl: i.imageUrl },
          styleContext: n
        }
      );
    case "MultipleImagesDisplayable":
      return /* @__PURE__ */ l.jsx(
        EM,
        {
          displayContext: { imageUrls: i.imageUrls },
          styleContext: n
        }
      );
    default:
      return null;
  }
};
var Em = "Dialog", [Vb] = $t(Em), [JM, ua] = Vb(Em), Hb = (e) => {
  const {
    __scopeDialog: n,
    children: i,
    open: t,
    defaultOpen: a,
    onOpenChange: s,
    modal: r = !0
  } = e, o = w.useRef(null), d = w.useRef(null), [c, u] = Oa({
    prop: t,
    defaultProp: a != null ? a : !1,
    onChange: s,
    caller: Em
  });
  return /* @__PURE__ */ l.jsx(
    JM,
    {
      scope: n,
      triggerRef: o,
      contentRef: d,
      contentId: Za(),
      titleId: Za(),
      descriptionId: Za(),
      open: c,
      onOpenChange: u,
      onOpenToggle: w.useCallback(() => u((k) => !k), [u]),
      modal: r,
      children: i
    }
  );
};
Hb.displayName = Em;
var zb = "DialogTrigger", Bb = w.forwardRef(
  (e, n) => {
    const { __scopeDialog: i, ...t } = e, a = ua(zb, i), s = Rn(n, a.triggerRef);
    return /* @__PURE__ */ l.jsx(
      ln.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": Ov(a.open),
        ...t,
        ref: s,
        onClick: nn(e.onClick, a.onOpenToggle)
      }
    );
  }
);
Bb.displayName = zb;
var jv = "DialogPortal", [_M, qb] = Vb(jv, {
  forceMount: void 0
}), Gb = (e) => {
  const { __scopeDialog: n, forceMount: i, children: t, container: a } = e, s = ua(jv, n);
  return /* @__PURE__ */ l.jsx(_M, { scope: n, forceMount: i, children: w.Children.map(t, (r) => /* @__PURE__ */ l.jsx(kl, { present: i || s.open, children: /* @__PURE__ */ l.jsx(wv, { asChild: !0, container: a, children: r }) })) });
};
Gb.displayName = jv;
var gu = "DialogOverlay", Wb = w.forwardRef(
  (e, n) => {
    const i = qb(gu, e.__scopeDialog), { forceMount: t = i.forceMount, ...a } = e, s = ua(gu, e.__scopeDialog);
    return s.modal ? /* @__PURE__ */ l.jsx(kl, { present: t || s.open, children: /* @__PURE__ */ l.jsx(MM, { ...a, ref: n }) }) : null;
  }
);
Wb.displayName = gu;
var QM = /* @__PURE__ */ B1("DialogOverlay.RemoveScroll"), MM = w.forwardRef(
  (e, n) => {
    const { __scopeDialog: i, ...t } = e, a = ua(gu, i);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ l.jsx(Pm, { as: QM, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ l.jsx(
        ln.div,
        {
          "data-state": Ov(a.open),
          ...t,
          ref: n,
          style: { pointerEvents: "auto", ...t.style }
        }
      ) })
    );
  }
), Bs = "DialogContent", Kb = w.forwardRef(
  (e, n) => {
    const i = qb(Bs, e.__scopeDialog), { forceMount: t = i.forceMount, ...a } = e, s = ua(Bs, e.__scopeDialog);
    return /* @__PURE__ */ l.jsx(kl, { present: t || s.open, children: s.modal ? /* @__PURE__ */ l.jsx(LM, { ...a, ref: n }) : /* @__PURE__ */ l.jsx($M, { ...a, ref: n }) });
  }
);
Kb.displayName = Bs;
var LM = w.forwardRef(
  (e, n) => {
    const i = ua(Bs, e.__scopeDialog), t = w.useRef(null), a = Rn(n, i.contentRef, t);
    return w.useEffect(() => {
      const s = t.current;
      if (s) return Pv(s);
    }, []), /* @__PURE__ */ l.jsx(
      Yb,
      {
        ...e,
        ref: a,
        trapFocus: i.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: nn(e.onCloseAutoFocus, (s) => {
          var r;
          s.preventDefault(), (r = i.triggerRef.current) == null || r.focus();
        }),
        onPointerDownOutside: nn(e.onPointerDownOutside, (s) => {
          const r = s.detail.originalEvent, o = r.button === 0 && r.ctrlKey === !0;
          (r.button === 2 || o) && s.preventDefault();
        }),
        onFocusOutside: nn(
          e.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), $M = w.forwardRef(
  (e, n) => {
    const i = ua(Bs, e.__scopeDialog), t = w.useRef(!1), a = w.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      Yb,
      {
        ...e,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var r, o;
          (r = e.onCloseAutoFocus) == null || r.call(e, s), s.defaultPrevented || (t.current || (o = i.triggerRef.current) == null || o.focus(), s.preventDefault()), t.current = !1, a.current = !1;
        },
        onInteractOutside: (s) => {
          var d, c;
          (d = e.onInteractOutside) == null || d.call(e, s), s.defaultPrevented || (t.current = !0, s.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const r = s.target;
          ((c = i.triggerRef.current) == null ? void 0 : c.contains(r)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && a.current && s.preventDefault();
        }
      }
    );
  }
), Yb = w.forwardRef(
  (e, n) => {
    const { __scopeDialog: i, trapFocus: t, onOpenAutoFocus: a, onCloseAutoFocus: s, ...r } = e, o = ua(Bs, i), d = w.useRef(null), c = Rn(n, d);
    return Nv(), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        Im,
        {
          asChild: !0,
          loop: !0,
          trapped: t,
          onMountAutoFocus: a,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ l.jsx(
            Fm,
            {
              role: "dialog",
              id: o.contentId,
              "aria-describedby": o.descriptionId,
              "aria-labelledby": o.titleId,
              "data-state": Ov(o.open),
              ...r,
              ref: c,
              onDismiss: () => o.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        /* @__PURE__ */ l.jsx(UM, { titleId: o.titleId }),
        /* @__PURE__ */ l.jsx(HM, { contentRef: d, descriptionId: o.descriptionId })
      ] })
    ] });
  }
), Av = "DialogTitle", Xb = w.forwardRef(
  (e, n) => {
    const { __scopeDialog: i, ...t } = e, a = ua(Av, i);
    return /* @__PURE__ */ l.jsx(ln.h2, { id: a.titleId, ...t, ref: n });
  }
);
Xb.displayName = Av;
var Zb = "DialogDescription", e5 = w.forwardRef(
  (e, n) => {
    const { __scopeDialog: i, ...t } = e, a = ua(Zb, i);
    return /* @__PURE__ */ l.jsx(ln.p, { id: a.descriptionId, ...t, ref: n });
  }
);
e5.displayName = Zb;
var n5 = "DialogClose", i5 = w.forwardRef(
  (e, n) => {
    const { __scopeDialog: i, ...t } = e, a = ua(n5, i);
    return /* @__PURE__ */ l.jsx(
      ln.button,
      {
        type: "button",
        ...t,
        ref: n,
        onClick: nn(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
i5.displayName = n5;
function Ov(e) {
  return e ? "open" : "closed";
}
var t5 = "DialogTitleWarning", [Gxe, a5] = G8(t5, {
  contentName: Bs,
  titleName: Av,
  docsSlug: "dialog"
}), UM = ({ titleId: e }) => {
  const n = a5(t5), i = `\`${n.contentName}\` requires a \`${n.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${n.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${n.docsSlug}`;
  return w.useEffect(() => {
    e && (document.getElementById(e) || console.error(i));
  }, [i, e]), null;
}, VM = "DialogDescriptionWarning", HM = ({ contentRef: e, descriptionId: n }) => {
  const t = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${a5(VM).contentName}}.`;
  return w.useEffect(() => {
    var s;
    const a = (s = e.current) == null ? void 0 : s.getAttribute("aria-describedby");
    n && a && (document.getElementById(n) || console.warn(t));
  }, [t, e, n]), null;
}, l5 = Hb, zM = Bb, s5 = Gb, Ev = Wb, Jm = Kb, Jv = Xb, _v = e5, BM = i5;
const r5 = Ot(null), Wxe = ({ container: e, children: n }) => /* @__PURE__ */ l.jsx(r5.Provider, { value: e, children: n }), yr = () => {
  var e;
  return (e = oi(r5)) != null ? e : void 0;
}, br = l5, o5 = (e) => /* @__PURE__ */ l.jsx(s5, { container: yr(), ...e }), Qv = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  Ev,
  {
    ref: i,
    className: ce(
      "ch-fixed ch-inset-0 ch-z-[199] ch-bg-black/80 data-[state=open]:ch-animate-in data-[state=closed]:ch-animate-out data-[state=closed]:ch-fade-out-0 data-[state=open]:ch-fade-in-0",
      e
    ),
    ...n
  }
));
Qv.displayName = Ev.displayName;
const Cr = w.forwardRef(({ className: e, children: n, ...i }, t) => /* @__PURE__ */ l.jsxs(o5, { children: [
  /* @__PURE__ */ l.jsx(Qv, {}),
  /* @__PURE__ */ l.jsx(
    Jm,
    {
      ref: t,
      className: ce(
        "ch-fixed ch-left-[50%] ch-top-[50%] ch-z-[200] ch-grid ch-w-full ch-max-w-lg ch-translate-x-[-50%] ch-translate-y-[-50%] ch-gap-4 ch-rounded-lg ch-border ch-border-zinc-200 ch-bg-white ch-p-6 ch-shadow-lg ch-duration-200 data-[state=open]:ch-animate-in data-[state=closed]:ch-animate-out data-[state=closed]:ch-fade-out-0 data-[state=open]:ch-fade-in-0 data-[state=closed]:ch-zoom-out-95 data-[state=open]:ch-zoom-in-95 data-[state=closed]:ch-slide-out-to-left-1/2 data-[state=closed]:ch-slide-out-to-top-[48%] data-[state=open]:ch-slide-in-from-left-1/2 data-[state=open]:ch-slide-in-from-top-[48%]",
        e
      ),
      ...i,
      children: n
    }
  )
] }));
Cr.displayName = Jm.displayName;
const d5 = ({ className: e, ...n }) => /* @__PURE__ */ l.jsx("div", { className: ce("ch-flex ch-flex-col ch-space-y-1.5 ch-text-left", e), ...n });
d5.displayName = "DialogHeader";
const t1 = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  Jv,
  {
    ref: i,
    className: ce("ch-text-lg ch-font-semibold ch-leading-none ch-tracking-tight", e),
    ...n
  }
));
t1.displayName = Jv.displayName;
const qM = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  _v,
  {
    ref: i,
    className: ce("ch-text-muted-foreground ch-text-sm", e),
    ...n
  }
));
qM.displayName = _v.displayName;
function GM(e) {
  if (typeof document == "undefined") return;
  let n = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
  i.type = "text/css", n.appendChild(i), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e));
}
const c5 = K.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), xr = () => {
  const e = K.useContext(c5);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
GM(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function WM() {
  const e = navigator.userAgent;
  return typeof window != "undefined" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function KM() {
  return Mv(/^Mac/);
}
function YM() {
  return Mv(/^iPhone/);
}
function C4() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function XM() {
  return Mv(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  KM() && navigator.maxTouchPoints > 1;
}
function u5() {
  return YM() || XM();
}
function Mv(e) {
  return typeof window != "undefined" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const ZM = 24, eL = typeof window != "undefined" ? as : be;
function x4(...e) {
  return (...n) => {
    for (let i of e)
      typeof i == "function" && i(...n);
  };
}
const A0 = typeof document != "undefined" && window.visualViewport;
function D4(e) {
  let n = window.getComputedStyle(e);
  return /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
}
function m5(e) {
  for (D4(e) && (e = e.parentElement); e && !D4(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const nL = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let dc = 0, O0;
function iL(e = {}) {
  let { isDisabled: n } = e;
  eL(() => {
    if (!n)
      return dc++, dc === 1 && u5() && (O0 = tL()), () => {
        dc--, dc === 0 && (O0 == null || O0());
      };
  }, [
    n
  ]);
}
function tL() {
  let e, n = 0, i = (k) => {
    e = m5(k.target), !(e === document.documentElement && e === document.body) && (n = k.changedTouches[0].pageY);
  }, t = (k) => {
    if (!e || e === document.documentElement || e === document.body) {
      k.preventDefault();
      return;
    }
    let m = k.changedTouches[0].pageY, f = e.scrollTop, p = e.scrollHeight - e.clientHeight;
    p !== 0 && ((f <= 0 && m > n || f >= p && m < n) && k.preventDefault(), n = m);
  }, a = (k) => {
    let m = k.target;
    ok(m) && m !== document.activeElement && (k.preventDefault(), m.style.transform = "translateY(-2000px)", m.focus(), requestAnimationFrame(() => {
      m.style.transform = "";
    }));
  }, s = (k) => {
    let m = k.target;
    ok(m) && (m.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      m.style.transform = "", A0 && (A0.height < window.innerHeight ? requestAnimationFrame(() => {
        w4(m);
      }) : A0.addEventListener("resize", () => w4(m), {
        once: !0
      }));
    }));
  }, r = () => {
    window.scrollTo(0, 0);
  }, o = window.pageXOffset, d = window.pageYOffset, c = x4(aL(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = x4(Zr(document, "touchstart", i, {
    passive: !1,
    capture: !0
  }), Zr(document, "touchmove", t, {
    passive: !1,
    capture: !0
  }), Zr(document, "touchend", a, {
    passive: !1,
    capture: !0
  }), Zr(document, "focus", s, !0), Zr(window, "scroll", r));
  return () => {
    c(), u(), window.scrollTo(o, d);
  };
}
function aL(e, n, i) {
  let t = e.style[n];
  return e.style[n] = i, () => {
    e.style[n] = t;
  };
}
function Zr(e, n, i, t) {
  return e.addEventListener(n, i, t), () => {
    e.removeEventListener(n, i, t);
  };
}
function w4(e) {
  let n = document.scrollingElement || document.documentElement;
  for (; e && e !== n; ) {
    let i = m5(e);
    if (i !== document.documentElement && i !== document.body && i !== e) {
      let t = i.getBoundingClientRect().top, a = e.getBoundingClientRect().top, s = e.getBoundingClientRect().bottom;
      const r = i.getBoundingClientRect().bottom + ZM;
      s > r && (i.scrollTop += a - t);
    }
    e = i.parentElement;
  }
}
function ok(e) {
  return e instanceof HTMLInputElement && !nL.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function lL(e, n) {
  typeof e == "function" ? e(n) : e != null && (e.current = n);
}
function sL(...e) {
  return (n) => e.forEach((i) => lL(i, n));
}
function k5(...e) {
  return w.useCallback(sL(...e), e);
}
const f5 = /* @__PURE__ */ new WeakMap();
function Ti(e, n, i = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let t = {};
  Object.entries(n).forEach(([a, s]) => {
    if (a.startsWith("--")) {
      e.style.setProperty(a, s);
      return;
    }
    t[a] = e.style[a], e.style[a] = s;
  }), !i && f5.set(e, t);
}
function rL(e, n) {
  if (!e || !(e instanceof HTMLElement)) return;
  let i = f5.get(e);
  i && (e.style[n] = i[n]);
}
const bi = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function cc(e, n) {
  if (!e)
    return null;
  const i = window.getComputedStyle(e), t = (
    // @ts-ignore
    i.transform || i.webkitTransform || i.mozTransform
  );
  let a = t.match(/^matrix3d\((.+)\)$/);
  return a ? parseFloat(a[1].split(", ")[bi(n) ? 13 : 12]) : (a = t.match(/^matrix\((.+)\)$/), a ? parseFloat(a[1].split(", ")[bi(n) ? 5 : 4]) : null);
}
function oL(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function E0(e, n) {
  if (!e) return () => {
  };
  const i = e.style.cssText;
  return Object.assign(e.style, n), () => {
    e.style.cssText = i;
  };
}
function dL(...e) {
  return (...n) => {
    for (const i of e)
      typeof i == "function" && i(...n);
  };
}
const si = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, v5 = 0.4, cL = 0.25, uL = 100, h5 = 8, Cs = 16, dk = 26, J0 = "vaul-dragging";
function p5(e) {
  const n = K.useRef(e);
  return K.useEffect(() => {
    n.current = e;
  }), K.useMemo(() => (...i) => n.current == null ? void 0 : n.current.call(n, ...i), []);
}
function mL({ defaultProp: e, onChange: n }) {
  const i = K.useState(e), [t] = i, a = K.useRef(t), s = p5(n);
  return K.useEffect(() => {
    a.current !== t && (s(t), a.current = t);
  }, [
    t,
    a,
    s
  ]), i;
}
function N5({ prop: e, defaultProp: n, onChange: i = () => {
} }) {
  const [t, a] = mL({
    defaultProp: n,
    onChange: i
  }), s = e !== void 0, r = s ? e : t, o = p5(i), d = K.useCallback((c) => {
    if (s) {
      const k = typeof c == "function" ? c(e) : c;
      k !== e && o(k);
    } else
      a(c);
  }, [
    s,
    e,
    a,
    o
  ]);
  return [
    r,
    d
  ];
}
function kL({ activeSnapPointProp: e, setActiveSnapPointProp: n, snapPoints: i, drawerRef: t, overlayRef: a, fadeFromIndex: s, onSnapPointChange: r, direction: o = "bottom", container: d, snapToSequentialPoint: c }) {
  const [u, k] = N5({
    prop: e,
    defaultProp: i == null ? void 0 : i[0],
    onChange: n
  }), [m, f] = K.useState(typeof window != "undefined" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  K.useEffect(() => {
    function j() {
      f({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", j), () => window.removeEventListener("resize", j);
  }, []);
  const p = K.useMemo(() => u === (i == null ? void 0 : i[i.length - 1]) || null, [
    i,
    u
  ]), h = K.useMemo(() => {
    var j;
    return (j = i == null ? void 0 : i.findIndex((A) => A === u)) != null ? j : null;
  }, [
    i,
    u
  ]), N = i && i.length > 0 && (s || s === 0) && !Number.isNaN(s) && i[s] === u || !i, S = K.useMemo(() => {
    const j = d ? {
      width: d.getBoundingClientRect().width,
      height: d.getBoundingClientRect().height
    } : typeof window != "undefined" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var A;
    return (A = i == null ? void 0 : i.map((B) => {
      const W = typeof B == "string";
      let E = 0;
      if (W && (E = parseInt(B, 10)), bi(o)) {
        const V = W ? E : m ? B * j.height : 0;
        return m ? o === "bottom" ? j.height - V : -j.height + V : V;
      }
      const $ = W ? E : m ? B * j.width : 0;
      return m ? o === "right" ? j.width - $ : -j.width + $ : $;
    })) != null ? A : [];
  }, [
    i,
    m,
    d
  ]), F = K.useMemo(() => h !== null ? S == null ? void 0 : S[h] : null, [
    S,
    h
  ]), y = K.useCallback((j) => {
    var A;
    const B = (A = S == null ? void 0 : S.findIndex((W) => W === j)) != null ? A : null;
    r(B), Ti(t.current, {
      transition: `transform ${si.DURATION}s cubic-bezier(${si.EASE.join(",")})`,
      transform: bi(o) ? `translate3d(0, ${j}px, 0)` : `translate3d(${j}px, 0, 0)`
    }), S && B !== S.length - 1 && s !== void 0 && B !== s && B < s ? Ti(a.current, {
      transition: `opacity ${si.DURATION}s cubic-bezier(${si.EASE.join(",")})`,
      opacity: "0"
    }) : Ti(a.current, {
      transition: `opacity ${si.DURATION}s cubic-bezier(${si.EASE.join(",")})`,
      opacity: "1"
    }), k(i == null ? void 0 : i[Math.max(B, 0)]);
  }, [
    t.current,
    i,
    S,
    s,
    a,
    k
  ]);
  K.useEffect(() => {
    if (u || e) {
      var j;
      const A = (j = i == null ? void 0 : i.findIndex((B) => B === e || B === u)) != null ? j : -1;
      S && A !== -1 && typeof S[A] == "number" && y(S[A]);
    }
  }, [
    u,
    e,
    i,
    S,
    y
  ]);
  function x({ draggedDistance: j, closeDrawer: A, velocity: B, dismissible: W }) {
    if (s === void 0) return;
    const E = o === "bottom" || o === "right" ? (F != null ? F : 0) - j : (F != null ? F : 0) + j, $ = h === s - 1, V = h === 0, H = j > 0;
    if ($ && Ti(a.current, {
      transition: `opacity ${si.DURATION}s cubic-bezier(${si.EASE.join(",")})`
    }), !c && B > 2 && !H) {
      W ? A() : y(S[0]);
      return;
    }
    if (!c && B > 2 && H && S && i) {
      y(S[i.length - 1]);
      return;
    }
    const O = S == null ? void 0 : S.reduce((L, _) => typeof L != "number" || typeof _ != "number" ? L : Math.abs(_ - E) < Math.abs(L - E) ? _ : L), M = bi(o) ? window.innerHeight : window.innerWidth;
    if (B > v5 && Math.abs(j) < M * 0.4) {
      const L = H ? 1 : -1;
      if (L > 0 && p && i) {
        y(S[i.length - 1]);
        return;
      }
      if (V && L < 0 && W && A(), h === null) return;
      y(S[h + L]);
      return;
    }
    y(O);
  }
  function R({ draggedDistance: j }) {
    if (F === null) return;
    const A = o === "bottom" || o === "right" ? F - j : F + j;
    (o === "bottom" || o === "right") && A < S[S.length - 1] || (o === "top" || o === "left") && A > S[S.length - 1] || Ti(t.current, {
      transform: bi(o) ? `translate3d(0, ${A}px, 0)` : `translate3d(${A}px, 0, 0)`
    });
  }
  function T(j, A) {
    if (!i || typeof h != "number" || !S || s === void 0) return null;
    const B = h === s - 1;
    if (h >= s && A)
      return 0;
    if (B && !A) return 1;
    if (!N && !B) return null;
    const E = B ? h + 1 : h - 1, $ = B ? S[E] - S[E - 1] : S[E + 1] - S[E], V = j / Math.abs($);
    return B ? 1 - V : V;
  }
  return {
    isLastSnapPoint: p,
    activeSnapPoint: u,
    shouldFade: N,
    getPercentageDragged: T,
    setActiveSnapPoint: k,
    activeSnapPointIndex: h,
    onRelease: x,
    onDrag: R,
    snapPointsOffset: S
  };
}
const fL = () => () => {
};
function vL() {
  const { direction: e, isOpen: n, shouldScaleBackground: i, setBackgroundColorOnScale: t, noBodyStyles: a } = xr(), s = K.useRef(null), r = v(() => document.body.style.backgroundColor, []);
  function o() {
    return (window.innerWidth - dk) / window.innerWidth;
  }
  K.useEffect(() => {
    if (n && i) {
      s.current && clearTimeout(s.current);
      const d = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!d) return;
      dL(t && !a ? E0(document.body, {
        background: "black"
      }) : fL, E0(d, {
        transformOrigin: bi(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${si.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${si.EASE.join(",")})`
      }));
      const c = E0(d, {
        borderRadius: `${h5}px`,
        overflow: "hidden",
        ...bi(e) ? {
          transform: `scale(${o()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${o()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        c(), s.current = window.setTimeout(() => {
          r ? document.body.style.background = r : document.body.style.removeProperty("background");
        }, si.DURATION * 1e3);
      };
    }
  }, [
    n,
    i,
    r
  ]);
}
let eo = null;
function hL({ isOpen: e, modal: n, nested: i, hasBeenOpened: t, preventScrollRestoration: a, noBodyStyles: s }) {
  const [r, o] = K.useState(() => typeof window != "undefined" ? window.location.href : ""), d = K.useRef(0), c = K.useCallback(() => {
    if (C4() && eo === null && e && !s) {
      eo = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: k, innerHeight: m } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-d.current}px`,
        left: `${-k}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const f = m - window.innerHeight;
        f && d.current >= m && (document.body.style.top = `${-(d.current + f)}px`);
      }), 300);
    }
  }, [
    e
  ]), u = K.useCallback(() => {
    if (C4() && eo !== null && !s) {
      const k = -parseInt(document.body.style.top, 10), m = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, eo), window.requestAnimationFrame(() => {
        if (a && r !== window.location.href) {
          o(window.location.href);
          return;
        }
        window.scrollTo(m, k);
      }), eo = null;
    }
  }, [
    r
  ]);
  return K.useEffect(() => {
    function k() {
      d.current = window.scrollY;
    }
    return k(), window.addEventListener("scroll", k), () => {
      window.removeEventListener("scroll", k);
    };
  }, []), K.useEffect(() => {
    if (n)
      return () => {
        typeof document == "undefined" || document.querySelector("[data-vaul-drawer]") || u();
      };
  }, [
    n,
    u
  ]), K.useEffect(() => {
    i || !t || (e ? (!window.matchMedia("(display-mode: standalone)").matches && c(), n || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    e,
    t,
    r,
    n,
    i,
    c,
    u
  ]), {
    restorePositionSetting: u
  };
}
function S5({ open: e, onOpenChange: n, children: i, onDrag: t, onRelease: a, snapPoints: s, shouldScaleBackground: r = !1, setBackgroundColorOnScale: o = !0, closeThreshold: d = cL, scrollLockTimeout: c = uL, dismissible: u = !0, handleOnly: k = !1, fadeFromIndex: m = s && s.length - 1, activeSnapPoint: f, setActiveSnapPoint: p, fixed: h, modal: N = !0, onClose: S, nested: F, noBodyStyles: y = !1, direction: x = "bottom", defaultOpen: R = !1, disablePreventScroll: T = !0, snapToSequentialPoint: j = !1, preventScrollRestoration: A = !1, repositionInputs: B = !0, onAnimationEnd: W, container: E, autoFocus: $ = !1 }) {
  var V, H;
  const [O = !1, M] = N5({
    defaultProp: R,
    prop: e,
    onChange: (Le) => {
      n == null || n(Le), !Le && !F && Ui(), setTimeout(() => {
        W == null || W(Le);
      }, si.DURATION * 1e3), Le && !N && typeof window != "undefined" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), Le || (document.body.style.pointerEvents = "auto");
    }
  }), [L, _] = K.useState(!1), [z, ne] = K.useState(!1), [Se, he] = K.useState(!1), ue = K.useRef(null), oe = K.useRef(null), $e = K.useRef(null), we = K.useRef(null), ie = K.useRef(null), De = K.useRef(!1), _e = K.useRef(null), Ie = K.useRef(0), Fe = K.useRef(!1), re = K.useRef(!R), Me = K.useRef(0), ge = K.useRef(null), rn = K.useRef(((V = ge.current) == null ? void 0 : V.getBoundingClientRect().height) || 0), Sn = K.useRef(((H = ge.current) == null ? void 0 : H.getBoundingClientRect().width) || 0), Jn = K.useRef(0), Xn = K.useCallback((Le) => {
    s && Le === pi.length - 1 && (oe.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: Mn, activeSnapPointIndex: Zn, setActiveSnapPoint: mn, onRelease: We, snapPointsOffset: pi, onDrag: Fi, shouldFade: ut, getPercentageDragged: ti } = kL({
    snapPoints: s,
    activeSnapPointProp: f,
    setActiveSnapPointProp: p,
    drawerRef: ge,
    fadeFromIndex: m,
    overlayRef: ue,
    onSnapPointChange: Xn,
    direction: x,
    container: E,
    snapToSequentialPoint: j
  });
  iL({
    isDisabled: !O || z || !N || Se || !L || !B || !T
  });
  const { restorePositionSetting: Ui } = hL({
    isOpen: O,
    modal: N,
    nested: F != null ? F : !1,
    hasBeenOpened: L,
    preventScrollRestoration: A,
    noBodyStyles: y
  });
  function Ct() {
    return (window.innerWidth - dk) / window.innerWidth;
  }
  function xt(Le) {
    var Xe, gn;
    !u && !s || ge.current && !ge.current.contains(Le.target) || (rn.current = ((Xe = ge.current) == null ? void 0 : Xe.getBoundingClientRect().height) || 0, Sn.current = ((gn = ge.current) == null ? void 0 : gn.getBoundingClientRect().width) || 0, ne(!0), $e.current = /* @__PURE__ */ new Date(), u5() && window.addEventListener("touchend", () => De.current = !1, {
      once: !0
    }), Le.target.setPointerCapture(Le.pointerId), Ie.current = bi(x) ? Le.pageY : Le.pageX);
  }
  function Di(Le, Xe) {
    var gn;
    let Ze = Le;
    const vn = (gn = window.getSelection()) == null ? void 0 : gn.toString(), zn = ge.current ? cc(ge.current, x) : null, je = /* @__PURE__ */ new Date();
    if (Ze.tagName === "SELECT" || Ze.hasAttribute("data-vaul-no-drag") || Ze.closest("[data-vaul-no-drag]"))
      return !1;
    if (x === "right" || x === "left")
      return !0;
    if (oe.current && je.getTime() - oe.current.getTime() < 500)
      return !1;
    if (zn !== null && (x === "bottom" ? zn > 0 : zn < 0))
      return !0;
    if (vn && vn.length > 0)
      return !1;
    if (ie.current && je.getTime() - ie.current.getTime() < c && zn === 0 || Xe)
      return ie.current = je, !1;
    for (; Ze; ) {
      if (Ze.scrollHeight > Ze.clientHeight) {
        if (Ze.scrollTop !== 0)
          return ie.current = /* @__PURE__ */ new Date(), !1;
        if (Ze.getAttribute("role") === "dialog")
          return !0;
      }
      Ze = Ze.parentNode;
    }
    return !0;
  }
  function Bt(Le) {
    if (ge.current && z) {
      const Xe = x === "bottom" || x === "right" ? 1 : -1, gn = (Ie.current - (bi(x) ? Le.pageY : Le.pageX)) * Xe, Ze = gn > 0, vn = s && !u && !Ze;
      if (vn && Zn === 0) return;
      const zn = Math.abs(gn), je = document.querySelector("[data-vaul-drawer-wrapper]"), He = x === "bottom" || x === "top" ? rn.current : Sn.current;
      let sn = zn / He;
      const ei = ti(zn, Ze);
      if (ei !== null && (sn = ei), vn && sn >= 1 || !De.current && !Di(Le.target, Ze)) return;
      if (ge.current.classList.add(J0), De.current = !0, Ti(ge.current, {
        transition: "none"
      }), Ti(ue.current, {
        transition: "none"
      }), s && Fi({
        draggedDistance: gn
      }), Ze && !s) {
        const ni = oL(gn), _i = Math.min(ni * -1, 0) * Xe;
        Ti(ge.current, {
          transform: bi(x) ? `translate3d(0, ${_i}px, 0)` : `translate3d(${_i}px, 0, 0)`
        });
        return;
      }
      const hn = 1 - sn;
      if ((ut || m && Zn === m - 1) && (t == null || t(Le, sn), Ti(ue.current, {
        opacity: `${hn}`,
        transition: "none"
      }, !0)), je && ue.current && r) {
        const ni = Math.min(Ct() + sn * (1 - Ct()), 1), _i = 8 - sn * 8, ui = Math.max(0, 14 - sn * 14);
        Ti(je, {
          borderRadius: `${_i}px`,
          transform: bi(x) ? `scale(${ni}) translate3d(0, ${ui}px, 0)` : `scale(${ni}) translate3d(${ui}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!s) {
        const ni = zn * Xe;
        Ti(ge.current, {
          transform: bi(x) ? `translate3d(0, ${ni}px, 0)` : `translate3d(${ni}px, 0, 0)`
        });
      }
    }
  }
  K.useEffect(() => {
    window.requestAnimationFrame(() => {
      re.current = !0;
    });
  }, []), K.useEffect(() => {
    var Le;
    function Xe() {
      if (!ge.current || !B) return;
      const gn = document.activeElement;
      if (ok(gn) || Fe.current) {
        var Ze;
        const vn = ((Ze = window.visualViewport) == null ? void 0 : Ze.height) || 0, zn = window.innerHeight;
        let je = zn - vn;
        const He = ge.current.getBoundingClientRect().height || 0, sn = He > zn * 0.8;
        Jn.current || (Jn.current = He);
        const ei = ge.current.getBoundingClientRect().top;
        if (Math.abs(Me.current - je) > 60 && (Fe.current = !Fe.current), s && s.length > 0 && pi && Zn) {
          const hn = pi[Zn] || 0;
          je += hn;
        }
        if (Me.current = je, He > vn || Fe.current) {
          const hn = ge.current.getBoundingClientRect().height;
          let ni = hn;
          hn > vn && (ni = vn - (sn ? ei : dk)), h ? ge.current.style.height = `${hn - Math.max(je, 0)}px` : ge.current.style.height = `${Math.max(ni, vn - ei)}px`;
        } else WM() || (ge.current.style.height = `${Jn.current}px`);
        s && s.length > 0 && !Fe.current ? ge.current.style.bottom = "0px" : ge.current.style.bottom = `${Math.max(je, 0)}px`;
      }
    }
    return (Le = window.visualViewport) == null || Le.addEventListener("resize", Xe), () => {
      var gn;
      return (gn = window.visualViewport) == null ? void 0 : gn.removeEventListener("resize", Xe);
    };
  }, [
    Zn,
    s,
    pi
  ]);
  function wi(Le) {
    Vi(), S == null || S(), Le || M(!1), setTimeout(() => {
      s && mn(s[0]);
    }, si.DURATION * 1e3);
  }
  function Pi() {
    if (!ge.current) return;
    const Le = document.querySelector("[data-vaul-drawer-wrapper]"), Xe = cc(ge.current, x);
    Ti(ge.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${si.DURATION}s cubic-bezier(${si.EASE.join(",")})`
    }), Ti(ue.current, {
      transition: `opacity ${si.DURATION}s cubic-bezier(${si.EASE.join(",")})`,
      opacity: "1"
    }), r && Xe && Xe > 0 && O && Ti(Le, {
      borderRadius: `${h5}px`,
      overflow: "hidden",
      ...bi(x) ? {
        transform: `scale(${Ct()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Ct()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${si.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${si.EASE.join(",")})`
    }, !0);
  }
  function Vi() {
    !z || !ge.current || (ge.current.classList.remove(J0), De.current = !1, ne(!1), we.current = /* @__PURE__ */ new Date());
  }
  function mt(Le) {
    if (!z || !ge.current) return;
    ge.current.classList.remove(J0), De.current = !1, ne(!1), we.current = /* @__PURE__ */ new Date();
    const Xe = cc(ge.current, x);
    if (!Le || !Di(Le.target, !1) || !Xe || Number.isNaN(Xe) || $e.current === null) return;
    const gn = we.current.getTime() - $e.current.getTime(), Ze = Ie.current - (bi(x) ? Le.pageY : Le.pageX), vn = Math.abs(Ze) / gn;
    if (vn > 0.05 && (he(!0), setTimeout(() => {
      he(!1);
    }, 200)), s) {
      We({
        draggedDistance: Ze * (x === "bottom" || x === "right" ? 1 : -1),
        closeDrawer: wi,
        velocity: vn,
        dismissible: u
      }), a == null || a(Le, !0);
      return;
    }
    if (x === "bottom" || x === "right" ? Ze > 0 : Ze < 0) {
      Pi(), a == null || a(Le, !0);
      return;
    }
    if (vn > v5) {
      wi(), a == null || a(Le, !1);
      return;
    }
    var zn;
    const je = Math.min((zn = ge.current.getBoundingClientRect().height) != null ? zn : 0, window.innerHeight);
    var He;
    const sn = Math.min((He = ge.current.getBoundingClientRect().width) != null ? He : 0, window.innerWidth), ei = x === "left" || x === "right";
    if (Math.abs(Xe) >= (ei ? sn : je) * d) {
      wi(), a == null || a(Le, !1);
      return;
    }
    a == null || a(Le, !0), Pi();
  }
  K.useEffect(() => (O && (Ti(document.documentElement, {
    scrollBehavior: "auto"
  }), oe.current = /* @__PURE__ */ new Date()), () => {
    rL(document.documentElement, "scrollBehavior");
  }), [
    O
  ]);
  function ot(Le) {
    const Xe = Le ? (window.innerWidth - Cs) / window.innerWidth : 1, gn = Le ? -Cs : 0;
    _e.current && window.clearTimeout(_e.current), Ti(ge.current, {
      transition: `transform ${si.DURATION}s cubic-bezier(${si.EASE.join(",")})`,
      transform: bi(x) ? `scale(${Xe}) translate3d(0, ${gn}px, 0)` : `scale(${Xe}) translate3d(${gn}px, 0, 0)`
    }), !Le && ge.current && (_e.current = setTimeout(() => {
      const Ze = cc(ge.current, x);
      Ti(ge.current, {
        transition: "none",
        transform: bi(x) ? `translate3d(0, ${Ze}px, 0)` : `translate3d(${Ze}px, 0, 0)`
      });
    }, 500));
  }
  function qt(Le, Xe) {
    if (Xe < 0) return;
    const gn = (window.innerWidth - Cs) / window.innerWidth, Ze = gn + Xe * (1 - gn), vn = -Cs + Xe * Cs;
    Ti(ge.current, {
      transform: bi(x) ? `scale(${Ze}) translate3d(0, ${vn}px, 0)` : `scale(${Ze}) translate3d(${vn}px, 0, 0)`,
      transition: "none"
    });
  }
  function Gt(Le, Xe) {
    const gn = bi(x) ? window.innerHeight : window.innerWidth, Ze = Xe ? (gn - Cs) / gn : 1, vn = Xe ? -Cs : 0;
    Xe && Ti(ge.current, {
      transition: `transform ${si.DURATION}s cubic-bezier(${si.EASE.join(",")})`,
      transform: bi(x) ? `scale(${Ze}) translate3d(0, ${vn}px, 0)` : `scale(${Ze}) translate3d(${vn}px, 0, 0)`
    });
  }
  return K.useEffect(() => {
    N || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    N
  ]), /* @__PURE__ */ K.createElement(l5, {
    defaultOpen: R,
    onOpenChange: (Le) => {
      !u && !Le || (Le ? _(!0) : wi(!0), M(Le));
    },
    open: O
  }, /* @__PURE__ */ K.createElement(c5.Provider, {
    value: {
      activeSnapPoint: Mn,
      snapPoints: s,
      setActiveSnapPoint: mn,
      drawerRef: ge,
      overlayRef: ue,
      onOpenChange: n,
      onPress: xt,
      onRelease: mt,
      onDrag: Bt,
      dismissible: u,
      shouldAnimate: re,
      handleOnly: k,
      isOpen: O,
      isDragging: z,
      shouldFade: ut,
      closeDrawer: wi,
      onNestedDrag: qt,
      onNestedOpenChange: ot,
      onNestedRelease: Gt,
      keyboardIsOpen: Fe,
      modal: N,
      snapPointsOffset: pi,
      activeSnapPointIndex: Zn,
      direction: x,
      shouldScaleBackground: r,
      setBackgroundColorOnScale: o,
      noBodyStyles: y,
      container: E,
      autoFocus: $
    }
  }, i));
}
const g5 = /* @__PURE__ */ K.forwardRef(function({ ...e }, n) {
  const { overlayRef: i, snapPoints: t, onRelease: a, shouldFade: s, isOpen: r, modal: o, shouldAnimate: d } = xr(), c = k5(n, i), u = t && t.length > 0;
  if (!o)
    return null;
  const k = K.useCallback((m) => a(m), [
    a
  ]);
  return /* @__PURE__ */ K.createElement(Ev, {
    onMouseUp: k,
    ref: c,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": r && u ? "true" : "false",
    "data-vaul-snap-points-overlay": r && s ? "true" : "false",
    "data-vaul-animate": d != null && d.current ? "true" : "false",
    ...e
  });
});
g5.displayName = "Drawer.Overlay";
const F5 = /* @__PURE__ */ K.forwardRef(function({ onPointerDownOutside: e, style: n, onOpenAutoFocus: i, ...t }, a) {
  const { drawerRef: s, onPress: r, onRelease: o, onDrag: d, keyboardIsOpen: c, snapPointsOffset: u, activeSnapPointIndex: k, modal: m, isOpen: f, direction: p, snapPoints: h, container: N, handleOnly: S, shouldAnimate: F, autoFocus: y } = xr(), [x, R] = K.useState(!1), T = k5(a, s), j = K.useRef(null), A = K.useRef(null), B = K.useRef(!1), W = h && h.length > 0;
  vL();
  const E = (V, H, O = 0) => {
    if (B.current) return !0;
    const M = Math.abs(V.y), L = Math.abs(V.x), _ = L > M, z = [
      "bottom",
      "right"
    ].includes(H) ? 1 : -1;
    if (H === "left" || H === "right") {
      if (!(V.x * z < 0) && L >= 0 && L <= O)
        return _;
    } else if (!(V.y * z < 0) && M >= 0 && M <= O)
      return !_;
    return B.current = !0, !0;
  };
  K.useEffect(() => {
    W && window.requestAnimationFrame(() => {
      R(!0);
    });
  }, []);
  function $(V) {
    j.current = null, B.current = !1, o(V);
  }
  return /* @__PURE__ */ K.createElement(Jm, {
    "data-vaul-drawer-direction": p,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": x ? "true" : "false",
    "data-vaul-snap-points": f && W ? "true" : "false",
    "data-vaul-custom-container": N ? "true" : "false",
    "data-vaul-animate": F != null && F.current ? "true" : "false",
    ...t,
    ref: T,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[k != null ? k : 0]}px`,
      ...n
    } : n,
    onPointerDown: (V) => {
      S || (t.onPointerDown == null || t.onPointerDown.call(t, V), j.current = {
        x: V.pageX,
        y: V.pageY
      }, r(V));
    },
    onOpenAutoFocus: (V) => {
      i == null || i(V), y || V.preventDefault();
    },
    onPointerDownOutside: (V) => {
      if (e == null || e(V), !m || V.defaultPrevented) {
        V.preventDefault();
        return;
      }
      c.current && (c.current = !1);
    },
    onFocusOutside: (V) => {
      if (!m) {
        V.preventDefault();
        return;
      }
    },
    onPointerMove: (V) => {
      if (A.current = V, S || (t.onPointerMove == null || t.onPointerMove.call(t, V), !j.current)) return;
      const H = V.pageY - j.current.y, O = V.pageX - j.current.x, M = V.pointerType === "touch" ? 10 : 2;
      E({
        x: O,
        y: H
      }, p, M) ? d(V) : (Math.abs(O) > M || Math.abs(H) > M) && (j.current = null);
    },
    onPointerUp: (V) => {
      t.onPointerUp == null || t.onPointerUp.call(t, V), j.current = null, B.current = !1, o(V);
    },
    onPointerOut: (V) => {
      t.onPointerOut == null || t.onPointerOut.call(t, V), $(A.current);
    },
    onContextMenu: (V) => {
      t.onContextMenu == null || t.onContextMenu.call(t, V), A.current && $(A.current);
    }
  });
});
F5.displayName = "Drawer.Content";
const pL = 250, NL = 120, SL = /* @__PURE__ */ K.forwardRef(function({ preventCycle: e = !1, children: n, ...i }, t) {
  const { closeDrawer: a, isDragging: s, snapPoints: r, activeSnapPoint: o, setActiveSnapPoint: d, dismissible: c, handleOnly: u, isOpen: k, onPress: m, onDrag: f } = xr(), p = K.useRef(null), h = K.useRef(!1);
  function N() {
    if (h.current) {
      y();
      return;
    }
    window.setTimeout(() => {
      S();
    }, NL);
  }
  function S() {
    if (s || e || h.current) {
      y();
      return;
    }
    if (y(), !r || r.length === 0) {
      c || a();
      return;
    }
    if (o === r[r.length - 1] && c) {
      a();
      return;
    }
    const R = r.findIndex((j) => j === o);
    if (R === -1) return;
    const T = r[R + 1];
    d(T);
  }
  function F() {
    p.current = window.setTimeout(() => {
      h.current = !0;
    }, pL);
  }
  function y() {
    p.current && window.clearTimeout(p.current), h.current = !1;
  }
  return /* @__PURE__ */ K.createElement("div", {
    onClick: N,
    onPointerCancel: y,
    onPointerDown: (x) => {
      u && m(x), F();
    },
    onPointerMove: (x) => {
      u && f(x);
    },
    // onPointerUp is already handled by the content component
    ref: t,
    "data-vaul-drawer-visible": k ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...i
  }, /* @__PURE__ */ K.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, n));
});
SL.displayName = "Drawer.Handle";
function gL({ onDrag: e, onOpenChange: n, open: i, ...t }) {
  const { onNestedDrag: a, onNestedOpenChange: s, onNestedRelease: r } = xr();
  if (!a)
    throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */ K.createElement(S5, {
    nested: !0,
    open: i,
    onClose: () => {
      s(!1);
    },
    onDrag: (o, d) => {
      a(o, d), e == null || e(o, d);
    },
    onOpenChange: (o) => {
      o && s(o), n == null || n(o);
    },
    onRelease: r,
    ...t
  });
}
function FL(e) {
  const n = xr(), { container: i = n.container, ...t } = e;
  return /* @__PURE__ */ K.createElement(s5, {
    container: i,
    ...t
  });
}
const Vt = {
  Root: S5,
  NestedRoot: gL,
  Content: F5,
  Overlay: g5,
  Trigger: zM,
  Portal: FL,
  Close: BM,
  Title: Jv,
  Description: _v
}, ks = () => {
  const [e, n] = w.useState(!1), i = w.useCallback(() => n(!0), []), t = w.useCallback(() => n(!1), []), a = w.useCallback((s) => {
    n(s);
  }, []);
  return {
    isOpen: e,
    open: i,
    close: t,
    handleOpenChange: a
  };
}, fl = ({ shouldScaleBackground: e = !0, ...n }) => /* @__PURE__ */ l.jsx(
  Vt.Root,
  {
    autoFocus: !0,
    repositionInputs: !1,
    shouldScaleBackground: e,
    ...n
  }
);
fl.displayName = "Drawer";
const Dr = (e) => /* @__PURE__ */ l.jsx(Vt.NestedRoot, { autoFocus: !0, ...e });
Dr.displayName = "DrawerNested";
const Et = Vt.Trigger, wr = (e) => /* @__PURE__ */ l.jsx(Vt.Portal, { container: yr(), ...e }), pd = Vt.Close, a1 = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  Vt.Overlay,
  {
    ref: i,
    className: ce("ch-fixed ch-inset-0 ch-z-[200] ch-cursor-default ch-bg-black/80", e),
    ...n
  }
));
a1.displayName = Vt.Overlay.displayName;
const I5 = w.forwardRef(({ className: e, children: n, ...i }, t) => /* @__PURE__ */ l.jsxs(
  Vt.Content,
  {
    ref: t,
    className: ce(
      "ch-fixed ch-inset-x-0 ch-bottom-0 ch-z-[200] ch-mt-24 ch-flex ch-h-auto ch-flex-col ch-rounded-t-[10px] ch-bg-white",
      e
    ),
    ...i,
    children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-mb-3 ch-mt-2.5 ch-h-1.5 ch-w-16 ch-shrink-0 ch-rounded-full ch-bg-gray-200" }),
      n
    ]
  }
)), Pr = w.forwardRef(({ ...e }, n) => /* @__PURE__ */ l.jsx(I5, { ref: n, ...e }));
Pr.displayName = "DrawerNestedContent";
const vl = w.forwardRef(({ removeOverlay: e = !1, ...n }, i) => /* @__PURE__ */ l.jsxs(wr, { children: [
  !e && /* @__PURE__ */ l.jsx(a1, {}),
  /* @__PURE__ */ l.jsx(I5, { ref: i, ...n })
] }));
vl.displayName = "DrawerContent";
const y5 = ({ className: e, ...n }) => /* @__PURE__ */ l.jsx("div", { className: ce("sm:ch-text-left ch-grid ch-gap-1.5 ch-p-4 ch-text-center", e), ...n });
y5.displayName = "DrawerHeader";
const _m = ({ className: e, ...n }) => /* @__PURE__ */ l.jsx("div", { className: ce("ch-mt-auto ch-flex ch-flex-col ch-gap-2", e), ...n });
_m.displayName = "DrawerFooter";
const yt = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(
  Vt.Title,
  {
    ref: i,
    className: ce("ch-text-lg ch-font-semibold ch-leading-none ch-tracking-tight", e),
    ...n
  }
));
yt.displayName = Vt.Title.displayName;
const IL = w.forwardRef(({ className: e, ...n }, i) => /* @__PURE__ */ l.jsx(Vt.Description, { ref: i, className: ce("ch-text-sm", e), ...n }));
IL.displayName = Vt.Description.displayName;
const Nd = ({ displayContext: e, styleContext: n }) => {
  var i;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      style: {
        aspectRatio: (i = n == null ? void 0 : n.aspectRatio) != null ? i : "16/9",
        height: n == null ? void 0 : n.height
      },
      children: /* @__PURE__ */ l.jsx(
        "img",
        {
          src: e.imageUrl,
          className: "ch-h-full ch-w-full ch-object-cover",
          style: {
            borderRadius: n == null ? void 0 : n.borderRadius,
            height: n == null ? void 0 : n.height
          }
        }
      )
    }
  );
};
var yL = Object.defineProperty, bL = Object.defineProperties, CL = Object.getOwnPropertyDescriptors, Fu = Object.getOwnPropertySymbols, b5 = Object.prototype.hasOwnProperty, C5 = Object.prototype.propertyIsEnumerable, P4 = (e, n, i) => n in e ? yL(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i, Ql = (e, n) => {
  for (var i in n || (n = {}))
    b5.call(n, i) && P4(e, i, n[i]);
  if (Fu)
    for (var i of Fu(n))
      C5.call(n, i) && P4(e, i, n[i]);
  return e;
}, ck = (e, n) => bL(e, CL(n)), x5 = (e, n) => {
  var i = {};
  for (var t in e)
    b5.call(e, t) && n.indexOf(t) < 0 && (i[t] = e[t]);
  if (e != null && Fu)
    for (var t of Fu(e))
      n.indexOf(t) < 0 && C5.call(e, t) && (i[t] = e[t]);
  return i;
}, xL = Object.defineProperty, DL = Object.defineProperties, wL = Object.getOwnPropertyDescriptors, Iu = Object.getOwnPropertySymbols, D5 = Object.prototype.hasOwnProperty, w5 = Object.prototype.propertyIsEnumerable, uk = (e, n, i) => n in e ? xL(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i, Bi = (e, n) => {
  for (var i in n || (n = {}))
    D5.call(n, i) && uk(e, i, n[i]);
  if (Iu)
    for (var i of Iu(n))
      w5.call(n, i) && uk(e, i, n[i]);
  return e;
}, vt = (e, n) => DL(e, wL(n)), P5 = (e, n) => {
  var i = {};
  for (var t in e)
    D5.call(e, t) && n.indexOf(t) < 0 && (i[t] = e[t]);
  if (e != null && Iu)
    for (var t of Iu(e))
      n.indexOf(t) < 0 && w5.call(e, t) && (i[t] = e[t]);
  return i;
}, cn = (e, n, i) => uk(e, typeof n != "symbol" ? n + "" : n, i), Fn = (e, n, i) => new Promise((t, a) => {
  var s = (d) => {
    try {
      o(i.next(d));
    } catch (c) {
      a(c);
    }
  }, r = (d) => {
    try {
      o(i.throw(d));
    } catch (c) {
      a(c);
    }
  }, o = (d) => d.done ? t(d.value) : Promise.resolve(d.value).then(s, r);
  o((i = i.apply(e, n)).next());
}), PL = class {
  requestAnimationFrame(e) {
    return requestAnimationFrame(e);
  }
  cancelAnimationFrame(e) {
    cancelAnimationFrame(e);
  }
}, RL = class {
  constructor() {
    cn(this, "_lastHandleId", 0), cn(this, "_lastImmediate", null);
  }
  requestAnimationFrame(e) {
    return this._lastHandleId >= Number.MAX_SAFE_INTEGER && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(() => {
      e(Date.now());
    }), this._lastHandleId;
  }
  cancelAnimationFrame(e) {
    this._lastImmediate && clearImmediate(this._lastImmediate);
  }
}, TL = class {
  constructor() {
    cn(this, "_strategy"), this._strategy = typeof requestAnimationFrame == "function" ? new PL() : new RL();
  }
  requestAnimationFrame(e) {
    return this._strategy.requestAnimationFrame(e);
  }
  cancelAnimationFrame(e) {
    this._strategy.cancelAnimationFrame(e);
  }
}, Xi = typeof window != "undefined" && typeof window.document != "undefined", _0 = new Uint8Array([80, 75, 3, 4]), jL = ["v", "ip", "op", "layers", "fr", "w", "h"], R5 = "0.38.2", T5 = "@lottiefiles/dotlottie-web", AL = 0.75, OL = (() => {
  var e, n = typeof document != "undefined" ? (e = document.currentScript) == null ? void 0 : e.src : void 0;
  return function(i = {}) {
    var t, a = i, s, r, o = new Promise((b, C) => {
      s = b, r = C;
    }), d = Object.assign({}, a), c = "./this.program", u = "", k;
    typeof document != "undefined" && document.currentScript && (u = document.currentScript.src), n && (u = n), u.startsWith("blob:") ? u = "" : u = u.substr(0, u.replace(/[?#].*/, "").lastIndexOf("/") + 1), k = (b) => fetch(b, { credentials: "same-origin" }).then((C) => C.ok ? C.arrayBuffer() : Promise.reject(Error(C.status + " : " + C.url)));
    var m = a.print || console.log.bind(console), f = a.printErr || console.error.bind(console);
    Object.assign(a, d), d = null, a.thisProgram && (c = a.thisProgram);
    var p = a.wasmBinary, h, N = !1, S, F, y, x, R, T, j, A, B;
    function W() {
      var b = h.buffer;
      a.HEAP8 = F = new Int8Array(b), a.HEAP16 = x = new Int16Array(b), a.HEAPU8 = y = new Uint8Array(b), a.HEAPU16 = R = new Uint16Array(b), a.HEAP32 = T = new Int32Array(b), a.HEAPU32 = j = new Uint32Array(b), a.HEAPF32 = A = new Float32Array(b), a.HEAPF64 = B = new Float64Array(b);
    }
    var E = [], $ = [], V = [];
    function H() {
      var b = a.preRun.shift();
      E.unshift(b);
    }
    var O = 0, M = null;
    function L(b) {
      var C;
      throw (C = a.onAbort) == null || C.call(a, b), b = "Aborted(" + b + ")", f(b), N = !0, b = new WebAssembly.RuntimeError(b + ". Build with -sASSERTIONS for more info."), r(b), b;
    }
    var _ = (b) => b.startsWith("data:application/octet-stream;base64,"), z;
    function ne(b) {
      if (b == z && p)
        return new Uint8Array(p);
      throw "both async and sync fetching of the wasm failed";
    }
    function Se(b) {
      return p ? Promise.resolve().then(() => ne(b)) : k(b).then((C) => new Uint8Array(C), () => ne(b));
    }
    function he(b, C, J) {
      return Se(b).then((Q) => WebAssembly.instantiate(Q, C)).then(J, (Q) => {
        f(`failed to asynchronously prepare wasm: ${Q}`), L(Q);
      });
    }
    function ue(b, C) {
      var J = z;
      return p || typeof WebAssembly.instantiateStreaming != "function" || _(J) || typeof fetch != "function" ? he(J, b, C) : fetch(J, { credentials: "same-origin" }).then((Q) => WebAssembly.instantiateStreaming(Q, b).then(C, function(q) {
        return f(`wasm streaming compile failed: ${q}`), f("falling back to ArrayBuffer instantiation"), he(J, b, C);
      }));
    }
    class oe {
      constructor(C) {
        cn(this, "name", "ExitStatus"), this.message = `Program terminated with exit(${C})`, this.status = C;
      }
    }
    var $e = (b) => {
      for (; 0 < b.length; )
        b.shift()(a);
    }, we = a.noExitRuntime || !0, ie = typeof TextDecoder != "undefined" ? new TextDecoder() : void 0, De = (b, C = 0, J = NaN) => {
      var Q = C + J;
      for (J = C; b[J] && !(J >= Q); )
        ++J;
      if (16 < J - C && b.buffer && ie)
        return ie.decode(b.subarray(C, J));
      for (Q = ""; C < J; ) {
        var q = b[C++];
        if (q & 128) {
          var ee = b[C++] & 63;
          if ((q & 224) == 192)
            Q += String.fromCharCode((q & 31) << 6 | ee);
          else {
            var fe = b[C++] & 63;
            q = (q & 240) == 224 ? (q & 15) << 12 | ee << 6 | fe : (q & 7) << 18 | ee << 12 | fe << 6 | b[C++] & 63, 65536 > q ? Q += String.fromCharCode(q) : (q -= 65536, Q += String.fromCharCode(55296 | q >> 10, 56320 | q & 1023));
          }
        } else
          Q += String.fromCharCode(q);
      }
      return Q;
    };
    class _e {
      constructor(C) {
        this.wa = C - 24;
      }
    }
    var Ie = 0, Fe = (b, C, J) => {
      var Q = y;
      if (0 < J) {
        J = C + J - 1;
        for (var q = 0; q < b.length; ++q) {
          var ee = b.charCodeAt(q);
          if (55296 <= ee && 57343 >= ee) {
            var fe = b.charCodeAt(++q);
            ee = 65536 + ((ee & 1023) << 10) | fe & 1023;
          }
          if (127 >= ee) {
            if (C >= J)
              break;
            Q[C++] = ee;
          } else {
            if (2047 >= ee) {
              if (C + 1 >= J)
                break;
              Q[C++] = 192 | ee >> 6;
            } else {
              if (65535 >= ee) {
                if (C + 2 >= J)
                  break;
                Q[C++] = 224 | ee >> 12;
              } else {
                if (C + 3 >= J)
                  break;
                Q[C++] = 240 | ee >> 18, Q[C++] = 128 | ee >> 12 & 63;
              }
              Q[C++] = 128 | ee >> 6 & 63;
            }
            Q[C++] = 128 | ee & 63;
          }
        }
        Q[C] = 0;
      }
    }, re = {}, Me = (b) => {
      for (; b.length; ) {
        var C = b.pop();
        b.pop()(C);
      }
    };
    function ge(b) {
      return this.fromWireType(j[b >> 2]);
    }
    var rn = {}, Sn = {}, Jn = {}, Xn, Mn = (b, C, J) => {
      function Q(te) {
        if (te = J(te), te.length !== b.length)
          throw new Xn("Mismatched type converter count");
        for (var Te = 0; Te < b.length; ++Te)
          Fi(b[Te], te[Te]);
      }
      b.forEach((te) => Jn[te] = C);
      var q = Array(C.length), ee = [], fe = 0;
      C.forEach((te, Te) => {
        Sn.hasOwnProperty(te) ? q[Te] = Sn[te] : (ee.push(te), rn.hasOwnProperty(te) || (rn[te] = []), rn[te].push(() => {
          q[Te] = Sn[te], ++fe, fe === ee.length && Q(q);
        }));
      }), ee.length === 0 && Q(q);
    }, Zn, mn = (b) => {
      for (var C = ""; y[b]; )
        C += Zn[y[b++]];
      return C;
    }, We;
    function pi(b, C, J = {}) {
      var Q = C.name;
      if (!b)
        throw new We(`type "${Q}" must have a positive integer typeid pointer`);
      if (Sn.hasOwnProperty(b)) {
        if (J.ab)
          return;
        throw new We(`Cannot register type '${Q}' twice`);
      }
      Sn[b] = C, delete Jn[b], rn.hasOwnProperty(b) && (C = rn[b], delete rn[b], C.forEach((q) => q()));
    }
    function Fi(b, C, J = {}) {
      return pi(b, C, J);
    }
    var ut = (b) => {
      throw new We(b.ua.xa.va.name + " instance already deleted");
    }, ti = !1, Ui = () => {
    }, Ct = (b, C, J) => C === J ? b : J.Aa === void 0 ? null : (b = Ct(b, C, J.Aa), b === null ? null : J.Ua(b)), xt = {}, Di = {}, Bt = (b, C) => {
      if (C === void 0)
        throw new We("ptr should not be undefined");
      for (; b.Aa; )
        C = b.Ka(C), b = b.Aa;
      return Di[C];
    }, wi = (b, C) => {
      if (!C.xa || !C.wa)
        throw new Xn("makeClassHandle requires ptr and ptrType");
      if (!!C.Ba != !!C.za)
        throw new Xn("Both smartPtrType and smartPtr must be specified");
      return C.count = { value: 1 }, Pi(Object.create(b, { ua: { value: C, writable: !0 } }));
    }, Pi = (b) => typeof FinalizationRegistry == "undefined" ? (Pi = (C) => C, b) : (ti = new FinalizationRegistry((C) => {
      C = C.ua, --C.count.value, C.count.value === 0 && (C.za ? C.Ba.Ea(C.za) : C.xa.va.Ea(C.wa));
    }), Pi = (C) => {
      var J = C.ua;
      return J.za && ti.register(C, { ua: J }, C), C;
    }, Ui = (C) => {
      ti.unregister(C);
    }, Pi(b));
    function Vi() {
    }
    var mt = (b, C) => Object.defineProperty(C, "name", { value: b }), ot = (b, C, J) => {
      if (b[C].ya === void 0) {
        var Q = b[C];
        b[C] = function(...q) {
          if (!b[C].ya.hasOwnProperty(q.length))
            throw new We(`Function '${J}' called with an invalid number of arguments (${q.length}) - expects one of (${b[C].ya})!`);
          return b[C].ya[q.length].apply(this, q);
        }, b[C].ya = [], b[C].ya[Q.Ha] = Q;
      }
    }, qt = (b, C, J) => {
      if (a.hasOwnProperty(b)) {
        if (J === void 0 || a[b].ya !== void 0 && a[b].ya[J] !== void 0)
          throw new We(`Cannot register public name '${b}' twice`);
        if (ot(a, b, b), a[b].ya.hasOwnProperty(J))
          throw new We(`Cannot register multiple overloads of a function with the same number of arguments (${J})!`);
        a[b].ya[J] = C;
      } else
        a[b] = C, a[b].Ha = J;
    }, Gt = (b) => {
      b = b.replace(/[^a-zA-Z0-9_]/g, "$");
      var C = b.charCodeAt(0);
      return 48 <= C && 57 >= C ? `_${b}` : b;
    };
    function Le(b, C, J, Q, q, ee, fe, te) {
      this.name = b, this.constructor = C, this.Ga = J, this.Ea = Q, this.Aa = q, this.Wa = ee, this.Ka = fe, this.Ua = te, this.cb = [];
    }
    var Xe = (b, C, J) => {
      for (; C !== J; ) {
        if (!C.Ka)
          throw new We(`Expected null or instance of ${J.name}, got an instance of ${C.name}`);
        b = C.Ka(b), C = C.Aa;
      }
      return b;
    };
    function gn(b, C) {
      if (C === null) {
        if (this.Na)
          throw new We(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!C.ua)
        throw new We(`Cannot pass "${Ri(C)}" as a ${this.name}`);
      if (!C.ua.wa)
        throw new We(`Cannot pass deleted object as a pointer of type ${this.name}`);
      return Xe(C.ua.wa, C.ua.xa.va, this.va);
    }
    function Ze(b, C) {
      if (C === null) {
        if (this.Na)
          throw new We(`null is not a valid ${this.name}`);
        if (this.Ma) {
          var J = this.Oa();
          return b !== null && b.push(this.Ea, J), J;
        }
        return 0;
      }
      if (!C || !C.ua)
        throw new We(`Cannot pass "${Ri(C)}" as a ${this.name}`);
      if (!C.ua.wa)
        throw new We(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (!this.La && C.ua.xa.La)
        throw new We(`Cannot convert argument of type ${C.ua.Ba ? C.ua.Ba.name : C.ua.xa.name} to parameter type ${this.name}`);
      if (J = Xe(C.ua.wa, C.ua.xa.va, this.va), this.Ma) {
        if (C.ua.za === void 0)
          throw new We("Passing raw pointer to smart pointer is illegal");
        switch (this.ib) {
          case 0:
            if (C.ua.Ba === this)
              J = C.ua.za;
            else
              throw new We(`Cannot convert argument of type ${C.ua.Ba ? C.ua.Ba.name : C.ua.xa.name} to parameter type ${this.name}`);
            break;
          case 1:
            J = C.ua.za;
            break;
          case 2:
            if (C.ua.Ba === this)
              J = C.ua.za;
            else {
              var Q = C.clone();
              J = this.eb(J, xn(() => Q.delete())), b !== null && b.push(this.Ea, J);
            }
            break;
          default:
            throw new We("Unsupporting sharing policy");
        }
      }
      return J;
    }
    function vn(b, C) {
      if (C === null) {
        if (this.Na)
          throw new We(`null is not a valid ${this.name}`);
        return 0;
      }
      if (!C.ua)
        throw new We(`Cannot pass "${Ri(C)}" as a ${this.name}`);
      if (!C.ua.wa)
        throw new We(`Cannot pass deleted object as a pointer of type ${this.name}`);
      if (C.ua.xa.La)
        throw new We(`Cannot convert argument of type ${C.ua.xa.name} to parameter type ${this.name}`);
      return Xe(C.ua.wa, C.ua.xa.va, this.va);
    }
    function zn(b, C, J, Q, q, ee, fe, te, Te, Ae, Ue) {
      this.name = b, this.va = C, this.Na = J, this.La = Q, this.Ma = q, this.bb = ee, this.ib = fe, this.Sa = te, this.Oa = Te, this.eb = Ae, this.Ea = Ue, q || C.Aa !== void 0 ? this.toWireType = Ze : (this.toWireType = Q ? gn : vn, this.Da = null);
    }
    var je = (b, C, J) => {
      if (!a.hasOwnProperty(b))
        throw new Xn("Replacing nonexistent public symbol");
      a[b].ya !== void 0 && J !== void 0 ? a[b].ya[J] = C : (a[b] = C, a[b].Ha = J);
    }, He, sn = (b, C, J = []) => (b.includes("j") ? (b = b.replace(/p/g, "i"), C = (0, a["dynCall_" + b])(C, ...J)) : C = He.get(C)(...J), C), ei = (b, C) => (...J) => sn(b, C, J), hn = (b, C) => {
      b = mn(b);
      var J = b.includes("j") ? ei(b, C) : He.get(C);
      if (typeof J != "function")
        throw new We(`unknown function pointer with signature ${b}: ${C}`);
      return J;
    }, ni, _i = (b) => {
      b = yp(b);
      var C = mn(b);
      return Ga(b), C;
    }, ui = (b, C) => {
      function J(ee) {
        q[ee] || Sn[ee] || (Jn[ee] ? Jn[ee].forEach(J) : (Q.push(ee), q[ee] = !0));
      }
      var Q = [], q = {};
      throw C.forEach(J), new ni(`${b}: ` + Q.map(_i).join([", "]));
    }, kt = (b, C) => {
      for (var J = [], Q = 0; Q < b; Q++)
        J.push(j[C + 4 * Q >> 2]);
      return J;
    };
    function e0(b) {
      for (var C = 1; C < b.length; ++C)
        if (b[C] !== null && b[C].Da === void 0)
          return !0;
      return !1;
    }
    function Hr(b, C, J, Q, q) {
      var ee = C.length;
      if (2 > ee)
        throw new We("argTypes array size mismatch! Must at least get return value and 'this' types!");
      var fe = C[1] !== null && J !== null, te = e0(C), Te = C[0].name !== "void", Ae = ee - 2, Ue = Array(Ae), Cn = [], Vn = [];
      return mt(b, function(...Dt) {
        if (Vn.length = 0, Cn.length = fe ? 2 : 1, Cn[0] = q, fe) {
          var Ni = C[1].toWireType(Vn, this);
          Cn[1] = Ni;
        }
        for (var yi = 0; yi < Ae; ++yi)
          Ue[yi] = C[yi + 2].toWireType(Vn, Dt[yi]), Cn.push(Ue[yi]);
        if (Dt = Q(...Cn), te)
          Me(Vn);
        else
          for (yi = fe ? 1 : 2; yi < C.length; yi++) {
            var Wt = yi === 1 ? Ni : Ue[yi - 2];
            C[yi].Da !== null && C[yi].Da(Wt);
          }
        return Ni = Te ? C[0].fromWireType(Dt) : void 0, Ni;
      });
    }
    var Kd = (b) => {
      b = b.trim();
      let C = b.indexOf("(");
      return C !== -1 ? b.substr(0, C) : b;
    }, U = [], de = [], Pe = (b) => {
      9 < b && --de[b + 1] === 0 && (de[b] = void 0, U.push(b));
    }, qe = (b) => {
      if (!b)
        throw new We("Cannot use deleted val. handle = " + b);
      return de[b];
    }, xn = (b) => {
      switch (b) {
        case void 0:
          return 2;
        case null:
          return 4;
        case !0:
          return 6;
        case !1:
          return 8;
        default:
          let C = U.pop() || de.length;
          return de[C] = b, de[C + 1] = 1, C;
      }
    }, On = { name: "emscripten::val", fromWireType: (b) => {
      var C = qe(b);
      return Pe(b), C;
    }, toWireType: (b, C) => xn(C), Ca: 8, readValueFromPointer: ge, Da: null }, bn = (b, C, J) => {
      switch (C) {
        case 1:
          return J ? function(Q) {
            return this.fromWireType(F[Q]);
          } : function(Q) {
            return this.fromWireType(y[Q]);
          };
        case 2:
          return J ? function(Q) {
            return this.fromWireType(x[Q >> 1]);
          } : function(Q) {
            return this.fromWireType(R[Q >> 1]);
          };
        case 4:
          return J ? function(Q) {
            return this.fromWireType(T[Q >> 2]);
          } : function(Q) {
            return this.fromWireType(j[Q >> 2]);
          };
        default:
          throw new TypeError(`invalid integer width (${C}): ${b}`);
      }
    }, un = (b, C) => {
      var J = Sn[b];
      if (J === void 0)
        throw b = `${C} has unknown type ${_i(b)}`, new We(b);
      return J;
    }, Ri = (b) => {
      if (b === null)
        return "null";
      var C = typeof b;
      return C === "object" || C === "array" || C === "function" ? b.toString() : "" + b;
    }, ai = (b, C) => {
      switch (C) {
        case 4:
          return function(J) {
            return this.fromWireType(A[J >> 2]);
          };
        case 8:
          return function(J) {
            return this.fromWireType(B[J >> 3]);
          };
        default:
          throw new TypeError(`invalid float width (${C}): ${b}`);
      }
    }, mi = (b, C, J) => {
      switch (C) {
        case 1:
          return J ? (Q) => F[Q] : (Q) => y[Q];
        case 2:
          return J ? (Q) => x[Q >> 1] : (Q) => R[Q >> 1];
        case 4:
          return J ? (Q) => T[Q >> 2] : (Q) => j[Q >> 2];
        default:
          throw new TypeError(`invalid integer width (${C}): ${b}`);
      }
    }, ft = Object.assign({ optional: !0 }, On), Ba = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0, qa = (b, C) => {
      for (var J = b >> 1, Q = J + C / 2; !(J >= Q) && R[J]; )
        ++J;
      if (J <<= 1, 32 < J - b && Ba)
        return Ba.decode(y.subarray(b, J));
      for (J = "", Q = 0; !(Q >= C / 2); ++Q) {
        var q = x[b + 2 * Q >> 1];
        if (q == 0)
          break;
        J += String.fromCharCode(q);
      }
      return J;
    }, Ki = (b, C, J) => {
      if (J != null || (J = 2147483647), 2 > J)
        return 0;
      J -= 2;
      var Q = C;
      J = J < 2 * b.length ? J / 2 : b.length;
      for (var q = 0; q < J; ++q)
        x[C >> 1] = b.charCodeAt(q), C += 2;
      return x[C >> 1] = 0, C - Q;
    }, zr = (b) => 2 * b.length, n0 = (b, C) => {
      for (var J = 0, Q = ""; !(J >= C / 4); ) {
        var q = T[b + 4 * J >> 2];
        if (q == 0)
          break;
        ++J, 65536 <= q ? (q -= 65536, Q += String.fromCharCode(55296 | q >> 10, 56320 | q & 1023)) : Q += String.fromCharCode(q);
      }
      return Q;
    }, i0 = (b, C, J) => {
      if (J != null || (J = 2147483647), 4 > J)
        return 0;
      var Q = C;
      J = Q + J - 4;
      for (var q = 0; q < b.length; ++q) {
        var ee = b.charCodeAt(q);
        if (55296 <= ee && 57343 >= ee) {
          var fe = b.charCodeAt(++q);
          ee = 65536 + ((ee & 1023) << 10) | fe & 1023;
        }
        if (T[C >> 2] = ee, C += 4, C + 4 > J)
          break;
      }
      return T[C >> 2] = 0, C - Q;
    }, p8 = (b) => {
      for (var C = 0, J = 0; J < b.length; ++J) {
        var Q = b.charCodeAt(J);
        55296 <= Q && 57343 >= Q && ++J, C += 4;
      }
      return C;
    }, t0 = 0, a0 = [], N8 = (b) => {
      var C = a0.length;
      return a0.push(b), C;
    }, S8 = (b, C) => {
      for (var J = Array(b), Q = 0; Q < b; ++Q)
        J[Q] = un(j[C + 4 * Q >> 2], "parameter " + Q);
      return J;
    }, g8 = Reflect.construct, Br = {}, Np = (b) => {
      if (!(b instanceof oe || b == "unwind"))
        throw b;
    }, Sp = (b) => {
      var C;
      throw S = b, we || 0 < t0 || ((C = a.onExit) == null || C.call(a, b), N = !0), new oe(b);
    }, F8 = (b) => {
      if (!N)
        try {
          if (b(), !(we || 0 < t0))
            try {
              S = b = S, Sp(b);
            } catch (C) {
              Np(C);
            }
        } catch (C) {
          Np(C);
        }
    }, l0 = {}, gp = () => {
      if (!s0) {
        var b = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _: c || "./this.program" }, C;
        for (C in l0)
          l0[C] === void 0 ? delete b[C] : b[C] = l0[C];
        var J = [];
        for (C in b)
          J.push(`${C}=${b[C]}`);
        s0 = J;
      }
      return s0;
    }, s0, I8 = [null, [], []], y8 = () => {
      if (typeof crypto == "object" && typeof crypto.getRandomValues == "function")
        return (b) => crypto.getRandomValues(b);
      L("initRandomDevice");
    }, Fp = (b) => (Fp = y8())(b);
    Xn = a.InternalError = class extends Error {
      constructor(b) {
        super(b), this.name = "InternalError";
      }
    };
    for (var Ip = Array(256), Yd = 0; 256 > Yd; ++Yd)
      Ip[Yd] = String.fromCharCode(Yd);
    Zn = Ip, We = a.BindingError = class extends Error {
      constructor(b) {
        super(b), this.name = "BindingError";
      }
    }, Object.assign(Vi.prototype, { isAliasOf: function(b) {
      if (!(this instanceof Vi && b instanceof Vi))
        return !1;
      var C = this.ua.xa.va, J = this.ua.wa;
      b.ua = b.ua;
      var Q = b.ua.xa.va;
      for (b = b.ua.wa; C.Aa; )
        J = C.Ka(J), C = C.Aa;
      for (; Q.Aa; )
        b = Q.Ka(b), Q = Q.Aa;
      return C === Q && J === b;
    }, clone: function() {
      if (this.ua.wa || ut(this), this.ua.Ja)
        return this.ua.count.value += 1, this;
      var b = Pi, C = Object, J = C.create, Q = Object.getPrototypeOf(this), q = this.ua;
      return b = b(J.call(C, Q, { ua: { value: { count: q.count, Ia: q.Ia, Ja: q.Ja, wa: q.wa, xa: q.xa, za: q.za, Ba: q.Ba } } })), b.ua.count.value += 1, b.ua.Ia = !1, b;
    }, delete() {
      if (this.ua.wa || ut(this), this.ua.Ia && !this.ua.Ja)
        throw new We("Object already scheduled for deletion");
      Ui(this);
      var b = this.ua;
      --b.count.value, b.count.value === 0 && (b.za ? b.Ba.Ea(b.za) : b.xa.va.Ea(b.wa)), this.ua.Ja || (this.ua.za = void 0, this.ua.wa = void 0);
    }, isDeleted: function() {
      return !this.ua.wa;
    }, deleteLater: function() {
      if (this.ua.wa || ut(this), this.ua.Ia && !this.ua.Ja)
        throw new We("Object already scheduled for deletion");
      return this.ua.Ia = !0, this;
    } }), Object.assign(zn.prototype, { Xa(b) {
      return this.Sa && (b = this.Sa(b)), b;
    }, Qa(b) {
      var C;
      (C = this.Ea) == null || C.call(this, b);
    }, Ca: 8, readValueFromPointer: ge, fromWireType: function(b) {
      function C() {
        return this.Ma ? wi(this.va.Ga, { xa: this.bb, wa: J, Ba: this, za: b }) : wi(this.va.Ga, { xa: this, wa: b });
      }
      var J = this.Xa(b);
      if (!J)
        return this.Qa(b), null;
      var Q = Bt(this.va, J);
      if (Q !== void 0)
        return Q.ua.count.value === 0 ? (Q.ua.wa = J, Q.ua.za = b, Q.clone()) : (Q = Q.clone(), this.Qa(b), Q);
      if (Q = this.va.Wa(J), Q = xt[Q], !Q)
        return C.call(this);
      Q = this.La ? Q.Ta : Q.pointerType;
      var q = Ct(J, this.va, Q.va);
      return q === null ? C.call(this) : this.Ma ? wi(Q.va.Ga, { xa: Q, wa: q, Ba: this, za: b }) : wi(Q.va.Ga, { xa: Q, wa: q });
    } }), ni = a.UnboundTypeError = ((b, C) => {
      var J = mt(C, function(Q) {
        this.name = C, this.message = Q, Q = Error(Q).stack, Q !== void 0 && (this.stack = this.toString() + `
` + Q.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return J.prototype = Object.create(b.prototype), J.prototype.constructor = J, J.prototype.toString = function() {
        return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
      }, J;
    })(Error, "UnboundTypeError"), de.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1), a.count_emval_handles = () => de.length / 2 - 5 - U.length;
    var b8 = { c: (b, C, J, Q) => L(`Assertion failed: ${b ? De(y, b) : ""}, at: ` + [C ? C ? De(y, C) : "" : "unknown filename", J, Q ? Q ? De(y, Q) : "" : "unknown function"]), m: (b, C, J) => {
      var Q = new _e(b);
      throw j[Q.wa + 16 >> 2] = 0, j[Q.wa + 4 >> 2] = C, j[Q.wa + 8 >> 2] = J, Ie = b, Ie;
    }, M: () => {
    }, J: () => {
    }, K: () => {
    }, P: function() {
    }, L: () => {
    }, R: () => L(""), v: (b) => {
      var C = re[b];
      delete re[b];
      var J = C.Oa, Q = C.Ea, q = C.Ra, ee = q.map((fe) => fe.$a).concat(q.map((fe) => fe.gb));
      Mn([b], ee, (fe) => {
        var te = {};
        return q.forEach((Te, Ae) => {
          var Ue = fe[Ae], Cn = Te.Ya, Vn = Te.Za, Dt = fe[Ae + q.length], Ni = Te.fb, yi = Te.hb;
          te[Te.Va] = { read: (Wt) => Ue.fromWireType(Cn(Vn, Wt)), write: (Wt, qr) => {
            var wt = [];
            Ni(yi, Wt, Dt.toWireType(wt, qr)), Me(wt);
          } };
        }), [{ name: C.name, fromWireType: (Te) => {
          var Ae = {}, Ue;
          for (Ue in te)
            Ae[Ue] = te[Ue].read(Te);
          return Q(Te), Ae;
        }, toWireType: (Te, Ae) => {
          for (var Ue in te)
            if (!(Ue in Ae))
              throw new TypeError(`Missing field: "${Ue}"`);
          var Cn = J();
          for (Ue in te)
            te[Ue].write(Cn, Ae[Ue]);
          return Te !== null && Te.push(Q, Cn), Cn;
        }, Ca: 8, readValueFromPointer: ge, Da: Q }];
      });
    }, C: () => {
    }, W: (b, C, J, Q) => {
      C = mn(C), Fi(b, { name: C, fromWireType: function(q) {
        return !!q;
      }, toWireType: function(q, ee) {
        return ee ? J : Q;
      }, Ca: 8, readValueFromPointer: function(q) {
        return this.fromWireType(y[q]);
      }, Da: null });
    }, r: (b, C, J, Q, q, ee, fe, te, Te, Ae, Ue, Cn, Vn) => {
      Ue = mn(Ue), ee = hn(q, ee), te && (te = hn(fe, te)), Ae && (Ae = hn(Te, Ae)), Vn = hn(Cn, Vn);
      var Dt = Gt(Ue);
      qt(Dt, function() {
        ui(`Cannot construct ${Ue} due to unbound types`, [Q]);
      }), Mn([b, C, J], Q ? [Q] : [], (Ni) => {
        if (Ni = Ni[0], Q)
          var yi = Ni.va, Wt = yi.Ga;
        else
          Wt = Vi.prototype;
        Ni = mt(Ue, function(...o0) {
          if (Object.getPrototypeOf(this) !== qr)
            throw new We("Use 'new' to construct " + Ue);
          if (wt.Fa === void 0)
            throw new We(Ue + " has no accessible constructor");
          var xp = wt.Fa[o0.length];
          if (xp === void 0)
            throw new We(`Tried to invoke ctor of ${Ue} with invalid number of parameters (${o0.length}) - expected (${Object.keys(wt.Fa).toString()}) parameters instead!`);
          return xp.apply(this, o0);
        });
        var qr = Object.create(Wt, { constructor: { value: Ni } });
        Ni.prototype = qr;
        var wt = new Le(Ue, Ni, qr, Vn, yi, ee, te, Ae);
        if (wt.Aa) {
          var Gr;
          (Gr = wt.Aa).Pa != null || (Gr.Pa = []), wt.Aa.Pa.push(wt);
        }
        return yi = new zn(Ue, wt, !0, !1, !1), Gr = new zn(Ue + "*", wt, !1, !1, !1), Wt = new zn(Ue + " const*", wt, !1, !0, !1), xt[b] = { pointerType: Gr, Ta: Wt }, je(Dt, Ni), [yi, Gr, Wt];
      });
    }, q: (b, C, J, Q, q, ee) => {
      var fe = kt(C, J);
      q = hn(Q, q), Mn([], [b], (te) => {
        te = te[0];
        var Te = `constructor ${te.name}`;
        if (te.va.Fa === void 0 && (te.va.Fa = []), te.va.Fa[C - 1] !== void 0)
          throw new We(`Cannot register multiple constructors with identical number of parameters (${C - 1}) for class '${te.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
        return te.va.Fa[C - 1] = () => {
          ui(`Cannot construct ${te.name} due to unbound types`, fe);
        }, Mn([], fe, (Ae) => (Ae.splice(1, 0, null), te.va.Fa[C - 1] = Hr(Te, Ae, null, q, ee), [])), [];
      });
    }, f: (b, C, J, Q, q, ee, fe, te) => {
      var Te = kt(J, Q);
      C = mn(C), C = Kd(C), ee = hn(q, ee), Mn([], [b], (Ae) => {
        function Ue() {
          ui(`Cannot call ${Cn} due to unbound types`, Te);
        }
        Ae = Ae[0];
        var Cn = `${Ae.name}.${C}`;
        C.startsWith("@@") && (C = Symbol[C.substring(2)]), te && Ae.va.cb.push(C);
        var Vn = Ae.va.Ga, Dt = Vn[C];
        return Dt === void 0 || Dt.ya === void 0 && Dt.className !== Ae.name && Dt.Ha === J - 2 ? (Ue.Ha = J - 2, Ue.className = Ae.name, Vn[C] = Ue) : (ot(Vn, C, Cn), Vn[C].ya[J - 2] = Ue), Mn([], Te, (Ni) => (Ni = Hr(Cn, Ni, Ae, ee, fe), Vn[C].ya === void 0 ? (Ni.Ha = J - 2, Vn[C] = Ni) : Vn[C].ya[J - 2] = Ni, [])), [];
      });
    }, V: (b) => Fi(b, On), x: (b, C, J, Q) => {
      function q() {
      }
      C = mn(C), q.values = {}, Fi(b, { name: C, constructor: q, fromWireType: function(ee) {
        return this.constructor.values[ee];
      }, toWireType: (ee, fe) => fe.value, Ca: 8, readValueFromPointer: bn(C, J, Q), Da: null }), qt(C, q);
    }, k: (b, C, J) => {
      var Q = un(b, "enum");
      C = mn(C), b = Q.constructor, Q = Object.create(Q.constructor.prototype, { value: { value: J }, constructor: { value: mt(`${Q.name}_${C}`, function() {
      }) } }), b.values[J] = Q, b[C] = Q;
    }, z: (b, C, J) => {
      C = mn(C), Fi(b, { name: C, fromWireType: (Q) => Q, toWireType: (Q, q) => q, Ca: 8, readValueFromPointer: ai(C, J), Da: null });
    }, u: (b, C, J, Q, q, ee) => {
      var fe = kt(C, J);
      b = mn(b), b = Kd(b), q = hn(Q, q), qt(b, function() {
        ui(`Cannot call ${b} due to unbound types`, fe);
      }, C - 1), Mn([], fe, (te) => (je(b, Hr(b, [te[0], null].concat(te.slice(1)), null, q, ee), C - 1), []));
    }, l: (b, C, J, Q, q) => {
      if (C = mn(C), q === -1 && (q = 4294967295), q = (te) => te, Q === 0) {
        var ee = 32 - 8 * J;
        q = (te) => te << ee >>> ee;
      }
      var fe = C.includes("unsigned") ? function(te, Te) {
        return Te >>> 0;
      } : function(te, Te) {
        return Te;
      };
      Fi(b, { name: C, fromWireType: q, toWireType: fe, Ca: 8, readValueFromPointer: mi(C, J, Q !== 0), Da: null });
    }, h: (b, C, J) => {
      function Q(ee) {
        return new q(F.buffer, j[ee + 4 >> 2], j[ee >> 2]);
      }
      var q = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array][C];
      J = mn(J), Fi(b, { name: J, fromWireType: Q, Ca: 8, readValueFromPointer: Q }, { ab: !0 });
    }, t: (b) => {
      Fi(b, ft);
    }, aa: (b, C, J, Q, q, ee, fe, te, Te, Ae, Ue, Cn) => {
      J = mn(J), ee = hn(q, ee), te = hn(fe, te), Ae = hn(Te, Ae), Cn = hn(Ue, Cn), Mn([b], [C], (Vn) => (Vn = Vn[0], [new zn(J, Vn.va, !1, !1, !0, Vn, Q, ee, te, Ae, Cn)]));
    }, A: (b, C) => {
      C = mn(C);
      var J = C === "std::string";
      Fi(b, { name: C, fromWireType: function(Q) {
        var q = j[Q >> 2], ee = Q + 4;
        if (J)
          for (var fe = ee, te = 0; te <= q; ++te) {
            var Te = ee + te;
            if (te == q || y[Te] == 0) {
              if (fe = fe ? De(y, fe, Te - fe) : "", Ae === void 0)
                var Ae = fe;
              else
                Ae += "\0", Ae += fe;
              fe = Te + 1;
            }
          }
        else {
          for (Ae = Array(q), te = 0; te < q; ++te)
            Ae[te] = String.fromCharCode(y[ee + te]);
          Ae = Ae.join("");
        }
        return Ga(Q), Ae;
      }, toWireType: function(Q, q) {
        q instanceof ArrayBuffer && (q = new Uint8Array(q));
        var ee, fe = typeof q == "string";
        if (!(fe || q instanceof Uint8Array || q instanceof Uint8ClampedArray || q instanceof Int8Array))
          throw new We("Cannot pass non-string to std::string");
        if (J && fe)
          for (var te = ee = 0; te < q.length; ++te) {
            var Te = q.charCodeAt(te);
            127 >= Te ? ee++ : 2047 >= Te ? ee += 2 : 55296 <= Te && 57343 >= Te ? (ee += 4, ++te) : ee += 3;
          }
        else
          ee = q.length;
        if (te = r0(4 + ee + 1), Te = te + 4, j[te >> 2] = ee, J && fe)
          Fe(q, Te, ee + 1);
        else if (fe)
          for (fe = 0; fe < ee; ++fe) {
            var Ae = q.charCodeAt(fe);
            if (255 < Ae)
              throw Ga(Te), new We("String has UTF-16 code units that do not fit in 8 bits");
            y[Te + fe] = Ae;
          }
        else
          for (fe = 0; fe < ee; ++fe)
            y[Te + fe] = q[fe];
        return Q !== null && Q.push(Ga, te), te;
      }, Ca: 8, readValueFromPointer: ge, Da(Q) {
        Ga(Q);
      } });
    }, s: (b, C, J) => {
      if (J = mn(J), C === 2)
        var Q = qa, q = Ki, ee = zr, fe = (te) => R[te >> 1];
      else
        C === 4 && (Q = n0, q = i0, ee = p8, fe = (te) => j[te >> 2]);
      Fi(b, { name: J, fromWireType: (te) => {
        for (var Te = j[te >> 2], Ae, Ue = te + 4, Cn = 0; Cn <= Te; ++Cn) {
          var Vn = te + 4 + Cn * C;
          (Cn == Te || fe(Vn) == 0) && (Ue = Q(Ue, Vn - Ue), Ae === void 0 ? Ae = Ue : (Ae += "\0", Ae += Ue), Ue = Vn + C);
        }
        return Ga(te), Ae;
      }, toWireType: (te, Te) => {
        if (typeof Te != "string")
          throw new We(`Cannot pass non-string to C++ string type ${J}`);
        var Ae = ee(Te), Ue = r0(4 + Ae + C);
        return j[Ue >> 2] = Ae / C, q(Te, Ue + 4, Ae + C), te !== null && te.push(Ga, Ue), Ue;
      }, Ca: 8, readValueFromPointer: ge, Da(te) {
        Ga(te);
      } });
    }, w: (b, C, J, Q, q, ee) => {
      re[b] = { name: mn(C), Oa: hn(J, Q), Ea: hn(q, ee), Ra: [] };
    }, j: (b, C, J, Q, q, ee, fe, te, Te, Ae) => {
      re[b].Ra.push({ Va: mn(C), $a: J, Ya: hn(Q, q), Za: ee, gb: fe, fb: hn(te, Te), hb: Ae });
    }, X: (b, C) => {
      C = mn(C), Fi(b, { jb: !0, name: C, Ca: 0, fromWireType: () => {
      }, toWireType: () => {
      } });
    }, H: () => {
      we = !1, t0 = 0;
    }, D: () => {
      throw 1 / 0;
    }, _: (b, C, J, Q) => (b = a0[b], C = qe(C), b(null, C, J, Q)), B: Pe, Z: (b, C, J) => {
      var Q = S8(b, C), q = Q.shift();
      b--;
      var ee = Array(b);
      return C = `methodCaller<(${Q.map((fe) => fe.name).join(", ")}) => ${q.name}>`, N8(mt(C, (fe, te, Te, Ae) => {
        for (var Ue = 0, Cn = 0; Cn < b; ++Cn)
          ee[Cn] = Q[Cn].readValueFromPointer(Ae + Ue), Ue += Q[Cn].Ca;
        return te = J === 1 ? g8(te, ee) : te.apply(fe, ee), fe = [], te = q.toWireType(fe, te), fe.length && (j[Te >> 2] = xn(fe)), te;
      }));
    }, $: (b) => {
      9 < b && (de[b + 1] += 1);
    }, Y: (b) => {
      var C = qe(b);
      Me(C), Pe(b);
    }, o: (b, C) => (b = un(b, "_emval_take_value"), b = b.readValueFromPointer(C), xn(b)), E: (b, C) => {
      if (Br[b] && (clearTimeout(Br[b].id), delete Br[b]), !C)
        return 0;
      var J = setTimeout(() => {
        delete Br[b], F8(() => bp(b, performance.now()));
      }, C);
      return Br[b] = { id: J, kb: C }, 0;
    }, F: (b, C, J, Q) => {
      var q = (/* @__PURE__ */ new Date()).getFullYear(), ee = new Date(q, 0, 1).getTimezoneOffset();
      q = new Date(q, 6, 1).getTimezoneOffset(), j[b >> 2] = 60 * Math.max(ee, q), T[C >> 2] = +(ee != q), C = (fe) => {
        var te = Math.abs(fe);
        return `UTC${0 <= fe ? "-" : "+"}${String(Math.floor(te / 60)).padStart(2, "0")}${String(te % 60).padStart(2, "0")}`;
      }, b = C(ee), C = C(q), q < ee ? (Fe(b, J, 17), Fe(C, Q, 17)) : (Fe(b, Q, 17), Fe(C, J, 17));
    }, ba: () => performance.now(), G: (b) => {
      var C = y.length;
      if (b >>>= 0, 2147483648 < b)
        return !1;
      for (var J = 1; 4 >= J; J *= 2) {
        var Q = C * (1 + 0.2 / J);
        Q = Math.min(Q, b + 100663296);
        e: {
          Q = (Math.min(2147483648, 65536 * Math.ceil(Math.max(b, Q) / 65536)) - h.buffer.byteLength + 65535) / 65536 | 0;
          try {
            h.grow(Q), W();
            var q = 1;
            break e;
          } catch (ee) {
          }
          q = void 0;
        }
        if (q)
          return !0;
      }
      return !1;
    }, T: (b, C) => {
      var J = 0;
      return gp().forEach((Q, q) => {
        var ee = C + J;
        for (q = j[b + 4 * q >> 2] = ee, ee = 0; ee < Q.length; ++ee)
          F[q++] = Q.charCodeAt(ee);
        F[q] = 0, J += Q.length + 1;
      }), 0;
    }, U: (b, C) => {
      var J = gp();
      j[b >> 2] = J.length;
      var Q = 0;
      return J.forEach((q) => Q += q.length + 1), j[C >> 2] = Q, 0;
    }, Q: () => 52, O: () => 52, N: (b, C, J, Q) => {
      for (var q = 0, ee = 0; ee < J; ee++) {
        var fe = j[C >> 2], te = j[C + 4 >> 2];
        C += 8;
        for (var Te = 0; Te < te; Te++) {
          var Ae = b, Ue = y[fe + Te], Cn = I8[Ae];
          Ue === 0 || Ue === 10 ? ((Ae === 1 ? m : f)(De(Cn)), Cn.length = 0) : Cn.push(Ue);
        }
        q += te;
      }
      return j[Q >> 2] = q, 0;
    }, i: P8, d: w8, e: D8, p: R8, y: A8, b: x8, a: C8, g: j8, n: T8, S: Sp, I: (b, C) => (Fp(y.subarray(b, b + C)), 0) }, Ii = function() {
      var b;
      function C(Q) {
        var q;
        return Ii = Q.exports, h = Ii.ca, W(), He = Ii.ga, $.unshift(Ii.da), O--, (q = a.monitorRunDependencies) == null || q.call(a, O), O == 0 && M && (Q = M, M = null, Q()), Ii;
      }
      O++, (b = a.monitorRunDependencies) == null || b.call(a, O);
      var J = { a: b8 };
      if (a.instantiateWasm)
        try {
          return a.instantiateWasm(J, C);
        } catch (Q) {
          f(`Module.instantiateWasm callback failed with error: ${Q}`), r(Q);
        }
      return z != null || (z = _("DotLottiePlayer.wasm") ? "DotLottiePlayer.wasm" : a.locateFile ? a.locateFile("DotLottiePlayer.wasm", u) : u + "DotLottiePlayer.wasm"), ue(J, function(Q) {
        C(Q.instance);
      }).catch(r), {};
    }(), r0 = (b) => (r0 = Ii.ea)(b), yp = (b) => (yp = Ii.fa)(b), Ga = (b) => (Ga = Ii.ha)(b), bp = (b, C) => (bp = Ii.ia)(b, C), va = (b, C) => (va = Ii.ja)(b, C), ha = (b) => (ha = Ii.ka)(b), pa = () => (pa = Ii.la)();
    a.dynCall_iijj = (b, C, J, Q, q, ee) => (a.dynCall_iijj = Ii.ma)(b, C, J, Q, q, ee), a.dynCall_vijj = (b, C, J, Q, q, ee) => (a.dynCall_vijj = Ii.na)(b, C, J, Q, q, ee), a.dynCall_jiii = (b, C, J, Q) => (a.dynCall_jiii = Ii.oa)(b, C, J, Q), a.dynCall_jii = (b, C, J) => (a.dynCall_jii = Ii.pa)(b, C, J), a.dynCall_viijii = (b, C, J, Q, q, ee, fe) => (a.dynCall_viijii = Ii.qa)(b, C, J, Q, q, ee, fe), a.dynCall_iiiiij = (b, C, J, Q, q, ee, fe) => (a.dynCall_iiiiij = Ii.ra)(b, C, J, Q, q, ee, fe), a.dynCall_iiiiijj = (b, C, J, Q, q, ee, fe, te, Te) => (a.dynCall_iiiiijj = Ii.sa)(b, C, J, Q, q, ee, fe, te, Te), a.dynCall_iiiiiijj = (b, C, J, Q, q, ee, fe, te, Te, Ae) => (a.dynCall_iiiiiijj = Ii.ta)(b, C, J, Q, q, ee, fe, te, Te, Ae);
    function C8(b, C, J) {
      var Q = pa();
      try {
        He.get(b)(C, J);
      } catch (q) {
        if (ha(Q), q !== q + 0)
          throw q;
        va(1, 0);
      }
    }
    function x8(b, C) {
      var J = pa();
      try {
        He.get(b)(C);
      } catch (Q) {
        if (ha(J), Q !== Q + 0)
          throw Q;
        va(1, 0);
      }
    }
    function D8(b, C, J, Q) {
      var q = pa();
      try {
        return He.get(b)(C, J, Q);
      } catch (ee) {
        if (ha(q), ee !== ee + 0)
          throw ee;
        va(1, 0);
      }
    }
    function w8(b, C, J) {
      var Q = pa();
      try {
        return He.get(b)(C, J);
      } catch (q) {
        if (ha(Q), q !== q + 0)
          throw q;
        va(1, 0);
      }
    }
    function P8(b, C) {
      var J = pa();
      try {
        return He.get(b)(C);
      } catch (Q) {
        if (ha(J), Q !== Q + 0)
          throw Q;
        va(1, 0);
      }
    }
    function R8(b, C, J, Q, q, ee) {
      var fe = pa();
      try {
        return He.get(b)(C, J, Q, q, ee);
      } catch (te) {
        if (ha(fe), te !== te + 0)
          throw te;
        va(1, 0);
      }
    }
    function T8(b, C, J, Q, q) {
      var ee = pa();
      try {
        He.get(b)(C, J, Q, q);
      } catch (fe) {
        if (ha(ee), fe !== fe + 0)
          throw fe;
        va(1, 0);
      }
    }
    function j8(b, C, J, Q) {
      var q = pa();
      try {
        He.get(b)(C, J, Q);
      } catch (ee) {
        if (ha(q), ee !== ee + 0)
          throw ee;
        va(1, 0);
      }
    }
    function A8(b) {
      var C = pa();
      try {
        He.get(b)();
      } catch (J) {
        if (ha(C), J !== J + 0)
          throw J;
        va(1, 0);
      }
    }
    var Xd;
    M = function b() {
      Xd || Cp(), Xd || (M = b);
    };
    function Cp() {
      function b() {
        var C;
        if (!Xd && (Xd = !0, a.calledRun = !0, !N)) {
          if ($e($), s(a), (C = a.onRuntimeInitialized) == null || C.call(a), a.postRun)
            for (typeof a.postRun == "function" && (a.postRun = [a.postRun]); a.postRun.length; ) {
              var J = a.postRun.shift();
              V.unshift(J);
            }
          $e(V);
        }
      }
      if (!(0 < O)) {
        if (a.preRun)
          for (typeof a.preRun == "function" && (a.preRun = [a.preRun]); a.preRun.length; )
            H();
        $e(E), 0 < O || (a.setStatus ? (a.setStatus("Running..."), setTimeout(() => {
          setTimeout(() => a.setStatus(""), 1), b();
        }, 1)) : b());
      }
    }
    if (a.preInit)
      for (typeof a.preInit == "function" && (a.preInit = [a.preInit]); 0 < a.preInit.length; )
        a.preInit.pop()();
    return Cp(), t = o, t;
  };
})(), EL = OL, yu = class {
  constructor() {
    throw new Error("RendererLoader is a static class and cannot be instantiated.");
  }
  static _tryLoad(e) {
    return Fn(this, null, function* () {
      return yield EL({ locateFile: () => e });
    });
  }
  static _loadWithBackup() {
    return Fn(this, null, function* () {
      return this._ModulePromise || (this._ModulePromise = this._tryLoad(this._wasmURL).catch((e) => Fn(this, null, function* () {
        let n = `https://unpkg.com/${T5}@${R5}/dist/dotlottie-player.wasm`;
        console.warn(`Primary WASM load failed from ${this._wasmURL}. Error: ${e.message}`), console.warn(`Attempting to load WASM from backup URL: ${n}`);
        try {
          return yield this._tryLoad(n);
        } catch (i) {
          throw console.error(`Primary WASM URL failed: ${e.message}`), console.error(`Backup WASM URL failed: ${i.message}`), new Error("WASM loading failed from all sources.");
        }
      }))), this._ModulePromise;
    });
  }
  static load() {
    return Fn(this, null, function* () {
      return this._loadWithBackup();
    });
  }
  static setWasmUrl(e) {
    e !== this._wasmURL && (this._wasmURL = e, this._ModulePromise = null);
  }
};
cn(yu, "_ModulePromise", null), cn(yu, "_wasmURL", `https://cdn.jsdelivr.net/npm/${T5}@${R5}/dist/dotlottie-player.wasm`);
var j5 = class {
  constructor() {
    cn(this, "_eventListeners", /* @__PURE__ */ new Map());
  }
  addEventListener(e, n) {
    let i = this._eventListeners.get(e);
    i || (i = /* @__PURE__ */ new Set(), this._eventListeners.set(e, i)), i.add(n);
  }
  removeEventListener(e, n) {
    let i = this._eventListeners.get(e);
    i && (n ? (i.delete(n), i.size === 0 && this._eventListeners.delete(e)) : this._eventListeners.delete(e));
  }
  dispatch(e) {
    let n = this._eventListeners.get(e.type);
    n == null || n.forEach((i) => i(e));
  }
  removeAllEventListeners() {
    this._eventListeners.clear();
  }
}, ya = class {
  static _initializeObserver() {
    if (this._observer)
      return;
    let e = (n) => {
      n.forEach((i) => {
        let t = this._observedCanvases.get(i.target);
        t && (i.isIntersecting ? t.unfreeze() : t.freeze());
      });
    };
    this._observer = new IntersectionObserver(e, { threshold: 0 });
  }
  static observe(e, n) {
    var i;
    this._initializeObserver(), !this._observedCanvases.has(e) && (this._observedCanvases.set(e, n), (i = this._observer) == null || i.observe(e));
  }
  static unobserve(e) {
    var n, i;
    (n = this._observer) == null || n.unobserve(e), this._observedCanvases.delete(e), this._observedCanvases.size === 0 && ((i = this._observer) == null || i.disconnect(), this._observer = null);
  }
};
cn(ya, "_observer", null), cn(ya, "_observedCanvases", /* @__PURE__ */ new Map());
var ba = class {
  static _initializeObserver() {
    if (this._observer)
      return;
    let e = (n) => {
      n.forEach((i) => {
        let t = this._observedCanvases.get(i.target);
        if (!t)
          return;
        let [a, s] = t;
        clearTimeout(s);
        let r = setTimeout(() => {
          a.resize();
        }, 100);
        this._observedCanvases.set(i.target, [a, r]);
      });
    };
    this._observer = new ResizeObserver(e);
  }
  static observe(e, n) {
    var i;
    this._initializeObserver(), !this._observedCanvases.has(e) && (this._observedCanvases.set(e, [n, 0]), (i = this._observer) == null || i.observe(e));
  }
  static unobserve(e) {
    var n, i;
    (n = this._observer) == null || n.unobserve(e), this._observedCanvases.delete(e), this._observedCanvases.size === 0 && ((i = this._observer) == null || i.disconnect(), this._observer = null);
  }
};
cn(ba, "_observer", null), cn(ba, "_observedCanvases", /* @__PURE__ */ new Map());
function JL(e) {
  return /^#([\da-f]{6}|[\da-f]{8})$/iu.test(e);
}
function _L(e) {
  if (!JL(e))
    return 0;
  let n = e.replace("#", "");
  return n = n.length === 6 ? `${n}ff` : n, parseInt(n, 16);
}
function R4(e) {
  if (e.byteLength < 4)
    return !1;
  let n = new Uint8Array(e.slice(0, _0.byteLength));
  for (let i = 0; i < _0.length; i += 1)
    if (_0[i] !== n[i])
      return !1;
  return !0;
}
function T4(e) {
  return jL.every((n) => Object.prototype.hasOwnProperty.call(e, n));
}
function j4(e) {
  if (typeof e == "string")
    try {
      return T4(JSON.parse(e));
    } catch (n) {
      return !1;
    }
  else
    return T4(e);
}
function Ts() {
  return 1 + ((Xi ? window.devicePixelRatio : 1) - 1) * AL;
}
function A5(e) {
  let n = e.getBoundingClientRect();
  return n.top >= 0 && n.left >= 0 && n.bottom <= (window.innerHeight || document.documentElement.clientHeight) && n.right <= (window.innerWidth || document.documentElement.clientWidth);
}
var Q0 = (e, n) => e === "reverse" ? n.Mode.Reverse : e === "bounce" ? n.Mode.Bounce : e === "reverse-bounce" ? n.Mode.ReverseBounce : n.Mode.Forward, M0 = (e, n) => e === "contain" ? n.Fit.Contain : e === "cover" ? n.Fit.Cover : e === "fill" ? n.Fit.Fill : e === "fit-height" ? n.Fit.FitHeight : e === "fit-width" ? n.Fit.FitWidth : n.Fit.None, L0 = (e, n) => {
  let i = new n.VectorFloat();
  return i.push_back(e[0]), i.push_back(e[1]), i;
}, $0 = (e, n) => {
  let i = new n.VectorFloat();
  return e.length !== 2 || (i.push_back(e[0]), i.push_back(e[1])), i;
}, O5 = class Kn {
  constructor(n) {
    cn(this, "_canvas"), cn(this, "_context", null), cn(this, "_eventManager"), cn(this, "_animationFrameId", null), cn(this, "_frameManager"), cn(this, "_dotLottieCore", null), cn(this, "_renderConfig", {}), cn(this, "_isFrozen", !1), cn(this, "_backgroundColor", null), cn(this, "_pointerUpMethod"), cn(this, "_pointerDownMethod"), cn(this, "_pointerMoveMethod"), cn(this, "_pointerEnterMethod"), cn(this, "_pointerExitMethod");
    var i, t, a;
    this._canvas = n.canvas, this._context = this._canvas.getContext("2d"), this._eventManager = new j5(), this._frameManager = new TL(), this._renderConfig = vt(Bi({}, n.renderConfig), { devicePixelRatio: ((i = n.renderConfig) == null ? void 0 : i.devicePixelRatio) || Ts(), freezeOnOffscreen: (a = (t = n.renderConfig) == null ? void 0 : t.freezeOnOffscreen) != null ? a : !0 }), yu.load().then((s) => {
      var r, o, d, c, u, k, m, f;
      Kn._wasmModule = s, this._dotLottieCore = new s.DotLottiePlayer({ themeId: (r = n.themeId) != null ? r : "", autoplay: (o = n.autoplay) != null ? o : !1, backgroundColor: 0, loopAnimation: (d = n.loop) != null ? d : !1, mode: Q0((c = n.mode) != null ? c : "forward", s), segment: $0((u = n.segment) != null ? u : [], s), speed: (k = n.speed) != null ? k : 1, useFrameInterpolation: (m = n.useFrameInterpolation) != null ? m : !0, marker: (f = n.marker) != null ? f : "", layout: n.layout ? { align: L0(n.layout.align, s), fit: M0(n.layout.fit, s) } : s.createDefaultLayout() }), this._eventManager.dispatch({ type: "ready" }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), n.backgroundColor && this.setBackgroundColor(n.backgroundColor);
    }).catch((s) => {
      this._eventManager.dispatch({ type: "loadError", error: new Error(`Failed to load wasm module: ${s}`) });
    }), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
  }
  _dispatchError(n) {
    console.error(n), this._eventManager.dispatch({ type: "loadError", error: new Error(n) });
  }
  _fetchData(n) {
    return Fn(this, null, function* () {
      let i = yield fetch(n);
      if (!i.ok)
        throw new Error(`Failed to fetch animation data from URL: ${n}. ${i.status}: ${i.statusText}`);
      let t = yield i.arrayBuffer();
      return R4(t) ? t : new TextDecoder().decode(t);
    });
  }
  _loadFromData(n) {
    if (this._dotLottieCore === null)
      return;
    let i = this._canvas.width, t = this._canvas.height, a = !1;
    if (typeof n == "string") {
      if (!j4(n)) {
        this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
        return;
      }
      a = this._dotLottieCore.loadAnimationData(n, i, t);
    } else if (n instanceof ArrayBuffer) {
      if (!R4(n)) {
        this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
        return;
      }
      a = this._dotLottieCore.loadDotLottieData(n, i, t);
    } else if (typeof n == "object") {
      if (!j4(n)) {
        this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
        return;
      }
      a = this._dotLottieCore.loadAnimationData(JSON.stringify(n), i, t);
    } else {
      this._dispatchError(`Unsupported data type for animation data. Expected: 
          - string (Lottie JSON),
          - ArrayBuffer (dotLottie),
          - object (Lottie JSON). 
          Received: ${typeof n}`);
      return;
    }
    a ? (this._eventManager.dispatch({ type: "load" }), Xi && this.resize(), this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render(), this._dotLottieCore.config().autoplay && (this._dotLottieCore.play(), this._dotLottieCore.isPlaying() ? (this._eventManager.dispatch({ type: "play" }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))) : console.error("something went wrong, the animation was suppose to autoplay")), Xi && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && ya.observe(this._canvas, this), this._renderConfig.autoResize && ba.observe(this._canvas, this))) : this._dispatchError("Failed to load animation data");
  }
  _loadFromSrc(n) {
    this._fetchData(n).then((i) => this._loadFromData(i)).catch((i) => this._dispatchError(`Failed to load animation data from URL: ${n}. ${i}`));
  }
  get activeAnimationId() {
    var n;
    return (n = this._dotLottieCore) == null ? void 0 : n.activeAnimationId();
  }
  get activeThemeId() {
    var n;
    return (n = this._dotLottieCore) == null ? void 0 : n.activeThemeId();
  }
  get layout() {
    var n;
    let i = (n = this._dotLottieCore) == null ? void 0 : n.config().layout;
    if (i)
      return { align: [i.align.get(0), i.align.get(1)], fit: (() => {
        var t, a, s, r, o, d;
        switch (i.fit) {
          case ((t = Kn._wasmModule) == null ? void 0 : t.Fit.Contain):
            return "contain";
          case ((a = Kn._wasmModule) == null ? void 0 : a.Fit.Cover):
            return "cover";
          case ((s = Kn._wasmModule) == null ? void 0 : s.Fit.Fill):
            return "fill";
          case ((r = Kn._wasmModule) == null ? void 0 : r.Fit.FitHeight):
            return "fit-height";
          case ((o = Kn._wasmModule) == null ? void 0 : o.Fit.FitWidth):
            return "fit-width";
          case ((d = Kn._wasmModule) == null ? void 0 : d.Fit.None):
            return "none";
          default:
            return "contain";
        }
      })() };
  }
  get marker() {
    var n;
    return (n = this._dotLottieCore) == null ? void 0 : n.config().marker;
  }
  get manifest() {
    var n;
    try {
      let i = (n = this._dotLottieCore) == null ? void 0 : n.manifestString();
      if (this._dotLottieCore === null || !i)
        return null;
      let t = JSON.parse(i);
      return Object.keys(t).length === 0 ? null : t;
    } catch (i) {
      return null;
    }
  }
  get renderConfig() {
    return this._renderConfig;
  }
  get segment() {
    var n;
    let i = (n = this._dotLottieCore) == null ? void 0 : n.config().segment;
    if (i && i.size() === 2)
      return [i.get(0), i.get(1)];
  }
  get loop() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().loopAnimation) != null ? i : !1;
  }
  get mode() {
    var n, i, t, a;
    let s = (n = this._dotLottieCore) == null ? void 0 : n.config().mode;
    return s === ((i = Kn._wasmModule) == null ? void 0 : i.Mode.Reverse) ? "reverse" : s === ((t = Kn._wasmModule) == null ? void 0 : t.Mode.Bounce) ? "bounce" : s === ((a = Kn._wasmModule) == null ? void 0 : a.Mode.ReverseBounce) ? "reverse-bounce" : "forward";
  }
  get isFrozen() {
    return this._isFrozen;
  }
  get backgroundColor() {
    var n;
    return (n = this._backgroundColor) != null ? n : "";
  }
  get autoplay() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().autoplay) != null ? i : !1;
  }
  get useFrameInterpolation() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().useFrameInterpolation) != null ? i : !1;
  }
  get speed() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().speed) != null ? i : 0;
  }
  get isReady() {
    return this._dotLottieCore !== null;
  }
  get isLoaded() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isLoaded()) != null ? i : !1;
  }
  get isPlaying() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isPlaying()) != null ? i : !1;
  }
  get isPaused() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isPaused()) != null ? i : !1;
  }
  get isStopped() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.isStopped()) != null ? i : !1;
  }
  get currentFrame() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.currentFrame()) != null ? i : 0;
  }
  get loopCount() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.loopCount()) != null ? i : 0;
  }
  get totalFrames() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.totalFrames()) != null ? i : 0;
  }
  get duration() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.duration()) != null ? i : 0;
  }
  get segmentDuration() {
    var n, i;
    return (i = (n = this._dotLottieCore) == null ? void 0 : n.segmentDuration()) != null ? i : 0;
  }
  get canvas() {
    return this._canvas;
  }
  load(n) {
    var i, t, a, s, r, o, d, c, u;
    this._dotLottieCore === null || Kn._wasmModule === null || (this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), this._dotLottieCore.setConfig({ themeId: (i = n.themeId) != null ? i : "", autoplay: (t = n.autoplay) != null ? t : !1, backgroundColor: 0, loopAnimation: (a = n.loop) != null ? a : !1, mode: Q0((s = n.mode) != null ? s : "forward", Kn._wasmModule), segment: $0((r = n.segment) != null ? r : [], Kn._wasmModule), speed: (o = n.speed) != null ? o : 1, useFrameInterpolation: (d = n.useFrameInterpolation) != null ? d : !0, marker: (c = n.marker) != null ? c : "", layout: n.layout ? { align: L0(n.layout.align, Kn._wasmModule), fit: M0(n.layout.fit, Kn._wasmModule) } : Kn._wasmModule.createDefaultLayout() }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), this.setBackgroundColor((u = n.backgroundColor) != null ? u : ""));
  }
  _render() {
    if (this._dotLottieCore === null || this._context === null)
      return !1;
    if (this._dotLottieCore.render()) {
      let n = this._dotLottieCore.buffer(), i = new Uint8ClampedArray(n, 0, this._canvas.width * this._canvas.height * 4), t = null;
      return typeof ImageData == "undefined" ? (t = this._context.createImageData(this._canvas.width, this._canvas.height), t.data.set(i)) : t = new ImageData(i, this._canvas.width, this._canvas.height), this._context.putImageData(t, 0, 0), this._eventManager.dispatch({ type: "render", currentFrame: this._dotLottieCore.currentFrame() }), !0;
    }
    return !1;
  }
  _draw() {
    if (this._dotLottieCore === null || this._context === null || !this._dotLottieCore.isPlaying())
      return;
    let n = this._dotLottieCore.requestFrame();
    this._dotLottieCore.setFrame(n) && (this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render() && this._dotLottieCore.isComplete() && (this._dotLottieCore.config().loopAnimation ? this._eventManager.dispatch({ type: "loop", loopCount: this._dotLottieCore.loopCount() }) : this._eventManager.dispatch({ type: "complete" }))), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this));
  }
  play() {
    this._dotLottieCore !== null && ((this._dotLottieCore.play() || this._dotLottieCore.isPlaying()) && (this._isFrozen = !1, this._eventManager.dispatch({ type: "play" }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))), Xi && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !A5(this._canvas) && this.freeze());
  }
  pause() {
    this._dotLottieCore !== null && (this._dotLottieCore.pause() || this._dotLottieCore.isPaused()) && this._eventManager.dispatch({ type: "pause" });
  }
  stop() {
    this._dotLottieCore !== null && this._dotLottieCore.stop() && (this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render(), this._eventManager.dispatch({ type: "stop" }));
  }
  setFrame(n) {
    this._dotLottieCore === null || n < 0 || n > this._dotLottieCore.totalFrames() || this._dotLottieCore.seek(n) && (this._eventManager.dispatch({ type: "frame", currentFrame: this._dotLottieCore.currentFrame() }), this._render());
  }
  setSpeed(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(vt(Bi({}, this._dotLottieCore.config()), { speed: n }));
  }
  setBackgroundColor(n) {
    this._dotLottieCore !== null && (Xi && this._canvas instanceof HTMLCanvasElement ? this._canvas.style.backgroundColor = n : this._dotLottieCore.setConfig(vt(Bi({}, this._dotLottieCore.config()), { backgroundColor: _L(n) })), this._backgroundColor = n);
  }
  setLoop(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(vt(Bi({}, this._dotLottieCore.config()), { loopAnimation: n }));
  }
  setUseFrameInterpolation(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(vt(Bi({}, this._dotLottieCore.config()), { useFrameInterpolation: n }));
  }
  addEventListener(n, i) {
    this._eventManager.addEventListener(n, i);
  }
  removeEventListener(n, i) {
    this._eventManager.removeEventListener(n, i);
  }
  destroy() {
    var n;
    Xi && this._canvas instanceof HTMLCanvasElement && (ya.unobserve(this._canvas), ba.unobserve(this._canvas)), (n = this._dotLottieCore) == null || n.delete(), this._dotLottieCore = null, this._context = null, this._eventManager.dispatch({ type: "destroy" }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
  }
  freeze() {
    this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null, this._isFrozen = !0, this._eventManager.dispatch({ type: "freeze" }));
  }
  unfreeze() {
    this._animationFrameId === null && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this)), this._isFrozen = !1, this._eventManager.dispatch({ type: "unfreeze" }));
  }
  resize() {
    if (!(!this._dotLottieCore || !this.isLoaded)) {
      if (Xi && this._canvas instanceof HTMLCanvasElement) {
        let n = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, { height: i, width: t } = this._canvas.getBoundingClientRect();
        this._canvas.width = t * n, this._canvas.height = i * n;
      }
      this._dotLottieCore.resize(this._canvas.width, this._canvas.height) && this._render();
    }
  }
  setSegment(n, i) {
    this._dotLottieCore === null || Kn._wasmModule === null || this._dotLottieCore.setConfig(vt(Bi({}, this._dotLottieCore.config()), { segment: $0([n, i], Kn._wasmModule) }));
  }
  setMode(n) {
    this._dotLottieCore === null || Kn._wasmModule === null || this._dotLottieCore.setConfig(vt(Bi({}, this._dotLottieCore.config()), { mode: Q0(n, Kn._wasmModule) }));
  }
  setRenderConfig(n) {
    let i = n, { devicePixelRatio: t, freezeOnOffscreen: a } = i, s = P5(i, ["devicePixelRatio", "freezeOnOffscreen"]);
    this._renderConfig = vt(Bi(Bi({}, this._renderConfig), s), { devicePixelRatio: t || Ts(), freezeOnOffscreen: a != null ? a : !0 }), Xi && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? ba.observe(this._canvas, this) : ba.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? ya.observe(this._canvas, this) : (ya.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
  }
  loadAnimation(n) {
    this._dotLottieCore === null || this._dotLottieCore.activeAnimationId() === n || (this._dotLottieCore.loadAnimation(n, this._canvas.width, this._canvas.height) ? (this._eventManager.dispatch({ type: "load" }), this.resize()) : this._eventManager.dispatch({ type: "loadError", error: new Error(`Failed to animation :${n}`) }));
  }
  setMarker(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setConfig(vt(Bi({}, this._dotLottieCore.config()), { marker: n }));
  }
  markers() {
    var n;
    let i = (n = this._dotLottieCore) == null ? void 0 : n.markers();
    if (i) {
      let t = [];
      for (let a = 0; a < i.size(); a += 1) {
        let s = i.get(a);
        t.push({ name: s.name, time: s.time, duration: s.duration });
      }
      return t;
    }
    return [];
  }
  setTheme(n) {
    if (this._dotLottieCore === null)
      return !1;
    let i = this._dotLottieCore.setTheme(n);
    return this._render(), i;
  }
  resetTheme() {
    return this._dotLottieCore === null ? !1 : this._dotLottieCore.resetTheme();
  }
  setThemeData(n) {
    if (this._dotLottieCore === null)
      return !1;
    let i = this._dotLottieCore.setThemeData(n);
    return this._render(), i;
  }
  setSlots(n) {
    this._dotLottieCore !== null && this._dotLottieCore.setSlots(n);
  }
  setLayout(n) {
    this._dotLottieCore === null || Kn._wasmModule === null || this._dotLottieCore.setConfig(vt(Bi({}, this._dotLottieCore.config()), { layout: { align: L0(n.align, Kn._wasmModule), fit: M0(n.fit, Kn._wasmModule) } }));
  }
  setViewport(n, i, t, a) {
    return this._dotLottieCore === null ? !1 : this._dotLottieCore.setViewport(n, i, t, a);
  }
  static setWasmUrl(n) {
    yu.setWasmUrl(n);
  }
  loadStateMachine(n) {
    var i, t;
    return (t = (i = this._dotLottieCore) == null ? void 0 : i.loadStateMachine(n)) != null ? t : !1;
  }
  startStateMachine() {
    var n, i;
    let t = (i = (n = this._dotLottieCore) == null ? void 0 : n.startStateMachine()) != null ? i : !1;
    return t && this._setupStateMachineListeners(), t;
  }
  stopStateMachine() {
    var n, i;
    let t = (i = (n = this._dotLottieCore) == null ? void 0 : n.stopStateMachine()) != null ? i : !1;
    return t && this._cleanupStateMachineListeners(), t;
  }
  _getPointerPosition(n) {
    let i = this._canvas.getBoundingClientRect(), t = this._canvas.width / i.width, a = this._canvas.height / i.height, s = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, r = (n.clientX - i.left) * t / s, o = (n.clientY - i.top) * a / s;
    return { x: r, y: o };
  }
  _onPointerUp(n) {
    let { x: i, y: t } = this._getPointerPosition(n);
    this.postPointerUpEvent(i, t);
  }
  _onPointerDown(n) {
    let { x: i, y: t } = this._getPointerPosition(n);
    this.postPointerDownEvent(i, t);
  }
  _onPointerMove(n) {
    let { x: i, y: t } = this._getPointerPosition(n);
    this.postPointerMoveEvent(i, t);
  }
  _onPointerEnter(n) {
    let { x: i, y: t } = this._getPointerPosition(n);
    this.postPointerEnterEvent(i, t);
  }
  _onPointerLeave(n) {
    let { x: i, y: t } = this._getPointerPosition(n);
    this.postPointerExitEvent(i, t);
  }
  postPointerUpEvent(n, i) {
    var t;
    return (t = this._dotLottieCore) == null ? void 0 : t.postPointerUpEvent(n, i);
  }
  postPointerDownEvent(n, i) {
    var t;
    return (t = this._dotLottieCore) == null ? void 0 : t.postPointerDownEvent(n, i);
  }
  postPointerMoveEvent(n, i) {
    var t;
    return (t = this._dotLottieCore) == null ? void 0 : t.postPointerMoveEvent(n, i);
  }
  postPointerEnterEvent(n, i) {
    var t;
    return (t = this._dotLottieCore) == null ? void 0 : t.postPointerEnterEvent(n, i);
  }
  postPointerExitEvent(n, i) {
    var t;
    return (t = this._dotLottieCore) == null ? void 0 : t.postPointerExitEvent(n, i);
  }
  getStateMachineListeners() {
    if (!this._dotLottieCore)
      return [];
    let n = this._dotLottieCore.stateMachineFrameworkSetup(), i = [];
    for (let t = 0; t < n.size(); t += 1)
      i.push(n.get(t));
    return i;
  }
  _setupStateMachineListeners() {
    if (Xi && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
      let n = this.getStateMachineListeners();
      n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
    }
  }
  _cleanupStateMachineListeners() {
    Xi && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
  }
  loadStateMachineData(n) {
    var i, t;
    return (t = (i = this._dotLottieCore) == null ? void 0 : i.loadStateMachineData(n)) != null ? t : !1;
  }
  animationSize() {
    var n, i, t, a;
    let s = (i = (n = this._dotLottieCore) == null ? void 0 : n.animationSize().get(0)) != null ? i : 0, r = (a = (t = this._dotLottieCore) == null ? void 0 : t.animationSize().get(1)) != null ? a : 0;
    return { width: s, height: r };
  }
  setStateMachineBooleanContext(n, i) {
    var t, a;
    return (a = (t = this._dotLottieCore) == null ? void 0 : t.setStateMachineBooleanContext(n, i)) != null ? a : !1;
  }
  setStateMachineNumericContext(n, i) {
    var t, a;
    return (a = (t = this._dotLottieCore) == null ? void 0 : t.setStateMachineNumericContext(n, i)) != null ? a : !1;
  }
  setStateMachineStringContext(n, i) {
    var t, a;
    return (a = (t = this._dotLottieCore) == null ? void 0 : t.setStateMachineStringContext(n, i)) != null ? a : !1;
  }
  getLayerBoundingBox(n) {
    var i;
    let t = (i = this._dotLottieCore) == null ? void 0 : i.getLayerBounds(n);
    if (!t || t.size() !== 4)
      return;
    let a = t.get(0), s = t.get(1), r = t.get(2), o = t.get(3);
    return { x: a, y: s, width: r, height: o };
  }
  static transformThemeToLottieSlots(n, i) {
    var t, a;
    return (a = (t = Kn._wasmModule) == null ? void 0 : t.transformThemeToLottieSlots(n, i)) != null ? a : "";
  }
};
cn(O5, "_wasmModule", null);
var QL = O5, ML = class {
  constructor() {
    if (typeof Worker == "undefined")
      throw new Error("Worker is not supported in this environment.");
    let e = new Blob([new Uint8Array([34, 117, 115, 101, 32, 115, 116, 114, 105, 99, 116, 34, 59, 10, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 105, 101, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 68, 101, 115, 99, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 68, 101, 115, 99, 114, 105, 112, 116, 111, 114, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 83, 121, 109, 98, 111, 108, 115, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 112, 114, 111, 112, 101, 114, 116, 121, 73, 115, 69, 110, 117, 109, 101, 114, 97, 98, 108, 101, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 32, 61, 32, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 107, 101, 121, 32, 105, 110, 32, 111, 98, 106, 32, 63, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 123, 32, 101, 110, 117, 109, 101, 114, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 99, 111, 110, 102, 105, 103, 117, 114, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 119, 114, 105, 116, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 44, 32, 118, 97, 108, 117, 101, 32, 125, 41, 32, 58, 32, 111, 98, 106, 91, 107, 101, 121, 93, 32, 61, 32, 118, 97, 108, 117, 101, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 105, 110, 32, 98, 32, 124, 124, 32, 40, 98, 32, 61, 32, 123, 125, 41, 41, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 46, 99, 97, 108, 108, 40, 98, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 97, 44, 32, 112, 114, 111, 112, 44, 32, 98, 91, 112, 114, 111, 112, 93, 41, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 41, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 111, 102, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 40, 98, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 46, 99, 97, 108, 108, 40, 98, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 97, 44, 32, 112, 114, 111, 112, 44, 32, 98, 91, 112, 114, 111, 112, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 95, 95, 100, 101, 102, 80, 114, 111, 112, 115, 40, 97, 44, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 68, 101, 115, 99, 115, 40, 98, 41, 41, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 111, 98, 106, 82, 101, 115, 116, 32, 61, 32, 40, 115, 111, 117, 114, 99, 101, 44, 32, 101, 120, 99, 108, 117, 100, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 118, 97, 114, 32, 116, 97, 114, 103, 101, 116, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 105, 110, 32, 115, 111, 117, 114, 99, 101, 41, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 95, 95, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 46, 99, 97, 108, 108, 40, 115, 111, 117, 114, 99, 101, 44, 32, 112, 114, 111, 112, 41, 32, 38, 38, 32, 101, 120, 99, 108, 117, 100, 101, 46, 105, 110, 100, 101, 120, 79, 102, 40, 112, 114, 111, 112, 41, 32, 60, 32, 48, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 114, 103, 101, 116, 91, 112, 114, 111, 112, 93, 32, 61, 32, 115, 111, 117, 114, 99, 101, 91, 112, 114, 111, 112, 93, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 115, 111, 117, 114, 99, 101, 32, 33, 61, 32, 110, 117, 108, 108, 32, 38, 38, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 41, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 112, 114, 111, 112, 32, 111, 102, 32, 95, 95, 103, 101, 116, 79, 119, 110, 80, 114, 111, 112, 83, 121, 109, 98, 111, 108, 115, 40, 115, 111, 117, 114, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 120, 99, 108, 117, 100, 101, 46, 105, 110, 100, 101, 120, 79, 102, 40, 112, 114, 111, 112, 41, 32, 60, 32, 48, 32, 38, 38, 32, 95, 95, 112, 114, 111, 112, 73, 115, 69, 110, 117, 109, 46, 99, 97, 108, 108, 40, 115, 111, 117, 114, 99, 101, 44, 32, 112, 114, 111, 112, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 114, 103, 101, 116, 91, 112, 114, 111, 112, 93, 32, 61, 32, 115, 111, 117, 114, 99, 101, 91, 112, 114, 111, 112, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 97, 114, 103, 101, 116, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 32, 61, 32, 40, 111, 98, 106, 44, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 95, 95, 100, 101, 102, 78, 111, 114, 109, 97, 108, 80, 114, 111, 112, 40, 111, 98, 106, 44, 32, 116, 121, 112, 101, 111, 102, 32, 107, 101, 121, 32, 33, 61, 61, 32, 34, 115, 121, 109, 98, 111, 108, 34, 32, 63, 32, 107, 101, 121, 32, 43, 32, 34, 34, 32, 58, 32, 107, 101, 121, 44, 32, 118, 97, 108, 117, 101, 41, 59, 10, 32, 32, 118, 97, 114, 32, 95, 95, 97, 115, 121, 110, 99, 32, 61, 32, 40, 95, 95, 116, 104, 105, 115, 44, 32, 95, 95, 97, 114, 103, 117, 109, 101, 110, 116, 115, 44, 32, 103, 101, 110, 101, 114, 97, 116, 111, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 80, 114, 111, 109, 105, 115, 101, 40, 40, 114, 101, 115, 111, 108, 118, 101, 44, 32, 114, 101, 106, 101, 99, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 117, 108, 102, 105, 108, 108, 101, 100, 32, 61, 32, 40, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 110, 101, 120, 116, 40, 118, 97, 108, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 106, 101, 99, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 101, 106, 101, 99, 116, 101, 100, 32, 61, 32, 40, 118, 97, 108, 117, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 116, 104, 114, 111, 119, 40, 118, 97, 108, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 106, 101, 99, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 115, 116, 101, 112, 32, 61, 32, 40, 120, 41, 32, 61, 62, 32, 120, 46, 100, 111, 110, 101, 32, 63, 32, 114, 101, 115, 111, 108, 118, 101, 40, 120, 46, 118, 97, 108, 117, 101, 41, 32, 58, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 115, 111, 108, 118, 101, 40, 120, 46, 118, 97, 108, 117, 101, 41, 46, 116, 104, 101, 110, 40, 102, 117, 108, 102, 105, 108, 108, 101, 100, 44, 32, 114, 101, 106, 101, 99, 116, 101, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 115, 116, 101, 112, 40, 40, 103, 101, 110, 101, 114, 97, 116, 111, 114, 32, 61, 32, 103, 101, 110, 101, 114, 97, 116, 111, 114, 46, 97, 112, 112, 108, 121, 40, 95, 95, 116, 104, 105, 115, 44, 32, 95, 95, 97, 114, 103, 117, 109, 101, 110, 116, 115, 41, 41, 46, 110, 101, 120, 116, 40, 41, 41, 59, 10, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 97, 110, 105, 109, 97, 116, 105, 111, 110, 45, 102, 114, 97, 109, 101, 45, 109, 97, 110, 97, 103, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 87, 101, 98, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 78, 111, 100, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 34, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 62, 61, 32, 78, 117, 109, 98, 101, 114, 46, 77, 65, 88, 95, 83, 65, 70, 69, 95, 73, 78, 84, 69, 71, 69, 82, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 32, 43, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 32, 61, 32, 115, 101, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 108, 108, 98, 97, 99, 107, 40, 68, 97, 116, 101, 46, 110, 111, 119, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 72, 97, 110, 100, 108, 101, 73, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 95, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 101, 97, 114, 73, 109, 109, 101, 100, 105, 97, 116, 101, 40, 116, 104, 105, 115, 46, 95, 108, 97, 115, 116, 73, 109, 109, 101, 100, 105, 97, 116, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 115, 116, 114, 97, 116, 101, 103, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 63, 32, 110, 101, 119, 32, 87, 101, 98, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 40, 41, 32, 58, 32, 110, 101, 119, 32, 78, 111, 100, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 83, 116, 114, 97, 116, 101, 103, 121, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 99, 97, 108, 108, 98, 97, 99, 107, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 116, 114, 97, 116, 101, 103, 121, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 105, 100, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 110, 115, 116, 97, 110, 116, 115, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 119, 105, 110, 100, 111, 119, 32, 33, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 38, 38, 32, 116, 121, 112, 101, 111, 102, 32, 119, 105, 110, 100, 111, 119, 46, 100, 111, 99, 117, 109, 101, 110, 116, 32, 33, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 59, 10, 32, 32, 118, 97, 114, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 91, 56, 48, 44, 32, 55, 53, 44, 32, 51, 44, 32, 52, 93, 41, 59, 10, 32, 32, 118, 97, 114, 32, 76, 79, 84, 84, 73, 69, 95, 74, 83, 79, 78, 95, 77, 65, 78, 68, 65, 84, 79, 82, 89, 95, 70, 73, 69, 76, 68, 83, 32, 61, 32, 91, 34, 118, 34, 44, 32, 34, 105, 112, 34, 44, 32, 34, 111, 112, 34, 44, 32, 34, 108, 97, 121, 101, 114, 115, 34, 44, 32, 34, 102, 114, 34, 44, 32, 34, 119, 34, 44, 32, 34, 104, 34, 93, 59, 10, 32, 32, 118, 97, 114, 32, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 32, 61, 32, 34, 48, 46, 51, 56, 46, 50, 34, 59, 10, 32, 32, 118, 97, 114, 32, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 32, 61, 32, 34, 64, 108, 111, 116, 116, 105, 101, 102, 105, 108, 101, 115, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 119, 101, 98, 34, 59, 10, 32, 32, 118, 97, 114, 32, 68, 69, 70, 65, 85, 76, 84, 95, 68, 80, 82, 95, 70, 65, 67, 84, 79, 82, 32, 61, 32, 48, 46, 55, 53, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 114, 101, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 106, 115, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 77, 111, 100, 117, 108, 101, 32, 61, 32, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 118, 97, 114, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 111, 99, 117, 109, 101, 110, 116, 32, 33, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 63, 32, 40, 95, 97, 32, 61, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 114, 99, 32, 58, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 109, 111, 100, 117, 108, 101, 65, 114, 103, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 32, 61, 32, 109, 111, 100, 117, 108, 101, 65, 114, 103, 44, 32, 97, 97, 44, 32, 98, 97, 44, 32, 99, 97, 32, 61, 32, 110, 101, 119, 32, 80, 114, 111, 109, 105, 115, 101, 40, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 44, 32, 102, 97, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 123, 125, 44, 32, 107, 41, 44, 32, 104, 97, 32, 61, 32, 34, 46, 47, 116, 104, 105, 115, 46, 112, 114, 111, 103, 114, 97, 109, 34, 44, 32, 112, 32, 61, 32, 34, 34, 44, 32, 105, 97, 59, 10, 32, 32, 32, 32, 32, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 100, 111, 99, 117, 109, 101, 110, 116, 32, 38, 38, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 32, 38, 38, 32, 40, 112, 32, 61, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 99, 117, 114, 114, 101, 110, 116, 83, 99, 114, 105, 112, 116, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 32, 38, 38, 32, 40, 112, 32, 61, 32, 95, 115, 99, 114, 105, 112, 116, 78, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 112, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 98, 108, 111, 98, 58, 34, 41, 32, 63, 32, 112, 32, 61, 32, 34, 34, 32, 58, 32, 112, 32, 61, 32, 112, 46, 115, 117, 98, 115, 116, 114, 40, 48, 44, 32, 112, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 91, 63, 35, 93, 46, 42, 47, 44, 32, 34, 34, 41, 46, 108, 97, 115, 116, 73, 110, 100, 101, 120, 79, 102, 40, 34, 47, 34, 41, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 102, 101, 116, 99, 104, 40, 97, 44, 32, 123, 32, 99, 114, 101, 100, 101, 110, 116, 105, 97, 108, 115, 58, 32, 34, 115, 97, 109, 101, 45, 111, 114, 105, 103, 105, 110, 34, 32, 125, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 98, 41, 32, 61, 62, 32, 98, 46, 111, 107, 32, 63, 32, 98, 46, 97, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 40, 41, 32, 58, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 106, 101, 99, 116, 40, 69, 114, 114, 111, 114, 40, 98, 46, 115, 116, 97, 116, 117, 115, 32, 43, 32, 34, 32, 58, 32, 34, 32, 43, 32, 98, 46, 117, 114, 108, 41, 41, 10, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 106, 97, 32, 61, 32, 107, 46, 112, 114, 105, 110, 116, 32, 124, 124, 32, 99, 111, 110, 115, 111, 108, 101, 46, 108, 111, 103, 46, 98, 105, 110, 100, 40, 99, 111, 110, 115, 111, 108, 101, 41, 44, 32, 116, 32, 61, 32, 107, 46, 112, 114, 105, 110, 116, 69, 114, 114, 32, 124, 124, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 46, 98, 105, 110, 100, 40, 99, 111, 110, 115, 111, 108, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 107, 44, 32, 102, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 102, 97, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 116, 104, 105, 115, 80, 114, 111, 103, 114, 97, 109, 32, 38, 38, 32, 40, 104, 97, 32, 61, 32, 107, 46, 116, 104, 105, 115, 80, 114, 111, 103, 114, 97, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 107, 97, 32, 61, 32, 107, 46, 119, 97, 115, 109, 66, 105, 110, 97, 114, 121, 44, 32, 108, 97, 44, 32, 109, 97, 32, 61, 32, 102, 97, 108, 115, 101, 44, 32, 110, 97, 44, 32, 119, 44, 32, 120, 44, 32, 121, 44, 32, 122, 44, 32, 67, 44, 32, 68, 44, 32, 111, 97, 44, 32, 112, 97, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 113, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 108, 97, 46, 98, 117, 102, 102, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 56, 32, 61, 32, 119, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 56, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 49, 54, 32, 61, 32, 121, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 49, 54, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 56, 32, 61, 32, 120, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 49, 54, 32, 61, 32, 122, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 49, 54, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 51, 50, 32, 61, 32, 67, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 85, 51, 50, 32, 61, 32, 68, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 70, 51, 50, 32, 61, 32, 111, 97, 32, 61, 32, 110, 101, 119, 32, 70, 108, 111, 97, 116, 51, 50, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 46, 72, 69, 65, 80, 70, 54, 52, 32, 61, 32, 112, 97, 32, 61, 32, 110, 101, 119, 32, 70, 108, 111, 97, 116, 54, 52, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 97, 32, 61, 32, 91, 93, 44, 32, 115, 97, 32, 61, 32, 91, 93, 44, 32, 116, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 107, 46, 112, 114, 101, 82, 117, 110, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 70, 32, 61, 32, 48, 44, 32, 118, 97, 32, 61, 32, 110, 117, 108, 108, 44, 32, 71, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 107, 46, 111, 110, 65, 98, 111, 114, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 34, 65, 98, 111, 114, 116, 101, 100, 40, 34, 32, 43, 32, 97, 32, 43, 32, 34, 41, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 110, 101, 119, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 82, 117, 110, 116, 105, 109, 101, 69, 114, 114, 111, 114, 40, 97, 32, 43, 32, 34, 46, 32, 66, 117, 105, 108, 100, 32, 119, 105, 116, 104, 32, 45, 115, 65, 83, 83, 69, 82, 84, 73, 79, 78, 83, 32, 102, 111, 114, 32, 109, 111, 114, 101, 32, 105, 110, 102, 111, 46, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 120, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 97, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 100, 97, 116, 97, 58, 97, 112, 112, 108, 105, 99, 97, 116, 105, 111, 110, 47, 111, 99, 116, 101, 116, 45, 115, 116, 114, 101, 97, 109, 59, 98, 97, 115, 101, 54, 52, 44, 34, 41, 44, 32, 121, 97, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 122, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 32, 61, 61, 32, 121, 97, 32, 38, 38, 32, 107, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 107, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 34, 98, 111, 116, 104, 32, 97, 115, 121, 110, 99, 32, 97, 110, 100, 32, 115, 121, 110, 99, 32, 102, 101, 116, 99, 104, 105, 110, 103, 32, 111, 102, 32, 116, 104, 101, 32, 119, 97, 115, 109, 32, 102, 97, 105, 108, 101, 100, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 65, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 97, 32, 63, 32, 80, 114, 111, 109, 105, 115, 101, 46, 114, 101, 115, 111, 108, 118, 101, 40, 41, 46, 116, 104, 101, 110, 40, 40, 41, 32, 61, 62, 32, 122, 97, 40, 97, 41, 41, 32, 58, 32, 105, 97, 40, 97, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 98, 41, 32, 61, 62, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 41, 32, 61, 62, 32, 122, 97, 40, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 66, 97, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 65, 97, 40, 97, 41, 46, 116, 104, 101, 110, 40, 40, 100, 41, 32, 61, 62, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 40, 100, 44, 32, 98, 41, 41, 46, 116, 104, 101, 110, 40, 99, 44, 32, 40, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 96, 102, 97, 105, 108, 101, 100, 32, 116, 111, 32, 97, 115, 121, 110, 99, 104, 114, 111, 110, 111, 117, 115, 108, 121, 32, 112, 114, 101, 112, 97, 114, 101, 32, 119, 97, 115, 109, 58, 32, 36, 123, 100, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 67, 97, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 121, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 97, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 83, 116, 114, 101, 97, 109, 105, 110, 103, 32, 124, 124, 32, 120, 97, 40, 99, 41, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 102, 101, 116, 99, 104, 32, 63, 32, 66, 97, 40, 99, 44, 32, 97, 44, 32, 98, 41, 32, 58, 32, 102, 101, 116, 99, 104, 40, 99, 44, 32, 123, 32, 99, 114, 101, 100, 101, 110, 116, 105, 97, 108, 115, 58, 32, 34, 115, 97, 109, 101, 45, 111, 114, 105, 103, 105, 110, 34, 32, 125, 41, 46, 116, 104, 101, 110, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 100, 41, 32, 61, 62, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 83, 116, 114, 101, 97, 109, 105, 110, 103, 40, 100, 44, 32, 97, 41, 46, 116, 104, 101, 110, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 96, 119, 97, 115, 109, 32, 115, 116, 114, 101, 97, 109, 105, 110, 103, 32, 99, 111, 109, 112, 105, 108, 101, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 34, 102, 97, 108, 108, 105, 110, 103, 32, 98, 97, 99, 107, 32, 116, 111, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 66, 97, 40, 99, 44, 32, 97, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 108, 97, 115, 115, 32, 68, 97, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 110, 97, 109, 101, 34, 44, 32, 34, 69, 120, 105, 116, 83, 116, 97, 116, 117, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 96, 80, 114, 111, 103, 114, 97, 109, 32, 116, 101, 114, 109, 105, 110, 97, 116, 101, 100, 32, 119, 105, 116, 104, 32, 101, 120, 105, 116, 40, 36, 123, 97, 125, 41, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 116, 97, 116, 117, 115, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 48, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 97, 46, 115, 104, 105, 102, 116, 40, 41, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 70, 97, 32, 61, 32, 107, 46, 110, 111, 69, 120, 105, 116, 82, 117, 110, 116, 105, 109, 101, 32, 124, 124, 32, 116, 114, 117, 101, 44, 32, 71, 97, 32, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 32, 63, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 44, 32, 72, 32, 61, 32, 40, 97, 44, 32, 98, 32, 61, 32, 48, 44, 32, 99, 32, 61, 32, 78, 97, 78, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 32, 43, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 99, 32, 61, 32, 98, 59, 32, 97, 91, 99, 93, 32, 38, 38, 32, 33, 40, 99, 32, 62, 61, 32, 100, 41, 59, 32, 41, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 54, 32, 60, 32, 99, 32, 45, 32, 98, 32, 38, 38, 32, 97, 46, 98, 117, 102, 102, 101, 114, 32, 38, 38, 32, 71, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 71, 97, 46, 100, 101, 99, 111, 100, 101, 40, 97, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 98, 44, 32, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 100, 32, 61, 32, 34, 34, 59, 32, 98, 32, 60, 32, 99, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 97, 91, 98, 43, 43, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 38, 32, 49, 50, 56, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 57, 50, 32, 61, 61, 32, 40, 101, 32, 38, 32, 50, 50, 52, 41, 41, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 40, 101, 32, 38, 32, 51, 49, 41, 32, 60, 60, 32, 54, 32, 124, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 50, 50, 52, 32, 61, 61, 32, 40, 101, 32, 38, 32, 50, 52, 48, 41, 32, 63, 32, 40, 101, 32, 38, 32, 49, 53, 41, 32, 60, 60, 32, 49, 50, 32, 124, 32, 102, 32, 60, 60, 32, 54, 32, 124, 32, 104, 32, 58, 32, 40, 101, 32, 38, 32, 55, 41, 32, 60, 60, 32, 49, 56, 32, 124, 32, 102, 32, 60, 60, 32, 49, 50, 32, 124, 32, 104, 32, 60, 60, 32, 54, 32, 124, 32, 97, 91, 98, 43, 43, 93, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 54, 53, 53, 51, 54, 32, 62, 32, 101, 32, 63, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 32, 58, 32, 40, 101, 32, 45, 61, 32, 54, 53, 53, 51, 54, 44, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 53, 53, 50, 57, 54, 32, 124, 32, 101, 32, 62, 62, 32, 49, 48, 44, 32, 53, 54, 51, 50, 48, 32, 124, 32, 101, 32, 38, 32, 49, 48, 50, 51, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 99, 108, 97, 115, 115, 32, 72, 97, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 119, 97, 32, 61, 32, 97, 32, 45, 32, 50, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 73, 97, 32, 61, 32, 48, 44, 32, 74, 97, 32, 61, 32, 48, 44, 32, 73, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 120, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 60, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 98, 32, 43, 32, 99, 32, 45, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 53, 53, 50, 57, 54, 32, 60, 61, 32, 102, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 43, 43, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 54, 53, 53, 51, 54, 32, 43, 32, 40, 40, 102, 32, 38, 32, 49, 48, 50, 51, 41, 32, 60, 60, 32, 49, 48, 41, 32, 124, 32, 104, 32, 38, 32, 49, 48, 50, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 49, 50, 55, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 48, 52, 55, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 49, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 57, 50, 32, 124, 32, 102, 32, 62, 62, 32, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 54, 53, 53, 51, 53, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 50, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 50, 50, 52, 32, 124, 32, 102, 32, 62, 62, 32, 49, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 51, 32, 62, 61, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 50, 52, 48, 32, 124, 32, 102, 32, 62, 62, 32, 49, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 62, 62, 32, 49, 50, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 62, 62, 32, 54, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 43, 43, 93, 32, 61, 32, 49, 50, 56, 32, 124, 32, 102, 32, 38, 32, 54, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 91, 98, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 75, 97, 32, 61, 32, 123, 125, 44, 32, 76, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 46, 112, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 112, 111, 112, 40, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 74, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 68, 91, 97, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 75, 32, 61, 32, 123, 125, 44, 32, 76, 32, 61, 32, 123, 125, 44, 32, 77, 97, 32, 61, 32, 123, 125, 44, 32, 77, 44, 32, 79, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 99, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 46, 108, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 97, 46, 108, 101, 110, 103, 116, 104, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 77, 105, 115, 109, 97, 116, 99, 104, 101, 100, 32, 116, 121, 112, 101, 32, 99, 111, 110, 118, 101, 114, 116, 101, 114, 32, 99, 111, 117, 110, 116, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 48, 59, 32, 108, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 108, 41, 32, 78, 40, 97, 91, 108, 93, 44, 32, 103, 91, 108, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 103, 41, 32, 61, 62, 32, 77, 97, 91, 103, 93, 32, 61, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 65, 114, 114, 97, 121, 40, 98, 46, 108, 101, 110, 103, 116, 104, 41, 44, 32, 102, 32, 61, 32, 91, 93, 44, 32, 104, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 103, 44, 32, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 32, 63, 32, 101, 91, 108, 93, 32, 61, 32, 76, 91, 103, 93, 32, 58, 32, 40, 102, 46, 112, 117, 115, 104, 40, 103, 41, 44, 32, 75, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 103, 41, 32, 124, 124, 32, 40, 75, 91, 103, 93, 32, 61, 32, 91, 93, 41, 44, 32, 75, 91, 103, 93, 46, 112, 117, 115, 104, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 91, 108, 93, 32, 61, 32, 76, 91, 103, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 43, 43, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 61, 61, 32, 102, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 100, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 102, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 100, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 78, 97, 44, 32, 80, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 34, 34, 59, 32, 120, 91, 97, 93, 59, 32, 41, 32, 98, 32, 43, 61, 32, 78, 97, 91, 120, 91, 97, 43, 43, 93, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 81, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 80, 97, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 110, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 116, 121, 112, 101, 32, 34, 36, 123, 100, 125, 34, 32, 109, 117, 115, 116, 32, 104, 97, 118, 101, 32, 97, 32, 112, 111, 115, 105, 116, 105, 118, 101, 32, 105, 110, 116, 101, 103, 101, 114, 32, 116, 121, 112, 101, 105, 100, 32, 112, 111, 105, 110, 116, 101, 114, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 76, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 46, 97, 98, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 116, 121, 112, 101, 32, 39, 36, 123, 100, 125, 39, 32, 116, 119, 105, 99, 101, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 76, 91, 97, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 77, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 75, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 75, 91, 97, 93, 44, 32, 100, 101, 108, 101, 116, 101, 32, 75, 91, 97, 93, 44, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 41, 32, 61, 62, 32, 101, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 78, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 123, 125, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 80, 97, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 81, 97, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 97, 46, 117, 97, 46, 120, 97, 46, 118, 97, 46, 110, 97, 109, 101, 32, 43, 32, 34, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 97, 108, 114, 101, 97, 100, 121, 32, 100, 101, 108, 101, 116, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 97, 32, 61, 32, 102, 97, 108, 115, 101, 44, 32, 83, 97, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 84, 97, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 61, 61, 61, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 46, 65, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 84, 97, 40, 97, 44, 32, 98, 44, 32, 99, 46, 65, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 32, 61, 61, 61, 32, 97, 32, 63, 32, 110, 117, 108, 108, 32, 58, 32, 99, 46, 85, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 85, 97, 32, 61, 32, 123, 125, 44, 32, 86, 97, 32, 61, 32, 123, 125, 44, 32, 87, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 98, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 112, 116, 114, 32, 115, 104, 111, 117, 108, 100, 32, 110, 111, 116, 32, 98, 101, 32, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 97, 46, 65, 97, 59, 32, 41, 32, 98, 32, 61, 32, 97, 46, 75, 97, 40, 98, 41, 44, 32, 97, 32, 61, 32, 97, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 86, 97, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 88, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 120, 97, 32, 124, 124, 32, 33, 98, 46, 119, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 109, 97, 107, 101, 67, 108, 97, 115, 115, 72, 97, 110, 100, 108, 101, 32, 114, 101, 113, 117, 105, 114, 101, 115, 32, 112, 116, 114, 32, 97, 110, 100, 32, 112, 116, 114, 84, 121, 112, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 33, 98, 46, 66, 97, 32, 33, 61, 61, 32, 33, 33, 98, 46, 122, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 66, 111, 116, 104, 32, 115, 109, 97, 114, 116, 80, 116, 114, 84, 121, 112, 101, 32, 97, 110, 100, 32, 115, 109, 97, 114, 116, 80, 116, 114, 32, 109, 117, 115, 116, 32, 98, 101, 32, 115, 112, 101, 99, 105, 102, 105, 101, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 99, 111, 117, 110, 116, 32, 61, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 49, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 82, 40, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 97, 44, 32, 123, 32, 117, 97, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 98, 44, 32, 119, 114, 105, 116, 97, 98, 108, 101, 58, 32, 116, 114, 117, 101, 32, 125, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 61, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 70, 105, 110, 97, 108, 105, 122, 97, 116, 105, 111, 110, 82, 101, 103, 105, 115, 116, 114, 121, 41, 32, 114, 101, 116, 117, 114, 110, 32, 82, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 98, 44, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 97, 32, 61, 32, 110, 101, 119, 32, 70, 105, 110, 97, 108, 105, 122, 97, 116, 105, 111, 110, 82, 101, 103, 105, 115, 116, 114, 121, 40, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 46, 117, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 45, 98, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 98, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 38, 38, 32, 40, 98, 46, 122, 97, 32, 63, 32, 98, 46, 66, 97, 46, 69, 97, 40, 98, 46, 122, 97, 41, 32, 58, 32, 98, 46, 120, 97, 46, 118, 97, 46, 69, 97, 40, 98, 46, 119, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 46, 117, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 122, 97, 32, 38, 38, 32, 82, 97, 46, 114, 101, 103, 105, 115, 116, 101, 114, 40, 98, 44, 32, 123, 32, 117, 97, 58, 32, 99, 32, 125, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 83, 97, 32, 61, 32, 40, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 97, 46, 117, 110, 114, 101, 103, 105, 115, 116, 101, 114, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 82, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 89, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 90, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 36, 97, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 100, 101, 102, 105, 110, 101, 80, 114, 111, 112, 101, 114, 116, 121, 40, 98, 44, 32, 34, 110, 97, 109, 101, 34, 44, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 97, 32, 125, 41, 44, 32, 97, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 91, 98, 93, 46, 121, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 91, 98, 93, 46, 121, 97, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 101, 46, 108, 101, 110, 103, 116, 104, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 70, 117, 110, 99, 116, 105, 111, 110, 32, 39, 36, 123, 99, 125, 39, 32, 99, 97, 108, 108, 101, 100, 32, 119, 105, 116, 104, 32, 97, 110, 32, 105, 110, 118, 97, 108, 105, 100, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 97, 114, 103, 117, 109, 101, 110, 116, 115, 32, 40, 36, 123, 101, 46, 108, 101, 110, 103, 116, 104, 125, 41, 32, 45, 32, 101, 120, 112, 101, 99, 116, 115, 32, 111, 110, 101, 32, 111, 102, 32, 40, 36, 123, 97, 91, 98, 93, 46, 121, 97, 125, 41, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 91, 98, 93, 46, 121, 97, 91, 101, 46, 108, 101, 110, 103, 116, 104, 93, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 46, 121, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 46, 121, 97, 91, 100, 46, 72, 97, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 121, 97, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 121, 97, 91, 99, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 112, 117, 98, 108, 105, 99, 32, 110, 97, 109, 101, 32, 39, 36, 123, 97, 125, 39, 32, 116, 119, 105, 99, 101, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 98, 40, 107, 44, 32, 97, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 91, 97, 93, 46, 121, 97, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 99, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 109, 117, 108, 116, 105, 112, 108, 101, 32, 111, 118, 101, 114, 108, 111, 97, 100, 115, 32, 111, 102, 32, 97, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 119, 105, 116, 104, 32, 116, 104, 101, 32, 115, 97, 109, 101, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 97, 114, 103, 117, 109, 101, 110, 116, 115, 32, 40, 36, 123, 99, 125, 41, 33, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 107, 91, 97, 93, 46, 121, 97, 91, 99, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 107, 91, 97, 93, 32, 61, 32, 98, 44, 32, 107, 91, 97, 93, 46, 72, 97, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 99, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 91, 94, 97, 45, 122, 65, 45, 90, 48, 45, 57, 95, 93, 47, 103, 44, 32, 34, 36, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 52, 56, 32, 60, 61, 32, 98, 32, 38, 38, 32, 53, 55, 32, 62, 61, 32, 98, 32, 63, 32, 96, 95, 36, 123, 97, 125, 96, 32, 58, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 71, 97, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 69, 97, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 65, 97, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 87, 97, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 75, 97, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 85, 97, 32, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 99, 98, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 98, 32, 33, 61, 61, 32, 99, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 75, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 69, 120, 112, 101, 99, 116, 101, 100, 32, 110, 117, 108, 108, 32, 111, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 111, 102, 32, 36, 123, 99, 46, 110, 97, 109, 101, 125, 44, 32, 103, 111, 116, 32, 97, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 111, 102, 32, 36, 123, 98, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 46, 75, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 102, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 78, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 117, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 103, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 117, 97, 46, 119, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 101, 98, 40, 98, 46, 117, 97, 46, 119, 97, 44, 32, 98, 46, 117, 97, 46, 120, 97, 46, 118, 97, 44, 32, 116, 104, 105, 115, 46, 118, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 78, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 77, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 79, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 46, 69, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 32, 124, 124, 32, 33, 98, 46, 117, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 103, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 117, 97, 46, 119, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 76, 97, 32, 38, 38, 32, 98, 46, 117, 97, 46, 120, 97, 46, 76, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 117, 97, 46, 66, 97, 32, 63, 32, 98, 46, 117, 97, 46, 66, 97, 46, 110, 97, 109, 101, 32, 58, 32, 98, 46, 117, 97, 46, 120, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 101, 98, 40, 98, 46, 117, 97, 46, 119, 97, 44, 32, 98, 46, 117, 97, 46, 120, 97, 46, 118, 97, 44, 32, 116, 104, 105, 115, 46, 118, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 77, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 98, 46, 117, 97, 46, 122, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 80, 97, 115, 115, 105, 110, 103, 32, 114, 97, 119, 32, 112, 111, 105, 110, 116, 101, 114, 32, 116, 111, 32, 115, 109, 97, 114, 116, 32, 112, 111, 105, 110, 116, 101, 114, 32, 105, 115, 32, 105, 108, 108, 101, 103, 97, 108, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 116, 104, 105, 115, 46, 105, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 48, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 117, 97, 46, 66, 97, 32, 61, 61, 61, 32, 116, 104, 105, 115, 41, 32, 99, 32, 61, 32, 98, 46, 117, 97, 46, 122, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 117, 97, 46, 66, 97, 32, 63, 32, 98, 46, 117, 97, 46, 66, 97, 46, 110, 97, 109, 101, 32, 58, 32, 98, 46, 117, 97, 46, 120, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 98, 46, 117, 97, 46, 122, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 117, 97, 46, 66, 97, 32, 61, 61, 61, 32, 116, 104, 105, 115, 41, 32, 99, 32, 61, 32, 98, 46, 117, 97, 46, 122, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 101, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 98, 40, 40, 41, 32, 61, 62, 32, 100, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 32, 38, 38, 32, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 46, 69, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 85, 110, 115, 117, 112, 112, 111, 114, 116, 105, 110, 103, 32, 115, 104, 97, 114, 105, 110, 103, 32, 112, 111, 108, 105, 99, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 106, 98, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 78, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 110, 117, 108, 108, 32, 105, 115, 32, 110, 111, 116, 32, 97, 32, 118, 97, 108, 105, 100, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 117, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 34, 36, 123, 103, 98, 40, 98, 41, 125, 34, 32, 97, 115, 32, 97, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 46, 117, 97, 46, 119, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 100, 101, 108, 101, 116, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 97, 115, 32, 97, 32, 112, 111, 105, 110, 116, 101, 114, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 46, 117, 97, 46, 120, 97, 46, 76, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 118, 101, 114, 116, 32, 97, 114, 103, 117, 109, 101, 110, 116, 32, 111, 102, 32, 116, 121, 112, 101, 32, 36, 123, 98, 46, 117, 97, 46, 120, 97, 46, 110, 97, 109, 101, 125, 32, 116, 111, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 116, 121, 112, 101, 32, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 101, 98, 40, 98, 46, 117, 97, 46, 119, 97, 44, 32, 98, 46, 117, 97, 46, 120, 97, 46, 118, 97, 44, 32, 116, 104, 105, 115, 46, 118, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 107, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 118, 97, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 78, 97, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 76, 97, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 77, 97, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 98, 98, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 105, 98, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 83, 97, 32, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 79, 97, 32, 61, 32, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 101, 98, 32, 61, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 69, 97, 32, 61, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 98, 46, 65, 97, 32, 63, 32, 116, 104, 105, 115, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 32, 61, 32, 104, 98, 32, 58, 32, 40, 116, 104, 105, 115, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 32, 61, 32, 100, 32, 63, 32, 102, 98, 32, 58, 32, 106, 98, 44, 32, 116, 104, 105, 115, 46, 68, 97, 32, 61, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 107, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 40, 97, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 77, 40, 34, 82, 101, 112, 108, 97, 99, 105, 110, 103, 32, 110, 111, 110, 101, 120, 105, 115, 116, 101, 110, 116, 32, 112, 117, 98, 108, 105, 99, 32, 115, 121, 109, 98, 111, 108, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 107, 91, 97, 93, 46, 121, 97, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 99, 32, 63, 32, 107, 91, 97, 93, 46, 121, 97, 91, 99, 93, 32, 61, 32, 98, 32, 58, 32, 40, 107, 91, 97, 93, 32, 61, 32, 98, 44, 32, 107, 91, 97, 93, 46, 72, 97, 32, 61, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 83, 44, 32, 109, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 32, 61, 32, 91, 93, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 106, 34, 41, 32, 63, 32, 40, 97, 32, 61, 32, 97, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 112, 47, 103, 44, 32, 34, 105, 34, 41, 44, 32, 98, 32, 61, 32, 40, 48, 44, 32, 107, 91, 34, 100, 121, 110, 67, 97, 108, 108, 95, 34, 32, 43, 32, 97, 93, 41, 40, 98, 44, 32, 46, 46, 46, 99, 41, 41, 32, 58, 32, 98, 32, 61, 32, 83, 46, 103, 101, 116, 40, 98, 41, 40, 46, 46, 46, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 110, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 46, 46, 46, 99, 41, 32, 61, 62, 32, 109, 98, 40, 97, 44, 32, 98, 44, 32, 99, 41, 44, 32, 84, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 80, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 106, 34, 41, 32, 63, 32, 110, 98, 40, 97, 44, 32, 98, 41, 32, 58, 32, 83, 46, 103, 101, 116, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 117, 110, 107, 110, 111, 119, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 112, 111, 105, 110, 116, 101, 114, 32, 119, 105, 116, 104, 32, 115, 105, 103, 110, 97, 116, 117, 114, 101, 32, 36, 123, 97, 125, 58, 32, 36, 123, 98, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 111, 98, 44, 32, 113, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 112, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 80, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 114, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 99, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 91, 102, 93, 32, 124, 124, 32, 76, 91, 102, 93, 32, 124, 124, 32, 40, 77, 97, 91, 102, 93, 32, 63, 32, 77, 97, 91, 102, 93, 46, 102, 111, 114, 69, 97, 99, 104, 40, 99, 41, 32, 58, 32, 40, 100, 46, 112, 117, 115, 104, 40, 102, 41, 44, 32, 101, 91, 102, 93, 32, 61, 32, 116, 114, 117, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 91, 93, 44, 32, 101, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 102, 111, 114, 69, 97, 99, 104, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 111, 98, 40, 96, 36, 123, 97, 125, 58, 32, 96, 32, 43, 32, 100, 46, 109, 97, 112, 40, 113, 98, 41, 46, 106, 111, 105, 110, 40, 91, 34, 44, 32, 34, 93, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 115, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 91, 93, 44, 32, 100, 32, 61, 32, 48, 59, 32, 100, 32, 60, 32, 97, 59, 32, 100, 43, 43, 41, 32, 99, 46, 112, 117, 115, 104, 40, 68, 91, 98, 32, 43, 32, 52, 32, 42, 32, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 116, 98, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 49, 59, 32, 98, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 98, 41, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 33, 61, 61, 32, 97, 91, 98, 93, 32, 38, 38, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 97, 91, 98, 93, 46, 68, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 117, 98, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 62, 32, 102, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 97, 114, 103, 84, 121, 112, 101, 115, 32, 97, 114, 114, 97, 121, 32, 115, 105, 122, 101, 32, 109, 105, 115, 109, 97, 116, 99, 104, 33, 32, 77, 117, 115, 116, 32, 97, 116, 32, 108, 101, 97, 115, 116, 32, 103, 101, 116, 32, 114, 101, 116, 117, 114, 110, 32, 118, 97, 108, 117, 101, 32, 97, 110, 100, 32, 39, 116, 104, 105, 115, 39, 32, 116, 121, 112, 101, 115, 33, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 49, 93, 32, 38, 38, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 99, 44, 32, 103, 32, 61, 32, 116, 98, 40, 98, 41, 44, 32, 108, 32, 61, 32, 34, 118, 111, 105, 100, 34, 32, 33, 61, 61, 32, 98, 91, 48, 93, 46, 110, 97, 109, 101, 44, 32, 109, 32, 61, 32, 102, 32, 45, 32, 50, 44, 32, 110, 32, 61, 32, 65, 114, 114, 97, 121, 40, 109, 41, 44, 32, 113, 32, 61, 32, 91, 93, 44, 32, 114, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 36, 97, 40, 97, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 65, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 104, 32, 63, 32, 50, 32, 58, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 91, 48, 93, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 117, 32, 61, 32, 98, 91, 49, 93, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 114, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 91, 49, 93, 32, 61, 32, 117, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 118, 32, 61, 32, 48, 59, 32, 118, 32, 60, 32, 109, 59, 32, 43, 43, 118, 41, 32, 110, 91, 118, 93, 32, 61, 32, 98, 91, 118, 32, 43, 32, 50, 93, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 114, 44, 32, 65, 91, 118, 93, 41, 44, 32, 113, 46, 112, 117, 115, 104, 40, 110, 91, 118, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 65, 32, 61, 32, 100, 40, 46, 46, 46, 113, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 41, 32, 76, 97, 40, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 32, 61, 32, 104, 32, 63, 32, 49, 32, 58, 32, 50, 59, 32, 118, 32, 60, 32, 98, 46, 108, 101, 110, 103, 116, 104, 59, 32, 118, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 32, 61, 32, 49, 32, 61, 61, 61, 32, 118, 32, 63, 32, 117, 32, 58, 32, 110, 91, 118, 32, 45, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 98, 91, 118, 93, 46, 68, 97, 32, 38, 38, 32, 98, 91, 118, 93, 46, 68, 97, 40, 69, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 32, 61, 32, 108, 32, 63, 32, 98, 91, 48, 93, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 65, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 117, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 118, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 116, 114, 105, 109, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 32, 61, 32, 97, 46, 105, 110, 100, 101, 120, 79, 102, 40, 34, 40, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 45, 49, 32, 33, 61, 61, 32, 98, 32, 63, 32, 97, 46, 115, 117, 98, 115, 116, 114, 40, 48, 44, 32, 98, 41, 32, 58, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 120, 98, 32, 61, 32, 91, 93, 44, 32, 86, 32, 61, 32, 91, 93, 44, 32, 121, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 57, 32, 60, 32, 97, 32, 38, 38, 32, 48, 32, 61, 61, 61, 32, 45, 45, 86, 91, 97, 32, 43, 32, 49, 93, 32, 38, 38, 32, 40, 86, 91, 97, 93, 32, 61, 32, 118, 111, 105, 100, 32, 48, 44, 32, 120, 98, 46, 112, 117, 115, 104, 40, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 122, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 67, 97, 110, 110, 111, 116, 32, 117, 115, 101, 32, 100, 101, 108, 101, 116, 101, 100, 32, 118, 97, 108, 46, 32, 104, 97, 110, 100, 108, 101, 32, 61, 32, 34, 32, 43, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 86, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 105, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 118, 111, 105, 100, 32, 48, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 110, 117, 108, 108, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 116, 114, 117, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 54, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 102, 97, 108, 115, 101, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 32, 61, 32, 120, 98, 46, 112, 111, 112, 40, 41, 32, 124, 124, 32, 86, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 91, 98, 93, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 91, 98, 32, 43, 32, 49, 93, 32, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 65, 98, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 34, 101, 109, 115, 99, 114, 105, 112, 116, 101, 110, 58, 58, 118, 97, 108, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 122, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 121, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 105, 98, 40, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 68, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 66, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 119, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 120, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 121, 91, 100, 32, 62, 62, 32, 49, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 122, 91, 100, 32, 62, 62, 32, 49, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 67, 91, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 68, 91, 100, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 105, 110, 116, 101, 103, 101, 114, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 67, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 76, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 99, 41, 32, 116, 104, 114, 111, 119, 32, 97, 32, 61, 32, 96, 36, 123, 98, 125, 32, 104, 97, 115, 32, 117, 110, 107, 110, 111, 119, 110, 32, 116, 121, 112, 101, 32, 36, 123, 113, 98, 40, 97, 41, 125, 96, 44, 32, 110, 101, 119, 32, 81, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 103, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 110, 117, 108, 108, 32, 61, 61, 61, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 34, 110, 117, 108, 108, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 121, 112, 101, 111, 102, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 61, 32, 98, 32, 124, 124, 32, 34, 97, 114, 114, 97, 121, 34, 32, 61, 61, 61, 32, 98, 32, 124, 124, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 61, 32, 98, 32, 63, 32, 97, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 32, 58, 32, 34, 34, 32, 43, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 68, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 111, 97, 91, 99, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 56, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 112, 97, 91, 99, 32, 62, 62, 32, 51, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 102, 108, 111, 97, 116, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 69, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 49, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 119, 91, 100, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 120, 91, 100, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 50, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 121, 91, 100, 32, 62, 62, 32, 49, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 122, 91, 100, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 52, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 32, 63, 32, 40, 100, 41, 32, 61, 62, 32, 67, 91, 100, 32, 62, 62, 32, 50, 93, 32, 58, 32, 40, 100, 41, 32, 61, 62, 32, 68, 91, 100, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 105, 110, 118, 97, 108, 105, 100, 32, 105, 110, 116, 101, 103, 101, 114, 32, 119, 105, 100, 116, 104, 32, 40, 36, 123, 98, 125, 41, 58, 32, 36, 123, 97, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 70, 98, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 123, 32, 111, 112, 116, 105, 111, 110, 97, 108, 58, 32, 116, 114, 117, 101, 32, 125, 44, 32, 65, 98, 41, 44, 32, 71, 98, 32, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 32, 63, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 34, 117, 116, 102, 45, 49, 54, 108, 101, 34, 41, 32, 58, 32, 118, 111, 105, 100, 32, 48, 44, 32, 72, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 97, 32, 62, 62, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 100, 32, 61, 32, 99, 32, 43, 32, 98, 32, 47, 32, 50, 59, 32, 33, 40, 99, 32, 62, 61, 32, 100, 41, 32, 38, 38, 32, 122, 91, 99, 93, 59, 32, 41, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 60, 60, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 51, 50, 32, 60, 32, 99, 32, 45, 32, 97, 32, 38, 38, 32, 71, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 71, 98, 46, 100, 101, 99, 111, 100, 101, 40, 120, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 97, 44, 32, 99, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 34, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 100, 32, 61, 32, 48, 59, 32, 33, 40, 100, 32, 62, 61, 32, 98, 32, 47, 32, 50, 41, 59, 32, 43, 43, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 121, 91, 97, 32, 43, 32, 50, 32, 42, 32, 100, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 32, 101, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 73, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 99, 32, 58, 32, 99, 32, 61, 32, 50, 49, 52, 55, 52, 56, 51, 54, 52, 55, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 62, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 45, 61, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 99, 32, 60, 32, 50, 32, 42, 32, 97, 46, 108, 101, 110, 103, 116, 104, 32, 63, 32, 99, 32, 47, 32, 50, 32, 58, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 99, 59, 32, 43, 43, 101, 41, 32, 121, 91, 98, 32, 62, 62, 32, 49, 93, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 44, 32, 98, 32, 43, 61, 32, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 91, 98, 32, 62, 62, 32, 49, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 45, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 74, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 50, 32, 42, 32, 97, 46, 108, 101, 110, 103, 116, 104, 44, 32, 75, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 48, 44, 32, 100, 32, 61, 32, 34, 34, 59, 32, 33, 40, 99, 32, 62, 61, 32, 98, 32, 47, 32, 52, 41, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 67, 91, 97, 32, 43, 32, 52, 32, 42, 32, 99, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 32, 101, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 54, 53, 53, 51, 54, 32, 60, 61, 32, 101, 32, 63, 32, 40, 101, 32, 45, 61, 32, 54, 53, 53, 51, 54, 44, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 53, 53, 50, 57, 54, 32, 124, 32, 101, 32, 62, 62, 32, 49, 48, 44, 32, 53, 54, 51, 50, 48, 32, 124, 32, 101, 32, 38, 32, 49, 48, 50, 51, 41, 41, 32, 58, 32, 100, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 76, 98, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 99, 32, 58, 32, 99, 32, 61, 32, 50, 49, 52, 55, 52, 56, 51, 54, 52, 55, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 52, 32, 62, 32, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 100, 32, 43, 32, 99, 32, 45, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 59, 32, 101, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 53, 53, 50, 57, 54, 32, 60, 61, 32, 102, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 43, 43, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 54, 53, 53, 51, 54, 32, 43, 32, 40, 40, 102, 32, 38, 32, 49, 48, 50, 51, 41, 32, 60, 60, 32, 49, 48, 41, 32, 124, 32, 104, 32, 38, 32, 49, 48, 50, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 32, 43, 32, 52, 32, 62, 32, 99, 41, 32, 98, 114, 101, 97, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 45, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 77, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 32, 61, 32, 48, 44, 32, 99, 32, 61, 32, 48, 59, 32, 99, 32, 60, 32, 97, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 53, 53, 50, 57, 54, 32, 60, 61, 32, 100, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 100, 32, 38, 38, 32, 43, 43, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 78, 98, 32, 61, 32, 48, 44, 32, 79, 98, 32, 61, 32, 91, 93, 44, 32, 80, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 79, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 98, 46, 112, 117, 115, 104, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 81, 98, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 65, 114, 114, 97, 121, 40, 97, 41, 44, 32, 100, 32, 61, 32, 48, 59, 32, 100, 32, 60, 32, 97, 59, 32, 43, 43, 100, 41, 32, 99, 91, 100, 93, 32, 61, 32, 67, 98, 40, 68, 91, 98, 32, 43, 32, 52, 32, 42, 32, 100, 32, 62, 62, 32, 50, 93, 44, 32, 34, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 34, 32, 43, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 98, 32, 61, 32, 82, 101, 102, 108, 101, 99, 116, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 44, 32, 83, 98, 32, 61, 32, 123, 125, 44, 32, 84, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 68, 97, 32, 124, 124, 32, 34, 117, 110, 119, 105, 110, 100, 34, 32, 61, 61, 32, 97, 41, 41, 32, 116, 104, 114, 111, 119, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 85, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 97, 32, 124, 124, 32, 48, 32, 60, 32, 78, 98, 32, 124, 124, 32, 40, 40, 95, 97, 50, 32, 61, 32, 107, 46, 111, 110, 69, 120, 105, 116, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 44, 32, 97, 41, 44, 32, 109, 97, 32, 61, 32, 116, 114, 117, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 68, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 86, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 109, 97, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 97, 40, 41, 44, 32, 33, 40, 70, 97, 32, 124, 124, 32, 48, 32, 60, 32, 78, 98, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 32, 61, 32, 97, 32, 61, 32, 110, 97, 44, 32, 85, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 84, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 87, 98, 32, 61, 32, 123, 125, 44, 32, 89, 98, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 88, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 83, 69, 82, 58, 32, 34, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 79, 71, 78, 65, 77, 69, 58, 32, 34, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 65, 84, 72, 58, 32, 34, 47, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 80, 87, 68, 58, 32, 34, 47, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 72, 79, 77, 69, 58, 32, 34, 47, 104, 111, 109, 101, 47, 119, 101, 98, 95, 117, 115, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 65, 78, 71, 58, 32, 40, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 32, 38, 38, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 46, 108, 97, 110, 103, 117, 97, 103, 101, 115, 32, 38, 38, 32, 110, 97, 118, 105, 103, 97, 116, 111, 114, 46, 108, 97, 110, 103, 117, 97, 103, 101, 115, 91, 48, 93, 32, 124, 124, 32, 34, 67, 34, 41, 46, 114, 101, 112, 108, 97, 99, 101, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 45, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 95, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 32, 43, 32, 34, 46, 85, 84, 70, 45, 56, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 95, 58, 32, 104, 97, 32, 124, 124, 32, 34, 46, 47, 116, 104, 105, 115, 46, 112, 114, 111, 103, 114, 97, 109, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 87, 98, 41, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 87, 98, 91, 98, 93, 32, 63, 32, 100, 101, 108, 101, 116, 101, 32, 97, 91, 98, 93, 32, 58, 32, 97, 91, 98, 93, 32, 61, 32, 87, 98, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 98, 32, 105, 110, 32, 97, 41, 32, 99, 46, 112, 117, 115, 104, 40, 96, 36, 123, 98, 125, 61, 36, 123, 97, 91, 98, 93, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 98, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 88, 98, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 88, 98, 44, 32, 90, 98, 32, 61, 32, 91, 110, 117, 108, 108, 44, 32, 91, 93, 44, 32, 91, 93, 93, 44, 32, 36, 98, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 111, 98, 106, 101, 99, 116, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 114, 121, 112, 116, 111, 32, 38, 38, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 99, 114, 121, 112, 116, 111, 46, 103, 101, 116, 82, 97, 110, 100, 111, 109, 86, 97, 108, 117, 101, 115, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 97, 41, 32, 61, 62, 32, 99, 114, 121, 112, 116, 111, 46, 103, 101, 116, 82, 97, 110, 100, 111, 109, 86, 97, 108, 117, 101, 115, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 97, 40, 34, 105, 110, 105, 116, 82, 97, 110, 100, 111, 109, 68, 101, 118, 105, 99, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 97, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 97, 99, 32, 61, 32, 36, 98, 40, 41, 41, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 77, 32, 61, 32, 107, 46, 73, 110, 116, 101, 114, 110, 97, 108, 69, 114, 114, 111, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 101, 120, 116, 101, 110, 100, 115, 32, 69, 114, 114, 111, 114, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 112, 101, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 73, 110, 116, 101, 114, 110, 97, 108, 69, 114, 114, 111, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 98, 99, 32, 61, 32, 65, 114, 114, 97, 121, 40, 50, 53, 54, 41, 44, 32, 99, 99, 32, 61, 32, 48, 59, 32, 50, 53, 54, 32, 62, 32, 99, 99, 59, 32, 43, 43, 99, 99, 41, 32, 98, 99, 91, 99, 99, 93, 32, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 99, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 78, 97, 32, 61, 32, 98, 99, 59, 10, 32, 32, 32, 32, 32, 32, 81, 32, 61, 32, 107, 46, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 101, 120, 116, 101, 110, 100, 115, 32, 69, 114, 114, 111, 114, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 112, 101, 114, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 34, 66, 105, 110, 100, 105, 110, 103, 69, 114, 114, 111, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 90, 97, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 65, 108, 105, 97, 115, 79, 102, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 116, 104, 105, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 90, 97, 32, 38, 38, 32, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 90, 97, 41, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 116, 104, 105, 115, 46, 117, 97, 46, 120, 97, 46, 118, 97, 44, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 117, 97, 46, 119, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 117, 97, 32, 61, 32, 97, 46, 117, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 97, 46, 117, 97, 46, 120, 97, 46, 118, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 97, 32, 61, 32, 97, 46, 117, 97, 46, 119, 97, 59, 32, 98, 46, 65, 97, 59, 32, 41, 32, 99, 32, 61, 32, 98, 46, 75, 97, 40, 99, 41, 44, 32, 98, 32, 61, 32, 98, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 59, 32, 100, 46, 65, 97, 59, 32, 41, 32, 97, 32, 61, 32, 100, 46, 75, 97, 40, 97, 41, 44, 32, 100, 32, 61, 32, 100, 46, 65, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 98, 32, 61, 61, 61, 32, 100, 32, 38, 38, 32, 99, 32, 61, 61, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 111, 110, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 117, 97, 46, 119, 97, 32, 124, 124, 32, 81, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 117, 97, 46, 74, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 117, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 43, 61, 32, 49, 44, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 82, 44, 32, 98, 32, 61, 32, 79, 98, 106, 101, 99, 116, 44, 32, 99, 32, 61, 32, 98, 46, 99, 114, 101, 97, 116, 101, 44, 32, 100, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 80, 114, 111, 116, 111, 116, 121, 112, 101, 79, 102, 40, 116, 104, 105, 115, 41, 44, 32, 101, 32, 61, 32, 116, 104, 105, 115, 46, 117, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 99, 97, 108, 108, 40, 98, 44, 32, 100, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 97, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 123, 32, 99, 111, 117, 110, 116, 58, 32, 101, 46, 99, 111, 117, 110, 116, 44, 32, 73, 97, 58, 32, 101, 46, 73, 97, 44, 32, 74, 97, 58, 32, 101, 46, 74, 97, 44, 32, 119, 97, 58, 32, 101, 46, 119, 97, 44, 32, 120, 97, 58, 32, 101, 46, 120, 97, 44, 32, 122, 97, 58, 32, 101, 46, 122, 97, 44, 32, 66, 97, 58, 32, 101, 46, 66, 97, 32, 125, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 117, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 43, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 117, 97, 46, 73, 97, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 91, 34, 100, 101, 108, 101, 116, 101, 34, 93, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 117, 97, 46, 119, 97, 32, 124, 124, 32, 81, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 117, 97, 46, 73, 97, 32, 38, 38, 32, 33, 116, 104, 105, 115, 46, 117, 97, 46, 74, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 79, 98, 106, 101, 99, 116, 32, 97, 108, 114, 101, 97, 100, 121, 32, 115, 99, 104, 101, 100, 117, 108, 101, 100, 32, 102, 111, 114, 32, 100, 101, 108, 101, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 97, 32, 61, 32, 116, 104, 105, 115, 46, 117, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 45, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 32, 38, 38, 32, 40, 97, 46, 122, 97, 32, 63, 32, 97, 46, 66, 97, 46, 69, 97, 40, 97, 46, 122, 97, 41, 32, 58, 32, 97, 46, 120, 97, 46, 118, 97, 46, 69, 97, 40, 97, 46, 119, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 117, 97, 46, 74, 97, 32, 124, 124, 32, 40, 116, 104, 105, 115, 46, 117, 97, 46, 122, 97, 32, 61, 32, 118, 111, 105, 100, 32, 48, 44, 32, 116, 104, 105, 115, 46, 117, 97, 46, 119, 97, 32, 61, 32, 118, 111, 105, 100, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 68, 101, 108, 101, 116, 101, 100, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 33, 116, 104, 105, 115, 46, 117, 97, 46, 119, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 76, 97, 116, 101, 114, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 117, 97, 46, 119, 97, 32, 124, 124, 32, 81, 97, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 117, 97, 46, 73, 97, 32, 38, 38, 32, 33, 116, 104, 105, 115, 46, 117, 97, 46, 74, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 79, 98, 106, 101, 99, 116, 32, 97, 108, 114, 101, 97, 100, 121, 32, 115, 99, 104, 101, 100, 117, 108, 101, 100, 32, 102, 111, 114, 32, 100, 101, 108, 101, 116, 105, 111, 110, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 97, 46, 112, 117, 115, 104, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 117, 97, 46, 73, 97, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 79, 98, 106, 101, 99, 116, 46, 97, 115, 115, 105, 103, 110, 40, 107, 98, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 88, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 83, 97, 32, 38, 38, 32, 40, 97, 32, 61, 32, 116, 104, 105, 115, 46, 83, 97, 40, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 97, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 116, 104, 105, 115, 46, 69, 97, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 98, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 77, 97, 32, 63, 32, 88, 97, 40, 116, 104, 105, 115, 46, 118, 97, 46, 71, 97, 44, 32, 123, 32, 120, 97, 58, 32, 116, 104, 105, 115, 46, 98, 98, 44, 32, 119, 97, 58, 32, 99, 44, 32, 66, 97, 58, 32, 116, 104, 105, 115, 44, 32, 122, 97, 58, 32, 97, 32, 125, 41, 32, 58, 32, 88, 97, 40, 116, 104, 105, 115, 46, 118, 97, 46, 71, 97, 44, 32, 123, 32, 120, 97, 58, 32, 116, 104, 105, 115, 44, 32, 119, 97, 58, 32, 97, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 116, 104, 105, 115, 46, 88, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 99, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 81, 97, 40, 97, 41, 44, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 87, 97, 40, 116, 104, 105, 115, 46, 118, 97, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 100, 46, 117, 97, 46, 99, 111, 117, 110, 116, 46, 118, 97, 108, 117, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 100, 46, 117, 97, 46, 119, 97, 32, 61, 32, 99, 44, 32, 100, 46, 117, 97, 46, 122, 97, 32, 61, 32, 97, 44, 32, 100, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 100, 46, 99, 108, 111, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 81, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 116, 104, 105, 115, 46, 118, 97, 46, 87, 97, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 85, 97, 91, 100, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 100, 41, 32, 114, 101, 116, 117, 114, 110, 32, 98, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 116, 104, 105, 115, 46, 76, 97, 32, 63, 32, 100, 46, 84, 97, 32, 58, 32, 100, 46, 112, 111, 105, 110, 116, 101, 114, 84, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 84, 97, 40, 99, 44, 32, 116, 104, 105, 115, 46, 118, 97, 44, 32, 100, 46, 118, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 32, 61, 61, 61, 32, 101, 32, 63, 32, 98, 46, 99, 97, 108, 108, 40, 116, 104, 105, 115, 41, 32, 58, 32, 116, 104, 105, 115, 46, 77, 97, 32, 63, 32, 88, 97, 40, 100, 46, 118, 97, 46, 71, 97, 44, 32, 123, 32, 120, 97, 58, 32, 100, 44, 32, 119, 97, 58, 32, 101, 44, 32, 66, 97, 58, 32, 116, 104, 105, 115, 44, 32, 122, 97, 58, 32, 97, 32, 125, 41, 32, 58, 32, 88, 97, 40, 100, 46, 118, 97, 46, 71, 97, 44, 32, 123, 32, 120, 97, 58, 32, 100, 44, 32, 119, 97, 58, 32, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 111, 98, 32, 61, 32, 107, 46, 85, 110, 98, 111, 117, 110, 100, 84, 121, 112, 101, 69, 114, 114, 111, 114, 32, 61, 32, 40, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 36, 97, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 69, 114, 114, 111, 114, 40, 100, 41, 46, 115, 116, 97, 99, 107, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 100, 32, 38, 38, 32, 40, 116, 104, 105, 115, 46, 115, 116, 97, 99, 107, 32, 61, 32, 116, 104, 105, 115, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 32, 43, 32, 34, 92, 110, 34, 32, 43, 32, 100, 46, 114, 101, 112, 108, 97, 99, 101, 40, 47, 94, 69, 114, 114, 111, 114, 40, 58, 91, 94, 92, 110, 93, 42, 41, 63, 92, 110, 47, 44, 32, 34, 34, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 97, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 116, 111, 83, 116, 114, 105, 110, 103, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 32, 63, 32, 116, 104, 105, 115, 46, 110, 97, 109, 101, 32, 58, 32, 96, 36, 123, 116, 104, 105, 115, 46, 110, 97, 109, 101, 125, 58, 32, 36, 123, 116, 104, 105, 115, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 40, 69, 114, 114, 111, 114, 44, 32, 34, 85, 110, 98, 111, 117, 110, 100, 84, 121, 112, 101, 69, 114, 114, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 86, 46, 112, 117, 115, 104, 40, 48, 44, 32, 49, 44, 32, 118, 111, 105, 100, 32, 48, 44, 32, 49, 44, 32, 110, 117, 108, 108, 44, 32, 49, 44, 32, 116, 114, 117, 101, 44, 32, 49, 44, 32, 102, 97, 108, 115, 101, 44, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 99, 111, 117, 110, 116, 95, 101, 109, 118, 97, 108, 95, 104, 97, 110, 100, 108, 101, 115, 32, 61, 32, 40, 41, 32, 61, 62, 32, 86, 46, 108, 101, 110, 103, 116, 104, 32, 47, 32, 50, 32, 45, 32, 53, 32, 45, 32, 120, 98, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 111, 99, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 119, 97, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 65, 115, 115, 101, 114, 116, 105, 111, 110, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 97, 32, 63, 32, 72, 40, 120, 44, 32, 97, 41, 32, 58, 32, 34, 34, 125, 44, 32, 97, 116, 58, 32, 96, 32, 43, 32, 91, 98, 32, 63, 32, 98, 32, 63, 32, 72, 40, 120, 44, 32, 98, 41, 32, 58, 32, 34, 34, 32, 58, 32, 34, 117, 110, 107, 110, 111, 119, 110, 32, 102, 105, 108, 101, 110, 97, 109, 101, 34, 44, 32, 99, 44, 32, 100, 32, 63, 32, 100, 32, 63, 32, 72, 40, 120, 44, 32, 100, 41, 32, 58, 32, 34, 34, 32, 58, 32, 34, 117, 110, 107, 110, 111, 119, 110, 32, 102, 117, 110, 99, 116, 105, 111, 110, 34, 93, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 110, 101, 119, 32, 72, 97, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 46, 119, 97, 32, 43, 32, 49, 54, 32, 62, 62, 32, 50, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 46, 119, 97, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 32, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 46, 119, 97, 32, 43, 32, 56, 32, 62, 62, 32, 50, 93, 32, 61, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 73, 97, 32, 61, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 74, 97, 43, 43, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 77, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 74, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 75, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 80, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 76, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 82, 58, 32, 40, 41, 32, 61, 62, 32, 119, 97, 40, 34, 34, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 75, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 75, 97, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 98, 46, 79, 97, 44, 32, 100, 32, 61, 32, 98, 46, 69, 97, 44, 32, 101, 32, 61, 32, 98, 46, 82, 97, 44, 32, 102, 32, 61, 32, 101, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 36, 97, 41, 46, 99, 111, 110, 99, 97, 116, 40, 101, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 103, 98, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 97, 93, 44, 32, 102, 44, 32, 40, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 110, 32, 61, 32, 104, 91, 109, 93, 44, 32, 113, 32, 61, 32, 108, 46, 89, 97, 44, 32, 114, 32, 61, 32, 108, 46, 90, 97, 44, 32, 65, 32, 61, 32, 104, 91, 109, 32, 43, 32, 101, 46, 108, 101, 110, 103, 116, 104, 93, 44, 32, 117, 32, 61, 32, 108, 46, 102, 98, 44, 32, 118, 32, 61, 32, 108, 46, 104, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 91, 108, 46, 86, 97, 93, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 58, 32, 40, 69, 41, 32, 61, 62, 32, 110, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 113, 40, 114, 44, 32, 69, 41, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 114, 105, 116, 101, 58, 32, 40, 69, 44, 32, 100, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 66, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 40, 118, 44, 32, 69, 44, 32, 65, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 66, 44, 32, 100, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 97, 40, 66, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 46, 110, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 123, 125, 44, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 110, 32, 105, 110, 32, 103, 41, 32, 109, 91, 110, 93, 32, 61, 32, 103, 91, 110, 93, 46, 114, 101, 97, 100, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 40, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 110, 32, 105, 110, 32, 103, 41, 32, 105, 102, 32, 40, 33, 40, 110, 32, 105, 110, 32, 109, 41, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 84, 121, 112, 101, 69, 114, 114, 111, 114, 40, 96, 77, 105, 115, 115, 105, 110, 103, 32, 102, 105, 101, 108, 100, 58, 32, 34, 36, 123, 110, 125, 34, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 113, 32, 61, 32, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 110, 32, 105, 110, 32, 103, 41, 32, 103, 91, 110, 93, 46, 119, 114, 105, 116, 101, 40, 113, 44, 32, 109, 91, 110, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 108, 32, 38, 38, 32, 108, 46, 112, 117, 115, 104, 40, 100, 44, 32, 113, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 113, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 97, 58, 32, 100, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 87, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 33, 33, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 32, 63, 32, 99, 32, 58, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 40, 120, 91, 101, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 44, 32, 113, 44, 32, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 80, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 40, 103, 32, 61, 32, 84, 40, 104, 44, 32, 103, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 38, 38, 32, 40, 109, 32, 61, 32, 84, 40, 108, 44, 32, 109, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 32, 61, 32, 84, 40, 113, 44, 32, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 65, 32, 61, 32, 99, 98, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 98, 40, 65, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 36, 123, 110, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 91, 100, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 97, 44, 32, 98, 44, 32, 99, 93, 44, 32, 100, 32, 63, 32, 91, 100, 93, 32, 58, 32, 91, 93, 44, 32, 40, 117, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 32, 61, 32, 117, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 118, 32, 61, 32, 117, 46, 118, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 69, 32, 61, 32, 118, 46, 71, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 69, 32, 61, 32, 90, 97, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 32, 61, 32, 36, 97, 40, 110, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 46, 46, 46, 79, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 98, 106, 101, 99, 116, 46, 103, 101, 116, 80, 114, 111, 116, 111, 116, 121, 112, 101, 79, 102, 40, 116, 104, 105, 115, 41, 32, 33, 61, 61, 32, 100, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 85, 115, 101, 32, 39, 110, 101, 119, 39, 32, 116, 111, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 34, 32, 43, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 66, 46, 70, 97, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 110, 32, 43, 32, 34, 32, 104, 97, 115, 32, 110, 111, 32, 97, 99, 99, 101, 115, 115, 105, 98, 108, 101, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 119, 98, 32, 61, 32, 66, 46, 70, 97, 91, 79, 97, 46, 108, 101, 110, 103, 116, 104, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 119, 98, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 84, 114, 105, 101, 100, 32, 116, 111, 32, 105, 110, 118, 111, 107, 101, 32, 99, 116, 111, 114, 32, 111, 102, 32, 36, 123, 110, 125, 32, 119, 105, 116, 104, 32, 105, 110, 118, 97, 108, 105, 100, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 40, 36, 123, 79, 97, 46, 108, 101, 110, 103, 116, 104, 125, 41, 32, 45, 32, 101, 120, 112, 101, 99, 116, 101, 100, 32, 40, 36, 123, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 66, 46, 70, 97, 41, 46, 116, 111, 83, 116, 114, 105, 110, 103, 40, 41, 125, 41, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 105, 110, 115, 116, 101, 97, 100, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 119, 98, 46, 97, 112, 112, 108, 121, 40, 116, 104, 105, 115, 44, 32, 79, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 97, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 69, 44, 32, 123, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 117, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 32, 61, 32, 100, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 66, 32, 61, 32, 110, 101, 119, 32, 100, 98, 40, 110, 44, 32, 117, 44, 32, 100, 97, 44, 32, 114, 44, 32, 118, 44, 32, 102, 44, 32, 103, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 66, 46, 65, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 40, 101, 97, 32, 61, 32, 66, 46, 65, 97, 41, 46, 80, 97, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 50, 32, 58, 32, 101, 97, 46, 80, 97, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 66, 46, 65, 97, 46, 80, 97, 46, 112, 117, 115, 104, 40, 66, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 32, 61, 32, 110, 101, 119, 32, 107, 98, 40, 110, 44, 32, 66, 44, 32, 116, 114, 117, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 97, 32, 61, 32, 110, 101, 119, 32, 107, 98, 40, 110, 32, 43, 32, 34, 42, 34, 44, 32, 66, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 32, 61, 32, 110, 101, 119, 32, 107, 98, 40, 110, 32, 43, 32, 34, 32, 99, 111, 110, 115, 116, 42, 34, 44, 32, 66, 44, 32, 102, 97, 108, 115, 101, 44, 32, 116, 114, 117, 101, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 97, 91, 97, 93, 32, 61, 32, 123, 32, 112, 111, 105, 110, 116, 101, 114, 84, 121, 112, 101, 58, 32, 101, 97, 44, 32, 84, 97, 58, 32, 69, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 98, 40, 65, 44, 32, 117, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 118, 44, 32, 101, 97, 44, 32, 69, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 113, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 115, 98, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 84, 40, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 103, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 96, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 32, 36, 123, 103, 46, 110, 97, 109, 101, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 103, 46, 118, 97, 46, 70, 97, 32, 38, 38, 32, 40, 103, 46, 118, 97, 46, 70, 97, 32, 61, 32, 91, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 33, 61, 61, 32, 103, 46, 118, 97, 46, 70, 97, 91, 98, 32, 45, 32, 49, 93, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 67, 97, 110, 110, 111, 116, 32, 114, 101, 103, 105, 115, 116, 101, 114, 32, 109, 117, 108, 116, 105, 112, 108, 101, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 115, 32, 119, 105, 116, 104, 32, 105, 100, 101, 110, 116, 105, 99, 97, 108, 32, 110, 117, 109, 98, 101, 114, 32, 111, 102, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 115, 32, 40, 36, 123, 98, 32, 45, 32, 49, 125, 41, 32, 102, 111, 114, 32, 99, 108, 97, 115, 115, 32, 39, 36, 123, 103, 46, 110, 97, 109, 101, 125, 39, 33, 32, 79, 118, 101, 114, 108, 111, 97, 100, 32, 114, 101, 115, 111, 108, 117, 116, 105, 111, 110, 32, 105, 115, 32, 99, 117, 114, 114, 101, 110, 116, 108, 121, 32, 111, 110, 108, 121, 32, 112, 101, 114, 102, 111, 114, 109, 101, 100, 32, 117, 115, 105, 110, 103, 32, 116, 104, 101, 32, 112, 97, 114, 97, 109, 101, 116, 101, 114, 32, 99, 111, 117, 110, 116, 44, 32, 110, 111, 116, 32, 97, 99, 116, 117, 97, 108, 32, 116, 121, 112, 101, 32, 105, 110, 102, 111, 33, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 118, 97, 46, 70, 97, 91, 98, 32, 45, 32, 49, 93, 32, 61, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 32, 36, 123, 103, 46, 110, 97, 109, 101, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 104, 44, 32, 40, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 46, 115, 112, 108, 105, 99, 101, 40, 49, 44, 32, 48, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 46, 118, 97, 46, 70, 97, 91, 98, 32, 45, 32, 49, 93, 32, 61, 32, 117, 98, 40, 108, 44, 32, 109, 44, 32, 110, 117, 108, 108, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 115, 98, 40, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 118, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 91, 97, 93, 44, 32, 40, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 113, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 109, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 113, 32, 61, 32, 96, 36, 123, 109, 46, 110, 97, 109, 101, 125, 46, 36, 123, 98, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 46, 115, 116, 97, 114, 116, 115, 87, 105, 116, 104, 40, 34, 64, 64, 34, 41, 32, 38, 38, 32, 40, 98, 32, 61, 32, 83, 121, 109, 98, 111, 108, 91, 98, 46, 115, 117, 98, 115, 116, 114, 105, 110, 103, 40, 50, 41, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 38, 38, 32, 109, 46, 118, 97, 46, 99, 98, 46, 112, 117, 115, 104, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 32, 61, 32, 109, 46, 118, 97, 46, 71, 97, 44, 32, 65, 32, 61, 32, 114, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 65, 32, 124, 124, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 65, 46, 121, 97, 32, 38, 38, 32, 65, 46, 99, 108, 97, 115, 115, 78, 97, 109, 101, 32, 33, 61, 61, 32, 109, 46, 110, 97, 109, 101, 32, 38, 38, 32, 65, 46, 72, 97, 32, 61, 61, 61, 32, 99, 32, 45, 32, 50, 32, 63, 32, 40, 110, 46, 72, 97, 32, 61, 32, 99, 32, 45, 32, 50, 44, 32, 110, 46, 99, 108, 97, 115, 115, 78, 97, 109, 101, 32, 61, 32, 109, 46, 110, 97, 109, 101, 44, 32, 114, 91, 98, 93, 32, 61, 32, 110, 41, 32, 58, 32, 40, 97, 98, 40, 114, 44, 32, 98, 44, 32, 113, 41, 44, 32, 114, 91, 98, 93, 46, 121, 97, 91, 99, 32, 45, 32, 50, 93, 32, 61, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 108, 44, 32, 40, 117, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 32, 61, 32, 117, 98, 40, 113, 44, 32, 117, 44, 32, 109, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 114, 91, 98, 93, 46, 121, 97, 32, 63, 32, 40, 117, 46, 72, 97, 32, 61, 32, 99, 32, 45, 32, 50, 44, 32, 114, 91, 98, 93, 32, 61, 32, 117, 41, 32, 58, 32, 114, 91, 98, 93, 46, 121, 97, 91, 99, 32, 45, 32, 50, 93, 32, 61, 32, 117, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 86, 58, 32, 40, 97, 41, 32, 61, 62, 32, 78, 40, 97, 44, 32, 65, 98, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 46, 118, 97, 108, 117, 101, 115, 32, 61, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 118, 97, 108, 117, 101, 115, 91, 102, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 102, 44, 32, 104, 41, 32, 61, 62, 32, 104, 46, 118, 97, 108, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 66, 98, 40, 98, 44, 32, 99, 44, 32, 100, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 98, 40, 98, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 107, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 67, 98, 40, 97, 44, 32, 34, 101, 110, 117, 109, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 100, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 79, 98, 106, 101, 99, 116, 46, 99, 114, 101, 97, 116, 101, 40, 100, 46, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 108, 117, 101, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 99, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 58, 32, 123, 32, 118, 97, 108, 117, 101, 58, 32, 36, 97, 40, 96, 36, 123, 100, 46, 110, 97, 109, 101, 125, 95, 36, 123, 98, 125, 96, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 46, 118, 97, 108, 117, 101, 115, 91, 99, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 91, 98, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 122, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 100, 41, 32, 61, 62, 32, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 100, 44, 32, 101, 41, 32, 61, 62, 32, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 68, 98, 40, 98, 44, 32, 99, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 97, 58, 32, 110, 117, 108, 108, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 115, 98, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 80, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 118, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 84, 40, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 98, 40, 96, 67, 97, 110, 110, 111, 116, 32, 99, 97, 108, 108, 32, 36, 123, 97, 125, 32, 100, 117, 101, 32, 116, 111, 32, 117, 110, 98, 111, 117, 110, 100, 32, 116, 121, 112, 101, 115, 96, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 45, 32, 49, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 93, 44, 32, 104, 44, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 98, 40, 97, 44, 32, 117, 98, 40, 97, 44, 32, 91, 103, 91, 48, 93, 44, 32, 110, 117, 108, 108, 93, 46, 99, 111, 110, 99, 97, 116, 40, 103, 46, 115, 108, 105, 99, 101, 40, 49, 41, 41, 44, 32, 110, 117, 108, 108, 44, 32, 101, 44, 32, 102, 41, 44, 32, 98, 32, 45, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 49, 32, 61, 61, 61, 32, 101, 32, 38, 38, 32, 40, 101, 32, 61, 32, 52, 50, 57, 52, 57, 54, 55, 50, 57, 53, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 48, 32, 61, 61, 61, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 51, 50, 32, 45, 32, 56, 32, 42, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 103, 32, 60, 60, 32, 102, 32, 62, 62, 62, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 98, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 117, 110, 115, 105, 103, 110, 101, 100, 34, 41, 32, 63, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 103, 44, 32, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 32, 62, 62, 62, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 103, 44, 32, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 32, 110, 97, 109, 101, 58, 32, 98, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 101, 44, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 104, 44, 32, 67, 97, 58, 32, 56, 44, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 69, 98, 40, 98, 44, 32, 99, 44, 32, 48, 32, 33, 61, 61, 32, 100, 41, 44, 32, 68, 97, 58, 32, 110, 117, 108, 108, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 100, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 101, 40, 119, 46, 98, 117, 102, 102, 101, 114, 44, 32, 68, 91, 102, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 44, 32, 68, 91, 102, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 91, 73, 110, 116, 56, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 44, 32, 73, 110, 116, 49, 54, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 49, 54, 65, 114, 114, 97, 121, 44, 32, 73, 110, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 85, 105, 110, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 70, 108, 111, 97, 116, 51, 50, 65, 114, 114, 97, 121, 44, 32, 70, 108, 111, 97, 116, 54, 52, 65, 114, 114, 97, 121, 93, 91, 98, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 80, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 32, 110, 97, 109, 101, 58, 32, 99, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 100, 44, 32, 67, 97, 58, 32, 56, 44, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 100, 32, 125, 44, 32, 123, 32, 97, 98, 58, 32, 116, 114, 117, 101, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 70, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 44, 32, 110, 44, 32, 113, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 80, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 32, 61, 32, 84, 40, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 84, 40, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 84, 40, 108, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 32, 61, 32, 84, 40, 110, 44, 32, 113, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 40, 91, 97, 93, 44, 32, 91, 98, 93, 44, 32, 40, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 32, 61, 32, 114, 91, 48, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 110, 101, 119, 32, 107, 98, 40, 99, 44, 32, 114, 46, 118, 97, 44, 32, 102, 97, 108, 115, 101, 44, 32, 102, 97, 108, 115, 101, 44, 32, 116, 114, 117, 101, 44, 32, 114, 44, 32, 100, 44, 32, 102, 44, 32, 103, 44, 32, 109, 44, 32, 113, 41, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 65, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 34, 115, 116, 100, 58, 58, 115, 116, 114, 105, 110, 103, 34, 32, 61, 61, 61, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 68, 91, 100, 32, 62, 62, 32, 50, 93, 44, 32, 102, 32, 61, 32, 100, 32, 43, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 104, 32, 61, 32, 102, 44, 32, 103, 32, 61, 32, 48, 59, 32, 103, 32, 60, 61, 32, 101, 59, 32, 43, 43, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 102, 32, 43, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 61, 61, 32, 101, 32, 124, 124, 32, 48, 32, 61, 61, 32, 120, 91, 108, 93, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 104, 32, 63, 32, 72, 40, 120, 44, 32, 104, 44, 32, 108, 32, 45, 32, 104, 41, 32, 58, 32, 34, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 109, 41, 32, 118, 97, 114, 32, 109, 32, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 109, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 48, 41, 44, 32, 109, 32, 43, 61, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 108, 32, 43, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 65, 114, 114, 97, 121, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 103, 32, 61, 32, 48, 59, 32, 103, 32, 60, 32, 101, 59, 32, 43, 43, 103, 41, 32, 109, 91, 103, 93, 32, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 120, 91, 102, 32, 43, 32, 103, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 32, 61, 32, 109, 46, 106, 111, 105, 110, 40, 34, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 38, 38, 32, 40, 101, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 101, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 44, 32, 104, 32, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 104, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 85, 105, 110, 116, 56, 67, 108, 97, 109, 112, 101, 100, 65, 114, 114, 97, 121, 32, 124, 124, 32, 101, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 73, 110, 116, 56, 65, 114, 114, 97, 121, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 34, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 110, 111, 110, 45, 115, 116, 114, 105, 110, 103, 32, 116, 111, 32, 115, 116, 100, 58, 58, 115, 116, 114, 105, 110, 103, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 38, 38, 32, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 103, 32, 61, 32, 102, 32, 61, 32, 48, 59, 32, 103, 32, 60, 32, 101, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 108, 32, 61, 32, 101, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 49, 50, 55, 32, 62, 61, 32, 108, 32, 63, 32, 102, 43, 43, 32, 58, 32, 50, 48, 52, 55, 32, 62, 61, 32, 108, 32, 63, 32, 102, 32, 43, 61, 32, 50, 32, 58, 32, 53, 53, 50, 57, 54, 32, 60, 61, 32, 108, 32, 38, 38, 32, 53, 55, 51, 52, 51, 32, 62, 61, 32, 108, 32, 63, 32, 40, 102, 32, 43, 61, 32, 52, 44, 32, 43, 43, 103, 41, 32, 58, 32, 102, 32, 43, 61, 32, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 102, 32, 61, 32, 101, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 100, 99, 40, 52, 32, 43, 32, 102, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 32, 61, 32, 103, 32, 43, 32, 52, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 103, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 38, 38, 32, 104, 41, 32, 73, 40, 101, 44, 32, 108, 44, 32, 102, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 104, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 102, 59, 32, 43, 43, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 101, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 53, 53, 32, 60, 32, 109, 41, 32, 116, 104, 114, 111, 119, 32, 85, 40, 108, 41, 44, 32, 110, 101, 119, 32, 81, 40, 34, 83, 116, 114, 105, 110, 103, 32, 104, 97, 115, 32, 85, 84, 70, 45, 49, 54, 32, 99, 111, 100, 101, 32, 117, 110, 105, 116, 115, 32, 116, 104, 97, 116, 32, 100, 111, 32, 110, 111, 116, 32, 102, 105, 116, 32, 105, 110, 32, 56, 32, 98, 105, 116, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 120, 91, 108, 32, 43, 32, 104, 93, 32, 61, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 108, 115, 101, 32, 102, 111, 114, 32, 40, 104, 32, 61, 32, 48, 59, 32, 104, 32, 60, 32, 102, 59, 32, 43, 43, 104, 41, 32, 120, 91, 108, 32, 43, 32, 104, 93, 32, 61, 32, 101, 91, 104, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 100, 32, 38, 38, 32, 100, 46, 112, 117, 115, 104, 40, 85, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 97, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 61, 32, 80, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 32, 61, 61, 61, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 72, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 73, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 74, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 122, 91, 103, 32, 62, 62, 32, 49, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 52, 32, 61, 61, 61, 32, 98, 32, 38, 38, 32, 40, 100, 32, 61, 32, 75, 98, 44, 32, 101, 32, 61, 32, 76, 98, 44, 32, 102, 32, 61, 32, 77, 98, 44, 32, 104, 32, 61, 32, 40, 103, 41, 32, 61, 62, 32, 68, 91, 103, 32, 62, 62, 32, 50, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 103, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 68, 91, 103, 32, 62, 62, 32, 50, 93, 44, 32, 109, 44, 32, 110, 32, 61, 32, 103, 32, 43, 32, 52, 44, 32, 113, 32, 61, 32, 48, 59, 32, 113, 32, 60, 61, 32, 108, 59, 32, 43, 43, 113, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 114, 32, 61, 32, 103, 32, 43, 32, 52, 32, 43, 32, 113, 32, 42, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 113, 32, 61, 61, 32, 108, 32, 124, 124, 32, 48, 32, 61, 61, 32, 104, 40, 114, 41, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 32, 61, 32, 100, 40, 110, 44, 32, 114, 32, 45, 32, 110, 41, 44, 32, 118, 111, 105, 100, 32, 48, 32, 61, 61, 61, 32, 109, 32, 63, 32, 109, 32, 61, 32, 110, 32, 58, 32, 40, 109, 32, 43, 61, 32, 83, 116, 114, 105, 110, 103, 46, 102, 114, 111, 109, 67, 104, 97, 114, 67, 111, 100, 101, 40, 48, 41, 44, 32, 109, 32, 43, 61, 32, 110, 41, 44, 32, 110, 32, 61, 32, 114, 32, 43, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 103, 44, 32, 108, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 34, 115, 116, 114, 105, 110, 103, 34, 32, 33, 61, 32, 116, 121, 112, 101, 111, 102, 32, 108, 41, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 81, 40, 96, 67, 97, 110, 110, 111, 116, 32, 112, 97, 115, 115, 32, 110, 111, 110, 45, 115, 116, 114, 105, 110, 103, 32, 116, 111, 32, 67, 43, 43, 32, 115, 116, 114, 105, 110, 103, 32, 116, 121, 112, 101, 32, 36, 123, 99, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 102, 40, 108, 41, 44, 32, 110, 32, 61, 32, 100, 99, 40, 52, 32, 43, 32, 109, 32, 43, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 110, 32, 62, 62, 32, 50, 93, 32, 61, 32, 109, 32, 47, 32, 98, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 40, 108, 44, 32, 110, 32, 43, 32, 52, 44, 32, 109, 32, 43, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 117, 108, 108, 32, 33, 61, 61, 32, 103, 32, 38, 38, 32, 103, 46, 112, 117, 115, 104, 40, 85, 44, 32, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 58, 32, 56, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 58, 32, 74, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 97, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 85, 40, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 97, 91, 97, 93, 32, 61, 32, 123, 32, 110, 97, 109, 101, 58, 32, 80, 40, 98, 41, 44, 32, 79, 97, 58, 32, 84, 40, 99, 44, 32, 100, 41, 44, 32, 69, 97, 58, 32, 84, 40, 101, 44, 32, 102, 41, 44, 32, 82, 97, 58, 32, 91, 93, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 106, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 75, 97, 91, 97, 93, 46, 82, 97, 46, 112, 117, 115, 104, 40, 123, 32, 86, 97, 58, 32, 80, 40, 98, 41, 44, 32, 36, 97, 58, 32, 99, 44, 32, 89, 97, 58, 32, 84, 40, 100, 44, 32, 101, 41, 44, 32, 90, 97, 58, 32, 102, 44, 32, 103, 98, 58, 32, 104, 44, 32, 102, 98, 58, 32, 84, 40, 103, 44, 32, 108, 41, 44, 32, 104, 98, 58, 32, 109, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 88, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 80, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 40, 97, 44, 32, 123, 32, 106, 98, 58, 32, 116, 114, 117, 101, 44, 32, 110, 97, 109, 101, 58, 32, 98, 44, 32, 67, 97, 58, 32, 48, 44, 32, 102, 114, 111, 109, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 72, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 70, 97, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 78, 98, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 68, 58, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 73, 110, 102, 105, 110, 105, 116, 121, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 79, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 122, 98, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 97, 40, 110, 117, 108, 108, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 66, 58, 32, 121, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 90, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 81, 98, 40, 97, 44, 32, 98, 41, 44, 32, 101, 32, 61, 32, 100, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 45, 45, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 65, 114, 114, 97, 121, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 96, 109, 101, 116, 104, 111, 100, 67, 97, 108, 108, 101, 114, 60, 40, 36, 123, 100, 46, 109, 97, 112, 40, 40, 104, 41, 32, 61, 62, 32, 104, 46, 110, 97, 109, 101, 41, 46, 106, 111, 105, 110, 40, 34, 44, 32, 34, 41, 125, 41, 32, 61, 62, 32, 36, 123, 101, 46, 110, 97, 109, 101, 125, 62, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 80, 98, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 36, 97, 40, 98, 44, 32, 40, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 110, 32, 61, 32, 48, 44, 32, 113, 32, 61, 32, 48, 59, 32, 113, 32, 60, 32, 97, 59, 32, 43, 43, 113, 41, 32, 102, 91, 113, 93, 32, 61, 32, 100, 91, 113, 93, 46, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 40, 109, 32, 43, 32, 110, 41, 44, 32, 110, 32, 43, 61, 32, 100, 91, 113, 93, 46, 67, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 49, 32, 61, 61, 61, 32, 99, 32, 63, 32, 82, 98, 40, 103, 44, 32, 102, 41, 32, 58, 32, 103, 46, 97, 112, 112, 108, 121, 40, 104, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 103, 32, 61, 32, 101, 46, 116, 111, 87, 105, 114, 101, 84, 121, 112, 101, 40, 104, 44, 32, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 104, 46, 108, 101, 110, 103, 116, 104, 32, 38, 38, 32, 40, 68, 91, 108, 32, 62, 62, 32, 50, 93, 32, 61, 32, 105, 98, 40, 104, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 36, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 57, 32, 60, 32, 97, 32, 38, 38, 32, 40, 86, 91, 97, 32, 43, 32, 49, 93, 32, 43, 61, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 89, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 122, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 76, 97, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 121, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 111, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 67, 98, 40, 97, 44, 32, 34, 95, 101, 109, 118, 97, 108, 95, 116, 97, 107, 101, 95, 118, 97, 108, 117, 101, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 97, 46, 114, 101, 97, 100, 86, 97, 108, 117, 101, 70, 114, 111, 109, 80, 111, 105, 110, 116, 101, 114, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 98, 40, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 69, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 98, 91, 97, 93, 32, 38, 38, 32, 40, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 83, 98, 91, 97, 93, 46, 105, 100, 41, 44, 32, 100, 101, 108, 101, 116, 101, 32, 83, 98, 91, 97, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 41, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 108, 101, 116, 101, 32, 83, 98, 91, 97, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 86, 98, 40, 40, 41, 32, 61, 62, 32, 101, 99, 40, 97, 44, 32, 112, 101, 114, 102, 111, 114, 109, 97, 110, 99, 101, 46, 110, 111, 119, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 98, 91, 97, 93, 32, 61, 32, 123, 32, 105, 100, 58, 32, 99, 44, 32, 107, 98, 58, 32, 98, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 40, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 41, 41, 46, 103, 101, 116, 70, 117, 108, 108, 89, 101, 97, 114, 40, 41, 44, 32, 102, 32, 61, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 101, 44, 32, 48, 44, 32, 49, 41, 46, 103, 101, 116, 84, 105, 109, 101, 122, 111, 110, 101, 79, 102, 102, 115, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 110, 101, 119, 32, 68, 97, 116, 101, 40, 101, 44, 32, 54, 44, 32, 49, 41, 46, 103, 101, 116, 84, 105, 109, 101, 122, 111, 110, 101, 79, 102, 102, 115, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 97, 32, 62, 62, 32, 50, 93, 32, 61, 32, 54, 48, 32, 42, 32, 77, 97, 116, 104, 46, 109, 97, 120, 40, 102, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 78, 117, 109, 98, 101, 114, 40, 102, 32, 33, 61, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 40, 104, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 103, 32, 61, 32, 77, 97, 116, 104, 46, 97, 98, 115, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 96, 85, 84, 67, 36, 123, 48, 32, 60, 61, 32, 104, 32, 63, 32, 34, 45, 34, 32, 58, 32, 34, 43, 34, 125, 36, 123, 83, 116, 114, 105, 110, 103, 40, 77, 97, 116, 104, 46, 102, 108, 111, 111, 114, 40, 103, 32, 47, 32, 54, 48, 41, 41, 46, 112, 97, 100, 83, 116, 97, 114, 116, 40, 50, 44, 32, 34, 48, 34, 41, 125, 36, 123, 83, 116, 114, 105, 110, 103, 40, 103, 32, 37, 32, 54, 48, 41, 46, 112, 97, 100, 83, 116, 97, 114, 116, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 48, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 125, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 61, 32, 98, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 61, 32, 98, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 60, 32, 102, 32, 63, 32, 40, 73, 40, 97, 44, 32, 99, 44, 32, 49, 55, 41, 44, 32, 73, 40, 98, 44, 32, 100, 44, 32, 49, 55, 41, 41, 32, 58, 32, 40, 73, 40, 97, 44, 32, 100, 44, 32, 49, 55, 41, 44, 32, 73, 40, 98, 44, 32, 99, 44, 32, 49, 55, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 58, 32, 40, 41, 32, 61, 62, 32, 112, 101, 114, 102, 111, 114, 109, 97, 110, 99, 101, 46, 110, 111, 119, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 71, 58, 32, 40, 97, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 120, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 32, 62, 62, 62, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 50, 49, 52, 55, 52, 56, 51, 54, 52, 56, 32, 60, 32, 97, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 99, 32, 61, 32, 49, 59, 32, 52, 32, 62, 61, 32, 99, 59, 32, 99, 32, 42, 61, 32, 50, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 98, 32, 42, 32, 40, 49, 32, 43, 32, 48, 46, 50, 32, 47, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 77, 97, 116, 104, 46, 109, 105, 110, 40, 100, 44, 32, 97, 32, 43, 32, 49, 48, 48, 54, 54, 51, 50, 57, 54, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 32, 61, 32, 40, 77, 97, 116, 104, 46, 109, 105, 110, 40, 50, 49, 52, 55, 52, 56, 51, 54, 52, 56, 44, 32, 54, 53, 53, 51, 54, 32, 42, 32, 77, 97, 116, 104, 46, 99, 101, 105, 108, 40, 77, 97, 116, 104, 46, 109, 97, 120, 40, 97, 44, 32, 100, 41, 32, 47, 32, 54, 53, 53, 51, 54, 41, 41, 32, 45, 32, 108, 97, 46, 98, 117, 102, 102, 101, 114, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 43, 32, 54, 53, 53, 51, 53, 41, 32, 47, 32, 54, 53, 53, 51, 54, 32, 124, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 46, 103, 114, 111, 119, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 114, 101, 97, 107, 32, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 84, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 98, 40, 41, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 100, 44, 32, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 98, 32, 43, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 61, 32, 68, 91, 97, 32, 43, 32, 52, 32, 42, 32, 101, 32, 62, 62, 32, 50, 93, 32, 61, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 100, 46, 108, 101, 110, 103, 116, 104, 59, 32, 43, 43, 102, 41, 32, 119, 91, 101, 43, 43, 93, 32, 61, 32, 100, 46, 99, 104, 97, 114, 67, 111, 100, 101, 65, 116, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 119, 91, 101, 93, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 32, 43, 61, 32, 100, 46, 108, 101, 110, 103, 116, 104, 32, 43, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 85, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 89, 98, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 97, 32, 62, 62, 32, 50, 93, 32, 61, 32, 99, 46, 108, 101, 110, 103, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 41, 32, 61, 62, 32, 100, 32, 43, 61, 32, 101, 46, 108, 101, 110, 103, 116, 104, 32, 43, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 98, 32, 62, 62, 32, 50, 93, 32, 61, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 81, 58, 32, 40, 41, 32, 61, 62, 32, 53, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 58, 32, 40, 41, 32, 61, 62, 32, 53, 50, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 78, 58, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 101, 32, 61, 32, 48, 44, 32, 102, 32, 61, 32, 48, 59, 32, 102, 32, 60, 32, 99, 59, 32, 102, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 68, 91, 98, 32, 62, 62, 32, 50, 93, 44, 32, 103, 32, 61, 32, 68, 91, 98, 32, 43, 32, 52, 32, 62, 62, 32, 50, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 32, 43, 61, 32, 56, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 118, 97, 114, 32, 108, 32, 61, 32, 48, 59, 32, 108, 32, 60, 32, 103, 59, 32, 108, 43, 43, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 109, 32, 61, 32, 97, 44, 32, 110, 32, 61, 32, 120, 91, 104, 32, 43, 32, 108, 93, 44, 32, 113, 32, 61, 32, 90, 98, 91, 109, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 61, 32, 110, 32, 124, 124, 32, 49, 48, 32, 61, 61, 61, 32, 110, 32, 63, 32, 40, 40, 49, 32, 61, 61, 61, 32, 109, 32, 63, 32, 106, 97, 32, 58, 32, 116, 41, 40, 72, 40, 113, 41, 41, 44, 32, 113, 46, 108, 101, 110, 103, 116, 104, 32, 61, 32, 48, 41, 32, 58, 32, 113, 46, 112, 117, 115, 104, 40, 110, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 32, 43, 61, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 68, 91, 100, 32, 62, 62, 32, 50, 93, 32, 61, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 58, 32, 102, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 58, 32, 103, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 58, 32, 104, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 112, 58, 32, 105, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 58, 32, 106, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 58, 32, 107, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 58, 32, 108, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 103, 58, 32, 109, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 110, 58, 32, 110, 99, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 83, 58, 32, 85, 98, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 73, 58, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 40, 120, 46, 115, 117, 98, 97, 114, 114, 97, 121, 40, 97, 44, 32, 97, 32, 43, 32, 98, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 44, 32, 87, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 51, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 87, 32, 61, 32, 99, 46, 101, 120, 112, 111, 114, 116, 115, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 32, 61, 32, 87, 46, 99, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 113, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 32, 61, 32, 87, 46, 103, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 87, 46, 100, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 70, 45, 45, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 51, 32, 61, 32, 107, 46, 109, 111, 110, 105, 116, 111, 114, 82, 117, 110, 68, 101, 112, 101, 110, 100, 101, 110, 99, 105, 101, 115, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 51, 46, 99, 97, 108, 108, 40, 107, 44, 32, 70, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 61, 61, 32, 70, 32, 38, 38, 32, 40, 110, 117, 108, 108, 32, 33, 61, 61, 32, 118, 97, 32, 38, 38, 32, 40, 99, 108, 101, 97, 114, 73, 110, 116, 101, 114, 118, 97, 108, 40, 118, 97, 41, 44, 32, 118, 97, 32, 61, 32, 110, 117, 108, 108, 41, 44, 32, 71, 32, 38, 38, 32, 40, 99, 32, 61, 32, 71, 44, 32, 71, 32, 61, 32, 110, 117, 108, 108, 44, 32, 99, 40, 41, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 87, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 70, 43, 43, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 107, 46, 109, 111, 110, 105, 116, 111, 114, 82, 117, 110, 68, 101, 112, 101, 110, 100, 101, 110, 99, 105, 101, 115, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 44, 32, 70, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 123, 32, 97, 58, 32, 111, 99, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 107, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 40, 98, 44, 32, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 40, 96, 77, 111, 100, 117, 108, 101, 46, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 87, 97, 115, 109, 32, 99, 97, 108, 108, 98, 97, 99, 107, 32, 102, 97, 105, 108, 101, 100, 32, 119, 105, 116, 104, 32, 101, 114, 114, 111, 114, 58, 32, 36, 123, 99, 125, 96, 41, 44, 32, 98, 97, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 97, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 121, 97, 32, 58, 32, 121, 97, 32, 61, 32, 120, 97, 40, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 41, 32, 63, 32, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 32, 58, 32, 107, 46, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 32, 63, 32, 107, 46, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 40, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 44, 32, 112, 41, 32, 58, 32, 112, 32, 43, 32, 34, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 40, 98, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 40, 99, 46, 105, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 46, 99, 97, 116, 99, 104, 40, 98, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 125, 59, 10, 32, 32, 32, 32, 32, 32, 125, 40, 41, 44, 32, 100, 99, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 100, 99, 32, 61, 32, 87, 46, 101, 97, 41, 40, 97, 41, 44, 32, 112, 98, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 112, 98, 32, 61, 32, 87, 46, 102, 97, 41, 40, 97, 41, 44, 32, 85, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 85, 32, 61, 32, 87, 46, 104, 97, 41, 40, 97, 41, 44, 32, 101, 99, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 101, 99, 32, 61, 32, 87, 46, 105, 97, 41, 40, 97, 44, 32, 98, 41, 44, 32, 88, 32, 61, 32, 40, 97, 44, 32, 98, 41, 32, 61, 62, 32, 40, 88, 32, 61, 32, 87, 46, 106, 97, 41, 40, 97, 44, 32, 98, 41, 44, 32, 89, 32, 61, 32, 40, 97, 41, 32, 61, 62, 32, 40, 89, 32, 61, 32, 87, 46, 107, 97, 41, 40, 97, 41, 44, 32, 90, 32, 61, 32, 40, 41, 32, 61, 62, 32, 40, 90, 32, 61, 32, 87, 46, 108, 97, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 106, 106, 32, 61, 32, 87, 46, 109, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 106, 106, 32, 61, 32, 87, 46, 110, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 105, 32, 61, 32, 87, 46, 111, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 106, 105, 105, 32, 61, 32, 87, 46, 112, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 118, 105, 105, 106, 105, 105, 32, 61, 32, 87, 46, 113, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 32, 61, 32, 87, 46, 114, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 87, 46, 115, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 32, 61, 62, 32, 40, 107, 46, 100, 121, 110, 67, 97, 108, 108, 95, 105, 105, 105, 105, 105, 105, 106, 106, 32, 61, 32, 87, 46, 116, 97, 41, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 44, 32, 104, 44, 32, 103, 44, 32, 108, 44, 32, 109, 41, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 108, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 107, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 103, 99, 40, 97, 44, 32, 98, 44, 32, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 100, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 32, 33, 61, 61, 32, 101, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 102, 99, 40, 97, 44, 32, 98, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 99, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 100, 32, 33, 61, 61, 32, 100, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 100, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 104, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 44, 32, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 104, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 103, 32, 33, 61, 61, 32, 103, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 103, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 110, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 102, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 44, 32, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 104, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 102, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 104, 32, 33, 61, 61, 32, 104, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 109, 99, 40, 97, 44, 32, 98, 44, 32, 99, 44, 32, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 101, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 98, 44, 32, 99, 44, 32, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 102, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 32, 33, 61, 61, 32, 102, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 106, 99, 40, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 90, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 83, 46, 103, 101, 116, 40, 97, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 89, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 32, 33, 61, 61, 32, 99, 32, 43, 32, 48, 41, 32, 116, 104, 114, 111, 119, 32, 99, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 88, 40, 49, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 112, 99, 59, 10, 32, 32, 32, 32, 32, 32, 71, 32, 61, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 113, 99, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 112, 99, 32, 124, 124, 32, 114, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 112, 99, 32, 124, 124, 32, 40, 71, 32, 61, 32, 113, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 114, 99, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 97, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 112, 99, 32, 38, 38, 32, 40, 112, 99, 32, 61, 32, 116, 114, 117, 101, 44, 32, 107, 46, 99, 97, 108, 108, 101, 100, 82, 117, 110, 32, 61, 32, 116, 114, 117, 101, 44, 32, 33, 109, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 115, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 97, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 97, 50, 32, 61, 32, 107, 46, 111, 110, 82, 117, 110, 116, 105, 109, 101, 73, 110, 105, 116, 105, 97, 108, 105, 122, 101, 100, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 99, 97, 108, 108, 40, 107, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 111, 115, 116, 82, 117, 110, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 32, 38, 38, 32, 40, 107, 46, 112, 111, 115, 116, 82, 117, 110, 32, 61, 32, 91, 107, 46, 112, 111, 115, 116, 82, 117, 110, 93, 41, 59, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 98, 32, 61, 32, 107, 46, 112, 111, 115, 116, 82, 117, 110, 46, 115, 104, 105, 102, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 97, 46, 117, 110, 115, 104, 105, 102, 116, 40, 98, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 40, 48, 32, 60, 32, 70, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 114, 101, 82, 117, 110, 41, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 114, 101, 82, 117, 110, 32, 38, 38, 32, 40, 107, 46, 112, 114, 101, 82, 117, 110, 32, 61, 32, 91, 107, 46, 112, 114, 101, 82, 117, 110, 93, 41, 59, 32, 107, 46, 112, 114, 101, 82, 117, 110, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 117, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 69, 97, 40, 114, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 48, 32, 60, 32, 70, 32, 124, 124, 32, 40, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 32, 63, 32, 40, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 40, 34, 82, 117, 110, 110, 105, 110, 103, 46, 46, 46, 34, 41, 44, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 107, 46, 115, 101, 116, 83, 116, 97, 116, 117, 115, 40, 34, 34, 41, 44, 32, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 49, 41, 41, 32, 58, 32, 97, 40, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 107, 46, 112, 114, 101, 73, 110, 105, 116, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 32, 61, 61, 32, 116, 121, 112, 101, 111, 102, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 32, 38, 38, 32, 40, 107, 46, 112, 114, 101, 73, 110, 105, 116, 32, 61, 32, 91, 107, 46, 112, 114, 101, 73, 110, 105, 116, 93, 41, 59, 32, 48, 32, 60, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 46, 108, 101, 110, 103, 116, 104, 59, 32, 41, 32, 107, 46, 112, 114, 101, 73, 110, 105, 116, 46, 112, 111, 112, 40, 41, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 99, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 32, 61, 32, 99, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 82, 116, 110, 59, 10, 32, 32, 32, 32, 125, 59, 10, 32, 32, 125, 41, 40, 41, 59, 10, 32, 32, 118, 97, 114, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 112, 108, 97, 121, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 32, 61, 32, 99, 114, 101, 97, 116, 101, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 77, 111, 100, 117, 108, 101, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 99, 111, 114, 101, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 119, 97, 115, 109, 45, 108, 111, 97, 100, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 34, 82, 101, 110, 100, 101, 114, 101, 114, 76, 111, 97, 100, 101, 114, 32, 105, 115, 32, 97, 32, 115, 116, 97, 116, 105, 99, 32, 99, 108, 97, 115, 115, 32, 97, 110, 100, 32, 99, 97, 110, 110, 111, 116, 32, 98, 101, 32, 105, 110, 115, 116, 97, 110, 116, 105, 97, 116, 101, 100, 46, 34, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 116, 114, 121, 76, 111, 97, 100, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 117, 108, 101, 32, 61, 32, 121, 105, 101, 108, 100, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 112, 108, 97, 121, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 40, 123, 32, 108, 111, 99, 97, 116, 101, 70, 105, 108, 101, 58, 32, 40, 41, 32, 61, 62, 32, 117, 114, 108, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 84, 114, 105, 101, 115, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 109, 111, 100, 117, 108, 101, 32, 102, 114, 111, 109, 32, 116, 104, 101, 32, 112, 114, 105, 109, 97, 114, 121, 32, 85, 82, 76, 44, 32, 102, 97, 108, 108, 105, 110, 103, 32, 98, 97, 99, 107, 32, 116, 111, 32, 97, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 32, 105, 102, 32, 110, 101, 99, 101, 115, 115, 97, 114, 121, 46, 10, 32, 32, 32, 32, 32, 42, 32, 84, 104, 114, 111, 119, 115, 32, 97, 110, 32, 101, 114, 114, 111, 114, 32, 105, 102, 32, 98, 111, 116, 104, 32, 85, 82, 76, 115, 32, 102, 97, 105, 108, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 80, 114, 111, 109, 105, 115, 101, 60, 77, 111, 100, 117, 108, 101, 62, 32, 45, 32, 65, 32, 112, 114, 111, 109, 105, 115, 101, 32, 116, 104, 97, 116, 32, 114, 101, 115, 111, 108, 118, 101, 115, 32, 116, 111, 32, 116, 104, 101, 32, 108, 111, 97, 100, 101, 100, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 108, 111, 97, 100, 87, 105, 116, 104, 66, 97, 99, 107, 117, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 116, 114, 121, 76, 111, 97, 100, 40, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 41, 46, 99, 97, 116, 99, 104, 40, 40, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 41, 32, 61, 62, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 97, 99, 107, 117, 112, 85, 114, 108, 32, 61, 32, 96, 104, 116, 116, 112, 115, 58, 47, 47, 117, 110, 112, 107, 103, 46, 99, 111, 109, 47, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 125, 64, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 125, 47, 100, 105, 115, 116, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 96, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 80, 114, 105, 109, 97, 114, 121, 32, 87, 65, 83, 77, 32, 108, 111, 97, 100, 32, 102, 97, 105, 108, 101, 100, 32, 102, 114, 111, 109, 32, 36, 123, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 125, 46, 32, 69, 114, 114, 111, 114, 58, 32, 36, 123, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 119, 97, 114, 110, 40, 96, 65, 116, 116, 101, 109, 112, 116, 105, 110, 103, 32, 116, 111, 32, 108, 111, 97, 100, 32, 87, 65, 83, 77, 32, 102, 114, 111, 109, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 58, 32, 36, 123, 98, 97, 99, 107, 117, 112, 85, 114, 108, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 121, 105, 101, 108, 100, 32, 116, 104, 105, 115, 46, 95, 116, 114, 121, 76, 111, 97, 100, 40, 98, 97, 99, 107, 117, 112, 85, 114, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 98, 97, 99, 107, 117, 112, 69, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 96, 80, 114, 105, 109, 97, 114, 121, 32, 87, 65, 83, 77, 32, 85, 82, 76, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 105, 110, 105, 116, 105, 97, 108, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 96, 66, 97, 99, 107, 117, 112, 32, 87, 65, 83, 77, 32, 85, 82, 76, 32, 102, 97, 105, 108, 101, 100, 58, 32, 36, 123, 98, 97, 99, 107, 117, 112, 69, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 34, 87, 65, 83, 77, 32, 108, 111, 97, 100, 105, 110, 103, 32, 102, 97, 105, 108, 101, 100, 32, 102, 114, 111, 109, 32, 97, 108, 108, 32, 115, 111, 117, 114, 99, 101, 115, 46, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 80, 117, 98, 108, 105, 99, 32, 109, 101, 116, 104, 111, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 116, 104, 101, 32, 87, 101, 98, 65, 115, 115, 101, 109, 98, 108, 121, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 32, 85, 116, 105, 108, 105, 122, 101, 115, 32, 97, 32, 112, 114, 105, 109, 97, 114, 121, 32, 97, 110, 100, 32, 98, 97, 99, 107, 117, 112, 32, 85, 82, 76, 32, 102, 111, 114, 32, 114, 111, 98, 117, 115, 116, 110, 101, 115, 115, 46, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 80, 114, 111, 109, 105, 115, 101, 60, 77, 111, 100, 117, 108, 101, 62, 32, 45, 32, 65, 32, 112, 114, 111, 109, 105, 115, 101, 32, 116, 104, 97, 116, 32, 114, 101, 115, 111, 108, 118, 101, 115, 32, 116, 111, 32, 116, 104, 101, 32, 108, 111, 97, 100, 101, 100, 32, 109, 111, 100, 117, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 108, 111, 97, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 87, 105, 116, 104, 66, 97, 99, 107, 117, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 83, 101, 116, 115, 32, 97, 32, 110, 101, 119, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 32, 97, 110, 100, 32, 105, 110, 118, 97, 108, 105, 100, 97, 116, 101, 115, 32, 116, 104, 101, 32, 99, 117, 114, 114, 101, 110, 116, 32, 109, 111, 100, 117, 108, 101, 32, 112, 114, 111, 109, 105, 115, 101, 46, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 64, 112, 97, 114, 97, 109, 32, 115, 116, 114, 105, 110, 103, 32, 45, 32, 32, 84, 104, 101, 32, 110, 101, 119, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 46, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 117, 114, 108, 32, 61, 61, 61, 32, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 119, 97, 115, 109, 85, 82, 76, 32, 61, 32, 117, 114, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 47, 47, 32, 101, 115, 108, 105, 110, 116, 45, 100, 105, 115, 97, 98, 108, 101, 45, 110, 101, 120, 116, 45, 108, 105, 110, 101, 32, 64, 116, 121, 112, 101, 115, 99, 114, 105, 112, 116, 45, 101, 115, 108, 105, 110, 116, 47, 110, 97, 109, 105, 110, 103, 45, 99, 111, 110, 118, 101, 110, 116, 105, 111, 110, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 44, 32, 34, 95, 77, 111, 100, 117, 108, 101, 80, 114, 111, 109, 105, 115, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 47, 47, 32, 85, 82, 76, 32, 102, 111, 114, 32, 116, 104, 101, 32, 87, 65, 83, 77, 32, 102, 105, 108, 101, 44, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 101, 100, 32, 117, 115, 105, 110, 103, 32, 112, 97, 99, 107, 97, 103, 101, 32, 105, 110, 102, 111, 114, 109, 97, 116, 105, 111, 110, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 44, 32, 34, 95, 119, 97, 115, 109, 85, 82, 76, 34, 44, 32, 96, 104, 116, 116, 112, 115, 58, 47, 47, 99, 100, 110, 46, 106, 115, 100, 101, 108, 105, 118, 114, 46, 110, 101, 116, 47, 110, 112, 109, 47, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 78, 65, 77, 69, 125, 64, 36, 123, 80, 65, 67, 75, 65, 71, 69, 95, 86, 69, 82, 83, 73, 79, 78, 125, 47, 100, 105, 115, 116, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 45, 112, 108, 97, 121, 101, 114, 46, 119, 97, 115, 109, 96, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 101, 118, 101, 110, 116, 45, 109, 97, 110, 97, 103, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 69, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 83, 101, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 115, 101, 116, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 97, 100, 100, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 108, 105, 115, 116, 101, 110, 101, 114, 115, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 100, 101, 108, 101, 116, 101, 40, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 100, 105, 115, 112, 97, 116, 99, 104, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 103, 101, 116, 40, 101, 118, 101, 110, 116, 46, 116, 121, 112, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 61, 62, 32, 108, 105, 115, 116, 101, 110, 101, 114, 40, 101, 118, 101, 110, 116, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 65, 108, 108, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 46, 99, 108, 101, 97, 114, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 111, 102, 102, 115, 99, 114, 101, 101, 110, 45, 111, 98, 115, 101, 114, 118, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 67, 97, 108, 108, 98, 97, 99, 107, 32, 61, 32, 40, 101, 110, 116, 114, 105, 101, 115, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 110, 116, 114, 105, 101, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 110, 116, 114, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 101, 110, 116, 114, 121, 46, 105, 115, 73, 110, 116, 101, 114, 115, 101, 99, 116, 105, 110, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 101, 119, 32, 73, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 40, 105, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 79, 98, 115, 101, 114, 118, 101, 114, 67, 97, 108, 108, 98, 97, 99, 107, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 101, 115, 104, 111, 108, 100, 58, 32, 48, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 104, 97, 115, 40, 99, 97, 110, 118, 97, 115, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 100, 101, 108, 101, 116, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 98, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 100, 105, 115, 99, 111, 110, 110, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 114, 101, 115, 105, 122, 101, 45, 111, 98, 115, 101, 114, 118, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 82, 69, 83, 73, 90, 69, 95, 68, 69, 66, 79, 85, 78, 67, 69, 95, 84, 73, 77, 69, 32, 61, 32, 49, 48, 48, 59, 10, 32, 32, 118, 97, 114, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 99, 108, 97, 115, 115, 32, 123, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 105, 122, 101, 72, 97, 110, 100, 108, 101, 114, 32, 61, 32, 40, 101, 110, 116, 114, 105, 101, 115, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 110, 116, 114, 105, 101, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 110, 116, 114, 121, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 108, 101, 109, 101, 110, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 103, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 101, 108, 101, 109, 101, 110, 116, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 116, 105, 109, 101, 111, 117, 116, 93, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 108, 101, 97, 114, 84, 105, 109, 101, 111, 117, 116, 40, 116, 105, 109, 101, 111, 117, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 110, 101, 119, 84, 105, 109, 101, 111, 117, 116, 32, 61, 32, 115, 101, 116, 84, 105, 109, 101, 111, 117, 116, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 44, 32, 82, 69, 83, 73, 90, 69, 95, 68, 69, 66, 79, 85, 78, 67, 69, 95, 84, 73, 77, 69, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 101, 110, 116, 114, 121, 46, 116, 97, 114, 103, 101, 116, 44, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 110, 101, 119, 84, 105, 109, 101, 111, 117, 116, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 101, 119, 32, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 114, 101, 115, 105, 122, 101, 72, 97, 110, 100, 108, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 44, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 110, 105, 116, 105, 97, 108, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 104, 97, 115, 40, 99, 97, 110, 118, 97, 115, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 101, 116, 40, 99, 97, 110, 118, 97, 115, 44, 32, 91, 100, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 44, 32, 48, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 100, 101, 108, 101, 116, 101, 40, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 46, 115, 105, 122, 101, 32, 61, 61, 61, 32, 48, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 40, 95, 98, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 100, 105, 115, 99, 111, 110, 110, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 111, 98, 115, 101, 114, 118, 101, 114, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 44, 32, 34, 95, 111, 98, 115, 101, 114, 118, 101, 100, 67, 97, 110, 118, 97, 115, 101, 115, 34, 44, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 41, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 117, 116, 105, 108, 115, 46, 116, 115, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 72, 101, 120, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 47, 94, 35, 40, 91, 92, 100, 97, 45, 102, 93, 123, 54, 125, 124, 91, 92, 100, 97, 45, 102, 93, 123, 56, 125, 41, 36, 47, 105, 117, 46, 116, 101, 115, 116, 40, 99, 111, 108, 111, 114, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 104, 101, 120, 83, 116, 114, 105, 110, 103, 84, 111, 82, 71, 66, 65, 73, 110, 116, 40, 99, 111, 108, 111, 114, 72, 101, 120, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 72, 101, 120, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 72, 101, 120, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 101, 116, 32, 104, 101, 120, 32, 61, 32, 99, 111, 108, 111, 114, 72, 101, 120, 46, 114, 101, 112, 108, 97, 99, 101, 40, 34, 35, 34, 44, 32, 34, 34, 41, 59, 10, 32, 32, 32, 32, 104, 101, 120, 32, 61, 32, 104, 101, 120, 46, 108, 101, 110, 103, 116, 104, 32, 61, 61, 61, 32, 54, 32, 63, 32, 96, 36, 123, 104, 101, 120, 125, 102, 102, 96, 32, 58, 32, 104, 101, 120, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 112, 97, 114, 115, 101, 73, 110, 116, 40, 104, 101, 120, 44, 32, 49, 54, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 102, 105, 108, 101, 68, 97, 116, 97, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 32, 60, 32, 52, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 105, 108, 101, 83, 105, 103, 110, 97, 116, 117, 114, 101, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 65, 114, 114, 97, 121, 40, 102, 105, 108, 101, 68, 97, 116, 97, 46, 115, 108, 105, 99, 101, 40, 48, 44, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 46, 98, 121, 116, 101, 76, 101, 110, 103, 116, 104, 41, 41, 59, 10, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 46, 108, 101, 110, 103, 116, 104, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 90, 73, 80, 95, 83, 73, 71, 78, 65, 84, 85, 82, 69, 91, 105, 93, 32, 33, 61, 61, 32, 102, 105, 108, 101, 83, 105, 103, 110, 97, 116, 117, 114, 101, 91, 105, 93, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 106, 115, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 76, 79, 84, 84, 73, 69, 95, 74, 83, 79, 78, 95, 77, 65, 78, 68, 65, 84, 79, 82, 89, 95, 70, 73, 69, 76, 68, 83, 46, 101, 118, 101, 114, 121, 40, 40, 102, 105, 101, 108, 100, 41, 32, 61, 62, 32, 79, 98, 106, 101, 99, 116, 46, 112, 114, 111, 116, 111, 116, 121, 112, 101, 46, 104, 97, 115, 79, 119, 110, 80, 114, 111, 112, 101, 114, 116, 121, 46, 99, 97, 108, 108, 40, 106, 115, 111, 110, 44, 32, 102, 105, 101, 108, 100, 41, 41, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 102, 105, 108, 101, 68, 97, 116, 97, 32, 61, 61, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 74, 83, 79, 78, 46, 112, 97, 114, 115, 101, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 95, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 115, 76, 111, 116, 116, 105, 101, 74, 83, 79, 78, 40, 102, 105, 108, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 112, 114, 32, 61, 32, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 63, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 58, 32, 49, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 49, 32, 43, 32, 40, 100, 112, 114, 32, 45, 32, 49, 41, 32, 42, 32, 68, 69, 70, 65, 85, 76, 84, 95, 68, 80, 82, 95, 70, 65, 67, 84, 79, 82, 59, 10, 32, 32, 125, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 105, 115, 69, 108, 101, 109, 101, 110, 116, 73, 110, 86, 105, 101, 119, 112, 111, 114, 116, 40, 101, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 99, 116, 32, 61, 32, 101, 108, 101, 109, 101, 110, 116, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 99, 116, 46, 116, 111, 112, 32, 62, 61, 32, 48, 32, 38, 38, 32, 114, 101, 99, 116, 46, 108, 101, 102, 116, 32, 62, 61, 32, 48, 32, 38, 38, 32, 114, 101, 99, 116, 46, 98, 111, 116, 116, 111, 109, 32, 60, 61, 32, 40, 119, 105, 110, 100, 111, 119, 46, 105, 110, 110, 101, 114, 72, 101, 105, 103, 104, 116, 32, 124, 124, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 100, 111, 99, 117, 109, 101, 110, 116, 69, 108, 101, 109, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 41, 32, 38, 38, 32, 114, 101, 99, 116, 46, 114, 105, 103, 104, 116, 32, 60, 61, 32, 40, 119, 105, 110, 100, 111, 119, 46, 105, 110, 110, 101, 114, 87, 105, 100, 116, 104, 32, 124, 124, 32, 100, 111, 99, 117, 109, 101, 110, 116, 46, 100, 111, 99, 117, 109, 101, 110, 116, 69, 108, 101, 109, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 41, 59, 10, 32, 32, 125, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 32, 61, 32, 40, 109, 111, 100, 101, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 114, 101, 118, 101, 114, 115, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 98, 111, 117, 110, 99, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 66, 111, 117, 110, 99, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 34, 114, 101, 118, 101, 114, 115, 101, 45, 98, 111, 117, 110, 99, 101, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 66, 111, 117, 110, 99, 101, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 77, 111, 100, 101, 46, 70, 111, 114, 119, 97, 114, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 32, 61, 32, 40, 102, 105, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 67, 111, 110, 116, 97, 105, 110, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 99, 111, 118, 101, 114, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 67, 111, 118, 101, 114, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 108, 108, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 108, 108, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 116, 45, 104, 101, 105, 103, 104, 116, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 116, 72, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 102, 105, 116, 32, 61, 61, 61, 32, 34, 102, 105, 116, 45, 119, 105, 100, 116, 104, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 70, 105, 116, 87, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 111, 100, 117, 108, 101, 46, 70, 105, 116, 46, 78, 111, 110, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 32, 61, 32, 40, 97, 108, 105, 103, 110, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 86, 101, 99, 116, 111, 114, 70, 108, 111, 97, 116, 40, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 97, 108, 105, 103, 110, 91, 48, 93, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 97, 108, 105, 103, 110, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 65, 108, 105, 103, 110, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 32, 61, 32, 40, 115, 101, 103, 109, 101, 110, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 86, 101, 99, 116, 111, 114, 70, 108, 111, 97, 116, 40, 41, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 115, 101, 103, 109, 101, 110, 116, 46, 108, 101, 110, 103, 116, 104, 32, 33, 61, 61, 32, 50, 41, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 115, 101, 103, 109, 101, 110, 116, 91, 48, 93, 41, 59, 10, 32, 32, 32, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 46, 112, 117, 115, 104, 95, 98, 97, 99, 107, 40, 115, 101, 103, 109, 101, 110, 116, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 114, 101, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 61, 32, 99, 108, 97, 115, 115, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 99, 97, 110, 118, 97, 115, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 99, 111, 110, 116, 101, 120, 116, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 34, 44, 32, 123, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 105, 115, 70, 114, 111, 122, 101, 110, 34, 44, 32, 102, 97, 108, 115, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 116, 104, 105, 115, 44, 32, 34, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 99, 97, 110, 118, 97, 115, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 67, 111, 110, 116, 101, 120, 116, 40, 34, 50, 100, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 110, 101, 119, 32, 69, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 32, 61, 32, 110, 101, 119, 32, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 58, 32, 40, 40, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 41, 32, 124, 124, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 47, 47, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 105, 115, 32, 116, 114, 117, 101, 32, 98, 121, 32, 100, 101, 102, 97, 117, 108, 116, 32, 116, 111, 32, 112, 114, 101, 118, 101, 110, 116, 32, 117, 110, 110, 101, 99, 101, 115, 115, 97, 114, 121, 32, 114, 101, 110, 100, 101, 114, 105, 110, 103, 32, 119, 104, 101, 110, 32, 116, 104, 101, 32, 99, 97, 110, 118, 97, 115, 32, 105, 115, 32, 111, 102, 102, 115, 99, 114, 101, 101, 110, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 58, 32, 40, 95, 99, 32, 61, 32, 40, 95, 98, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 32, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 46, 108, 111, 97, 100, 40, 41, 46, 116, 104, 101, 110, 40, 40, 109, 111, 100, 117, 108, 101, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 44, 32, 95, 98, 50, 44, 32, 95, 99, 50, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 44, 32, 95, 103, 44, 32, 95, 104, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 32, 109, 111, 100, 117, 108, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 32, 110, 101, 119, 32, 109, 111, 100, 117, 108, 101, 46, 68, 111, 116, 76, 111, 116, 116, 105, 101, 80, 108, 97, 121, 101, 114, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 101, 109, 101, 73, 100, 58, 32, 40, 95, 97, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 116, 104, 101, 109, 101, 73, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 50, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 40, 95, 98, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 50, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 48, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 95, 99, 50, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 108, 111, 111, 112, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 50, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 40, 95, 100, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 111, 100, 101, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 40, 95, 101, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 101, 103, 109, 101, 110, 116, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 101, 32, 58, 32, 91, 93, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 40, 95, 102, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 102, 32, 58, 32, 49, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 95, 103, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 103, 32, 58, 32, 116, 114, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 40, 95, 104, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 97, 114, 107, 101, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 104, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 32, 63, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 44, 32, 109, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 44, 32, 109, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 109, 111, 100, 117, 108, 101, 46, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 76, 97, 121, 111, 117, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 97, 100, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 46, 99, 97, 116, 99, 104, 40, 40, 101, 114, 114, 111, 114, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 119, 97, 115, 109, 32, 109, 111, 100, 117, 108, 101, 58, 32, 36, 123, 101, 114, 114, 111, 114, 125, 96, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 85, 112, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 76, 101, 97, 118, 101, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 109, 101, 115, 115, 97, 103, 101, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 102, 101, 116, 99, 104, 68, 97, 116, 97, 40, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 95, 95, 97, 115, 121, 110, 99, 40, 116, 104, 105, 115, 44, 32, 110, 117, 108, 108, 44, 32, 102, 117, 110, 99, 116, 105, 111, 110, 42, 32, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 121, 105, 101, 108, 100, 32, 102, 101, 116, 99, 104, 40, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 114, 101, 115, 112, 111, 110, 115, 101, 46, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 102, 101, 116, 99, 104, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 32, 102, 114, 111, 109, 32, 85, 82, 76, 58, 32, 36, 123, 115, 114, 99, 125, 46, 32, 36, 123, 114, 101, 115, 112, 111, 110, 115, 101, 46, 115, 116, 97, 116, 117, 115, 125, 58, 32, 36, 123, 114, 101, 115, 112, 111, 110, 115, 101, 46, 115, 116, 97, 116, 117, 115, 84, 101, 120, 116, 125, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 97, 116, 97, 32, 61, 32, 121, 105, 101, 108, 100, 32, 114, 101, 115, 112, 111, 110, 115, 101, 46, 97, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 100, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 101, 119, 32, 84, 101, 120, 116, 68, 101, 99, 111, 100, 101, 114, 40, 41, 46, 100, 101, 99, 111, 100, 101, 40, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 32, 61, 61, 61, 32, 34, 115, 116, 114, 105, 110, 103, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 115, 116, 114, 105, 110, 103, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 115, 116, 114, 105, 110, 103, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 68, 97, 116, 97, 40, 100, 97, 116, 97, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 100, 97, 116, 97, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 68, 111, 116, 76, 111, 116, 116, 105, 101, 68, 97, 116, 97, 40, 100, 97, 116, 97, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 32, 61, 61, 61, 32, 34, 111, 98, 106, 101, 99, 116, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 115, 76, 111, 116, 116, 105, 101, 40, 100, 97, 116, 97, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 34, 73, 110, 118, 97, 108, 105, 100, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 111, 98, 106, 101, 99, 116, 58, 32, 84, 104, 101, 32, 112, 114, 111, 118, 105, 100, 101, 100, 32, 111, 98, 106, 101, 99, 116, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 99, 111, 110, 102, 111, 114, 109, 32, 116, 111, 32, 116, 104, 101, 32, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 32, 102, 111, 114, 109, 97, 116, 46, 34, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 68, 97, 116, 97, 40, 74, 83, 79, 78, 46, 115, 116, 114, 105, 110, 103, 105, 102, 121, 40, 100, 97, 116, 97, 41, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 96, 85, 110, 115, 117, 112, 112, 111, 114, 116, 101, 100, 32, 100, 97, 116, 97, 32, 116, 121, 112, 101, 32, 102, 111, 114, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 46, 32, 69, 120, 112, 101, 99, 116, 101, 100, 58, 32, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 115, 116, 114, 105, 110, 103, 32, 40, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 65, 114, 114, 97, 121, 66, 117, 102, 102, 101, 114, 32, 40, 100, 111, 116, 76, 111, 116, 116, 105, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 45, 32, 111, 98, 106, 101, 99, 116, 32, 40, 76, 111, 116, 116, 105, 101, 32, 74, 83, 79, 78, 41, 46, 32, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 82, 101, 99, 101, 105, 118, 101, 100, 58, 32, 36, 123, 116, 121, 112, 101, 111, 102, 32, 100, 97, 116, 97, 125, 96, 10, 32, 32, 32, 32, 32, 32, 32, 32, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 108, 97, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 111, 108, 101, 46, 101, 114, 114, 111, 114, 40, 34, 115, 111, 109, 101, 116, 104, 105, 110, 103, 32, 119, 101, 110, 116, 32, 119, 114, 111, 110, 103, 44, 32, 116, 104, 101, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 119, 97, 115, 32, 115, 117, 112, 112, 111, 115, 101, 32, 116, 111, 32, 97, 117, 116, 111, 112, 108, 97, 121, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 82, 101, 115, 105, 122, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 34, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 34, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 101, 116, 99, 104, 68, 97, 116, 97, 40, 115, 114, 99, 41, 46, 116, 104, 101, 110, 40, 40, 100, 97, 116, 97, 41, 32, 61, 62, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 100, 97, 116, 97, 41, 41, 46, 99, 97, 116, 99, 104, 40, 40, 101, 114, 114, 111, 114, 41, 32, 61, 62, 32, 116, 104, 105, 115, 46, 95, 100, 105, 115, 112, 97, 116, 99, 104, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 108, 111, 97, 100, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 100, 97, 116, 97, 32, 102, 114, 111, 109, 32, 85, 82, 76, 58, 32, 36, 123, 115, 114, 99, 125, 46, 32, 36, 123, 101, 114, 114, 111, 114, 125, 96, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 97, 121, 111, 117, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 97, 121, 111, 117, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 97, 121, 111, 117, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 91, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 46, 103, 101, 116, 40, 48, 41, 44, 32, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 46, 103, 101, 116, 40, 49, 41, 93, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 40, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 50, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 115, 119, 105, 116, 99, 104, 32, 40, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 97, 50, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 50, 46, 70, 105, 116, 46, 67, 111, 110, 116, 97, 105, 110, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 98, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 70, 105, 116, 46, 67, 111, 118, 101, 114, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 118, 101, 114, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 99, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 70, 105, 116, 46, 70, 105, 108, 108, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 108, 108, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 100, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 100, 46, 70, 105, 116, 46, 70, 105, 116, 72, 101, 105, 103, 104, 116, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 116, 45, 104, 101, 105, 103, 104, 116, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 101, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 101, 46, 70, 105, 116, 46, 70, 105, 116, 87, 105, 100, 116, 104, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 105, 116, 45, 119, 105, 100, 116, 104, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 97, 115, 101, 32, 40, 40, 95, 102, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 102, 46, 70, 105, 116, 46, 78, 111, 110, 101, 41, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 110, 111, 110, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 102, 97, 117, 108, 116, 58, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 99, 111, 110, 116, 97, 105, 110, 34, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 97, 114, 107, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 109, 97, 110, 105, 102, 101, 115, 116, 83, 116, 114, 105, 110, 103, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 33, 109, 97, 110, 105, 102, 101, 115, 116, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 32, 61, 32, 74, 83, 79, 78, 46, 112, 97, 114, 115, 101, 40, 109, 97, 110, 105, 102, 101, 115, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 79, 98, 106, 101, 99, 116, 46, 107, 101, 121, 115, 40, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 41, 46, 108, 101, 110, 103, 116, 104, 32, 61, 61, 61, 32, 48, 41, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 109, 97, 110, 105, 102, 101, 115, 116, 74, 115, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 95, 101, 114, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 101, 103, 109, 101, 110, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 101, 103, 109, 101, 110, 116, 32, 38, 38, 32, 115, 101, 103, 109, 101, 110, 116, 46, 115, 105, 122, 101, 40, 41, 32, 61, 61, 61, 32, 50, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 115, 101, 103, 109, 101, 110, 116, 46, 103, 101, 116, 40, 48, 41, 44, 32, 115, 101, 103, 109, 101, 110, 116, 46, 103, 101, 116, 40, 49, 41, 93, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 111, 111, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 109, 111, 100, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 101, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 109, 111, 100, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 98, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 98, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 114, 101, 118, 101, 114, 115, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 99, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 77, 111, 100, 101, 46, 66, 111, 117, 110, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 98, 111, 117, 110, 99, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 109, 111, 100, 101, 32, 61, 61, 61, 32, 40, 40, 95, 100, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 100, 46, 77, 111, 100, 101, 46, 82, 101, 118, 101, 114, 115, 101, 66, 111, 117, 110, 99, 101, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 114, 101, 118, 101, 114, 115, 101, 45, 98, 111, 117, 110, 99, 101, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 70, 114, 111, 122, 101, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 32, 58, 32, 34, 34, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 97, 117, 116, 111, 112, 108, 97, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 112, 101, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 82, 101, 97, 100, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 33, 61, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 76, 111, 97, 100, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 76, 111, 97, 100, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 105, 115, 83, 116, 111, 112, 112, 101, 100, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 105, 115, 83, 116, 111, 112, 112, 101, 100, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 100, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 117, 114, 97, 116, 105, 111, 110, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 32, 99, 97, 110, 118, 97, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 44, 32, 95, 101, 44, 32, 95, 102, 44, 32, 95, 103, 44, 32, 95, 104, 44, 32, 95, 105, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 101, 109, 101, 73, 100, 58, 32, 40, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 116, 104, 101, 109, 101, 73, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 97, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 40, 95, 98, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 112, 108, 97, 121, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 48, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 95, 99, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 108, 111, 111, 112, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 99, 32, 58, 32, 102, 97, 108, 115, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 40, 95, 100, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 111, 100, 101, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 34, 102, 111, 114, 119, 97, 114, 100, 34, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 40, 95, 101, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 101, 103, 109, 101, 110, 116, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 101, 32, 58, 32, 91, 93, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 40, 95, 102, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 115, 112, 101, 101, 100, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 102, 32, 58, 32, 49, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 95, 103, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 103, 32, 58, 32, 116, 114, 117, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 40, 95, 104, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 109, 97, 114, 107, 101, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 104, 32, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 32, 63, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 99, 111, 110, 102, 105, 103, 46, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 58, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 46, 99, 114, 101, 97, 116, 101, 68, 101, 102, 97, 117, 108, 116, 76, 97, 121, 111, 117, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 68, 97, 116, 97, 40, 99, 111, 110, 102, 105, 103, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 105, 102, 32, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 108, 111, 97, 100, 70, 114, 111, 109, 83, 114, 99, 40, 99, 111, 110, 102, 105, 103, 46, 115, 114, 99, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 40, 95, 105, 32, 61, 32, 99, 111, 110, 102, 105, 103, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 105, 32, 58, 32, 34, 34, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 114, 101, 110, 100, 101, 114, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 114, 101, 110, 100, 101, 114, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 117, 102, 102, 101, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 98, 117, 102, 102, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 32, 61, 32, 110, 101, 119, 32, 85, 105, 110, 116, 56, 67, 108, 97, 109, 112, 101, 100, 65, 114, 114, 97, 121, 40, 98, 117, 102, 102, 101, 114, 44, 32, 48, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 42, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 42, 32, 52, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 101, 116, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 73, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 61, 61, 32, 34, 117, 110, 100, 101, 102, 105, 110, 101, 100, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 46, 99, 114, 101, 97, 116, 101, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 46, 100, 97, 116, 97, 46, 115, 101, 116, 40, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 109, 97, 103, 101, 68, 97, 116, 97, 32, 61, 32, 110, 101, 119, 32, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 99, 108, 97, 109, 112, 101, 100, 66, 117, 102, 102, 101, 114, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 46, 112, 117, 116, 73, 109, 97, 103, 101, 68, 97, 116, 97, 40, 105, 109, 97, 103, 101, 68, 97, 116, 97, 44, 32, 48, 44, 32, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 114, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 100, 114, 97, 119, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 110, 101, 120, 116, 70, 114, 97, 109, 101, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 113, 117, 101, 115, 116, 70, 114, 97, 109, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 112, 100, 97, 116, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 70, 114, 97, 109, 101, 40, 110, 101, 120, 116, 70, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 117, 112, 100, 97, 116, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 114, 101, 110, 100, 101, 114, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 67, 111, 109, 112, 108, 101, 116, 101, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 46, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 67, 111, 117, 110, 116, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 111, 112, 67, 111, 117, 110, 116, 40, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 99, 111, 109, 112, 108, 101, 116, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 108, 97, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 108, 97, 121, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 38, 38, 32, 33, 105, 115, 69, 108, 101, 109, 101, 110, 116, 73, 110, 86, 105, 101, 119, 112, 111, 114, 116, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 112, 97, 117, 115, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 105, 115, 80, 97, 117, 115, 101, 100, 40, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 112, 97, 117, 115, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 111, 112, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 115, 116, 111, 112, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 70, 114, 97, 109, 101, 40, 102, 114, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 102, 114, 97, 109, 101, 32, 60, 32, 48, 32, 124, 124, 32, 102, 114, 97, 109, 101, 32, 62, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 40, 41, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 101, 107, 40, 102, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 97, 109, 101, 34, 44, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 40, 41, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 112, 101, 101, 100, 40, 115, 112, 101, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 99, 111, 108, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 115, 116, 121, 108, 101, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 99, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 104, 101, 120, 83, 116, 114, 105, 110, 103, 84, 111, 82, 71, 66, 65, 73, 110, 116, 40, 99, 111, 108, 111, 114, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 99, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 76, 111, 111, 112, 40, 108, 111, 111, 112, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 108, 111, 111, 112, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 116, 121, 112, 101, 44, 32, 108, 105, 115, 116, 101, 110, 101, 114, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 100, 101, 108, 101, 116, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 111, 110, 116, 101, 120, 116, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 100, 101, 115, 116, 114, 111, 121, 34, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 109, 111, 118, 101, 65, 108, 108, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 99, 97, 110, 99, 101, 108, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 110, 117, 108, 108, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 116, 114, 117, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 102, 114, 101, 101, 122, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 33, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 97, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 73, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 102, 114, 97, 109, 101, 77, 97, 110, 97, 103, 101, 114, 46, 114, 101, 113, 117, 101, 115, 116, 65, 110, 105, 109, 97, 116, 105, 111, 110, 70, 114, 97, 109, 101, 40, 116, 104, 105, 115, 46, 95, 100, 114, 97, 119, 46, 98, 105, 110, 100, 40, 116, 104, 105, 115, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 32, 61, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 117, 110, 102, 114, 101, 101, 122, 101, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 115, 105, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 124, 124, 32, 33, 116, 104, 105, 115, 46, 105, 115, 76, 111, 97, 100, 101, 100, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 112, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 104, 101, 105, 103, 104, 116, 58, 32, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 44, 32, 119, 105, 100, 116, 104, 58, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 99, 108, 105, 101, 110, 116, 87, 105, 100, 116, 104, 32, 42, 32, 100, 112, 114, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 99, 108, 105, 101, 110, 116, 72, 101, 105, 103, 104, 116, 32, 42, 32, 100, 112, 114, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 111, 107, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 115, 105, 122, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 111, 107, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 40, 115, 116, 97, 114, 116, 70, 114, 97, 109, 101, 44, 32, 101, 110, 100, 70, 114, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 83, 101, 103, 109, 101, 110, 116, 40, 91, 115, 116, 97, 114, 116, 70, 114, 97, 109, 101, 44, 32, 101, 110, 100, 70, 114, 97, 109, 101, 93, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 77, 111, 100, 101, 40, 109, 111, 100, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 77, 111, 100, 101, 40, 109, 111, 100, 101, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 99, 111, 110, 102, 105, 103, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 95, 97, 32, 61, 32, 99, 111, 110, 102, 105, 103, 44, 32, 123, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 44, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 125, 32, 61, 32, 95, 97, 44, 32, 114, 101, 115, 116, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 111, 98, 106, 82, 101, 115, 116, 40, 95, 97, 44, 32, 91, 34, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 34, 44, 32, 34, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 34, 93, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 44, 32, 114, 101, 115, 116, 67, 111, 110, 102, 105, 103, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 47, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 105, 115, 32, 97, 32, 115, 112, 101, 99, 105, 97, 108, 32, 99, 97, 115, 101, 44, 32, 105, 116, 32, 115, 104, 111, 117, 108, 100, 32, 98, 101, 32, 115, 101, 116, 32, 116, 111, 32, 116, 104, 101, 32, 100, 101, 102, 97, 117, 108, 116, 32, 118, 97, 108, 117, 101, 32, 105, 102, 32, 105, 116, 39, 115, 32, 110, 111, 116, 32, 112, 114, 111, 118, 105, 100, 101, 100, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 58, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 103, 101, 116, 68, 101, 102, 97, 117, 108, 116, 68, 80, 82, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 58, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 32, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 97, 117, 116, 111, 82, 101, 115, 105, 122, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 67, 97, 110, 118, 97, 115, 82, 101, 115, 105, 122, 101, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 102, 114, 101, 101, 122, 101, 79, 110, 79, 102, 102, 115, 99, 114, 101, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 44, 32, 116, 104, 105, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 79, 102, 102, 115, 99, 114, 101, 101, 110, 79, 98, 115, 101, 114, 118, 101, 114, 46, 117, 110, 111, 98, 115, 101, 114, 118, 101, 40, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 105, 115, 70, 114, 111, 122, 101, 110, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 40, 41, 32, 61, 61, 61, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 44, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 34, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 101, 118, 101, 110, 116, 77, 97, 110, 97, 103, 101, 114, 46, 100, 105, 115, 112, 97, 116, 99, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 121, 112, 101, 58, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 70, 97, 105, 108, 101, 100, 32, 116, 111, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 32, 58, 36, 123, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 125, 96, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 109, 97, 114, 107, 101, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 115, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 109, 97, 114, 107, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 109, 97, 114, 107, 101, 114, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 117, 108, 116, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 109, 97, 114, 107, 101, 114, 115, 46, 115, 105, 122, 101, 40, 41, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 109, 97, 114, 107, 101, 114, 115, 46, 103, 101, 116, 40, 105, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 46, 112, 117, 115, 104, 40, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 110, 97, 109, 101, 58, 32, 109, 97, 114, 107, 101, 114, 46, 110, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 105, 109, 101, 58, 32, 109, 97, 114, 107, 101, 114, 46, 116, 105, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 100, 117, 114, 97, 116, 105, 111, 110, 58, 32, 109, 97, 114, 107, 101, 114, 46, 100, 117, 114, 97, 116, 105, 111, 110, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 114, 101, 115, 117, 108, 116, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 111, 97, 100, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 114, 101, 115, 101, 116, 84, 104, 101, 109, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 114, 101, 115, 101, 116, 84, 104, 101, 109, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 101, 100, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 111, 97, 100, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 108, 111, 116, 115, 40, 115, 108, 111, 116, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 83, 108, 111, 116, 115, 40, 115, 108, 111, 116, 115, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 32, 124, 124, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 67, 111, 110, 102, 105, 103, 40, 95, 95, 115, 112, 114, 101, 97, 100, 80, 114, 111, 112, 115, 40, 95, 95, 115, 112, 114, 101, 97, 100, 86, 97, 108, 117, 101, 115, 40, 123, 125, 44, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 99, 111, 110, 102, 105, 103, 40, 41, 41, 44, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 97, 108, 105, 103, 110, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 65, 108, 105, 103, 110, 40, 108, 97, 121, 111, 117, 116, 46, 97, 108, 105, 103, 110, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 102, 105, 116, 58, 32, 99, 114, 101, 97, 116, 101, 67, 111, 114, 101, 70, 105, 116, 40, 108, 97, 121, 111, 117, 116, 46, 102, 105, 116, 44, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 41, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 61, 61, 61, 32, 110, 117, 108, 108, 41, 32, 114, 101, 116, 117, 114, 110, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 87, 97, 115, 109, 76, 111, 97, 100, 101, 114, 46, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 114, 116, 101, 100, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 116, 97, 114, 116, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 115, 101, 116, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 116, 97, 114, 116, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 111, 112, 112, 101, 100, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 115, 116, 111, 112, 112, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 115, 116, 111, 112, 112, 101, 100, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 99, 116, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 103, 101, 116, 66, 111, 117, 110, 100, 105, 110, 103, 67, 108, 105, 101, 110, 116, 82, 101, 99, 116, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 99, 97, 108, 101, 88, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 47, 32, 114, 101, 99, 116, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 99, 97, 108, 101, 89, 32, 61, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 47, 32, 114, 101, 99, 116, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 61, 32, 116, 104, 105, 115, 46, 95, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 119, 105, 110, 100, 111, 119, 46, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 32, 124, 124, 32, 49, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 40, 101, 118, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 88, 32, 45, 32, 114, 101, 99, 116, 46, 108, 101, 102, 116, 41, 32, 42, 32, 115, 99, 97, 108, 101, 88, 32, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 40, 101, 118, 101, 110, 116, 46, 99, 108, 105, 101, 110, 116, 89, 32, 45, 32, 114, 101, 99, 116, 46, 116, 111, 112, 41, 32, 42, 32, 115, 99, 97, 108, 101, 89, 32, 47, 32, 100, 101, 118, 105, 99, 101, 80, 105, 120, 101, 108, 82, 97, 116, 105, 111, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 85, 112, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 111, 110, 80, 111, 105, 110, 116, 101, 114, 76, 101, 97, 118, 101, 40, 101, 118, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 32, 125, 32, 61, 32, 116, 104, 105, 115, 46, 95, 103, 101, 116, 80, 111, 105, 110, 116, 101, 114, 80, 111, 115, 105, 116, 105, 111, 110, 40, 101, 118, 101, 110, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 114, 101, 116, 117, 114, 110, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 70, 114, 97, 109, 101, 119, 111, 114, 107, 83, 101, 116, 117, 112, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 91, 93, 59, 10, 32, 32, 32, 32, 32, 32, 102, 111, 114, 32, 40, 108, 101, 116, 32, 105, 32, 61, 32, 48, 59, 32, 105, 32, 60, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 46, 115, 105, 122, 101, 40, 41, 59, 32, 105, 32, 43, 61, 32, 49, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 112, 117, 115, 104, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 86, 101, 99, 116, 111, 114, 46, 103, 101, 116, 40, 105, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 115, 101, 116, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 32, 33, 61, 61, 32, 110, 117, 108, 108, 32, 38, 38, 32, 116, 104, 105, 115, 46, 105, 115, 76, 111, 97, 100, 101, 100, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 105, 115, 116, 101, 110, 101, 114, 115, 32, 61, 32, 116, 104, 105, 115, 46, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 85, 112, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 117, 112, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 100, 111, 119, 110, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 109, 111, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 101, 110, 116, 101, 114, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 108, 105, 115, 116, 101, 110, 101, 114, 115, 46, 105, 110, 99, 108, 117, 100, 101, 115, 40, 34, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 34, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 108, 101, 97, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 95, 99, 108, 101, 97, 110, 117, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 73, 83, 95, 66, 82, 79, 87, 83, 69, 82, 32, 38, 38, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 32, 105, 110, 115, 116, 97, 110, 99, 101, 111, 102, 32, 72, 84, 77, 76, 67, 97, 110, 118, 97, 115, 69, 108, 101, 109, 101, 110, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 117, 112, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 85, 112, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 100, 111, 119, 110, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 109, 111, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 101, 110, 116, 101, 114, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 105, 115, 46, 95, 99, 97, 110, 118, 97, 115, 46, 114, 101, 109, 111, 118, 101, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 34, 112, 111, 105, 110, 116, 101, 114, 108, 101, 97, 118, 101, 34, 44, 32, 116, 104, 105, 115, 46, 95, 112, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 77, 101, 116, 104, 111, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 44, 32, 95, 99, 44, 32, 95, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 46, 103, 101, 116, 40, 48, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 40, 95, 100, 32, 61, 32, 40, 95, 99, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 99, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 83, 105, 122, 101, 40, 41, 46, 103, 101, 116, 40, 49, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 100, 32, 58, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 105, 100, 116, 104, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 101, 105, 103, 104, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 66, 111, 111, 108, 101, 97, 110, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 66, 111, 111, 108, 101, 97, 110, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 78, 117, 109, 101, 114, 105, 99, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 78, 117, 109, 101, 114, 105, 99, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 114, 105, 110, 103, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 115, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 83, 116, 114, 105, 110, 103, 67, 111, 110, 116, 101, 120, 116, 40, 110, 97, 109, 101, 44, 32, 118, 97, 108, 117, 101, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 102, 97, 108, 115, 101, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 47, 42, 42, 10, 32, 32, 32, 32, 32, 42, 32, 71, 101, 116, 32, 116, 104, 101, 32, 98, 111, 117, 110, 100, 115, 32, 111, 102, 32, 97, 32, 108, 97, 121, 101, 114, 32, 98, 121, 32, 105, 116, 115, 32, 110, 97, 109, 101, 10, 32, 32, 32, 32, 32, 42, 32, 64, 112, 97, 114, 97, 109, 32, 108, 97, 121, 101, 114, 78, 97, 109, 101, 32, 45, 32, 84, 104, 101, 32, 110, 97, 109, 101, 32, 111, 102, 32, 116, 104, 101, 32, 108, 97, 121, 101, 114, 10, 32, 32, 32, 32, 32, 42, 32, 64, 114, 101, 116, 117, 114, 110, 115, 32, 84, 104, 101, 32, 98, 111, 117, 110, 100, 115, 32, 111, 102, 32, 116, 104, 101, 32, 108, 97, 121, 101, 114, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 64, 101, 120, 97, 109, 112, 108, 101, 10, 32, 32, 32, 32, 32, 42, 32, 96, 96, 96, 116, 121, 112, 101, 115, 99, 114, 105, 112, 116, 10, 32, 32, 32, 32, 32, 42, 32, 47, 47, 32, 68, 114, 97, 119, 32, 97, 32, 114, 101, 99, 116, 97, 110, 103, 108, 101, 32, 97, 114, 111, 117, 110, 100, 32, 116, 104, 101, 32, 108, 97, 121, 101, 114, 32, 39, 76, 97, 121, 101, 114, 32, 49, 39, 10, 32, 32, 32, 32, 32, 42, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 39, 114, 101, 110, 100, 101, 114, 39, 44, 32, 40, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 111, 117, 110, 100, 105, 110, 103, 66, 111, 120, 32, 61, 32, 100, 111, 116, 76, 111, 116, 116, 105, 101, 46, 103, 101, 116, 76, 97, 121, 101, 114, 66, 111, 117, 110, 100, 105, 110, 103, 66, 111, 120, 40, 39, 76, 97, 121, 101, 114, 32, 49, 39, 41, 59, 10, 32, 32, 32, 32, 32, 42, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 105, 102, 32, 40, 98, 111, 117, 110, 100, 105, 110, 103, 66, 111, 120, 41, 32, 123, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 123, 32, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 32, 125, 32, 61, 32, 98, 111, 117, 110, 100, 105, 110, 103, 66, 111, 120, 59, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 32, 32, 99, 111, 110, 116, 101, 120, 116, 46, 115, 116, 114, 111, 107, 101, 82, 101, 99, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 32, 42, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 42, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 42, 32, 96, 96, 96, 10, 32, 32, 32, 32, 32, 42, 47, 10, 32, 32, 32, 32, 103, 101, 116, 76, 97, 121, 101, 114, 66, 111, 117, 110, 100, 105, 110, 103, 66, 111, 120, 40, 108, 97, 121, 101, 114, 78, 97, 109, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 111, 117, 110, 100, 115, 32, 61, 32, 40, 95, 97, 32, 61, 32, 116, 104, 105, 115, 46, 95, 100, 111, 116, 76, 111, 116, 116, 105, 101, 67, 111, 114, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 103, 101, 116, 76, 97, 121, 101, 114, 66, 111, 117, 110, 100, 115, 40, 108, 97, 121, 101, 114, 78, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 98, 111, 117, 110, 100, 115, 41, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 98, 111, 117, 110, 100, 115, 46, 115, 105, 122, 101, 40, 41, 32, 33, 61, 61, 32, 52, 41, 32, 114, 101, 116, 117, 114, 110, 32, 118, 111, 105, 100, 32, 48, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 98, 111, 117, 110, 100, 115, 46, 103, 101, 116, 40, 48, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 98, 111, 117, 110, 100, 115, 46, 103, 101, 116, 40, 49, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 98, 111, 117, 110, 100, 115, 46, 103, 101, 116, 40, 50, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 98, 111, 117, 110, 100, 115, 46, 103, 101, 116, 40, 51, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 120, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 119, 105, 100, 116, 104, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 104, 101, 105, 103, 104, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 115, 116, 97, 116, 105, 99, 32, 116, 114, 97, 110, 115, 102, 111, 114, 109, 84, 104, 101, 109, 101, 84, 111, 76, 111, 116, 116, 105, 101, 83, 108, 111, 116, 115, 40, 116, 104, 101, 109, 101, 44, 32, 115, 108, 111, 116, 115, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 118, 97, 114, 32, 95, 97, 44, 32, 95, 98, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 40, 95, 98, 32, 61, 32, 40, 95, 97, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 41, 32, 61, 61, 32, 110, 117, 108, 108, 32, 63, 32, 118, 111, 105, 100, 32, 48, 32, 58, 32, 95, 97, 46, 116, 114, 97, 110, 115, 102, 111, 114, 109, 84, 104, 101, 109, 101, 84, 111, 76, 111, 116, 116, 105, 101, 83, 108, 111, 116, 115, 40, 116, 104, 101, 109, 101, 44, 32, 115, 108, 111, 116, 115, 41, 41, 32, 33, 61, 32, 110, 117, 108, 108, 32, 63, 32, 95, 98, 32, 58, 32, 34, 34, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 95, 95, 112, 117, 98, 108, 105, 99, 70, 105, 101, 108, 100, 40, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 44, 32, 34, 95, 119, 97, 115, 109, 77, 111, 100, 117, 108, 101, 34, 44, 32, 110, 117, 108, 108, 41, 59, 10, 32, 32, 118, 97, 114, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 32, 61, 32, 95, 68, 111, 116, 76, 111, 116, 116, 105, 101, 59, 10, 10, 32, 32, 47, 47, 32, 115, 114, 99, 47, 119, 111, 114, 107, 101, 114, 47, 100, 111, 116, 108, 111, 116, 116, 105, 101, 46, 119, 111, 114, 107, 101, 114, 46, 116, 115, 10, 32, 32, 118, 97, 114, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 32, 61, 32, 47, 42, 32, 64, 95, 95, 80, 85, 82, 69, 95, 95, 32, 42, 47, 32, 110, 101, 119, 32, 77, 97, 112, 40, 41, 59, 10, 32, 32, 118, 97, 114, 32, 101, 118, 101, 110, 116, 72, 97, 110, 100, 108, 101, 114, 77, 97, 112, 32, 61, 32, 123, 10, 32, 32, 32, 32, 114, 101, 97, 100, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 97, 100, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 99, 111, 109, 112, 108, 101, 116, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 67, 111, 109, 112, 108, 101, 116, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 97, 100, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 97, 100, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 97, 100, 69, 114, 114, 111, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 111, 112, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 111, 112, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 76, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 108, 111, 111, 112, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 108, 97, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 108, 97, 121, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 80, 108, 97, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 112, 108, 97, 121, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 112, 97, 117, 115, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 80, 97, 117, 115, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 112, 97, 117, 115, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 111, 112, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 83, 116, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 115, 116, 111, 112, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 97, 109, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 97, 109, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 70, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 102, 114, 97, 109, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 82, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 114, 101, 110, 100, 101, 114, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 70, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 110, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 85, 110, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 117, 110, 102, 114, 101, 101, 122, 101, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 58, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 32, 61, 62, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 100, 101, 115, 116, 114, 111, 121, 69, 118, 101, 110, 116, 32, 61, 32, 101, 118, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 34, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 34, 111, 110, 68, 101, 115, 116, 114, 111, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 58, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 58, 32, 100, 101, 115, 116, 114, 111, 121, 69, 118, 101, 110, 116, 10, 32, 32, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 99, 111, 109, 109, 97, 110, 100, 115, 32, 61, 32, 123, 10, 32, 32, 32, 32, 103, 101, 116, 68, 111, 116, 76, 111, 116, 116, 105, 101, 73, 110, 115, 116, 97, 110, 99, 101, 83, 116, 97, 116, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 76, 111, 97, 100, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 76, 111, 97, 100, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 80, 97, 117, 115, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 80, 97, 117, 115, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 80, 108, 97, 121, 105, 110, 103, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 80, 108, 97, 121, 105, 110, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 83, 116, 111, 112, 112, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 83, 116, 111, 112, 112, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 70, 114, 111, 122, 101, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 70, 114, 111, 122, 101, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 111, 111, 112, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 111, 112, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 111, 100, 101, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 111, 100, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 112, 101, 101, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 112, 101, 101, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 117, 114, 114, 101, 110, 116, 70, 114, 97, 109, 101, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 116, 111, 116, 97, 108, 70, 114, 97, 109, 101, 115, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 100, 117, 114, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 100, 117, 114, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 114, 107, 101, 114, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 114, 107, 101, 114, 115, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 114, 107, 101, 114, 115, 40, 41, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 99, 116, 105, 118, 101, 65, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 99, 116, 105, 118, 101, 84, 104, 101, 109, 101, 73, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 97, 117, 116, 111, 112, 108, 97, 121, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 117, 116, 111, 112, 108, 97, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 103, 109, 101, 110, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 108, 97, 121, 111, 117, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 97, 121, 111, 117, 116, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 103, 109, 101, 110, 116, 68, 117, 114, 97, 116, 105, 111, 110, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 115, 82, 101, 97, 100, 121, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 105, 115, 82, 101, 97, 100, 121, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 97, 110, 105, 102, 101, 115, 116, 58, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 109, 97, 110, 105, 102, 101, 115, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 116, 97, 116, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 97, 121, 111, 117, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 108, 97, 121, 111, 117, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 76, 97, 121, 111, 117, 116, 40, 108, 97, 121, 111, 117, 116, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 103, 101, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 76, 105, 115, 116, 101, 110, 101, 114, 115, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 68, 111, 119, 110, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 110, 116, 101, 114, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 69, 120, 105, 116, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 77, 111, 118, 101, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 111, 115, 116, 80, 111, 105, 110, 116, 101, 114, 85, 112, 69, 118, 101, 110, 116, 40, 120, 44, 32, 121, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 97, 114, 116, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 111, 112, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 83, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 40, 115, 116, 97, 116, 101, 77, 97, 99, 104, 105, 110, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 99, 114, 101, 97, 116, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 104, 97, 115, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 97, 108, 114, 101, 97, 100, 121, 32, 101, 120, 105, 115, 116, 115, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 110, 101, 119, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 40, 99, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 115, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 44, 32, 105, 110, 115, 116, 97, 110, 99, 101, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 118, 101, 110, 116, 115, 32, 61, 32, 91, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 99, 111, 109, 112, 108, 101, 116, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 102, 114, 97, 109, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 97, 100, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 97, 100, 69, 114, 114, 111, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 108, 111, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 112, 97, 117, 115, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 112, 108, 97, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 115, 116, 111, 112, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 100, 101, 115, 116, 114, 111, 121, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 117, 110, 102, 114, 101, 101, 122, 101, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 110, 100, 101, 114, 34, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 34, 114, 101, 97, 100, 121, 34, 10, 32, 32, 32, 32, 32, 32, 93, 59, 10, 32, 32, 32, 32, 32, 32, 101, 118, 101, 110, 116, 115, 46, 102, 111, 114, 69, 97, 99, 104, 40, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 97, 100, 100, 69, 118, 101, 110, 116, 76, 105, 115, 116, 101, 110, 101, 114, 40, 101, 118, 101, 110, 116, 44, 32, 101, 118, 101, 110, 116, 72, 97, 110, 100, 108, 101, 114, 77, 97, 112, 91, 101, 118, 101, 110, 116, 93, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 100, 101, 115, 116, 114, 111, 121, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 114, 101, 116, 117, 114, 110, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 100, 101, 115, 116, 114, 111, 121, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 100, 101, 108, 101, 116, 101, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 102, 114, 101, 101, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 99, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 99, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 40, 99, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 108, 111, 97, 100, 65, 110, 105, 109, 97, 116, 105, 111, 110, 40, 97, 110, 105, 109, 97, 116, 105, 111, 110, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 104, 101, 109, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 116, 104, 101, 109, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 40, 116, 104, 101, 109, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 116, 104, 101, 109, 101, 68, 97, 116, 97, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 116, 104, 101, 109, 101, 68, 97, 116, 97, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 84, 104, 101, 109, 101, 68, 97, 116, 97, 40, 116, 104, 101, 109, 101, 68, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 97, 117, 115, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 97, 117, 115, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 112, 108, 97, 121, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 112, 108, 97, 121, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 114, 101, 115, 105, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 104, 101, 105, 103, 104, 116, 32, 61, 32, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 99, 97, 110, 118, 97, 115, 46, 119, 105, 100, 116, 104, 32, 61, 32, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 114, 101, 115, 105, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 66, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 40, 98, 97, 99, 107, 103, 114, 111, 117, 110, 100, 67, 111, 108, 111, 114, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 70, 114, 97, 109, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 102, 114, 97, 109, 101, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 102, 114, 97, 109, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 70, 114, 97, 109, 101, 40, 102, 114, 97, 109, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 77, 111, 100, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 111, 100, 101, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 109, 111, 100, 101, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 77, 111, 100, 101, 40, 109, 111, 100, 101, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 82, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 40, 114, 101, 110, 100, 101, 114, 67, 111, 110, 102, 105, 103, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 101, 103, 109, 101, 110, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 101, 103, 109, 101, 110, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 83, 101, 103, 109, 101, 110, 116, 40, 115, 101, 103, 109, 101, 110, 116, 91, 48, 93, 44, 32, 115, 101, 103, 109, 101, 110, 116, 91, 49, 93, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 83, 112, 101, 101, 100, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 115, 112, 101, 101, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 115, 112, 101, 101, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 83, 112, 101, 101, 100, 40, 115, 112, 101, 101, 100, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 85, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 40, 117, 115, 101, 70, 114, 97, 109, 101, 73, 110, 116, 101, 114, 112, 111, 108, 97, 116, 105, 111, 110, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 68, 111, 116, 76, 111, 116, 116, 105, 101, 46, 115, 101, 116, 87, 97, 115, 109, 85, 114, 108, 40, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 117, 114, 108, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 116, 111, 112, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 116, 111, 112, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 117, 110, 102, 114, 101, 101, 122, 101, 58, 32, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 117, 110, 102, 114, 101, 101, 122, 101, 40, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 120, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 120, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 121, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 121, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 119, 105, 100, 116, 104, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 119, 105, 100, 116, 104, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 104, 101, 105, 103, 104, 116, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 104, 101, 105, 103, 104, 116, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 86, 105, 101, 119, 112, 111, 114, 116, 40, 120, 44, 32, 121, 44, 32, 119, 105, 100, 116, 104, 44, 32, 104, 101, 105, 103, 104, 116, 41, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 97, 114, 107, 101, 114, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 109, 97, 114, 107, 101, 114, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 77, 97, 114, 107, 101, 114, 40, 109, 97, 114, 107, 101, 114, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 44, 10, 32, 32, 32, 32, 115, 101, 116, 76, 111, 111, 112, 40, 114, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 108, 111, 111, 112, 32, 61, 32, 114, 101, 113, 117, 101, 115, 116, 46, 112, 97, 114, 97, 109, 115, 46, 108, 111, 111, 112, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 105, 110, 115, 116, 97, 110, 99, 101, 32, 61, 32, 105, 110, 115, 116, 97, 110, 99, 101, 115, 77, 97, 112, 46, 103, 101, 116, 40, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 41, 59, 10, 32, 32, 32, 32, 32, 32, 105, 102, 32, 40, 33, 105, 110, 115, 116, 97, 110, 99, 101, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 73, 110, 115, 116, 97, 110, 99, 101, 32, 119, 105, 116, 104, 32, 105, 100, 32, 36, 123, 105, 110, 115, 116, 97, 110, 99, 101, 73, 100, 125, 32, 100, 111, 101, 115, 32, 110, 111, 116, 32, 101, 120, 105, 115, 116, 46, 96, 41, 59, 10, 32, 32, 32, 32, 32, 32, 125, 10, 32, 32, 32, 32, 32, 32, 105, 110, 115, 116, 97, 110, 99, 101, 46, 115, 101, 116, 76, 111, 111, 112, 40, 108, 111, 111, 112, 41, 59, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 115, 117, 99, 99, 101, 115, 115, 58, 32, 116, 114, 117, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 102, 117, 110, 99, 116, 105, 111, 110, 32, 101, 120, 101, 99, 117, 116, 101, 67, 111, 109, 109, 97, 110, 100, 40, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 41, 32, 123, 10, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 109, 101, 116, 104, 111, 100, 32, 61, 32, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 46, 109, 101, 116, 104, 111, 100, 59, 10, 32, 32, 32, 32, 105, 102, 32, 40, 116, 121, 112, 101, 111, 102, 32, 99, 111, 109, 109, 97, 110, 100, 115, 91, 109, 101, 116, 104, 111, 100, 93, 32, 61, 61, 61, 32, 34, 102, 117, 110, 99, 116, 105, 111, 110, 34, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 114, 101, 116, 117, 114, 110, 32, 99, 111, 109, 109, 97, 110, 100, 115, 91, 109, 101, 116, 104, 111, 100, 93, 40, 114, 112, 99, 82, 101, 113, 117, 101, 115, 116, 41, 59, 10, 32, 32, 32, 32, 125, 32, 101, 108, 115, 101, 32, 123, 10, 32, 32, 32, 32, 32, 32, 116, 104, 114, 111, 119, 32, 110, 101, 119, 32, 69, 114, 114, 111, 114, 40, 96, 77, 101, 116, 104, 111, 100, 32, 36, 123, 109, 101, 116, 104, 111, 100, 125, 32, 105, 115, 32, 110, 111, 116, 32, 105, 109, 112, 108, 101, 109, 101, 110, 116, 101, 100, 32, 105, 110, 32, 99, 111, 109, 109, 97, 110, 100, 115, 46, 96, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 10, 32, 32, 115, 101, 108, 102, 46, 111, 110, 109, 101, 115, 115, 97, 103, 101, 32, 61, 32, 40, 101, 118, 101, 110, 116, 41, 32, 61, 62, 32, 123, 10, 32, 32, 32, 32, 116, 114, 121, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 117, 108, 116, 32, 61, 32, 101, 120, 101, 99, 117, 116, 101, 67, 111, 109, 109, 97, 110, 100, 40, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 41, 59, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 114, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 105, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 109, 101, 116, 104, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 114, 101, 115, 117, 108, 116, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 114, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 32, 99, 97, 116, 99, 104, 32, 40, 101, 114, 114, 111, 114, 41, 32, 123, 10, 32, 32, 32, 32, 32, 32, 99, 111, 110, 115, 116, 32, 101, 114, 114, 111, 114, 82, 101, 115, 112, 111, 110, 115, 101, 32, 61, 32, 123, 10, 32, 32, 32, 32, 32, 32, 32, 32, 105, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 105, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 109, 101, 116, 104, 111, 100, 58, 32, 101, 118, 101, 110, 116, 46, 100, 97, 116, 97, 46, 109, 101, 116, 104, 111, 100, 44, 10, 32, 32, 32, 32, 32, 32, 32, 32, 101, 114, 114, 111, 114, 58, 32, 101, 114, 114, 111, 114, 46, 109, 101, 115, 115, 97, 103, 101, 10, 32, 32, 32, 32, 32, 32, 125, 59, 10, 32, 32, 32, 32, 32, 32, 115, 101, 108, 102, 46, 112, 111, 115, 116, 77, 101, 115, 115, 97, 103, 101, 40, 101, 114, 114, 111, 114, 82, 101, 115, 112, 111, 110, 115, 101, 41, 59, 10, 32, 32, 32, 32, 125, 10, 32, 32, 125, 59, 10, 32, 32, 118, 97, 114, 32, 100, 117, 109, 109, 121, 32, 61, 32, 34, 34, 59, 10, 32, 32, 118, 97, 114, 32, 100, 111, 116, 108, 111, 116, 116, 105, 101, 95, 119, 111, 114, 107, 101, 114, 95, 100, 101, 102, 97, 117, 108, 116, 32, 61, 32, 100, 117, 109, 109, 121, 59, 10, 125, 41, 40, 41, 59, 10])], { type: "application/javascript" }), n = URL.createObjectURL(e), i = new Worker(n);
    return URL.revokeObjectURL(n), i;
  }
}, LL = ML, $L = class {
  constructor() {
    cn(this, "_workers", /* @__PURE__ */ new Map()), cn(this, "_animationWorkerMap", /* @__PURE__ */ new Map());
  }
  getWorker(e) {
    return this._workers.has(e) || this._workers.set(e, new LL()), this._workers.get(e);
  }
  assignAnimationToWorker(e, n) {
    this._animationWorkerMap.set(e, n);
  }
  unassignAnimationFromWorker(e) {
    this._animationWorkerMap.delete(e);
  }
  sendMessage(e, n, i) {
    this.getWorker(e).postMessage(n, i || []);
  }
  terminateWorker(e) {
    let n = this._workers.get(e);
    n && (n.terminate(), this._workers.delete(e));
  }
};
function A4(e, n) {
  if (e instanceof OffscreenCanvas)
    return { width: e.width, height: e.height };
  let { height: i, width: t } = e.getBoundingClientRect();
  return { width: t * n, height: i * n };
}
function O4() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var E4 = class Ps {
  constructor(n) {
    cn(this, "_eventManager", new j5()), cn(this, "_id"), cn(this, "_worker"), cn(this, "_canvas"), cn(this, "_dotLottieInstanceState", { markers: [], autoplay: !1, backgroundColor: "", currentFrame: 0, duration: 0, loop: !1, mode: "forward", segment: [0, 0], segmentDuration: 0, speed: 1, totalFrames: 0, isLoaded: !1, isPlaying: !1, isPaused: !1, isStopped: !0, isFrozen: !1, useFrameInterpolation: !1, renderConfig: { devicePixelRatio: Ts() }, activeAnimationId: "", activeThemeId: "", layout: void 0, marker: void 0, isReady: !1, manifest: null }), cn(this, "_created", !1), cn(this, "_pointerUpMethod"), cn(this, "_pointerDownMethod"), cn(this, "_pointerMoveMethod"), cn(this, "_pointerEnterMethod"), cn(this, "_pointerExitMethod");
    var i, t, a;
    this._canvas = n.canvas, this._id = `dotlottie-${O4()}`;
    let s = n.workerId || "defaultWorker";
    this._worker = Ps._workerManager.getWorker(s), Ps._workerManager.assignAnimationToWorker(this._id, s), Ps._wasmUrl && this._sendMessage("setWasmUrl", { url: Ps._wasmUrl }), this._create(vt(Bi({}, n), { renderConfig: vt(Bi({}, n.renderConfig), { devicePixelRatio: ((i = n.renderConfig) == null ? void 0 : i.devicePixelRatio) || Ts(), freezeOnOffscreen: (a = (t = n.renderConfig) == null ? void 0 : t.freezeOnOffscreen) != null ? a : !0 }) })), this._worker.addEventListener("message", this._handleWorkerEvent.bind(this)), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
  }
  _handleWorkerEvent(n) {
    return Fn(this, null, function* () {
      let i = n.data;
      i.id || (i.method === "onLoad" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event), Xi && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && ya.observe(this._canvas, this), this._dotLottieInstanceState.renderConfig.autoResize && ba.observe(this._canvas, this))), i.method === "onComplete" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onDestroy" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onUnfreeze" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._dotLottieInstanceState.isFrozen = !1, this._eventManager.dispatch(i.result.event)), i.method === "onFrame" && i.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = i.result.event.currentFrame, this._eventManager.dispatch(i.result.event)), i.method === "onRender" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event), i.method === "onFreeze" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onPause" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onPlay" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onStop" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onLoadError" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)), i.method === "onReady" && i.result.instanceId === this._id && (yield this._updateDotLottieInstanceState(), this._eventManager.dispatch(i.result.event)));
    });
  }
  _create(n) {
    return Fn(this, null, function* () {
      var i;
      let t;
      this._canvas instanceof HTMLCanvasElement ? t = this._canvas.transferControlToOffscreen() : t = this._canvas;
      let { instanceId: a } = yield this._sendMessage("create", Bi({ instanceId: this._id, config: vt(Bi({}, n), { canvas: t }) }, A4(this._canvas, ((i = n.renderConfig) == null ? void 0 : i.devicePixelRatio) || Ts())), [t]);
      if (a !== this._id)
        throw new Error("Instance ID mismatch");
      this._created = !0, yield this._updateDotLottieInstanceState();
    });
  }
  get isLoaded() {
    return this._dotLottieInstanceState.isLoaded;
  }
  get isPlaying() {
    return this._dotLottieInstanceState.isPlaying;
  }
  get isPaused() {
    return this._dotLottieInstanceState.isPaused;
  }
  get isStopped() {
    return this._dotLottieInstanceState.isStopped;
  }
  get currentFrame() {
    return this._dotLottieInstanceState.currentFrame;
  }
  get isFrozen() {
    return this._dotLottieInstanceState.isFrozen;
  }
  get segmentDuration() {
    return this._dotLottieInstanceState.segmentDuration;
  }
  get totalFrames() {
    return this._dotLottieInstanceState.totalFrames;
  }
  get segment() {
    return this._dotLottieInstanceState.segment;
  }
  get speed() {
    return this._dotLottieInstanceState.speed;
  }
  get duration() {
    return this._dotLottieInstanceState.duration;
  }
  get isReady() {
    return this._dotLottieInstanceState.isReady;
  }
  get mode() {
    return this._dotLottieInstanceState.mode;
  }
  get canvas() {
    return this._canvas;
  }
  get autoplay() {
    return this._dotLottieInstanceState.autoplay;
  }
  get backgroundColor() {
    return this._dotLottieInstanceState.backgroundColor;
  }
  get loop() {
    return this._dotLottieInstanceState.loop;
  }
  get useFrameInterpolation() {
    return this._dotLottieInstanceState.useFrameInterpolation;
  }
  get renderConfig() {
    return this._dotLottieInstanceState.renderConfig;
  }
  get manifest() {
    return this._dotLottieInstanceState.manifest;
  }
  get activeAnimationId() {
    return this._dotLottieInstanceState.activeAnimationId;
  }
  get marker() {
    return this._dotLottieInstanceState.marker;
  }
  get activeThemeId() {
    return this._dotLottieInstanceState.activeThemeId;
  }
  get layout() {
    return this._dotLottieInstanceState.layout;
  }
  play() {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("play", { instanceId: this._id }), yield this._updateDotLottieInstanceState(), Xi && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !A5(this._canvas) && (yield this.freeze()));
    });
  }
  pause() {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("pause", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  stop() {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("stop", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setSpeed(n) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("setSpeed", { instanceId: this._id, speed: n }), yield this._updateDotLottieInstanceState());
    });
  }
  setMode(n) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("setMode", { instanceId: this._id, mode: n }), yield this._updateDotLottieInstanceState());
    });
  }
  setFrame(n) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("setFrame", { frame: n, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setSegment(n, i) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("setSegment", { instanceId: this._id, segment: [n, i] }), yield this._updateDotLottieInstanceState());
    });
  }
  setRenderConfig(n) {
    return Fn(this, null, function* () {
      if (!this._created)
        return;
      let i = n, { devicePixelRatio: t, freezeOnOffscreen: a } = i, s = P5(i, ["devicePixelRatio", "freezeOnOffscreen"]);
      yield this._sendMessage("setRenderConfig", { instanceId: this._id, renderConfig: vt(Bi(Bi({}, this._dotLottieInstanceState.renderConfig), s), { devicePixelRatio: t || Ts(), freezeOnOffscreen: a != null ? a : !0 }) }), yield this._updateDotLottieInstanceState(), Xi && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.autoResize ? ba.observe(this._canvas, this) : ba.unobserve(this._canvas), this._dotLottieInstanceState.renderConfig.freezeOnOffscreen ? ya.observe(this._canvas, this) : (ya.unobserve(this._canvas), this._dotLottieInstanceState.isFrozen && (yield this.unfreeze())));
    });
  }
  setUseFrameInterpolation(n) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("setUseFrameInterpolation", { instanceId: this._id, useFrameInterpolation: n }), yield this._updateDotLottieInstanceState());
    });
  }
  setTheme(n) {
    return Fn(this, null, function* () {
      if (!this._created)
        return !1;
      let i = this._sendMessage("setTheme", { instanceId: this._id, themeId: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  load(n) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("load", { config: n, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setLoop(n) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("setLoop", { instanceId: this._id, loop: n }), yield this._updateDotLottieInstanceState());
    });
  }
  resize() {
    return Fn(this, null, function* () {
      if (!this._created)
        return;
      let { height: n, width: i } = A4(this._canvas, this._dotLottieInstanceState.renderConfig.devicePixelRatio || Ts());
      yield this._sendMessage("resize", { height: n, instanceId: this._id, width: i }), yield this._updateDotLottieInstanceState();
    });
  }
  destroy() {
    return Fn(this, null, function* () {
      this._created && (this._created = !1, yield this._sendMessage("destroy", { instanceId: this._id }), this._cleanupStateMachineListeners(), Ps._workerManager.unassignAnimationFromWorker(this._id), this._eventManager.removeAllEventListeners(), Xi && this._canvas instanceof HTMLCanvasElement && (ya.unobserve(this._canvas), ba.unobserve(this._canvas)));
    });
  }
  freeze() {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("freeze", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  unfreeze() {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("unfreeze", { instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setBackgroundColor(n) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("setBackgroundColor", { instanceId: this._id, backgroundColor: n }), yield this._updateDotLottieInstanceState());
    });
  }
  loadAnimation(n) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("loadAnimation", { animationId: n, instanceId: this._id }), yield this._updateDotLottieInstanceState());
    });
  }
  setLayout(n) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("setLayout", { instanceId: this._id, layout: n }), yield this._updateDotLottieInstanceState());
    });
  }
  _updateDotLottieInstanceState() {
    return Fn(this, null, function* () {
      if (!this._created)
        return;
      let n = yield this._sendMessage("getDotLottieInstanceState", { instanceId: this._id });
      this._dotLottieInstanceState = n.state;
    });
  }
  markers() {
    return this._dotLottieInstanceState.markers;
  }
  setMarker(n) {
    return Fn(this, null, function* () {
      this._created && (yield this._sendMessage("setMarker", { instanceId: this._id, marker: n }), yield this._updateDotLottieInstanceState());
    });
  }
  setThemeData(n) {
    return Fn(this, null, function* () {
      if (!this._created)
        return !1;
      let i = yield this._sendMessage("setThemeData", { instanceId: this._id, themeData: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  setViewport(n, i, t, a) {
    return Fn(this, null, function* () {
      return this._created ? this._sendMessage("setViewport", { x: n, y: i, width: t, height: a, instanceId: this._id }) : !1;
    });
  }
  _sendMessage(n, i, t) {
    return Fn(this, null, function* () {
      let a = { id: `dotlottie-request-${O4()}`, method: n, params: i };
      return this._worker.postMessage(a, t || []), new Promise((s, r) => {
        let o = (d) => {
          let c = d.data;
          c.id === a.id && (this._worker.removeEventListener("message", o), c.error ? r(new Error(`Failed to execute method ${n}: ${c.error}`)) : s(c.result));
        };
        this._worker.addEventListener("message", o);
      });
    });
  }
  addEventListener(n, i) {
    this._eventManager.addEventListener(n, i);
  }
  removeEventListener(n, i) {
    this._eventManager.removeEventListener(n, i);
  }
  static setWasmUrl(n) {
    Ps._wasmUrl = n;
  }
  loadStateMachine(n) {
    return Fn(this, null, function* () {
      if (!this._created)
        return !1;
      let i = yield this._sendMessage("loadStateMachine", { instanceId: this._id, stateMachineId: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  loadStateMachineData(n) {
    return Fn(this, null, function* () {
      if (!this._created)
        return !1;
      let i = yield this._sendMessage("loadStateMachineData", { instanceId: this._id, stateMachineData: n });
      return yield this._updateDotLottieInstanceState(), i;
    });
  }
  startStateMachine() {
    return Fn(this, null, function* () {
      if (!this._created)
        return !1;
      this._setupStateMachineListeners();
      let n = yield this._sendMessage("startStateMachine", { instanceId: this._id });
      return yield this._updateDotLottieInstanceState(), n;
    });
  }
  stopStateMachine() {
    return Fn(this, null, function* () {
      return this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stopStateMachine", { instanceId: this._id })) : !1;
    });
  }
  getStateMachineListeners() {
    return Fn(this, null, function* () {
      return this._created ? this._sendMessage("getStateMachineListeners", { instanceId: this._id }) : [];
    });
  }
  _getPointerPosition(n) {
    let i = this._canvas.getBoundingClientRect(), t = this._canvas.width / i.width, a = this._canvas.height / i.height, s = this._dotLottieInstanceState.renderConfig.devicePixelRatio || window.devicePixelRatio || 1, r = (n.clientX - i.left) * t / s, o = (n.clientY - i.top) * a / s;
    return { x: r, y: o };
  }
  _onPointerUp(n) {
    let { x: i, y: t } = this._getPointerPosition(n);
    this._sendMessage("postPointerUpEvent", { instanceId: this._id, x: i, y: t });
  }
  _onPointerDown(n) {
    let { x: i, y: t } = this._getPointerPosition(n);
    this._sendMessage("postPointerDownEvent", { instanceId: this._id, x: i, y: t });
  }
  _onPointerMove(n) {
    let { x: i, y: t } = this._getPointerPosition(n);
    this._sendMessage("postPointerMoveEvent", { instanceId: this._id, x: i, y: t });
  }
  _onPointerEnter(n) {
    let { x: i, y: t } = this._getPointerPosition(n);
    this._sendMessage("postPointerEnterEvent", { instanceId: this._id, x: i, y: t });
  }
  _onPointerLeave(n) {
    let { x: i, y: t } = this._getPointerPosition(n);
    this._sendMessage("postPointerExitEvent", { instanceId: this._id, x: i, y: t });
  }
  _setupStateMachineListeners() {
    return Fn(this, null, function* () {
      if (Xi && this._canvas instanceof HTMLCanvasElement && this.isLoaded) {
        let n = yield this._sendMessage("getStateMachineListeners", { instanceId: this._id });
        n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
      }
    });
  }
  _cleanupStateMachineListeners() {
    Xi && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
  }
};
cn(E4, "_workerManager", new $L()), cn(E4, "_wasmUrl", "");
function UL(e) {
  var n = e, {
    children: i,
    className: t = "",
    setCanvasRef: a,
    setContainerRef: s,
    style: r
  } = n, o = x5(n, [
    "children",
    "className",
    "setCanvasRef",
    "setContainerRef",
    "style"
  ]);
  const d = Ql({
    width: "100%",
    height: "100%",
    lineHeight: 0
  }, r);
  return /* @__PURE__ */ l.jsx("div", ck(Ql({ ref: s, className: t }, !t && { style: d }), { children: /* @__PURE__ */ l.jsx(
    "canvas",
    ck(Ql({
      ref: a,
      style: {
        width: "100%",
        height: "100%"
      }
    }, o), {
      children: i
    })
  ) }));
}
var VL = (e) => {
  const [n, i] = se(null), t = Ye(null), a = Ye(e), s = Ye(null), r = Ye(null);
  t.current = n, a.current = e;
  const o = I((k) => {
    var m, f;
    !((m = a.current) != null && m.playOnHover) || !((f = t.current) != null && f.isLoaded) || (k.type === "mouseenter" ? t.current.play() : k.type === "mouseleave" && t.current.pause());
  }, []), d = I((k) => {
    s.current = k;
  }, []), c = I((k) => {
    r.current = k;
  }, []), u = I(
    (k) => /* @__PURE__ */ l.jsx(UL, Ql({ setContainerRef: c, setCanvasRef: d }, k)),
    [d, c]
  );
  return be(() => {
    const k = s.current;
    let m = null;
    return k && (m = new QL(ck(Ql({}, a.current), {
      canvas: k
    })), k.addEventListener("mouseenter", o), k.addEventListener("mouseleave", o), i(m)), () => {
      m == null || m.destroy(), i(null), k == null || k.removeEventListener("mouseenter", o), k == null || k.removeEventListener("mouseleave", o);
    };
  }, [o]), be(() => {
    t.current && typeof (e == null ? void 0 : e.speed) == "number" && e.speed !== t.current.speed && t.current.setSpeed(e.speed);
  }, [e == null ? void 0 : e.speed]), be(() => {
    t.current && typeof (e == null ? void 0 : e.mode) == "string" && e.mode !== t.current.mode && t.current.setMode(e.mode);
  }, [e == null ? void 0 : e.mode]), be(() => {
    t.current && typeof (e == null ? void 0 : e.loop) == "boolean" && e.loop !== t.current.loop && t.current.setLoop(e.loop);
  }, [e == null ? void 0 : e.loop]), be(() => {
    t.current && typeof (e == null ? void 0 : e.useFrameInterpolation) == "boolean" && e.useFrameInterpolation !== t.current.useFrameInterpolation && t.current.setUseFrameInterpolation(e.useFrameInterpolation);
  }, [e == null ? void 0 : e.useFrameInterpolation]), be(() => {
    var k, m;
    if (!t.current)
      return;
    const f = (k = e == null ? void 0 : e.segment) == null ? void 0 : k[0], p = (m = e == null ? void 0 : e.segment) == null ? void 0 : m[1];
    typeof f == "number" && typeof p == "number" && t.current.setSegment(f, p);
  }, [e == null ? void 0 : e.segment]), be(() => {
    t.current && typeof (e == null ? void 0 : e.backgroundColor) == "string" && e.backgroundColor !== t.current.backgroundColor && t.current.setBackgroundColor(e.backgroundColor);
  }, [e == null ? void 0 : e.backgroundColor]), be(() => {
    t.current && typeof (e == null ? void 0 : e.renderConfig) == "object" && t.current.setRenderConfig(e.renderConfig);
  }, [JSON.stringify(e == null ? void 0 : e.renderConfig)]), be(() => {
    t.current && (typeof (e == null ? void 0 : e.data) == "string" || (e == null ? void 0 : e.data) instanceof ArrayBuffer) && t.current.load(Ql({
      data: e.data
    }, a.current || {}));
  }, [e == null ? void 0 : e.data]), be(() => {
    t.current && typeof (e == null ? void 0 : e.src) == "string" && t.current.load(Ql({
      src: e.src
    }, a.current || {}));
  }, [e == null ? void 0 : e.src]), be(() => {
    t.current && typeof (e == null ? void 0 : e.marker) == "string" && t.current.setMarker(e.marker);
  }, [e == null ? void 0 : e.marker]), be(() => {
    t.current && t.current.isLoaded && e != null && e.animationId && t.current.activeAnimationId !== e.animationId && t.current.loadAnimation(e.animationId);
  }, [e == null ? void 0 : e.animationId]), be(() => {
    t.current && t.current.isLoaded && t.current.activeThemeId !== (e == null ? void 0 : e.themeId) && t.current.setTheme((e == null ? void 0 : e.themeId) || "");
  }, [e == null ? void 0 : e.themeId]), be(() => {
    t.current && t.current.isLoaded && t.current.setThemeData((e == null ? void 0 : e.themeData) || "");
  }, [e == null ? void 0 : e.themeData]), {
    dotLottie: n,
    setCanvasRef: d,
    setContainerRef: c,
    canvas: s.current,
    container: r.current,
    DotLottieComponent: u
  };
}, HL = typeof window != "undefined" ? as : be;
function zL(e) {
  const n = Ye(e);
  return HL(() => {
    n.current = e;
  }), I((...i) => n.current(...i), [n]);
}
var E5 = (e) => {
  var n = e, {
    animationId: i,
    autoplay: t,
    backgroundColor: a,
    data: s,
    dotLottieRefCallback: r,
    loop: o,
    marker: d,
    mode: c,
    playOnHover: u,
    renderConfig: k,
    segment: m,
    speed: f,
    src: p,
    themeData: h,
    themeId: N,
    useFrameInterpolation: S
  } = n, F = x5(n, [
    "animationId",
    "autoplay",
    "backgroundColor",
    "data",
    "dotLottieRefCallback",
    "loop",
    "marker",
    "mode",
    "playOnHover",
    "renderConfig",
    "segment",
    "speed",
    "src",
    "themeData",
    "themeId",
    "useFrameInterpolation"
  ]);
  const { DotLottieComponent: y, dotLottie: x } = VL({
    data: s,
    mode: c,
    speed: f,
    src: p,
    autoplay: t,
    loop: o,
    segment: m,
    renderConfig: k,
    backgroundColor: a,
    useFrameInterpolation: S,
    playOnHover: u,
    marker: d,
    themeId: N,
    animationId: i,
    themeData: h
  }), R = typeof r == "function" ? zL(r) : void 0;
  return be(() => {
    typeof R == "function" && R(x);
  }, [R, x]), /* @__PURE__ */ l.jsx(y, Ql({}, F));
};
const J5 = "data:application/json;base64,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", Sd = g(() => {
  const [e, n] = se(!1);
  return be(() => {
    n(!0);
  }, []), e ? /* @__PURE__ */ l.jsx("div", { className: "ch-fixed ch-inset-0 ch-z-[9998] ch-flex ch-h-full ch-w-full ch-items-center ch-justify-center ch-bg-white", children: /* @__PURE__ */ l.jsx(E5, { className: "ch-aspect-auto ch-size-32", src: J5, loop: !0, autoplay: !0 }) }) : null;
});
var BL = "Portal", _5 = w.forwardRef((e, n) => {
  var o;
  const { container: i, ...t } = e, [a, s] = w.useState(!1);
  Mi(() => s(!0), []);
  const r = i || a && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return r ? pf.createPortal(/* @__PURE__ */ l.jsx(e6.div, { ...t, ref: n }), r) : null;
});
_5.displayName = BL;
var Lv = _5;
const qL = g(() => {
  const e = yr(), [n, i] = se(!1);
  return be(() => {
    i(!0);
  }, []), n ? /* @__PURE__ */ l.jsx(Lv, { container: e, className: "ch-fixed ch-inset-0 ch-z-[400] ch-h-full ch-w-full ch-bg-black/5", children: /* @__PURE__ */ l.jsx("div", { className: "ch-absolute ch-top-16 ch-mx-auto ch-flex ch-w-full ch-justify-center", children: /* @__PURE__ */ l.jsx("div", { className: "ch-h-11 ch-rounded-full ch-bg-white ch-p-2 ch-shadow-md", children: /* @__PURE__ */ l.jsx(
    E5,
    {
      className: "-ch-mt-[26px] ch-size-20 ch-overflow-hidden",
      src: J5,
      loop: !0,
      autoplay: !0
    }
  ) }) }) }) : null;
});
var Q5 = "Popover", [M5] = $t(Q5, [
  Dm
]), Qm = Dm(), [Kxe, fs] = M5(Q5), L5 = "PopoverAnchor", GL = w.forwardRef(
  (e, n) => {
    const { __scopePopover: i, ...t } = e, a = fs(L5, i), s = Qm(i), { onCustomAnchorAdd: r, onCustomAnchorRemove: o } = a;
    return w.useEffect(() => (r(), () => o()), [r, o]), /* @__PURE__ */ l.jsx(Dv, { ...s, ...t, ref: n });
  }
);
GL.displayName = L5;
var $5 = "PopoverTrigger", WL = w.forwardRef(
  (e, n) => {
    const { __scopePopover: i, ...t } = e, a = fs($5, i), s = Qm(i), r = Rn(n, a.triggerRef), o = /* @__PURE__ */ l.jsx(
      ln.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": B5(a.open),
        ...t,
        ref: r,
        onClick: nn(e.onClick, a.onOpenToggle)
      }
    );
    return a.hasCustomAnchor ? o : /* @__PURE__ */ l.jsx(Dv, { asChild: !0, ...s, children: o });
  }
);
WL.displayName = $5;
var $v = "PopoverPortal", [KL, YL] = M5($v, {
  forceMount: void 0
}), U5 = (e) => {
  const { __scopePopover: n, forceMount: i, children: t, container: a } = e, s = fs($v, n);
  return /* @__PURE__ */ l.jsx(KL, { scope: n, forceMount: i, children: /* @__PURE__ */ l.jsx(kl, { present: i || s.open, children: /* @__PURE__ */ l.jsx(wv, { asChild: !0, container: a, children: t }) }) });
};
U5.displayName = $v;
var Y1 = "PopoverContent", V5 = w.forwardRef(
  (e, n) => {
    const i = YL(Y1, e.__scopePopover), { forceMount: t = i.forceMount, ...a } = e, s = fs(Y1, e.__scopePopover);
    return /* @__PURE__ */ l.jsx(kl, { present: t || s.open, children: s.modal ? /* @__PURE__ */ l.jsx(ZL, { ...a, ref: n }) : /* @__PURE__ */ l.jsx(e$, { ...a, ref: n }) });
  }
);
V5.displayName = Y1;
var XL = /* @__PURE__ */ B1("PopoverContent.RemoveScroll"), ZL = w.forwardRef(
  (e, n) => {
    const i = fs(Y1, e.__scopePopover), t = w.useRef(null), a = Rn(n, t), s = w.useRef(!1);
    return w.useEffect(() => {
      const r = t.current;
      if (r) return Pv(r);
    }, []), /* @__PURE__ */ l.jsx(Pm, { as: XL, allowPinchZoom: !0, children: /* @__PURE__ */ l.jsx(
      H5,
      {
        ...e,
        ref: a,
        trapFocus: i.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: nn(e.onCloseAutoFocus, (r) => {
          var o;
          r.preventDefault(), s.current || (o = i.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: nn(
          e.onPointerDownOutside,
          (r) => {
            const o = r.detail.originalEvent, d = o.button === 0 && o.ctrlKey === !0, c = o.button === 2 || d;
            s.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: nn(
          e.onFocusOutside,
          (r) => r.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), e$ = w.forwardRef(
  (e, n) => {
    const i = fs(Y1, e.__scopePopover), t = w.useRef(!1), a = w.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      H5,
      {
        ...e,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var r, o;
          (r = e.onCloseAutoFocus) == null || r.call(e, s), s.defaultPrevented || (t.current || (o = i.triggerRef.current) == null || o.focus(), s.preventDefault()), t.current = !1, a.current = !1;
        },
        onInteractOutside: (s) => {
          var d, c;
          (d = e.onInteractOutside) == null || d.call(e, s), s.defaultPrevented || (t.current = !0, s.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const r = s.target;
          ((c = i.triggerRef.current) == null ? void 0 : c.contains(r)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && a.current && s.preventDefault();
        }
      }
    );
  }
), H5 = w.forwardRef(
  (e, n) => {
    const {
      __scopePopover: i,
      trapFocus: t,
      onOpenAutoFocus: a,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: r,
      onEscapeKeyDown: o,
      onPointerDownOutside: d,
      onFocusOutside: c,
      onInteractOutside: u,
      ...k
    } = e, m = fs(Y1, i), f = Qm(i);
    return Nv(), /* @__PURE__ */ l.jsx(
      Im,
      {
        asChild: !0,
        loop: !0,
        trapped: t,
        onMountAutoFocus: a,
        onUnmountAutoFocus: s,
        children: /* @__PURE__ */ l.jsx(
          Fm,
          {
            asChild: !0,
            disableOutsidePointerEvents: r,
            onInteractOutside: u,
            onEscapeKeyDown: o,
            onPointerDownOutside: d,
            onFocusOutside: c,
            onDismiss: () => m.onOpenChange(!1),
            children: /* @__PURE__ */ l.jsx(
              A6,
              {
                "data-state": B5(m.open),
                role: "dialog",
                id: m.contentId,
                ...f,
                ...k,
                ref: n,
                style: {
                  ...k.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), z5 = "PopoverClose", n$ = w.forwardRef(
  (e, n) => {
    const { __scopePopover: i, ...t } = e, a = fs(z5, i);
    return /* @__PURE__ */ l.jsx(
      ln.button,
      {
        type: "button",
        ...t,
        ref: n,
        onClick: nn(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
n$.displayName = z5;
var i$ = "PopoverArrow", t$ = w.forwardRef(
  (e, n) => {
    const { __scopePopover: i, ...t } = e, a = Qm(i);
    return /* @__PURE__ */ l.jsx(O6, { ...a, ...t, ref: n });
  }
);
t$.displayName = i$;
function B5(e) {
  return e ? "open" : "closed";
}
var a$ = U5, q5 = V5;
const l$ = w.forwardRef(({ className: e, align: n = "center", sideOffset: i = 4, ...t }, a) => /* @__PURE__ */ l.jsx(a$, { container: yr(), children: /* @__PURE__ */ l.jsx(
  q5,
  {
    ref: a,
    align: n,
    sideOffset: i,
    className: ce(
      "ch-z-[200] ch-w-72 ch-rounded-md ch-border ch-border-gray-200 ch-bg-white ch-p-4 ch-text-black ch-shadow-md ch-outline-none data-[state=open]:ch-animate-in data-[state=closed]:ch-animate-out data-[state=closed]:ch-fade-out-0 data-[state=open]:ch-fade-in-0 data-[state=closed]:ch-zoom-out-95 data-[state=open]:ch-zoom-in-95 data-[side=bottom]:ch-slide-in-from-top-2 data-[side=left]:ch-slide-in-from-right-2 data-[side=right]:ch-slide-in-from-left-2 data-[side=top]:ch-slide-in-from-bottom-2",
      e
    ),
    ...t
  }
) }));
l$.displayName = q5.displayName;
const s$ = (e) => ({
  kind: "DayTripDateNotSelected",
  lang: e.lang
}), r$ = (e) => (n) => ({
  kind: "DayTripDateSelected",
  dayTripDt: n,
  lang: e.lang
}), o$ = (e) => ({
  kind: "StayNotSelected",
  lang: e.lang
}), d$ = (e) => (n) => ({
  kind: "StayCinSelected",
  cinDt: n,
  lang: e.lang
}), c$ = (e) => (n) => ({
  kind: "StayCoutSelected",
  cinDt: e.cinDt,
  coutDt: n,
  lang: e.lang
}), u$ = (e) => e.isDayTrip ? P(e.stayStartDt) ? {
  kind: "DayTripDateNotSelected",
  lang: e.lang
} : {
  kind: "DayTripDateSelected",
  dayTripDt: e.stayStartDt,
  lang: e.lang
} : !P(e.stayStartDt) && !P(e.stayLastDt) ? {
  kind: "StayCoutSelected",
  cinDt: e.stayStartDt,
  coutDt: Ci({ date: e.stayLastDt, inc: 1 }),
  lang: e.lang
} : !P(e.stayStartDt) && P(e.stayLastDt) ? {
  kind: "StayCinSelected",
  cinDt: e.stayStartDt,
  coutDt: null,
  lang: e.lang
} : {
  kind: "StayNotSelected",
  lang: e.lang
}, m$ = (e) => ({
  onSelectDayTripDate: I(
    (i) => (t) => async () => {
      if (e.state.kind !== "DayTripDateNotSelected" && e.state.kind !== "DayTripDateSelected")
        return;
      const a = r$(e.state)(t);
      await e.onSelectDayTripDateCallback(i)(a.dayTripDt).finally(() => {
        e.onChangeState(a);
      });
    },
    [e]
  )
}), k$ = (e) => ({
  onSelectDayTripUnSelectableDate: I(
    (i) => async () => {
      if (e.state.kind !== "DayTripDateSelected")
        return;
      const t = s$(e.state);
      await e.onSelectDayTripUnSelectableDateCallback(i).finally(() => {
        e.onChangeState(t);
      });
    },
    [e]
  )
}), f$ = (e) => ({
  onSelectStayCinDate: I(
    (i) => (t) => async () => {
      if (e.state.kind !== "StayNotSelected" && e.state.kind !== "StayCoutSelected")
        return;
      const a = d$(e.state)(t);
      await e.onSelectStayCinDateCallback(i)(a.cinDt).finally(() => {
        e.onChangeState(a);
      });
    },
    [e]
  )
}), v$ = (e) => ({
  onSelectStayCoutDate: I(
    (i) => (t) => async () => {
      if (e.state.kind !== "StayCinSelected")
        return;
      const a = c$(e.state)(t);
      await e.onSelectStayCoutDateCallback(i)(a.cinDt)(
        Ci({ date: a.coutDt, inc: -1 })
      ).finally(() => {
        e.onChangeState(a);
      });
    },
    [e]
  )
}), h$ = (e) => {
  const n = I(
    async (t) => {
      e.state.kind === "StayCoutSelected" && await e.onSelectStayUnSelectableDateCallback(t);
    },
    [e]
  );
  return {
    onSelectStayUnSelectableDate: I(
      (t) => async () => {
        if (e.state.kind !== "StayCinSelected" && e.state.kind !== "StayCoutSelected")
          return;
        const a = o$(e.state);
        await n(t).finally(() => {
          e.onChangeState(a);
        });
      },
      [n, e]
    )
  };
}, p$ = (e) => {
  const [n, i] = se(u$(e)), t = I((c) => {
    i(c);
  }, []), { onSelectDayTripDate: a } = m$({ ...e, state: n, onChangeState: t }), { onSelectDayTripUnSelectableDate: s } = k$({
    ...e,
    state: n,
    onChangeState: t
  }), { onSelectStayCinDate: r } = f$({ ...e, state: n, onChangeState: t }), { onSelectStayCoutDate: o } = v$({ ...e, state: n, onChangeState: t }), { onSelectStayUnSelectableDate: d } = h$({ ...e, state: n, onChangeState: t });
  return {
    state: n,
    onSelectDayTripDate: a,
    onSelectDayTripUnSelectableDate: s,
    onSelectStayCinDate: r,
    onSelectStayCoutDate: o,
    onSelectStayUnSelectableDate: d
  };
}, J4 = g((e) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-[10px] ch-font-normal ch-leading-3", children: e.text })), Es = g((e) => {
  const n = I(async () => {
    (e.kind === "SelectableDay" || e.kind === "ResettableDay") && await e.onSubmitCallback();
  }, [e]), i = v(() => Ne(e.date, "D"), [e.date]), t = I(() => e.kind === "DifferentMonthDay" ? null : e.kind === "NotSelectableDay" || e.kind === "ResettableDay" ? /* @__PURE__ */ l.jsx(Ei, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]" }) : e.kind === "SelectableDay" ? e.canShowPrice && !P(e.price) ? /* @__PURE__ */ l.jsx(J4, { text: e.price.toLocaleString() }) : /* @__PURE__ */ l.jsx(am, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]", size: "2xs" }) : e.kind === "DayTripSelectedDay" && e.canShowPrice && !P(e.price) ? /* @__PURE__ */ l.jsx(J4, { text: e.price.toLocaleString() }) : /* @__PURE__ */ l.jsx(tm, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]" }), [e]), a = v(() => {
    if (e.kind === "DifferentMonthDay")
      return "ch-pointer-events-none ch-cursor-default ch-text-white ch-opacity-0";
    if (e.kind === "DayTripSelectedDay")
      return "ch-bg-primary ch-text-white";
    if (e.kind === "SelectableDay")
      return "ch-cursor-pointer ch-text-black hover:ch-bg-gray-100 hover:ch-opacity-90 hover:ch-duration-500";
    if (e.kind === "ResettableDay")
      return "ch-text-gray-400 ch-cursor-pointer";
    if (e.kind === "NotSelectableDay")
      return "ch-text-gray-400 ch-cursor-default";
  }, [e]);
  return /* @__PURE__ */ l.jsxs(
    "button",
    {
      className: ce(
        "ch-w-full ch-max-w-[50px] ch-space-y-1 ch-rounded ch-py-2.5 ch-text-center ch-tabular-nums",
        a
      ),
      onClick: n,
      children: [
        /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-normal", children: i }),
        t()
      ]
    }
  );
}), N$ = (e) => {
  var t, a;
  const n = e.availableStayStartDateList.find(
    (s) => Ht({ targetDate: s.date, compareDate: e.date })
  ), i = e.sessionStateContext.reservationPolicy.isShowCalendarPrice;
  if (P(n) || e.isDifferentMonth)
    return {
      kind: "NotDisplayable",
      date: e.date
    };
  if (n.currentViewState === Un.DayTripSelected)
    return {
      kind: "DayTripReadable",
      canShowPrice: i,
      price: (t = n.dailyMinimumPrice) != null ? t : null,
      date: e.date
    };
  if (n.currentViewState === Un.NotSelected && n.selectable)
    return {
      kind: "Selectable",
      lang: e.sessionStateContext.lang,
      canShowPrice: i,
      price: (a = n.dailyMinimumPrice) != null ? a : null,
      date: e.date,
      onSelect: e.onSelectDayTripDate(e.date)
    };
  if (n.currentViewState === Un.NotSelected && !n.selectable)
    return {
      kind: "Resettable",
      lang: e.sessionStateContext.lang,
      date: e.date,
      onSelect: e.onSelectDayTripUnSelectableDate
    };
  throw new Error("Invalid state");
}, S$ = (e) => ({
  state: v(() => N$(e), [e])
}), g$ = g((e) => {
  const { state: n } = S$(e);
  switch (n.kind) {
    case "DayTripReadable":
      return /* @__PURE__ */ l.jsx(
        Es,
        {
          kind: "DayTripSelectedDay",
          date: n.date,
          canShowPrice: n.canShowPrice,
          price: n.price
        }
      );
    case "Selectable":
      return /* @__PURE__ */ l.jsx(
        Es,
        {
          kind: "SelectableDay",
          lang: n.lang,
          date: n.date,
          canShowPrice: n.canShowPrice,
          price: n.price,
          onSubmitCallback: n.onSelect
        }
      );
    case "Resettable":
      return /* @__PURE__ */ l.jsx(
        Es,
        {
          kind: "ResettableDay",
          lang: n.lang,
          date: n.date,
          onSubmitCallback: n.onSelect
        }
      );
    default:
      return /* @__PURE__ */ l.jsx(Es, { kind: "DifferentMonthDay", date: n.date });
  }
}), F$ = (e) => {
  var t;
  const n = e.availableStayStartDateList.find(
    (a) => Ht({ targetDate: a.date, compareDate: e.date })
  ), i = e.sessionStateContext.reservationPolicy.isShowCalendarPrice;
  if (P(n) || e.isDifferentMonth)
    return {
      kind: "NotDisplayable",
      date: e.date
    };
  if (n.currentViewState === Un.NotSelected && n.selectable)
    return {
      kind: "Selectable",
      lang: e.sessionStateContext.lang,
      canShowPrice: i,
      price: (t = n.dailyMinimumPrice) != null ? t : null,
      date: e.date,
      onSelect: e.onSelectDayTripDate(e.date)
    };
  if (n.currentViewState === Un.NotSelected && !n.selectable)
    return {
      kind: "NotSelectable",
      date: e.date
    };
  throw new Error("Invalid state");
}, I$ = (e) => ({
  state: v(() => F$(e), [e])
}), y$ = (e) => {
  const { state: n } = I$(e);
  switch (n.kind) {
    case "Selectable":
      return /* @__PURE__ */ l.jsx(
        Es,
        {
          kind: "SelectableDay",
          lang: n.lang,
          date: n.date,
          canShowPrice: n.canShowPrice,
          price: n.price,
          onSubmitCallback: n.onSelect
        }
      );
    case "NotSelectable":
      return /* @__PURE__ */ l.jsx(Es, { kind: "NotSelectableDay", date: n.date });
    default:
      return /* @__PURE__ */ l.jsx(Es, { kind: "DifferentMonthDay", date: n.date });
  }
}, b$ = (e) => {
  const { onHideLoadingScreenCallback: n, onShowLoadingScreenCallback: i } = fn();
  return {
    handleSubmit: I(async () => {
      (e.kind === "SelectableMiddleDay" || e.kind === "SelectableDay" || e.kind === "ResettableDay") && (i(), await e.onSubmitCallback().finally(() => {
        n();
      }));
    }, [n, i, e])
  };
}, C$ = g((e) => {
  const { handleSubmit: n } = b$(e), i = I(() => ["ch-pointer-events-none", "ch-cursor-default", "ch-text-white", "ch-opacity-0"], []), t = I(() => ["ch-text-gray-400"], []), a = I(() => ["ch-text-gray-400"], []), s = I(
    (d) => {
      const c = ["ch-bg-primary", "ch-text-white", "ch-font-semibold"];
      switch (d.kind) {
        case "CinSelected":
          return c.concat("ch-rounded-l-lg");
        case "CoutSelected":
          return c.concat("ch-rounded-r-lg");
        default:
          return c;
      }
    },
    []
  ), r = I(
    (d) => {
      const c = ["ch-cursor-pointer", "ch-font-semibold"];
      switch (d.kind) {
        case "SelectableDay":
          return c.concat(["hover:ch-rounded-lg", "hover:ch-bg-gray-100", "hover:ch-opacity-90"]);
        case "SelectableMiddleDay":
          return c.concat(["ch-bg-primary", "ch-text-white"]);
        default:
          return c;
      }
    },
    []
  ), o = v(() => {
    switch (e.kind) {
      case "DifferentMonthDay":
        return i();
      case "ResettableDay":
        return a();
      case "NotSelectableDay":
        return t();
      case "CinSelected":
        return s(e);
      case "MiddleDaySelected":
        return s(e);
      case "CoutSelected":
        return s(e);
      case "SelectableDay":
        return r(e);
      case "SelectableMiddleDay":
        return r(e);
      default:
        return;
    }
  }, [
    i,
    t,
    a,
    r,
    s,
    e
  ]);
  return /* @__PURE__ */ l.jsx(
    "button",
    {
      className: ce(
        "ch-w-full ch-max-w-[50px] ch-cursor-default ch-space-y-1 ch-py-2.5 ch-text-center",
        o
      ),
      onClick: n,
      children: e.children
    }
  );
}), _4 = g(() => /* @__PURE__ */ l.jsx(tm, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]" })), Q4 = g(() => /* @__PURE__ */ l.jsx(am, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]" })), M4 = g((e) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-[10px] ch-font-normal ch-leading-3", children: e.text })), x$ = g((e) => {
  if (e.kind === "DifferentMonthDay")
    return null;
  if (e.kind === "NotSelectableDay" || e.kind === "ResettableDay")
    return /* @__PURE__ */ l.jsx(Ei, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]" });
  if (!e.canShowPrice)
    switch (e.kind) {
      case "SelectableDay":
        return /* @__PURE__ */ l.jsx(Q4, {});
      case "SelectableMiddleDay":
        return /* @__PURE__ */ l.jsx(Q4, {});
      case "CinSelected":
        return /* @__PURE__ */ l.jsx(_4, {});
      case "MiddleDaySelected":
        return /* @__PURE__ */ l.jsx(_4, {});
      case "CoutSelected":
        return /* @__PURE__ */ l.jsx("div", { className: "ch-h-[12px] ch-w-[12px]" });
      default:
        return null;
    }
  if ((e.kind === "MiddleDaySelected" || e.kind === "SelectableDay" || e.kind === "SelectableMiddleDay") && e.price !== 0) {
    const n = `${e.price.toLocaleString()}~`;
    return /* @__PURE__ */ l.jsx(M4, { text: n });
  }
  return e.kind === "CinSelected" && !P(e.price) ? /* @__PURE__ */ l.jsx(M4, { text: `${e.price.toLocaleString()}~` }) : /* @__PURE__ */ l.jsx("div", { className: "ch-h-[12px] ch-w-[12px]" });
}), D$ = g((e) => {
  const n = Ne(e.date, "D");
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-normal", children: n });
}), Zi = g((e) => /* @__PURE__ */ l.jsxs(C$, { ...e, children: [
  /* @__PURE__ */ l.jsx(D$, { ...e }),
  /* @__PURE__ */ l.jsx(x$, { ...e })
] })), w$ = (e) => {
  var u, k, m, f;
  const n = e.availableStayStartDateList.find(
    (p) => Ht({
      targetDate: p.date,
      compareDate: e.date
    })
  );
  if (P(n) || e.isDifferentMonth)
    return {
      kind: "NotDisplayable",
      date: e.date
    };
  if (n.currentViewState === Un.NotSelected && n.selectable)
    return {
      kind: "Selectable",
      lang: e.sessionStateContext.lang,
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (u = n.dailyMinimumPrice) != null ? u : 0,
      onSubmitCallback: e.onSelectStayCinDate(e.date)
    };
  if (n.currentViewState === Un.Cin)
    return {
      kind: "CinReadable",
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (k = n.dailyMinimumPrice) != null ? k : 0
    };
  if (n.currentViewState === Un.Cout)
    return {
      kind: "CoutReadable",
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice
    };
  const r = n.currentViewState === Un.MiddleDay;
  if (r && n.available)
    return {
      kind: "MiddleDayReadable",
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (m = n.dailyMinimumPrice) != null ? m : 0
    };
  if (r && n.selectable)
    return {
      kind: "MiddleDaySelectable",
      lang: e.sessionStateContext.lang,
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (f = n.dailyMinimumPrice) != null ? f : 0,
      onSubmitCallback: e.onSelectStayCinDate(e.date)
    };
  if (r)
    return {
      kind: "MiddleDayReadable",
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: 0
    };
  if (n.currentViewState === Un.NotSelected && !n.selectable)
    return {
      kind: "Resettable",
      lang: e.sessionStateContext.lang,
      date: e.date,
      onSubmitCallback: e.onSelectStayUnSelectableDate
    };
  throw new Error("Invalid state");
}, P$ = (e) => ({
  state: v(() => w$(e), [e])
}), R$ = g((e) => {
  const { state: n } = P$(e);
  switch (n.kind) {
    case "CinReadable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "CinSelected" });
    case "CoutReadable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "CoutSelected" });
    case "MiddleDayReadable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "MiddleDaySelected" });
    case "MiddleDaySelectable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "SelectableMiddleDay" });
    case "Selectable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "SelectableDay" });
    case "Resettable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "ResettableDay" });
    case "NotDisplayable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "DifferentMonthDay" });
    default:
      throw new Error("Invalid state");
  }
}), T$ = (e) => {
  var i, t, a, s;
  const n = e.availableCoutDateList.find(
    (r) => Ht({
      targetDate: r.date,
      compareDate: e.date
    })
  );
  if (e.isDifferentMonth)
    return {
      kind: "NotDisplayable",
      date: e.date
    };
  if (P(n))
    return {
      kind: "Resettable",
      lang: e.sessionStateContext.lang,
      date: e.date,
      onSubmitCallback: e.onSelectStayUnSelectableDate
    };
  if (n.currentViewState === Rt.NotSelected && n.selectable)
    return {
      kind: "Selectable",
      isDifferentMonth: e.isDifferentMonth,
      lang: e.sessionStateContext.lang,
      date: n.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (i = n.dailyMinimumPrice) != null ? i : 0,
      onSubmitCallback: e.onSelectStayCoutDate(e.date)
    };
  if (n.currentViewState === Rt.MiddleDay && n.selectable)
    return {
      kind: "MiddleDaySelectable",
      isDifferentMonth: e.isDifferentMonth,
      lang: e.sessionStateContext.lang,
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (t = n.dailyMinimumPrice) != null ? t : 0,
      onSubmitCallback: e.onSelectStayCoutDate(e.date)
    };
  if (n.currentViewState === Rt.Cin)
    return {
      kind: "CinReadable",
      isDifferentMonth: e.isDifferentMonth,
      lang: e.sessionStateContext.lang,
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (a = n.dailyMinimumPrice) != null ? a : 0
    };
  if (n.currentViewState === Rt.MiddleDay && n.available)
    return {
      kind: "MiddleDayReadable",
      isDifferentMonth: e.isDifferentMonth,
      lang: e.sessionStateContext.lang,
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (s = n.dailyMinimumPrice) != null ? s : 0
    };
  if (n.currentViewState === Rt.NotSelected && !n.selectable)
    return {
      kind: "Resettable",
      lang: e.sessionStateContext.lang,
      date: n.date,
      onSubmitCallback: e.onSelectStayUnSelectableDate
    };
  throw new Error("Invalid state");
}, j$ = (e) => ({
  state: v(() => T$(e), [e])
}), A$ = g((e) => {
  const { state: n } = j$(e);
  switch (n.kind) {
    case "CinReadable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "CinSelected" });
    case "MiddleDayReadable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "MiddleDaySelected" });
    case "MiddleDaySelectable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "SelectableMiddleDay" });
    case "Selectable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "SelectableDay" });
    case "Resettable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "ResettableDay" });
    case "NotDisplayable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "DifferentMonthDay" });
    default:
      throw new Error("Invalid state");
  }
}), O$ = (e) => {
  var i;
  const n = e.availableStayStartDateList.find(
    (t) => Ht({ targetDate: t.date, compareDate: e.date })
  );
  if (P(n) || e.isDifferentMonth)
    return {
      kind: "NotDisplayable",
      date: e.date
    };
  if (n.currentViewState === Un.NotSelected && n.selectable || n.currentViewState === Un.MiddleDay && n.selectable || n.currentViewState === Un.Cin && n.selectable || n.currentViewState === Un.Cout && n.selectable)
    return {
      kind: "Selectable",
      lang: e.sessionStateContext.lang,
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (i = n.dailyMinimumPrice) != null ? i : 0,
      onSubmitCallback: e.onSelectStayCinDate(e.date)
    };
  if (n.currentViewState === Un.NotSelected && !n.selectable)
    return {
      kind: "NotSelectable",
      date: e.date
    };
  throw new Error("Invalid state");
}, E$ = (e) => ({
  state: v(() => O$(e), [e])
}), J$ = (e) => {
  const { state: n } = E$(e);
  switch (n.kind) {
    case "Selectable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "SelectableDay" });
    case "NotSelectable":
      return /* @__PURE__ */ l.jsx(Zi, { kind: "NotSelectableDay", date: n.date });
    case "NotDisplayable":
      return /* @__PURE__ */ l.jsx(Zi, { ...n, kind: "DifferentMonthDay" });
    default:
      throw new Error("Invalid state");
  }
}, _$ = ({ currentYearMonth: e }) => ({
  dateListForMonth: v(() => {
    var o, d;
    if (P(e))
      return [];
    const { firstDate: i, lastDate: t } = gt(e), a = Hv({ startDate: i, endDate: t }).map((c) => ({
      date: c,
      isDifferentMonth: !1
    })), s = Q$((o = a[0]) == null ? void 0 : o.date), r = M$((d = a[a.length - 1]) == null ? void 0 : d.date);
    return [...s, ...a, ...r];
  }, [e])
}), Q$ = (e) => {
  if (P(e)) return [];
  const n = [], i = Fd({ date: e });
  if (i !== 0)
    for (let t = i; t > 0; t--) {
      const a = La({ date: e, amount: t + 1 });
      n.push({ date: a, isDifferentMonth: !0 });
    }
  return n;
}, M$ = (e) => {
  if (P(e)) return [];
  const n = [], i = Fd({ date: e });
  if (i !== 6) {
    let t = 0;
    for (let a = i; a < 6; a++) {
      t++;
      const s = Ci({ date: e, inc: t });
      n.push({ date: s, isDifferentMonth: !0 });
    }
  }
  return n;
}, L$ = (e) => {
  const { dateListForMonth: n } = _$(e);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-grid ch-grid-cols-7 ch-place-content-center", children: n.map((i, t) => {
    const a = `${e.reservationCalendarState.kind}-${i.date}-${t}`;
    switch (e.reservationCalendarState.kind) {
      case "StayNotSelected":
        return /* @__PURE__ */ l.jsx(
          J$,
          {
            ...e,
            date: i.date,
            isDifferentMonth: i.isDifferentMonth
          },
          a
        );
      case "StayCinSelected":
        return /* @__PURE__ */ l.jsx(
          A$,
          {
            ...e,
            date: i.date,
            isDifferentMonth: i.isDifferentMonth
          },
          a
        );
      case "StayCoutSelected":
        return /* @__PURE__ */ l.jsx(
          R$,
          {
            ...e,
            date: i.date,
            isDifferentMonth: i.isDifferentMonth
          },
          a
        );
      case "DayTripDateNotSelected":
        return /* @__PURE__ */ l.jsx(
          y$,
          {
            ...e,
            date: i.date,
            isDifferentMonth: i.isDifferentMonth
          },
          a
        );
      case "DayTripDateSelected":
        return /* @__PURE__ */ l.jsx(
          g$,
          {
            ...e,
            date: i.date,
            isDifferentMonth: i.isDifferentMonth
          },
          a
        );
      default:
        return null;
    }
  }) });
}, $$ = [
  {
    default: "日",
    en: "Su"
  },
  {
    default: "月",
    en: "Mo"
  },
  {
    default: "火",
    en: "Tu"
  },
  {
    default: "水",
    en: "We"
  },
  {
    default: "木",
    en: "Th"
  },
  {
    default: "金",
    en: "Fr"
  },
  {
    default: "土",
    en: "Sa"
  }
], U$ = g((e) => {
  const n = v(() => {
    const i = [];
    for (let t = 0; t <= 6; t++)
      i.push($$[t][e.lang]);
    return i;
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-grid ch-grid-cols-7 ch-place-items-center ch-gap-y-0.5", children: n.map((i) => /* @__PURE__ */ l.jsx("h6", { className: "ch-select-none ch-text-sm", children: i }, i)) });
}), V$ = g((e) => {
  const n = v(() => e.lang === D.Default ? Ne(e.currentYearMonth, "YYYY.MM") : Ne(e.currentYearMonth, "MMM YYYY", "en"), [e.currentYearMonth, e.lang]);
  return /* @__PURE__ */ l.jsx("h6", { className: "ch-shrink-0 ch-text-center ch-text-lg ch-font-medium ch-tabular-nums", children: n });
}), L4 = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-5", children: [
  /* @__PURE__ */ l.jsx(V$, { ...e.titleContext }),
  /* @__PURE__ */ l.jsxs("div", { children: [
    /* @__PURE__ */ l.jsx(U$, { ...e.headerContext }),
    /* @__PURE__ */ l.jsx(L$, { ...e.dateContext })
  ] })
] })), G5 = (e) => ({
  kind: "Errored",
  lang: e.lang,
  onInitialize: e.onInitialize
}), H$ = (e) => e.reservationCalendarState.kind === "DayTripDateNotSelected" || e.reservationCalendarState.kind === "DayTripDateSelected" || e.reservationCalendarState.kind === "StayNotSelected" || e.reservationCalendarState.kind === "StayCoutSelected" ? {
  kind: "NotInitialized",
  isSingleCalendar: e.isSingleCalendar,
  lang: e.reservationCalendarState.lang,
  onInitialize: e.onAvailableStayStartDateListQuery
} : {
  kind: "NotInitialized",
  isSingleCalendar: e.isSingleCalendar,
  lang: e.reservationCalendarState.lang,
  onInitialize: e.onAvailableStayLastDateListQuery(e.reservationCalendarState.cinDt)
}, W5 = () => ({
  kind: "Initialized"
}), z$ = ({ state: e, onChangeState: n }) => {
  const i = Ye(!1);
  as(() => {
    i.current || e.kind !== "NotInitialized" || (i.current = !0, e.onInitialize().then(() => {
      n(W5());
    }).catch(() => {
      n(G5(e));
    }));
  }, [n, e]);
}, B$ = ({ onChangeState: e }) => ({
  onReInitialize: I(
    (i) => async () => {
      try {
        await i.onInitialize(), e(W5(i));
      } catch (t) {
        e(G5(i));
      }
    },
    [e]
  )
}), q$ = (e) => {
  const [n, i] = se(H$(e)), t = I((s) => {
    i(s);
  }, []);
  z$({ state: n, onChangeState: t });
  const { onReInitialize: a } = B$({ onChangeState: t });
  return {
    state: n,
    onReInitialize: a
  };
}, G$ = (e) => {
  const n = I(async () => {
    await e.onRefetch();
  }, [e]), i = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: n, children: i });
}, W$ = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "データが正しく取得できませんでした。" : "Failed to fetch data.", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, K$ = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-py-8 ch-text-center", children: [
  /* @__PURE__ */ l.jsx(W$, { ...e }),
  /* @__PURE__ */ l.jsx(G$, { ...e })
] }), U0 = g(() => /* @__PURE__ */ l.jsx("div", { className: "ch-mt-8 ch-w-full", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-px-5 ch-py-2", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-h-[328px] ch-w-full ch-animate-pulse ch-rounded-xl ch-bg-gray-200" }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-h-9 ch-w-full ch-animate-pulse ch-rounded-md ch-bg-gray-200" })
] }) })), Y$ = g(({ children: e, modelContext: n }) => {
  const { state: i, onReInitialize: t } = q$(n);
  return i.kind === "NotInitialized" && i.isSingleCalendar ? /* @__PURE__ */ l.jsx(U0, {}) : i.kind === "NotInitialized" && !i.isSingleCalendar ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(U0, {}),
    /* @__PURE__ */ l.jsx(U0, {})
  ] }) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(K$, { lang: i.lang, onRefetch: t(i) }) : e;
}), X$ = (e) => {
  let n = e.initialDate;
  return e.reservationCalendarState.kind === "DayTripDateSelected" && (n = e.reservationCalendarState.dayTripDt), (e.reservationCalendarState.kind === "StayCinSelected" || e.reservationCalendarState.kind === "StayCoutSelected") && (n = e.reservationCalendarState.cinDt), e.isSingleCalendar ? {
    kind: "Initialized",
    currentYearMonthInfo: {
      from: Ne(n, "YYYY-MM-DD"),
      to: Ne(n, "YYYY-MM-DD")
    }
  } : {
    kind: "Initialized",
    currentYearMonthInfo: {
      from: Ne(n, "YYYY-MM-DD"),
      to: nl({ date: n, amount: 1, format: "YYYY-MM-DD" })
    }
  };
}, Z$ = (e) => (n) => {
  if (!e.isSingleCalendar)
    return {
      kind: "NextMonthDisplayed",
      currentYearMonthInfo: {
        from: nl({
          date: n.currentYearMonthInfo.from,
          amount: 1,
          format: "YYYY-MM-DD"
        }),
        to: nl({
          date: n.currentYearMonthInfo.to,
          amount: 1,
          format: "YYYY-MM-DD"
        })
      }
    };
  const i = nl({
    date: n.currentYearMonthInfo.from,
    amount: 1,
    format: "YYYY-MM-DD"
  });
  return {
    kind: "NextMonthDisplayed",
    currentYearMonthInfo: {
      from: i,
      to: i
    }
  };
}, eU = (e) => (n) => {
  if (!e.isSingleCalendar)
    return {
      kind: "PrevMonthDisplayed",
      currentYearMonthInfo: {
        from: nl({
          date: n.currentYearMonthInfo.from,
          amount: -1,
          format: "YYYY-MM-DD"
        }),
        to: nl({
          date: n.currentYearMonthInfo.to,
          amount: -1,
          format: "YYYY-MM-DD"
        })
      }
    };
  const i = nl({
    date: n.currentYearMonthInfo.from,
    amount: -1,
    format: "YYYY-MM-DD"
  });
  return {
    kind: "PrevMonthDisplayed",
    currentYearMonthInfo: {
      from: i,
      to: i
    }
  };
}, nU = (e) => {
  const n = I(
    async (t) => {
      e.reservationCalendarState.kind === "DayTripDateSelected" || e.reservationCalendarState.kind === "StayCoutSelected" || e.reservationCalendarState.kind === "StayNotSelected" || e.reservationCalendarState.kind === "DayTripDateNotSelected" ? await e.onAvailableStayStartDateListQuery(t.currentYearMonthInfo)() : await e.onAvailableStayLastDateListQuery(t.currentYearMonthInfo)(
        e.reservationCalendarState.cinDt
      )();
    },
    [e]
  );
  return {
    onSelectNextMonth: I(async () => {
      const t = Z$(e.stateContext.inputContext)(e.stateContext.state);
      await n(t).finally(() => {
        e.stateContext.onChangeState(t);
      });
    }, [n, e.stateContext])
  };
}, iU = (e) => {
  const n = I(
    async (t) => {
      e.reservationCalendarState.kind === "DayTripDateSelected" || e.reservationCalendarState.kind === "StayCoutSelected" || e.reservationCalendarState.kind === "StayNotSelected" || e.reservationCalendarState.kind === "DayTripDateNotSelected" ? await e.onAvailableStayStartDateListQuery(t.currentYearMonthInfo)() : await e.onAvailableStayLastDateListQuery(t.currentYearMonthInfo)(
        e.reservationCalendarState.cinDt
      )();
    },
    [e]
  );
  return {
    onSelectPrevMonth: I(async () => {
      const t = eU(e.stateContext.inputContext)(e.stateContext.state);
      await n(t).finally(() => {
        e.stateContext.onChangeState(t);
      });
    }, [n, e.stateContext])
  };
}, tU = (e) => {
  const [n, i] = se(X$(e)), t = I((r) => {
    i(r);
  }, []), { onSelectNextMonth: a } = nU({
    ...e,
    stateContext: { onChangeState: t, state: n, inputContext: e }
  }), { onSelectPrevMonth: s } = iU({
    ...e,
    stateContext: { onChangeState: t, state: n, inputContext: e }
  });
  return {
    state: n,
    onSelectNextMonth: a,
    onSelectPrevMonth: s
  };
}, aU = (e) => {
  const { state: n, onSelectNextMonth: i, onSelectPrevMonth: t } = tU(e), { onShowLoadingScreenCallback: a, onHideLoadingScreenCallback: s } = fn(), r = I(async () => {
    a(), await t().finally(() => {
      s();
    });
  }, [s, t, a]), o = I(async () => {
    a(), await i().finally(() => {
      s();
    });
  }, [s, i, a]), d = v(() => kC(n.currentYearMonthInfo.from), [n.currentYearMonthInfo.from]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-relative ch-mx-auto ch-flex ch-max-w-[max-content] ch-justify-center", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-absolute ch-left-0 ch-flex-1", children: /* @__PURE__ */ l.jsx(
      ae,
      {
        className: "ch-border-none",
        disabled: d,
        size: "icon",
        variant: "float",
        onClick: r,
        children: /* @__PURE__ */ l.jsx(lm, { className: "ch-h-4 ch-w-4" })
      }
    ) }),
    e.children(n),
    /* @__PURE__ */ l.jsx("div", { className: "ch-absolute ch-right-0 ch-flex-1", children: /* @__PURE__ */ l.jsx(
      ae,
      {
        className: "ch-border-none",
        size: "icon",
        variant: "float",
        onClick: o,
        children: /* @__PURE__ */ l.jsx(zl, { className: "ch-h-4 ch-w-4" })
      }
    ) })
  ] });
}, lU = () => {
  const [e, n] = se(window.innerWidth);
  return be(() => {
    const i = () => n(window.innerWidth);
    return window.addEventListener("resize", i), () => {
      window.removeEventListener("resize", i);
    };
  }, []), { windowInnerWidth: e };
}, K5 = (e) => {
  const {
    state: n,
    onSelectDayTripDate: i,
    onSelectDayTripUnSelectableDate: t,
    onSelectStayCinDate: a,
    onSelectStayCoutDate: s,
    onSelectStayUnSelectableDate: r
  } = p$(e.modelContext), { windowInnerWidth: o } = lU(), d = v(
    () => e.forceSingleCalendar || o <= 830,
    [e.forceSingleCalendar, o]
  );
  return /* @__PURE__ */ l.jsx("div", { className: ce("ch-w-full ch-space-y-4 ch-rounded-[10px] ch-px-2 ch-py-6", e.className), children: /* @__PURE__ */ l.jsx(
    aU,
    {
      lang: n.lang,
      reservationCalendarState: n,
      isSingleCalendar: d,
      onAvailableStayStartDateListQuery: e.onAvailableStayStartDateListQuery,
      onAvailableStayLastDateListQuery: e.onAvailableStayLastDateListQuery,
      initialDate: e.initialDate,
      children: (c) => /* @__PURE__ */ l.jsx(
        "div",
        {
          className: ce(
            "ch-grid",
            d ? "ch-grid-cols-[minmax(304px,350px)]" : "ch-grid-cols-[350px_350px] ch-gap-x-4"
          ),
          children: /* @__PURE__ */ l.jsx(
            Y$,
            {
              modelContext: {
                isSingleCalendar: d,
                reservationCalendarState: n,
                onAvailableStayLastDateListQuery: e.onAvailableStayLastDateListQuery(
                  c.currentYearMonthInfo
                ),
                onAvailableStayStartDateListQuery: e.onAvailableStayStartDateListQuery(
                  c.currentYearMonthInfo
                )
              },
              children: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
                /* @__PURE__ */ l.jsx(
                  L4,
                  {
                    titleContext: {
                      currentYearMonth: c.currentYearMonthInfo.from,
                      lang: n.lang
                    },
                    headerContext: {
                      lang: n.lang
                    },
                    dateContext: {
                      ...e.calendarContext,
                      reservationCalendarState: n,
                      currentYearMonth: c.currentYearMonthInfo.from,
                      onSelectStayCinDate: a(
                        c.currentYearMonthInfo
                      ),
                      onSelectStayCoutDate: s(
                        c.currentYearMonthInfo
                      ),
                      onSelectStayUnSelectableDate: r(
                        c.currentYearMonthInfo
                      ),
                      onSelectDayTripUnSelectableDate: t(
                        c.currentYearMonthInfo
                      ),
                      onSelectDayTripDate: i(
                        c.currentYearMonthInfo
                      )
                    }
                  }
                ),
                d ? null : /* @__PURE__ */ l.jsx(
                  L4,
                  {
                    titleContext: {
                      currentYearMonth: c.currentYearMonthInfo.to,
                      lang: n.lang
                    },
                    headerContext: {
                      lang: n.lang
                    },
                    dateContext: {
                      ...e.calendarContext,
                      reservationCalendarState: n,
                      currentYearMonth: c.currentYearMonthInfo.to,
                      onSelectStayCinDate: a(
                        c.currentYearMonthInfo
                      ),
                      onSelectStayCoutDate: s(
                        c.currentYearMonthInfo
                      ),
                      onSelectStayUnSelectableDate: r(
                        c.currentYearMonthInfo
                      ),
                      onSelectDayTripUnSelectableDate: t(
                        c.currentYearMonthInfo
                      ),
                      onSelectDayTripDate: i(
                        c.currentYearMonthInfo
                      )
                    }
                  }
                )
              ] })
            }
          )
        }
      )
    },
    d ? "single" : "double"
  ) });
};
var sU = (e) => {
  switch (e) {
    case "success":
      return dU;
    case "info":
      return uU;
    case "warning":
      return cU;
    case "error":
      return mU;
    default:
      return null;
  }
}, rU = Array(12).fill(0), oU = ({ visible: e, className: n }) => K.createElement("div", { className: ["sonner-loading-wrapper", n].filter(Boolean).join(" "), "data-visible": e }, K.createElement("div", { className: "sonner-spinner" }, rU.map((i, t) => K.createElement("div", { className: "sonner-loading-bar", key: `spinner-bar-${t}` })))), dU = K.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, K.createElement("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z", clipRule: "evenodd" })), cU = K.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", height: "20", width: "20" }, K.createElement("path", { fillRule: "evenodd", d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z", clipRule: "evenodd" })), uU = K.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, K.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z", clipRule: "evenodd" })), mU = K.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", height: "20", width: "20" }, K.createElement("path", { fillRule: "evenodd", d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z", clipRule: "evenodd" })), kU = K.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, K.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), K.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })), fU = () => {
  let [e, n] = K.useState(document.hidden);
  return K.useEffect(() => {
    let i = () => {
      n(document.hidden);
    };
    return document.addEventListener("visibilitychange", i), () => window.removeEventListener("visibilitychange", i);
  }, []), e;
}, mk = 1, vU = class {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      let n = this.subscribers.indexOf(e);
      this.subscribers.splice(n, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((n) => n(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [...this.toasts, e];
    }, this.create = (e) => {
      var n;
      let { message: i, ...t } = e, a = typeof (e == null ? void 0 : e.id) == "number" || ((n = e.id) == null ? void 0 : n.length) > 0 ? e.id : mk++, s = this.toasts.find((o) => o.id === a), r = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(a) && this.dismissedToasts.delete(a), s ? this.toasts = this.toasts.map((o) => o.id === a ? (this.publish({ ...o, ...e, id: a, title: i }), { ...o, ...e, id: a, dismissible: r, title: i }) : o) : this.addToast({ title: i, ...t, dismissible: r, id: a }), a;
    }, this.dismiss = (e) => (this.dismissedToasts.add(e), e || this.toasts.forEach((n) => {
      this.subscribers.forEach((i) => i({ id: n.id, dismiss: !0 }));
    }), this.subscribers.forEach((n) => n({ id: e, dismiss: !0 })), e), this.message = (e, n) => this.create({ ...n, message: e }), this.error = (e, n) => this.create({ ...n, message: e, type: "error" }), this.success = (e, n) => this.create({ ...n, type: "success", message: e }), this.info = (e, n) => this.create({ ...n, type: "info", message: e }), this.warning = (e, n) => this.create({ ...n, type: "warning", message: e }), this.loading = (e, n) => this.create({ ...n, type: "loading", message: e }), this.promise = (e, n) => {
      if (!n) return;
      let i;
      n.loading !== void 0 && (i = this.create({ ...n, promise: e, type: "loading", message: n.loading, description: typeof n.description != "function" ? n.description : void 0 }));
      let t = e instanceof Promise ? e : e(), a = i !== void 0, s, r = t.then(async (d) => {
        if (s = ["resolve", d], K.isValidElement(d)) a = !1, this.create({ id: i, type: "default", message: d });
        else if (pU(d) && !d.ok) {
          a = !1;
          let c = typeof n.error == "function" ? await n.error(`HTTP error! status: ${d.status}`) : n.error, u = typeof n.description == "function" ? await n.description(`HTTP error! status: ${d.status}`) : n.description;
          this.create({ id: i, type: "error", message: c, description: u });
        } else if (n.success !== void 0) {
          a = !1;
          let c = typeof n.success == "function" ? await n.success(d) : n.success, u = typeof n.description == "function" ? await n.description(d) : n.description;
          this.create({ id: i, type: "success", message: c, description: u });
        }
      }).catch(async (d) => {
        if (s = ["reject", d], n.error !== void 0) {
          a = !1;
          let c = typeof n.error == "function" ? await n.error(d) : n.error, u = typeof n.description == "function" ? await n.description(d) : n.description;
          this.create({ id: i, type: "error", message: c, description: u });
        }
      }).finally(() => {
        var d;
        a && (this.dismiss(i), i = void 0), (d = n.finally) == null || d.call(n);
      }), o = () => new Promise((d, c) => r.then(() => s[0] === "reject" ? c(s[1]) : d(s[1])).catch(c));
      return typeof i != "string" && typeof i != "number" ? { unwrap: o } : Object.assign(i, { unwrap: o });
    }, this.custom = (e, n) => {
      let i = (n == null ? void 0 : n.id) || mk++;
      return this.create({ jsx: e(i), id: i, ...n }), i;
    }, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}, ht = new vU(), hU = (e, n) => {
  let i = (n == null ? void 0 : n.id) || mk++;
  return ht.addToast({ title: e, ...n, id: i }), i;
}, pU = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", NU = hU, SU = () => ht.toasts, gU = () => ht.getActiveToasts(), V0 = Object.assign(NU, { success: ht.success, info: ht.info, warning: ht.warning, error: ht.error, custom: ht.custom, message: ht.message, promise: ht.promise, dismiss: ht.dismiss, loading: ht.loading }, { getHistory: SU, getToasts: gU });
function FU(e, { insertAt: n } = {}) {
  if (typeof document == "undefined") return;
  let i = document.head || document.getElementsByTagName("head")[0], t = document.createElement("style");
  t.type = "text/css", n === "top" && i.firstChild ? i.insertBefore(t, i.firstChild) : i.appendChild(t), t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
FU(`:where(html[dir="ltr"]),:where([data-sonner-toaster][dir="ltr"]){--toast-icon-margin-start: -3px;--toast-icon-margin-end: 4px;--toast-svg-margin-start: -1px;--toast-svg-margin-end: 0px;--toast-button-margin-start: auto;--toast-button-margin-end: 0;--toast-close-button-start: 0;--toast-close-button-end: unset;--toast-close-button-transform: translate(-35%, -35%)}:where(html[dir="rtl"]),:where([data-sonner-toaster][dir="rtl"]){--toast-icon-margin-start: 4px;--toast-icon-margin-end: -3px;--toast-svg-margin-start: 0px;--toast-svg-margin-end: -1px;--toast-button-margin-start: 0;--toast-button-margin-end: auto;--toast-close-button-start: unset;--toast-close-button-end: 0;--toast-close-button-transform: translate(35%, -35%)}:where([data-sonner-toaster]){position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1: hsl(0, 0%, 99%);--gray2: hsl(0, 0%, 97.3%);--gray3: hsl(0, 0%, 95.1%);--gray4: hsl(0, 0%, 93%);--gray5: hsl(0, 0%, 90.9%);--gray6: hsl(0, 0%, 88.7%);--gray7: hsl(0, 0%, 85.8%);--gray8: hsl(0, 0%, 78%);--gray9: hsl(0, 0%, 56.1%);--gray10: hsl(0, 0%, 52.3%);--gray11: hsl(0, 0%, 43.5%);--gray12: hsl(0, 0%, 9%);--border-radius: 8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:none;z-index:999999999;transition:transform .4s ease}:where([data-sonner-toaster][data-lifted="true"]){transform:translateY(-10px)}@media (hover: none) and (pointer: coarse){:where([data-sonner-toaster][data-lifted="true"]){transform:none}}:where([data-sonner-toaster][data-x-position="right"]){right:var(--offset-right)}:where([data-sonner-toaster][data-x-position="left"]){left:var(--offset-left)}:where([data-sonner-toaster][data-x-position="center"]){left:50%;transform:translate(-50%)}:where([data-sonner-toaster][data-y-position="top"]){top:var(--offset-top)}:where([data-sonner-toaster][data-y-position="bottom"]){bottom:var(--offset-bottom)}:where([data-sonner-toast]){--y: translateY(100%);--lift-amount: calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);filter:blur(0);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:none;overflow-wrap:anywhere}:where([data-sonner-toast][data-styled="true"]){padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px #0000001a;width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}:where([data-sonner-toast]:focus-visible){box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast][data-y-position="top"]){top:0;--y: translateY(-100%);--lift: 1;--lift-amount: calc(1 * var(--gap))}:where([data-sonner-toast][data-y-position="bottom"]){bottom:0;--y: translateY(100%);--lift: -1;--lift-amount: calc(var(--lift) * var(--gap))}:where([data-sonner-toast]) :where([data-description]){font-weight:400;line-height:1.4;color:inherit}:where([data-sonner-toast]) :where([data-title]){font-weight:500;line-height:1.5;color:inherit}:where([data-sonner-toast]) :where([data-icon]){display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}:where([data-sonner-toast][data-promise="true"]) :where([data-icon])>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}:where([data-sonner-toast]) :where([data-icon])>*{flex-shrink:0}:where([data-sonner-toast]) :where([data-icon]) svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}:where([data-sonner-toast]) :where([data-content]){display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:none;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}:where([data-sonner-toast]) :where([data-button]):focus-visible{box-shadow:0 0 0 2px #0006}:where([data-sonner-toast]) :where([data-button]):first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}:where([data-sonner-toast]) :where([data-cancel]){color:var(--normal-text);background:rgba(0,0,0,.08)}:where([data-sonner-toast][data-theme="dark"]) :where([data-cancel]){background:rgba(255,255,255,.3)}:where([data-sonner-toast]) :where([data-close-button]){position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]{background:var(--gray1)}:where([data-sonner-toast]) :where([data-close-button]):focus-visible{box-shadow:0 4px 12px #0000001a,0 0 0 2px #0003}:where([data-sonner-toast]) :where([data-disabled="true"]){cursor:not-allowed}:where([data-sonner-toast]):hover :where([data-close-button]):hover{background:var(--gray2);border-color:var(--gray5)}:where([data-sonner-toast][data-swiping="true"]):before{content:"";position:absolute;left:-50%;right:-50%;height:100%;z-index:-1}:where([data-sonner-toast][data-y-position="top"][data-swiping="true"]):before{bottom:50%;transform:scaleY(3) translateY(50%)}:where([data-sonner-toast][data-y-position="bottom"][data-swiping="true"]):before{top:50%;transform:scaleY(3) translateY(-50%)}:where([data-sonner-toast][data-swiping="false"][data-removed="true"]):before{content:"";position:absolute;inset:0;transform:scaleY(2)}:where([data-sonner-toast]):after{content:"";position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}:where([data-sonner-toast][data-mounted="true"]){--y: translateY(0);opacity:1}:where([data-sonner-toast][data-expanded="false"][data-front="false"]){--scale: var(--toasts-before) * .05 + 1;--y: translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}:where([data-sonner-toast])>*{transition:opacity .4s}:where([data-sonner-toast][data-expanded="false"][data-front="false"][data-styled="true"])>*{opacity:0}:where([data-sonner-toast][data-visible="false"]){opacity:0;pointer-events:none}:where([data-sonner-toast][data-mounted="true"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}:where([data-sonner-toast][data-removed="true"][data-front="true"][data-swipe-out="false"]){--y: translateY(calc(var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="true"]){--y: translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}:where([data-sonner-toast][data-removed="true"][data-front="false"][data-swipe-out="false"][data-expanded="false"]){--y: translateY(40%);opacity:0;transition:transform .5s,opacity .2s}:where([data-sonner-toast][data-removed="true"][data-front="false"]):before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y, 0px)) translate(var(--swipe-amount-x, 0px));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{0%{transform:var(--y) translate(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translate(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{0%{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width: 600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg: #fff;--normal-border: var(--gray4);--normal-text: var(--gray12);--success-bg: hsl(143, 85%, 96%);--success-border: hsl(145, 92%, 91%);--success-text: hsl(140, 100%, 27%);--info-bg: hsl(208, 100%, 97%);--info-border: hsl(221, 91%, 91%);--info-text: hsl(210, 92%, 45%);--warning-bg: hsl(49, 100%, 97%);--warning-border: hsl(49, 91%, 91%);--warning-text: hsl(31, 92%, 45%);--error-bg: hsl(359, 100%, 97%);--error-border: hsl(359, 100%, 94%);--error-text: hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg: #000;--normal-border: hsl(0, 0%, 20%);--normal-text: var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg: #fff;--normal-border: var(--gray3);--normal-text: var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg: #000;--normal-bg-hover: hsl(0, 0%, 12%);--normal-border: hsl(0, 0%, 20%);--normal-border-hover: hsl(0, 0%, 25%);--normal-text: var(--gray1);--success-bg: hsl(150, 100%, 6%);--success-border: hsl(147, 100%, 12%);--success-text: hsl(150, 86%, 65%);--info-bg: hsl(215, 100%, 6%);--info-border: hsl(223, 100%, 12%);--info-text: hsl(216, 87%, 65%);--warning-bg: hsl(64, 100%, 6%);--warning-border: hsl(60, 100%, 12%);--warning-text: hsl(46, 87%, 65%);--error-bg: hsl(358, 76%, 10%);--error-border: hsl(357, 89%, 16%);--error-text: hsl(358, 100%, 81%)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success],[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info],[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning],[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error],[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size: 16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:nth-child(1){animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}to{opacity:.15}}@media (prefers-reduced-motion){[data-sonner-toast],[data-sonner-toast]>*,.sonner-loading-bar{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}
`);
function uc(e) {
  return e.label !== void 0;
}
var IU = 3, yU = "32px", bU = "16px", $4 = 4e3, CU = 356, xU = 14, DU = 20, wU = 200;
function Kt(...e) {
  return e.filter(Boolean).join(" ");
}
function PU(e) {
  let [n, i] = e.split("-"), t = [];
  return n && t.push(n), i && t.push(i), t;
}
var RU = (e) => {
  var n, i, t, a, s, r, o, d, c, u, k;
  let { invert: m, toast: f, unstyled: p, interacting: h, setHeights: N, visibleToasts: S, heights: F, index: y, toasts: x, expanded: R, removeToast: T, defaultRichColors: j, closeButton: A, style: B, cancelButtonStyle: W, actionButtonStyle: E, className: $ = "", descriptionClassName: V = "", duration: H, position: O, gap: M, loadingIcon: L, expandByDefault: _, classNames: z, icons: ne, closeButtonAriaLabel: Se = "Close toast", pauseWhenPageIsHidden: he } = e, [ue, oe] = K.useState(null), [$e, we] = K.useState(null), [ie, De] = K.useState(!1), [_e, Ie] = K.useState(!1), [Fe, re] = K.useState(!1), [Me, ge] = K.useState(!1), [rn, Sn] = K.useState(!1), [Jn, Xn] = K.useState(0), [Mn, Zn] = K.useState(0), mn = K.useRef(f.duration || H || $4), We = K.useRef(null), pi = K.useRef(null), Fi = y === 0, ut = y + 1 <= S, ti = f.type, Ui = f.dismissible !== !1, Ct = f.className || "", xt = f.descriptionClassName || "", Di = K.useMemo(() => F.findIndex((je) => je.toastId === f.id) || 0, [F, f.id]), Bt = K.useMemo(() => {
    var je;
    return (je = f.closeButton) != null ? je : A;
  }, [f.closeButton, A]), wi = K.useMemo(() => f.duration || H || $4, [f.duration, H]), Pi = K.useRef(0), Vi = K.useRef(0), mt = K.useRef(0), ot = K.useRef(null), [qt, Gt] = O.split("-"), Le = K.useMemo(() => F.reduce((je, He, sn) => sn >= Di ? je : je + He.height, 0), [F, Di]), Xe = fU(), gn = f.invert || m, Ze = ti === "loading";
  Vi.current = K.useMemo(() => Di * M + Le, [Di, Le]), K.useEffect(() => {
    mn.current = wi;
  }, [wi]), K.useEffect(() => {
    De(!0);
  }, []), K.useEffect(() => {
    let je = pi.current;
    if (je) {
      let He = je.getBoundingClientRect().height;
      return Zn(He), N((sn) => [{ toastId: f.id, height: He, position: f.position }, ...sn]), () => N((sn) => sn.filter((ei) => ei.toastId !== f.id));
    }
  }, [N, f.id]), K.useLayoutEffect(() => {
    if (!ie) return;
    let je = pi.current, He = je.style.height;
    je.style.height = "auto";
    let sn = je.getBoundingClientRect().height;
    je.style.height = He, Zn(sn), N((ei) => ei.find((hn) => hn.toastId === f.id) ? ei.map((hn) => hn.toastId === f.id ? { ...hn, height: sn } : hn) : [{ toastId: f.id, height: sn, position: f.position }, ...ei]);
  }, [ie, f.title, f.description, N, f.id]);
  let vn = K.useCallback(() => {
    Ie(!0), Xn(Vi.current), N((je) => je.filter((He) => He.toastId !== f.id)), setTimeout(() => {
      T(f);
    }, wU);
  }, [f, T, N, Vi]);
  K.useEffect(() => {
    if (f.promise && ti === "loading" || f.duration === 1 / 0 || f.type === "loading") return;
    let je;
    return R || h || he && Xe ? (() => {
      if (mt.current < Pi.current) {
        let He = (/* @__PURE__ */ new Date()).getTime() - Pi.current;
        mn.current = mn.current - He;
      }
      mt.current = (/* @__PURE__ */ new Date()).getTime();
    })() : mn.current !== 1 / 0 && (Pi.current = (/* @__PURE__ */ new Date()).getTime(), je = setTimeout(() => {
      var He;
      (He = f.onAutoClose) == null || He.call(f, f), vn();
    }, mn.current)), () => clearTimeout(je);
  }, [R, h, f, ti, he, Xe, vn]), K.useEffect(() => {
    f.delete && vn();
  }, [vn, f.delete]);
  function zn() {
    var je, He, sn;
    return ne != null && ne.loading ? K.createElement("div", { className: Kt(z == null ? void 0 : z.loader, (je = f == null ? void 0 : f.classNames) == null ? void 0 : je.loader, "sonner-loader"), "data-visible": ti === "loading" }, ne.loading) : L ? K.createElement("div", { className: Kt(z == null ? void 0 : z.loader, (He = f == null ? void 0 : f.classNames) == null ? void 0 : He.loader, "sonner-loader"), "data-visible": ti === "loading" }, L) : K.createElement(oU, { className: Kt(z == null ? void 0 : z.loader, (sn = f == null ? void 0 : f.classNames) == null ? void 0 : sn.loader), visible: ti === "loading" });
  }
  return K.createElement("li", { tabIndex: 0, ref: pi, className: Kt($, Ct, z == null ? void 0 : z.toast, (n = f == null ? void 0 : f.classNames) == null ? void 0 : n.toast, z == null ? void 0 : z.default, z == null ? void 0 : z[ti], (i = f == null ? void 0 : f.classNames) == null ? void 0 : i[ti]), "data-sonner-toast": "", "data-rich-colors": (t = f.richColors) != null ? t : j, "data-styled": !(f.jsx || f.unstyled || p), "data-mounted": ie, "data-promise": !!f.promise, "data-swiped": rn, "data-removed": _e, "data-visible": ut, "data-y-position": qt, "data-x-position": Gt, "data-index": y, "data-front": Fi, "data-swiping": Fe, "data-dismissible": Ui, "data-type": ti, "data-invert": gn, "data-swipe-out": Me, "data-swipe-direction": $e, "data-expanded": !!(R || _ && ie), style: { "--index": y, "--toasts-before": y, "--z-index": x.length - y, "--offset": `${_e ? Jn : Vi.current}px`, "--initial-height": _ ? "auto" : `${Mn}px`, ...B, ...f.style }, onDragEnd: () => {
    re(!1), oe(null), ot.current = null;
  }, onPointerDown: (je) => {
    Ze || !Ui || (We.current = /* @__PURE__ */ new Date(), Xn(Vi.current), je.target.setPointerCapture(je.pointerId), je.target.tagName !== "BUTTON" && (re(!0), ot.current = { x: je.clientX, y: je.clientY }));
  }, onPointerUp: () => {
    var je, He, sn, ei;
    if (Me || !Ui) return;
    ot.current = null;
    let hn = Number(((je = pi.current) == null ? void 0 : je.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), ni = Number(((He = pi.current) == null ? void 0 : He.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), _i = (/* @__PURE__ */ new Date()).getTime() - ((sn = We.current) == null ? void 0 : sn.getTime()), ui = ue === "x" ? hn : ni, kt = Math.abs(ui) / _i;
    if (Math.abs(ui) >= DU || kt > 0.11) {
      Xn(Vi.current), (ei = f.onDismiss) == null || ei.call(f, f), we(ue === "x" ? hn > 0 ? "right" : "left" : ni > 0 ? "down" : "up"), vn(), ge(!0), Sn(!1);
      return;
    }
    re(!1), oe(null);
  }, onPointerMove: (je) => {
    var He, sn, ei, hn;
    if (!ot.current || !Ui || ((He = window.getSelection()) == null ? void 0 : He.toString().length) > 0) return;
    let ni = je.clientY - ot.current.y, _i = je.clientX - ot.current.x, ui = (sn = e.swipeDirections) != null ? sn : PU(O);
    !ue && (Math.abs(_i) > 1 || Math.abs(ni) > 1) && oe(Math.abs(_i) > Math.abs(ni) ? "x" : "y");
    let kt = { x: 0, y: 0 };
    ue === "y" ? (ui.includes("top") || ui.includes("bottom")) && (ui.includes("top") && ni < 0 || ui.includes("bottom") && ni > 0) && (kt.y = ni) : ue === "x" && (ui.includes("left") || ui.includes("right")) && (ui.includes("left") && _i < 0 || ui.includes("right") && _i > 0) && (kt.x = _i), (Math.abs(kt.x) > 0 || Math.abs(kt.y) > 0) && Sn(!0), (ei = pi.current) == null || ei.style.setProperty("--swipe-amount-x", `${kt.x}px`), (hn = pi.current) == null || hn.style.setProperty("--swipe-amount-y", `${kt.y}px`);
  } }, Bt && !f.jsx ? K.createElement("button", { "aria-label": Se, "data-disabled": Ze, "data-close-button": !0, onClick: Ze || !Ui ? () => {
  } : () => {
    var je;
    vn(), (je = f.onDismiss) == null || je.call(f, f);
  }, className: Kt(z == null ? void 0 : z.closeButton, (a = f == null ? void 0 : f.classNames) == null ? void 0 : a.closeButton) }, (s = ne == null ? void 0 : ne.close) != null ? s : kU) : null, f.jsx || jc(f.title) ? f.jsx ? f.jsx : typeof f.title == "function" ? f.title() : f.title : K.createElement(K.Fragment, null, ti || f.icon || f.promise ? K.createElement("div", { "data-icon": "", className: Kt(z == null ? void 0 : z.icon, (r = f == null ? void 0 : f.classNames) == null ? void 0 : r.icon) }, f.promise || f.type === "loading" && !f.icon ? f.icon || zn() : null, f.type !== "loading" ? f.icon || (ne == null ? void 0 : ne[ti]) || sU(ti) : null) : null, K.createElement("div", { "data-content": "", className: Kt(z == null ? void 0 : z.content, (o = f == null ? void 0 : f.classNames) == null ? void 0 : o.content) }, K.createElement("div", { "data-title": "", className: Kt(z == null ? void 0 : z.title, (d = f == null ? void 0 : f.classNames) == null ? void 0 : d.title) }, typeof f.title == "function" ? f.title() : f.title), f.description ? K.createElement("div", { "data-description": "", className: Kt(V, xt, z == null ? void 0 : z.description, (c = f == null ? void 0 : f.classNames) == null ? void 0 : c.description) }, typeof f.description == "function" ? f.description() : f.description) : null), jc(f.cancel) ? f.cancel : f.cancel && uc(f.cancel) ? K.createElement("button", { "data-button": !0, "data-cancel": !0, style: f.cancelButtonStyle || W, onClick: (je) => {
    var He, sn;
    uc(f.cancel) && Ui && ((sn = (He = f.cancel).onClick) == null || sn.call(He, je), vn());
  }, className: Kt(z == null ? void 0 : z.cancelButton, (u = f == null ? void 0 : f.classNames) == null ? void 0 : u.cancelButton) }, f.cancel.label) : null, jc(f.action) ? f.action : f.action && uc(f.action) ? K.createElement("button", { "data-button": !0, "data-action": !0, style: f.actionButtonStyle || E, onClick: (je) => {
    var He, sn;
    uc(f.action) && ((sn = (He = f.action).onClick) == null || sn.call(He, je), !je.defaultPrevented && vn());
  }, className: Kt(z == null ? void 0 : z.actionButton, (k = f == null ? void 0 : f.classNames) == null ? void 0 : k.actionButton) }, f.action.label) : null));
};
function U4() {
  if (typeof window == "undefined" || typeof document == "undefined") return "ltr";
  let e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function TU(e, n) {
  let i = {};
  return [e, n].forEach((t, a) => {
    let s = a === 1, r = s ? "--mobile-offset" : "--offset", o = s ? bU : yU;
    function d(c) {
      ["top", "right", "bottom", "left"].forEach((u) => {
        i[`${r}-${u}`] = typeof c == "number" ? `${c}px` : c;
      });
    }
    typeof t == "number" || typeof t == "string" ? d(t) : typeof t == "object" ? ["top", "right", "bottom", "left"].forEach((c) => {
      t[c] === void 0 ? i[`${r}-${c}`] = o : i[`${r}-${c}`] = typeof t[c] == "number" ? `${t[c]}px` : t[c];
    }) : d(o);
  }), i;
}
var jU = Li(function(e, n) {
  let { invert: i, position: t = "bottom-right", hotkey: a = ["altKey", "KeyT"], expand: s, closeButton: r, className: o, offset: d, mobileOffset: c, theme: u = "light", richColors: k, duration: m, style: f, visibleToasts: p = IU, toastOptions: h, dir: N = U4(), gap: S = xU, loadingIcon: F, icons: y, containerAriaLabel: x = "Notifications", pauseWhenPageIsHidden: R } = e, [T, j] = K.useState([]), A = K.useMemo(() => Array.from(new Set([t].concat(T.filter((he) => he.position).map((he) => he.position)))), [T, t]), [B, W] = K.useState([]), [E, $] = K.useState(!1), [V, H] = K.useState(!1), [O, M] = K.useState(u !== "system" ? u : typeof window != "undefined" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), L = K.useRef(null), _ = a.join("+").replace(/Key/g, "").replace(/Digit/g, ""), z = K.useRef(null), ne = K.useRef(!1), Se = K.useCallback((he) => {
    j((ue) => {
      var oe;
      return (oe = ue.find(($e) => $e.id === he.id)) != null && oe.delete || ht.dismiss(he.id), ue.filter(({ id: $e }) => $e !== he.id);
    });
  }, []);
  return K.useEffect(() => ht.subscribe((he) => {
    if (he.dismiss) {
      j((ue) => ue.map((oe) => oe.id === he.id ? { ...oe, delete: !0 } : oe));
      return;
    }
    setTimeout(() => {
      pf.flushSync(() => {
        j((ue) => {
          let oe = ue.findIndex(($e) => $e.id === he.id);
          return oe !== -1 ? [...ue.slice(0, oe), { ...ue[oe], ...he }, ...ue.slice(oe + 1)] : [he, ...ue];
        });
      });
    });
  }), []), K.useEffect(() => {
    if (u !== "system") {
      M(u);
      return;
    }
    if (u === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? M("dark") : M("light")), typeof window == "undefined") return;
    let he = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      he.addEventListener("change", ({ matches: ue }) => {
        M(ue ? "dark" : "light");
      });
    } catch (ue) {
      he.addListener(({ matches: oe }) => {
        try {
          M(oe ? "dark" : "light");
        } catch ($e) {
          console.error($e);
        }
      });
    }
  }, [u]), K.useEffect(() => {
    T.length <= 1 && $(!1);
  }, [T]), K.useEffect(() => {
    let he = (ue) => {
      var oe, $e;
      a.every((we) => ue[we] || ue.code === we) && ($(!0), (oe = L.current) == null || oe.focus()), ue.code === "Escape" && (document.activeElement === L.current || ($e = L.current) != null && $e.contains(document.activeElement)) && $(!1);
    };
    return document.addEventListener("keydown", he), () => document.removeEventListener("keydown", he);
  }, [a]), K.useEffect(() => {
    if (L.current) return () => {
      z.current && (z.current.focus({ preventScroll: !0 }), z.current = null, ne.current = !1);
    };
  }, [L.current]), K.createElement("section", { ref: n, "aria-label": `${x} ${_}`, tabIndex: -1, "aria-live": "polite", "aria-relevant": "additions text", "aria-atomic": "false", suppressHydrationWarning: !0 }, A.map((he, ue) => {
    var oe;
    let [$e, we] = he.split("-");
    return T.length ? K.createElement("ol", { key: he, dir: N === "auto" ? U4() : N, tabIndex: -1, ref: L, className: o, "data-sonner-toaster": !0, "data-theme": O, "data-y-position": $e, "data-lifted": E && T.length > 1 && !s, "data-x-position": we, style: { "--front-toast-height": `${((oe = B[0]) == null ? void 0 : oe.height) || 0}px`, "--width": `${CU}px`, "--gap": `${S}px`, ...f, ...TU(d, c) }, onBlur: (ie) => {
      ne.current && !ie.currentTarget.contains(ie.relatedTarget) && (ne.current = !1, z.current && (z.current.focus({ preventScroll: !0 }), z.current = null));
    }, onFocus: (ie) => {
      ie.target instanceof HTMLElement && ie.target.dataset.dismissible === "false" || ne.current || (ne.current = !0, z.current = ie.relatedTarget);
    }, onMouseEnter: () => $(!0), onMouseMove: () => $(!0), onMouseLeave: () => {
      V || $(!1);
    }, onDragEnd: () => $(!1), onPointerDown: (ie) => {
      ie.target instanceof HTMLElement && ie.target.dataset.dismissible === "false" || H(!0);
    }, onPointerUp: () => H(!1) }, T.filter((ie) => !ie.position && ue === 0 || ie.position === he).map((ie, De) => {
      var _e, Ie;
      return K.createElement(RU, { key: ie.id, icons: y, index: De, toast: ie, defaultRichColors: k, duration: (_e = h == null ? void 0 : h.duration) != null ? _e : m, className: h == null ? void 0 : h.className, descriptionClassName: h == null ? void 0 : h.descriptionClassName, invert: i, visibleToasts: p, closeButton: (Ie = h == null ? void 0 : h.closeButton) != null ? Ie : r, interacting: V, position: he, style: h == null ? void 0 : h.style, unstyled: h == null ? void 0 : h.unstyled, classNames: h == null ? void 0 : h.classNames, cancelButtonStyle: h == null ? void 0 : h.cancelButtonStyle, actionButtonStyle: h == null ? void 0 : h.actionButtonStyle, removeToast: Se, toasts: T.filter((Fe) => Fe.position == ie.position), heights: B.filter((Fe) => Fe.position == ie.position), setHeights: W, expandByDefault: s, gap: S, loadingIcon: F, expanded: E, pauseWhenPageIsHidden: R, swipeDirections: e.swipeDirections });
    })) : null;
  }));
});
const l1 = ({ ...e }) => {
  const n = yr();
  return /* @__PURE__ */ l.jsx(Lv, { container: n, children: /* @__PURE__ */ l.jsx(
    jU,
    {
      theme: "light",
      className: "ch-toaster ch-group",
      toastOptions: {
        classNames: {
          toast: "group toast group-[.toaster]:ch-bg-white group-[.toaster]:ch-text-gray-950 group-[.toaster]:ch-border-gray-200 group-[.toaster]:ch-shadow-lg",
          title: "group-[.toast]:ch-text-gray-900 group-[.toast]:ch-text-base",
          error: "group-[.toast]:ch-bg-urgent-100 group-[.toast]:ch-text-urgent-400",
          description: "group-[.toast]:ch-text-gray-500",
          actionButton: "group-[.toast]:ch-bg-gray-900 group-[.toast]:ch-text-gray-50",
          cancelButton: "group-[.toast]:ch-bg-gray-100 group-[.toast]:ch-text-gray-500"
        }
      },
      offset: "64px",
      ...e
    }
  ) });
}, H0 = {
  position: "top-center",
  richColors: !0
}, Uv = () => {
  const e = I((t) => {
    $1().addInfo(t);
  }, []), n = I((t) => {
    $1().addError(t);
  }, []), i = I((t) => {
    $1().addWarning(t);
  }, []);
  return {
    addInfo: e,
    addError: n,
    addWarning: i
  };
}, $1 = () => ({
  addInfo: (t) => {
    V0.info(t, { ...H0, richColors: !1, icon: /* @__PURE__ */ l.jsx(zP, { size: "sm" }) });
  },
  addError: (t) => {
    V0.error(t, H0);
  },
  addWarning: (t) => {
    V0.warning(t, H0);
  }
}), AU = { enabled: !0 }, Y5 = Ot(AU), Yxe = ({ enabled: e, children: n }) => {
  const i = v(() => ({ enabled: e }), [e]);
  return /* @__PURE__ */ l.jsx(Y5.Provider, { value: i, children: n });
}, X5 = (e) => {
  e.preventDefault(), e.returnValue = !1;
}, OU = () => {
  window.addEventListener("beforeunload", X5);
}, EU = () => {
  window.removeEventListener("beforeunload", X5);
}, Mc = {
  onEnableBeforeUnload: OU,
  onDisableBeforeUnload: EU
}, JU = {
  onEnableBeforeUnload: () => {
  },
  onDisableBeforeUnload: () => {
  }
}, Z5 = Ot(Mc), s1 = ({ children: e }) => {
  const { enabled: n } = oi(Y5);
  return be(() => {
    if (n)
      return Mc.onEnableBeforeUnload(), () => {
        Mc.onDisableBeforeUnload();
      };
  }, [n]), /* @__PURE__ */ l.jsx(Z5.Provider, { value: n ? Mc : JU, children: e });
}, gd = () => {
  const e = oi(Z5);
  if (!e)
    throw new Error("useBeforeUnload must be used within a BeforeUnloadContext.Provider");
  return e;
}, _U = { enabled: !0 }, eC = Ot(_U), Xxe = ({ enabled: e, children: n }) => {
  const i = v(() => ({ enabled: e }), [e]);
  return /* @__PURE__ */ l.jsx(eC.Provider, { value: i, children: n });
}, QU = () => oi(eC), r1 = (e = !0) => {
  be(() => {
    if (typeof document !== void 0)
      return e ? document.body.style.overflow = "hidden" : document.body.style.overflow = "auto", () => {
        document.body.style.overflow = "auto";
      };
  }, [e]);
}, MU = (e = !0) => {
  const n = I(
    (i) => {
      e && i.preventDefault();
    },
    [e]
  );
  be(() => {
    if (typeof document !== void 0)
      return e ? (document.body.style.pointerEvents = "none", document.addEventListener("keydown", n)) : (document.body.style.pointerEvents = "auto", document.removeEventListener("keydown", n)), () => {
        document.body.style.pointerEvents = "auto", document.removeEventListener("keydown", n);
      };
  }, [e, n]);
}, nC = Ot({}), o1 = ({ children: e }) => {
  const [n, i] = se(!1);
  MU(n);
  const t = I(() => {
    i(!0);
  }, []), a = I(() => {
    i(!1);
  }, []), s = v(
    () => ({
      onShowLoadingScreenCallback: t,
      onHideLoadingScreenCallback: a
    }),
    [t, a]
  );
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    n ? /* @__PURE__ */ l.jsx(qL, {}) : null,
    /* @__PURE__ */ l.jsx(nC.Provider, { value: s, children: e })
  ] });
}, fn = () => {
  const e = oi(nC);
  if (!e)
    throw new Error("useLoadingScreen must be used within a ShowLoadingScreenToUserContext.Provider");
  return e;
}, Vv = "-", LU = (e) => {
  const n = UU(e), {
    conflictingClassGroups: i,
    conflictingClassGroupModifiers: t
  } = e;
  return {
    getClassGroupId: (r) => {
      const o = r.split(Vv);
      return o[0] === "" && o.length !== 1 && o.shift(), iC(o, n) || $U(r);
    },
    getConflictingClassGroupIds: (r, o) => {
      const d = i[r] || [];
      return o && t[r] ? [...d, ...t[r]] : d;
    }
  };
}, iC = (e, n) => {
  var r;
  if (e.length === 0)
    return n.classGroupId;
  const i = e[0], t = n.nextPart.get(i), a = t ? iC(e.slice(1), t) : void 0;
  if (a)
    return a;
  if (n.validators.length === 0)
    return;
  const s = e.join(Vv);
  return (r = n.validators.find(({
    validator: o
  }) => o(s))) == null ? void 0 : r.classGroupId;
}, V4 = /^\[(.+)\]$/, $U = (e) => {
  if (V4.test(e)) {
    const n = V4.exec(e)[1], i = n == null ? void 0 : n.substring(0, n.indexOf(":"));
    if (i)
      return "arbitrary.." + i;
  }
}, UU = (e) => {
  const {
    theme: n,
    prefix: i
  } = e, t = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return HU(Object.entries(e.classGroups), i).forEach(([s, r]) => {
    kk(r, t, s, n);
  }), t;
}, kk = (e, n, i, t) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const s = a === "" ? n : H4(n, a);
      s.classGroupId = i;
      return;
    }
    if (typeof a == "function") {
      if (VU(a)) {
        kk(a(t), n, i, t);
        return;
      }
      n.validators.push({
        validator: a,
        classGroupId: i
      });
      return;
    }
    Object.entries(a).forEach(([s, r]) => {
      kk(r, H4(n, s), i, t);
    });
  });
}, H4 = (e, n) => {
  let i = e;
  return n.split(Vv).forEach((t) => {
    i.nextPart.has(t) || i.nextPart.set(t, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), i = i.nextPart.get(t);
  }), i;
}, VU = (e) => e.isThemeGetter, HU = (e, n) => n ? e.map(([i, t]) => {
  const a = t.map((s) => typeof s == "string" ? n + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([r, o]) => [n + r, o])) : s);
  return [i, a];
}) : e, zU = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let n = 0, i = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  const a = (s, r) => {
    i.set(s, r), n++, n > e && (n = 0, t = i, i = /* @__PURE__ */ new Map());
  };
  return {
    get(s) {
      let r = i.get(s);
      if (r !== void 0)
        return r;
      if ((r = t.get(s)) !== void 0)
        return a(s, r), r;
    },
    set(s, r) {
      i.has(s) ? i.set(s, r) : a(s, r);
    }
  };
}, tC = "!", BU = (e) => {
  const {
    separator: n,
    experimentalParseClassName: i
  } = e, t = n.length === 1, a = n[0], s = n.length, r = (o) => {
    const d = [];
    let c = 0, u = 0, k;
    for (let N = 0; N < o.length; N++) {
      let S = o[N];
      if (c === 0) {
        if (S === a && (t || o.slice(N, N + s) === n)) {
          d.push(o.slice(u, N)), u = N + s;
          continue;
        }
        if (S === "/") {
          k = N;
          continue;
        }
      }
      S === "[" ? c++ : S === "]" && c--;
    }
    const m = d.length === 0 ? o : o.substring(u), f = m.startsWith(tC), p = f ? m.substring(1) : m, h = k && k > u ? k - u : void 0;
    return {
      modifiers: d,
      hasImportantModifier: f,
      baseClassName: p,
      maybePostfixModifierPosition: h
    };
  };
  return i ? (o) => i({
    className: o,
    parseClassName: r
  }) : r;
}, qU = (e) => {
  if (e.length <= 1)
    return e;
  const n = [];
  let i = [];
  return e.forEach((t) => {
    t[0] === "[" ? (n.push(...i.sort(), t), i = []) : i.push(t);
  }), n.push(...i.sort()), n;
}, GU = (e) => ({
  cache: zU(e.cacheSize),
  parseClassName: BU(e),
  ...LU(e)
}), WU = /\s+/, KU = (e, n) => {
  const {
    parseClassName: i,
    getClassGroupId: t,
    getConflictingClassGroupIds: a
  } = n, s = [], r = e.trim().split(WU);
  let o = "";
  for (let d = r.length - 1; d >= 0; d -= 1) {
    const c = r[d], {
      modifiers: u,
      hasImportantModifier: k,
      baseClassName: m,
      maybePostfixModifierPosition: f
    } = i(c);
    let p = !!f, h = t(p ? m.substring(0, f) : m);
    if (!h) {
      if (!p) {
        o = c + (o.length > 0 ? " " + o : o);
        continue;
      }
      if (h = t(m), !h) {
        o = c + (o.length > 0 ? " " + o : o);
        continue;
      }
      p = !1;
    }
    const N = qU(u).join(":"), S = k ? N + tC : N, F = S + h;
    if (s.includes(F))
      continue;
    s.push(F);
    const y = a(h, p);
    for (let x = 0; x < y.length; ++x) {
      const R = y[x];
      s.push(S + R);
    }
    o = c + (o.length > 0 ? " " + o : o);
  }
  return o;
};
function YU() {
  let e = 0, n, i, t = "";
  for (; e < arguments.length; )
    (n = arguments[e++]) && (i = aC(n)) && (t && (t += " "), t += i);
  return t;
}
const aC = (e) => {
  if (typeof e == "string")
    return e;
  let n, i = "";
  for (let t = 0; t < e.length; t++)
    e[t] && (n = aC(e[t])) && (i && (i += " "), i += n);
  return i;
};
function XU(e, ...n) {
  let i, t, a, s = r;
  function r(d) {
    const c = n.reduce((u, k) => k(u), e());
    return i = GU(c), t = i.cache.get, a = i.cache.set, s = o, o(d);
  }
  function o(d) {
    const c = t(d);
    if (c)
      return c;
    const u = KU(d, i);
    return a(d, u), u;
  }
  return function() {
    return s(YU.apply(null, arguments));
  };
}
const Wn = (e) => {
  const n = (i) => i[e] || [];
  return n.isThemeGetter = !0, n;
}, lC = /^\[(?:([a-z-]+):)?(.+)\]$/i, ZU = /^\d+\/\d+$/, eV = /* @__PURE__ */ new Set(["px", "full", "screen"]), nV = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, iV = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, tV = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, aV = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, lV = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Wa = (e) => U1(e) || eV.has(e) || ZU.test(e), Cl = (e) => Rr(e, "length", kV), U1 = (e) => !!e && !Number.isNaN(Number(e)), z0 = (e) => Rr(e, "number", U1), no = (e) => !!e && Number.isInteger(Number(e)), sV = (e) => e.endsWith("%") && U1(e.slice(0, -1)), on = (e) => lC.test(e), xl = (e) => nV.test(e), rV = /* @__PURE__ */ new Set(["length", "size", "percentage"]), oV = (e) => Rr(e, rV, sC), dV = (e) => Rr(e, "position", sC), cV = /* @__PURE__ */ new Set(["image", "url"]), uV = (e) => Rr(e, cV, vV), mV = (e) => Rr(e, "", fV), io = () => !0, Rr = (e, n, i) => {
  const t = lC.exec(e);
  return t ? t[1] ? typeof n == "string" ? t[1] === n : n.has(t[1]) : i(t[2]) : !1;
}, kV = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  iV.test(e) && !tV.test(e)
), sC = () => !1, fV = (e) => aV.test(e), vV = (e) => lV.test(e), hV = () => {
  const e = Wn("colors"), n = Wn("spacing"), i = Wn("blur"), t = Wn("brightness"), a = Wn("borderColor"), s = Wn("borderRadius"), r = Wn("borderSpacing"), o = Wn("borderWidth"), d = Wn("contrast"), c = Wn("grayscale"), u = Wn("hueRotate"), k = Wn("invert"), m = Wn("gap"), f = Wn("gradientColorStops"), p = Wn("gradientColorStopPositions"), h = Wn("inset"), N = Wn("margin"), S = Wn("opacity"), F = Wn("padding"), y = Wn("saturate"), x = Wn("scale"), R = Wn("sepia"), T = Wn("skew"), j = Wn("space"), A = Wn("translate"), B = () => ["auto", "contain", "none"], W = () => ["auto", "hidden", "clip", "visible", "scroll"], E = () => ["auto", on, n], $ = () => [on, n], V = () => ["", Wa, Cl], H = () => ["auto", U1, on], O = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], M = () => ["solid", "dashed", "dotted", "double", "none"], L = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], _ = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], z = () => ["", "0", on], ne = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Se = () => [U1, on];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [io],
      spacing: [Wa, Cl],
      blur: ["none", "", xl, on],
      brightness: Se(),
      borderColor: [e],
      borderRadius: ["none", "", "full", xl, on],
      borderSpacing: $(),
      borderWidth: V(),
      contrast: Se(),
      grayscale: z(),
      hueRotate: Se(),
      invert: z(),
      gap: $(),
      gradientColorStops: [e],
      gradientColorStopPositions: [sV, Cl],
      inset: E(),
      margin: E(),
      opacity: Se(),
      padding: $(),
      saturate: Se(),
      scale: Se(),
      sepia: z(),
      skew: Se(),
      space: $(),
      translate: $()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", on]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [xl]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": ne()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": ne()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...O(), on]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: W()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": W()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": W()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", no, on]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: E()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", on]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: z()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: z()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", no, on]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [io]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", no, on]
        }, on]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": H()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": H()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [io]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [no, on]
        }, on]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": H()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": H()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", on]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", on]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [m]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [m]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [m]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ..._()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ..._(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [..._(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [F]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [F]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [F]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [F]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [F]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [F]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [F]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [F]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [F]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [N]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [N]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [N]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [N]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [N]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [N]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [N]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [N]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [N]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [j]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [j]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", on, n]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [on, n, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [on, n, "none", "full", "min", "max", "fit", "prose", {
          screen: [xl]
        }, xl]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [on, n, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [on, n, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [on, n, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [on, n, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", xl, Cl]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", z0]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [io]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", on]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", U1, z0]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Wa, on]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", on]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", on]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [S]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [S]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...M(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Wa, Cl]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Wa, on]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: $()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", on]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", on]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [S]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...O(), dV]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", oV]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, uV]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [f]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [f]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [f]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [o]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [o]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [o]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [o]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [o]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [o]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [o]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [o]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [o]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [S]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...M(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [o]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [o]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [S]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: M()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...M()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Wa, on]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Wa, Cl]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: V()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [S]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Wa, Cl]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", xl, mV]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [io]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [S]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...L(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": L()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [i]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [t]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [d]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", xl, on]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [k]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [y]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [R]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [i]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [t]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [d]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [k]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [S]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [y]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [R]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [r]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [r]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [r]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", on]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Se()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", on]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Se()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", on]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [no, on]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [A]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [A]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [T]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [T]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", on]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", on]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": $()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": $()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": $()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": $()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": $()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": $()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": $()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": $()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": $()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": $()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": $()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": $()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": $()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": $()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": $()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": $()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": $()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": $()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", on]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Wa, Cl, z0]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, pV = /* @__PURE__ */ XU(hV);
function ce(...e) {
  return pV(iI(e));
}
var rC = { exports: {} };
(function(e, n) {
  (function(i, t) {
    e.exports = t();
  })(Be, function() {
    var i = 1e3, t = 6e4, a = 36e5, s = "millisecond", r = "second", o = "minute", d = "hour", c = "day", u = "week", k = "month", m = "quarter", f = "year", p = "date", h = "Invalid Date", N = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, S = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, F = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(H) {
      var O = ["th", "st", "nd", "rd"], M = H % 100;
      return "[" + H + (O[(M - 20) % 10] || O[M] || O[0]) + "]";
    } }, y = function(H, O, M) {
      var L = String(H);
      return !L || L.length >= O ? H : "" + Array(O + 1 - L.length).join(M) + H;
    }, x = { s: y, z: function(H) {
      var O = -H.utcOffset(), M = Math.abs(O), L = Math.floor(M / 60), _ = M % 60;
      return (O <= 0 ? "+" : "-") + y(L, 2, "0") + ":" + y(_, 2, "0");
    }, m: function H(O, M) {
      if (O.date() < M.date()) return -H(M, O);
      var L = 12 * (M.year() - O.year()) + (M.month() - O.month()), _ = O.clone().add(L, k), z = M - _ < 0, ne = O.clone().add(L + (z ? -1 : 1), k);
      return +(-(L + (M - _) / (z ? _ - ne : ne - _)) || 0);
    }, a: function(H) {
      return H < 0 ? Math.ceil(H) || 0 : Math.floor(H);
    }, p: function(H) {
      return { M: k, y: f, w: u, d: c, D: p, h: d, m: o, s: r, ms: s, Q: m }[H] || String(H || "").toLowerCase().replace(/s$/, "");
    }, u: function(H) {
      return H === void 0;
    } }, R = "en", T = {};
    T[R] = F;
    var j = "$isDayjsObject", A = function(H) {
      return H instanceof $ || !(!H || !H[j]);
    }, B = function H(O, M, L) {
      var _;
      if (!O) return R;
      if (typeof O == "string") {
        var z = O.toLowerCase();
        T[z] && (_ = z), M && (T[z] = M, _ = z);
        var ne = O.split("-");
        if (!_ && ne.length > 1) return H(ne[0]);
      } else {
        var Se = O.name;
        T[Se] = O, _ = Se;
      }
      return !L && _ && (R = _), _ || !L && R;
    }, W = function(H, O) {
      if (A(H)) return H.clone();
      var M = typeof O == "object" ? O : {};
      return M.date = H, M.args = arguments, new $(M);
    }, E = x;
    E.l = B, E.i = A, E.w = function(H, O) {
      return W(H, { locale: O.$L, utc: O.$u, x: O.$x, $offset: O.$offset });
    };
    var $ = function() {
      function H(M) {
        this.$L = B(M.locale, null, !0), this.parse(M), this.$x = this.$x || M.x || {}, this[j] = !0;
      }
      var O = H.prototype;
      return O.parse = function(M) {
        this.$d = function(L) {
          var _ = L.date, z = L.utc;
          if (_ === null) return /* @__PURE__ */ new Date(NaN);
          if (E.u(_)) return /* @__PURE__ */ new Date();
          if (_ instanceof Date) return new Date(_);
          if (typeof _ == "string" && !/Z$/i.test(_)) {
            var ne = _.match(N);
            if (ne) {
              var Se = ne[2] - 1 || 0, he = (ne[7] || "0").substring(0, 3);
              return z ? new Date(Date.UTC(ne[1], Se, ne[3] || 1, ne[4] || 0, ne[5] || 0, ne[6] || 0, he)) : new Date(ne[1], Se, ne[3] || 1, ne[4] || 0, ne[5] || 0, ne[6] || 0, he);
            }
          }
          return new Date(_);
        }(M), this.init();
      }, O.init = function() {
        var M = this.$d;
        this.$y = M.getFullYear(), this.$M = M.getMonth(), this.$D = M.getDate(), this.$W = M.getDay(), this.$H = M.getHours(), this.$m = M.getMinutes(), this.$s = M.getSeconds(), this.$ms = M.getMilliseconds();
      }, O.$utils = function() {
        return E;
      }, O.isValid = function() {
        return this.$d.toString() !== h;
      }, O.isSame = function(M, L) {
        var _ = W(M);
        return this.startOf(L) <= _ && _ <= this.endOf(L);
      }, O.isAfter = function(M, L) {
        return W(M) < this.startOf(L);
      }, O.isBefore = function(M, L) {
        return this.endOf(L) < W(M);
      }, O.$g = function(M, L, _) {
        return E.u(M) ? this[L] : this.set(_, M);
      }, O.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, O.valueOf = function() {
        return this.$d.getTime();
      }, O.startOf = function(M, L) {
        var _ = this, z = !!E.u(L) || L, ne = E.p(M), Se = function(_e, Ie) {
          var Fe = E.w(_.$u ? Date.UTC(_.$y, Ie, _e) : new Date(_.$y, Ie, _e), _);
          return z ? Fe : Fe.endOf(c);
        }, he = function(_e, Ie) {
          return E.w(_.toDate()[_e].apply(_.toDate("s"), (z ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Ie)), _);
        }, ue = this.$W, oe = this.$M, $e = this.$D, we = "set" + (this.$u ? "UTC" : "");
        switch (ne) {
          case f:
            return z ? Se(1, 0) : Se(31, 11);
          case k:
            return z ? Se(1, oe) : Se(0, oe + 1);
          case u:
            var ie = this.$locale().weekStart || 0, De = (ue < ie ? ue + 7 : ue) - ie;
            return Se(z ? $e - De : $e + (6 - De), oe);
          case c:
          case p:
            return he(we + "Hours", 0);
          case d:
            return he(we + "Minutes", 1);
          case o:
            return he(we + "Seconds", 2);
          case r:
            return he(we + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, O.endOf = function(M) {
        return this.startOf(M, !1);
      }, O.$set = function(M, L) {
        var _, z = E.p(M), ne = "set" + (this.$u ? "UTC" : ""), Se = (_ = {}, _[c] = ne + "Date", _[p] = ne + "Date", _[k] = ne + "Month", _[f] = ne + "FullYear", _[d] = ne + "Hours", _[o] = ne + "Minutes", _[r] = ne + "Seconds", _[s] = ne + "Milliseconds", _)[z], he = z === c ? this.$D + (L - this.$W) : L;
        if (z === k || z === f) {
          var ue = this.clone().set(p, 1);
          ue.$d[Se](he), ue.init(), this.$d = ue.set(p, Math.min(this.$D, ue.daysInMonth())).$d;
        } else Se && this.$d[Se](he);
        return this.init(), this;
      }, O.set = function(M, L) {
        return this.clone().$set(M, L);
      }, O.get = function(M) {
        return this[E.p(M)]();
      }, O.add = function(M, L) {
        var _, z = this;
        M = Number(M);
        var ne = E.p(L), Se = function(oe) {
          var $e = W(z);
          return E.w($e.date($e.date() + Math.round(oe * M)), z);
        };
        if (ne === k) return this.set(k, this.$M + M);
        if (ne === f) return this.set(f, this.$y + M);
        if (ne === c) return Se(1);
        if (ne === u) return Se(7);
        var he = (_ = {}, _[o] = t, _[d] = a, _[r] = i, _)[ne] || 1, ue = this.$d.getTime() + M * he;
        return E.w(ue, this);
      }, O.subtract = function(M, L) {
        return this.add(-1 * M, L);
      }, O.format = function(M) {
        var L = this, _ = this.$locale();
        if (!this.isValid()) return _.invalidDate || h;
        var z = M || "YYYY-MM-DDTHH:mm:ssZ", ne = E.z(this), Se = this.$H, he = this.$m, ue = this.$M, oe = _.weekdays, $e = _.months, we = _.meridiem, ie = function(Ie, Fe, re, Me) {
          return Ie && (Ie[Fe] || Ie(L, z)) || re[Fe].slice(0, Me);
        }, De = function(Ie) {
          return E.s(Se % 12 || 12, Ie, "0");
        }, _e = we || function(Ie, Fe, re) {
          var Me = Ie < 12 ? "AM" : "PM";
          return re ? Me.toLowerCase() : Me;
        };
        return z.replace(S, function(Ie, Fe) {
          return Fe || function(re) {
            switch (re) {
              case "YY":
                return String(L.$y).slice(-2);
              case "YYYY":
                return E.s(L.$y, 4, "0");
              case "M":
                return ue + 1;
              case "MM":
                return E.s(ue + 1, 2, "0");
              case "MMM":
                return ie(_.monthsShort, ue, $e, 3);
              case "MMMM":
                return ie($e, ue);
              case "D":
                return L.$D;
              case "DD":
                return E.s(L.$D, 2, "0");
              case "d":
                return String(L.$W);
              case "dd":
                return ie(_.weekdaysMin, L.$W, oe, 2);
              case "ddd":
                return ie(_.weekdaysShort, L.$W, oe, 3);
              case "dddd":
                return oe[L.$W];
              case "H":
                return String(Se);
              case "HH":
                return E.s(Se, 2, "0");
              case "h":
                return De(1);
              case "hh":
                return De(2);
              case "a":
                return _e(Se, he, !0);
              case "A":
                return _e(Se, he, !1);
              case "m":
                return String(he);
              case "mm":
                return E.s(he, 2, "0");
              case "s":
                return String(L.$s);
              case "ss":
                return E.s(L.$s, 2, "0");
              case "SSS":
                return E.s(L.$ms, 3, "0");
              case "Z":
                return ne;
            }
            return null;
          }(Ie) || ne.replace(":", "");
        });
      }, O.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, O.diff = function(M, L, _) {
        var z, ne = this, Se = E.p(L), he = W(M), ue = (he.utcOffset() - this.utcOffset()) * t, oe = this - he, $e = function() {
          return E.m(ne, he);
        };
        switch (Se) {
          case f:
            z = $e() / 12;
            break;
          case k:
            z = $e();
            break;
          case m:
            z = $e() / 3;
            break;
          case u:
            z = (oe - ue) / 6048e5;
            break;
          case c:
            z = (oe - ue) / 864e5;
            break;
          case d:
            z = oe / a;
            break;
          case o:
            z = oe / t;
            break;
          case r:
            z = oe / i;
            break;
          default:
            z = oe;
        }
        return _ ? z : E.a(z);
      }, O.daysInMonth = function() {
        return this.endOf(k).$D;
      }, O.$locale = function() {
        return T[this.$L];
      }, O.locale = function(M, L) {
        if (!M) return this.$L;
        var _ = this.clone(), z = B(M, L, !0);
        return z && (_.$L = z), _;
      }, O.clone = function() {
        return E.w(this.$d, this);
      }, O.toDate = function() {
        return new Date(this.valueOf());
      }, O.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, O.toISOString = function() {
        return this.$d.toISOString();
      }, O.toString = function() {
        return this.$d.toUTCString();
      }, H;
    }(), V = $.prototype;
    return W.prototype = V, [["$ms", s], ["$s", r], ["$m", o], ["$H", d], ["$W", c], ["$M", k], ["$y", f], ["$D", p]].forEach(function(H) {
      V[H[1]] = function(O) {
        return this.$g(O, H[0], H[1]);
      };
    }), W.extend = function(H, O) {
      return H.$i || (H(O, $, W), H.$i = !0), W;
    }, W.locale = B, W.isDayjs = A, W.unix = function(H) {
      return W(1e3 * H);
    }, W.en = T[R], W.Ls = T, W.p = {}, W;
  });
})(rC);
var oC = rC.exports;
const Hn = /* @__PURE__ */ ls(oC);
var dC = { exports: {} };
(function(e, n) {
  (function(i, t) {
    e.exports = t();
  })(Be, function() {
    return function(i, t) {
      t.prototype.isSameOrAfter = function(a, s) {
        return this.isSame(a, s) || this.isAfter(a, s);
      };
    };
  });
})(dC);
var NV = dC.exports;
const SV = /* @__PURE__ */ ls(NV);
var cC = { exports: {} };
(function(e, n) {
  (function(i, t) {
    e.exports = t();
  })(Be, function() {
    return function(i, t) {
      t.prototype.isSameOrBefore = function(a, s) {
        return this.isSame(a, s) || this.isBefore(a, s);
      };
    };
  });
})(cC);
var gV = cC.exports;
const FV = /* @__PURE__ */ ls(gV);
var uC = { exports: {} };
(function(e, n) {
  (function(i, t) {
    e.exports = t();
  })(Be, function() {
    return function(i, t, a) {
      i = i || {};
      var s = t.prototype, r = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function o(c, u, k, m) {
        return s.fromToBase(c, u, k, m);
      }
      a.en.relativeTime = r, s.fromToBase = function(c, u, k, m, f) {
        for (var p, h, N, S = k.$locale().relativeTime || r, F = i.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], y = F.length, x = 0; x < y; x += 1) {
          var R = F[x];
          R.d && (p = m ? a(c).diff(k, R.d, !0) : k.diff(c, R.d, !0));
          var T = (i.rounding || Math.round)(Math.abs(p));
          if (N = p > 0, T <= R.r || !R.r) {
            T <= 1 && x > 0 && (R = F[x - 1]);
            var j = S[R.l];
            f && (T = f("" + T)), h = typeof j == "string" ? j.replace("%d", T) : j(T, u, R.l, N);
            break;
          }
        }
        if (u) return h;
        var A = N ? S.future : S.past;
        return typeof A == "function" ? A(h) : A.replace("%s", h);
      }, s.to = function(c, u) {
        return o(c, u, this, !0);
      }, s.from = function(c, u) {
        return o(c, u, this);
      };
      var d = function(c) {
        return c.$u ? a.utc() : a();
      };
      s.toNow = function(c) {
        return this.to(d(this), c);
      }, s.fromNow = function(c) {
        return this.from(d(this), c);
      };
    };
  });
})(uC);
var IV = uC.exports;
const yV = /* @__PURE__ */ ls(IV);
var bV = { exports: {} };
(function(e, n) {
  (function(i, t) {
    e.exports = t(oC);
  })(Be, function(i) {
    function t(r) {
      return r && typeof r == "object" && "default" in r ? r : { default: r };
    }
    var a = t(i), s = { name: "ja", weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"), weekdaysShort: "日_月_火_水_木_金_土".split("_"), weekdaysMin: "日_月_火_水_木_金_土".split("_"), months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(r) {
      return r + "日";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日 HH:mm", LLLL: "YYYY年M月D日 dddd HH:mm", l: "YYYY/MM/DD", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日(ddd) HH:mm" }, meridiem: function(r) {
      return r < 12 ? "午前" : "午後";
    }, relativeTime: { future: "%s後", past: "%s前", s: "数秒", m: "1分", mm: "%d分", h: "1時間", hh: "%d時間", d: "1日", dd: "%d日", M: "1ヶ月", MM: "%dヶ月", y: "1年", yy: "%d年" } };
    return a.default.locale(s, null, !0), s;
  });
})(bV);
Hn.locale("ja");
Hn.extend(SV);
Hn.extend(FV);
Hn.extend(yV);
function Ci({ date: e, inc: n, format: i = "YYYY-MM-DD" }) {
  return Hn(e).add(n, "day").format(i);
}
const nl = ({ amount: e, date: n, format: i = "YYYY-MM-DD" }) => Hn(n).add(e, "month").format(i);
function fk({ from: e, to: n, format: i = "day" }) {
  const t = Hn(e), a = Hn(n);
  return t.diff(a, i);
}
function Ne(e, n = "YYYY-MM-DD", i = "ja") {
  return e === "" ? Hn().locale(i).format(n) : Hn(e).locale(i).format(n);
}
function Hv({ startDate: e, endDate: n }) {
  const i = [];
  if (e > n) return i;
  let t = Hn(e);
  const a = Hn(n);
  for (; t <= a; )
    i.push(Ne(t.toString())), t = Hn(Ci({ date: t.toString(), inc: 1 }));
  return i;
}
const Fd = ({ date: e }) => Hn(e).day();
function gt(e) {
  const n = Hn(e).startOf("month").format("YYYY-MM-DD"), i = Hn(e).endOf("month").format("YYYY-MM-DD");
  return { firstDate: n, lastDate: i };
}
function Tr() {
  return Hn().unix();
}
function Id() {
  return Hn().format("YYYY-MM-DD");
}
function CV({ targetDate: e, compareDate: n }) {
  return Hn(e).isAfter(Hn(n), "date");
}
function mC({ targetDate: e, compareDate: n }) {
  return Hn(e).isBefore(Hn(n), "date");
}
function Ht({ targetDate: e, compareDate: n }) {
  return Hn(e).isSame(Hn(n));
}
function kC(e) {
  const n = Hn(e).startOf("month"), i = Hn().startOf("month");
  return n.isSameOrBefore(i, "month");
}
function La({ date: e, amount: n, format: i = "YYYY-MM-DD" }) {
  return Hn(e).subtract(n, "day").format(i);
}
const xV = () => !1, DV = (e) => {
  const n = window[e];
  if (n) return n;
  const i = [];
  return window[e] = i, i;
};
function wV() {
  this.reset();
}
const fC = (e, n) => {
  if (typeof window != "undefined")
    try {
      xV();
      const i = DV(e);
      i.push(n), e === "dataLayerChillnn" && i.push(wV);
    } catch (i) {
    }
}, le = (e) => fC("dataLayerChillnn", e), PV = (e) => fC("dataLayer", e), bt = (e) => {
  le(e), PV(e);
}, ct = (e) => ({
  reservation_session_id: e.sessionID,
  hotel_id: e.hotelID
}), vC = (e) => () => ({
  event: e
}), hl = (e) => (n) => ({
  event: e,
  ...n
}), RV = "reservation_component_view", TV = hl(RV), jV = "reservation_click_button", Pn = hl(jV), AV = "reservation_proceed", jr = hl(AV), OV = "reservation_submit_options", hC = vC(OV), EV = "reservation_submit_guest_info", pC = vC(EV), JV = "reservation_submit_payment_info", zv = hl(JV), _V = "reservation_completed", Mm = hl(_V), QV = "reservation_failed", bu = hl(QV), MV = "reservation_session_start", pl = hl(MV), LV = "reservation_screen_view", Ja = hl(LV), $V = "reservation_input", yn = hl($V), NC = "JPY", UV = (e) => ({
  item_id: e.itemID,
  item_name: e.name,
  item_category: e.category,
  price: e.price,
  quantity: e.quantity
}), Lm = (e) => ({
  value: e.value,
  currency: e.currency.toUpperCase(),
  items: e.items.map(UV)
}), Bv = (e) => e ? { coupon: e } : {}, $m = (e) => [{ ecommerce: null }, e], Um = (e) => {
  var n, i;
  return (i = (n = e.priceHostInserted) != null ? n : e.priceDiscounted) != null ? i : e.price;
}, VV = (e) => {
  const n = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i) continue;
    const t = i.subOptionID ? `${i.optionID}_${i.subOptionID}` : i.optionID, a = n.get(t), s = Um(i);
    if (!a) {
      n.set(t, { itemID: t, name: i.name, category: "option", price: s, quantity: 1 });
      continue;
    }
    n.set(t, { ...a, price: a.price + s });
  }
  return [...n.values()];
}, HV = (e) => {
  const n = e.willReserve;
  return n ? [
    {
      itemID: n.planID,
      name: n.name,
      category: "plan",
      price: Um(n),
      quantity: 1
    }
  ] : [];
}, zV = (e) => e.willReserve.flatMap((n) => {
  var a, s, r, o;
  if (!n) return [];
  const i = n.dailyItems.flatMap((d) => d.roomInfo ? [d.roomInfo] : []);
  if (i.length === 0) return [];
  const t = i[0];
  return [
    {
      itemID: (s = (a = n.baseRoomInfo) == null ? void 0 : a.baseRoomID) != null ? s : t.roomID,
      name: (o = (r = n.baseRoomInfo) == null ? void 0 : r.baseRoomName) != null ? o : t.name,
      category: "room",
      price: i.reduce((d, c) => d + Um(c), 0),
      quantity: 1
    }
  ];
}), BV = (e) => e.map((n) => ({
  itemID: n.additionalFeeID,
  name: n.name,
  category: "additional_fee",
  price: Um(n),
  quantity: 1
})), qV = (e) => {
  var n, i, t, a;
  return (a = (t = (n = e.discountInfo) == null ? void 0 : n.name) != null ? t : (i = e.voucherInfo[0]) == null ? void 0 : i.voucherCode) != null ? a : null;
}, GV = ({ sessionStateContext: e }) => {
  const { currentState: n, priceInfo: i } = e, t = [
    ...HV(n.planInfo),
    ...zV(n.roomInfo),
    ...VV([
      ...n.optionPerDateInfo.willReserve,
      ...n.optionPerReservationInfo.willReserve
    ]),
    ...BV(n.additionalFeeInfo)
  ];
  return t.length === 0 ? null : {
    // 割引とチケットを引いた最終的な請求額。items の合計とは割引分だけズレるが、
    // GA4 は value を売上として扱うため、請求額と一致させることを優先する。
    value: i.totalGuestCharge,
    currency: NC,
    coupon: qV(n),
    items: t
  };
}, qv = (e) => $m({
  event: "view_item",
  ecommerce: Lm({
    value: e.price,
    currency: NC,
    items: [{ ...e, quantity: 1 }]
  })
}), Ar = (e) => e ? $m({
  event: "begin_checkout",
  ecommerce: {
    ...Lm(e),
    ...Bv(e.coupon)
  }
}) : [], Gv = (e, n) => e ? $m({
  event: "add_payment_info",
  ecommerce: {
    ...Lm(e),
    ...Bv(e.coupon),
    payment_type: n
  }
}) : [], SC = (e) => e ? $m({
  event: "purchase",
  ecommerce: {
    ...Lm(e),
    ...Bv(e.coupon),
    transaction_id: e.reservationID
  }
}) : [], WV = "chillnn:gtm:purchase:", vk = (e) => `${WV}${e}`, gC = (e, n) => {
  if (typeof sessionStorage == "undefined") return n;
  try {
    return e(sessionStorage);
  } catch (i) {
    return n;
  }
}, KV = (e, n) => {
  gC((i) => i.setItem(vk(e), JSON.stringify(n)), void 0);
}, YV = (e) => {
  const n = gC((i) => {
    const t = i.getItem(vk(e));
    return i.removeItem(vk(e)), t;
  }, null);
  if (!n) return null;
  try {
    return JSON.parse(n);
  } catch (i) {
    return null;
  }
};
function Vm({
  hotelID: e,
  uiType: n
}) {
  be(() => {
    const i = `reservation_component_view:${e}:${n}`;
    if (sessionStorage.getItem(i)) return;
    const t = TV({ reservation_component_ui_type: n });
    le(t), sessionStorage.setItem(i, "1");
  }, [e, n]);
}
let z4 = !1;
const Nl = ({ stage: e, user: n, componentType: i }) => {
  const t = v(() => e === "local", [e]), a = v(() => e === "prd" ? {
    init: {
      session_replay: {
        enabled: !0,
        block_selector: "",
        mask_text_selector: "*",
        sampling_rate: 10,
        error_sampling_rate: 100,
        mask_all_inputs: !0,
        collect_fonts: !0,
        inline_images: !1,
        inline_stylesheet: !0,
        fix_stylesheets: !0,
        mask_input_options: {}
      },
      distributed_tracing: { enabled: !0 },
      privacy: { cookies_enabled: !0 },
      ajax: { deny_list: ["bam.nr-data.net"] }
    },
    loader_config: {
      accountID: "6283683",
      trustKey: "6283683",
      agentID: "1120359442",
      licenseKey: "NRJS-95b4ed89dc940e1e3b7",
      applicationID: "1120359442"
    },
    info: {
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey: "NRJS-95b4ed89dc940e1e3b7",
      applicationID: "1120359442",
      sa: 1
    }
  } : {
    init: {
      session_replay: {
        enabled: !0,
        block_selector: "",
        mask_text_selector: "*",
        sampling_rate: 10,
        error_sampling_rate: 100,
        mask_all_inputs: !0,
        collect_fonts: !0,
        inline_images: !1,
        inline_stylesheet: !0,
        mask_input_options: {}
      },
      distributed_tracing: { enabled: !0 },
      privacy: { cookies_enabled: !0 },
      ajax: { deny_list: ["bam.nr-data.net"] }
    },
    loader_config: {
      accountID: "6283683",
      trustKey: "6283683",
      agentID: "1120359454",
      licenseKey: "NRJS-95b4ed89dc940e1e3b7",
      applicationID: "1120359454"
    },
    info: {
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey: "NRJS-95b4ed89dc940e1e3b7",
      applicationID: "1120359454",
      sa: 1
    }
  }, [e]);
  be(() => {
    typeof window != "undefined" && (z4 || t || (z4 = !0, (async () => {
      const { Agent: s, Metrics: r, PageViewEvent: o, PageViewTiming: d, JSErrors: c, GenericEvents: u } = await import("./index-Csp4UgPJ.mjs").then((f) => f.aj), { SoftNav: k } = await import("./index-iP61K4ND.mjs").then((f) => f.a0), m = new s({
        ...a,
        features: [r, o, d, k, c, u]
      });
      m.setCustomAttribute("stage", e), m.setCustomAttribute("componentType", i), m.setCustomAttribute("user", n);
    })()));
  }, [i, t, a, e, n]);
}, XV = ({ payjpInstance: e, createTokenContext: n }) => {
  const i = I(
    (a) => a.hasOwnProperty("object"),
    []
  );
  return {
    onCreateToken: I(
      (a) => async (s) => {
        var d, c;
        const r = await e.createToken(a, {
          three_d_secure: !0,
          card: { name: s, email: n.guestEmail }
        });
        return i(r) ? (await n.onCreateTokenCallback(r.id), {
          kind: "success"
        }) : ((c = n.onCreateTokenErrorCallback) == null || c.call(n, (d = r.error.code) != null ? d : r.error.type), {
          kind: "error",
          message: r.error.message
        });
      },
      [i, n, e]
    )
  };
}, vs = ({ reservationPolicy: e }) => (e == null ? void 0 : e.isShowRoomForGuest) === !1, kn = ({ lang: e, i18nString: n }) => n[e], ZV = g(({ lang: e }) => {
  const n = v(() => kn({
    lang: e,
    i18nString: {
      default: "カードの有効性を確認するために、少額の決済が行われる場合があります。",
      en: "For the purpose of verifying the validity of the card, a small amount of payment will be made."
    }
  }), [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal", children: n });
}), B4 = [
  {
    id: "Visa",
    src: "https://editor-assets.chillnn.com/reservation/img/card/visa.png"
  },
  {
    id: "MasterCard",
    src: "https://editor-assets.chillnn.com/reservation/img/card/mastercard.png"
  },
  {
    id: "JCB",
    src: "https://editor-assets.chillnn.com/reservation/img/card/jcb.png"
  },
  {
    id: "American Express",
    src: "https://editor-assets.chillnn.com/reservation/img/card/americanExpress.png"
  },
  {
    id: "Discover",
    src: "https://editor-assets.chillnn.com/reservation/img/card/discover.png"
  }
], eH = g(({ current: e }) => {
  const n = I(
    (t) => e === "unknown" ? !0 : e === t,
    [e]
  ), i = v(() => !B4.some(({ id: a }) => a === e), [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-gap-x-3 tablet:ch-gap-x-4", children: B4.map(({ id: t, src: a }) => {
    const s = n(t);
    return /* @__PURE__ */ l.jsx(
      "img",
      {
        className: ce(
          "ch-w-10 ch-border ch-border-zinc-50",
          i ? "ch-opacity-100" : void 0,
          s ? "ch-opacity-100" : "ch-opacity-20"
        ),
        src: a
      },
      t
    );
  }) });
}), nH = "https://chillnn.notion.site/2-82c5658f695c4a85a1ce93ba6b9483b7", iH = g(() => /* @__PURE__ */ l.jsxs("p", { className: "ch-text-sm ch-font-normal ch-text-black", children: [
  "デビットカードは",
  /* @__PURE__ */ l.jsx("strong", { children: "二重決済などのおそれがあるため非推奨" }),
  "です。",
  /* @__PURE__ */ l.jsx("br", {}),
  "デビットカードの方は",
  /* @__PURE__ */ l.jsx(
    "a",
    {
      className: "ch-font-semibold ch-text-link-400 ch-underline",
      href: nH,
      target: "_blank",
      rel: "noopener noreferrer",
      children: "こちら"
    }
  ),
  "をご確認ください。"
] })), tH = "https://chillnn.notion.site/2-82c5658f695c4a85a1ce93ba6b9483b7", aH = g(() => /* @__PURE__ */ l.jsxs("p", { className: "ch-text-sm ch-font-normal ch-text-black", children: [
  "Using a Debit Card is",
  /* @__PURE__ */ l.jsx("strong", { className: "ch-mx-1", children: "not encouraged owing to potential risks such as a double charge." }),
  /* @__PURE__ */ l.jsx("br", {}),
  "Please check",
  /* @__PURE__ */ l.jsx(
    "a",
    {
      className: "ch-mx-1 ch-font-semibold ch-text-link-400 ch-underline",
      href: tH,
      target: "_blank",
      rel: "noopener noreferrer",
      children: "this link"
    }
  ),
  "to learn more."
] })), lH = g(({ lang: e }) => {
  if (e === D.Default)
    return /* @__PURE__ */ l.jsx(iH, {});
  if (e === D.En)
    return /* @__PURE__ */ l.jsx(aH, {});
  throw new Error("Invalid lang code.");
});
g(
  ({
    cardNameErrorMessage: e,
    cardCvcErrorMessage: n,
    cardExpiryErrorMessage: i,
    cardNumberErrorMessage: t,
    tokenErrorMessage: a
  }) => P(a) ? P(e) ? P(t) ? P(i) ? P(n) ? null : /* @__PURE__ */ l.jsx("div", { className: "ch-text-urgent-400", children: /* @__PURE__ */ l.jsx("p", { children: n }) }) : /* @__PURE__ */ l.jsx("div", { className: "ch-text-urgent-400", children: /* @__PURE__ */ l.jsx("p", { children: i }) }) : /* @__PURE__ */ l.jsx("div", { className: "ch-text-urgent-400", children: /* @__PURE__ */ l.jsx("p", { children: t }) }) : /* @__PURE__ */ l.jsx("div", { className: "ch-text-urgent-400", children: /* @__PURE__ */ l.jsx("p", { children: e }) }) : /* @__PURE__ */ l.jsx("div", { className: "ch-text-urgent-400", children: /* @__PURE__ */ l.jsx("p", { children: a }) })
);
const sH = g(({ lang: e, htmlFor: n }) => {
  const i = v(() => e === D.Default ? "セキュリティコード" : "Security code", [e]);
  return /* @__PURE__ */ l.jsx(
    Qn,
    {
      className: "ch-cursor-pointer ch-text-sm ch-font-normal ch-text-gray-400",
      htmlFor: n,
      children: i
    }
  );
}), Hm = g(({ errorMessage: e }) => P(e) ? null : /* @__PURE__ */ l.jsx("div", { className: "ch-text-xs ch-text-urgent-400", children: e })), B0 = "card-cvc", rH = g((e) => {
  var t;
  const n = I(
    (a) => {
      const s = a.error ? a.error.message : null;
      e.onChangeCallback(a.complete)(s);
    },
    [e]
  );
  be(() => {
    e.element.mount(`#${B0}`), e.element.on("change", n);
  }, [n, e.element]);
  const i = v(() => !P(e.errorMessage), [e.errorMessage]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(sH, { lang: e.lang, htmlFor: B0 }),
    /* @__PURE__ */ l.jsx(
      "div",
      {
        id: B0,
        className: ce(
          "ch-w-full ch-rounded-md ch-border ch-border-gray-200 ch-px-3 ch-py-4",
          i ? "ch-border-urgent-400 ch-text-urgent-400" : void 0
        )
      }
    ),
    /* @__PURE__ */ l.jsx(Hm, { errorMessage: (t = e.errorMessage) != null ? t : void 0 })
  ] });
}), oH = g(({ lang: e, htmlFor: n }) => {
  const i = v(() => e === D.Default ? "有効期限" : "Expiry", [e]);
  return /* @__PURE__ */ l.jsx(
    Qn,
    {
      className: "ch-cursor-pointer ch-text-sm ch-font-normal ch-text-gray-400",
      htmlFor: n,
      children: i
    }
  );
}), q0 = "card-expiry", dH = g((e) => {
  var t;
  const n = I(
    (a) => {
      const s = a.error ? a.error.message : null;
      e.onChangeCallback(a.complete)(s);
    },
    [e]
  );
  be(() => {
    e.element.mount(`#${q0}`), e.element.on("change", n);
  }, [n, e.element]);
  const i = v(() => !P(e.errorMessage), [e.errorMessage]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(oH, { lang: e.lang, htmlFor: q0 }),
    /* @__PURE__ */ l.jsx(
      "div",
      {
        id: q0,
        className: ce(
          "ch-w-full ch-rounded-md ch-border ch-border-gray-200 ch-px-3 ch-py-4",
          i ? "ch-ring-offset ch-text-urgent-400 ch-outline-none ch-outline-urgent-400 ch-ring-offset-2" : void 0
        )
      }
    ),
    /* @__PURE__ */ l.jsx(Hm, { errorMessage: (t = e.errorMessage) != null ? t : void 0 })
  ] });
}), cH = g(({ lang: e, htmlFor: n }) => {
  const i = v(() => e === D.Default ? "カード名義" : "Cardholder's name", [e]);
  return /* @__PURE__ */ l.jsx(
    Qn,
    {
      className: "ch-cursor-pointer ch-text-sm ch-font-normal ch-text-gray-400",
      htmlFor: n,
      children: i
    }
  );
}), q4 = "card-name", uH = g((e) => {
  var t, a;
  const n = I(
    (s) => {
      const r = s.target.value;
      if (P(r)) {
        const c = kn({
          lang: e.lang,
          i18nString: {
            default: "カード名義を入力してください",
            en: "Please enter the cardholder's name"
          }
        });
        e.onChangeCallback(!1)(c)(null);
        return;
      }
      if (r.length > 45) {
        const c = kn({
          lang: e.lang,
          i18nString: {
            default: "カード名義は45文字以内で入力してください",
            en: "The cardholder's name must be 45 characters or less"
          }
        });
        e.onChangeCallback(!1)(c)(r);
        return;
      }
      if (!/^[A-Za-z0-9 .\-]+$/.test(r)) {
        const c = kn({
          lang: e.lang,
          i18nString: {
            default: "カード名義は英数字、スペース、ピリオド、ハイフンのみ入力可能です（全て半角）",
            en: "The cardholder's name can only contain alphanumeric characters, spaces, periods, and hyphens (all in half-width)"
          }
        });
        e.onChangeCallback(!1)(c)(r);
        return;
      }
      e.onChangeCallback(!0)(null)(r);
    },
    [e]
  ), i = v(() => !P(e.errorMessage), [e.errorMessage]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(cH, { lang: e.lang, htmlFor: q4 }),
    /* @__PURE__ */ l.jsx(
      Qa,
      {
        id: q4,
        required: !0,
        type: "text",
        value: (t = e.value) != null ? t : "",
        placeholder: "TARO YAMADA",
        autoComplete: "cc-name",
        onChange: n,
        className: ce(
          "ch-w-full ch-rounded ch-border ch-border-gray-200 ch-px-3 ch-py-4",
          "focus-visible:ch-ring-0 focus-visible:ch-ring-transparent focus-visible:ch-ring-offset-0",
          // Payjp の field と同じスタイルにする
          i ? "ch-ring-offset ch-text-urgent-400 ch-outline-none ch-outline-urgent-400 ch-ring-offset-2" : void 0
        )
      }
    ),
    /* @__PURE__ */ l.jsx(Hm, { errorMessage: (a = e.errorMessage) != null ? a : void 0 })
  ] });
}), mH = g(({ lang: e, htmlFor: n }) => {
  const i = v(() => e === D.Default ? "カード番号" : "Card number", [e]);
  return /* @__PURE__ */ l.jsx(
    Qn,
    {
      className: "ch-cursor-pointer ch-text-sm ch-font-normal ch-text-gray-400",
      htmlFor: n,
      children: i
    }
  );
}), G0 = "card-number", kH = g((e) => {
  var t;
  const n = I(
    (a) => {
      const s = a.error ? a.error.message : null;
      e.onChangeCallback(a.complete)(s), e.onChangeCardBrand(a.brand);
    },
    [e]
  );
  be(() => {
    e.element.mount(`#${G0}`), e.element.on("change", n);
  }, [n, e.element]);
  const i = v(() => !P(e.errorMessage), [e.errorMessage]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(mH, { lang: e.lang, htmlFor: G0 }),
    /* @__PURE__ */ l.jsx(
      "div",
      {
        id: G0,
        className: ce(
          "ch-w-full ch-rounded-md ch-border ch-border-gray-200 ch-px-3 ch-py-4",
          i ? "ch-ring-offset ch-text-urgent-400 ch-outline-none ch-outline-urgent-400 ch-ring-offset-2" : void 0
        )
      }
    ),
    /* @__PURE__ */ l.jsx(Hm, { errorMessage: (t = e.errorMessage) != null ? t : void 0 })
  ] });
}), fH = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case D.Default:
        return "本人認証を行うため、外部サイトに一度移動します";
      case D.En:
        return "You will be redirected to an external site to verify your identity";
      default:
        return "";
    }
  }, [e.lang]), { onHideLoadingScreenCallback: i, onShowLoadingScreenCallback: t } = fn(), { onDisableBeforeUnload: a } = gd(), { addError: s } = Uv(), r = I(
    async (c) => {
      c.currentTarget.disabled = !0, !(P(e.formState.cardName.value) || !e.formState.cardNumber.complete || !e.formState.cardExpiry.complete || !e.formState.cardCvc.complete || !window.confirm(n)) && (a(), t(), await e.onSubmitCallback(e.cardNumberElement)(e.formState.cardName.value).then((k) => {
        k.kind === "error" && s(k.message);
      }).finally(() => {
        i();
      }));
    },
    [s, n, a, i, t, e]
  ), o = v(() => {
    switch (e.lang) {
      case D.Default:
        return "決済する";
      case D.En:
        return "Make payment";
      default:
        return "";
    }
  }, [e.lang]), d = v(() => !e.formState.cardName.complete || !e.formState.cardNumber.complete || !e.formState.cardExpiry.complete || !e.formState.cardCvc.complete, [
    e.formState.cardCvc.complete,
    e.formState.cardExpiry.complete,
    e.formState.cardName.complete,
    e.formState.cardNumber.complete
  ]);
  return /* @__PURE__ */ l.jsx(
    ae,
    {
      className: "ch-w-full",
      size: "md",
      variant: "default",
      disabled: d,
      onClick: r,
      children: o
    }
  );
}), vH = () => {
  const [e, n] = se({
    cardName: { value: null, errorMessage: null, complete: !1 },
    cardNumber: { errorMessage: null, complete: !1 },
    cardExpiry: { errorMessage: null, complete: !1 },
    cardCvc: { errorMessage: null, complete: !1 }
  }), i = I(
    (a) => (s) => (r) => {
      n((o) => ({
        ...o,
        [a]: {
          complete: s,
          errorMessage: r
        }
      }));
    },
    []
  ), t = I(
    (a) => (s) => (r) => {
      n((o) => ({
        ...o,
        cardName: {
          value: r,
          complete: a,
          errorMessage: s
        }
      }));
    },
    []
  );
  return {
    formState: e,
    onChangeFormStateForPayjpElement: i,
    onChangeFormStateForCardName: t
  };
}, hH = ({ lang: e, payjpInstance: n }) => {
  const [i, t] = se({
    cardNumberElement: null,
    cardExpiryElement: null,
    cardCvcElement: null
  });
  return be(() => {
    const a = e === D.Default ? "ja" : "en", s = n.elements({ locale: a }), r = s.create("cardNumber"), o = s.create("cardExpiry"), d = s.create("cardCvc");
    t({
      cardNumberElement: r,
      cardExpiryElement: o,
      cardCvcElement: d
    });
  }, [e, n]), {
    cardElementState: i
  };
}, pH = g(({ lang: e, payjpInstance: n, submitButtonContext: i, cardNumberFieldContext: t }) => {
  const { cardElementState: a } = hH({ lang: e, payjpInstance: n }), { formState: s, onChangeFormStateForCardName: r, onChangeFormStateForPayjpElement: o } = vH();
  return P(a.cardNumberElement) || P(a.cardExpiryElement) || P(a.cardCvcElement) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-5", children: [
      /* @__PURE__ */ l.jsx(
        kH,
        {
          ...t,
          lang: e,
          element: a.cardNumberElement,
          errorMessage: s.cardNumber.errorMessage,
          onChangeCallback: o("cardNumber")
        }
      ),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-flow-col ch-grid-cols-2 ch-gap-3", children: [
        /* @__PURE__ */ l.jsx(
          dH,
          {
            lang: e,
            element: a.cardExpiryElement,
            errorMessage: s.cardExpiry.errorMessage,
            onChangeCallback: o("cardExpiry")
          }
        ),
        /* @__PURE__ */ l.jsx(
          rH,
          {
            lang: e,
            element: a.cardCvcElement,
            errorMessage: s.cardCvc.errorMessage,
            onChangeCallback: o("cardCvc")
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx(
        uH,
        {
          lang: e,
          value: s.cardName.value,
          errorMessage: s.cardName.errorMessage,
          onChangeCallback: r
        }
      )
    ] }),
    /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
      fH,
      {
        ...i,
        lang: e,
        cardNumberElement: a.cardNumberElement,
        formState: s
      }
    ) })
  ] });
}), FC = g(({ payjpInstance: e, createTokenContext: n, lang: i, cautionChildren: t }) => {
  const { onCreateToken: a } = XV({ payjpInstance: e, createTokenContext: n }), [s, r] = se("unknown"), o = I((d) => {
    r(d);
  }, []);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-5", children: [
    /* @__PURE__ */ l.jsx(eH, { current: s }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
      /* @__PURE__ */ l.jsx(
        pH,
        {
          lang: i,
          payjpInstance: e,
          cardNumberFieldContext: {
            onChangeCardBrand: o
          },
          submitButtonContext: {
            onSubmitCallback: a
          }
        }
      ),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
        t,
        /* @__PURE__ */ l.jsx(ZV, { lang: i }),
        /* @__PURE__ */ l.jsx(lH, { lang: i })
      ] })
    ] })
  ] });
}), IC = ({ instance: e }) => ({
  onGet3DSecureStartUrl: I(
    (i) => (t) => {
      const a = e.getPublicKey();
      return `https://api.pay.jp/v1/tds/${i}/start?publickey=${a}&back_url=${t}`;
    },
    [e]
  )
}), NH = "X-Reservation-Access-Token", G4 = "chillnn.com", SH = ["localhost", "127.0.0.1"], yC = (e = globalThis.location) => {
  if (e === void 0)
    return !1;
  const { protocol: n, hostname: i } = e;
  return n === "https:" && (i === G4 || i.endsWith(`.${G4}`)) ? !0 : n === "http:" && SH.includes(i);
}, gH = "chillnn:reservation-access-token:", Wv = (e) => `${gH}${e}`, Kv = (e, n) => {
  if (typeof sessionStorage == "undefined") return n;
  try {
    return e(sessionStorage);
  } catch (i) {
    return n;
  }
}, FH = (e) => Kv((n) => {
  var i;
  return (i = n.getItem(Wv(e))) != null ? i : void 0;
}, void 0), IH = (e, n) => Kv((i) => i.setItem(Wv(e), n), void 0), Yv = (e) => Kv((n) => n.removeItem(Wv(e)), void 0), bC = (e, n) => {
  n != null && IH(e, n);
}, CC = (e) => (n, i) => {
  if (yC())
    return fetch(n, { ...i, credentials: "include" });
  const t = FH(e);
  if (t === void 0)
    return fetch(n, i);
  const a = new Headers(i == null ? void 0 : i.headers);
  return a.set(NH, t), fetch(n, { ...i, headers: a });
}, yH = {
  // 許可されるHTMLタグ（DOMPurifyのデフォルトに近い設定）
  allowedTags: [
    // 基本的なテキスト要素
    "p",
    "br",
    "strong",
    "em",
    "b",
    "i",
    "u",
    "s",
    "sub",
    "sup",
    // リンク
    "a",
    // リスト
    "ul",
    "ol",
    "li",
    // 見出し
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    // その他のテキスト要素
    "blockquote",
    "code",
    "pre",
    "cite",
    "q",
    "small",
    // コンテナ要素（DOMPurifyデフォルトで許可される）
    "div",
    "span",
    "section",
    "article",
    "header",
    "footer",
    "main",
    "aside",
    "nav",
    // テーブル要素（必要に応じて）
    "table",
    "thead",
    "tbody",
    "tr",
    "td",
    "th"
  ],
  // 許可される属性（DOMPurifyの動作に合わせる）
  allowedAttributes: {
    a: ["href", "target", "rel"],
    // ADD_ATTR: ["target", "rel"] + デフォルトのhref
    "*": ["class", "id"]
  },
  // 許可されるURLスキーム
  allowedSchemes: ["http", "https", "mailto"],
  // タグ別の許可されるスキーム
  allowedSchemesByTag: {
    a: ["http", "https", "mailto"]
  },
  // 自己終了タグの処理
  selfClosing: ["br"],
  // 許可されないタグの処理方法（除去）
  disallowedTagsMode: "discard",
  // 許可されない属性の処理方法（除去）
  allowedSchemesAppliedToAttributes: ["href"],
  // プロトコル相対URLを許可しない
  allowProtocolRelative: !1
};
var xC = {}, Uo = {}, Xv = {}, Vo = {}, Zv = {};
Object.defineProperty(Zv, "__esModule", { value: !0 });
Zv.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(e) {
    return e.charCodeAt(0);
  })
);
var eh = {};
Object.defineProperty(eh, "__esModule", { value: !0 });
eh.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(e) {
    return e.charCodeAt(0);
  })
);
var hk = {};
(function(e) {
  var n;
  Object.defineProperty(e, "__esModule", { value: !0 }), e.replaceCodePoint = e.fromCodePoint = void 0;
  var i = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  e.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (n = String.fromCodePoint) !== null && n !== void 0 ? n : function(s) {
    var r = "";
    return s > 65535 && (s -= 65536, r += String.fromCharCode(s >>> 10 & 1023 | 55296), s = 56320 | s & 1023), r += String.fromCharCode(s), r;
  };
  function t(s) {
    var r;
    return s >= 55296 && s <= 57343 || s > 1114111 ? 65533 : (r = i.get(s)) !== null && r !== void 0 ? r : s;
  }
  e.replaceCodePoint = t;
  function a(s) {
    return (0, e.fromCodePoint)(t(s));
  }
  e.default = a;
})(hk);
(function(e) {
  var n = Be && Be.__createBinding || (Object.create ? function(E, $, V, H) {
    H === void 0 && (H = V);
    var O = Object.getOwnPropertyDescriptor($, V);
    (!O || ("get" in O ? !$.__esModule : O.writable || O.configurable)) && (O = { enumerable: !0, get: function() {
      return $[V];
    } }), Object.defineProperty(E, H, O);
  } : function(E, $, V, H) {
    H === void 0 && (H = V), E[H] = $[V];
  }), i = Be && Be.__setModuleDefault || (Object.create ? function(E, $) {
    Object.defineProperty(E, "default", { enumerable: !0, value: $ });
  } : function(E, $) {
    E.default = $;
  }), t = Be && Be.__importStar || function(E) {
    if (E && E.__esModule) return E;
    var $ = {};
    if (E != null) for (var V in E) V !== "default" && Object.prototype.hasOwnProperty.call(E, V) && n($, E, V);
    return i($, E), $;
  }, a = Be && Be.__importDefault || function(E) {
    return E && E.__esModule ? E : { default: E };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXML = e.decodeHTMLStrict = e.decodeHTMLAttribute = e.decodeHTML = e.determineBranch = e.EntityDecoder = e.DecodingMode = e.BinTrieFlags = e.fromCodePoint = e.replaceCodePoint = e.decodeCodePoint = e.xmlDecodeTree = e.htmlDecodeTree = void 0;
  var s = a(Zv);
  e.htmlDecodeTree = s.default;
  var r = a(eh);
  e.xmlDecodeTree = r.default;
  var o = t(hk);
  e.decodeCodePoint = o.default;
  var d = hk;
  Object.defineProperty(e, "replaceCodePoint", { enumerable: !0, get: function() {
    return d.replaceCodePoint;
  } }), Object.defineProperty(e, "fromCodePoint", { enumerable: !0, get: function() {
    return d.fromCodePoint;
  } });
  var c;
  (function(E) {
    E[E.NUM = 35] = "NUM", E[E.SEMI = 59] = "SEMI", E[E.EQUALS = 61] = "EQUALS", E[E.ZERO = 48] = "ZERO", E[E.NINE = 57] = "NINE", E[E.LOWER_A = 97] = "LOWER_A", E[E.LOWER_F = 102] = "LOWER_F", E[E.LOWER_X = 120] = "LOWER_X", E[E.LOWER_Z = 122] = "LOWER_Z", E[E.UPPER_A = 65] = "UPPER_A", E[E.UPPER_F = 70] = "UPPER_F", E[E.UPPER_Z = 90] = "UPPER_Z";
  })(c || (c = {}));
  var u = 32, k;
  (function(E) {
    E[E.VALUE_LENGTH = 49152] = "VALUE_LENGTH", E[E.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", E[E.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(k = e.BinTrieFlags || (e.BinTrieFlags = {}));
  function m(E) {
    return E >= c.ZERO && E <= c.NINE;
  }
  function f(E) {
    return E >= c.UPPER_A && E <= c.UPPER_F || E >= c.LOWER_A && E <= c.LOWER_F;
  }
  function p(E) {
    return E >= c.UPPER_A && E <= c.UPPER_Z || E >= c.LOWER_A && E <= c.LOWER_Z || m(E);
  }
  function h(E) {
    return E === c.EQUALS || p(E);
  }
  var N;
  (function(E) {
    E[E.EntityStart = 0] = "EntityStart", E[E.NumericStart = 1] = "NumericStart", E[E.NumericDecimal = 2] = "NumericDecimal", E[E.NumericHex = 3] = "NumericHex", E[E.NamedEntity = 4] = "NamedEntity";
  })(N || (N = {}));
  var S;
  (function(E) {
    E[E.Legacy = 0] = "Legacy", E[E.Strict = 1] = "Strict", E[E.Attribute = 2] = "Attribute";
  })(S = e.DecodingMode || (e.DecodingMode = {}));
  var F = (
    /** @class */
    function() {
      function E($, V, H) {
        this.decodeTree = $, this.emitCodePoint = V, this.errors = H, this.state = N.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = S.Strict;
      }
      return E.prototype.startEntity = function($) {
        this.decodeMode = $, this.state = N.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, E.prototype.write = function($, V) {
        switch (this.state) {
          case N.EntityStart:
            return $.charCodeAt(V) === c.NUM ? (this.state = N.NumericStart, this.consumed += 1, this.stateNumericStart($, V + 1)) : (this.state = N.NamedEntity, this.stateNamedEntity($, V));
          case N.NumericStart:
            return this.stateNumericStart($, V);
          case N.NumericDecimal:
            return this.stateNumericDecimal($, V);
          case N.NumericHex:
            return this.stateNumericHex($, V);
          case N.NamedEntity:
            return this.stateNamedEntity($, V);
        }
      }, E.prototype.stateNumericStart = function($, V) {
        return V >= $.length ? -1 : ($.charCodeAt(V) | u) === c.LOWER_X ? (this.state = N.NumericHex, this.consumed += 1, this.stateNumericHex($, V + 1)) : (this.state = N.NumericDecimal, this.stateNumericDecimal($, V));
      }, E.prototype.addToNumericResult = function($, V, H, O) {
        if (V !== H) {
          var M = H - V;
          this.result = this.result * Math.pow(O, M) + parseInt($.substr(V, M), O), this.consumed += M;
        }
      }, E.prototype.stateNumericHex = function($, V) {
        for (var H = V; V < $.length; ) {
          var O = $.charCodeAt(V);
          if (m(O) || f(O))
            V += 1;
          else
            return this.addToNumericResult($, H, V, 16), this.emitNumericEntity(O, 3);
        }
        return this.addToNumericResult($, H, V, 16), -1;
      }, E.prototype.stateNumericDecimal = function($, V) {
        for (var H = V; V < $.length; ) {
          var O = $.charCodeAt(V);
          if (m(O))
            V += 1;
          else
            return this.addToNumericResult($, H, V, 10), this.emitNumericEntity(O, 2);
        }
        return this.addToNumericResult($, H, V, 10), -1;
      }, E.prototype.emitNumericEntity = function($, V) {
        var H;
        if (this.consumed <= V)
          return (H = this.errors) === null || H === void 0 || H.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if ($ === c.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === S.Strict)
          return 0;
        return this.emitCodePoint((0, o.replaceCodePoint)(this.result), this.consumed), this.errors && ($ !== c.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, E.prototype.stateNamedEntity = function($, V) {
        for (var H = this.decodeTree, O = H[this.treeIndex], M = (O & k.VALUE_LENGTH) >> 14; V < $.length; V++, this.excess++) {
          var L = $.charCodeAt(V);
          if (this.treeIndex = x(H, O, this.treeIndex + Math.max(1, M), L), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === S.Attribute && // We shouldn't have consumed any characters after the entity,
            (M === 0 || // And there should be no invalid characters.
            h(L)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (O = H[this.treeIndex], M = (O & k.VALUE_LENGTH) >> 14, M !== 0) {
            if (L === c.SEMI)
              return this.emitNamedEntityData(this.treeIndex, M, this.consumed + this.excess);
            this.decodeMode !== S.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, E.prototype.emitNotTerminatedNamedEntity = function() {
        var $, V = this, H = V.result, O = V.decodeTree, M = (O[H] & k.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(H, M, this.consumed), ($ = this.errors) === null || $ === void 0 || $.missingSemicolonAfterCharacterReference(), this.consumed;
      }, E.prototype.emitNamedEntityData = function($, V, H) {
        var O = this.decodeTree;
        return this.emitCodePoint(V === 1 ? O[$] & ~k.VALUE_LENGTH : O[$ + 1], H), V === 3 && this.emitCodePoint(O[$ + 2], H), H;
      }, E.prototype.end = function() {
        var $;
        switch (this.state) {
          case N.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== S.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case N.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case N.NumericHex:
            return this.emitNumericEntity(0, 3);
          case N.NumericStart:
            return ($ = this.errors) === null || $ === void 0 || $.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case N.EntityStart:
            return 0;
        }
      }, E;
    }()
  );
  e.EntityDecoder = F;
  function y(E) {
    var $ = "", V = new F(E, function(H) {
      return $ += (0, o.fromCodePoint)(H);
    });
    return function(O, M) {
      for (var L = 0, _ = 0; (_ = O.indexOf("&", _)) >= 0; ) {
        $ += O.slice(L, _), V.startEntity(M);
        var z = V.write(
          O,
          // Skip the "&"
          _ + 1
        );
        if (z < 0) {
          L = _ + V.end();
          break;
        }
        L = _ + z, _ = z === 0 ? L + 1 : L;
      }
      var ne = $ + O.slice(L);
      return $ = "", ne;
    };
  }
  function x(E, $, V, H) {
    var O = ($ & k.BRANCH_LENGTH) >> 7, M = $ & k.JUMP_TABLE;
    if (O === 0)
      return M !== 0 && H === M ? V : -1;
    if (M) {
      var L = H - M;
      return L < 0 || L >= O ? -1 : E[V + L] - 1;
    }
    for (var _ = V, z = _ + O - 1; _ <= z; ) {
      var ne = _ + z >>> 1, Se = E[ne];
      if (Se < H)
        _ = ne + 1;
      else if (Se > H)
        z = ne - 1;
      else
        return E[ne + O];
    }
    return -1;
  }
  e.determineBranch = x;
  var R = y(s.default), T = y(r.default);
  function j(E, $) {
    return $ === void 0 && ($ = S.Legacy), R(E, $);
  }
  e.decodeHTML = j;
  function A(E) {
    return R(E, S.Attribute);
  }
  e.decodeHTMLAttribute = A;
  function B(E) {
    return R(E, S.Strict);
  }
  e.decodeHTMLStrict = B;
  function W(E) {
    return T(E, S.Strict);
  }
  e.decodeXML = W;
})(Vo);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.QuoteType = void 0;
  var n = Vo, i;
  (function(m) {
    m[m.Tab = 9] = "Tab", m[m.NewLine = 10] = "NewLine", m[m.FormFeed = 12] = "FormFeed", m[m.CarriageReturn = 13] = "CarriageReturn", m[m.Space = 32] = "Space", m[m.ExclamationMark = 33] = "ExclamationMark", m[m.Number = 35] = "Number", m[m.Amp = 38] = "Amp", m[m.SingleQuote = 39] = "SingleQuote", m[m.DoubleQuote = 34] = "DoubleQuote", m[m.Dash = 45] = "Dash", m[m.Slash = 47] = "Slash", m[m.Zero = 48] = "Zero", m[m.Nine = 57] = "Nine", m[m.Semi = 59] = "Semi", m[m.Lt = 60] = "Lt", m[m.Eq = 61] = "Eq", m[m.Gt = 62] = "Gt", m[m.Questionmark = 63] = "Questionmark", m[m.UpperA = 65] = "UpperA", m[m.LowerA = 97] = "LowerA", m[m.UpperF = 70] = "UpperF", m[m.LowerF = 102] = "LowerF", m[m.UpperZ = 90] = "UpperZ", m[m.LowerZ = 122] = "LowerZ", m[m.LowerX = 120] = "LowerX", m[m.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(i || (i = {}));
  var t;
  (function(m) {
    m[m.Text = 1] = "Text", m[m.BeforeTagName = 2] = "BeforeTagName", m[m.InTagName = 3] = "InTagName", m[m.InSelfClosingTag = 4] = "InSelfClosingTag", m[m.BeforeClosingTagName = 5] = "BeforeClosingTagName", m[m.InClosingTagName = 6] = "InClosingTagName", m[m.AfterClosingTagName = 7] = "AfterClosingTagName", m[m.BeforeAttributeName = 8] = "BeforeAttributeName", m[m.InAttributeName = 9] = "InAttributeName", m[m.AfterAttributeName = 10] = "AfterAttributeName", m[m.BeforeAttributeValue = 11] = "BeforeAttributeValue", m[m.InAttributeValueDq = 12] = "InAttributeValueDq", m[m.InAttributeValueSq = 13] = "InAttributeValueSq", m[m.InAttributeValueNq = 14] = "InAttributeValueNq", m[m.BeforeDeclaration = 15] = "BeforeDeclaration", m[m.InDeclaration = 16] = "InDeclaration", m[m.InProcessingInstruction = 17] = "InProcessingInstruction", m[m.BeforeComment = 18] = "BeforeComment", m[m.CDATASequence = 19] = "CDATASequence", m[m.InSpecialComment = 20] = "InSpecialComment", m[m.InCommentLike = 21] = "InCommentLike", m[m.BeforeSpecialS = 22] = "BeforeSpecialS", m[m.SpecialStartSequence = 23] = "SpecialStartSequence", m[m.InSpecialTag = 24] = "InSpecialTag", m[m.BeforeEntity = 25] = "BeforeEntity", m[m.BeforeNumericEntity = 26] = "BeforeNumericEntity", m[m.InNamedEntity = 27] = "InNamedEntity", m[m.InNumericEntity = 28] = "InNumericEntity", m[m.InHexEntity = 29] = "InHexEntity";
  })(t || (t = {}));
  function a(m) {
    return m === i.Space || m === i.NewLine || m === i.Tab || m === i.FormFeed || m === i.CarriageReturn;
  }
  function s(m) {
    return m === i.Slash || m === i.Gt || a(m);
  }
  function r(m) {
    return m >= i.Zero && m <= i.Nine;
  }
  function o(m) {
    return m >= i.LowerA && m <= i.LowerZ || m >= i.UpperA && m <= i.UpperZ;
  }
  function d(m) {
    return m >= i.UpperA && m <= i.UpperF || m >= i.LowerA && m <= i.LowerF;
  }
  var c;
  (function(m) {
    m[m.NoValue = 0] = "NoValue", m[m.Unquoted = 1] = "Unquoted", m[m.Single = 2] = "Single", m[m.Double = 3] = "Double";
  })(c = e.QuoteType || (e.QuoteType = {}));
  var u = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, k = (
    /** @class */
    function() {
      function m(f, p) {
        var h = f.xmlMode, N = h === void 0 ? !1 : h, S = f.decodeEntities, F = S === void 0 ? !0 : S;
        this.cbs = p, this.state = t.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = t.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = N, this.decodeEntities = F, this.entityTrie = N ? n.xmlDecodeTree : n.htmlDecodeTree;
      }
      return m.prototype.reset = function() {
        this.state = t.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = t.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
      }, m.prototype.write = function(f) {
        this.offset += this.buffer.length, this.buffer = f, this.parse();
      }, m.prototype.end = function() {
        this.running && this.finish();
      }, m.prototype.pause = function() {
        this.running = !1;
      }, m.prototype.resume = function() {
        this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
      }, m.prototype.getIndex = function() {
        return this.index;
      }, m.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, m.prototype.stateText = function(f) {
        f === i.Lt || !this.decodeEntities && this.fastForwardTo(i.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = t.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && f === i.Amp && (this.state = t.BeforeEntity);
      }, m.prototype.stateSpecialStartSequence = function(f) {
        var p = this.sequenceIndex === this.currentSequence.length, h = p ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          s(f)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (f | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!h)
          this.isSpecial = !1;
        else if (!p) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = t.InTagName, this.stateInTagName(f);
      }, m.prototype.stateInSpecialTag = function(f) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (f === i.Gt || a(f)) {
            var p = this.index - this.currentSequence.length;
            if (this.sectionStart < p) {
              var h = this.index;
              this.index = p, this.cbs.ontext(this.sectionStart, p), this.index = h;
            }
            this.isSpecial = !1, this.sectionStart = p + 2, this.stateInClosingTagName(f);
            return;
          }
          this.sequenceIndex = 0;
        }
        (f | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === u.TitleEnd ? this.decodeEntities && f === i.Amp && (this.state = t.BeforeEntity) : this.fastForwardTo(i.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(f === i.Lt);
      }, m.prototype.stateCDATASequence = function(f) {
        f === u.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === u.Cdata.length && (this.state = t.InCommentLike, this.currentSequence = u.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = t.InDeclaration, this.stateInDeclaration(f));
      }, m.prototype.fastForwardTo = function(f) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === f)
            return !0;
        return this.index = this.buffer.length + this.offset - 1, !1;
      }, m.prototype.stateInCommentLike = function(f) {
        f === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === u.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = t.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : f !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, m.prototype.isTagStartChar = function(f) {
        return this.xmlMode ? !s(f) : o(f);
      }, m.prototype.startSpecial = function(f, p) {
        this.isSpecial = !0, this.currentSequence = f, this.sequenceIndex = p, this.state = t.SpecialStartSequence;
      }, m.prototype.stateBeforeTagName = function(f) {
        if (f === i.ExclamationMark)
          this.state = t.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (f === i.Questionmark)
          this.state = t.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(f)) {
          var p = f | 32;
          this.sectionStart = this.index, !this.xmlMode && p === u.TitleEnd[2] ? this.startSpecial(u.TitleEnd, 3) : this.state = !this.xmlMode && p === u.ScriptEnd[2] ? t.BeforeSpecialS : t.InTagName;
        } else f === i.Slash ? this.state = t.BeforeClosingTagName : (this.state = t.Text, this.stateText(f));
      }, m.prototype.stateInTagName = function(f) {
        s(f) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = t.BeforeAttributeName, this.stateBeforeAttributeName(f));
      }, m.prototype.stateBeforeClosingTagName = function(f) {
        a(f) || (f === i.Gt ? this.state = t.Text : (this.state = this.isTagStartChar(f) ? t.InClosingTagName : t.InSpecialComment, this.sectionStart = this.index));
      }, m.prototype.stateInClosingTagName = function(f) {
        (f === i.Gt || a(f)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = t.AfterClosingTagName, this.stateAfterClosingTagName(f));
      }, m.prototype.stateAfterClosingTagName = function(f) {
        (f === i.Gt || this.fastForwardTo(i.Gt)) && (this.state = t.Text, this.baseState = t.Text, this.sectionStart = this.index + 1);
      }, m.prototype.stateBeforeAttributeName = function(f) {
        f === i.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = t.InSpecialTag, this.sequenceIndex = 0) : this.state = t.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : f === i.Slash ? this.state = t.InSelfClosingTag : a(f) || (this.state = t.InAttributeName, this.sectionStart = this.index);
      }, m.prototype.stateInSelfClosingTag = function(f) {
        f === i.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = t.Text, this.baseState = t.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : a(f) || (this.state = t.BeforeAttributeName, this.stateBeforeAttributeName(f));
      }, m.prototype.stateInAttributeName = function(f) {
        (f === i.Eq || s(f)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = t.AfterAttributeName, this.stateAfterAttributeName(f));
      }, m.prototype.stateAfterAttributeName = function(f) {
        f === i.Eq ? this.state = t.BeforeAttributeValue : f === i.Slash || f === i.Gt ? (this.cbs.onattribend(c.NoValue, this.index), this.state = t.BeforeAttributeName, this.stateBeforeAttributeName(f)) : a(f) || (this.cbs.onattribend(c.NoValue, this.index), this.state = t.InAttributeName, this.sectionStart = this.index);
      }, m.prototype.stateBeforeAttributeValue = function(f) {
        f === i.DoubleQuote ? (this.state = t.InAttributeValueDq, this.sectionStart = this.index + 1) : f === i.SingleQuote ? (this.state = t.InAttributeValueSq, this.sectionStart = this.index + 1) : a(f) || (this.sectionStart = this.index, this.state = t.InAttributeValueNq, this.stateInAttributeValueNoQuotes(f));
      }, m.prototype.handleInAttributeValue = function(f, p) {
        f === p || !this.decodeEntities && this.fastForwardTo(p) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(p === i.DoubleQuote ? c.Double : c.Single, this.index), this.state = t.BeforeAttributeName) : this.decodeEntities && f === i.Amp && (this.baseState = this.state, this.state = t.BeforeEntity);
      }, m.prototype.stateInAttributeValueDoubleQuotes = function(f) {
        this.handleInAttributeValue(f, i.DoubleQuote);
      }, m.prototype.stateInAttributeValueSingleQuotes = function(f) {
        this.handleInAttributeValue(f, i.SingleQuote);
      }, m.prototype.stateInAttributeValueNoQuotes = function(f) {
        a(f) || f === i.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(c.Unquoted, this.index), this.state = t.BeforeAttributeName, this.stateBeforeAttributeName(f)) : this.decodeEntities && f === i.Amp && (this.baseState = this.state, this.state = t.BeforeEntity);
      }, m.prototype.stateBeforeDeclaration = function(f) {
        f === i.OpeningSquareBracket ? (this.state = t.CDATASequence, this.sequenceIndex = 0) : this.state = f === i.Dash ? t.BeforeComment : t.InDeclaration;
      }, m.prototype.stateInDeclaration = function(f) {
        (f === i.Gt || this.fastForwardTo(i.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = t.Text, this.sectionStart = this.index + 1);
      }, m.prototype.stateInProcessingInstruction = function(f) {
        (f === i.Gt || this.fastForwardTo(i.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = t.Text, this.sectionStart = this.index + 1);
      }, m.prototype.stateBeforeComment = function(f) {
        f === i.Dash ? (this.state = t.InCommentLike, this.currentSequence = u.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = t.InDeclaration;
      }, m.prototype.stateInSpecialComment = function(f) {
        (f === i.Gt || this.fastForwardTo(i.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = t.Text, this.sectionStart = this.index + 1);
      }, m.prototype.stateBeforeSpecialS = function(f) {
        var p = f | 32;
        p === u.ScriptEnd[3] ? this.startSpecial(u.ScriptEnd, 4) : p === u.StyleEnd[3] ? this.startSpecial(u.StyleEnd, 4) : (this.state = t.InTagName, this.stateInTagName(f));
      }, m.prototype.stateBeforeEntity = function(f) {
        this.entityExcess = 1, this.entityResult = 0, f === i.Number ? this.state = t.BeforeNumericEntity : f === i.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = t.InNamedEntity, this.stateInNamedEntity(f));
      }, m.prototype.stateInNamedEntity = function(f) {
        if (this.entityExcess += 1, this.trieIndex = (0, n.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, f), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var p = this.trieCurrent & n.BinTrieFlags.VALUE_LENGTH;
        if (p) {
          var h = (p >> 14) - 1;
          if (!this.allowLegacyEntity() && f !== i.Semi)
            this.trieIndex += h;
          else {
            var N = this.index - this.entityExcess + 1;
            N > this.sectionStart && this.emitPartial(this.sectionStart, N), this.entityResult = this.trieIndex, this.trieIndex += h, this.entityExcess = 0, this.sectionStart = this.index + 1, h === 0 && this.emitNamedEntity();
          }
        }
      }, m.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var f = (this.entityTrie[this.entityResult] & n.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (f) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~n.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, m.prototype.stateBeforeNumericEntity = function(f) {
        (f | 32) === i.LowerX ? (this.entityExcess++, this.state = t.InHexEntity) : (this.state = t.InNumericEntity, this.stateInNumericEntity(f));
      }, m.prototype.emitNumericEntity = function(f) {
        var p = this.index - this.entityExcess - 1, h = p + 2 + +(this.state === t.InHexEntity);
        h !== this.index && (p > this.sectionStart && this.emitPartial(this.sectionStart, p), this.sectionStart = this.index + Number(f), this.emitCodePoint((0, n.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, m.prototype.stateInNumericEntity = function(f) {
        f === i.Semi ? this.emitNumericEntity(!0) : r(f) ? (this.entityResult = this.entityResult * 10 + (f - i.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, m.prototype.stateInHexEntity = function(f) {
        f === i.Semi ? this.emitNumericEntity(!0) : r(f) ? (this.entityResult = this.entityResult * 16 + (f - i.Zero), this.entityExcess++) : d(f) ? (this.entityResult = this.entityResult * 16 + ((f | 32) - i.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, m.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === t.Text || this.baseState === t.InSpecialTag);
      }, m.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === t.Text || this.state === t.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === t.InAttributeValueDq || this.state === t.InAttributeValueSq || this.state === t.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, m.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, m.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var f = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case t.Text: {
              this.stateText(f);
              break;
            }
            case t.SpecialStartSequence: {
              this.stateSpecialStartSequence(f);
              break;
            }
            case t.InSpecialTag: {
              this.stateInSpecialTag(f);
              break;
            }
            case t.CDATASequence: {
              this.stateCDATASequence(f);
              break;
            }
            case t.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(f);
              break;
            }
            case t.InAttributeName: {
              this.stateInAttributeName(f);
              break;
            }
            case t.InCommentLike: {
              this.stateInCommentLike(f);
              break;
            }
            case t.InSpecialComment: {
              this.stateInSpecialComment(f);
              break;
            }
            case t.BeforeAttributeName: {
              this.stateBeforeAttributeName(f);
              break;
            }
            case t.InTagName: {
              this.stateInTagName(f);
              break;
            }
            case t.InClosingTagName: {
              this.stateInClosingTagName(f);
              break;
            }
            case t.BeforeTagName: {
              this.stateBeforeTagName(f);
              break;
            }
            case t.AfterAttributeName: {
              this.stateAfterAttributeName(f);
              break;
            }
            case t.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(f);
              break;
            }
            case t.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(f);
              break;
            }
            case t.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(f);
              break;
            }
            case t.AfterClosingTagName: {
              this.stateAfterClosingTagName(f);
              break;
            }
            case t.BeforeSpecialS: {
              this.stateBeforeSpecialS(f);
              break;
            }
            case t.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(f);
              break;
            }
            case t.InSelfClosingTag: {
              this.stateInSelfClosingTag(f);
              break;
            }
            case t.InDeclaration: {
              this.stateInDeclaration(f);
              break;
            }
            case t.BeforeDeclaration: {
              this.stateBeforeDeclaration(f);
              break;
            }
            case t.BeforeComment: {
              this.stateBeforeComment(f);
              break;
            }
            case t.InProcessingInstruction: {
              this.stateInProcessingInstruction(f);
              break;
            }
            case t.InNamedEntity: {
              this.stateInNamedEntity(f);
              break;
            }
            case t.BeforeEntity: {
              this.stateBeforeEntity(f);
              break;
            }
            case t.InHexEntity: {
              this.stateInHexEntity(f);
              break;
            }
            case t.InNumericEntity: {
              this.stateInNumericEntity(f);
              break;
            }
            default:
              this.stateBeforeNumericEntity(f);
          }
          this.index++;
        }
        this.cleanup();
      }, m.prototype.finish = function() {
        this.state === t.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, m.prototype.handleTrailingData = function() {
        var f = this.buffer.length + this.offset;
        this.state === t.InCommentLike ? this.currentSequence === u.CdataEnd ? this.cbs.oncdata(this.sectionStart, f, 0) : this.cbs.oncomment(this.sectionStart, f, 0) : this.state === t.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === t.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === t.InTagName || this.state === t.BeforeAttributeName || this.state === t.BeforeAttributeValue || this.state === t.AfterAttributeName || this.state === t.InAttributeName || this.state === t.InAttributeValueSq || this.state === t.InAttributeValueDq || this.state === t.InAttributeValueNq || this.state === t.InClosingTagName || this.cbs.ontext(this.sectionStart, f);
      }, m.prototype.emitPartial = function(f, p) {
        this.baseState !== t.Text && this.baseState !== t.InSpecialTag ? this.cbs.onattribdata(f, p) : this.cbs.ontext(f, p);
      }, m.prototype.emitCodePoint = function(f) {
        this.baseState !== t.Text && this.baseState !== t.InSpecialTag ? this.cbs.onattribentity(f) : this.cbs.ontextentity(f);
      }, m;
    }()
  );
  e.default = k;
})(Xv);
var bH = Be && Be.__createBinding || (Object.create ? function(e, n, i, t) {
  t === void 0 && (t = i);
  var a = Object.getOwnPropertyDescriptor(n, i);
  (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return n[i];
  } }), Object.defineProperty(e, t, a);
} : function(e, n, i, t) {
  t === void 0 && (t = i), e[t] = n[i];
}), CH = Be && Be.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), xH = Be && Be.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var i in e) i !== "default" && Object.prototype.hasOwnProperty.call(e, i) && bH(n, e, i);
  return CH(n, e), n;
};
Object.defineProperty(Uo, "__esModule", { value: !0 });
Uo.Parser = void 0;
var mc = xH(Xv), W4 = Vo, g1 = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), Ln = /* @__PURE__ */ new Set(["p"]), K4 = /* @__PURE__ */ new Set(["thead", "tbody"]), Y4 = /* @__PURE__ */ new Set(["dd", "dt"]), X4 = /* @__PURE__ */ new Set(["rt", "rp"]), DH = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", Ln],
  ["h1", Ln],
  ["h2", Ln],
  ["h3", Ln],
  ["h4", Ln],
  ["h5", Ln],
  ["h6", Ln],
  ["select", g1],
  ["input", g1],
  ["output", g1],
  ["button", g1],
  ["datalist", g1],
  ["textarea", g1],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", Y4],
  ["dt", Y4],
  ["address", Ln],
  ["article", Ln],
  ["aside", Ln],
  ["blockquote", Ln],
  ["details", Ln],
  ["div", Ln],
  ["dl", Ln],
  ["fieldset", Ln],
  ["figcaption", Ln],
  ["figure", Ln],
  ["footer", Ln],
  ["form", Ln],
  ["header", Ln],
  ["hr", Ln],
  ["main", Ln],
  ["nav", Ln],
  ["ol", Ln],
  ["pre", Ln],
  ["section", Ln],
  ["table", Ln],
  ["ul", Ln],
  ["rt", X4],
  ["rp", X4],
  ["tbody", K4],
  ["tfoot", K4]
]), wH = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), Z4 = /* @__PURE__ */ new Set(["math", "svg"]), eS = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), PH = /\s|\//, RH = (
  /** @class */
  function() {
    function e(n, i) {
      i === void 0 && (i = {});
      var t, a, s, r, o;
      this.options = i, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = n != null ? n : {}, this.lowerCaseTagNames = (t = i.lowerCaseTags) !== null && t !== void 0 ? t : !i.xmlMode, this.lowerCaseAttributeNames = (a = i.lowerCaseAttributeNames) !== null && a !== void 0 ? a : !i.xmlMode, this.tokenizer = new ((s = i.Tokenizer) !== null && s !== void 0 ? s : mc.default)(this.options, this), (o = (r = this.cbs).onparserinit) === null || o === void 0 || o.call(r, this);
    }
    return e.prototype.ontext = function(n, i) {
      var t, a, s = this.getSlice(n, i);
      this.endIndex = i - 1, (a = (t = this.cbs).ontext) === null || a === void 0 || a.call(t, s), this.startIndex = i;
    }, e.prototype.ontextentity = function(n) {
      var i, t, a = this.tokenizer.getSectionStart();
      this.endIndex = a - 1, (t = (i = this.cbs).ontext) === null || t === void 0 || t.call(i, (0, W4.fromCodePoint)(n)), this.startIndex = a;
    }, e.prototype.isVoidElement = function(n) {
      return !this.options.xmlMode && wH.has(n);
    }, e.prototype.onopentagname = function(n, i) {
      this.endIndex = i;
      var t = this.getSlice(n, i);
      this.lowerCaseTagNames && (t = t.toLowerCase()), this.emitOpenTag(t);
    }, e.prototype.emitOpenTag = function(n) {
      var i, t, a, s;
      this.openTagStart = this.startIndex, this.tagname = n;
      var r = !this.options.xmlMode && DH.get(n);
      if (r)
        for (; this.stack.length > 0 && r.has(this.stack[this.stack.length - 1]); ) {
          var o = this.stack.pop();
          (t = (i = this.cbs).onclosetag) === null || t === void 0 || t.call(i, o, !0);
        }
      this.isVoidElement(n) || (this.stack.push(n), Z4.has(n) ? this.foreignContext.push(!0) : eS.has(n) && this.foreignContext.push(!1)), (s = (a = this.cbs).onopentagname) === null || s === void 0 || s.call(a, n), this.cbs.onopentag && (this.attribs = {});
    }, e.prototype.endOpenTag = function(n) {
      var i, t;
      this.startIndex = this.openTagStart, this.attribs && ((t = (i = this.cbs).onopentag) === null || t === void 0 || t.call(i, this.tagname, this.attribs, n), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, e.prototype.onopentagend = function(n) {
      this.endIndex = n, this.endOpenTag(!1), this.startIndex = n + 1;
    }, e.prototype.onclosetag = function(n, i) {
      var t, a, s, r, o, d;
      this.endIndex = i;
      var c = this.getSlice(n, i);
      if (this.lowerCaseTagNames && (c = c.toLowerCase()), (Z4.has(c) || eS.has(c)) && this.foreignContext.pop(), this.isVoidElement(c))
        !this.options.xmlMode && c === "br" && ((a = (t = this.cbs).onopentagname) === null || a === void 0 || a.call(t, "br"), (r = (s = this.cbs).onopentag) === null || r === void 0 || r.call(s, "br", {}, !0), (d = (o = this.cbs).onclosetag) === null || d === void 0 || d.call(o, "br", !1));
      else {
        var u = this.stack.lastIndexOf(c);
        if (u !== -1)
          if (this.cbs.onclosetag)
            for (var k = this.stack.length - u; k--; )
              this.cbs.onclosetag(this.stack.pop(), k !== 0);
          else
            this.stack.length = u;
        else !this.options.xmlMode && c === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = i + 1;
    }, e.prototype.onselfclosingtag = function(n) {
      this.endIndex = n, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = n + 1) : this.onopentagend(n);
    }, e.prototype.closeCurrentTag = function(n) {
      var i, t, a = this.tagname;
      this.endOpenTag(n), this.stack[this.stack.length - 1] === a && ((t = (i = this.cbs).onclosetag) === null || t === void 0 || t.call(i, a, !n), this.stack.pop());
    }, e.prototype.onattribname = function(n, i) {
      this.startIndex = n;
      var t = this.getSlice(n, i);
      this.attribname = this.lowerCaseAttributeNames ? t.toLowerCase() : t;
    }, e.prototype.onattribdata = function(n, i) {
      this.attribvalue += this.getSlice(n, i);
    }, e.prototype.onattribentity = function(n) {
      this.attribvalue += (0, W4.fromCodePoint)(n);
    }, e.prototype.onattribend = function(n, i) {
      var t, a;
      this.endIndex = i, (a = (t = this.cbs).onattribute) === null || a === void 0 || a.call(t, this.attribname, this.attribvalue, n === mc.QuoteType.Double ? '"' : n === mc.QuoteType.Single ? "'" : n === mc.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, e.prototype.getInstructionName = function(n) {
      var i = n.search(PH), t = i < 0 ? n : n.substr(0, i);
      return this.lowerCaseTagNames && (t = t.toLowerCase()), t;
    }, e.prototype.ondeclaration = function(n, i) {
      this.endIndex = i;
      var t = this.getSlice(n, i);
      if (this.cbs.onprocessinginstruction) {
        var a = this.getInstructionName(t);
        this.cbs.onprocessinginstruction("!".concat(a), "!".concat(t));
      }
      this.startIndex = i + 1;
    }, e.prototype.onprocessinginstruction = function(n, i) {
      this.endIndex = i;
      var t = this.getSlice(n, i);
      if (this.cbs.onprocessinginstruction) {
        var a = this.getInstructionName(t);
        this.cbs.onprocessinginstruction("?".concat(a), "?".concat(t));
      }
      this.startIndex = i + 1;
    }, e.prototype.oncomment = function(n, i, t) {
      var a, s, r, o;
      this.endIndex = i, (s = (a = this.cbs).oncomment) === null || s === void 0 || s.call(a, this.getSlice(n, i - t)), (o = (r = this.cbs).oncommentend) === null || o === void 0 || o.call(r), this.startIndex = i + 1;
    }, e.prototype.oncdata = function(n, i, t) {
      var a, s, r, o, d, c, u, k, m, f;
      this.endIndex = i;
      var p = this.getSlice(n, i - t);
      this.options.xmlMode || this.options.recognizeCDATA ? ((s = (a = this.cbs).oncdatastart) === null || s === void 0 || s.call(a), (o = (r = this.cbs).ontext) === null || o === void 0 || o.call(r, p), (c = (d = this.cbs).oncdataend) === null || c === void 0 || c.call(d)) : ((k = (u = this.cbs).oncomment) === null || k === void 0 || k.call(u, "[CDATA[".concat(p, "]]")), (f = (m = this.cbs).oncommentend) === null || f === void 0 || f.call(m)), this.startIndex = i + 1;
    }, e.prototype.onend = function() {
      var n, i;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var t = this.stack.length; t > 0; this.cbs.onclosetag(this.stack[--t], !0))
          ;
      }
      (i = (n = this.cbs).onend) === null || i === void 0 || i.call(n);
    }, e.prototype.reset = function() {
      var n, i, t, a;
      (i = (n = this.cbs).onreset) === null || i === void 0 || i.call(n), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (a = (t = this.cbs).onparserinit) === null || a === void 0 || a.call(t, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, e.prototype.parseComplete = function(n) {
      this.reset(), this.end(n);
    }, e.prototype.getSlice = function(n, i) {
      for (; n - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var t = this.buffers[0].slice(n - this.bufferOffset, i - this.bufferOffset); i - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), t += this.buffers[0].slice(0, i - this.bufferOffset);
      return t;
    }, e.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, e.prototype.write = function(n) {
      var i, t;
      if (this.ended) {
        (t = (i = this.cbs).onerror) === null || t === void 0 || t.call(i, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(n), this.tokenizer.running && (this.tokenizer.write(n), this.writeIndex++);
    }, e.prototype.end = function(n) {
      var i, t;
      if (this.ended) {
        (t = (i = this.cbs).onerror) === null || t === void 0 || t.call(i, new Error(".end() after done!"));
        return;
      }
      n && this.write(n), this.ended = !0, this.tokenizer.end();
    }, e.prototype.pause = function() {
      this.tokenizer.pause();
    }, e.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, e.prototype.parseChunk = function(n) {
      this.write(n);
    }, e.prototype.done = function(n) {
      this.end(n);
    }, e;
  }()
);
Uo.Parser = RH;
var sl = {}, Or = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
  var n;
  (function(t) {
    t.Root = "root", t.Text = "text", t.Directive = "directive", t.Comment = "comment", t.Script = "script", t.Style = "style", t.Tag = "tag", t.CDATA = "cdata", t.Doctype = "doctype";
  })(n = e.ElementType || (e.ElementType = {}));
  function i(t) {
    return t.type === n.Tag || t.type === n.Script || t.type === n.Style;
  }
  e.isTag = i, e.Root = n.Root, e.Text = n.Text, e.Directive = n.Directive, e.Comment = n.Comment, e.Script = n.Script, e.Style = n.Style, e.Tag = n.Tag, e.CDATA = n.CDATA, e.Doctype = n.Doctype;
})(Or);
var In = {}, hs = Be && Be.__extends || /* @__PURE__ */ function() {
  var e = function(n, i) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, a) {
      t.__proto__ = a;
    } || function(t, a) {
      for (var s in a) Object.prototype.hasOwnProperty.call(a, s) && (t[s] = a[s]);
    }, e(n, i);
  };
  return function(n, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Class extends value " + String(i) + " is not a constructor or null");
    e(n, i);
    function t() {
      this.constructor = n;
    }
    n.prototype = i === null ? Object.create(i) : (t.prototype = i.prototype, new t());
  };
}(), xo = Be && Be.__assign || function() {
  return xo = Object.assign || function(e) {
    for (var n, i = 1, t = arguments.length; i < t; i++) {
      n = arguments[i];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, xo.apply(this, arguments);
};
Object.defineProperty(In, "__esModule", { value: !0 });
In.cloneNode = In.hasChildren = In.isDocument = In.isDirective = In.isComment = In.isText = In.isCDATA = In.isTag = In.Element = In.Document = In.CDATA = In.NodeWithChildren = In.ProcessingInstruction = In.Comment = In.Text = In.DataNode = In.Node = void 0;
var Ft = Or, nh = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(n) {
        this.parent = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(n) {
        this.prev = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(n) {
        this.next = n;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(n) {
      return n === void 0 && (n = !1), ih(this, n);
    }, e;
  }()
);
In.Node = nh;
var zm = (
  /** @class */
  function(e) {
    hs(n, e);
    function n(i) {
      var t = e.call(this) || this;
      return t.data = i, t;
    }
    return Object.defineProperty(n.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(i) {
        this.data = i;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(nh)
);
In.DataNode = zm;
var DC = (
  /** @class */
  function(e) {
    hs(n, e);
    function n() {
      var i = e !== null && e.apply(this, arguments) || this;
      return i.type = Ft.ElementType.Text, i;
    }
    return Object.defineProperty(n.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(zm)
);
In.Text = DC;
var wC = (
  /** @class */
  function(e) {
    hs(n, e);
    function n() {
      var i = e !== null && e.apply(this, arguments) || this;
      return i.type = Ft.ElementType.Comment, i;
    }
    return Object.defineProperty(n.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(zm)
);
In.Comment = wC;
var PC = (
  /** @class */
  function(e) {
    hs(n, e);
    function n(i, t) {
      var a = e.call(this, t) || this;
      return a.name = i, a.type = Ft.ElementType.Directive, a;
    }
    return Object.defineProperty(n.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(zm)
);
In.ProcessingInstruction = PC;
var Bm = (
  /** @class */
  function(e) {
    hs(n, e);
    function n(i) {
      var t = e.call(this) || this;
      return t.children = i, t;
    }
    return Object.defineProperty(n.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var i;
        return (i = this.children[0]) !== null && i !== void 0 ? i : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(i) {
        this.children = i;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(nh)
);
In.NodeWithChildren = Bm;
var RC = (
  /** @class */
  function(e) {
    hs(n, e);
    function n() {
      var i = e !== null && e.apply(this, arguments) || this;
      return i.type = Ft.ElementType.CDATA, i;
    }
    return Object.defineProperty(n.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(Bm)
);
In.CDATA = RC;
var TC = (
  /** @class */
  function(e) {
    hs(n, e);
    function n() {
      var i = e !== null && e.apply(this, arguments) || this;
      return i.type = Ft.ElementType.Root, i;
    }
    return Object.defineProperty(n.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(Bm)
);
In.Document = TC;
var jC = (
  /** @class */
  function(e) {
    hs(n, e);
    function n(i, t, a, s) {
      a === void 0 && (a = []), s === void 0 && (s = i === "script" ? Ft.ElementType.Script : i === "style" ? Ft.ElementType.Style : Ft.ElementType.Tag);
      var r = e.call(this, a) || this;
      return r.name = i, r.attribs = t, r.type = s, r;
    }
    return Object.defineProperty(n.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(i) {
        this.name = i;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "attributes", {
      get: function() {
        var i = this;
        return Object.keys(this.attribs).map(function(t) {
          var a, s;
          return {
            name: t,
            value: i.attribs[t],
            namespace: (a = i["x-attribsNamespace"]) === null || a === void 0 ? void 0 : a[t],
            prefix: (s = i["x-attribsPrefix"]) === null || s === void 0 ? void 0 : s[t]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), n;
  }(Bm)
);
In.Element = jC;
function AC(e) {
  return (0, Ft.isTag)(e);
}
In.isTag = AC;
function OC(e) {
  return e.type === Ft.ElementType.CDATA;
}
In.isCDATA = OC;
function EC(e) {
  return e.type === Ft.ElementType.Text;
}
In.isText = EC;
function JC(e) {
  return e.type === Ft.ElementType.Comment;
}
In.isComment = JC;
function _C(e) {
  return e.type === Ft.ElementType.Directive;
}
In.isDirective = _C;
function QC(e) {
  return e.type === Ft.ElementType.Root;
}
In.isDocument = QC;
function TH(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
In.hasChildren = TH;
function ih(e, n) {
  n === void 0 && (n = !1);
  var i;
  if (EC(e))
    i = new DC(e.data);
  else if (JC(e))
    i = new wC(e.data);
  else if (AC(e)) {
    var t = n ? W0(e.children) : [], a = new jC(e.name, xo({}, e.attribs), t);
    t.forEach(function(d) {
      return d.parent = a;
    }), e.namespace != null && (a.namespace = e.namespace), e["x-attribsNamespace"] && (a["x-attribsNamespace"] = xo({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (a["x-attribsPrefix"] = xo({}, e["x-attribsPrefix"])), i = a;
  } else if (OC(e)) {
    var t = n ? W0(e.children) : [], s = new RC(t);
    t.forEach(function(c) {
      return c.parent = s;
    }), i = s;
  } else if (QC(e)) {
    var t = n ? W0(e.children) : [], r = new TC(t);
    t.forEach(function(c) {
      return c.parent = r;
    }), e["x-mode"] && (r["x-mode"] = e["x-mode"]), i = r;
  } else if (_C(e)) {
    var o = new PC(e.name, e.data);
    e["x-name"] != null && (o["x-name"] = e["x-name"], o["x-publicId"] = e["x-publicId"], o["x-systemId"] = e["x-systemId"]), i = o;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return i.startIndex = e.startIndex, i.endIndex = e.endIndex, e.sourceCodeLocation != null && (i.sourceCodeLocation = e.sourceCodeLocation), i;
}
In.cloneNode = ih;
function W0(e) {
  for (var n = e.map(function(t) {
    return ih(t, !0);
  }), i = 1; i < n.length; i++)
    n[i].prev = n[i - 1], n[i - 1].next = n[i];
  return n;
}
(function(e) {
  var n = Be && Be.__createBinding || (Object.create ? function(o, d, c, u) {
    u === void 0 && (u = c);
    var k = Object.getOwnPropertyDescriptor(d, c);
    (!k || ("get" in k ? !d.__esModule : k.writable || k.configurable)) && (k = { enumerable: !0, get: function() {
      return d[c];
    } }), Object.defineProperty(o, u, k);
  } : function(o, d, c, u) {
    u === void 0 && (u = c), o[u] = d[c];
  }), i = Be && Be.__exportStar || function(o, d) {
    for (var c in o) c !== "default" && !Object.prototype.hasOwnProperty.call(d, c) && n(d, o, c);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
  var t = Or, a = In;
  i(In, e);
  var s = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, r = (
    /** @class */
    function() {
      function o(d, c, u) {
        this.dom = [], this.root = new a.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof c == "function" && (u = c, c = s), typeof d == "object" && (c = d, d = void 0), this.callback = d != null ? d : null, this.options = c != null ? c : s, this.elementCB = u != null ? u : null;
      }
      return o.prototype.onparserinit = function(d) {
        this.parser = d;
      }, o.prototype.onreset = function() {
        this.dom = [], this.root = new a.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, o.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, o.prototype.onerror = function(d) {
        this.handleCallback(d);
      }, o.prototype.onclosetag = function() {
        this.lastNode = null;
        var d = this.tagStack.pop();
        this.options.withEndIndices && (d.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(d);
      }, o.prototype.onopentag = function(d, c) {
        var u = this.options.xmlMode ? t.ElementType.Tag : void 0, k = new a.Element(d, c, void 0, u);
        this.addNode(k), this.tagStack.push(k);
      }, o.prototype.ontext = function(d) {
        var c = this.lastNode;
        if (c && c.type === t.ElementType.Text)
          c.data += d, this.options.withEndIndices && (c.endIndex = this.parser.endIndex);
        else {
          var u = new a.Text(d);
          this.addNode(u), this.lastNode = u;
        }
      }, o.prototype.oncomment = function(d) {
        if (this.lastNode && this.lastNode.type === t.ElementType.Comment) {
          this.lastNode.data += d;
          return;
        }
        var c = new a.Comment(d);
        this.addNode(c), this.lastNode = c;
      }, o.prototype.oncommentend = function() {
        this.lastNode = null;
      }, o.prototype.oncdatastart = function() {
        var d = new a.Text(""), c = new a.CDATA([d]);
        this.addNode(c), d.parent = c, this.lastNode = d;
      }, o.prototype.oncdataend = function() {
        this.lastNode = null;
      }, o.prototype.onprocessinginstruction = function(d, c) {
        var u = new a.ProcessingInstruction(d, c);
        this.addNode(u);
      }, o.prototype.handleCallback = function(d) {
        if (typeof this.callback == "function")
          this.callback(d, this.dom);
        else if (d)
          throw d;
      }, o.prototype.addNode = function(d) {
        var c = this.tagStack[this.tagStack.length - 1], u = c.children[c.children.length - 1];
        this.options.withStartIndices && (d.startIndex = this.parser.startIndex), this.options.withEndIndices && (d.endIndex = this.parser.endIndex), c.children.push(d), u && (d.prev = u, u.next = d), d.parent = c, this.lastNode = null;
      }, o;
    }()
  );
  e.DomHandler = r, e.default = r;
})(sl);
var Lc = {}, ps = {}, yd = {}, MC = {}, qs = {}, th = {};
Object.defineProperty(th, "__esModule", { value: !0 });
function kc(e) {
  for (var n = 1; n < e.length; n++)
    e[n][0] += e[n - 1][0] + 1;
  return e;
}
th.default = new Map(/* @__PURE__ */ kc([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ kc([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ kc([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ kc([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var Cu = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.getCodePoint = e.xmlReplacer = void 0, e.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var n = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  e.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(a, s) {
    return a.codePointAt(s);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(a, s) {
      return (a.charCodeAt(s) & 64512) === 55296 ? (a.charCodeAt(s) - 55296) * 1024 + a.charCodeAt(s + 1) - 56320 + 65536 : a.charCodeAt(s);
    }
  );
  function i(a) {
    for (var s = "", r = 0, o; (o = e.xmlReplacer.exec(a)) !== null; ) {
      var d = o.index, c = a.charCodeAt(d), u = n.get(c);
      u !== void 0 ? (s += a.substring(r, d) + u, r = d + 1) : (s += "".concat(a.substring(r, d), "&#x").concat((0, e.getCodePoint)(a, d).toString(16), ";"), r = e.xmlReplacer.lastIndex += +((c & 64512) === 55296));
    }
    return s + a.substr(r);
  }
  e.encodeXML = i, e.escape = i;
  function t(a, s) {
    return function(o) {
      for (var d, c = 0, u = ""; d = a.exec(o); )
        c !== d.index && (u += o.substring(c, d.index)), u += s.get(d[0].charCodeAt(0)), c = d.index + 1;
      return u + o.substring(c);
    };
  }
  e.escapeUTF8 = t(/[&<>'"]/g, n), e.escapeAttribute = t(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), e.escapeText = t(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(Cu);
var jH = Be && Be.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(qs, "__esModule", { value: !0 });
qs.encodeNonAsciiHTML = qs.encodeHTML = void 0;
var AH = jH(th), LC = Cu, OH = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function EH(e) {
  return $C(OH, e);
}
qs.encodeHTML = EH;
function JH(e) {
  return $C(LC.xmlReplacer, e);
}
qs.encodeNonAsciiHTML = JH;
function $C(e, n) {
  for (var i = "", t = 0, a; (a = e.exec(n)) !== null; ) {
    var s = a.index;
    i += n.substring(t, s);
    var r = n.charCodeAt(s), o = AH.default.get(r);
    if (typeof o == "object") {
      if (s + 1 < n.length) {
        var d = n.charCodeAt(s + 1), c = typeof o.n == "number" ? o.n === d ? o.o : void 0 : o.n.get(d);
        if (c !== void 0) {
          i += c, t = e.lastIndex += 1;
          continue;
        }
      }
      o = o.v;
    }
    if (o !== void 0)
      i += o, t = s + 1;
    else {
      var u = (0, LC.getCodePoint)(n, s);
      i += "&#x".concat(u.toString(16), ";"), t = e.lastIndex += +(u !== r);
    }
  }
  return i + n.substr(t);
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.decodeXMLStrict = e.decodeHTML5Strict = e.decodeHTML4Strict = e.decodeHTML5 = e.decodeHTML4 = e.decodeHTMLAttribute = e.decodeHTMLStrict = e.decodeHTML = e.decodeXML = e.DecodingMode = e.EntityDecoder = e.encodeHTML5 = e.encodeHTML4 = e.encodeNonAsciiHTML = e.encodeHTML = e.escapeText = e.escapeAttribute = e.escapeUTF8 = e.escape = e.encodeXML = e.encode = e.decodeStrict = e.decode = e.EncodingMode = e.EntityLevel = void 0;
  var n = Vo, i = qs, t = Cu, a;
  (function(m) {
    m[m.XML = 0] = "XML", m[m.HTML = 1] = "HTML";
  })(a = e.EntityLevel || (e.EntityLevel = {}));
  var s;
  (function(m) {
    m[m.UTF8 = 0] = "UTF8", m[m.ASCII = 1] = "ASCII", m[m.Extensive = 2] = "Extensive", m[m.Attribute = 3] = "Attribute", m[m.Text = 4] = "Text";
  })(s = e.EncodingMode || (e.EncodingMode = {}));
  function r(m, f) {
    f === void 0 && (f = a.XML);
    var p = typeof f == "number" ? f : f.level;
    if (p === a.HTML) {
      var h = typeof f == "object" ? f.mode : void 0;
      return (0, n.decodeHTML)(m, h);
    }
    return (0, n.decodeXML)(m);
  }
  e.decode = r;
  function o(m, f) {
    var p;
    f === void 0 && (f = a.XML);
    var h = typeof f == "number" ? { level: f } : f;
    return (p = h.mode) !== null && p !== void 0 || (h.mode = n.DecodingMode.Strict), r(m, h);
  }
  e.decodeStrict = o;
  function d(m, f) {
    f === void 0 && (f = a.XML);
    var p = typeof f == "number" ? { level: f } : f;
    return p.mode === s.UTF8 ? (0, t.escapeUTF8)(m) : p.mode === s.Attribute ? (0, t.escapeAttribute)(m) : p.mode === s.Text ? (0, t.escapeText)(m) : p.level === a.HTML ? p.mode === s.ASCII ? (0, i.encodeNonAsciiHTML)(m) : (0, i.encodeHTML)(m) : (0, t.encodeXML)(m);
  }
  e.encode = d;
  var c = Cu;
  Object.defineProperty(e, "encodeXML", { enumerable: !0, get: function() {
    return c.encodeXML;
  } }), Object.defineProperty(e, "escape", { enumerable: !0, get: function() {
    return c.escape;
  } }), Object.defineProperty(e, "escapeUTF8", { enumerable: !0, get: function() {
    return c.escapeUTF8;
  } }), Object.defineProperty(e, "escapeAttribute", { enumerable: !0, get: function() {
    return c.escapeAttribute;
  } }), Object.defineProperty(e, "escapeText", { enumerable: !0, get: function() {
    return c.escapeText;
  } });
  var u = qs;
  Object.defineProperty(e, "encodeHTML", { enumerable: !0, get: function() {
    return u.encodeHTML;
  } }), Object.defineProperty(e, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return u.encodeNonAsciiHTML;
  } }), Object.defineProperty(e, "encodeHTML4", { enumerable: !0, get: function() {
    return u.encodeHTML;
  } }), Object.defineProperty(e, "encodeHTML5", { enumerable: !0, get: function() {
    return u.encodeHTML;
  } });
  var k = Vo;
  Object.defineProperty(e, "EntityDecoder", { enumerable: !0, get: function() {
    return k.EntityDecoder;
  } }), Object.defineProperty(e, "DecodingMode", { enumerable: !0, get: function() {
    return k.DecodingMode;
  } }), Object.defineProperty(e, "decodeXML", { enumerable: !0, get: function() {
    return k.decodeXML;
  } }), Object.defineProperty(e, "decodeHTML", { enumerable: !0, get: function() {
    return k.decodeHTML;
  } }), Object.defineProperty(e, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return k.decodeHTMLStrict;
  } }), Object.defineProperty(e, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return k.decodeHTMLAttribute;
  } }), Object.defineProperty(e, "decodeHTML4", { enumerable: !0, get: function() {
    return k.decodeHTML;
  } }), Object.defineProperty(e, "decodeHTML5", { enumerable: !0, get: function() {
    return k.decodeHTML;
  } }), Object.defineProperty(e, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return k.decodeHTMLStrict;
  } }), Object.defineProperty(e, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return k.decodeHTMLStrict;
  } }), Object.defineProperty(e, "decodeXMLStrict", { enumerable: !0, get: function() {
    return k.decodeXML;
  } });
})(MC);
var X1 = {};
Object.defineProperty(X1, "__esModule", { value: !0 });
X1.attributeNames = X1.elementNames = void 0;
X1.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(e) {
  return [e.toLowerCase(), e];
}));
X1.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(e) {
  return [e.toLowerCase(), e];
}));
var O1 = Be && Be.__assign || function() {
  return O1 = Object.assign || function(e) {
    for (var n, i = 1, t = arguments.length; i < t; i++) {
      n = arguments[i];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, O1.apply(this, arguments);
}, _H = Be && Be.__createBinding || (Object.create ? function(e, n, i, t) {
  t === void 0 && (t = i);
  var a = Object.getOwnPropertyDescriptor(n, i);
  (!a || ("get" in a ? !n.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return n[i];
  } }), Object.defineProperty(e, t, a);
} : function(e, n, i, t) {
  t === void 0 && (t = i), e[t] = n[i];
}), QH = Be && Be.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), MH = Be && Be.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var i in e) i !== "default" && Object.prototype.hasOwnProperty.call(e, i) && _H(n, e, i);
  return QH(n, e), n;
};
Object.defineProperty(yd, "__esModule", { value: !0 });
yd.render = void 0;
var Ka = MH(Or), xu = MC, UC = X1, LH = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function $H(e) {
  return e.replace(/"/g, "&quot;");
}
function UH(e, n) {
  var i;
  if (e) {
    var t = ((i = n.encodeEntities) !== null && i !== void 0 ? i : n.decodeEntities) === !1 ? $H : n.xmlMode || n.encodeEntities !== "utf8" ? xu.encodeXML : xu.escapeAttribute;
    return Object.keys(e).map(function(a) {
      var s, r, o = (s = e[a]) !== null && s !== void 0 ? s : "";
      return n.xmlMode === "foreign" && (a = (r = UC.attributeNames.get(a)) !== null && r !== void 0 ? r : a), !n.emptyAttrs && !n.xmlMode && o === "" ? a : "".concat(a, '="').concat(t(o), '"');
    }).join(" ");
  }
}
var nS = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function qm(e, n) {
  n === void 0 && (n = {});
  for (var i = ("length" in e) ? e : [e], t = "", a = 0; a < i.length; a++)
    t += VH(i[a], n);
  return t;
}
yd.render = qm;
yd.default = qm;
function VH(e, n) {
  switch (e.type) {
    case Ka.Root:
      return qm(e.children, n);
    case Ka.Doctype:
    case Ka.Directive:
      return qH(e);
    case Ka.Comment:
      return KH(e);
    case Ka.CDATA:
      return WH(e);
    case Ka.Script:
    case Ka.Style:
    case Ka.Tag:
      return BH(e, n);
    case Ka.Text:
      return GH(e, n);
  }
}
var HH = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), zH = /* @__PURE__ */ new Set(["svg", "math"]);
function BH(e, n) {
  var i;
  n.xmlMode === "foreign" && (e.name = (i = UC.elementNames.get(e.name)) !== null && i !== void 0 ? i : e.name, e.parent && HH.has(e.parent.name) && (n = O1(O1({}, n), { xmlMode: !1 }))), !n.xmlMode && zH.has(e.name) && (n = O1(O1({}, n), { xmlMode: "foreign" }));
  var t = "<".concat(e.name), a = UH(e.attribs, n);
  return a && (t += " ".concat(a)), e.children.length === 0 && (n.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    n.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    n.selfClosingTags && nS.has(e.name)
  )) ? (n.xmlMode || (t += " "), t += "/>") : (t += ">", e.children.length > 0 && (t += qm(e.children, n)), (n.xmlMode || !nS.has(e.name)) && (t += "</".concat(e.name, ">"))), t;
}
function qH(e) {
  return "<".concat(e.data, ">");
}
function GH(e, n) {
  var i, t = e.data || "";
  return ((i = n.encodeEntities) !== null && i !== void 0 ? i : n.decodeEntities) !== !1 && !(!n.xmlMode && e.parent && LH.has(e.parent.name)) && (t = n.xmlMode || n.encodeEntities !== "utf8" ? (0, xu.encodeXML)(t) : (0, xu.escapeText)(t)), t;
}
function WH(e) {
  return "<![CDATA[".concat(e.children[0].data, "]]>");
}
function KH(e) {
  return "<!--".concat(e.data, "-->");
}
var YH = Be && Be.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ps, "__esModule", { value: !0 });
ps.getOuterHTML = VC;
ps.getInnerHTML = ez;
ps.getText = $c;
ps.textContent = pk;
ps.innerText = Nk;
var Ra = sl, XH = YH(yd), ZH = Or;
function VC(e, n) {
  return (0, XH.default)(e, n);
}
function ez(e, n) {
  return (0, Ra.hasChildren)(e) ? e.children.map(function(i) {
    return VC(i, n);
  }).join("") : "";
}
function $c(e) {
  return Array.isArray(e) ? e.map($c).join("") : (0, Ra.isTag)(e) ? e.name === "br" ? `
` : $c(e.children) : (0, Ra.isCDATA)(e) ? $c(e.children) : (0, Ra.isText)(e) ? e.data : "";
}
function pk(e) {
  return Array.isArray(e) ? e.map(pk).join("") : (0, Ra.hasChildren)(e) && !(0, Ra.isComment)(e) ? pk(e.children) : (0, Ra.isText)(e) ? e.data : "";
}
function Nk(e) {
  return Array.isArray(e) ? e.map(Nk).join("") : (0, Ra.hasChildren)(e) && (e.type === ZH.ElementType.Tag || (0, Ra.isCDATA)(e)) ? Nk(e.children) : (0, Ra.isText)(e) ? e.data : "";
}
var $a = {};
Object.defineProperty($a, "__esModule", { value: !0 });
$a.getChildren = HC;
$a.getParent = zC;
$a.getSiblings = nz;
$a.getAttributeValue = iz;
$a.hasAttrib = tz;
$a.getName = az;
$a.nextElementSibling = lz;
$a.prevElementSibling = sz;
var ah = sl;
function HC(e) {
  return (0, ah.hasChildren)(e) ? e.children : [];
}
function zC(e) {
  return e.parent || null;
}
function nz(e) {
  var n, i, t = zC(e);
  if (t != null)
    return HC(t);
  for (var a = [e], s = e.prev, r = e.next; s != null; )
    a.unshift(s), n = s, s = n.prev;
  for (; r != null; )
    a.push(r), i = r, r = i.next;
  return a;
}
function iz(e, n) {
  var i;
  return (i = e.attribs) === null || i === void 0 ? void 0 : i[n];
}
function tz(e, n) {
  return e.attribs != null && Object.prototype.hasOwnProperty.call(e.attribs, n) && e.attribs[n] != null;
}
function az(e) {
  return e.name;
}
function lz(e) {
  for (var n, i = e.next; i !== null && !(0, ah.isTag)(i); )
    n = i, i = n.next;
  return i;
}
function sz(e) {
  for (var n, i = e.prev; i !== null && !(0, ah.isTag)(i); )
    n = i, i = n.prev;
  return i;
}
var Ns = {};
Object.defineProperty(Ns, "__esModule", { value: !0 });
Ns.removeElement = bd;
Ns.replaceElement = rz;
Ns.appendChild = oz;
Ns.append = dz;
Ns.prependChild = cz;
Ns.prepend = uz;
function bd(e) {
  if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
    var n = e.parent.children, i = n.lastIndexOf(e);
    i >= 0 && n.splice(i, 1);
  }
  e.next = null, e.prev = null, e.parent = null;
}
function rz(e, n) {
  var i = n.prev = e.prev;
  i && (i.next = n);
  var t = n.next = e.next;
  t && (t.prev = n);
  var a = n.parent = e.parent;
  if (a) {
    var s = a.children;
    s[s.lastIndexOf(e)] = n, e.parent = null;
  }
}
function oz(e, n) {
  if (bd(n), n.next = null, n.parent = e, e.children.push(n) > 1) {
    var i = e.children[e.children.length - 2];
    i.next = n, n.prev = i;
  } else
    n.prev = null;
}
function dz(e, n) {
  bd(n);
  var i = e.parent, t = e.next;
  if (n.next = t, n.prev = e, e.next = n, n.parent = i, t) {
    if (t.prev = n, i) {
      var a = i.children;
      a.splice(a.lastIndexOf(t), 0, n);
    }
  } else i && i.children.push(n);
}
function cz(e, n) {
  if (bd(n), n.parent = e, n.prev = null, e.children.unshift(n) !== 1) {
    var i = e.children[1];
    i.prev = n, n.next = i;
  } else
    n.next = null;
}
function uz(e, n) {
  bd(n);
  var i = e.parent;
  if (i) {
    var t = i.children;
    t.splice(t.indexOf(e), 0, n);
  }
  e.prev && (e.prev.next = n), n.parent = i, n.prev = e.prev, n.next = e, e.prev = n;
}
var Sl = {};
Object.defineProperty(Sl, "__esModule", { value: !0 });
Sl.filter = mz;
Sl.find = BC;
Sl.findOneChild = kz;
Sl.findOne = qC;
Sl.existsOne = GC;
Sl.findAll = fz;
var Gs = sl;
function mz(e, n, i, t) {
  return i === void 0 && (i = !0), t === void 0 && (t = 1 / 0), BC(e, Array.isArray(n) ? n : [n], i, t);
}
function BC(e, n, i, t) {
  for (var a = [], s = [Array.isArray(n) ? n : [n]], r = [0]; ; ) {
    if (r[0] >= s[0].length) {
      if (r.length === 1)
        return a;
      s.shift(), r.shift();
      continue;
    }
    var o = s[0][r[0]++];
    if (e(o) && (a.push(o), --t <= 0))
      return a;
    i && (0, Gs.hasChildren)(o) && o.children.length > 0 && (r.unshift(0), s.unshift(o.children));
  }
}
function kz(e, n) {
  return n.find(e);
}
function qC(e, n, i) {
  i === void 0 && (i = !0);
  for (var t = Array.isArray(n) ? n : [n], a = 0; a < t.length; a++) {
    var s = t[a];
    if ((0, Gs.isTag)(s) && e(s))
      return s;
    if (i && (0, Gs.hasChildren)(s) && s.children.length > 0) {
      var r = qC(e, s.children, !0);
      if (r)
        return r;
    }
  }
  return null;
}
function GC(e, n) {
  return (Array.isArray(n) ? n : [n]).some(function(i) {
    return (0, Gs.isTag)(i) && e(i) || (0, Gs.hasChildren)(i) && GC(e, i.children);
  });
}
function fz(e, n) {
  for (var i = [], t = [Array.isArray(n) ? n : [n]], a = [0]; ; ) {
    if (a[0] >= t[0].length) {
      if (t.length === 1)
        return i;
      t.shift(), a.shift();
      continue;
    }
    var s = t[0][a[0]++];
    (0, Gs.isTag)(s) && e(s) && i.push(s), (0, Gs.hasChildren)(s) && s.children.length > 0 && (a.unshift(0), t.unshift(s.children));
  }
}
var gl = {};
Object.defineProperty(gl, "__esModule", { value: !0 });
gl.testElement = hz;
gl.getElements = pz;
gl.getElementById = Nz;
gl.getElementsByTagName = Sz;
gl.getElementsByClassName = gz;
gl.getElementsByTagType = Fz;
var js = sl, Cd = Sl, Du = {
  tag_name: function(e) {
    return typeof e == "function" ? function(n) {
      return (0, js.isTag)(n) && e(n.name);
    } : e === "*" ? js.isTag : function(n) {
      return (0, js.isTag)(n) && n.name === e;
    };
  },
  tag_type: function(e) {
    return typeof e == "function" ? function(n) {
      return e(n.type);
    } : function(n) {
      return n.type === e;
    };
  },
  tag_contains: function(e) {
    return typeof e == "function" ? function(n) {
      return (0, js.isText)(n) && e(n.data);
    } : function(n) {
      return (0, js.isText)(n) && n.data === e;
    };
  }
};
function lh(e, n) {
  return typeof n == "function" ? function(i) {
    return (0, js.isTag)(i) && n(i.attribs[e]);
  } : function(i) {
    return (0, js.isTag)(i) && i.attribs[e] === n;
  };
}
function vz(e, n) {
  return function(i) {
    return e(i) || n(i);
  };
}
function WC(e) {
  var n = Object.keys(e).map(function(i) {
    var t = e[i];
    return Object.prototype.hasOwnProperty.call(Du, i) ? Du[i](t) : lh(i, t);
  });
  return n.length === 0 ? null : n.reduce(vz);
}
function hz(e, n) {
  var i = WC(e);
  return i ? i(n) : !0;
}
function pz(e, n, i, t) {
  t === void 0 && (t = 1 / 0);
  var a = WC(e);
  return a ? (0, Cd.filter)(a, n, i, t) : [];
}
function Nz(e, n, i) {
  return i === void 0 && (i = !0), Array.isArray(n) || (n = [n]), (0, Cd.findOne)(lh("id", e), n, i);
}
function Sz(e, n, i, t) {
  return i === void 0 && (i = !0), t === void 0 && (t = 1 / 0), (0, Cd.filter)(Du.tag_name(e), n, i, t);
}
function gz(e, n, i, t) {
  return i === void 0 && (i = !0), t === void 0 && (t = 1 / 0), (0, Cd.filter)(lh("class", e), n, i, t);
}
function Fz(e, n, i, t) {
  return i === void 0 && (i = !0), t === void 0 && (t = 1 / 0), (0, Cd.filter)(Du.tag_type(e), n, i, t);
}
var d1 = {};
Object.defineProperty(d1, "__esModule", { value: !0 });
d1.DocumentPosition = void 0;
d1.removeSubsets = Iz;
d1.compareDocumentPosition = KC;
d1.uniqueSort = yz;
var iS = sl;
function Iz(e) {
  for (var n = e.length; --n >= 0; ) {
    var i = e[n];
    if (n > 0 && e.lastIndexOf(i, n - 1) >= 0) {
      e.splice(n, 1);
      continue;
    }
    for (var t = i.parent; t; t = t.parent)
      if (e.includes(t)) {
        e.splice(n, 1);
        break;
      }
  }
  return e;
}
var na;
(function(e) {
  e[e.DISCONNECTED = 1] = "DISCONNECTED", e[e.PRECEDING = 2] = "PRECEDING", e[e.FOLLOWING = 4] = "FOLLOWING", e[e.CONTAINS = 8] = "CONTAINS", e[e.CONTAINED_BY = 16] = "CONTAINED_BY";
})(na || (d1.DocumentPosition = na = {}));
function KC(e, n) {
  var i = [], t = [];
  if (e === n)
    return 0;
  for (var a = (0, iS.hasChildren)(e) ? e : e.parent; a; )
    i.unshift(a), a = a.parent;
  for (a = (0, iS.hasChildren)(n) ? n : n.parent; a; )
    t.unshift(a), a = a.parent;
  for (var s = Math.min(i.length, t.length), r = 0; r < s && i[r] === t[r]; )
    r++;
  if (r === 0)
    return na.DISCONNECTED;
  var o = i[r - 1], d = o.children, c = i[r], u = t[r];
  return d.indexOf(c) > d.indexOf(u) ? o === n ? na.FOLLOWING | na.CONTAINED_BY : na.FOLLOWING : o === e ? na.PRECEDING | na.CONTAINS : na.PRECEDING;
}
function yz(e) {
  return e = e.filter(function(n, i, t) {
    return !t.includes(n, i + 1);
  }), e.sort(function(n, i) {
    var t = KC(n, i);
    return t & na.PRECEDING ? -1 : t & na.FOLLOWING ? 1 : 0;
  }), e;
}
var sh = {};
Object.defineProperty(sh, "__esModule", { value: !0 });
sh.getFeed = Cz;
var bz = ps, xd = gl;
function Cz(e) {
  var n = wu(Rz, e);
  return n ? n.name === "feed" ? xz(n) : Dz(n) : null;
}
function xz(e) {
  var n, i = e.children, t = {
    type: "atom",
    items: (0, xd.getElementsByTagName)("entry", i).map(function(r) {
      var o, d = r.children, c = { media: YC(d) };
      pt(c, "id", "id", d), pt(c, "title", "title", d);
      var u = (o = wu("link", d)) === null || o === void 0 ? void 0 : o.attribs.href;
      u && (c.link = u);
      var k = Ml("summary", d) || Ml("content", d);
      k && (c.description = k);
      var m = Ml("updated", d);
      return m && (c.pubDate = new Date(m)), c;
    })
  };
  pt(t, "id", "id", i), pt(t, "title", "title", i);
  var a = (n = wu("link", i)) === null || n === void 0 ? void 0 : n.attribs.href;
  a && (t.link = a), pt(t, "description", "subtitle", i);
  var s = Ml("updated", i);
  return s && (t.updated = new Date(s)), pt(t, "author", "email", i, !0), t;
}
function Dz(e) {
  var n, i, t = (i = (n = wu("channel", e.children)) === null || n === void 0 ? void 0 : n.children) !== null && i !== void 0 ? i : [], a = {
    type: e.name.substr(0, 3),
    id: "",
    items: (0, xd.getElementsByTagName)("item", e.children).map(function(r) {
      var o = r.children, d = { media: YC(o) };
      pt(d, "id", "guid", o), pt(d, "title", "title", o), pt(d, "link", "link", o), pt(d, "description", "description", o);
      var c = Ml("pubDate", o) || Ml("dc:date", o);
      return c && (d.pubDate = new Date(c)), d;
    })
  };
  pt(a, "title", "title", t), pt(a, "link", "link", t), pt(a, "description", "description", t);
  var s = Ml("lastBuildDate", t);
  return s && (a.updated = new Date(s)), pt(a, "author", "managingEditor", t, !0), a;
}
var wz = ["url", "type", "lang"], Pz = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function YC(e) {
  return (0, xd.getElementsByTagName)("media:content", e).map(function(n) {
    for (var i = n.attribs, t = {
      medium: i.medium,
      isDefault: !!i.isDefault
    }, a = 0, s = wz; a < s.length; a++) {
      var r = s[a];
      i[r] && (t[r] = i[r]);
    }
    for (var o = 0, d = Pz; o < d.length; o++) {
      var r = d[o];
      i[r] && (t[r] = parseInt(i[r], 10));
    }
    return i.expression && (t.expression = i.expression), t;
  });
}
function wu(e, n) {
  return (0, xd.getElementsByTagName)(e, n, !0, 1)[0];
}
function Ml(e, n, i) {
  return i === void 0 && (i = !1), (0, bz.textContent)((0, xd.getElementsByTagName)(e, n, i, 1)).trim();
}
function pt(e, n, i, t, a) {
  a === void 0 && (a = !1);
  var s = Ml(i, t, a);
  s && (e[n] = s);
}
function Rz(e) {
  return e === "rss" || e === "feed" || e === "rdf:RDF";
}
(function(e) {
  var n = Be && Be.__createBinding || (Object.create ? function(a, s, r, o) {
    o === void 0 && (o = r);
    var d = Object.getOwnPropertyDescriptor(s, r);
    (!d || ("get" in d ? !s.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
      return s[r];
    } }), Object.defineProperty(a, o, d);
  } : function(a, s, r, o) {
    o === void 0 && (o = r), a[o] = s[r];
  }), i = Be && Be.__exportStar || function(a, s) {
    for (var r in a) r !== "default" && !Object.prototype.hasOwnProperty.call(s, r) && n(s, a, r);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.hasChildren = e.isDocument = e.isComment = e.isText = e.isCDATA = e.isTag = void 0, i(ps, e), i($a, e), i(Ns, e), i(Sl, e), i(gl, e), i(d1, e), i(sh, e);
  var t = sl;
  Object.defineProperty(e, "isTag", { enumerable: !0, get: function() {
    return t.isTag;
  } }), Object.defineProperty(e, "isCDATA", { enumerable: !0, get: function() {
    return t.isCDATA;
  } }), Object.defineProperty(e, "isText", { enumerable: !0, get: function() {
    return t.isText;
  } }), Object.defineProperty(e, "isComment", { enumerable: !0, get: function() {
    return t.isComment;
  } }), Object.defineProperty(e, "isDocument", { enumerable: !0, get: function() {
    return t.isDocument;
  } }), Object.defineProperty(e, "hasChildren", { enumerable: !0, get: function() {
    return t.hasChildren;
  } });
})(Lc);
(function(e) {
  var n = Be && Be.__createBinding || (Object.create ? function(S, F, y, x) {
    x === void 0 && (x = y);
    var R = Object.getOwnPropertyDescriptor(F, y);
    (!R || ("get" in R ? !F.__esModule : R.writable || R.configurable)) && (R = { enumerable: !0, get: function() {
      return F[y];
    } }), Object.defineProperty(S, x, R);
  } : function(S, F, y, x) {
    x === void 0 && (x = y), S[x] = F[y];
  }), i = Be && Be.__setModuleDefault || (Object.create ? function(S, F) {
    Object.defineProperty(S, "default", { enumerable: !0, value: F });
  } : function(S, F) {
    S.default = F;
  }), t = Be && Be.__importStar || function(S) {
    if (S && S.__esModule) return S;
    var F = {};
    if (S != null) for (var y in S) y !== "default" && Object.prototype.hasOwnProperty.call(S, y) && n(F, S, y);
    return i(F, S), F;
  }, a = Be && Be.__importDefault || function(S) {
    return S && S.__esModule ? S : { default: S };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomUtils = e.parseFeed = e.getFeed = e.ElementType = e.Tokenizer = e.createDomStream = e.parseDOM = e.parseDocument = e.DefaultHandler = e.DomHandler = e.Parser = void 0;
  var s = Uo, r = Uo;
  Object.defineProperty(e, "Parser", { enumerable: !0, get: function() {
    return r.Parser;
  } });
  var o = sl, d = sl;
  Object.defineProperty(e, "DomHandler", { enumerable: !0, get: function() {
    return d.DomHandler;
  } }), Object.defineProperty(e, "DefaultHandler", { enumerable: !0, get: function() {
    return d.DomHandler;
  } });
  function c(S, F) {
    var y = new o.DomHandler(void 0, F);
    return new s.Parser(y, F).end(S), y.root;
  }
  e.parseDocument = c;
  function u(S, F) {
    return c(S, F).children;
  }
  e.parseDOM = u;
  function k(S, F, y) {
    var x = new o.DomHandler(S, F, y);
    return new s.Parser(x, F);
  }
  e.createDomStream = k;
  var m = Xv;
  Object.defineProperty(e, "Tokenizer", { enumerable: !0, get: function() {
    return a(m).default;
  } }), e.ElementType = t(Or);
  var f = Lc, p = Lc;
  Object.defineProperty(e, "getFeed", { enumerable: !0, get: function() {
    return p.getFeed;
  } });
  var h = { xmlMode: !0 };
  function N(S, F) {
    return F === void 0 && (F = h), (0, f.getFeed)(u(S, F));
  }
  e.parseFeed = N, e.DomUtils = t(Lc);
})(xC);
var Tz = (e) => {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, rh = {};
Object.defineProperty(rh, "__esModule", { value: !0 });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function tS(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function jz(e) {
  var n, i;
  return tS(e) === !1 ? !1 : (n = e.constructor, n === void 0 ? !0 : (i = n.prototype, !(tS(i) === !1 || i.hasOwnProperty("isPrototypeOf") === !1)));
}
rh.isPlainObject = jz;
var Az = function(n) {
  return Oz(n) && !Ez(n);
};
function Oz(e) {
  return !!e && typeof e == "object";
}
function Ez(e) {
  var n = Object.prototype.toString.call(e);
  return n === "[object RegExp]" || n === "[object Date]" || Qz(e);
}
var Jz = typeof Symbol == "function" && Symbol.for, _z = Jz ? Symbol.for("react.element") : 60103;
function Qz(e) {
  return e.$$typeof === _z;
}
function Mz(e) {
  return Array.isArray(e) ? [] : {};
}
function Ho(e, n) {
  return n.clone !== !1 && n.isMergeableObject(e) ? Z1(Mz(e), e, n) : e;
}
function Lz(e, n, i) {
  return e.concat(n).map(function(t) {
    return Ho(t, i);
  });
}
function $z(e, n) {
  if (!n.customMerge)
    return Z1;
  var i = n.customMerge(e);
  return typeof i == "function" ? i : Z1;
}
function Uz(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(n) {
    return Object.propertyIsEnumerable.call(e, n);
  }) : [];
}
function aS(e) {
  return Object.keys(e).concat(Uz(e));
}
function XC(e, n) {
  try {
    return n in e;
  } catch (i) {
    return !1;
  }
}
function Vz(e, n) {
  return XC(e, n) && !(Object.hasOwnProperty.call(e, n) && Object.propertyIsEnumerable.call(e, n));
}
function Hz(e, n, i) {
  var t = {};
  return i.isMergeableObject(e) && aS(e).forEach(function(a) {
    t[a] = Ho(e[a], i);
  }), aS(n).forEach(function(a) {
    Vz(e, a) || (XC(e, a) && i.isMergeableObject(n[a]) ? t[a] = $z(a, i)(e[a], n[a], i) : t[a] = Ho(n[a], i));
  }), t;
}
function Z1(e, n, i) {
  i = i || {}, i.arrayMerge = i.arrayMerge || Lz, i.isMergeableObject = i.isMergeableObject || Az, i.cloneUnlessOtherwiseSpecified = Ho;
  var t = Array.isArray(n), a = Array.isArray(e), s = t === a;
  return s ? t ? i.arrayMerge(e, n, i) : Hz(e, n, i) : Ho(n, i);
}
Z1.all = function(n, i) {
  if (!Array.isArray(n))
    throw new Error("first argument should be an array");
  return n.reduce(function(t, a) {
    return Z1(t, a, i);
  }, {});
};
var zz = Z1, Bz = zz, ZC = { exports: {} };
(function(e) {
  (function(n, i) {
    e.exports ? e.exports = i() : n.parseSrcset = i();
  })(Be, function() {
    return function(n) {
      function i(x) {
        return x === " " || // space
        x === "	" || // horizontal tab
        x === `
` || // new line
        x === "\f" || // form feed
        x === "\r";
      }
      function t(x) {
        var R, T = x.exec(n.substring(N));
        if (T)
          return R = T[0], N += R.length, R;
      }
      for (var a = n.length, s = /^[ \t\n\r\u000c]+/, r = /^[, \t\n\r\u000c]+/, o = /^[^ \t\n\r\u000c]+/, d = /[,]+$/, c = /^\d+$/, u = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, k, m, f, p, h, N = 0, S = []; ; ) {
        if (t(r), N >= a)
          return S;
        k = t(o), m = [], k.slice(-1) === "," ? (k = k.replace(d, ""), y()) : F();
      }
      function F() {
        for (t(s), f = "", p = "in descriptor"; ; ) {
          if (h = n.charAt(N), p === "in descriptor")
            if (i(h))
              f && (m.push(f), f = "", p = "after descriptor");
            else if (h === ",") {
              N += 1, f && m.push(f), y();
              return;
            } else if (h === "(")
              f = f + h, p = "in parens";
            else if (h === "") {
              f && m.push(f), y();
              return;
            } else
              f = f + h;
          else if (p === "in parens")
            if (h === ")")
              f = f + h, p = "in descriptor";
            else if (h === "") {
              m.push(f), y();
              return;
            } else
              f = f + h;
          else if (p === "after descriptor" && !i(h))
            if (h === "") {
              y();
              return;
            } else
              p = "in descriptor", N -= 1;
          N += 1;
        }
      }
      function y() {
        var x = !1, R, T, j, A, B = {}, W, E, $, V, H;
        for (A = 0; A < m.length; A++)
          W = m[A], E = W[W.length - 1], $ = W.substring(0, W.length - 1), V = parseInt($, 10), H = parseFloat($), c.test($) && E === "w" ? ((R || T) && (x = !0), V === 0 ? x = !0 : R = V) : u.test($) && E === "x" ? ((R || T || j) && (x = !0), H < 0 ? x = !0 : T = H) : c.test($) && E === "h" ? ((j || T) && (x = !0), V === 0 ? x = !0 : j = V) : x = !0;
        x ? console && console.log && console.log("Invalid srcset descriptor found in '" + n + "' at '" + W + "'.") : (B.url = k, R && (B.w = R), T && (B.d = T), j && (B.h = j), S.push(B));
      }
    };
  });
})(ZC);
var qz = ZC.exports, oh = { exports: {} }, dn = String, ex = function() {
  return { isColorSupported: !1, reset: dn, bold: dn, dim: dn, italic: dn, underline: dn, inverse: dn, hidden: dn, strikethrough: dn, black: dn, red: dn, green: dn, yellow: dn, blue: dn, magenta: dn, cyan: dn, white: dn, gray: dn, bgBlack: dn, bgRed: dn, bgGreen: dn, bgYellow: dn, bgBlue: dn, bgMagenta: dn, bgCyan: dn, bgWhite: dn, blackBright: dn, redBright: dn, greenBright: dn, yellowBright: dn, blueBright: dn, magentaBright: dn, cyanBright: dn, whiteBright: dn, bgBlackBright: dn, bgRedBright: dn, bgGreenBright: dn, bgYellowBright: dn, bgBlueBright: dn, bgMagentaBright: dn, bgCyanBright: dn, bgWhiteBright: dn };
};
oh.exports = ex();
oh.exports.createColors = ex;
var Gz = oh.exports;
const Wz = {}, Kz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wz
}, Symbol.toStringTag, { value: "Module" })), ma = /* @__PURE__ */ _8(Kz);
let lS = Gz, sS = ma, Sk = class nx extends Error {
  constructor(n, i, t, a, s, r) {
    super(n), this.name = "CssSyntaxError", this.reason = n, s && (this.file = s), a && (this.source = a), r && (this.plugin = r), typeof i != "undefined" && typeof t != "undefined" && (typeof i == "number" ? (this.line = i, this.column = t) : (this.line = i.line, this.column = i.column, this.endLine = t.line, this.endColumn = t.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, nx);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line != "undefined" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(n) {
    if (!this.source) return "";
    let i = this.source;
    n == null && (n = lS.isColorSupported);
    let t = (u) => u, a = (u) => u, s = (u) => u;
    if (n) {
      let { bold: u, gray: k, red: m } = lS.createColors(!0);
      a = (f) => u(m(f)), t = (f) => k(f), sS && (s = (f) => sS(f));
    }
    let r = i.split(/\r?\n/), o = Math.max(this.line - 3, 0), d = Math.min(this.line + 2, r.length), c = String(d).length;
    return r.slice(o, d).map((u, k) => {
      let m = o + 1 + k, f = " " + (" " + m).slice(-c) + " | ";
      if (m === this.line) {
        if (u.length > 160) {
          let h = 20, N = Math.max(0, this.column - h), S = Math.max(
            this.column + h,
            this.endColumn + h
          ), F = u.slice(N, S), y = t(f.replace(/\d/g, " ")) + u.slice(0, Math.min(this.column - 1, h - 1)).replace(/[^\t]/g, " ");
          return a(">") + t(f) + s(F) + `
 ` + y + a("^");
        }
        let p = t(f.replace(/\d/g, " ")) + u.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return a(">") + t(f) + s(u) + `
 ` + p + a("^");
      }
      return " " + t(f) + s(u);
    }).join(`
`);
  }
  toString() {
    let n = this.showSourceCode();
    return n && (n = `

` + n + `
`), this.name + ": " + this.message + n;
  }
};
var dh = Sk;
Sk.default = Sk;
const rS = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function Yz(e) {
  return e[0].toUpperCase() + e.slice(1);
}
let gk = class {
  constructor(n) {
    this.builder = n;
  }
  atrule(n, i) {
    let t = "@" + n.name, a = n.params ? this.rawValue(n, "params") : "";
    if (typeof n.raws.afterName != "undefined" ? t += n.raws.afterName : a && (t += " "), n.nodes)
      this.block(n, t + a);
    else {
      let s = (n.raws.between || "") + (i ? ";" : "");
      this.builder(t + a + s, n);
    }
  }
  beforeAfter(n, i) {
    let t;
    n.type === "decl" ? t = this.raw(n, null, "beforeDecl") : n.type === "comment" ? t = this.raw(n, null, "beforeComment") : i === "before" ? t = this.raw(n, null, "beforeRule") : t = this.raw(n, null, "beforeClose");
    let a = n.parent, s = 0;
    for (; a && a.type !== "root"; )
      s += 1, a = a.parent;
    if (t.includes(`
`)) {
      let r = this.raw(n, null, "indent");
      if (r.length)
        for (let o = 0; o < s; o++) t += r;
    }
    return t;
  }
  block(n, i) {
    let t = this.raw(n, "between", "beforeOpen");
    this.builder(i + t + "{", n, "start");
    let a;
    n.nodes && n.nodes.length ? (this.body(n), a = this.raw(n, "after")) : a = this.raw(n, "after", "emptyBody"), a && this.builder(a), this.builder("}", n, "end");
  }
  body(n) {
    let i = n.nodes.length - 1;
    for (; i > 0 && n.nodes[i].type === "comment"; )
      i -= 1;
    let t = this.raw(n, "semicolon");
    for (let a = 0; a < n.nodes.length; a++) {
      let s = n.nodes[a], r = this.raw(s, "before");
      r && this.builder(r), this.stringify(s, i !== a || t);
    }
  }
  comment(n) {
    let i = this.raw(n, "left", "commentLeft"), t = this.raw(n, "right", "commentRight");
    this.builder("/*" + i + n.text + t + "*/", n);
  }
  decl(n, i) {
    let t = this.raw(n, "between", "colon"), a = n.prop + t + this.rawValue(n, "value");
    n.important && (a += n.raws.important || " !important"), i && (a += ";"), this.builder(a, n);
  }
  document(n) {
    this.body(n);
  }
  raw(n, i, t) {
    let a;
    if (t || (t = i), i && (a = n.raws[i], typeof a != "undefined"))
      return a;
    let s = n.parent;
    if (t === "before" && (!s || s.type === "root" && s.first === n || s && s.type === "document"))
      return "";
    if (!s) return rS[t];
    let r = n.root();
    if (r.rawCache || (r.rawCache = {}), typeof r.rawCache[t] != "undefined")
      return r.rawCache[t];
    if (t === "before" || t === "after")
      return this.beforeAfter(n, t);
    {
      let o = "raw" + Yz(t);
      this[o] ? a = this[o](r, n) : r.walk((d) => {
        if (a = d.raws[i], typeof a != "undefined") return !1;
      });
    }
    return typeof a == "undefined" && (a = rS[t]), r.rawCache[t] = a, a;
  }
  rawBeforeClose(n) {
    let i;
    return n.walk((t) => {
      if (t.nodes && t.nodes.length > 0 && typeof t.raws.after != "undefined")
        return i = t.raws.after, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeComment(n, i) {
    let t;
    return n.walkComments((a) => {
      if (typeof a.raws.before != "undefined")
        return t = a.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), typeof t == "undefined" ? t = this.raw(i, null, "beforeDecl") : t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeDecl(n, i) {
    let t;
    return n.walkDecls((a) => {
      if (typeof a.raws.before != "undefined")
        return t = a.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), typeof t == "undefined" ? t = this.raw(i, null, "beforeRule") : t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeOpen(n) {
    let i;
    return n.walk((t) => {
      if (t.type !== "decl" && (i = t.raws.between, typeof i != "undefined"))
        return !1;
    }), i;
  }
  rawBeforeRule(n) {
    let i;
    return n.walk((t) => {
      if (t.nodes && (t.parent !== n || n.first !== t) && typeof t.raws.before != "undefined")
        return i = t.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), i && (i = i.replace(/\S/g, "")), i;
  }
  rawColon(n) {
    let i;
    return n.walkDecls((t) => {
      if (typeof t.raws.between != "undefined")
        return i = t.raws.between.replace(/[^\s:]/g, ""), !1;
    }), i;
  }
  rawEmptyBody(n) {
    let i;
    return n.walk((t) => {
      if (t.nodes && t.nodes.length === 0 && (i = t.raws.after, typeof i != "undefined"))
        return !1;
    }), i;
  }
  rawIndent(n) {
    if (n.raws.indent) return n.raws.indent;
    let i;
    return n.walk((t) => {
      let a = t.parent;
      if (a && a !== n && a.parent && a.parent === n && typeof t.raws.before != "undefined") {
        let s = t.raws.before.split(`
`);
        return i = s[s.length - 1], i = i.replace(/\S/g, ""), !1;
      }
    }), i;
  }
  rawSemicolon(n) {
    let i;
    return n.walk((t) => {
      if (t.nodes && t.nodes.length && t.last.type === "decl" && (i = t.raws.semicolon, typeof i != "undefined"))
        return !1;
    }), i;
  }
  rawValue(n, i) {
    let t = n[i], a = n.raws[i];
    return a && a.value === t ? a.raw : t;
  }
  root(n) {
    this.body(n), n.raws.after && this.builder(n.raws.after);
  }
  rule(n) {
    this.block(n, this.rawValue(n, "selector")), n.raws.ownSemicolon && this.builder(n.raws.ownSemicolon, n, "end");
  }
  stringify(n, i) {
    if (!this[n.type])
      throw new Error(
        "Unknown AST node type " + n.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[n.type](n, i);
  }
};
var ix = gk;
gk.default = gk;
let Xz = ix;
function Fk(e, n) {
  new Xz(n).stringify(e);
}
var Gm = Fk;
Fk.default = Fk;
var Dd = {};
Dd.isClean = Symbol("isClean");
Dd.my = Symbol("my");
let Zz = dh, eB = ix, nB = Gm, { isClean: to, my: iB } = Dd;
function Ik(e, n) {
  let i = new e.constructor();
  for (let t in e) {
    if (!Object.prototype.hasOwnProperty.call(e, t) || t === "proxyCache") continue;
    let a = e[t], s = typeof a;
    t === "parent" && s === "object" ? n && (i[t] = n) : t === "source" ? i[t] = a : Array.isArray(a) ? i[t] = a.map((r) => Ik(r, i)) : (s === "object" && a !== null && (a = Ik(a)), i[t] = a);
  }
  return i;
}
function Ya(e, n) {
  if (n && typeof n.offset != "undefined")
    return n.offset;
  let i = 1, t = 1, a = 0;
  for (let s = 0; s < e.length; s++) {
    if (t === n.line && i === n.column) {
      a = s;
      break;
    }
    e[s] === `
` ? (i = 1, t += 1) : i += 1;
  }
  return a;
}
let yk = class {
  get proxyOf() {
    return this;
  }
  constructor(n = {}) {
    this.raws = {}, this[to] = !1, this[iB] = !0;
    for (let i in n)
      if (i === "nodes") {
        this.nodes = [];
        for (let t of n[i])
          typeof t.clone == "function" ? this.append(t.clone()) : this.append(t);
      } else
        this[i] = n[i];
  }
  addToError(n) {
    if (n.postcssNode = this, n.stack && this.source && /\n\s{4}at /.test(n.stack)) {
      let i = this.source;
      n.stack = n.stack.replace(
        /\n\s{4}at /,
        `$&${i.input.from}:${i.start.line}:${i.start.column}$&`
      );
    }
    return n;
  }
  after(n) {
    return this.parent.insertAfter(this, n), this;
  }
  assign(n = {}) {
    for (let i in n)
      this[i] = n[i];
    return this;
  }
  before(n) {
    return this.parent.insertBefore(this, n), this;
  }
  cleanRaws(n) {
    delete this.raws.before, delete this.raws.after, n || delete this.raws.between;
  }
  clone(n = {}) {
    let i = Ik(this);
    for (let t in n)
      i[t] = n[t];
    return i;
  }
  cloneAfter(n = {}) {
    let i = this.clone(n);
    return this.parent.insertAfter(this, i), i;
  }
  cloneBefore(n = {}) {
    let i = this.clone(n);
    return this.parent.insertBefore(this, i), i;
  }
  error(n, i = {}) {
    if (this.source) {
      let { end: t, start: a } = this.rangeBy(i);
      return this.source.input.error(
        n,
        { column: a.column, line: a.line },
        { column: t.column, line: t.line },
        i
      );
    }
    return new Zz(n);
  }
  getProxyProcessor() {
    return {
      get(n, i) {
        return i === "proxyOf" ? n : i === "root" ? () => n.root().toProxy() : n[i];
      },
      set(n, i, t) {
        return n[i] === t || (n[i] = t, (i === "prop" || i === "value" || i === "name" || i === "params" || i === "important" || /* c8 ignore next */
        i === "text") && n.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[to] = !0;
  }
  markDirty() {
    if (this[to]) {
      this[to] = !1;
      let n = this;
      for (; n = n.parent; )
        n[to] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let n = this.parent.index(this);
    return this.parent.nodes[n + 1];
  }
  positionBy(n = {}) {
    let i = this.source.start;
    if (n.index)
      i = this.positionInside(n.index);
    else if (n.word) {
      let t = "document" in this.source.input ? this.source.input.document : this.source.input.css, s = t.slice(
        Ya(t, this.source.start),
        Ya(t, this.source.end)
      ).indexOf(n.word);
      s !== -1 && (i = this.positionInside(s));
    }
    return i;
  }
  positionInside(n) {
    let i = this.source.start.column, t = this.source.start.line, a = "document" in this.source.input ? this.source.input.document : this.source.input.css, s = Ya(a, this.source.start), r = s + n;
    for (let o = s; o < r; o++)
      a[o] === `
` ? (i = 1, t += 1) : i += 1;
    return { column: i, line: t, offset: r };
  }
  prev() {
    if (!this.parent) return;
    let n = this.parent.index(this);
    return this.parent.nodes[n - 1];
  }
  rangeBy(n = {}) {
    let i = "document" in this.source.input ? this.source.input.document : this.source.input.css, t = {
      column: this.source.start.column,
      line: this.source.start.line,
      offset: Ya(i, this.source.start)
    }, a = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line,
      offset: typeof this.source.end.offset == "number" ? (
        // `source.end.offset` is exclusive, so we don't need to add 1
        this.source.end.offset
      ) : (
        // Since line/column in this.source.end is inclusive,
        // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
        // So, we add 1 to convert it to exclusive.
        Ya(i, this.source.end) + 1
      )
    } : {
      column: t.column + 1,
      line: t.line,
      offset: t.offset + 1
    };
    if (n.word) {
      let r = i.slice(
        Ya(i, this.source.start),
        Ya(i, this.source.end)
      ).indexOf(n.word);
      r !== -1 && (t = this.positionInside(r), a = this.positionInside(r + n.word.length));
    } else
      n.start ? t = {
        column: n.start.column,
        line: n.start.line,
        offset: Ya(i, n.start)
      } : n.index && (t = this.positionInside(n.index)), n.end ? a = {
        column: n.end.column,
        line: n.end.line,
        offset: Ya(i, n.end)
      } : typeof n.endIndex == "number" ? a = this.positionInside(n.endIndex) : n.index && (a = this.positionInside(n.index + 1));
    return (a.line < t.line || a.line === t.line && a.column <= t.column) && (a = {
      column: t.column + 1,
      line: t.line,
      offset: t.offset + 1
    }), { end: a, start: t };
  }
  raw(n, i) {
    return new eB().raw(this, n, i);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...n) {
    if (this.parent) {
      let i = this, t = !1;
      for (let a of n)
        a === this ? t = !0 : t ? (this.parent.insertAfter(i, a), i = a) : this.parent.insertBefore(i, a);
      t || this.remove();
    }
    return this;
  }
  root() {
    let n = this;
    for (; n.parent && n.parent.type !== "document"; )
      n = n.parent;
    return n;
  }
  toJSON(n, i) {
    let t = {}, a = i == null;
    i = i || /* @__PURE__ */ new Map();
    let s = 0;
    for (let r in this) {
      if (!Object.prototype.hasOwnProperty.call(this, r) || r === "parent" || r === "proxyCache") continue;
      let o = this[r];
      if (Array.isArray(o))
        t[r] = o.map((d) => typeof d == "object" && d.toJSON ? d.toJSON(null, i) : d);
      else if (typeof o == "object" && o.toJSON)
        t[r] = o.toJSON(null, i);
      else if (r === "source") {
        if (o == null) continue;
        let d = i.get(o.input);
        d == null && (d = s, i.set(o.input, s), s++), t[r] = {
          end: o.end,
          inputId: d,
          start: o.start
        };
      } else
        t[r] = o;
    }
    return a && (t.inputs = [...i.keys()].map((r) => r.toJSON())), t;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(n = nB) {
    n.stringify && (n = n.stringify);
    let i = "";
    return n(this, (t) => {
      i += t;
    }), i;
  }
  warn(n, i, t = {}) {
    let a = { node: this };
    for (let s in t) a[s] = t[s];
    return n.warn(i, a);
  }
};
var Wm = yk;
yk.default = yk;
let tB = Wm, bk = class extends tB {
  constructor(n) {
    super(n), this.type = "comment";
  }
};
var Km = bk;
bk.default = bk;
let aB = Wm, Ck = class extends aB {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(n) {
    n && typeof n.value != "undefined" && typeof n.value != "string" && (n = { ...n, value: String(n.value) }), super(n), this.type = "decl";
  }
};
var Ym = Ck;
Ck.default = Ck;
let tx = Km, ax = Ym, lB = Wm, { isClean: lx, my: sx } = Dd, ch, rx, ox, uh;
function dx(e) {
  return e.map((n) => (n.nodes && (n.nodes = dx(n.nodes)), delete n.source, n));
}
function cx(e) {
  if (e[lx] = !1, e.proxyOf.nodes)
    for (let n of e.proxyOf.nodes)
      cx(n);
}
let rl = class ux extends lB {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...n) {
    for (let i of n) {
      let t = this.normalize(i, this.last);
      for (let a of t) this.proxyOf.nodes.push(a);
    }
    return this.markDirty(), this;
  }
  cleanRaws(n) {
    if (super.cleanRaws(n), this.nodes)
      for (let i of this.nodes) i.cleanRaws(n);
  }
  each(n) {
    if (!this.proxyOf.nodes) return;
    let i = this.getIterator(), t, a;
    for (; this.indexes[i] < this.proxyOf.nodes.length && (t = this.indexes[i], a = n(this.proxyOf.nodes[t], t), a !== !1); )
      this.indexes[i] += 1;
    return delete this.indexes[i], a;
  }
  every(n) {
    return this.nodes.every(n);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let n = this.lastEach;
    return this.indexes[n] = 0, n;
  }
  getProxyProcessor() {
    return {
      get(n, i) {
        return i === "proxyOf" ? n : n[i] ? i === "each" || typeof i == "string" && i.startsWith("walk") ? (...t) => n[i](
          ...t.map((a) => typeof a == "function" ? (s, r) => a(s.toProxy(), r) : a)
        ) : i === "every" || i === "some" ? (t) => n[i](
          (a, ...s) => t(a.toProxy(), ...s)
        ) : i === "root" ? () => n.root().toProxy() : i === "nodes" ? n.nodes.map((t) => t.toProxy()) : i === "first" || i === "last" ? n[i].toProxy() : n[i] : n[i];
      },
      set(n, i, t) {
        return n[i] === t || (n[i] = t, (i === "name" || i === "params" || i === "selector") && n.markDirty()), !0;
      }
    };
  }
  index(n) {
    return typeof n == "number" ? n : (n.proxyOf && (n = n.proxyOf), this.proxyOf.nodes.indexOf(n));
  }
  insertAfter(n, i) {
    let t = this.index(n), a = this.normalize(i, this.proxyOf.nodes[t]).reverse();
    t = this.index(n);
    for (let r of a) this.proxyOf.nodes.splice(t + 1, 0, r);
    let s;
    for (let r in this.indexes)
      s = this.indexes[r], t < s && (this.indexes[r] = s + a.length);
    return this.markDirty(), this;
  }
  insertBefore(n, i) {
    let t = this.index(n), a = t === 0 ? "prepend" : !1, s = this.normalize(
      i,
      this.proxyOf.nodes[t],
      a
    ).reverse();
    t = this.index(n);
    for (let o of s) this.proxyOf.nodes.splice(t, 0, o);
    let r;
    for (let o in this.indexes)
      r = this.indexes[o], t <= r && (this.indexes[o] = r + s.length);
    return this.markDirty(), this;
  }
  normalize(n, i) {
    if (typeof n == "string")
      n = dx(rx(n).nodes);
    else if (typeof n == "undefined")
      n = [];
    else if (Array.isArray(n)) {
      n = n.slice(0);
      for (let a of n)
        a.parent && a.parent.removeChild(a, "ignore");
    } else if (n.type === "root" && this.type !== "document") {
      n = n.nodes.slice(0);
      for (let a of n)
        a.parent && a.parent.removeChild(a, "ignore");
    } else if (n.type)
      n = [n];
    else if (n.prop) {
      if (typeof n.value == "undefined")
        throw new Error("Value field is missed in node creation");
      typeof n.value != "string" && (n.value = String(n.value)), n = [new ax(n)];
    } else if (n.selector || n.selectors)
      n = [new uh(n)];
    else if (n.name)
      n = [new ch(n)];
    else if (n.text)
      n = [new tx(n)];
    else
      throw new Error("Unknown node type in node creation");
    return n.map((a) => (a[sx] || ux.rebuild(a), a = a.proxyOf, a.parent && a.parent.removeChild(a), a[lx] && cx(a), a.raws || (a.raws = {}), typeof a.raws.before == "undefined" && i && typeof i.raws.before != "undefined" && (a.raws.before = i.raws.before.replace(/\S/g, "")), a.parent = this.proxyOf, a));
  }
  prepend(...n) {
    n = n.reverse();
    for (let i of n) {
      let t = this.normalize(i, this.first, "prepend").reverse();
      for (let a of t) this.proxyOf.nodes.unshift(a);
      for (let a in this.indexes)
        this.indexes[a] = this.indexes[a] + t.length;
    }
    return this.markDirty(), this;
  }
  push(n) {
    return n.parent = this, this.proxyOf.nodes.push(n), this;
  }
  removeAll() {
    for (let n of this.proxyOf.nodes) n.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(n) {
    n = this.index(n), this.proxyOf.nodes[n].parent = void 0, this.proxyOf.nodes.splice(n, 1);
    let i;
    for (let t in this.indexes)
      i = this.indexes[t], i >= n && (this.indexes[t] = i - 1);
    return this.markDirty(), this;
  }
  replaceValues(n, i, t) {
    return t || (t = i, i = {}), this.walkDecls((a) => {
      i.props && !i.props.includes(a.prop) || i.fast && !a.value.includes(i.fast) || (a.value = a.value.replace(n, t));
    }), this.markDirty(), this;
  }
  some(n) {
    return this.nodes.some(n);
  }
  walk(n) {
    return this.each((i, t) => {
      let a;
      try {
        a = n(i, t);
      } catch (s) {
        throw i.addToError(s);
      }
      return a !== !1 && i.walk && (a = i.walk(n)), a;
    });
  }
  walkAtRules(n, i) {
    return i ? n instanceof RegExp ? this.walk((t, a) => {
      if (t.type === "atrule" && n.test(t.name))
        return i(t, a);
    }) : this.walk((t, a) => {
      if (t.type === "atrule" && t.name === n)
        return i(t, a);
    }) : (i = n, this.walk((t, a) => {
      if (t.type === "atrule")
        return i(t, a);
    }));
  }
  walkComments(n) {
    return this.walk((i, t) => {
      if (i.type === "comment")
        return n(i, t);
    });
  }
  walkDecls(n, i) {
    return i ? n instanceof RegExp ? this.walk((t, a) => {
      if (t.type === "decl" && n.test(t.prop))
        return i(t, a);
    }) : this.walk((t, a) => {
      if (t.type === "decl" && t.prop === n)
        return i(t, a);
    }) : (i = n, this.walk((t, a) => {
      if (t.type === "decl")
        return i(t, a);
    }));
  }
  walkRules(n, i) {
    return i ? n instanceof RegExp ? this.walk((t, a) => {
      if (t.type === "rule" && n.test(t.selector))
        return i(t, a);
    }) : this.walk((t, a) => {
      if (t.type === "rule" && t.selector === n)
        return i(t, a);
    }) : (i = n, this.walk((t, a) => {
      if (t.type === "rule")
        return i(t, a);
    }));
  }
};
rl.registerParse = (e) => {
  rx = e;
};
rl.registerRule = (e) => {
  uh = e;
};
rl.registerAtRule = (e) => {
  ch = e;
};
rl.registerRoot = (e) => {
  ox = e;
};
var c1 = rl;
rl.default = rl;
rl.rebuild = (e) => {
  e.type === "atrule" ? Object.setPrototypeOf(e, ch.prototype) : e.type === "rule" ? Object.setPrototypeOf(e, uh.prototype) : e.type === "decl" ? Object.setPrototypeOf(e, ax.prototype) : e.type === "comment" ? Object.setPrototypeOf(e, tx.prototype) : e.type === "root" && Object.setPrototypeOf(e, ox.prototype), e[sx] = !0, e.nodes && e.nodes.forEach((n) => {
    rl.rebuild(n);
  });
};
let mx = c1, Pu = class extends mx {
  constructor(n) {
    super(n), this.type = "atrule";
  }
  append(...n) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...n);
  }
  prepend(...n) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...n);
  }
};
var mh = Pu;
Pu.default = Pu;
mx.registerAtRule(Pu);
let sB = c1, kx, fx, zo = class extends sB {
  constructor(n) {
    super({ type: "document", ...n }), this.nodes || (this.nodes = []);
  }
  toResult(n = {}) {
    return new kx(new fx(), this, n).stringify();
  }
};
zo.registerLazyResult = (e) => {
  kx = e;
};
zo.registerProcessor = (e) => {
  fx = e;
};
var kh = zo;
zo.default = zo;
let rB = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", oB = (e = 21) => {
  let n = "", i = e | 0;
  for (; i--; )
    n += rB[Math.random() * 64 | 0];
  return n;
};
var dB = { nanoid: oB };
let { existsSync: cB, readFileSync: uB } = ma, { dirname: K0, join: mB } = ma, { SourceMapConsumer: oS, SourceMapGenerator: dS } = ma;
function kB(e) {
  return Buffer ? Buffer.from(e, "base64").toString() : window.atob(e);
}
let xk = class {
  constructor(n, i) {
    if (i.map === !1) return;
    this.loadAnnotation(n), this.inline = this.startWith(this.annotation, "data:");
    let t = i.map ? i.map.prev : void 0, a = this.loadMap(i.from, t);
    !this.mapFile && i.from && (this.mapFile = i.from), this.mapFile && (this.root = K0(this.mapFile)), a && (this.text = a);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new oS(this.text)), this.consumerCache;
  }
  decodeInline(n) {
    let i = /^data:application\/json;charset=utf-?8;base64,/, t = /^data:application\/json;base64,/, a = /^data:application\/json;charset=utf-?8,/, s = /^data:application\/json,/, r = n.match(a) || n.match(s);
    if (r)
      return decodeURIComponent(n.substr(r[0].length));
    let o = n.match(i) || n.match(t);
    if (o)
      return kB(n.substr(o[0].length));
    let d = n.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + d);
  }
  getAnnotationURL(n) {
    return n.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(n) {
    return typeof n != "object" ? !1 : typeof n.mappings == "string" || typeof n._mappings == "string" || Array.isArray(n.sections);
  }
  loadAnnotation(n) {
    let i = n.match(/\/\*\s*# sourceMappingURL=/g);
    if (!i) return;
    let t = n.lastIndexOf(i.pop()), a = n.indexOf("*/", t);
    t > -1 && a > -1 && (this.annotation = this.getAnnotationURL(n.substring(t, a)));
  }
  loadFile(n) {
    if (this.root = K0(n), cB(n))
      return this.mapFile = n, uB(n, "utf-8").toString().trim();
  }
  loadMap(n, i) {
    if (i === !1) return !1;
    if (i) {
      if (typeof i == "string")
        return i;
      if (typeof i == "function") {
        let t = i(n);
        if (t) {
          let a = this.loadFile(t);
          if (!a)
            throw new Error(
              "Unable to load previous source map: " + t.toString()
            );
          return a;
        }
      } else {
        if (i instanceof oS)
          return dS.fromSourceMap(i).toString();
        if (i instanceof dS)
          return i.toString();
        if (this.isMap(i))
          return JSON.stringify(i);
        throw new Error(
          "Unsupported previous source map format: " + i.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let t = this.annotation;
        return n && (t = mB(K0(n), t)), this.loadFile(t);
      }
    }
  }
  startWith(n, i) {
    return n ? n.substr(0, i.length) === i : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var vx = xk;
xk.default = xk;
let { nanoid: fB } = dB, { isAbsolute: Dk, resolve: wk } = ma, { SourceMapConsumer: vB, SourceMapGenerator: hB } = ma, { fileURLToPath: cS, pathToFileURL: fc } = ma, uS = dh, pB = vx, Y0 = ma, X0 = Symbol("lineToIndexCache"), NB = !!(vB && hB), mS = !!(wk && Dk);
function kS(e) {
  if (e[X0]) return e[X0];
  let n = e.css.split(`
`), i = new Array(n.length), t = 0;
  for (let a = 0, s = n.length; a < s; a++)
    i[a] = t, t += n[a].length + 1;
  return e[X0] = i, i;
}
let Ru = class {
  get from() {
    return this.file || this.id;
  }
  constructor(n, i = {}) {
    if (n === null || typeof n == "undefined" || typeof n == "object" && !n.toString)
      throw new Error(`PostCSS received ${n} instead of CSS string`);
    if (this.css = n.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, i.document && (this.document = i.document.toString()), i.from && (!mS || /^\w+:\/\//.test(i.from) || Dk(i.from) ? this.file = i.from : this.file = wk(i.from)), mS && NB) {
      let t = new pB(this.css, i);
      if (t.text) {
        this.map = t;
        let a = t.consumer().file;
        !this.file && a && (this.file = this.mapResolve(a));
      }
    }
    this.file || (this.id = "<input css " + fB(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(n, i, t, a = {}) {
    let s, r, o, d, c;
    if (i && typeof i == "object") {
      let k = i, m = t;
      if (typeof k.offset == "number") {
        d = k.offset;
        let f = this.fromOffset(d);
        i = f.line, t = f.col;
      } else
        i = k.line, t = k.column, d = this.fromLineAndColumn(i, t);
      if (typeof m.offset == "number") {
        o = m.offset;
        let f = this.fromOffset(o);
        r = f.line, s = f.col;
      } else
        r = m.line, s = m.column, o = this.fromLineAndColumn(m.line, m.column);
    } else if (t)
      d = this.fromLineAndColumn(i, t);
    else {
      d = i;
      let k = this.fromOffset(d);
      i = k.line, t = k.col;
    }
    let u = this.origin(i, t, r, s);
    return u ? c = new uS(
      n,
      u.endLine === void 0 ? u.line : { column: u.column, line: u.line },
      u.endLine === void 0 ? u.column : { column: u.endColumn, line: u.endLine },
      u.source,
      u.file,
      a.plugin
    ) : c = new uS(
      n,
      r === void 0 ? i : { column: t, line: i },
      r === void 0 ? t : { column: s, line: r },
      this.css,
      this.file,
      a.plugin
    ), c.input = { column: t, endColumn: s, endLine: r, endOffset: o, line: i, offset: d, source: this.css }, this.file && (fc && (c.input.url = fc(this.file).toString()), c.input.file = this.file), c;
  }
  fromLineAndColumn(n, i) {
    return kS(this)[n - 1] + i - 1;
  }
  fromOffset(n) {
    let i = kS(this), t = i[i.length - 1], a = 0;
    if (n >= t)
      a = i.length - 1;
    else {
      let s = i.length - 2, r;
      for (; a < s; )
        if (r = a + (s - a >> 1), n < i[r])
          s = r - 1;
        else if (n >= i[r + 1])
          a = r + 1;
        else {
          a = r;
          break;
        }
    }
    return {
      col: n - i[a] + 1,
      line: a + 1
    };
  }
  mapResolve(n) {
    return /^\w+:\/\//.test(n) ? n : wk(this.map.consumer().sourceRoot || this.map.root || ".", n);
  }
  origin(n, i, t, a) {
    if (!this.map) return !1;
    let s = this.map.consumer(), r = s.originalPositionFor({ column: i, line: n });
    if (!r.source) return !1;
    let o;
    typeof t == "number" && (o = s.originalPositionFor({ column: a, line: t }));
    let d;
    Dk(r.source) ? d = fc(r.source) : d = new URL(
      r.source,
      this.map.consumer().sourceRoot || fc(this.map.mapFile)
    );
    let c = {
      column: r.column,
      endColumn: o && o.column,
      endLine: o && o.line,
      line: r.line,
      url: d.toString()
    };
    if (d.protocol === "file:")
      if (cS)
        c.file = cS(d);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let u = s.sourceContentFor(r.source);
    return u && (c.source = u), c;
  }
  toJSON() {
    let n = {};
    for (let i of ["hasBOM", "css", "file", "id"])
      this[i] != null && (n[i] = this[i]);
    return this.map && (n.map = { ...this.map }, n.map.consumerCache && (n.map.consumerCache = void 0)), n;
  }
};
var Xm = Ru;
Ru.default = Ru;
Y0 && Y0.registerInput && Y0.registerInput(Ru);
let hx = c1, px, Nx, er = class extends hx {
  constructor(n) {
    super(n), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(n, i, t) {
    let a = super.normalize(n);
    if (i) {
      if (t === "prepend")
        this.nodes.length > 1 ? i.raws.before = this.nodes[1].raws.before : delete i.raws.before;
      else if (this.first !== i)
        for (let s of a)
          s.raws.before = i.raws.before;
    }
    return a;
  }
  removeChild(n, i) {
    let t = this.index(n);
    return !i && t === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[t].raws.before), super.removeChild(n);
  }
  toResult(n = {}) {
    return new px(new Nx(), this, n).stringify();
  }
};
er.registerLazyResult = (e) => {
  px = e;
};
er.registerProcessor = (e) => {
  Nx = e;
};
var wd = er;
er.default = er;
hx.registerRoot(er);
let Bo = {
  comma(e) {
    return Bo.split(e, [","], !0);
  },
  space(e) {
    let n = [" ", `
`, "	"];
    return Bo.split(e, n);
  },
  split(e, n, i) {
    let t = [], a = "", s = !1, r = 0, o = !1, d = "", c = !1;
    for (let u of e)
      c ? c = !1 : u === "\\" ? c = !0 : o ? u === d && (o = !1) : u === '"' || u === "'" ? (o = !0, d = u) : u === "(" ? r += 1 : u === ")" ? r > 0 && (r -= 1) : r === 0 && n.includes(u) && (s = !0), s ? (a !== "" && t.push(a.trim()), a = "", s = !1) : a += u;
    return (i || a !== "") && t.push(a.trim()), t;
  }
};
var Sx = Bo;
Bo.default = Bo;
let gx = c1, SB = Sx, Tu = class extends gx {
  get selectors() {
    return SB.comma(this.selector);
  }
  set selectors(n) {
    let i = this.selector ? this.selector.match(/,\s*/) : null, t = i ? i[0] : "," + this.raw("between", "beforeOpen");
    this.selector = n.join(t);
  }
  constructor(n) {
    super(n), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var fh = Tu;
Tu.default = Tu;
gx.registerRule(Tu);
let gB = mh, FB = Km, IB = Ym, yB = Xm, bB = vx, CB = wd, xB = fh;
function qo(e, n) {
  if (Array.isArray(e)) return e.map((a) => qo(a));
  let { inputs: i, ...t } = e;
  if (i) {
    n = [];
    for (let a of i) {
      let s = { ...a, __proto__: yB.prototype };
      s.map && (s.map = {
        ...s.map,
        __proto__: bB.prototype
      }), n.push(s);
    }
  }
  if (t.nodes && (t.nodes = e.nodes.map((a) => qo(a, n))), t.source) {
    let { inputId: a, ...s } = t.source;
    t.source = s, a != null && (t.source.input = n[a]);
  }
  if (t.type === "root")
    return new CB(t);
  if (t.type === "decl")
    return new IB(t);
  if (t.type === "rule")
    return new xB(t);
  if (t.type === "comment")
    return new FB(t);
  if (t.type === "atrule")
    return new gB(t);
  throw new Error("Unknown node type: " + e.type);
}
var DB = qo;
qo.default = qo;
let { dirname: Uc, relative: Fx, resolve: Ix, sep: yx } = ma, { SourceMapConsumer: bx, SourceMapGenerator: Vc } = ma, { pathToFileURL: fS } = ma, wB = Xm, PB = !!(bx && Vc), RB = !!(Uc && Ix && Fx && yx), TB = class {
  constructor(n, i, t, a) {
    this.stringify = n, this.mapOpts = t.map || {}, this.root = i, this.opts = t, this.css = a, this.originalCSS = a, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let n;
    this.isInline() ? n = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? n = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? n = this.mapOpts.annotation(this.opts.to, this.root) : n = this.outputFile() + ".map";
    let i = `
`;
    this.css.includes(`\r
`) && (i = `\r
`), this.css += i + "/*# sourceMappingURL=" + n + " */";
  }
  applyPrevMaps() {
    for (let n of this.previous()) {
      let i = this.toUrl(this.path(n.file)), t = n.root || Uc(n.file), a;
      this.mapOpts.sourcesContent === !1 ? (a = new bx(n.text), a.sourcesContent && (a.sourcesContent = null)) : a = n.consumer(), this.map.applySourceMap(a, i, this.toUrl(this.path(t)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1) {
      if (this.root) {
        let n;
        for (let i = this.root.nodes.length - 1; i >= 0; i--)
          n = this.root.nodes[i], n.type === "comment" && n.text.startsWith("# sourceMappingURL=") && this.root.removeChild(i);
      } else if (this.css) {
        let n;
        for (; (n = this.css.lastIndexOf("/*#")) !== -1; ) {
          let i = this.css.indexOf("*/", n + 3);
          if (i === -1) break;
          for (; n > 0 && this.css[n - 1] === `
`; )
            n--;
          this.css = this.css.slice(0, n) + this.css.slice(i + 2);
        }
      }
    }
  }
  generate() {
    if (this.clearAnnotation(), RB && PB && this.isMap())
      return this.generateMap();
    {
      let n = "";
      return this.stringify(this.root, (i) => {
        n += i;
      }), [n];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let n = this.previous()[0].consumer();
      n.file = this.outputFile(), this.map = Vc.fromSourceMap(n, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new Vc({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new Vc({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let n = 1, i = 1, t = "<no source>", a = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, s, r;
    this.stringify(this.root, (o, d, c) => {
      if (this.css += o, d && c !== "end" && (a.generated.line = n, a.generated.column = i - 1, d.source && d.source.start ? (a.source = this.sourcePath(d), a.original.line = d.source.start.line, a.original.column = d.source.start.column - 1, this.map.addMapping(a)) : (a.source = t, a.original.line = 1, a.original.column = 0, this.map.addMapping(a))), r = o.match(/\n/g), r ? (n += r.length, s = o.lastIndexOf(`
`), i = o.length - s) : i += o.length, d && c !== "start") {
        let u = d.parent || { raws: {} };
        (!(d.type === "decl" || d.type === "atrule" && !d.nodes) || d !== u.last || u.raws.semicolon) && (d.source && d.source.end ? (a.source = this.sourcePath(d), a.original.line = d.source.end.line, a.original.column = d.source.end.column - 1, a.generated.line = n, a.generated.column = i - 2, this.map.addMapping(a)) : (a.source = t, a.original.line = 1, a.original.column = 0, a.generated.line = n, a.generated.column = i - 1, this.map.addMapping(a)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation != "undefined" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((n) => n.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline != "undefined")
      return this.mapOpts.inline;
    let n = this.mapOpts.annotation;
    return typeof n != "undefined" && n !== !0 ? !1 : this.previous().length ? this.previous().some((i) => i.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map != "undefined" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent != "undefined" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((n) => n.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(n) {
    if (this.mapOpts.absolute || n.charCodeAt(0) === 60 || /^\w+:\/\//.test(n)) return n;
    let i = this.memoizedPaths.get(n);
    if (i) return i;
    let t = this.opts.to ? Uc(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (t = Uc(Ix(t, this.mapOpts.annotation)));
    let a = Fx(t, n);
    return this.memoizedPaths.set(n, a), a;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((n) => {
          if (n.source && n.source.input.map) {
            let i = n.source.input.map;
            this.previousMaps.includes(i) || this.previousMaps.push(i);
          }
        });
      else {
        let n = new wB(this.originalCSS, this.opts);
        n.map && this.previousMaps.push(n.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let n = {};
    if (this.root)
      this.root.walk((i) => {
        if (i.source) {
          let t = i.source.input.from;
          if (t && !n[t]) {
            n[t] = !0;
            let a = this.usesFileUrls ? this.toFileUrl(t) : this.toUrl(this.path(t));
            this.map.setSourceContent(a, i.source.input.css);
          }
        }
      });
    else if (this.css) {
      let i = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(i, this.css);
    }
  }
  sourcePath(n) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(n.source.input.from) : this.toUrl(this.path(n.source.input.from));
  }
  toBase64(n) {
    return Buffer ? Buffer.from(n).toString("base64") : window.btoa(unescape(encodeURIComponent(n)));
  }
  toFileUrl(n) {
    let i = this.memoizedFileURLs.get(n);
    if (i) return i;
    if (fS) {
      let t = fS(n).toString();
      return this.memoizedFileURLs.set(n, t), t;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(n) {
    let i = this.memoizedURLs.get(n);
    if (i) return i;
    yx === "\\" && (n = n.replace(/\\/g, "/"));
    let t = encodeURI(n).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(n, t), t;
  }
};
var Cx = TB;
const Z0 = 39, vS = 34, vc = 92, hS = 47, hc = 10, ao = 32, pc = 12, Nc = 9, Sc = 13, jB = 91, AB = 93, OB = 40, EB = 41, JB = 123, _B = 125, QB = 59, MB = 42, LB = 58, $B = 64, gc = /[\t\n\f\r "#'()/;[\\\]{}]/g, Fc = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, UB = /.[\r\n"'(/\\]/, pS = /[\da-f]/i;
var VB = function(n, i = {}) {
  let t = n.css.valueOf(), a = i.ignoreErrors, s, r, o, d, c, u, k, m, f, p, h = t.length, N = 0, S = [], F = [];
  function y() {
    return N;
  }
  function x(A) {
    throw n.error("Unclosed " + A, N);
  }
  function R() {
    return F.length === 0 && N >= h;
  }
  function T(A) {
    if (F.length) return F.pop();
    if (N >= h) return;
    let B = A ? A.ignoreUnclosed : !1;
    switch (s = t.charCodeAt(N), s) {
      case hc:
      case ao:
      case Nc:
      case Sc:
      case pc: {
        d = N;
        do
          d += 1, s = t.charCodeAt(d);
        while (s === ao || s === hc || s === Nc || s === Sc || s === pc);
        u = ["space", t.slice(N, d)], N = d - 1;
        break;
      }
      case jB:
      case AB:
      case JB:
      case _B:
      case LB:
      case QB:
      case EB: {
        let W = String.fromCharCode(s);
        u = [W, W, N];
        break;
      }
      case OB: {
        if (p = S.length ? S.pop()[1] : "", f = t.charCodeAt(N + 1), p === "url" && f !== Z0 && f !== vS && f !== ao && f !== hc && f !== Nc && f !== pc && f !== Sc) {
          d = N;
          do {
            if (k = !1, d = t.indexOf(")", d + 1), d === -1)
              if (a || B) {
                d = N;
                break;
              } else
                x("bracket");
            for (m = d; t.charCodeAt(m - 1) === vc; )
              m -= 1, k = !k;
          } while (k);
          u = ["brackets", t.slice(N, d + 1), N, d], N = d;
        } else
          d = t.indexOf(")", N + 1), r = t.slice(N, d + 1), d === -1 || UB.test(r) ? u = ["(", "(", N] : (u = ["brackets", r, N, d], N = d);
        break;
      }
      case Z0:
      case vS: {
        c = s === Z0 ? "'" : '"', d = N;
        do {
          if (k = !1, d = t.indexOf(c, d + 1), d === -1)
            if (a || B) {
              d = N + 1;
              break;
            } else
              x("string");
          for (m = d; t.charCodeAt(m - 1) === vc; )
            m -= 1, k = !k;
        } while (k);
        u = ["string", t.slice(N, d + 1), N, d], N = d;
        break;
      }
      case $B: {
        gc.lastIndex = N + 1, gc.test(t), gc.lastIndex === 0 ? d = t.length - 1 : d = gc.lastIndex - 2, u = ["at-word", t.slice(N, d + 1), N, d], N = d;
        break;
      }
      case vc: {
        for (d = N, o = !0; t.charCodeAt(d + 1) === vc; )
          d += 1, o = !o;
        if (s = t.charCodeAt(d + 1), o && s !== hS && s !== ao && s !== hc && s !== Nc && s !== Sc && s !== pc && (d += 1, pS.test(t.charAt(d)))) {
          for (; pS.test(t.charAt(d + 1)); )
            d += 1;
          t.charCodeAt(d + 1) === ao && (d += 1);
        }
        u = ["word", t.slice(N, d + 1), N, d], N = d;
        break;
      }
      default: {
        s === hS && t.charCodeAt(N + 1) === MB ? (d = t.indexOf("*/", N + 2) + 1, d === 0 && (a || B ? d = t.length : x("comment")), u = ["comment", t.slice(N, d + 1), N, d], N = d) : (Fc.lastIndex = N + 1, Fc.test(t), Fc.lastIndex === 0 ? d = t.length - 1 : d = Fc.lastIndex - 2, u = ["word", t.slice(N, d + 1), N, d], S.push(u), N = d);
        break;
      }
    }
    return N++, u;
  }
  function j(A) {
    F.push(A);
  }
  return {
    back: j,
    endOfFile: R,
    nextToken: T,
    position: y
  };
};
let HB = mh, zB = Km, BB = Ym, qB = wd, NS = fh, GB = VB;
const SS = {
  empty: !0,
  space: !0
};
function WB(e) {
  for (let n = e.length - 1; n >= 0; n--) {
    let i = e[n], t = i[3] || i[2];
    if (t) return t;
  }
}
let KB = class {
  constructor(n) {
    this.input = n, this.root = new qB(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: n, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(n) {
    let i = new HB();
    i.name = n[1].slice(1), i.name === "" && this.unnamedAtrule(i, n), this.init(i, n[2]);
    let t, a, s, r = !1, o = !1, d = [], c = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (n = this.tokenizer.nextToken(), t = n[0], t === "(" || t === "[" ? c.push(t === "(" ? ")" : "]") : t === "{" && c.length > 0 ? c.push("}") : t === c[c.length - 1] && c.pop(), c.length === 0)
        if (t === ";") {
          i.source.end = this.getPosition(n[2]), i.source.end.offset++, this.semicolon = !0;
          break;
        } else if (t === "{") {
          o = !0;
          break;
        } else if (t === "}") {
          if (d.length > 0) {
            for (s = d.length - 1, a = d[s]; a && a[0] === "space"; )
              a = d[--s];
            a && (i.source.end = this.getPosition(a[3] || a[2]), i.source.end.offset++);
          }
          this.end(n);
          break;
        } else
          d.push(n);
      else
        d.push(n);
      if (this.tokenizer.endOfFile()) {
        r = !0;
        break;
      }
    }
    i.raws.between = this.spacesAndCommentsFromEnd(d), d.length ? (i.raws.afterName = this.spacesAndCommentsFromStart(d), this.raw(i, "params", d), r && (n = d[d.length - 1], i.source.end = this.getPosition(n[3] || n[2]), i.source.end.offset++, this.spaces = i.raws.between, i.raws.between = "")) : (i.raws.afterName = "", i.params = ""), o && (i.nodes = [], this.current = i);
  }
  checkMissedSemicolon(n) {
    let i = this.colon(n);
    if (i === !1) return;
    let t = 0, a;
    for (let s = i - 1; s >= 0 && (a = n[s], !(a[0] !== "space" && (t += 1, t === 2))); s--)
      ;
    throw this.input.error(
      "Missed semicolon",
      a[0] === "word" ? a[3] + 1 : a[2]
    );
  }
  colon(n) {
    let i = 0, t, a, s;
    for (let [r, o] of n.entries()) {
      if (a = o, s = a[0], s === "(" && (i += 1), s === ")" && (i -= 1), i === 0 && s === ":")
        if (!t)
          this.doubleColon(a);
        else {
          if (t[0] === "word" && t[1] === "progid")
            continue;
          return r;
        }
      t = a;
    }
    return !1;
  }
  comment(n) {
    let i = new zB();
    this.init(i, n[2]), i.source.end = this.getPosition(n[3] || n[2]), i.source.end.offset++;
    let t = n[1].slice(2, -2);
    if (!t.trim())
      i.text = "", i.raws.left = t, i.raws.right = "";
    else {
      let a = t.match(/^(\s*)([^]*\S)(\s*)$/);
      i.text = a[2], i.raws.left = a[1], i.raws.right = a[3];
    }
  }
  createTokenizer() {
    this.tokenizer = GB(this.input);
  }
  decl(n, i) {
    let t = new BB();
    this.init(t, n[0][2]);
    let a = n[n.length - 1];
    for (a[0] === ";" && (this.semicolon = !0, n.pop()), t.source.end = this.getPosition(
      a[3] || a[2] || WB(n)
    ), t.source.end.offset++; n[0][0] !== "word"; )
      n.length === 1 && this.unknownWord(n), t.raws.before += n.shift()[1];
    for (t.source.start = this.getPosition(n[0][2]), t.prop = ""; n.length; ) {
      let c = n[0][0];
      if (c === ":" || c === "space" || c === "comment")
        break;
      t.prop += n.shift()[1];
    }
    t.raws.between = "";
    let s;
    for (; n.length; )
      if (s = n.shift(), s[0] === ":") {
        t.raws.between += s[1];
        break;
      } else
        s[0] === "word" && /\w/.test(s[1]) && this.unknownWord([s]), t.raws.between += s[1];
    (t.prop[0] === "_" || t.prop[0] === "*") && (t.raws.before += t.prop[0], t.prop = t.prop.slice(1));
    let r = [], o;
    for (; n.length && (o = n[0][0], !(o !== "space" && o !== "comment")); )
      r.push(n.shift());
    this.precheckMissedSemicolon(n);
    for (let c = n.length - 1; c >= 0; c--) {
      if (s = n[c], s[1].toLowerCase() === "!important") {
        t.important = !0;
        let u = this.stringFrom(n, c);
        u = this.spacesFromEnd(n) + u, u !== " !important" && (t.raws.important = u);
        break;
      } else if (s[1].toLowerCase() === "important") {
        let u = n.slice(0), k = "";
        for (let m = c; m > 0; m--) {
          let f = u[m][0];
          if (k.trim().startsWith("!") && f !== "space")
            break;
          k = u.pop()[1] + k;
        }
        k.trim().startsWith("!") && (t.important = !0, t.raws.important = k, n = u);
      }
      if (s[0] !== "space" && s[0] !== "comment")
        break;
    }
    n.some((c) => c[0] !== "space" && c[0] !== "comment") && (t.raws.between += r.map((c) => c[1]).join(""), r = []), this.raw(t, "value", r.concat(n), i), t.value.includes(":") && !i && this.checkMissedSemicolon(n);
  }
  doubleColon(n) {
    throw this.input.error(
      "Double colon",
      { offset: n[2] },
      { offset: n[2] + n[1].length }
    );
  }
  emptyRule(n) {
    let i = new NS();
    this.init(i, n[2]), i.selector = "", i.raws.between = "", this.current = i;
  }
  end(n) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(n[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(n);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(n) {
    if (this.spaces += n[1], this.current.nodes) {
      let i = this.current.nodes[this.current.nodes.length - 1];
      i && i.type === "rule" && !i.raws.ownSemicolon && (i.raws.ownSemicolon = this.spaces, this.spaces = "", i.source.end = this.getPosition(n[2]), i.source.end.offset += i.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(n) {
    let i = this.input.fromOffset(n);
    return {
      column: i.col,
      line: i.line,
      offset: n
    };
  }
  init(n, i) {
    this.current.push(n), n.source = {
      input: this.input,
      start: this.getPosition(i)
    }, n.raws.before = this.spaces, this.spaces = "", n.type !== "comment" && (this.semicolon = !1);
  }
  other(n) {
    let i = !1, t = null, a = !1, s = null, r = [], o = n[1].startsWith("--"), d = [], c = n;
    for (; c; ) {
      if (t = c[0], d.push(c), t === "(" || t === "[")
        s || (s = c), r.push(t === "(" ? ")" : "]");
      else if (o && a && t === "{")
        s || (s = c), r.push("}");
      else if (r.length === 0)
        if (t === ";")
          if (a) {
            this.decl(d, o);
            return;
          } else
            break;
        else if (t === "{") {
          this.rule(d);
          return;
        } else if (t === "}") {
          this.tokenizer.back(d.pop()), i = !0;
          break;
        } else t === ":" && (a = !0);
      else t === r[r.length - 1] && (r.pop(), r.length === 0 && (s = null));
      c = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (i = !0), r.length > 0 && this.unclosedBracket(s), i && a) {
      if (!o)
        for (; d.length && (c = d[d.length - 1][0], !(c !== "space" && c !== "comment")); )
          this.tokenizer.back(d.pop());
      this.decl(d, o);
    } else
      this.unknownWord(d);
  }
  parse() {
    let n;
    for (; !this.tokenizer.endOfFile(); )
      switch (n = this.tokenizer.nextToken(), n[0]) {
        case "space":
          this.spaces += n[1];
          break;
        case ";":
          this.freeSemicolon(n);
          break;
        case "}":
          this.end(n);
          break;
        case "comment":
          this.comment(n);
          break;
        case "at-word":
          this.atrule(n);
          break;
        case "{":
          this.emptyRule(n);
          break;
        default:
          this.other(n);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(n, i, t, a) {
    let s, r, o = t.length, d = "", c = !0, u, k;
    for (let m = 0; m < o; m += 1)
      s = t[m], r = s[0], r === "space" && m === o - 1 && !a ? c = !1 : r === "comment" ? (k = t[m - 1] ? t[m - 1][0] : "empty", u = t[m + 1] ? t[m + 1][0] : "empty", !SS[k] && !SS[u] ? d.slice(-1) === "," ? c = !1 : d += s[1] : c = !1) : d += s[1];
    if (!c) {
      let m = t.reduce((f, p) => f + p[1], "");
      n.raws[i] = { raw: m, value: d };
    }
    n[i] = d;
  }
  rule(n) {
    n.pop();
    let i = new NS();
    this.init(i, n[0][2]), i.raws.between = this.spacesAndCommentsFromEnd(n), this.raw(i, "selector", n), this.current = i;
  }
  spacesAndCommentsFromEnd(n) {
    let i, t = "";
    for (; n.length && (i = n[n.length - 1][0], !(i !== "space" && i !== "comment")); )
      t = n.pop()[1] + t;
    return t;
  }
  // Errors
  spacesAndCommentsFromStart(n) {
    let i, t = "";
    for (; n.length && (i = n[0][0], !(i !== "space" && i !== "comment")); )
      t += n.shift()[1];
    return t;
  }
  spacesFromEnd(n) {
    let i, t = "";
    for (; n.length && (i = n[n.length - 1][0], i === "space"); )
      t = n.pop()[1] + t;
    return t;
  }
  stringFrom(n, i) {
    let t = "";
    for (let a = i; a < n.length; a++)
      t += n[a][1];
    return n.splice(i, n.length - i), t;
  }
  unclosedBlock() {
    let n = this.current.source.start;
    throw this.input.error("Unclosed block", n.line, n.column);
  }
  unclosedBracket(n) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: n[2] },
      { offset: n[2] + 1 }
    );
  }
  unexpectedClose(n) {
    throw this.input.error(
      "Unexpected }",
      { offset: n[2] },
      { offset: n[2] + 1 }
    );
  }
  unknownWord(n) {
    throw this.input.error(
      "Unknown word " + n[0][1],
      { offset: n[0][2] },
      { offset: n[0][2] + n[0][1].length }
    );
  }
  unnamedAtrule(n, i) {
    throw this.input.error(
      "At-rule without name",
      { offset: i[2] },
      { offset: i[2] + i[1].length }
    );
  }
};
var YB = KB;
let XB = c1, ZB = Xm, eq = YB;
function ju(e, n) {
  let i = new ZB(e, n), t = new eq(i);
  try {
    t.parse();
  } catch (a) {
    throw process.env.NODE_ENV !== "production" && a.name === "CssSyntaxError" && n && n.from && (/\.scss$/i.test(n.from) ? a.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(n.from) ? a.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(n.from) && (a.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), a;
  }
  return t.root;
}
var vh = ju;
ju.default = ju;
XB.registerParse(ju);
let Pk = class {
  constructor(n, i = {}) {
    if (this.type = "warning", this.text = n, i.node && i.node.source) {
      let t = i.node.rangeBy(i);
      this.line = t.start.line, this.column = t.start.column, this.endLine = t.end.line, this.endColumn = t.end.column;
    }
    for (let t in i) this[t] = i[t];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var xx = Pk;
Pk.default = Pk;
let nq = xx, Rk = class {
  get content() {
    return this.css;
  }
  constructor(n, i, t) {
    this.processor = n, this.messages = [], this.root = i, this.opts = t, this.css = "", this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(n, i = {}) {
    i.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (i.plugin = this.lastPlugin.postcssPlugin);
    let t = new nq(n, i);
    return this.messages.push(t), t;
  }
  warnings() {
    return this.messages.filter((n) => n.type === "warning");
  }
};
var hh = Rk;
Rk.default = Rk;
let gS = {};
var Dx = function(n) {
  gS[n] || (gS[n] = !0, typeof console != "undefined" && console.warn && console.warn(n));
};
let iq = c1, tq = kh, aq = Cx, lq = vh, FS = hh, sq = wd, rq = Gm, { isClean: Na, my: oq } = Dd, dq = Dx;
const cq = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, uq = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, mq = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, nr = 0;
function lo(e) {
  return typeof e == "object" && typeof e.then == "function";
}
function wx(e) {
  let n = !1, i = cq[e.type];
  return e.type === "decl" ? n = e.prop.toLowerCase() : e.type === "atrule" && (n = e.name.toLowerCase()), n && e.append ? [
    i,
    i + "-" + n,
    nr,
    i + "Exit",
    i + "Exit-" + n
  ] : n ? [i, i + "-" + n, i + "Exit", i + "Exit-" + n] : e.append ? [i, nr, i + "Exit"] : [i, i + "Exit"];
}
function IS(e) {
  let n;
  return e.type === "document" ? n = ["Document", nr, "DocumentExit"] : e.type === "root" ? n = ["Root", nr, "RootExit"] : n = wx(e), {
    eventIndex: 0,
    events: n,
    iterator: 0,
    node: e,
    visitorIndex: 0,
    visitors: []
  };
}
function Tk(e) {
  return e[Na] = !1, e.nodes && e.nodes.forEach((n) => Tk(n)), e;
}
let jk = {}, ir = class Px {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(n, i, t) {
    this.stringified = !1, this.processed = !1;
    let a;
    if (typeof i == "object" && i !== null && (i.type === "root" || i.type === "document"))
      a = Tk(i);
    else if (i instanceof Px || i instanceof FS)
      a = Tk(i.root), i.map && (typeof t.map == "undefined" && (t.map = {}), t.map.inline || (t.map.inline = !1), t.map.prev = i.map);
    else {
      let s = lq;
      t.syntax && (s = t.syntax.parse), t.parser && (s = t.parser), s.parse && (s = s.parse);
      try {
        a = s(i, t);
      } catch (r) {
        this.processed = !0, this.error = r;
      }
      a && !a[oq] && iq.rebuild(a);
    }
    this.result = new FS(n, a, t), this.helpers = { ...jk, postcss: jk, result: this.result }, this.plugins = this.processor.plugins.map((s) => typeof s == "object" && s.prepare ? { ...s, ...s.prepare(this.result) } : s);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(n) {
    return this.async().catch(n);
  }
  finally(n) {
    return this.async().then(n, n);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(n, i) {
    let t = this.result.lastPlugin;
    try {
      if (i && i.addToError(n), this.error = n, n.name === "CssSyntaxError" && !n.plugin)
        n.plugin = t.postcssPlugin, n.setMessage();
      else if (t.postcssVersion && process.env.NODE_ENV !== "production") {
        let a = t.postcssPlugin, s = t.postcssVersion, r = this.result.processor.version, o = s.split("."), d = r.split(".");
        (o[0] !== d[0] || parseInt(o[1]) > parseInt(d[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + r + ", but " + a + " uses " + s + ". Perhaps this is the source of the error below."
        );
      }
    } catch (a) {
      console && console.error && console.error(a);
    }
    return n;
  }
  prepareVisitors() {
    this.listeners = {};
    let n = (i, t, a) => {
      this.listeners[t] || (this.listeners[t] = []), this.listeners[t].push([i, a]);
    };
    for (let i of this.plugins)
      if (typeof i == "object")
        for (let t in i) {
          if (!uq[t] && /^[A-Z]/.test(t))
            throw new Error(
              `Unknown event ${t} in ${i.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!mq[t])
            if (typeof i[t] == "object")
              for (let a in i[t])
                a === "*" ? n(i, t, i[t][a]) : n(
                  i,
                  t + "-" + a.toLowerCase(),
                  i[t][a]
                );
            else typeof i[t] == "function" && n(i, t, i[t]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  async runAsync() {
    this.plugin = 0;
    for (let n = 0; n < this.plugins.length; n++) {
      let i = this.plugins[n], t = this.runOnRoot(i);
      if (lo(t))
        try {
          await t;
        } catch (a) {
          throw this.handleError(a);
        }
    }
    if (this.prepareVisitors(), this.hasListener) {
      let n = this.result.root;
      for (; !n[Na]; ) {
        n[Na] = !0;
        let i = [IS(n)];
        for (; i.length > 0; ) {
          let t = this.visitTick(i);
          if (lo(t))
            try {
              await t;
            } catch (a) {
              let s = i[i.length - 1].node;
              throw this.handleError(a, s);
            }
        }
      }
      if (this.listeners.OnceExit)
        for (let [i, t] of this.listeners.OnceExit) {
          this.result.lastPlugin = i;
          try {
            if (n.type === "document") {
              let a = n.nodes.map(
                (s) => t(s, this.helpers)
              );
              await Promise.all(a);
            } else
              await t(n, this.helpers);
          } catch (a) {
            throw this.handleError(a);
          }
        }
    }
    return this.processed = !0, this.stringify();
  }
  runOnRoot(n) {
    this.result.lastPlugin = n;
    try {
      if (typeof n == "object" && n.Once) {
        if (this.result.root.type === "document") {
          let i = this.result.root.nodes.map(
            (t) => n.Once(t, this.helpers)
          );
          return lo(i[0]) ? Promise.all(i) : i;
        }
        return n.Once(this.result.root, this.helpers);
      } else if (typeof n == "function")
        return n(this.result.root, this.result);
    } catch (i) {
      throw this.handleError(i);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let n = this.result.opts, i = rq;
    n.syntax && (i = n.syntax.stringify), n.stringifier && (i = n.stringifier), i.stringify && (i = i.stringify);
    let a = new aq(i, this.result.root, this.result.opts).generate();
    return this.result.css = a[0], this.result.map = a[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let n of this.plugins) {
      let i = this.runOnRoot(n);
      if (lo(i))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let n = this.result.root;
      for (; !n[Na]; )
        n[Na] = !0, this.walkSync(n);
      if (this.listeners.OnceExit)
        if (n.type === "document")
          for (let i of n.nodes)
            this.visitSync(this.listeners.OnceExit, i);
        else
          this.visitSync(this.listeners.OnceExit, n);
    }
    return this.result;
  }
  then(n, i) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || dq(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(n, i);
  }
  toString() {
    return this.css;
  }
  visitSync(n, i) {
    for (let [t, a] of n) {
      this.result.lastPlugin = t;
      let s;
      try {
        s = a(i, this.helpers);
      } catch (r) {
        throw this.handleError(r, i.proxyOf);
      }
      if (i.type !== "root" && i.type !== "document" && !i.parent)
        return !0;
      if (lo(s))
        throw this.getAsyncError();
    }
  }
  visitTick(n) {
    let i = n[n.length - 1], { node: t, visitors: a } = i;
    if (t.type !== "root" && t.type !== "document" && !t.parent) {
      n.pop();
      return;
    }
    if (a.length > 0 && i.visitorIndex < a.length) {
      let [r, o] = a[i.visitorIndex];
      i.visitorIndex += 1, i.visitorIndex === a.length && (i.visitors = [], i.visitorIndex = 0), this.result.lastPlugin = r;
      try {
        return o(t.toProxy(), this.helpers);
      } catch (d) {
        throw this.handleError(d, t);
      }
    }
    if (i.iterator !== 0) {
      let r = i.iterator, o;
      for (; o = t.nodes[t.indexes[r]]; )
        if (t.indexes[r] += 1, !o[Na]) {
          o[Na] = !0, n.push(IS(o));
          return;
        }
      i.iterator = 0, delete t.indexes[r];
    }
    let s = i.events;
    for (; i.eventIndex < s.length; ) {
      let r = s[i.eventIndex];
      if (i.eventIndex += 1, r === nr) {
        t.nodes && t.nodes.length && (t[Na] = !0, i.iterator = t.getIterator());
        return;
      } else if (this.listeners[r]) {
        i.visitors = this.listeners[r];
        return;
      }
    }
    n.pop();
  }
  walkSync(n) {
    n[Na] = !0;
    let i = wx(n);
    for (let t of i)
      if (t === nr)
        n.nodes && n.each((a) => {
          a[Na] || this.walkSync(a);
        });
      else {
        let a = this.listeners[t];
        if (a && this.visitSync(a, n.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
ir.registerPostcss = (e) => {
  jk = e;
};
var Rx = ir;
ir.default = ir;
sq.registerLazyResult(ir);
tq.registerLazyResult(ir);
let kq = Cx, fq = vh;
const vq = hh;
let hq = Gm, pq = Dx, Ak = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let n, i = fq;
    try {
      n = i(this._css, this._opts);
    } catch (t) {
      this.error = t;
    }
    if (this.error)
      throw this.error;
    return this._root = n, n;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(n, i, t) {
    i = i.toString(), this.stringified = !1, this._processor = n, this._css = i, this._opts = t, this._map = void 0;
    let a = hq;
    this.result = new vq(this._processor, void 0, this._opts), this.result.css = i;
    let s = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return s.root;
      }
    });
    let r = new kq(a, void 0, this._opts, i);
    if (r.isMap()) {
      let [o, d] = r.generate();
      o && (this.result.css = o), d && (this.result.map = d);
    } else
      r.clearAnnotation(), this.result.css = r.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(n) {
    return this.async().catch(n);
  }
  finally(n) {
    return this.async().then(n, n);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(n, i) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || pq(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(n, i);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var Nq = Ak;
Ak.default = Ak;
let Sq = kh, gq = Rx, Fq = Nq, Iq = wd, Go = class {
  constructor(n = []) {
    this.version = "8.5.8", this.plugins = this.normalize(n);
  }
  normalize(n) {
    let i = [];
    for (let t of n)
      if (t.postcss === !0 ? t = t() : t.postcss && (t = t.postcss), typeof t == "object" && Array.isArray(t.plugins))
        i = i.concat(t.plugins);
      else if (typeof t == "object" && t.postcssPlugin)
        i.push(t);
      else if (typeof t == "function")
        i.push(t);
      else if (typeof t == "object" && (t.parse || t.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(t + " is not a PostCSS plugin");
    return i;
  }
  process(n, i = {}) {
    return !this.plugins.length && !i.parser && !i.stringifier && !i.syntax ? new Fq(this, n, i) : new gq(this, n, i);
  }
  use(n) {
    return this.plugins = this.plugins.concat(this.normalize([n])), this;
  }
};
var yq = Go;
Go.default = Go;
Iq.registerProcessor(Go);
Sq.registerProcessor(Go);
let Tx = mh, jx = Km, bq = c1, Cq = dh, Ax = Ym, Ox = kh, xq = DB, Dq = Xm, wq = Rx, Pq = Sx, Rq = Wm, Tq = vh, ph = yq, jq = hh, Ex = wd, Jx = fh, Aq = Gm, Oq = xx;
function _n(...e) {
  return e.length === 1 && Array.isArray(e[0]) && (e = e[0]), new ph(e);
}
_n.plugin = function(n, i) {
  let t = !1;
  function a(...r) {
    console && console.warn && !t && (t = !0, console.warn(
      n + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      n + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let o = i(...r);
    return o.postcssPlugin = n, o.postcssVersion = new ph().version, o;
  }
  let s;
  return Object.defineProperty(a, "postcss", {
    get() {
      return s || (s = a()), s;
    }
  }), a.process = function(r, o, d) {
    return _n([a(d)]).process(r, o);
  }, a;
};
_n.stringify = Aq;
_n.parse = Tq;
_n.fromJSON = xq;
_n.list = Pq;
_n.comment = (e) => new jx(e);
_n.atRule = (e) => new Tx(e);
_n.decl = (e) => new Ax(e);
_n.rule = (e) => new Jx(e);
_n.root = (e) => new Ex(e);
_n.document = (e) => new Ox(e);
_n.CssSyntaxError = Cq;
_n.Declaration = Ax;
_n.Container = bq;
_n.Processor = ph;
_n.Document = Ox;
_n.Comment = jx;
_n.Warning = Oq;
_n.AtRule = Tx;
_n.Result = jq;
_n.Input = Dq;
_n.Rule = Jx;
_n.Root = Ex;
_n.Node = Rq;
wq.registerPostcss(_n);
var Eq = _n;
_n.default = _n;
const Jq = xC, yS = Tz, { isPlainObject: _q } = rh, bS = Bz, Qq = qz, { parse: Mq } = Eq, Lq = [
  "img",
  "audio",
  "video",
  "picture",
  "svg",
  "object",
  "map",
  "iframe",
  "embed"
], $q = ["script", "style"];
function C1(e, n) {
  e && Object.keys(e).forEach(function(i) {
    n(e[i], i);
  });
}
function Xa(e, n) {
  return {}.hasOwnProperty.call(e, n);
}
function CS(e, n) {
  const i = [];
  return C1(e, function(t) {
    n(t) && i.push(t);
  }), i;
}
function Uq(e) {
  for (const n in e)
    if (Xa(e, n))
      return !1;
  return !0;
}
function Vq(e) {
  return e.map(function(n) {
    if (!n.url)
      throw new Error("URL missing");
    return n.url + (n.w ? ` ${n.w}w` : "") + (n.h ? ` ${n.h}h` : "") + (n.d ? ` ${n.d}x` : "");
  }).join(", ");
}
var Hq = Wo;
const zq = /^[^\0\t\n\f\r /<=>]+$/;
function Wo(e, n, i) {
  if (e == null)
    return "";
  typeof e == "number" && (e = e.toString());
  let t = "", a = "";
  function s(O, M) {
    const L = this;
    this.tag = O, this.attribs = M || {}, this.tagPosition = t.length, this.text = "", this.openingTagLength = 0, this.mediaChildren = [], this.updateParentNodeText = function() {
      if (N.length) {
        const _ = N[N.length - 1];
        _.text += L.text;
      }
    }, this.updateParentNodeMediaChildren = function() {
      N.length && Lq.includes(this.tag) && N[N.length - 1].mediaChildren.push(this.tag);
    };
  }
  n = Object.assign({}, Wo.defaults, n), n.parser = Object.assign({}, Bq, n.parser);
  const r = function(O) {
    return n.allowedTags === !1 || (n.allowedTags || []).indexOf(O) > -1;
  };
  $q.forEach(function(O) {
    r(O) && !n.allowVulnerableTags && console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${O}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
  });
  const o = n.nonTextTags || [
    "script",
    "style",
    "textarea",
    "option"
  ];
  let d, c;
  n.allowedAttributes && (d = {}, c = {}, C1(n.allowedAttributes, function(O, M) {
    d[M] = [];
    const L = [];
    O.forEach(function(_) {
      typeof _ == "string" && _.indexOf("*") >= 0 ? L.push(yS(_).replace(/\\\*/g, ".*")) : d[M].push(_);
    }), L.length && (c[M] = new RegExp("^(" + L.join("|") + ")$"));
  }));
  const u = {}, k = {}, m = {};
  C1(n.allowedClasses, function(O, M) {
    if (d && (Xa(d, M) || (d[M] = []), d[M].push("class")), u[M] = O, Array.isArray(O)) {
      const L = [];
      u[M] = [], m[M] = [], O.forEach(function(_) {
        typeof _ == "string" && _.indexOf("*") >= 0 ? L.push(yS(_).replace(/\\\*/g, ".*")) : _ instanceof RegExp ? m[M].push(_) : u[M].push(_);
      }), L.length && (k[M] = new RegExp("^(" + L.join("|") + ")$"));
    }
  });
  const f = {};
  let p;
  C1(n.transformTags, function(O, M) {
    let L;
    typeof O == "function" ? L = O : typeof O == "string" && (L = Wo.simpleTransform(O)), M === "*" ? p = L : f[M] = L;
  });
  let h, N, S, F, y, x, R = !1;
  j();
  const T = new Jq.Parser({
    onopentag: function(O, M) {
      if (n.onOpenTag && n.onOpenTag(O, M), n.enforceHtmlBoundary && O === "html" && j(), y) {
        x++;
        return;
      }
      const L = new s(O, M);
      N.push(L);
      let _ = !1;
      const z = !!L.text;
      let ne;
      if (Xa(f, O) && (ne = f[O](O, M), L.attribs = M = ne.attribs, ne.text !== void 0 && (L.innerText = ne.text), O !== ne.tagName && (L.name = O = ne.tagName, F[h] = ne.tagName)), p && (ne = p(O, M), L.attribs = M = ne.attribs, O !== ne.tagName && (L.name = O = ne.tagName, F[h] = ne.tagName)), (!r(O) || n.disallowedTagsMode === "recursiveEscape" && !Uq(S) || n.nestingLimit != null && h >= n.nestingLimit) && (_ = !0, S[h] = !0, (n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") && o.indexOf(O) !== -1 && (y = !0, x = 1)), h++, _) {
        if (n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") {
          if (L.innerText && !z) {
            const ue = A(L.innerText);
            n.textFilter ? t += n.textFilter(ue, O) : t += ue, R = !0;
          }
          return;
        }
        a = t, t = "";
      }
      t += "<" + O, O === "script" && (n.allowedScriptHostnames || n.allowedScriptDomains) && (L.innerText = ""), _ && (n.disallowedTagsMode === "escape" || n.disallowedTagsMode === "recursiveEscape") && n.preserveEscapedAttributes ? C1(M, function(ue, oe) {
        t += " " + oe + '="' + A(ue || "", !0) + '"';
      }) : (!d || Xa(d, O) || d["*"]) && C1(M, function(ue, oe) {
        if (!zq.test(oe)) {
          delete L.attribs[oe];
          return;
        }
        if (ue === "" && !n.allowedEmptyAttributes.includes(oe) && (n.nonBooleanAttributes.includes(oe) || n.nonBooleanAttributes.includes("*"))) {
          delete L.attribs[oe];
          return;
        }
        let $e = !1;
        if (!d || Xa(d, O) && d[O].indexOf(oe) !== -1 || d["*"] && d["*"].indexOf(oe) !== -1 || Xa(c, O) && c[O].test(oe) || c["*"] && c["*"].test(oe))
          $e = !0;
        else if (d && d[O]) {
          for (const we of d[O])
            if (_q(we) && we.name && we.name === oe) {
              $e = !0;
              let ie = "";
              if (we.multiple === !0) {
                const De = ue.split(" ");
                for (const _e of De)
                  we.values.indexOf(_e) !== -1 && (ie === "" ? ie = _e : ie += " " + _e);
              } else we.values.indexOf(ue) >= 0 && (ie = ue);
              ue = ie;
            }
        }
        if ($e) {
          if (n.allowedSchemesAppliedToAttributes.indexOf(oe) !== -1 && B(O, ue)) {
            delete L.attribs[oe];
            return;
          }
          if (O === "script" && oe === "src") {
            let we = !0;
            try {
              const ie = W(ue);
              if (n.allowedScriptHostnames || n.allowedScriptDomains) {
                const De = (n.allowedScriptHostnames || []).find(function(Ie) {
                  return Ie === ie.url.hostname;
                }), _e = (n.allowedScriptDomains || []).find(function(Ie) {
                  return ie.url.hostname === Ie || ie.url.hostname.endsWith(`.${Ie}`);
                });
                we = De || _e;
              }
            } catch (ie) {
              we = !1;
            }
            if (!we) {
              delete L.attribs[oe];
              return;
            }
          }
          if (O === "iframe" && oe === "src") {
            let we = !0;
            try {
              const ie = W(ue);
              if (ie.isRelativeUrl)
                we = Xa(n, "allowIframeRelativeUrls") ? n.allowIframeRelativeUrls : !n.allowedIframeHostnames && !n.allowedIframeDomains;
              else if (n.allowedIframeHostnames || n.allowedIframeDomains) {
                const De = (n.allowedIframeHostnames || []).find(function(Ie) {
                  return Ie === ie.url.hostname;
                }), _e = (n.allowedIframeDomains || []).find(function(Ie) {
                  return ie.url.hostname === Ie || ie.url.hostname.endsWith(`.${Ie}`);
                });
                we = De || _e;
              }
            } catch (ie) {
              we = !1;
            }
            if (!we) {
              delete L.attribs[oe];
              return;
            }
          }
          if (oe === "srcset")
            try {
              let we = Qq(ue);
              if (we.forEach(function(ie) {
                B("srcset", ie.url) && (ie.evil = !0);
              }), we = CS(we, function(ie) {
                return !ie.evil;
              }), we.length)
                ue = Vq(CS(we, function(ie) {
                  return !ie.evil;
                })), L.attribs[oe] = ue;
              else {
                delete L.attribs[oe];
                return;
              }
            } catch (we) {
              delete L.attribs[oe];
              return;
            }
          if (oe === "class") {
            const we = u[O], ie = u["*"], De = k[O], _e = m[O], Ie = m["*"], Fe = k["*"], re = [
              De,
              Fe
            ].concat(_e, Ie).filter(function(Me) {
              return Me;
            });
            if (we && ie ? ue = H(ue, bS(we, ie), re) : ue = H(ue, we || ie, re), !ue.length) {
              delete L.attribs[oe];
              return;
            }
          }
          if (oe === "style") {
            if (n.parseStyleAttributes)
              try {
                const we = Mq(O + " {" + ue + "}", { map: !1 }), ie = E(we, n.allowedStyles);
                if (ue = $(ie), ue.length === 0) {
                  delete L.attribs[oe];
                  return;
                }
              } catch (we) {
                typeof window != "undefined" && console.warn('Failed to parse "' + O + " {" + ue + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`), delete L.attribs[oe];
                return;
              }
            else if (n.allowedStyles)
              throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
          }
          t += " " + oe, ue && ue.length ? t += '="' + A(ue, !0) + '"' : n.allowedEmptyAttributes.includes(oe) && (t += '=""');
        } else
          delete L.attribs[oe];
      }), n.selfClosing.indexOf(O) !== -1 ? t += " />" : (t += ">", L.innerText && !z && !n.textFilter && (t += A(L.innerText), R = !0)), _ && (t = a + A(t), a = ""), L.openingTagLength = t.length - L.tagPosition;
    },
    ontext: function(O) {
      if (y)
        return;
      const M = N[N.length - 1];
      let L;
      if (M && (L = M.tag, O = M.innerText !== void 0 ? M.innerText : O), n.disallowedTagsMode === "completelyDiscard" && !r(L))
        O = "";
      else if ((n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") && (L === "script" || L === "style"))
        t += O;
      else if (!R) {
        const _ = A(O, !1);
        n.textFilter ? t += n.textFilter(_, L) : t += _;
      }
      if (N.length) {
        const _ = N[N.length - 1];
        _.text += O;
      }
    },
    onclosetag: function(O, M) {
      if (n.onCloseTag && n.onCloseTag(O, M), y)
        if (x--, !x)
          y = !1;
        else
          return;
      const L = N.pop();
      if (!L)
        return;
      if (L.tag !== O) {
        N.push(L);
        return;
      }
      y = n.enforceHtmlBoundary ? O === "html" : !1, h--;
      const _ = S[h];
      if (_) {
        if (delete S[h], n.disallowedTagsMode === "discard" || n.disallowedTagsMode === "completelyDiscard") {
          L.updateParentNodeText();
          return;
        }
        a = t, t = "";
      }
      if (F[h] && (O = F[h], delete F[h]), n.exclusiveFilter) {
        const z = n.exclusiveFilter(L);
        if (z === "excludeTag") {
          _ && (t = a, a = ""), t = t.substring(0, L.tagPosition) + t.substring(L.tagPosition + L.openingTagLength);
          return;
        } else if (z) {
          t = t.substring(0, L.tagPosition);
          return;
        }
      }
      if (L.updateParentNodeMediaChildren(), L.updateParentNodeText(), // Already output />
      n.selfClosing.indexOf(O) !== -1 || // Escaped tag, closing tag is implied
      M && !r(O) && ["escape", "recursiveEscape"].indexOf(n.disallowedTagsMode) >= 0) {
        _ && (t = a, a = "");
        return;
      }
      t += "</" + O + ">", _ && (t = a + A(t), a = ""), R = !1;
    }
  }, n.parser);
  return T.write(e), T.end(), t;
  function j() {
    t = "", h = 0, N = [], S = {}, F = {}, y = !1, x = 0;
  }
  function A(O, M) {
    return typeof O != "string" && (O = O + ""), n.parser.decodeEntities && (O = O.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), M && (O = O.replace(/"/g, "&quot;"))), O = O.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), M && (O = O.replace(/"/g, "&quot;")), O;
  }
  function B(O, M) {
    for (M = M.replace(/[\x00-\x20]+/g, ""); ; ) {
      const z = M.indexOf("<!--");
      if (z === -1)
        break;
      const ne = M.indexOf("-->", z + 4);
      if (ne === -1)
        break;
      M = M.substring(0, z) + M.substring(ne + 3);
    }
    const L = M.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
    if (!L)
      return M.match(/^[/\\]{2}/) ? !n.allowProtocolRelative : !1;
    const _ = L[1].toLowerCase();
    return Xa(n.allowedSchemesByTag, O) ? n.allowedSchemesByTag[O].indexOf(_) === -1 : !n.allowedSchemes || n.allowedSchemes.indexOf(_) === -1;
  }
  function W(O) {
    if (O = O.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//"), O.startsWith("relative:"))
      throw new Error("relative: exploit attempt");
    let M = "relative://relative-site";
    for (let z = 0; z < 100; z++)
      M += `/${z}`;
    const L = new URL(O, M);
    return {
      isRelativeUrl: L && L.hostname === "relative-site" && L.protocol === "relative:",
      url: L
    };
  }
  function E(O, M) {
    if (!M)
      return O;
    const L = O.nodes[0];
    let _;
    return M[L.selector] && M["*"] ? _ = bS(
      M[L.selector],
      M["*"]
    ) : _ = M[L.selector] || M["*"], _ && (O.nodes[0].nodes = L.nodes.reduce(V(_), [])), O;
  }
  function $(O) {
    return O.nodes[0].nodes.reduce(function(M, L) {
      return M.push(
        `${L.prop}:${L.value}${L.important ? " !important" : ""}`
      ), M;
    }, []).join(";");
  }
  function V(O) {
    return function(M, L) {
      return Xa(O, L.prop) && O[L.prop].some(function(z) {
        return z.test(L.value);
      }) && M.push(L), M;
    };
  }
  function H(O, M, L) {
    return M ? (O = O.split(/\s+/), O.filter(function(_) {
      return M.indexOf(_) !== -1 || L.some(function(z) {
        return z.test(_);
      });
    }).join(" ")) : O;
  }
}
const Bq = {
  decodeEntities: !0
};
Wo.defaults = {
  allowedTags: [
    // Sections derived from MDN element categories and limited to the more
    // benign categories.
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
    // Content sectioning
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hgroup",
    "main",
    "nav",
    "section",
    // Text content
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "menu",
    "ol",
    "p",
    "pre",
    "ul",
    // Inline text semantics
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Table content
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr"
  ],
  // Tags that cannot be boolean
  nonBooleanAttributes: [
    "abbr",
    "accept",
    "accept-charset",
    "accesskey",
    "action",
    "allow",
    "alt",
    "as",
    "autocapitalize",
    "autocomplete",
    "blocking",
    "charset",
    "cite",
    "class",
    "color",
    "cols",
    "colspan",
    "content",
    "contenteditable",
    "coords",
    "crossorigin",
    "data",
    "datetime",
    "decoding",
    "dir",
    "dirname",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "fetchpriority",
    "for",
    "form",
    "formaction",
    "formenctype",
    "formmethod",
    "formtarget",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "http-equiv",
    "id",
    "imagesizes",
    "imagesrcset",
    "inputmode",
    "integrity",
    "is",
    "itemid",
    "itemprop",
    "itemref",
    "itemtype",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "name",
    "nonce",
    "optimum",
    "pattern",
    "ping",
    "placeholder",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "referrerpolicy",
    "rel",
    "rows",
    "rowspan",
    "sandbox",
    "scope",
    "shape",
    "size",
    "sizes",
    "slot",
    "span",
    "spellcheck",
    "src",
    "srcdoc",
    "srclang",
    "srcset",
    "start",
    "step",
    "style",
    "tabindex",
    "target",
    "title",
    "translate",
    "type",
    "usemap",
    "value",
    "width",
    "wrap",
    // Event handlers
    "onauxclick",
    "onafterprint",
    "onbeforematch",
    "onbeforeprint",
    "onbeforeunload",
    "onbeforetoggle",
    "onblur",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "onchange",
    "onclick",
    "onclose",
    "oncontextlost",
    "oncontextmenu",
    "oncontextrestored",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onended",
    "onerror",
    "onfocus",
    "onformdata",
    "onhashchange",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlanguagechange",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onmessage",
    "onmessageerror",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onoffline",
    "ononline",
    "onpagehide",
    "onpageshow",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpopstate",
    "onprogress",
    "onratechange",
    "onreset",
    "onresize",
    "onrejectionhandled",
    "onscroll",
    "onscrollend",
    "onsecuritypolicyviolation",
    "onseeked",
    "onseeking",
    "onselect",
    "onslotchange",
    "onstalled",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "ontimeupdate",
    "ontoggle",
    "onunhandledrejection",
    "onunload",
    "onvolumechange",
    "onwaiting",
    "onwheel"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    // We don't currently allow img itself by default, but
    // these attributes would make sense if we did.
    img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
  },
  allowedEmptyAttributes: [
    "alt"
  ],
  // Lots of these won't come up by default because we don't allow them
  selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: !0,
  enforceHtmlBoundary: !1,
  parseStyleAttributes: !0,
  preserveEscapedAttributes: !1
};
Wo.simpleTransform = function(e, n, i) {
  return i = i === void 0 ? !0 : i, n = n || {}, function(t, a) {
    let s;
    if (i)
      for (s in n)
        a[s] = n[s];
    else
      a = n;
    return {
      tagName: e,
      attribs: a
    };
  };
};
const qq = /* @__PURE__ */ ls(Hq), _x = (e, n) => {
  if (!e || typeof e != "string")
    return "";
  try {
    const i = { ...yH, ...n };
    return qq(e, i);
  } catch (i) {
    return console.error("HTML sanitization failed", { error: i, input: e.substring(0, 100) }), e.replace(/<[^>]*>/g, "").replace(/javascript:/gi, "").replace(/on\w+\s*=/gi, "");
  }
}, Ok = [
  "br",
  "p",
  "span",
  "div",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "a"
], Nh = (e) => e ? _x(e, {
  allowedTags: Ok
}) : "", Gq = [
  ...Ok || [],
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "img",
  "ul",
  "ol",
  "li",
  "blockquote",
  "pre",
  "code",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td"
], Wq = {
  a: ["href", "target", "rel"],
  "*": ["class", "id"],
  img: ["src", "alt", "title", "width", "height"]
}, Kq = (e) => e ? _x(e, {
  allowedTags: Gq,
  allowedAttributes: Wq
}) : "", en = (e) => typeof e == "string", so = () => {
  let e, n;
  const i = new Promise((t, a) => {
    e = t, n = a;
  });
  return i.resolve = e, i.reject = n, i;
}, xS = (e) => e == null ? "" : "" + e, Yq = (e, n, i) => {
  e.forEach((t) => {
    n[t] && (i[t] = n[t]);
  });
}, Xq = /###/g, DS = (e) => e && e.indexOf("###") > -1 ? e.replace(Xq, ".") : e, wS = (e) => !e || en(e), Do = (e, n, i) => {
  const t = en(n) ? n.split(".") : n;
  let a = 0;
  for (; a < t.length - 1; ) {
    if (wS(e)) return {};
    const s = DS(t[a]);
    !e[s] && i && (e[s] = new i()), Object.prototype.hasOwnProperty.call(e, s) ? e = e[s] : e = {}, ++a;
  }
  return wS(e) ? {} : {
    obj: e,
    k: DS(t[a])
  };
}, PS = (e, n, i) => {
  const {
    obj: t,
    k: a
  } = Do(e, n, Object);
  if (t !== void 0 || n.length === 1) {
    t[a] = i;
    return;
  }
  let s = n[n.length - 1], r = n.slice(0, n.length - 1), o = Do(e, r, Object);
  for (; o.obj === void 0 && r.length; )
    s = `${r[r.length - 1]}.${s}`, r = r.slice(0, r.length - 1), o = Do(e, r, Object), o && o.obj && typeof o.obj[`${o.k}.${s}`] != "undefined" && (o.obj = void 0);
  o.obj[`${o.k}.${s}`] = i;
}, Zq = (e, n, i, t) => {
  const {
    obj: a,
    k: s
  } = Do(e, n, Object);
  a[s] = a[s] || [], a[s].push(i);
}, Au = (e, n) => {
  const {
    obj: i,
    k: t
  } = Do(e, n);
  if (i)
    return i[t];
}, eG = (e, n, i) => {
  const t = Au(e, i);
  return t !== void 0 ? t : Au(n, i);
}, Qx = (e, n, i) => {
  for (const t in n)
    t !== "__proto__" && t !== "constructor" && (t in e ? en(e[t]) || e[t] instanceof String || en(n[t]) || n[t] instanceof String ? i && (e[t] = n[t]) : Qx(e[t], n[t], i) : e[t] = n[t]);
  return e;
}, F1 = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var nG = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const iG = (e) => en(e) ? e.replace(/[&<>"'\/]/g, (n) => nG[n]) : e;
class tG {
  constructor(n) {
    this.capacity = n, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(n) {
    const i = this.regExpMap.get(n);
    if (i !== void 0)
      return i;
    const t = new RegExp(n);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(n, t), this.regExpQueue.push(n), t;
  }
}
const aG = [" ", ",", "?", "!", ";"], lG = new tG(20), sG = (e, n, i) => {
  n = n || "", i = i || "";
  const t = aG.filter((r) => n.indexOf(r) < 0 && i.indexOf(r) < 0);
  if (t.length === 0) return !0;
  const a = lG.getRegExp(`(${t.map((r) => r === "?" ? "\\?" : r).join("|")})`);
  let s = !a.test(e);
  if (!s) {
    const r = e.indexOf(i);
    r > 0 && !a.test(e.substring(0, r)) && (s = !0);
  }
  return s;
}, Ek = function(e, n) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e) return;
  if (e[n]) return e[n];
  const t = n.split(i);
  let a = e;
  for (let s = 0; s < t.length; ) {
    if (!a || typeof a != "object")
      return;
    let r, o = "";
    for (let d = s; d < t.length; ++d)
      if (d !== s && (o += i), o += t[d], r = a[o], r !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof r) > -1 && d < t.length - 1)
          continue;
        s += d - s + 1;
        break;
      }
    a = r;
  }
  return a;
}, Ou = (e) => e && e.replace("_", "-"), rG = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, n) {
    console && console[e] && console[e].apply(console, n);
  }
};
class Eu {
  constructor(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(n, i);
  }
  init(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = i.prefix || "i18next:", this.logger = n || rG, this.options = i, this.debug = i.debug;
  }
  log() {
    for (var n = arguments.length, i = new Array(n), t = 0; t < n; t++)
      i[t] = arguments[t];
    return this.forward(i, "log", "", !0);
  }
  warn() {
    for (var n = arguments.length, i = new Array(n), t = 0; t < n; t++)
      i[t] = arguments[t];
    return this.forward(i, "warn", "", !0);
  }
  error() {
    for (var n = arguments.length, i = new Array(n), t = 0; t < n; t++)
      i[t] = arguments[t];
    return this.forward(i, "error", "");
  }
  deprecate() {
    for (var n = arguments.length, i = new Array(n), t = 0; t < n; t++)
      i[t] = arguments[t];
    return this.forward(i, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(n, i, t, a) {
    return a && !this.debug ? null : (en(n[0]) && (n[0] = `${t}${this.prefix} ${n[0]}`), this.logger[i](n));
  }
  create(n) {
    return new Eu(this.logger, {
      prefix: `${this.prefix}:${n}:`,
      ...this.options
    });
  }
  clone(n) {
    return n = n || this.options, n.prefix = n.prefix || this.prefix, new Eu(this.logger, n);
  }
}
var Ca = new Eu();
class Zm {
  constructor() {
    this.observers = {};
  }
  on(n, i) {
    return n.split(" ").forEach((t) => {
      this.observers[t] || (this.observers[t] = /* @__PURE__ */ new Map());
      const a = this.observers[t].get(i) || 0;
      this.observers[t].set(i, a + 1);
    }), this;
  }
  off(n, i) {
    if (this.observers[n]) {
      if (!i) {
        delete this.observers[n];
        return;
      }
      this.observers[n].delete(i);
    }
  }
  emit(n) {
    for (var i = arguments.length, t = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
      t[a - 1] = arguments[a];
    this.observers[n] && Array.from(this.observers[n].entries()).forEach((r) => {
      let [o, d] = r;
      for (let c = 0; c < d; c++)
        o(...t);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((r) => {
      let [o, d] = r;
      for (let c = 0; c < d; c++)
        o.apply(o, [n, ...t]);
    });
  }
}
class RS extends Zm {
  constructor(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = n || {}, this.options = i, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(n) {
    this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
  }
  removeNamespaces(n) {
    const i = this.options.ns.indexOf(n);
    i > -1 && this.options.ns.splice(i, 1);
  }
  getResource(n, i, t) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const s = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, r = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    n.indexOf(".") > -1 ? o = n.split(".") : (o = [n, i], t && (Array.isArray(t) ? o.push(...t) : en(t) && s ? o.push(...t.split(s)) : o.push(t)));
    const d = Au(this.data, o);
    return !d && !i && !t && n.indexOf(".") > -1 && (n = o[0], i = o[1], t = o.slice(2).join(".")), d || !r || !en(t) ? d : Ek(this.data && this.data[n] && this.data[n][i], t, s);
  }
  addResource(n, i, t, a) {
    let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const r = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator;
    let o = [n, i];
    t && (o = o.concat(r ? t.split(r) : t)), n.indexOf(".") > -1 && (o = n.split("."), a = i, i = o[1]), this.addNamespaces(i), PS(this.data, o, a), s.silent || this.emit("added", n, i, t, a);
  }
  addResources(n, i, t) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const s in t)
      (en(t[s]) || Array.isArray(t[s])) && this.addResource(n, i, s, t[s], {
        silent: !0
      });
    a.silent || this.emit("added", n, i, t);
  }
  addResourceBundle(n, i, t, a, s) {
    let r = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [n, i];
    n.indexOf(".") > -1 && (o = n.split("."), a = t, t = i, i = o[1]), this.addNamespaces(i);
    let d = Au(this.data, o) || {};
    r.skipCopy || (t = JSON.parse(JSON.stringify(t))), a ? Qx(d, t, s) : d = {
      ...d,
      ...t
    }, PS(this.data, o, d), r.silent || this.emit("added", n, i, t);
  }
  removeResourceBundle(n, i) {
    this.hasResourceBundle(n, i) && delete this.data[n][i], this.removeNamespaces(i), this.emit("removed", n, i);
  }
  hasResourceBundle(n, i) {
    return this.getResource(n, i) !== void 0;
  }
  getResourceBundle(n, i) {
    return i || (i = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(n, i)
    } : this.getResource(n, i);
  }
  getDataByLanguage(n) {
    return this.data[n];
  }
  hasLanguageSomeTranslations(n) {
    const i = this.getDataByLanguage(n);
    return !!(i && Object.keys(i) || []).find((a) => i[a] && Object.keys(i[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Mx = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, n, i, t, a) {
    return e.forEach((s) => {
      this.processors[s] && (n = this.processors[s].process(n, i, t, a));
    }), n;
  }
};
const TS = {};
class Ju extends Zm {
  constructor(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Yq(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], n, this), this.options = i, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Ca.create("translator");
  }
  changeLanguage(n) {
    n && (this.language = n);
  }
  exists(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (n == null)
      return !1;
    const t = this.resolve(n, i);
    return t && t.res !== void 0;
  }
  extractFromKey(n, i) {
    let t = i.nsSeparator !== void 0 ? i.nsSeparator : this.options.nsSeparator;
    t === void 0 && (t = ":");
    const a = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = i.ns || this.options.defaultNS || [];
    const r = t && n.indexOf(t) > -1, o = !this.options.userDefinedKeySeparator && !i.keySeparator && !this.options.userDefinedNsSeparator && !i.nsSeparator && !sG(n, t, a);
    if (r && !o) {
      const d = n.match(this.interpolator.nestingRegexp);
      if (d && d.length > 0)
        return {
          key: n,
          namespaces: en(s) ? [s] : s
        };
      const c = n.split(t);
      (t !== a || t === a && this.options.ns.indexOf(c[0]) > -1) && (s = c.shift()), n = c.join(a);
    }
    return {
      key: n,
      namespaces: en(s) ? [s] : s
    };
  }
  translate(n, i, t) {
    if (typeof i != "object" && this.options.overloadTranslationOptionHandler && (i = this.options.overloadTranslationOptionHandler(arguments)), typeof i == "object" && (i = {
      ...i
    }), i || (i = {}), n == null) return "";
    Array.isArray(n) || (n = [String(n)]);
    const a = i.returnDetails !== void 0 ? i.returnDetails : this.options.returnDetails, s = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator, {
      key: r,
      namespaces: o
    } = this.extractFromKey(n[n.length - 1], i), d = o[o.length - 1], c = i.lng || this.language, u = i.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const x = i.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${d}${x}${r}`,
          usedKey: r,
          exactUsedKey: r,
          usedLng: c,
          usedNS: d,
          usedParams: this.getUsedParamsDetails(i)
        } : `${d}${x}${r}`;
      }
      return a ? {
        res: r,
        usedKey: r,
        exactUsedKey: r,
        usedLng: c,
        usedNS: d,
        usedParams: this.getUsedParamsDetails(i)
      } : r;
    }
    const k = this.resolve(n, i);
    let m = k && k.res;
    const f = k && k.usedKey || r, p = k && k.exactUsedKey || r, h = Object.prototype.toString.apply(m), N = ["[object Number]", "[object Function]", "[object RegExp]"], S = i.joinArrays !== void 0 ? i.joinArrays : this.options.joinArrays, F = !this.i18nFormat || this.i18nFormat.handleAsObject, y = !en(m) && typeof m != "boolean" && typeof m != "number";
    if (F && m && y && N.indexOf(h) < 0 && !(en(S) && Array.isArray(m))) {
      if (!i.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const x = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(f, m, {
          ...i,
          ns: o
        }) : `key '${r} (${this.language})' returned an object instead of string.`;
        return a ? (k.res = x, k.usedParams = this.getUsedParamsDetails(i), k) : x;
      }
      if (s) {
        const x = Array.isArray(m), R = x ? [] : {}, T = x ? p : f;
        for (const j in m)
          if (Object.prototype.hasOwnProperty.call(m, j)) {
            const A = `${T}${s}${j}`;
            R[j] = this.translate(A, {
              ...i,
              joinArrays: !1,
              ns: o
            }), R[j] === A && (R[j] = m[j]);
          }
        m = R;
      }
    } else if (F && en(S) && Array.isArray(m))
      m = m.join(S), m && (m = this.extendTranslation(m, n, i, t));
    else {
      let x = !1, R = !1;
      const T = i.count !== void 0 && !en(i.count), j = Ju.hasDefaultValue(i), A = T ? this.pluralResolver.getSuffix(c, i.count, i) : "", B = i.ordinal && T ? this.pluralResolver.getSuffix(c, i.count, {
        ordinal: !1
      }) : "", W = T && !i.ordinal && i.count === 0 && this.pluralResolver.shouldUseIntlApi(), E = W && i[`defaultValue${this.options.pluralSeparator}zero`] || i[`defaultValue${A}`] || i[`defaultValue${B}`] || i.defaultValue;
      !this.isValidLookup(m) && j && (x = !0, m = E), this.isValidLookup(m) || (R = !0, m = r);
      const V = (i.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && R ? void 0 : m, H = j && E !== m && this.options.updateMissing;
      if (R || x || H) {
        if (this.logger.log(H ? "updateKey" : "missingKey", c, d, r, H ? E : m), s) {
          const _ = this.resolve(r, {
            ...i,
            keySeparator: !1
          });
          _ && _.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let O = [];
        const M = this.languageUtils.getFallbackCodes(this.options.fallbackLng, i.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && M && M[0])
          for (let _ = 0; _ < M.length; _++)
            O.push(M[_]);
        else this.options.saveMissingTo === "all" ? O = this.languageUtils.toResolveHierarchy(i.lng || this.language) : O.push(i.lng || this.language);
        const L = (_, z, ne) => {
          const Se = j && ne !== m ? ne : V;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(_, d, z, Se, H, i) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(_, d, z, Se, H, i), this.emit("missingKey", _, d, z, m);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && T ? O.forEach((_) => {
          const z = this.pluralResolver.getSuffixes(_, i);
          W && i[`defaultValue${this.options.pluralSeparator}zero`] && z.indexOf(`${this.options.pluralSeparator}zero`) < 0 && z.push(`${this.options.pluralSeparator}zero`), z.forEach((ne) => {
            L([_], r + ne, i[`defaultValue${ne}`] || E);
          });
        }) : L(O, r, E));
      }
      m = this.extendTranslation(m, n, i, k, t), R && m === r && this.options.appendNamespaceToMissingKey && (m = `${d}:${r}`), (R || x) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? m = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${d}:${r}` : r, x ? m : void 0) : m = this.options.parseMissingKeyHandler(m));
    }
    return a ? (k.res = m, k.usedParams = this.getUsedParamsDetails(i), k) : m;
  }
  extendTranslation(n, i, t, a, s) {
    var r = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      n = this.i18nFormat.parse(n, {
        ...this.options.interpolation.defaultVariables,
        ...t
      }, t.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!t.skipInterpolation) {
      t.interpolation && this.interpolator.init({
        ...t,
        interpolation: {
          ...this.options.interpolation,
          ...t.interpolation
        }
      });
      const c = en(n) && (t && t.interpolation && t.interpolation.skipOnVariables !== void 0 ? t.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const m = n.match(this.interpolator.nestingRegexp);
        u = m && m.length;
      }
      let k = t.replace && !en(t.replace) ? t.replace : t;
      if (this.options.interpolation.defaultVariables && (k = {
        ...this.options.interpolation.defaultVariables,
        ...k
      }), n = this.interpolator.interpolate(n, k, t.lng || this.language || a.usedLng, t), c) {
        const m = n.match(this.interpolator.nestingRegexp), f = m && m.length;
        u < f && (t.nest = !1);
      }
      !t.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (t.lng = this.language || a.usedLng), t.nest !== !1 && (n = this.interpolator.nest(n, function() {
        for (var m = arguments.length, f = new Array(m), p = 0; p < m; p++)
          f[p] = arguments[p];
        return s && s[0] === f[0] && !t.context ? (r.logger.warn(`It seems you are nesting recursively key: ${f[0]} in key: ${i[0]}`), null) : r.translate(...f, i);
      }, t)), t.interpolation && this.interpolator.reset();
    }
    const o = t.postProcess || this.options.postProcess, d = en(o) ? [o] : o;
    return n != null && d && d.length && t.applyPostProcessor !== !1 && (n = Mx.handle(d, n, i, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(t)
      },
      ...t
    } : t, this)), n;
  }
  resolve(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t, a, s, r, o;
    return en(n) && (n = [n]), n.forEach((d) => {
      if (this.isValidLookup(t)) return;
      const c = this.extractFromKey(d, i), u = c.key;
      a = u;
      let k = c.namespaces;
      this.options.fallbackNS && (k = k.concat(this.options.fallbackNS));
      const m = i.count !== void 0 && !en(i.count), f = m && !i.ordinal && i.count === 0 && this.pluralResolver.shouldUseIntlApi(), p = i.context !== void 0 && (en(i.context) || typeof i.context == "number") && i.context !== "", h = i.lngs ? i.lngs : this.languageUtils.toResolveHierarchy(i.lng || this.language, i.fallbackLng);
      k.forEach((N) => {
        this.isValidLookup(t) || (o = N, !TS[`${h[0]}-${N}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (TS[`${h[0]}-${N}`] = !0, this.logger.warn(`key "${a}" for languages "${h.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), h.forEach((S) => {
          if (this.isValidLookup(t)) return;
          r = S;
          const F = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(F, u, S, N, i);
          else {
            let x;
            m && (x = this.pluralResolver.getSuffix(S, i.count, i));
            const R = `${this.options.pluralSeparator}zero`, T = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (m && (F.push(u + x), i.ordinal && x.indexOf(T) === 0 && F.push(u + x.replace(T, this.options.pluralSeparator)), f && F.push(u + R)), p) {
              const j = `${u}${this.options.contextSeparator}${i.context}`;
              F.push(j), m && (F.push(j + x), i.ordinal && x.indexOf(T) === 0 && F.push(j + x.replace(T, this.options.pluralSeparator)), f && F.push(j + R));
            }
          }
          let y;
          for (; y = F.pop(); )
            this.isValidLookup(t) || (s = y, t = this.getResource(S, N, y, i));
        }));
      });
    }), {
      res: t,
      usedKey: a,
      exactUsedKey: s,
      usedLng: r,
      usedNS: o
    };
  }
  isValidLookup(n) {
    return n !== void 0 && !(!this.options.returnNull && n === null) && !(!this.options.returnEmptyString && n === "");
  }
  getResource(n, i, t) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(n, i, t, a) : this.resourceStore.getResource(n, i, t, a);
  }
  getUsedParamsDetails() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const i = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], t = n.replace && !en(n.replace);
    let a = t ? n.replace : n;
    if (t && typeof n.count != "undefined" && (a.count = n.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !t) {
      a = {
        ...a
      };
      for (const s of i)
        delete a[s];
    }
    return a;
  }
  static hasDefaultValue(n) {
    const i = "defaultValue";
    for (const t in n)
      if (Object.prototype.hasOwnProperty.call(n, t) && i === t.substring(0, i.length) && n[t] !== void 0)
        return !0;
    return !1;
  }
}
const e3 = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class jS {
  constructor(n) {
    this.options = n, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ca.create("languageUtils");
  }
  getScriptPartFromCode(n) {
    if (n = Ou(n), !n || n.indexOf("-") < 0) return null;
    const i = n.split("-");
    return i.length === 2 || (i.pop(), i[i.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(i.join("-"));
  }
  getLanguagePartFromCode(n) {
    if (n = Ou(n), !n || n.indexOf("-") < 0) return n;
    const i = n.split("-");
    return this.formatLanguageCode(i[0]);
  }
  formatLanguageCode(n) {
    if (en(n) && n.indexOf("-") > -1) {
      if (typeof Intl != "undefined" && typeof Intl.getCanonicalLocales != "undefined")
        try {
          let a = Intl.getCanonicalLocales(n)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a) return a;
        } catch (a) {
        }
      const i = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let t = n.split("-");
      return this.options.lowerCaseLng ? t = t.map((a) => a.toLowerCase()) : t.length === 2 ? (t[0] = t[0].toLowerCase(), t[1] = t[1].toUpperCase(), i.indexOf(t[1].toLowerCase()) > -1 && (t[1] = e3(t[1].toLowerCase()))) : t.length === 3 && (t[0] = t[0].toLowerCase(), t[1].length === 2 && (t[1] = t[1].toUpperCase()), t[0] !== "sgn" && t[2].length === 2 && (t[2] = t[2].toUpperCase()), i.indexOf(t[1].toLowerCase()) > -1 && (t[1] = e3(t[1].toLowerCase())), i.indexOf(t[2].toLowerCase()) > -1 && (t[2] = e3(t[2].toLowerCase()))), t.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? n.toLowerCase() : n;
  }
  isSupportedCode(n) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (n = this.getLanguagePartFromCode(n)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(n) > -1;
  }
  getBestMatchFromCodes(n) {
    if (!n) return null;
    let i;
    return n.forEach((t) => {
      if (i) return;
      const a = this.formatLanguageCode(t);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (i = a);
    }), !i && this.options.supportedLngs && n.forEach((t) => {
      if (i) return;
      const a = this.getLanguagePartFromCode(t);
      if (this.isSupportedCode(a)) return i = a;
      i = this.options.supportedLngs.find((s) => {
        if (s === a) return s;
        if (!(s.indexOf("-") < 0 && a.indexOf("-") < 0) && (s.indexOf("-") > 0 && a.indexOf("-") < 0 && s.substring(0, s.indexOf("-")) === a || s.indexOf(a) === 0 && a.length > 1))
          return s;
      });
    }), i || (i = this.getFallbackCodes(this.options.fallbackLng)[0]), i;
  }
  getFallbackCodes(n, i) {
    if (!n) return [];
    if (typeof n == "function" && (n = n(i)), en(n) && (n = [n]), Array.isArray(n)) return n;
    if (!i) return n.default || [];
    let t = n[i];
    return t || (t = n[this.getScriptPartFromCode(i)]), t || (t = n[this.formatLanguageCode(i)]), t || (t = n[this.getLanguagePartFromCode(i)]), t || (t = n.default), t || [];
  }
  toResolveHierarchy(n, i) {
    const t = this.getFallbackCodes(i || this.options.fallbackLng || [], n), a = [], s = (r) => {
      r && (this.isSupportedCode(r) ? a.push(r) : this.logger.warn(`rejecting language code not found in supportedLngs: ${r}`));
    };
    return en(n) && (n.indexOf("-") > -1 || n.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && s(this.formatLanguageCode(n)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && s(this.getScriptPartFromCode(n)), this.options.load !== "currentOnly" && s(this.getLanguagePartFromCode(n))) : en(n) && s(this.formatLanguageCode(n)), t.forEach((r) => {
      a.indexOf(r) < 0 && s(this.formatLanguageCode(r));
    }), a;
  }
}
let oG = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], dG = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const cG = ["v1", "v2", "v3"], uG = ["v4"], AS = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, mG = () => {
  const e = {};
  return oG.forEach((n) => {
    n.lngs.forEach((i) => {
      e[i] = {
        numbers: n.nr,
        plurals: dG[n.fc]
      };
    });
  }), e;
};
class kG {
  constructor(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = n, this.options = i, this.logger = Ca.create("pluralResolver"), (!this.options.compatibilityJSON || uG.includes(this.options.compatibilityJSON)) && (typeof Intl == "undefined" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = mG(), this.pluralRulesCache = {};
  }
  addRule(n, i) {
    this.rules[n] = i;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const t = Ou(n === "dev" ? "en" : n), a = i.ordinal ? "ordinal" : "cardinal", s = JSON.stringify({
        cleanedCode: t,
        type: a
      });
      if (s in this.pluralRulesCache)
        return this.pluralRulesCache[s];
      let r;
      try {
        r = new Intl.PluralRules(t, {
          type: a
        });
      } catch (o) {
        if (!n.match(/-|_/)) return;
        const d = this.languageUtils.getLanguagePartFromCode(n);
        r = this.getRule(d, i);
      }
      return this.pluralRulesCache[s] = r, r;
    }
    return this.rules[n] || this.rules[this.languageUtils.getLanguagePartFromCode(n)];
  }
  needsPlural(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const t = this.getRule(n, i);
    return this.shouldUseIntlApi() ? t && t.resolvedOptions().pluralCategories.length > 1 : t && t.numbers.length > 1;
  }
  getPluralFormsOfKey(n, i) {
    let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(n, t).map((a) => `${i}${a}`);
  }
  getSuffixes(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const t = this.getRule(n, i);
    return t ? this.shouldUseIntlApi() ? t.resolvedOptions().pluralCategories.sort((a, s) => AS[a] - AS[s]).map((a) => `${this.options.prepend}${i.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : t.numbers.map((a) => this.getSuffix(n, a, i)) : [];
  }
  getSuffix(n, i) {
    let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(n, t);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(i)}` : this.getSuffixRetroCompatible(a, i) : (this.logger.warn(`no plural rule found for: ${n}`), "");
  }
  getSuffixRetroCompatible(n, i) {
    const t = n.noAbs ? n.plurals(i) : n.plurals(Math.abs(i));
    let a = n.numbers[t];
    this.options.simplifyPluralSuffix && n.numbers.length === 2 && n.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const s = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : s() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && n.numbers.length === 2 && n.numbers[0] === 1 ? s() : this.options.prepend && t.toString() ? this.options.prepend + t.toString() : t.toString();
  }
  shouldUseIntlApi() {
    return !cG.includes(this.options.compatibilityJSON);
  }
}
const OS = function(e, n, i) {
  let t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, s = eG(e, n, i);
  return !s && a && en(i) && (s = Ek(e, i, t), s === void 0 && (s = Ek(n, i, t))), s;
}, n3 = (e) => e.replace(/\$/g, "$$$$");
class fG {
  constructor() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ca.create("interpolator"), this.options = n, this.format = n.interpolation && n.interpolation.format || ((i) => i), this.init(n);
  }
  init() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    n.interpolation || (n.interpolation = {
      escapeValue: !0
    });
    const {
      escape: i,
      escapeValue: t,
      useRawValueToEscape: a,
      prefix: s,
      prefixEscaped: r,
      suffix: o,
      suffixEscaped: d,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: k,
      nestingPrefix: m,
      nestingPrefixEscaped: f,
      nestingSuffix: p,
      nestingSuffixEscaped: h,
      nestingOptionsSeparator: N,
      maxReplaces: S,
      alwaysFormat: F
    } = n.interpolation;
    this.escape = i !== void 0 ? i : iG, this.escapeValue = t !== void 0 ? t : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = s ? F1(s) : r || "{{", this.suffix = o ? F1(o) : d || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : k || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = m ? F1(m) : f || F1("$t("), this.nestingSuffix = p ? F1(p) : h || F1(")"), this.nestingOptionsSeparator = N || ",", this.maxReplaces = S || 1e3, this.alwaysFormat = F !== void 0 ? F : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const n = (i, t) => i && i.source === t ? (i.lastIndex = 0, i) : new RegExp(t, "g");
    this.regexp = n(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = n(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = n(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(n, i, t, a) {
    let s, r, o;
    const d = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const S = OS(i, d, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(S, void 0, t, {
          ...a,
          ...i,
          interpolationkey: f
        }) : S;
      }
      const p = f.split(this.formatSeparator), h = p.shift().trim(), N = p.join(this.formatSeparator).trim();
      return this.format(OS(i, d, h, this.options.keySeparator, this.options.ignoreJSONStructure), N, t, {
        ...a,
        ...i,
        interpolationkey: h
      });
    };
    this.resetRegExp();
    const u = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, k = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => n3(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? n3(this.escape(f)) : n3(f)
    }].forEach((f) => {
      for (o = 0; s = f.regex.exec(n); ) {
        const p = s[1].trim();
        if (r = c(p), r === void 0)
          if (typeof u == "function") {
            const N = u(n, s, a);
            r = en(N) ? N : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, p))
            r = "";
          else if (k) {
            r = s[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${n}`), r = "";
        else !en(r) && !this.useRawValueToEscape && (r = xS(r));
        const h = f.safeValue(r);
        if (n = n.replace(s[0], h), k ? (f.regex.lastIndex += r.length, f.regex.lastIndex -= s[0].length) : f.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), n;
  }
  nest(n, i) {
    let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, s, r;
    const o = (d, c) => {
      const u = this.nestingOptionsSeparator;
      if (d.indexOf(u) < 0) return d;
      const k = d.split(new RegExp(`${u}[ ]*{`));
      let m = `{${k[1]}`;
      d = k[0], m = this.interpolate(m, r);
      const f = m.match(/'/g), p = m.match(/"/g);
      (f && f.length % 2 === 0 && !p || p.length % 2 !== 0) && (m = m.replace(/'/g, '"'));
      try {
        r = JSON.parse(m), c && (r = {
          ...c,
          ...r
        });
      } catch (h) {
        return this.logger.warn(`failed parsing options string in nesting for key ${d}`, h), `${d}${u}${m}`;
      }
      return r.defaultValue && r.defaultValue.indexOf(this.prefix) > -1 && delete r.defaultValue, d;
    };
    for (; a = this.nestingRegexp.exec(n); ) {
      let d = [];
      r = {
        ...t
      }, r = r.replace && !en(r.replace) ? r.replace : r, r.applyPostProcessor = !1, delete r.defaultValue;
      let c = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const u = a[1].split(this.formatSeparator).map((k) => k.trim());
        a[1] = u.shift(), d = u, c = !0;
      }
      if (s = i(o.call(this, a[1].trim(), r), r), s && a[0] === n && !en(s)) return s;
      en(s) || (s = xS(s)), s || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${n}`), s = ""), c && (s = d.reduce((u, k) => this.format(u, k, t.lng, {
        ...t,
        interpolationkey: a[1].trim()
      }), s.trim())), n = n.replace(a[0], s), this.regexp.lastIndex = 0;
    }
    return n;
  }
}
const vG = (e) => {
  let n = e.toLowerCase().trim();
  const i = {};
  if (e.indexOf("(") > -1) {
    const t = e.split("(");
    n = t[0].toLowerCase().trim();
    const a = t[1].substring(0, t[1].length - 1);
    n === "currency" && a.indexOf(":") < 0 ? i.currency || (i.currency = a.trim()) : n === "relativetime" && a.indexOf(":") < 0 ? i.range || (i.range = a.trim()) : a.split(";").forEach((r) => {
      if (r) {
        const [o, ...d] = r.split(":"), c = d.join(":").trim().replace(/^'+|'+$/g, ""), u = o.trim();
        i[u] || (i[u] = c), c === "false" && (i[u] = !1), c === "true" && (i[u] = !0), isNaN(c) || (i[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: n,
    formatOptions: i
  };
}, I1 = (e) => {
  const n = {};
  return (i, t, a) => {
    let s = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (s = {
      ...s,
      [a.interpolationkey]: void 0
    });
    const r = t + JSON.stringify(s);
    let o = n[r];
    return o || (o = e(Ou(t), a), n[r] = o), o(i);
  };
};
class hG {
  constructor() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ca.create("formatter"), this.options = n, this.formats = {
      number: I1((i, t) => {
        const a = new Intl.NumberFormat(i, {
          ...t
        });
        return (s) => a.format(s);
      }),
      currency: I1((i, t) => {
        const a = new Intl.NumberFormat(i, {
          ...t,
          style: "currency"
        });
        return (s) => a.format(s);
      }),
      datetime: I1((i, t) => {
        const a = new Intl.DateTimeFormat(i, {
          ...t
        });
        return (s) => a.format(s);
      }),
      relativetime: I1((i, t) => {
        const a = new Intl.RelativeTimeFormat(i, {
          ...t
        });
        return (s) => a.format(s, t.range || "day");
      }),
      list: I1((i, t) => {
        const a = new Intl.ListFormat(i, {
          ...t
        });
        return (s) => a.format(s);
      })
    }, this.init(n);
  }
  init(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = i.interpolation.formatSeparator || ",";
  }
  add(n, i) {
    this.formats[n.toLowerCase().trim()] = i;
  }
  addCached(n, i) {
    this.formats[n.toLowerCase().trim()] = I1(i);
  }
  format(n, i, t) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const s = i.split(this.formatSeparator);
    if (s.length > 1 && s[0].indexOf("(") > 1 && s[0].indexOf(")") < 0 && s.find((o) => o.indexOf(")") > -1)) {
      const o = s.findIndex((d) => d.indexOf(")") > -1);
      s[0] = [s[0], ...s.splice(1, o)].join(this.formatSeparator);
    }
    return s.reduce((o, d) => {
      const {
        formatName: c,
        formatOptions: u
      } = vG(d);
      if (this.formats[c]) {
        let k = o;
        try {
          const m = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, f = m.locale || m.lng || a.locale || a.lng || t;
          k = this.formats[c](o, f, {
            ...u,
            ...a,
            ...m
          });
        } catch (m) {
          this.logger.warn(m);
        }
        return k;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return o;
    }, n);
  }
}
const pG = (e, n) => {
  e.pending[n] !== void 0 && (delete e.pending[n], e.pendingCount--);
};
class NG extends Zm {
  constructor(n, i, t) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = n, this.store = i, this.services = t, this.languageUtils = t.languageUtils, this.options = a, this.logger = Ca.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(t, a.backend, a);
  }
  queueLoad(n, i, t, a) {
    const s = {}, r = {}, o = {}, d = {};
    return n.forEach((c) => {
      let u = !0;
      i.forEach((k) => {
        const m = `${c}|${k}`;
        !t.reload && this.store.hasResourceBundle(c, k) ? this.state[m] = 2 : this.state[m] < 0 || (this.state[m] === 1 ? r[m] === void 0 && (r[m] = !0) : (this.state[m] = 1, u = !1, r[m] === void 0 && (r[m] = !0), s[m] === void 0 && (s[m] = !0), d[k] === void 0 && (d[k] = !0)));
      }), u || (o[c] = !0);
    }), (Object.keys(s).length || Object.keys(r).length) && this.queue.push({
      pending: r,
      pendingCount: Object.keys(r).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(s),
      pending: Object.keys(r),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(d)
    };
  }
  loaded(n, i, t) {
    const a = n.split("|"), s = a[0], r = a[1];
    i && this.emit("failedLoading", s, r, i), !i && t && this.store.addResourceBundle(s, r, t, void 0, void 0, {
      skipCopy: !0
    }), this.state[n] = i ? -1 : 2, i && t && (this.state[n] = 0);
    const o = {};
    this.queue.forEach((d) => {
      Zq(d.loaded, [s], r), pG(d, n), i && d.errors.push(i), d.pendingCount === 0 && !d.done && (Object.keys(d.loaded).forEach((c) => {
        o[c] || (o[c] = {});
        const u = d.loaded[c];
        u.length && u.forEach((k) => {
          o[c][k] === void 0 && (o[c][k] = !0);
        });
      }), d.done = !0, d.errors.length ? d.callback(d.errors) : d.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((d) => !d.done);
  }
  read(n, i, t) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, r = arguments.length > 5 ? arguments[5] : void 0;
    if (!n.length) return r(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: n,
        ns: i,
        fcName: t,
        tried: a,
        wait: s,
        callback: r
      });
      return;
    }
    this.readingCalls++;
    const o = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const k = this.waitingReads.shift();
        this.read(k.lng, k.ns, k.fcName, k.tried, k.wait, k.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, n, i, t, a + 1, s * 2, r);
        }, s);
        return;
      }
      r(c, u);
    }, d = this.backend[t].bind(this.backend);
    if (d.length === 2) {
      try {
        const c = d(n, i);
        c && typeof c.then == "function" ? c.then((u) => o(null, u)).catch(o) : o(null, c);
      } catch (c) {
        o(c);
      }
      return;
    }
    return d(n, i, o);
  }
  prepareLoading(n, i) {
    let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    en(n) && (n = this.languageUtils.toResolveHierarchy(n)), en(i) && (i = [i]);
    const s = this.queueLoad(n, i, t, a);
    if (!s.toLoad.length)
      return s.pending.length || a(), null;
    s.toLoad.forEach((r) => {
      this.loadOne(r);
    });
  }
  load(n, i, t) {
    this.prepareLoading(n, i, {}, t);
  }
  reload(n, i, t) {
    this.prepareLoading(n, i, {
      reload: !0
    }, t);
  }
  loadOne(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const t = n.split("|"), a = t[0], s = t[1];
    this.read(a, s, "read", void 0, void 0, (r, o) => {
      r && this.logger.warn(`${i}loading namespace ${s} for language ${a} failed`, r), !r && o && this.logger.log(`${i}loaded namespace ${s} for language ${a}`, o), this.loaded(n, r, o);
    });
  }
  saveMissing(n, i, t, a, s) {
    let r = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(i)) {
      this.logger.warn(`did not save key "${t}" as the namespace "${i}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(t == null || t === "")) {
      if (this.backend && this.backend.create) {
        const d = {
          ...r,
          isUpdate: s
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(n, i, t, a, d) : u = c(n, i, t, a), u && typeof u.then == "function" ? u.then((k) => o(null, k)).catch(o) : o(null, u);
          } catch (u) {
            o(u);
          }
        else
          c(n, i, t, a, o, d);
      }
      !n || !n[0] || this.store.addResource(n[0], i, t, a);
    }
  }
}
const ES = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let n = {};
    if (typeof e[1] == "object" && (n = e[1]), en(e[1]) && (n.defaultValue = e[1]), en(e[2]) && (n.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const i = e[3] || e[2];
      Object.keys(i).forEach((t) => {
        n[t] = i[t];
      });
    }
    return n;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), JS = (e) => (en(e.ns) && (e.ns = [e.ns]), en(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), en(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), Ic = () => {
}, SG = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((i) => {
    typeof e[i] == "function" && (e[i] = e[i].bind(e));
  });
};
class Ko extends Zm {
  constructor() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = JS(n), this.services = {}, this.logger = Ca, this.modules = {
      external: []
    }, SG(this), i && !this.isInitialized && !n.isClone) {
      if (!this.options.initImmediate)
        return this.init(n, i), this;
      setTimeout(() => {
        this.init(n, i);
      }, 0);
    }
  }
  init() {
    var n = this;
    let i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof i == "function" && (t = i, i = {}), !i.defaultNS && i.defaultNS !== !1 && i.ns && (en(i.ns) ? i.defaultNS = i.ns : i.ns.indexOf("translation") < 0 && (i.defaultNS = i.ns[0]));
    const a = ES();
    this.options = {
      ...a,
      ...this.options,
      ...JS(i)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), i.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = i.keySeparator), i.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = i.nsSeparator);
    const s = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? Ca.init(s(this.modules.logger), this.options) : Ca.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl != "undefined" && (u = hG);
      const k = new jS(this.options);
      this.store = new RS(this.options.resources, this.options);
      const m = this.services;
      m.logger = Ca, m.resourceStore = this.store, m.languageUtils = k, m.pluralResolver = new kG(k, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (m.formatter = s(u), m.formatter.init(m, this.options), this.options.interpolation.format = m.formatter.format.bind(m.formatter)), m.interpolator = new fG(this.options), m.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, m.backendConnector = new NG(s(this.modules.backend), m.resourceStore, m, this.options), m.backendConnector.on("*", function(f) {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), N = 1; N < p; N++)
          h[N - 1] = arguments[N];
        n.emit(f, ...h);
      }), this.modules.languageDetector && (m.languageDetector = s(this.modules.languageDetector), m.languageDetector.init && m.languageDetector.init(m, this.options.detection, this.options)), this.modules.i18nFormat && (m.i18nFormat = s(this.modules.i18nFormat), m.i18nFormat.init && m.i18nFormat.init(this)), this.translator = new Ju(this.services, this.options), this.translator.on("*", function(f) {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), N = 1; N < p; N++)
          h[N - 1] = arguments[N];
        n.emit(f, ...h);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, t || (t = Ic), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return n.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return n.store[u](...arguments), n;
      };
    });
    const d = so(), c = () => {
      const u = (k, m) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), d.resolve(m), t(k, m);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), d;
  }
  loadResources(n) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ic;
    const a = en(n) ? n : this.language;
    if (typeof n == "function" && (t = n), !this.options.resources || this.options.partialBundledLanguages) {
      if (a && a.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return t();
      const s = [], r = (o) => {
        if (!o || o === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((c) => {
          c !== "cimode" && s.indexOf(c) < 0 && s.push(c);
        });
      };
      a ? r(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((d) => r(d)), this.options.preload && this.options.preload.forEach((o) => r(o)), this.services.backendConnector.load(s, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), t(o);
      });
    } else
      t(null);
  }
  reloadResources(n, i, t) {
    const a = so();
    return typeof n == "function" && (t = n, n = void 0), typeof i == "function" && (t = i, i = void 0), n || (n = this.languages), i || (i = this.options.ns), t || (t = Ic), this.services.backendConnector.reload(n, i, (s) => {
      a.resolve(), t(s);
    }), a;
  }
  use(n) {
    if (!n) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!n.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return n.type === "backend" && (this.modules.backend = n), (n.type === "logger" || n.log && n.warn && n.error) && (this.modules.logger = n), n.type === "languageDetector" && (this.modules.languageDetector = n), n.type === "i18nFormat" && (this.modules.i18nFormat = n), n.type === "postProcessor" && Mx.addPostProcessor(n), n.type === "formatter" && (this.modules.formatter = n), n.type === "3rdParty" && this.modules.external.push(n), this;
  }
  setResolvedLanguage(n) {
    if (!(!n || !this.languages) && !(["cimode", "dev"].indexOf(n) > -1))
      for (let i = 0; i < this.languages.length; i++) {
        const t = this.languages[i];
        if (!(["cimode", "dev"].indexOf(t) > -1) && this.store.hasLanguageSomeTranslations(t)) {
          this.resolvedLanguage = t;
          break;
        }
      }
  }
  changeLanguage(n, i) {
    var t = this;
    this.isLanguageChangingTo = n;
    const a = so();
    this.emit("languageChanging", n);
    const s = (d) => {
      this.language = d, this.languages = this.services.languageUtils.toResolveHierarchy(d), this.resolvedLanguage = void 0, this.setResolvedLanguage(d);
    }, r = (d, c) => {
      c ? (s(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return t.t(...arguments);
      }), i && i(d, function() {
        return t.t(...arguments);
      });
    }, o = (d) => {
      !n && !d && this.services.languageDetector && (d = []);
      const c = en(d) ? d : this.services.languageUtils.getBestMatchFromCodes(d);
      c && (this.language || s(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        r(u, c);
      });
    };
    return !n && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !n && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(n), a;
  }
  getFixedT(n, i, t) {
    var a = this;
    const s = function(r, o) {
      let d;
      if (typeof o != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), k = 2; k < c; k++)
          u[k - 2] = arguments[k];
        d = a.options.overloadTranslationOptionHandler([r, o].concat(u));
      } else
        d = {
          ...o
        };
      d.lng = d.lng || s.lng, d.lngs = d.lngs || s.lngs, d.ns = d.ns || s.ns, d.keyPrefix !== "" && (d.keyPrefix = d.keyPrefix || t || s.keyPrefix);
      const m = a.options.keySeparator || ".";
      let f;
      return d.keyPrefix && Array.isArray(r) ? f = r.map((p) => `${d.keyPrefix}${m}${p}`) : f = d.keyPrefix ? `${d.keyPrefix}${m}${r}` : r, a.t(f, d);
    };
    return en(n) ? s.lng = n : s.lngs = n, s.ns = i, s.keyPrefix = t, s;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(n) {
    this.options.defaultNS = n;
  }
  hasLoadedNamespace(n) {
    let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const t = i.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, s = this.languages[this.languages.length - 1];
    if (t.toLowerCase() === "cimode") return !0;
    const r = (o, d) => {
      const c = this.services.backendConnector.state[`${o}|${d}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (i.precheck) {
      const o = i.precheck(this, r);
      if (o !== void 0) return o;
    }
    return !!(this.hasResourceBundle(t, n) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || r(t, n) && (!a || r(s, n)));
  }
  loadNamespaces(n, i) {
    const t = so();
    return this.options.ns ? (en(n) && (n = [n]), n.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      t.resolve(), i && i(a);
    }), t) : (i && i(), Promise.resolve());
  }
  loadLanguages(n, i) {
    const t = so();
    en(n) && (n = [n]);
    const a = this.options.preload || [], s = n.filter((r) => a.indexOf(r) < 0 && this.services.languageUtils.isSupportedCode(r));
    return s.length ? (this.options.preload = a.concat(s), this.loadResources((r) => {
      t.resolve(), i && i(r);
    }), t) : (i && i(), Promise.resolve());
  }
  dir(n) {
    if (n || (n = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !n) return "rtl";
    const i = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], t = this.services && this.services.languageUtils || new jS(ES());
    return i.indexOf(t.getLanguagePartFromCode(n)) > -1 || n.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
    return new Ko(n, i);
  }
  cloneInstance() {
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ic;
    const t = n.forkResourceStore;
    t && delete n.forkResourceStore;
    const a = {
      ...this.options,
      ...n,
      isClone: !0
    }, s = new Ko(a);
    return (n.debug !== void 0 || n.prefix !== void 0) && (s.logger = s.logger.clone(n)), ["store", "services", "language"].forEach((o) => {
      s[o] = this[o];
    }), s.services = {
      ...this.services
    }, s.services.utils = {
      hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
    }, t && (s.store = new RS(this.store.data, a), s.services.resourceStore = s.store), s.translator = new Ju(s.services, a), s.translator.on("*", function(o) {
      for (var d = arguments.length, c = new Array(d > 1 ? d - 1 : 0), u = 1; u < d; u++)
        c[u - 1] = arguments[u];
      s.emit(o, ...c);
    }), s.init(a, i), s.translator.options = a, s.translator.backendConnector.services.utils = {
      hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
    }, s;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Gi = Ko.createInstance();
Gi.createInstance = Ko.createInstance;
Gi.createInstance;
Gi.dir;
Gi.init;
Gi.loadResources;
Gi.reloadResources;
Gi.use;
Gi.changeLanguage;
Gi.getFixedT;
Gi.t;
Gi.exists;
Gi.setDefaultNamespace;
Gi.hasLoadedNamespace;
Gi.loadNamespaces;
Gi.loadLanguages;
var An;
(function(e) {
  e.assertEqual = (a) => {
  };
  function n(a) {
  }
  e.assertIs = n;
  function i(a) {
    throw new Error();
  }
  e.assertNever = i, e.arrayToEnum = (a) => {
    const s = {};
    for (const r of a)
      s[r] = r;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), r = {};
    for (const o of s)
      r[o] = a[o];
    return e.objectValues(r);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const r in a)
      Object.prototype.hasOwnProperty.call(a, r) && s.push(r);
    return s;
  }, e.find = (a, s) => {
    for (const r of a)
      if (s(r))
        return r;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function t(a, s = " | ") {
    return a.map((r) => typeof r == "string" ? `'${r}'` : r).join(s);
  }
  e.joinValues = t, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(An || (An = {}));
var _S;
(function(e) {
  e.mergeShapes = (n, i) => ({
    ...n,
    ...i
    // second overwrites first
  });
})(_S || (_S = {}));
const Ee = An.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Ol = (e) => {
  switch (typeof e) {
    case "undefined":
      return Ee.undefined;
    case "string":
      return Ee.string;
    case "number":
      return Number.isNaN(e) ? Ee.nan : Ee.number;
    case "boolean":
      return Ee.boolean;
    case "function":
      return Ee.function;
    case "bigint":
      return Ee.bigint;
    case "symbol":
      return Ee.symbol;
    case "object":
      return Array.isArray(e) ? Ee.array : e === null ? Ee.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Ee.promise : typeof Map != "undefined" && e instanceof Map ? Ee.map : typeof Set != "undefined" && e instanceof Set ? Ee.set : typeof Date != "undefined" && e instanceof Date ? Ee.date : Ee.object;
    default:
      return Ee.unknown;
  }
}, me = An.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class ol extends Error {
  get errors() {
    return this.issues;
  }
  constructor(n) {
    super(), this.issues = [], this.addIssue = (t) => {
      this.issues = [...this.issues, t];
    }, this.addIssues = (t = []) => {
      this.issues = [...this.issues, ...t];
    };
    const i = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, i) : this.__proto__ = i, this.name = "ZodError", this.issues = n;
  }
  format(n) {
    const i = n || function(s) {
      return s.message;
    }, t = { _errors: [] }, a = (s) => {
      for (const r of s.issues)
        if (r.code === "invalid_union")
          r.unionErrors.map(a);
        else if (r.code === "invalid_return_type")
          a(r.returnTypeError);
        else if (r.code === "invalid_arguments")
          a(r.argumentsError);
        else if (r.path.length === 0)
          t._errors.push(i(r));
        else {
          let o = t, d = 0;
          for (; d < r.path.length; ) {
            const c = r.path[d];
            d === r.path.length - 1 ? (o[c] = o[c] || { _errors: [] }, o[c]._errors.push(i(r))) : o[c] = o[c] || { _errors: [] }, o = o[c], d++;
          }
        }
    };
    return a(this), t;
  }
  static assert(n) {
    if (!(n instanceof ol))
      throw new Error(`Not a ZodError: ${n}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, An.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(n = (i) => i.message) {
    const i = {}, t = [];
    for (const a of this.issues)
      if (a.path.length > 0) {
        const s = a.path[0];
        i[s] = i[s] || [], i[s].push(n(a));
      } else
        t.push(n(a));
    return { formErrors: t, fieldErrors: i };
  }
  get formErrors() {
    return this.flatten();
  }
}
ol.create = (e) => new ol(e);
const _u = (e, n) => {
  let i;
  switch (e.code) {
    case me.invalid_type:
      e.received === Ee.undefined ? i = "Required" : i = `Expected ${e.expected}, received ${e.received}`;
      break;
    case me.invalid_literal:
      i = `Invalid literal value, expected ${JSON.stringify(e.expected, An.jsonStringifyReplacer)}`;
      break;
    case me.unrecognized_keys:
      i = `Unrecognized key(s) in object: ${An.joinValues(e.keys, ", ")}`;
      break;
    case me.invalid_union:
      i = "Invalid input";
      break;
    case me.invalid_union_discriminator:
      i = `Invalid discriminator value. Expected ${An.joinValues(e.options)}`;
      break;
    case me.invalid_enum_value:
      i = `Invalid enum value. Expected ${An.joinValues(e.options)}, received '${e.received}'`;
      break;
    case me.invalid_arguments:
      i = "Invalid function arguments";
      break;
    case me.invalid_return_type:
      i = "Invalid function return type";
      break;
    case me.invalid_date:
      i = "Invalid date";
      break;
    case me.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (i = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (i = `${i} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? i = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? i = `Invalid input: must end with "${e.validation.endsWith}"` : An.assertNever(e.validation) : e.validation !== "regex" ? i = `Invalid ${e.validation}` : i = "Invalid";
      break;
    case me.too_small:
      e.type === "array" ? i = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? i = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? i = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "bigint" ? i = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? i = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : i = "Invalid input";
      break;
    case me.too_big:
      e.type === "array" ? i = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? i = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? i = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? i = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? i = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : i = "Invalid input";
      break;
    case me.custom:
      i = "Invalid input";
      break;
    case me.invalid_intersection_types:
      i = "Intersection results could not be merged";
      break;
    case me.not_multiple_of:
      i = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case me.not_finite:
      i = "Number must be finite";
      break;
    default:
      i = n.defaultError, An.assertNever(e);
  }
  return { message: i };
};
let Lx = _u;
function gG(e) {
  Lx = e;
}
function FG() {
  return Lx;
}
const IG = (e) => {
  const { data: n, path: i, errorMaps: t, issueData: a } = e, s = [...i, ...a.path || []], r = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const d = t.filter((c) => !!c).slice().reverse();
  for (const c of d)
    o = c(r, { data: n, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
};
function Re(e, n) {
  const i = FG(), t = IG({
    issueData: n,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      i,
      // then global override map
      i === _u ? void 0 : _u
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(t);
}
class At {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(n, i) {
    const t = [];
    for (const a of i) {
      if (a.status === "aborted")
        return tn;
      a.status === "dirty" && n.dirty(), t.push(a.value);
    }
    return { status: n.value, value: t };
  }
  static async mergeObjectAsync(n, i) {
    const t = [];
    for (const a of i) {
      const s = await a.key, r = await a.value;
      t.push({
        key: s,
        value: r
      });
    }
    return At.mergeObjectSync(n, t);
  }
  static mergeObjectSync(n, i) {
    const t = {};
    for (const a of i) {
      const { key: s, value: r } = a;
      if (s.status === "aborted" || r.status === "aborted")
        return tn;
      s.status === "dirty" && n.dirty(), r.status === "dirty" && n.dirty(), s.value !== "__proto__" && (typeof r.value != "undefined" || a.alwaysSet) && (t[s.value] = r.value);
    }
    return { status: n.value, value: t };
  }
}
const tn = Object.freeze({
  status: "aborted"
}), po = (e) => ({ status: "dirty", value: e }), zt = (e) => ({ status: "valid", value: e }), QS = (e) => e.status === "aborted", MS = (e) => e.status === "dirty", tr = (e) => e.status === "valid", Qu = (e) => typeof Promise != "undefined" && e instanceof Promise;
var Qe;
(function(e) {
  e.errToObj = (n) => typeof n == "string" ? { message: n } : n || {}, e.toString = (n) => typeof n == "string" ? n : n == null ? void 0 : n.message;
})(Qe || (Qe = {}));
class Xl {
  constructor(n, i, t, a) {
    this._cachedPath = [], this.parent = n, this.data = i, this._path = t, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const LS = (e, n) => {
  if (tr(n))
    return { success: !0, data: n.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const i = new ol(e.common.issues);
      return this._error = i, this._error;
    }
  };
};
function Nn(e) {
  if (!e)
    return {};
  const { errorMap: n, invalid_type_error: i, required_error: t, description: a } = e;
  if (n && (i || t))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return n ? { errorMap: n, description: a } : { errorMap: (r, o) => {
    var c, u;
    const { message: d } = e;
    return r.code === "invalid_enum_value" ? { message: d != null ? d : o.defaultError } : typeof o.data == "undefined" ? { message: (c = d != null ? d : t) != null ? c : o.defaultError } : r.code !== "invalid_type" ? { message: o.defaultError } : { message: (u = d != null ? d : i) != null ? u : o.defaultError };
  }, description: a };
}
class Tn {
  get description() {
    return this._def.description;
  }
  _getType(n) {
    return Ol(n.data);
  }
  _getOrReturnCtx(n, i) {
    return i || {
      common: n.parent.common,
      data: n.data,
      parsedType: Ol(n.data),
      schemaErrorMap: this._def.errorMap,
      path: n.path,
      parent: n.parent
    };
  }
  _processInputParams(n) {
    return {
      status: new At(),
      ctx: {
        common: n.parent.common,
        data: n.data,
        parsedType: Ol(n.data),
        schemaErrorMap: this._def.errorMap,
        path: n.path,
        parent: n.parent
      }
    };
  }
  _parseSync(n) {
    const i = this._parse(n);
    if (Qu(i))
      throw new Error("Synchronous parse encountered promise.");
    return i;
  }
  _parseAsync(n) {
    const i = this._parse(n);
    return Promise.resolve(i);
  }
  parse(n, i) {
    const t = this.safeParse(n, i);
    if (t.success)
      return t.data;
    throw t.error;
  }
  safeParse(n, i) {
    var s;
    const t = {
      common: {
        issues: [],
        async: (s = i == null ? void 0 : i.async) != null ? s : !1,
        contextualErrorMap: i == null ? void 0 : i.errorMap
      },
      path: (i == null ? void 0 : i.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: n,
      parsedType: Ol(n)
    }, a = this._parseSync({ data: n, path: t.path, parent: t });
    return LS(t, a);
  }
  "~validate"(n) {
    var t, a;
    const i = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: n,
      parsedType: Ol(n)
    };
    if (!this["~standard"].async)
      try {
        const s = this._parseSync({ data: n, path: [], parent: i });
        return tr(s) ? {
          value: s.value
        } : {
          issues: i.common.issues
        };
      } catch (s) {
        (a = (t = s == null ? void 0 : s.message) == null ? void 0 : t.toLowerCase()) != null && a.includes("encountered") && (this["~standard"].async = !0), i.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: n, path: [], parent: i }).then((s) => tr(s) ? {
      value: s.value
    } : {
      issues: i.common.issues
    });
  }
  async parseAsync(n, i) {
    const t = await this.safeParseAsync(n, i);
    if (t.success)
      return t.data;
    throw t.error;
  }
  async safeParseAsync(n, i) {
    const t = {
      common: {
        issues: [],
        contextualErrorMap: i == null ? void 0 : i.errorMap,
        async: !0
      },
      path: (i == null ? void 0 : i.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: n,
      parsedType: Ol(n)
    }, a = this._parse({ data: n, path: t.path, parent: t }), s = await (Qu(a) ? a : Promise.resolve(a));
    return LS(t, s);
  }
  refine(n, i) {
    const t = (a) => typeof i == "string" || typeof i == "undefined" ? { message: i } : typeof i == "function" ? i(a) : i;
    return this._refinement((a, s) => {
      const r = n(a), o = () => s.addIssue({
        code: me.custom,
        ...t(a)
      });
      return typeof Promise != "undefined" && r instanceof Promise ? r.then((d) => d ? !0 : (o(), !1)) : r ? !0 : (o(), !1);
    });
  }
  refinement(n, i) {
    return this._refinement((t, a) => n(t) ? !0 : (a.addIssue(typeof i == "function" ? i(t, a) : i), !1));
  }
  _refinement(n) {
    return new lr({
      schema: this,
      typeName: an.ZodEffects,
      effect: { type: "refinement", refinement: n }
    });
  }
  superRefine(n) {
    return this._refinement(n);
  }
  constructor(n) {
    this.spa = this.safeParseAsync, this._def = n, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (i) => this["~validate"](i)
    };
  }
  optional() {
    return Hl.create(this, this._def);
  }
  nullable() {
    return sr.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Ta.create(this);
  }
  promise() {
    return Uu.create(this, this._def);
  }
  or(n) {
    return Lu.create([this, n], this._def);
  }
  and(n) {
    return $u.create(this, n, this._def);
  }
  transform(n) {
    return new lr({
      ...Nn(this._def),
      schema: this,
      typeName: an.ZodEffects,
      effect: { type: "transform", transform: n }
    });
  }
  default(n) {
    const i = typeof n == "function" ? n : () => n;
    return new _k({
      ...Nn(this._def),
      innerType: this,
      defaultValue: i,
      typeName: an.ZodDefault
    });
  }
  brand() {
    return new zG({
      typeName: an.ZodBranded,
      type: this,
      ...Nn(this._def)
    });
  }
  catch(n) {
    const i = typeof n == "function" ? n : () => n;
    return new Qk({
      ...Nn(this._def),
      innerType: this,
      catchValue: i,
      typeName: an.ZodCatch
    });
  }
  describe(n) {
    const i = this.constructor;
    return new i({
      ...this._def,
      description: n
    });
  }
  pipe(n) {
    return Sh.create(this, n);
  }
  readonly() {
    return Mk.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const yG = /^c[^\s-]{8,}$/i, bG = /^[0-9a-z]+$/, CG = /^[0-9A-HJKMNP-TV-Z]{26}$/i, xG = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, DG = /^[a-z0-9_-]{21}$/i, wG = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, PG = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, RG = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, TG = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let i3;
const jG = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, AG = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, OG = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, EG = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, JG = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, _G = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, $x = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", QG = new RegExp(`^${$x}$`);
function Ux(e) {
  let n = "[0-5]\\d";
  e.precision ? n = `${n}\\.\\d{${e.precision}}` : e.precision == null && (n = `${n}(\\.\\d+)?`);
  const i = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${n})${i}`;
}
function MG(e) {
  return new RegExp(`^${Ux(e)}$`);
}
function LG(e) {
  let n = `${$x}T${Ux(e)}`;
  const i = [];
  return i.push(e.local ? "Z?" : "Z"), e.offset && i.push("([+-]\\d{2}:?\\d{2})"), n = `${n}(${i.join("|")})`, new RegExp(`^${n}$`);
}
function $G(e, n) {
  return !!((n === "v4" || !n) && jG.test(e) || (n === "v6" || !n) && OG.test(e));
}
function UG(e, n) {
  if (!wG.test(e))
    return !1;
  try {
    const [i] = e.split(".");
    if (!i)
      return !1;
    const t = i.replace(/-/g, "+").replace(/_/g, "/").padEnd(i.length + (4 - i.length % 4) % 4, "="), a = JSON.parse(atob(t));
    return !(typeof a != "object" || a === null || "typ" in a && (a == null ? void 0 : a.typ) !== "JWT" || !a.alg || n && a.alg !== n);
  } catch (i) {
    return !1;
  }
}
function VG(e, n) {
  return !!((n === "v4" || !n) && AG.test(e) || (n === "v6" || !n) && EG.test(e));
}
class Ll extends Tn {
  _parse(n) {
    if (this._def.coerce && (n.data = String(n.data)), this._getType(n) !== Ee.string) {
      const s = this._getOrReturnCtx(n);
      return Re(s, {
        code: me.invalid_type,
        expected: Ee.string,
        received: s.parsedType
      }), tn;
    }
    const t = new At();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        n.data.length < s.value && (a = this._getOrReturnCtx(n, a), Re(a, {
          code: me.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), t.dirty());
      else if (s.kind === "max")
        n.data.length > s.value && (a = this._getOrReturnCtx(n, a), Re(a, {
          code: me.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), t.dirty());
      else if (s.kind === "length") {
        const r = n.data.length > s.value, o = n.data.length < s.value;
        (r || o) && (a = this._getOrReturnCtx(n, a), r ? Re(a, {
          code: me.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && Re(a, {
          code: me.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), t.dirty());
      } else if (s.kind === "email")
        RG.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
          validation: "email",
          code: me.invalid_string,
          message: s.message
        }), t.dirty());
      else if (s.kind === "emoji")
        i3 || (i3 = new RegExp(TG, "u")), i3.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
          validation: "emoji",
          code: me.invalid_string,
          message: s.message
        }), t.dirty());
      else if (s.kind === "uuid")
        xG.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
          validation: "uuid",
          code: me.invalid_string,
          message: s.message
        }), t.dirty());
      else if (s.kind === "nanoid")
        DG.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
          validation: "nanoid",
          code: me.invalid_string,
          message: s.message
        }), t.dirty());
      else if (s.kind === "cuid")
        yG.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
          validation: "cuid",
          code: me.invalid_string,
          message: s.message
        }), t.dirty());
      else if (s.kind === "cuid2")
        bG.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
          validation: "cuid2",
          code: me.invalid_string,
          message: s.message
        }), t.dirty());
      else if (s.kind === "ulid")
        CG.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
          validation: "ulid",
          code: me.invalid_string,
          message: s.message
        }), t.dirty());
      else if (s.kind === "url")
        try {
          new URL(n.data);
        } catch (r) {
          a = this._getOrReturnCtx(n, a), Re(a, {
            validation: "url",
            code: me.invalid_string,
            message: s.message
          }), t.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
        validation: "regex",
        code: me.invalid_string,
        message: s.message
      }), t.dirty())) : s.kind === "trim" ? n.data = n.data.trim() : s.kind === "includes" ? n.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(n, a), Re(a, {
        code: me.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), t.dirty()) : s.kind === "toLowerCase" ? n.data = n.data.toLowerCase() : s.kind === "toUpperCase" ? n.data = n.data.toUpperCase() : s.kind === "startsWith" ? n.data.startsWith(s.value) || (a = this._getOrReturnCtx(n, a), Re(a, {
        code: me.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), t.dirty()) : s.kind === "endsWith" ? n.data.endsWith(s.value) || (a = this._getOrReturnCtx(n, a), Re(a, {
        code: me.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), t.dirty()) : s.kind === "datetime" ? LG(s).test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
        code: me.invalid_string,
        validation: "datetime",
        message: s.message
      }), t.dirty()) : s.kind === "date" ? QG.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
        code: me.invalid_string,
        validation: "date",
        message: s.message
      }), t.dirty()) : s.kind === "time" ? MG(s).test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
        code: me.invalid_string,
        validation: "time",
        message: s.message
      }), t.dirty()) : s.kind === "duration" ? PG.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
        validation: "duration",
        code: me.invalid_string,
        message: s.message
      }), t.dirty()) : s.kind === "ip" ? $G(n.data, s.version) || (a = this._getOrReturnCtx(n, a), Re(a, {
        validation: "ip",
        code: me.invalid_string,
        message: s.message
      }), t.dirty()) : s.kind === "jwt" ? UG(n.data, s.alg) || (a = this._getOrReturnCtx(n, a), Re(a, {
        validation: "jwt",
        code: me.invalid_string,
        message: s.message
      }), t.dirty()) : s.kind === "cidr" ? VG(n.data, s.version) || (a = this._getOrReturnCtx(n, a), Re(a, {
        validation: "cidr",
        code: me.invalid_string,
        message: s.message
      }), t.dirty()) : s.kind === "base64" ? JG.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
        validation: "base64",
        code: me.invalid_string,
        message: s.message
      }), t.dirty()) : s.kind === "base64url" ? _G.test(n.data) || (a = this._getOrReturnCtx(n, a), Re(a, {
        validation: "base64url",
        code: me.invalid_string,
        message: s.message
      }), t.dirty()) : An.assertNever(s);
    return { status: t.value, value: n.data };
  }
  _regex(n, i, t) {
    return this.refinement((a) => n.test(a), {
      validation: i,
      code: me.invalid_string,
      ...Qe.errToObj(t)
    });
  }
  _addCheck(n) {
    return new Ll({
      ...this._def,
      checks: [...this._def.checks, n]
    });
  }
  email(n) {
    return this._addCheck({ kind: "email", ...Qe.errToObj(n) });
  }
  url(n) {
    return this._addCheck({ kind: "url", ...Qe.errToObj(n) });
  }
  emoji(n) {
    return this._addCheck({ kind: "emoji", ...Qe.errToObj(n) });
  }
  uuid(n) {
    return this._addCheck({ kind: "uuid", ...Qe.errToObj(n) });
  }
  nanoid(n) {
    return this._addCheck({ kind: "nanoid", ...Qe.errToObj(n) });
  }
  cuid(n) {
    return this._addCheck({ kind: "cuid", ...Qe.errToObj(n) });
  }
  cuid2(n) {
    return this._addCheck({ kind: "cuid2", ...Qe.errToObj(n) });
  }
  ulid(n) {
    return this._addCheck({ kind: "ulid", ...Qe.errToObj(n) });
  }
  base64(n) {
    return this._addCheck({ kind: "base64", ...Qe.errToObj(n) });
  }
  base64url(n) {
    return this._addCheck({
      kind: "base64url",
      ...Qe.errToObj(n)
    });
  }
  jwt(n) {
    return this._addCheck({ kind: "jwt", ...Qe.errToObj(n) });
  }
  ip(n) {
    return this._addCheck({ kind: "ip", ...Qe.errToObj(n) });
  }
  cidr(n) {
    return this._addCheck({ kind: "cidr", ...Qe.errToObj(n) });
  }
  datetime(n) {
    var i, t;
    return typeof n == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: n
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (n == null ? void 0 : n.precision) == "undefined" ? null : n == null ? void 0 : n.precision,
      offset: (i = n == null ? void 0 : n.offset) != null ? i : !1,
      local: (t = n == null ? void 0 : n.local) != null ? t : !1,
      ...Qe.errToObj(n == null ? void 0 : n.message)
    });
  }
  date(n) {
    return this._addCheck({ kind: "date", message: n });
  }
  time(n) {
    return typeof n == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: n
    }) : this._addCheck({
      kind: "time",
      precision: typeof (n == null ? void 0 : n.precision) == "undefined" ? null : n == null ? void 0 : n.precision,
      ...Qe.errToObj(n == null ? void 0 : n.message)
    });
  }
  duration(n) {
    return this._addCheck({ kind: "duration", ...Qe.errToObj(n) });
  }
  regex(n, i) {
    return this._addCheck({
      kind: "regex",
      regex: n,
      ...Qe.errToObj(i)
    });
  }
  includes(n, i) {
    return this._addCheck({
      kind: "includes",
      value: n,
      position: i == null ? void 0 : i.position,
      ...Qe.errToObj(i == null ? void 0 : i.message)
    });
  }
  startsWith(n, i) {
    return this._addCheck({
      kind: "startsWith",
      value: n,
      ...Qe.errToObj(i)
    });
  }
  endsWith(n, i) {
    return this._addCheck({
      kind: "endsWith",
      value: n,
      ...Qe.errToObj(i)
    });
  }
  min(n, i) {
    return this._addCheck({
      kind: "min",
      value: n,
      ...Qe.errToObj(i)
    });
  }
  max(n, i) {
    return this._addCheck({
      kind: "max",
      value: n,
      ...Qe.errToObj(i)
    });
  }
  length(n, i) {
    return this._addCheck({
      kind: "length",
      value: n,
      ...Qe.errToObj(i)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(n) {
    return this.min(1, Qe.errToObj(n));
  }
  trim() {
    return new Ll({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Ll({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Ll({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((n) => n.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((n) => n.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((n) => n.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((n) => n.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((n) => n.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((n) => n.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((n) => n.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((n) => n.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((n) => n.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((n) => n.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((n) => n.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((n) => n.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((n) => n.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((n) => n.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((n) => n.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((n) => n.kind === "base64url");
  }
  get minLength() {
    let n = null;
    for (const i of this._def.checks)
      i.kind === "min" && (n === null || i.value > n) && (n = i.value);
    return n;
  }
  get maxLength() {
    let n = null;
    for (const i of this._def.checks)
      i.kind === "max" && (n === null || i.value < n) && (n = i.value);
    return n;
  }
}
Ll.create = (e) => {
  var n;
  return new Ll({
    checks: [],
    typeName: an.ZodString,
    coerce: (n = e == null ? void 0 : e.coerce) != null ? n : !1,
    ...Nn(e)
  });
};
function HG(e, n) {
  const i = (e.toString().split(".")[1] || "").length, t = (n.toString().split(".")[1] || "").length, a = i > t ? i : t, s = Number.parseInt(e.toFixed(a).replace(".", "")), r = Number.parseInt(n.toFixed(a).replace(".", ""));
  return s % r / 10 ** a;
}
class Yo extends Tn {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(n) {
    if (this._def.coerce && (n.data = Number(n.data)), this._getType(n) !== Ee.number) {
      const s = this._getOrReturnCtx(n);
      return Re(s, {
        code: me.invalid_type,
        expected: Ee.number,
        received: s.parsedType
      }), tn;
    }
    let t;
    const a = new At();
    for (const s of this._def.checks)
      s.kind === "int" ? An.isInteger(n.data) || (t = this._getOrReturnCtx(n, t), Re(t, {
        code: me.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? n.data < s.value : n.data <= s.value) && (t = this._getOrReturnCtx(n, t), Re(t, {
        code: me.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? n.data > s.value : n.data >= s.value) && (t = this._getOrReturnCtx(n, t), Re(t, {
        code: me.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? HG(n.data, s.value) !== 0 && (t = this._getOrReturnCtx(n, t), Re(t, {
        code: me.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(n.data) || (t = this._getOrReturnCtx(n, t), Re(t, {
        code: me.not_finite,
        message: s.message
      }), a.dirty()) : An.assertNever(s);
    return { status: a.value, value: n.data };
  }
  gte(n, i) {
    return this.setLimit("min", n, !0, Qe.toString(i));
  }
  gt(n, i) {
    return this.setLimit("min", n, !1, Qe.toString(i));
  }
  lte(n, i) {
    return this.setLimit("max", n, !0, Qe.toString(i));
  }
  lt(n, i) {
    return this.setLimit("max", n, !1, Qe.toString(i));
  }
  setLimit(n, i, t, a) {
    return new Yo({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: n,
          value: i,
          inclusive: t,
          message: Qe.toString(a)
        }
      ]
    });
  }
  _addCheck(n) {
    return new Yo({
      ...this._def,
      checks: [...this._def.checks, n]
    });
  }
  int(n) {
    return this._addCheck({
      kind: "int",
      message: Qe.toString(n)
    });
  }
  positive(n) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Qe.toString(n)
    });
  }
  negative(n) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Qe.toString(n)
    });
  }
  nonpositive(n) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Qe.toString(n)
    });
  }
  nonnegative(n) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Qe.toString(n)
    });
  }
  multipleOf(n, i) {
    return this._addCheck({
      kind: "multipleOf",
      value: n,
      message: Qe.toString(i)
    });
  }
  finite(n) {
    return this._addCheck({
      kind: "finite",
      message: Qe.toString(n)
    });
  }
  safe(n) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Qe.toString(n)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Qe.toString(n)
    });
  }
  get minValue() {
    let n = null;
    for (const i of this._def.checks)
      i.kind === "min" && (n === null || i.value > n) && (n = i.value);
    return n;
  }
  get maxValue() {
    let n = null;
    for (const i of this._def.checks)
      i.kind === "max" && (n === null || i.value < n) && (n = i.value);
    return n;
  }
  get isInt() {
    return !!this._def.checks.find((n) => n.kind === "int" || n.kind === "multipleOf" && An.isInteger(n.value));
  }
  get isFinite() {
    let n = null, i = null;
    for (const t of this._def.checks) {
      if (t.kind === "finite" || t.kind === "int" || t.kind === "multipleOf")
        return !0;
      t.kind === "min" ? (i === null || t.value > i) && (i = t.value) : t.kind === "max" && (n === null || t.value < n) && (n = t.value);
    }
    return Number.isFinite(i) && Number.isFinite(n);
  }
}
Yo.create = (e) => new Yo({
  checks: [],
  typeName: an.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Nn(e)
});
class Xo extends Tn {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(n) {
    if (this._def.coerce)
      try {
        n.data = BigInt(n.data);
      } catch (s) {
        return this._getInvalidInput(n);
      }
    if (this._getType(n) !== Ee.bigint)
      return this._getInvalidInput(n);
    let t;
    const a = new At();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? n.data < s.value : n.data <= s.value) && (t = this._getOrReturnCtx(n, t), Re(t, {
        code: me.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? n.data > s.value : n.data >= s.value) && (t = this._getOrReturnCtx(n, t), Re(t, {
        code: me.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? n.data % s.value !== BigInt(0) && (t = this._getOrReturnCtx(n, t), Re(t, {
        code: me.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : An.assertNever(s);
    return { status: a.value, value: n.data };
  }
  _getInvalidInput(n) {
    const i = this._getOrReturnCtx(n);
    return Re(i, {
      code: me.invalid_type,
      expected: Ee.bigint,
      received: i.parsedType
    }), tn;
  }
  gte(n, i) {
    return this.setLimit("min", n, !0, Qe.toString(i));
  }
  gt(n, i) {
    return this.setLimit("min", n, !1, Qe.toString(i));
  }
  lte(n, i) {
    return this.setLimit("max", n, !0, Qe.toString(i));
  }
  lt(n, i) {
    return this.setLimit("max", n, !1, Qe.toString(i));
  }
  setLimit(n, i, t, a) {
    return new Xo({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: n,
          value: i,
          inclusive: t,
          message: Qe.toString(a)
        }
      ]
    });
  }
  _addCheck(n) {
    return new Xo({
      ...this._def,
      checks: [...this._def.checks, n]
    });
  }
  positive(n) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Qe.toString(n)
    });
  }
  negative(n) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Qe.toString(n)
    });
  }
  nonpositive(n) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Qe.toString(n)
    });
  }
  nonnegative(n) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Qe.toString(n)
    });
  }
  multipleOf(n, i) {
    return this._addCheck({
      kind: "multipleOf",
      value: n,
      message: Qe.toString(i)
    });
  }
  get minValue() {
    let n = null;
    for (const i of this._def.checks)
      i.kind === "min" && (n === null || i.value > n) && (n = i.value);
    return n;
  }
  get maxValue() {
    let n = null;
    for (const i of this._def.checks)
      i.kind === "max" && (n === null || i.value < n) && (n = i.value);
    return n;
  }
}
Xo.create = (e) => {
  var n;
  return new Xo({
    checks: [],
    typeName: an.ZodBigInt,
    coerce: (n = e == null ? void 0 : e.coerce) != null ? n : !1,
    ...Nn(e)
  });
};
class $S extends Tn {
  _parse(n) {
    if (this._def.coerce && (n.data = !!n.data), this._getType(n) !== Ee.boolean) {
      const t = this._getOrReturnCtx(n);
      return Re(t, {
        code: me.invalid_type,
        expected: Ee.boolean,
        received: t.parsedType
      }), tn;
    }
    return zt(n.data);
  }
}
$S.create = (e) => new $S({
  typeName: an.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Nn(e)
});
class Mu extends Tn {
  _parse(n) {
    if (this._def.coerce && (n.data = new Date(n.data)), this._getType(n) !== Ee.date) {
      const s = this._getOrReturnCtx(n);
      return Re(s, {
        code: me.invalid_type,
        expected: Ee.date,
        received: s.parsedType
      }), tn;
    }
    if (Number.isNaN(n.data.getTime())) {
      const s = this._getOrReturnCtx(n);
      return Re(s, {
        code: me.invalid_date
      }), tn;
    }
    const t = new At();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? n.data.getTime() < s.value && (a = this._getOrReturnCtx(n, a), Re(a, {
        code: me.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), t.dirty()) : s.kind === "max" ? n.data.getTime() > s.value && (a = this._getOrReturnCtx(n, a), Re(a, {
        code: me.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), t.dirty()) : An.assertNever(s);
    return {
      status: t.value,
      value: new Date(n.data.getTime())
    };
  }
  _addCheck(n) {
    return new Mu({
      ...this._def,
      checks: [...this._def.checks, n]
    });
  }
  min(n, i) {
    return this._addCheck({
      kind: "min",
      value: n.getTime(),
      message: Qe.toString(i)
    });
  }
  max(n, i) {
    return this._addCheck({
      kind: "max",
      value: n.getTime(),
      message: Qe.toString(i)
    });
  }
  get minDate() {
    let n = null;
    for (const i of this._def.checks)
      i.kind === "min" && (n === null || i.value > n) && (n = i.value);
    return n != null ? new Date(n) : null;
  }
  get maxDate() {
    let n = null;
    for (const i of this._def.checks)
      i.kind === "max" && (n === null || i.value < n) && (n = i.value);
    return n != null ? new Date(n) : null;
  }
}
Mu.create = (e) => new Mu({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: an.ZodDate,
  ...Nn(e)
});
class US extends Tn {
  _parse(n) {
    if (this._getType(n) !== Ee.symbol) {
      const t = this._getOrReturnCtx(n);
      return Re(t, {
        code: me.invalid_type,
        expected: Ee.symbol,
        received: t.parsedType
      }), tn;
    }
    return zt(n.data);
  }
}
US.create = (e) => new US({
  typeName: an.ZodSymbol,
  ...Nn(e)
});
class VS extends Tn {
  _parse(n) {
    if (this._getType(n) !== Ee.undefined) {
      const t = this._getOrReturnCtx(n);
      return Re(t, {
        code: me.invalid_type,
        expected: Ee.undefined,
        received: t.parsedType
      }), tn;
    }
    return zt(n.data);
  }
}
VS.create = (e) => new VS({
  typeName: an.ZodUndefined,
  ...Nn(e)
});
class HS extends Tn {
  _parse(n) {
    if (this._getType(n) !== Ee.null) {
      const t = this._getOrReturnCtx(n);
      return Re(t, {
        code: me.invalid_type,
        expected: Ee.null,
        received: t.parsedType
      }), tn;
    }
    return zt(n.data);
  }
}
HS.create = (e) => new HS({
  typeName: an.ZodNull,
  ...Nn(e)
});
class zS extends Tn {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(n) {
    return zt(n.data);
  }
}
zS.create = (e) => new zS({
  typeName: an.ZodAny,
  ...Nn(e)
});
class BS extends Tn {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(n) {
    return zt(n.data);
  }
}
BS.create = (e) => new BS({
  typeName: an.ZodUnknown,
  ...Nn(e)
});
class Zl extends Tn {
  _parse(n) {
    const i = this._getOrReturnCtx(n);
    return Re(i, {
      code: me.invalid_type,
      expected: Ee.never,
      received: i.parsedType
    }), tn;
  }
}
Zl.create = (e) => new Zl({
  typeName: an.ZodNever,
  ...Nn(e)
});
class qS extends Tn {
  _parse(n) {
    if (this._getType(n) !== Ee.undefined) {
      const t = this._getOrReturnCtx(n);
      return Re(t, {
        code: me.invalid_type,
        expected: Ee.void,
        received: t.parsedType
      }), tn;
    }
    return zt(n.data);
  }
}
qS.create = (e) => new qS({
  typeName: an.ZodVoid,
  ...Nn(e)
});
class Ta extends Tn {
  _parse(n) {
    const { ctx: i, status: t } = this._processInputParams(n), a = this._def;
    if (i.parsedType !== Ee.array)
      return Re(i, {
        code: me.invalid_type,
        expected: Ee.array,
        received: i.parsedType
      }), tn;
    if (a.exactLength !== null) {
      const r = i.data.length > a.exactLength.value, o = i.data.length < a.exactLength.value;
      (r || o) && (Re(i, {
        code: r ? me.too_big : me.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: r ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), t.dirty());
    }
    if (a.minLength !== null && i.data.length < a.minLength.value && (Re(i, {
      code: me.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), t.dirty()), a.maxLength !== null && i.data.length > a.maxLength.value && (Re(i, {
      code: me.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), t.dirty()), i.common.async)
      return Promise.all([...i.data].map((r, o) => a.type._parseAsync(new Xl(i, r, i.path, o)))).then((r) => At.mergeArray(t, r));
    const s = [...i.data].map((r, o) => a.type._parseSync(new Xl(i, r, i.path, o)));
    return At.mergeArray(t, s);
  }
  get element() {
    return this._def.type;
  }
  min(n, i) {
    return new Ta({
      ...this._def,
      minLength: { value: n, message: Qe.toString(i) }
    });
  }
  max(n, i) {
    return new Ta({
      ...this._def,
      maxLength: { value: n, message: Qe.toString(i) }
    });
  }
  length(n, i) {
    return new Ta({
      ...this._def,
      exactLength: { value: n, message: Qe.toString(i) }
    });
  }
  nonempty(n) {
    return this.min(1, n);
  }
}
Ta.create = (e, n) => new Ta({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: an.ZodArray,
  ...Nn(n)
});
function x1(e) {
  if (e instanceof ji) {
    const n = {};
    for (const i in e.shape) {
      const t = e.shape[i];
      n[i] = Hl.create(x1(t));
    }
    return new ji({
      ...e._def,
      shape: () => n
    });
  } else return e instanceof Ta ? new Ta({
    ...e._def,
    type: x1(e.element)
  }) : e instanceof Hl ? Hl.create(x1(e.unwrap())) : e instanceof sr ? sr.create(x1(e.unwrap())) : e instanceof Ws ? Ws.create(e.items.map((n) => x1(n))) : e;
}
class ji extends Tn {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const n = this._def.shape(), i = An.objectKeys(n);
    return this._cached = { shape: n, keys: i }, this._cached;
  }
  _parse(n) {
    if (this._getType(n) !== Ee.object) {
      const c = this._getOrReturnCtx(n);
      return Re(c, {
        code: me.invalid_type,
        expected: Ee.object,
        received: c.parsedType
      }), tn;
    }
    const { status: t, ctx: a } = this._processInputParams(n), { shape: s, keys: r } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Zl && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        r.includes(c) || o.push(c);
    const d = [];
    for (const c of r) {
      const u = s[c], k = a.data[c];
      d.push({
        key: { status: "valid", value: c },
        value: u._parse(new Xl(a, k, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof Zl) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of o)
          d.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        o.length > 0 && (Re(a, {
          code: me.unrecognized_keys,
          keys: o
        }), t.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of o) {
        const k = a.data[u];
        d.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new Xl(a, k, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of d) {
        const k = await u.key, m = await u.value;
        c.push({
          key: k,
          value: m,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => At.mergeObjectSync(t, c)) : At.mergeObjectSync(t, d);
  }
  get shape() {
    return this._def.shape();
  }
  strict(n) {
    return Qe.errToObj, new ji({
      ...this._def,
      unknownKeys: "strict",
      ...n !== void 0 ? {
        errorMap: (i, t) => {
          var s, r, o, d;
          const a = (o = (r = (s = this._def).errorMap) == null ? void 0 : r.call(s, i, t).message) != null ? o : t.defaultError;
          return i.code === "unrecognized_keys" ? {
            message: (d = Qe.errToObj(n).message) != null ? d : a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new ji({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ji({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(n) {
    return new ji({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...n
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(n) {
    return new ji({
      unknownKeys: n._def.unknownKeys,
      catchall: n._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...n._def.shape()
      }),
      typeName: an.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(n, i) {
    return this.augment({ [n]: i });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(n) {
    return new ji({
      ...this._def,
      catchall: n
    });
  }
  pick(n) {
    const i = {};
    for (const t of An.objectKeys(n))
      n[t] && this.shape[t] && (i[t] = this.shape[t]);
    return new ji({
      ...this._def,
      shape: () => i
    });
  }
  omit(n) {
    const i = {};
    for (const t of An.objectKeys(this.shape))
      n[t] || (i[t] = this.shape[t]);
    return new ji({
      ...this._def,
      shape: () => i
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return x1(this);
  }
  partial(n) {
    const i = {};
    for (const t of An.objectKeys(this.shape)) {
      const a = this.shape[t];
      n && !n[t] ? i[t] = a : i[t] = a.optional();
    }
    return new ji({
      ...this._def,
      shape: () => i
    });
  }
  required(n) {
    const i = {};
    for (const t of An.objectKeys(this.shape))
      if (n && !n[t])
        i[t] = this.shape[t];
      else {
        let s = this.shape[t];
        for (; s instanceof Hl; )
          s = s._def.innerType;
        i[t] = s;
      }
    return new ji({
      ...this._def,
      shape: () => i
    });
  }
  keyof() {
    return Vx(An.objectKeys(this.shape));
  }
}
ji.create = (e, n) => new ji({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Zl.create(),
  typeName: an.ZodObject,
  ...Nn(n)
});
ji.strictCreate = (e, n) => new ji({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Zl.create(),
  typeName: an.ZodObject,
  ...Nn(n)
});
ji.lazycreate = (e, n) => new ji({
  shape: e,
  unknownKeys: "strip",
  catchall: Zl.create(),
  typeName: an.ZodObject,
  ...Nn(n)
});
class Lu extends Tn {
  _parse(n) {
    const { ctx: i } = this._processInputParams(n), t = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return i.common.issues.push(...o.ctx.common.issues), o.result;
      const r = s.map((o) => new ol(o.ctx.common.issues));
      return Re(i, {
        code: me.invalid_union,
        unionErrors: r
      }), tn;
    }
    if (i.common.async)
      return Promise.all(t.map(async (s) => {
        const r = {
          ...i,
          common: {
            ...i.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: i.data,
            path: i.path,
            parent: r
          }),
          ctx: r
        };
      })).then(a);
    {
      let s;
      const r = [];
      for (const d of t) {
        const c = {
          ...i,
          common: {
            ...i.common,
            issues: []
          },
          parent: null
        }, u = d._parseSync({
          data: i.data,
          path: i.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !s && (s = { result: u, ctx: c }), c.common.issues.length && r.push(c.common.issues);
      }
      if (s)
        return i.common.issues.push(...s.ctx.common.issues), s.result;
      const o = r.map((d) => new ol(d));
      return Re(i, {
        code: me.invalid_union,
        unionErrors: o
      }), tn;
    }
  }
  get options() {
    return this._def.options;
  }
}
Lu.create = (e, n) => new Lu({
  options: e,
  typeName: an.ZodUnion,
  ...Nn(n)
});
function Jk(e, n) {
  const i = Ol(e), t = Ol(n);
  if (e === n)
    return { valid: !0, data: e };
  if (i === Ee.object && t === Ee.object) {
    const a = An.objectKeys(n), s = An.objectKeys(e).filter((o) => a.indexOf(o) !== -1), r = { ...e, ...n };
    for (const o of s) {
      const d = Jk(e[o], n[o]);
      if (!d.valid)
        return { valid: !1 };
      r[o] = d.data;
    }
    return { valid: !0, data: r };
  } else if (i === Ee.array && t === Ee.array) {
    if (e.length !== n.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const r = e[s], o = n[s], d = Jk(r, o);
      if (!d.valid)
        return { valid: !1 };
      a.push(d.data);
    }
    return { valid: !0, data: a };
  } else return i === Ee.date && t === Ee.date && +e == +n ? { valid: !0, data: e } : { valid: !1 };
}
class $u extends Tn {
  _parse(n) {
    const { status: i, ctx: t } = this._processInputParams(n), a = (s, r) => {
      if (QS(s) || QS(r))
        return tn;
      const o = Jk(s.value, r.value);
      return o.valid ? ((MS(s) || MS(r)) && i.dirty(), { status: i.value, value: o.data }) : (Re(t, {
        code: me.invalid_intersection_types
      }), tn);
    };
    return t.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: t.data,
        path: t.path,
        parent: t
      }),
      this._def.right._parseAsync({
        data: t.data,
        path: t.path,
        parent: t
      })
    ]).then(([s, r]) => a(s, r)) : a(this._def.left._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }), this._def.right._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }));
  }
}
$u.create = (e, n, i) => new $u({
  left: e,
  right: n,
  typeName: an.ZodIntersection,
  ...Nn(i)
});
class Ws extends Tn {
  _parse(n) {
    const { status: i, ctx: t } = this._processInputParams(n);
    if (t.parsedType !== Ee.array)
      return Re(t, {
        code: me.invalid_type,
        expected: Ee.array,
        received: t.parsedType
      }), tn;
    if (t.data.length < this._def.items.length)
      return Re(t, {
        code: me.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), tn;
    !this._def.rest && t.data.length > this._def.items.length && (Re(t, {
      code: me.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), i.dirty());
    const s = [...t.data].map((r, o) => {
      const d = this._def.items[o] || this._def.rest;
      return d ? d._parse(new Xl(t, r, t.path, o)) : null;
    }).filter((r) => !!r);
    return t.common.async ? Promise.all(s).then((r) => At.mergeArray(i, r)) : At.mergeArray(i, s);
  }
  get items() {
    return this._def.items;
  }
  rest(n) {
    return new Ws({
      ...this._def,
      rest: n
    });
  }
}
Ws.create = (e, n) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Ws({
    items: e,
    typeName: an.ZodTuple,
    rest: null,
    ...Nn(n)
  });
};
class GS extends Tn {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(n) {
    const { status: i, ctx: t } = this._processInputParams(n);
    if (t.parsedType !== Ee.map)
      return Re(t, {
        code: me.invalid_type,
        expected: Ee.map,
        received: t.parsedType
      }), tn;
    const a = this._def.keyType, s = this._def.valueType, r = [...t.data.entries()].map(([o, d], c) => ({
      key: a._parse(new Xl(t, o, t.path, [c, "key"])),
      value: s._parse(new Xl(t, d, t.path, [c, "value"]))
    }));
    if (t.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const d of r) {
          const c = await d.key, u = await d.value;
          if (c.status === "aborted" || u.status === "aborted")
            return tn;
          (c.status === "dirty" || u.status === "dirty") && i.dirty(), o.set(c.value, u.value);
        }
        return { status: i.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const d of r) {
        const c = d.key, u = d.value;
        if (c.status === "aborted" || u.status === "aborted")
          return tn;
        (c.status === "dirty" || u.status === "dirty") && i.dirty(), o.set(c.value, u.value);
      }
      return { status: i.value, value: o };
    }
  }
}
GS.create = (e, n, i) => new GS({
  valueType: n,
  keyType: e,
  typeName: an.ZodMap,
  ...Nn(i)
});
class Zo extends Tn {
  _parse(n) {
    const { status: i, ctx: t } = this._processInputParams(n);
    if (t.parsedType !== Ee.set)
      return Re(t, {
        code: me.invalid_type,
        expected: Ee.set,
        received: t.parsedType
      }), tn;
    const a = this._def;
    a.minSize !== null && t.data.size < a.minSize.value && (Re(t, {
      code: me.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), i.dirty()), a.maxSize !== null && t.data.size > a.maxSize.value && (Re(t, {
      code: me.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), i.dirty());
    const s = this._def.valueType;
    function r(d) {
      const c = /* @__PURE__ */ new Set();
      for (const u of d) {
        if (u.status === "aborted")
          return tn;
        u.status === "dirty" && i.dirty(), c.add(u.value);
      }
      return { status: i.value, value: c };
    }
    const o = [...t.data.values()].map((d, c) => s._parse(new Xl(t, d, t.path, c)));
    return t.common.async ? Promise.all(o).then((d) => r(d)) : r(o);
  }
  min(n, i) {
    return new Zo({
      ...this._def,
      minSize: { value: n, message: Qe.toString(i) }
    });
  }
  max(n, i) {
    return new Zo({
      ...this._def,
      maxSize: { value: n, message: Qe.toString(i) }
    });
  }
  size(n, i) {
    return this.min(n, i).max(n, i);
  }
  nonempty(n) {
    return this.min(1, n);
  }
}
Zo.create = (e, n) => new Zo({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: an.ZodSet,
  ...Nn(n)
});
class WS extends Tn {
  get schema() {
    return this._def.getter();
  }
  _parse(n) {
    const { ctx: i } = this._processInputParams(n);
    return this._def.getter()._parse({ data: i.data, path: i.path, parent: i });
  }
}
WS.create = (e, n) => new WS({
  getter: e,
  typeName: an.ZodLazy,
  ...Nn(n)
});
class KS extends Tn {
  _parse(n) {
    if (n.data !== this._def.value) {
      const i = this._getOrReturnCtx(n);
      return Re(i, {
        received: i.data,
        code: me.invalid_literal,
        expected: this._def.value
      }), tn;
    }
    return { status: "valid", value: n.data };
  }
  get value() {
    return this._def.value;
  }
}
KS.create = (e, n) => new KS({
  value: e,
  typeName: an.ZodLiteral,
  ...Nn(n)
});
function Vx(e, n) {
  return new ar({
    values: e,
    typeName: an.ZodEnum,
    ...Nn(n)
  });
}
class ar extends Tn {
  _parse(n) {
    if (typeof n.data != "string") {
      const i = this._getOrReturnCtx(n), t = this._def.values;
      return Re(i, {
        expected: An.joinValues(t),
        received: i.parsedType,
        code: me.invalid_type
      }), tn;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(n.data)) {
      const i = this._getOrReturnCtx(n), t = this._def.values;
      return Re(i, {
        received: i.data,
        code: me.invalid_enum_value,
        options: t
      }), tn;
    }
    return zt(n.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const n = {};
    for (const i of this._def.values)
      n[i] = i;
    return n;
  }
  get Values() {
    const n = {};
    for (const i of this._def.values)
      n[i] = i;
    return n;
  }
  get Enum() {
    const n = {};
    for (const i of this._def.values)
      n[i] = i;
    return n;
  }
  extract(n, i = this._def) {
    return ar.create(n, {
      ...this._def,
      ...i
    });
  }
  exclude(n, i = this._def) {
    return ar.create(this.options.filter((t) => !n.includes(t)), {
      ...this._def,
      ...i
    });
  }
}
ar.create = Vx;
class YS extends Tn {
  _parse(n) {
    const i = An.getValidEnumValues(this._def.values), t = this._getOrReturnCtx(n);
    if (t.parsedType !== Ee.string && t.parsedType !== Ee.number) {
      const a = An.objectValues(i);
      return Re(t, {
        expected: An.joinValues(a),
        received: t.parsedType,
        code: me.invalid_type
      }), tn;
    }
    if (this._cache || (this._cache = new Set(An.getValidEnumValues(this._def.values))), !this._cache.has(n.data)) {
      const a = An.objectValues(i);
      return Re(t, {
        received: t.data,
        code: me.invalid_enum_value,
        options: a
      }), tn;
    }
    return zt(n.data);
  }
  get enum() {
    return this._def.values;
  }
}
YS.create = (e, n) => new YS({
  values: e,
  typeName: an.ZodNativeEnum,
  ...Nn(n)
});
class Uu extends Tn {
  unwrap() {
    return this._def.type;
  }
  _parse(n) {
    const { ctx: i } = this._processInputParams(n);
    if (i.parsedType !== Ee.promise && i.common.async === !1)
      return Re(i, {
        code: me.invalid_type,
        expected: Ee.promise,
        received: i.parsedType
      }), tn;
    const t = i.parsedType === Ee.promise ? i.data : Promise.resolve(i.data);
    return zt(t.then((a) => this._def.type.parseAsync(a, {
      path: i.path,
      errorMap: i.common.contextualErrorMap
    })));
  }
}
Uu.create = (e, n) => new Uu({
  type: e,
  typeName: an.ZodPromise,
  ...Nn(n)
});
class lr extends Tn {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === an.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(n) {
    const { status: i, ctx: t } = this._processInputParams(n), a = this._def.effect || null, s = {
      addIssue: (r) => {
        Re(t, r), r.fatal ? i.abort() : i.dirty();
      },
      get path() {
        return t.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const r = a.transform(t.data, s);
      if (t.common.async)
        return Promise.resolve(r).then(async (o) => {
          if (i.value === "aborted")
            return tn;
          const d = await this._def.schema._parseAsync({
            data: o,
            path: t.path,
            parent: t
          });
          return d.status === "aborted" ? tn : d.status === "dirty" || i.value === "dirty" ? po(d.value) : d;
        });
      {
        if (i.value === "aborted")
          return tn;
        const o = this._def.schema._parseSync({
          data: r,
          path: t.path,
          parent: t
        });
        return o.status === "aborted" ? tn : o.status === "dirty" || i.value === "dirty" ? po(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const r = (o) => {
        const d = a.refinement(o, s);
        if (t.common.async)
          return Promise.resolve(d);
        if (d instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (t.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: t.data,
          path: t.path,
          parent: t
        });
        return o.status === "aborted" ? tn : (o.status === "dirty" && i.dirty(), r(o.value), { status: i.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: t.data, path: t.path, parent: t }).then((o) => o.status === "aborted" ? tn : (o.status === "dirty" && i.dirty(), r(o.value).then(() => ({ status: i.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (t.common.async === !1) {
        const r = this._def.schema._parseSync({
          data: t.data,
          path: t.path,
          parent: t
        });
        if (!tr(r))
          return tn;
        const o = a.transform(r.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: i.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: t.data, path: t.path, parent: t }).then((r) => tr(r) ? Promise.resolve(a.transform(r.value, s)).then((o) => ({
          status: i.value,
          value: o
        })) : tn);
    An.assertNever(a);
  }
}
lr.create = (e, n, i) => new lr({
  schema: e,
  typeName: an.ZodEffects,
  effect: n,
  ...Nn(i)
});
lr.createWithPreprocess = (e, n, i) => new lr({
  schema: n,
  effect: { type: "preprocess", transform: e },
  typeName: an.ZodEffects,
  ...Nn(i)
});
class Hl extends Tn {
  _parse(n) {
    return this._getType(n) === Ee.undefined ? zt(void 0) : this._def.innerType._parse(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Hl.create = (e, n) => new Hl({
  innerType: e,
  typeName: an.ZodOptional,
  ...Nn(n)
});
class sr extends Tn {
  _parse(n) {
    return this._getType(n) === Ee.null ? zt(null) : this._def.innerType._parse(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
sr.create = (e, n) => new sr({
  innerType: e,
  typeName: an.ZodNullable,
  ...Nn(n)
});
class _k extends Tn {
  _parse(n) {
    const { ctx: i } = this._processInputParams(n);
    let t = i.data;
    return i.parsedType === Ee.undefined && (t = this._def.defaultValue()), this._def.innerType._parse({
      data: t,
      path: i.path,
      parent: i
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
_k.create = (e, n) => new _k({
  innerType: e,
  typeName: an.ZodDefault,
  defaultValue: typeof n.default == "function" ? n.default : () => n.default,
  ...Nn(n)
});
class Qk extends Tn {
  _parse(n) {
    const { ctx: i } = this._processInputParams(n), t = {
      ...i,
      common: {
        ...i.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: t.data,
      path: t.path,
      parent: {
        ...t
      }
    });
    return Qu(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new ol(t.common.issues);
        },
        input: t.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new ol(t.common.issues);
        },
        input: t.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Qk.create = (e, n) => new Qk({
  innerType: e,
  typeName: an.ZodCatch,
  catchValue: typeof n.catch == "function" ? n.catch : () => n.catch,
  ...Nn(n)
});
class XS extends Tn {
  _parse(n) {
    if (this._getType(n) !== Ee.nan) {
      const t = this._getOrReturnCtx(n);
      return Re(t, {
        code: me.invalid_type,
        expected: Ee.nan,
        received: t.parsedType
      }), tn;
    }
    return { status: "valid", value: n.data };
  }
}
XS.create = (e) => new XS({
  typeName: an.ZodNaN,
  ...Nn(e)
});
class zG extends Tn {
  _parse(n) {
    const { ctx: i } = this._processInputParams(n), t = i.data;
    return this._def.type._parse({
      data: t,
      path: i.path,
      parent: i
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Sh extends Tn {
  _parse(n) {
    const { status: i, ctx: t } = this._processInputParams(n);
    if (t.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: t.data,
          path: t.path,
          parent: t
        });
        return s.status === "aborted" ? tn : s.status === "dirty" ? (i.dirty(), po(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: t.path,
          parent: t
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: t.data,
        path: t.path,
        parent: t
      });
      return a.status === "aborted" ? tn : a.status === "dirty" ? (i.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: t.path,
        parent: t
      });
    }
  }
  static create(n, i) {
    return new Sh({
      in: n,
      out: i,
      typeName: an.ZodPipeline
    });
  }
}
class Mk extends Tn {
  _parse(n) {
    const i = this._def.innerType._parse(n), t = (a) => (tr(a) && (a.value = Object.freeze(a.value)), a);
    return Qu(i) ? i.then((a) => t(a)) : t(i);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Mk.create = (e, n) => new Mk({
  innerType: e,
  typeName: an.ZodReadonly,
  ...Nn(n)
});
var an;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(an || (an = {}));
const Wi = Ll.create;
Zl.create;
Ta.create;
Lu.create;
$u.create;
Ws.create;
ar.create;
Uu.create;
Hl.create;
sr.create;
var BG = (e, n) => typeof n == "bigint" ? n.toString() : n;
function t3(e, n = " | ") {
  return e.map((i) => typeof i == "string" ? `'${i}'` : i).join(n);
}
var ZS = (e) => {
  if (typeof e != "object" || e === null)
    return !1;
  for (const n in e)
    if (!Object.prototype.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}, qG = (e, n) => {
  if (typeof e == "string")
    return { key: e, values: {} };
  if (ZS(e)) {
    const i = "key" in e && typeof e.key == "string" ? e.key : n, t = "values" in e && ZS(e.values) ? e.values : {};
    return { key: i, values: t };
  }
  return { key: n, values: {} };
}, eg = "zod", GG = (e) => (n, i) => {
  var d;
  const { t, ns: a, handlePath: s } = {
    t: Gi.t,
    ns: eg,
    ...e,
    handlePath: {
      context: "with_path",
      ns: eg,
      keyPrefix: void 0,
      ...e == null ? void 0 : e.handlePath
    }
  };
  let r;
  r = _u(n, i).message;
  const o = n.path.length > 0 && s ? {
    context: s.context,
    path: t(
      [s.keyPrefix, n.path.join(".")].filter(Boolean).join("."),
      {
        ns: s.ns,
        defaultValue: n.path.join(".")
      }
    )
  } : {};
  switch (n.code) {
    case me.invalid_type:
      n.received === Ee.undefined ? r = t("errors.invalid_type_received_undefined", {
        ns: a,
        defaultValue: r,
        ...o
      }) : n.received === Ee.null ? r = t("errors.invalid_type_received_null", {
        ns: a,
        defaultValue: r,
        ...o
      }) : r = t("errors.invalid_type", {
        expected: t(`types.${n.expected}`, {
          defaultValue: n.expected,
          ns: a
        }),
        received: t(`types.${n.received}`, {
          defaultValue: n.received,
          ns: a
        }),
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.invalid_literal:
      r = t("errors.invalid_literal", {
        expected: JSON.stringify(n.expected, BG),
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.unrecognized_keys:
      r = t("errors.unrecognized_keys", {
        keys: t3(n.keys, ", "),
        count: n.keys.length,
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.invalid_union:
      r = t("errors.invalid_union", {
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.invalid_union_discriminator:
      r = t("errors.invalid_union_discriminator", {
        options: t3(n.options),
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.invalid_enum_value:
      r = t("errors.invalid_enum_value", {
        options: t3(n.options),
        received: n.received,
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.invalid_arguments:
      r = t("errors.invalid_arguments", {
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.invalid_return_type:
      r = t("errors.invalid_return_type", {
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.invalid_date:
      r = t("errors.invalid_date", {
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.invalid_string:
      typeof n.validation == "object" ? "startsWith" in n.validation ? r = t("errors.invalid_string.startsWith", {
        startsWith: n.validation.startsWith,
        ns: a,
        defaultValue: r,
        ...o
      }) : "endsWith" in n.validation && (r = t("errors.invalid_string.endsWith", {
        endsWith: n.validation.endsWith,
        ns: a,
        defaultValue: r,
        ...o
      })) : r = t(`errors.invalid_string.${n.validation}`, {
        validation: t(`validations.${n.validation}`, {
          defaultValue: n.validation,
          ns: a
        }),
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.too_small:
      const c = n.type === "date" ? new Date(n.minimum) : n.minimum;
      r = t(
        `errors.too_small.${n.type}.${n.exact ? "exact" : n.inclusive ? "inclusive" : "not_inclusive"}`,
        {
          minimum: c,
          count: typeof c == "number" ? c : void 0,
          ns: a,
          defaultValue: r,
          ...o
        }
      );
      break;
    case me.too_big:
      const u = n.type === "date" ? new Date(n.maximum) : n.maximum;
      r = t(
        `errors.too_big.${n.type}.${n.exact ? "exact" : n.inclusive ? "inclusive" : "not_inclusive"}`,
        {
          maximum: u,
          count: typeof u == "number" ? u : void 0,
          ns: a,
          defaultValue: r,
          ...o
        }
      );
      break;
    case me.custom:
      const { key: k, values: m } = qG(
        (d = n.params) == null ? void 0 : d.i18n,
        "errors.custom"
      );
      r = t(k, {
        ...m,
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.invalid_intersection_types:
      r = t("errors.invalid_intersection_types", {
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.not_multiple_of:
      r = t("errors.not_multiple_of", {
        multipleOf: n.multipleOf,
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
    case me.not_finite:
      r = t("errors.not_finite", {
        ns: a,
        defaultValue: r,
        ...o
      });
      break;
  }
  return { message: r };
}, WG = GG();
const KG = {
  invalid_type: "{{expected}}での入力を期待していますが、{{received}}が入力されました。",
  invalid_type_received_undefined: "必須",
  invalid_type_received_null: "必須",
  invalid_literal: "無効なリテラル値です。{{expected}}を入力してください。",
  unrecognized_keys: "オブジェクトのキー{{- keys}}が識別できません。",
  invalid_union: "入力形式が間違っています。",
  invalid_union_discriminator: "無効な識別子です。{{- options}}で入力してください。",
  invalid_enum_value: "'{{received}}'は無効な値です。{{- options}}で入力してください。",
  invalid_arguments: "引数が間違っています。",
  invalid_return_type: "返値の型が間違っています。",
  invalid_date: "間違った日時データです。",
  custom: "入力形式が間違っています。",
  invalid_intersection_types: "交差型のマージができませんでした。",
  not_multiple_of: "{{multipleOf}}の倍数である必要があります。",
  not_finite: "有限数である必要があります。",
  invalid_string: {
    email: "{{validation}}の形式で入力してください。",
    url: "{{validation}}の形式で入力してください。",
    uuid: "{{validation}}の形式で入力してください。",
    cuid: "{{validation}}の形式で入力してください。",
    regex: "入力形式が間違っています。",
    datetime: "{{validation}}の形式で入力してください。",
    startsWith: '"{{startsWith}}"で始まる文字列である必要があります。',
    endsWith: '"{{endsWith}}"で終わる文字列である必要があります。'
  },
  too_small: {
    array: {
      exact: "{{minimum}}個の要素が必要です。",
      inclusive: "{{minimum}}個以上の要素が必要です。",
      not_inclusive: "{{minimum}}個より多くの要素が必要です。"
    },
    string: {
      exact: "{{minimum}}文字の文字列である必要があります。",
      inclusive: "{{minimum}}文字以上の文字列である必要があります。",
      not_inclusive: "{{minimum}}文字より長い文字列である必要があります。"
    },
    number: {
      exact: "{{minimum}}の数値である必要があります。",
      inclusive: "{{minimum}}以上の数値である必要があります。",
      not_inclusive: "{{minimum}}より大きな数値である必要があります。"
    },
    set: {
      exact: "入力形式が間違っています。",
      inclusive: "入力形式が間違っています。",
      not_inclusive: "入力形式が間違っています。"
    },
    date: {
      exact: "{{- minimum, datetime}}の日時である必要があります。",
      inclusive: "{{- minimum, datetime}}以降の日時である必要があります。",
      not_inclusive: "{{- minimum, datetime}}よりも後の日時である必要があります。"
    }
  },
  too_big: {
    array: {
      exact: "{{maximum}}個の要素である必要があります。",
      inclusive: "{{maximum}}個以下の要素である必要があります。",
      not_inclusive: "{{maximum}}個より少ない要素である必要があります。"
    },
    string: {
      exact: "{{maximum}}文字の文字列である必要があります。",
      inclusive: "{{maximum}}文字以下の文字列である必要があります。",
      not_inclusive: "{{maximum}}文字より短い文字列である必要があります。"
    },
    number: {
      exact: "{{maximum}}の数値である必要があります。",
      inclusive: "{{maximum}}以下の数値である必要があります。",
      not_inclusive: "{{maximum}}より小さな数値である必要があります。"
    },
    set: {
      exact: "入力形式が間違っています。",
      inclusive: "入力形式が間違っています。",
      not_inclusive: "入力形式が間違っています。"
    },
    date: {
      exact: "{{- maximum, datetime}}の日時である必要があります。",
      inclusive: "{{- maximum, datetime}}以前の日時である必要があります。",
      not_inclusive: "{{- maximum, datetime}}よりも前の日時である必要があります。"
    }
  }
}, YG = {
  email: "メールアドレス",
  url: "URL",
  uuid: "UUID",
  cuid: "CUID",
  regex: "正規表現",
  datetime: "日時"
}, XG = {
  function: "関数",
  number: "数値",
  string: "文字列",
  nan: "NaN",
  integer: "整数",
  float: "浮動小数点数",
  boolean: "真偽値",
  date: "日時",
  bigint: "Bigint",
  undefined: "undefined",
  symbol: "シンボル",
  null: "NULL",
  array: "配列",
  object: "オブジェクト",
  unknown: "unknown",
  promise: "Promise",
  void: "void",
  never: "never",
  map: "マップ",
  set: "セット"
}, a3 = {
  errors: KG,
  validations: YG,
  types: XG
}, ng = "入力が必須の項目です", ZG = "数字", Pd = (e) => {
  const n = v(() => e === D.En ? "en" : "ja", [e]);
  be(() => {
    (async () => {
      await Gi.init({
        lng: n,
        resources: {
          ja: {
            zod: {
              ...a3,
              errors: {
                ...a3.errors,
                invalid_type_received_undefined: ng,
                invalid_type_received_null: ng
              },
              types: {
                ...a3.types,
                number: ZG
              }
            }
          }
        }
      }), gG(WG);
    })();
  }, [n]);
};
function Hx(e, n) {
  return e - n;
}
function ja(e) {
  return Array.from({ length: e }, (n, i) => i);
}
function P(e) {
  return e === null || e === void 0;
}
function Ke(e) {
  return !!(P(e) || e === "");
}
function zx(e) {
  return e.isShowTimeSchedule === !0 && !Ke(e.startAt) && !Ke(e.endAt);
}
function ke(e) {
  return e.length === 0;
}
var Bx = {}, qx = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return i;
    }
  });
  function n(t, a) {
    return {
      handler: t,
      config: a
    };
  }
  n.withOptions = function(t, a = () => ({})) {
    const s = function(r) {
      return {
        __options: r,
        handler: t(r),
        config: a(r)
      };
    };
    return s.__isOptionsFunction = !0, s.__pluginFunction = t, s.__configFunction = a, s;
  };
  const i = n;
})(qx);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  const n = /* @__PURE__ */ i(qx);
  function i(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  const t = n.default;
})(Bx);
let l3 = Bx;
var eW = (l3.__esModule ? l3 : { default: l3 }).default;
const nW = /* @__PURE__ */ ls(eW);
nW(function() {
});
const iW = {
  BLACK: "rgba(0, 0, 0, 1.0)"
}, gh = {
  // tailwind.config.ts で 定義している
  theme: {
    colors: {
      black: iW.BLACK
    }
  }
}, Gx = Ot(null), Rd = ({ children: e }) => {
  const [n, i] = se(null), t = I((r) => {
    i(r);
  }, []), a = I(() => {
    i(null);
  }, []), s = v(
    () => ({ session: n, updateSession: t, reset: a }),
    [n, t, a]
  );
  return /* @__PURE__ */ l.jsx(Gx.Provider, { value: s, children: e });
}, Wx = (e) => {
  const n = oi(Gx);
  if (n === null)
    throw new Error(
      "[reservation] ReservationStoreProvider の外で予約セッションを参照しています。予約コンポーネントの Presenter 配下で使ってください。"
    );
  return e(n);
}, xi = () => {
  const e = Wx((n) => n.session);
  if (P(e)) throw new Error("Session is null.");
  return {
    session: e
  };
}, lt = () => {
  const { session: e } = xi();
  return {
    baseInfoInput: v(
      () => ({
        hotelID: e.hotelID,
        sessionID: e.sessionID,
        reservationID: e.reservationID,
        lastUpdatedAt: e.lastUpdatedAt
      }),
      [e.hotelID, e.lastUpdatedAt, e.reservationID, e.sessionID]
    )
  };
}, tW = () => {
  const { session: e } = xi();
  return {
    isShowBestRateNotice: v(() => e.isShowBestRateNotice, [e.isShowBestRateNotice])
  };
}, Td = () => {
  const { session: e } = xi();
  return {
    hotelName: v(() => e.hotelName, [e.hotelName])
  };
}, u1 = () => {
  const { session: e } = xi();
  return {
    lang: v(() => e.lang, [e.lang])
  };
}, Er = () => {
  const { session: e } = xi();
  return {
    reservationContext: v(() => e.reservationContext, [e.reservationContext])
  };
}, Ua = () => {
  const { session: e } = xi();
  return {
    reservationPolicy: v(() => e.reservationPolicy, [e.reservationPolicy])
  };
}, Va = () => {
  const { session: e } = xi();
  return {
    reservationCart: v(() => GV({ sessionStateContext: e }), [e])
  };
}, m1 = () => {
  const { session: e } = xi();
  return {
    reserveStatus: v(() => e.reserveStatus, [e.reserveStatus])
  };
};
var s3 = "Invariant Violation", ig = Object.setPrototypeOf, aW = ig === void 0 ? function(e, n) {
  return e.__proto__ = n, e;
} : ig, Kx = (
  /** @class */
  function(e) {
    ca(n, e);
    function n(i) {
      i === void 0 && (i = s3);
      var t = e.call(this, typeof i == "number" ? s3 + ": " + i + " (see https://github.com/apollographql/invariant-packages)" : i) || this;
      return t.framesToPop = 1, t.name = s3, aW(t, n.prototype), t;
    }
    return n;
  }(Error)
);
function As(e, n) {
  if (!e)
    throw new Kx(n);
}
var Yx = ["debug", "log", "warn", "error", "silent"], lW = Yx.indexOf("log");
function yc(e) {
  return function() {
    if (Yx.indexOf(e) >= lW) {
      var n = console[e] || console.log;
      return n.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = yc("debug"), e.log = yc("log"), e.warn = yc("warn"), e.error = yc("error");
})(As || (As = {}));
var Fh = "3.14.1";
function ia(e) {
  try {
    return e();
  } catch (n) {
  }
}
const Vu = ia(function() {
  return globalThis;
}) || ia(function() {
  return window;
}) || ia(function() {
  return self;
}) || ia(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
ia(function() {
  return ia.constructor("return this")();
});
var tg = /* @__PURE__ */ new Map();
function Lk(e) {
  var n = tg.get(e) || 1;
  return tg.set(e, n + 1), "".concat(e, ":").concat(n, ":").concat(Math.random().toString(36).slice(2));
}
function Xx(e, n) {
  n === void 0 && (n = 0);
  var i = Lk("stringifyForDisplay");
  return JSON.stringify(e, function(t, a) {
    return a === void 0 ? i : a;
  }, n).split(JSON.stringify(i)).join("<undefined>");
}
function bc(e) {
  return function(n) {
    for (var i = [], t = 1; t < arguments.length; t++)
      i[t - 1] = arguments[t];
    if (typeof n == "number") {
      var a = n;
      n = Ih(a), n || (n = yh(a, i), i = []);
    }
    e.apply(void 0, [n].concat(i));
  };
}
var ye = Object.assign(function(n, i) {
  for (var t = [], a = 2; a < arguments.length; a++)
    t[a - 2] = arguments[a];
  n || As(n, Ih(i, t) || yh(i, t));
}, {
  debug: bc(As.debug),
  log: bc(As.log),
  warn: bc(As.warn),
  error: bc(As.error)
});
function dt(e) {
  for (var n = [], i = 1; i < arguments.length; i++)
    n[i - 1] = arguments[i];
  return new Kx(Ih(e, n) || yh(e, n));
}
var ag = Symbol.for("ApolloErrorMessageHandler_" + Fh);
function Zx(e) {
  if (typeof e == "string")
    return e;
  try {
    return Xx(e, 2).slice(0, 1e3);
  } catch (n) {
    return "<non-serializable>";
  }
}
function Ih(e, n) {
  if (n === void 0 && (n = []), !!e)
    return Vu[ag] && Vu[ag](e, n.map(Zx));
}
function yh(e, n) {
  if (n === void 0 && (n = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: Fh,
      message: e,
      args: n.map(Zx)
    })));
}
function Hc(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Hc = function(i) {
    return typeof i;
  } : Hc = function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, Hc(e);
}
function sW(e) {
  return Hc(e) == "object" && e !== null;
}
var rW = typeof Symbol == "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";
function $k(e, n) {
  for (var i = /\r\n|[\n\r]/g, t = 1, a = n + 1, s; (s = i.exec(e.body)) && s.index < n; )
    t += 1, a = n + 1 - (s.index + s[0].length);
  return {
    line: t,
    column: a
  };
}
function oW(e) {
  return eD(e.source, $k(e.source, e.start));
}
function eD(e, n) {
  var i = e.locationOffset.column - 1, t = zc(i) + e.body, a = n.line - 1, s = e.locationOffset.line - 1, r = n.line + s, o = n.line === 1 ? i : 0, d = n.column + o, c = "".concat(e.name, ":").concat(r, ":").concat(d, `
`), u = t.split(/\r\n|[\n\r]/g), k = u[a];
  if (k.length > 120) {
    for (var m = Math.floor(d / 80), f = d % 80, p = [], h = 0; h < k.length; h += 80)
      p.push(k.slice(h, h + 80));
    return c + lg([["".concat(r), p[0]]].concat(p.slice(1, m + 1).map(function(N) {
      return ["", N];
    }), [[" ", zc(f - 1) + "^"], ["", p[m + 1]]]));
  }
  return c + lg([
    // Lines specified like this: ["prefix", "string"],
    ["".concat(r - 1), u[a - 1]],
    ["".concat(r), k],
    ["", zc(d - 1) + "^"],
    ["".concat(r + 1), u[a + 1]]
  ]);
}
function lg(e) {
  var n = e.filter(function(t) {
    t[0];
    var a = t[1];
    return a !== void 0;
  }), i = Math.max.apply(Math, n.map(function(t) {
    var a = t[0];
    return a.length;
  }));
  return n.map(function(t) {
    var a = t[0], s = t[1];
    return dW(i, a) + (s ? " | " + s : " |");
  }).join(`
`);
}
function zc(e) {
  return Array(e + 1).join(" ");
}
function dW(e, n) {
  return zc(e - n.length) + n;
}
function Bc(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Bc = function(i) {
    return typeof i;
  } : Bc = function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, Bc(e);
}
function sg(e, n) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), i.push.apply(i, t);
  }
  return i;
}
function cW(e) {
  for (var n = 1; n < arguments.length; n++) {
    var i = arguments[n] != null ? arguments[n] : {};
    n % 2 ? sg(Object(i), !0).forEach(function(t) {
      uW(e, t, i[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : sg(Object(i)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
    });
  }
  return e;
}
function uW(e, n, i) {
  return n in e ? Object.defineProperty(e, n, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = i, e;
}
function mW(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function kW(e, n) {
  for (var i = 0; i < n.length; i++) {
    var t = n[i];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
  }
}
function fW(e, n, i) {
  return n && kW(e.prototype, n), e;
}
function vW(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), n && ed(e, n);
}
function hW(e) {
  var n = iD();
  return function() {
    var t = nd(e), a;
    if (n) {
      var s = nd(this).constructor;
      a = Reflect.construct(t, arguments, s);
    } else
      a = t.apply(this, arguments);
    return nD(this, a);
  };
}
function nD(e, n) {
  return n && (Bc(n) === "object" || typeof n == "function") ? n : No(e);
}
function No(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Uk(e) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Uk = function(t) {
    if (t === null || !pW(t)) return t;
    if (typeof t != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof n != "undefined") {
      if (n.has(t)) return n.get(t);
      n.set(t, a);
    }
    function a() {
      return qc(t, arguments, nd(this).constructor);
    }
    return a.prototype = Object.create(t.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), ed(a, t);
  }, Uk(e);
}
function qc(e, n, i) {
  return iD() ? qc = Reflect.construct : qc = function(a, s, r) {
    var o = [null];
    o.push.apply(o, s);
    var d = Function.bind.apply(a, o), c = new d();
    return r && ed(c, r.prototype), c;
  }, qc.apply(null, arguments);
}
function iD() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch (e) {
    return !1;
  }
}
function pW(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function ed(e, n) {
  return ed = Object.setPrototypeOf || function(t, a) {
    return t.__proto__ = a, t;
  }, ed(e, n);
}
function nd(e) {
  return nd = Object.setPrototypeOf ? Object.getPrototypeOf : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, nd(e);
}
var tD = /* @__PURE__ */ function(e) {
  vW(i, e);
  var n = hW(i);
  function i(t, a, s, r, o, d, c) {
    var u, k, m, f;
    mW(this, i), f = n.call(this, t), f.name = "GraphQLError", f.originalError = d != null ? d : void 0, f.nodes = rg(Array.isArray(a) ? a : a ? [a] : void 0);
    for (var p = [], h = 0, N = (S = f.nodes) !== null && S !== void 0 ? S : []; h < N.length; h++) {
      var S, F = N[h], y = F.loc;
      y != null && p.push(y);
    }
    p = rg(p), f.source = s != null ? s : (u = p) === null || u === void 0 ? void 0 : u[0].source, f.positions = r != null ? r : (k = p) === null || k === void 0 ? void 0 : k.map(function(R) {
      return R.start;
    }), f.locations = r && s ? r.map(function(R) {
      return $k(s, R);
    }) : (m = p) === null || m === void 0 ? void 0 : m.map(function(R) {
      return $k(R.source, R.start);
    }), f.path = o != null ? o : void 0;
    var x = d == null ? void 0 : d.extensions;
    return c == null && sW(x) ? f.extensions = cW({}, x) : f.extensions = c != null ? c : {}, Object.defineProperties(No(f), {
      message: {
        enumerable: !0
      },
      locations: {
        enumerable: f.locations != null
      },
      path: {
        enumerable: f.path != null
      },
      extensions: {
        enumerable: f.extensions != null && Object.keys(f.extensions).length > 0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), d != null && d.stack ? (Object.defineProperty(No(f), "stack", {
      value: d.stack,
      writable: !0,
      configurable: !0
    }), nD(f)) : (Error.captureStackTrace ? Error.captureStackTrace(No(f), i) : Object.defineProperty(No(f), "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    }), f);
  }
  return fW(i, [{
    key: "toString",
    value: function() {
      return NW(this);
    }
    // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  }, {
    key: rW,
    get: function() {
      return "Object";
    }
  }]), i;
}(/* @__PURE__ */ Uk(Error));
function rg(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function NW(e) {
  var n = e.message;
  if (e.nodes)
    for (var i = 0, t = e.nodes; i < t.length; i++) {
      var a = t[i];
      a.loc && (n += `

` + oW(a.loc));
    }
  else if (e.source && e.locations)
    for (var s = 0, r = e.locations; s < r.length; s++) {
      var o = r[s];
      n += `

` + eD(e.source, o);
    }
  return n;
}
var Bn = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function SW(e, n) {
  var i = !!e;
  if (!i)
    throw new Error("Unexpected invariant triggered.");
}
var Vk = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function aD(e) {
  var n = e.prototype.toJSON;
  typeof n == "function" || SW(0), e.prototype.inspect = n, Vk && (e.prototype[Vk] = n);
}
var gW = /* @__PURE__ */ function() {
  function e(i, t, a) {
    this.start = i.start, this.end = t.end, this.startToken = i, this.endToken = t, this.source = a;
  }
  var n = e.prototype;
  return n.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
}();
aD(gW);
var FW = /* @__PURE__ */ function() {
  function e(i, t, a, s, r, o, d) {
    this.kind = i, this.start = t, this.end = a, this.line = s, this.column = r, this.value = d, this.prev = o, this.next = null;
  }
  var n = e.prototype;
  return n.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
}();
aD(FW);
function og(e) {
  return e != null && typeof e.kind == "string";
}
function Gc(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Gc = function(i) {
    return typeof i;
  } : Gc = function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, Gc(e);
}
var IW = 10, lD = 2;
function yW(e) {
  return e2(e, []);
}
function e2(e, n) {
  switch (Gc(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : bW(e, n);
    default:
      return String(e);
  }
}
function bW(e, n) {
  if (n.indexOf(e) !== -1)
    return "[Circular]";
  var i = [].concat(n, [e]), t = DW(e);
  if (t !== void 0) {
    var a = t.call(e);
    if (a !== e)
      return typeof a == "string" ? a : e2(a, i);
  } else if (Array.isArray(e))
    return xW(e, i);
  return CW(e, i);
}
function CW(e, n) {
  var i = Object.keys(e);
  if (i.length === 0)
    return "{}";
  if (n.length > lD)
    return "[" + wW(e) + "]";
  var t = i.map(function(a) {
    var s = e2(e[a], n);
    return a + ": " + s;
  });
  return "{ " + t.join(", ") + " }";
}
function xW(e, n) {
  if (e.length === 0)
    return "[]";
  if (n.length > lD)
    return "[Array]";
  for (var i = Math.min(IW, e.length), t = e.length - i, a = [], s = 0; s < i; ++s)
    a.push(e2(e[s], n));
  return t === 1 ? a.push("... 1 more item") : t > 1 && a.push("... ".concat(t, " more items")), "[" + a.join(", ") + "]";
}
function DW(e) {
  var n = e[String(Vk)];
  if (typeof n == "function")
    return n;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function wW(e) {
  var n = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (n === "Object" && typeof e.constructor == "function") {
    var i = e.constructor.name;
    if (typeof i == "string" && i !== "")
      return i;
  }
  return n;
}
function PW(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, t = e.indexOf(`
`) === -1, a = e[0] === " " || e[0] === "	", s = e[e.length - 1] === '"', r = e[e.length - 1] === "\\", o = !t || s || r || i, d = "";
  return o && !(t && a) && (d += `
` + n), d += n ? e.replace(/\n/g, `
` + n) : e, o && (d += `
`), '"""' + d.replace(/"""/g, '\\"""') + '"""';
}
var RW = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, n2 = Object.freeze({});
function Lt(e, n) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : RW, t = void 0, a = Array.isArray(e), s = [e], r = -1, o = [], d = void 0, c = void 0, u = void 0, k = [], m = [], f = e;
  do {
    r++;
    var p = r === s.length, h = p && o.length !== 0;
    if (p) {
      if (c = m.length === 0 ? void 0 : k[k.length - 1], d = u, u = m.pop(), h) {
        if (a)
          d = d.slice();
        else {
          for (var N = {}, S = 0, F = Object.keys(d); S < F.length; S++) {
            var y = F[S];
            N[y] = d[y];
          }
          d = N;
        }
        for (var x = 0, R = 0; R < o.length; R++) {
          var T = o[R][0], j = o[R][1];
          a && (T -= x), a && j === null ? (d.splice(T, 1), x++) : d[T] = j;
        }
      }
      r = t.index, s = t.keys, o = t.edits, a = t.inArray, t = t.prev;
    } else {
      if (c = u ? a ? r : s[r] : void 0, d = u ? u[c] : f, d == null)
        continue;
      u && k.push(c);
    }
    var A = void 0;
    if (!Array.isArray(d)) {
      if (!og(d))
        throw new Error("Invalid AST Node: ".concat(yW(d), "."));
      var B = TW(n, d.kind, p);
      if (B) {
        if (A = B.call(n, d, c, u, k, m), A === n2)
          break;
        if (A === !1) {
          if (!p) {
            k.pop();
            continue;
          }
        } else if (A !== void 0 && (o.push([c, A]), !p))
          if (og(A))
            d = A;
          else {
            k.pop();
            continue;
          }
      }
    }
    if (A === void 0 && h && o.push([c, d]), p)
      k.pop();
    else {
      var W;
      t = {
        inArray: a,
        index: r,
        keys: s,
        edits: o,
        prev: t
      }, a = Array.isArray(d), s = a ? d : (W = i[d.kind]) !== null && W !== void 0 ? W : [], r = -1, o = [], u && m.push(u), u = d;
    }
  } while (t !== void 0);
  return o.length !== 0 && (f = o[o.length - 1][1]), f;
}
function TW(e, n, i) {
  var t = e[n];
  if (t) {
    if (!i && typeof t == "function")
      return t;
    var a = i ? t.leave : t.enter;
    if (typeof a == "function")
      return a;
  } else {
    var s = i ? e.leave : e.enter;
    if (s) {
      if (typeof s == "function")
        return s;
      var r = s[n];
      if (typeof r == "function")
        return r;
    }
  }
}
function jW(e) {
  return Lt(e, {
    leave: OW
  });
}
var AW = 80, OW = {
  Name: function(n) {
    return n.value;
  },
  Variable: function(n) {
    return "$" + n.name;
  },
  // Document
  Document: function(n) {
    return Oe(n.definitions, `

`) + `
`;
  },
  OperationDefinition: function(n) {
    var i = n.operation, t = n.name, a = li("(", Oe(n.variableDefinitions, ", "), ")"), s = Oe(n.directives, " "), r = n.selectionSet;
    return !t && !s && !a && i === "query" ? r : Oe([i, Oe([t, a]), s, r], " ");
  },
  VariableDefinition: function(n) {
    var i = n.variable, t = n.type, a = n.defaultValue, s = n.directives;
    return i + ": " + t + li(" = ", a) + li(" ", Oe(s, " "));
  },
  SelectionSet: function(n) {
    var i = n.selections;
    return Xt(i);
  },
  Field: function(n) {
    var i = n.alias, t = n.name, a = n.arguments, s = n.directives, r = n.selectionSet, o = li("", i, ": ") + t, d = o + li("(", Oe(a, ", "), ")");
    return d.length > AW && (d = o + li(`(
`, Wc(Oe(a, `
`)), `
)`)), Oe([d, Oe(s, " "), r], " ");
  },
  Argument: function(n) {
    var i = n.name, t = n.value;
    return i + ": " + t;
  },
  // Fragments
  FragmentSpread: function(n) {
    var i = n.name, t = n.directives;
    return "..." + i + li(" ", Oe(t, " "));
  },
  InlineFragment: function(n) {
    var i = n.typeCondition, t = n.directives, a = n.selectionSet;
    return Oe(["...", li("on ", i), Oe(t, " "), a], " ");
  },
  FragmentDefinition: function(n) {
    var i = n.name, t = n.typeCondition, a = n.variableDefinitions, s = n.directives, r = n.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(i).concat(li("(", Oe(a, ", "), ")"), " ") + "on ".concat(t, " ").concat(li("", Oe(s, " "), " ")) + r
    );
  },
  // Value
  IntValue: function(n) {
    var i = n.value;
    return i;
  },
  FloatValue: function(n) {
    var i = n.value;
    return i;
  },
  StringValue: function(n, i) {
    var t = n.value, a = n.block;
    return a ? PW(t, i === "description" ? "" : "  ") : JSON.stringify(t);
  },
  BooleanValue: function(n) {
    var i = n.value;
    return i ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(n) {
    var i = n.value;
    return i;
  },
  ListValue: function(n) {
    var i = n.values;
    return "[" + Oe(i, ", ") + "]";
  },
  ObjectValue: function(n) {
    var i = n.fields;
    return "{" + Oe(i, ", ") + "}";
  },
  ObjectField: function(n) {
    var i = n.name, t = n.value;
    return i + ": " + t;
  },
  // Directive
  Directive: function(n) {
    var i = n.name, t = n.arguments;
    return "@" + i + li("(", Oe(t, ", "), ")");
  },
  // Type
  NamedType: function(n) {
    var i = n.name;
    return i;
  },
  ListType: function(n) {
    var i = n.type;
    return "[" + i + "]";
  },
  NonNullType: function(n) {
    var i = n.type;
    return i + "!";
  },
  // Type System Definitions
  SchemaDefinition: Yt(function(e) {
    var n = e.directives, i = e.operationTypes;
    return Oe(["schema", Oe(n, " "), Xt(i)], " ");
  }),
  OperationTypeDefinition: function(n) {
    var i = n.operation, t = n.type;
    return i + ": " + t;
  },
  ScalarTypeDefinition: Yt(function(e) {
    var n = e.name, i = e.directives;
    return Oe(["scalar", n, Oe(i, " ")], " ");
  }),
  ObjectTypeDefinition: Yt(function(e) {
    var n = e.name, i = e.interfaces, t = e.directives, a = e.fields;
    return Oe(["type", n, li("implements ", Oe(i, " & ")), Oe(t, " "), Xt(a)], " ");
  }),
  FieldDefinition: Yt(function(e) {
    var n = e.name, i = e.arguments, t = e.type, a = e.directives;
    return n + (dg(i) ? li(`(
`, Wc(Oe(i, `
`)), `
)`) : li("(", Oe(i, ", "), ")")) + ": " + t + li(" ", Oe(a, " "));
  }),
  InputValueDefinition: Yt(function(e) {
    var n = e.name, i = e.type, t = e.defaultValue, a = e.directives;
    return Oe([n + ": " + i, li("= ", t), Oe(a, " ")], " ");
  }),
  InterfaceTypeDefinition: Yt(function(e) {
    var n = e.name, i = e.interfaces, t = e.directives, a = e.fields;
    return Oe(["interface", n, li("implements ", Oe(i, " & ")), Oe(t, " "), Xt(a)], " ");
  }),
  UnionTypeDefinition: Yt(function(e) {
    var n = e.name, i = e.directives, t = e.types;
    return Oe(["union", n, Oe(i, " "), t && t.length !== 0 ? "= " + Oe(t, " | ") : ""], " ");
  }),
  EnumTypeDefinition: Yt(function(e) {
    var n = e.name, i = e.directives, t = e.values;
    return Oe(["enum", n, Oe(i, " "), Xt(t)], " ");
  }),
  EnumValueDefinition: Yt(function(e) {
    var n = e.name, i = e.directives;
    return Oe([n, Oe(i, " ")], " ");
  }),
  InputObjectTypeDefinition: Yt(function(e) {
    var n = e.name, i = e.directives, t = e.fields;
    return Oe(["input", n, Oe(i, " "), Xt(t)], " ");
  }),
  DirectiveDefinition: Yt(function(e) {
    var n = e.name, i = e.arguments, t = e.repeatable, a = e.locations;
    return "directive @" + n + (dg(i) ? li(`(
`, Wc(Oe(i, `
`)), `
)`) : li("(", Oe(i, ", "), ")")) + (t ? " repeatable" : "") + " on " + Oe(a, " | ");
  }),
  SchemaExtension: function(n) {
    var i = n.directives, t = n.operationTypes;
    return Oe(["extend schema", Oe(i, " "), Xt(t)], " ");
  },
  ScalarTypeExtension: function(n) {
    var i = n.name, t = n.directives;
    return Oe(["extend scalar", i, Oe(t, " ")], " ");
  },
  ObjectTypeExtension: function(n) {
    var i = n.name, t = n.interfaces, a = n.directives, s = n.fields;
    return Oe(["extend type", i, li("implements ", Oe(t, " & ")), Oe(a, " "), Xt(s)], " ");
  },
  InterfaceTypeExtension: function(n) {
    var i = n.name, t = n.interfaces, a = n.directives, s = n.fields;
    return Oe(["extend interface", i, li("implements ", Oe(t, " & ")), Oe(a, " "), Xt(s)], " ");
  },
  UnionTypeExtension: function(n) {
    var i = n.name, t = n.directives, a = n.types;
    return Oe(["extend union", i, Oe(t, " "), a && a.length !== 0 ? "= " + Oe(a, " | ") : ""], " ");
  },
  EnumTypeExtension: function(n) {
    var i = n.name, t = n.directives, a = n.values;
    return Oe(["extend enum", i, Oe(t, " "), Xt(a)], " ");
  },
  InputObjectTypeExtension: function(n) {
    var i = n.name, t = n.directives, a = n.fields;
    return Oe(["extend input", i, Oe(t, " "), Xt(a)], " ");
  }
};
function Yt(e) {
  return function(n) {
    return Oe([n.description, e(n)], `
`);
  };
}
function Oe(e) {
  var n, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (n = e == null ? void 0 : e.filter(function(t) {
    return t;
  }).join(i)) !== null && n !== void 0 ? n : "";
}
function Xt(e) {
  return li(`{
`, Wc(Oe(e, `
`)), `
}`);
}
function li(e, n) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return n != null && n !== "" ? e + n + i : "";
}
function Wc(e) {
  return li("  ", e.replace(/\n/g, `
  `));
}
function EW(e) {
  return e.indexOf(`
`) !== -1;
}
function dg(e) {
  return e != null && e.some(EW);
}
function cg(e) {
  return e.kind === Bn.FIELD || e.kind === Bn.FRAGMENT_SPREAD || e.kind === Bn.INLINE_FRAGMENT;
}
function jd(e, n) {
  var i = e.directives;
  return !i || !i.length ? !0 : QW(i).every(function(t) {
    var a = t.directive, s = t.ifArgument, r = !1;
    return s.value.kind === "Variable" ? (r = n && n[s.value.name.value], ye(r !== void 0, 105, a.name.value)) : r = s.value.value, a.name.value === "skip" ? !r : r;
  });
}
function id(e, n, i) {
  var t = new Set(e), a = t.size;
  return Lt(n, {
    Directive: function(s) {
      if (t.delete(s.name.value) && (!i || !t.size))
        return n2;
    }
  }), i ? !t.size : t.size < a;
}
function JW(e) {
  return e && id(["client", "export"], e, !0);
}
function _W(e) {
  var n = e.name.value;
  return n === "skip" || n === "include";
}
function QW(e) {
  var n = [];
  return e && e.length && e.forEach(function(i) {
    if (_W(i)) {
      var t = i.arguments, a = i.name.value;
      ye(t && t.length === 1, 106, a);
      var s = t[0];
      ye(s.name && s.name.value === "if", 107, a);
      var r = s.value;
      ye(r && (r.kind === "Variable" || r.kind === "BooleanValue"), 108, a), n.push({ directive: i, ifArgument: s });
    }
  }), n;
}
function MW(e) {
  var n, i, t = (n = e.directives) === null || n === void 0 ? void 0 : n.find(function(s) {
    var r = s.name;
    return r.value === "unmask";
  });
  if (!t)
    return "mask";
  var a = (i = t.arguments) === null || i === void 0 ? void 0 : i.find(function(s) {
    var r = s.name;
    return r.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && a && (a.value.kind === Bn.VARIABLE ? globalThis.__DEV__ !== !1 && ye.warn(109) : a.value.kind !== Bn.STRING ? globalThis.__DEV__ !== !1 && ye.warn(110) : a.value.value !== "migrate" && globalThis.__DEV__ !== !1 && ye.warn(111, a.value.value)), a && "value" in a.value && a.value.value === "migrate" ? "migrate" : "unmask";
}
const LW = () => /* @__PURE__ */ Object.create(null), { forEach: $W, slice: ug } = Array.prototype, { hasOwnProperty: UW } = Object.prototype;
class sa {
  constructor(n = !0, i = LW) {
    this.weakness = n, this.makeData = i;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(n) {
    let i = this;
    return $W.call(n, (t) => i = i.getChildTrie(t)), UW.call(i, "data") ? i.data : i.data = this.makeData(ug.call(n));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(n) {
    let i = this;
    for (let t = 0, a = n.length; i && t < a; ++t) {
      const s = i.mapFor(n[t], !1);
      i = s && s.get(n[t]);
    }
    return i && i.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(n) {
    let i;
    if (n.length) {
      const t = n[0], a = this.mapFor(t, !1), s = a && a.get(t);
      s && (i = s.removeArray(ug.call(n, 1)), !s.data && !s.weak && !(s.strong && s.strong.size) && a.delete(t));
    } else
      i = this.data, delete this.data;
    return i;
  }
  getChildTrie(n) {
    const i = this.mapFor(n, !0);
    let t = i.get(n);
    return t || i.set(n, t = new sa(this.weakness, this.makeData)), t;
  }
  mapFor(n, i) {
    return this.weakness && VW(n) ? this.weak || (i ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (i ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function VW(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
var HW = ia(function() {
  return navigator.product;
}) == "ReactNative", dl = typeof WeakMap == "function" && !(HW && !global.HermesInternal), bh = typeof WeakSet == "function", Ch = typeof Symbol == "function" && typeof Symbol.for == "function", i2 = Ch && Symbol.asyncIterator, zW = typeof ia(function() {
  return window.document.createElement;
}) == "function";
ia(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function fi(e) {
  return e !== null && typeof e == "object";
}
function sD(e) {
  return e !== null && typeof e == "object" && (Object.getPrototypeOf(e) === Object.prototype || Object.getPrototypeOf(e) === null);
}
function BW(e, n) {
  var i = n, t = [];
  e.definitions.forEach(function(s) {
    if (s.kind === "OperationDefinition")
      throw dt(
        112,
        s.operation,
        s.name ? " named '".concat(s.name.value, "'") : ""
      );
    s.kind === "FragmentDefinition" && t.push(s);
  }), typeof i == "undefined" && (ye(t.length === 1, 113, t.length), i = t[0].name.value);
  var a = G(G({}, e), { definitions: Oi([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: i
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return a;
}
function Jr(e) {
  e === void 0 && (e = []);
  var n = {};
  return e.forEach(function(i) {
    n[i.name.value] = i;
  }), n;
}
function t2(e, n) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var i = e.name.value;
      if (typeof n == "function")
        return n(i);
      var t = n && n[i];
      return ye(t, 114, i), t || null;
    }
    default:
      return null;
  }
}
function qW(e) {
  var n = !0;
  return Lt(e, {
    FragmentSpread: function(i) {
      if (n = !!i.directives && i.directives.some(function(t) {
        return t.name.value === "unmask";
      }), !n)
        return n2;
    }
  }), n;
}
function GW() {
}
class Hk {
  constructor(n = 1 / 0, i = GW) {
    this.max = n, this.dispose = i, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(n) {
    return this.map.has(n);
  }
  get(n) {
    const i = this.getNode(n);
    return i && i.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(n) {
    const i = this.map.get(n);
    if (i && i !== this.newest) {
      const { older: t, newer: a } = i;
      a && (a.older = t), t && (t.newer = a), i.older = this.newest, i.older.newer = i, i.newer = null, this.newest = i, i === this.oldest && (this.oldest = a);
    }
    return i;
  }
  set(n, i) {
    let t = this.getNode(n);
    return t ? t.value = i : (t = {
      key: n,
      value: i,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = t), this.newest = t, this.oldest = this.oldest || t, this.map.set(n, t), t.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(n) {
    const i = this.map.get(n);
    return i ? (i === this.newest && (this.newest = i.older), i === this.oldest && (this.oldest = i.newer), i.newer && (i.newer.older = i.older), i.older && (i.older.newer = i.newer), this.map.delete(n), this.dispose(i.value, n), !0) : !1;
  }
}
function zk() {
}
const WW = zk, KW = typeof WeakRef != "undefined" ? WeakRef : function(e) {
  return { deref: () => e };
}, YW = typeof WeakMap != "undefined" ? WeakMap : Map, XW = typeof FinalizationRegistry != "undefined" ? FinalizationRegistry : function() {
  return {
    register: zk,
    unregister: zk
  };
}, ZW = 10024;
class td {
  constructor(n = 1 / 0, i = WW) {
    this.max = n, this.dispose = i, this.map = new YW(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const t = this.unfinalizedNodes.values();
      for (let a = 0; a < ZW; a++) {
        const s = t.next().value;
        if (!s)
          break;
        this.unfinalizedNodes.delete(s);
        const r = s.key;
        delete s.key, s.keyRef = new KW(r), this.registry.register(r, s, s);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new XW(this.deleteNode.bind(this));
  }
  has(n) {
    return this.map.has(n);
  }
  get(n) {
    const i = this.getNode(n);
    return i && i.value;
  }
  getNode(n) {
    const i = this.map.get(n);
    if (i && i !== this.newest) {
      const { older: t, newer: a } = i;
      a && (a.older = t), t && (t.newer = a), i.older = this.newest, i.older.newer = i, i.newer = null, this.newest = i, i === this.oldest && (this.oldest = a);
    }
    return i;
  }
  set(n, i) {
    let t = this.getNode(n);
    return t ? t.value = i : (t = {
      key: n,
      value: i,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = t), this.newest = t, this.oldest = this.oldest || t, this.scheduleFinalization(t), this.map.set(n, t), this.size++, t.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(n) {
    n === this.newest && (this.newest = n.older), n === this.oldest && (this.oldest = n.newer), n.newer && (n.newer.older = n.older), n.older && (n.older.newer = n.newer), this.size--;
    const i = n.key || n.keyRef && n.keyRef.deref();
    this.dispose(n.value, i), n.keyRef ? this.registry.unregister(n) : this.unfinalizedNodes.delete(n), i && this.map.delete(i);
  }
  delete(n) {
    const i = this.map.get(n);
    return i ? (this.deleteNode(i), !0) : !1;
  }
  scheduleFinalization(n) {
    this.unfinalizedNodes.add(n), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var r3 = /* @__PURE__ */ new WeakSet();
function rD(e) {
  e.size <= (e.max || -1) || r3.has(e) || (r3.add(e), setTimeout(function() {
    e.clean(), r3.delete(e);
  }, 100));
}
var xh = function(e, n) {
  var i = new td(e, n);
  return i.set = function(t, a) {
    var s = td.prototype.set.call(this, t, a);
    return rD(this), s;
  }, i;
}, eK = function(e, n) {
  var i = new Hk(e, n);
  return i.set = function(t, a) {
    var s = Hk.prototype.set.call(this, t, a);
    return rD(this), s;
  }, i;
}, nK = Symbol.for("apollo.cacheSize"), ra = G({}, Vu[nK]), Rs = {};
function Dh(e, n) {
  Rs[e] = n;
}
var iK = globalThis.__DEV__ !== !1 ? sK : void 0, tK = globalThis.__DEV__ !== !1 ? rK : void 0, aK = globalThis.__DEV__ !== !1 ? oD : void 0;
function lK() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(n) {
    var i = n[0], t = n[1];
    return [
      i,
      ra[i] || t
    ];
  }));
}
function sK() {
  var e, n, i, t, a;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: lK(),
    sizes: G({ print: (e = Rs.print) === null || e === void 0 ? void 0 : e.call(Rs), parser: (n = Rs.parser) === null || n === void 0 ? void 0 : n.call(Rs), canonicalStringify: (i = Rs.canonicalStringify) === null || i === void 0 ? void 0 : i.call(Rs), links: qk(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: cD(this.queryManager.documentTransform)
    } }, (a = (t = this.cache).getMemoryInternals) === null || a === void 0 ? void 0 : a.call(t))
  };
}
function oD() {
  return {
    cache: {
      fragmentQueryDocuments: El(this.getFragmentDoc)
    }
  };
}
function rK() {
  var e = this.config.fragments;
  return G(G({}, oD.apply(this)), { addTypenameDocumentTransform: cD(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: El(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: El(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: El(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: El(e == null ? void 0 : e.findFragmentSpreads),
    lookup: El(e == null ? void 0 : e.lookup),
    transform: El(e == null ? void 0 : e.transform)
  } });
}
function oK(e) {
  return !!e && "dirtyKey" in e;
}
function El(e) {
  return oK(e) ? e.size : void 0;
}
function dD(e) {
  return e != null;
}
function cD(e) {
  return Bk(e).map(function(n) {
    return { cache: n };
  });
}
function Bk(e) {
  return e ? Oi(Oi([
    El(e == null ? void 0 : e.performWork)
  ], Bk(e == null ? void 0 : e.left), !0), Bk(e == null ? void 0 : e.right), !0).filter(dD) : [];
}
function qk(e) {
  var n;
  return e ? Oi(Oi([
    (n = e == null ? void 0 : e.getMemoryInternals) === null || n === void 0 ? void 0 : n.call(e)
  ], qk(e == null ? void 0 : e.left), !0), qk(e == null ? void 0 : e.right), !0).filter(dD) : [];
}
var il = Object.assign(function(n) {
  return JSON.stringify(n, dK);
}, {
  reset: function() {
    E1 = new eK(
      ra.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && Dh("canonicalStringify", function() {
  return E1.size;
});
var E1;
il.reset();
function dK(e, n) {
  if (n && typeof n == "object") {
    var i = Object.getPrototypeOf(n);
    if (i === Object.prototype || i === null) {
      var t = Object.keys(n);
      if (t.every(cK))
        return n;
      var a = JSON.stringify(t), s = E1.get(a);
      if (!s) {
        t.sort();
        var r = JSON.stringify(t);
        s = E1.get(r) || t, E1.set(a, s), E1.set(r, s);
      }
      var o = Object.create(i);
      return s.forEach(function(d) {
        o[d] = n[d];
      }), o;
    }
  }
  return n;
}
function cK(e, n, i) {
  return n === 0 || i[n - 1] <= e;
}
function V1(e) {
  return { __ref: String(e) };
}
function En(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function uK(e) {
  return fi(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function mK(e) {
  return e.kind === "StringValue";
}
function kK(e) {
  return e.kind === "BooleanValue";
}
function fK(e) {
  return e.kind === "IntValue";
}
function vK(e) {
  return e.kind === "FloatValue";
}
function hK(e) {
  return e.kind === "Variable";
}
function pK(e) {
  return e.kind === "ObjectValue";
}
function NK(e) {
  return e.kind === "ListValue";
}
function SK(e) {
  return e.kind === "EnumValue";
}
function gK(e) {
  return e.kind === "NullValue";
}
function rr(e, n, i, t) {
  if (fK(i) || vK(i))
    e[n.value] = Number(i.value);
  else if (kK(i) || mK(i))
    e[n.value] = i.value;
  else if (pK(i)) {
    var a = {};
    i.fields.map(function(r) {
      return rr(a, r.name, r.value, t);
    }), e[n.value] = a;
  } else if (hK(i)) {
    var s = (t || {})[i.name.value];
    e[n.value] = s;
  } else if (NK(i))
    e[n.value] = i.values.map(function(r) {
      var o = {};
      return rr(o, n, r, t), o[n.value];
    });
  else if (SK(i))
    e[n.value] = i.value;
  else if (gK(i))
    e[n.value] = null;
  else
    throw dt(123, n.value, i.kind);
}
function FK(e, n) {
  var i = null;
  e.directives && (i = {}, e.directives.forEach(function(a) {
    i[a.name.value] = {}, a.arguments && a.arguments.forEach(function(s) {
      var r = s.name, o = s.value;
      return rr(i[a.name.value], r, o, n);
    });
  }));
  var t = null;
  return e.arguments && e.arguments.length && (t = {}, e.arguments.forEach(function(a) {
    var s = a.name, r = a.value;
    return rr(t, s, r, n);
  })), uD(e.name.value, t, i);
}
var IK = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], ro = il, uD = Object.assign(function(e, n, i) {
  if (n && i && i.connection && i.connection.key)
    if (i.connection.filter && i.connection.filter.length > 0) {
      var t = i.connection.filter ? i.connection.filter : [];
      t.sort();
      var a = {};
      return t.forEach(function(o) {
        a[o] = n[o];
      }), "".concat(i.connection.key, "(").concat(ro(a), ")");
    } else
      return i.connection.key;
  var s = e;
  if (n) {
    var r = ro(n);
    s += "(".concat(r, ")");
  }
  return i && Object.keys(i).forEach(function(o) {
    IK.indexOf(o) === -1 && (i[o] && Object.keys(i[o]).length ? s += "@".concat(o, "(").concat(ro(i[o]), ")") : s += "@".concat(o));
  }), s;
}, {
  setStringify: function(e) {
    var n = ro;
    return ro = e, n;
  }
});
function a2(e, n) {
  if (e.arguments && e.arguments.length) {
    var i = {};
    return e.arguments.forEach(function(t) {
      var a = t.name, s = t.value;
      return rr(i, a, s, n);
    }), i;
  }
  return null;
}
function cl(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function Gk(e, n, i) {
  for (var t, a = 0, s = n.selections; a < s.length; a++) {
    var r = s[a];
    if (es(r)) {
      if (r.name.value === "__typename")
        return e[cl(r)];
    } else t ? t.push(r) : t = [r];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (t)
    for (var o = 0, d = t; o < d.length; o++) {
      var r = d[o], c = Gk(e, t2(r, i).selectionSet, i);
      if (typeof c == "string")
        return c;
    }
}
function es(e) {
  return e.kind === "Field";
}
function yK(e) {
  return e.kind === "InlineFragment";
}
function _r(e) {
  ye(e && e.kind === "Document", 115);
  var n = e.definitions.filter(function(i) {
    return i.kind !== "FragmentDefinition";
  }).map(function(i) {
    if (i.kind !== "OperationDefinition")
      throw dt(116, i.kind);
    return i;
  });
  return ye(n.length <= 1, 117, n.length), e;
}
function Ks(e) {
  return _r(e), e.definitions.filter(function(n) {
    return n.kind === "OperationDefinition";
  })[0];
}
function So(e) {
  return e.definitions.filter(function(n) {
    return n.kind === "OperationDefinition" && !!n.name;
  }).map(function(n) {
    return n.name.value;
  })[0] || null;
}
function Qr(e) {
  return e.definitions.filter(function(n) {
    return n.kind === "FragmentDefinition";
  });
}
function mD(e) {
  var n = Ks(e);
  return ye(n && n.operation === "query", 118), n;
}
function kD(e) {
  ye(e.kind === "Document", 119), ye(e.definitions.length <= 1, 120);
  var n = e.definitions[0];
  return ye(n.kind === "FragmentDefinition", 121), n;
}
function Ad(e) {
  _r(e);
  for (var n, i = 0, t = e.definitions; i < t.length; i++) {
    var a = t[i];
    if (a.kind === "OperationDefinition") {
      var s = a.operation;
      if (s === "query" || s === "mutation" || s === "subscription")
        return a;
    }
    a.kind === "FragmentDefinition" && !n && (n = a);
  }
  if (n)
    return n;
  throw dt(122);
}
function wh(e) {
  var n = /* @__PURE__ */ Object.create(null), i = e && e.variableDefinitions;
  return i && i.length && i.forEach(function(t) {
    t.defaultValue && rr(n, t.variable.name, t.defaultValue);
  }), n;
}
let Hi = null;
const mg = {};
let bK = 1;
const CK = () => class {
  constructor() {
    this.id = [
      "slot",
      bK++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let n = Hi; n; n = n.parent)
      if (this.id in n.slots) {
        const i = n.slots[this.id];
        if (i === mg)
          break;
        return n !== Hi && (Hi.slots[this.id] = i), !0;
      }
    return Hi && (Hi.slots[this.id] = mg), !1;
  }
  getValue() {
    if (this.hasValue())
      return Hi.slots[this.id];
  }
  withValue(n, i, t, a) {
    const s = {
      __proto__: null,
      [this.id]: n
    }, r = Hi;
    Hi = { parent: r, slots: s };
    try {
      return i.apply(a, t);
    } finally {
      Hi = r;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(n) {
    const i = Hi;
    return function() {
      const t = Hi;
      try {
        return Hi = i, n.apply(this, arguments);
      } finally {
        Hi = t;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(n, i, t) {
    if (Hi) {
      const a = Hi;
      try {
        return Hi = null, n.apply(t, i);
      } finally {
        Hi = a;
      }
    } else
      return n.apply(t, i);
  }
};
function kg(e) {
  try {
    return e();
  } catch (n) {
  }
}
const o3 = "@wry/context:Slot", xK = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  kg(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  kg(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), fg = xK, Mr = fg[o3] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[o3] || function(e) {
  try {
    Object.defineProperty(fg, o3, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
}(CK()), { bind: hDe, noContext: pDe } = Mr, l2 = new Mr(), { hasOwnProperty: DK } = Object.prototype, Ph = Array.from || function(e) {
  const n = [];
  return e.forEach((i) => n.push(i)), n;
};
function Rh(e) {
  const { unsubscribe: n } = e;
  typeof n == "function" && (e.unsubscribe = void 0, n());
}
const ad = [], wK = 100;
function or(e, n) {
  if (!e)
    throw new Error(n || "assertion failure");
}
function fD(e, n) {
  const i = e.length;
  return (
    // Unknown values are not equal to each other.
    i > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    i === n.length && // The underlying value or exception must be the same.
    e[i - 1] === n[i - 1]
  );
}
function vD(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function hD(e) {
  return e.slice(0);
}
class s2 {
  constructor(n) {
    this.fn = n, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++s2.count;
  }
  peek() {
    if (this.value.length === 1 && !ns(this))
      return vg(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(n) {
    return or(!this.recomputing, "already recomputing"), vg(this), ns(this) ? PK(this, n) : vD(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, pD(this), Rh(this));
  }
  dispose() {
    this.setDirty(), ID(this), Th(this, (n, i) => {
      n.setDirty(), yD(n, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(n) {
    n.add(this), this.deps || (this.deps = ad.pop() || /* @__PURE__ */ new Set()), this.deps.add(n);
  }
  forgetDeps() {
    this.deps && (Ph(this.deps).forEach((n) => n.delete(this)), this.deps.clear(), ad.push(this.deps), this.deps = null);
  }
}
s2.count = 0;
function vg(e) {
  const n = l2.getValue();
  if (n)
    return e.parents.add(n), n.childValues.has(e) || n.childValues.set(e, []), ns(e) ? SD(n, e) : gD(n, e), n;
}
function PK(e, n) {
  return ID(e), l2.withValue(e, RK, [e, n]), jK(e, n) && TK(e), vD(e.value);
}
function RK(e, n) {
  e.recomputing = !0;
  const { normalizeResult: i } = e;
  let t;
  i && e.value.length === 1 && (t = hD(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, n), i && t && !fD(t, e.value))
      try {
        e.value[0] = i(e.value[0], t[0]);
      } catch (a) {
      }
  } catch (a) {
    e.value[1] = a;
  }
  e.recomputing = !1;
}
function ns(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function TK(e) {
  e.dirty = !1, !ns(e) && ND(e);
}
function pD(e) {
  Th(e, SD);
}
function ND(e) {
  Th(e, gD);
}
function Th(e, n) {
  const i = e.parents.size;
  if (i) {
    const t = Ph(e.parents);
    for (let a = 0; a < i; ++a)
      n(t[a], e);
  }
}
function SD(e, n) {
  or(e.childValues.has(n)), or(ns(n));
  const i = !ns(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = ad.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(n))
    return;
  e.dirtyChildren.add(n), i && pD(e);
}
function gD(e, n) {
  or(e.childValues.has(n)), or(!ns(n));
  const i = e.childValues.get(n);
  i.length === 0 ? e.childValues.set(n, hD(n.value)) : fD(i, n.value) || e.setDirty(), FD(e, n), !ns(e) && ND(e);
}
function FD(e, n) {
  const i = e.dirtyChildren;
  i && (i.delete(n), i.size === 0 && (ad.length < wK && ad.push(i), e.dirtyChildren = null));
}
function ID(e) {
  e.childValues.size > 0 && e.childValues.forEach((n, i) => {
    yD(e, i);
  }), e.forgetDeps(), or(e.dirtyChildren === null);
}
function yD(e, n) {
  n.parents.delete(e), e.childValues.delete(n), FD(e, n);
}
function jK(e, n) {
  if (typeof e.subscribe == "function")
    try {
      Rh(e), e.unsubscribe = e.subscribe.apply(null, n);
    } catch (i) {
      return e.setDirty(), !1;
    }
  return !0;
}
const AK = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function bD(e) {
  const n = /* @__PURE__ */ new Map();
  function i(t) {
    const a = l2.getValue();
    if (a) {
      let s = n.get(t);
      s || n.set(t, s = /* @__PURE__ */ new Set()), a.dependOn(s);
    }
  }
  return i.dirty = function(a, s) {
    const r = n.get(a);
    if (r) {
      const o = s && DK.call(AK, s) ? s : "setDirty";
      Ph(r).forEach((d) => d[o]()), n.delete(a), Rh(r);
    }
  }, i;
}
let hg;
function OK(...e) {
  return (hg || (hg = new sa(typeof WeakMap == "function"))).lookupArray(e);
}
const d3 = /* @__PURE__ */ new Set();
function dr(e, { max: n = Math.pow(2, 16), keyArgs: i, makeCacheKey: t = OK, normalizeResult: a, subscribe: s, cache: r = Hk } = /* @__PURE__ */ Object.create(null)) {
  const o = typeof r == "function" ? new r(n, (m) => m.dispose()) : r, d = function() {
    const m = t.apply(null, i ? i.apply(null, arguments) : arguments);
    if (m === void 0)
      return e.apply(null, arguments);
    let f = o.get(m);
    f || (o.set(m, f = new s2(e)), f.normalizeResult = a, f.subscribe = s, f.forget = () => o.delete(m));
    const p = f.recompute(Array.prototype.slice.call(arguments));
    return o.set(m, f), d3.add(o), l2.hasValue() || (d3.forEach((h) => h.clean()), d3.clear()), p;
  };
  Object.defineProperty(d, "size", {
    get: () => o.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(d.options = {
    max: n,
    keyArgs: i,
    makeCacheKey: t,
    normalizeResult: a,
    subscribe: s,
    cache: o
  });
  function c(m) {
    const f = m && o.get(m);
    f && f.setDirty();
  }
  d.dirtyKey = c, d.dirty = function() {
    c(t.apply(null, arguments));
  };
  function u(m) {
    const f = m && o.get(m);
    if (f)
      return f.peek();
  }
  d.peekKey = u, d.peek = function() {
    return u(t.apply(null, arguments));
  };
  function k(m) {
    return m ? o.delete(m) : !1;
  }
  return d.forgetKey = k, d.forget = function() {
    return k(t.apply(null, arguments));
  }, d.makeCacheKey = t, d.getKey = i ? function() {
    return t.apply(null, i.apply(null, arguments));
  } : t, Object.freeze(d);
}
function EK(e) {
  return e;
}
var CD = (
  /** @class */
  function() {
    function e(n, i) {
      i === void 0 && (i = /* @__PURE__ */ Object.create(null)), this.resultCache = bh ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = n, i.getCacheKey && (this.getCacheKey = i.getCacheKey), this.cached = i.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(n) {
      return [n];
    }, e.identity = function() {
      return new e(EK, { cache: !1 });
    }, e.split = function(n, i, t) {
      return t === void 0 && (t = e.identity()), Object.assign(new e(
        function(a) {
          var s = n(a) ? i : t;
          return s.transformDocument(a);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: i, right: t });
    }, e.prototype.resetCache = function() {
      var n = this;
      if (this.cached) {
        var i = new sa(dl);
        this.performWork = dr(e.prototype.performWork.bind(this), {
          makeCacheKey: function(t) {
            var a = n.getCacheKey(t);
            if (a)
              return ye(Array.isArray(a), 104), i.lookupArray(a);
          },
          max: ra["documentTransform.cache"],
          cache: td
        });
      }
    }, e.prototype.performWork = function(n) {
      return _r(n), this.transform(n);
    }, e.prototype.transformDocument = function(n) {
      if (this.resultCache.has(n))
        return n;
      var i = this.performWork(n);
      return this.resultCache.add(i), i;
    }, e.prototype.concat = function(n) {
      var i = this;
      return Object.assign(new e(
        function(t) {
          return n.transformDocument(i.transformDocument(t));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: n
      });
    }, e;
  }()
), wo, Js = Object.assign(function(e) {
  var n = wo.get(e);
  return n || (n = jW(e), wo.set(e, n)), n;
}, {
  reset: function() {
    wo = new xh(
      ra.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
Js.reset();
globalThis.__DEV__ !== !1 && Dh("print", function() {
  return wo ? wo.size : 0;
});
var vi = Array.isArray;
function oa(e) {
  return Array.isArray(e) && e.length > 0;
}
var pg = {
  kind: Bn.FIELD,
  name: {
    kind: Bn.NAME,
    value: "__typename"
  }
};
function xD(e, n) {
  return !e || e.selectionSet.selections.every(function(i) {
    return i.kind === Bn.FRAGMENT_SPREAD && xD(n[i.name.value], n);
  });
}
function JK(e) {
  return xD(Ks(e) || kD(e), Jr(Qr(e))) ? null : e;
}
function _K(e) {
  var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  return e.forEach(function(t) {
    t && (t.name ? n.set(t.name, t) : t.test && i.set(t.test, t));
  }), function(t) {
    var a = n.get(t.name.value);
    return !a && i.size && i.forEach(function(s, r) {
      r(t) && (a = s);
    }), a;
  };
}
function Ng(e) {
  var n = /* @__PURE__ */ new Map();
  return function(t) {
    t === void 0 && (t = e);
    var a = n.get(t);
    return a || n.set(t, a = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), a;
  };
}
function DD(e, n) {
  _r(n);
  for (var i = Ng(""), t = Ng(""), a = function(S) {
    for (var F = 0, y = void 0; F < S.length && (y = S[F]); ++F)
      if (!vi(y)) {
        if (y.kind === Bn.OPERATION_DEFINITION)
          return i(y.name && y.name.value);
        if (y.kind === Bn.FRAGMENT_DEFINITION)
          return t(y.name.value);
      }
    return globalThis.__DEV__ !== !1 && ye.error(124), null;
  }, s = 0, r = n.definitions.length - 1; r >= 0; --r)
    n.definitions[r].kind === Bn.OPERATION_DEFINITION && ++s;
  var o = _K(e), d = function(S) {
    return oa(S) && S.map(o).some(function(F) {
      return F && F.remove;
    });
  }, c = /* @__PURE__ */ new Map(), u = !1, k = {
    enter: function(S) {
      if (d(S.directives))
        return u = !0, null;
    }
  }, m = Lt(n, {
    // These two AST node types share the same implementation, defined above.
    Field: k,
    InlineFragment: k,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(S, F, y, x, R) {
        var T = a(R);
        T && T.variables.add(S.name.value);
      }
    },
    FragmentSpread: {
      enter: function(S, F, y, x, R) {
        if (d(S.directives))
          return u = !0, null;
        var T = a(R);
        T && T.fragmentSpreads.add(S.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(S, F, y, x) {
        c.set(JSON.stringify(x), S);
      },
      leave: function(S, F, y, x) {
        var R = c.get(JSON.stringify(x));
        if (S === R)
          return S;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          s > 0 && S.selectionSet.selections.every(function(T) {
            return T.kind === Bn.FIELD && T.name.value === "__typename";
          })
        )
          return t(S.name.value).removed = !0, u = !0, null;
      }
    },
    Directive: {
      leave: function(S) {
        if (o(S))
          return u = !0, null;
      }
    }
  });
  if (!u)
    return n;
  var f = function(S) {
    return S.transitiveVars || (S.transitiveVars = new Set(S.variables), S.removed || S.fragmentSpreads.forEach(function(F) {
      f(t(F)).transitiveVars.forEach(function(y) {
        S.transitiveVars.add(y);
      });
    })), S;
  }, p = /* @__PURE__ */ new Set();
  m.definitions.forEach(function(S) {
    S.kind === Bn.OPERATION_DEFINITION ? f(i(S.name && S.name.value)).fragmentSpreads.forEach(function(F) {
      p.add(F);
    }) : S.kind === Bn.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    s === 0 && !t(S.name.value).removed && p.add(S.name.value);
  }), p.forEach(function(S) {
    f(t(S)).fragmentSpreads.forEach(function(F) {
      p.add(F);
    });
  });
  var h = function(S) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!p.has(S) || t(S).removed);
  }, N = {
    enter: function(S) {
      if (h(S.name.value))
        return null;
    }
  };
  return JK(Lt(m, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: N,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: N,
    OperationDefinition: {
      leave: function(S) {
        if (S.variableDefinitions) {
          var F = f(
            // If an operation is anonymous, we use the empty string as its key.
            i(S.name && S.name.value)
          ).transitiveVars;
          if (F.size < S.variableDefinitions.length)
            return G(G({}, S), { variableDefinitions: S.variableDefinitions.filter(function(y) {
              return F.has(y.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var jh = Object.assign(function(e) {
  return Lt(e, {
    SelectionSet: {
      enter: function(n, i, t) {
        if (!(t && t.kind === Bn.OPERATION_DEFINITION)) {
          var a = n.selections;
          if (a) {
            var s = a.some(function(o) {
              return es(o) && (o.name.value === "__typename" || o.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!s) {
              var r = t;
              if (!(es(r) && r.directives && r.directives.some(function(o) {
                return o.name.value === "export";
              })))
                return G(G({}, n), { selections: Oi(Oi([], a, !0), [pg], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === pg;
  }
});
function QK(e) {
  var n = Ad(e), i = n.operation;
  if (i === "query")
    return e;
  var t = Lt(e, {
    OperationDefinition: {
      enter: function(a) {
        return G(G({}, a), { operation: "query" });
      }
    }
  });
  return t;
}
function wD(e) {
  _r(e);
  var n = DD([
    {
      test: function(i) {
        return i.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return n;
}
function MK(e) {
  return _r(e), Lt(e, {
    FragmentSpread: function(n) {
      var i;
      if (!(!((i = n.directives) === null || i === void 0) && i.some(function(t) {
        return t.name.value === "unmask";
      })))
        return G(G({}, n), { directives: Oi(Oi([], n.directives || [], !0), [
          {
            kind: Bn.DIRECTIVE,
            name: { kind: Bn.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var LK = Object.prototype.hasOwnProperty;
function Sg() {
  for (var e = [], n = 0; n < arguments.length; n++)
    e[n] = arguments[n];
  return r2(e);
}
function r2(e) {
  var n = e[0] || {}, i = e.length;
  if (i > 1)
    for (var t = new is(), a = 1; a < i; ++a)
      n = t.merge(n, e[a]);
  return n;
}
var $K = function(e, n, i) {
  return this.merge(e[i], n[i]);
}, is = (
  /** @class */
  function() {
    function e(n) {
      n === void 0 && (n = $K), this.reconciler = n, this.isObject = fi, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(n, i) {
      for (var t = this, a = [], s = 2; s < arguments.length; s++)
        a[s - 2] = arguments[s];
      return fi(i) && fi(n) ? (Object.keys(i).forEach(function(r) {
        if (LK.call(n, r)) {
          var o = n[r];
          if (i[r] !== o) {
            var d = t.reconciler.apply(t, Oi([
              n,
              i,
              r
            ], a, !1));
            d !== o && (n = t.shallowCopyForMerge(n), n[r] = d);
          }
        } else
          n = t.shallowCopyForMerge(n), n[r] = i[r];
      }), n) : i;
    }, e.prototype.shallowCopyForMerge = function(n) {
      return fi(n) && (this.pastCopies.has(n) || (Array.isArray(n) ? n = n.slice(0) : n = G({ __proto__: Object.getPrototypeOf(n) }, n), this.pastCopies.add(n))), n;
    }, e;
  }()
);
function UK(e, n) {
  var i = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (i) return (i = i.call(e)).next.bind(i);
  if (Array.isArray(e) || (i = VK(e)) || n) {
    i && (e = i);
    var t = 0;
    return function() {
      return t >= e.length ? { done: !0 } : { done: !1, value: e[t++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VK(e, n) {
  if (e) {
    if (typeof e == "string") return gg(e, n);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set") return Array.from(e);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return gg(e, n);
  }
}
function gg(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var i = 0, t = new Array(n); i < n; i++)
    t[i] = e[i];
  return t;
}
function Fg(e, n) {
  for (var i = 0; i < n.length; i++) {
    var t = n[i];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
  }
}
function Ah(e, n, i) {
  return n && Fg(e.prototype, n), i && Fg(e, i), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Oh = function() {
  return typeof Symbol == "function";
}, Eh = function(e) {
  return Oh() && !!Symbol[e];
}, Jh = function(e) {
  return Eh(e) ? Symbol[e] : "@@" + e;
};
Oh() && !Eh("observable") && (Symbol.observable = Symbol("observable"));
var HK = Jh("iterator"), Wk = Jh("observable"), PD = Jh("species");
function Hu(e, n) {
  var i = e[n];
  if (i != null) {
    if (typeof i != "function") throw new TypeError(i + " is not a function");
    return i;
  }
}
function oo(e) {
  var n = e.constructor;
  return n !== void 0 && (n = n[PD], n === null && (n = void 0)), n !== void 0 ? n : $n;
}
function zK(e) {
  return e instanceof $n;
}
function cr(e) {
  cr.log ? cr.log(e) : setTimeout(function() {
    throw e;
  });
}
function Kc(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (n) {
      cr(n);
    }
  });
}
function RD(e) {
  var n = e._cleanup;
  if (n !== void 0 && (e._cleanup = void 0, !!n))
    try {
      if (typeof n == "function")
        n();
      else {
        var i = Hu(n, "unsubscribe");
        i && i.call(n);
      }
    } catch (t) {
      cr(t);
    }
}
function Kk(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function BK(e) {
  var n = e._queue;
  if (n) {
    e._queue = void 0, e._state = "ready";
    for (var i = 0; i < n.length && (TD(e, n[i].type, n[i].value), e._state !== "closed"); ++i)
      ;
  }
}
function TD(e, n, i) {
  e._state = "running";
  var t = e._observer;
  try {
    var a = Hu(t, n);
    switch (n) {
      case "next":
        a && a.call(t, i);
        break;
      case "error":
        if (Kk(e), a) a.call(t, i);
        else throw i;
        break;
      case "complete":
        Kk(e), a && a.call(t);
        break;
    }
  } catch (s) {
    cr(s);
  }
  e._state === "closed" ? RD(e) : e._state === "running" && (e._state = "ready");
}
function c3(e, n, i) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: n,
        value: i
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: n,
        value: i
      }], Kc(function() {
        return BK(e);
      });
      return;
    }
    TD(e, n, i);
  }
}
var qK = /* @__PURE__ */ function() {
  function e(i, t) {
    this._cleanup = void 0, this._observer = i, this._queue = void 0, this._state = "initializing";
    var a = new GK(this);
    try {
      this._cleanup = t.call(void 0, a);
    } catch (s) {
      a.error(s);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var n = e.prototype;
  return n.unsubscribe = function() {
    this._state !== "closed" && (Kk(this), RD(this));
  }, Ah(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
}(), GK = /* @__PURE__ */ function() {
  function e(i) {
    this._subscription = i;
  }
  var n = e.prototype;
  return n.next = function(t) {
    c3(this._subscription, "next", t);
  }, n.error = function(t) {
    c3(this._subscription, "error", t);
  }, n.complete = function() {
    c3(this._subscription, "complete");
  }, Ah(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
}(), $n = /* @__PURE__ */ function() {
  function e(i) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof i != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = i;
  }
  var n = e.prototype;
  return n.subscribe = function(t) {
    return (typeof t != "object" || t === null) && (t = {
      next: t,
      error: arguments[1],
      complete: arguments[2]
    }), new qK(t, this._subscriber);
  }, n.forEach = function(t) {
    var a = this;
    return new Promise(function(s, r) {
      if (typeof t != "function") {
        r(new TypeError(t + " is not a function"));
        return;
      }
      function o() {
        d.unsubscribe(), s();
      }
      var d = a.subscribe({
        next: function(c) {
          try {
            t(c, o);
          } catch (u) {
            r(u), d.unsubscribe();
          }
        },
        error: r,
        complete: s
      });
    });
  }, n.map = function(t) {
    var a = this;
    if (typeof t != "function") throw new TypeError(t + " is not a function");
    var s = oo(this);
    return new s(function(r) {
      return a.subscribe({
        next: function(o) {
          try {
            o = t(o);
          } catch (d) {
            return r.error(d);
          }
          r.next(o);
        },
        error: function(o) {
          r.error(o);
        },
        complete: function() {
          r.complete();
        }
      });
    });
  }, n.filter = function(t) {
    var a = this;
    if (typeof t != "function") throw new TypeError(t + " is not a function");
    var s = oo(this);
    return new s(function(r) {
      return a.subscribe({
        next: function(o) {
          try {
            if (!t(o)) return;
          } catch (d) {
            return r.error(d);
          }
          r.next(o);
        },
        error: function(o) {
          r.error(o);
        },
        complete: function() {
          r.complete();
        }
      });
    });
  }, n.reduce = function(t) {
    var a = this;
    if (typeof t != "function") throw new TypeError(t + " is not a function");
    var s = oo(this), r = arguments.length > 1, o = !1, d = arguments[1], c = d;
    return new s(function(u) {
      return a.subscribe({
        next: function(k) {
          var m = !o;
          if (o = !0, !m || r)
            try {
              c = t(c, k);
            } catch (f) {
              return u.error(f);
            }
          else
            c = k;
        },
        error: function(k) {
          u.error(k);
        },
        complete: function() {
          if (!o && !r) return u.error(new TypeError("Cannot reduce an empty sequence"));
          u.next(c), u.complete();
        }
      });
    });
  }, n.concat = function() {
    for (var t = this, a = arguments.length, s = new Array(a), r = 0; r < a; r++)
      s[r] = arguments[r];
    var o = oo(this);
    return new o(function(d) {
      var c, u = 0;
      function k(m) {
        c = m.subscribe({
          next: function(f) {
            d.next(f);
          },
          error: function(f) {
            d.error(f);
          },
          complete: function() {
            u === s.length ? (c = void 0, d.complete()) : k(o.from(s[u++]));
          }
        });
      }
      return k(t), function() {
        c && (c.unsubscribe(), c = void 0);
      };
    });
  }, n.flatMap = function(t) {
    var a = this;
    if (typeof t != "function") throw new TypeError(t + " is not a function");
    var s = oo(this);
    return new s(function(r) {
      var o = [], d = a.subscribe({
        next: function(u) {
          if (t)
            try {
              u = t(u);
            } catch (m) {
              return r.error(m);
            }
          var k = s.from(u).subscribe({
            next: function(m) {
              r.next(m);
            },
            error: function(m) {
              r.error(m);
            },
            complete: function() {
              var m = o.indexOf(k);
              m >= 0 && o.splice(m, 1), c();
            }
          });
          o.push(k);
        },
        error: function(u) {
          r.error(u);
        },
        complete: function() {
          c();
        }
      });
      function c() {
        d.closed && o.length === 0 && r.complete();
      }
      return function() {
        o.forEach(function(u) {
          return u.unsubscribe();
        }), d.unsubscribe();
      };
    });
  }, n[Wk] = function() {
    return this;
  }, e.from = function(t) {
    var a = typeof this == "function" ? this : e;
    if (t == null) throw new TypeError(t + " is not an object");
    var s = Hu(t, Wk);
    if (s) {
      var r = s.call(t);
      if (Object(r) !== r) throw new TypeError(r + " is not an object");
      return zK(r) && r.constructor === a ? r : new a(function(o) {
        return r.subscribe(o);
      });
    }
    if (Eh("iterator") && (s = Hu(t, HK), s))
      return new a(function(o) {
        Kc(function() {
          if (!o.closed) {
            for (var d = UK(s.call(t)), c; !(c = d()).done; ) {
              var u = c.value;
              if (o.next(u), o.closed) return;
            }
            o.complete();
          }
        });
      });
    if (Array.isArray(t))
      return new a(function(o) {
        Kc(function() {
          if (!o.closed) {
            for (var d = 0; d < t.length; ++d)
              if (o.next(t[d]), o.closed) return;
            o.complete();
          }
        });
      });
    throw new TypeError(t + " is not observable");
  }, e.of = function() {
    for (var t = arguments.length, a = new Array(t), s = 0; s < t; s++)
      a[s] = arguments[s];
    var r = typeof this == "function" ? this : e;
    return new r(function(o) {
      Kc(function() {
        if (!o.closed) {
          for (var d = 0; d < a.length; ++d)
            if (o.next(a[d]), o.closed) return;
          o.complete();
        }
      });
    });
  }, Ah(e, null, [{
    key: PD,
    get: function() {
      return this;
    }
  }]), e;
}();
Oh() && Object.defineProperty($n, Symbol("extensions"), {
  value: {
    symbol: Wk,
    hostReportError: cr
  },
  configurable: !0
});
function WK(e) {
  var n, i = e.Symbol;
  if (typeof i == "function")
    if (i.observable)
      n = i.observable;
    else {
      typeof i.for == "function" ? n = i.for("https://github.com/benlesh/symbol-observable") : n = i("https://github.com/benlesh/symbol-observable");
      try {
        i.observable = n;
      } catch (t) {
      }
    }
  else
    n = "@@observable";
  return n;
}
var D1;
typeof self != "undefined" ? D1 = self : typeof window != "undefined" ? D1 = window : typeof global != "undefined" ? D1 = global : typeof module != "undefined" ? D1 = module : D1 = Function("return this")();
WK(D1);
var Ig = $n.prototype, yg = "@@observable";
Ig[yg] || (Ig[yg] = function() {
  return this;
});
function Po(e) {
  var n = Promise.resolve(e);
  return n.status = "fulfilled", n.value = e, n;
}
function KK(e) {
  var n = Promise.reject(e);
  return n.catch(function() {
  }), n.status = "rejected", n.reason = e, n;
}
function YK(e) {
  return "status" in e;
}
function _h(e) {
  if (YK(e))
    return e;
  var n = e;
  return n.status = "pending", n.then(function(i) {
    if (n.status === "pending") {
      var t = n;
      t.status = "fulfilled", t.value = i;
    }
  }, function(i) {
    if (n.status === "pending") {
      var t = n;
      t.status = "rejected", t.reason = i;
    }
  }), e;
}
function XK(e) {
  return e.catch(function() {
  }), e;
}
var ZK = Object.prototype.toString;
function jD(e) {
  return Yk(e);
}
function Yk(e, n) {
  switch (ZK.call(e)) {
    case "[object Array]": {
      if (n = n || /* @__PURE__ */ new Map(), n.has(e))
        return n.get(e);
      var i = e.slice(0);
      return n.set(e, i), i.forEach(function(a, s) {
        i[s] = Yk(a, n);
      }), i;
    }
    case "[object Object]": {
      if (n = n || /* @__PURE__ */ new Map(), n.has(e))
        return n.get(e);
      var t = Object.create(Object.getPrototypeOf(e));
      return n.set(e, t), Object.keys(e).forEach(function(a) {
        t[a] = Yk(e[a], n);
      }), t;
    }
    default:
      return e;
  }
}
function eY(e) {
  var n = /* @__PURE__ */ new Set([e]);
  return n.forEach(function(i) {
    fi(i) && nY(i) === i && Object.getOwnPropertyNames(i).forEach(function(t) {
      fi(i[t]) && n.add(i[t]);
    });
  }), e;
}
function nY(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (n) {
      if (n instanceof TypeError)
        return null;
      throw n;
    }
  return e;
}
function zu(e) {
  return globalThis.__DEV__ !== !1 && eY(e), e;
}
function Ro(e, n, i) {
  var t = [];
  e.forEach(function(a) {
    return a[n] && t.push(a);
  }), t.forEach(function(a) {
    return a[n](i);
  });
}
function u3(e, n, i) {
  return new $n(function(t) {
    var a = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(d) {
        return new Promise(function(c) {
          return c(d());
        });
      }
    };
    function s(d, c) {
      return function(u) {
        if (d) {
          var k = function() {
            return t.closed ? (
              /* will be swallowed */
              0
            ) : d(u);
          };
          a = a.then(k, k).then(function(m) {
            return t.next(m);
          }, function(m) {
            return t.error(m);
          });
        } else
          t[c](u);
      };
    }
    var r = {
      next: s(n, "next"),
      error: s(i, "error"),
      complete: function() {
        a.then(function() {
          return t.complete();
        });
      }
    }, o = e.subscribe(r);
    return function() {
      return o.unsubscribe();
    };
  });
}
function AD(e) {
  function n(i) {
    Object.defineProperty(e, i, { value: $n });
  }
  return Ch && Symbol.species && n(Symbol.species), n("@@species"), e;
}
function bg(e) {
  return e && typeof e.then == "function";
}
var w1 = (
  /** @class */
  function(e) {
    ca(n, e);
    function n(i) {
      var t = e.call(this, function(a) {
        return t.addObserver(a), function() {
          return t.removeObserver(a);
        };
      }) || this;
      return t.observers = /* @__PURE__ */ new Set(), t.promise = new Promise(function(a, s) {
        t.resolve = a, t.reject = s;
      }), t.handlers = {
        next: function(a) {
          t.sub !== null && (t.latest = ["next", a], t.notify("next", a), Ro(t.observers, "next", a));
        },
        error: function(a) {
          var s = t.sub;
          s !== null && (s && setTimeout(function() {
            return s.unsubscribe();
          }), t.sub = null, t.latest = ["error", a], t.reject(a), t.notify("error", a), Ro(t.observers, "error", a));
        },
        complete: function() {
          var a = t, s = a.sub, r = a.sources, o = r === void 0 ? [] : r;
          if (s !== null) {
            var d = o.shift();
            d ? bg(d) ? d.then(function(c) {
              return t.sub = c.subscribe(t.handlers);
            }, t.handlers.error) : t.sub = d.subscribe(t.handlers) : (s && setTimeout(function() {
              return s.unsubscribe();
            }), t.sub = null, t.latest && t.latest[0] === "next" ? t.resolve(t.latest[1]) : t.resolve(), t.notify("complete"), Ro(t.observers, "complete"));
          }
        }
      }, t.nextResultListeners = /* @__PURE__ */ new Set(), t.cancel = function(a) {
        t.reject(a), t.sources = [], t.handlers.error(a);
      }, t.promise.catch(function(a) {
      }), typeof i == "function" && (i = [new $n(i)]), bg(i) ? i.then(function(a) {
        return t.start(a);
      }, t.handlers.error) : t.start(i), t;
    }
    return n.prototype.start = function(i) {
      this.sub === void 0 && (this.sources = Array.from(i), this.handlers.complete());
    }, n.prototype.deliverLastMessage = function(i) {
      if (this.latest) {
        var t = this.latest[0], a = i[t];
        a && a.call(i, this.latest[1]), this.sub === null && t === "next" && i.complete && i.complete();
      }
    }, n.prototype.addObserver = function(i) {
      this.observers.has(i) || (this.deliverLastMessage(i), this.observers.add(i));
    }, n.prototype.removeObserver = function(i) {
      this.observers.delete(i) && this.observers.size < 1 && this.handlers.complete();
    }, n.prototype.notify = function(i, t) {
      var a = this.nextResultListeners;
      a.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), a.forEach(function(s) {
        return s(i, t);
      }));
    }, n.prototype.beforeNext = function(i) {
      var t = !1;
      this.nextResultListeners.add(function(a, s) {
        t || (t = !0, i(a, s));
      });
    }, n;
  }($n)
);
AD(w1);
function H1(e) {
  return "incremental" in e;
}
function iY(e) {
  return "hasNext" in e && "data" in e;
}
function tY(e) {
  return H1(e) || iY(e);
}
function aY(e) {
  return fi(e) && "payload" in e;
}
function OD(e, n) {
  var i = e, t = new is();
  return H1(n) && oa(n.incremental) && n.incremental.forEach(function(a) {
    for (var s = a.data, r = a.path, o = r.length - 1; o >= 0; --o) {
      var d = r[o], c = !isNaN(+d), u = c ? [] : {};
      u[d] = s, s = u;
    }
    i = t.merge(i, s);
  }), i;
}
function Yc(e) {
  var n = Xk(e);
  return oa(n);
}
function Xk(e) {
  var n = oa(e.errors) ? e.errors.slice(0) : [];
  return H1(e) && oa(e.incremental) && e.incremental.forEach(function(i) {
    i.errors && n.push.apply(n, i.errors);
  }), n;
}
function ur() {
  for (var e = [], n = 0; n < arguments.length; n++)
    e[n] = arguments[n];
  var i = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(t) {
    t && Object.keys(t).forEach(function(a) {
      var s = t[a];
      s !== void 0 && (i[a] = s);
    });
  }), i;
}
function Xc(e, n) {
  return ur(e, n, n.variables && {
    variables: ur(G(G({}, e && e.variables), n.variables))
  });
}
function lY(e, n) {
  return Zk(e, n);
}
function Zk(e, n, i) {
  if (i === void 0 && (i = /* @__PURE__ */ new Map()), i.has(e))
    return i.get(e);
  var t = !1;
  if (Array.isArray(e)) {
    var a = [];
    if (i.set(e, a), e.forEach(function(r, o) {
      var d = Zk(r, n, i);
      t || (t = d !== r), a[o] = d;
    }), t)
      return a;
  } else if (sD(e)) {
    var s = Object.create(Object.getPrototypeOf(e));
    if (i.set(e, s), Object.keys(e).forEach(function(r) {
      if (r === n) {
        t = !0;
        return;
      }
      var o = Zk(e[r], n, i);
      t || (t = o !== e[r]), s[r] = o;
    }), t)
      return s;
  }
  return e;
}
function Qh(e) {
  return lY(e, "__typename");
}
var m3, sY = Symbol.for("apollo.deprecations"), Cg = Symbol.for("apollo.deprecations.slot"), ef = Vu, nf = (m3 = ef[Cg]) !== null && m3 !== void 0 ? m3 : ef[Cg] = new Mr();
function rY(e) {
  return ef[sY] || (nf.getValue() || []).includes(e);
}
function Ai(e) {
  for (var n = [], i = 1; i < arguments.length; i++)
    n[i - 1] = arguments[i];
  return nf.withValue.apply(nf, Oi([Array.isArray(e) ? e : [e]], n, !1));
}
function ki(e, n, i, t) {
  t === void 0 && (t = "Please remove this option."), Jl(n, function() {
    n in e && globalThis.__DEV__ !== !1 && ye.warn(103, i, n, t);
  });
}
function Jl(e, n) {
  rY(e) || n();
}
function k3(e) {
  return new $n(function(n) {
    n.error(e);
  });
}
var ED = function(e, n, i) {
  var t = new Error(i);
  throw t.name = "ServerError", t.response = e, t.statusCode = e.status, t.result = n, t;
};
function oY(e) {
  for (var n = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], i = 0, t = Object.keys(e); i < t.length; i++) {
    var a = t[i];
    if (n.indexOf(a) < 0)
      throw dt(58, a);
  }
  return e;
}
function dY(e, n) {
  var i = G({}, e), t = function(s) {
    typeof s == "function" ? i = G(G({}, i), s(i)) : i = G(G({}, i), s);
  }, a = function() {
    return G({}, i);
  };
  return Object.defineProperty(n, "setContext", {
    enumerable: !1,
    value: t
  }), Object.defineProperty(n, "getContext", {
    enumerable: !1,
    value: a
  }), n;
}
function cY(e) {
  var n = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return n.operationName || (n.operationName = typeof n.query != "string" ? So(n.query) || void 0 : ""), n;
}
function uY(e, n) {
  var i = G({}, e), t = new Set(Object.keys(e));
  return Lt(n, {
    Variable: function(a, s, r) {
      r && r.kind !== "VariableDefinition" && t.delete(a.name.value);
    }
  }), t.forEach(function(a) {
    delete i[a];
  }), i;
}
function xg(e, n) {
  return n ? n(e) : $n.of();
}
function co(e) {
  return typeof e == "function" ? new Ha(e) : e;
}
function Cc(e) {
  return e.request.length <= 1;
}
var Ha = (
  /** @class */
  function() {
    function e(n) {
      n && (this.request = n);
    }
    return e.empty = function() {
      return new e(function() {
        return $n.of();
      });
    }, e.from = function(n) {
      return n.length === 0 ? e.empty() : n.map(co).reduce(function(i, t) {
        return i.concat(t);
      });
    }, e.split = function(n, i, t) {
      var a = co(i), s = co(t || new e(xg)), r;
      return Cc(a) && Cc(s) ? r = new e(function(o) {
        return n(o) ? a.request(o) || $n.of() : s.request(o) || $n.of();
      }) : r = new e(function(o, d) {
        return n(o) ? a.request(o, d) || $n.of() : s.request(o, d) || $n.of();
      }), Object.assign(r, { left: a, right: s });
    }, e.execute = function(n, i) {
      return n.request(dY(i.context, cY(oY(i)))) || $n.of();
    }, e.concat = function(n, i) {
      var t = co(n);
      if (Cc(t))
        return globalThis.__DEV__ !== !1 && ye.warn(47, t), t;
      var a = co(i), s;
      return Cc(a) ? s = new e(function(r) {
        return t.request(r, function(o) {
          return a.request(o) || $n.of();
        }) || $n.of();
      }) : s = new e(function(r, o) {
        return t.request(r, function(d) {
          return a.request(d, o) || $n.of();
        }) || $n.of();
      }), Object.assign(s, { left: t, right: a });
    }, e.prototype.split = function(n, i, t) {
      return this.concat(e.split(n, i, t || new e(xg)));
    }, e.prototype.concat = function(n) {
      return e.concat(this, n);
    }, e.prototype.request = function(n, i) {
      throw dt(48);
    }, e.prototype.onError = function(n, i) {
      if (globalThis.__DEV__ !== !1 && Jl("onError", function() {
        globalThis.__DEV__ !== !1 && ye.warn(49);
      }), i && i.error)
        return i.error(n), !1;
      throw n;
    }, e.prototype.setOnError = function(n) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ye.warn(50), this.onError = n, this;
    }, e;
  }()
), Mh = Ha.from, tf = Ha.execute;
function mY(e) {
  var n, i = e[Symbol.asyncIterator]();
  return n = {
    next: function() {
      return i.next();
    }
  }, n[Symbol.asyncIterator] = function() {
    return this;
  }, n;
}
function kY(e) {
  var n = null, i = null, t = !1, a = [], s = [];
  function r(k) {
    if (!i) {
      if (s.length) {
        var m = s.shift();
        if (Array.isArray(m) && m[0])
          return m[0]({ value: k, done: !1 });
      }
      a.push(k);
    }
  }
  function o(k) {
    i = k;
    var m = s.slice();
    m.forEach(function(f) {
      f[1](k);
    }), !n || n();
  }
  function d() {
    t = !0;
    var k = s.slice();
    k.forEach(function(m) {
      m[0]({ value: void 0, done: !0 });
    }), !n || n();
  }
  n = function() {
    n = null, e.removeListener("data", r), e.removeListener("error", o), e.removeListener("end", d), e.removeListener("finish", d), e.removeListener("close", d);
  }, e.on("data", r), e.on("error", o), e.on("end", d), e.on("finish", d), e.on("close", d);
  function c() {
    return new Promise(function(k, m) {
      if (i)
        return m(i);
      if (a.length)
        return k({ value: a.shift(), done: !1 });
      if (t)
        return k({ value: void 0, done: !0 });
      s.push([k, m]);
    });
  }
  var u = {
    next: function() {
      return c();
    }
  };
  return i2 && (u[Symbol.asyncIterator] = function() {
    return this;
  }), u;
}
function fY(e) {
  var n = !1, i = {
    next: function() {
      return n ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (n = !0, new Promise(function(t, a) {
        e.then(function(s) {
          t({ value: s, done: !1 });
        }).catch(a);
      }));
    }
  };
  return i2 && (i[Symbol.asyncIterator] = function() {
    return this;
  }), i;
}
function Dg(e) {
  var n = {
    next: function() {
      return e.read();
    }
  };
  return i2 && (n[Symbol.asyncIterator] = function() {
    return this;
  }), n;
}
function vY(e) {
  return !!e.body;
}
function hY(e) {
  return !!e.getReader;
}
function pY(e) {
  return !!(i2 && e[Symbol.asyncIterator]);
}
function NY(e) {
  return !!e.stream;
}
function SY(e) {
  return !!e.arrayBuffer;
}
function gY(e) {
  return !!e.pipe;
}
function FY(e) {
  var n = e;
  if (vY(e) && (n = e.body), pY(n))
    return mY(n);
  if (hY(n))
    return Dg(n.getReader());
  if (NY(n))
    return Dg(n.stream().getReader());
  if (SY(n))
    return fY(n.arrayBuffer());
  if (gY(n))
    return kY(n);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var o2 = Symbol();
function JD(e) {
  return e.extensions ? Array.isArray(e.extensions[o2]) : !1;
}
function _D(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var IY = function(e) {
  var n = Oi(Oi(Oi([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && n.push(e.networkError), n.map(function(i) {
    return fi(i) && i.message || "Error message not found.";
  }).join(`
`);
}, Sa = (
  /** @class */
  function(e) {
    ca(n, e);
    function n(i) {
      var t = i.graphQLErrors, a = i.protocolErrors, s = i.clientErrors, r = i.networkError, o = i.errorMessage, d = i.extraInfo, c = e.call(this, o) || this;
      return c.name = "ApolloError", c.graphQLErrors = t || [], c.protocolErrors = a || [], c.clientErrors = s || [], c.networkError = r || null, c.message = o || IY(c), c.extraInfo = d, c.cause = Oi(Oi(Oi([
        r
      ], t || [], !0), a || [], !0), s || [], !0).find(function(u) {
        return !!u;
      }) || null, c.__proto__ = n.prototype, c;
    }
    return n;
  }(Error)
), wg = Object.prototype.hasOwnProperty;
function yY(e, n) {
  return jl(this, void 0, void 0, function() {
    var i, t, a, s, r, o, d, c, u, k, m, f, p, h, N, S, F, y, x, R, T, j, A, B;
    return Al(this, function(W) {
      switch (W.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          i = new TextDecoder("utf-8"), t = (B = e.headers) === null || B === void 0 ? void 0 : B.get("content-type"), a = "boundary=", s = t != null && t.includes(a) ? t == null ? void 0 : t.substring((t == null ? void 0 : t.indexOf(a)) + a.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", r = `\r
--`.concat(s), o = "", d = FY(e), c = !0, W.label = 1;
        case 1:
          return c ? [4, d.next()] : [3, 3];
        case 2:
          for (u = W.sent(), k = u.value, m = u.done, f = typeof k == "string" ? k : i.decode(k), p = o.length - r.length + 1, c = !m, o += f, h = o.indexOf(r, p); h > -1; ) {
            if (N = void 0, j = [
              o.slice(0, h),
              o.slice(h + r.length)
            ], N = j[0], o = j[1], S = N.indexOf(`\r
\r
`), F = bY(N.slice(0, S)), y = F["content-type"], y && y.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (x = N.slice(S), x) {
              if (R = QD(e, x), Object.keys(R).length > 1 || "data" in R || "incremental" in R || "errors" in R || "payload" in R)
                if (aY(R)) {
                  if (T = {}, "payload" in R) {
                    if (Object.keys(R).length === 1 && R.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    T = G({}, R.payload);
                  }
                  "errors" in R && (T = G(G({}, T), { extensions: G(G({}, "extensions" in T ? T.extensions : null), (A = {}, A[o2] = R.errors, A)) })), n(T);
                } else
                  n(R);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(R).length === 1 && "hasNext" in R && !R.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            h = o.indexOf(r);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function bY(e) {
  var n = {};
  return e.split(`
`).forEach(function(i) {
    var t = i.indexOf(":");
    if (t > -1) {
      var a = i.slice(0, t).trim().toLowerCase(), s = i.slice(t + 1).trim();
      n[a] = s;
    }
  }), n;
}
function QD(e, n) {
  if (e.status >= 300) {
    var i = function() {
      try {
        return JSON.parse(n);
      } catch (a) {
        return n;
      }
    };
    ED(e, i(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(n);
  } catch (a) {
    var t = a;
    throw t.name = "ServerParseError", t.response = e, t.statusCode = e.status, t.bodyText = n, t;
  }
}
function CY(e, n) {
  e.result && e.result.errors && e.result.data && n.next(e.result), n.error(e);
}
function xY(e) {
  return function(n) {
    return n.text().then(function(i) {
      return QD(n, i);
    }).then(function(i) {
      return !Array.isArray(i) && !wg.call(i, "data") && !wg.call(i, "errors") && ED(n, i, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(t) {
        return t.operationName;
      }) : e.operationName, "'.")), i;
    });
  };
}
var af = function(e, n) {
  var i;
  try {
    i = JSON.stringify(e);
  } catch (a) {
    var t = dt(54, n, a.message);
    throw t.parseError = a, t;
  }
  return i;
}, DY = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, wY = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, PY = {
  method: "POST"
}, RY = {
  http: DY,
  headers: wY,
  options: PY
}, TY = function(e, n) {
  return n(e);
};
function jY(e, n) {
  for (var i = [], t = 2; t < arguments.length; t++)
    i[t - 2] = arguments[t];
  var a = {}, s = {};
  i.forEach(function(k) {
    a = G(G(G({}, a), k.options), { headers: G(G({}, a.headers), k.headers) }), k.credentials && (a.credentials = k.credentials), s = G(G({}, s), k.http);
  }), a.headers && (a.headers = AY(a.headers, s.preserveHeaderCase));
  var r = e.operationName, o = e.extensions, d = e.variables, c = e.query, u = { operationName: r, variables: d };
  return s.includeExtensions && (u.extensions = o), s.includeQuery && (u.query = n(c, Js)), {
    options: a,
    body: u
  };
}
function AY(e, n) {
  if (!n) {
    var i = {};
    return Object.keys(Object(e)).forEach(function(s) {
      i[s.toLowerCase()] = e[s];
    }), i;
  }
  var t = {};
  Object.keys(Object(e)).forEach(function(s) {
    t[s.toLowerCase()] = {
      originalName: s,
      value: e[s]
    };
  });
  var a = {};
  return Object.keys(t).forEach(function(s) {
    a[t[s].originalName] = t[s].value;
  }), a;
}
var OY = function(e) {
  if (!e && typeof fetch == "undefined")
    throw dt(51);
}, EY = function(e, n) {
  var i = e.getContext(), t = i.uri;
  return t || (typeof n == "function" ? n(e) : n || "/graphql");
};
function JY(e, n) {
  var i = [], t = function(k, m) {
    i.push("".concat(k, "=").concat(encodeURIComponent(m)));
  };
  if ("query" in n && t("query", n.query), n.operationName && t("operationName", n.operationName), n.variables) {
    var a = void 0;
    try {
      a = af(n.variables, "Variables map");
    } catch (k) {
      return { parseError: k };
    }
    t("variables", a);
  }
  if (n.extensions) {
    var s = void 0;
    try {
      s = af(n.extensions, "Extensions map");
    } catch (k) {
      return { parseError: k };
    }
    t("extensions", s);
  }
  var r = "", o = e, d = e.indexOf("#");
  d !== -1 && (r = e.substr(d), o = e.substr(0, d));
  var c = o.indexOf("?") === -1 ? "?" : "&", u = o + c + i.join("&") + r;
  return { newURI: u };
}
var Pg = ia(function() {
  return fetch;
}), d2 = function(e) {
  e === void 0 && (e = {});
  var n = e.uri, i = n === void 0 ? "/graphql" : n, t = e.fetch, a = e.print, s = a === void 0 ? TY : a, r = e.includeExtensions, o = e.preserveHeaderCase, d = e.useGETForQueries, c = e.includeUnusedVariables, u = c === void 0 ? !1 : c, k = Mt(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && OY(t || Pg);
  var m = {
    http: { includeExtensions: r, preserveHeaderCase: o },
    options: k.fetchOptions,
    credentials: k.credentials,
    headers: k.headers
  };
  return new Ha(function(f) {
    var p = EY(f, i), h = f.getContext(), N = {};
    if (h.clientAwareness) {
      var S = h.clientAwareness, F = S.name, y = S.version;
      F && (N["apollographql-client-name"] = F), y && (N["apollographql-client-version"] = y);
    }
    var x = G(G({}, N), h.headers), R = {
      http: h.http,
      options: h.fetchOptions,
      credentials: h.credentials,
      headers: x
    };
    if (id(["client"], f.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ye.warn(52);
      var T = wD(f.query);
      if (!T)
        return k3(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      f.query = T;
    }
    var j = jY(f, s, RY, m, R), A = j.options, B = j.body;
    B.variables && !u && (B.variables = uY(B.variables, f.query));
    var W;
    !A.signal && typeof AbortController != "undefined" && (W = new AbortController(), A.signal = W.signal);
    var E = function(z) {
      return z.kind === "OperationDefinition" && z.operation === "mutation";
    }, $ = function(z) {
      return z.kind === "OperationDefinition" && z.operation === "subscription";
    }, V = $(Ad(f.query)), H = id(["defer"], f.query);
    if (d && !f.query.definitions.some(E) && (A.method = "GET"), H || V) {
      A.headers = A.headers || {};
      var O = "multipart/mixed;";
      V && H && globalThis.__DEV__ !== !1 && ye.warn(53), V ? O += "boundary=graphql;subscriptionSpec=1.0,application/json" : H && (O += "deferSpec=20220824,application/json"), A.headers.accept = O;
    }
    if (A.method === "GET") {
      var M = JY(p, B), L = M.newURI, _ = M.parseError;
      if (_)
        return k3(_);
      p = L;
    } else
      try {
        A.body = af(B, "Payload");
      } catch (z) {
        return k3(z);
      }
    return new $n(function(z) {
      var ne = t || ia(function() {
        return fetch;
      }) || Pg, Se = z.next.bind(z);
      return ne(p, A).then(function(he) {
        var ue;
        f.setContext({ response: he });
        var oe = (ue = he.headers) === null || ue === void 0 ? void 0 : ue.get("content-type");
        return oe !== null && /^multipart\/mixed/i.test(oe) ? yY(he, Se) : xY(f)(he).then(Se);
      }).then(function() {
        W = void 0, z.complete();
      }).catch(function(he) {
        W = void 0, CY(he, z);
      }), function() {
        W && W.abort();
      };
    });
  });
}, _Y = (
  /** @class */
  function(e) {
    ca(n, e);
    function n(i) {
      i === void 0 && (i = {});
      var t = e.call(this, d2(i).request) || this;
      return t.options = i, t;
    }
    return n;
  }(Ha)
);
const { toString: Rg, hasOwnProperty: QY } = Object.prototype, Tg = Function.prototype.toString, lf = /* @__PURE__ */ new Map();
function Dn(e, n) {
  try {
    return sf(e, n);
  } finally {
    lf.clear();
  }
}
function sf(e, n) {
  if (e === n)
    return !0;
  const i = Rg.call(e), t = Rg.call(n);
  if (i !== t)
    return !1;
  switch (i) {
    case "[object Array]":
      if (e.length !== n.length)
        return !1;
    case "[object Object]": {
      if (Ag(e, n))
        return !0;
      const a = jg(e), s = jg(n), r = a.length;
      if (r !== s.length)
        return !1;
      for (let o = 0; o < r; ++o)
        if (!QY.call(n, a[o]))
          return !1;
      for (let o = 0; o < r; ++o) {
        const d = a[o];
        if (!sf(e[d], n[d]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === n.name && e.message === n.message;
    case "[object Number]":
      if (e !== e)
        return n !== n;
    case "[object Boolean]":
    case "[object Date]":
      return +e == +n;
    case "[object RegExp]":
    case "[object String]":
      return e == `${n}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== n.size)
        return !1;
      if (Ag(e, n))
        return !0;
      const a = e.entries(), s = i === "[object Map]";
      for (; ; ) {
        const r = a.next();
        if (r.done)
          break;
        const [o, d] = r.value;
        if (!n.has(o) || s && !sf(d, n.get(o)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), n = new Uint8Array(n);
    case "[object DataView]": {
      let a = e.byteLength;
      if (a === n.byteLength)
        for (; a-- && e[a] === n[a]; )
          ;
      return a === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const a = Tg.call(e);
      return a !== Tg.call(n) ? !1 : !$Y(a, LY);
    }
  }
  return !1;
}
function jg(e) {
  return Object.keys(e).filter(MY, e);
}
function MY(e) {
  return this[e] !== void 0;
}
const LY = "{ [native code] }";
function $Y(e, n) {
  const i = e.length - n.length;
  return i >= 0 && e.indexOf(n, i) === i;
}
function Ag(e, n) {
  let i = lf.get(e);
  if (i) {
    if (i.has(n))
      return !0;
  } else
    lf.set(e, i = /* @__PURE__ */ new Set());
  return i.add(n), !1;
}
function MD(e, n, i, t) {
  var a = n.data, s = Mt(n, ["data"]), r = i.data, o = Mt(i, ["data"]);
  return Dn(s, o) && Zc(Ad(e).selectionSet, a, r, {
    fragmentMap: Jr(Qr(e)),
    variables: t
  });
}
function Zc(e, n, i, t) {
  if (n === i)
    return !0;
  var a = /* @__PURE__ */ new Set();
  return e.selections.every(function(s) {
    if (a.has(s) || (a.add(s), !jd(s, t.variables)) || Og(s))
      return !0;
    if (es(s)) {
      var r = cl(s), o = n && n[r], d = i && i[r], c = s.selectionSet;
      if (!c)
        return Dn(o, d);
      var u = Array.isArray(o), k = Array.isArray(d);
      if (u !== k)
        return !1;
      if (u && k) {
        var m = o.length;
        if (d.length !== m)
          return !1;
        for (var f = 0; f < m; ++f)
          if (!Zc(c, o[f], d[f], t))
            return !1;
        return !0;
      }
      return Zc(c, o, d, t);
    } else {
      var p = t2(s, t.fragmentMap);
      if (p)
        return Og(p) ? !0 : Zc(
          p.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          n,
          i,
          t
        );
    }
  });
}
function Og(e) {
  return !!e.directives && e.directives.some(UY);
}
function UY(e) {
  return e.name.value === "nonreactive";
}
var LD = dl ? WeakMap : Map, $D = bh ? WeakSet : Set, Lh = new Mr(), Eg = !1;
function UD() {
  Eg || (Eg = !0, globalThis.__DEV__ !== !1 && ye.warn(64));
}
function VD(e, n, i) {
  return Lh.withValue(!0, function() {
    var t = go(e, n, i, !1);
    return Object.isFrozen(e) && zu(t), t;
  });
}
function VY(e, n) {
  if (n.has(e))
    return n.get(e);
  var i = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return n.set(e, i), i;
}
function go(e, n, i, t, a) {
  var s, r = i.knownChanged, o = VY(e, i.mutableTargets);
  if (Array.isArray(e)) {
    for (var d = 0, c = Array.from(e.entries()); d < c.length; d++) {
      var u = c[d], k = u[0], m = u[1];
      if (m === null) {
        o[k] = null;
        continue;
      }
      var f = go(m, n, i, t, globalThis.__DEV__ !== !1 ? "".concat(a || "", "[").concat(k, "]") : void 0);
      r.has(f) && r.add(o), o[k] = f;
    }
    return r.has(o) ? o : e;
  }
  for (var p = 0, h = n.selections; p < h.length; p++) {
    var N = h[p], S = void 0;
    if (t && r.add(o), N.kind === Bn.FIELD) {
      var F = cl(N), y = N.selectionSet;
      if (S = o[F] || e[F], S === void 0)
        continue;
      if (y && S !== null) {
        var f = go(e[F], y, i, t, globalThis.__DEV__ !== !1 ? "".concat(a || "", ".").concat(F) : void 0);
        r.has(f) && (S = f);
      }
      globalThis.__DEV__ === !1 && (o[F] = S), globalThis.__DEV__ !== !1 && (t && F !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((s = Object.getOwnPropertyDescriptor(o, F)) === null || s === void 0) && s.value) ? Object.defineProperty(o, F, HY(F, S, a || "", i.operationName, i.operationType)) : (delete o[F], o[F] = S));
    }
    if (N.kind === Bn.INLINE_FRAGMENT && (!N.typeCondition || i.cache.fragmentMatches(N, e.__typename)) && (S = go(e, N.selectionSet, i, t, a)), N.kind === Bn.FRAGMENT_SPREAD) {
      var x = N.name.value, R = i.fragmentMap[x] || (i.fragmentMap[x] = i.cache.lookupFragment(x));
      ye(R, 59, x);
      var T = MW(N);
      T !== "mask" && (S = go(e, R.selectionSet, i, T === "migrate", a));
    }
    r.has(S) && r.add(o);
  }
  return "__typename" in e && !("__typename" in o) && (o.__typename = e.__typename), Object.keys(o).length !== Object.keys(e).length && r.add(o), r.has(o) ? o : e;
}
function HY(e, n, i, t, a) {
  var s = function() {
    return Lh.getValue() || (globalThis.__DEV__ !== !1 && ye.warn(60, t ? "".concat(a, " '").concat(t, "'") : "anonymous ".concat(a), "".concat(i, ".").concat(e).replace(/^\./, "")), s = function() {
      return n;
    }), n;
  };
  return {
    get: function() {
      return s();
    },
    set: function(r) {
      s = function() {
        return r;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function HD(e, n, i, t) {
  if (!i.fragmentMatches)
    return globalThis.__DEV__ !== !1 && UD(), e;
  var a = n.definitions.filter(function(r) {
    return r.kind === Bn.FRAGMENT_DEFINITION;
  });
  typeof t == "undefined" && (ye(a.length === 1, 61, a.length), t = a[0].name.value);
  var s = a.find(function(r) {
    return r.name.value === t;
  });
  return ye(!!s, 62, t), e == null || Dn(e, {}) ? e : VD(e, s.selectionSet, {
    operationType: "fragment",
    operationName: s.name.value,
    fragmentMap: Jr(Qr(n)),
    cache: i,
    mutableTargets: new LD(),
    knownChanged: new $D()
  });
}
function zY(e, n, i) {
  var t;
  if (!i.fragmentMatches)
    return globalThis.__DEV__ !== !1 && UD(), e;
  var a = Ks(n);
  return ye(a, 63), e == null ? e : VD(e, a.selectionSet, {
    operationType: a.operation,
    operationName: (t = a.name) === null || t === void 0 ? void 0 : t.value,
    fragmentMap: Jr(Qr(n)),
    cache: i,
    mutableTargets: new LD(),
    knownChanged: new $D()
  });
}
var zD = (
  /** @class */
  function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = dr(BW, {
        max: ra["cache.fragmentQueryDocuments"] || 1e3,
        cache: td
      });
    }
    return e.prototype.lookupFragment = function(n) {
      return null;
    }, e.prototype.batch = function(n) {
      var i = this, t = typeof n.optimistic == "string" ? n.optimistic : n.optimistic === !1 ? null : void 0, a;
      return this.performTransaction(function() {
        return a = n.update(i);
      }, t), a;
    }, e.prototype.recordOptimisticTransaction = function(n, i) {
      this.performTransaction(n, i);
    }, e.prototype.transformDocument = function(n) {
      return n;
    }, e.prototype.transformForLink = function(n) {
      return n;
    }, e.prototype.identify = function(n) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(n) {
      return !1;
    }, e.prototype.readQuery = function(n, i) {
      var t = this;
      return i === void 0 && (i = !!n.optimistic), globalThis.__DEV__ !== !1 && ki(n, "canonizeResults", "cache.readQuery"), Ai("canonizeResults", function() {
        return t.read(G(G({}, n), { rootId: n.id || "ROOT_QUERY", optimistic: i }));
      });
    }, e.prototype.watchFragment = function(n) {
      var i = this, t = n.fragment, a = n.fragmentName, s = n.from, r = n.optimistic, o = r === void 0 ? !0 : r, d = Mt(n, ["fragment", "fragmentName", "from", "optimistic"]), c = this.getFragmentDoc(t, a), u = typeof s == "undefined" || typeof s == "string" ? s : this.identify(s), k = !!n[Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var m = a || kD(t).name.value;
        u || globalThis.__DEV__ !== !1 && ye.warn(1, m);
      }
      var f = G(G({}, d), { returnPartialData: !0, id: u, query: c, optimistic: o }), p;
      return new $n(function(h) {
        return i.watch(G(G({}, f), { immediate: !0, callback: function(N) {
          var S = k ? HD(N.result, t, i, a) : N.result;
          if (
            // Always ensure we deliver the first result
            !(p && MD(
              c,
              { data: p.result },
              { data: S },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              n.variables
            ))
          ) {
            var F = {
              data: S,
              complete: !!N.complete
            };
            N.missing && (F.missing = r2(N.missing.map(function(y) {
              return y.missing;
            }))), p = G(G({}, N), { result: S }), h.next(F);
          }
        } }));
      });
    }, e.prototype.readFragment = function(n, i) {
      var t = this;
      return i === void 0 && (i = !!n.optimistic), globalThis.__DEV__ !== !1 && ki(n, "canonizeResults", "cache.readFragment"), Ai("canonizeResults", function() {
        return t.read(G(G({}, n), { query: t.getFragmentDoc(n.fragment, n.fragmentName), rootId: n.id, optimistic: i }));
      });
    }, e.prototype.writeQuery = function(n) {
      var i = n.id, t = n.data, a = Mt(n, ["id", "data"]);
      return this.write(Object.assign(a, {
        dataId: i || "ROOT_QUERY",
        result: t
      }));
    }, e.prototype.writeFragment = function(n) {
      var i = n.id, t = n.data, a = n.fragment, s = n.fragmentName, r = Mt(n, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(r, {
        query: this.getFragmentDoc(a, s),
        dataId: i,
        result: t
      }));
    }, e.prototype.updateQuery = function(n, i) {
      return globalThis.__DEV__ !== !1 && ki(n, "canonizeResults", "cache.updateQuery"), this.batch({
        update: function(t) {
          var a = Ai("canonizeResults", function() {
            return t.readQuery(n);
          }), s = i(a);
          return s == null ? a : (t.writeQuery(G(G({}, n), { data: s })), s);
        }
      });
    }, e.prototype.updateFragment = function(n, i) {
      return globalThis.__DEV__ !== !1 && ki(n, "canonizeResults", "cache.updateFragment"), this.batch({
        update: function(t) {
          var a = Ai("canonizeResults", function() {
            return t.readFragment(n);
          }), s = i(a);
          return s == null ? a : (t.writeFragment(G(G({}, n), { data: s })), s);
        }
      });
    }, e;
  }()
);
globalThis.__DEV__ !== !1 && (zD.prototype.getMemoryInternals = aK);
var BD = (
  /** @class */
  function(e) {
    ca(n, e);
    function n(i, t, a, s) {
      var r, o = e.call(this, i) || this;
      if (o.message = i, o.path = t, o.query = a, o.variables = s, Array.isArray(o.path)) {
        o.missing = o.message;
        for (var d = o.path.length - 1; d >= 0; --d)
          o.missing = (r = {}, r[o.path[d]] = o.missing, r);
      } else
        o.missing = o.path;
      return o.__proto__ = n.prototype, o;
    }
    return n;
  }(Error)
), Qi = Object.prototype.hasOwnProperty;
function uo(e) {
  return e == null;
}
function qD(e, n) {
  var i = e.__typename, t = e.id, a = e._id;
  if (typeof i == "string" && (n && (n.keyObject = uo(t) ? uo(a) ? void 0 : { _id: a } : { id: t }), uo(t) && !uo(a) && (t = a), !uo(t)))
    return "".concat(i, ":").concat(typeof t == "number" || typeof t == "string" ? t : JSON.stringify(t));
}
var GD = {
  dataIdFromObject: qD,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function BY(e) {
  return ur(GD, e);
}
function WD(e) {
  var n = e.canonizeResults;
  return n === void 0 ? GD.canonizeResults : n;
}
function qY(e, n) {
  return En(n) ? e.get(n.__ref, "__typename") : n && n.__typename;
}
var KD = /^[_a-z][_0-9a-z]*/i;
function ts(e) {
  var n = e.match(KD);
  return n ? n[0] : e;
}
function rf(e, n, i) {
  return fi(n) ? vi(n) ? n.every(function(t) {
    return rf(e, t, i);
  }) : e.selections.every(function(t) {
    if (es(t) && jd(t, i)) {
      var a = cl(t);
      return Qi.call(n, a) && (!t.selectionSet || rf(t.selectionSet, n[a], i));
    }
    return !0;
  }) : !1;
}
function J1(e) {
  return fi(e) && !En(e) && !vi(e);
}
function GY() {
  return new is();
}
function YD(e, n) {
  var i = Jr(Qr(e));
  return {
    fragmentMap: i,
    lookupFragment: function(t) {
      var a = i[t];
      return !a && n && (a = n.lookup(t)), a || null;
    }
  };
}
var eu = /* @__PURE__ */ Object.create(null), f3 = function() {
  return eu;
}, Jg = /* @__PURE__ */ Object.create(null), ld = (
  /** @class */
  function() {
    function e(n, i) {
      var t = this;
      this.policies = n, this.group = i, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(a, s) {
        return zu(En(a) ? t.get(a.__ref, s) : a && a[s]);
      }, this.canRead = function(a) {
        return En(a) ? t.has(a.__ref) : typeof a == "object";
      }, this.toReference = function(a, s) {
        if (typeof a == "string")
          return V1(a);
        if (En(a))
          return a;
        var r = t.policies.identify(a)[0];
        if (r) {
          var o = V1(r);
          return s && t.merge(r, a), o;
        }
      };
    }
    return e.prototype.toObject = function() {
      return G({}, this.data);
    }, e.prototype.has = function(n) {
      return this.lookup(n, !0) !== void 0;
    }, e.prototype.get = function(n, i) {
      if (this.group.depend(n, i), Qi.call(this.data, n)) {
        var t = this.data[n];
        if (t && Qi.call(t, i))
          return t[i];
      }
      if (i === "__typename" && Qi.call(this.policies.rootTypenamesById, n))
        return this.policies.rootTypenamesById[n];
      if (this instanceof Tl)
        return this.parent.get(n, i);
    }, e.prototype.lookup = function(n, i) {
      if (i && this.group.depend(n, "__exists"), Qi.call(this.data, n))
        return this.data[n];
      if (this instanceof Tl)
        return this.parent.lookup(n, i);
      if (this.policies.rootTypenamesById[n])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(n, i) {
      var t = this, a;
      En(n) && (n = n.__ref), En(i) && (i = i.__ref);
      var s = typeof n == "string" ? this.lookup(a = n) : n, r = typeof i == "string" ? this.lookup(a = i) : i;
      if (r) {
        ye(typeof a == "string", 2);
        var o = new is(KY).merge(s, r);
        if (this.data[a] = o, o !== s && (delete this.refs[a], this.group.caching)) {
          var d = /* @__PURE__ */ Object.create(null);
          s || (d.__exists = 1), Object.keys(r).forEach(function(c) {
            if (!s || s[c] !== o[c]) {
              d[c] = 1;
              var u = ts(c);
              u !== c && !t.policies.hasKeyArgs(o.__typename, u) && (d[u] = 1), o[c] === void 0 && !(t instanceof Tl) && delete o[c];
            }
          }), d.__typename && !(s && s.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[a] === o.__typename && delete d.__typename, Object.keys(d).forEach(function(c) {
            return t.group.dirty(a, c);
          });
        }
      }
    }, e.prototype.modify = function(n, i) {
      var t = this, a = this.lookup(n);
      if (a) {
        var s = /* @__PURE__ */ Object.create(null), r = !1, o = !0, d = {
          DELETE: eu,
          INVALIDATE: Jg,
          isReference: En,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(c, u) {
            return t.policies.readField(typeof c == "string" ? {
              fieldName: c,
              from: u || V1(n)
            } : c, { store: t });
          }
        };
        if (Object.keys(a).forEach(function(c) {
          var u = ts(c), k = a[c];
          if (k !== void 0) {
            var m = typeof i == "function" ? i : i[c] || i[u];
            if (m) {
              var f = m === f3 ? eu : m(zu(k), G(G({}, d), { fieldName: u, storeFieldName: c, storage: t.getStorage(n, c) }));
              if (f === Jg)
                t.group.dirty(n, c);
              else if (f === eu && (f = void 0), f !== k && (s[c] = f, r = !0, k = f, globalThis.__DEV__ !== !1)) {
                var p = function(R) {
                  if (t.lookup(R.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && ye.warn(3, R), !0;
                };
                if (En(f))
                  p(f);
                else if (Array.isArray(f))
                  for (var h = !1, N = void 0, S = 0, F = f; S < F.length; S++) {
                    var y = F[S];
                    if (En(y)) {
                      if (h = !0, p(y))
                        break;
                    } else if (typeof y == "object" && y) {
                      var x = t.policies.identify(y)[0];
                      x && (N = y);
                    }
                    if (h && N !== void 0) {
                      globalThis.__DEV__ !== !1 && ye.warn(4, N);
                      break;
                    }
                  }
              }
            }
            k !== void 0 && (o = !1);
          }
        }), r)
          return this.merge(n, s), o && (this instanceof Tl ? this.data[n] = void 0 : delete this.data[n], this.group.dirty(n, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(n, i, t) {
      var a, s = this.lookup(n);
      if (s) {
        var r = this.getFieldValue(s, "__typename"), o = i && t ? this.policies.getStoreFieldName({ typename: r, fieldName: i, args: t }) : i;
        return this.modify(n, o ? (a = {}, a[o] = f3, a) : f3);
      }
      return !1;
    }, e.prototype.evict = function(n, i) {
      var t = !1;
      return n.id && (Qi.call(this.data, n.id) && (t = this.delete(n.id, n.fieldName, n.args)), this instanceof Tl && this !== i && (t = this.parent.evict(n, i) || t), (n.fieldName || t) && this.group.dirty(n.id, n.fieldName || "__exists")), t;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var n = this, i = this.toObject(), t = [];
      return this.getRootIdSet().forEach(function(a) {
        Qi.call(n.policies.rootTypenamesById, a) || t.push(a);
      }), t.length && (i.__META = { extraRootIds: t.sort() }), i;
    }, e.prototype.replace = function(n) {
      var i = this;
      if (Object.keys(this.data).forEach(function(s) {
        n && Qi.call(n, s) || i.delete(s);
      }), n) {
        var t = n.__META, a = Mt(n, ["__META"]);
        Object.keys(a).forEach(function(s) {
          i.merge(s, a[s]);
        }), t && t.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(n) {
      return this.rootIds[n] = (this.rootIds[n] || 0) + 1;
    }, e.prototype.release = function(n) {
      if (this.rootIds[n] > 0) {
        var i = --this.rootIds[n];
        return i || delete this.rootIds[n], i;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(n) {
      return n === void 0 && (n = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(n.add, n), this instanceof Tl ? this.parent.getRootIdSet(n) : Object.keys(this.policies.rootTypenamesById).forEach(n.add, n), n;
    }, e.prototype.gc = function() {
      var n = this, i = this.getRootIdSet(), t = this.toObject();
      i.forEach(function(r) {
        Qi.call(t, r) && (Object.keys(n.findChildRefIds(r)).forEach(i.add, i), delete t[r]);
      });
      var a = Object.keys(t);
      if (a.length) {
        for (var s = this; s instanceof Tl; )
          s = s.parent;
        a.forEach(function(r) {
          return s.delete(r);
        });
      }
      return a;
    }, e.prototype.findChildRefIds = function(n) {
      if (!Qi.call(this.refs, n)) {
        var i = this.refs[n] = /* @__PURE__ */ Object.create(null), t = this.data[n];
        if (!t)
          return i;
        var a = /* @__PURE__ */ new Set([t]);
        a.forEach(function(s) {
          En(s) && (i[s.__ref] = !0), fi(s) && Object.keys(s).forEach(function(r) {
            var o = s[r];
            fi(o) && a.add(o);
          });
        });
      }
      return this.refs[n];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  }()
), XD = (
  /** @class */
  function() {
    function e(n, i) {
      i === void 0 && (i = null), this.caching = n, this.parent = i, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? bD() : null, this.keyMaker = new sa(dl);
    }, e.prototype.depend = function(n, i) {
      if (this.d) {
        this.d(v3(n, i));
        var t = ts(i);
        t !== i && this.d(v3(n, t)), this.parent && this.parent.depend(n, i);
      }
    }, e.prototype.dirty = function(n, i) {
      this.d && this.d.dirty(
        v3(n, i),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        i === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  }()
);
function v3(e, n) {
  return n + "#" + e;
}
function _g(e, n) {
  To(e) && e.group.depend(n, "__exists");
}
(function(e) {
  var n = (
    /** @class */
    function(i) {
      ca(t, i);
      function t(a) {
        var s = a.policies, r = a.resultCaching, o = r === void 0 ? !0 : r, d = a.seed, c = i.call(this, s, new XD(o)) || this;
        return c.stump = new WY(c), c.storageTrie = new sa(dl), d && c.replace(d), c;
      }
      return t.prototype.addLayer = function(a, s) {
        return this.stump.addLayer(a, s);
      }, t.prototype.removeLayer = function() {
        return this;
      }, t.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, t;
    }(e)
  );
  e.Root = n;
})(ld || (ld = {}));
var Tl = (
  /** @class */
  function(e) {
    ca(n, e);
    function n(i, t, a, s) {
      var r = e.call(this, t.policies, s) || this;
      return r.id = i, r.parent = t, r.replay = a, r.group = s, a(r), r;
    }
    return n.prototype.addLayer = function(i, t) {
      return new n(i, this, t, this.group);
    }, n.prototype.removeLayer = function(i) {
      var t = this, a = this.parent.removeLayer(i);
      return i === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(s) {
        var r = t.data[s], o = a.lookup(s);
        o ? r ? r !== o && Object.keys(r).forEach(function(d) {
          Dn(r[d], o[d]) || t.group.dirty(s, d);
        }) : (t.group.dirty(s, "__exists"), Object.keys(o).forEach(function(d) {
          t.group.dirty(s, d);
        })) : t.delete(s);
      }), a) : a === this.parent ? this : a.addLayer(this.id, this.replay);
    }, n.prototype.toObject = function() {
      return G(G({}, this.parent.toObject()), this.data);
    }, n.prototype.findChildRefIds = function(i) {
      var t = this.parent.findChildRefIds(i);
      return Qi.call(this.data, i) ? G(G({}, t), e.prototype.findChildRefIds.call(this, i)) : t;
    }, n.prototype.getStorage = function() {
      for (var i = this.parent; i.parent; )
        i = i.parent;
      return i.getStorage.apply(
        i,
        // @ts-expect-error
        arguments
      );
    }, n;
  }(ld)
), WY = (
  /** @class */
  function(e) {
    ca(n, e);
    function n(i) {
      return e.call(this, "EntityStore.Stump", i, function() {
      }, new XD(i.group.caching, i.group)) || this;
    }
    return n.prototype.removeLayer = function() {
      return this;
    }, n.prototype.merge = function(i, t) {
      return this.parent.merge(i, t);
    }, n;
  }(Tl)
);
function KY(e, n, i) {
  var t = e[i], a = n[i];
  return Dn(t, a) ? t : a;
}
function To(e) {
  return !!(e instanceof ld && e.group.caching);
}
function YY(e) {
  return fi(e) ? vi(e) ? e.slice(0) : G({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var Qg = (
  /** @class */
  function() {
    function e() {
      this.known = new (bh ? WeakSet : Set)(), this.pool = new sa(dl), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(n) {
      return fi(n) && this.known.has(n);
    }, e.prototype.pass = function(n) {
      if (fi(n)) {
        var i = YY(n);
        return this.passes.set(i, n), i;
      }
      return n;
    }, e.prototype.admit = function(n) {
      var i = this;
      if (fi(n)) {
        var t = this.passes.get(n);
        if (t)
          return t;
        var a = Object.getPrototypeOf(n);
        switch (a) {
          case Array.prototype: {
            if (this.known.has(n))
              return n;
            var s = n.map(this.admit, this), r = this.pool.lookupArray(s);
            return r.array || (this.known.add(r.array = s), globalThis.__DEV__ !== !1 && Object.freeze(s)), r.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(n))
              return n;
            var o = Object.getPrototypeOf(n), d = [o], c = this.sortedKeys(n);
            d.push(c.json);
            var u = d.length;
            c.sorted.forEach(function(f) {
              d.push(i.admit(n[f]));
            });
            var r = this.pool.lookupArray(d);
            if (!r.object) {
              var k = r.object = Object.create(o);
              this.known.add(k), c.sorted.forEach(function(f, p) {
                k[f] = d[u + p];
              }), globalThis.__DEV__ !== !1 && Object.freeze(k);
            }
            return r.object;
          }
        }
      }
      return n;
    }, e.prototype.sortedKeys = function(n) {
      var i = Object.keys(n), t = this.pool.lookupArray(i);
      if (!t.keys) {
        i.sort();
        var a = JSON.stringify(i);
        (t.keys = this.keysByJSON.get(a)) || this.keysByJSON.set(a, t.keys = { sorted: i, json: a });
      }
      return t.keys;
    }, e;
  }()
);
function Mg(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var XY = (
  /** @class */
  function() {
    function e(n) {
      var i = this;
      this.knownResults = new (dl ? WeakMap : Map)(), this.config = ur(n, {
        addTypename: n.addTypename !== !1,
        canonizeResults: WD(n)
      }), this.canon = n.canon || new Qg(), this.executeSelectionSet = dr(function(t) {
        var a, s = t.context.canonizeResults, r = Mg(t);
        r[3] = !s;
        var o = (a = i.executeSelectionSet).peek.apply(a, r);
        return o ? s ? G(G({}, o), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: i.canon.admit(o.result)
        }) : o : (_g(t.context.store, t.enclosingRef.__ref), i.execSelectionSetImpl(t));
      }, {
        max: this.config.resultCacheMaxSize || ra["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: Mg,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(t, a, s, r) {
          if (To(s.store))
            return s.store.makeCacheKey(t, En(a) ? a.__ref : a, s.varString, r);
        }
      }), this.executeSubSelectedArray = dr(function(t) {
        return _g(t.context.store, t.enclosingRef.__ref), i.execSubSelectedArrayImpl(t);
      }, {
        max: this.config.resultCacheMaxSize || ra["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(t) {
          var a = t.field, s = t.array, r = t.context;
          if (To(r.store))
            return r.store.makeCacheKey(a, s, r.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new Qg();
    }, e.prototype.diffQueryAgainstStore = function(n) {
      var i = n.store, t = n.query, a = n.rootId, s = a === void 0 ? "ROOT_QUERY" : a, r = n.variables, o = n.returnPartialData, d = o === void 0 ? !0 : o, c = n.canonizeResults, u = c === void 0 ? this.config.canonizeResults : c, k = this.config.cache.policies;
      r = G(G({}, wh(mD(t))), r);
      var m = V1(s), f = this.executeSelectionSet({
        selectionSet: Ad(t).selectionSet,
        objectOrReference: m,
        enclosingRef: m,
        context: G({ store: i, query: t, policies: k, variables: r, varString: il(r), canonizeResults: u }, YD(t, this.config.fragments))
      }), p;
      if (f.missing && (p = [
        new BD(ZY(f.missing), f.missing, t, r)
      ], !d))
        throw p[0];
      return {
        result: f.result,
        complete: !p,
        missing: p
      };
    }, e.prototype.isFresh = function(n, i, t, a) {
      if (To(a.store) && this.knownResults.get(n) === t) {
        var s = this.executeSelectionSet.peek(
          t,
          i,
          a,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(n)
        );
        if (s && n === s.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(n) {
      var i = this, t = n.selectionSet, a = n.objectOrReference, s = n.enclosingRef, r = n.context;
      if (En(a) && !r.policies.rootTypenamesById[a.__ref] && !r.store.has(a.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(a.__ref, " object")
        };
      var o = r.variables, d = r.policies, c = r.store, u = c.getFieldValue(a, "__typename"), k = [], m, f = new is();
      this.config.addTypename && typeof u == "string" && !d.rootIdsByTypename[u] && k.push({ __typename: u });
      function p(y, x) {
        var R;
        return y.missing && (m = f.merge(m, (R = {}, R[x] = y.missing, R))), y.result;
      }
      var h = new Set(t.selections);
      h.forEach(function(y) {
        var x, R;
        if (jd(y, o))
          if (es(y)) {
            var T = d.readField({
              fieldName: y.name.value,
              field: y,
              variables: r.variables,
              from: a
            }, r), j = cl(y);
            T === void 0 ? jh.added(y) || (m = f.merge(m, (x = {}, x[j] = "Can't find field '".concat(y.name.value, "' on ").concat(En(a) ? a.__ref + " object" : "object " + JSON.stringify(a, null, 2)), x))) : vi(T) ? T.length > 0 && (T = p(i.executeSubSelectedArray({
              field: y,
              array: T,
              enclosingRef: s,
              context: r
            }), j)) : y.selectionSet ? T != null && (T = p(i.executeSelectionSet({
              selectionSet: y.selectionSet,
              objectOrReference: T,
              enclosingRef: En(T) ? T : s,
              context: r
            }), j)) : r.canonizeResults && (T = i.canon.pass(T)), T !== void 0 && k.push((R = {}, R[j] = T, R));
          } else {
            var A = t2(y, r.lookupFragment);
            if (!A && y.kind === Bn.FRAGMENT_SPREAD)
              throw dt(10, y.name.value);
            A && d.fragmentMatches(A, u) && A.selectionSet.selections.forEach(h.add, h);
          }
      });
      var N = r2(k), S = { result: N, missing: m }, F = r.canonizeResults ? this.canon.admit(S) : zu(S);
      return F.result && this.knownResults.set(F.result, t), F;
    }, e.prototype.execSubSelectedArrayImpl = function(n) {
      var i = this, t = n.field, a = n.array, s = n.enclosingRef, r = n.context, o, d = new is();
      function c(u, k) {
        var m;
        return u.missing && (o = d.merge(o, (m = {}, m[k] = u.missing, m))), u.result;
      }
      return t.selectionSet && (a = a.filter(r.store.canRead)), a = a.map(function(u, k) {
        return u === null ? null : vi(u) ? c(i.executeSubSelectedArray({
          field: t,
          array: u,
          enclosingRef: s,
          context: r
        }), k) : t.selectionSet ? c(i.executeSelectionSet({
          selectionSet: t.selectionSet,
          objectOrReference: u,
          enclosingRef: En(u) ? u : s,
          context: r
        }), k) : (globalThis.__DEV__ !== !1 && eX(r.store, t, u), u);
      }), {
        result: r.canonizeResults ? this.canon.admit(a) : a,
        missing: o
      };
    }, e;
  }()
);
function ZY(e) {
  try {
    JSON.stringify(e, function(n, i) {
      if (typeof i == "string")
        throw i;
      return i;
    });
  } catch (n) {
    return n;
  }
}
function eX(e, n, i) {
  if (!n.selectionSet) {
    var t = /* @__PURE__ */ new Set([i]);
    t.forEach(function(a) {
      fi(a) && (ye(
        !En(a),
        11,
        qY(e, a),
        n.name.value
      ), Object.values(a).forEach(t.add, t));
    });
  }
}
var $h = new Mr(), Lg = /* @__PURE__ */ new WeakMap();
function jo(e) {
  var n = Lg.get(e);
  return n || Lg.set(e, n = {
    vars: /* @__PURE__ */ new Set(),
    dep: bD()
  }), n;
}
function $g(e) {
  jo(e).vars.forEach(function(n) {
    return n.forgetCache(e);
  });
}
function nX(e) {
  jo(e).vars.forEach(function(n) {
    return n.attachCache(e);
  });
}
function iX(e) {
  var n = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), t = function(s) {
    if (arguments.length > 0) {
      if (e !== s) {
        e = s, n.forEach(function(d) {
          jo(d).dep.dirty(t), tX(d);
        });
        var r = Array.from(i);
        i.clear(), r.forEach(function(d) {
          return d(e);
        });
      }
    } else {
      var o = $h.getValue();
      o && (a(o), jo(o).dep(t));
    }
    return e;
  };
  t.onNextChange = function(s) {
    return i.add(s), function() {
      i.delete(s);
    };
  };
  var a = t.attachCache = function(s) {
    return n.add(s), jo(s).vars.add(t), t;
  };
  return t.forgetCache = function(s) {
    return n.delete(s);
  }, t;
}
function tX(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var Ug = /* @__PURE__ */ Object.create(null);
function Uh(e) {
  var n = JSON.stringify(e);
  return Ug[n] || (Ug[n] = /* @__PURE__ */ Object.create(null));
}
function Vg(e) {
  var n = Uh(e);
  return n.keyFieldsFn || (n.keyFieldsFn = function(i, t) {
    var a = function(r, o) {
      return t.readField(o, r);
    }, s = t.keyObject = Vh(e, function(r) {
      var o = z1(
        t.storeObject,
        r,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        a
      );
      return o === void 0 && i !== t.storeObject && Qi.call(i, r[0]) && (o = z1(i, r, e7)), ye(o !== void 0, 5, r.join("."), i), o;
    });
    return "".concat(t.typename, ":").concat(JSON.stringify(s));
  });
}
function Hg(e) {
  var n = Uh(e);
  return n.keyArgsFn || (n.keyArgsFn = function(i, t) {
    var a = t.field, s = t.variables, r = t.fieldName, o = Vh(e, function(c) {
      var u = c[0], k = u.charAt(0);
      if (k === "@") {
        if (a && oa(a.directives)) {
          var m = u.slice(1), f = a.directives.find(function(S) {
            return S.name.value === m;
          }), p = f && a2(f, s);
          return p && z1(
            p,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            c.slice(1)
          );
        }
        return;
      }
      if (k === "$") {
        var h = u.slice(1);
        if (s && Qi.call(s, h)) {
          var N = c.slice(0);
          return N[0] = h, z1(s, N);
        }
        return;
      }
      if (i)
        return z1(i, c);
    }), d = JSON.stringify(o);
    return (i || d !== "{}") && (r += ":" + d), r;
  });
}
function Vh(e, n) {
  var i = new is();
  return ZD(e).reduce(function(t, a) {
    var s, r = n(a);
    if (r !== void 0) {
      for (var o = a.length - 1; o >= 0; --o)
        r = (s = {}, s[a[o]] = r, s);
      t = i.merge(t, r);
    }
    return t;
  }, /* @__PURE__ */ Object.create(null));
}
function ZD(e) {
  var n = Uh(e);
  if (!n.paths) {
    var i = n.paths = [], t = [];
    e.forEach(function(a, s) {
      vi(a) ? (ZD(a).forEach(function(r) {
        return i.push(t.concat(r));
      }), t.length = 0) : (t.push(a), vi(e[s + 1]) || (i.push(t.slice(0)), t.length = 0));
    });
  }
  return n.paths;
}
function e7(e, n) {
  return e[n];
}
function z1(e, n, i) {
  return i = i || e7, n7(n.reduce(function t(a, s) {
    return vi(a) ? a.map(function(r) {
      return t(r, s);
    }) : a && i(a, s);
  }, e));
}
function n7(e) {
  return fi(e) ? vi(e) ? e.map(n7) : Vh(Object.keys(e).sort(), function(n) {
    return z1(e, n);
  }) : e;
}
function of(e) {
  return e.args !== void 0 ? e.args : e.field ? a2(e.field, e.variables) : null;
}
var aX = function() {
}, zg = function(e, n) {
  return n.fieldName;
}, Bg = function(e, n, i) {
  var t = i.mergeObjects;
  return t(e, n);
}, qg = function(e, n) {
  return n;
}, lX = (
  /** @class */
  function() {
    function e(n) {
      this.config = n, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = G({ dataIdFromObject: qD }, n), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), n.possibleTypes && this.addPossibleTypes(n.possibleTypes), n.typePolicies && this.addTypePolicies(n.typePolicies);
    }
    return e.prototype.identify = function(n, i) {
      var t, a = this, s = i && (i.typename || ((t = i.storeObject) === null || t === void 0 ? void 0 : t.__typename)) || n.__typename;
      if (s === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var r = i && i.storeObject || n, o = G(G({}, i), { typename: s, storeObject: r, readField: i && i.readField || function() {
        var k = Hh(arguments, r);
        return a.readField(k, {
          store: a.cache.data,
          variables: k.variables
        });
      } }), d, c = s && this.getTypePolicy(s), u = c && c.keyFn || this.config.dataIdFromObject;
      return Lh.withValue(!0, function() {
        for (; u; ) {
          var k = u(G(G({}, n), r), o);
          if (vi(k))
            u = Vg(k);
          else {
            d = k;
            break;
          }
        }
      }), d = d ? String(d) : void 0, o.keyObject ? [d, o.keyObject] : [d];
    }, e.prototype.addTypePolicies = function(n) {
      var i = this;
      Object.keys(n).forEach(function(t) {
        var a = n[t], s = a.queryType, r = a.mutationType, o = a.subscriptionType, d = Mt(a, ["queryType", "mutationType", "subscriptionType"]);
        s && i.setRootTypename("Query", t), r && i.setRootTypename("Mutation", t), o && i.setRootTypename("Subscription", t), Qi.call(i.toBeAdded, t) ? i.toBeAdded[t].push(d) : i.toBeAdded[t] = [d];
      });
    }, e.prototype.updateTypePolicy = function(n, i, t) {
      var a = this.getTypePolicy(n), s = i.keyFields, r = i.fields;
      function o(d, c) {
        d.merge = typeof c == "function" ? c : c === !0 ? Bg : c === !1 ? qg : d.merge;
      }
      o(a, i.merge), a.keyFn = // Pass false to disable normalization for this typename.
      s === !1 ? aX : vi(s) ? Vg(s) : typeof s == "function" ? s : a.keyFn, r && Object.keys(r).forEach(function(d) {
        var c = t[d];
        (!c || (c == null ? void 0 : c.typename) !== n) && (c = t[d] = { typename: n });
        var u = r[d];
        if (typeof u == "function")
          c.read = u;
        else {
          var k = u.keyArgs, m = u.read, f = u.merge;
          c.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          k === !1 ? zg : vi(k) ? Hg(k) : typeof k == "function" ? k : c.keyFn, typeof m == "function" && (c.read = m), o(c, f);
        }
        c.read && c.merge && (c.keyFn = c.keyFn || zg);
      });
    }, e.prototype.setRootTypename = function(n, i) {
      i === void 0 && (i = n);
      var t = "ROOT_" + n.toUpperCase(), a = this.rootTypenamesById[t];
      i !== a && (ye(!a || a === n, 6, n), a && delete this.rootIdsByTypename[a], this.rootIdsByTypename[i] = t, this.rootTypenamesById[t] = i);
    }, e.prototype.addPossibleTypes = function(n) {
      var i = this;
      this.usingPossibleTypes = !0, Object.keys(n).forEach(function(t) {
        i.getSupertypeSet(t, !0), n[t].forEach(function(a) {
          i.getSupertypeSet(a, !0).add(t);
          var s = a.match(KD);
          (!s || s[0] !== a) && i.fuzzySubtypes.set(a, new RegExp(a));
        });
      });
    }, e.prototype.getTypePolicy = function(n) {
      var i = this;
      if (!Qi.call(this.typePolicies, n)) {
        var t = this.typePolicies[n] = /* @__PURE__ */ Object.create(null);
        t.fields = /* @__PURE__ */ Object.create(null);
        var a = this.supertypeMap.get(n);
        !a && this.fuzzySubtypes.size && (a = this.getSupertypeSet(n, !0), this.fuzzySubtypes.forEach(function(r, o) {
          if (r.test(n)) {
            var d = i.supertypeMap.get(o);
            d && d.forEach(function(c) {
              return a.add(c);
            });
          }
        })), a && a.size && a.forEach(function(r) {
          var o = i.getTypePolicy(r), d = o.fields, c = Mt(o, ["fields"]);
          Object.assign(t, c), Object.assign(t.fields, d);
        });
      }
      var s = this.toBeAdded[n];
      return s && s.length && s.splice(0).forEach(function(r) {
        i.updateTypePolicy(n, r, i.typePolicies[n].fields);
      }), this.typePolicies[n];
    }, e.prototype.getFieldPolicy = function(n, i) {
      if (n)
        return this.getTypePolicy(n).fields[i];
    }, e.prototype.getSupertypeSet = function(n, i) {
      var t = this.supertypeMap.get(n);
      return !t && i && this.supertypeMap.set(n, t = /* @__PURE__ */ new Set()), t;
    }, e.prototype.fragmentMatches = function(n, i, t, a) {
      var s = this;
      if (!n.typeCondition)
        return !0;
      if (!i)
        return !1;
      var r = n.typeCondition.name.value;
      if (i === r)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(r))
        for (var o = this.getSupertypeSet(i, !0), d = [o], c = function(p) {
          var h = s.getSupertypeSet(p, !1);
          h && h.size && d.indexOf(h) < 0 && d.push(h);
        }, u = !!(t && this.fuzzySubtypes.size), k = !1, m = 0; m < d.length; ++m) {
          var f = d[m];
          if (f.has(r))
            return o.has(r) || (k && globalThis.__DEV__ !== !1 && ye.warn(7, i, r), o.add(r)), !0;
          f.forEach(c), u && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          m === d.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          rf(n.selectionSet, t, a) && (u = !1, k = !0, this.fuzzySubtypes.forEach(function(p, h) {
            var N = i.match(p);
            N && N[0] === i && c(h);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(n, i) {
      var t = this.getFieldPolicy(n, i);
      return !!(t && t.keyFn);
    }, e.prototype.getStoreFieldName = function(n) {
      var i = n.typename, t = n.fieldName, a = this.getFieldPolicy(i, t), s, r = a && a.keyFn;
      if (r && i)
        for (var o = {
          typename: i,
          fieldName: t,
          field: n.field || null,
          variables: n.variables
        }, d = of(n); r; ) {
          var c = r(d, o);
          if (vi(c))
            r = Hg(c);
          else {
            s = c || t;
            break;
          }
        }
      return s === void 0 && (s = n.field ? FK(n.field, n.variables) : uD(t, of(n))), s === !1 ? t : t === ts(s) ? s : t + ":" + s;
    }, e.prototype.readField = function(n, i) {
      var t = n.from;
      if (t) {
        var a = n.field || n.fieldName;
        if (a) {
          if (n.typename === void 0) {
            var s = i.store.getFieldValue(t, "__typename");
            s && (n.typename = s);
          }
          var r = this.getStoreFieldName(n), o = ts(r), d = i.store.getFieldValue(t, r), c = this.getFieldPolicy(n.typename, o), u = c && c.read;
          if (u) {
            var k = Gg(this, t, n, i, i.store.getStorage(En(t) ? t.__ref : t, r));
            return $h.withValue(this.cache, u, [
              d,
              k
            ]);
          }
          return d;
        }
      }
    }, e.prototype.getReadFunction = function(n, i) {
      var t = this.getFieldPolicy(n, i);
      return t && t.read;
    }, e.prototype.getMergeFunction = function(n, i, t) {
      var a = this.getFieldPolicy(n, i), s = a && a.merge;
      return !s && t && (a = this.getTypePolicy(t), s = a && a.merge), s;
    }, e.prototype.runMergeFunction = function(n, i, t, a, s) {
      var r = t.field, o = t.typename, d = t.merge;
      return d === Bg ? i7(a.store)(n, i) : d === qg ? i : (a.overwrite && (n = void 0), d(n, i, Gg(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: o,
          fieldName: r.name.value,
          field: r,
          variables: a.variables
        },
        a,
        s || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  }()
);
function Gg(e, n, i, t, a) {
  var s = e.getStoreFieldName(i), r = ts(s), o = i.variables || t.variables, d = t.store, c = d.toReference, u = d.canRead;
  return {
    args: of(i),
    field: i.field || null,
    fieldName: r,
    storeFieldName: s,
    variables: o,
    isReference: En,
    toReference: c,
    storage: a,
    cache: e.cache,
    canRead: u,
    readField: function() {
      return e.readField(Hh(arguments, n, o), t);
    },
    mergeObjects: i7(t.store)
  };
}
function Hh(e, n, i) {
  var t = e[0], a = e[1], s = e.length, r;
  return typeof t == "string" ? r = {
    fieldName: t,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: s > 1 ? a : n
  } : (r = G({}, t), Qi.call(r, "from") || (r.from = n)), globalThis.__DEV__ !== !1 && r.from === void 0 && globalThis.__DEV__ !== !1 && ye.warn(8, Xx(Array.from(e))), r.variables === void 0 && (r.variables = i), r;
}
function i7(e) {
  return function(i, t) {
    if (vi(i) || vi(t))
      throw dt(9);
    if (fi(i) && fi(t)) {
      var a = e.getFieldValue(i, "__typename"), s = e.getFieldValue(t, "__typename"), r = a && s && a !== s;
      if (r)
        return t;
      if (En(i) && J1(t))
        return e.merge(i.__ref, t), i;
      if (J1(i) && En(t))
        return e.merge(i, t.__ref), t;
      if (J1(i) && J1(t))
        return G(G({}, i), t);
    }
    return t;
  };
}
function h3(e, n, i) {
  var t = "".concat(n).concat(i), a = e.flavors.get(t);
  return a || e.flavors.set(t, a = e.clientOnly === n && e.deferred === i ? e : G(G({}, e), { clientOnly: n, deferred: i })), a;
}
var sX = (
  /** @class */
  function() {
    function e(n, i, t) {
      this.cache = n, this.reader = i, this.fragments = t;
    }
    return e.prototype.writeToStore = function(n, i) {
      var t = this, a = i.query, s = i.result, r = i.dataId, o = i.variables, d = i.overwrite, c = Ks(a), u = GY();
      o = G(G({}, wh(c)), o);
      var k = G(G({ store: n, written: /* @__PURE__ */ Object.create(null), merge: function(f, p) {
        return u.merge(f, p);
      }, variables: o, varString: il(o) }, YD(a, this.fragments)), { overwrite: !!d, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), m = this.processSelectionSet({
        result: s || /* @__PURE__ */ Object.create(null),
        dataId: r,
        selectionSet: c.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: k
      });
      if (!En(m))
        throw dt(12, s);
      return k.incomingById.forEach(function(f, p) {
        var h = f.storeObject, N = f.mergeTree, S = f.fieldNodeSet, F = V1(p);
        if (N && N.map.size) {
          var y = t.applyMerges(N, F, h, k);
          if (En(y))
            return;
          h = y;
        }
        if (globalThis.__DEV__ !== !1 && !k.overwrite) {
          var x = /* @__PURE__ */ Object.create(null);
          S.forEach(function(j) {
            j.selectionSet && (x[j.name.value] = !0);
          });
          var R = function(j) {
            return x[ts(j)] === !0;
          }, T = function(j) {
            var A = N && N.map.get(j);
            return !!(A && A.info && A.info.merge);
          };
          Object.keys(h).forEach(function(j) {
            R(j) && !T(j) && rX(F, h, j, k.store);
          });
        }
        n.merge(p, h);
      }), n.retain(m.__ref), m;
    }, e.prototype.processSelectionSet = function(n) {
      var i = this, t = n.dataId, a = n.result, s = n.selectionSet, r = n.context, o = n.mergeTree, d = this.cache.policies, c = /* @__PURE__ */ Object.create(null), u = t && d.rootTypenamesById[t] || Gk(a, s, r.fragmentMap) || t && r.store.get(t, "__typename");
      typeof u == "string" && (c.__typename = u);
      var k = function() {
        var y = Hh(arguments, c, r.variables);
        if (En(y.from)) {
          var x = r.incomingById.get(y.from.__ref);
          if (x) {
            var R = d.readField(G(G({}, y), { from: x.storeObject }), r);
            if (R !== void 0)
              return R;
          }
        }
        return d.readField(y, r);
      }, m = /* @__PURE__ */ new Set();
      this.flattenFields(
        s,
        a,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        r,
        u
      ).forEach(function(y, x) {
        var R, T = cl(x), j = a[T];
        if (m.add(x), j !== void 0) {
          var A = d.getStoreFieldName({
            typename: u,
            fieldName: x.name.value,
            field: x,
            variables: y.variables
          }), B = Wg(o, A), W = i.processFieldValue(
            j,
            x,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            x.selectionSet ? h3(y, !1, !1) : y,
            B
          ), E = void 0;
          x.selectionSet && (En(W) || J1(W)) && (E = k("__typename", W));
          var $ = d.getMergeFunction(u, x.name.value, E);
          $ ? B.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: x,
            typename: u,
            merge: $
          } : Kg(o, A), c = y.merge(c, (R = {}, R[A] = W, R));
        } else globalThis.__DEV__ !== !1 && !y.clientOnly && !y.deferred && !jh.added(x) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !d.getReadFunction(u, x.name.value) && globalThis.__DEV__ !== !1 && ye.error(13, cl(x), a);
      });
      try {
        var f = d.identify(a, {
          typename: u,
          selectionSet: s,
          fragmentMap: r.fragmentMap,
          storeObject: c,
          readField: k
        }), p = f[0], h = f[1];
        t = t || p, h && (c = r.merge(c, h));
      } catch (y) {
        if (!t)
          throw y;
      }
      if (typeof t == "string") {
        var N = V1(t), S = r.written[t] || (r.written[t] = []);
        if (S.indexOf(s) >= 0 || (S.push(s), this.reader && this.reader.isFresh(a, N, s, r)))
          return N;
        var F = r.incomingById.get(t);
        return F ? (F.storeObject = r.merge(F.storeObject, c), F.mergeTree = df(F.mergeTree, o), m.forEach(function(y) {
          return F.fieldNodeSet.add(y);
        })) : r.incomingById.set(t, {
          storeObject: c,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: Bu(o) ? void 0 : o,
          fieldNodeSet: m
        }), N;
      }
      return c;
    }, e.prototype.processFieldValue = function(n, i, t, a) {
      var s = this;
      return !i.selectionSet || n === null ? globalThis.__DEV__ !== !1 ? jD(n) : n : vi(n) ? n.map(function(r, o) {
        var d = s.processFieldValue(r, i, t, Wg(a, o));
        return Kg(a, o), d;
      }) : this.processSelectionSet({
        result: n,
        selectionSet: i.selectionSet,
        context: t,
        mergeTree: a
      });
    }, e.prototype.flattenFields = function(n, i, t, a) {
      a === void 0 && (a = Gk(i, n, t.fragmentMap));
      var s = /* @__PURE__ */ new Map(), r = this.cache.policies, o = new sa(!1);
      return function d(c, u) {
        var k = o.lookup(
          c,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          u.clientOnly,
          u.deferred
        );
        k.visited || (k.visited = !0, c.selections.forEach(function(m) {
          if (jd(m, t.variables)) {
            var f = u.clientOnly, p = u.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(f && p) && oa(m.directives) && m.directives.forEach(function(S) {
                var F = S.name.value;
                if (F === "client" && (f = !0), F === "defer") {
                  var y = a2(S, t.variables);
                  (!y || y.if !== !1) && (p = !0);
                }
              }), es(m)
            ) {
              var h = s.get(m);
              h && (f = f && h.clientOnly, p = p && h.deferred), s.set(m, h3(t, f, p));
            } else {
              var N = t2(m, t.lookupFragment);
              if (!N && m.kind === Bn.FRAGMENT_SPREAD)
                throw dt(14, m.name.value);
              N && r.fragmentMatches(N, a, i, t.variables) && d(N.selectionSet, h3(t, f, p));
            }
          }
        }));
      }(n, t), s;
    }, e.prototype.applyMerges = function(n, i, t, a, s) {
      var r, o = this;
      if (n.map.size && !En(t)) {
        var d = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !vi(t) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (En(i) || J1(i)) ? i : void 0
        ), c = t;
        d && !s && (s = [En(d) ? d.__ref : d]);
        var u, k = function(m, f) {
          return vi(m) ? typeof f == "number" ? m[f] : void 0 : a.store.getFieldValue(m, String(f));
        };
        n.map.forEach(function(m, f) {
          var p = k(d, f), h = k(c, f);
          if (h !== void 0) {
            s && s.push(f);
            var N = o.applyMerges(m, p, h, a, s);
            N !== h && (u = u || /* @__PURE__ */ new Map(), u.set(f, N)), s && ye(s.pop() === f);
          }
        }), u && (t = vi(c) ? c.slice(0) : G({}, c), u.forEach(function(m, f) {
          t[f] = m;
        }));
      }
      return n.info ? this.cache.policies.runMergeFunction(i, t, n.info, a, s && (r = a.store).getStorage.apply(r, s)) : t;
    }, e;
  }()
), t7 = [];
function Wg(e, n) {
  var i = e.map;
  return i.has(n) || i.set(n, t7.pop() || { map: /* @__PURE__ */ new Map() }), i.get(n);
}
function df(e, n) {
  if (e === n || !n || Bu(n))
    return e;
  if (!e || Bu(e))
    return n;
  var i = e.info && n.info ? G(G({}, e.info), n.info) : e.info || n.info, t = e.map.size && n.map.size, a = t ? /* @__PURE__ */ new Map() : e.map.size ? e.map : n.map, s = { info: i, map: a };
  if (t) {
    var r = new Set(n.map.keys());
    e.map.forEach(function(o, d) {
      s.map.set(d, df(o, n.map.get(d))), r.delete(d);
    }), r.forEach(function(o) {
      s.map.set(o, df(n.map.get(o), e.map.get(o)));
    });
  }
  return s;
}
function Bu(e) {
  return !e || !(e.info || e.map.size);
}
function Kg(e, n) {
  var i = e.map, t = i.get(n);
  t && Bu(t) && (t7.push(t), i.delete(n));
}
var Yg = /* @__PURE__ */ new Set();
function rX(e, n, i, t) {
  var a = function(k) {
    var m = t.getFieldValue(k, i);
    return typeof m == "object" && m;
  }, s = a(e);
  if (s) {
    var r = a(n);
    if (r && !En(s) && !Dn(s, r) && !Object.keys(s).every(function(k) {
      return t.getFieldValue(r, k) !== void 0;
    })) {
      var o = t.getFieldValue(e, "__typename") || t.getFieldValue(n, "__typename"), d = ts(i), c = "".concat(o, ".").concat(d);
      if (!Yg.has(c)) {
        Yg.add(c);
        var u = [];
        !vi(s) && !vi(r) && [s, r].forEach(function(k) {
          var m = t.getFieldValue(k, "__typename");
          typeof m == "string" && !u.includes(m) && u.push(m);
        }), globalThis.__DEV__ !== !1 && ye.warn(15, d, o, u.length ? "either ensure all objects of type " + u.join(" and ") + " have an ID or a custom merge function, or " : "", c, G({}, s), G({}, r));
      }
    }
  }
}
var c2 = (
  /** @class */
  function(e) {
    ca(n, e);
    function n(i) {
      i === void 0 && (i = {});
      var t = e.call(this) || this;
      return t.watches = /* @__PURE__ */ new Set(), t.addTypenameTransform = new CD(jh), t.assumeImmutableResults = !0, t.makeVar = iX, t.txCount = 0, globalThis.__DEV__ !== !1 && (ki(i, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`."), ki(i, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.")), t.config = BY(i), t.addTypename = !!t.config.addTypename, t.policies = new lX({
        cache: t,
        dataIdFromObject: t.config.dataIdFromObject,
        possibleTypes: t.config.possibleTypes,
        typePolicies: t.config.typePolicies
      }), t.init(), t;
    }
    return n.prototype.init = function() {
      var i = this.data = new ld.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = i.stump, this.resetResultCache();
    }, n.prototype.resetResultCache = function(i) {
      var t = this, a = this.storeReader, s = this.config.fragments;
      this.addTypenameTransform.resetCache(), s == null || s.resetCaches(), this.storeWriter = new sX(this, this.storeReader = new XY({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: WD(this.config),
        canon: i ? void 0 : a && a.canon,
        fragments: s
      }), s), this.maybeBroadcastWatch = dr(function(r, o) {
        return t.broadcastWatch(r, o);
      }, {
        max: this.config.resultCacheMaxSize || ra["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(r) {
          var o = r.optimistic ? t.optimisticData : t.data;
          if (To(o)) {
            var d = r.optimistic, c = r.id, u = r.variables;
            return o.makeCacheKey(
              r.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              r.callback,
              il({ optimistic: d, id: c, variables: u })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(r) {
        return r.resetCaching();
      });
    }, n.prototype.restore = function(i) {
      return this.init(), i && this.data.replace(i), this;
    }, n.prototype.extract = function(i) {
      return i === void 0 && (i = !1), (i ? this.optimisticData : this.data).extract();
    }, n.prototype.read = function(i) {
      globalThis.__DEV__ !== !1 && ki(i, "canonizeResults", "cache.read");
      var t = i.returnPartialData, a = t === void 0 ? !1 : t;
      try {
        return this.storeReader.diffQueryAgainstStore(G(G({}, i), { store: i.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: a })).result || null;
      } catch (s) {
        if (s instanceof BD)
          return null;
        throw s;
      }
    }, n.prototype.write = function(i) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, i);
      } finally {
        !--this.txCount && i.broadcast !== !1 && this.broadcastWatches();
      }
    }, n.prototype.modify = function(i) {
      if (Qi.call(i, "id") && !i.id)
        return !1;
      var t = i.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, t.modify(i.id || "ROOT_QUERY", i.fields);
      } finally {
        !--this.txCount && i.broadcast !== !1 && this.broadcastWatches();
      }
    }, n.prototype.diff = function(i) {
      return globalThis.__DEV__ !== !1 && ki(i, "canonizeResults", "cache.diff"), this.storeReader.diffQueryAgainstStore(G(G({}, i), { store: i.optimistic ? this.optimisticData : this.data, rootId: i.id || "ROOT_QUERY", config: this.config }));
    }, n.prototype.watch = function(i) {
      var t = this;
      return this.watches.size || nX(this), this.watches.add(i), i.immediate && this.maybeBroadcastWatch(i), function() {
        t.watches.delete(i) && !t.watches.size && $g(t), t.maybeBroadcastWatch.forget(i);
      };
    }, n.prototype.gc = function(i) {
      globalThis.__DEV__ !== !1 && ki(i || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option."), il.reset(), Js.reset();
      var t = this.optimisticData.gc();
      return i && !this.txCount && (i.resetResultCache ? this.resetResultCache(i.resetResultIdentities) : i.resetResultIdentities && this.storeReader.resetCanon()), t;
    }, n.prototype.retain = function(i, t) {
      return (t ? this.optimisticData : this.data).retain(i);
    }, n.prototype.release = function(i, t) {
      return (t ? this.optimisticData : this.data).release(i);
    }, n.prototype.identify = function(i) {
      if (En(i))
        return i.__ref;
      try {
        return this.policies.identify(i)[0];
      } catch (t) {
        globalThis.__DEV__ !== !1 && ye.warn(t);
      }
    }, n.prototype.evict = function(i) {
      if (!i.id) {
        if (Qi.call(i, "id"))
          return !1;
        i = G(G({}, i), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(i, this.data);
      } finally {
        !--this.txCount && i.broadcast !== !1 && this.broadcastWatches();
      }
    }, n.prototype.reset = function(i) {
      var t = this;
      return this.init(), il.reset(), i && i.discardWatches ? (this.watches.forEach(function(a) {
        return t.maybeBroadcastWatch.forget(a);
      }), this.watches.clear(), $g(this)) : this.broadcastWatches(), Promise.resolve();
    }, n.prototype.removeOptimistic = function(i) {
      var t = this.optimisticData.removeLayer(i);
      t !== this.optimisticData && (this.optimisticData = t, this.broadcastWatches());
    }, n.prototype.batch = function(i) {
      var t = this, a = i.update, s = i.optimistic, r = s === void 0 ? !0 : s, o = i.removeOptimistic, d = i.onWatchUpdated, c, u = function(m) {
        var f = t, p = f.data, h = f.optimisticData;
        ++t.txCount, m && (t.data = t.optimisticData = m);
        try {
          return c = a(t);
        } finally {
          --t.txCount, t.data = p, t.optimisticData = h;
        }
      }, k = /* @__PURE__ */ new Set();
      return d && !this.txCount && this.broadcastWatches(G(G({}, i), { onWatchUpdated: function(m) {
        return k.add(m), !1;
      } })), typeof r == "string" ? this.optimisticData = this.optimisticData.addLayer(r, u) : r === !1 ? u(this.data) : u(), typeof o == "string" && (this.optimisticData = this.optimisticData.removeLayer(o)), d && k.size ? (this.broadcastWatches(G(G({}, i), { onWatchUpdated: function(m, f) {
        var p = d.call(this, m, f);
        return p !== !1 && k.delete(m), p;
      } })), k.size && k.forEach(function(m) {
        return t.maybeBroadcastWatch.dirty(m);
      })) : this.broadcastWatches(i), c;
    }, n.prototype.performTransaction = function(i, t) {
      return this.batch({
        update: i,
        optimistic: t || t !== null
      });
    }, n.prototype.transformDocument = function(i) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(i));
    }, n.prototype.fragmentMatches = function(i, t) {
      return this.policies.fragmentMatches(i, t);
    }, n.prototype.lookupFragment = function(i) {
      var t;
      return ((t = this.config.fragments) === null || t === void 0 ? void 0 : t.lookup(i)) || null;
    }, n.prototype.broadcastWatches = function(i) {
      var t = this;
      this.txCount || this.watches.forEach(function(a) {
        return t.maybeBroadcastWatch(a, i);
      });
    }, n.prototype.addFragmentsToDocument = function(i) {
      var t = this.config.fragments;
      return t ? t.transform(i) : i;
    }, n.prototype.addTypenameToDocument = function(i) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(i) : i;
    }, n.prototype.broadcastWatch = function(i, t) {
      var a = this, s = i.lastDiff, r = Ai("canonizeResults", function() {
        return a.diff(i);
      });
      t && (i.optimistic && typeof t.optimistic == "string" && (r.fromOptimisticTransaction = !0), t.onWatchUpdated && t.onWatchUpdated.call(this, i, r, s) === !1) || (!s || !Dn(s.result, r.result)) && i.callback(i.lastDiff = r, s);
    }, n;
  }(zD)
);
globalThis.__DEV__ !== !1 && (c2.prototype.getMemoryInternals = tK);
var jn;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(jn || (jn = {}));
function _1(e) {
  return e ? e < 7 : !1;
}
var Xg = Object.assign, oX = Object.hasOwnProperty, nu = (
  /** @class */
  function(e) {
    ca(n, e);
    function n(i) {
      var t = i.queryManager, a = i.queryInfo, s = i.options, r = this, o = n.inactiveOnCreation.getValue();
      r = e.call(this, function(S) {
        r._getOrCreateQuery();
        try {
          var F = S._subscription._observer;
          F && !F.error && (F.error = dX);
        } catch (R) {
        }
        var y = !r.observers.size;
        r.observers.add(S);
        var x = r.last;
        return x && x.error ? S.error && S.error(x.error) : x && x.result && S.next && S.next(r.maskResult(x.result)), y && r.reobserve().catch(function() {
        }), function() {
          r.observers.delete(S) && !r.observers.size && r.tearDownQuery();
        };
      }) || this, r.observers = /* @__PURE__ */ new Set(), r.subscriptions = /* @__PURE__ */ new Set(), r.dirty = !1, r._getOrCreateQuery = function() {
        return o && (t.queries.set(r.queryId, a), o = !1), r.queryManager.getOrCreateQuery(r.queryId);
      }, r.queryInfo = a, r.queryManager = t, r.waitForOwnResult = p3(s.fetchPolicy), r.isTornDown = !1, r.subscribeToMore = r.subscribeToMore.bind(r), r.maskResult = r.maskResult.bind(r);
      var d = t.defaultOptions.watchQuery, c = d === void 0 ? {} : d, u = c.fetchPolicy, k = u === void 0 ? "cache-first" : u, m = s.fetchPolicy, f = m === void 0 ? k : m, p = s.initialFetchPolicy, h = p === void 0 ? f === "standby" ? k : f : p;
      r.options = G(G({}, s), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: h,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: f
      }), r.queryId = a.queryId || t.generateQueryId();
      var N = Ks(r.query);
      return r.queryName = N && N.name && N.name.value, r;
    }
    return Object.defineProperty(n.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(n.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), n.prototype.result = function() {
      var i = this;
      return globalThis.__DEV__ !== !1 && Jl("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && ye.warn(23);
      }), new Promise(function(t, a) {
        var s = {
          next: function(o) {
            t(o), i.observers.delete(s), i.observers.size || i.queryManager.removeQuery(i.queryId), setTimeout(function() {
              r.unsubscribe();
            }, 0);
          },
          error: a
        }, r = i.subscribe(s);
      });
    }, n.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, n.prototype.getCurrentFullResult = function(i) {
      var t = this;
      i === void 0 && (i = !0);
      var a = Ai("getLastResult", function() {
        return t.getLastResult(!0);
      }), s = this.queryInfo.networkStatus || a && a.networkStatus || jn.ready, r = G(G({}, a), { loading: _1(s), networkStatus: s }), o = this.options.fetchPolicy, d = o === void 0 ? "cache-first" : o;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(p3(d) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var c = this.queryInfo.getDiff();
        (c.complete || this.options.returnPartialData) && (r.data = c.result), Dn(r.data, {}) && (r.data = void 0), c.complete ? (delete r.partial, c.complete && r.networkStatus === jn.loading && (d === "cache-first" || d === "cache-only") && (r.networkStatus = jn.ready, r.loading = !1)) : r.partial = !0, r.networkStatus === jn.ready && (r.error || r.errors) && (r.networkStatus = jn.error), globalThis.__DEV__ !== !1 && !c.complete && !this.options.partialRefetch && !r.loading && !r.data && !r.error && a7(c.missing);
      }
      return i && this.updateLastResult(r), r;
    }, n.prototype.getCurrentResult = function(i) {
      return i === void 0 && (i = !0), this.maskResult(this.getCurrentFullResult(i));
    }, n.prototype.isDifferentFromLastResult = function(i, t) {
      if (!this.last)
        return !0;
      var a = this.queryManager.getDocumentInfo(this.query), s = this.queryManager.dataMasking, r = s ? a.nonReactiveQuery : this.query, o = s || a.hasNonreactiveDirective ? !MD(r, this.last.result, i, this.variables) : !Dn(this.last.result, i);
      return o || t && !Dn(this.last.variables, t);
    }, n.prototype.getLast = function(i, t) {
      var a = this.last;
      if (a && a[i] && (!t || Dn(a.variables, this.variables)))
        return a[i];
    }, n.prototype.getLastResult = function(i) {
      return globalThis.__DEV__ !== !1 && Jl("getLastResult", function() {
        globalThis.__DEV__ !== !1 && ye.warn(24);
      }), this.getLast("result", i);
    }, n.prototype.getLastError = function(i) {
      return globalThis.__DEV__ !== !1 && Jl("getLastError", function() {
        globalThis.__DEV__ !== !1 && ye.warn(25);
      }), this.getLast("error", i);
    }, n.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && Jl("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && ye.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, n.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && ye.warn(27), this.queryManager.resetErrors(this.queryId);
    }, n.prototype.refetch = function(i) {
      var t, a = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, s = this.options.fetchPolicy;
      if (s === "no-cache" ? a.fetchPolicy = "no-cache" : a.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && i && oX.call(i, "variables")) {
        var r = mD(this.query), o = r.variableDefinitions;
        (!o || !o.some(function(d) {
          return d.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && ye.warn(
          28,
          i,
          ((t = r.name) === null || t === void 0 ? void 0 : t.value) || r
        );
      }
      return i && !Dn(this.options.variables, i) && (a.variables = this.options.variables = G(G({}, this.options.variables), i)), this.queryInfo.resetLastWrite(), this.reobserve(a, jn.refetch);
    }, n.prototype.fetchMore = function(i) {
      var t = this, a = G(G({}, i.query ? i : G(G(G(G({}, this.options), { query: this.options.query }), i), { variables: G(G({}, this.options.variables), i.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      a.query = this.transformDocument(a.query);
      var s = this.queryManager.generateQueryId();
      this.lastQuery = i.query ? this.transformDocument(this.options.query) : a.query;
      var r = this.queryInfo, o = r.networkStatus;
      r.networkStatus = jn.fetchMore, a.notifyOnNetworkStatusChange && this.observe();
      var d = /* @__PURE__ */ new Set(), c = i == null ? void 0 : i.updateQuery, u = this.options.fetchPolicy !== "no-cache";
      return u || ye(c, 29), this.queryManager.fetchQuery(s, a, jn.fetchMore).then(function(k) {
        if (t.queryManager.removeQuery(s), r.networkStatus === jn.fetchMore && (r.networkStatus = o), u)
          t.queryManager.cache.batch({
            update: function(p) {
              var h = i.updateQuery;
              h ? p.updateQuery({
                query: t.query,
                variables: t.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(N) {
                return h(N, {
                  fetchMoreResult: k.data,
                  variables: a.variables
                });
              }) : p.writeQuery({
                query: a.query,
                variables: a.variables,
                data: k.data
              });
            },
            onWatchUpdated: function(p) {
              d.add(p.query);
            }
          });
        else {
          var m = t.getLast("result"), f = c(m.data, {
            fetchMoreResult: k.data,
            variables: a.variables
          });
          t.reportResult(G(G({}, m), { networkStatus: o, loading: _1(o), data: f }), t.variables);
        }
        return t.maskResult(k);
      }).finally(function() {
        u && !d.has(t.query) && t.reobserveCacheFirst();
      });
    }, n.prototype.subscribeToMore = function(i) {
      var t = this, a = this.queryManager.startGraphQLSubscription({
        query: i.document,
        variables: i.variables,
        context: i.context
      }).subscribe({
        next: function(s) {
          var r = i.updateQuery;
          r && t.updateQuery(function(o, d) {
            return r(o, G({ subscriptionData: s }, d));
          });
        },
        error: function(s) {
          if (i.onError) {
            i.onError(s);
            return;
          }
          globalThis.__DEV__ !== !1 && ye.error(30, s);
        }
      });
      return this.subscriptions.add(a), function() {
        t.subscriptions.delete(a) && a.unsubscribe();
      };
    }, n.prototype.setOptions = function(i) {
      return globalThis.__DEV__ !== !1 && (ki(i, "canonizeResults", "setOptions"), Jl("setOptions", function() {
        globalThis.__DEV__ !== !1 && ye.warn(31);
      })), this.reobserve(i);
    }, n.prototype.silentSetOptions = function(i) {
      var t = ur(this.options, i || {});
      Xg(this.options, t);
    }, n.prototype.setVariables = function(i) {
      var t = this;
      return Dn(this.variables, i) ? this.observers.size ? Ai("observableQuery.result", function() {
        return t.result();
      }) : Promise.resolve() : (this.options.variables = i, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: i
      }, jn.setVariables) : Promise.resolve());
    }, n.prototype.updateQuery = function(i) {
      var t = this.queryManager, a = t.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), s = a.result, r = a.complete, o = i(s, {
        variables: this.variables,
        complete: !!r,
        previousData: s
      });
      o && (t.cache.writeQuery({
        query: this.options.query,
        data: o,
        variables: this.variables
      }), t.broadcastQueries());
    }, n.prototype.startPolling = function(i) {
      this.options.pollInterval = i, this.updatePolling();
    }, n.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, n.prototype.applyNextFetchPolicy = function(i, t) {
      if (t.nextFetchPolicy) {
        var a = t.fetchPolicy, s = a === void 0 ? "cache-first" : a, r = t.initialFetchPolicy, o = r === void 0 ? s : r;
        s === "standby" || (typeof t.nextFetchPolicy == "function" ? t.fetchPolicy = t.nextFetchPolicy(s, {
          reason: i,
          options: t,
          observable: this,
          initialFetchPolicy: o
        }) : i === "variables-changed" ? t.fetchPolicy = o : t.fetchPolicy = t.nextFetchPolicy);
      }
      return t.fetchPolicy;
    }, n.prototype.fetch = function(i, t, a) {
      var s = this._getOrCreateQuery();
      return s.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(s, i, t, a);
    }, n.prototype.updatePolling = function() {
      var i = this;
      if (!this.queryManager.ssrMode) {
        var t = this, a = t.pollingInfo, s = t.options.pollInterval;
        if (!s || !this.hasObservers()) {
          a && (clearTimeout(a.timeout), delete this.pollingInfo);
          return;
        }
        if (!(a && a.interval === s)) {
          ye(s, 32);
          var r = a || (this.pollingInfo = {});
          r.interval = s;
          var o = function() {
            var c, u;
            i.pollingInfo && (!_1(i.queryInfo.networkStatus) && !(!((u = (c = i.options).skipPollAttempt) === null || u === void 0) && u.call(c)) ? i.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: i.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, jn.poll).then(d, d) : d());
          }, d = function() {
            var c = i.pollingInfo;
            c && (clearTimeout(c.timeout), c.timeout = setTimeout(o, c.interval));
          };
          d();
        }
      }
    }, n.prototype.updateLastResult = function(i, t) {
      var a = this;
      t === void 0 && (t = this.variables);
      var s = Ai("getLastError", function() {
        return a.getLastError();
      });
      return s && this.last && !Dn(t, this.last.variables) && (s = void 0), this.last = G({ result: this.queryManager.assumeImmutableResults ? i : jD(i), variables: t }, s ? { error: s } : null);
    }, n.prototype.reobserveAsConcast = function(i, t) {
      var a = this;
      this.isTornDown = !1;
      var s = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        t === jn.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        t === jn.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        t === jn.poll
      ), r = this.options.variables, o = this.options.fetchPolicy, d = ur(this.options, i || {}), c = s ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        d
      ) : Xg(this.options, d), u = this.transformDocument(c.query);
      this.lastQuery = u, s || (this.updatePolling(), i && i.variables && !Dn(i.variables, r) && // Don't mess with the fetchPolicy if it's currently "standby".
      c.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (c.fetchPolicy === o || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof c.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", c), t === void 0 && (t = jn.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = p3(c.fetchPolicy));
      var k = function() {
        a.concast === p && (a.waitForOwnResult = !1);
      }, m = c.variables && G({}, c.variables), f = this.fetch(c, t, u), p = f.concast, h = f.fromLink, N = {
        next: function(S) {
          Dn(a.variables, m) && (k(), a.reportResult(S, m));
        },
        error: function(S) {
          Dn(a.variables, m) && (_D(S) || (S = new Sa({ networkError: S })), k(), a.reportError(S, m));
        }
      };
      return !s && (h || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = p, this.observer = N), p.addObserver(N), p;
    }, n.prototype.reobserve = function(i, t) {
      return XK(this.reobserveAsConcast(i, t).promise.then(this.maskResult));
    }, n.prototype.resubscribeAfterError = function() {
      for (var i = this, t = [], a = 0; a < arguments.length; a++)
        t[a] = arguments[a];
      var s = this.last;
      Ai("resetLastResults", function() {
        return i.resetLastResults();
      });
      var r = this.subscribe.apply(this, t);
      return this.last = s, r;
    }, n.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, n.prototype.reportResult = function(i, t) {
      var a = this, s = Ai("getLastError", function() {
        return a.getLastError();
      }), r = this.isDifferentFromLastResult(i, t);
      (s || !i.partial || this.options.returnPartialData) && this.updateLastResult(i, t), (s || r) && Ro(this.observers, "next", this.maskResult(i));
    }, n.prototype.reportError = function(i, t) {
      var a = this, s = G(G({}, Ai("getLastResult", function() {
        return a.getLastResult();
      })), { error: i, errors: i.graphQLErrors, networkStatus: jn.error, loading: !1 });
      this.updateLastResult(s, t), Ro(this.observers, "error", this.last.error = i);
    }, n.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, n.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(i) {
        return i.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, n.prototype.transformDocument = function(i) {
      return this.queryManager.transform(i);
    }, n.prototype.maskResult = function(i) {
      return i && "data" in i ? G(G({}, i), { data: this.queryManager.maskOperation({
        document: this.query,
        data: i.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : i;
    }, n.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, n.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, n.prototype.scheduleNotify = function() {
      var i = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return i.notify();
      }, 0)));
    }, n.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !_1(this.queryInfo.networkStatus))) {
        var i = this.queryInfo.getDiff();
        i.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, n.prototype.reobserveCacheFirst = function() {
      var i = this.options, t = i.fetchPolicy, a = i.nextFetchPolicy;
      return t === "cache-and-network" || t === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(s, r) {
          return this.nextFetchPolicy = a, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(s, r) : t;
        }
      }) : this.reobserve();
    }, n.inactiveOnCreation = new Mr(), n;
  }($n)
);
AD(nu);
function dX(e) {
  globalThis.__DEV__ !== !1 && ye.error(33, e.message, e.stack);
}
function a7(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && ye.debug(34, e);
}
function p3(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var Q1 = new (dl ? WeakMap : Map)();
function N3(e, n) {
  var i = e[n];
  typeof i == "function" && (e[n] = function() {
    return Q1.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (Q1.get(e) + 1) % 1e15
    ), i.apply(this, arguments);
  });
}
var S3 = (
  /** @class */
  function() {
    function e(n, i) {
      i === void 0 && (i = n.generateQueryId()), this.queryId = i, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var t = this.cache = n.cache;
      Q1.has(t) || (Q1.set(t, 0), N3(t, "evict"), N3(t, "modify"), N3(t, "reset"));
    }
    return e.prototype.init = function(n) {
      var i = n.networkStatus || jn.loading;
      return this.variables && this.networkStatus !== jn.loading && !Dn(this.variables, n.variables) && (i = jn.setVariables), Dn(n.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: n.document,
        variables: n.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: i
      }), n.observableQuery && this.setObservableQuery(n.observableQuery), n.lastRequestId && (this.lastRequestId = n.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var n = this, i = this.getDiffOptions();
      if (this.lastDiff && Dn(i, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var t = this.observableQuery;
      if (t && t.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var a = Ai("canonizeResults", function() {
        return n.cache.diff(i);
      });
      return this.updateLastDiff(a, i), a;
    }, e.prototype.updateLastDiff = function(n, i) {
      this.lastDiff = n ? {
        diff: n,
        options: i || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(n) {
      var i;
      return n === void 0 && (n = this.variables), {
        query: this.document,
        variables: n,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (i = this.observableQuery) === null || i === void 0 ? void 0 : i.options.canonizeResults
      };
    }, e.prototype.setDiff = function(n) {
      var i = this, t, a = this.lastDiff && this.lastDiff.diff;
      n && !n.complete && Ai("getLastError", function() {
        var s;
        return (s = i.observableQuery) === null || s === void 0 ? void 0 : s.getLastError();
      }) || (this.updateLastDiff(n), Dn(a && a.result, n && n.result) || (t = this.observableQuery) === null || t === void 0 || t.scheduleNotify());
    }, e.prototype.setObservableQuery = function(n) {
      n !== this.observableQuery && (this.observableQuery = n, n && (n.queryInfo = this));
    }, e.prototype.stop = function() {
      var n;
      if (!this.stopped) {
        this.stopped = !0, (n = this.observableQuery) === null || n === void 0 || n.resetNotifications(), this.cancel();
        var i = this.observableQuery;
        i && i.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var n;
      (n = this.cancelWatch) === null || n === void 0 || n.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(n) {
      var i = this;
      n === void 0 && (n = this.variables);
      var t = this.observableQuery;
      if (!(t && t.options.fetchPolicy === "no-cache")) {
        var a = G(G({}, this.getDiffOptions(n)), { watcher: this, callback: function(s) {
          return i.setDiff(s);
        } });
        (!this.lastWatch || !Dn(a, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = a));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(n, i) {
      var t = this.lastWrite;
      return !(t && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      t.dmCount === Q1.get(this.cache) && Dn(i, t.variables) && Dn(n.data, t.result.data));
    }, e.prototype.markResult = function(n, i, t, a) {
      var s = this, r, o = new is(), d = oa(n.errors) ? n.errors.slice(0) : [];
      if ((r = this.observableQuery) === null || r === void 0 || r.resetNotifications(), "incremental" in n && oa(n.incremental)) {
        var c = OD(this.getDiff().result, n);
        n.data = c;
      } else if ("hasNext" in n && n.hasNext) {
        var u = this.getDiff();
        n.data = o.merge(u.result, n.data);
      }
      this.graphQLErrors = d, t.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: n.data, complete: !0 }, this.getDiffOptions(t.variables)) : a !== 0 && (cf(n, t.errorPolicy) ? this.cache.performTransaction(function(k) {
        if (s.shouldWrite(n, t.variables))
          k.writeQuery({
            query: i,
            data: n.data,
            variables: t.variables,
            overwrite: a === 1
          }), s.lastWrite = {
            result: n,
            variables: t.variables,
            dmCount: Q1.get(s.cache)
          };
        else if (s.lastDiff && s.lastDiff.diff.complete) {
          n.data = s.lastDiff.diff.result;
          return;
        }
        var m = s.getDiffOptions(t.variables), f = Ai("canonizeResults", function() {
          return k.diff(m);
        });
        !s.stopped && Dn(s.variables, t.variables) && s.updateWatch(t.variables), s.updateLastDiff(f, m), f.complete && (n.data = f.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = jn.ready;
    }, e.prototype.markError = function(n) {
      var i;
      return this.networkStatus = jn.error, this.lastWrite = void 0, (i = this.observableQuery) === null || i === void 0 || i.resetNotifications(), n.graphQLErrors && (this.graphQLErrors = n.graphQLErrors), n.networkError && (this.networkError = n.networkError), n;
    }, e;
  }()
);
function cf(e, n) {
  n === void 0 && (n = "none");
  var i = n === "ignore" || n === "all", t = !Yc(e);
  return !t && i && e.data && (t = !0), t;
}
var cX = Object.prototype.hasOwnProperty, Zg = /* @__PURE__ */ Object.create(null), uX = (
  /** @class */
  function() {
    function e(n) {
      var i = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new xh(
        ra["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new sa(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var t = new CD(
        function(s) {
          return i.cache.transformDocument(s);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = n.cache, this.link = n.link, this.defaultOptions = n.defaultOptions, this.queryDeduplication = n.queryDeduplication, this.clientAwareness = n.clientAwareness, this.localState = n.localState, this.ssrMode = n.ssrMode, this.assumeImmutableResults = n.assumeImmutableResults, this.dataMasking = n.dataMasking;
      var a = n.documentTransform;
      this.documentTransform = a ? t.concat(a).concat(t) : t, this.defaultContext = n.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = n.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var n = this;
      this.queries.forEach(function(i, t) {
        n.stopQueryNoBroadcast(t);
      }), this.cancelPendingFetches(dt(35));
    }, e.prototype.cancelPendingFetches = function(n) {
      this.fetchCancelFns.forEach(function(i) {
        return i(n);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(n) {
      return jl(this, arguments, void 0, function(i) {
        var t, a, s, r, o, d, c, u = i.mutation, k = i.variables, m = i.optimisticResponse, f = i.updateQueries, p = i.refetchQueries, h = p === void 0 ? [] : p, N = i.awaitRefetchQueries, S = N === void 0 ? !1 : N, F = i.update, y = i.onQueryUpdated, x = i.fetchPolicy, R = x === void 0 ? ((d = this.defaultOptions.mutate) === null || d === void 0 ? void 0 : d.fetchPolicy) || "network-only" : x, T = i.errorPolicy, j = T === void 0 ? ((c = this.defaultOptions.mutate) === null || c === void 0 ? void 0 : c.errorPolicy) || "none" : T, A = i.keepRootFields, B = i.context;
        return Al(this, function(W) {
          switch (W.label) {
            case 0:
              return ye(u, 36), ye(R === "network-only" || R === "no-cache", 37), t = this.generateMutationId(), u = this.cache.transformForLink(this.transform(u)), a = this.getDocumentInfo(u).hasClientExports, k = this.getVariables(u, k), a ? [4, this.localState.addExportedVariables(u, k, B)] : [3, 2];
            case 1:
              k = W.sent(), W.label = 2;
            case 2:
              return s = this.mutationStore && (this.mutationStore[t] = {
                mutation: u,
                variables: k,
                loading: !0,
                error: null
              }), r = m && this.markMutationOptimistic(m, {
                mutationId: t,
                document: u,
                variables: k,
                fetchPolicy: R,
                errorPolicy: j,
                context: B,
                updateQueries: f,
                update: F,
                keepRootFields: A
              }), this.broadcastQueries(), o = this, [2, new Promise(function(E, $) {
                return u3(o.getObservableFromLink(u, G(G({}, B), { optimisticResponse: r ? m : void 0 }), k, {}, !1), function(V) {
                  if (Yc(V) && j === "none")
                    throw new Sa({
                      graphQLErrors: Xk(V)
                    });
                  s && (s.loading = !1, s.error = null);
                  var H = G({}, V);
                  return typeof h == "function" && (h = h(H)), j === "ignore" && Yc(H) && delete H.errors, o.markMutationResult({
                    mutationId: t,
                    result: H,
                    document: u,
                    variables: k,
                    fetchPolicy: R,
                    errorPolicy: j,
                    context: B,
                    update: F,
                    updateQueries: f,
                    awaitRefetchQueries: S,
                    refetchQueries: h,
                    removeOptimistic: r ? t : void 0,
                    onQueryUpdated: y,
                    keepRootFields: A
                  });
                }).subscribe({
                  next: function(V) {
                    o.broadcastQueries(), (!("hasNext" in V) || V.hasNext === !1) && E(G(G({}, V), { data: o.maskOperation({
                      document: u,
                      data: V.data,
                      fetchPolicy: R,
                      id: t
                    }) }));
                  },
                  error: function(V) {
                    s && (s.loading = !1, s.error = V), r && o.cache.removeOptimistic(t), o.broadcastQueries(), $(V instanceof Sa ? V : new Sa({
                      networkError: V
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(n, i) {
      var t = this;
      i === void 0 && (i = this.cache);
      var a = n.result, s = [], r = n.fetchPolicy === "no-cache";
      if (!r && cf(a, n.errorPolicy)) {
        if (H1(a) || s.push({
          result: a.data,
          dataId: "ROOT_MUTATION",
          query: n.document,
          variables: n.variables
        }), H1(a) && oa(a.incremental)) {
          var o = i.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(n.document).asQuery,
            variables: n.variables,
            optimistic: !1,
            returnPartialData: !0
          }), d = void 0;
          o.result && (d = OD(o.result, a)), typeof d != "undefined" && (a.data = d, s.push({
            result: d,
            dataId: "ROOT_MUTATION",
            query: n.document,
            variables: n.variables
          }));
        }
        var c = n.updateQueries;
        c && this.queries.forEach(function(k, m) {
          var f = k.observableQuery, p = f && f.queryName;
          if (!(!p || !cX.call(c, p))) {
            var h = c[p], N = t.queries.get(m), S = N.document, F = N.variables, y = i.diff({
              query: S,
              variables: F,
              returnPartialData: !0,
              optimistic: !1
            }), x = y.result, R = y.complete;
            if (R && x) {
              var T = h(x, {
                mutationResult: a,
                queryName: S && So(S) || void 0,
                queryVariables: F
              });
              T && s.push({
                result: T,
                dataId: "ROOT_QUERY",
                query: S,
                variables: F
              });
            }
          }
        });
      }
      if (s.length > 0 || (n.refetchQueries || "").length > 0 || n.update || n.onQueryUpdated || n.removeOptimistic) {
        var u = [];
        if (this.refetchQueries({
          updateCache: function(k) {
            r || s.forEach(function(h) {
              return k.write(h);
            });
            var m = n.update, f = !tY(a) || H1(a) && !a.hasNext;
            if (m) {
              if (!r) {
                var p = k.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: t.getDocumentInfo(n.document).asQuery,
                  variables: n.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                p.complete && (a = G(G({}, a), { data: p.result }), "incremental" in a && delete a.incremental, "hasNext" in a && delete a.hasNext);
              }
              f && m(k, a, {
                context: n.context,
                variables: n.variables
              });
            }
            !r && !n.keepRootFields && f && k.modify({
              id: "ROOT_MUTATION",
              fields: function(h, N) {
                var S = N.fieldName, F = N.DELETE;
                return S === "__typename" ? h : F;
              }
            });
          },
          include: n.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: n.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: n.onQueryUpdated || null
        }).forEach(function(k) {
          return u.push(k);
        }), n.awaitRefetchQueries || n.onQueryUpdated)
          return Promise.all(u).then(function() {
            return a;
          });
      }
      return Promise.resolve(a);
    }, e.prototype.markMutationOptimistic = function(n, i) {
      var t = this, a = typeof n == "function" ? n(i.variables, { IGNORE: Zg }) : n;
      return a === Zg ? !1 : (this.cache.recordOptimisticTransaction(function(s) {
        try {
          t.markMutationResult(G(G({}, i), { result: { data: a } }), s);
        } catch (r) {
          globalThis.__DEV__ !== !1 && ye.error(r);
        }
      }, i.mutationId), !0);
    }, e.prototype.fetchQuery = function(n, i, t) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(n), i, t).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var n = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(i, t) {
        n[t] = {
          variables: i.variables,
          networkStatus: i.networkStatus,
          networkError: i.networkError,
          graphQLErrors: i.graphQLErrors
        };
      }), n;
    }, e.prototype.resetErrors = function(n) {
      var i = this.queries.get(n);
      i && (i.networkError = void 0, i.graphQLErrors = []);
    }, e.prototype.transform = function(n) {
      return this.documentTransform.transformDocument(n);
    }, e.prototype.getDocumentInfo = function(n) {
      var i = this.transformCache;
      if (!i.has(n)) {
        var t = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: JW(n),
          hasForcedResolvers: this.localState.shouldForceResolvers(n),
          hasNonreactiveDirective: id(["nonreactive"], n),
          nonReactiveQuery: MK(n),
          clientQuery: this.localState.clientQuery(n),
          serverQuery: DD([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], n),
          defaultVars: wh(Ks(n)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: G(G({}, n), { definitions: n.definitions.map(function(a) {
            return a.kind === "OperationDefinition" && a.operation !== "query" ? G(G({}, a), { operation: "query" }) : a;
          }) })
        };
        i.set(n, t);
      }
      return i.get(n);
    }, e.prototype.getVariables = function(n, i) {
      return G(G({}, this.getDocumentInfo(n).defaultVars), i);
    }, e.prototype.watchQuery = function(n) {
      var i = this.transform(n.query);
      n = G(G({}, n), { variables: this.getVariables(i, n.variables) }), typeof n.notifyOnNetworkStatusChange == "undefined" && (n.notifyOnNetworkStatusChange = !1);
      var t = new S3(this), a = new nu({
        queryManager: this,
        queryInfo: t,
        options: n
      });
      return a.lastQuery = i, nu.inactiveOnCreation.getValue() || this.queries.set(a.queryId, t), t.init({
        document: i,
        observableQuery: a,
        variables: a.variables
      }), a;
    }, e.prototype.query = function(n, i) {
      var t = this;
      i === void 0 && (i = this.generateQueryId()), ye(n.query, 38), ye(n.query.kind === "Document", 39), ye(!n.returnPartialData, 40), ye(!n.pollInterval, 41);
      var a = this.transform(n.query);
      return this.fetchQuery(i, G(G({}, n), { query: a })).then(function(s) {
        return s && G(G({}, s), { data: t.maskOperation({
          document: a,
          data: s.data,
          fetchPolicy: n.fetchPolicy,
          id: i
        }) });
      }).finally(function() {
        return t.stopQuery(i);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(n) {
      this.stopQueryInStoreNoBroadcast(n), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(n) {
      var i = this.queries.get(n);
      i && i.stop();
    }, e.prototype.clearStore = function(n) {
      return n === void 0 && (n = {
        discardWatches: !0
      }), this.cancelPendingFetches(dt(42)), this.queries.forEach(function(i) {
        i.observableQuery ? i.networkStatus = jn.loading : i.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(n);
    }, e.prototype.getObservableQueries = function(n) {
      var i = this;
      n === void 0 && (n = "active");
      var t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set();
      return Array.isArray(n) && n.forEach(function(o) {
        if (typeof o == "string")
          a.set(o, o), s.set(o, !1);
        else if (uK(o)) {
          var d = Js(i.transform(o));
          a.set(d, So(o)), s.set(d, !1);
        } else fi(o) && o.query && r.add(o);
      }), this.queries.forEach(function(o, d) {
        var c = o.observableQuery, u = o.document;
        if (c) {
          if (n === "all") {
            t.set(d, c);
            return;
          }
          var k = c.queryName, m = c.options.fetchPolicy;
          if (m === "standby" || n === "active" && !c.hasObservers())
            return;
          (n === "active" || k && s.has(k) || u && s.has(Js(u))) && (t.set(d, c), k && s.set(k, !0), u && s.set(Js(u), !0));
        }
      }), r.size && r.forEach(function(o) {
        var d = Lk("legacyOneTimeQuery"), c = i.getOrCreateQuery(d).init({
          document: o.query,
          variables: o.variables
        }), u = new nu({
          queryManager: i,
          queryInfo: c,
          options: G(G({}, o), { fetchPolicy: "network-only" })
        });
        ye(u.queryId === d), c.setObservableQuery(u), t.set(d, u);
      }), globalThis.__DEV__ !== !1 && s.size && s.forEach(function(o, d) {
        if (!o) {
          var c = a.get(d);
          c ? globalThis.__DEV__ !== !1 && ye.warn(43, c) : globalThis.__DEV__ !== !1 && ye.warn(44);
        }
      }), t;
    }, e.prototype.reFetchObservableQueries = function(n) {
      var i = this;
      n === void 0 && (n = !1);
      var t = [];
      return this.getObservableQueries(n ? "all" : "active").forEach(function(a, s) {
        var r = a.options.fetchPolicy;
        Ai("resetLastResults", function() {
          return a.resetLastResults();
        }), (n || r !== "standby" && r !== "cache-only") && t.push(a.refetch()), (i.queries.get(s) || a.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(t);
    }, e.prototype.startGraphQLSubscription = function(n) {
      var i = this, t = n.query, a = n.variables, s = n.fetchPolicy, r = n.errorPolicy, o = r === void 0 ? "none" : r, d = n.context, c = d === void 0 ? {} : d, u = n.extensions, k = u === void 0 ? {} : u;
      t = this.transform(t), a = this.getVariables(t, a);
      var m = function(p) {
        return i.getObservableFromLink(t, c, p, k).map(function(h) {
          s !== "no-cache" && (cf(h, o) && i.cache.write({
            query: t,
            result: h.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: p
          }), i.broadcastQueries());
          var N = Yc(h), S = JD(h);
          if (N || S) {
            var F = {};
            if (N && (F.graphQLErrors = h.errors), S && (F.protocolErrors = h.extensions[o2]), o === "none" || S)
              throw new Sa(F);
          }
          return o === "ignore" && delete h.errors, h;
        });
      };
      if (this.getDocumentInfo(t).hasClientExports) {
        var f = this.localState.addExportedVariables(t, a, c).then(m);
        return new $n(function(p) {
          var h = null;
          return f.then(function(N) {
            return h = N.subscribe(p);
          }, p.error), function() {
            return h && h.unsubscribe();
          };
        });
      }
      return m(a);
    }, e.prototype.stopQuery = function(n) {
      this.stopQueryNoBroadcast(n), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(n) {
      this.stopQueryInStoreNoBroadcast(n), this.removeQuery(n);
    }, e.prototype.removeQuery = function(n) {
      var i;
      this.fetchCancelFns.delete(n), this.queries.has(n) && ((i = this.queries.get(n)) === null || i === void 0 || i.stop(), this.queries.delete(n));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(n) {
        var i;
        return (i = n.observableQuery) === null || i === void 0 ? void 0 : i.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(n, i, t, a, s) {
      var r = this, o;
      s === void 0 && (s = (o = i == null ? void 0 : i.queryDeduplication) !== null && o !== void 0 ? o : this.queryDeduplication);
      var d, c = this.getDocumentInfo(n), u = c.serverQuery, k = c.clientQuery;
      if (u) {
        var m = this, f = m.inFlightLinkObservables, p = m.link, h = {
          query: u,
          variables: t,
          operationName: So(u) || void 0,
          context: this.prepareContext(G(G({}, i), { forceFetch: !s })),
          extensions: a
        };
        if (i = h.context, s) {
          var N = Js(u), S = il(t), F = f.lookup(N, S);
          if (d = F.observable, !d) {
            var y = new w1([
              tf(p, h)
            ]);
            d = F.observable = y, y.beforeNext(function x(R, T) {
              R === "next" && "hasNext" in T && T.hasNext ? y.beforeNext(x) : f.remove(N, S);
            });
          }
        } else
          d = new w1([
            tf(p, h)
          ]);
      } else
        d = new w1([$n.of({ data: {} })]), i = this.prepareContext(i);
      return k && (d = u3(d, function(x) {
        return r.localState.runResolvers({
          document: k,
          remoteResult: x,
          context: i,
          variables: t
        });
      })), d;
    }, e.prototype.getResultsFromLink = function(n, i, t) {
      var a = n.lastRequestId = this.generateRequestId(), s = this.cache.transformForLink(t.query);
      return u3(this.getObservableFromLink(s, t.context, t.variables), function(r) {
        var o = Xk(r), d = o.length > 0, c = t.errorPolicy;
        if (a >= n.lastRequestId) {
          if (d && c === "none")
            throw n.markError(new Sa({
              graphQLErrors: o
            }));
          n.markResult(r, s, t, i), n.markReady();
        }
        var u = {
          data: r.data,
          loading: !1,
          networkStatus: jn.ready
        };
        return d && c === "none" && (u.data = void 0), d && c !== "ignore" && (u.errors = o, u.networkStatus = jn.error), u;
      }, function(r) {
        var o = _D(r) ? r : new Sa({ networkError: r });
        throw a >= n.lastRequestId && n.markError(o), o;
      });
    }, e.prototype.fetchConcastWithInfo = function(n, i, t, a) {
      var s = this;
      t === void 0 && (t = jn.loading), a === void 0 && (a = i.query);
      var r = this.getVariables(a, i.variables), o = this.defaultOptions.watchQuery, d = i.fetchPolicy, c = d === void 0 ? o && o.fetchPolicy || "cache-first" : d, u = i.errorPolicy, k = u === void 0 ? o && o.errorPolicy || "none" : u, m = i.returnPartialData, f = m === void 0 ? !1 : m, p = i.notifyOnNetworkStatusChange, h = p === void 0 ? !1 : p, N = i.context, S = N === void 0 ? {} : N, F = Object.assign({}, i, {
        query: a,
        variables: r,
        fetchPolicy: c,
        errorPolicy: k,
        returnPartialData: f,
        notifyOnNetworkStatusChange: h,
        context: S
      }), y = function(A) {
        F.variables = A;
        var B = s.fetchQueryByPolicy(n, F, t);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          F.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          B.sources.length > 0 && n.observableQuery && n.observableQuery.applyNextFetchPolicy("after-fetch", i), B
        );
      }, x = function() {
        return s.fetchCancelFns.delete(n.queryId);
      };
      this.fetchCancelFns.set(n.queryId, function(A) {
        x(), setTimeout(function() {
          return R.cancel(A);
        });
      });
      var R, T;
      if (this.getDocumentInfo(F.query).hasClientExports)
        R = new w1(this.localState.addExportedVariables(F.query, F.variables, F.context).then(y).then(function(A) {
          return A.sources;
        })), T = !0;
      else {
        var j = y(F.variables);
        T = j.fromLink, R = new w1(j.sources);
      }
      return R.promise.then(x, x), {
        concast: R,
        fromLink: T
      };
    }, e.prototype.refetchQueries = function(n) {
      var i = this, t = n.updateCache, a = n.include, s = n.optimistic, r = s === void 0 ? !1 : s, o = n.removeOptimistic, d = o === void 0 ? r ? Lk("refetchQueries") : void 0 : o, c = n.onQueryUpdated, u = /* @__PURE__ */ new Map();
      a && this.getObservableQueries(a).forEach(function(m, f) {
        u.set(f, {
          oq: m,
          lastDiff: (i.queries.get(f) || m.queryInfo).getDiff()
        });
      });
      var k = /* @__PURE__ */ new Map();
      return t && this.cache.batch({
        update: t,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: r && d || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: d,
        onWatchUpdated: function(m, f, p) {
          var h = m.watcher instanceof S3 && m.watcher.observableQuery;
          if (h) {
            if (c) {
              u.delete(h.queryId);
              var N = c(h, f, p);
              return N === !0 && (N = h.refetch()), N !== !1 && k.set(h, N), N;
            }
            c !== null && u.set(h.queryId, { oq: h, lastDiff: p, diff: f });
          }
        }
      }), u.size && u.forEach(function(m, f) {
        var p = m.oq, h = m.lastDiff, N = m.diff, S;
        c && (N || (N = Ai("canonizeResults", function() {
          return i.cache.diff(p.queryInfo.getDiffOptions());
        })), S = c(p, N, h)), (!c || S === !0) && (S = p.refetch()), S !== !1 && k.set(p, S), f.indexOf("legacyOneTimeQuery") >= 0 && i.stopQueryNoBroadcast(f);
      }), d && this.cache.removeOptimistic(d), k;
    }, e.prototype.maskOperation = function(n) {
      var i, t, a, s = n.document, r = n.data;
      if (globalThis.__DEV__ !== !1) {
        var o = n.fetchPolicy, d = n.id, c = (i = Ks(s)) === null || i === void 0 ? void 0 : i.operation, u = ((t = c == null ? void 0 : c[0]) !== null && t !== void 0 ? t : "o") + d;
        this.dataMasking && o === "no-cache" && !qW(s) && !this.noCacheWarningsByQueryId.has(u) && (this.noCacheWarningsByQueryId.add(u), globalThis.__DEV__ !== !1 && ye.warn(
          45,
          (a = So(s)) !== null && a !== void 0 ? a : "Unnamed ".concat(c != null ? c : "operation")
        ));
      }
      return this.dataMasking ? zY(r, s, this.cache) : r;
    }, e.prototype.maskFragment = function(n) {
      var i = n.data, t = n.fragment, a = n.fragmentName;
      return this.dataMasking ? HD(i, t, this.cache, a) : i;
    }, e.prototype.fetchQueryByPolicy = function(n, i, t) {
      var a = this, s = i.query, r = i.variables, o = i.fetchPolicy, d = i.refetchWritePolicy, c = i.errorPolicy, u = i.returnPartialData, k = i.context, m = i.notifyOnNetworkStatusChange, f = n.networkStatus;
      n.init({
        document: s,
        variables: r,
        networkStatus: t
      });
      var p = function() {
        return n.getDiff();
      }, h = function(x, R) {
        R === void 0 && (R = n.networkStatus || jn.loading);
        var T = x.result;
        globalThis.__DEV__ !== !1 && !u && !Dn(T, {}) && a7(x.missing);
        var j = function(A) {
          return $n.of(G({ data: A, loading: _1(R), networkStatus: R }, x.complete ? null : { partial: !0 }));
        };
        return T && a.getDocumentInfo(s).hasForcedResolvers ? a.localState.runResolvers({
          document: s,
          remoteResult: { data: T },
          context: k,
          variables: r,
          onlyRunForcedResolvers: !0
        }).then(function(A) {
          return j(A.data || void 0);
        }) : c === "none" && R === jn.refetch && Array.isArray(x.missing) ? j(void 0) : j(T);
      }, N = o === "no-cache" ? 0 : t === jn.refetch && d !== "merge" ? 1 : 2, S = function() {
        return a.getResultsFromLink(n, N, {
          query: s,
          variables: r,
          context: k,
          fetchPolicy: o,
          errorPolicy: c
        });
      }, F = m && typeof f == "number" && f !== t && _1(t);
      switch (o) {
        default:
        case "cache-first": {
          var y = p();
          return y.complete ? {
            fromLink: !1,
            sources: [h(y, n.markReady())]
          } : u || F ? {
            fromLink: !0,
            sources: [h(y), S()]
          } : { fromLink: !0, sources: [S()] };
        }
        case "cache-and-network": {
          var y = p();
          return y.complete || u || F ? {
            fromLink: !0,
            sources: [h(y), S()]
          } : { fromLink: !0, sources: [S()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [h(p(), n.markReady())]
          };
        case "network-only":
          return F ? {
            fromLink: !0,
            sources: [h(p()), S()]
          } : { fromLink: !0, sources: [S()] };
        case "no-cache":
          return F ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [h(n.getDiff()), S()]
          } : { fromLink: !0, sources: [S()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(n) {
      return n && !this.queries.has(n) && this.queries.set(n, new S3(this, n)), this.queries.get(n);
    }, e.prototype.prepareContext = function(n) {
      n === void 0 && (n = {});
      var i = this.localState.prepareContext(n);
      return G(G(G({}, this.defaultContext), i), { clientAwareness: this.clientAwareness });
    }, e;
  }()
), mX = (
  /** @class */
  function() {
    function e(n) {
      var i = n.cache, t = n.client, a = n.resolvers, s = n.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = i, t && (this.client = t), a && this.addResolvers(a), s && this.setFragmentMatcher(s);
    }
    return e.prototype.addResolvers = function(n) {
      var i = this;
      this.resolvers = this.resolvers || {}, Array.isArray(n) ? n.forEach(function(t) {
        i.resolvers = Sg(i.resolvers, t);
      }) : this.resolvers = Sg(this.resolvers, n);
    }, e.prototype.setResolvers = function(n) {
      this.resolvers = {}, this.addResolvers(n);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(n) {
      return jl(this, arguments, void 0, function(i) {
        var t = i.document, a = i.remoteResult, s = i.context, r = i.variables, o = i.onlyRunForcedResolvers, d = o === void 0 ? !1 : o;
        return Al(this, function(c) {
          return t ? [2, this.resolveDocument(t, a.data, s, r, this.fragmentMatcher, d).then(function(u) {
            return G(G({}, a), { data: u.result });
          })] : [2, a];
        });
      });
    }, e.prototype.setFragmentMatcher = function(n) {
      this.fragmentMatcher = n;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(n) {
      return id(["client"], n) && this.resolvers ? n : null;
    }, e.prototype.serverQuery = function(n) {
      return wD(n);
    }, e.prototype.prepareContext = function(n) {
      var i = this.cache;
      return G(G({}, n), {
        cache: i,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(t) {
          return i.identify(t);
        }
      });
    }, e.prototype.addExportedVariables = function(n) {
      return jl(this, arguments, void 0, function(i, t, a) {
        return t === void 0 && (t = {}), a === void 0 && (a = {}), Al(this, function(s) {
          return i ? [2, this.resolveDocument(i, this.buildRootValueFromCache(i, t) || {}, this.prepareContext(a), t).then(function(r) {
            return G(G({}, t), r.exportedVariables);
          })] : [2, G({}, t)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(n) {
      var i = !1;
      return Lt(n, {
        Directive: {
          enter: function(t) {
            if (t.name.value === "client" && t.arguments && (i = t.arguments.some(function(a) {
              return a.name.value === "always" && a.value.kind === "BooleanValue" && a.value.value === !0;
            }), i))
              return n2;
          }
        }
      }), i;
    }, e.prototype.buildRootValueFromCache = function(n, i) {
      return this.cache.diff({
        query: QK(n),
        variables: i,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(n, i) {
      return jl(this, arguments, void 0, function(t, a, s, r, o, d) {
        var c, u, k, m, f, p, h, N, S, F, y;
        return s === void 0 && (s = {}), r === void 0 && (r = {}), o === void 0 && (o = function() {
          return !0;
        }), d === void 0 && (d = !1), Al(this, function(x) {
          return c = Ad(t), u = Qr(t), k = Jr(u), m = this.collectSelectionsToResolve(c, k), f = c.operation, p = f ? f.charAt(0).toUpperCase() + f.slice(1) : "Query", h = this, N = h.cache, S = h.client, F = {
            fragmentMap: k,
            context: G(G({}, s), { cache: N, client: S }),
            variables: r,
            fragmentMatcher: o,
            defaultOperationType: p,
            exportedVariables: {},
            selectionsToResolve: m,
            onlyRunForcedResolvers: d
          }, y = !1, [2, this.resolveSelectionSet(c.selectionSet, y, a, F).then(function(R) {
            return {
              result: R,
              exportedVariables: F.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(n, i, t, a) {
      return jl(this, void 0, void 0, function() {
        var s, r, o, d, c, u = this;
        return Al(this, function(k) {
          return s = a.fragmentMap, r = a.context, o = a.variables, d = [t], c = function(m) {
            return jl(u, void 0, void 0, function() {
              var f, p;
              return Al(this, function(h) {
                return !i && !a.selectionsToResolve.has(m) ? [
                  2
                  /*return*/
                ] : jd(m, o) ? es(m) ? [2, this.resolveField(m, i, t, a).then(function(N) {
                  var S;
                  typeof N != "undefined" && d.push((S = {}, S[cl(m)] = N, S));
                })] : (yK(m) ? f = m : (f = s[m.name.value], ye(f, 21, m.name.value)), f && f.typeCondition && (p = f.typeCondition.name.value, a.fragmentMatcher(t, p, r)) ? [2, this.resolveSelectionSet(f.selectionSet, i, t, a).then(function(N) {
                  d.push(N);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(n.selections.map(c)).then(function() {
            return r2(d);
          })];
        });
      });
    }, e.prototype.resolveField = function(n, i, t, a) {
      return jl(this, void 0, void 0, function() {
        var s, r, o, d, c, u, k, m, f, p = this;
        return Al(this, function(h) {
          return t ? (s = a.variables, r = n.name.value, o = cl(n), d = r !== o, c = t[o] || t[r], u = Promise.resolve(c), (!a.onlyRunForcedResolvers || this.shouldForceResolvers(n)) && (k = t.__typename || a.defaultOperationType, m = this.resolvers && this.resolvers[k], m && (f = m[d ? r : o], f && (u = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            $h.withValue(this.cache, f, [
              t,
              a2(n, s),
              a.context,
              { field: n, fragmentMap: a.fragmentMap }
            ])
          )))), [2, u.then(function(N) {
            var S, F;
            if (N === void 0 && (N = c), n.directives && n.directives.forEach(function(x) {
              x.name.value === "export" && x.arguments && x.arguments.forEach(function(R) {
                R.name.value === "as" && R.value.kind === "StringValue" && (a.exportedVariables[R.value.value] = N);
              });
            }), !n.selectionSet || N == null)
              return N;
            var y = (F = (S = n.directives) === null || S === void 0 ? void 0 : S.some(function(x) {
              return x.name.value === "client";
            })) !== null && F !== void 0 ? F : !1;
            if (Array.isArray(N))
              return p.resolveSubSelectedArray(n, i || y, N, a);
            if (n.selectionSet)
              return p.resolveSelectionSet(n.selectionSet, i || y, N, a);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(n, i, t, a) {
      var s = this;
      return Promise.all(t.map(function(r) {
        if (r === null)
          return null;
        if (Array.isArray(r))
          return s.resolveSubSelectedArray(n, i, r, a);
        if (n.selectionSet)
          return s.resolveSelectionSet(n.selectionSet, i, r, a);
      }));
    }, e.prototype.collectSelectionsToResolve = function(n, i) {
      var t = function(r) {
        return !Array.isArray(r);
      }, a = this.selectionsToResolveCache;
      function s(r) {
        if (!a.has(r)) {
          var o = /* @__PURE__ */ new Set();
          a.set(r, o), Lt(r, {
            Directive: function(d, c, u, k, m) {
              d.name.value === "client" && m.forEach(function(f) {
                t(f) && cg(f) && o.add(f);
              });
            },
            FragmentSpread: function(d, c, u, k, m) {
              var f = i[d.name.value];
              ye(f, 22, d.name.value);
              var p = s(f);
              p.size > 0 && (m.forEach(function(h) {
                t(h) && cg(h) && o.add(h);
              }), o.add(d), p.forEach(function(h) {
                o.add(h);
              }));
            }
          });
        }
        return a.get(r);
      }
      return s(n);
    }, e;
  }()
), e9 = !1, u2 = (
  /** @class */
  function() {
    function e(n) {
      var i = this, t, a, s;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !n.cache)
        throw dt(16);
      var r = n.uri, o = n.credentials, d = n.headers, c = n.cache, u = n.documentTransform, k = n.ssrMode, m = k === void 0 ? !1 : k, f = n.ssrForceFetchDelay, p = f === void 0 ? 0 : f, h = n.connectToDevTools, N = n.queryDeduplication, S = N === void 0 ? !0 : N, F = n.defaultOptions, y = n.defaultContext, x = n.assumeImmutableResults, R = x === void 0 ? c.assumeImmutableResults : x, T = n.resolvers, j = n.typeDefs, A = n.fragmentMatcher, B = n.clientAwareness, W = n.name, E = n.version, $ = n.devtools, V = n.dataMasking;
      globalThis.__DEV__ !== !1 && (ki(n, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), ki(n, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), ki(n, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), ki(n, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), ki(n, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), ki(n, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), ki(n, "typeDefs", "ApolloClient"), n.link || globalThis.__DEV__ !== !1 && ye.warn(17));
      var H = n.link;
      H || (H = r ? new _Y({ uri: r, credentials: o, headers: d }) : Ha.empty()), this.link = H, this.cache = c, this.disableNetworkFetches = m || p > 0, this.queryDeduplication = S, this.defaultOptions = F || /* @__PURE__ */ Object.create(null), this.typeDefs = j, this.devtoolsConfig = G(G({}, $), { enabled: (t = $ == null ? void 0 : $.enabled) !== null && t !== void 0 ? t : h }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), p && setTimeout(function() {
        return i.disableNetworkFetches = !1;
      }, p), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = Fh, this.localState = new mX({
        cache: c,
        client: this,
        resolvers: T,
        fragmentMatcher: A
      }), this.queryManager = new uX({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: y,
        documentTransform: u,
        queryDeduplication: S,
        ssrMode: m,
        dataMasking: !!V,
        clientAwareness: {
          name: (a = B == null ? void 0 : B.name) !== null && a !== void 0 ? a : W,
          version: (s = B == null ? void 0 : B.version) !== null && s !== void 0 ? s : E
        },
        localState: this.localState,
        assumeImmutableResults: R,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          i.devToolsHookCb && i.devToolsHookCb({
            action: {},
            state: {
              queries: i.queryManager.getQueryStore(),
              mutations: i.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: i.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(n) {
        this.disableNetworkFetches = n;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (typeof window != "undefined") {
        var n = window, i = Symbol.for("apollo.devtools");
        (n[i] = n[i] || []).push(this), n.__APOLLO_CLIENT__ = this, !e9 && globalThis.__DEV__ !== !1 && (e9 = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var t = window.navigator, a = t && t.userAgent, s = void 0;
            typeof a == "string" && (a.indexOf("Chrome/") > -1 ? s = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : a.indexOf("Firefox/") > -1 && (s = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), s && globalThis.__DEV__ !== !1 && ye.log("Download the Apollo DevTools for a better development experience: %s", s);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(n) {
      return this.defaultOptions.watchQuery && (n = Xc(this.defaultOptions.watchQuery, n)), this.disableNetworkFetches && (n.fetchPolicy === "network-only" || n.fetchPolicy === "cache-and-network") && (n = G(G({}, n), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (ki(n, "canonizeResults", "client.watchQuery"), ki(n, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(n);
    }, e.prototype.query = function(n) {
      return this.defaultOptions.query && (n = Xc(this.defaultOptions.query, n)), ye(n.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && n.fetchPolicy === "network-only" && (n = G(G({}, n), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (ki(n, "canonizeResults", "client.query"), ki(n, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), n.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && ye.warn(19)), this.queryManager.query(n);
    }, e.prototype.mutate = function(n) {
      return this.defaultOptions.mutate && (n = Xc(this.defaultOptions.mutate, n)), this.queryManager.mutate(n);
    }, e.prototype.subscribe = function(n) {
      var i = this, t = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(n).map(function(a) {
        return G(G({}, a), { data: i.queryManager.maskOperation({
          document: n.query,
          data: a.data,
          fetchPolicy: n.fetchPolicy,
          id: t
        }) });
      });
    }, e.prototype.readQuery = function(n, i) {
      return i === void 0 && (i = !1), this.cache.readQuery(n, i);
    }, e.prototype.watchFragment = function(n) {
      var i;
      return this.cache.watchFragment(G(G({}, n), (i = {}, i[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, i)));
    }, e.prototype.readFragment = function(n, i) {
      return i === void 0 && (i = !1), this.cache.readFragment(n, i);
    }, e.prototype.writeQuery = function(n) {
      var i = this.cache.writeQuery(n);
      return n.broadcast !== !1 && this.queryManager.broadcastQueries(), i;
    }, e.prototype.writeFragment = function(n) {
      var i = this.cache.writeFragment(n);
      return n.broadcast !== !1 && this.queryManager.broadcastQueries(), i;
    }, e.prototype.__actionHookForDevTools = function(n) {
      this.devToolsHookCb = n;
    }, e.prototype.__requestRaw = function(n) {
      return tf(this.link, n);
    }, e.prototype.resetStore = function() {
      var n = this;
      return Promise.resolve().then(function() {
        return n.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(n.resetStoreCallbacks.map(function(i) {
          return i();
        }));
      }).then(function() {
        return n.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var n = this;
      return Promise.resolve().then(function() {
        return n.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(n.clearStoreCallbacks.map(function(i) {
          return i();
        }));
      });
    }, e.prototype.onResetStore = function(n) {
      var i = this;
      return this.resetStoreCallbacks.push(n), function() {
        i.resetStoreCallbacks = i.resetStoreCallbacks.filter(function(t) {
          return t !== n;
        });
      };
    }, e.prototype.onClearStore = function(n) {
      var i = this;
      return this.clearStoreCallbacks.push(n), function() {
        i.clearStoreCallbacks = i.clearStoreCallbacks.filter(function(t) {
          return t !== n;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(n) {
      return this.queryManager.reFetchObservableQueries(n);
    }, e.prototype.refetchQueries = function(n) {
      var i = this.queryManager.refetchQueries(n), t = [], a = [];
      i.forEach(function(r, o) {
        t.push(o), a.push(r);
      });
      var s = Promise.all(a);
      return s.queries = t, s.results = a, s.catch(function(r) {
        globalThis.__DEV__ !== !1 && ye.debug(20, r);
      }), s;
    }, e.prototype.getObservableQueries = function(n) {
      return n === void 0 && (n = "active"), this.queryManager.getObservableQueries(n);
    }, e.prototype.extract = function(n) {
      return this.cache.extract(n);
    }, e.prototype.restore = function(n) {
      return this.cache.restore(n);
    }, e.prototype.addResolvers = function(n) {
      this.localState.addResolvers(n);
    }, e.prototype.setResolvers = function(n) {
      this.localState.setResolvers(n);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(n) {
      this.localState.setFragmentMatcher(n);
    }, e.prototype.setLink = function(n) {
      this.link = this.queryManager.link = n;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
globalThis.__DEV__ !== !1 && (u2.prototype.getMemoryInternals = iK);
var l7 = { exports: {} };
(function(e) {
  e.exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = void 0, e.exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, e.exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, Object.assign(e.exports, K);
})(l7);
var ii = l7.exports;
const kX = /* @__PURE__ */ ls(ii), s7 = /* @__PURE__ */ J8({
  __proto__: null,
  default: kX
}, [ii]);
var n9 = Ch ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function r7() {
  ye("createContext" in s7, 69);
  var e = ii.createContext[n9];
  return e || (Object.defineProperty(ii.createContext, n9, {
    value: e = ii.createContext({}),
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), e.displayName = "ApolloContext"), e;
}
var zh = function(e) {
  var n = e.client, i = e.children, t = r7(), a = ii.useContext(t), s = ii.useMemo(function() {
    return G(G({}, a), { client: n || a.client });
  }, [a, n]);
  return ye(s.client, 71), ii.createElement(t.Provider, { value: s }, i);
};
function Bh(e) {
  var n = ii.useContext(r7()), i = e || n.client;
  return ye(!!i, 78), i;
}
var Aa;
(function(e) {
  e[e.Query = 0] = "Query", e[e.Mutation = 1] = "Mutation", e[e.Subscription = 2] = "Subscription";
})(Aa || (Aa = {}));
var _s;
function i9(e) {
  var n;
  switch (e) {
    case Aa.Query:
      n = "Query";
      break;
    case Aa.Mutation:
      n = "Mutation";
      break;
    case Aa.Subscription:
      n = "Subscription";
      break;
  }
  return n;
}
function o7(e) {
  Jl("parser", function() {
    globalThis.__DEV__ !== !1 && ye.warn(93);
  }), _s || (_s = new xh(
    ra.parser || 1e3
    /* defaultCacheSizes.parser */
  ));
  var n = _s.get(e);
  if (n)
    return n;
  var i, t, a;
  ye(!!e && !!e.kind, 94, e);
  for (var s = [], r = [], o = [], d = [], c = 0, u = e.definitions; c < u.length; c++) {
    var k = u[c];
    if (k.kind === "FragmentDefinition") {
      s.push(k);
      continue;
    }
    if (k.kind === "OperationDefinition")
      switch (k.operation) {
        case "query":
          r.push(k);
          break;
        case "mutation":
          o.push(k);
          break;
        case "subscription":
          d.push(k);
          break;
      }
  }
  ye(!s.length || r.length || o.length || d.length, 95), ye(
    r.length + o.length + d.length <= 1,
    96,
    e,
    r.length,
    d.length,
    o.length
  ), t = r.length ? Aa.Query : Aa.Mutation, !r.length && !o.length && (t = Aa.Subscription);
  var m = r.length ? r : o.length ? o : d;
  ye(m.length === 1, 97, e, m.length);
  var f = m[0];
  i = f.variableDefinitions || [], f.name && f.name.kind === "Name" ? a = f.name.value : a = "data";
  var p = { name: a, type: t, variables: i };
  return _s.set(e, p), p;
}
o7.resetCache = function() {
  _s = void 0;
};
globalThis.__DEV__ !== !1 && Dh("parser", function() {
  return _s ? _s.size : 0;
});
function d7(e, n) {
  var i = Ai("parser", o7, [e]), t = i9(n), a = i9(i.type);
  ye(
    i.type === n,
    98,
    t,
    t,
    a
  );
}
function fX(e, n) {
  var i = ii.useRef(void 0);
  return (!i.current || !Dn(i.current.deps, n)) && (i.current = { value: e(), deps: n }), i.current.value;
}
var vX = zW ? ii.useLayoutEffect : ii.useEffect;
function c7(e, n, i, t) {
  "use no memo";
  t === void 0 && (t = "Please remove this option.");
  var a = ii.useRef(!1);
  globalThis.__DEV__ !== !1 && n in e && !a.current && (ki(e, n, i, t), a.current = !0);
}
var hX = "use", pX = s7[hX], NX = pX || function(n) {
  var i = _h(n);
  switch (i.status) {
    case "pending":
      throw i;
    case "rejected":
      throw i.reason;
    case "fulfilled":
      return i.value;
  }
}, SX = Symbol.for("apollo.hook.wrappers");
function gX(e, n, i) {
  var t = i.queryManager, a = t && t[SX], s = a && a[e];
  return s ? s(n) : n;
}
function qh(e, n) {
  globalThis.__DEV__ !== !1 && c7(n || {}, "ignoreResults", "useMutation", "If you don't want to synchronize component state with the mutation, please use the `useApolloClient` hook to get the client instance and call `client.mutate` directly.");
  var i = Bh(n == null ? void 0 : n.client);
  d7(e, Aa.Mutation);
  var t = ii.useState({
    called: !1,
    loading: !1,
    client: i
  }), a = t[0], s = t[1], r = ii.useRef({
    result: a,
    mutationId: 0,
    isMounted: !0,
    client: i,
    mutation: e,
    options: n
  });
  vX(function() {
    Object.assign(r.current, { client: i, options: n, mutation: e });
  });
  var o = ii.useCallback(function(c) {
    c === void 0 && (c = {});
    var u = r.current, k = u.options, m = u.mutation, f = G(G({}, k), { mutation: m }), p = c.client || r.current.client;
    !r.current.result.loading && !f.ignoreResults && r.current.isMounted && s(r.current.result = {
      loading: !0,
      error: void 0,
      data: void 0,
      called: !0,
      client: p
    });
    var h = ++r.current.mutationId, N = Xc(f, c);
    return p.mutate(N).then(function(S) {
      var F, y, x = S.data, R = S.errors, T = R && R.length > 0 ? new Sa({ graphQLErrors: R }) : void 0, j = c.onError || ((F = r.current.options) === null || F === void 0 ? void 0 : F.onError);
      if (T && j && j(T, N), h === r.current.mutationId && !N.ignoreResults) {
        var A = {
          called: !0,
          loading: !1,
          data: x,
          error: T,
          client: p
        };
        r.current.isMounted && !Dn(r.current.result, A) && s(r.current.result = A);
      }
      var B = c.onCompleted || ((y = r.current.options) === null || y === void 0 ? void 0 : y.onCompleted);
      return T || B == null || B(S.data, N), S;
    }, function(S) {
      var F;
      if (h === r.current.mutationId && r.current.isMounted) {
        var y = {
          loading: !1,
          error: S,
          data: void 0,
          called: !0,
          client: p
        };
        Dn(r.current.result, y) || s(r.current.result = y);
      }
      var x = c.onError || ((F = r.current.options) === null || F === void 0 ? void 0 : F.onError);
      if (x)
        return x(S, N), { data: void 0, errors: S };
      throw S;
    });
  }, []), d = ii.useCallback(function() {
    if (r.current.isMounted) {
      var c = {
        called: !1,
        loading: !1,
        client: r.current.client
      };
      Object.assign(r.current, { mutationId: 0, result: c }), s(c);
    }
  }, []);
  return ii.useEffect(function() {
    var c = r.current;
    return c.isMounted = !0, function() {
      c.isMounted = !1;
    };
  }, []), [o, G({ reset: d }, a)];
}
var FX = [
  "canonizeResults",
  "context",
  "errorPolicy",
  "fetchPolicy",
  "refetchWritePolicy",
  "returnPartialData"
], IX = (
  /** @class */
  function() {
    function e(n, i) {
      var t = this;
      this.key = {}, this.listeners = /* @__PURE__ */ new Set(), this.references = 0, this.softReferences = 0, this.handleNext = this.handleNext.bind(this), this.handleError = this.handleError.bind(this), this.dispose = this.dispose.bind(this), this.observable = n, i.onDispose && (this.onDispose = i.onDispose), this.setResult(), this.subscribeToQuery();
      var a = function() {
        var s;
        t.references || (t.autoDisposeTimeoutId = setTimeout(t.dispose, (s = i.autoDisposeTimeoutMs) !== null && s !== void 0 ? s : 3e4));
      };
      this.promise.then(a, a);
    }
    return Object.defineProperty(e.prototype, "disposed", {
      get: function() {
        return this.subscription.closed;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "watchQueryOptions", {
      get: function() {
        return this.observable.options;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.reinitialize = function() {
      var n = this.observable, i = this.watchQueryOptions.fetchPolicy, t = i === "no-cache" || i === "standby";
      try {
        if (t ? n.silentSetOptions({ fetchPolicy: "standby" }) : (Ai("resetLastResults", function() {
          return n.resetLastResults();
        }), n.silentSetOptions({ fetchPolicy: "cache-first" })), this.subscribeToQuery(), t)
          return;
        n.resetDiff(), this.setResult();
      } finally {
        n.silentSetOptions({ fetchPolicy: i });
      }
    }, e.prototype.retain = function() {
      var n = this;
      this.references++, clearTimeout(this.autoDisposeTimeoutId);
      var i = !1;
      return function() {
        i || (i = !0, n.references--, setTimeout(function() {
          n.references || n.dispose();
        }));
      };
    }, e.prototype.softRetain = function() {
      var n = this;
      this.softReferences++;
      var i = !1;
      return function() {
        i || (i = !0, n.softReferences--, setTimeout(function() {
          !n.softReferences && !n.references && n.dispose();
        }));
      };
    }, e.prototype.didChangeOptions = function(n) {
      var i = this;
      return FX.some(function(t) {
        return t in n && !Dn(i.watchQueryOptions[t], n[t]);
      });
    }, e.prototype.applyOptions = function(n) {
      var i = this.watchQueryOptions, t = i.fetchPolicy, a = i.canonizeResults;
      return t === "standby" && t !== n.fetchPolicy ? this.initiateFetch(this.observable.reobserve(n)) : (this.observable.silentSetOptions(n), a !== n.canonizeResults && (this.result = G(G({}, this.result), this.observable.getCurrentResult()), this.promise = Po(this.result))), this.promise;
    }, e.prototype.listen = function(n) {
      var i = this;
      return this.listeners.add(n), function() {
        i.listeners.delete(n);
      };
    }, e.prototype.refetch = function(n) {
      return this.initiateFetch(this.observable.refetch(n));
    }, e.prototype.fetchMore = function(n) {
      return this.initiateFetch(this.observable.fetchMore(n));
    }, e.prototype.dispose = function() {
      this.subscription.unsubscribe(), this.onDispose();
    }, e.prototype.onDispose = function() {
    }, e.prototype.handleNext = function(n) {
      var i;
      switch (this.promise.status) {
        case "pending": {
          n.data === void 0 && (n.data = this.result.data), this.result = n, (i = this.resolve) === null || i === void 0 || i.call(this, n);
          break;
        }
        default: {
          if (n.data === this.result.data && n.networkStatus === this.result.networkStatus)
            return;
          n.data === void 0 && (n.data = this.result.data), this.result = n, this.promise = Po(n), this.deliver(this.promise);
          break;
        }
      }
    }, e.prototype.handleError = function(n) {
      var i;
      switch (this.subscription.unsubscribe(), this.subscription = this.observable.resubscribeAfterError(this.handleNext, this.handleError), this.promise.status) {
        case "pending": {
          (i = this.reject) === null || i === void 0 || i.call(this, n);
          break;
        }
        default:
          this.promise = KK(n), this.deliver(this.promise);
      }
    }, e.prototype.deliver = function(n) {
      this.listeners.forEach(function(i) {
        return i(n);
      });
    }, e.prototype.initiateFetch = function(n) {
      var i = this;
      return this.promise = this.createPendingPromise(), this.promise.catch(function() {
      }), n.then(function() {
        setTimeout(function() {
          var t;
          i.promise.status === "pending" && (i.result = i.observable.getCurrentResult(), (t = i.resolve) === null || t === void 0 || t.call(i, i.result));
        });
      }).catch(function(t) {
        var a;
        return (a = i.reject) === null || a === void 0 ? void 0 : a.call(i, t);
      }), n;
    }, e.prototype.subscribeToQuery = function() {
      var n = this;
      this.subscription = this.observable.filter(function(i) {
        return !Dn(i.data, {}) && !Dn(i, n.result);
      }).subscribe(this.handleNext, this.handleError);
    }, e.prototype.setResult = function() {
      var n = this.observable.getCurrentResult(!1);
      Dn(n, this.result) || (this.result = n, this.promise = n.data && (!n.partial || this.watchQueryOptions.returnPartialData) ? Po(n) : this.createPendingPromise());
    }, e.prototype.createPendingPromise = function() {
      var n = this;
      return _h(new Promise(function(i, t) {
        n.resolve = i, n.reject = t;
      }));
    }, e;
  }()
), yX = (
  /** @class */
  function() {
    function e(n, i, t) {
      var a = this;
      this.key = {}, this.listeners = /* @__PURE__ */ new Set(), this.references = 0, this.dispose = this.dispose.bind(this), this.handleNext = this.handleNext.bind(this), this.handleError = this.handleError.bind(this), this.observable = n.watchFragment(i), t.onDispose && (this.onDispose = t.onDispose);
      var s = this.getDiff(n, i), r = function() {
        var o;
        a.references || (a.autoDisposeTimeoutId = setTimeout(a.dispose, (o = t.autoDisposeTimeoutMs) !== null && o !== void 0 ? o : 3e4));
      };
      this.promise = s.complete ? Po(s.result) : this.createPendingPromise(), this.subscribeToFragment(), this.promise.then(r, r);
    }
    return e.prototype.listen = function(n) {
      var i = this;
      return this.listeners.add(n), function() {
        i.listeners.delete(n);
      };
    }, e.prototype.retain = function() {
      var n = this;
      this.references++, clearTimeout(this.autoDisposeTimeoutId);
      var i = !1;
      return function() {
        i || (i = !0, n.references--, setTimeout(function() {
          n.references || n.dispose();
        }));
      };
    }, e.prototype.dispose = function() {
      this.subscription.unsubscribe(), this.onDispose();
    }, e.prototype.onDispose = function() {
    }, e.prototype.subscribeToFragment = function() {
      this.subscription = this.observable.subscribe(this.handleNext.bind(this), this.handleError.bind(this));
    }, e.prototype.handleNext = function(n) {
      var i;
      switch (this.promise.status) {
        case "pending": {
          if (n.complete)
            return (i = this.resolve) === null || i === void 0 ? void 0 : i.call(this, n.data);
          this.deliver(this.promise);
          break;
        }
        case "fulfilled": {
          if (Dn(this.promise.value, n.data))
            return;
          this.promise = n.complete ? Po(n.data) : this.createPendingPromise(), this.deliver(this.promise);
        }
      }
    }, e.prototype.handleError = function(n) {
      var i;
      (i = this.reject) === null || i === void 0 || i.call(this, n);
    }, e.prototype.deliver = function(n) {
      this.listeners.forEach(function(i) {
        return i(n);
      });
    }, e.prototype.createPendingPromise = function() {
      var n = this;
      return _h(new Promise(function(i, t) {
        n.resolve = i, n.reject = t;
      }));
    }, e.prototype.getDiff = function(n, i) {
      var t = n.cache, a = i.from, s = i.fragment, r = i.fragmentName, o = t.diff(G(G({}, i), { query: t.getFragmentDoc(s, r), returnPartialData: !0, id: a, optimistic: !0 }));
      return G(G({}, o), { result: n.queryManager.maskFragment({
        fragment: s,
        fragmentName: r,
        data: o.result
      }) });
    }, e;
  }()
), bX = (
  /** @class */
  function() {
    function e(n) {
      n === void 0 && (n = /* @__PURE__ */ Object.create(null)), this.queryRefs = new sa(dl), this.fragmentRefs = new sa(dl), this.options = n;
    }
    return e.prototype.getQueryRef = function(n, i) {
      var t = this.queryRefs.lookupArray(n);
      return t.current || (t.current = new IX(i(), {
        autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
        onDispose: function() {
          delete t.current;
        }
      })), t.current;
    }, e.prototype.getFragmentRef = function(n, i, t) {
      var a = this.fragmentRefs.lookupArray(n);
      return a.current || (a.current = new yX(i, t, {
        autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
        onDispose: function() {
          delete a.current;
        }
      })), a.current;
    }, e.prototype.add = function(n, i) {
      var t = this.queryRefs.lookupArray(n);
      t.current = i;
    }, e;
  }()
), g3 = Symbol.for("apollo.suspenseCache");
function CX(e) {
  var n;
  return e[g3] || (e[g3] = new bX((n = e.defaultOptions.react) === null || n === void 0 ? void 0 : n.suspense)), e[g3];
}
var m2 = Symbol.for("apollo.skipToken");
function k2(e, n) {
  return n === void 0 && (n = /* @__PURE__ */ Object.create(null)), gX(
    "useSuspenseQuery",
    // eslint-disable-next-line react-compiler/react-compiler
    xX,
    Bh(typeof n == "object" ? n.client : void 0)
  )(e, n);
}
function xX(e, n) {
  globalThis.__DEV__ !== !1 && c7(typeof n == "symbol" ? {} : n, "canonizeResults", "useSuspenseQuery");
  var i = Bh(n.client), t = CX(i), a = RX({
    client: i,
    query: e,
    options: n
  }), s = a.fetchPolicy, r = a.variables, o = n.queryKey, d = o === void 0 ? [] : o, c = Oi([
    e,
    il(r)
  ], [].concat(d), !0), u = Ai("canonizeResults", function() {
    return t.getQueryRef(c, function() {
      return i.watchQuery(a);
    });
  }), k = ii.useState([u.key, u.promise]), m = k[0], f = k[1];
  m[0] !== u.key && (m[0] = u.key, m[1] = u.promise);
  var p = m[1];
  u.didChangeOptions(a) && (m[1] = p = u.applyOptions(a)), ii.useEffect(function() {
    var x = u.retain(), R = u.listen(function(T) {
      f([u.key, T]);
    });
    return function() {
      R(), x();
    };
  }, [u]);
  var h = ii.useMemo(function() {
    var x = t9(u.result);
    return {
      loading: !1,
      data: u.result.data,
      networkStatus: x ? jn.error : jn.ready,
      error: x
    };
  }, [u.result]), N = s === "standby" ? h : NX(p), S = ii.useCallback(function(x) {
    var R = u.fetchMore(x);
    return f([u.key, u.promise]), R;
  }, [u]), F = ii.useCallback(function(x) {
    var R = u.refetch(x);
    return f([u.key, u.promise]), R;
  }, [u]), y = u.observable.subscribeToMore;
  return ii.useMemo(function() {
    return {
      client: i,
      data: N.data,
      error: t9(N),
      networkStatus: N.networkStatus,
      fetchMore: S,
      refetch: F,
      subscribeToMore: y
    };
  }, [i, S, F, N, y]);
}
function DX(e) {
  var n = e.query, i = e.fetchPolicy, t = e.returnPartialData;
  d7(n, Aa.Query), wX(i), PX(i, t);
}
function wX(e) {
  e === void 0 && (e = "cache-first");
  var n = [
    "cache-first",
    "network-only",
    "no-cache",
    "cache-and-network"
  ];
  ye(n.includes(e), 89, e);
}
function PX(e, n) {
  e === "no-cache" && n && globalThis.__DEV__ !== !1 && ye.warn(90);
}
function t9(e) {
  return oa(e.errors) ? new Sa({ graphQLErrors: e.errors }) : e.error;
}
function RX(e) {
  var n = e.client, i = e.query, t = e.options;
  return fX(function() {
    var a;
    if (t === m2)
      return { query: i, fetchPolicy: "standby" };
    var s = t.fetchPolicy || ((a = n.defaultOptions.watchQuery) === null || a === void 0 ? void 0 : a.fetchPolicy) || "cache-first", r = G(G({}, t), { fetchPolicy: s, query: i, notifyOnNetworkStatusChange: !1, nextFetchPolicy: void 0 });
    return globalThis.__DEV__ !== !1 && DX(r), t.skip && (r.fetchPolicy = "standby"), r;
  }, [n, t, i]);
}
const TX = (e, n) => {
  const [i, { data: t, loading: a }] = qh(e, { ...n, errorPolicy: "all" });
  return {
    mutationFunc: I(
      async (r) => {
        const { data: o, errors: d } = await i(r);
        if (!P(d))
          throw d;
        if (P(o))
          throw new Error("data is null");
        return {
          data: o
        };
      },
      [i]
    ),
    mutationResult: {
      data: t,
      loading: a
    }
  };
};
function u7(e) {
  return new Ha(function(n, i) {
    var t = Mt(n, []);
    return new $n(function(a) {
      var s, r = !1;
      return Promise.resolve(t).then(function(o) {
        return e(o, n.getContext());
      }).then(n.setContext).then(function() {
        r || (s = i(n).subscribe({
          next: a.next.bind(a),
          error: a.error.bind(a),
          complete: a.complete.bind(a)
        }));
      }).catch(a.error.bind(a)), function() {
        r = !0, s && s.unsubscribe();
      };
    });
  });
}
const jX = ({ getToken: e }) => u7(async (n, { headers: i = {} }) => {
  if (!e) return { headers: i };
  const t = await e();
  return {
    headers: {
      ...i,
      authorization: `Bearer ${t}`
    }
  };
});
function f2(e) {
  return new Ha(function(n, i) {
    return new $n(function(t) {
      var a, s, r;
      try {
        a = i(n).subscribe({
          next: function(o) {
            if (o.errors ? r = e({
              graphQLErrors: o.errors,
              response: o,
              operation: n,
              forward: i
            }) : JD(o) && (r = e({
              protocolErrors: o.extensions[o2],
              response: o,
              operation: n,
              forward: i
            })), r) {
              s = r.subscribe({
                next: t.next.bind(t),
                error: t.error.bind(t),
                complete: t.complete.bind(t)
              });
              return;
            }
            t.next(o);
          },
          error: function(o) {
            if (r = e({
              operation: n,
              networkError: o,
              //Network errors can return GraphQL errors on for example a 403
              graphQLErrors: o && o.result && o.result.errors || void 0,
              forward: i
            }), r) {
              s = r.subscribe({
                next: t.next.bind(t),
                error: t.error.bind(t),
                complete: t.complete.bind(t)
              });
              return;
            }
            t.error(o);
          },
          complete: function() {
            r || t.complete.bind(t)();
          }
        });
      } catch (o) {
        e({ networkError: o, operation: n, forward: i }), t.error(o);
      }
      return function() {
        a && a.unsubscribe(), s && a.unsubscribe();
      };
    });
  });
}
(function(e) {
  ca(n, e);
  function n(i) {
    var t = e.call(this) || this;
    return t.link = f2(i), t;
  }
  return n.prototype.request = function(i, t) {
    return this.link.request(i, t);
  }, n;
})(Ha);
const AX = (e) => e.extensions != null && "chillnnErrorMessageForUser" in e.extensions && "chillnnStatusCode" in e.extensions, OX = (e) => e === D.Default ? "ja" : "en", a9 = {
  ja: "エラーが発生しました。時間をおいて再度お試しください。",
  en: "An error occurred. Please try again later."
}, EX = ({ lang: e }) => f2(({ graphQLErrors: n, networkError: i }) => {
  const t = OX(e), { addError: a } = $1();
  if (n != null && n.length) {
    const s = n[0];
    AX(s) ? a(`${s.extensions.chillnnErrorMessageForUser[t]}`) : a(`${a9[t]}`);
  }
  i && a(a9[t]);
}), JX = ({ httpOptions: e }) => d2(e);
var _X = "__KEEP";
function Gh(e) {
  return e === void 0 && (e = /* @__PURE__ */ Object.create(null)), Object.assign(new Ha(function(n, i) {
    var t = e.except, a = n.query, s = n.variables;
    return s && (n.variables = t ? QX(a, s, t) : Qh(s)), i(n);
  }), globalThis.__DEV__ !== !1 ? {
    getMemoryInternals: function() {
      var n;
      return {
        removeTypenameFromVariables: {
          getVariableDefinitions: (n = iu == null ? void 0 : iu.size) !== null && n !== void 0 ? n : 0
        }
      };
    }
  } : {});
}
function QX(e, n, i) {
  var t = iu(e);
  return Object.fromEntries(Object.entries(n).map(function(a) {
    var s = a[0], r = a[1], o = t[s], d = i[o];
    return a[1] = d ? uf(r, d) : Qh(r), a;
  }));
}
function uf(e, n) {
  if (n === _X)
    return e;
  if (Array.isArray(e))
    return e.map(function(t) {
      return uf(t, n);
    });
  if (sD(e)) {
    var i = {};
    return Object.keys(e).forEach(function(t) {
      var a = e[t];
      if (t !== "__typename") {
        var s = n[t];
        i[t] = s ? uf(a, s) : Qh(a);
      }
    }), i;
  }
  return e;
}
var iu = dr(function(e) {
  var n = {};
  return Lt(e, {
    VariableDefinition: function(i) {
      n[i.variable.name.value] = mf(i.type);
    }
  }), n;
}, {
  max: ra["removeTypenameFromVariables.getVariableDefinitions"] || 2e3,
  cache: td
});
function mf(e) {
  switch (e.kind) {
    case Bn.NON_NULL_TYPE:
      return mf(e.type);
    case Bn.LIST_TYPE:
      return mf(e.type);
    case Bn.NAMED_TYPE:
      return e.name.value;
  }
}
const MX = () => Gh(), LX = (e) => new u2({
  link: Mh([
    jX(e),
    //
    EX(e),
    MX(),
    // httpLinkは最後に設定する必要がある（@see https://www.apollographql.com/docs/react/api/link/introduction#the-terminating-link）
    JX(e)
  ]),
  cache: new c2()
  // connectToDevTools: true,
}), $X = (e, n, i) => {
  const {
    data: t,
    error: a,
    refetch: s
  } = k2(e, i ? m2 : { ...n, errorPolicy: "all" }), r = I(
    async (o) => {
      try {
        const { data: d, error: c, errors: u } = await s(o);
        if (!P(c))
          throw c;
        if (!P(u))
          throw u;
        if (P(d))
          throw new Error("data is null");
        return { data: d };
      } catch (d) {
        throw d;
      }
    },
    [s]
  );
  return { data: t, refetch: r, error: a };
}, v2 = (e) => "chillnnErrorMessageForDeveloper" in e.extensions && "chillnnErrorMessageForUser" in e.extensions && "chillnnStatusCode" in e.extensions, h2 = (e) => e instanceof tD, k1 = (e) => {
  const n = Array.isArray(e) ? e[0] : e;
  if (typeof n != "object" || n === null || !("extensions" in n)) return "unknown";
  const { extensions: i } = n;
  return typeof i != "object" || i === null || !("code" in i) ? "unknown" : typeof i.code == "string" ? i.code : "unknown";
}, UX = Ve(`
	fragment ReservationSessionStateFragment on ReservationSessionState {
		id
		hotelID
		sessionID
		reservationID
		lang
		hotelName
		isShowBestRateNotice
		clientContext {
			reserveFailedReason
			planQueryFilter
		}
		prevState {
			groupInfo {
				uniqueRoomID
				adultNum
				kidsNum {
					age
					asCosleeping
				}
			}
			dateInfo {
				stayStartDt
				stayLastDt
			}
			defaultCancelPolicy {
				beforeDays
				chargeRatio
			}
			planInfo {
				reserved {
					planID
					cancelPolicy {
						beforeDays
						chargeRatio
					}
					amount
					price
					priceDiscounted
					priceHostInserted
					sessionResourceUUID
				}
				canceled {
					planID
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
					name
					sessionResourceUUID
				}
			}
			roomInfo {
				reserved {
					uniqueGroupID
					dailyInfo {
						sessionResourceUUID
						roomID
						date
						reservedStock
						price
						priceDiscounted
						priceHostInserted
					}
				}
				canceled {
					roomID
					date
					name
					roomGroupID
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
					sessionResourceUUID
				}
			}
			optionPerDateInfo {
				reserved {
					optionID
					subOptionID
					amount
					date
					price
					priceDiscounted
					priceHostInserted
					sessionResourceUUID
					cancelPolicy {
						beforeDays
						chargeRatio
					}
				}
				canceled {
					sessionResourceUUID
					optionID
					subOptionID
					amount
					date
					name
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
				}
			}
			optionPerReservationInfo {
				reserved {
					optionID
					subOptionID
					amount
					price
					priceDiscounted
					priceHostInserted
					sessionResourceUUID
					cancelPolicy {
						beforeDays
						chargeRatio
					}
				}
				canceled {
					sessionResourceUUID
					optionID
					subOptionID
					amount
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
					name
				}
			}
			guestInfo {
				name
				nameKana
				email
				postalCode
				address
				tel
			}
			discountInfo {
				discountID
				discountPrice
				name
			}
			voucherInfo {
				voucherCode
				discountPrice
			}
			questionAnswerInfo {
				questionID
				question
				answers
			}
		}
		currentState {
			planInfo {
				willReserve {
					planID
					name
					cancelPolicy {
						beforeDays
						chargeRatio
					}
					sessionResourceUUID
					price
					priceDiscounted
					priceHostInserted
				}
				willCancel {
					planID
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					sessionResourceUUID
					cancelPriceHostInserted
					name
				}
			}
			roomInfo {
				willReserve {
					baseRoomInfo {
						baseRoomID
						baseRoomName
					}
					uniqueRoomID
					dailyItems {
						date
						roomInfo {
							roomID
							name
							consumedStock
							name
							price
							priceDiscounted
							sessionResourceUUID
							priceHostInserted
						}
					}
				}
				willCancel {
					roomID
					uniqueGroupID
					date
					name
					cancelPrice
					sessionResourceUUID
					cancelPriceHostInserted
				}
			}
			optionPerDateInfo {
				willReserve {
					optionID
					subOptionID
					amount
					date
					name
					price
					priceDiscounted
					priceHostInserted
					name
					sessionResourceUUID
				}
				willCancel {
					optionID
					subOptionID
					amount
					date
					name
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
					sessionResourceUUID
				}
			}
			optionPerReservationInfo {
				willReserve {
					optionID
					subOptionID
					amount
					name
					price
					priceDiscounted
					priceHostInserted
					name
					sessionResourceUUID
				}
				willCancel {
					optionID
					subOptionID
					amount
					stayDates {
						stayStartDt
						stayLastDt
					}
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
					name
					sessionResourceUUID
				}
			}
			dateInfo {
				stayStartDt
				stayLastDt
			}
			groupInfo {
				kidsNum {
					age
					asCosleeping
				}
				uniqueRoomID
				adultNum
			}
			guestInfo {
				name
				nameKana
				firstName
				lastName
				firstNameKana
				lastNameKana
				email
				postalCode
				address
				tel
			}
			discountInfo {
				discountID
				name
				discountPrice
			}
			voucherInfo {
				voucherCode
				discountPrice
				name
			}
			questionAnswerInfo {
				questionID
				question
				answers
			}
			additionalFeeInfo {
				additionalFeeID
				name
				price
				priceDiscounted
				priceHostInserted
				sessionResourceUUID
			}
			agreementOfTermsOfService
			isMailMagazineAccept
		}
		priceInfo {
			totalPriceBeforeDiscount
			totalPriceDiscounted
			voucherDiscountPrice
			totalGuestCharge
			rawPricePlan
			rawPriceRoom
			rawPriceOption
			rawPriceAdditionalFee
		}
		reservationContext {
			isTestReservation
			reservationEditMode
		}
		reserveStatus {
			isCompleteDate
			isCompleteGroup
			isCompletePlan
			isCompleteRoom
			isCompleteOption
			isCompleteDateTabbedTimeSelectionOption
			isCompleteRequiredOptionGroup
			isCompleteGuestInfo
			isCompleteQuestionAndAnswer
			isCompleteAgreementOfTermsOfService
		}
		reservationPolicy {
			isPlanSelectRequired
			isDayTrip
			isShowRoomSelect
			isShowRoomForGuest
			isShowDiscountInput
			isShowOptionSelect
			optionSelectionMode
			isRequiredOptionGroupSatisfiableWithRegularOption
			isAddressInputRequired
			isShowPlanFilter
			isShowPlanSelect
			isShowCalendarPrice
			isShowPlanIncludedPrice
			isRequestReservation
			canCancelReservation
			canUpdateReservation
			canUpdateOnlyOptionReservation
			customTypeRoomTitle
			checkInOutPolicy {
				checkInStart
				checkInEnd
				checkOut
			}
			defaultCancelPolicy {
				beforeDays
				chargeRatio
			}
		}
		lastUpdatedAt
	}
`), Ss = (e) => Wu(
  UX,
  e
), VX = (e) => Ss(e), Ji = () => {
  const e = Wx((i) => i.updateSession);
  return {
    onUpdateSession: I(
      (i) => {
        const t = VX(i);
        e(t);
      },
      [e]
    )
  };
}, Od = () => {
  const { session: e } = xi();
  return {
    agreementOfTermsOfService: v(() => e.currentState.agreementOfTermsOfService, [e.currentState.agreementOfTermsOfService])
  };
}, Ed = () => {
  const { session: e } = xi();
  return {
    clientContext: v(() => e.clientContext, [e.clientContext])
  };
}, Lr = () => {
  const { session: e } = xi();
  return {
    dateInfo: v(() => e.currentState.dateInfo, [e.currentState.dateInfo])
  };
}, Jd = () => {
  const { session: e } = xi();
  return {
    discountInfo: v(() => e.currentState.discountInfo, [e.currentState.discountInfo])
  };
}, _d = () => {
  const { session: e } = xi();
  return {
    groupInfo: v(() => e.currentState.groupInfo, [e.currentState.groupInfo])
  };
}, Qd = () => {
  const { session: e } = xi();
  return {
    guestInfo: v(() => e.currentState.guestInfo, [e.currentState.guestInfo])
  };
}, Md = () => {
  const { session: e } = xi(), n = v(() => e.currentState.optionPerDateInfo, [e.currentState.optionPerDateInfo]), i = v(() => e.currentState.optionPerReservationInfo, [e.currentState.optionPerReservationInfo]);
  return {
    optionPerDateInfo: n,
    optionPerReservationInfo: i
  };
}, Ld = () => {
  const { session: e } = xi();
  return {
    planInfo: v(() => e.currentState.planInfo, [e.currentState.planInfo])
  };
}, $d = () => {
  const { session: e } = xi();
  return {
    priceInfo: v(() => e.priceInfo, [e.priceInfo])
  };
}, Ud = () => {
  const { session: e } = xi();
  return {
    questionAnswerInfo: v(() => e.currentState.questionAnswerInfo, [e.currentState.questionAnswerInfo])
  };
}, Vd = () => {
  const { session: e } = xi();
  return {
    roomInfo: v(() => e.currentState.roomInfo, [e.currentState.roomInfo])
  };
}, Hd = () => {
  const { session: e } = xi();
  return {
    voucherInfo: v(() => e.currentState.voucherInfo, [e.currentState.voucherInfo])
  };
}, HX = Wi().min(7).max(7), zX = "https://zipcloud.ibsnet.co.jp/api/search?zipcode=", BX = () => {
  const [e, n] = se(!1), i = I(async (t) => {
    n(!0);
    const a = t.replace(/-/g, "");
    if (HX.safeParse(a).error)
      return n(!1), null;
    try {
      const r = await fetch(`${zX}${a}`).then((u) => u.json());
      if (P(r) || P(r.results) || ke(r.results) || r.status !== 200)
        return null;
      const { address1: o, address2: d, address3: c } = r.results[0];
      return `${o}${d}${c}`;
    } catch (r) {
      return null;
    } finally {
      n(!1);
    }
  }, []);
  return {
    isFetching: e,
    fetchAddress: i
  };
}, Gn = TX, qn = $X, qX = ({ sessionStateContext: e }) => {
  const { onUpdateSession: n } = Ji(), { refetch: i } = qn(
    q8,
    void 0,
    !0
  ), t = v(() => ({
    dateInfo: P(e.cinDt) || P(e.coutDt) ? void 0 : {
      stayStartDt: e.cinDt,
      stayLastDt: La({
        date: e.coutDt,
        amount: 1
      })
    },
    groupInfo: P(e.adultNum) || P(e.kidsNum) ? void 0 : { adultNum: e.adultNum, kidsNum: e.kidsNum },
    planID: e.planID,
    roomID: e.roomID,
    voucherCode: e.voucherCode
  }), [
    e.adultNum,
    e.cinDt,
    e.coutDt,
    e.kidsNum,
    e.planID,
    e.roomID,
    e.voucherCode
  ]);
  return {
    onInitSession: I(async () => {
      const { data: s } = await i({
        hotelId: e.hotelID,
        reservationId: e.reservationID,
        reservationIdOfReplicationSource: e.reservationIDOfReplicationSource,
        lang: e.lang,
        optionInfo: t
      });
      n(s.reservationInitialSessionState), le(
        pl({
          ...ct(
            Ss(s.reservationInitialSessionState)
          ),
          trigger: "init"
        })
      );
    }, [
      i,
      n,
      t,
      e.hotelID,
      e.lang,
      e.reservationID,
      e.reservationIDOfReplicationSource
    ])
  };
}, GX = ({ sessionStateContext: e }) => {
  const { onUpdateSession: n } = Ji(), { refetch: i } = qn(
    B8,
    void 0,
    !0
  );
  return {
    onRestoreSession: I(async () => {
      if (!P(e.sessionID) && !P(e.lastUpdatedAt)) {
        const { data: a } = await i({
          baseInfo: {
            hotelID: e.hotelID,
            sessionID: e.sessionID,
            lastUpdatedAt: e.lastUpdatedAt
          }
        });
        n(a.reservationCurrentSessionState), le(
          pl({
            ...ct({
              hotelID: e.hotelID,
              sessionID: e.sessionID
            }),
            trigger: "restore"
          })
        );
      }
    }, [
      i,
      n,
      e.hotelID,
      e.lastUpdatedAt,
      e.sessionID
    ])
  };
}, WX = ({ sessionStateContext: e }) => {
  const { onInitSession: n } = qX({ sessionStateContext: e }), { onRestoreSession: i } = GX({ sessionStateContext: e });
  return {
    onInitialize: I(async () => {
      if (!P(e.sessionID) && !P(e.lastUpdatedAt))
        try {
          await i();
        } catch (a) {
          if (h2(a) && v2(a))
            if (a.extensions.code === "Reservation_SessionNotFound")
              await n();
            else
              throw a;
        }
      else
        await n();
    }, [e.sessionID, e.lastUpdatedAt, i, n])
  };
}, KX = g(({ children: e, initializeContext: n }) => {
  const { onInitialize: i } = WX(n), { state: t } = H8({ onInitialize: i });
  return t.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(Sd, {}) : e;
}), YX = () => {
  const { agreementOfTermsOfService: e } = Od(), { clientContext: n } = Ed(), { dateInfo: i } = Lr(), { discountInfo: t } = Jd(), { groupInfo: a } = _d(), { guestInfo: s } = Qd(), { optionPerDateInfo: r, optionPerReservationInfo: o } = Md(), { planInfo: d } = Ld(), { priceInfo: c } = $d(), { questionAnswerInfo: u } = Ud(), { roomInfo: k } = Vd(), { voucherInfo: m } = Hd(), { baseInfoInput: f } = lt(), { lang: p } = u1(), { hotelName: h } = Td(), { reservationContext: N } = Er(), { reservationPolicy: S } = Ua(), { reserveStatus: F } = m1(), { onUpdateSession: y } = Ji();
  return {
    sessionState: {
      currentState: {
        agreementOfTermsOfService: e,
        dateInfo: i,
        discountInfo: t,
        guestInfo: s,
        groupInfo: a,
        optionPerDateInfo: r,
        optionPerReservationInfo: o,
        planInfo: d,
        questionAnswerInfo: u,
        roomInfo: k,
        voucherInfo: m
      },
      clientContext: n,
      baseInfoInput: f,
      lang: p,
      reservationContext: N,
      reservationPolicy: S,
      priceInfo: c,
      reserveStatus: F,
      hotelName: h,
      onUpdateSession: y
    }
  };
};
function XX({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === "Screen4")
    return 1;
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === "Screen1")
      return 1;
    if (e === "Screen2")
      return 2;
    if (e === "Screen3")
      return 3;
    if (e === "Screen4")
      return 4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === "Screen1")
      return 1;
    if (e === "Screen3")
      return 2;
    if (e === "Screen4")
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === "Screen2")
      return 1;
    if (e === "Screen3")
      return 2;
    if (e === "Screen4")
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === "Screen3")
      return 1;
    if (e === "Screen4")
      return 2;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === "Screen1")
      return 1;
    if (e === "Screen3")
      return 2;
    if (e === "Screen4")
      return 3;
    throw new Error("Invalid current step.");
  }
  if (e === "Screen1")
    return 1;
  if (e === "Screen2")
    return 2;
  if (e === "Screen3")
    return 3;
  if (e === "Screen4")
    return 4;
  throw new Error("Invalid current step.");
}
function ZX({
  sessionStateContext: {
    reservationContext: { reservationEditMode: e },
    reservationPolicy: { optionSelectionMode: n },
    clientContext: { reserveFailedReason: i }
  }
}) {
  return e === X.EditReservationAuthorizedFailed || e === X.EditReservationCreditCardOnly ? Je.screen4 : e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotAndRegular || e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotOnly ? Je.screen1 : e === X.EditReservationOptionUpdateOnly && n === Z.RegularOnly ? Je.screen2 : e === X.EditReservationOptionUpdateOnly && n === Z.None ? Je.screen3 : i === ml.PaymentFailed ? Je.screen4 : Je.screen1;
}
function eZ({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === Je.screen4)
    throw new Error("Invalid current screen.");
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === Je.screen1)
      return Je.screen2;
    if (e === Je.screen2)
      return Je.screen3;
    if (e === Je.screen3)
      return Je.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === Je.screen1)
      return Je.screen3;
    if (e === Je.screen3)
      return Je.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === Je.screen2)
      return Je.screen3;
    if (e === Je.screen3)
      return Je.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === Je.screen3)
      return Je.screen4;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === Je.screen1)
      return Je.screen3;
    if (e === Je.screen3)
      return Je.screen4;
    throw new Error("Invalid current step.");
  }
  if (e === Je.screen1)
    return Je.screen2;
  if (e === Je.screen2)
    return Je.screen3;
  if (e === Je.screen3)
    return Je.screen4;
  throw new Error("Invalid next screen.");
}
function nZ({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === Je.screen4)
    throw new Error("Invalid current screen.");
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === Je.screen4)
      return Je.screen3;
    if (e === Je.screen3)
      return Je.screen2;
    if (e === Je.screen2)
      return Je.screen1;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === Je.screen4)
      return Je.screen3;
    if (e === Je.screen3)
      return Je.screen1;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === Je.screen4)
      return Je.screen3;
    if (e === Je.screen3)
      return Je.screen2;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === Je.screen4)
      return Je.screen3;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === Je.screen4)
      return Je.screen3;
    if (e === Je.screen3)
      return Je.screen1;
    throw new Error("Invalid current step.");
  }
  if (e === Je.screen4)
    return Je.screen3;
  if (e === Je.screen3)
    return Je.screen2;
  if (e === Je.screen2)
    return Je.screen1;
  throw new Error("Invalid next screen.");
}
function iZ({
  sessionStateContext: {
    reservationContext: { reservationEditMode: e },
    //
    reservationPolicy: { optionSelectionMode: n }
  }
}) {
  return e === X.EditReservationAuthorizedFailed || e === X.EditReservationCreditCardOnly ? 1 : e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotAndRegular ? 4 : e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotOnly || e === X.EditReservationOptionUpdateOnly && n === Z.RegularOnly ? 3 : e === X.EditReservationOptionUpdateOnly && n === Z.None ? 2 : n === Z.TimeSlotOnly || n === Z.None ? 3 : 4;
}
const Je = {
  screen1: "Screen1",
  screen2: "Screen2",
  screen3: "Screen3",
  screen4: "Screen4"
}, l9 = {
  Screen1: "selection",
  Screen2: "option",
  Screen3: "guest_info",
  Screen4: "payment"
}, tZ = (e) => {
  const [n, i] = se(ZX(e)), t = I(() => {
    const o = eZ({ currentScreen: n, ...e });
    i(o), le(
      Ja({
        reservation_component_ui_type: "full",
        screen: l9[o],
        direction: "next"
      })
    );
  }, [n, e]), a = I(() => {
    const o = nZ({ currentScreen: n, ...e });
    i(o), le(
      Ja({
        reservation_component_ui_type: "full",
        screen: l9[o],
        direction: "prev"
      })
    );
  }, [n, e]), s = v(() => XX({ currentScreen: n, ...e }), [n, e]), r = v(() => iZ(e), [e]);
  return {
    currentScreen: n,
    onNextScreen: t,
    onPrevScreen: a,
    currentStep: s,
    totalStep: r
  };
}, zd = ({
  disabled: e = !1,
  open: n,
  onOpenChange: i,
  trackingTarget: t,
  triggerSlot: a,
  contentWidthClassName: s = "ch-max-w-screen-tablet",
  contentContext: r
}) => {
  const o = ks(), d = I(
    (h) => {
      t && le(
        Pn({
          target: `drawer.${t}.${h ? "open" : "close"}`
        })
      );
    },
    [t]
  ), c = n != null, u = c ? n : o.isOpen, k = I(
    (h) => {
      d(h), i && i(h), c || o.handleOpenChange(h);
    },
    [i, c, o, d]
  ), m = I(() => {
    i && i(!1), c || o.close();
  }, [i, c, o]), f = I(
    (h) => {
      h.preventDefault(), d(!1), m();
    },
    [m, d]
  ), p = I((h) => {
    h.preventDefault();
  }, []);
  return /* @__PURE__ */ l.jsxs(fl, { open: u, onOpenChange: k, children: [
    /* @__PURE__ */ l.jsx(
      Et,
      {
        disabled: e,
        className: ce(
          "ch-w-full ch-min-w-0 ch-px-5 ch-py-4 hover:ch-no-underline",
          e ? "ch-cursor-not-allowed ch-opacity-50" : void 0
        ),
        children: a
      }
    ),
    /* @__PURE__ */ l.jsxs(
      vl,
      {
        className: "ch-h-drawer-almost-full ch-max-h-drawer-almost-full ch-rounded-t-2xl ch-font-system-ui",
        onClick: p,
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ l.jsxs(
            yt,
            {
              className: ce(
                "ch-mx-auto ch-grid ch-w-full ch-grid-cols-[1fr_40px] ch-items-center ch-border-b ch-border-t-gray-200 ch-px-5 ch-pb-3",
                s
              ),
              children: [
                r.titleSlot,
                /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", onClick: f, children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) })
              ]
            }
          ),
          /* @__PURE__ */ l.jsx(
            "div",
            {
              className: ce(
                "ch-mx-auto ch-min-h-0 ch-w-full ch-flex-1 ch-overflow-y-scroll",
                s
              ),
              children: r.bodySlot
            }
          ),
          /* @__PURE__ */ l.jsx(
            _m,
            {
              className: ce(
                "ch-mx-auto ch-w-full ch-border-t ch-border-t-gray-200 ch-px-5",
                s
              ),
              children: r.footerSlot({ onCloseDrawer: m })
            }
          )
        ]
      }
    )
  ] });
}, aZ = Ve(
  /* GraphQL */
  `
	mutation RCSelectDateDateRemove($baseInfo: BaseInfoInput!) {
		dateRemove(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), lZ = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(aZ);
  return {
    onRemoveReservationStayDt: I(async () => {
      const { data: t } = await n({
        variables: { baseInfo: e.baseInfoInput }
      });
      e.onUpdateSession(t.dateRemove), le(
        yn({
          target: "date",
          action: "remove"
        })
      );
    }, [n, e])
  };
}, sZ = (e) => e.sessionStateContext.reservationPolicy.isDayTrip && !P(e.selectedDtContext.cinDt) ? {
  kind: "DayTripDtSelected",
  lang: e.sessionStateContext.lang,
  dt: e.selectedDtContext.cinDt,
  onSubmitCallback: e.onSubmit,
  onResetCallback: e.onResetForDayTripDt
} : !P(e.selectedDtContext.cinDt) && !P(e.selectedDtContext.coutDt) ? {
  kind: "ReservationCinOutSelected",
  lang: e.sessionStateContext.lang,
  cinDt: e.selectedDtContext.cinDt,
  coutDt: e.selectedDtContext.coutDt,
  onSubmitCallback: e.onSubmit,
  onResetCallback: e.onResetForStayDt(e.selectedDtContext.coutDt)
} : P(e.selectedDtContext.cinDt) ? {
  kind: "NotSelected",
  lang: e.sessionStateContext.lang
} : {
  kind: "ReservationCinSelected",
  lang: e.sessionStateContext.lang,
  cinDt: e.selectedDtContext.cinDt,
  onResetCallback: e.onResetForStayDt()
}, rZ = (e) => ({
  state: v(() => sZ(e), [e])
}), oZ = g(({ state: e }) => {
  const n = v(() => kn({
    lang: e.lang,
    i18nString: {
      default: "日付のリセット",
      en: "Reset date"
    }
  }), [e]), i = v(() => e.kind === "NotSelected", [e.kind]), { onShowLoadingScreenCallback: t, onHideLoadingScreenCallback: a } = fn(), s = I(async () => {
    e.kind !== "NotSelected" && (t(), await e.onResetCallback().finally(() => {
      a();
    }));
  }, [a, t, e]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: i, variant: "outline", size: "md", onClick: s, children: n });
}), dZ = g(({ state: e }) => {
  const n = v(() => {
    switch (e.lang) {
      case D.Default:
        return "決定する";
      case D.En:
        return "Confirm";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]), i = v(() => e.kind === "NotSelected" || e.kind === "ReservationCinSelected", [e.kind]), t = I(() => {
    e.kind === "NotSelected" || e.kind === "ReservationCinSelected" || e.onSubmitCallback();
  }, [e]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: i, variant: "default", size: "md", onClick: t, children: n });
}), cZ = g(({ state: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-cols-2 ch-gap-x-4 ch-py-4", children: [
  /* @__PURE__ */ l.jsx(oZ, { state: e }),
  /* @__PURE__ */ l.jsx(dZ, { state: e })
] })), uZ = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "滞在日";
      case D.En:
        return "Stay date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), mZ = g(({ lang: e, dt: n }) => {
  const i = v(() => {
    switch (e) {
      case D.Default:
        return `${Ne(n, "YYYY年MM月DD日")}（日帰り）`;
      case D.En:
        return `${Ne(n, "D MMM YYYY", "en")} (Day trip)`;
      default:
        throw new Error("Invalid lang code");
    }
  }, [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), kZ = g(({ lang: e, dt: n }) => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pt-4 ch-text-center", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
  /* @__PURE__ */ l.jsx(uZ, { lang: e }),
  /* @__PURE__ */ l.jsx(mZ, { lang: e, dt: n })
] }) })), fZ = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "日付を選択してください";
      case D.En:
        return "Please select a date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pb-3 ch-pt-7 ch-text-center", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-urgent-400", children: n }) });
}), vZ = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックイン";
      case D.En:
        return "Check-in";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), hZ = g(({ lang: e, dt: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), pZ = g(({ lang: e, cinDt: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(vZ, { lang: e }),
  /* @__PURE__ */ l.jsx(hZ, { dt: n, lang: e })
] })), NZ = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックアウト";
      case D.En:
        return "Check-out";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), SZ = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "日付を選択してください";
      case D.En:
        return "Please select a date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-leading-5 ch-text-urgent-400", children: n });
}), gZ = g(({ lang: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(NZ, { lang: e }),
  /* @__PURE__ */ l.jsx(SZ, { lang: e })
] })), FZ = g(({ lang: e, cinDt: n }) => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pt-4 ch-text-center", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-gap-x-6", children: [
  /* @__PURE__ */ l.jsx(pZ, { lang: e, cinDt: n }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-bold", children: "→" }),
  /* @__PURE__ */ l.jsx(gZ, { lang: e })
] }) })), IZ = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックイン";
      case D.En:
        return "Check-in";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), yZ = g(({ lang: e, dt: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), bZ = g(({ lang: e, cinDt: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(IZ, { lang: e }),
  /* @__PURE__ */ l.jsx(yZ, { lang: e, dt: n })
] })), CZ = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックアウト";
      case D.En:
        return "Check-out";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), xZ = g(({ lang: e, dt: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), DZ = g(({ lang: e, coutDt: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(CZ, { lang: e }),
  /* @__PURE__ */ l.jsx(xZ, { lang: e, dt: n })
] })), wZ = g(({ lang: e, cinDt: n, coutDt: i }) => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pt-4 ch-text-center", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-gap-x-6", children: [
  /* @__PURE__ */ l.jsx(bZ, { lang: e, cinDt: n }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-bold", children: "→" }),
  /* @__PURE__ */ l.jsx(DZ, { lang: e, coutDt: i })
] }) })), PZ = g(({ state: e }) => e.kind === "DayTripDtSelected" ? /* @__PURE__ */ l.jsx(kZ, { lang: e.lang, dt: e.dt }) : e.kind === "ReservationCinSelected" ? /* @__PURE__ */ l.jsx(FZ, { lang: e.lang, cinDt: e.cinDt }) : e.kind === "ReservationCinOutSelected" ? /* @__PURE__ */ l.jsx(wZ, { lang: e.lang, cinDt: e.cinDt, coutDt: e.coutDt }) : /* @__PURE__ */ l.jsx(fZ, { lang: e.lang })), RZ = g(({ modelContext: e }) => {
  const { state: n } = rZ(e);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-grid", children: [
    /* @__PURE__ */ l.jsx(PZ, { state: n }),
    /* @__PURE__ */ l.jsx(cZ, { state: n })
  ] });
}), TZ = g(({ sessionStateContext: e }) => {
  const n = v(() => {
    switch (e.lang) {
      case D.Default:
        return "日付を選択";
      case D.En:
        return "Select date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-bold ch-text-black ch-opacity-80", children: n });
}), jZ = g(({ lang: e }) => v(() => {
  switch (e) {
    case D.Default:
      return "日付(日帰り)";
    case D.En:
      return "Date (Day Trip)";
    default:
      throw new Error("Invalid lang code");
  }
}, [e])), AZ = g(({ lang: e }) => v(() => {
  switch (e) {
    case D.Default:
      return "日付";
    case D.En:
      return "Date";
    default:
      throw new Error("Invalid lang code");
  }
}, [e])), OZ = g(({ displayContext: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: e.sessionStateContext.reservationPolicy.isDayTrip ? /* @__PURE__ */ l.jsx(jZ, { lang: e.sessionStateContext.lang }) : /* @__PURE__ */ l.jsx(AZ, { lang: e.sessionStateContext.lang }) })), F3 = (e) => !(P(e) || Ke(e)), EZ = (e) => e.sessionStateContext.reservationPolicy.isDayTrip && !P(e.sessionStateContext.currentState.dateInfo) && F3(e.sessionStateContext.currentState.dateInfo.stayStartDt) ? {
  kind: "DayTripSelected",
  lang: e.sessionStateContext.lang,
  dt: e.sessionStateContext.currentState.dateInfo.stayStartDt
} : !P(e.sessionStateContext.currentState.dateInfo) && F3(e.sessionStateContext.currentState.dateInfo.stayStartDt) && F3(e.sessionStateContext.currentState.dateInfo.stayLastDt) ? {
  kind: "ReservationSelected",
  lang: e.sessionStateContext.lang,
  cInDt: e.sessionStateContext.currentState.dateInfo.stayStartDt,
  /**
   * StayLastDt を CheckoutDt へ変換
   */
  cOutDt: Ci({
    date: e.sessionStateContext.currentState.dateInfo.stayLastDt,
    inc: 1
  })
} : {
  kind: "NotSelected",
  lang: e.sessionStateContext.lang
}, JZ = (e) => ({ state: v(() => EZ(e), [e]) }), _Z = g(({ lang: e, dt: n }) => v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e])), QZ = g(({ lang: e }) => v(() => {
  switch (e) {
    case D.Default:
      return "未選択";
    case D.En:
      return "Not selected";
    default:
      throw new Error("Invalid lang code");
  }
}, [e])), MZ = g(({ lang: e, cInDt: n, cOutDt: i }) => {
  const t = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]), a = v(() => e === D.Default ? Ne(i, "YYYY年MM月DD日") : Ne(i, "D MMM YYYY", "en"), [i, e]);
  return v(() => `${t} ~ ${a}`, [t, a]);
}), LZ = g((e) => {
  const { state: n } = JZ(e.modelContext);
  return /* @__PURE__ */ l.jsxs(
    "p",
    {
      className: ce(
        "ch-text-lg",
        n.kind !== "NotSelected" ? "ch-text-black ch-opacity-90" : "ch-text-gray-400"
      ),
      children: [
        n.kind === "DayTripSelected" ? /* @__PURE__ */ l.jsx(_Z, { lang: n.lang, dt: n.dt }) : null,
        n.kind === "ReservationSelected" ? /* @__PURE__ */ l.jsx(MZ, { lang: n.lang, cInDt: n.cInDt, cOutDt: n.cOutDt }) : null,
        n.kind === "NotSelected" ? /* @__PURE__ */ l.jsx(QZ, { lang: n.lang }) : null
      ]
    }
  );
}), $Z = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(
    OZ,
    {
      displayContext: {
        sessionStateContext: e
      }
    }
  ),
  /* @__PURE__ */ l.jsx(
    LZ,
    {
      modelContext: {
        sessionStateContext: e
      }
    }
  )
] }));
function UZ(e) {
  const n = Tr();
  return e.isDayTrip ? {
    cinDt: e.stayStartDt,
    coutDt: void 0,
    resetAt: n
  } : P(e.stayStartDt) || P(e.stayLastDt) ? {
    cinDt: e.stayStartDt,
    coutDt: void 0,
    resetAt: n
  } : {
    cinDt: e.stayStartDt,
    /**
     * StayLastDt は宿泊最終日なので +1 日する必要がある
     */
    coutDt: Ci({ date: e.stayLastDt, inc: 1 }),
    resetAt: n
  };
}
const VZ = (e) => {
  const n = v(() => {
    var o, d, c, u;
    return UZ({
      isDayTrip: e.sessionStateContext.reservationPolicy.isDayTrip,
      stayStartDt: (d = (o = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : o.stayStartDt) != null ? d : void 0,
      stayLastDt: (u = (c = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : c.stayLastDt) != null ? u : void 0
    });
  }, [e.sessionStateContext]), [i, t] = se(n), a = I(() => {
    t({
      cinDt: void 0,
      coutDt: void 0,
      resetAt: Tr()
    });
  }, []), s = I((o) => {
    t((d) => ({
      ...d,
      cinDt: o,
      coutDt: void 0
    }));
  }, []), r = I((o) => {
    t((d) => ({
      ...d,
      coutDt: o
    }));
  }, []);
  return {
    checkDtState: i,
    onSelectCinDt: s,
    onSelectCoutDt: r,
    onResetCheckDt: a
  };
}, HZ = (e) => {
  const { sessionStateContext: n, onUpdateAgreementOfTermsOfService: i } = e, t = n.currentState.agreementOfTermsOfService, a = n.lang;
  return t ? {
    kind: "Checked",
    lang: a,
    onUnchecked: (s) => i(s)
  } : {
    kind: "NotChecked",
    lang: a,
    onChecked: (s) => i(s)
  };
}, zZ = (e) => ({
  state: v(() => HZ(e), [e])
}), BZ = g(({ htmlFor: e, lang: n }) => {
  const i = v(() => n === D.Default ? "同意する" : "Agree to the terms and conditions", [n]);
  return /* @__PURE__ */ l.jsx(Qn, { htmlFor: e, className: "ch-cursor-pointer ch-text-base ch-font-semibold", children: i });
}), qZ = g((e) => {
  const { state: n } = zZ(e), { onHideLoadingScreenCallback: i, onShowLoadingScreenCallback: t } = fn(), a = I(async () => {
    const o = async () => {
      n.kind === "Checked" ? await n.onUnchecked(!1) : await n.onChecked(!0);
    };
    t(), await o().finally(() => {
      i();
    });
  }, [i, t, n]), s = ul(), r = v(() => n.kind === "Checked", [n.kind]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-mt-8 ch-flex ch-items-center ch-justify-center ch-gap-x-2", children: [
    /* @__PURE__ */ l.jsx(hv, { id: s, checked: r, onCheckedChange: a }),
    /* @__PURE__ */ l.jsx(BZ, { htmlFor: s, lang: n.lang })
  ] });
}), GZ = (e) => e.sessionStateContext.lang === D.Default ? {
  kind: "ForDefaultDisplayable"
} : {
  kind: "ForEnDisplayable"
}, WZ = (e) => ({
  state: v(() => GZ(e), [e])
}), mr = g(({ text: e, url: n }) => /* @__PURE__ */ l.jsx("a", { className: "ch-mx-1 ch-text-link-400 ch-underline-offset-2 hover:ch-underline", target: "_blank", href: n, children: e })), KZ = "https://www.chillnn.com/policy/privacyPolicy", YZ = "https://www.chillnn.com/policy/servicePolicy", XZ = g(() => /* @__PURE__ */ l.jsxs("p", { className: "ch-text-sm ch-font-normal", children: [
  /* @__PURE__ */ l.jsx(mr, { text: "利用規約", url: YZ }),
  "、及び ",
  /* @__PURE__ */ l.jsx(mr, { text: "プライバシーポリシー", url: KZ }),
  "を読んだ上で内容に同意します。入力情報と質問の回答はご予約ホテルに提供されます。"
] })), ZZ = "https://www.chillnn.com/policy/privacyPolicy", eee = "https://www.chillnn.com/policy/servicePolicy", nee = g(() => /* @__PURE__ */ l.jsxs("p", { className: "ch-text-sm", children: [
  "Please read and agree to the ",
  /* @__PURE__ */ l.jsx(mr, { text: "Terms of Service", url: eee }),
  " and",
  " ",
  /* @__PURE__ */ l.jsx(mr, { text: "Privacy Policy", url: ZZ }),
  ". The input information and answers to the questions will be provided to the reserved hotel."
] })), iee = g((e) => {
  const { state: n } = WZ(e);
  return n.kind === "ForDefaultDisplayable" ? /* @__PURE__ */ l.jsx(XZ, {}) : /* @__PURE__ */ l.jsx(nee, {});
}), tee = g(({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "利用者に対し権利を制限、又は義務を課する条項" : "Clauses that restrict rights or impose obligations on users", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: n });
}), aee = (e) => e.sessionStateContext.lang === D.Default ? {
  kind: "ForDefaultDisplayable"
} : {
  kind: "ForEnDisplayable"
}, lee = (e) => ({
  state: v(() => aee(e), [e])
}), ze = g(({ slot: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-my-2", children: e })), Nt = g(({ text: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-mb-2 ch-mt-3 ch-font-semibold", children: e })), see = "https://www.chillnn.com/policy/servicePolicy", ree = g(() => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        "(本サービスに関する",
        /* @__PURE__ */ l.jsx(mr, { text: "利用規約", url: see }),
        "より抜粋)"
      ] })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "第３条（サービスの利用条件）" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "５. 当社は、利用者が、以下の各号のいずれかの事由に該当する場合は、利用を拒否することがあり、またその理由について一切開示義務を負いません。" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "5.1. 当社に提供した登録事項の全部または一部につき虚偽、誤記または記載漏れがあった場合" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "5.2. 未成年者、成年被後見人、被保佐人または被補助人のいずれかであり、法定代理人、後見人、保佐人または補助人の同意等を得ていなかった場合" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "5.3. 反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ。）である、または資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与を行っていると当社が判断した場合" })
    }
  ),
  /* @__PURE__ */ l.jsx(ze, { slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "5.4. 過去当社との契約に違反した者またはその関係者であると当社が判断した場合" }) }),
  /* @__PURE__ */ l.jsx(ze, { slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "5.5. その他、登録を適当でないと当社が判断した場合" }) }),
  /* @__PURE__ */ l.jsx(Nt, { text: "第５条（宿泊代金決済・代金決済）" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "3. 予約者が他人名義のクレジットカードまたは偽造されたクレジットカードを使用し、その結果当社が損害を受けた場合には、当社は予約者に対して当該損害の賠償を求めることができ、予約者はこれを賠償する義務を負うものとします。" })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "第８条（本サービスの停止）" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "当社は、以下のいずれかに該当する場合には、利用者に事前に通知することなく、本サービスの全部または一部の提供を停止または中断することができるものとします。ただし、本条項に基づき本サービスを停止した場合における損害に対し、サービスの停止が明らかに当社の責めに帰すべき事由で生じた場合は、直近の予約確認メールに明記された請求合計を上限として補償する。" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1. 本サービスに係るコンピューター・システムの点検または保守作業を緊急に行う場合" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "2. コンピューター、通信回線等の障害、誤操作、過度なアクセスの集中、不正アクセス、ハッキング等により本サービスの運営ができなくなった場合" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "3. 地震、落雷、火災、風水害、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合" })
    }
  ),
  /* @__PURE__ */ l.jsx(ze, { slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "4. その他、当社が停止または中断を必要と判断した場合" }) }),
  /* @__PURE__ */ l.jsx(Nt, { text: "第１０条（利用抹消等）" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1. 当社は、利用者が、以下の各号のいずれかの事由に該当する場合は、事前に通知または催告することなく、掲載データを削除もしくは非表示にし、当該利用者について本サービスの利用を一時的に停止し、または利用者としての利用を抹消することができます" })
    }
  ),
  /* @__PURE__ */ l.jsx(ze, { slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.1. 本規約のいずれかの条項に違反した場合" }) }),
  /* @__PURE__ */ l.jsx(ze, { slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.2. 登録事項に虚偽の事実があることが判明した場合" }) }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.3. 支払停止もしくは支払不能となり，または破産手続開始，民事再生手続開始，会社更生手続開始，特別清算開始もしくはこれらに類する手続きの開始の申立てがあった場合" })
    }
  ),
  /* @__PURE__ */ l.jsx(ze, { slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.4. ６ヶ月以上本サービスの利用がない場合" }) }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.5. 当社からの問い合わせその他の回答を求める連絡に対して３０日間以上応答がない場合" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.6. その他，当社が本サービスの利用または利用者としての利用の継続を適当でないと判断した場合" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "2. 前項各号のいずれかの事由に該当した場合，利用者は，当社に対して追っている債務の一切について当然に期限の利益を失い，直ちに当社に対して全ての債務の支払を行わなければなりません。" })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "第１１条（本サービスの内容の変更，終了）" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1. 当社は、当社の都合により、本サービスの内容を変更し、または提供を終了するとができます。" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "2. 当社が本サービスの提供を終了する場合、当社は登録ユーザーに事前に通知するものとします。" })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "第１２条（保証の否認および免責事項）" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1. 当社は、本サービスが利用者の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、利用者による本サービスの利用が利用者に適用のある法令または業界団体の内部規則等に適合すること、継続的に利用できること、及び不具合が生じないことについて、明示又は黙示を問わず何ら保証するものではありません。" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "2. 当社は、本サービスに関して当社の責務不足に起因し利用者が被った損害につき、当社が利用者に送信済みの直近の予約確認メールに明記された請求金額を超えて賠償する責任を負わないものとし、また、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については、賠償する責任を負わないものとします。" })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "3. 本サービスまたは当社ウェブサイトに関連して利用者と他の利用者または第三者との間において生じた取引、連絡、紛争等については、利用者が自己の責任によって解決するものとします。" })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "第１６条（連絡・通知）" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "4. 登録ユーザーが当社に届け出た登録情報に虚偽、誤記、記載漏れがあり、当社からの通知または連絡が届かなかったことによる損害について当社は一切の責任を負いません。" })
    }
  )
] })), oee = "https://www.chillnn.com/policy/servicePolicy", dee = g(() => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        "(Please note that the translation of the English version of this agreement is provided for your convenience only and must be accepted as a legal contract in its original form. Please click",
        " ",
        /* @__PURE__ */ l.jsx(mr, { text: "here", url: oee }),
        " to see the original.)"
      ] })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "Article 3 (Conditions of Use of the Service)" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "５. The Company may refuse to allow a user to use the site if the user falls into any of the following categories, and the Company is under no obligation to disclose the reason for such refusal." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "5.1. If there is any falsity, error or omission in all or any part of the registration information you have provided to us." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "5.2. The applicant is a minor, an adult ward, a person under curatorship, or a person under assistance, and has not obtained the consent of a legal representative, guardian, curator, or assistant." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "5.3. Antisocial forces, etc. (meaning organized crime groups, organized crime group members, right-wing groups, antisocial forces, and other persons equivalent thereto. The same shall apply hereinafter. In the event that the Company judges that the person is an antisocial force, etc. (meaning a crime syndicate, gangster, right wing group, antisocial force, or any other equivalent person; the same shall apply hereinafter), or that the person has some kind of interaction or involvement with antisocial forces, etc. such as cooperating with or being involved in the maintenance, operation, or management of antisocial forces, etc. through the provision of funds or other means." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "5.4. In the event that the Company determines that you are a person who has violated a contract with the Company in the past or a person related to such a person." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "5.5. In any other cases where the Company deems the registration to be inappropriate." })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "Article 5 (Accommodation Deposit Resolution)" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "3. In the event that the Company suffers damage as a result of the use of a credit card in the name of another person or a forged credit card by the person making the reservation, the Company may demand compensation for such damage from the person making the reservation, and the person making the reservation shall be obligated to compensate the Company for such damage." })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "Article 8 (Suspension of the Service)" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "The Company may stop or suspend the provision of all or part of the Service without prior notice to the User in any of the following cases. However, the Company shall compensate for damages in the event that the Service is suspended in accordance with this clause, up to the total amount of claims specified in the most recent reservation confirmation e-mail, if the suspension of the Service was caused by reasons clearly attributable to the Company." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1. In case of urgent inspection or maintenance of the computer system related to this service." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "2. In the event that the operation of the Service becomes impossible due to computer or communication line failure, erroneous operation, excessive concentration of access, unauthorized access, hacking, etc." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "3. In the event that the operation of this service becomes impossible due to force majeure such as earthquakes, lightning, fire, wind, flood, power outages, or natural disasters." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "4. In any other cases where the Company deems it necessary to suspend or discontinue the service." })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "Article 10 (Termination of Use, etc.)" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1. The Company may delete or hide the posted data, temporarily suspend the use of this service for the user in question, or terminate the user's use of this service without prior notice or warning if the user falls under any of the following categories." })
    }
  ),
  /* @__PURE__ */ l.jsx(ze, { slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.1. If you violate any of the provisions of this Agreement." }) }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.2. If it is discovered that there is false information in the registered information." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.3. In the event of suspension of payment or inability to pay, or the filing of a petition for commencement of bankruptcy proceedings, commencement of civil rehabilitation proceedings, commencement of corporate reorganization proceedings, commencement of special liquidation or similar proceedings." })
    }
  ),
  /* @__PURE__ */ l.jsx(ze, { slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.4. If you have not used this service for more than 6 months." }) }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.5. If there is no response to our inquiries or other communications requesting a response for more than 30 days." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1.6. In any other cases where the Company deems it inappropriate to use the Service or to continue to use the Service as a User." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "2. In the event of any of the events listed in the preceding paragraph, the User shall naturally lose the benefit of time for all debts owed to the Company, and shall immediately make payment of all debts to the Company." })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "Article 11 (Change and Termination of the Service)" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1. The Company may change the contents of the Service or terminate the provision of the Service at the Company's convenience." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "2. In the event that the Company terminates the provision of the Service, the Company shall notify the registered users in advance." })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "Article 12 (Disclaimer of Warranty and Disclaimer of Liability)" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "1. The Company makes no warranties, express or implied, that the Service will be suitable for the specific purpose of the User, that it will have the expected functions, commercial value, accuracy, or usefulness, that the use of the Service by the User will comply with laws and regulations applicable to the User or internal rules of industry organizations, that the Service will be continuously available, or that defects will not occur." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "2. The Company shall not be liable to compensate for any damages incurred by the User due to the Company's lack of responsibility with respect to the Service beyond the amount of the claim specified in the most recent reservation confirmation email sent by the Company to the User, nor shall the Company be liable to compensate for incidental damages, indirect damages, special damages, future damages, or damages for lost earnings." })
    }
  ),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "3. Any transactions, communications, disputes, etc. between users and other users or third parties in connection with this service or the Company's website shall be resolved by the users at their own responsibility." })
    }
  ),
  /* @__PURE__ */ l.jsx(Nt, { text: "Article 16 (Contact and Notification)" }),
  /* @__PURE__ */ l.jsx(
    ze,
    {
      slot: /* @__PURE__ */ l.jsx(l.Fragment, { children: "4. The Company shall not be held responsible for any damages caused by falsehoods, errors, or omissions in the registration information submitted by the registered user to the Company, and the failure to receive notifications or communications from the Company." })
    }
  )
] })), cee = g((e) => {
  const { state: n } = lee(e);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-h-40 ch-overflow-y-scroll ch-overscroll-y-contain ch-rounded ch-bg-gray-100 ch-p-4 ch-text-sm ch-font-normal", children: n.kind === "ForDefaultDisplayable" ? /* @__PURE__ */ l.jsx(ree, {}) : /* @__PURE__ */ l.jsx(dee, {}) });
}), uee = Ve(
  /* GraphQL */
  `
	mutation InputAOTOSAOTOSUpdate($baseInfo: BaseInfoInput!, $isAgree: Boolean!) {
		agreementOfTermsOfServiceSet(baseInfo: $baseInfo, isAgree: $isAgree) {
			...ReservationSessionStateFragment
		}
	}
`
), mee = ({
  sessionStateContext: e
}) => {
  const { mutationFunc: n } = Gn(uee);
  return {
    onUpdateAgreementOfTermsOfService: I(
      async (t) => {
        const { data: a } = await n({
          variables: {
            baseInfo: e.baseInfoInput,
            isAgree: t
          }
        });
        P(a.agreementOfTermsOfServiceSet) || e.onUpdateSession(a.agreementOfTermsOfServiceSet), le(
          yn({
            target: "terms",
            action: "update"
          })
        );
      },
      [n, e]
    )
  };
}, m7 = g(({ sessionStateContext: e }) => {
  const { onUpdateAgreementOfTermsOfService: n } = mee({ sessionStateContext: e });
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-gap-y-4", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-gap-y-4", children: [
      /* @__PURE__ */ l.jsx(tee, { sessionStateContext: e }),
      /* @__PURE__ */ l.jsx(cee, { sessionStateContext: e }),
      /* @__PURE__ */ l.jsx(iee, { sessionStateContext: e })
    ] }),
    /* @__PURE__ */ l.jsx(
      qZ,
      {
        sessionStateContext: e,
        onUpdateAgreementOfTermsOfService: n
      }
    )
  ] });
}), kee = Ve(
  /* GraphQL */
  `
	mutation InputDiscountDiscountUpdate($baseInfo: BaseInfoInput!, $discountInfo: DiscountUpdateInput!) {
		discountUpdate(baseInfo: $baseInfo, discountInfo: $discountInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), fee = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(kee);
  return {
    onUpdateDiscount: I(
      (t) => async () => {
        try {
          const { data: a } = await n({
            variables: {
              baseInfo: e.baseInfoInput,
              discountInfo: { discountCode: t }
            }
          });
          e.onUpdateSession(a.discountUpdate), le(yn({ target: "discount", action: "update", ok: !0 }));
        } catch (a) {
          throw le(
            yn({
              target: "discount",
              action: "update",
              ok: !1,
              error_code: k1(a)
            })
          ), a;
        }
      },
      [n, e]
    )
  };
}, vee = g(({ lang: e }) => {
  const n = v(() => e === D.Default ? "適用中のディスカウント" : "Discount during adaptation", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: n });
}), hee = g(({ appliedDiscountState: e }) => {
  const n = v(() => `- ¥${e.price.toLocaleString()}`, [e.price]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-gap-x-2 ch-text-sm", children: [
    /* @__PURE__ */ l.jsx("p", { children: e.name }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: n })
  ] });
}), pee = g(({ appliedDiscountState: e }) => {
  const n = v(() => e.lang === D.Default ? "なし" : "Not applied.", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: n });
}), Nee = (e) => P(e.sessionState.currentState.discountInfo) ? {
  kind: "NotApplied",
  lang: e.sessionState.lang
} : {
  kind: "Applied",
  name: e.sessionState.currentState.discountInfo.name,
  price: e.sessionState.currentState.discountInfo.discountPrice
}, See = (e) => ({
  state: v(() => Nee(e), [e])
}), gee = g((e) => {
  const { state: n } = See(e);
  return n.kind === "Applied" ? /* @__PURE__ */ l.jsx(hee, { appliedDiscountState: n }) : /* @__PURE__ */ l.jsx(pee, { appliedDiscountState: n });
}), Fee = (e) => P(e) || Ke(e) ? {
  kind: "Invalidated",
  input: void 0
} : {
  kind: "Validated",
  input: e
}, Iee = () => ({
  kind: "Invalidated",
  input: void 0
}), yee = ({ onChangeState: e }) => ({
  onChangeInput: I(
    (i) => {
      const t = Fee(i);
      e(t);
    },
    [e]
  )
}), bee = () => {
  const [e, n] = se(Iee()), i = I((a) => {
    n(a);
  }, []), { onChangeInput: t } = yee({ onChangeState: i });
  return {
    state: e,
    onChangeInput: t
  };
}, Cee = (e) => e.discountFormState.kind === "Invalidated" ? {
  kind: "NotClickable",
  lang: e.lang
} : {
  kind: "Clickable",
  lang: e.lang,
  onClick: e.onApplyDiscount(e.discountFormState.input)
}, xee = (e) => ({
  state: v(() => Cee(e), [e])
}), Dee = g((e) => {
  const { state: n } = xee(e), { onHideLoadingScreenCallback: i, onShowLoadingScreenCallback: t } = fn(), a = I(async () => {
    n.kind === "Clickable" && (t(), await n.onClick().finally(() => {
      i();
    }));
  }, [i, t, n]), s = v(() => {
    switch (n.lang) {
      case D.Default:
        return "適用";
      case D.En:
        return "apply";
      default:
        return "";
    }
  }, [n.lang]), r = v(() => n.kind !== "Clickable", [n.kind]);
  return /* @__PURE__ */ l.jsx(
    ae,
    {
      size: "md",
      variant: "outline",
      className: "ch-h-full",
      disabled: r,
      onClick: a,
      children: s
    }
  );
}), wee = g(({ lang: e, discountFormState: n, onChangeInput: i }) => {
  var s;
  const t = I(
    (r) => {
      const o = r.target.value;
      i(o);
    },
    [i]
  ), a = v(() => e === D.Default ? "コードを入力してください" : "Please enter the code", [e]);
  return /* @__PURE__ */ l.jsx(
    Qa,
    {
      value: (s = n.input) != null ? s : "",
      onChange: t,
      placeholder: a
    }
  );
}), Pee = g(({ lang: e, ...n }) => {
  const { state: i, onChangeInput: t } = bee();
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-h-12 ch-items-center ch-gap-x-2 ch-pl-1", children: [
    /* @__PURE__ */ l.jsx(wee, { lang: e, discountFormState: i, onChangeInput: t }),
    /* @__PURE__ */ l.jsx(Dee, { ...n, lang: e, discountFormState: i })
  ] });
}), Ree = g(({ lang: e }) => {
  const n = v(() => e === D.Default ? "ディスカウントコード" : "Discount Code", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: n });
}), k7 = g(({ sessionStateContext: e }) => {
  const { onUpdateDiscount: n } = fee({ sessionStateContext: e }), i = v(() => e.reservationPolicy.isShowDiscountInput, [e.reservationPolicy.isShowDiscountInput]), t = v(() => !P(e.currentState.discountInfo), [e.currentState.discountInfo]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    i ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
      /* @__PURE__ */ l.jsx(Ree, { lang: e.lang }),
      /* @__PURE__ */ l.jsx(Pee, { lang: e.lang, onApplyDiscount: n })
    ] }) : null,
    t && /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
      /* @__PURE__ */ l.jsx(vee, { lang: e.lang }),
      /* @__PURE__ */ l.jsx(gee, { sessionState: e })
    ] })
  ] });
}), Tee = Ve(
  /* GraphQL */
  `
	mutation InputGuestInfoGuestInfoUpdate($baseInfo: BaseInfoInput!, $guestInfo: GuestInfoInput!) {
		guestInfoSet(baseInfo: $baseInfo, guestInfo: $guestInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), jee = (e) => Object.entries(e).filter(([, n]) => typeof n == "string" && n.trim() !== "").map(([n]) => n.replace(/[A-Z]/g, (i) => `_${i.toLowerCase()}`)).sort().join(","), s9 = /* @__PURE__ */ new Map(), Aee = () => {
  const { baseInfoInput: e } = lt(), { onUpdateSession: n } = Ji(), { mutationFunc: i } = Gn(Tee);
  return {
    onUpdateGuestInfo: I(
      async (a) => {
        const s = {
          baseInfo: e,
          guestInfo: a
        }, { data: r } = await i({ variables: s });
        n(r.guestInfoSet);
        const o = jee(a);
        s9.get(e.sessionID) !== o && (s9.set(e.sessionID, o), le(
          yn({
            target: "guest_info",
            action: "update",
            filled_fields: o
          })
        ));
      },
      [e, i, n]
    )
  };
}, Oee = (e) => e.sessionStateContext.reservationContext.reservationEditMode !== X.NewReservation ? {
  kind: "NotDisplayable"
} : e.sessionStateContext.lang === D.Default ? {
  kind: "LangForDefaultDisplayable"
} : {
  kind: "LangForEnDisplayable"
}, Eee = (e) => ({
  state: v(() => Oee(e), [e])
}), Jee = (e) => (n) => P(n) || Ke(n) ? {
  ...e,
  kind: "Changed",
  address: {
    kind: "AddressInValidated",
    value: n
  }
} : {
  ...e,
  kind: "Changed",
  address: {
    kind: "AddressValidated",
    value: n
  }
}, _ee = (e) => (n) => P(n) || Ke(n) ? {
  ...e,
  kind: "Changed",
  email: {
    kind: "EmailInValidated",
    value: n
  }
} : {
  ...e,
  kind: "Changed",
  email: {
    kind: "EmailValidated",
    value: n
  }
}, Qee = (e) => (n) => {
  if (e.displayMode !== "split")
    throw new Error("firstNameChanged can only be called in split mode");
  return P(n) || Ke(n) ? {
    ...e,
    kind: "Changed",
    firstName: { kind: "FirstNameInValidated", value: n }
  } : {
    ...e,
    kind: "Changed",
    firstName: { kind: "FirstNameValidated", value: n }
  };
}, Mee = (e) => (n) => {
  if (e.displayMode !== "split")
    throw new Error("firstNameKanaChanged can only be called in split mode");
  return P(n) || Ke(n) ? {
    ...e,
    kind: "Changed",
    firstNameKana: { kind: "FirstNameKanaInValidated", value: n }
  } : {
    ...e,
    kind: "Changed",
    firstNameKana: { kind: "FirstNameKanaValidated", value: n }
  };
}, Lee = (e) => {
  const { guestInfo: n } = e.sessionStateContext.currentState, i = n, t = (n == null ? void 0 : n.name) !== void 0 || (n == null ? void 0 : n.nameKana) !== void 0, a = (i == null ? void 0 : i.firstName) !== void 0 || (i == null ? void 0 : i.lastName) !== void 0;
  return t && !a ? e.sessionStateContext.reservationPolicy.isAddressInputRequired ? {
    kind: "Initialized",
    displayMode: "single",
    name: {
      kind: "NameInValidated",
      value: n == null ? void 0 : n.name
    },
    nameKana: {
      kind: "NameKanaInValidated",
      value: n == null ? void 0 : n.nameKana
    },
    postalCode: {
      kind: "PostalCodeInValidated",
      value: n == null ? void 0 : n.postalCode
    },
    address: {
      kind: "AddressInValidated",
      value: n == null ? void 0 : n.address
    },
    tel: {
      kind: "TelInValidated",
      value: n == null ? void 0 : n.tel
    },
    email: {
      kind: "EmailInValidated",
      value: n == null ? void 0 : n.email
    }
  } : {
    kind: "Initialized",
    displayMode: "single",
    name: {
      kind: "NameInValidated",
      value: n == null ? void 0 : n.name
    },
    nameKana: {
      kind: "NameKanaInValidated",
      value: n == null ? void 0 : n.nameKana
    },
    postalCode: {
      kind: "PostalCodeValidated",
      value: ""
    },
    address: {
      kind: "AddressValidated",
      value: ""
    },
    tel: {
      kind: "TelInValidated",
      value: n == null ? void 0 : n.tel
    },
    email: {
      kind: "EmailInValidated",
      value: n == null ? void 0 : n.email
    }
  } : e.sessionStateContext.reservationPolicy.isAddressInputRequired ? {
    kind: "Initialized",
    displayMode: "split",
    firstName: {
      kind: "FirstNameInValidated",
      value: i == null ? void 0 : i.firstName
    },
    lastName: {
      kind: "LastNameInValidated",
      value: i == null ? void 0 : i.lastName
    },
    firstNameKana: {
      kind: "FirstNameKanaInValidated",
      value: i == null ? void 0 : i.firstNameKana
    },
    lastNameKana: {
      kind: "LastNameKanaInValidated",
      value: i == null ? void 0 : i.lastNameKana
    },
    postalCode: {
      kind: "PostalCodeInValidated",
      value: n == null ? void 0 : n.postalCode
    },
    address: {
      kind: "AddressInValidated",
      value: n == null ? void 0 : n.address
    },
    tel: {
      kind: "TelInValidated",
      value: n == null ? void 0 : n.tel
    },
    email: {
      kind: "EmailInValidated",
      value: n == null ? void 0 : n.email
    }
  } : {
    kind: "Initialized",
    displayMode: "split",
    firstName: {
      kind: "FirstNameInValidated",
      value: i == null ? void 0 : i.firstName
    },
    lastName: {
      kind: "LastNameInValidated",
      value: i == null ? void 0 : i.lastName
    },
    firstNameKana: {
      kind: "FirstNameKanaInValidated",
      value: i == null ? void 0 : i.firstNameKana
    },
    lastNameKana: {
      kind: "LastNameKanaInValidated",
      value: i == null ? void 0 : i.lastNameKana
    },
    postalCode: {
      kind: "PostalCodeValidated",
      value: ""
    },
    address: {
      kind: "AddressValidated",
      value: ""
    },
    tel: {
      kind: "TelInValidated",
      value: n == null ? void 0 : n.tel
    },
    email: {
      kind: "EmailInValidated",
      value: n == null ? void 0 : n.email
    }
  };
}, $ee = (e) => (n) => {
  if (e.displayMode !== "split")
    throw new Error("lastNameChanged can only be called in split mode");
  return P(n) || Ke(n) ? {
    ...e,
    kind: "Changed",
    lastName: { kind: "LastNameInValidated", value: n }
  } : {
    ...e,
    kind: "Changed",
    lastName: { kind: "LastNameValidated", value: n }
  };
}, Uee = (e) => (n) => {
  if (e.displayMode !== "split")
    throw new Error("lastNameKanaChanged can only be called in split mode");
  return P(n) || Ke(n) ? {
    ...e,
    kind: "Changed",
    lastNameKana: { kind: "LastNameKanaInValidated", value: n }
  } : {
    ...e,
    kind: "Changed",
    lastNameKana: { kind: "LastNameKanaValidated", value: n }
  };
}, Vee = (e) => (n) => {
  if (e.displayMode !== "single")
    throw new Error("nameChanged can only be called in single mode");
  return P(n) || Ke(n) ? {
    ...e,
    kind: "Changed",
    name: { kind: "NameInValidated", value: n }
  } : {
    ...e,
    kind: "Changed",
    name: { kind: "NameValidated", value: n }
  };
}, Hee = (e) => (n) => {
  if (e.displayMode !== "single")
    throw new Error("nameKanaChanged can only be called in single mode");
  return P(n) || Ke(n) ? {
    ...e,
    kind: "Changed",
    nameKana: { kind: "NameKanaInValidated", value: n }
  } : {
    ...e,
    kind: "Changed",
    nameKana: { kind: "NameKanaValidated", value: n }
  };
}, zee = (e) => (n) => P(n) || Ke(n) ? {
  ...e,
  kind: "Changed",
  postalCode: {
    kind: "PostalCodeInValidated",
    value: n
  }
} : {
  ...e,
  kind: "Changed",
  postalCode: {
    kind: "PostalCodeValidated",
    value: n
  }
}, Bee = (e) => (n) => P(n) || Ke(n) ? {
  ...e,
  kind: "Changed",
  tel: {
    kind: "TelInValidated",
    value: n
  }
} : {
  ...e,
  kind: "Changed",
  tel: {
    kind: "TelValidated",
    value: n
  }
}, qee = (e) => {
  const n = I(
    (k) => {
      if (e.state.displayMode !== "single") return;
      const m = Vee(e.state)(k);
      e.onChangeState(m);
    },
    [e]
  ), i = I(
    (k) => {
      if (e.state.displayMode !== "single") return;
      const m = Hee(e.state)(k);
      e.onChangeState(m);
    },
    [e]
  ), t = I(
    (k) => {
      if (e.state.displayMode !== "split") return;
      const m = Qee(e.state)(k);
      e.onChangeState(m);
    },
    [e]
  ), a = I(
    (k) => {
      if (e.state.displayMode !== "split") return;
      const m = $ee(e.state)(k);
      e.onChangeState(m);
    },
    [e]
  ), s = I(
    (k) => {
      if (e.state.displayMode !== "split") return;
      const m = Mee(e.state)(k);
      e.onChangeState(m);
    },
    [e]
  ), r = I(
    (k) => {
      if (e.state.displayMode !== "split") return;
      const m = Uee(e.state)(k);
      e.onChangeState(m);
    },
    [e]
  ), o = I(
    (k) => {
      const m = Jee(e.state)(k);
      e.onChangeState(m);
    },
    [e]
  ), d = I(
    (k) => {
      const m = _ee(e.state)(k);
      e.onChangeState(m);
    },
    [e]
  ), c = I(
    (k) => {
      const m = zee(e.state)(k);
      e.onChangeState(m);
    },
    [e]
  ), u = I(
    (k) => {
      const m = Bee(e.state)(k);
      e.onChangeState(m);
    },
    [e]
  );
  return {
    // 単一フィールドモード用
    onChangeName: n,
    onChangeNameKana: i,
    // 分割フィールドモード用
    onChangeFirstName: t,
    onChangeLastName: a,
    onChangeFirstNameKana: s,
    onChangeLastNameKana: r,
    // 共通
    onChangeAddress: o,
    onChangeEmail: d,
    onChangePostalCode: c,
    onChangeTel: u
  };
}, Gee = (e) => {
  const n = I((r) => r.displayMode === "split" ? {
    firstName: r.firstName.value,
    lastName: r.lastName.value,
    firstNameKana: r.firstNameKana.value,
    lastNameKana: r.lastNameKana.value,
    postalCode: r.postalCode.value,
    address: r.address.value,
    tel: r.tel.value,
    email: r.email.value
  } : {
    name: r.name.value,
    nameKana: r.nameKana.value,
    postalCode: r.postalCode.value,
    address: r.address.value,
    tel: r.tel.value,
    email: r.email.value
  }, []), i = I(
    (r, o) => {
      const d = JSON.stringify(r), c = JSON.stringify(o);
      return d === c;
    },
    []
  ), { onHideLoadingScreenCallback: t, onShowLoadingScreenCallback: a } = fn(), s = Ye(void 0);
  be(() => {
    const r = n(e.state);
    if (P(s.current) && !P(r)) {
      s.current = r;
      return;
    }
    if (i(s.current, r))
      return;
    s.current = r;
    const c = setTimeout(async () => {
      a(), await e.onUpdateGuestInfo(r).finally(() => {
        t();
      });
    }, 1e3);
    return () => {
      clearTimeout(c);
    };
  }, [n, i, t, a, e]);
}, Wee = (e) => {
  const [n, i] = se(Lee(e)), t = I((s) => {
    i(s);
  }, []);
  Gee({ state: n, ...e });
  const a = qee({ state: n, onChangeState: t, ...e });
  return n.displayMode === "split" ? {
    displayMode: "split",
    currentGuestInfo: {
      firstName: n.firstName.value,
      lastName: n.lastName.value,
      firstNameKana: n.firstNameKana.value,
      lastNameKana: n.lastNameKana.value,
      postalCode: n.postalCode.value,
      address: n.address.value,
      tel: n.tel.value,
      email: n.email.value
    },
    onChangeFirstName: a.onChangeFirstName,
    onChangeLastName: a.onChangeLastName,
    onChangeFirstNameKana: a.onChangeFirstNameKana,
    onChangeLastNameKana: a.onChangeLastNameKana,
    onChangeAddress: a.onChangeAddress,
    onChangeEmail: a.onChangeEmail,
    onChangePostalCode: a.onChangePostalCode,
    onChangeTel: a.onChangeTel
  } : {
    displayMode: "single",
    currentGuestInfo: {
      name: n.name.value,
      nameKana: n.nameKana.value,
      postalCode: n.postalCode.value,
      address: n.address.value,
      tel: n.tel.value,
      email: n.email.value
    },
    onChangeName: a.onChangeName,
    onChangeNameKana: a.onChangeNameKana,
    onChangeAddress: a.onChangeAddress,
    onChangeEmail: a.onChangeEmail,
    onChangePostalCode: a.onChangePostalCode,
    onChangeTel: a.onChangeTel
  };
}, Kee = (e) => e.sessionStateContext.reservationPolicy.isAddressInputRequired ? {
  kind: "Displayable"
} : {
  kind: "NotDisplayable"
}, Yee = (e) => ({
  state: v(() => Kee(e), [e])
}), st = g(
  ({
    isRequired: e = !1,
    label: n,
    //
    value: i,
    placeholder: t,
    inputMode: a,
    autoComplete: s,
    name: r,
    onChangeCallback: o,
    errorMessage: d,
    type: c = "text",
    disabled: u = !1,
    trackingField: k,
    isTrackingValid: m = !1
  }) => {
    const f = ul(), p = I(() => {
      k && le(
        yn({
          target: "guest_info",
          action: "blur",
          field: k,
          valid: m
        })
      );
    }, [m, k]), h = I(
      (S) => {
        const F = S.target.value;
        o(F);
      },
      [o]
    ), N = v(() => !P(d) && !Ke(d), [d]);
    return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-1", children: [
        /* @__PURE__ */ l.jsx("label", { htmlFor: f, className: "ch-text-sm ch-font-semibold ch-text-black", children: n }),
        e ? /* @__PURE__ */ l.jsx(sm, { size: "3xs", className: "ch-text-urgent-400" }) : null
      ] }),
      /* @__PURE__ */ l.jsx(
        Qa,
        {
          id: f,
          type: c,
          name: r,
          value: i,
          required: e,
          placeholder: t,
          onChange: h,
          onBlur: p,
          autoComplete: s,
          inputMode: a,
          disabled: u,
          className: ce(N ? "!ch-border-urgent-400 focus-visible:ch-ring-urgent-400" : null)
        }
      ),
      N ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-text-urgent-400", children: d }) : null
    ] });
  }
), Xee = Wi().min(1, { message: "都道府県は入力が必須です" });
function Zee(e) {
  const n = Xee.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const ene = (e) => {
  const n = Zee(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, r9 = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), nne = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = ene(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), ine = (e) => {
  const [n, i] = se(r9(e)), t = I((r) => {
    i(r);
  }, []), { onChangeValue: a } = nne({ onChangeState: t, ...e }), s = v(() => (r) => r9({ value: r }), []);
  return be(() => {
    i((r) => r.value === e.value ? r : s(e.value));
  }, [e.value, s]), {
    state: n,
    onChangeValue: a
  };
}, tne = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = ine(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      isRequired: !0,
      label: "住所",
      placeholder: "京都府京都市下京区烏丸通七条下る東塩小路町721-1",
      autoComplete: "street-address",
      value: (a = n.value) != null ? a : "",
      trackingField: "address",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t,
      disabled: e.disabled
    }
  );
}), ane = Wi().regex(/^[0-9-]+$/, { message: "半角数字で入力してください" }).max(8, { message: "8文字以内で入力してください" });
function lne(e) {
  const n = ane.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const sne = (e) => {
  const n = lne(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, rne = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), one = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = sne(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), dne = (e) => {
  const [n, i] = se(rne(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = one({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, cne = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = dne(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      isRequired: !0,
      label: "郵便番号",
      autoComplete: "postal-code",
      placeholder: "000-0000",
      value: (a = n.value) != null ? a : "",
      trackingField: "postal_code",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t
    }
  );
}), une = g((e) => {
  const { state: n } = Yee(e), { isFetching: i, fetchAddress: t } = BX(), a = !!e.postalCodeFieldContext.value, s = i || !a, r = async () => {
    var c;
    if (i) return;
    le(Pn({ target: "address.autofill" }));
    const o = (c = e.postalCodeFieldContext.value) != null ? c : "", d = await t(o);
    d && e.addressFieldContext.onChangeValueCallback(d);
  };
  return n.kind === "NotDisplayable" ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-10", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-gap-4", children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-w-1/2 ch-max-w-[50%]", children: /* @__PURE__ */ l.jsx(cne, { ...e.postalCodeFieldContext }) }),
      /* @__PURE__ */ l.jsx(
        ae,
        {
          disabled: s,
          size: "md",
          variant: "outline",
          type: "button",
          onClick: r,
          children: "住所自動入力"
        }
      )
    ] }),
    /* @__PURE__ */ l.jsx(tne, { ...e.addressFieldContext, disabled: i })
  ] });
}), mne = Wi().min(1, { message: "名を入力してください" });
function kne(e) {
  const n = mne.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const fne = (e) => {
  const n = kne(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, vne = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), hne = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = fne(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), pne = (e) => {
  const [n, i] = se(vne(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = hne({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, Nne = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = pne(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      isRequired: !0,
      label: "名",
      placeholder: "太郎",
      autoComplete: "given-name",
      value: (a = n.value) != null ? a : "",
      trackingField: "first_name",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t
    }
  );
}), Sne = Wi().optional().refine(
  (e) => !e || e.trim() === "" ? !0 : /^[\u30A1-\u30F6\u30FB-\u30FE\uFF66-\uFF9F]*$/.test(e),
  {
    message: "全角カナまたは半角カナで入力してください"
  }
);
function gne(e) {
  const n = Sne.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const Fne = (e) => {
  const n = gne(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, Ine = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), yne = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = Fne(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), bne = (e) => {
  const [n, i] = se(Ine(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = yne({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, Cne = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = bne(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      label: "名（カナ）",
      placeholder: "タロウ",
      autoComplete: "given-name",
      name: "given-name-phonetic",
      value: (a = n.value) != null ? a : "",
      trackingField: "first_name_kana",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t
    }
  );
}), xne = Wi().min(1, { message: "姓を入力してください" });
function Dne(e) {
  const n = xne.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const wne = (e) => {
  const n = Dne(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, Pne = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), Rne = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = wne(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), Tne = (e) => {
  const [n, i] = se(Pne(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = Rne({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, jne = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = Tne(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      isRequired: !0,
      label: "姓",
      placeholder: "山田",
      autoComplete: "family-name",
      value: (a = n.value) != null ? a : "",
      trackingField: "last_name",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t
    }
  );
}), Ane = Wi().optional().refine(
  (e) => !e || e.trim() === "" ? !0 : /^[\u30A1-\u30F6\u30FB-\u30FE\uFF66-\uFF9F]*$/.test(e),
  {
    message: "全角カナまたは半角カナで入力してください"
  }
);
function One(e) {
  const n = Ane.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const Ene = (e) => {
  const n = One(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, Jne = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), _ne = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = Ene(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), Qne = (e) => {
  const [n, i] = se(Jne(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = _ne({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, Mne = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = Qne(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      label: "姓（カナ）",
      placeholder: "ヤマダ",
      autoComplete: "family-name",
      name: "family-name-phonetic",
      value: (a = n.value) != null ? a : "",
      trackingField: "last_name_kana",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t
    }
  );
}), Lne = Wi().min(1, { message: "名前を入力してください" });
function $ne(e) {
  const n = Lne.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const Une = (e) => {
  const n = $ne(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, Vne = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), Hne = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = Une(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), zne = (e) => {
  const [n, i] = se(Vne(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = Hne({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, Bne = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = zne(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      isRequired: !0,
      label: "お名前",
      placeholder: "山田太郎",
      autoComplete: "name",
      value: (a = n.value) != null ? a : "",
      trackingField: "name",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t
    }
  );
}), qne = Wi().optional();
function Gne(e) {
  const n = qne.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const Wne = (e) => {
  const n = Gne(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, Kne = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), Yne = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = Wne(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), Xne = (e) => {
  const [n, i] = se(Kne(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = Yne({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, Zne = g((e) => {
  var t;
  const { state: n, onChangeValue: i } = Xne(e);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      label: "カナ",
      placeholder: "ヤマダタロウ",
      autoComplete: "name",
      name: "full-name-phonetic",
      value: (t = n.value) != null ? t : "",
      trackingField: "name_kana",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i
    }
  );
}), o9 = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black", children: "予約情報の入力" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-10", children: [
    e.displayMode === "split" ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-cols-2 ch-items-start ch-gap-4", children: [
        /* @__PURE__ */ l.jsx(jne, { ...e.lastNameContext }),
        /* @__PURE__ */ l.jsx(Nne, { ...e.firstNameContext })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-cols-2 ch-items-start ch-gap-4", children: [
        /* @__PURE__ */ l.jsx(Mne, { ...e.lastNameKanaContext }),
        /* @__PURE__ */ l.jsx(Cne, { ...e.firstNameKanaContext })
      ] })
    ] }) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(Bne, { ...e.nameContext }),
      /* @__PURE__ */ l.jsx(Zne, { ...e.nameKanaContext })
    ] }),
    /* @__PURE__ */ l.jsx(une, { ...e.addressContext })
  ] })
] })), eie = Wi().email().refine(
  (e) => {
    const n = e.split("@")[1];
    return n ? n.split(".").every((t) => t ? !t.endsWith("-") : !1) : !1;
  },
  {
    message: "ドメイン名の末尾にハイフンは使用できません"
  }
);
function nie(e) {
  const n = eie.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const iie = (e) => {
  const n = nie(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, tie = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), aie = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = iie(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), lie = (e) => {
  const [n, i] = se(tie(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = aie({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
};
var f7 = { exports: {} };
(function(e) {
  var n = {
    domainThreshold: 2,
    secondLevelThreshold: 2,
    topLevelThreshold: 2,
    defaultDomains: [
      "msn.com",
      "bellsouth.net",
      "telus.net",
      "comcast.net",
      "optusnet.com.au",
      "earthlink.net",
      "qq.com",
      "sky.com",
      "icloud.com",
      "mac.com",
      "sympatico.ca",
      "googlemail.com",
      "att.net",
      "xtra.co.nz",
      "web.de",
      "cox.net",
      "gmail.com",
      "ymail.com",
      "aim.com",
      "rogers.com",
      "verizon.net",
      "rocketmail.com",
      "google.com",
      "optonline.net",
      "sbcglobal.net",
      "aol.com",
      "me.com",
      "btinternet.com",
      "charter.net",
      "shaw.ca"
    ],
    defaultSecondLevelDomains: ["yahoo", "hotmail", "mail", "live", "outlook", "gmx"],
    defaultTopLevelDomains: [
      "com",
      "com.au",
      "com.tw",
      "ca",
      "co.nz",
      "co.uk",
      "de",
      "fr",
      "it",
      "ru",
      "net",
      "org",
      "edu",
      "gov",
      "jp",
      "nl",
      "kr",
      "se",
      "eu",
      "ie",
      "co.il",
      "us",
      "at",
      "be",
      "dk",
      "hk",
      "es",
      "gr",
      "ch",
      "no",
      "cz",
      "in",
      "net",
      "net.au",
      "info",
      "biz",
      "mil",
      "co.jp",
      "sg",
      "hu"
    ],
    run: function(i) {
      i.domains = i.domains || n.defaultDomains, i.secondLevelDomains = i.secondLevelDomains || n.defaultSecondLevelDomains, i.topLevelDomains = i.topLevelDomains || n.defaultTopLevelDomains, i.distanceFunction = i.distanceFunction || n.sift3Distance;
      var t = function(o) {
        return o;
      }, a = i.suggested || t, s = i.empty || t, r = n.suggest(n.encodeEmail(i.email), i.domains, i.secondLevelDomains, i.topLevelDomains, i.distanceFunction);
      return r ? a(r) : s();
    },
    suggest: function(i, t, a, s, r) {
      i = i.toLowerCase();
      var o = this.splitEmail(i);
      if (a && s && a.indexOf(o.secondLevelDomain) !== -1 && s.indexOf(o.topLevelDomain) !== -1)
        return !1;
      var d = this.findClosestDomain(o.domain, t, r, this.domainThreshold);
      if (d)
        return d == o.domain ? !1 : { address: o.address, domain: d, full: o.address + "@" + d };
      var c = this.findClosestDomain(o.secondLevelDomain, a, r, this.secondLevelThreshold), u = this.findClosestDomain(o.topLevelDomain, s, r, this.topLevelThreshold);
      if (o.domain) {
        var d = o.domain, k = !1;
        if (c && c != o.secondLevelDomain && (d = d.replace(o.secondLevelDomain, c), k = !0), u && u != o.topLevelDomain && (d = d.replace(o.topLevelDomain, u), k = !0), k == !0)
          return { address: o.address, domain: d, full: o.address + "@" + d };
      }
      return !1;
    },
    findClosestDomain: function(i, t, a, s) {
      s = s || this.topLevelThreshold;
      var r, o = 99, d = null;
      if (!i || !t)
        return !1;
      a || (a = this.sift3Distance);
      for (var c = 0; c < t.length; c++) {
        if (i === t[c])
          return i;
        r = a(i, t[c]), r < o && (o = r, d = t[c]);
      }
      return o <= s && d !== null ? d : !1;
    },
    sift3Distance: function(i, t) {
      if (i == null || i.length === 0)
        return t == null || t.length === 0 ? 0 : t.length;
      if (t == null || t.length === 0)
        return i.length;
      for (var a = 0, s = 0, r = 0, o = 0, d = 5; a + s < i.length && a + r < t.length; ) {
        if (i.charAt(a + s) == t.charAt(a + r))
          o++;
        else {
          s = 0, r = 0;
          for (var c = 0; c < d; c++) {
            if (a + c < i.length && i.charAt(a + c) == t.charAt(a)) {
              s = c;
              break;
            }
            if (a + c < t.length && i.charAt(a) == t.charAt(a + c)) {
              r = c;
              break;
            }
          }
        }
        a++;
      }
      return (i.length + t.length) / 2 - o;
    },
    splitEmail: function(i) {
      var t = i.trim().split("@");
      if (t.length < 2)
        return !1;
      for (var a = 0; a < t.length; a++)
        if (t[a] === "")
          return !1;
      var s = t.pop(), r = s.split("."), o = "", d = "";
      if (r.length == 0)
        return !1;
      if (r.length == 1)
        d = r[0];
      else {
        o = r[0];
        for (var a = 1; a < r.length; a++)
          d += r[a] + ".";
        d = d.substring(0, d.length - 1);
      }
      return {
        topLevelDomain: d,
        secondLevelDomain: o,
        domain: s,
        address: t.join("@")
      };
    },
    // Encode the email address to prevent XSS but leave in valid
    // characters, following this official spec:
    // http://en.wikipedia.org/wiki/Email_address#Syntax
    encodeEmail: function(i) {
      var t = encodeURI(i);
      return t = t.replace("%20", " ").replace("%25", "%").replace("%5E", "^").replace("%60", "`").replace("%7B", "{").replace("%7C", "|").replace("%7D", "}"), t;
    }
  };
  e.exports && (e.exports = n), typeof window != "undefined" && window.jQuery && function(i) {
    i.fn.mailcheck = function(t) {
      var a = this;
      if (t.suggested) {
        var s = t.suggested;
        t.suggested = function(o) {
          s(a, o);
        };
      }
      if (t.empty) {
        var r = t.empty;
        t.empty = function() {
          r.call(null, a);
        };
      }
      t.email = this.val(), n.run(t);
    };
  }(jQuery);
})(f7);
var v7 = f7.exports;
const sie = {
  // gmail.com タイポ
  "mail.com": "gmail.com",
  "mail.co": "gmail.com",
  // Sift3距離が閾値ちょうどのため明示的に追加
  "mai.com": "gmail.com",
  // mailcheckだと mac.com をサジェストしてしまうため
  "gail.com": "gmail.com",
  "gmial.com": "gmail.com",
  "gmaill.com": "gmail.com",
  "gmail.co": "gmail.com",
  "gmail.cm": "gmail.com",
  // yahoo タイポ
  "yaho.co.jp": "yahoo.co.jp",
  "yahooo.co.jp": "yahoo.co.jp",
  "yaho.com": "yahoo.com",
  "yahooo.com": "yahoo.com",
  // outlook タイポ
  "outloo.com": "outlook.com",
  "outlok.com": "outlook.com",
  // hotmail タイポ
  "hotmal.com": "hotmail.com",
  "hotmai.com": "hotmail.com",
  // icloud タイポ
  "iclod.com": "icloud.com",
  "icloud.co": "icloud.com",
  // docomo タイポ
  "docomo.jp": "docomo.ne.jp",
  "docomo.co.jp": "docomo.ne.jp",
  "dokomo.ne.jp": "docomo.ne.jp",
  "docmo.ne.jp": "docomo.ne.jp",
  // au タイポ
  "au.co.jp": "au.com",
  "au.ne.jp": "au.com",
  // ezweb タイポ
  "ezweb.jp": "ezweb.ne.jp",
  "ezweb.co.jp": "ezweb.ne.jp",
  // softbank タイポ
  "softbank.jp": "softbank.ne.jp",
  "softbank.co.jp": "softbank.ne.jp",
  "i.softbank.ne.jp": "i.softbank.jp"
}, rie = [
  // gmail.com タイポプレフィックス
  ["mail.", "gmail.com"],
  ["mai.", "gmail.com"],
  ["gmail.", "gmail.com"],
  ["gmai.", "gmail.com"],
  ["gail.", "gmail.com"],
  ["gmial.", "gmail.com"],
  ["gmaill.", "gmail.com"],
  ["gnail.", "gmail.com"],
  ["gmal.", "gmail.com"],
  ["gamil.", "gmail.com"],
  // hotmail.com タイポプレフィックス
  ["hotmail.", "hotmail.com"],
  ["hotmal.", "hotmail.com"],
  ["hotmai.", "hotmail.com"],
  // outlook.com タイポプレフィックス
  ["outlook.", "outlook.com"],
  ["outloo.", "outlook.com"],
  ["outlok.", "outlook.com"],
  // icloud.com タイポプレフィックス
  ["icloud.", "icloud.com"],
  ["iclod.", "icloud.com"],
  // キャリア
  ["docomo.", "docomo.ne.jp"],
  ["dokomo.", "docomo.ne.jp"],
  ["i.softbank.", "i.softbank.jp"],
  ["softbank.", "softbank.ne.jp"],
  ["ezweb.", "ezweb.ne.jp"]
], oie = (e) => {
  const n = e.indexOf("@");
  if (n === -1)
    return null;
  const i = e.substring(0, n), t = e.substring(n + 1).toLowerCase(), a = sie[t];
  if (a)
    return `${i}@${a}`;
  for (const [s, r] of rie)
    if (t.startsWith(s) && t !== r)
      return `${i}@${r}`;
  return null;
}, die = [
  // 一般的なメールプロバイダー
  "gmail.com",
  "yahoo.co.jp",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "live.jp",
  // 日本のプロバイダー
  "nifty.com",
  "biglobe.ne.jp",
  "so-net.ne.jp",
  "ocn.ne.jp",
  "plala.or.jp",
  "goo.ne.jp",
  "rakuten.jp",
  // キャリアメール
  "docomo.ne.jp",
  "au.com",
  "ezweb.ne.jp",
  "softbank.ne.jp",
  "i.softbank.jp",
  // その他
  "icloud.com",
  "mac.com",
  "me.com"
], d9 = [
  "co.jp",
  //
  "ne.jp",
  "or.jp",
  "com",
  "net",
  "org"
], cie = g(({ email: e, onClickSuggestion: n }) => {
  const [i, t] = se(null), a = I(() => {
    i && n(i);
  }, [n, i]);
  return be(() => {
    if (!e || e.trim() === "") {
      t(null);
      return;
    }
    const s = oie(e);
    if (s) {
      t(s);
      return;
    }
    v7.run({
      email: e,
      domains: die,
      secondLevelDomains: [],
      // mailcheck内部のSLDバイパスを無効化（"mail" 等を「正しいドメイン」と判定させない）
      topLevelDomains: d9,
      suggested: (r) => {
        if (r.full === e) {
          t(null);
          return;
        }
        if (d9.includes(r.domain)) {
          t(null);
          return;
        }
        t(r.full);
      },
      empty: () => {
        t(null);
      }
    });
  }, [e]), i ? /* @__PURE__ */ l.jsxs("div", { className: "ch-mt-2 ch-space-y-3 ch-rounded-md ch-border ch-border-yellow-400 ch-bg-yellow-50 ch-p-3", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-blue-800 ch-mb-2 ch-text-sm ch-font-semibold", children: "入力内容にお間違いはありませんか？" }),
    /* @__PURE__ */ l.jsxs("div", { children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: "選択すると自動で修正されます" }),
      /* @__PURE__ */ l.jsx("div", { className: "ch-p-2", children: /* @__PURE__ */ l.jsx(
        ae,
        {
          type: "button",
          variant: "underline",
          size: "md",
          className: "!ch-p-0",
          onClick: a,
          children: i
        }
      ) })
    ] })
  ] }) : null;
}), uie = (e) => P(e.email) || Ke(e.email) ? {
  kind: "NotDisplayable"
} : {
  kind: "Displayable",
  email: e.email
}, mie = (e) => ({
  state: v(() => uie(e), [e])
}), kie = ({ ...e }) => {
  const { state: n } = mie(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-[3px]", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: "no-reply@chillnn.com からのメールが受信できるよう、ドメイン指定受信の設定をお願いします。" }) }) : null;
}, fie = g((e) => {
  var r;
  const { state: n, onChangeValue: i } = lie(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]), a = I(
    (o) => {
      i(o);
    },
    [i]
  ), s = I(
    (o) => {
      le(Pn({ target: "email.suggestion" })), i(o);
    },
    [i]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
    /* @__PURE__ */ l.jsxs("div", { children: [
      /* @__PURE__ */ l.jsx(
        st,
        {
          isRequired: !0,
          type: "email",
          inputMode: "email",
          autoComplete: "email",
          label: "メールアドレス",
          placeholder: "taro.yamada@chillnn.com",
          value: (r = n.value) != null ? r : "",
          trackingField: "email",
          isTrackingValid: n.kind === "Validated",
          onChangeCallback: a,
          errorMessage: t
        }
      ),
      /* @__PURE__ */ l.jsx(cie, { email: n.value, onClickSuggestion: s })
    ] }),
    /* @__PURE__ */ l.jsx(kie, { email: n.value })
  ] });
}), vie = Wi().min(1, { message: "電話番号を入力してください" }).regex(/^[0-9+]+$/, { message: "半角数字で入力してください" }).refine(
  (e) => {
    const n = e.replace(/[^0-9]/g, "");
    return e.startsWith("+") ? n.length >= 12 : n.length === 10 || n.length === 11;
  },
  { message: "正しい電話番号の形式で入力してください" }
);
function hie(e) {
  const n = vie.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const pie = (e) => {
  const n = hie(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, Nie = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), Sie = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = pie(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), gie = (e) => {
  const [n, i] = se(Nie(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = Sie({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, Fie = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = gie(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      isRequired: !0,
      label: "電話番号",
      value: (a = n.value) != null ? a : "",
      trackingField: "tel",
      isTrackingValid: n.kind === "Validated",
      autoComplete: "tel",
      placeholder: "09012345678",
      inputMode: "tel",
      onChangeCallback: i,
      errorMessage: t,
      type: "tel"
    }
  );
}), Iie = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black", children: "連絡先の入力" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-10", children: [
    /* @__PURE__ */ l.jsx(Fie, { ...e.telContext }),
    /* @__PURE__ */ l.jsx(fie, { ...e.emailContext })
  ] })
] })), yie = g((e) => {
  var i, t, a, s, r, o, d, c, u, k, m, f;
  const n = Wee(e);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8 ch-bg-white ch-px-5 ch-py-8", children: [
    n.displayMode === "split" ? /* @__PURE__ */ l.jsx(
      o9,
      {
        displayMode: "split",
        firstNameContext: {
          value: (i = n.currentGuestInfo) == null ? void 0 : i.firstName,
          onChangeValueCallback: n.onChangeFirstName
        },
        lastNameContext: {
          value: (t = n.currentGuestInfo) == null ? void 0 : t.lastName,
          onChangeValueCallback: n.onChangeLastName
        },
        firstNameKanaContext: {
          value: (a = n.currentGuestInfo) == null ? void 0 : a.firstNameKana,
          onChangeValueCallback: n.onChangeFirstNameKana
        },
        lastNameKanaContext: {
          value: (s = n.currentGuestInfo) == null ? void 0 : s.lastNameKana,
          onChangeValueCallback: n.onChangeLastNameKana
        },
        addressContext: {
          ...e,
          postalCodeFieldContext: {
            value: (r = n.currentGuestInfo) == null ? void 0 : r.postalCode,
            onChangeValueCallback: n.onChangePostalCode
          },
          addressFieldContext: {
            value: (o = n.currentGuestInfo) == null ? void 0 : o.address,
            onChangeValueCallback: n.onChangeAddress
          }
        }
      }
    ) : /* @__PURE__ */ l.jsx(
      o9,
      {
        displayMode: "single",
        nameContext: {
          value: (d = n.currentGuestInfo) == null ? void 0 : d.name,
          onChangeValueCallback: n.onChangeName
        },
        nameKanaContext: {
          value: (c = n.currentGuestInfo) == null ? void 0 : c.nameKana,
          onChangeValueCallback: n.onChangeNameKana
        },
        addressContext: {
          ...e,
          postalCodeFieldContext: {
            value: (u = n.currentGuestInfo) == null ? void 0 : u.postalCode,
            onChangeValueCallback: n.onChangePostalCode
          },
          addressFieldContext: {
            value: (k = n.currentGuestInfo) == null ? void 0 : k.address,
            onChangeValueCallback: n.onChangeAddress
          }
        }
      }
    ),
    /* @__PURE__ */ l.jsx("div", { className: "ch-border-t" }),
    /* @__PURE__ */ l.jsx(
      Iie,
      {
        emailContext: {
          value: (m = n.currentGuestInfo) == null ? void 0 : m.email,
          onChangeValueCallback: n.onChangeEmail
        },
        telContext: {
          value: (f = n.currentGuestInfo) == null ? void 0 : f.tel,
          onChangeValueCallback: n.onChangeTel
        }
      }
    )
  ] });
}), bie = (e) => (n) => P(n) || Ke(n) ? {
  ...e,
  kind: "Changed",
  address: {
    kind: "AddressInValidated",
    value: n
  }
} : {
  ...e,
  kind: "Changed",
  address: {
    kind: "AddressValidated",
    value: n
  }
}, Cie = (e) => (n) => P(n) || Ke(n) ? {
  ...e,
  kind: "Changed",
  email: {
    kind: "EmailInValidated",
    value: n
  }
} : {
  ...e,
  kind: "Changed",
  email: {
    kind: "EmailValidated",
    value: n
  }
}, xie = (e) => (n) => P(n) || Ke(n) ? {
  ...e,
  kind: "Changed",
  firstName: { kind: "FirstNameInValidated", value: n }
} : {
  ...e,
  kind: "Changed",
  firstName: { kind: "FirstNameValidated", value: n }
}, Die = (e) => {
  const { guestInfo: n } = e.sessionStateContext.currentState, i = n;
  return (i == null ? void 0 : i.firstName) !== void 0 || (i == null || i.lastName), e.sessionStateContext.reservationPolicy.isAddressInputRequired ? {
    kind: "Initialized",
    firstName: {
      kind: "FirstNameInValidated",
      value: i == null ? void 0 : i.firstName
    },
    lastName: {
      kind: "LastNameInValidated",
      value: i == null ? void 0 : i.lastName
    },
    postalCode: {
      kind: "PostalCodeInValidated",
      value: n == null ? void 0 : n.postalCode
    },
    address: {
      kind: "AddressInValidated",
      value: n == null ? void 0 : n.address
    },
    tel: {
      kind: "TelInValidated",
      value: n == null ? void 0 : n.tel
    },
    email: {
      kind: "EmailInValidated",
      value: n == null ? void 0 : n.email
    }
  } : {
    kind: "Initialized",
    firstName: {
      kind: "FirstNameInValidated",
      value: i == null ? void 0 : i.firstName
    },
    lastName: {
      kind: "LastNameInValidated",
      value: i == null ? void 0 : i.lastName
    },
    postalCode: {
      kind: "PostalCodeValidated",
      value: ""
    },
    address: {
      kind: "AddressValidated",
      value: ""
    },
    tel: {
      kind: "TelInValidated",
      value: n == null ? void 0 : n.tel
    },
    email: {
      kind: "EmailInValidated",
      value: n == null ? void 0 : n.email
    }
  };
}, wie = (e) => (n) => P(n) || Ke(n) ? {
  ...e,
  kind: "Changed",
  lastName: { kind: "LastNameInValidated", value: n }
} : {
  ...e,
  kind: "Changed",
  lastName: { kind: "LastNameValidated", value: n }
}, Pie = (e) => (n) => ({
  ...e,
  kind: "Changed",
  postalCode: {
    kind: "PostalCodeValidated",
    value: n != null ? n : ""
  }
}), Rie = (e) => (n) => P(n) || Ke(n) ? {
  ...e,
  kind: "Changed",
  tel: {
    kind: "TelInValidated",
    value: n
  }
} : {
  ...e,
  kind: "Changed",
  tel: {
    kind: "TelValidated",
    value: n
  }
}, Tie = (e) => {
  const n = I(
    (o) => {
      const d = xie(e.state)(o);
      e.onChangeState(d);
    },
    [e]
  ), i = I(
    (o) => {
      const d = wie(e.state)(o);
      e.onChangeState(d);
    },
    [e]
  ), t = I(
    (o) => {
      const d = bie(e.state)(o);
      e.onChangeState(d);
    },
    [e]
  ), a = I(
    (o) => {
      const d = Cie(e.state)(o);
      e.onChangeState(d);
    },
    [e]
  ), s = I(
    (o) => {
      const d = Pie(e.state)(o);
      e.onChangeState(d);
    },
    [e]
  ), r = I(
    (o) => {
      const d = Rie(e.state)(o);
      e.onChangeState(d);
    },
    [e]
  );
  return {
    onChangeFirstName: n,
    onChangeLastName: i,
    onChangeAddress: t,
    onChangeEmail: a,
    onChangePostalCode: s,
    onChangeTel: r
  };
}, jie = (e) => {
  const n = I((r) => ({
    firstName: r.firstName.value,
    lastName: r.lastName.value,
    postalCode: r.postalCode.value,
    address: r.address.value,
    tel: r.tel.value,
    email: r.email.value
  }), []), i = I(
    (r, o) => {
      const d = JSON.stringify(r), c = JSON.stringify(o);
      return d === c;
    },
    []
  ), { onHideLoadingScreenCallback: t, onShowLoadingScreenCallback: a } = fn(), s = Ye(void 0);
  be(() => {
    const r = n(e.state);
    if (P(s.current) && !P(r)) {
      s.current = r;
      return;
    }
    if (i(s.current, r))
      return;
    s.current = r;
    const c = setTimeout(async () => {
      a(), await e.onUpdateGuestInfo(r).finally(() => {
        t();
      });
    }, 1e3);
    return () => {
      clearTimeout(c);
    };
  }, [n, i, t, a, e]);
}, Aie = (e) => {
  const [n, i] = se(Die(e)), t = I((s) => {
    i(s);
  }, []);
  jie({ state: n, ...e });
  const a = Tie({ state: n, onChangeState: t, ...e });
  return {
    currentGuestInfo: {
      firstName: n.firstName.value,
      lastName: n.lastName.value,
      postalCode: n.postalCode.value,
      address: n.address.value,
      tel: n.tel.value,
      email: n.email.value
    },
    onChangeFirstName: a.onChangeFirstName,
    onChangeLastName: a.onChangeLastName,
    onChangeAddress: a.onChangeAddress,
    onChangeEmail: a.onChangeEmail,
    onChangePostalCode: a.onChangePostalCode,
    onChangeTel: a.onChangeTel
  };
}, Oie = (e) => e.sessionStateContext.reservationPolicy.isAddressInputRequired ? {
  kind: "Displayable"
} : {
  kind: "NotDisplayable"
}, Eie = (e) => ({
  state: v(() => Oie(e), [e])
}), Jie = Wi().min(1, { message: "Country is required." });
function _ie(e) {
  const n = Jie.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const Qie = (e) => {
  const n = _ie(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, Mie = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), Lie = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = Qie(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), $ie = (e) => {
  const [n, i] = se(Mie(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = Lie({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, Uie = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = $ie(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      isRequired: !0,
      label: "Address",
      placeholder: "721-1 Higashi-shiokoji-cho, Shimogyo-ku, Kyoto-shi, Kyoto Japan",
      autoComplete: "off",
      value: (a = n.value) != null ? a : "",
      trackingField: "address",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t
    }
  );
}), Vie = Wi().optional();
function Hie(e) {
  const n = Vie.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const zie = (e) => {
  const n = Hie(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, Bie = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), qie = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = zie(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), Gie = (e) => {
  const [n, i] = se(Bie(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = qie({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, Wie = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = Gie(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      label: "ZIP / Postal Code",
      autoComplete: "postal-code",
      value: (a = n.value) != null ? a : "",
      trackingField: "postal_code",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t
    }
  );
}), Kie = g((e) => {
  const { state: n } = Eie(e);
  return n.kind === "NotDisplayable" ? null : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(Uie, { ...e.addressContext }),
    /* @__PURE__ */ l.jsx(Wie, { ...e.postalCodeContext })
  ] });
}), Yie = Wi().min(1, { message: "Please enter your first name" });
function Xie(e) {
  const n = Yie.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const Zie = (e) => {
  const n = Xie(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, ete = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), nte = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = Zie(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), ite = (e) => {
  const [n, i] = se(ete(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = nte({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, tte = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = ite(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      isRequired: !0,
      label: "First Name",
      placeholder: "John",
      autoComplete: "given-name",
      value: (a = n.value) != null ? a : "",
      trackingField: "first_name",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t
    }
  );
}), ate = Wi().min(1, { message: "Please enter your last name" });
function lte(e) {
  const n = ate.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const ste = (e) => {
  const n = lte(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, rte = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), ote = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = ste(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), dte = (e) => {
  const [n, i] = se(rte(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = ote({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, cte = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = dte(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      isRequired: !0,
      label: "Last Name",
      placeholder: "Doe",
      autoComplete: "family-name",
      value: (a = n.value) != null ? a : "",
      trackingField: "last_name",
      isTrackingValid: n.kind === "Validated",
      onChangeCallback: i,
      errorMessage: t
    }
  );
}), ute = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black", children: "Enter reservation information" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-10", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-cols-2 ch-items-start ch-gap-4", children: [
      /* @__PURE__ */ l.jsx(tte, { ...e.firstNameContext }),
      /* @__PURE__ */ l.jsx(cte, { ...e.lastNameContext })
    ] }),
    /* @__PURE__ */ l.jsx(Kie, { ...e.addressContext })
  ] })
] })), mte = Wi().email().refine(
  (e) => {
    const n = e.split("@")[1];
    return n ? n.split(".").every((t) => t ? !t.endsWith("-") : !1) : !1;
  },
  {
    message: "Hyphens cannot be used at the end of domain names"
  }
);
function kte(e) {
  const n = mte.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const fte = (e) => {
  const n = kte(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, vte = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), hte = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = fte(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), pte = (e) => {
  const [n, i] = se(vte(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = hte({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, Nte = {
  // gmail.com タイポ
  "mail.com": "gmail.com",
  "mail.co": "gmail.com",
  // Sift3距離が閾値ちょうどのため明示的に追加
  "mai.com": "gmail.com",
  // mailcheckだと mac.com をサジェストしてしまうため
  "gail.com": "gmail.com",
  "gmial.com": "gmail.com",
  "gmaill.com": "gmail.com",
  "gmail.co": "gmail.com",
  "gmail.cm": "gmail.com",
  // yahoo タイポ
  "yaho.com": "yahoo.com",
  "yahooo.com": "yahoo.com",
  // outlook タイポ
  "outloo.com": "outlook.com",
  "outlok.com": "outlook.com",
  // hotmail タイポ
  "hotmal.com": "hotmail.com",
  "hotmai.com": "hotmail.com",
  // icloud タイポ
  "iclod.com": "icloud.com",
  "icloud.co": "icloud.com"
}, Ste = [
  // gmail.com タイポプレフィックス
  ["mail.", "gmail.com"],
  ["mai.", "gmail.com"],
  ["gmail.", "gmail.com"],
  ["gmai.", "gmail.com"],
  ["gail.", "gmail.com"],
  ["gmial.", "gmail.com"],
  ["gmaill.", "gmail.com"],
  ["gnail.", "gmail.com"],
  ["gmal.", "gmail.com"],
  ["gamil.", "gmail.com"],
  // hotmail.com タイポプレフィックス
  ["hotmail.", "hotmail.com"],
  ["hotmal.", "hotmail.com"],
  ["hotmai.", "hotmail.com"],
  // outlook.com タイポプレフィックス
  ["outlook.", "outlook.com"],
  ["outloo.", "outlook.com"],
  ["outlok.", "outlook.com"],
  // icloud.com タイポプレフィックス
  ["icloud.", "icloud.com"],
  ["iclod.", "icloud.com"]
], gte = (e) => {
  const n = e.indexOf("@");
  if (n === -1)
    return null;
  const i = e.substring(0, n), t = e.substring(n + 1).toLowerCase(), a = Nte[t];
  if (a)
    return `${i}@${a}`;
  for (const [s, r] of Ste)
    if (t.startsWith(s) && t !== r)
      return `${i}@${r}`;
  return null;
}, Fte = [
  // Major email providers
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "aol.com",
  // Other popular domains
  "icloud.com",
  "me.com",
  "protonmail.com",
  "yandex.com",
  "zoho.com",
  "fastmail.com"
], c9 = [
  "com",
  //
  "net",
  "org",
  "edu",
  "gov",
  "co.uk",
  "ca",
  "au"
], Ite = g(({ email: e, onClickSuggestion: n }) => {
  const [i, t] = se(null), a = I(() => {
    i && n(i);
  }, [n, i]);
  return be(() => {
    if (!e || e.trim() === "") {
      t(null);
      return;
    }
    const s = gte(e);
    if (s) {
      t(s);
      return;
    }
    v7.run({
      email: e,
      domains: Fte,
      secondLevelDomains: [],
      // mailcheck内部のSLDバイパスを無効化（"mail" 等を「正しいドメイン」と判定させない）
      topLevelDomains: c9,
      suggested: (r) => {
        if (r.full === e) {
          t(null);
          return;
        }
        if (c9.includes(r.domain)) {
          t(null);
          return;
        }
        t(r.full);
      },
      empty: () => {
        t(null);
      }
    });
  }, [e]), i ? /* @__PURE__ */ l.jsxs("div", { className: "ch-mt-2 ch-space-y-3 ch-rounded-md ch-border ch-border-yellow-400 ch-bg-yellow-50 ch-p-3", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-blue-800 ch-mb-2 ch-text-sm ch-font-semibold", children: "Please confirm that your email address is correct." }),
    /* @__PURE__ */ l.jsxs("div", { children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: "Select to automatically correct" }),
      /* @__PURE__ */ l.jsx("div", { className: "ch-p-2", children: /* @__PURE__ */ l.jsx(
        ae,
        {
          type: "button",
          variant: "underline",
          size: "md",
          className: "!ch-p-0",
          onClick: a,
          children: i
        }
      ) })
    ] })
  ] }) : null;
}), yte = (e) => P(e.email) || Ke(e.email) ? {
  kind: "NotDisplayable"
} : {
  kind: "Displayable",
  email: e.email
}, bte = (e) => ({
  state: v(() => yte(e), [e])
}), Cte = ({ ...e }) => {
  const { state: n } = bte(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-[3px]", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: "Please set up your domain name preferences so that you can receive emails from no-reply@chillnn.com." }) }) : null;
}, xte = g((e) => {
  var r, o;
  const { state: n, onChangeValue: i } = pte(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]), a = I(
    (d) => {
      i(d);
    },
    [i]
  ), s = I(
    (d) => {
      le(Pn({ target: "email.suggestion" })), i(d);
    },
    [i]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
    /* @__PURE__ */ l.jsxs("div", { children: [
      /* @__PURE__ */ l.jsx(
        st,
        {
          isRequired: !0,
          type: "email",
          inputMode: "email",
          autoComplete: "email",
          label: "Email",
          placeholder: "john.doe@chillnn.com",
          value: (r = n.value) != null ? r : "",
          trackingField: "email",
          isTrackingValid: n.kind === "Validated",
          onChangeCallback: a,
          errorMessage: t
        }
      ),
      /* @__PURE__ */ l.jsx(Ite, { email: (o = n.value) != null ? o : "", onClickSuggestion: s })
    ] }),
    /* @__PURE__ */ l.jsx(Cte, { email: n.value })
  ] });
}), Dte = Wi().min(1, { message: "Phone Number is required." }).regex(/^[0-9+]+$/, { message: "Please use single-byte numbers." }).refine(
  (e) => {
    const n = e.replace(/[^0-9]/g, "");
    return e.startsWith("+") ? n.length >= 9 : n.length >= 7;
  },
  { message: "Please enter a valid phone number format." }
);
function wte(e) {
  const n = Dte.safeParse(e);
  if (!P(n.error) && !ke(n.error.errors))
    return {
      message: n.error.errors[0].message
    };
}
const Pte = (e) => {
  const n = wte(e);
  return P(n) ? {
    kind: "Validated",
    value: e != null ? e : ""
  } : {
    kind: "InValidated",
    value: e,
    errorMessage: n.message
  };
}, Rte = (e) => ({
  kind: "NotYetValidated",
  value: e.value
}), Tte = (e) => ({
  onChangeValue: I(
    (i) => {
      const t = Pte(i);
      e.onChangeState(t), e.onChangeValueCallback(i);
    },
    [e]
  )
}), jte = (e) => {
  const [n, i] = se(Rte(e)), t = I((s) => {
    i(s);
  }, []), { onChangeValue: a } = Tte({ onChangeState: t, ...e });
  return {
    state: n,
    onChangeValue: a
  };
}, Ate = g((e) => {
  var a;
  const { state: n, onChangeValue: i } = jte(e), t = v(() => {
    if (n.kind === "InValidated")
      return n.errorMessage;
  }, [n]);
  return /* @__PURE__ */ l.jsx(
    st,
    {
      isRequired: !0,
      label: "Phone Number",
      value: (a = n.value) != null ? a : "",
      trackingField: "tel",
      isTrackingValid: n.kind === "Validated",
      autoComplete: "tel",
      placeholder: "09012345678",
      inputMode: "tel",
      onChangeCallback: i,
      errorMessage: t,
      type: "tel"
    }
  );
}), Ote = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black", children: "Enter contact information" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-10", children: [
    /* @__PURE__ */ l.jsx(Ate, { ...e.telContext }),
    /* @__PURE__ */ l.jsx(xte, { ...e.emailContext })
  ] })
] })), Ete = g((e) => {
  const {
    currentGuestInfo: n,
    onChangeAddress: i,
    onChangeEmail: t,
    onChangeFirstName: a,
    onChangeLastName: s,
    onChangePostalCode: r,
    onChangeTel: o
  } = Aie(e);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8 ch-bg-white ch-px-5 ch-py-8", children: [
    /* @__PURE__ */ l.jsx(
      ute,
      {
        firstNameContext: {
          value: n == null ? void 0 : n.firstName,
          onChangeValueCallback: a
        },
        lastNameContext: {
          value: n == null ? void 0 : n.lastName,
          onChangeValueCallback: s
        },
        addressContext: {
          ...e,
          postalCodeContext: {
            value: n == null ? void 0 : n.postalCode,
            onChangeValueCallback: r
          },
          addressContext: {
            value: n == null ? void 0 : n.address,
            onChangeValueCallback: i
          }
        }
      }
    ),
    /* @__PURE__ */ l.jsx("div", { className: "ch-border-t" }),
    /* @__PURE__ */ l.jsx(
      Ote,
      {
        emailContext: {
          value: n == null ? void 0 : n.email,
          onChangeValueCallback: t
        },
        telContext: {
          value: n == null ? void 0 : n.tel,
          onChangeValueCallback: o
        }
      }
    )
  ] });
}), Jte = g((e) => {
  const { state: n } = Eee(e);
  if (n.kind === "LangForDefaultDisplayable")
    return /* @__PURE__ */ l.jsx(yie, { ...e });
  if (n.kind === "LangForEnDisplayable")
    return /* @__PURE__ */ l.jsx(Ete, { ...e });
}), h7 = g(({ sessionStateContext: e }) => {
  const { onUpdateGuestInfo: n } = Aee();
  return /* @__PURE__ */ l.jsx(Jte, { sessionStateContext: e, onUpdateGuestInfo: n });
}), _te = (e) => e.currentPaymentMethod === pn.Free ? {
  kind: "Clickable",
  lang: e.sessionStateContext.lang,
  isRequestReservation: e.sessionStateContext.reservationPolicy.isRequestReservation,
  onSubmitCallback: e.onReserveWithFreePayment,
  onErrorCallback: e.onClearPaymentMethod
} : e.currentPaymentMethod === pn.Local ? {
  kind: "Clickable",
  lang: e.sessionStateContext.lang,
  isRequestReservation: e.sessionStateContext.reservationPolicy.isRequestReservation,
  onSubmitCallback: e.onReserveWithLocalPayment,
  onErrorCallback: e.onClearPaymentMethod
} : e.currentPaymentMethod === pn.CreditCardContinuedUse ? {
  kind: "Clickable",
  isRequestReservation: e.sessionStateContext.reservationPolicy.isRequestReservation,
  lang: e.sessionStateContext.lang,
  onSubmitCallback: e.onReserveWithCreditContinuedUse,
  onErrorCallback: e.onClearPaymentMethod
} : e.currentPaymentMethod === pn.CreditCardNewlyRegistration ? {
  kind: "NotDisplayable"
} : {
  kind: "NotClickable",
  lang: e.sessionStateContext.lang,
  isRequestReservation: e.sessionStateContext.reservationPolicy.isRequestReservation
}, Qte = (e) => ({
  state: v(() => _te(e), [e])
}), Mte = g((e) => {
  const { state: n } = Qte(e), { reservationCart: i } = Va(), { baseInfoInput: t } = lt(), { onHideLoadingScreenCallback: a, onShowLoadingScreenCallback: s } = fn(), { onEnableBeforeUnload: r, onDisableBeforeUnload: o } = gd(), d = I(
    (k) => {
      if (n.kind === "Clickable") {
        k.currentTarget.disabled = !0;
        const m = (() => {
          switch (e.currentPaymentMethod) {
            case pn.CreditCardNewlyRegistration:
            case pn.CreditCardContinuedUse:
              return "credit_card";
            case pn.Free:
              return "free";
            case pn.Local:
              return "local";
            default:
              return "unknown";
          }
        })();
        le(
          zv({
            payment_method: m
          })
        ), Gv(i, m).forEach(bt), o(), s(), n.onSubmitCallback().then(() => {
          le(
            yn({
              target: "reserve",
              action: "submit",
              ok: !0
            })
          );
        }).catch((f) => {
          r(), n.onErrorCallback(), le(
            yn({
              target: "reserve",
              action: "submit",
              ok: !1,
              error_code: k1(f)
            })
          ), le(
            bu({ ...ct(t), reason: "reserve_request" })
          );
        }).finally(() => {
          a();
        });
      }
    },
    [
      t,
      o,
      r,
      a,
      s,
      e.currentPaymentMethod,
      i,
      n
    ]
  ), c = v(() => {
    if (n.kind !== "NotDisplayable")
      if (n.isRequestReservation)
        switch (n.lang) {
          case D.Default:
            return "予約を申請する";
          case D.En:
            return "Request reservation";
          default:
            return "";
        }
      else
        switch (n.lang) {
          case D.Default:
            return "予約する";
          case D.En:
            return "Reserve";
          default:
            return "";
        }
  }, [n]), u = v(() => n.kind === "NotClickable", [n.kind]);
  return n.kind === "NotDisplayable" ? null : /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", disabled: u, onClick: d, children: c });
}), Lte = () => {
  const [e, n] = se(void 0), i = I(() => {
    n(void 0);
  }, []), t = I(
    (a) => {
      n(a), le(
        yn({
          target: "payment_method",
          action: "update",
          payment_method: a.toLowerCase()
        })
      );
    },
    []
  );
  return {
    currentPaymentMethod: e,
    onClearPaymentMethod: i,
    onChangePaymentMethod: t
  };
}, Bd = g(({ triggerSlotContext: e, activeSlot: n, active: i }) => /* @__PURE__ */ l.jsxs(
  "div",
  {
    className: ce(
      "ch-space-y-6 ch-rounded-md ch-border ch-px-4 ch-py-6",
      i ? "ch-border-black" : "ch-border-gray-200"
    ),
    children: [
      /* @__PURE__ */ l.jsxs(
        Qn,
        {
          htmlFor: e.htmlFor,
          className: "ch-flex ch-cursor-pointer ch-items-center ch-gap-x-2",
          children: [
            e.radioGroupItemSlot,
            e.labelText
          ]
        }
      ),
      i ? n : null
    ]
  }
)), $te = g(({ sessionStateContext: e, currentPaymentMethod: n }) => {
  const i = v(() => n === pn.CreditCardContinuedUse, [n]), t = v(() => kn({
    lang: e.lang,
    i18nString: {
      default: "前回のクレジットカードを利用",
      en: "Use the same credit card as last time"
    }
  }), [e.lang]);
  return /* @__PURE__ */ l.jsx(
    Bd,
    {
      triggerSlotContext: {
        htmlFor: pn.CreditCardContinuedUse,
        labelText: t,
        radioGroupItemSlot: /* @__PURE__ */ l.jsx(
          i1,
          {
            value: pn.CreditCardContinuedUse,
            checked: i,
            id: pn.CreditCardContinuedUse
          }
        )
      },
      active: i
    }
  );
}), Ute = g((e) => {
  var r, o, d, c;
  const n = I(
    (u) => {
      le(
        yn({
          target: "card",
          action: "update",
          valid: !1,
          error_code: u
        })
      );
    },
    []
  ), i = v(() => e.currentPaymentMethod === pn.CreditCardNewlyRegistration, [e.currentPaymentMethod]), t = v(() => kn({
    lang: e.sessionStateContext.lang,
    i18nString: {
      default: "クレジットカード決済",
      en: "Credit card payment"
    }
  }), [e.sessionStateContext.lang]), a = v(() => e.sessionStateContext.reservationPolicy.isDayTrip ? kn({
    lang: e.sessionStateContext.lang,
    i18nString: {
      default: "滞在日まで有効なカードをご利用ください。",
      en: "Please use a card that is valid until the day of use."
    }
  }) : kn({
    lang: e.sessionStateContext.lang,
    i18nString: {
      default: "チェックイン日まで有効なカードをご利用ください。",
      en: "Please use a card that is valid until the day of check-in."
    }
  }), [e.sessionStateContext.lang, e.sessionStateContext.reservationPolicy.isDayTrip]), s = e.sessionStateContext.lang === D.Default ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal", children: "※本予約の決済は CHILLNN Inc. が行うため、クレジットカードのご利用明細には「チルン」または「CHILLNN」と表示されます。" }) : /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal", children: "※This reservation is processed by CHILLNN Inc., so it will appear on your credit card statement as either “チルン” or “CHILLNN”." });
  return /* @__PURE__ */ l.jsx(
    Bd,
    {
      triggerSlotContext: {
        htmlFor: pn.CreditCardNewlyRegistration,
        labelText: t,
        radioGroupItemSlot: /* @__PURE__ */ l.jsx(
          i1,
          {
            value: pn.CreditCardNewlyRegistration,
            checked: i,
            id: pn.CreditCardNewlyRegistration
          }
        )
      },
      activeSlot: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        s,
        /* @__PURE__ */ l.jsx(
          FC,
          {
            lang: e.sessionStateContext.lang,
            payjpInstance: e.libContext.payjp.instance,
            createTokenContext: {
              guestEmail: (c = (d = (o = (r = e.sessionStateContext) == null ? void 0 : r.currentState) == null ? void 0 : o.guestInfo) == null ? void 0 : d.email) != null ? c : "",
              onCreateTokenCallback: e.onReserveWithCreditNewlyRegistration,
              onCreateTokenErrorCallback: n
            },
            cautionChildren: /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal", children: a })
          }
        )
      ] }),
      active: i
    }
  );
}), Vte = g(({ lang: e }) => {
  const n = v(() => kn({
    lang: e,
    i18nString: {
      default: "こちらの予約は無料ですが、現地にて追加のサービスをご利用の場合など、現地にて追加の料金をお支払いいただく場合がございます。",
      en: "This reservation is free, but if you use additional services at the venue, you may need to pay additional fees at the venue."
    }
  }), [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-text-sm ch-font-normal ch-text-black", children: n });
}), Hte = g(({ currentPaymentMethod: e, sessionStateContext: n }) => {
  const i = v(() => e === pn.Free, [e]), t = v(() => kn({
    lang: n.lang,
    i18nString: {
      default: "無料の予約",
      en: "Free reservation"
    }
  }), [n.lang]);
  return /* @__PURE__ */ l.jsx(
    Bd,
    {
      triggerSlotContext: {
        htmlFor: pn.Free,
        labelText: t,
        radioGroupItemSlot: /* @__PURE__ */ l.jsx(
          i1,
          {
            value: pn.Free,
            checked: i,
            id: pn.Free
          }
        )
      },
      activeSlot: /* @__PURE__ */ l.jsx(Vte, { lang: n.lang }),
      active: i
    }
  );
}), zte = g(({ currentPaymentMethod: e, sessionStateContext: n }) => {
  const i = v(() => e === pn.Local, [e]), t = v(() => kn({
    lang: n.lang,
    i18nString: {
      default: "現地決済",
      en: "Local payment"
    }
  }), [n.lang]);
  return /* @__PURE__ */ l.jsx(
    Bd,
    {
      triggerSlotContext: {
        htmlFor: pn.Local,
        labelText: t,
        radioGroupItemSlot: /* @__PURE__ */ l.jsx(
          i1,
          {
            value: pn.Local,
            checked: i,
            id: pn.Local
          }
        )
      },
      active: i
    }
  );
}), Bte = g(({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? `テスト予約を行います。
テスト予約では決済は行いませんが在庫は連動します。
テスト予約はキャンセルを行うようにしてください。` : `Make a test reservation.
Test reservations do not include payment, but inventory will be updated.
 Please cancel the test reservation.`, [e.lang]);
  return /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-wrap ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: n }) });
}), qte = g(({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "合計金額" : "Total Price", [e.lang]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), Gte = g(({ sessionStateContext: e }) => {
  const n = v(() => `¥${e.priceInfo.totalGuestCharge.toLocaleString()}`, [e.priceInfo.totalGuestCharge]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-2xl ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), Wte = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-space-y-1.5 ch-border-b ch-border-solid ch-border-gray-200 ch-pb-3", children: [
  /* @__PURE__ */ l.jsx(qte, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(Gte, { sessionStateContext: e })
] })), Kte = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-5", children: [
  /* @__PURE__ */ l.jsx(Wte, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(Bte, { sessionStateContext: e })
] })), Yte = g(({ currentPaymentMethod: e, sessionStateContext: n }) => {
  const i = v(() => e === pn.Test, [e]), t = v(() => kn({
    lang: n.lang,
    i18nString: {
      default: "テスト決済",
      en: "Test payment"
    }
  }), [n.lang]);
  return /* @__PURE__ */ l.jsx(
    Bd,
    {
      triggerSlotContext: {
        htmlFor: pn.Test,
        labelText: t,
        radioGroupItemSlot: /* @__PURE__ */ l.jsx(
          i1,
          {
            value: pn.Test,
            checked: i,
            id: pn.Test
          }
        )
      },
      activeSlot: /* @__PURE__ */ l.jsx(Kte, { sessionStateContext: n }),
      active: i
    }
  );
}), Xte = Ve(
  /* GraphQL */
  `
	mutation RCReserveWithCreditPaymentEncodeCallBackForNewReservation(
		$baseInfoInput: BaseInfoInput!
		$creditCardInfoInput: CreditCardInfoInput!
	) {
		reserveWithCreditPaymentEncodeCallBackUrlForNewReservation(
			baseInfo: $baseInfoInput
			creditCardInfoInput: $creditCardInfoInput
		)
	}
`
), Zte = Ve(
  /* GraphQL */
  `
	mutation RCReserveWithCreditPaymentEncodeCallBackUrlForExistingReservation(
		$baseInfoInput: BaseInfoInput!
		$creditCardInfoInput: CreditCardInfoInput
	) {
		reserveWithCreditPaymentEncodeCallBackUrlForExistingReservation(
			baseInfo: $baseInfoInput
			creditCardInfoInput: $creditCardInfoInput
		)
	}
`
), eae = Ve(
  /* GraphQL */
  `
	mutation RCReserveWithFreePayment($baseInfoInput: BaseInfoInput!) {
		reserveWithFreePayment(baseInfo: $baseInfoInput) {
			hotelID
			reservationID
		}
	}
`
), nae = Ve(
  /* GraphQL */
  `
	mutation RCReserveWithLocalPayment($baseInfoInput: BaseInfoInput!) {
		reserveWithLocalPayment(baseInfo: $baseInfoInput) {
			hotelID
			reservationID
		}
	}
`
), iae = Ve(
  /* GraphQL */
  `
	mutation RCReserveWithTestPayment($baseInfoInput: BaseInfoInput!) {
		reserveWithTestPayment(baseInfo: $baseInfoInput) {
			hotelID
			reservationID
		}
	}
`
), tae = ({
  sessionStateContext: e
}) => {
  const { mutationFunc: n } = Gn(
    Xte
  ), i = I(
    async (s) => {
      const { data: r } = await n({
        variables: {
          baseInfoInput: e.baseInfoInput,
          creditCardInfoInput: s
        }
      });
      return r.reserveWithCreditPaymentEncodeCallBackUrlForNewReservation;
    },
    [n, e.baseInfoInput]
  ), { mutationFunc: t } = Gn(
    Zte
  );
  return {
    onReserveWithCreditPaymentEncodeCallBackUrlForExistingReservation: I(
      async (s) => {
        const { data: r } = await t({
          variables: {
            baseInfoInput: e.baseInfoInput,
            creditCardInfoInput: s
          }
        });
        return r.reserveWithCreditPaymentEncodeCallBackUrlForExistingReservation;
      },
      [t, e.baseInfoInput]
    ),
    onReserveWithCreditPaymentEncodeCallBackUrlForNewReservation: i
  };
}, Wh = () => {
  const { reservationCart: e } = Va(), { reservationContext: n } = Er(), i = I(() => n.reservationEditMode !== X.NewReservation || n.isTestReservation ? null : e, [e, n.isTestReservation, n.reservationEditMode]), t = I(
    (s) => {
      const r = i();
      r && SC({ ...r, reservationID: s }).forEach(bt);
    },
    [i]
  ), a = I(
    (s) => {
      const r = i();
      r && KV(s, r);
    },
    [i]
  );
  return {
    onPushPurchase: t,
    onStashPurchase: a
  };
}, aae = ({
  sessionStateContext: e,
  callbackContext: n,
  libContext: i
}) => {
  const {
    onReserveWithCreditPaymentEncodeCallBackUrlForExistingReservation: t,
    onReserveWithCreditPaymentEncodeCallBackUrlForNewReservation: a
  } = tae({ sessionStateContext: e }), { onGet3DSecureStartUrl: s } = IC({ instance: i.payjp.instance }), { onStashPurchase: r } = Wh(), { reservationCart: o } = Va(), d = I(
    async (p) => {
      const h = {
        confirmedPaymentToken: p,
        callbackUrlFor3DSecure: n.onGetPayjpBackUrlCallback(e.baseInfoInput)(
          e.lang
        )
      }, N = await a(h);
      return r(e.baseInfoInput.sessionID), s(p)(N);
    },
    [
      n,
      s,
      a,
      r,
      e.baseInfoInput,
      e.lang
    ]
  ), c = I(
    async (p) => {
      const h = {
        confirmedPaymentToken: p,
        callbackUrlFor3DSecure: n.onGetPayjpBackUrlCallback(e.baseInfoInput)(
          e.lang
        )
      }, N = await t(h);
      return P(N) || Ke(N) ? n.onGetPayjpBackUrlCallback(e.baseInfoInput)(
        e.lang
      ) : s(p)(N);
    },
    [
      n,
      e.baseInfoInput,
      e.lang,
      t,
      s
    ]
  ), u = I(async () => (await t(), n.onGetPayjpBackUrlCallback(e.baseInfoInput)(e.lang)), [
    n,
    e.baseInfoInput,
    e.lang,
    t
  ]), k = I(async (p) => {
    const h = await p().catch((N) => {
      throw le(
        yn({
          target: "reserve",
          action: "three_d_secure_start",
          ok: !1,
          error_code: k1(N)
        })
      ), N;
    });
    le(
      yn({
        target: "reserve",
        action: "three_d_secure_start",
        ok: !0
      })
    ), window.location.href = h;
  }, []), m = I(
    async (p) => {
      le(
        zv({
          payment_method: "credit_card"
        })
      ), Gv(o, "credit_card").forEach(bt);
      const h = e.reservationContext.reservationEditMode === X.NewReservation;
      await k(
        () => h ? d(p) : c(p)
      ).catch((N) => {
        throw le(
          bu({
            ...ct(e.baseInfoInput),
            reason: "three_d_secure_start"
          })
        ), N;
      });
    },
    [
      c,
      d,
      k,
      o,
      e.baseInfoInput,
      e.reservationContext.reservationEditMode
    ]
  ), f = I(async () => {
    await k(u);
  }, [u, k]);
  return {
    onReserveWithCreditNewlyRegistration: m,
    onReserveWithCreditContinuedUse: f
  };
}, lae = ({
  sessionStateContext: e,
  callbackContext: n
}) => {
  const { onPushPurchase: i } = Wh(), { mutationFunc: t } = Gn(eae);
  return {
    onReserveWithFreePayment: I(async () => {
      const { data: s } = await t({
        variables: {
          baseInfoInput: e.baseInfoInput
        }
      }), { hotelID: r, reservationID: o } = s.reserveWithFreePayment;
      i(o), n.onSuccessCallback({ hotelID: r, reservationID: o }), le(
        Mm({
          ...ct(e.baseInfoInput),
          reservation_id: o
        })
      );
    }, [n, t, i, e.baseInfoInput])
  };
}, sae = ({
  sessionStateContext: e,
  callbackContext: n
}) => {
  const { onPushPurchase: i } = Wh(), { mutationFunc: t } = Gn(nae);
  return {
    onReserveWithLocalPayment: I(async () => {
      const { data: s } = await t({
        variables: {
          baseInfoInput: e.baseInfoInput
        }
      }), { hotelID: r, reservationID: o } = s.reserveWithLocalPayment;
      i(o), n.onSuccessCallback({ hotelID: r, reservationID: o }), le(
        Mm({
          ...ct(e.baseInfoInput),
          reservation_id: o
        })
      );
    }, [n, t, i, e.baseInfoInput])
  };
}, rae = ({
  sessionStateContext: e,
  callbackContext: n
}) => {
  const { mutationFunc: i } = Gn(iae);
  return {
    onReserveWithTestPayment: I(async () => {
      const { data: a } = await i({
        variables: {
          baseInfoInput: e.baseInfoInput
        }
      }), { hotelID: s, reservationID: r } = a.reserveWithTestPayment;
      n.onSuccessCallback({ hotelID: s, reservationID: r }), le(
        Mm({
          ...ct(e.baseInfoInput),
          reservation_id: r
        })
      );
    }, [n, i, e.baseInfoInput])
  };
}, oae = g(({ availableDataContext: e, sessionStateContext: n, callbackContext: i, libContext: t }) => {
  const { onReserveWithCreditContinuedUse: a, onReserveWithCreditNewlyRegistration: s } = aae({
    sessionStateContext: n,
    callbackContext: i,
    libContext: t
  }), { onReserveWithFreePayment: r } = lae({
    sessionStateContext: n,
    callbackContext: i
  }), { onReserveWithLocalPayment: o } = sae({
    sessionStateContext: n,
    callbackContext: i
  }), { currentPaymentMethod: d, onChangePaymentMethod: c, onClearPaymentMethod: u } = Lte(), k = v(() => e.selectablePaymentMethodList.includes(
    pn.CreditCardNewlyRegistration
  ), [e.selectablePaymentMethodList]), m = v(() => e.selectablePaymentMethodList.includes(
    pn.CreditCardContinuedUse
  ), [e.selectablePaymentMethodList]), f = v(() => e.selectablePaymentMethodList.includes(pn.Free), [e.selectablePaymentMethodList]), p = v(() => e.selectablePaymentMethodList.includes(pn.Local), [e.selectablePaymentMethodList]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
    /* @__PURE__ */ l.jsx(Om, { defaultValue: d, onValueChange: c, children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
      k ? /* @__PURE__ */ l.jsx(
        Ute,
        {
          sessionStateContext: n,
          libContext: t,
          currentPaymentMethod: d,
          onReserveWithCreditNewlyRegistration: s
        }
      ) : null,
      m ? /* @__PURE__ */ l.jsx(
        $te,
        {
          sessionStateContext: n,
          currentPaymentMethod: d
        }
      ) : null,
      f ? /* @__PURE__ */ l.jsx(
        Hte,
        {
          currentPaymentMethod: d,
          sessionStateContext: n
        }
      ) : null,
      p ? /* @__PURE__ */ l.jsx(
        zte,
        {
          currentPaymentMethod: d,
          sessionStateContext: n
        }
      ) : null
    ] }) }),
    /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
      Mte,
      {
        sessionStateContext: n,
        currentPaymentMethod: d,
        onClearPaymentMethod: u,
        onReserveWithCreditContinuedUse: a,
        onReserveWithFreePayment: r,
        onReserveWithLocalPayment: o
      }
    ) })
  ] });
}), dae = (e) => e.currentPaymentMethod === pn.Test ? {
  kind: "Clickable",
  lang: e.sessionStateContext.lang,
  onSubmit: e.onReserveWithTestPayment,
  onErrorCallback: e.onClearPaymentMethod
} : {
  kind: "NotClickable",
  lang: e.sessionStateContext.lang
}, cae = (e) => ({
  state: v(() => dae(e), [e])
}), uae = g((e) => {
  const { state: n } = cae(e), { reservationCart: i } = Va(), t = v(() => n.kind === "NotClickable", [n.kind]), { onHideLoadingScreenCallback: a, onShowLoadingScreenCallback: s } = fn(), { onEnableBeforeUnload: r, onDisableBeforeUnload: o } = gd(), d = I(
    (u) => {
      n.kind === "Clickable" && (u.currentTarget.disabled = !0, le(
        zv({
          payment_method: "unknown"
        })
      ), Gv(i, "unknown").forEach(bt), o(), s(), n.onSubmit().then(() => {
        le(
          yn({
            target: "reserve",
            action: "submit",
            ok: !0
          })
        );
      }).catch((k) => {
        r(), n.onErrorCallback(), le(
          yn({
            target: "reserve",
            action: "submit",
            ok: !1,
            error_code: k1(k)
          })
        );
      }).finally(() => {
        a();
      }));
    },
    [
      o,
      r,
      a,
      s,
      i,
      n
    ]
  ), c = v(() => n.lang === D.Default ? "テスト予約をする" : "Reserve for test", [n]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", disabled: t, size: "md", onClick: d, children: c });
}), mae = () => {
  const [e, n] = se(void 0), i = I(() => {
    n(void 0);
  }, []), t = I(
    (a) => {
      n({ paymentMethod: a }), le(
        yn({
          target: "payment_method",
          action: "update",
          payment_method: a.toLowerCase()
        })
      );
    },
    []
  );
  return {
    paymentMethodState: e,
    onClearPaymentMethod: i,
    onChangePaymentMethodForTest: t
  };
}, kae = g(({ availableDataContext: e, sessionStateContext: n, callbackContext: i }) => {
  const { onReserveWithTestPayment: t } = rae({ sessionStateContext: n, callbackContext: i }), { paymentMethodState: a, onChangePaymentMethodForTest: s, onClearPaymentMethod: r } = mae(), o = v(() => e.selectablePaymentMethodList.includes(pn.Test), [e.selectablePaymentMethodList]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-px-5 ch-py-10", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
    /* @__PURE__ */ l.jsx(
      Om,
      {
        defaultValue: a == null ? void 0 : a.paymentMethod,
        onValueChange: s,
        children: o ? /* @__PURE__ */ l.jsx(
          Yte,
          {
            sessionStateContext: n,
            currentPaymentMethod: a == null ? void 0 : a.paymentMethod
          }
        ) : null
      }
    ),
    /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
      uae,
      {
        sessionStateContext: n,
        currentPaymentMethod: a == null ? void 0 : a.paymentMethod,
        onClearPaymentMethod: r,
        onReserveWithTestPayment: t
      }
    ) })
  ] }) });
}), fae = (e) => ke(e.availableQuestionAndAnswerList) ? {
  kind: "NotDisplayable"
} : {
  kind: "Displayable",
  availableQuestionAndAnswerList: e.availableQuestionAndAnswerList
}, vae = (e) => ({
  state: v(() => fae(e), [e])
}), hae = Ve(
  /* GraphQL */
  `
	mutation InputQAAAQAAUpdate($baseInfo: BaseInfoInput!, $questionAndAnswerInfo: [QuestionAndAnswerUpdateInput!]!) {
		questionAndAnswerUpdate(baseInfo: $baseInfo, questionAndAnswerInfo: $questionAndAnswerInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), pae = (e) => {
  const { baseInfoInput: n } = lt(), { onUpdateSession: i } = Ji(), t = I(
    (r) => (o) => ({
      ...r,
      answers: o
    }),
    []
  ), { mutationFunc: a } = Gn(hae);
  return {
    onUpdateQuestionAndAnswer: I(
      (r) => async (o) => {
        const d = t(r)(o), { data: c } = await a({
          variables: {
            baseInfo: n,
            questionAndAnswerInfo: d
          }
        });
        i(c.questionAndAnswerUpdate);
        const { currentState: u } = Ss(c.questionAndAnswerUpdate);
        le(
          yn({
            target: "question",
            action: "update",
            answered_num: u.questionAnswerInfo.filter(
              (k) => k.answers.some((m) => m !== "")
            ).length,
            question_num: e
          })
        );
      },
      [t, a, n, i, e]
    )
  };
}, Nae = (e) => e.isRequired ? {
  kind: "Displayable"
} : {
  kind: "NotDisplayable"
}, Sae = (e) => ({
  state: v(() => Nae(e), [e])
}), gae = (e) => {
  const { state: n } = Sae(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx(sm, { size: "3xs", className: "ch-text-urgent-400" }) : null;
}, Fae = ({ questionNumber: e, isRequired: n }) => {
  const i = v(() => `Q${e}`, [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-0.5", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: i }),
    /* @__PURE__ */ l.jsx(gae, { isRequired: n })
  ] });
}, Iae = ({ questionText: e }) => /* @__PURE__ */ l.jsx(
  "p",
  {
    className: ce(
      "ch-whitespace-pre-wrap ch-break-words ch-text-base",
      // 空白の無い長い URL も表示領域内で折り返す
      "[&>a]:ch-text-link-400 [&>a]:ch-underline-offset-2 [&>a]:hover:ch-underline"
      // aタグを含んでいた場合のスタイルを指定する
    ),
    dangerouslySetInnerHTML: { __html: Nh(e) }
  }
), yae = (e) => {
  var a, s, r;
  const n = e.sessionStateContext.lang, i = e.availableQuestionAndAnswer.questionType, t = e.sessionStateContext.currentState.questionAnswerInfo.find(
    (o) => o.questionID === e.availableQuestionAndAnswer.questionID
  );
  return i === Ms.Check || i === Ms.Select ? {
    kind: "CheckAnswerDisplayable",
    lang: n,
    answerList: (a = t == null ? void 0 : t.answers) != null ? a : [],
    answerChoiceList: e.availableQuestionAndAnswer.answerChoices,
    onUpdateAnswer: e.onUpdateQuestionAndAnswer
  } : i === Ms.Free ? {
    kind: "FreeAnswerDisplayable",
    lang: n,
    answer: (s = t == null ? void 0 : t.answers[0]) != null ? s : "",
    onUpdateAnswer: e.onUpdateQuestionAndAnswer
  } : {
    kind: "RadioAnswerDisplayable",
    lang: n,
    answer: (r = t == null ? void 0 : t.answers[0]) != null ? r : "",
    answerChoiceList: e.availableQuestionAndAnswer.answerChoices,
    onUpdateAnswer: e.onUpdateQuestionAndAnswer
  };
}, bae = (e) => ({
  state: v(() => yae(e), [e])
}), Cae = g((e) => {
  const [n, i] = se(e.initData.answerList), { onHideLoadingScreenCallback: t, onShowLoadingScreenCallback: a } = fn(), s = I(
    (o) => async (d) => {
      const c = d ? n.concat(o) : n.filter((u) => u !== o);
      a(), await e.onUpdateAnswer(c).then(() => {
        i(c);
      }).finally(() => {
        t();
      });
    },
    [n, t, a, e]
  ), r = ul();
  return /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-1", children: e.answerChoiceList.map((o, d) => {
    const c = n.some((k) => k === o), u = `${r}-${o}-${d}`;
    return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-2", children: [
      /* @__PURE__ */ l.jsx(hv, { id: u, checked: c, onCheckedChange: s(o) }),
      /* @__PURE__ */ l.jsx(
        Qn,
        {
          htmlFor: u,
          className: "ch-cursor-pointer !ch-text-base ch-font-normal",
          children: o
        }
      )
    ] }, u);
  }) });
}), xae = g((e) => {
  const [n, i] = se(e.initData.answer), { onHideLoadingScreenCallback: t, onShowLoadingScreenCallback: a } = fn(), s = I(
    async (o) => {
      const d = [o];
      a(), await e.onUpdateAnswer(d).then(() => {
        i(o);
      }).finally(() => {
        t();
      });
    },
    [t, a, e]
  ), r = ul();
  return /* @__PURE__ */ l.jsx(Om, { className: "ch-space-y-0.5", defaultValue: n, onValueChange: s, children: e.answerChoiceList.map((o, d) => {
    const c = `${r}-${o}-${d}`;
    return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-2", children: [
      /* @__PURE__ */ l.jsx(i1, { value: o, id: c }),
      /* @__PURE__ */ l.jsx(
        Qn,
        {
          htmlFor: c,
          className: "ch-cursor-pointer !ch-text-base ch-font-normal",
          children: o
        }
      )
    ] }, c);
  }) });
}), Dae = g((e) => {
  const [n, i] = se(e.initData.answer), t = I((c) => {
    i(c.target.value);
  }, []), { onHideLoadingScreenCallback: a, onShowLoadingScreenCallback: s } = fn(), r = Ye(n), o = I(
    async (c) => {
      r.current !== c && (r.current = c, s(), await e.onUpdateAnswer([c]).finally(() => {
        a();
      }));
    },
    [a, s, e]
  ), d = I(
    async (c) => {
      await o(c.target.value);
    },
    [o]
  );
  return be(() => {
    const c = setTimeout(async () => {
      await o(n);
    }, 1e3);
    return () => {
      clearTimeout(c);
    };
  }, [n, a, s, o, e]), /* @__PURE__ */ l.jsx(Ub, { value: n, onChange: t, onBlur: d });
}), wae = (e) => {
  const { state: n } = bae(e);
  switch (n.kind) {
    case "CheckAnswerDisplayable":
      return /* @__PURE__ */ l.jsx(
        Cae,
        {
          lang: n.lang,
          initData: {
            answerList: n.answerList
          },
          answerChoiceList: n.answerChoiceList,
          onUpdateAnswer: n.onUpdateAnswer
        }
      );
    case "FreeAnswerDisplayable":
      return /* @__PURE__ */ l.jsx(
        Dae,
        {
          lang: n.lang,
          initData: { answer: n.answer },
          onUpdateAnswer: n.onUpdateAnswer
        }
      );
    case "RadioAnswerDisplayable":
      return /* @__PURE__ */ l.jsx(
        xae,
        {
          lang: n.lang,
          initData: { answer: n.answer },
          answerChoiceList: n.answerChoiceList,
          onUpdateAnswer: n.onUpdateAnswer
        }
      );
    default:
      return null;
  }
}, Pae = g(
  ({
    sessionStateContext: e,
    availableQuestionAndAnswers: n,
    onUpdateQuestionAndAnswer: i
  }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6", children: n.map((t, a) => {
    const s = `${t.questionType}-${t.questionText}-${a}`, r = a + 1;
    return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-border-b ch-pb-6 last:ch-border-b-0", children: [
      /* @__PURE__ */ l.jsx(Fae, { questionNumber: r, isRequired: t.isRequired }),
      /* @__PURE__ */ l.jsx(Iae, { questionText: t.questionText }),
      /* @__PURE__ */ l.jsx(
        wae,
        {
          sessionStateContext: e,
          availableQuestionAndAnswer: t,
          onUpdateQuestionAndAnswer: i({
            questionID: t.questionID,
            question: t.questionText
          })
        }
      )
    ] }, s);
  }) })
), Rae = g(({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "ご予約に当たっての質問" : "Questions about your reservation", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black", children: n });
}), p7 = g((e) => {
  const { state: n } = vae(e), { onUpdateQuestionAndAnswer: i } = pae(
    n.kind === "NotDisplayable" ? 0 : n.availableQuestionAndAnswerList.length
  );
  return n.kind === "NotDisplayable" ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8 ch-bg-white ch-px-5 ch-py-8", children: [
    /* @__PURE__ */ l.jsx(Rae, { ...e }),
    /* @__PURE__ */ l.jsx(
      Pae,
      {
        ...e,
        availableQuestionAndAnswers: n.availableQuestionAndAnswerList,
        onUpdateQuestionAndAnswer: i
      }
    )
  ] });
}), Tae = Ve(
  /* GraphQL */
  `
	mutation InputVoucherVoucherRemove($baseInfo: BaseInfoInput!, $voucherInfo: VoucherInput!) {
		voucherRemove(baseInfo: $baseInfo, voucherInfo: $voucherInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), jae = Ve(
  /* GraphQL */
  `
	mutation InputVoucherVoucherUpdate($baseInfo: BaseInfoInput!, $voucherInfo: VoucherInput!) {
		voucherSet(baseInfo: $baseInfo, voucherInfo: $voucherInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Aae = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(Tae);
  return {
    onRemoveVoucher: I(
      (t) => async () => {
        try {
          const { data: a } = await n({
            variables: {
              baseInfo: e.baseInfoInput,
              voucherInfo: { voucherCode: t }
            }
          });
          e.onUpdateSession(a.voucherRemove), le(yn({ target: "voucher", action: "remove", ok: !0 }));
        } catch (a) {
          throw le(
            yn({
              target: "voucher",
              action: "remove",
              ok: !1,
              error_code: k1(a)
            })
          ), a;
        }
      },
      [n, e]
    )
  };
}, Oae = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(jae);
  return {
    onUpdateVoucher: I(
      (t) => async () => {
        try {
          const { data: a } = await n({
            variables: {
              baseInfo: e.baseInfoInput,
              voucherInfo: { voucherCode: t }
            }
          });
          e.onUpdateSession(a.voucherSet), le(yn({ target: "voucher", action: "update", ok: !0 }));
        } catch (a) {
          throw le(
            yn({
              target: "voucher",
              action: "update",
              ok: !1,
              error_code: k1(a)
            })
          ), a;
        }
      },
      [n, e]
    )
  };
}, Eae = g(({ sessionStateContext: { lang: e } }) => {
  const n = v(() => e === D.Default ? "適用中の宿泊券／チケット" : "Applied voucher code", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: n });
}), Jae = ({ lang: e, name: n, voucherCode: i, onRemoveVoucher: t }) => {
  const a = v(() => e === D.Default ? `「${n}(${i})」を削除してもよろしいですか？` : `Are you sure you want to remove "${i}"?`, [e, n, i]), s = I(async () => {
    window.confirm(a) && await t();
  }, [a, t]), r = v(() => e === D.Default ? "削除" : "Remove", [e]);
  return /* @__PURE__ */ l.jsx(
    ae,
    {
      size: "sm",
      variant: "underline",
      onClick: s,
      className: "ch-font-semibold",
      children: r
    }
  );
}, _ae = g(({ name: e, price: n, voucherCode: i, lang: t, onRemoveVoucher: a }) => {
  const s = v(() => `- ¥${n.toLocaleString()}`, [n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-gap-x-2", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: e }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-2", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: s }),
      /* @__PURE__ */ l.jsx(
        Jae,
        {
          lang: t,
          name: e,
          voucherCode: i,
          onRemoveVoucher: a
        }
      )
    ] })
  ] });
}), Qae = g(({ lang: e }) => {
  const n = v(() => e === D.Default ? "なし" : "none", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: n });
}), Mae = (e) => ke(e.sessionStateContext.currentState.voucherInfo) ? {
  kind: "NotApplied",
  lang: e.sessionStateContext.lang
} : {
  kind: "Applied",
  lang: e.sessionStateContext.lang,
  voucherList: e.sessionStateContext.currentState.voucherInfo
}, Lae = (e) => ({
  state: v(() => Mae(e), [e])
}), $ae = g(({ onRemoveVoucher: e, ...n }) => {
  const { state: i } = Lae(n);
  return i.kind === "Applied" ? i.voucherList.map((t, a) => {
    const s = `applied-voucher-${t.name}-${a}`;
    return /* @__PURE__ */ l.jsx(
      _ae,
      {
        lang: i.lang,
        onRemoveVoucher: e(t.voucherCode),
        name: t.name,
        price: t.discountPrice,
        voucherCode: t.voucherCode
      },
      s
    );
  }) : /* @__PURE__ */ l.jsx(Qae, { lang: i.lang });
});
g(({ lang: e }) => {
  const n = v(() => e === D.Default ? "宿泊券 / チケット" : "voucher code", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-bold", children: n });
});
const Uae = (e) => P(e) || Ke(e) ? {
  kind: "Invalidated",
  input: void 0
} : {
  kind: "Validated",
  input: e
}, Vae = () => ({
  kind: "Invalidated",
  input: void 0
}), Hae = ({ onChangeState: e }) => ({
  onChangeInput: I(
    (i) => {
      const t = Uae(i);
      e(t);
    },
    [e]
  )
}), zae = () => {
  const [e, n] = se(Vae()), i = I((a) => {
    n(a);
  }, []), { onChangeInput: t } = Hae({ onChangeState: i });
  return {
    state: e,
    onChangeInput: t
  };
}, Bae = (e) => e.voucherFormState.kind === "Invalidated" ? {
  kind: "NotClickable",
  lang: e.lang
} : {
  kind: "Clickable",
  lang: e.lang,
  onClick: e.onApplyVoucher(e.voucherFormState.input)
}, qae = (e) => ({
  state: v(() => Bae(e), [e])
}), Gae = g((e) => {
  const { state: n } = qae(e), { onShowLoadingScreenCallback: i, onHideLoadingScreenCallback: t } = fn(), a = I(async () => {
    n.kind === "Clickable" && (i(), await n.onClick().finally(() => {
      t();
    }));
  }, [t, i, n]), s = v(() => n.lang === D.Default ? "適用" : "apply", [n.lang]), r = v(() => n.kind !== "Clickable", [n.kind]);
  return /* @__PURE__ */ l.jsx(
    ae,
    {
      size: "md",
      variant: "outline",
      className: "ch-h-full",
      disabled: r,
      onClick: a,
      children: s
    }
  );
}), Wae = g(({ lang: e, voucherFormState: n, onChangeInput: i }) => {
  var s;
  const t = I(
    (r) => {
      const o = r.target.value;
      i(o);
    },
    [i]
  ), a = v(() => e === D.Default ? "コードを入力してください" : "Please enter the code", [e]);
  return /* @__PURE__ */ l.jsx(
    Qa,
    {
      value: (s = n.input) != null ? s : "",
      onChange: t,
      placeholder: a
    }
  );
}), Kae = g((e) => {
  const { state: n, onChangeInput: i } = zae();
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-h-12 ch-items-center ch-gap-x-2 ch-pl-1", children: [
    /* @__PURE__ */ l.jsx(
      Wae,
      {
        lang: e.sessionStateContext.lang,
        voucherFormState: n,
        onChangeInput: i
      }
    ),
    /* @__PURE__ */ l.jsx(
      Gae,
      {
        lang: e.sessionStateContext.lang,
        voucherFormState: n,
        onApplyVoucher: e.onApplyVoucher
      }
    )
  ] });
}), N7 = g(({ sessionStateContext: e }) => {
  var a;
  const { onUpdateVoucher: n } = Oae({ sessionStateContext: e }), { onRemoveVoucher: i } = Aae({ sessionStateContext: e }), t = v(() => {
    var r, o;
    return !P((r = e.currentState) == null ? void 0 : r.voucherInfo) && !ke((o = e.currentState) == null ? void 0 : o.voucherInfo);
  }, [(a = e.currentState) == null ? void 0 : a.voucherInfo]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
    /* @__PURE__ */ l.jsx(Kae, { sessionStateContext: e, onApplyVoucher: n }),
    t && /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
      /* @__PURE__ */ l.jsx(Eae, { sessionStateContext: e }),
      /* @__PURE__ */ l.jsx(
        $ae,
        {
          sessionStateContext: e,
          onRemoveVoucher: i
        }
      )
    ] })
  ] }) });
}), Yae = Ve(
  /* GraphQL */
  `
	mutation RCSelectDateDateUpdate($baseInfo: BaseInfoInput!, $dateInfo: DateUpdateInput!) {
		dataUpdate(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Xae = Ve(
  /* GraphQL */
  `
	query SelectDateDateCoutAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateCoutAvailableInput!) {
		dateCoutAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			availableCoutDates {
				date
				currentViewState
				selectable
				available
				dailyMinimumPrice
			}
		}
	}
`
), Zae = Ve(
  /* GraphQL */
  `
	query SelectDateDateStayStartAvailableInitial($baseInfo: BaseInfoInput!) {
		dateStayStartAvailableInitial(baseInfo: $baseInfo) {
			availableStayStartDates {
				date
				currentViewState
				selectable
				available
				dailyMinimumPrice
			}
		}
	}
`
), ele = Ve(
  /* GraphQL */
  `
	query SelectDateDateStayStartAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateStayStartAvailableInput!) {
		dateStayStartAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			availableStayStartDates {
				date
				currentViewState
				selectable
				available
				dailyMinimumPrice
			}
		}
	}
`
), nle = (e) => {
  const [n, i] = se([]), { refetch: t } = qn(
    ele,
    void 0,
    !0
  ), a = I(
    (c) => async () => {
      const { firstDate: u, lastDate: k } = gt(c), m = { startDt: u, endDt: k }, { data: f } = await t({
        baseInfo: e.sessionStateContext.baseInfoInput,
        dateInfo: m
      });
      i(f.dateStayStartAvailable.availableStayStartDates);
    },
    [e.sessionStateContext.baseInfoInput, t]
  ), { refetch: s } = qn(
    Xae,
    void 0,
    !0
  ), r = I(
    (c) => (u) => async () => {
      const { lastDate: k } = gt(c), m = { stayStartDt: u, endDt: k }, { data: f } = await s({
        baseInfo: e.sessionStateContext.baseInfoInput,
        dateInfo: m
      });
      i(f.dateCoutAvailable.availableCoutDates);
    },
    [e.sessionStateContext.baseInfoInput, s]
  ), { refetch: o } = qn(
    Zae,
    void 0,
    !0
  ), d = I(async () => {
    const { data: c } = await o({
      baseInfo: e.sessionStateContext.baseInfoInput
    }), u = c.dateStayStartAvailableInitial.availableStayStartDates;
    return i(u), {
      initialDate: Ne(u[0].date, "YYYY-MM-DD")
    };
  }, [e.sessionStateContext.baseInfoInput, o]);
  return {
    availableStayDateList: n,
    onAvailableStayStartDateListQuery: a,
    onAvailableStayLastDateListQuery: r,
    onInitialStayStartDateListQuery: d
  };
}, S7 = ({ stayStartDt: e, stayLastDt: n }, i = Id()) => ({
  nights: fk({ from: n, to: e }) + 1,
  lead_days: fk({ from: e, to: i }),
  day_of_week: Fd({ date: e })
}), ile = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(Yae);
  return {
    onUpdateReservationStayDt: I(
      async (t) => {
        const { data: a } = await n({
          variables: { baseInfo: e.baseInfoInput, dateInfo: t }
        });
        e.onUpdateSession(a.dataUpdate), le(
          yn({
            target: "date",
            action: "update",
            ...S7(t)
          })
        );
      },
      [n, e]
    )
  };
}, g7 = (e) => () => ({
  kind: "Errored",
  lang: e.sessionStateContext.lang,
  onInitialize: e.onInitialize
}), tle = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), F7 = () => ({
  kind: "Initialized"
}), ale = ({ state: e, onChangeState: n, erroredInputContext: i }) => {
  const t = Ye(!1);
  be(() => {
    t.current || e.kind !== "NotInitialized" || (t.current = !0, e.onInitialize().then(() => {
      n(F7());
    }).catch(() => {
      n(g7(i)(e));
    }));
  }, [i, n, e]);
}, lle = ({ onChangeState: e, erroredInputContext: n }) => ({
  onReInitialize: I(
    (t) => async () => {
      try {
        await t.onInitialize(), e(F7(t));
      } catch (a) {
        e(g7(n)(t));
      }
    },
    [n, e]
  )
}), sle = (e) => {
  const [n, i] = se(tle(e)), t = I((s) => {
    i(s);
  }, []);
  ale({ state: n, onChangeState: t, erroredInputContext: e });
  const { onReInitialize: a } = lle({ onChangeState: t, erroredInputContext: e });
  return {
    state: n,
    onReInitialize: a
  };
}, rle = (e) => {
  const n = I(async () => {
    le(Pn({ target: "refetch", area: "date" })), await e.onRefetch();
  }, [e]), i = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: n, children: i });
}, ole = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "データが正しく取得できませんでした。" : "Failed to fetch data.", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, dle = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-py-8 ch-text-center", children: [
  /* @__PURE__ */ l.jsx(ole, { ...e }),
  /* @__PURE__ */ l.jsx(rle, { ...e })
] }), cle = g(() => /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-max-w-[420px] ch-pb-4 ch-pt-6", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-animate-pulse ch-items-center ch-justify-between ch-px-5", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-7 ch-w-[120px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-20 ch-animate-pulse ch-rounded-lg ch-bg-gray-200" })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-px-5 ch-py-2", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-[328px] ch-w-full ch-animate-pulse ch-rounded-xl ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-9 ch-w-full ch-animate-pulse ch-rounded-md ch-bg-gray-200" })
  ] })
] })), ule = g(({ children: e, modelContext: n }) => {
  const { state: i, onReInitialize: t } = sle(n);
  return i.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(cle, {}) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(dle, { lang: i.lang, onRefetch: t(i) }) : e;
}), mle = (e) => e.sessionStateContext.reservationPolicy.isDayTrip ? {
  kind: "DayTripDateDisplayable",
  sessionStateContext: e.sessionStateContext,
  currentYearMonth: e.currentYearMonth,
  availableStayStartDateList: e.availableStayDateList.filter(
    (n) => n.__typename === "AvailableStayStartDate"
  ),
  onSelectDateCallback: e.onSelectDayTripDt,
  onPrevMonth: e.onPrevMonth,
  onNextMonth: e.onNextMonth
} : {
  kind: "StayDateDisplayable",
  sessionStateContext: e.sessionStateContext,
  currentYearMonth: e.currentYearMonth,
  availableStayDateList: e.availableStayDateList,
  onSelectCinDateCallback: e.onSelectCinDt,
  onSelectCoutDateCallback: e.onSelectCoutDt,
  onPrevMonth: e.onPrevMonth,
  onNextMonth: e.onNextMonth
}, kle = (e) => ({
  state: v(() => mle(e), [e])
}), fle = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "通貨単位：円 （税込）";
      case D.En:
        return "Currency: JPY (tax included)";
      default:
        throw new Error("Invalid lang code.");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-normal ch-text-gray-400", children: n });
}), vle = g(({ lang: e }) => {
  const { reservationPolicy: n } = Ua(), i = v(() => {
    if (n.isShowPlanIncludedPrice)
      switch (e) {
        case D.Default:
          return `表示料金は選択中のプランで予約する場合の最低料金です。
プラン未選択の場合は部屋のみ予約する場合の最低料金です。`;
        case D.En:
          return `The displayed price is the minimum price when booking with the selected plan.
If no plan is selected, it is the minimum price for booking the room only.`;
        default:
          throw new Error("Invalid lang code.");
      }
    switch (e) {
      case D.Default:
        return "料金はプラン等の料金を含まない、お部屋の最低価格です。";
      case D.En:
        return "The price is the minimum price of the room and does not include the price of the plan.";
      default:
        throw new Error("Invalid lang code.");
    }
  }, [e, n.isShowPlanIncludedPrice]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-text-xs ch-font-normal ch-text-gray-400", children: i });
}), hle = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
  /* @__PURE__ */ l.jsx(fle, { lang: e.state.sessionStateContext.lang }),
  /* @__PURE__ */ l.jsx(vle, { lang: e.state.sessionStateContext.lang })
] })), ple = (e) => {
  var t, a;
  const n = e.availableStayStartDateList.find(
    (s) => Ht({ targetDate: s.date, compareDate: e.date })
  ), i = e.sessionStateContext.reservationPolicy.isShowCalendarPrice;
  if (P(n) || e.isDifferentMonth)
    return {
      kind: "NotDisplayable",
      date: e.date
    };
  if (n.currentViewState === Un.DayTripSelected)
    return {
      kind: "DayTripReadable",
      canShowPrice: i,
      price: (t = n.dailyMinimumPrice) != null ? t : null,
      date: e.date
    };
  if (n.currentViewState === Un.NotSelected && n.selectable)
    return {
      kind: "Selectable",
      canShowPrice: i,
      price: (a = n.dailyMinimumPrice) != null ? a : null,
      lang: e.sessionStateContext.lang,
      date: e.date,
      onSubmitCallback: e.onSelectDateCallback(e.date)
    };
  if (n.currentViewState === Un.NotSelected && !n.selectable)
    return {
      kind: "NotSelectable",
      date: e.date
    };
  throw new Error("Invalid state");
}, Nle = (e) => ({
  state: v(() => ple(e), [e])
}), u9 = g((e) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-[10px] ch-font-normal ch-leading-3", children: e.text })), xc = g((e) => {
  const { onHideLoadingScreenCallback: n, onShowLoadingScreenCallback: i } = fn(), t = I(async () => {
    e.kind === "SelectableDay" && (i(), await e.onSubmitCallback().finally(() => {
      n();
    }));
  }, [n, i, e]), a = v(() => Ne(e.date, "D"), [e.date]), s = I(() => e.kind === "DifferentMonthDay" ? null : e.kind === "NotSelectableDay" ? /* @__PURE__ */ l.jsx(Ei, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]" }) : e.kind === "SelectableDay" ? e.canShowPrice && !P(e.price) ? /* @__PURE__ */ l.jsx(u9, { text: e.price.toLocaleString() }) : /* @__PURE__ */ l.jsx(am, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]", size: "2xs" }) : e.kind === "DayTripSelectedDay" && e.canShowPrice && !P(e.price) ? /* @__PURE__ */ l.jsx(u9, { text: e.price.toLocaleString() }) : /* @__PURE__ */ l.jsx(tm, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]" }), [e]), r = v(() => {
    if (e.kind === "DifferentMonthDay")
      return "ch-pointer-events-none ch-cursor-default ch-text-white ch-opacity-0";
    if (e.kind === "DayTripSelectedDay")
      return "ch-bg-primary ch-text-white";
    if (e.kind === "SelectableDay")
      return "ch-cursor-pointer ch-text-black hover:ch-bg-gray-100 hover:ch-opacity-90 hover:ch-duration-500";
    if (e.kind === "NotSelectableDay")
      return "ch-text-gray-400 ch-cursor-default";
  }, [e]);
  return /* @__PURE__ */ l.jsxs(
    "button",
    {
      className: ce(
        "ch-w-full ch-max-w-[50px] ch-space-y-1 ch-rounded ch-py-2.5 ch-text-center ch-tabular-nums",
        r
      ),
      onClick: t,
      children: [
        /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-normal", children: a }),
        s()
      ]
    }
  );
}), Sle = g((e) => {
  const { state: n } = Nle(e);
  switch (n.kind) {
    case "Selectable":
      return /* @__PURE__ */ l.jsx(xc, { ...n, kind: "SelectableDay" });
    case "DayTripReadable":
      return /* @__PURE__ */ l.jsx(xc, { ...n, kind: "DayTripSelectedDay" });
    case "NotSelectable":
      return /* @__PURE__ */ l.jsx(xc, { ...n, kind: "NotSelectableDay" });
    default:
      return /* @__PURE__ */ l.jsx(xc, { ...n, kind: "DifferentMonthDay" });
  }
});
function m9(e) {
  switch (e.__typename) {
    case "AvailableStayStartDate":
      return e.currentViewState === Un.Cin;
    case "AvailableCoutDate":
      return e.currentViewState === Rt.Cin;
    default:
      throw new Error("Invalid typename");
  }
}
function k9(e) {
  return e.__typename === "AvailableCoutDate" ? !1 : e.currentViewState === Un.Cout;
}
function gle(e) {
  switch (e.__typename) {
    case "AvailableStayStartDate":
      return e.currentViewState === Un.MiddleDay;
    case "AvailableCoutDate":
      return e.currentViewState === Rt.MiddleDay;
    default:
      throw new Error("Invalid typename");
  }
}
function Fle(e) {
  switch (e.__typename) {
    case "AvailableStayStartDate":
      return e.currentViewState === Un.NotSelected;
    case "AvailableCoutDate":
      return e.currentViewState === Rt.NotSelected;
    default:
      throw new Error("Invalid typename");
  }
}
const Ile = (e) => {
  var p, h, N, S, F, y;
  if (e.isDifferentMonth)
    return {
      kind: "NotDisplayable",
      date: e.date
    };
  const n = e.availableStayDateList.find(
    (x) => Ht({
      targetDate: x.date,
      compareDate: e.date
    })
  );
  if (P(n))
    return {
      kind: "NotSelectable",
      date: e.date
    };
  if (m9(n))
    return {
      kind: "CinReadable",
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (p = n.dailyMinimumPrice) != null ? p : null
    };
  if (k9(n))
    return {
      kind: "CoutReadable",
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice
    };
  const i = e.availableStayDateList.find((x) => m9(x)), t = !P(i), a = e.availableStayDateList.find((x) => k9(x)), s = !P(a), r = gle(n);
  if (r && n.available)
    return {
      kind: "MiddleDayReadable",
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (h = n.dailyMinimumPrice) != null ? h : 0
    };
  if (r && t && !s && n.selectable)
    return {
      kind: "MiddleDaySelectable",
      lang: e.sessionStateContext.lang,
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (N = n.dailyMinimumPrice) != null ? N : 0,
      onSubmitCallback: e.onSelectCoutDateCallback(i.date)(e.date)
    };
  if (r && n.selectable)
    return {
      kind: "MiddleDaySelectable",
      lang: e.sessionStateContext.lang,
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: (S = n.dailyMinimumPrice) != null ? S : 0,
      onSubmitCallback: e.onSelectCinDateCallback(e.date)
    };
  if (r)
    return {
      kind: "MiddleDayReadable",
      date: e.date,
      canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
      price: 0
    };
  const u = Fle(n), k = i && CV({
    targetDate: e.date,
    compareDate: i.date
  });
  return u && t && !s && n.selectable && k ? {
    kind: "Selectable",
    lang: e.sessionStateContext.lang,
    date: e.date,
    canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
    price: (F = n.dailyMinimumPrice) != null ? F : 0,
    onSubmitCallback: e.onSelectCoutDateCallback(i.date)(e.date)
  } : u && n.selectable ? {
    kind: "Selectable",
    lang: e.sessionStateContext.lang,
    date: e.date,
    canShowPrice: e.sessionStateContext.reservationPolicy.isShowCalendarPrice,
    price: (y = n.dailyMinimumPrice) != null ? y : 0,
    onSubmitCallback: e.onSelectCinDateCallback(e.date)
  } : {
    kind: "NotSelectable",
    date: e.date
  };
}, yle = (e) => ({
  state: v(() => Ile(e), [e])
}), ble = (e) => {
  const { onHideLoadingScreenCallback: n, onShowLoadingScreenCallback: i } = fn();
  return {
    handleSubmit: I(async () => {
      (e.kind === "SelectableMiddleDay" || e.kind === "SelectableDay") && (i(), await e.onSubmitCallback().finally(() => {
        n();
      }));
    }, [n, i, e])
  };
}, Cle = (e) => {
  const { handleSubmit: n } = ble(e), i = I(() => ["ch-pointer-events-none", "ch-cursor-default", "ch-text-white", "ch-opacity-0"], []), t = I(() => ["ch-text-gray-400"], []), a = I(
    (o) => {
      const d = ["ch-bg-primary", "ch-text-white", "ch-font-semibold"];
      switch (o.kind) {
        case "CinSelected":
          return d.concat("ch-rounded-l-lg");
        case "CoutSelected":
          return d.concat("ch-rounded-r-lg");
        default:
          return d;
      }
    },
    []
  ), s = I(
    (o) => {
      const d = ["ch-cursor-pointer", "ch-font-semibold"];
      switch (o.kind) {
        case "SelectableDay":
          return d.concat(["hover:ch-rounded-lg", "hover:ch-bg-gray-100", "hover:ch-opacity-90"]);
        case "SelectableMiddleDay":
          return d.concat(["ch-bg-primary", "ch-text-white"]);
        default:
          return d;
      }
    },
    []
  ), r = v(() => {
    switch (e.kind) {
      case "DifferentMonthDay":
        return i();
      case "NotSelectableDay":
        return t();
      case "CinSelected":
        return a(e);
      case "MiddleDaySelected":
        return a(e);
      case "CoutSelected":
        return a(e);
      case "SelectableDay":
        return s(e);
      case "SelectableMiddleDay":
        return s(e);
      default:
        return;
    }
  }, [
    i,
    t,
    s,
    a,
    e
  ]);
  return /* @__PURE__ */ l.jsx(
    "button",
    {
      className: ce(
        "ch-w-full ch-max-w-[50px] ch-cursor-default ch-space-y-1 ch-py-2.5 ch-text-center",
        r
      ),
      onClick: n,
      children: e.children
    }
  );
}, f9 = g(() => /* @__PURE__ */ l.jsx(tm, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]" })), v9 = g(() => /* @__PURE__ */ l.jsx(am, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]", size: "2xs" })), h9 = g((e) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-[10px] ch-font-normal ch-leading-3", children: e.text })), xle = g((e) => {
  if (e.kind === "DifferentMonthDay")
    return null;
  if (e.kind === "NotSelectableDay")
    return /* @__PURE__ */ l.jsx(XP, { className: "ch-mx-auto ch-h-[12px] ch-w-[12px]" });
  if (!e.canShowPrice)
    switch (e.kind) {
      case "SelectableDay":
        return /* @__PURE__ */ l.jsx(v9, {});
      case "SelectableMiddleDay":
        return /* @__PURE__ */ l.jsx(v9, {});
      case "CinSelected":
        return /* @__PURE__ */ l.jsx(f9, {});
      case "MiddleDaySelected":
        return /* @__PURE__ */ l.jsx(f9, {});
      case "CoutSelected":
        return /* @__PURE__ */ l.jsx("div", { className: "ch-h-[12px] ch-w-[12px]" });
      default:
        return null;
    }
  if ((e.kind === "MiddleDaySelected" || e.kind === "SelectableDay" || e.kind === "SelectableMiddleDay") && e.price !== 0) {
    const n = `${e.price.toLocaleString()}~`;
    return /* @__PURE__ */ l.jsx(h9, { text: n });
  }
  return e.kind === "CinSelected" && !P(e.price) ? /* @__PURE__ */ l.jsx(h9, { text: `${e.price.toLocaleString()}~` }) : /* @__PURE__ */ l.jsx("div", { className: "ch-h-[12px] ch-w-[12px]" });
}), Dle = g((e) => {
  const n = Ne(e.date, "D");
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-normal", children: n });
}), xs = g((e) => /* @__PURE__ */ l.jsxs(Cle, { ...e, children: [
  /* @__PURE__ */ l.jsx(Dle, { ...e }),
  /* @__PURE__ */ l.jsx(xle, { ...e })
] })), wle = g((e) => {
  const { state: n } = yle(e);
  switch (n.kind) {
    case "CinReadable":
      return /* @__PURE__ */ l.jsx(xs, { ...n, kind: "CinSelected" });
    case "CoutReadable":
      return /* @__PURE__ */ l.jsx(xs, { ...n, kind: "CoutSelected" });
    case "MiddleDayReadable":
      return /* @__PURE__ */ l.jsx(xs, { ...n, kind: "MiddleDaySelected" });
    case "MiddleDaySelectable":
      return /* @__PURE__ */ l.jsx(xs, { ...n, kind: "SelectableMiddleDay" });
    case "Selectable":
      return /* @__PURE__ */ l.jsx(xs, { ...n, kind: "SelectableDay" });
    case "NotSelectable":
      return /* @__PURE__ */ l.jsx(xs, { ...n, kind: "NotSelectableDay" });
    default:
      return /* @__PURE__ */ l.jsx(xs, { ...n, kind: "DifferentMonthDay" });
  }
}), Ple = ({ yearMonth: e }) => ({
  dateListForMonth: v(() => {
    var o, d;
    const { firstDate: i, lastDate: t } = gt(e), a = Hv({ startDate: i, endDate: t }).map((c) => ({
      date: c,
      isDifferentMonth: !1
    })), s = Rle((o = a[0]) == null ? void 0 : o.date), r = Tle((d = a[a.length - 1]) == null ? void 0 : d.date);
    return [...s, ...a, ...r];
  }, [e])
}), Rle = (e) => {
  if (P(e)) return [];
  const n = [], i = Fd({ date: e });
  if (i !== 0)
    for (let t = i; t > 0; t--) {
      const a = La({ date: e, amount: t + 1 });
      n.push({ date: a, isDifferentMonth: !0 });
    }
  return n;
}, Tle = (e) => {
  if (P(e)) return [];
  const n = [], i = Fd({ date: e });
  if (i !== 6) {
    let t = 0;
    for (let a = i; a < 6; a++) {
      t++;
      const s = Ci({ date: e, inc: t });
      n.push({ date: s, isDifferentMonth: !0 });
    }
  }
  return n;
}, jle = g((e) => {
  const { dateListForMonth: n } = Ple({ yearMonth: e.state.currentYearMonth });
  return /* @__PURE__ */ l.jsx("div", { className: "ch-grid ch-grid-cols-7 ch-place-content-center ch-py-1", children: n.map((i, t) => {
    const a = `${e.state.kind}-${i.date}-${t}`;
    switch (e.state.kind) {
      case "StayDateDisplayable":
        return /* @__PURE__ */ l.jsx(
          wle,
          {
            date: i.date,
            isDifferentMonth: i.isDifferentMonth,
            ...e.state
          },
          a
        );
      case "DayTripDateDisplayable":
        return /* @__PURE__ */ l.jsx(
          Sle,
          {
            date: i.date,
            isDifferentMonth: i.isDifferentMonth,
            ...e.state
          },
          a
        );
      default:
        return null;
    }
  }) });
});
var qu;
((e) => {
  e.ForDefault = ["日", "月", "火", "水", "木", "金", "土"], e.ForEn = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
})(qu || (qu = {}));
const Ale = g(({ text: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-medium ch-text-gray-400", children: e })), Ole = g((e) => {
  const n = v(() => {
    switch (e.state.sessionStateContext.lang) {
      case D.Default:
        return qu.ForDefault;
      case D.En:
        return qu.ForEn;
      default:
        throw new Error("Invalid lang code.");
    }
  }, [e.state.sessionStateContext.lang]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-grid ch-grid-cols-7 ch-place-content-center ch-py-2", children: n.map((i, t) => /* @__PURE__ */ l.jsx("div", { className: "ch-py-[2px] ch-text-center", children: /* @__PURE__ */ l.jsx(Ale, { text: i }) }, t)) });
}), Ele = g((e) => {
  const { onShowLoadingScreenCallback: n, onHideLoadingScreenCallback: i } = fn(), t = I(async () => {
    le(Pn({ target: "calendar.next" })), n(), await e.onSubmitCallback().finally(() => {
      i();
    });
  }, [i, n, e]);
  return /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", onClick: t, children: /* @__PURE__ */ l.jsx(zl, { size: "lg" }) });
}), Jle = g((e) => {
  const n = v(() => kC(e.currentYearMonth), [e.currentYearMonth]), { onShowLoadingScreenCallback: i, onHideLoadingScreenCallback: t } = fn(), a = I(async () => {
    n || (le(Pn({ target: "calendar.prev" })), i(), await e.onSubmitCallback().finally(() => {
      t();
    }));
  }, [n, t, i, e]);
  return /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", disabled: n, onClick: a, children: /* @__PURE__ */ l.jsx(
    lm,
    {
      className: ce(n ? "ch-fill-gray-400" : "ch-fill-current"),
      size: "lg"
    }
  ) });
}), _le = g((e) => {
  const n = v(() => {
    switch (e.state.sessionStateContext.lang) {
      case D.Default:
        return Ne(e.state.currentYearMonth, "YYYY年MM月");
      case D.En:
        return Ne(e.state.currentYearMonth, "MMM YYYY", "en");
      default:
        throw new Error("Invalid lang code.");
    }
  }, [e.state.currentYearMonth, e.state.sessionStateContext.lang]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-2xl ch-font-normal ch-text-black ch-opacity-80", children: n }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-4", children: [
      /* @__PURE__ */ l.jsx(
        Jle,
        {
          lang: e.state.sessionStateContext.lang,
          currentYearMonth: e.state.currentYearMonth,
          onSubmitCallback: e.state.onPrevMonth
        }
      ),
      /* @__PURE__ */ l.jsx(
        Ele,
        {
          lang: e.state.sessionStateContext.lang,
          onSubmitCallback: e.state.onNextMonth
        }
      )
    ] })
  ] });
}), Qle = g((e) => {
  const { state: n } = kle(e);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-4 ch-pb-4 ch-pt-6", children: [
    /* @__PURE__ */ l.jsx(_le, { state: n }),
    /* @__PURE__ */ l.jsxs("div", { children: [
      /* @__PURE__ */ l.jsx(Ole, { state: n }),
      /* @__PURE__ */ l.jsx(jle, { state: n })
    ] }),
    /* @__PURE__ */ l.jsx(hle, { state: n })
  ] });
}), Mle = (e) => {
  var m;
  const n = v(() => {
    var p;
    const f = ((p = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : p.stayStartDt) || Id();
    return Ne(f, "YYYY-MM-DD");
  }, [(m = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : m.stayStartDt]), [i, t] = se(n), a = I(
    (f) => async () => {
      await e.onUpdateReservationStayDt({ stayStartDt: f, stayLastDt: f }), await e.onAvailableStayStartDateListQuery(i)(), e.onSelectCinDtCallback(f);
    },
    [i, e]
  ), s = v(() => e.availableStayDateList.find((f) => {
    if (f.__typename === "AvailableStayStartDate")
      return f.currentViewState === Un.Cout;
  }), [e.availableStayDateList]), r = I(
    (f) => async () => {
      !P(s) && await e.onRemoveReservationStayDt(), await e.onAvailableStayLastDateListQuery(i)(f)(), e.onSelectCinDtCallback(f);
    },
    [s, i, e]
  ), o = I(
    (f) => (p) => async () => {
      await e.onUpdateReservationStayDt({
        stayStartDt: f,
        stayLastDt: Ci({ date: p, inc: -1 })
      }), await e.onAvailableStayStartDateListQuery(i)(), e.onSelectCoutDtCallback(p);
    },
    [i, e]
  ), d = v(() => e.availableStayDateList.find((f) => f.__typename === "AvailableStayStartDate" ? f.currentViewState === Un.Cin : f.currentViewState === Rt.Cin), [e.availableStayDateList]), c = I(async () => {
    const f = nl({ date: i, amount: -1 }), p = !P(d), h = !P(s);
    p && !h ? await e.onAvailableStayLastDateListQuery(f)(d.date)() : await e.onAvailableStayStartDateListQuery(f)(), t(f);
  }, [d, s, i, e]), u = I(async () => {
    const f = nl({ date: i, amount: 1 }), p = !P(d), h = !P(s);
    p && !h ? await e.onAvailableStayLastDateListQuery(f)(d.date)() : await e.onAvailableStayStartDateListQuery(f)(), t(f);
  }, [d, s, i, e]), k = I(async () => {
    var p, h;
    if (
      /** 日帰りかつ Cin 選択済み・Cout 未選択の場合は Cout 候補を取得 */
      e.sessionStateContext.reservationPolicy.isDayTrip && !P((p = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : p.stayStartDt) && P((h = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : h.stayLastDt)
    ) {
      await e.onAvailableStayLastDateListQuery(i)(
        e.sessionStateContext.currentState.dateInfo.stayStartDt
      )();
      return;
    }
    const f = await e.onInitialStayStartDateListQuery();
    t(f.initialDate);
  }, [i, e]);
  return {
    currentYearMonth: i,
    onSelectDayTripDt: a,
    onSelectCinDt: r,
    onSelectCoutDt: o,
    onPrevMonth: c,
    onNextMonth: u,
    onInitialize: k
  };
}, Kh = g((e) => {
  const {
    availableStayDateList: n,
    onAvailableStayStartDateListQuery: i,
    onAvailableStayLastDateListQuery: t,
    onInitialStayStartDateListQuery: a
  } = nle(e), { onUpdateReservationStayDt: s } = ile(e), { onInitialize: r, ...o } = Mle({
    ...e,
    availableStayDateList: n,
    onAvailableStayStartDateListQuery: i,
    onAvailableStayLastDateListQuery: t,
    onInitialStayStartDateListQuery: a,
    onUpdateReservationStayDt: s
  });
  return /* @__PURE__ */ l.jsx(ule, { modelContext: { ...e, onInitialize: r }, children: /* @__PURE__ */ l.jsx("div", { className: "ch-px-5", children: /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-max-w-[350px]", children: /* @__PURE__ */ l.jsx(
    Qle,
    {
      ...e,
      ...o,
      availableStayDateList: n
    }
  ) }) }) });
}), Lle = (e) => e.sessionStateContext.currentState.groupInfo.length < e.availableGroup.maximumGroupNum ? {
  kind: "Selectable",
  onSelect: e.onAddGroup,
  sessionStateContext: {
    lang: e.sessionStateContext.lang
  }
} : {
  kind: "NotSelectable",
  sessionStateContext: {
    lang: e.sessionStateContext.lang
  }
}, $le = (e) => ({
  state: v(() => Lle(e), [e])
}), Ule = g(({ modelContext: e }) => {
  const { state: n } = $le(e), { onShowLoadingScreenCallback: i, onHideLoadingScreenCallback: t } = fn(), a = I(async () => {
    n.kind === "Selectable" && (i(), await n.onSelect().finally(() => {
      t();
    }));
  }, [t, i, n]), s = v(() => n.sessionStateContext.lang === D.Default ? "部屋を追加する" : "Add a room", [n.sessionStateContext.lang]), r = v(() => n.kind === "NotSelectable", [n.kind]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: r, size: "icon", variant: "minimal", onClick: a, children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1", children: [
    /* @__PURE__ */ l.jsx(AP, { size: "md" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: s })
  ] }) });
}), Vle = (e) => D.Default === e.lang ? {
  kind: "Displayable"
} : {
  kind: "NotDisplayable"
}, Hle = (e) => ({
  state: v(() => Vle(e), [e])
}), zle = ({ modelContext: e }) => {
  const { state: n } = Hle(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: "名" }) : null;
}, Ble = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "大人" : "Adults", [e.lang]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-base", children: n });
}, Yh = g(
  ({
    keyPrefix: e,
    //
    value: n,
    onChange: i,
    optionList: t
  }) => /* @__PURE__ */ l.jsxs(n1, { onValueChange: i, value: String(n), children: [
    /* @__PURE__ */ l.jsx(cs, { children: /* @__PURE__ */ l.jsx("div", { className: "ch-text-base ch-font-light", children: n }) }),
    /* @__PURE__ */ l.jsx(us, { children: t.map((a, s) => {
      const r = `${e}_${a}_${s}`;
      return /* @__PURE__ */ l.jsx(ms, { value: String(a), children: a }, r);
    }) })
  ] })
), qle = g(({ availableGroup: e, adultNum: n, kidsNum: i, sessionStateContext: t, callbackContext: a }) => {
  const s = v(() => {
    const u = e.maximumAdultNumPerGroup, k = e.maximumChildNumPerGroup, m = e.maximumTotalNumPerGroup;
    if (m >= u + k)
      return u;
    const f = m - i.length;
    return f <= 0 ? 1 : f < u ? f : u;
  }, [
    e.maximumAdultNumPerGroup,
    e.maximumChildNumPerGroup,
    e.maximumTotalNumPerGroup,
    i.length
  ]), r = v(() => {
    const u = ja(s + 1);
    return u.shift(), u;
  }, [s]), { onShowLoadingScreenCallback: o, onHideLoadingScreenCallback: d } = fn(), c = I(
    async (u) => {
      o(), await a.onChangeAdultNum(Number(u)).finally(() => {
        d();
      });
    },
    [a, d, o]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-gap-x-3", children: [
    /* @__PURE__ */ l.jsx(Ble, { sessionStateContext: t }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-space-x-2", children: [
      /* @__PURE__ */ l.jsx(
        Yh,
        {
          keyPrefix: "adult-num",
          optionList: r,
          value: n,
          onChange: c
        }
      ),
      /* @__PURE__ */ l.jsx(zle, { modelContext: { lang: t.lang } })
    ] })
  ] });
}), Gle = (e) => e.groupInfoLength >= 2 ? {
  kind: "GroupNumDisplayable",
  lang: e.lang,
  groupNum: e.groupNum
} : {
  kind: "GroupNumNotDisplayable",
  lang: e.lang
}, Wle = (e) => ({
  state: v(() => Gle(e), [e])
}), Kle = ({ modelContext: e }) => {
  const { state: n } = Wle(e);
  return n.kind === "GroupNumDisplayable" ? /* @__PURE__ */ l.jsx("p", { children: n.groupNum }) : null;
}, Yle = ({ sessionStateContext: e, groupInfoLength: n, groupNum: i }) => {
  const t = v(() => e.lang === D.Default ? "部屋" : "Room", [e.lang]), a = vs(e);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-space-x-1 ch-text-lg ch-font-semibold ch-text-black", children: [
    a ? null : /* @__PURE__ */ l.jsx("p", { children: t }),
    /* @__PURE__ */ l.jsx(Kle, { modelContext: { groupInfoLength: n, groupNum: i, lang: e.lang } })
  ] });
}, Xle = (e) => D.Default === e.lang ? {
  kind: "Displayable"
} : {
  kind: "NotDisplayable"
}, Zle = (e) => ({
  state: v(() => Xle(e), [e])
}), ese = ({ modelContext: e }) => {
  const { state: n } = Zle(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: "歳" }) : null;
}, nse = ({ kidsIdx: e, sessionStateContext: n }) => {
  const i = v(() => e + 1, [e]), t = v(() => n.lang === D.Default ? `子ども（年齢）${i} 人目` : `Child ${i} (age)`, [i, n.lang]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm", children: t });
}, ise = g(({ selectableChildAges: e, kidsAge: n, kidsIdx: i, onChangeKidsAge: t }) => {
  const { onShowLoadingScreenCallback: a, onHideLoadingScreenCallback: s } = fn(), r = I(
    async (o) => {
      a(), await t(Number(o)).finally(() => {
        s();
      });
    },
    [t, s, a]
  );
  return /* @__PURE__ */ l.jsx(
    Yh,
    {
      keyPrefix: `kids-age-${i}`,
      value: n,
      onChange: r,
      optionList: e
    }
  );
});
function tse({
  maximumCoSleepingAge: e,
  kidsAge: n
}) {
  return P(e) ? !1 : n <= e;
}
const ase = (e) => tse({
  maximumCoSleepingAge: e.availableGroup.maximumCoSleepingAge,
  kidsAge: e.kidsAge
}) ? {
  kind: "Selectable",
  asCosleeping: e.asCosleeping,
  onChangeAsCosleeping: e.onUpdateAsCosleeping
} : {
  kind: "NotSelectable"
}, lse = (e) => ({
  state: v(() => ase(e), [e])
}), sse = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "添い寝に設定する" : "Set as cosleeping", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: n });
}, rse = g(({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = lse(n), { onShowLoadingScreenCallback: t, onHideLoadingScreenCallback: a } = fn(), s = I(
    async (o) => {
      i.kind === "Selectable" && (t(), await i.onChangeAsCosleeping(o).finally(() => {
        a();
      }));
    },
    [a, t, i]
  ), r = v(() => e.lang === D.Default, [e.lang]);
  return i.kind === "NotSelectable" ? null : /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: ce(
        "ch-flex ch-items-center ch-justify-between ch-gap-x-1 ch-pl-4",
        r ? "ch-pr-6" : null
        // 他のインプットと右端を揃えるためのスペース
      ),
      children: [
        /* @__PURE__ */ l.jsx(sse, { sessionStateContext: e }),
        /* @__PURE__ */ l.jsx(pv, { checked: i.asCosleeping, onCheckedChange: s })
      ]
    }
  );
}), ose = ({
  kidsIdx: e,
  selectableChildAges: n,
  availableGroup: i,
  kidsItem: t,
  sessionStateContext: a,
  callbackContext: s
}) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-pl-4", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx(nse, { kidsIdx: e, sessionStateContext: a }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-space-x-2", children: [
      /* @__PURE__ */ l.jsx(
        ise,
        {
          kidsIdx: e,
          selectableChildAges: n,
          kidsAge: t.age,
          onChangeKidsAge: s.onChangeKidsAge(e),
          sessionStateContext: a
        }
      ),
      /* @__PURE__ */ l.jsx(ese, { modelContext: { lang: a.lang } })
    ] })
  ] }),
  /* @__PURE__ */ l.jsx(
    rse,
    {
      modelContext: {
        asCosleeping: t.asCosleeping,
        kidsAge: t.age,
        availableGroup: i,
        onUpdateAsCosleeping: s.onChangeKidsAsCoSleeping(e)
      },
      sessionStateContext: a
    }
  )
] }), dse = (e) => D.Default === e.lang ? {
  kind: "Displayable"
} : {
  kind: "NotDisplayable"
}, cse = (e) => ({
  state: v(() => dse(e), [e])
}), use = ({ modelContext: e }) => {
  const { state: n } = cse(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: "名" }) : null;
}, mse = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "子ども" : "Children", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: n });
}, kse = (e) => P(e.maximumChildAge) ? {
  kind: "NotDisplayable"
} : {
  kind: "Displayable",
  maximumChildAge: e.maximumChildAge
}, fse = (e) => ({
  state: v(() => kse(e), [e])
}), vse = ({ state: e, sessionStateContext: n }) => {
  const i = v(() => n.lang === D.Default ? `~ ${e.maximumChildAge} 歳` : `Up to ${e.maximumChildAge} years`, [n.lang, e.maximumChildAge]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-gray-400", children: i });
}, hse = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = fse(n);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsx(vse, { sessionStateContext: e, state: i }) : null;
}, pse = ({ sessionStateContext: e, maximumChildAge: n }) => /* @__PURE__ */ l.jsxs("label", { className: "ch-flex ch-items-center ch-space-x-3", children: [
  /* @__PURE__ */ l.jsx(mse, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(
    hse,
    {
      sessionStateContext: e,
      modelContext: { maximumChildAge: n }
    }
  )
] }), Nse = g(({ adultNum: e, availableGroup: n, kidsNum: i, sessionStateContext: t, callbackContext: a }) => {
  const s = v(() => {
    const k = n.maximumAdultNumPerGroup, m = n.maximumChildNumPerGroup, f = n.maximumTotalNumPerGroup;
    if (f >= k + m)
      return m;
    const p = f - e;
    return p < m ? p : m;
  }, [
    e,
    n.maximumAdultNumPerGroup,
    n.maximumChildNumPerGroup,
    n.maximumTotalNumPerGroup
  ]), r = v(() => ja(s + 1), [s]), { onShowLoadingScreenCallback: o, onHideLoadingScreenCallback: d } = fn(), c = I(
    async (k) => {
      o(), await a.onChangeKidsNum(Number(k)).finally(() => {
        d();
      });
    },
    [a, d, o]
  ), u = v(() => i.length, [i.length]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-space-x-3", children: [
    /* @__PURE__ */ l.jsx(
      pse,
      {
        sessionStateContext: t,
        maximumChildAge: n.maximumChildAge
      }
    ),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-space-x-2", children: [
      /* @__PURE__ */ l.jsx(
        Yh,
        {
          keyPrefix: "kids-num",
          optionList: r,
          value: u,
          onChange: c
        }
      ),
      /* @__PURE__ */ l.jsx(use, { modelContext: { lang: t.lang } })
    ] })
  ] });
}), Sse = (e) => e.groupInfoLength > 1 ? {
  kind: "Displayable",
  onSelect: e.onRemoveGroup,
  lang: e.lang
} : {
  kind: "NotDisplayable"
}, gse = (e) => ({
  state: v(() => Sse(e), [e])
}), Fse = ({ state: e }) => {
  const { onShowLoadingScreenCallback: n, onHideLoadingScreenCallback: i } = fn(), t = I(async () => {
    n(), await e.onSelect().finally(() => {
      i();
    });
  }, [i, n, e]), a = v(() => e.lang === D.Default ? "削除する" : "Delete", [e.lang]);
  return /* @__PURE__ */ l.jsx(
    ae,
    {
      className: "ch-text-sm ch-font-semibold",
      variant: "underline",
      size: "sm",
      onClick: t,
      children: a
    }
  );
}, Ise = g(({ modelContext: e }) => {
  const { state: n } = gse(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx(Fse, { state: n }) : null;
}), yse = g(
  ({
    availableGroup: e,
    groupInfoLength: n,
    groupNum: i,
    adultNum: t,
    kidsNum: a,
    sessionStateContext: s,
    callbackContext: r
  }) => {
    const { selectableChildAges: o, maximumChildNumPerGroup: d } = e, c = !P(o) && !ke(o), u = d > 0 || a.length > 0;
    return /* @__PURE__ */ l.jsxs("div", { className: ce("ch-space-y-6 ch-pb-5"), children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-start ch-justify-between", children: [
        /* @__PURE__ */ l.jsx(
          Yle,
          {
            sessionStateContext: s,
            groupInfoLength: n,
            groupNum: i
          }
        ),
        /* @__PURE__ */ l.jsx(
          Ise,
          {
            modelContext: {
              groupInfoLength: n,
              onRemoveGroup: r.onRemoveGroup,
              lang: s.lang
            }
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx(
        qle,
        {
          sessionStateContext: s,
          availableGroup: e,
          adultNum: t,
          kidsNum: a,
          callbackContext: r
        }
      ),
      u ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
        /* @__PURE__ */ l.jsx(
          Nse,
          {
            availableGroup: e,
            adultNum: t,
            kidsNum: a,
            sessionStateContext: s,
            callbackContext: r
          }
        ),
        c ? /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6", children: a.map((k, m) => {
          const f = `kids-age-${m}`;
          return /* @__PURE__ */ l.jsx(
            ose,
            {
              kidsIdx: m,
              kidsItem: k,
              selectableChildAges: o,
              availableGroup: e,
              sessionStateContext: s,
              callbackContext: r
            },
            f
          );
        }) }) : null
      ] }) : null
    ] });
  }
), bse = (e) => ({
  kind: "NotInitialized",
  onAvailableGroup: e.onAvailableGroup
}), I7 = () => (e) => ({
  kind: "Initialized",
  availableGroup: e.availableGroup
}), y7 = (e) => ({
  kind: "Errored",
  onAvailableGroup: e.onAvailableGroup
}), Cse = ({ state: e, onChangeState: n }) => {
  be(() => {
    e.kind === "NotInitialized" && e.onAvailableGroup().then((i) => {
      n(I7()({ availableGroup: i }));
    }).catch(() => {
      n(y7(e));
    });
  }, [n, e]);
}, xse = ({ onChangeState: e }) => ({
  onReInitialize: I(
    (i) => async () => {
      try {
        const t = await i.onAvailableGroup();
        e(I7(i)({ availableGroup: t }));
      } catch (t) {
        e(y7(i));
      }
    },
    [e]
  )
}), Dse = (e) => {
  const [n, i] = se(bse(e)), t = I((s) => {
    i(s);
  }, []);
  Cse({ state: n, onChangeState: t });
  const { onReInitialize: a } = xse({ onChangeState: t });
  return {
    state: n,
    onReInitialize: a
  };
}, wse = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = I(async () => {
    le(Pn({ target: "refetch", area: "group" })), await n.onRefetch();
  }, [n]), t = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: i, children: t });
}, Pse = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "選択可能な人数の情報が正しく取得できませんでした。" : "The information on the number of people that can be selected could not be obtained correctly.", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, Rse = ({ sessionStateContext: e, callbackContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-py-8 ch-text-center", children: [
  /* @__PURE__ */ l.jsx(Pse, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(wse, { sessionStateContext: e, callbackContext: n })
] }), Tse = () => /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-6 ch-bg-white ch-px-5 ch-py-6", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-h-6 ch-w-[74px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-3", children: Array.from({ length: 2 }).map((e, n) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-6 ch-w-[101px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-9 ch-w-[101px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" })
  ] }, n)) }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-border-t" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-justify-end", children: /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-[156px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" }) })
  ] })
] }), jse = g(({ children: e, sessionStateContext: n, ...i }) => {
  const { state: t, onReInitialize: a } = Dse(i);
  return t.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(Tse, {}) : t.kind === "Errored" ? /* @__PURE__ */ l.jsx(
    Rse,
    {
      sessionStateContext: n,
      callbackContext: { onRefetch: a(t) }
    }
  ) : e({ state: t });
}), Ase = Ve(
  /* GraphQL */
  `
	mutation RCGroupAdd($baseInfo: BaseInfoInput!) {
		groupAdd(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Ose = Ve(
  /* GraphQL */
  `
	mutation RCGroupUpdate($baseInfo: BaseInfoInput!, $groupInfo: [GroupUpdateInput!]!) {
		groupUpdate(baseInfo: $baseInfo, groupInfo: $groupInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Ese = Ve(
  /* GraphQL */
  `
	query RCGroupAvailable($baseInfo: BaseInfoInput!) {
		groupAvailable(baseInfo: $baseInfo) {
			availableGroup {
				minimumGroupNum
				maximumGroupNum
				maximumTotalNumPerGroup
				maximumAdultNumPerGroup
				maximumChildNumPerGroup
				maximumChildAge
				selectableChildAges
				maximumCoSleepingAge
			}
		}
	}
`
), Jse = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(Ase);
  return {
    onAddReservationGroup: I(async () => {
      const { data: t } = await n({
        variables: { baseInfo: e.baseInfoInput }
      });
      e.onUpdateSession(t.groupAdd), le(
        yn({
          target: "group",
          action: "add"
        })
      );
    }, [n, e])
  };
}, _se = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(Ose), i = I(
    async (d, c = "update") => {
      const { data: u } = await n({
        variables: { baseInfo: e.baseInfoInput, groupInfo: d }
      });
      e.onUpdateSession(u.groupUpdate), le(
        yn({
          target: "group",
          action: c,
          adult_num: d.reduce((k, m) => k + m.adultNum, 0),
          kids_num: d.reduce((k, m) => k + m.kidsNum.length, 0)
        })
      );
    },
    [n, e]
  ), t = I(
    (d) => async (c) => {
      const u = e.currentState.groupInfo.map(
        (k) => k.uniqueRoomID === d ? {
          ...k,
          adultNum: c
        } : k
      );
      await i(u);
    },
    [i, e.currentState.groupInfo]
  ), a = I(
    (d) => (c) => async (u) => {
      const m = ja(u).map(() => {
        var p;
        return {
          age: (p = d.maximumChildAge) != null ? p : 0,
          asCosleeping: !1
        };
      }), f = e.currentState.groupInfo.map(
        (p) => p.uniqueRoomID === c ? {
          ...p,
          kidsNum: m
        } : p
      );
      await i(f);
    },
    [i, e.currentState.groupInfo]
  ), s = I(
    (d) => (c) => (u) => async (k) => {
      const m = e.currentState.groupInfo.map(
        (f) => f.uniqueRoomID === c ? {
          ...f,
          kidsNum: f.kidsNum.map(
            (p, h) => h === u ? {
              ...p,
              age: k,
              asCosleeping: !P(d.maximumCoSleepingAge) && p.age >= d.maximumCoSleepingAge ? p.asCosleeping : !1
            } : p
          )
        } : f
      );
      await i(m);
    },
    [i, e.currentState.groupInfo]
  ), r = I(
    (d) => (c) => async (u) => {
      const k = e.currentState.groupInfo.map(
        (m) => m.uniqueRoomID === d ? {
          ...m,
          kidsNum: m.kidsNum.map(
            (f, p) => p === c ? {
              ...f,
              asCosleeping: u
            } : f
          )
        } : m
      );
      await i(k);
    },
    [i, e.currentState.groupInfo]
  ), o = I(
    (d) => async () => {
      if (e.currentState.groupInfo.length > 1) {
        const c = e.currentState.groupInfo.filter(
          (u) => u.uniqueRoomID !== d
        );
        await i(c, "remove");
      }
    },
    [i, e.currentState.groupInfo]
  );
  return {
    onChangeAdultNum: t,
    onChangeKidsNum: a,
    onChangeKidsAge: s,
    onChangeKidsAsCoSleeping: r,
    onRemoveGroup: o
  };
}, Qse = () => {
  const { baseInfoInput: e } = lt(), { refetch: n } = qn(Ese, void 0, !0);
  return {
    onAvailableGroupQuery: I(async () => {
      const { data: t } = await n({ baseInfo: e });
      return t.groupAvailable.availableGroup;
    }, [n, e])
  };
}, Xh = ({ sessionStateContext: e }) => {
  const { onAvailableGroupQuery: n } = Qse(), { onAddReservationGroup: i } = Jse({ sessionStateContext: e }), { onChangeAdultNum: t, onChangeKidsAge: a, onChangeKidsAsCoSleeping: s, onChangeKidsNum: r, onRemoveGroup: o } = _se({ sessionStateContext: e }), d = !vs(e);
  return /* @__PURE__ */ l.jsx(jse, { sessionStateContext: e, onAvailableGroup: n, children: ({ state: c }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-flex-col ch-gap-y-4 ch-px-5 ch-py-6", children: [
    /* @__PURE__ */ l.jsx("div", { className: d ? "ch-w-full ch-space-y-5 ch-border-b" : "ch-w-full ch-space-y-5", children: e.currentState.groupInfo.map(({ adultNum: u, uniqueRoomID: k, kidsNum: m }, f) => {
      const p = f + 1;
      return /* @__PURE__ */ l.jsx(
        yse,
        {
          groupNum: p,
          groupInfoLength: e.currentState.groupInfo.length,
          adultNum: u,
          kidsNum: m,
          availableGroup: c.availableGroup,
          sessionStateContext: e,
          callbackContext: {
            onChangeAdultNum: t(k),
            onChangeKidsAge: a(c.availableGroup)(k),
            onChangeKidsAsCoSleeping: s(k),
            onChangeKidsNum: r(c.availableGroup)(k),
            onRemoveGroup: o(k)
          }
        },
        k
      );
    }) }),
    d ? /* @__PURE__ */ l.jsx("div", { className: "ch-text-right", children: /* @__PURE__ */ l.jsx(
      Ule,
      {
        modelContext: {
          sessionStateContext: e,
          availableGroup: c.availableGroup,
          onAddGroup: i
        }
      }
    ) }) : null
  ] }) });
}, Mse = Ve(
  /* GraphQL */
  `
	query SelectInlineDateDateCoutAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateCoutAvailableInput!) {
		dateCoutAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			availableCoutDates {
				date
				currentViewState
				selectable
				available
				dailyMinimumPrice
			}
		}
	}
`
), Lse = Ve(
  /* GraphQL */
  `
	query SelectInlineDateDateStayStartAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateStayStartAvailableInput!) {
		dateStayStartAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			availableStayStartDates {
				date
				currentViewState
				selectable
				available
				dailyMinimumPrice
			}
		}
	}
`
), $se = Ve(
  /* GraphQL */
  `
	query SelectInlineDateInitialize($baseInfo: BaseInfoInput!) {
		metaData(baseInfo: $baseInfo) {
			metaData {
				isDayTrip
			}
		}
		staticPriceDataAvailable(baseInfo: $baseInfo) {
			availableStaticPriceData {
				planBillingPricePerDate
				planBillingPricePerReservation
				requiredOptionBillingMinimumPricePerDate
				requiredOptionBillingMinimumPricePerReservation
			}
		}
		dateStayStartAvailableInitial(baseInfo: $baseInfo) {
			availableStayStartDates {
				date
				currentViewState
				selectable
				available
				dailyMinimumPrice
			}
		}
	}
`
), Use = Ve(
  /* GraphQL */
  `
	mutation EditDateDateRemove($baseInfo: BaseInfoInput!) {
		dateRemove(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Vse = Ve(
  /* GraphQL */
  `
	mutation EditDateDateUpdate($baseInfo: BaseInfoInput!, $dateInfo: DateUpdateInput!) {
		dataUpdate(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Hse = ({ baseInfoInput: e, onSetAvailableCoutDateList: n }) => {
  const i = I(
    (s) => (r) => (o) => {
      if (Ht({ targetDate: s, compareDate: r })) {
        const { lastDate: c } = gt(s);
        return {
          stayStartDt: o,
          endDt: c
        };
      }
      const { lastDate: d } = gt(r);
      return {
        stayStartDt: o,
        endDt: d
      };
    },
    []
  ), { refetch: t } = qn(
    Mse,
    void 0,
    !0
  );
  return {
    onAvailableCoutDateListQuery: I(
      (s) => (r) => async () => {
        const o = i(s.from)(s.to)(r), { data: d } = await t({
          baseInfo: e,
          dateInfo: o
        });
        n(d.dateCoutAvailable.availableCoutDates);
      },
      [i, t, e, n]
    )
  };
}, zse = ({ baseInfoInput: e, onSetAvailableStayStartDateList: n }) => {
  const i = I(
    (s) => (r) => {
      if (Ht({ targetDate: s, compareDate: r })) {
        const { firstDate: c, lastDate: u } = gt(s);
        return {
          startDt: c,
          endDt: u
        };
      }
      const { firstDate: o } = gt(s), { lastDate: d } = gt(r);
      return {
        startDt: o,
        endDt: d
      };
    },
    []
  ), { refetch: t } = qn(
    Lse,
    void 0,
    !0
  );
  return {
    onAvailableStayStartDateListQuery: I(
      (s) => async () => {
        const r = i(s.from)(s.to), { data: o } = await t({
          baseInfo: e,
          dateInfo: r
        });
        n(o.dateStayStartAvailable.availableStayStartDates);
      },
      [i, e, n, t]
    )
  };
}, Bse = () => {
  const [e, n] = se([]), i = I((c) => {
    n(c);
  }, []), [t, a] = se([]), s = I((c) => {
    a(c);
  }, []), { baseInfoInput: r } = lt(), { onAvailableStayStartDateListQuery: o } = zse({
    baseInfoInput: r,
    onSetAvailableStayStartDateList: i
  }), { onAvailableCoutDateListQuery: d } = Hse({
    baseInfoInput: r,
    onSetAvailableCoutDateList: s
  });
  return {
    availableStayStartDateList: e,
    availableCoutDateList: t,
    onAvailableStayStartDateListQuery: o,
    onAvailableCoutDateListQuery: d
  };
}, qse = () => {
  const { baseInfoInput: e } = lt(), { refetch: n } = qn($se, void 0, !0);
  return {
    onInitializeDataQuery: I(async () => {
      const { data: t } = await n({ baseInfo: e });
      return {
        metaData: t.metaData.metaData,
        availableStaticPriceData: t.staticPriceDataAvailable.availableStaticPriceData,
        initialAvailableStayStartDates: t.dateStayStartAvailableInitial.availableStayStartDates
      };
    }, [e, n])
  };
}, Gse = () => {
  const { lang: e } = u1(), { reservationPolicy: n } = Ua(), { dateInfo: i } = Lr();
  return {
    lang: e,
    reservationPolicy: n,
    currentState: {
      dateInfo: i
    }
  };
}, Wse = ({ baseInfoInput: e, onUpdateSession: n }) => {
  const { mutationFunc: i } = Gn(Use);
  return {
    onRemoveReservationStayDt: I(async () => {
      const { data: a } = await i({
        variables: { baseInfo: e }
      });
      n(a.dateRemove), le(
        yn({
          target: "date",
          action: "remove"
        })
      );
    }, [e, i, n])
  };
}, Kse = ({ baseInfoInput: e, onUpdateSession: n }) => {
  const { mutationFunc: i } = Gn(Vse);
  return {
    onUpdateReservationStayDt: I(
      async (a) => {
        const { data: s } = await i({
          variables: { baseInfo: e, dateInfo: a }
        });
        n(s.dataUpdate), le(
          yn({
            target: "date",
            action: "update",
            ...S7(a)
          })
        );
      },
      [e, i, n]
    )
  };
}, Yse = () => {
  const { baseInfoInput: e } = lt(), { onUpdateSession: n } = Ji(), { onRemoveReservationStayDt: i } = Wse({ baseInfoInput: e, onUpdateSession: n }), { onUpdateReservationStayDt: t } = Kse({ baseInfoInput: e, onUpdateSession: n });
  return {
    onRemoveReservationStayDt: i,
    onUpdateReservationStayDt: t
  };
}, Xse = g(() => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: ce(
      "ch-h-fit ch-max-h-80 ch-min-h-80 ch-w-full ch-animate-pulse ch-rounded-md ch-border-2 ch-border-zinc-200 ch-bg-zinc-300/70"
    )
  }
)), b7 = (e) => e.kind === "NotInitialized" ? {
  kind: "Errored",
  tryCount: 0,
  onRetry: e.onInitialize
} : {
  ...e,
  tryCount: e.tryCount + 1
}, Zse = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitializeDataQuery
}), C7 = () => (e) => ({
  kind: "Initialized",
  metaData: e.metaData,
  availableStaticPriceData: e.availableStaticPriceData,
  initialAvailableStayStartDates: e.initialAvailableStayStartDates
}), e1e = ({ state: e, callbackContext: n }) => {
  const i = I(
    async (a) => {
      try {
        const s = await a.onInitialize();
        n.onChangeState(C7(a)(s));
      } catch (s) {
        n.onChangeState(b7(a));
      }
    },
    [n]
  ), t = Ye(!1);
  be(() => {
    t.current || e.kind !== "NotInitialized" || (t.current = !0, i(e));
  }, [i, e]);
}, n1e = (e) => {
  const { addError: n } = Uv();
  return {
    onRetry: I(
      async (t) => {
        if (t.tryCount >= 3) {
          n("ブラウザを再読み込みしてください");
          return;
        }
        try {
          const a = await t.onRetry();
          e.callbackContext.onChangeState(C7(t)(a));
        } catch (a) {
          e.callbackContext.onChangeState(b7(t));
        }
      },
      [n, e.callbackContext]
    )
  };
}, i1e = (e) => {
  const [n, i] = se(Zse(e)), t = I((s) => {
    i(s);
  }, []);
  e1e({ state: n, callbackContext: { onChangeState: t } });
  const { onRetry: a } = n1e({ callbackContext: { onChangeState: t } });
  return {
    state: n,
    onRetry: a
  };
}, t1e = g(({ children: e, ...n }) => {
  const {
    state: i
    // onRetry
  } = i1e(n);
  return i.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(Xse, {}) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(l.Fragment, {}) : e({
    metaData: i.metaData,
    availableStaticPriceData: i.availableStaticPriceData,
    initialAvailableStayStartDates: i.initialAvailableStayStartDates
  });
}), x7 = g((e) => {
  const {
    availableStayStartDateList: n,
    availableCoutDateList: i,
    onAvailableStayStartDateListQuery: t,
    onAvailableCoutDateListQuery: a
  } = Bse(), s = Gse(), { onRemoveReservationStayDt: r, onUpdateReservationStayDt: o } = Yse(), { onInitializeDataQuery: d } = qse(), c = I(
    (f) => async (p) => {
      await o({ stayStartDt: p, stayLastDt: p }), await t(f)();
    },
    [t, o]
  ), u = I(
    (f) => async (p) => {
      await a(f)(p)();
    },
    [a]
  ), k = I(
    (f) => (p) => async (h) => {
      await o({
        stayStartDt: p,
        stayLastDt: h
      }), await t(f)();
    },
    [t, o]
  ), m = I(
    async (f) => {
      await r(), await t(f)();
    },
    [t, r]
  );
  return /* @__PURE__ */ l.jsx(t1e, { onInitializeDataQuery: d, children: ({ metaData: f, initialAvailableStayStartDates: p }) => {
    var h, N, S, F;
    return /* @__PURE__ */ l.jsx(
      K5,
      {
        className: e.className,
        forceSingleCalendar: e.forceSingleCalendar,
        initialDate: p[0].date,
        onAvailableStayLastDateListQuery: a,
        onAvailableStayStartDateListQuery: t,
        modelContext: {
          lang: s.lang,
          isDayTrip: f.isDayTrip,
          stayStartDt: (N = (h = s.currentState.dateInfo) == null ? void 0 : h.stayStartDt) != null ? N : null,
          stayLastDt: (F = (S = s.currentState.dateInfo) == null ? void 0 : S.stayLastDt) != null ? F : null,
          onSelectDayTripDateCallback: c,
          onSelectDayTripUnSelectableDateCallback: m,
          onSelectStayCinDateCallback: u,
          onSelectStayCoutDateCallback: k,
          onSelectStayUnSelectableDateCallback: m
        },
        calendarContext: {
          sessionStateContext: s,
          availableStayStartDateList: n.length > 0 ? n : p,
          availableCoutDateList: i
        }
      }
    );
  } });
}), a1e = Ve(
  /* GraphQL */
  `
	mutation SelectOptionOptionUpdate($baseInfo: BaseInfoInput!, $optionInfo: OptionUpdateInput!) {
		optionUpdate(baseInfo: $baseInfo, optionInfo: $optionInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), D7 = ({ sessionStateContext: e, isInputEventPushedByCaller: n = !1 }) => {
  const { mutationFunc: i } = Gn(a1e);
  return {
    onUpdateOptionAmount: I(
      ({ optionID: a }) => ({ subOptionID: s, date: r }) => async (o) => {
        const { data: d } = await i({
          variables: {
            baseInfo: e.baseInfoInput,
            optionInfo: {
              optionID: a,
              subOptionID: s,
              date: r,
              amount: o
            }
          }
        });
        e.onUpdateSession(d.optionUpdate), !n && le(
          yn({
            target: "option",
            action: "update",
            option_id: a,
            quantity: o
          })
        );
      },
      [i, e, n]
    )
  };
};
function l1e(e) {
  return e.__typename === "OptionBillingPerReservation";
}
function s1e(e) {
  return e.__typename === "OptionBillingPerDate";
}
function r1e(e) {
  return e.__typename === "SubOptionBillingPerDate";
}
const o1e = (e) => {
  const n = e.option.detail;
  return s1e(n) ? {
    kind: "OptionBillingPerDateInfoDisplayable",
    optionDetail: n
  } : l1e(n) ? {
    kind: "OptionBillingPerReservationInfoDisplayable",
    optionDetail: n
  } : r1e(n) ? {
    kind: "SubOptionBillingPerDateInfoDisplayable",
    optionDetail: n
  } : {
    kind: "SubOptionBillingPerReservationInfoDisplayable",
    optionDetail: n
  };
}, d1e = (e) => ({
  state: v(() => o1e(e), [e])
}), w7 = ({ children: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-text-urgent-400", children: e }), qd = ({ lang: e, amount: n }) => {
  const i = v(() => e === D.Default ? `${n}つ以上の選択が必要です` : `At least ${n} selection is required.`, [e, n]);
  return /* @__PURE__ */ l.jsx(w7, { children: i });
}, c1e = ({ lang: e, amount: n }) => {
  const i = v(() => e === D.Default ? `合計${n}以下になるように選択してください` : `Please select less than ${n}.`, [e, n]);
  return /* @__PURE__ */ l.jsx(w7, { children: i });
}, u1e = (e) => {
  var t, a;
  const n = (a = (t = e.sessionStateContext.currentState.optionPerDateInfo.willReserve.find(
    (s) => (s == null ? void 0 : s.optionID) === e.option.optionID && s.date === e.date
  )) == null ? void 0 : t.amount) != null ? a : 0;
  return !e.option.isRequired || e.optionDetail.minimumSoldAmount === 0 || n >= e.optionDetail.minimumSoldAmount ? {
    kind: "NotDisplayable"
  } : {
    kind: "TooFewSelectionsMessageDisplayable",
    amount: e.optionDetail.minimumSoldAmount,
    lang: e.sessionStateContext.lang
  };
}, m1e = (e) => ({
  state: v(() => u1e(e), [e])
}), k1e = ({ modelContext: e }) => {
  const { state: n } = m1e(e);
  return n.kind === "TooFewSelectionsMessageDisplayable" ? /* @__PURE__ */ l.jsx(qd, { lang: n.lang, amount: n.amount }) : null;
}, f1e = ({ lang: e, date: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold", children: i });
}, v1e = (e) => e.optionDetail.isNextMorning ? {
  kind: "Displayable",
  lang: e.lang
} : {
  kind: "NotDisplayable"
}, h1e = (e) => ({
  state: v(() => v1e(e), [e])
}), p1e = ({ modelContext: e }) => {
  const { state: n } = h1e(e), i = v(() => {
    if (n.kind === "Displayable")
      return n.lang === D.Default ? "翌朝" : "Next morning";
  }, [n]);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-medium", children: i }) : null;
}, N1e = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "選択する" : "Select an option", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: n });
}, S1e = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = v(() => e.lang === D.Default ? "閉じる" : "Close", [e.lang]), t = I(() => {
    n.onCloseAccordion();
  }, [n]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-sticky ch-bottom-24 ch-flex ch-justify-center", children: /* @__PURE__ */ l.jsx(ae, { variant: "float", onClick: t, children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-1", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-semibold", children: i }),
    /* @__PURE__ */ l.jsx(sI, { size: "xs" })
  ] }) }) });
}, p9 = "option-selector-item", N9 = "", p2 = ({ sessionStateContext: e, displayContext: n, contentContext: i }) => {
  const t = v(() => n.isRequiredOption ? p9 : N9, [n.isRequiredOption]), [a, s] = se(t), r = I((d) => {
    s(d);
  }, []), o = I(() => {
    s(N9);
  }, []);
  return /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, value: a, onValueChange: r, children: /* @__PURE__ */ l.jsxs(it, { value: p9, borderBottom: !1, children: [
    /* @__PURE__ */ l.jsx(tt, { className: "ch-flex-none ch-gap-x-2 ch-px-0 ch-py-2.5", hover: !1, children: /* @__PURE__ */ l.jsx(N1e, { sessionStateContext: e }) }),
    /* @__PURE__ */ l.jsxs(at, { className: "ch-h-full ch-space-y-3 ch-overflow-clip ch-px-0 ch-py-3 tablet:ch-px-0", children: [
      i.contentSlot,
      i.displayCloseButton ? /* @__PURE__ */ l.jsx(
        S1e,
        {
          sessionStateContext: e,
          callbackContext: {
            onCloseAccordion: o
          }
        }
      ) : null
    ] })
  ] }) });
}, g1e = ({ lang: e }) => v(() => e === D.Default ? "１団体あたり" : "per group", [e]), F1e = ({ lang: e }) => v(() => e === D.Default ? "1個あたり" : "per item", [e]), I1e = ({ lang: e }) => v(() => e === D.Default ? "1名あたり" : "per person", [e]), y1e = ({ lang: e }) => v(() => e === D.Default ? "1名（子供のみ）あたり" : "per person (kids only)", [e]), b1e = ({ lang: e }) => v(() => e === D.Default ? "1部屋あたり" : "per room", [e]), P7 = ({ lang: e, priceTarget: n, optionType: i }) => {
  if (i === Zs.Goods)
    return /* @__PURE__ */ l.jsx(F1e, { lang: e });
  if (n === Qt.Group)
    return /* @__PURE__ */ l.jsx(g1e, { lang: e });
  if (n === Qt.Person)
    return /* @__PURE__ */ l.jsx(I1e, { lang: e });
  if (n === Qt.Room)
    return /* @__PURE__ */ l.jsx(b1e, { lang: e });
  if (n === Qt.PersonOnlyKids)
    return /* @__PURE__ */ l.jsx(y1e, { lang: e });
}, R7 = ({ price: e, isPriceRange: n }) => v(() => `¥ ${e.toLocaleString()}${n ? "~" : ""}`, [n, e]), sd = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-gap-x-2", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: /* @__PURE__ */ l.jsx(
    P7,
    {
      lang: e.lang,
      priceTarget: n.option.billingTypeTarget,
      optionType: n.option.optionType
    }
  ) }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: /* @__PURE__ */ l.jsx(R7, { isPriceRange: !1, price: n.optionPrice }) })
] }), C1e = ({ displayContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-start", children: [
  /* @__PURE__ */ l.jsx("h4", { className: "ch-space-x-1 ch-text-lg ch-font-semibold", children: e.name }),
  e.isRequired ? /* @__PURE__ */ l.jsx(sm, { size: "3xs", className: "ch-text-urgent-400" }) : null
] }), x1e = (e) => e.optionType !== Zs.Goods ? {
  kind: "Displayable",
  isDayTrip: e.isDayTrip,
  priceType: e.priceType
} : {
  kind: "NotDisplayable"
}, D1e = (e) => ({
  state: v(() => x1e(e), [e])
}), w1e = ({ lang: e }) => v(() => e === D.Default ? "１日ごと" : "per date", [e]), P1e = ({ lang: e }) => v(() => e === D.Default ? "予約ごと" : "per reservation", [e]), R1e = ({ lang: e, priceType: n }) => {
  if (n === nt.PerDate)
    return /* @__PURE__ */ l.jsx(w1e, { lang: e });
  if (n === nt.PerReservation)
    return /* @__PURE__ */ l.jsx(P1e, { lang: e });
}, T1e = ({ lang: e }) => v(() => e === D.Default ? "１泊ごと" : "per night", [e]), j1e = ({ lang: e }) => v(() => e === D.Default ? "予約ごと" : "per reservation", [e]), A1e = ({ lang: e, priceType: n }) => {
  if (n === nt.PerDate)
    return /* @__PURE__ */ l.jsx(T1e, { lang: e });
  if (n === nt.PerReservation)
    return /* @__PURE__ */ l.jsx(j1e, { lang: e });
}, O1e = ({ lang: e, isDayTrip: n, priceType: i }) => n ? /* @__PURE__ */ l.jsx(R1e, { lang: e, priceType: i }) : /* @__PURE__ */ l.jsx(A1e, { lang: e, priceType: i }), E1e = ({ lang: e, modelContext: n }) => {
  const { state: i } = D1e(n);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsx(O1e, { lang: e, isDayTrip: i.isDayTrip, priceType: i.priceType }) : null;
}, J1e = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-gap-x-2", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-gap-x-0.5 ch-text-base", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-flex", children: /* @__PURE__ */ l.jsx(
      E1e,
      {
        lang: e.lang,
        modelContext: {
          isDayTrip: n.isDayTrip,
          priceType: n.option.billingTypeTerm,
          optionType: n.option.optionType
        }
      }
    ) }),
    /* @__PURE__ */ l.jsx("p", { children: /* @__PURE__ */ l.jsx(
      P7,
      {
        lang: e.lang,
        priceTarget: n.option.billingTypeTarget,
        optionType: n.option.optionType
      }
    ) })
  ] }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: /* @__PURE__ */ l.jsx(R7, { isPriceRange: n.isSubOption, price: n.optionPrice }) })
] }), _1e = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "もっとみる" : "Read more", [e.lang]), Q1e = (e) => ke(e.cancelPolicy) ? {
  kind: "NotDisplayable"
} : {
  kind: "Displayable",
  cancelPolicy: e.cancelPolicy,
  lang: e.sessionStateContext.lang
}, M1e = (e) => ({
  state: v(() => Q1e(e), [e])
}), L1e = (e) => e.cancelPolicyItem.beforeDays === 0 ? {
  kind: "OnTheDayInfoDisplayable",
  cancelPolicyItem: e.cancelPolicyItem,
  lang: e.lang
} : {
  kind: "BeforeOnTheDayInfoDisplayable",
  cancelPolicyItem: e.cancelPolicyItem,
  lang: e.lang
}, $1e = (e) => ({
  state: v(() => L1e(e), [e])
}), U1e = ({ lang: e, cancelPolicyItem: n }) => {
  const i = v(() => e === D.Default ? `ご利用日の${n.beforeDays}日前 00時00分以降: 税込オプション料金の${n.chargeRatio}%` : `Before ${n.beforeDays} days of use date 00:00:00: ${n.chargeRatio}% of tax-included option fee`, [n.beforeDays, n.chargeRatio, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: i });
}, V1e = ({ lang: e, cancelPolicyItem: n }) => {
  const i = v(() => e === D.Default ? `ご利用日 当日 00時00分から: 税込オプション料金の${n.chargeRatio}%` : `On the day of use: ${n.chargeRatio}% of tax-included option fee`, [n.chargeRatio, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-medium", children: i });
}, H1e = ({ modelContext: e }) => {
  const { state: n } = $1e(e);
  return n.kind === "OnTheDayInfoDisplayable" ? /* @__PURE__ */ l.jsx(V1e, { lang: n.lang, cancelPolicyItem: n.cancelPolicyItem }) : /* @__PURE__ */ l.jsx(U1e, { lang: n.lang, cancelPolicyItem: n.cancelPolicyItem });
}, z1e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "キャンセルポリシー" : "Cancel Policy", [e]);
  return /* @__PURE__ */ l.jsx("h4", { className: "ch-text-base", children: n });
}, B1e = ({ displayContext: e, modelContext: n }) => {
  const { state: i } = M1e(n);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-rounded-md ch-bg-gray-100 ch-p-4", children: [
    /* @__PURE__ */ l.jsx(z1e, { lang: i.lang }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-1", children: i.cancelPolicy.map((t, a) => {
      const s = `${e.optionID}_${t.beforeDays}_${a}`;
      return /* @__PURE__ */ l.jsx(
        H1e,
        {
          modelContext: {
            cancelPolicyItem: t,
            lang: i.lang
          }
        },
        s
      );
    }) })
  ] }) : null;
}, q1e = (e) => e.description.length >= 1 ? {
  kind: "DescriptionDisplayable",
  description: e.description
} : {
  kind: "DescriptionNotDisplayable"
}, G1e = (e) => ({
  state: v(() => q1e(e), [e])
}), W1e = ({ modelContext: e }) => {
  const { state: n } = G1e(e);
  return n.kind === "DescriptionDisplayable" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-black ch-opacity-90", children: n.description }) : null;
}, K1e = ({ sessionStateContext: e, displayContext: n }) => {
  const { close: i, isOpen: t, handleOpenChange: a } = ks(), { optionID: s, optionPrice: r, name: o } = n, d = I(
    (u) => {
      u && (qv({
        itemID: s,
        name: o,
        category: "option",
        price: r
      }).forEach(bt), le(Pn({ target: "option.detail" }))), a(u);
    },
    [a, o, s, r]
  ), c = I(
    (u) => {
      u.stopPropagation(), i();
    },
    [i]
  );
  return /* @__PURE__ */ l.jsxs(fl, { open: t, onOpenChange: d, children: [
    /* @__PURE__ */ l.jsx(Et, { className: "ch-py-1.5 ch-text-base ch-font-medium ch-underline ch-decoration-1 ch-underline-offset-4", children: /* @__PURE__ */ l.jsx(_1e, { sessionStateContext: e }) }),
    /* @__PURE__ */ l.jsxs(
      vl,
      {
        className: "ch-h-drawer-almost-full ch-max-h-drawer-almost-full ch-font-system-ui",
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ l.jsx(y5, { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-border-b ch-px-5 ch-pb-3 ch-pt-2.5", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
            /* @__PURE__ */ l.jsx(yt, { className: "ch-text-xl ch-font-semibold", children: n.name }),
            /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", onClick: c, children: /* @__PURE__ */ l.jsx(Ei, { size: "md" }) })
          ] }) }),
          /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-space-y-8 ch-overflow-y-scroll ch-overscroll-y-contain ch-whitespace-pre-wrap ch-px-5 ch-py-8 ch-text-left", children: [
            /* @__PURE__ */ l.jsx(W1e, { modelContext: { description: n.description } }),
            /* @__PURE__ */ l.jsx(
              B1e,
              {
                displayContext: n,
                modelContext: { sessionStateContext: e, cancelPolicy: n.cancelPolicy }
              }
            )
          ] })
        ]
      }
    )
  ] });
}, Y1e = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-line-clamp-2 ch-whitespace-pre-wrap ch-text-base", children: n.description }),
  /* @__PURE__ */ l.jsx(K1e, { sessionStateContext: e, displayContext: n })
] }), N2 = g(({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-sticky ch-top-[70px] ch-mt-6 ch-space-y-1 ch-bg-white", children: [
    /* @__PURE__ */ l.jsx(C1e, { displayContext: n.option }),
    /* @__PURE__ */ l.jsx(
      J1e,
      {
        sessionStateContext: e,
        displayContext: n
      }
    )
  ] }),
  /* @__PURE__ */ l.jsx(
    Y1e,
    {
      sessionStateContext: e,
      displayContext: {
        description: n.option.description,
        optionID: n.option.optionID,
        optionPrice: n.optionPrice,
        cancelPolicy: n.option.cancelPolicy,
        name: n.option.name
      }
    }
  )
] })), X1e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "在庫なし" : "No stock", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-shrink-0 ch-text-base ch-font-bold", children: n });
}, rd = g(
  ({
    lang: e,
    labelChildren: n,
    //
    keyPrefix: i,
    availableItemList: t,
    value: a,
    onChangeItem: s
  }) => {
    const { onShowLoadingScreenCallback: r, onHideLoadingScreenCallback: o } = fn(), d = I(
      async (c) => {
        r(), await s(Number(c)).finally(() => {
          o();
        });
      },
      [s, o, r]
    );
    return P(t) ? /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-justify-between ch-gap-x-3", children: [
      n,
      /* @__PURE__ */ l.jsx(X1e, { lang: e })
    ] }) : /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-justify-between ch-gap-x-3 ch-pr-1", children: [
      n,
      /* @__PURE__ */ l.jsxs(n1, { value: String(a), onValueChange: d, children: [
        /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(cs, { className: "ch-w-fit", children: /* @__PURE__ */ l.jsx("div", { children: a }) }) }),
        /* @__PURE__ */ l.jsx(us, { children: t.map((c, u) => {
          const k = `${i}_${c}_${u}`;
          return /* @__PURE__ */ l.jsx(ms, { value: String(c), children: c }, k);
        }) })
      ] })
    ] });
  }
), Z1e = ({ sessionStateContext: e, displayContext: n, callbackContext: i }) => {
  const t = I(
    ({ date: a }) => {
      var s, r;
      return (r = (s = e.currentState.optionPerDateInfo.willReserve.find(
        (o) => (o == null ? void 0 : o.optionID) === n.option.optionID && o.date === a
      )) == null ? void 0 : s.amount) != null ? r : 0;
    },
    [n.option.optionID, e.currentState.optionPerDateInfo.willReserve]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-py-6", children: [
    /* @__PURE__ */ l.jsx(
      Ut,
      {
        modelContext: { imageUrls: n.imageUrls },
        styleContext: { borderRadius: "12px" }
      }
    ),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
      /* @__PURE__ */ l.jsx(
        N2,
        {
          sessionStateContext: e,
          displayContext: {
            ...n,
            isSubOption: !1,
            optionPrice: n.optionDetail.price
          }
        }
      ),
      /* @__PURE__ */ l.jsx(
        p2,
        {
          sessionStateContext: e,
          displayContext: { isRequiredOption: n.option.isRequired },
          contentContext: {
            displayCloseButton: !1,
            contentSlot: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-8", children: n.optionDetail.dailyItems.map((a, s) => {
              var c;
              const r = `${a.date}_${n.optionDetail.__typename}_${a.__typename}_${s}`, o = t({ date: a.date }), d = i.onUpdateOptionAmount({
                subOptionID: void 0,
                date: a.date
              });
              return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
                /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-2", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
                  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
                    /* @__PURE__ */ l.jsx(
                      f1e,
                      {
                        lang: e.lang,
                        date: a.date
                      }
                    ),
                    /* @__PURE__ */ l.jsx(
                      k1e,
                      {
                        modelContext: {
                          sessionStateContext: e,
                          optionDetail: n.optionDetail,
                          option: n.option,
                          date: a.date
                        }
                      }
                    )
                  ] }),
                  /* @__PURE__ */ l.jsx(
                    p1e,
                    {
                      modelContext: {
                        lang: e.lang,
                        optionDetail: n.optionDetail
                      }
                    }
                  )
                ] }) }),
                /* @__PURE__ */ l.jsx(
                  rd,
                  {
                    lang: e.lang,
                    labelChildren: /* @__PURE__ */ l.jsx(
                      sd,
                      {
                        sessionStateContext: e,
                        displayContext: {
                          isDayTrip: n.isDayTrip,
                          optionPrice: n.optionDetail.price,
                          option: n.option
                        }
                      }
                    ),
                    keyPrefix: r,
                    availableItemList: (c = a.availableChoices) != null ? c : void 0,
                    value: o,
                    onChangeItem: d
                  }
                )
              ] }, r);
            }) })
          }
        }
      )
    ] })
  ] });
}, ere = (e) => !e.option.isRequired || e.optionDetail.minimumSoldAmount === 0 || e.selectedAmount >= e.optionDetail.minimumSoldAmount ? {
  kind: "NotDisplayable"
} : {
  kind: "TooFewSelectionsMessageDisplayable",
  amount: e.optionDetail.minimumSoldAmount,
  lang: e.lang
}, nre = (e) => ({
  state: v(() => ere(e), [e])
}), ire = ({ modelContext: e }) => {
  const { state: n } = nre(e);
  return n.kind === "TooFewSelectionsMessageDisplayable" ? /* @__PURE__ */ l.jsx(qd, { lang: n.lang, amount: n.amount }) : null;
}, tre = g(({ sessionStateContext: e, displayContext: n, callbackContext: i }) => {
  var s, r;
  const t = v(() => {
    var o, d;
    return (d = (o = e.currentState.optionPerReservationInfo.willReserve.find(
      (c) => (c == null ? void 0 : c.optionID) === n.option.optionID
    )) == null ? void 0 : o.amount) != null ? d : 0;
  }, [n.option.optionID, e.currentState.optionPerReservationInfo.willReserve]), a = I(
    async (o) => {
      await i.onUpdateOptionAmount({
        subOptionID: void 0,
        date: ""
      })(o);
    },
    [i]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-py-6", children: [
    /* @__PURE__ */ l.jsx(
      Ut,
      {
        modelContext: { imageUrls: n.imageUrls },
        styleContext: { borderRadius: "12px" }
      }
    ),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
      /* @__PURE__ */ l.jsx(
        N2,
        {
          sessionStateContext: e,
          displayContext: {
            ...n,
            isSubOption: !1,
            optionPrice: n.optionDetail.price
          }
        }
      ),
      /* @__PURE__ */ l.jsx(
        p2,
        {
          sessionStateContext: e,
          displayContext: { isRequiredOption: n.option.isRequired },
          contentContext: {
            displayCloseButton: !1,
            contentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
              /* @__PURE__ */ l.jsx(
                ire,
                {
                  modelContext: {
                    lang: e.lang,
                    optionDetail: n.optionDetail,
                    selectedAmount: t,
                    option: n.option
                  }
                }
              ),
              /* @__PURE__ */ l.jsx(
                rd,
                {
                  lang: e.lang,
                  labelChildren: /* @__PURE__ */ l.jsx(
                    sd,
                    {
                      sessionStateContext: e,
                      displayContext: {
                        ...n,
                        optionPrice: n.optionDetail.price
                      }
                    }
                  ),
                  keyPrefix: (s = n.optionDetail.__typename) != null ? s : "",
                  availableItemList: (r = n.optionDetail.availableChoices) != null ? r : void 0,
                  value: t,
                  onChangeItem: a
                }
              )
            ] })
          }
        }
      )
    ] })
  ] });
}), are = (e) => {
  const n = e.sessionStateContext.lang;
  if (e.option.isRequired) {
    const t = e.subOptionItem.subOptionItems.map(
      (a) => {
        var s, r;
        return (r = (s = e.sessionStateContext.currentState.optionPerDateInfo.willReserve.find(
          (o) => (o == null ? void 0 : o.optionID) === e.option.optionID && o.date === e.subOptionItem.date && o.subOptionID === a.subOptionID
        )) == null ? void 0 : s.amount) != null ? r : 0;
      }
    ).reduce((a, s) => a + s, 0);
    if (t < e.optionDetail.minimumSoldAmount)
      return {
        kind: "TooFewSelectionsMessageDisplayable",
        amount: e.optionDetail.minimumSoldAmount,
        lang: n
      };
    if (t > e.subOptionItem.maxSoldAmount)
      return {
        kind: "TooManySelectionsMessageDisplayable",
        amount: e.subOptionItem.maxSoldAmount,
        lang: n
      };
  }
  return {
    kind: "NotDisplayable"
  };
}, lre = (e) => ({
  state: v(() => are(e), [e])
}), sre = ({ modelContext: e }) => {
  const { state: n } = lre(e);
  return n.kind === "TooFewSelectionsMessageDisplayable" ? /* @__PURE__ */ l.jsx(qd, { lang: n.lang, amount: n.amount }) : n.kind === "TooManySelectionsMessageDisplayable" ? /* @__PURE__ */ l.jsx(c1e, { lang: n.lang, amount: n.amount }) : null;
}, rre = ({ lang: e, date: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold", children: i });
}, ore = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "翌朝" : "Next morning", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold", children: n });
}, dre = (e) => e.isShowTimeSchedule && !Ke(e.startAt) && !Ke(e.endAt) ? {
  kind: "Displayable",
  startAt: e.startAt,
  endAt: e.endAt
} : {
  kind: "NotDisplayable"
}, cre = (e) => ({
  state: v(() => dre(e), [e])
}), S9 = g(({ modelContext: e }) => {
  const { state: n } = cre(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsxs("p", { className: "ch-text-base", children: [
    n.startAt,
    "~",
    n.endAt
  ] }) : null;
}), ure = g(
  ({
    sessionStateContext: e,
    displayContext: n,
    callbackContext: i
  }) => {
    const t = v(() => {
      var s;
      return (s = n.optionDetail.dailyItems.map((r) => r.subOptionItems.map((o) => o.price)).flat().sort(Hx).at(0)) != null ? s : 0;
    }, [n.optionDetail.dailyItems]), a = I(
      ({ date: s, subOptionID: r }) => {
        var o, d;
        return (d = (o = e.currentState.optionPerDateInfo.willReserve.find(
          (c) => (c == null ? void 0 : c.optionID) === n.option.optionID && c.date === s && c.subOptionID === r
        )) == null ? void 0 : o.amount) != null ? d : 0;
      },
      [n.option.optionID, e.currentState.optionPerDateInfo.willReserve]
    );
    return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-py-6", children: [
      /* @__PURE__ */ l.jsx(
        Ut,
        {
          modelContext: { imageUrls: n.imageUrls },
          styleContext: { borderRadius: "12px" }
        }
      ),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
        /* @__PURE__ */ l.jsx(
          N2,
          {
            sessionStateContext: e,
            displayContext: { ...n, isSubOption: !0, optionPrice: t }
          }
        ),
        /* @__PURE__ */ l.jsx(
          p2,
          {
            sessionStateContext: e,
            displayContext: { isRequiredOption: n.option.isRequired },
            contentContext: {
              displayCloseButton: !0,
              contentSlot: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-16", children: n.optionDetail.dailyItems.map((s, r) => {
                const o = `${s.date}_${n.optionDetail.__typename}_${s.__typename}_${r}`, d = s.subOptionItems.filter(
                  (u) => !u.isNextMorning
                ), c = s.subOptionItems.filter(
                  (u) => u.isNextMorning
                );
                return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
                  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
                    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
                      /* @__PURE__ */ l.jsx(
                        rre,
                        {
                          lang: e.lang,
                          date: s.date
                        }
                      ),
                      /* @__PURE__ */ l.jsx(
                        sre,
                        {
                          modelContext: {
                            sessionStateContext: e,
                            option: n.option,
                            optionDetail: n.optionDetail,
                            subOptionItem: s
                          }
                        }
                      )
                    ] }),
                    /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-12", children: d.map((u, k) => {
                      var N, S, F, y;
                      const m = `${o}_${u.subOptionID}_${u.__typename}_${k}`, f = a({
                        subOptionID: u.subOptionID,
                        date: s.date
                      }), p = i.onUpdateOptionAmount({
                        subOptionID: u.subOptionID,
                        date: s.date
                      }), h = u.price > 0;
                      return /* @__PURE__ */ l.jsx(
                        rd,
                        {
                          lang: e.lang,
                          labelChildren: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
                            /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: u.name }),
                            /* @__PURE__ */ l.jsx(
                              S9,
                              {
                                modelContext: {
                                  isShowTimeSchedule: (N = u.isShowTimeSchedule) != null ? N : null,
                                  startAt: (S = u.startAt) != null ? S : null,
                                  endAt: (F = u.endAt) != null ? F : null
                                }
                              }
                            ),
                            h ? /* @__PURE__ */ l.jsx(
                              sd,
                              {
                                sessionStateContext: e,
                                displayContext: {
                                  isDayTrip: n.isDayTrip,
                                  optionPrice: u.price,
                                  option: n.option
                                }
                              }
                            ) : null
                          ] }),
                          keyPrefix: m,
                          availableItemList: (y = u.availableChoices) != null ? y : void 0,
                          value: f,
                          onChangeItem: p
                        },
                        m
                      );
                    }) })
                  ] }),
                  c.length > 0 ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
                    /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-items-center ch-justify-between", children: /* @__PURE__ */ l.jsx(
                      ore,
                      {
                        lang: e.lang
                      }
                    ) }),
                    /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: c.map((u, k) => {
                      var N, S, F, y;
                      const m = `${o}_${u.subOptionID}_${u.__typename}_${k}`, f = a({
                        subOptionID: u.subOptionID,
                        date: s.date
                      }), p = i.onUpdateOptionAmount({
                        subOptionID: u.subOptionID,
                        date: s.date
                      }), h = u.price > 0;
                      return /* @__PURE__ */ l.jsx(
                        rd,
                        {
                          lang: e.lang,
                          labelChildren: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
                            /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: u.name }),
                            /* @__PURE__ */ l.jsx(
                              S9,
                              {
                                modelContext: {
                                  isShowTimeSchedule: (N = u.isShowTimeSchedule) != null ? N : null,
                                  startAt: (S = u.startAt) != null ? S : null,
                                  endAt: (F = u.endAt) != null ? F : null
                                }
                              }
                            ),
                            h ? /* @__PURE__ */ l.jsx(
                              sd,
                              {
                                sessionStateContext: e,
                                displayContext: {
                                  isDayTrip: n.isDayTrip,
                                  optionPrice: u.price,
                                  option: n.option
                                }
                              }
                            ) : null
                          ] }),
                          keyPrefix: m,
                          availableItemList: (y = u.availableChoices) != null ? y : void 0,
                          value: f,
                          onChangeItem: p
                        },
                        m
                      );
                    }) })
                  ] }) : null
                ] }, o);
              }) })
            }
          }
        )
      ] })
    ] });
  }
), mre = (e) => {
  const n = e.sessionStateContext.lang;
  if (e.option.isRequired) {
    const t = e.optionDetail.items.map(
      (a) => {
        var s, r;
        return (r = (s = e.sessionStateContext.currentState.optionPerReservationInfo.willReserve.find(
          (o) => (o == null ? void 0 : o.subOptionID) === a.subOptionID
        )) == null ? void 0 : s.amount) != null ? r : 0;
      }
    ).reduce((a, s) => a + s, 0);
    if (t < e.optionDetail.minimumSoldAmount)
      return {
        kind: "TooFewSelectionsMessageDisplayable",
        amount: e.optionDetail.minimumSoldAmount,
        lang: n
      };
    if (t > e.optionDetail.maxSoldAmount)
      return {
        kind: "TooManySelectionsMessageDisplayable",
        amount: e.optionDetail.maxSoldAmount,
        lang: n
      };
  }
  return {
    kind: "NotDisplayable"
  };
}, kre = (e) => ({
  state: v(() => mre(e), [e])
}), fre = ({ modelContext: e }) => {
  const { state: n } = kre(e);
  return n.kind === "TooFewSelectionsMessageDisplayable" ? /* @__PURE__ */ l.jsx(qd, { lang: n.lang, amount: n.amount }) : null;
}, vre = (e) => e.isShowTimeSchedule && !Ke(e.startAt) && !Ke(e.endAt) ? {
  kind: "Displayable",
  startAt: e.startAt,
  endAt: e.endAt
} : {
  kind: "NotDisplayable"
}, hre = (e) => ({
  state: v(() => vre(e), [e])
}), pre = g(({ modelContext: e }) => {
  const { state: n } = hre(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsxs("p", { className: "ch-text-sm", children: [
    n.startAt,
    "~",
    n.endAt
  ] }) : null;
}), Nre = g(
  ({
    sessionStateContext: e,
    displayContext: n,
    callbackContext: i
  }) => {
    const t = v(() => {
      var s;
      return (s = n.optionDetail.items.map((r) => r.price).sort(Hx).at(0)) != null ? s : 0;
    }, [n.optionDetail.items]), a = I(
      ({ subOptionID: s }) => {
        var r, o;
        return (o = (r = e.currentState.optionPerReservationInfo.willReserve.find(
          (d) => (d == null ? void 0 : d.optionID) === n.option.optionID && d.subOptionID === s
        )) == null ? void 0 : r.amount) != null ? o : 0;
      },
      [n.option.optionID, e.currentState.optionPerReservationInfo.willReserve]
    );
    return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-py-6", children: [
      /* @__PURE__ */ l.jsx(
        Ut,
        {
          modelContext: { imageUrls: n.imageUrls },
          styleContext: { borderRadius: "12px" }
        }
      ),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
        /* @__PURE__ */ l.jsx(
          N2,
          {
            sessionStateContext: e,
            displayContext: { ...n, isSubOption: !0, optionPrice: t }
          }
        ),
        /* @__PURE__ */ l.jsx(
          p2,
          {
            sessionStateContext: e,
            displayContext: { isRequiredOption: n.option.isRequired },
            contentContext: {
              displayCloseButton: !0,
              contentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
                /* @__PURE__ */ l.jsx(
                  fre,
                  {
                    modelContext: {
                      sessionStateContext: e,
                      option: n.option,
                      optionDetail: n.optionDetail
                    }
                  }
                ),
                n.optionDetail.items.map((s, r) => {
                  var u, k, m, f;
                  const o = `${s.subOptionID}_${n.optionDetail.__typename}_${s.__typename}_${r}`, d = a({ subOptionID: s.subOptionID }), c = i.onUpdateOptionAmount({
                    subOptionID: s.subOptionID,
                    date: ""
                  });
                  return /* @__PURE__ */ l.jsx(
                    rd,
                    {
                      lang: e.lang,
                      labelChildren: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
                        /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: s.name }),
                        /* @__PURE__ */ l.jsx(
                          pre,
                          {
                            modelContext: {
                              isShowTimeSchedule: (u = s.isShowTimeSchedule) != null ? u : null,
                              startAt: (k = s.startAt) != null ? k : null,
                              endAt: (m = s.endAt) != null ? m : null
                            }
                          }
                        ),
                        /* @__PURE__ */ l.jsx(
                          sd,
                          {
                            sessionStateContext: e,
                            displayContext: {
                              ...n,
                              optionPrice: s.price
                            }
                          }
                        )
                      ] }),
                      keyPrefix: o,
                      availableItemList: (f = s.availableChoices) != null ? f : void 0,
                      value: d,
                      onChangeItem: c
                    },
                    o
                  );
                })
              ] })
            }
          }
        )
      ] })
    ] });
  }
), Sre = ({ modelContext: e, sessionStateContext: n, displayContext: i, callbackContext: t }) => {
  const { state: a } = d1e(e);
  if (a.kind === "OptionBillingPerDateInfoDisplayable")
    return /* @__PURE__ */ l.jsx(
      Z1e,
      {
        sessionStateContext: n,
        callbackContext: t,
        displayContext: {
          ...i,
          optionDetail: a.optionDetail
        }
      }
    );
  if (a.kind === "OptionBillingPerReservationInfoDisplayable")
    return /* @__PURE__ */ l.jsx(
      tre,
      {
        sessionStateContext: n,
        callbackContext: t,
        displayContext: {
          ...i,
          optionDetail: a.optionDetail
        }
      }
    );
  if (a.kind === "SubOptionBillingPerDateInfoDisplayable")
    return /* @__PURE__ */ l.jsx(
      ure,
      {
        sessionStateContext: n,
        callbackContext: t,
        displayContext: {
          ...i,
          optionDetail: a.optionDetail
        }
      }
    );
  if (a.kind === "SubOptionBillingPerReservationInfoDisplayable")
    return /* @__PURE__ */ l.jsx(
      Nre,
      {
        sessionStateContext: n,
        callbackContext: t,
        displayContext: {
          ...i,
          optionDetail: a.optionDetail
        }
      }
    );
}, T7 = ({ availableOptions: e, sessionStateContext: n }) => {
  const { onUpdateOptionAmount: i } = D7({ sessionStateContext: n });
  return /* @__PURE__ */ l.jsx("div", { className: "ch-relative ch-w-full ch-space-y-8 ch-divide-y ch-px-5", children: e.map((t) => {
    const a = t.optionID;
    return /* @__PURE__ */ l.jsx(
      Sre,
      {
        modelContext: { option: t },
        displayContext: {
          isDayTrip: n.reservationPolicy.isDayTrip,
          imageUrls: t.keyVisuals,
          option: t
        },
        sessionStateContext: n,
        callbackContext: { onUpdateOptionAmount: i({ optionID: a }) }
      },
      a
    );
  }) });
}, Zh = Ve(
  /* GraphQL */
  `
	fragment SelectOptionAvailableOptionsFragment on AvailableOptionsResponse {
		availableOptions {
			optionID
			billingTypeTerm
			billingTypeTarget
			optionType
			name
			description
			isRequired
			isDateTabbedTimeSelectionEnabled
			isDateTabbedTimeSelectionTarget
			isOneOfRequired
			keyVisuals
			cancelPolicy {
				beforeDays
				chargeRatio
			}
			detail {
				... on OptionBillingPerDate {
					isNextMorning
					price
					minimumSoldAmount
					dailyItems {
						date
						availableChoices
					}
				}
				... on OptionBillingPerReservation {
					price
					minimumSoldAmount
					availableChoices
				}
				... on SubOptionBillingPerDate {
					multiSelectAvailable
					minimumSoldAmount
					dailyItems {
						date
						maxSoldAmount
						subOptionItems {
							subOptionID
							name
							price
							availableChoices
							isNextMorning
							startAt
							endAt
							isShowTimeSchedule
						}
					}
				}
				... on SubOptionBillingPerReservation {
					multiSelectAvailable
					maxSoldAmount
					minimumSoldAmount
					items {
						subOptionID
						name
						price
						availableChoices
						startAt
						endAt
						isShowTimeSchedule
					}
				}
			}
		}
	}
`
), gre = Ve(
  /* GraphQL */
  `
	query RCPlanAvailable($baseInfo: BaseInfoInput!) {
		planAvailable(baseInfo: $baseInfo) {
			availablePlans {
				planID
				name
				description
				keyVisuals
				isDayTrip
				includedMeals
				isUnCancelable
				requiredOptions {
					optionID
					optionType
					name
					minimumPrice
					priceType
					priceTarget
					isOneOfRequired
				}
				price
				priceType
				priceTarget
				article
				checkInOutPolicy {
					checkInStartTime
					checkInEndTime
					checkOutEndTime
				}
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					unavailable
					ratio
					static
				}
				minRoomNum
			}
		}
	}
`
), Fre = Ve(
  /* GraphQL */
  `
	mutation RCPlanUpdate($baseInfo: BaseInfoInput!, $planInfo: PlanUpdateInput!) {
		planUpdate(baseInfo: $baseInfo, planInfo: $planInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Ire = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(Fre);
  return {
    onUpdatePlan: I(
      (t) => async () => {
        const { data: a } = await n({
          variables: {
            baseInfo: e.baseInfoInput,
            planInfo: {
              planID: t
            }
          }
        });
        e.onUpdateSession(a.planUpdate), le(
          yn({
            target: "plan",
            action: t === null ? "remove" : "update",
            plan_id: t != null ? t : void 0
          })
        );
      },
      [n, e]
    )
  };
}, yre = !0, bre = ({ sessionStateContext: e }) => {
  const { refetch: n } = qn(gre, {}, yre);
  return {
    onAvailablePlansQuery: I(async () => {
      const { data: t } = await n({
        baseInfo: e.baseInfoInput
      });
      return t.planAvailable.availablePlans;
    }, [n, e.baseInfoInput])
  };
}, Cre = (e) => ({
  kind: "NotInitialized",
  onAvailablePlans: e.onAvailablePlans
}), j7 = () => (e) => ({
  kind: "Initialized",
  availablePlans: e.availablePlans
}), A7 = (e) => ({
  kind: "Errored",
  onAvailablePlans: e.onAvailablePlans
}), xre = ({ state: e, onChangeState: n }) => {
  be(() => {
    e.kind === "NotInitialized" && e.onAvailablePlans().then((i) => {
      n(j7()({ availablePlans: i }));
    }).catch(() => {
      n(A7(e));
    });
  }, [n, e]);
}, Dre = ({ onChangeState: e }) => ({
  onReInitialize: I(
    (i) => async () => {
      try {
        const t = await i.onAvailablePlans();
        e(j7(i)({ availablePlans: t }));
      } catch (t) {
        e(A7(i));
      }
    },
    [e]
  )
}), wre = (e) => {
  const [n, i] = se(Cre(e)), t = I((s) => {
    i(s);
  }, []);
  xre({ state: n, onChangeState: t });
  const { onReInitialize: a } = Dre({ onChangeState: t });
  return {
    state: n,
    onReInitialize: a
  };
}, Pre = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = I(async () => {
    le(Pn({ target: "refetch", area: "plan" })), await n.onRefetch();
  }, [n]), t = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: i, children: t });
}, Rre = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "プランの情報が正しく取得できませんでした。" : "Plan information could not be obtained correctly.", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, Tre = ({ sessionStateContext: e, callbackContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-py-8 ch-text-center", children: [
  /* @__PURE__ */ l.jsx(Rre, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(Pre, { sessionStateContext: e, callbackContext: n })
] }), jre = () => /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-w-full ch-gap-x-3 ch-overflow-hidden ch-bg-gray-100 ch-px-5 ch-py-8", children: Array.from({ length: 3 }).map((e, n) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: "ch-h-96 ch-min-w-[280px] ch-animate-pulse ch-rounded-xl ch-bg-gray-200 ch-p-4"
  },
  n
)) }), Are = g(({ children: e, sessionStateContext: n, ...i }) => {
  const { state: t, onReInitialize: a } = wre(i);
  return t.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(jre, {}) : t.kind === "Errored" ? /* @__PURE__ */ l.jsx(
    Tre,
    {
      sessionStateContext: n,
      callbackContext: { onRefetch: a(t) }
    }
  ) : e({ state: t });
}), Ore = (e) => {
  var i, t;
  return ((t = (i = e.sessionStateContext.currentState.planInfo) == null ? void 0 : i.willReserve) == null ? void 0 : t.planID) === e.availablePlan.planID ? {
    kind: "Selected",
    onUpdatePlan: e.callbackContext.onUpdatePlan(null)
  } : {
    kind: "NotSelected",
    onUpdatePlan: e.callbackContext.onUpdatePlan(e.availablePlan.planID)
  };
}, Ere = (e) => ({
  state: v(() => Ore(e), [e])
}), Jre = (e) => e.isDayTrip ? {
  kind: "Displayable"
} : {
  kind: "NotDisplayable"
}, _re = (e) => ({
  state: v(() => Jre(e), [e])
}), Qre = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = _re(n), t = v(() => e.lang === D.Default ? "日帰り" : "Day trip", [e.lang]);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsx("span", { className: "ch-rounded ch-bg-black/70 ch-px-1 ch-py-0.5 ch-text-xs ch-text-white", children: t }) : null;
}, Mre = (e) => e.minRoomNum >= 2 ? {
  kind: "Displayable"
} : {
  kind: "NotDisplayable"
}, Lre = (e) => ({
  state: v(() => Mre(e), [e])
}), $re = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = Lre(n), t = v(() => e.lang === D.Default ? "複数の部屋選択が必須" : "Multiple rooms required", [e.lang]);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsx("span", { className: "ch-rounded ch-bg-black/70 ch-px-1 ch-py-0.5 ch-text-xs ch-text-white", children: t }) : null;
}, Ure = ({ sessionStateContext: e, displayContext: n }) => (
  // バッジは表示のみ。カード上部の帯がカルーセルのスワイプやカードのクリックを奪わないよう、ポインターイベントを通す
  /* @__PURE__ */ l.jsx("div", { className: "ch-pointer-events-none ch-absolute ch-left-3 ch-right-3 ch-top-3", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-wrap ch-justify-end ch-gap-1.5", children: [
    /* @__PURE__ */ l.jsx($re, { sessionStateContext: e, modelContext: n }),
    /* @__PURE__ */ l.jsx(Qre, { sessionStateContext: e, modelContext: n })
  ] }) })
), Vre = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-relative", children: [
  /* @__PURE__ */ l.jsx(
    Ut,
    {
      modelContext: { imageUrls: n.availablePlan.keyVisuals },
      styleContext: { height: "160px", borderRadius: "12px 12px 0 0" }
    }
  ),
  /* @__PURE__ */ l.jsx(
    Ure,
    {
      sessionStateContext: e,
      displayContext: {
        minRoomNum: n.availablePlan.minRoomNum,
        isDayTrip: n.availablePlan.isDayTrip
      }
    }
  )
] }), Hre = ({ description: e }) => Ke(e) ? {
  kind: "NotDisplayable"
} : {
  kind: "Displayable",
  description: e
}, zre = (e) => ({
  state: v(() => Hre(e), [e])
}), Bre = ({ modelContext: e }) => {
  const { state: n } = zre(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("div", { className: "ch-absolute -ch-top-0.5 ch-w-full", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-relative ch-rounded-lg ch-bg-white ch-px-4 ch-py-3.5", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-line-clamp-2 ch-min-h-8 ch-text-xs", children: n.description }),
    /* @__PURE__ */ l.jsx("div", { className: "before:ch-absolute before:ch-left-1/2 before:ch-top-full before:-ch-translate-x-1/2 before:ch-border-[10px] before:ch-border-transparent before:ch-border-t-white before:ch-content-['']" })
  ] }) }) : null;
}, qre = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "キャンセルポリシー" : "Cancellation Policy", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: n });
}, Gre = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "ご利用日の" : "On the day of", [e.lang]), Wre = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "チェックイン日の" : "On the check-in day of", [e.lang]), Kre = ({ sessionStateContext: e, displayContext: n }) => n.isDayTrip ? /* @__PURE__ */ l.jsx(Gre, { sessionStateContext: e }) : /* @__PURE__ */ l.jsx(Wre, { sessionStateContext: e }), Yre = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "日前" : "days", [e.lang]), Xre = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("p", { children: [
  /* @__PURE__ */ l.jsx(Kre, { sessionStateContext: e, displayContext: n }),
  n.beforeDays,
  /* @__PURE__ */ l.jsx(Yre, { sessionStateContext: e })
] }), Zre = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "税込プラン料金の" : "Including tax plan fee", [e.lang]), eoe = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "％" : "%", [e.lang]), noe = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("p", { children: [
  /* @__PURE__ */ l.jsx(Zre, { sessionStateContext: e }),
  n.chargeRatio,
  /* @__PURE__ */ l.jsx(eoe, { sessionStateContext: e })
] }), ioe = "：", toe = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-1.5", children: n.cancelPolicy.map((i, t) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-wrap ch-gap-x-1 ch-text-sm", children: [
  /* @__PURE__ */ l.jsx(
    Xre,
    {
      sessionStateContext: e,
      displayContext: {
        beforeDays: i.beforeDays,
        isDayTrip: n.isDayTrip
      }
    }
  ),
  /* @__PURE__ */ l.jsx("p", { children: ioe }),
  /* @__PURE__ */ l.jsx(
    noe,
    {
      sessionStateContext: e,
      displayContext: { chargeRatio: i.chargeRatio }
    }
  )
] }, t)) }), aoe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "キャンセルできないプランです" : "This plan cannot be canceled.", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: n });
}, loe = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
  /* @__PURE__ */ l.jsx(qre, { sessionStateContext: e }),
  n.isUnCancelable ? /* @__PURE__ */ l.jsx(aoe, { sessionStateContext: e }) : /* @__PURE__ */ l.jsx(
    toe,
    {
      sessionStateContext: e,
      displayContext: { cancelPolicy: n.cancelPolicy, isDayTrip: n.isDayTrip }
    }
  )
] }), soe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "プランポリシー" : "Plan Policy", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: n });
}, roe = "：", ooe = "~", doe = ({ sessionStateContext: e, displayContext: n }) => {
  const i = v(() => e.lang === D.Default ? "チェックイン" : "Check-in", [e.lang]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-cols-[100px_12px_1fr] ch-gap-x-1 ch-text-sm", children: [
    /* @__PURE__ */ l.jsx("label", { className: "ch-col-span-1", children: i }),
    /* @__PURE__ */ l.jsx("p", { children: roe }),
    /* @__PURE__ */ l.jsxs("p", { className: "ch-col-span-1", children: [
      n.checkInStartTime,
      " ",
      ooe,
      " ",
      n.checkInEndTime
    ] })
  ] });
}, coe = "：", uoe = "~", moe = ({ sessionStateContext: e, displayContext: n }) => {
  const i = v(() => e.lang === D.Default ? "チェックアウト" : "Check-out", [e.lang]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-cols-[100px_12px_1fr] ch-gap-x-1 ch-text-sm", children: [
    /* @__PURE__ */ l.jsx("label", { className: "ch-col-span-1", children: i }),
    /* @__PURE__ */ l.jsx("p", { children: coe }),
    /* @__PURE__ */ l.jsxs("p", { className: "ch-col-span-1", children: [
      uoe,
      " ",
      n.checkOutEndTime
    ] })
  ] });
}, koe = ({ sessionStateContext: e, displayContext: n }) => n.isDayTrip ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
  /* @__PURE__ */ l.jsx(soe, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(
    doe,
    {
      sessionStateContext: e,
      displayContext: {
        checkInStartTime: n.checkInOutPolicy.checkInStartTime,
        checkInEndTime: n.checkInOutPolicy.checkInEndTime
      }
    }
  ),
  /* @__PURE__ */ l.jsx(
    moe,
    {
      sessionStateContext: e,
      displayContext: { checkOutEndTime: n.checkInOutPolicy.checkOutEndTime }
    }
  )
] }), foe = (e) => e.priceTarget === $l.Person && !ke(e.kidsPolicy) ? {
  kind: "Displayable",
  lang: e.sessionStateContext.lang,
  kidsPolicy: e.kidsPolicy
} : {
  kind: "NotDisplayable"
}, voe = (e) => ({
  state: v(() => foe(e), [e])
}), hoe = (e) => {
  const n = v(() => {
    switch (e.state.lang) {
      case D.Default:
        return "キッズポリシー";
      case D.En:
        return "Kids Policy";
      default:
        return "";
    }
  }, [e.state]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: n });
};
function poe(e) {
  return e.kidsPolicyItem.kidsMaxAge;
}
function Noe(e) {
  if (e.kidsPolicyItemIndex === 0)
    return 0;
  const i = e.kidsPolicyItemIndex - 1;
  return e.kidsPolicy[i].kidsMaxAge + 1;
}
const Soe = (e) => {
  const n = Noe(e), i = poe(e);
  return n === i ? {
    kind: "SingleAgeDisplayable",
    age: n
  } : {
    kind: "MultiAgesDisplayable",
    minAge: n,
    maxAge: i
  };
}, goe = (e) => ({
  state: v(() => Soe(e), [e])
}), g9 = "~", Foe = ({ sessionStateContext: e, displayContext: n }) => {
  const i = v(() => e.lang === D.Default ? `${n.minAge}歳 ${g9} ${n.maxAge}歳` : `${n.minAge} ${g9} ${n.maxAge} years old`, [n.maxAge, n.minAge, e.lang]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}, Ioe = ({ sessionStateContext: e, displayContext: n }) => {
  const i = v(() => e.lang === D.Default ? `${n.age}歳` : `${n.age} years old`, [n.age, e.lang]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}, yoe = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = goe(n);
  return i.kind === "SingleAgeDisplayable" ? /* @__PURE__ */ l.jsx(Ioe, { sessionStateContext: e, displayContext: { age: i.age } }) : /* @__PURE__ */ l.jsx(
    Foe,
    {
      sessionStateContext: e,
      displayContext: { maxAge: i.maxAge, minAge: i.minAge }
    }
  );
}, boe = (e) => {
  var n, i, t;
  return e.kidsPolicyItem.kidsDiscountType === Qs.NotAvailable || e.kidsPolicyItem.unavailable ? {
    kind: "NotAvailableInfoDisplayable",
    lang: e.sessionStateContext.lang
  } : e.kidsPolicyItem.kidsDiscountType === Qs.Minus ? {
    kind: "MinusInfoDisplayable",
    staticPrice: (n = e.kidsPolicyItem.static) != null ? n : 0,
    lang: e.sessionStateContext.lang
  } : e.kidsPolicyItem.kidsDiscountType === Qs.Static ? {
    kind: "StaticInfoDisplayable",
    staticPrice: (i = e.kidsPolicyItem.static) != null ? i : 0,
    lang: e.sessionStateContext.lang
  } : {
    kind: "RatioInfoDisplayable",
    ratio: (t = e.kidsPolicyItem.ratio) != null ? t : 0,
    lang: e.sessionStateContext.lang
  };
}, Coe = (e) => ({
  state: v(() => boe(e), [e])
}), xoe = (e) => {
  const n = v(() => {
    const { lang: i, staticPrice: t } = e.state, a = t.toLocaleString();
    switch (i) {
      case D.Default:
        return `大人の料金から ${a}円引き`;
      case D.En:
        return `${a} yen off from adult rate`;
      default:
        return "";
    }
  }, [e.state]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, Doe = (e) => {
  const n = v(() => {
    switch (e.state.lang) {
      case D.Default:
        return "利用できません";
      case D.En:
        return "Not available";
      default:
        return "";
    }
  }, [e.state.lang]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, woe = (e) => {
  const n = v(() => {
    const { lang: i, ratio: t } = e.state;
    switch (i) {
      case D.Default:
        return `大人の料金の ${t} %`;
      case D.En:
        return `${t} % of adult price`;
      default:
        return "";
    }
  }, [e.state]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, Poe = (e) => {
  const n = v(() => {
    const { lang: i, staticPrice: t } = e.state, a = t.toLocaleString();
    switch (i) {
      case D.Default:
        return `${a} 円`;
      case D.En:
        return `${a} yen`;
      default:
        return "";
    }
  }, [e.state]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, Roe = (e) => {
  const { state: n } = Coe(e);
  switch (n.kind) {
    case "NotAvailableInfoDisplayable":
      return /* @__PURE__ */ l.jsx(Doe, { state: n });
    case "MinusInfoDisplayable":
      return /* @__PURE__ */ l.jsx(xoe, { state: n });
    case "RatioInfoDisplayable":
      return /* @__PURE__ */ l.jsx(woe, { state: n });
    case "StaticInfoDisplayable":
      return /* @__PURE__ */ l.jsx(Poe, { state: n });
    default:
      return null;
  }
}, Toe = "：", joe = (e) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-1.5", children: e.state.kidsPolicy.map((n, i) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-wrap ch-gap-x-1 ch-text-sm", children: [
  /* @__PURE__ */ l.jsx(
    yoe,
    {
      ...e,
      modelContext: {
        kidsPolicy: e.state.kidsPolicy,
        kidsPolicyItem: n,
        kidsPolicyItemIndex: i
      }
    }
  ),
  /* @__PURE__ */ l.jsx("p", { children: Toe }),
  /* @__PURE__ */ l.jsx(Roe, { ...e, kidsPolicyItem: n })
] }, i)) }), Aoe = (e) => {
  const { state: n } = voe(e);
  return n.kind === "NotDisplayable" ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(hoe, { state: n }),
    /* @__PURE__ */ l.jsx(joe, { ...e, state: n })
  ] });
}, Ooe = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6 ch-rounded-lg ch-bg-gray-300/20 ch-p-3.5", children: [
  /* @__PURE__ */ l.jsx(
    koe,
    {
      sessionStateContext: e,
      displayContext: {
        checkInOutPolicy: n.checkInOutPolicy,
        isDayTrip: n.isDayTrip
      }
    }
  ),
  /* @__PURE__ */ l.jsx(
    loe,
    {
      sessionStateContext: e,
      displayContext: {
        cancelPolicy: n.cancelPolicy,
        isDayTrip: n.isDayTrip,
        isUnCancelable: n.isUnCancelable
      }
    }
  ),
  /* @__PURE__ */ l.jsx(
    Aoe,
    {
      sessionStateContext: e,
      kidsPolicy: n.kidsPolicy,
      priceTarget: n.priceTarget
    }
  )
] }), Eoe = (e) => {
  const n = v(() => {
    switch (e.sessionStateContext.lang) {
      case D.Default:
        return "詳細を見る";
      case D.En:
        return "Details";
      default:
        return "";
    }
  }, [e.sessionStateContext.lang]), { onOpenCallback: i } = e.callbackContext, t = I(
    (a) => {
      a.stopPropagation(), i();
    },
    [i]
  );
  return /* @__PURE__ */ l.jsx(Et, { asChild: !0, onClick: t, children: /* @__PURE__ */ l.jsx(ae, { variant: "outline", size: "sm", children: n }) });
}, Joe = ({ sessionStateContext: e, displayContext: n }) => {
  const { availablePlan: i } = n, t = I(() => {
    qv({
      itemID: i.planID,
      name: i.name,
      category: "plan",
      price: i.price
    }).forEach(bt), le(Pn({ target: "plan.detail" }));
  }, [i.name, i.planID, i.price]), a = I((o) => {
    o.stopPropagation();
  }, []), s = I((o) => {
    o.stopPropagation();
  }, []), r = I((o) => {
    o.stopPropagation();
  }, []);
  return /* @__PURE__ */ l.jsxs(Dr, { children: [
    /* @__PURE__ */ l.jsxs(wr, { children: [
      /* @__PURE__ */ l.jsx(a1, { "aria-hidden": !1, onClick: r }),
      /* @__PURE__ */ l.jsxs(
        Pr,
        {
          onClick: a,
          className: "ch-h-drawer-almost-full-nested ch-max-h-drawer-almost-full-nested ch-font-system-ui",
          "aria-describedby": void 0,
          children: [
            /* @__PURE__ */ l.jsxs(yt, { className: "ch-mx-auto ch-grid ch-w-full ch-max-w-screen-tablet ch-grid-cols-[1fr_40px] ch-items-center ch-px-5 ch-pb-5 ch-pt-3", children: [
              /* @__PURE__ */ l.jsx("p", { className: "ch-break-words", children: n.availablePlan.name }),
              /* @__PURE__ */ l.jsx(pd, { onClick: s, children: /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) }) })
            ] }),
            /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-space-y-14 ch-overflow-y-scroll ch-px-4 ch-pb-6 ch-pt-4", children: [
              /* @__PURE__ */ l.jsx(
                Ut,
                {
                  modelContext: {
                    imageUrls: n.availablePlan.keyVisuals
                  }
                }
              ),
              n.availablePlan.article && /* @__PURE__ */ l.jsx(
                fm,
                {
                  lang: e.lang,
                  articleUrl: n.availablePlan.article
                }
              ),
              /* @__PURE__ */ l.jsx(
                Ooe,
                {
                  sessionStateContext: e,
                  displayContext: {
                    checkInOutPolicy: n.availablePlan.checkInOutPolicy,
                    kidsPolicy: n.availablePlan.kidsPolicy,
                    cancelPolicy: n.availablePlan.cancelPolicy,
                    isUnCancelable: n.availablePlan.isUnCancelable,
                    isDayTrip: n.availablePlan.isDayTrip,
                    priceTarget: n.availablePlan.priceTarget
                  }
                }
              )
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ l.jsx(
      Eoe,
      {
        sessionStateContext: e,
        callbackContext: { onOpenCallback: t }
      }
    )
  ] });
}, _oe = (e) => {
  if (e.includes(_l.RoomOnly))
    return "ROOM_ONLY";
  const n = e.includes(_l.Breakfast), i = e.includes(_l.Lunch), t = e.includes(_l.Dinner);
  return n && i && t ? "ALL" : n && i ? "BREAKFAST_LUNCH" : n && t ? "BREAKFAST_DINNER" : i && t ? "LUNCH_DINNER" : n ? "BREAKFAST" : i ? "LUNCH" : t ? "DINNER" : null;
}, Qoe = (e) => {
  const n = _oe(e.includedMeals);
  return n ? {
    kind: "Displayable",
    mealCombination: n
  } : {
    kind: "NotDisplayable"
  };
}, Moe = (e) => ({
  state: v(() => Qoe(e), [e])
}), Loe = {
  ROOM_ONLY: { [D.Default]: "素泊まり", [D.En]: "Room only" },
  BREAKFAST: { [D.Default]: "朝食付き", [D.En]: "Breakfast" },
  LUNCH: { [D.Default]: "昼食付き", [D.En]: "Lunch" },
  DINNER: { [D.Default]: "夕食付き", [D.En]: "Dinner" },
  BREAKFAST_LUNCH: { [D.Default]: "朝昼食付き", [D.En]: "Breakfast & lunch" },
  BREAKFAST_DINNER: { [D.Default]: "朝夕食付き", [D.En]: "Breakfast & dinner" },
  LUNCH_DINNER: { [D.Default]: "昼夕食付き", [D.En]: "Lunch & dinner" },
  ALL: { [D.Default]: "3食付き", [D.En]: "All meals" }
}, $oe = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = Moe(n);
  return i.kind !== "Displayable" ? null : /* @__PURE__ */ l.jsxs("p", { className: "ch-flex ch-items-center ch-gap-1 ch-pb-2 ch-text-sm ch-font-semibold", children: [
    /* @__PURE__ */ l.jsx(tR, { size: "xs" }),
    kn({ lang: e.lang, i18nString: Loe[i.mealCombination] })
  ] });
}, Uoe = (e) => e.price !== 0 ? {
  kind: "Displayable",
  price: e.price,
  priceTarget: e.priceTarget,
  priceType: e.priceType,
  isDayTrip: e.isDayTrip
} : {
  kind: "NotDisplayable"
}, Voe = (e) => ({
  state: v(() => Uoe(e), [e])
}), Hoe = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "１団体あたり" : "per group", [e.lang]), zoe = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "1名あたり" : "per person", [e.lang]), Boe = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "1部屋あたり" : "per room", [e.lang]), qoe = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("p", { className: "ch-text-sm", children: [
  n.priceTarget === $l.Group ? /* @__PURE__ */ l.jsx(Hoe, { sessionStateContext: e }) : null,
  n.priceTarget === $l.Person ? /* @__PURE__ */ l.jsx(zoe, { sessionStateContext: e }) : null,
  n.priceTarget === $l.Room ? /* @__PURE__ */ l.jsx(Boe, { sessionStateContext: e }) : null
] }), Goe = ({ displayContext: e }) => {
  const n = v(() => `¥ ${e.price.toLocaleString()}`, [e.price]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold", children: n });
}, Woe = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "日" : "per date", [e.lang]), Koe = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "予約" : "per reservation", [e.lang]), Yoe = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  n.priceType === nt.PerDate ? /* @__PURE__ */ l.jsx(Woe, { sessionStateContext: e }) : null,
  n.priceType === nt.PerReservation ? /* @__PURE__ */ l.jsx(Koe, { sessionStateContext: e }) : null
] }), Xoe = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "泊" : "per night", [e.lang]), Zoe = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "予約" : "per reservation", [e.lang]), ede = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  n.priceType === nt.PerDate ? /* @__PURE__ */ l.jsx(Xoe, { sessionStateContext: e }) : null,
  n.priceType === nt.PerReservation ? /* @__PURE__ */ l.jsx(Zoe, { sessionStateContext: e }) : null
] }), nde = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: n.isDayTrip ? /* @__PURE__ */ l.jsx(Yoe, { sessionStateContext: e, displayContext: n }) : /* @__PURE__ */ l.jsx(ede, { sessionStateContext: e, displayContext: n }) }), ide = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = Voe(n);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-gap-x-2", children: [
    /* @__PURE__ */ l.jsx(qoe, { sessionStateContext: e, displayContext: i }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-[1px] ch-text-lg ch-font-semibold", children: [
      /* @__PURE__ */ l.jsx(Goe, { displayContext: i }),
      /* @__PURE__ */ l.jsx("p", { children: "/" }),
      /* @__PURE__ */ l.jsx(nde, { sessionStateContext: e, displayContext: i })
    ] })
  ] }) : null;
}, tde = (e) => ke(e.requiredOptions) ? {
  kind: "NotDisplayable"
} : {
  kind: "Displayable",
  requiredOptions: e.requiredOptions.filter((i) => !i.isOneOfRequired),
  requiredOptionGroupMembers: e.requiredOptions.filter((i) => i.isOneOfRequired)
}, ade = (e) => ({
  state: v(() => tde(e), [e])
}), lde = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "１団体あたり" : "per group", [e.lang]), sde = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "1名あたり" : "per person", [e.lang]), rde = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "1名（子供のみ）あたり" : "per person (kids only)", [e.lang]), ode = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "1部屋あたり" : "per room", [e.lang]), dde = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("p", { className: "ch-text-xs", children: [
  n.priceTarget === Qt.Group ? /* @__PURE__ */ l.jsx(lde, { sessionStateContext: e }) : null,
  n.priceTarget === Qt.Person ? /* @__PURE__ */ l.jsx(sde, { sessionStateContext: e }) : null,
  n.priceTarget === Qt.Room ? /* @__PURE__ */ l.jsx(ode, { sessionStateContext: e }) : null,
  n.priceTarget === Qt.PersonOnlyKids ? /* @__PURE__ */ l.jsx(rde, { sessionStateContext: e }) : null
] }), cde = (e) => e.optionType !== Zs.Goods ? {
  kind: "Displayable",
  isDayTrip: e.isDayTrip,
  priceType: e.priceType
} : {
  kind: "NotDisplayable"
}, ude = (e) => ({
  state: v(() => cde(e), [e])
}), mde = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "日" : "per date", [e.lang]), kde = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "予約" : "per reservation", [e.lang]), fde = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  n.priceType === nt.PerDate ? /* @__PURE__ */ l.jsx(mde, { sessionStateContext: e }) : null,
  n.priceType === nt.PerReservation ? /* @__PURE__ */ l.jsx(kde, { sessionStateContext: e }) : null
] }), vde = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "泊" : "per night", [e.lang]), hde = ({ sessionStateContext: e }) => v(() => e.lang === D.Default ? "予約" : "per reservation", [e.lang]), pde = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  n.priceType === nt.PerDate ? /* @__PURE__ */ l.jsx(vde, { sessionStateContext: e }) : null,
  n.priceType === nt.PerReservation ? /* @__PURE__ */ l.jsx(hde, { sessionStateContext: e }) : null
] }), Nde = ({ sessionStateContext: e, displayContext: n }) => n.isDayTrip ? /* @__PURE__ */ l.jsx(fde, { sessionStateContext: e, displayContext: n }) : /* @__PURE__ */ l.jsx(pde, { sessionStateContext: e, displayContext: n }), Sde = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = ude(n);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1 ch-font-semibold", children: [
    /* @__PURE__ */ l.jsx("p", { children: "/" }),
    /* @__PURE__ */ l.jsx(Nde, { sessionStateContext: e, displayContext: i })
  ] }) : null;
}, gde = ({ sessionStateContext: e, displayContext: n }) => {
  const i = v(
    () => `¥ ${n.minimumPrice.toLocaleString()}`,
    [n.minimumPrice]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-2", children: [
    /* @__PURE__ */ l.jsx(
      dde,
      {
        sessionStateContext: e,
        displayContext: { priceTarget: n.priceTarget }
      }
    ),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-[1px] ch-font-semibold", children: [
      /* @__PURE__ */ l.jsx("p", { children: i }),
      /* @__PURE__ */ l.jsx(
        Sde,
        {
          sessionStateContext: e,
          modelContext: n
        }
      )
    ] })
  ] });
}, F9 = ({ sessionStateContext: e, displayContext: n }) => n.requiredOptions.map((i) => {
  const t = `${n.planID}_${i.optionID}`;
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-xs ch-text-gray-400", children: [
    /* @__PURE__ */ l.jsx("p", { children: i.name }),
    /* @__PURE__ */ l.jsx(
      gde,
      {
        sessionStateContext: e,
        displayContext: {
          isDayTrip: n.isDayTrip,
          minimumPrice: i.minimumPrice,
          priceType: i.priceType,
          priceTarget: i.priceTarget,
          optionType: i.optionType
        }
      }
    )
  ] }, t);
}), Fde = ({ sessionStateContext: e, displayContext: n }) => {
  const i = v(() => n.isRequiredOptionGroupOnly ? e.lang === D.Default ? "いずれか1つ選択必須なオプション" : "Required options (choose one)" : e.lang === D.Default ? "選択必須なオプション" : "Required options", [e.lang, n.isRequiredOptionGroupOnly]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: i });
}, Ide = ({ sessionStateContext: e, displayContext: n, modelContext: i }) => {
  const { state: t } = ade(i), a = I((s) => {
    s.stopPropagation();
  }, []);
  return t.kind === "Displayable" ? /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, children: /* @__PURE__ */ l.jsxs(it, { value: "item", borderBottom: !1, children: [
    /* @__PURE__ */ l.jsx(
      tt,
      {
        className: "ch-flex-none ch-px-0 ch-py-0",
        hover: !1,
        onClick: a,
        children: /* @__PURE__ */ l.jsx(
          Fde,
          {
            sessionStateContext: e,
            displayContext: {
              isRequiredOptionGroupOnly: t.requiredOptions.length === 0 && t.requiredOptionGroupMembers.length > 0
            }
          }
        )
      }
    ),
    /* @__PURE__ */ l.jsxs(at, { className: "ch-space-y-3 ch-px-0 ch-py-3 tablet:ch-px-0", children: [
      /* @__PURE__ */ l.jsx(
        F9,
        {
          sessionStateContext: e,
          displayContext: {
            isDayTrip: n.availablePlan.isDayTrip,
            planID: n.availablePlan.planID,
            requiredOptions: t.requiredOptions
          }
        }
      ),
      t.requiredOptionGroupMembers.length > 0 && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        t.requiredOptions.length > 0 && /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-medium", children: e.lang === D.Default ? "以下のうち、いずれか1つ選択必須" : "Choose one of the following" }),
        /* @__PURE__ */ l.jsx(
          F9,
          {
            sessionStateContext: e,
            displayContext: {
              isDayTrip: n.availablePlan.isDayTrip,
              planID: n.availablePlan.planID,
              requiredOptions: t.requiredOptionGroupMembers
            }
          }
        )
      ] })
    ] })
  ] }) }) : null;
}, yde = ({ displayContext: e, sessionStateContext: n, modelContext: i }) => {
  const { state: t } = Ere(i), { reservationPolicy: a } = Ua(), { onShowLoadingScreenCallback: s, onHideLoadingScreenCallback: r } = fn(), o = I(
    async (c) => {
      c.stopPropagation(), s(), await t.onUpdatePlan().finally(() => {
        r();
      });
    },
    [r, s, t]
  ), d = v(() => e.availablePlans.some((c) => !Ke(c.description)), [e.availablePlans]);
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      id: e.id,
      className: ce(
        "ch-relative ch-snap-center ch-tabular-nums",
        //
        d ? "ch-pt-[72px]" : null
      ),
      children: [
        /* @__PURE__ */ l.jsx(
          Bre,
          {
            modelContext: {
              description: e.availablePlan.description
            }
          }
        ),
        /* @__PURE__ */ l.jsxs(
          "div",
          {
            role: "button",
            className: ce(
              "ch-w-[280px] ch-rounded-xl ch-bg-white ch-text-left",
              //
              t.kind === "Selected" ? "ch-ring-2 ch-ring-primary" : "ch-ring-0"
            ),
            onClick: o,
            children: [
              /* @__PURE__ */ l.jsx(
                Vre,
                {
                  sessionStateContext: n,
                  displayContext: e
                }
              ),
              /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6 ch-p-4", children: [
                /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
                  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
                    /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold", children: e.availablePlan.name }),
                    /* @__PURE__ */ l.jsx(
                      $oe,
                      {
                        sessionStateContext: n,
                        modelContext: { includedMeals: e.availablePlan.includedMeals }
                      }
                    )
                  ] }),
                  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
                    !a.isShowPlanIncludedPrice && /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-flex-wrap ch-items-baseline ch-space-x-2", children: /* @__PURE__ */ l.jsx(
                      ide,
                      {
                        sessionStateContext: n,
                        modelContext: {
                          price: e.availablePlan.price,
                          isDayTrip: e.availablePlan.isDayTrip,
                          priceTarget: e.availablePlan.priceTarget,
                          priceType: e.availablePlan.priceType
                        }
                      }
                    ) }),
                    /* @__PURE__ */ l.jsx(
                      Ide,
                      {
                        sessionStateContext: n,
                        displayContext: { availablePlan: e.availablePlan },
                        modelContext: { requiredOptions: e.availablePlan.requiredOptions }
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-justify-end", children: /* @__PURE__ */ l.jsx(
                  Joe,
                  {
                    sessionStateContext: n,
                    displayContext: {
                      availablePlan: e.availablePlan
                    }
                  }
                ) })
              ] })
            ]
          }
        )
      ]
    }
  );
}, bde = ({ callbackContext: e, displayContext: n, sessionStateContext: i }) => {
  var s;
  const t = I((r) => `CHILLNN_PLAN_${r}`, []), a = v(
    () => {
      var r;
      return (r = i.currentState.planInfo.willReserve) == null ? void 0 : r.planID;
    },
    [(s = i.currentState.planInfo.willReserve) == null ? void 0 : s.planID]
  );
  return be(() => {
    if (a) {
      const r = t(a), o = document.getElementById(r);
      o && o.scrollIntoView({ behavior: "smooth", inline: "center" });
    }
  }, [a, t]), /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-h-full ch-snap-x ch-snap-mandatory ch-space-x-6 ch-overflow-x-scroll ch-bg-gray-100 ch-px-5 ch-pb-[42px] ch-pt-4", children: n.availablePlans.map((r) => {
    const o = t(r.planID);
    return /* @__PURE__ */ l.jsx(
      yde,
      {
        sessionStateContext: i,
        displayContext: {
          availablePlan: r,
          availablePlans: n.availablePlans,
          id: o
        },
        modelContext: {
          availablePlan: r,
          sessionStateContext: i,
          callbackContext: {
            onUpdatePlan: e.onUpdatePlan
          }
        }
      },
      o
    );
  }) });
}, S2 = g(({ sessionStateContext: e }) => {
  const { onUpdatePlan: n } = Ire({ sessionStateContext: e }), { onAvailablePlansQuery: i } = bre({
    sessionStateContext: e
  });
  return /* @__PURE__ */ l.jsx(Are, { sessionStateContext: e, onAvailablePlans: i, children: ({ state: t }) => /* @__PURE__ */ l.jsx(
    bde,
    {
      displayContext: { availablePlans: t.availablePlans },
      callbackContext: { onUpdatePlan: n },
      sessionStateContext: e
    }
  ) });
});
S2.displayName = "Presenter";
const Cde = (e) => ({
  kind: "NotInitialized",
  onAvailableBaseRooms: e.onAvailableBaseRooms
}), O7 = () => (e) => ({
  kind: "Initialized",
  availableBaseRooms: e.availableBaseRooms
}), E7 = (e) => ({
  kind: "Errored",
  onAvailableBaseRooms: e.onAvailableBaseRooms
}), xde = ({ state: e, onChangeState: n }) => {
  be(() => {
    e.kind === "NotInitialized" && e.onAvailableBaseRooms().then((i) => {
      n(O7()({ availableBaseRooms: i }));
    }).catch(() => {
      n(E7(e));
    });
  }, [n, e]);
}, Dde = ({ onChangeState: e }) => ({
  onReInitialize: I(
    (i) => async () => {
      try {
        const t = await i.onAvailableBaseRooms();
        e(O7(i)({ availableBaseRooms: t }));
      } catch (t) {
        e(E7(i));
      }
    },
    [e]
  )
}), wde = (e) => {
  const [n, i] = se(Cde(e)), t = I((s) => {
    i(s);
  }, []);
  xde({ state: n, onChangeState: t });
  const { onReInitialize: a } = Dde({ onChangeState: t });
  return {
    state: n,
    onReInitialize: a
  };
}, Pde = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = I(async () => {
    le(Pn({ target: "refetch", area: "room" })), await n.onRefetch();
  }, [n]), t = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: i, children: t });
}, Rde = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "お部屋の情報が正しく取得できませんでした。" : "Room information could not be obtained correctly.", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, Tde = ({ sessionStateContext: e, callbackContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-py-8 ch-text-center", children: [
  /* @__PURE__ */ l.jsx(Rde, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(Pde, { sessionStateContext: e, callbackContext: n })
] }), jde = () => /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-w-full ch-gap-x-3 ch-overflow-hidden ch-bg-gray-100 ch-px-5 ch-py-8", children: Array.from({ length: 3 }).map((e, n) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: "ch-h-96 ch-min-w-[260px] ch-animate-pulse ch-rounded-xl ch-bg-gray-200 ch-p-4"
  },
  n
)) }), Ade = g(({ children: e, sessionStateContext: n, ...i }) => {
  const { state: t, onReInitialize: a } = wde(i);
  return t.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(jde, {}) : t.kind === "Errored" ? /* @__PURE__ */ l.jsx(
    Tde,
    {
      sessionStateContext: n,
      callbackContext: { onRefetch: a(t) }
    }
  ) : e({ state: t });
}), Ode = (e) => {
  const n = e.sessionStateContext.currentState.roomInfo.willReserve.filter((i) => !P(i)).find(
    (i) => {
      var t;
      return (i == null ? void 0 : i.uniqueRoomID) === e.uniqueRoomID && ((t = i.baseRoomInfo) == null ? void 0 : t.baseRoomID) === e.availableBaseRoom.roomID;
    }
  );
  return P(n) ? {
    kind: "NotSelected"
  } : {
    kind: "Selected"
  };
}, Ede = (e) => ({
  state: v(() => Ode(e), [e])
}), Jde = ({ beds: e }) => P(e) || ke(e) ? {
  kind: "NonDisplayable"
} : {
  kind: "Displayable",
  beds: e
}, _de = (e) => ({
  state: v(() => Jde(e), [e])
}), Qde = ({ sessionStateContext: { lang: e }, bedInfo: n }) => {
  const i = v(() => e === D.Default ? `${n.bedType} ${n.bedNum}つ` : `${n.bedNum} ${n.bedType}`, [n.bedNum, n.bedType, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: i });
}, Mde = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = _de(n);
  return i.kind === "Displayable" ? i.beds.map((t) => {
    const a = `${t.bedType}_${t.bedNum}`;
    return /* @__PURE__ */ l.jsx(Qde, { sessionStateContext: e, bedInfo: t }, a);
  }) : null;
}, Lde = ({ sessionStateContext: e, displayContext: n }) => {
  const i = v(() => e.lang === D.Default ? `定員 ~${n.capacityPeopleMaximum}名` : `Capacity: Up to ${n.capacityPeopleMaximum} people`, [e.lang, n.capacityPeopleMaximum]);
  return /* @__PURE__ */ l.jsx("span", { className: "ch-absolute ch-right-3 ch-top-3 ch-rounded ch-bg-black/70 ch-px-1 ch-py-0.5 ch-text-xs ch-text-white", children: i });
}, $de = ({ sessionStateContext: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-relative ch-h-[160px] ch-w-full", children: [
  /* @__PURE__ */ l.jsx(
    Ut,
    {
      modelContext: { imageUrls: n.availableBaseRoom.keyVisuals },
      styleContext: { height: "160px", borderRadius: "12px 12px 0 0" }
    }
  ),
  /* @__PURE__ */ l.jsx(
    Lde,
    {
      sessionStateContext: e,
      displayContext: { capacityPeopleMaximum: n.availableBaseRoom.capacityPeopleMaximum }
    }
  )
] }), Ude = ({ catchCopy: e }) => Ke(e) ? {
  kind: "NonDisplayable",
  catchCopy: ""
} : {
  kind: "Displayable",
  catchCopy: e
}, Vde = (e) => ({
  state: v(() => Ude(e), [e])
}), Hde = ({ modelContext: e }) => {
  const { state: n } = Vde(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("div", { className: "ch-absolute -ch-top-0.5 ch-w-full", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-relative ch-rounded-lg ch-bg-white ch-px-4 ch-py-3.5", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-line-clamp-2 ch-min-h-8 ch-text-xs", children: n.catchCopy }),
    /* @__PURE__ */ l.jsx("div", { className: "before:ch-absolute before:ch-left-1/2 before:ch-top-full before:-ch-translate-x-1/2 before:ch-border-[10px] before:ch-border-transparent before:ch-border-t-white before:ch-content-['']" })
  ] }) }) : null;
}, zde = ({ amenities: e, lang: n }) => ke(e.bathrooms) && ke(e.roomAmenities) && ke(e.roomFacilities) ? {
  kind: "NonDisplayable"
} : {
  kind: "Displayable",
  amenities: e,
  lang: n
}, Bde = (e) => ({
  state: v(() => zde(e), [e])
}), qde = ({ amenities: e }) => ke(e) ? {
  kind: "NonDisplayable"
} : {
  kind: "Displayable",
  amenities: e
}, Gde = (e) => ({
  state: v(() => qde(e), [e])
}), ep = ({ modelContext: e, displayContext: n }) => {
  const { state: i } = Gde(e);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-space-x-2", children: [
      n.iconSlot,
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: n.titleText })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-grid ch-grid-cols-2 ch-gap-x-4 ch-gap-y-1", children: i.amenities.map((t, a) => /* @__PURE__ */ l.jsx("p", { className: "ch-col-span-1 ch-text-sm", children: t }, a)) })
  ] }) : null;
}, Wde = ({ bathRoomAmenities: e, lang: n }) => {
  const i = v(() => n === D.Default ? "バスルーム" : "Bathroom", [n]);
  return /* @__PURE__ */ l.jsx(
    ep,
    {
      modelContext: { amenities: e },
      displayContext: { iconSlot: /* @__PURE__ */ l.jsx(tI, {}), titleText: i }
    }
  );
}, Kde = ({ facilities: e, lang: n }) => {
  const i = v(() => n === D.Default ? "設備" : "Facilities", [n]);
  return /* @__PURE__ */ l.jsx(
    ep,
    {
      modelContext: { amenities: e },
      displayContext: { iconSlot: /* @__PURE__ */ l.jsx(im, {}), titleText: i }
    }
  );
}, Yde = ({ roomAmenities: e, lang: n }) => {
  const i = v(() => n === D.Default ? "アメニティ" : "Amenities", [n]);
  return /* @__PURE__ */ l.jsx(
    ep,
    {
      modelContext: { amenities: e },
      displayContext: { iconSlot: /* @__PURE__ */ l.jsx(wf, {}), titleText: i }
    }
  );
}, Xde = ({ modelContext: e }) => {
  const { state: n } = Bde(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-rounded-lg ch-bg-gray-300/20 ch-px-4 ch-py-[18px]", children: [
    /* @__PURE__ */ l.jsx(Kde, { facilities: n.amenities.roomFacilities, lang: n.lang }),
    /* @__PURE__ */ l.jsx(Yde, { roomAmenities: n.amenities.roomAmenities, lang: n.lang }),
    /* @__PURE__ */ l.jsx(Wde, { bathRoomAmenities: n.amenities.bathrooms, lang: n.lang })
  ] }) : null;
}, Zde = (e) => {
  const n = v(() => {
    switch (e.sessionStateContext.lang) {
      case D.Default:
        return "詳細を見る";
      case D.En:
        return "Details";
      default:
        return "";
    }
  }, [e.sessionStateContext.lang]), { onOpenCallback: i } = e.callbackContext, t = I(
    (a) => {
      a.stopPropagation(), i();
    },
    [i]
  );
  return /* @__PURE__ */ l.jsx(Et, { asChild: !0, onClick: t, children: /* @__PURE__ */ l.jsx(ae, { variant: "outline", size: "sm", children: n }) });
}, ece = ({
  sessionStateContext: e,
  displayContext: { roomID: n, minimumDailyPrice: i, name: t, article: a, amenities: s, keyVisuals: r }
}) => {
  const o = I(() => {
    qv({
      itemID: n,
      name: t,
      category: "room",
      price: i
    }).forEach(bt), le(Pn({ target: "room.detail" }));
  }, [i, t, n]), d = I((k) => {
    k.stopPropagation();
  }, []), c = I((k) => {
    k.stopPropagation();
  }, []), u = I((k) => {
    k.stopPropagation();
  }, []);
  return /* @__PURE__ */ l.jsxs(Dr, { children: [
    /* @__PURE__ */ l.jsxs(wr, { children: [
      /* @__PURE__ */ l.jsx(a1, { onClick: u }),
      /* @__PURE__ */ l.jsxs(
        Pr,
        {
          onClick: d,
          className: "ch-h-drawer-almost-full-nested ch-max-h-drawer-almost-full-nested ch-font-system-ui",
          "aria-describedby": void 0,
          children: [
            /* @__PURE__ */ l.jsxs(yt, { className: "ch-mx-auto ch-grid ch-w-full ch-max-w-screen-tablet ch-grid-cols-[1fr_40px] ch-items-center ch-px-5 ch-pb-5 ch-pt-3", children: [
              /* @__PURE__ */ l.jsx("p", { className: "ch-break-words", children: t }),
              /* @__PURE__ */ l.jsx(pd, { asChild: !0, onClick: c, children: /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) }) })
            ] }),
            /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-space-y-10 ch-overflow-y-scroll ch-px-4 ch-pb-6 ch-pt-4", children: [
              /* @__PURE__ */ l.jsx(
                Ut,
                {
                  modelContext: {
                    imageUrls: r
                  }
                }
              ),
              a && /* @__PURE__ */ l.jsx(
                fm,
                {
                  lang: e.lang,
                  articleUrl: a
                }
              ),
              /* @__PURE__ */ l.jsx(Xde, { modelContext: { amenities: s, lang: e.lang } })
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ l.jsx(
      Zde,
      {
        sessionStateContext: e,
        callbackContext: { onOpenCallback: o }
      }
    )
  ] });
}, nce = (e, n) => {
  switch (e) {
    case Ul.Full:
      return {
        label: "満枠",
        dotClass: "ch-bg-gray-400",
        bgClass: "ch-bg-gray-200",
        textClass: "ch-text-gray-500"
      };
    case Ul.Few:
      return {
        label: `残り ${n} 室`,
        dotClass: "ch-bg-label-pink-600",
        bgClass: "ch-bg-label-pink-200",
        textClass: "ch-text-label-pink-600"
      };
    case Ul.Available:
      return {
        label: "空きあり",
        dotClass: "ch-bg-label-green-600",
        bgClass: "ch-bg-label-green-200",
        textClass: "ch-text-label-green-600"
      };
  }
}, ice = ({ displayContext: { grade: e, remainingStock: n } }) => {
  const i = nce(e, n);
  return /* @__PURE__ */ l.jsxs(
    "span",
    {
      className: `ch-flex ch-flex-shrink-0 ch-items-center ch-gap-1 ch-rounded-full ch-px-2 ch-py-0.5 ch-text-xs ch-font-semibold ${i.bgClass} ${i.textClass}`,
      "aria-label": `在庫: ${i.label}`,
      children: [
        /* @__PURE__ */ l.jsx("span", { className: `ch-h-1.5 ch-w-1.5 ch-rounded-full ${i.dotClass}`, "aria-hidden": !0 }),
        i.label
      ]
    }
  );
}, tce = () => {
  const { isShowBestRateNotice: e } = tW(), { lang: n } = u1(), { enabled: i } = QU();
  return !e || !i ? null : /* @__PURE__ */ l.jsxs(
    "aside",
    {
      className: "ch-flex ch-w-full ch-items-center ch-gap-2 ch-rounded-xl ch-border-[0.5px] ch-border-gray-300 ch-bg-white ch-p-4",
      "aria-label": kn({
        lang: n,
        i18nString: {
          default: "ベストレートのご案内",
          en: "Best rate notice"
        }
      }),
      children: [
        /* @__PURE__ */ l.jsx("span", { className: "ch-flex ch-h-[19px] ch-flex-shrink-0 ch-items-center ch-rounded ch-bg-brand-600 ch-px-1.5 ch-py-0.5 ch-text-[10px] ch-font-semibold ch-leading-3 ch-text-white", children: kn({
          lang: n,
          i18nString: {
            default: "お得",
            en: "Best rate"
          }
        }) }),
        /* @__PURE__ */ l.jsx("p", { className: "ch-min-w-0 ch-text-sm ch-font-medium ch-leading-5 ch-text-[#0c0d0d]", children: kn({
          lang: n,
          i18nString: {
            default: "このサイトからのご予約が最もお得です",
            en: "Book directly with us for the best rate."
          }
        }) })
      ]
    }
  );
}, ace = ({ displayContext: { stockPreview: e } }) => !e || e.grade === Ul.Full ? null : /* @__PURE__ */ l.jsx(
  ice,
  {
    displayContext: {
      grade: e.grade,
      remainingStock: e.remainingStock
    }
  }
), lce = ({ displayContext: { roomSize: e } }) => P(e) ? null : /* @__PURE__ */ l.jsxs("p", { className: "ch-inline ch-text-base", children: [
  e,
  "㎡"
] }), sce = ({ sessionStateContext: { lang: e }, displayContext: { minimumDailyPrice: n } }) => {
  const i = v(() => `¥${n.toLocaleString()}`, [n]), t = v(() => e === D.Default ? "泊" : "night", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-gap-x-[1px] ch-text-base ch-font-semibold", children: [
    /* @__PURE__ */ l.jsx("p", { children: i }),
    /* @__PURE__ */ l.jsx("p", { children: "/" }),
    /* @__PURE__ */ l.jsx("p", { children: t })
  ] });
}, rce = ({ displayContext: e, callbackContext: n, sessionStateContext: i, modelContext: t }) => {
  const { state: a } = Ede(t), { onHideLoadingScreenCallback: s, onShowLoadingScreenCallback: r } = fn(), o = I(
    async (c) => {
      c.stopPropagation(), r(), await n.onUpdateBaseRoom().finally(() => {
        s();
      });
    },
    [n, s, r]
  ), d = v(
    () => e.availableBaseRooms.some((c) => !Ke(c.catchCopy)),
    [e.availableBaseRooms]
  );
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: ce(
        "ch-relative ch-snap-center",
        //
        d ? "ch-pt-[72px]" : null
      ),
      children: [
        /* @__PURE__ */ l.jsx(
          Hde,
          {
            modelContext: {
              catchCopy: e.availableBaseRoom.catchCopy
            }
          }
        ),
        /* @__PURE__ */ l.jsxs(
          "div",
          {
            role: "button",
            className: ce(
              "ch-w-[280px] ch-rounded-xl ch-bg-white ch-text-left",
              //
              a.kind === "Selected" ? "ch-ring-2 ch-ring-primary" : "ch-ring-0"
            ),
            onClick: o,
            children: [
              /* @__PURE__ */ l.jsxs("div", { className: "ch-relative", children: [
                /* @__PURE__ */ l.jsx(
                  $de,
                  {
                    sessionStateContext: i,
                    displayContext: e
                  }
                ),
                /* @__PURE__ */ l.jsx("div", { className: "ch-absolute ch-left-2 ch-top-2 ch-z-10", children: /* @__PURE__ */ l.jsx(
                  ace,
                  {
                    displayContext: { stockPreview: e.availableBaseRoom.stockPreview }
                  }
                ) })
              ] }),
              /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6 ch-p-4", children: [
                /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
                  /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold", children: e.availableBaseRoom.name }),
                  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-wrap ch-items-baseline ch-space-x-2", children: [
                    /* @__PURE__ */ l.jsx(
                      lce,
                      {
                        displayContext: { roomSize: e.availableBaseRoom.roomSize }
                      }
                    ),
                    /* @__PURE__ */ l.jsx(
                      Mde,
                      {
                        sessionStateContext: i,
                        modelContext: { beds: e.availableBaseRoom.beds }
                      }
                    ),
                    /* @__PURE__ */ l.jsx(
                      sce,
                      {
                        sessionStateContext: i,
                        displayContext: {
                          minimumDailyPrice: e.availableBaseRoom.minimumDailyPrice
                        }
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-justify-end", children: /* @__PURE__ */ l.jsx(
                  ece,
                  {
                    sessionStateContext: i,
                    displayContext: {
                      roomID: e.availableBaseRoom.roomID,
                      minimumDailyPrice: e.availableBaseRoom.minimumDailyPrice,
                      name: e.availableBaseRoom.name,
                      article: e.availableBaseRoom.article,
                      amenities: e.availableBaseRoom.amenities,
                      keyVisuals: e.availableBaseRoom.keyVisuals
                    }
                  }
                ) })
              ] })
            ]
          }
        )
      ]
    }
  );
}, oce = ({ uniqueRoomID: e, callbackContext: n, displayContext: i, sessionStateContext: t }) => /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-h-full ch-snap-x ch-snap-mandatory ch-gap-x-6 ch-overflow-x-scroll ch-bg-gray-100 ch-px-5 ch-pb-[42px] ch-pt-4", children: i.availableBaseRooms.map((a) => {
  const s = `${e}_${a.roomID}`;
  return /* @__PURE__ */ l.jsx(
    rce,
    {
      sessionStateContext: t,
      displayContext: { availableBaseRoom: a, availableBaseRooms: i.availableBaseRooms },
      modelContext: {
        uniqueRoomID: e,
        availableBaseRoom: a,
        sessionStateContext: t
      },
      callbackContext: {
        onUpdateBaseRoom: n.onUpdateBaseRoom(a.roomID)
      }
    },
    s
  );
}) }), dce = ({ sessionStateContext: { lang: e } }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "選択できる部屋が存在しません。異なるプランや人数、日付を選択して再度確認してください。";
      case D.En:
        return "No rooms available for selection. Please select a different plan, number of people, or date and check again.";
      default:
        return "";
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-px-5 ch-text-sm", children: n });
}, cce = ({ sessionStateContext: e, uniqueRoomID: n, displayContext: i, callbackContext: t }) => ke(i.availableBaseRooms) ? /* @__PURE__ */ l.jsx(dce, { sessionStateContext: e }) : /* @__PURE__ */ l.jsx(
  oce,
  {
    uniqueRoomID: n,
    callbackContext: t,
    sessionStateContext: e,
    displayContext: i
  }
), J7 = ({
  availableEachRoomsList: e
}) => ({
  kind: "AvailableEachRoomsListFetched",
  availableEachRoomsList: e
}), uce = ({ onAvailableEachRoomsListQuery: e }) => ({
  kind: "AvailableEachRoomsListNotFetched",
  onAvailableEachRoomsListQuery: e
}), _7 = (e) => {
  let n = "データの取得に失敗しました";
  return e.error instanceof Error && (n = e.error.message), {
    kind: "FetchFailed",
    errorInfo: {
      message: n
    },
    onRefetchAvailableEachRoomsList: e.onRefetchAvailableEachRoomsList
  };
}, mce = ({ stateContext: e, callbackContext: n }) => ({
  onRefetchAvailableData: I(
    (t) => async () => {
      try {
        const a = await t.onRefetchAvailableEachRoomsList(), s = J7({ availableEachRoomsList: a });
        e.onChangeState(s);
      } catch (a) {
        const s = _7({
          error: a,
          onRefetchAvailableEachRoomsList: n.onAvailableEachRoomsListQuery
        });
        throw e.onChangeState(s), a;
      }
    },
    [n.onAvailableEachRoomsListQuery, e]
  )
}), kce = (e) => {
  const [n, i] = se(uce(e)), t = I((s) => {
    i(s);
  }, []);
  be(() => {
    (async () => {
      if (n.kind !== "AvailableEachRoomsListFetched")
        try {
          if (n.kind === "AvailableEachRoomsListNotFetched") {
            const r = await n.onAvailableEachRoomsListQuery(), o = J7({ availableEachRoomsList: r });
            t(o);
          }
        } catch (r) {
          const o = _7({
            error: r,
            onRefetchAvailableEachRoomsList: e.onAvailableEachRoomsListQuery
          });
          t(o);
        }
    })();
  }, [t, e, n]);
  const { onRefetchAvailableData: a } = mce({
    stateContext: { onChangeState: t },
    callbackContext: { onAvailableEachRoomsListQuery: e.onAvailableEachRoomsListQuery }
  });
  return {
    state: n,
    onRefetchAvailableData: a
  };
}, fce = ({ roomID: e, uniqueRoomID: n, date: i, sessionStateContext: t }) => {
  const a = t.currentState.roomInfo.willReserve.filter((r) => !P(r)).find((r) => r.uniqueRoomID === n), s = a == null ? void 0 : a.dailyItems.find(
    (r) => {
      var o;
      return r.date === i && ((o = r.roomInfo) == null ? void 0 : o.roomID) === e;
    }
  );
  return P(s) ? {
    kind: "NotSelected"
  } : {
    kind: "Selected"
  };
}, vce = (e) => ({
  state: v(() => fce(e), [e])
}), hce = ({ beds: e }) => P(e) || ke(e) ? {
  kind: "NonDisplayable"
} : {
  kind: "Displayable",
  beds: e
}, pce = (e) => ({
  state: v(() => hce(e), [e])
}), Nce = ({ sessionStateContext: { lang: e }, displayContext: { bedInfo: n } }) => {
  const i = v(() => e === D.Default ? `${n.bedType} ${n.bedNum}つ` : `${n.bedNum} ${n.bedType}`, [n.bedNum, n.bedType, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: i });
}, Sce = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = pce(n);
  return i.kind === "Displayable" ? i.beds.map((t) => {
    const a = `${t.bedType}_${t.bedNum}`;
    return /* @__PURE__ */ l.jsx(Nce, { sessionStateContext: e, displayContext: { bedInfo: t } }, a);
  }) : null;
}, gce = ({ sessionStateContext: { lang: e }, displayContext: { capacityPeopleMaximum: n } }) => {
  const i = v(() => e === D.Default ? `定員~${n}名` : `Up to ${n} people`, [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: i });
}, Fce = ({ displayContext: { roomSize: e } }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: P(e) ? null : /* @__PURE__ */ l.jsxs("p", { className: "ch-text-sm", children: [
  e,
  "㎡"
] }) }), Ice = ({ sessionStateContext: { lang: e }, displayContext: { price: n } }) => {
  const i = v(() => `¥${n.toLocaleString()}`, [n]), t = v(() => e === D.Default ? "泊" : "night", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-[1px] ch-text-sm ch-font-semibold", children: [
    /* @__PURE__ */ l.jsx("p", { children: i }),
    /* @__PURE__ */ l.jsx("p", { children: "/" }),
    /* @__PURE__ */ l.jsx("p", { children: t })
  ] });
}, yce = ({ displayContext: e, callbackContext: n, sessionStateContext: i, modelContext: t }) => {
  const { state: a } = vce(t), { onShowLoadingScreenCallback: s, onHideLoadingScreenCallback: r } = fn(), o = I(async () => {
    s(), await n.onUpdateEachRoom().finally(() => {
      r();
    });
  }, [n, r, s]), d = v(() => {
    var c;
    return (c = e.availableRoom.keyVisuals.at(0)) != null ? c : "";
  }, [e.availableRoom.keyVisuals]);
  return /* @__PURE__ */ l.jsxs(
    "button",
    {
      className: ce(
        "ch-flex ch-w-full ch-items-center ch-gap-x-4 ch-rounded-xl ch-border-2 ch-p-4 ch-text-left",
        //
        a.kind === "Selected" ? "ch-border-primary" : "ch-border-gray-100"
      ),
      onClick: o,
      children: [
        /* @__PURE__ */ l.jsx("img", { src: d, className: "ch-h-20 ch-w-20 ch-rounded-lg" }),
        /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-items-start ch-space-y-3", children: [
          /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
            /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: e.availableRoom.name }),
            /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-wrap ch-items-center ch-space-x-2", children: [
              /* @__PURE__ */ l.jsx(Fce, { displayContext: { roomSize: e.availableRoom.roomSize } }),
              /* @__PURE__ */ l.jsx(
                Sce,
                {
                  sessionStateContext: i,
                  modelContext: {
                    beds: e.availableRoom.beds
                  }
                }
              ),
              /* @__PURE__ */ l.jsx(
                gce,
                {
                  sessionStateContext: i,
                  displayContext: {
                    capacityPeopleMaximum: e.availableRoom.capacityPeopleMaximum
                  }
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ l.jsx(
            Ice,
            {
              sessionStateContext: i,
              displayContext: { price: e.availableRoom.price }
            }
          )
        ] })
      ]
    }
  );
}, bce = ({
  sessionStateContext: e,
  displayContext: {
    availableEachRooms: { date: n, availableRooms: i }
  },
  callbackContext: { onUpdateEachRoom: t },
  modelContext: a
}) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-8", children: i.map((s) => {
  const r = `${n}_${s.roomID}`;
  return /* @__PURE__ */ l.jsx(
    yce,
    {
      sessionStateContext: e,
      displayContext: { availableRoom: s },
      callbackContext: { onUpdateEachRoom: t(n, s.roomID) },
      modelContext: { ...a, roomID: s.roomID, date: n }
    },
    r
  );
}) }), Cce = (e) => {
  const n = e.sessionStateContext.currentState.roomInfo.willReserve.filter((t) => !P(t)).find((t) => t.uniqueRoomID === e.uniqueRoomID), i = n == null ? void 0 : n.dailyItems.find((t) => t.date === e.date);
  return P(i == null ? void 0 : i.roomInfo) ? {
    kind: "NotSelected",
    lang: e.sessionStateContext.lang
  } : {
    kind: "Selected",
    selectedRoom: i.roomInfo
  };
}, xce = (e) => ({
  state: v(() => Cce(e), [e])
}), Dce = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "部屋を選択してください" : "Please select a room", [e]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, wce = (e) => {
  const { state: n } = xce(e);
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: n.kind === "NotSelected" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-flex", children: [
    /* @__PURE__ */ l.jsx(Dce, { lang: n.lang }),
    /* @__PURE__ */ l.jsx(sm, { className: "ch-text-urgent-400", size: "3xs" })
  ] }) : /* @__PURE__ */ l.jsx("p", { children: n.selectedRoom.name }) });
}, I3 = ({ sessionStateContext: { lang: e } }) => {
  const n = v(() => {
    const i = e === D.Default ? "下記日程で選択された部屋の在庫が確保できませんでした。" : "The room you selected is not available for the following dates.", t = e === D.Default ? "別の部屋を選択してください。" : "Please select another room.";
    return {
      urgentMessage1: i,
      urgentMessage2: t
    };
  }, [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-text-sm ch-text-urgent-400", children: [
    /* @__PURE__ */ l.jsx("p", { children: n.urgentMessage1 }),
    /* @__PURE__ */ l.jsx("p", { children: n.urgentMessage2 })
  ] });
}, Pce = ({ sessionStateContext: { lang: e } }) => {
  const n = v(() => e === D.Default ? "選択できる部屋のデータ取得に失敗しました。" : "Failed to fetch available room data.", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-text-urgent-400", children: n });
}, Rce = ({ sessionStateContext: { lang: e }, callbackContext: n }) => {
  const { onHideLoadingScreenCallback: i, onShowLoadingScreenCallback: t } = fn(), a = I(async () => {
    le(Pn({ target: "refetch", area: "room_each" })), t(), await n.onRefetchAvailableEachRoomsList().finally(() => {
      i();
    });
  }, [n, i, t]), s = v(() => {
    switch (e) {
      case D.Default:
        return "再取得";
      case D.En:
        return "Refetch";
      default:
        return "";
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: a, size: "md", children: s });
}, Tce = ({ sessionStateContext: e, callbackContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(Pce, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(Rce, { sessionStateContext: e, callbackContext: n })
] }), jce = ({ sessionStateContext: e, modelContext: n, callbackContext: i }) => {
  const { state: t, onRefetchAvailableData: a } = kce(n), s = ul();
  return t.kind === "AvailableEachRoomsListNotFetched" ? /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-8 ch-px-5 ch-pb-5", children: /* @__PURE__ */ l.jsx(I3, { sessionStateContext: e }) }) : t.kind === "FetchFailed" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8 ch-px-5 ch-pb-5", children: [
    /* @__PURE__ */ l.jsx(I3, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(
      Tce,
      {
        sessionStateContext: e,
        callbackContext: { onRefetchAvailableEachRoomsList: a(t) }
      }
    )
  ] }) : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8 ch-px-5 ch-pb-5", children: [
    /* @__PURE__ */ l.jsx(I3, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: t.availableEachRoomsList.map((r, o) => {
      const d = `${s}_${o}`, c = e.lang === D.Default ? Ne(r.date, "YYYY年MM月DD日") : Ne(r.date, "D MMM YYYY", "en");
      return /* @__PURE__ */ l.jsxs("div", { children: [
        /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold ch-tracking-wider", children: c }),
        /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, children: /* @__PURE__ */ l.jsxs(it, { value: "item", borderBottom: !1, children: [
          /* @__PURE__ */ l.jsx(tt, { className: "ch-px-0", children: /* @__PURE__ */ l.jsx(
            wce,
            {
              uniqueRoomID: n.uniqueRoomID,
              date: r.date,
              sessionStateContext: e
            }
          ) }),
          /* @__PURE__ */ l.jsx(at, { children: /* @__PURE__ */ l.jsx(
            bce,
            {
              displayContext: { availableEachRooms: r },
              callbackContext: i,
              sessionStateContext: e,
              modelContext: {
                uniqueRoomID: n.uniqueRoomID,
                sessionStateContext: e
              }
            }
          ) })
        ] }) })
      ] }, d);
    }) })
  ] });
}, Ace = ({
  uniqueRoomID: e,
  availableBaseRooms: n,
  sessionStateContext: i,
  onAvailableEachRoomsListQuery: t
}) => {
  const a = i.currentState.roomInfo.willReserve.filter((o) => (o == null ? void 0 : o.uniqueRoomID) === e && o.baseRoomInfo).map((o) => o == null ? void 0 : o.baseRoomInfo.baseRoomID);
  return n.filter(
    (o) => a.includes(o.roomID)
  ).some(
    (o) => o.isRoomChangeRequired
  ) ? {
    kind: "ShouldSelectEachRoom",
    onAvailableEachRoomsListQuery: t
  } : {
    kind: "ShouldNotSelectEachRoom"
  };
}, Oce = (e) => ({
  state: v(() => Ace(e), [e])
}), Ece = ({ sessionStateContext: e, modelContext: n, callbackContext: i }) => {
  const { state: t } = Oce(n);
  return t.kind === "ShouldSelectEachRoom" ? /* @__PURE__ */ l.jsx(
    jce,
    {
      sessionStateContext: e,
      modelContext: n,
      callbackContext: i
    }
  ) : null;
}, Jce = Ve(
  /* GraphQL */
  `
	query RCRoomBaseAvailable($baseInfo: BaseInfoInput!, $roomInfo: RoomAvailableInput!) {
		roomBaseAvailable(baseInfo: $baseInfo, roomInfo: $roomInfo) {
			availableRooms {
				roomID
				name
				keyVisuals
				isDormitory
				minimumDailyPrice
				article
				isRoomChangeRequired
				amenities {
					bathrooms
					roomAmenities
					roomFacilities
				}
				catchCopy
				beds {
					bedType
					bedNum
				}
				capacityPeopleMaximum
				roomSize
				stockPreview {
					remainingStock
					grade
				}
			}
		}
	}
`
), _ce = Ve(
  /* GraphQL */
  `
	query RCRoomEachAvailable($baseInfo: BaseInfoInput!, $roomInfo: RoomAvailableInput!) {
		roomEachAvailable(baseInfo: $baseInfo, roomInfo: $roomInfo) {
			availableRoomsList {
				date
				availableRooms {
					roomID
					name
					isDormitory
					capacityPeopleMaximum
					keyVisuals
					price
					beds {
						bedType
						bedNum
					}
					capacityPeopleMaximum
					roomSize
				}
			}
		}
	}
`
), Qce = Ve(
  /* GraphQL */
  `
	mutation RCRoomBaseUpdate($baseInfo: BaseInfoInput!, $roomBaseInfo: RoomBaseUpdateInput!) {
		roomBaseUpdate(baseInfo: $baseInfo, roomBaseInfo: $roomBaseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Mce = Ve(
  /* GraphQL */
  `
	mutation RCRoomEachUpdate($baseInfo: BaseInfoInput!, $roomEachInfo: RoomEachUpdateInput!) {
		roomEachUpdate(baseInfo: $baseInfo, roomEachInfo: $roomEachInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Lce = ({ uniqueRoomID: e }) => {
  const { baseInfoInput: n } = lt(), { onUpdateSession: i } = Ji(), { mutationFunc: t } = Gn(Qce);
  return {
    onUpdateBaseRoom: I(
      (s) => async () => {
        const { data: r } = await t({
          variables: {
            baseInfo: n,
            roomBaseInfo: {
              roomID: s,
              groupID: e
            }
          }
        });
        i(r.roomBaseUpdate), le(
          yn({
            target: "room",
            action: "update",
            room_id: s
          })
        );
      },
      [n, t, i, e]
    )
  };
}, $ce = ({ uniqueRoomID: e }) => {
  const { baseInfoInput: n } = lt(), { onUpdateSession: i } = Ji(), { mutationFunc: t } = Gn(Mce);
  return {
    onUpdateEachRoom: I(
      (s, r) => async () => {
        const { data: o } = await t({
          variables: {
            baseInfo: n,
            roomEachInfo: {
              date: s,
              roomID: r,
              groupID: e
            }
          }
        });
        i(o.roomEachUpdate);
        const { currentState: d } = Ss(o.roomEachUpdate);
        le(
          yn({
            target: "room_each",
            action: "update",
            room_id: r,
            room_index: d.groupInfo.findIndex((c) => c.uniqueRoomID === e)
          })
        );
      },
      [n, t, i, e]
    )
  };
}, Uce = !0, Vce = ({ uniqueRoomID: e }) => {
  const { baseInfoInput: n } = lt(), { refetch: i } = qn(Jce, {}, Uce);
  return {
    onAvailableBaseRoomsQuery: I(async () => {
      const { data: a } = await i({
        baseInfo: n,
        roomInfo: { groupID: e }
      });
      return a.roomBaseAvailable.availableRooms;
    }, [n, i, e])
  };
}, Hce = !0, zce = ({ uniqueRoomID: e }) => {
  const { baseInfoInput: n } = lt(), { refetch: i } = qn(_ce, void 0, Hce);
  return {
    onAvailableEachRoomsListQuery: I(async () => {
      const { data: a } = await i({ baseInfo: n, roomInfo: { groupID: e } });
      return a.roomEachAvailable.availableRoomsList;
    }, [n, i, e])
  };
}, np = g(({ uniqueRoomID: e, sessionStateContext: n }) => {
  const { onAvailableBaseRoomsQuery: i } = Vce({ uniqueRoomID: e }), { onAvailableEachRoomsListQuery: t } = zce({ uniqueRoomID: e }), { onUpdateBaseRoom: a } = Lce({ uniqueRoomID: e }), { onUpdateEachRoom: s } = $ce({ uniqueRoomID: e });
  return /* @__PURE__ */ l.jsx(
    Ade,
    {
      sessionStateContext: n,
      onAvailableBaseRooms: i,
      children: ({ state: r }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
        /* @__PURE__ */ l.jsx(
          cce,
          {
            uniqueRoomID: e,
            displayContext: { availableBaseRooms: r.availableBaseRooms },
            sessionStateContext: n,
            callbackContext: { onUpdateBaseRoom: a }
          }
        ),
        /* @__PURE__ */ l.jsx(
          Ece,
          {
            sessionStateContext: n,
            callbackContext: { onUpdateEachRoom: s },
            modelContext: {
              uniqueRoomID: e,
              onAvailableEachRoomsListQuery: t,
              availableBaseRooms: r.availableBaseRooms,
              sessionStateContext: n
            }
          }
        )
      ] })
    }
  );
}), Bce = g(({ disabled: e, ...n }) => {
  const { onRemoveReservationStayDt: i } = lZ(n), t = I(
    (u) => async () => {
      await i().then(() => {
        u();
      });
    },
    [i]
  ), a = I(
    (u) => (k) => async () => {
      await (async () => {
        P(k) || await i();
      })().then(() => {
        u();
      });
    },
    [i]
  ), { checkDtState: s, onSelectCinDt: r, onSelectCoutDt: o, onResetCheckDt: d } = VZ(n), c = v(() => s.resetAt, [s.resetAt]);
  return /* @__PURE__ */ l.jsx(
    zd,
    {
      trackingTarget: "date",
      disabled: e,
      triggerSlot: /* @__PURE__ */ l.jsx($Z, { ...n }),
      contentContext: {
        titleSlot: /* @__PURE__ */ l.jsx(TZ, { ...n }),
        bodySlot: /* @__PURE__ */ l.jsx(
          Kh,
          {
            ...n,
            onSelectCinDtCallback: r,
            onSelectCoutDtCallback: o,
            onRemoveReservationStayDt: i
          },
          c
        ),
        footerSlot: ({ onCloseDrawer: u }) => /* @__PURE__ */ l.jsx(
          RZ,
          {
            modelContext: {
              ...n,
              selectedDtContext: {
                cinDt: s.cinDt,
                coutDt: s.coutDt
              },
              onSubmit: u,
              onResetForDayTripDt: t(d),
              onResetForStayDt: a(d)
            }
          }
        )
      }
    }
  );
});
g(() => /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-animate-pulse ch-space-y-6 ch-rounded ch-border-gray-300 ch-bg-white ch-px-6 ch-py-3", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-h-7 ch-w-28 ch-rounded-md ch-bg-gray-300" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-20 ch-rounded ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-24 ch-rounded ch-bg-gray-200" })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-20 ch-rounded ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-24 ch-rounded ch-bg-gray-200" })
  ] })
] }));
const qce = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "人数" : "Guests", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-black", children: n });
}, Gce = ({ sessionStateContext: e }) => {
  const n = v(() => {
    const t = e.currentState.groupInfo.reduce(
      (s, r) => s + r.adultNum,
      0
    ), a = e.currentState.groupInfo.reduce(
      (s, r) => s + r.kidsNum.length,
      0
    );
    return t + a;
  }, [e.currentState.groupInfo]), i = v(() => e.lang === D.Default ? `${n} 名` : `${n} guests`, [e.lang, n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}, Wce = ({ sessionStateContext: e }) => {
  const n = v(() => e.currentState.groupInfo.length, [e.currentState.groupInfo.length]), i = v(() => e.lang === D.Default ? `${n} 部屋` : `${n} rooms`, [e.lang, n]);
  return vs(e) ? null : /* @__PURE__ */ l.jsx("p", { children: i });
}, Kce = ({ sessionStateContext: e }) => {
  const n = v(
    () => e.currentState.groupInfo.reduce((t, a) => t + a.adultNum, 0),
    [e.currentState.groupInfo]
  ), i = v(() => e.lang === D.Default ? `大人 ${n} 名` : `${n} adults`, [e.lang, n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}, Yce = (e) => {
  const n = e.sessionStateContext.currentState.groupInfo.reduce(
    (t, a) => t + a.kidsNum.length,
    0
  );
  return n >= 1 ? {
    kind: "Displayable",
    totalChildNum: n
  } : {
    kind: "NotDisplayable"
  };
}, Xce = (e) => ({
  state: v(() => Yce(e), [e])
}), Zce = "・", eue = ({ sessionStateContext: e, totalChildNum: n }) => {
  const i = v(() => e.lang === D.Default ? `子ども ${n} 名` : `${n} children`, [e.lang, n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-[1px]", children: [
    /* @__PURE__ */ l.jsx("p", { children: Zce }),
    /* @__PURE__ */ l.jsx("p", { children: i })
  ] });
}, nue = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = Xce(n);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsx(eue, { sessionStateContext: e, totalChildNum: i.totalChildNum }) : null;
}, iue = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-justify-end ch-space-x-3", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-space-x-2 ch-text-base", children: [
    /* @__PURE__ */ l.jsx(Wce, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(Gce, { sessionStateContext: e })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-space-x-[1px] ch-text-sm", children: [
    /* @__PURE__ */ l.jsx(Kce, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(
      nue,
      {
        sessionStateContext: e,
        modelContext: { sessionStateContext: e }
      }
    )
  ] })
] })), tue = g(({ sessionStateContext: e, callbackContext: n }) => {
  const i = v(() => e.lang === D.Default ? "決定する" : "Confirm", [e.lang]), t = I(() => {
    n.onSubmitCallback();
  }, [n]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", onClick: t, children: i });
}), aue = ({ callbackContext: e, sessionStateContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-px-1 ch-py-4", children: [
  /* @__PURE__ */ l.jsx(iue, { sessionStateContext: n }),
  /* @__PURE__ */ l.jsx(tue, { sessionStateContext: n, callbackContext: e })
] }), lue = Ve(
  /* GraphQL */
  `
	query RCReservationDetailQuery($baseInfo: BaseInfoInput!) {
		currentStateViewModel(baseInfo: $baseInfo) {
			guestCurrentStateViewModel {
				hotelID
				reservationID
				sessionID
				footerSectionInfo {
					priceLabelText
					totalGuestChargePriceText
					beforeDiscountPriceText
				}
				headerSectionInfo {
					titleText
				}
				scheduleSectionInfo {
					sectionTitle
					sectionContent {
						... on GuestCurrentStateViewModelScheduleSectionInfoContentForDayTrip {
							stayDateLabel
							stayDateText
						}
						... on GuestCurrentStateViewModelScheduleSectionInfoContentForOverNightTrip {
							checkInDateLabel
							checkInDateText
							checkInTimeText
							checkOutDateLabel
							checkOutDateText
							checkOutTimeText
						}
					}
				}
				resourceReserveSectionInfo {
					sectionTitle {
						titleText
					}
					sectionContent {
						planInfo {
							title {
								titleText
								totalPlanPriceText
							}
							content {
								mainKeyVisual
								scheduleText
								planPriceText
								planNameText
								detail {
									planNameText
									detailTriggerText
									lang
									keyVisuals
									article
									policies {
										planPolicy {
											label
											checkInLabel
											checkInTimeText
											checkOutLabel
											checkOutTimeText
										}
										cancelPolicy {
											... on GuestCurrentStateViewModelCancelPolicyUnCancelable {
												label
												text
											}
											... on GuestCurrentStateViewModelCancelPolicyNoCharge {
												label
												text
											}
											... on GuestCurrentStateViewModelCancelPolicyItems {
												label
												items {
													beforeDaysText
													chargeRatioText
												}
											}
										}
										kidsPolicy {
											... on GuestCurrentStateViewModelKidsPolicyNotExist {
												label
												text
											}
											... on GuestCurrentStateViewModelKidsPolicyItems {
												label
												items {
													agesText
													detailText
												}
											}
										}
									}
								}
							}
						}
						roomInfo {
							title {
								titleText
								totalRoomPriceText
							}
							content {
								roomInfoPerGroup {
									title {
										titleText
										groupTotalRoomPriceText
									}
									content {
										numberOfGuestsText
										roomInfoPerDay {
											... on RoomInfoPerDayNotExists {
												text
											}
											... on RoomInfoPerDayExists {
												mainKeyVisual
												roomNameText
												roomDateText
												roomPriceText
												detail {
													roomNameText
													keyVisuals
													article
													detailTriggerText
													lang
													notes {
														amenityRoom
														amenityBathroom
														facility
													}
												}
											}
										}
									}
								}
							}
						}
						optionInfo {
							title {
								titleText
								totalOptionPriceText
							}
							content {
								optionInfo {
									keyVisual
									optionNameText
									detail {
										... on OptionInfoPerReservation {
											items {
												priceText
												countText
												subOptionNameText
												timeText
												nextMorningText
											}
										}
										... on OptionInfoPerDay {
											items {
												dateText
												items {
													priceText
													countText
													subOptionNameText
													timeText
													nextMorningText
												}
											}
										}
									}
								}
								optionDetail {
									detailTriggerText
									optionName
									optionDescription
									notes {
										cancelPolicy {
											... on GuestCurrentStateViewModelCancelPolicyUnCancelable {
												label
												text
											}
											... on GuestCurrentStateViewModelCancelPolicyNoCharge {
												label
												text
											}
											... on GuestCurrentStateViewModelCancelPolicyItems {
												label
												items {
													beforeDaysText
													chargeRatioText
												}
											}
										}
									}
								}
							}
						}
						timeSlotOptionInfo {
							title {
								titleText
								totalOptionPriceText
							}
							content {
								optionInfo {
									keyVisual
									optionNameText
									detail {
										... on OptionInfoPerReservation {
											items {
												priceText
												countText
												subOptionNameText
												timeText
												nextMorningText
											}
										}
										... on OptionInfoPerDay {
											items {
												dateText
												items {
													priceText
													countText
													subOptionNameText
													timeText
													nextMorningText
												}
											}
										}
									}
								}
								optionDetail {
									detailTriggerText
									optionName
									optionDescription
									notes {
										cancelPolicy {
											... on GuestCurrentStateViewModelCancelPolicyUnCancelable {
												label
												text
											}
											... on GuestCurrentStateViewModelCancelPolicyNoCharge {
												label
												text
											}
											... on GuestCurrentStateViewModelCancelPolicyItems {
												label
												items {
													beforeDaysText
													chargeRatioText
												}
											}
										}
									}
								}
							}
						}
						additionalFeeInfo {
							title {
								titleText
								totalAdditionalPriceText
							}
							content {
								items {
									nameText
									priceText
								}
							}
						}
					}
				}
				resourceCancelSectionInfo {
					sectionTitleText
					sectionContent {
						canceledPlanInfo {
							title {
								titleText
								totalCanceledPlanPriceText
							}
							content {
								scheduleText
								canceledPlanNameText
								canceledPlanPriceText
							}
						}
						canceledRoomInfo {
							title {
								titleText
								totalCanceledRoomPriceText
							}
							content {
								dateText
								canceledRoomNameText
								canceledRoomPriceText
								numberOfGuestsText
							}
						}
						canceledOptionInfo {
							title {
								titleText
								totalCanceledOptionPriceText
							}
							content {
								... on GuestCurrentStateViewModelResourceCancelSectionCanceledOptionInfoContentItemPerReservation {
									nameText
									items {
										scheduleText
										priceText
										countText
										subOptionNameText
									}
								}
								... on GuestCurrentStateViewModelResourceCancelSectionCanceledOptionInfoContentItemPerDay {
									nameText
									items {
										dateText
										items {
											priceText
											countText
											subOptionNameText
											timeText
											nextMorningText
										}
									}
								}
							}
						}
					}
				}
				discountSectionInfo {
					sectionTitleText
					sectionContent {
						discountNameText
						discountPriceText
					}
				}
			}
		}
	}
`
), sue = ({ sessionStateContext: e }) => {
  const { refetch: n } = qn(lue, {}, !0);
  return {
    onFetchReservationDetail: I(async () => {
      const { data: t } = await n({ baseInfo: e.baseInfoInput });
      return {
        guestCurrentStateViewModel: t.currentStateViewModel.guestCurrentStateViewModel
      };
    }, [n, e.baseInfoInput])
  };
}, rue = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onFetchReservationDetail,
  sessionStateContext: e.sessionStateContext
}), Q7 = (e) => (n) => ({
  kind: "Initialized",
  guestCurrentStateViewModel: e.guestCurrentStateViewModel,
  sessionStateContext: n.sessionStateContext
}), M7 = (e) => () => ({
  kind: "Errored",
  onInitialize: e.onFetchReservationDetail,
  sessionStateContext: e.sessionStateContext
}), oue = ({ state: e, onChangeState: n, erroredInputContext: i }) => {
  const t = Ye(!1);
  be(() => {
    t.current || e.kind !== "NotInitialized" || (t.current = !0, e.onInitialize().then((a) => {
      const s = { guestCurrentStateViewModel: a.guestCurrentStateViewModel };
      n(Q7(s)(e));
    }).catch(() => {
      n(M7(i)(e));
    }));
  }, [i, n, e]);
}, due = ({ onChangeState: e, erroredInputContext: n }) => ({
  onReInitialize: I(
    (t) => async () => {
      await t.onInitialize().then((a) => {
        const s = { guestCurrentStateViewModel: a.guestCurrentStateViewModel };
        e(Q7(s)(t));
      }).catch(() => {
        e(M7(n)(t));
      });
    },
    [n, e]
  )
}), cue = (e) => {
  const [n, i] = se(rue(e)), t = I((s) => {
    i(s);
  }, []);
  oue({ state: n, onChangeState: t, erroredInputContext: e });
  const { onReInitialize: a } = due({ onChangeState: t, erroredInputContext: e });
  return {
    state: n,
    onReInitialize: a
  };
}, uue = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = I(async () => {
    le(
      Pn({
        target: "refetch",
        area: "reservation_detail"
      })
    ), await n.onRefetch();
  }, [n]), t = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: i, children: t });
}, mue = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "データが正しく取得できませんでした。" : "Failed to fetch data.", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, kue = ({ sessionStateContext: e, callbackContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(mue, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(uue, { sessionStateContext: e, callbackContext: n })
] }), fue = () => /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-justify-center ch-py-3", children: /* @__PURE__ */ l.jsx("div", { className: "ch-h-5 ch-w-1/4 ch-animate-pulse ch-rounded ch-bg-gray-200 ch-text-center" }) }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-8 ch-px-5 ch-py-6", children: Array.from({ length: 5 }).map((e, n) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-2", children: /* @__PURE__ */ l.jsx("div", { className: "ch-h-5 ch-w-1/4 ch-animate-pulse ch-rounded ch-bg-gray-200" }) }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-h-4 ch-w-full ch-animate-pulse ch-rounded ch-bg-gray-200" }),
      /* @__PURE__ */ l.jsx("div", { className: "ch-h-4 ch-w-full ch-animate-pulse ch-rounded ch-bg-gray-200" })
    ] })
  ] }, n)) })
] }), vue = g(({ children: e, ...n }) => {
  const { state: i, onReInitialize: t } = cue(n);
  return i.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(fue, {}) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(
    kue,
    {
      sessionStateContext: i.sessionStateContext,
      callbackContext: { onRefetch: t(i) }
    }
  ) : e({ state: i });
}), hue = ({ sectionContent: e }) => P(e) ? null : /* @__PURE__ */ l.jsx("div", { children: e.map((n, i) => {
  const t = `${n.__typename}-${i}`;
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: n.discountNameText }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-medium", children: n.discountPriceText })
  ] }, t);
}) }), g2 = ({ text: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black", children: e }), pue = ({ sectionTitleText: e }) => /* @__PURE__ */ l.jsx(g2, { text: e }), Nue = ({ discountSectionInfo: e }) => P(e) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
  /* @__PURE__ */ l.jsx(pue, { sectionTitleText: e.sectionTitleText }),
  /* @__PURE__ */ l.jsx(hue, { sectionContent: e.sectionContent })
] }), Sue = ({ beforeDiscountPriceText: e }) => P(e) ? null : /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400 ch-line-through", children: e }), gue = ({ footerSectionInfo: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-border-t ch-border-t-gray-200 ch-p-5", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-start ch-justify-between", children: [
  /* @__PURE__ */ l.jsx("label", { className: "ch-block ch-text-xs ch-font-semibold", children: e.priceLabelText }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-text-right", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold", children: e.totalGuestChargePriceText }),
    /* @__PURE__ */ l.jsx(
      Sue,
      {
        beforeDiscountPriceText: e.beforeDiscountPriceText
      }
    )
  ] })
] }) }), Fue = ({ headerSectionInfo: e, displayContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-grid ch-w-full ch-max-w-screen-tablet ch-grid-cols-[10%_1fr_10%] ch-items-center ch-border-b ch-border-t-gray-200 ch-px-5 ch-py-2", children: [
  n.headerSectionContext.leftSlot,
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-center ch-text-xl ch-font-semibold", children: e.titleText })
] }), Iue = ({ nameText: e, items: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-5", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: e }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-8", children: n.map((i, t) => {
    const a = `${i.__typename}-${t}`;
    return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
      /* @__PURE__ */ l.jsx("p", { children: i.dateText }),
      /* @__PURE__ */ l.jsx("div", { children: i.items.map((s, r) => {
        const o = `${s.__typename}-${r}`;
        return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
          /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
            /* @__PURE__ */ l.jsx("p", { children: s.subOptionNameText }),
            /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: s.priceText })
          ] }),
          /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
            /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-space-x-1.5 ch-text-sm ch-text-gray-400", children: [
              /* @__PURE__ */ l.jsx("p", { children: s.timeText }),
              /* @__PURE__ */ l.jsx("p", { children: s.nextMorningText })
            ] }),
            /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: s.countText })
          ] })
        ] }, o);
      }) })
    ] }, a);
  }) })
] }), yue = ({ nameText: e, items: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-5", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: e }),
  /* @__PURE__ */ l.jsx("div", { children: n.map((i, t) => {
    const a = `${i.__typename}-${t}`;
    return /* @__PURE__ */ l.jsxs("div", { children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
        /* @__PURE__ */ l.jsx("p", { children: i.subOptionNameText }),
        /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: i.priceText })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
        /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-gray-400", children: i.scheduleText }),
        /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: i.countText })
      ] })
    ] }, a);
  }) })
] }), bue = (e) => {
  if (e.__typename === "GuestCurrentStateViewModelResourceCancelSectionCanceledOptionInfoContentItemPerDay")
    return /* @__PURE__ */ l.jsx(Iue, { ...e });
  if (e.__typename === "GuestCurrentStateViewModelResourceCancelSectionCanceledOptionInfoContentItemPerReservation")
    return /* @__PURE__ */ l.jsx(yue, { ...e });
  throw new Error("Invalid __typename");
}, Cue = ({ content: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-8 ch-pb-8", children: e.map((n, i) => {
  const t = `${n.__typename}-${i}`;
  return /* @__PURE__ */ l.jsx(bue, { ...n }, t);
}) }), xue = ({ title: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-items-center ch-justify-between", children: [
  /* @__PURE__ */ l.jsx("p", { children: e.titleText }),
  /* @__PURE__ */ l.jsx("p", { children: e.totalCanceledOptionPriceText })
] }), Fl = ({ children: e, value: n }) => /* @__PURE__ */ l.jsx(it, { value: n, children: e }), Il = ({ children: e }) => /* @__PURE__ */ l.jsx(at, { className: "ch-whitespace-pre-wrap ch-px-0 ch-pb-4 ch-pt-0 ch-text-sm ch-font-light tablet:ch-px-0 tablet:ch-pt-0", children: e }), yl = ({ children: e }) => /* @__PURE__ */ l.jsx(
  tt,
  {
    hover: !1,
    className: "ch-w-full ch-gap-x-1 ch-px-0 ch-py-5 ch-font-semibold",
    children: e
  }
), Due = "price-detail-accordion-item-canceled-room-info", wue = ({ canceledOptionInfo: e }) => P(e) ? null : /* @__PURE__ */ l.jsxs(Fl, { value: Due, children: [
  /* @__PURE__ */ l.jsx(yl, { children: /* @__PURE__ */ l.jsx(xue, { title: e.title }) }),
  /* @__PURE__ */ l.jsx(Il, { children: /* @__PURE__ */ l.jsx(Cue, { content: e.content }) })
] }), Pue = ({ content: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-8 ch-pb-8", children: e.map((n, i) => {
  const t = `${n.__typename}-${i}`;
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
      /* @__PURE__ */ l.jsx("p", { children: n.canceledPlanNameText }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-font-medium", children: n.canceledPlanPriceText })
    ] }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-gray-400", children: n.scheduleText })
  ] }, t);
}) }), Rue = ({ title: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-items-center ch-justify-between", children: [
  /* @__PURE__ */ l.jsx("p", { children: e.titleText }),
  /* @__PURE__ */ l.jsx("p", { children: e.totalCanceledPlanPriceText })
] }), Tue = "price-detail-accordion-item-canceled-plan-info", jue = ({ canceledPlanInfo: e }) => P(e) ? null : /* @__PURE__ */ l.jsxs(Fl, { value: Tue, children: [
  /* @__PURE__ */ l.jsx(yl, { children: /* @__PURE__ */ l.jsx(Rue, { title: e.title }) }),
  /* @__PURE__ */ l.jsx(Il, { children: /* @__PURE__ */ l.jsx(Pue, { content: e.content }) })
] }), Aue = ({ content: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-8 ch-pb-8", children: e.map((n, i) => {
  const t = `${n.__typename}-${i}`;
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
      /* @__PURE__ */ l.jsx("p", { children: n.canceledRoomNameText }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-font-medium", children: n.canceledRoomPriceText })
    ] }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-gray-400", children: n.dateText }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-gray-400", children: n.numberOfGuestsText })
  ] }, t);
}) }), Oue = ({ title: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-items-center ch-justify-between", children: [
  /* @__PURE__ */ l.jsx("p", { children: e.titleText }),
  /* @__PURE__ */ l.jsx("p", { children: e.totalCanceledRoomPriceText })
] }), Eue = "price-detail-accordion-item-canceled-room-info", Jue = ({ canceledRoomInfo: e }) => P(e) ? null : /* @__PURE__ */ l.jsxs(Fl, { value: Eue, children: [
  /* @__PURE__ */ l.jsx(yl, { children: /* @__PURE__ */ l.jsx(Oue, { title: e.title }) }),
  /* @__PURE__ */ l.jsx(Il, { children: /* @__PURE__ */ l.jsx(Aue, { content: e.content }) })
] }), _ue = ({ sectionContent: e }) => P(e) ? null : /* @__PURE__ */ l.jsx(qi, { type: "multiple", children: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx(jue, { canceledPlanInfo: e.canceledPlanInfo }),
  /* @__PURE__ */ l.jsx(Jue, { canceledRoomInfo: e.canceledRoomInfo }),
  /* @__PURE__ */ l.jsx(wue, { canceledOptionInfo: e.canceledOptionInfo })
] }) }), Que = ({ sectionTitleText: e }) => /* @__PURE__ */ l.jsx(g2, { text: e }), Mue = ({ resourceCancelSectionInfo: e }) => P(e) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
  /* @__PURE__ */ l.jsx(Que, { sectionTitleText: e.sectionTitleText }),
  /* @__PURE__ */ l.jsx(_ue, { sectionContent: e.sectionContent })
] }), Lue = ({ content: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-2.5", children: e.items.map((n, i) => {
  const t = `${n.__typename}-${i}`;
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal", children: n.nameText }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-medium", children: n.priceText })
  ] }, t);
}) }), $ue = ({ title: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-items-center ch-justify-between", children: [
  /* @__PURE__ */ l.jsx("p", { children: e.titleText }),
  /* @__PURE__ */ l.jsx("p", { children: e.totalAdditionalPriceText })
] }), Uue = "price-detail-accordion-item-additional-fee-info", Vue = ({ additionalFeeInfo: e }) => P(e) ? null : /* @__PURE__ */ l.jsxs(Fl, { value: Uue, children: [
  /* @__PURE__ */ l.jsx(yl, { children: /* @__PURE__ */ l.jsx($ue, { title: e.title }) }),
  /* @__PURE__ */ l.jsx(Il, { children: /* @__PURE__ */ l.jsx(Lue, { content: e.content }) })
] }), Hue = ({ items: e }) => /* @__PURE__ */ l.jsx("div", { children: e.map((n, i) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-1", children: [
  /* @__PURE__ */ l.jsx("p", { children: n.beforeDaysText }),
  /* @__PURE__ */ l.jsx("p", { children: "：" }),
  /* @__PURE__ */ l.jsx("p", { children: n.chargeRatioText })
] }, i)) }), zue = ({ text: e }) => /* @__PURE__ */ l.jsx("p", { children: e }), Bue = ({ text: e }) => /* @__PURE__ */ l.jsx("p", { children: e }), que = ({ cancelPolicy: e }) => {
  if (e.__typename === "GuestCurrentStateViewModelCancelPolicyUnCancelable")
    return /* @__PURE__ */ l.jsx(Bue, { ...e });
  if (e.__typename === "GuestCurrentStateViewModelCancelPolicyNoCharge")
    return /* @__PURE__ */ l.jsx(zue, { ...e });
  if (e.__typename === "GuestCurrentStateViewModelCancelPolicyItems")
    return /* @__PURE__ */ l.jsx(Hue, { ...e });
  throw new Error("Invalid __typename");
}, Gue = ({ cancelPolicy: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5 ch-text-sm", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: e.label }),
  /* @__PURE__ */ l.jsx(que, { cancelPolicy: e })
] }), Wue = ({ notes: e }) => P(e) ? null : /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6 ch-rounded-lg ch-bg-gray-300/20 ch-px-4 ch-py-[18px]", children: /* @__PURE__ */ l.jsx(Gue, { cancelPolicy: e.cancelPolicy }) }), Kue = ({ optionDetail: e }) => {
  const n = I((s) => {
    s.stopPropagation();
  }, []), i = I((s) => {
    s.stopPropagation();
  }, []), t = I((s) => {
    s.stopPropagation();
  }, []), a = I((s) => {
    s.stopPropagation();
  }, []);
  return /* @__PURE__ */ l.jsxs(Dr, { children: [
    /* @__PURE__ */ l.jsx(
      Et,
      {
        asChild: !0,
        onClick: n,
        className: "!tablet:ch-px-0 !ch-px-0 ch-py-1.5",
        children: /* @__PURE__ */ l.jsx(ae, { variant: "underline", size: "xs", className: "ch-font-semibold", children: e.detailTriggerText })
      }
    ),
    /* @__PURE__ */ l.jsxs(wr, { children: [
      /* @__PURE__ */ l.jsx(a1, { onClick: a }),
      /* @__PURE__ */ l.jsxs(
        Pr,
        {
          onClick: i,
          className: "ch-h-drawer-almost-full-nested ch-max-h-drawer-almost-full-nested ch-font-system-ui",
          "aria-describedby": void 0,
          children: [
            /* @__PURE__ */ l.jsxs(yt, { className: "ch-mx-auto ch-grid ch-w-full ch-max-w-screen-tablet ch-grid-cols-[1fr_40px] ch-items-center ch-px-5 ch-pb-5 ch-pt-3", children: [
              /* @__PURE__ */ l.jsx("p", { className: "ch-line-clamp-1", children: e.optionName }),
              /* @__PURE__ */ l.jsx(pd, { onClick: t, children: /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) }) })
            ] }),
            /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-space-y-14 ch-overflow-y-scroll ch-px-4 ch-pb-6 ch-pt-4", children: [
              /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-wrap ch-text-sm ch-font-light", children: e.optionDescription }),
              /* @__PURE__ */ l.jsx(Wue, { notes: e.notes })
            ] })
          ]
        }
      )
    ] })
  ] });
}, Yue = ({ items: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6", children: e.map((n, i) => {
  const t = `${n.__typename}-${n.dateText}-${i}`;
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: n.dateText }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6", children: n.items.map((a, s) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
        /* @__PURE__ */ l.jsx("p", { children: a.subOptionNameText }),
        /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: a.priceText })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
        /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-space-x-1.5", children: [
          /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: a.timeText }),
          /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: a.nextMorningText })
        ] }),
        /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: a.countText })
      ] })
    ] }, s)) })
  ] }, t);
}) }), Xue = ({ items: e }) => /* @__PURE__ */ l.jsx("div", { children: e.map((n, i) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { children: n.subOptionNameText }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: n.priceText })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-space-x-1.5", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: n.timeText }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: n.nextMorningText })
    ] }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: n.countText })
  ] })
] }, i)) }), Zue = ({ detail: e }) => {
  if (e.__typename === "OptionInfoPerDay")
    return /* @__PURE__ */ l.jsx(Yue, { ...e });
  if (e.__typename === "OptionInfoPerReservation")
    return /* @__PURE__ */ l.jsx(Xue, { ...e });
  throw new Error("Invalid __typename");
}, eme = ({ optionInfo: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsx(
    Nd,
    {
      displayContext: { imageUrl: e.keyVisual },
      styleContext: {
        borderRadius: "6px",
        height: "120px",
        aspectRatio: "auto"
      }
    }
  ),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: e.optionNameText }),
  /* @__PURE__ */ l.jsx(Zue, { detail: e.detail })
] }), L7 = ({ content: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-8", children: e.map((n, i) => {
  const t = `${n.__typename}-${i}`;
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3 ch-pb-6", children: [
    /* @__PURE__ */ l.jsx(eme, { optionInfo: n.optionInfo }),
    /* @__PURE__ */ l.jsx(Kue, { optionDetail: n.optionDetail })
  ] }, t);
}) }), $7 = ({ title: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-items-center ch-justify-between", children: [
  /* @__PURE__ */ l.jsx("p", { children: e.titleText }),
  /* @__PURE__ */ l.jsx("p", { children: e.totalOptionPriceText })
] }), nme = "price-detail-accordion-item-option-info", ime = ({ optionInfo: e }) => P(e) ? null : /* @__PURE__ */ l.jsxs(Fl, { value: nme, children: [
  /* @__PURE__ */ l.jsx(yl, { children: /* @__PURE__ */ l.jsx($7, { title: e.title }) }),
  /* @__PURE__ */ l.jsx(Il, { children: /* @__PURE__ */ l.jsx(L7, { content: e.content }) })
] }), tme = ({ items: e }) => /* @__PURE__ */ l.jsx("div", { children: e.map((n, i) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-1", children: [
  /* @__PURE__ */ l.jsx("p", { children: n.beforeDaysText }),
  /* @__PURE__ */ l.jsx("p", { children: "：" }),
  /* @__PURE__ */ l.jsx("p", { children: n.chargeRatioText })
] }, i)) }), ame = ({ text: e }) => /* @__PURE__ */ l.jsx("p", { children: e }), lme = ({ text: e }) => /* @__PURE__ */ l.jsx("p", { children: e }), sme = ({ cancelPolicy: e }) => {
  if (e.__typename === "GuestCurrentStateViewModelCancelPolicyUnCancelable")
    return /* @__PURE__ */ l.jsx(lme, { ...e });
  if (e.__typename === "GuestCurrentStateViewModelCancelPolicyNoCharge")
    return /* @__PURE__ */ l.jsx(ame, { ...e });
  if (e.__typename === "GuestCurrentStateViewModelCancelPolicyItems")
    return /* @__PURE__ */ l.jsx(tme, { ...e });
  throw new Error("Invalid __typename");
}, rme = ({ cancelPolicy: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5 ch-text-sm", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: e.label }),
  /* @__PURE__ */ l.jsx(sme, { cancelPolicy: e })
] }), ome = ({ items: e }) => /* @__PURE__ */ l.jsx("div", { children: e.map((n, i) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-1", children: [
  /* @__PURE__ */ l.jsx("p", { children: n.agesText }),
  /* @__PURE__ */ l.jsx("p", { children: "：" }),
  /* @__PURE__ */ l.jsx("p", { children: n.detailText })
] }, i)) }), dme = ({ text: e }) => /* @__PURE__ */ l.jsx("p", { children: e }), cme = ({ kidsPolicy: e }) => {
  if (e.__typename === "GuestCurrentStateViewModelKidsPolicyNotExist")
    return /* @__PURE__ */ l.jsx(dme, { ...e });
  if (e.__typename === "GuestCurrentStateViewModelKidsPolicyItems")
    return /* @__PURE__ */ l.jsx(ome, { ...e });
  throw new Error("Invalid __typename");
}, ume = ({ kidsPolicy: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5 ch-text-sm", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: e.label }),
  /* @__PURE__ */ l.jsx(cme, { kidsPolicy: e })
] }), mme = ({ planPolicy: e }) => P(e) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5 ch-text-sm", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: e.label }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-1", children: [
    /* @__PURE__ */ l.jsx("p", { children: e.checkInLabel }),
    /* @__PURE__ */ l.jsx("p", { children: "：" }),
    /* @__PURE__ */ l.jsx("p", { children: e.checkInTimeText })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-1", children: [
    /* @__PURE__ */ l.jsx("p", { children: e.checkOutLabel }),
    /* @__PURE__ */ l.jsx("p", { children: "：" }),
    /* @__PURE__ */ l.jsx("p", { children: e.checkOutTimeText })
  ] })
] }), kme = ({ policies: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6 ch-rounded-lg ch-bg-gray-300/20 ch-px-4 ch-py-[18px]", children: [
  /* @__PURE__ */ l.jsx(mme, { planPolicy: e.planPolicy }),
  /* @__PURE__ */ l.jsx(rme, { cancelPolicy: e.cancelPolicy }),
  /* @__PURE__ */ l.jsx(ume, { kidsPolicy: e.kidsPolicy })
] }), fme = ({ sessionStateContext: e, detail: n }) => {
  const i = I((r) => {
    r.stopPropagation();
  }, []), t = I((r) => {
    r.stopPropagation();
  }, []), a = I((r) => {
    r.stopPropagation();
  }, []), s = I((r) => {
    r.stopPropagation();
  }, []);
  return /* @__PURE__ */ l.jsxs(Dr, { children: [
    /* @__PURE__ */ l.jsx(
      Et,
      {
        asChild: !0,
        onClick: i,
        className: "!tablet:ch-px-0 !ch-px-0 ch-py-1.5",
        children: /* @__PURE__ */ l.jsx(ae, { variant: "underline", size: "xs", className: "ch-font-semibold", children: n.detailTriggerText })
      }
    ),
    /* @__PURE__ */ l.jsxs(wr, { children: [
      /* @__PURE__ */ l.jsx(a1, { onClick: s }),
      /* @__PURE__ */ l.jsxs(
        Pr,
        {
          onClick: t,
          className: "ch-h-drawer-almost-full-nested ch-max-h-drawer-almost-full-nested ch-font-system-ui",
          "aria-describedby": void 0,
          children: [
            /* @__PURE__ */ l.jsxs(yt, { className: "ch-mx-auto ch-grid ch-w-full ch-max-w-screen-tablet ch-grid-cols-[1fr_40px] ch-items-center ch-px-5 ch-pb-5 ch-pt-3", children: [
              /* @__PURE__ */ l.jsx("p", { className: "ch-line-clamp-1", children: n.planNameText }),
              /* @__PURE__ */ l.jsx(pd, { onClick: a, children: /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) }) })
            ] }),
            /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-space-y-14 ch-overflow-y-scroll ch-px-4 ch-pb-6 ch-pt-4", children: [
              /* @__PURE__ */ l.jsx(
                Ut,
                {
                  modelContext: {
                    imageUrls: n.keyVisuals
                  },
                  styleContext: {
                    borderRadius: "4px"
                  }
                }
              ),
              n.article && /* @__PURE__ */ l.jsx(
                fm,
                {
                  lang: e.lang,
                  articleUrl: n.article
                }
              ),
              /* @__PURE__ */ l.jsx(kme, { policies: n.policies })
            ] })
          ]
        }
      )
    ] })
  ] });
}, vme = ({ sessionStateContext: e, content: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsx(
    Nd,
    {
      displayContext: { imageUrl: n.mainKeyVisual },
      styleContext: {
        borderRadius: "6px",
        height: "120px",
        aspectRatio: "auto"
      }
    }
  ),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: n.planNameText }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-text-right", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: n.planPriceText }) }),
  /* @__PURE__ */ l.jsx(fme, { sessionStateContext: e, detail: n.detail })
] }), hme = ({ title: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-items-center ch-justify-between", children: [
  /* @__PURE__ */ l.jsx("p", { children: e.titleText }),
  /* @__PURE__ */ l.jsx("p", { children: e.totalPlanPriceText })
] }), pme = "price-detail-accordion-item-plan-info", Nme = ({ sessionStateContext: e, planInfo: n }) => P(n) ? null : /* @__PURE__ */ l.jsxs(Fl, { value: pme, children: [
  /* @__PURE__ */ l.jsx(yl, { children: /* @__PURE__ */ l.jsx(hme, { title: n.title }) }),
  /* @__PURE__ */ l.jsx(Il, { children: /* @__PURE__ */ l.jsx(vme, { sessionStateContext: e, content: n.content }) })
] }), ip = ({ iconSlot: e, items: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
  /* @__PURE__ */ l.jsx("div", { children: e }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-grid ch-grid-cols-2 ch-gap-x-4", children: n.map((i, t) => /* @__PURE__ */ l.jsx("p", { className: "ch-col-span-1 ch-text-sm", children: i }, t)) })
] }), Sme = ({ amenityBathroom: e }) => P(e) ? null : /* @__PURE__ */ l.jsx(ip, { items: e, iconSlot: /* @__PURE__ */ l.jsx(tI, {}) }), gme = ({ amenityRoom: e }) => P(e) ? null : /* @__PURE__ */ l.jsx(ip, { items: e, iconSlot: /* @__PURE__ */ l.jsx(wf, {}) }), Fme = ({ facility: e }) => P(e) ? null : /* @__PURE__ */ l.jsx(ip, { items: e, iconSlot: /* @__PURE__ */ l.jsx(im, {}) }), Ime = ({ notes: e }) => P(e) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6 ch-rounded-lg ch-bg-gray-300/20 ch-px-4 ch-py-[18px]", children: [
  /* @__PURE__ */ l.jsx(Sme, { amenityBathroom: e.amenityBathroom }),
  /* @__PURE__ */ l.jsx(gme, { amenityRoom: e.amenityRoom }),
  /* @__PURE__ */ l.jsx(Fme, { facility: e.facility })
] }), yme = ({ sessionStateContext: e, detail: n }) => {
  const i = I((r) => {
    r.stopPropagation();
  }, []), t = I((r) => {
    r.stopPropagation();
  }, []), a = I((r) => {
    r.stopPropagation();
  }, []), s = I((r) => {
    r.stopPropagation();
  }, []);
  return /* @__PURE__ */ l.jsxs(Dr, { children: [
    /* @__PURE__ */ l.jsx(
      Et,
      {
        asChild: !0,
        onClick: i,
        className: "!tablet:ch-px-0 !ch-px-0 ch-py-1.5",
        children: /* @__PURE__ */ l.jsx(ae, { variant: "underline", size: "xs", className: "ch-font-semibold", children: n.detailTriggerText })
      }
    ),
    /* @__PURE__ */ l.jsxs(wr, { children: [
      /* @__PURE__ */ l.jsx(a1, { onClick: s }),
      /* @__PURE__ */ l.jsxs(
        Pr,
        {
          onClick: t,
          className: "ch-h-drawer-almost-full-nested ch-max-h-drawer-almost-full-nested ch-font-system-ui",
          "aria-describedby": void 0,
          children: [
            /* @__PURE__ */ l.jsxs(yt, { className: "ch-mx-auto ch-grid ch-w-full ch-max-w-screen-tablet ch-grid-cols-[1fr_40px] ch-items-center ch-px-5 ch-pb-5 ch-pt-3", children: [
              /* @__PURE__ */ l.jsx("p", { className: "ch-line-clamp-1", children: n.roomNameText }),
              /* @__PURE__ */ l.jsx(pd, { onClick: a, children: /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) }) })
            ] }),
            /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-space-y-14 ch-overflow-y-scroll ch-px-4 ch-pb-6 ch-pt-4", children: [
              /* @__PURE__ */ l.jsx(
                Ut,
                {
                  modelContext: {
                    imageUrls: n.keyVisuals
                  },
                  styleContext: {
                    borderRadius: "4px"
                  }
                }
              ),
              n.article && /* @__PURE__ */ l.jsx(
                fm,
                {
                  lang: e.lang,
                  articleUrl: n.article
                }
              ),
              /* @__PURE__ */ l.jsx(Ime, { notes: n.notes })
            ] })
          ]
        }
      )
    ] })
  ] });
}, bme = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3 ch-border-b ch-pb-6 last:ch-border-none", children: [
  /* @__PURE__ */ l.jsx(
    Nd,
    {
      displayContext: { imageUrl: e.mainKeyVisual },
      styleContext: {
        borderRadius: "6px",
        height: "120px",
        aspectRatio: "auto"
      }
    }
  ),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: e.roomNameText }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: e.roomDateText }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: e.roomPriceText })
  ] }),
  /* @__PURE__ */ l.jsx(yme, { sessionStateContext: e.sessionStateContext, detail: e.detail })
] }), Cme = ({ text: e }) => /* @__PURE__ */ l.jsx("p", { children: e }), xme = (e) => {
  switch (e.__typename) {
    case "RoomInfoPerDayNotExists":
      return /* @__PURE__ */ l.jsx(Cme, { ...e });
    case "RoomInfoPerDayExists":
      return /* @__PURE__ */ l.jsx(bme, { ...e });
    default:
      return null;
  }
}, Dme = ({ content: e, sessionStateContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: e.numberOfGuestsText }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: e.roomInfoPerDay.map((i, t) => /* @__PURE__ */ l.jsx(
    xme,
    {
      sessionStateContext: n,
      ...i
    },
    t
  )) })
] }), wme = ({ title: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-font-normal", children: e.titleText }), Pme = ({ content: e, sessionStateContext: n }) => /* @__PURE__ */ l.jsx(qi, { type: "multiple", children: /* @__PURE__ */ l.jsx("div", { className: "ch-pl-4", children: e.roomInfoPerGroup.map((i, t) => {
  const a = `price-detail-accordion-item-room-info-per-group-item-${t}`;
  return /* @__PURE__ */ l.jsxs(Fl, { value: a, children: [
    /* @__PURE__ */ l.jsx(yl, { children: /* @__PURE__ */ l.jsx(wme, { title: i.title }) }),
    /* @__PURE__ */ l.jsx(Il, { children: /* @__PURE__ */ l.jsx(
      Dme,
      {
        sessionStateContext: n,
        content: i.content
      }
    ) })
  ] }, a);
}) }) }), Rme = ({ title: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-items-center ch-justify-between", children: [
  /* @__PURE__ */ l.jsx("p", { children: e.titleText }),
  /* @__PURE__ */ l.jsx("p", { children: e.totalRoomPriceText })
] }), Tme = "price-detail-accordion-item-room-info", jme = ({ roomInfo: e, sessionStateContext: n }) => P(e) ? null : /* @__PURE__ */ l.jsxs(Fl, { value: Tme, children: [
  /* @__PURE__ */ l.jsx(yl, { children: /* @__PURE__ */ l.jsx(Rme, { title: e.title }) }),
  /* @__PURE__ */ l.jsx(Il, { children: /* @__PURE__ */ l.jsx(Pme, { sessionStateContext: n, content: e.content }) })
] }), Ame = "price-detail-accordion-item-time-slot-info", Ome = ({ timeSlotOptionInfo: e }) => P(e) ? null : /* @__PURE__ */ l.jsxs(Fl, { value: Ame, children: [
  /* @__PURE__ */ l.jsx(yl, { children: /* @__PURE__ */ l.jsx($7, { title: e.title }) }),
  /* @__PURE__ */ l.jsx(Il, { children: /* @__PURE__ */ l.jsx(L7, { content: e.content }) })
] }), Eme = ({ sectionContent: e, sessionStateContext: n }) => P(e) ? null : (e.additionalFeeInfo, /* @__PURE__ */ l.jsx(qi, { type: "multiple", children: /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx(
    Nme,
    {
      sessionStateContext: n,
      planInfo: e.planInfo
    }
  ),
  /* @__PURE__ */ l.jsx(
    jme,
    {
      sessionStateContext: n,
      roomInfo: e.roomInfo
    }
  ),
  /* @__PURE__ */ l.jsx(Ome, { timeSlotOptionInfo: e.timeSlotOptionInfo }),
  /* @__PURE__ */ l.jsx(ime, { optionInfo: e.optionInfo }),
  /* @__PURE__ */ l.jsx(Vue, { additionalFeeInfo: e.additionalFeeInfo })
] }) })), Jme = ({ sectionTitle: e }) => /* @__PURE__ */ l.jsx(g2, { text: e.titleText }), _me = ({ resourceReserveSectionInfo: e, sessionStateContext: n }) => P(e) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
  /* @__PURE__ */ l.jsx(Jme, { sectionTitle: e.sectionTitle }),
  /* @__PURE__ */ l.jsx(
    Eme,
    {
      sessionStateContext: n,
      sectionContent: e.sectionContent
    }
  )
] }), Qme = g(({ stayDateLabel: e, stayDateText: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: e }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal", children: n })
] })), Mme = ({ checkInDateLabel: e, checkInDateText: n, checkInTimeText: i }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: e }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-4", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal", children: n }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal", children: i })
  ] })
] }), Lme = ({ checkOutDateLabel: e, checkOutDateText: n, checkOutTimeText: i }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: e }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-4", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal", children: n }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal", children: i })
  ] })
] }), $me = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(
    Mme,
    {
      checkInDateLabel: e.checkInDateLabel,
      checkInDateText: e.checkInDateText,
      checkInTimeText: e.checkInTimeText
    }
  ),
  /* @__PURE__ */ l.jsx(
    Lme,
    {
      checkOutDateLabel: e.checkOutDateLabel,
      checkOutDateText: e.checkOutDateText,
      checkOutTimeText: e.checkOutTimeText
    }
  )
] }), Ume = ({ sectionContent: e }) => {
  if (e.__typename === "GuestCurrentStateViewModelScheduleSectionInfoContentForOverNightTrip")
    return /* @__PURE__ */ l.jsx($me, { ...e });
  if (e.__typename === "GuestCurrentStateViewModelScheduleSectionInfoContentForDayTrip")
    return /* @__PURE__ */ l.jsx(Qme, { ...e });
  throw new Error("Invalid __typename");
}, Vme = ({ sectionTitle: e }) => /* @__PURE__ */ l.jsx(g2, { text: e }), Hme = ({ scheduleSectionInfo: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
  /* @__PURE__ */ l.jsx(Vme, { sectionTitle: e.sectionTitle }),
  /* @__PURE__ */ l.jsx(Ume, { sectionContent: e.sectionContent })
] }), zme = ({ displayContext: e, sessionStateContext: n, ...i }) => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx(
    Fue,
    {
      headerSectionInfo: i.headerSectionInfo,
      displayContext: e
    }
  ),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-h-full ch-w-full ch-max-w-screen-tablet ch-space-y-20 ch-overflow-y-scroll ch-px-5 ch-py-6", children: [
    /* @__PURE__ */ l.jsx(Hme, { scheduleSectionInfo: i.scheduleSectionInfo }),
    /* @__PURE__ */ l.jsx(
      _me,
      {
        sessionStateContext: n,
        resourceReserveSectionInfo: i.resourceReserveSectionInfo
      }
    ),
    /* @__PURE__ */ l.jsx(
      Mue,
      {
        resourceCancelSectionInfo: i.resourceCancelSectionInfo
      }
    ),
    /* @__PURE__ */ l.jsx(Nue, { discountSectionInfo: i.discountSectionInfo })
  ] }),
  /* @__PURE__ */ l.jsx(gue, { footerSectionInfo: i.footerSectionInfo })
] }), F2 = g(({ sessionStateContext: e, displayContext: n }) => {
  const { onFetchReservationDetail: i } = sue({
    sessionStateContext: e
  });
  return /* @__PURE__ */ l.jsx(
    vue,
    {
      sessionStateContext: e,
      onFetchReservationDetail: i,
      children: ({ state: t }) => /* @__PURE__ */ l.jsx(
        zme,
        {
          ...t.guestCurrentStateViewModel,
          sessionStateContext: e,
          displayContext: n
        }
      )
    }
  );
}), Bme = g(() => /* @__PURE__ */ l.jsx("svg", { width: "18", height: "20", viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l.jsx(
  "path",
  {
    d: "M16 2H15V0H13V2H5V0H3V2H2C0.89 2 0.00999999 2.9 0.00999999 4L0 18C0 19.1 0.89 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 18H2V8H16V18ZM16 6H2V4H16V6ZM6 12H4V10H6V12ZM10 12H8V10H10V12ZM14 12H12V10H14V12ZM6 16H4V14H6V16ZM10 16H8V14H10V16ZM14 16H12V14H14V16Z",
    fill: "#4d4d4d"
  }
) })), qme = g(() => /* @__PURE__ */ l.jsx(l.Fragment, { children: "日付" })), Gme = g(() => /* @__PURE__ */ l.jsx(l.Fragment, { children: "date" })), Wme = (e) => e.sessionStateContext.lang === D.Default ? {
  kind: "ForDefaultDisplayable",
  lang: D.Default
} : {
  kind: "ForEnDisplayable",
  lang: D.En
}, Kme = (e) => ({
  state: v(() => Wme(e), [e])
}), U7 = g(({ forDefaultSlot: e, forEnSlot: n, ...i }) => {
  const { state: t } = Kme(i);
  if (t.kind === "ForDefaultDisplayable")
    return e;
  if (t.kind === "ForEnDisplayable")
    return n;
  throw new Error("Invalid LangCode.");
}), Yme = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-bold ch-text-zinc-500", children: /* @__PURE__ */ l.jsx(
  U7,
  {
    sessionStateContext: e,
    forDefaultSlot: /* @__PURE__ */ l.jsx(qme, {}),
    forEnSlot: /* @__PURE__ */ l.jsx(Gme, {})
  }
) })), Xme = (e) => {
  if (P(e.sessionStateContext.currentState.dateInfo))
    return {
      kind: "NotSelected"
    };
  if (e.sessionStateContext.reservationPolicy.isDayTrip && !P(e.sessionStateContext.currentState.dateInfo.stayStartDt))
    return {
      kind: "StayAsDayTripDtSelected",
      dayTripDt: e.sessionStateContext.currentState.dateInfo.stayStartDt
    };
  if (!Ke(e.sessionStateContext.currentState.dateInfo.stayStartDt) && !Ke(e.sessionStateContext.currentState.dateInfo.stayLastDt))
    return {
      kind: "StayAsReservationDtSelected",
      cinDt: e.sessionStateContext.currentState.dateInfo.stayStartDt,
      coutDt: Ci({
        date: e.sessionStateContext.currentState.dateInfo.stayLastDt,
        inc: 1
      })
    };
  throw new Error("Invalid dateInfo.");
}, Zme = (e) => ({
  state: v(() => Xme(e), [e])
}), e2e = g((e) => {
  const { state: n } = Zme(e), i = v(() => {
    if (n.kind === "StayAsDayTripDtSelected")
      return Ne(n.dayTripDt, "YYYY年MM月DD日");
    if (n.kind === "StayAsReservationDtSelected") {
      const t = Ne(n.cinDt, "YYYY年MM月DD日"), a = Ne(n.coutDt, "MM月DD日");
      return `${t} 〜 ${a}`;
    } else
      return "未選択";
  }, [n]);
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: i });
}), n2e = (e) => {
  if (P(e.sessionStateContext.currentState.dateInfo))
    return {
      kind: "NotSelected"
    };
  if (e.sessionStateContext.reservationPolicy.isDayTrip && !P(e.sessionStateContext.currentState.dateInfo.stayStartDt))
    return {
      kind: "StayAsDayTripDtSelected",
      dayTripDt: e.sessionStateContext.currentState.dateInfo.stayStartDt
    };
  if (!Ke(e.sessionStateContext.currentState.dateInfo.stayStartDt) && !Ke(e.sessionStateContext.currentState.dateInfo.stayLastDt))
    return {
      kind: "StayAsReservationDtSelected",
      cinDt: e.sessionStateContext.currentState.dateInfo.stayStartDt,
      coutDt: Ci({
        date: e.sessionStateContext.currentState.dateInfo.stayLastDt,
        inc: 1
      })
    };
  throw new Error("Invalid dateInfo.");
}, i2e = (e) => ({
  state: v(() => n2e(e), [e])
}), t2e = g((e) => {
  const { state: n } = i2e(e), i = v(() => {
    if (n.kind === "StayAsDayTripDtSelected")
      return Ne(n.dayTripDt, "D MMM YYYY", "en");
    if (n.kind === "StayAsReservationDtSelected") {
      const t = Ne(n.cinDt, "D MMM YYYY", "en"), a = Ne(n.coutDt, "D MMM YYYY", "en");
      return `${t} 〜 ${a}`;
    } else
      return "unselected";
  }, [n]);
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: i });
}), a2e = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx("h3", { children: /* @__PURE__ */ l.jsx(
  U7,
  {
    sessionStateContext: e,
    forDefaultSlot: /* @__PURE__ */ l.jsx(e2e, { sessionStateContext: e }),
    forEnSlot: /* @__PURE__ */ l.jsx(t2e, { sessionStateContext: e })
  }
) })), l2e = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-4", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-flex-none", children: /* @__PURE__ */ l.jsx(Bme, {}) }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-flex-1 ch-gap-y-2 ch-text-left", children: [
    /* @__PURE__ */ l.jsx(Yme, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(a2e, { sessionStateContext: e })
  ] })
] })), s2e = g(() => /* @__PURE__ */ l.jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l.jsx(
  "path",
  {
    d: "M8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2ZM8 12C10.7 12 13.8 13.29 14 14H2C2.23 13.28 5.31 12 8 12ZM8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z",
    fill: "#4d4d4d"
  }
) })), r2e = g(() => /* @__PURE__ */ l.jsx(l.Fragment, { children: "人数" })), o2e = g(() => /* @__PURE__ */ l.jsx(l.Fragment, { children: "Number of Guests" })), d2e = (e) => e.sessionStateContext.lang === D.Default ? {
  kind: "ForDefaultDisplayable",
  lang: D.Default
} : {
  kind: "ForEnDisplayable",
  lang: D.En
}, c2e = (e) => ({
  state: v(() => d2e(e), [e])
}), kf = g(({ forDefaultSlot: e, forEnSlot: n, ...i }) => {
  const { state: t } = c2e(i);
  if (t.kind === "ForDefaultDisplayable")
    return e;
  if (t.kind === "ForEnDisplayable")
    return n;
  throw new Error("Invalid LangCode.");
}), u2e = (e) => e.sessionStateContext.reservationPolicy.isDayTrip ? {
  kind: "DayTripDisplayable"
} : {
  kind: "ReservationDisplayable"
}, m2e = (e) => ({
  state: v(() => u2e(e), [e])
}), k2e = g(({ reservationSlot: e, dayTripSlot: n, ...i }) => {
  const { state: t } = m2e(i);
  return t.kind === "DayTripDisplayable" ? n : e;
}), f2e = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-bold ch-text-zinc-500", children: /* @__PURE__ */ l.jsx(
  kf,
  {
    sessionStateContext: e,
    forDefaultSlot: /* @__PURE__ */ l.jsx(r2e, {}),
    forEnSlot: /* @__PURE__ */ l.jsx(o2e, {})
  }
) })), v2e = (e) => {
  const n = e.sessionStateContext.currentState.groupInfo.reduce(
    (t, a) => t + a.adultNum,
    0
  ), i = e.sessionStateContext.currentState.groupInfo.reduce(
    (t, a) => t + a.kidsNum.length,
    0
  );
  return i === 0 ? {
    kind: "KidsNumNotSelected",
    totalAdultNum: n
  } : {
    kind: "AllSelected",
    totalAdultNum: n,
    totalKidsNum: i
  };
}, h2e = (e) => ({
  state: v(() => v2e(e), [e])
}), p2e = g((e) => {
  const { state: n } = h2e(e), i = v(() => n.kind === "AllSelected" ? `大人${n.totalAdultNum}名 子ども${n.totalKidsNum}名` : `${n.totalAdultNum}名`, [n]);
  return /* @__PURE__ */ l.jsx("h3", { children: i });
}), N2e = (e) => {
  const n = e.sessionStateContext.currentState.groupInfo.reduce(
    (t, a) => t + a.adultNum,
    0
  ), i = e.sessionStateContext.currentState.groupInfo.reduce(
    (t, a) => t + a.kidsNum.length,
    0
  );
  return i === 0 ? {
    kind: "KidsNumNotSelected",
    totalAdultNum: n
  } : {
    kind: "AllSelected",
    totalAdultNum: n,
    totalKidsNum: i
  };
}, S2e = (e) => ({
  state: v(() => N2e(e), [e])
}), g2e = g((e) => {
  const { state: n } = S2e(e), i = v(() => n.kind === "AllSelected" ? `${n.totalAdultNum} adult(s), ${n.totalKidsNum} kid(s)` : `${n.totalAdultNum} guest(s)`, [n]);
  return /* @__PURE__ */ l.jsx("h3", { children: i });
}), F2e = (e) => {
  const n = e.sessionStateContext.currentState.groupInfo.length, i = e.sessionStateContext.currentState.groupInfo.reduce(
    (a, s) => a + s.adultNum,
    0
  ), t = e.sessionStateContext.currentState.groupInfo.reduce(
    (a, s) => a + s.kidsNum.length,
    0
  );
  return t === 0 ? {
    kind: "KidsNumNotSelected",
    totalRoomNum: n,
    totalAdultNum: i
  } : {
    kind: "AllSelected",
    totalRoomNum: n,
    totalAdultNum: i,
    totalKidsNum: t
  };
}, I2e = (e) => ({
  state: v(() => F2e(e), [e])
}), y2e = g((e) => {
  const { state: n } = I2e(e), i = v(() => {
    if (n.kind === "AllSelected") {
      const t = n.totalAdultNum + n.totalKidsNum;
      return `${n.totalRoomNum}部屋 合計${t}名 [大人${n.totalAdultNum}名 子ども${n.totalKidsNum}名]`;
    } else
      return `${n.totalRoomNum}部屋 ${n.totalAdultNum}名`;
  }, [n]);
  return /* @__PURE__ */ l.jsx("h3", { children: i });
}), b2e = (e) => {
  const n = e.sessionStateContext.currentState.groupInfo.length, i = e.sessionStateContext.currentState.groupInfo.reduce(
    (a, s) => a + s.adultNum,
    0
  ), t = e.sessionStateContext.currentState.groupInfo.reduce(
    (a, s) => a + s.kidsNum.length,
    0
  );
  return t === 0 ? {
    kind: "KidsNumNotSelected",
    totalRoomNum: n,
    totalAdultNum: i
  } : {
    kind: "AllSelected",
    totalRoomNum: n,
    totalAdultNum: i,
    totalKidsNum: t
  };
}, C2e = (e) => ({
  state: v(() => b2e(e), [e])
}), x2e = g((e) => {
  const { state: n } = C2e(e), i = v(() => {
    if (n.kind === "AllSelected") {
      const t = n.totalAdultNum + n.totalKidsNum;
      return `${n.totalRoomNum} room(s), ${t} guest(s) [${n.totalAdultNum} adult(s), ${n.totalKidsNum} kid(s)]`;
    } else
      return `${n.totalRoomNum} room(s), ${n.totalAdultNum} guest(s)`;
  }, [n]);
  return /* @__PURE__ */ l.jsx("h3", { children: i });
}), D2e = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx(
  k2e,
  {
    sessionStateContext: e,
    reservationSlot: /* @__PURE__ */ l.jsx(
      kf,
      {
        sessionStateContext: e,
        forDefaultSlot: /* @__PURE__ */ l.jsx(y2e, { sessionStateContext: e }),
        forEnSlot: /* @__PURE__ */ l.jsx(x2e, { sessionStateContext: e })
      }
    ),
    dayTripSlot: /* @__PURE__ */ l.jsx(
      kf,
      {
        sessionStateContext: e,
        forDefaultSlot: /* @__PURE__ */ l.jsx(p2e, { sessionStateContext: e }),
        forEnSlot: /* @__PURE__ */ l.jsx(g2e, { sessionStateContext: e })
      }
    )
  }
)), w2e = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-4", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-flex-none", children: /* @__PURE__ */ l.jsx(s2e, {}) }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-flex-1 ch-gap-y-2 ch-text-left", children: [
    /* @__PURE__ */ l.jsx(f2e, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(D2e, { sessionStateContext: e })
  ] })
] })), P2e = g(() => /* @__PURE__ */ l.jsx("svg", { width: "18", height: "20", viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l.jsx(
  "path",
  {
    d: "M13 4V12H16V20H18V0C15.24 0 13 2.24 13 4ZM8 7H6V0H4V7H2V0H0V7C0 9.21 1.79 11 4 11V20H6V11C8.21 11 10 9.21 10 7V0H8V7Z",
    fill: "#4d4d4d"
  }
) })), R2e = g(() => /* @__PURE__ */ l.jsx(l.Fragment, { children: "プラン" })), T2e = g(() => /* @__PURE__ */ l.jsx(l.Fragment, { children: "plan" })), j2e = (e) => e.sessionStateContext.lang === D.Default ? {
  kind: "ForDefaultDisplayable",
  lang: D.Default
} : {
  kind: "ForEnDisplayable",
  lang: D.En
}, A2e = (e) => ({
  state: v(() => j2e(e), [e])
}), V7 = g(({ forDefaultSlot: e, forEnSlot: n, ...i }) => {
  const { state: t } = A2e(i);
  if (t.kind === "ForDefaultDisplayable")
    return e;
  if (t.kind === "ForEnDisplayable")
    return n;
  throw new Error("Invalid LangCode.");
}), O2e = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-bold ch-text-zinc-500", children: /* @__PURE__ */ l.jsx(
  V7,
  {
    sessionStateContext: e,
    forDefaultSlot: /* @__PURE__ */ l.jsx(R2e, {}),
    forEnSlot: /* @__PURE__ */ l.jsx(T2e, {})
  }
) })), E2e = (e) => {
  var n;
  return P((n = e.sessionStateContext.currentState.planInfo) == null ? void 0 : n.willReserve) ? {
    kind: "NotSelected",
    isPlanSelectRequired: e.sessionStateContext.reservationPolicy.isPlanSelectRequired
  } : {
    kind: "Selected",
    name: e.sessionStateContext.currentState.planInfo.willReserve.name
  };
}, J2e = (e) => ({
  state: v(() => E2e(e), [e])
}), _2e = g((e) => {
  const { state: n } = J2e(e), i = v(() => n.kind === "NotSelected" ? `未選択${n.isPlanSelectRequired ? "（必須）" : ""} ` : n.name, [n]), t = v(() => n.kind === "NotSelected" && n.isPlanSelectRequired ? "ch-text-urgent-400" : "", [n]);
  return /* @__PURE__ */ l.jsx("span", { className: ce(t), children: i });
}), Q2e = (e) => {
  var n, i;
  return P((n = e.sessionStateContext.currentState.planInfo) == null ? void 0 : n.willReserve) ? {
    kind: "NotSelected",
    isPlanSelectRequired: e.sessionStateContext.reservationPolicy.isPlanSelectRequired
  } : {
    kind: "Selected",
    name: (i = e.sessionStateContext.currentState.planInfo) == null ? void 0 : i.willReserve.name
  };
}, M2e = (e) => ({
  state: v(() => Q2e(e), [e])
}), L2e = g((e) => {
  const { state: n } = M2e(e), i = v(() => n.kind === "NotSelected" ? `unselected${n.isPlanSelectRequired ? "(required)" : ""}` : n.name, [n]), t = v(() => n.kind === "NotSelected" && n.isPlanSelectRequired ? "ch-text-urgent-400" : "", [n]);
  return /* @__PURE__ */ l.jsx("span", { className: ce(t), children: i });
}), $2e = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx("h3", { children: /* @__PURE__ */ l.jsx(
  V7,
  {
    sessionStateContext: e,
    forDefaultSlot: /* @__PURE__ */ l.jsx(_2e, { sessionStateContext: e }),
    forEnSlot: /* @__PURE__ */ l.jsx(L2e, { sessionStateContext: e })
  }
) })), U2e = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-4", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-flex-none", children: /* @__PURE__ */ l.jsx(P2e, {}) }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-flex-1 ch-gap-y-2 ch-text-left", children: [
    /* @__PURE__ */ l.jsx(O2e, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx($2e, { sessionStateContext: e })
  ] })
] })), V2e = g(() => /* @__PURE__ */ l.jsx("svg", { width: "22", height: "16", viewBox: "0 0 22 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l.jsx(
  "path",
  {
    d: "M6 9.5C7.66 9.5 9 8.16 9 6.5C9 4.84 7.66 3.5 6 3.5C4.34 3.5 3 4.84 3 6.5C3 8.16 4.34 9.5 6 9.5ZM6 5.5C6.55 5.5 7 5.95 7 6.5C7 7.05 6.55 7.5 6 7.5C5.45 7.5 5 7.05 5 6.5C5 5.95 5.45 5.5 6 5.5ZM18 2.5H10V10.5H2V0.5H0V15.5H2V12.5H20V15.5H22V6.5C22 4.29 20.21 2.5 18 2.5ZM20 10.5H12V4.5H18C19.1 4.5 20 5.4 20 6.5V10.5Z",
    fill: "#4d4d4d"
  }
) })), H2e = g(({ roomIdx: e, sessionStateContext: n }) => {
  const i = v(() => n.reservationPolicy.customTypeRoomTitle === _a.Tent ? `テント-${e}` : `お部屋-${e}`, [e, n.reservationPolicy.customTypeRoomTitle]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-bold ch-text-zinc-500", children: i });
}), z2e = g(({ roomIdx: e, sessionStateContext: n }) => {
  const i = v(() => n.reservationPolicy.customTypeRoomTitle === _a.Tent ? `tent-${e}` : `room-${e}`, [e, n.reservationPolicy.customTypeRoomTitle]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-bold ch-text-zinc-500", children: i });
}), B2e = g(({ roomIdx: e, sessionStateContext: n }) => {
  if (n.lang === D.Default)
    return /* @__PURE__ */ l.jsx(H2e, { roomIdx: e, sessionStateContext: n });
  if (n.lang === D.En)
    return /* @__PURE__ */ l.jsx(z2e, { roomIdx: e, sessionStateContext: n });
  throw new Error("Invalid lang code.");
}), q2e = (e, n) => {
  var i;
  return (i = n.filter((t) => !P(t.baseRoomInfo)).find((t) => t.uniqueRoomID === e)) == null ? void 0 : i.baseRoomInfo;
}, G2e = (e) => {
  const n = e.sessionStateContext.currentState.roomInfo.willReserve.filter(
    (t) => !P(t)
  ), i = q2e(e.uniqueRoomID, n);
  return P(i) ? {
    kind: "NotSelected"
  } : {
    kind: "Selected",
    roomName: i.baseRoomName
  };
}, W2e = (e) => ({
  state: v(() => G2e(e), [e])
}), K2e = g((e) => {
  const { state: n } = W2e(e), i = v(() => n.kind === "NotSelected" ? "未選択" : n.roomName, [n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}), Y2e = (e, n) => {
  var i;
  return (i = n.filter((t) => !P(t.baseRoomInfo)).find((t) => t.uniqueRoomID === e)) == null ? void 0 : i.baseRoomInfo;
}, X2e = (e) => {
  const n = e.sessionStateContext.currentState.roomInfo.willReserve.filter(
    (t) => !P(t)
  ), i = Y2e(e.uniqueRoomID, n);
  return P(i) ? {
    kind: "NotSelected"
  } : {
    kind: "Selected",
    roomName: i.baseRoomName
  };
}, Z2e = (e) => ({
  state: v(() => X2e(e), [e])
}), e0e = g((e) => {
  const { state: n } = Z2e(e), i = v(() => n.kind === "NotSelected" ? "unselected" : n.roomName, [n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}), n0e = g(({ uniqueRoomID: e, sessionStateContext: n }) => {
  if (n.lang === D.Default)
    return /* @__PURE__ */ l.jsx(K2e, { uniqueRoomID: e, sessionStateContext: n });
  if (n.lang === D.En)
    return /* @__PURE__ */ l.jsx(e0e, { uniqueRoomID: e, sessionStateContext: n });
  throw new Error("Invalid lang code.");
}), i0e = g(({ roomIdx: e, uniqueRoomID: n, sessionStateContext: i }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-4", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-flex-none", children: /* @__PURE__ */ l.jsx(V2e, {}) }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-flex-1 ch-gap-y-2 ch-text-left", children: [
    /* @__PURE__ */ l.jsx(B2e, { roomIdx: e, sessionStateContext: i }),
    /* @__PURE__ */ l.jsx(n0e, { uniqueRoomID: n, sessionStateContext: i })
  ] })
] })), t0e = g(({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "人数" : "Guests", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), a0e = ({ sessionStateContext: e }) => {
  const n = v(() => {
    const i = e.currentState.groupInfo.length;
    return e.lang === D.Default ? `${i}部屋` : `${i} rooms`;
  }, [e.currentState.groupInfo.length, e.lang]);
  return vs(e) ? null : /* @__PURE__ */ l.jsx("p", { children: n });
}, l0e = ({ sessionStateContext: e }) => {
  const n = v(() => {
    const i = e.currentState.groupInfo.reduce(
      (t, a) => t + a.adultNum,
      0
    );
    return e.lang === D.Default ? `大人${i}名` : `${i} adults`;
  }, [e.currentState.groupInfo, e.lang]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, s0e = (e) => {
  const n = e.sessionStateContext.currentState.groupInfo.reduce(
    (t, a) => t + a.kidsNum.length,
    0
  );
  return n >= 1 ? {
    kind: "Displayable",
    lang: e.sessionStateContext.lang,
    totalChildNum: n
  } : {
    kind: "NotDisplayable"
  };
}, r0e = (e) => ({
  state: v(() => s0e(e), [e])
}), o0e = ({ lang: e, totalChildNum: n }) => {
  const i = v(() => e === D.Default ? `子ども${n}名` : `${n} children`, [e, n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}, d0e = (e) => {
  const { state: n } = r0e(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx(o0e, { lang: n.lang, totalChildNum: n.totalChildNum }) : null;
}, c0e = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-space-x-2 ch-text-lg ch-text-black", children: [
  /* @__PURE__ */ l.jsx(a0e, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(l0e, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(d0e, { sessionStateContext: e })
] })), H7 = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(t0e, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(c0e, { sessionStateContext: e })
] })), u0e = g(({ sessionStateContext: e }) => {
  const n = v(() => !!(e.reservationPolicy.isDayTrip || e.clientContext.planQueryFilter === It.OnlyDayTripPlans), [e.clientContext.planQueryFilter, e.reservationPolicy.isDayTrip]), i = v(() => kn(n ? {
    lang: e.lang,
    i18nString: {
      default: "日帰りプラン",
      en: "Day Trip Plan"
    }
  } : {
    lang: e.lang,
    i18nString: {
      default: "プラン",
      en: "Plan"
    }
  }), [e.lang, n]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: i });
}), m0e = (e) => e.sessionStateContext.currentState.planInfo.willReserve ? {
  kind: "Selected",
  sessionStateContext: {
    currentState: {
      willReservePlanInfo: e.sessionStateContext.currentState.planInfo.willReserve
    }
  }
} : {
  kind: "NotSelected",
  sessionStateContext: {
    reservationPolicy: e.sessionStateContext.reservationPolicy,
    lang: e.sessionStateContext.lang
  }
}, k0e = (e) => ({
  state: v(() => m0e(e), [e])
}), f0e = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "未選択" : "Not selected", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, v0e = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "（任意）" : "（Optional）", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, h0e = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "（必須）" : "（Required）", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, p0e = ({ sessionStateContext: e }) => e.reservationPolicy.isPlanSelectRequired ? /* @__PURE__ */ l.jsx(h0e, { sessionStateContext: e }) : /* @__PURE__ */ l.jsx(v0e, { sessionStateContext: e }), N0e = ({ stateContext: e }) => /* @__PURE__ */ l.jsxs(
  "div",
  {
    className: ce(
      "ch-flex ch-items-center ch-text-lg",
      //
      e.state.sessionStateContext.reservationPolicy.isPlanSelectRequired ? "ch-text-urgent-400" : "ch-text-gray-400"
    ),
    children: [
      /* @__PURE__ */ l.jsx(f0e, { sessionStateContext: e.state.sessionStateContext }),
      /* @__PURE__ */ l.jsx(p0e, { sessionStateContext: e.state.sessionStateContext })
    ]
  }
), S0e = ({ stateContext: e }) => {
  const n = v(() => e.state.sessionStateContext.currentState.willReservePlanInfo.name, [e.state.sessionStateContext.currentState.willReservePlanInfo.name]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-text-black", children: n });
}, g0e = g((e) => {
  const { state: n } = k0e(e);
  return n.kind === "Selected" ? /* @__PURE__ */ l.jsx(S0e, { stateContext: { state: n } }) : /* @__PURE__ */ l.jsx(N0e, { stateContext: { state: n } });
}), z7 = ({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(u0e, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(g0e, { sessionStateContext: e })
] }), F0e = (e) => e.sessionStateContext.currentState.groupInfo.length >= 2 ? {
  kind: "Displayable",
  roomIdx: e.roomIdx
} : {
  kind: "NotDisplayable"
}, I0e = (e) => ({
  state: v(() => F0e(e), [e])
}), y0e = (e) => {
  const { state: n } = I0e(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n.roomIdx }) : null;
}, b0e = g(({ sessionStateContext: e }) => {
  const n = v(() => e.reservationPolicy.customTypeRoomTitle === _a.Tent ? "テント" : "お部屋", [e.reservationPolicy.customTypeRoomTitle]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), C0e = g(({ sessionStateContext: e }) => {
  const n = v(() => e.reservationPolicy.customTypeRoomTitle === _a.Tent ? "Tent" : "Room", [e.reservationPolicy.customTypeRoomTitle]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), x0e = ({ sessionStateContext: e }) => {
  if (e.lang === D.Default)
    return /* @__PURE__ */ l.jsx(b0e, { sessionStateContext: e });
  if (e.lang === D.En)
    return /* @__PURE__ */ l.jsx(C0e, { sessionStateContext: e });
  throw new Error("Invalid lang code.");
}, D0e = g(({ roomIdx: e, sessionStateContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1", children: [
  /* @__PURE__ */ l.jsx(x0e, { sessionStateContext: n }),
  /* @__PURE__ */ l.jsx(y0e, { roomIdx: e, sessionStateContext: n })
] })), w0e = (e, n) => {
  var i;
  return (i = n.filter((t) => !P(t == null ? void 0 : t.baseRoomInfo)).find((t) => t.uniqueRoomID === e)) == null ? void 0 : i.baseRoomInfo;
}, P0e = (e) => {
  const n = e.sessionStateContext.currentState.roomInfo.willReserve.filter(
    (t) => !P(t)
  ), i = w0e(e.uniqueRoomID, n);
  return P(i) ? {
    kind: "NotSelected",
    lang: e.sessionStateContext.lang,
    isCompleteDate: e.sessionStateContext.reserveStatus.isCompleteDate
  } : {
    kind: "Selected",
    roomName: i.baseRoomName
  };
}, R0e = (e) => ({
  state: v(() => P0e(e), [e])
}), T0e = (e) => {
  const n = v(() => {
    switch (e.state.lang) {
      case D.Default:
        return "未選択";
      case D.En:
        return "Not selected";
      default:
        return "";
    }
  }, [e.state.lang]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, j0e = (e) => {
  const n = v(() => {
    switch (e.state.lang) {
      case D.Default:
        return "（日付を先にお選びください）";
      case D.En:
        return "（Please select a date first）";
      default:
        return "";
    }
  }, [e.state.lang]);
  return e.state.isCompleteDate ? null : /* @__PURE__ */ l.jsx("p", { children: n });
}, A0e = (e) => /* @__PURE__ */ l.jsxs(
  "div",
  {
    className: ce(
      "ch-flex ch-flex-wrap ch-text-lg",
      e.state.isCompleteDate ? "ch-text-gray-400" : "ch-opacity-30"
    ),
    children: [
      /* @__PURE__ */ l.jsx(T0e, { ...e }),
      /* @__PURE__ */ l.jsx(j0e, { ...e })
    ]
  }
), O0e = g((e) => /* @__PURE__ */ l.jsx("div", { className: "ch-text-lg", children: /* @__PURE__ */ l.jsx("p", { children: e.state.roomName }) })), E0e = g((e) => {
  const { state: n } = R0e(e);
  switch (n.kind) {
    case "Selected":
      return /* @__PURE__ */ l.jsx(O0e, { state: n });
    case "NotSelected":
      return /* @__PURE__ */ l.jsx(A0e, { state: n });
    default:
      return null;
  }
}), B7 = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-w-full ch-gap-y-3 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(D0e, { ...e }),
  /* @__PURE__ */ l.jsx(E0e, { ...e })
] })), J0e = g(({ notes: e }) => /* @__PURE__ */ l.jsx(qi, { type: "multiple", children: e.map(({ title: n, description: i }, t) => {
  const a = `${n}_${i}_${t}`;
  return /* @__PURE__ */ l.jsxs(it, { value: n, children: [
    /* @__PURE__ */ l.jsx(
      tt,
      {
        hover: !1,
        className: "ch-px-0 ch-py-[22px] ch-text-base ch-font-semibold",
        children: n
      }
    ),
    /* @__PURE__ */ l.jsx(at, { className: "ch-whitespace-pre-wrap ch-px-0 ch-pb-4 ch-pt-0 ch-text-sm ch-font-normal tablet:ch-px-0 tablet:ch-pt-0", children: /* @__PURE__ */ l.jsx(
      "p",
      {
        className: ce(
          // aタグを含んでいた場合のスタイルを指定する
          "[&>a]:ch-text-link-400 [&>a]:ch-underline-offset-2 [&>a]:hover:ch-underline"
        ),
        dangerouslySetInnerHTML: { __html: Nh(i) }
      }
    ) })
  ] }, a);
}) })), _0e = g(({ lang: e }) => {
  const n = v(() => e === D.Default ? "施設に関する注意事項" : "Facility Precautions", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black", children: n });
}), Q0e = (e) => ke(e.hotelInfo.notes) ? {
  kind: "NotDisplayable"
} : {
  kind: "Displayable",
  lang: e.sessionStateContext.lang,
  notes: e.hotelInfo.notes
}, M0e = (e) => ({
  state: v(() => Q0e(e), [e])
}), q7 = g((e) => {
  const { state: n } = M0e(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-bg-white ch-px-5 ch-py-8", children: [
    /* @__PURE__ */ l.jsx(_0e, { lang: n.lang }),
    /* @__PURE__ */ l.jsx(J0e, { notes: n.notes })
  ] }) : null;
}), L0e = (e) => {
  var s;
  const n = e.sessionStateContext.lang, i = (s = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : s.stayStartDt, t = e.sessionStateContext.reservationPolicy.isDayTrip, a = e.sessionStateContext.reservationPolicy.defaultCancelPolicy;
  if (!P(i)) {
    if (!e.sessionStateContext.reservationPolicy.canCancelReservation)
      return {
        kind: "NotCancelableInfoDisplayable",
        lang: n
      };
    if (e.sessionStateContext.reservationPolicy.canUpdateOnlyOptionReservation)
      return ke(e.sessionStateContext.reservationPolicy.defaultCancelPolicy) ? {
        kind: "NoChargeCancelableInfoDisplayable",
        lang: n
      } : {
        kind: "OnlyOptionCancelableInfoDisplayable",
        lang: n,
        isDayTrip: t,
        cancelPolicy: a,
        stayStartDt: i
      };
    if (e.sessionStateContext.reservationPolicy.canUpdateReservation)
      return ke(e.sessionStateContext.reservationPolicy.defaultCancelPolicy) ? {
        kind: "NoChargeCancelableInfoDisplayable",
        lang: n
      } : {
        kind: "CancelableInfoDisplayable",
        lang: n,
        isDayTrip: t,
        cancelPolicy: a,
        stayStartDt: i
      };
  }
  return {
    kind: "NotDisplayable"
  };
}, $0e = (e) => ({
  state: v(() => L0e(e), [e])
}), U0e = (e) => {
  const n = e.lang, i = e.stayStartDate, a = e.cancelPolicy.reduce((d, c) => d.beforeDays < c.beforeDays ? c : d), s = La({
    date: i,
    amount: a.beforeDays + 1
  }), r = Id();
  return mC({
    targetDate: r,
    compareDate: s
  }) ? {
    kind: "NoCancellationFeeUntilInfoDisplayable",
    lang: n,
    noCancellationFeeUntilDate: s
  } : {
    kind: "ShouldChargeCancellationFeeInfoDisplayable",
    lang: n
  };
}, V0e = (e) => ({
  state: v(() => U0e(e), [e])
}), H0e = ({ noCancellationFeeUntilDate: e, lang: n }) => {
  const i = v(() => n === D.Default ? `${Ne(e, "YYYY年MM月DD日")} 23時59分 までキャンセル無料` : `Free cancellation until ${Ne(e, "D MMM YYYY", "en")} 23:59`, [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-policy-400", children: i });
}, z0e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "キャンセル・変更をした場合、キャンセルポリシーに応じてキャンセル料金が発生します" : "If you cancel or change your reservation, a cancellation fee will be charged according to the cancellation policy", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-policy-400", children: n });
}, B0e = ({ ...e }) => {
  const { state: n } = V0e(e);
  return n.kind === "NoCancellationFeeUntilInfoDisplayable" ? /* @__PURE__ */ l.jsx(
    H0e,
    {
      lang: n.lang,
      noCancellationFeeUntilDate: n.noCancellationFeeUntilDate
    }
  ) : /* @__PURE__ */ l.jsx(z0e, { lang: n.lang });
}, q0e = ({ lang: e, cancelPolicy: n, stayStartDate: i }) => {
  const t = v(() => {
    const a = La({ date: i, amount: n.beforeDays });
    return e === D.Default ? `${Ne(a, "YYYY年MM月DD日")} 00時00分 から` : `From ${Ne(a, "D MMM YYYY", "en")} 00:00`;
  }, [n.beforeDays, e, i]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: t });
}, G0e = ({ lang: e, cancelPolicy: n }) => {
  const i = v(() => e === D.Default ? `税込合計金額の${n.chargeRatio}%` : `Total amount including tax ${n.chargeRatio}%`, [n.chargeRatio, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: i });
}, W0e = ({ lang: e, cancelPolicy: n, stayStartDate: i }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-wrap ch-items-center ch-space-x-1 ch-tabular-nums", children: [
  /* @__PURE__ */ l.jsx(q0e, { lang: e, stayStartDate: i, cancelPolicy: n }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: "：" }),
  /* @__PURE__ */ l.jsx(G0e, { lang: e, cancelPolicy: n })
] }), K0e = ({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "※ プランやオプションなどのキャンセルポリシーは異なる場合があります";
      case D.En:
        return "※ Cancellation policies may vary depending on the plan or options.";
      default:
        return "";
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: n });
}, Y0e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "※ 日程変更などの予約内容の変更の場合もキャンセル料金が発生する場合があります" : "※ Cancellation charges may apply even if you change your reservation details such as the schedule.", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs", children: n });
}, G7 = ({ lang: e }) => /* @__PURE__ */ l.jsxs("ul", { className: "ch-list-inside ch-list-disc", children: [
  /* @__PURE__ */ l.jsx(K0e, { lang: e }),
  /* @__PURE__ */ l.jsx(Y0e, { lang: e })
] }), W7 = ({ lang: e, stayStartDate: n, cancelPolicy: i }) => {
  const t = v(() => {
    switch (e) {
      case D.Default:
        return "キャンセルポリシーの詳細";
      case D.En:
        return "Cancellation Policy Details";
      default:
        return "キャンセルポリシーの詳細";
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, children: /* @__PURE__ */ l.jsxs(it, { value: "item", borderBottom: !1, children: [
    /* @__PURE__ */ l.jsx(
      tt,
      {
        className: "ch-flex-none ch-gap-x-2 ch-px-0 ch-py-1.5 ch-text-sm ch-font-semibold",
        hover: !1,
        children: t
      }
    ),
    /* @__PURE__ */ l.jsx(at, { className: "ch-space-y-3 ch-px-0 ch-py-3 tablet:ch-px-0", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-flex-col-reverse ch-gap-y-1", children: i.map((a, s) => /* @__PURE__ */ l.jsx(
        W0e,
        {
          lang: e,
          cancelPolicy: a,
          stayStartDate: n
        },
        s
      )) }),
      /* @__PURE__ */ l.jsx(G7, { lang: e })
    ] }) })
  ] }) });
}, X0e = ({ lang: e, cancelPolicy: n, stayStartDate: i }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-tabular-nums", children: [
  /* @__PURE__ */ l.jsx(B0e, { lang: e, cancelPolicy: n, stayStartDate: i }),
  /* @__PURE__ */ l.jsx(W7, { lang: e, cancelPolicy: n, stayStartDate: i })
] }), Z0e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "キャンセル料金がかからない予約です" : "This reservation is free to cancel", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-policy-400", children: n });
}, e3e = ({ lang: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
  /* @__PURE__ */ l.jsx(Z0e, { lang: e }),
  /* @__PURE__ */ l.jsx(G7, { lang: e })
] }), n3e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "この予約はキャンセルができません" : "This reservation cannot be canceled", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-policy-400", children: n });
}, i3e = (e) => {
  const n = e.lang, i = e.stayStartDate, a = e.cancelPolicy.reduce((d, c) => d.beforeDays < c.beforeDays ? c : d), s = La({
    date: i,
    amount: a.beforeDays + 1
  }), r = Id();
  return mC({
    targetDate: r,
    compareDate: s
  }) ? {
    kind: "NoCancellationFeeUntilInfoDisplayable",
    lang: n,
    noCancellationFeeUntilDate: s
  } : {
    kind: "ShouldChargeCancellationFeeInfoDisplayable",
    lang: n
  };
}, t3e = (e) => ({
  state: v(() => i3e(e), [e])
}), a3e = ({ noCancellationFeeUntilDate: e, lang: n }) => {
  const i = v(() => n === D.Default ? `${Ne(e, "YYYY年MM月DD日")} 23:59 までキャンセル無料` : `Free cancellation until ${Ne(e, "D MMM YYYY", "en")}`, [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-policy-400", children: i });
}, l3e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "キャンセル・変更をした場合、キャンセルポリシーに応じてキャンセル料金が発生します" : "If you cancel or change your reservation, a cancellation fee will be charged according to the cancellation policy", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-policy-400", children: n });
}, s3e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "※ オプションのみ変更・キャンセルができます" : "※ Only option cancellable.", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-semibold ch-text-policy-400", children: n });
}, r3e = ({ ...e }) => {
  const { state: n } = t3e(e);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-0.5", children: [
    n.kind === "NoCancellationFeeUntilInfoDisplayable" ? /* @__PURE__ */ l.jsx(
      a3e,
      {
        lang: n.lang,
        noCancellationFeeUntilDate: n.noCancellationFeeUntilDate
      }
    ) : /* @__PURE__ */ l.jsx(l3e, { lang: n.lang }),
    /* @__PURE__ */ l.jsx(s3e, { lang: n.lang })
  ] });
}, o3e = ({ lang: e, cancelPolicy: n, stayStartDate: i }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-tabular-nums", children: [
  /* @__PURE__ */ l.jsx(r3e, { lang: e, cancelPolicy: n, stayStartDate: i }),
  /* @__PURE__ */ l.jsx(W7, { lang: e, cancelPolicy: n, stayStartDate: i })
] }), K7 = g(({ ...e }) => {
  const { state: n } = $0e(e);
  if (n.kind === "CancelableInfoDisplayable")
    return /* @__PURE__ */ l.jsx(
      X0e,
      {
        lang: n.lang,
        cancelPolicy: n.cancelPolicy,
        stayStartDate: n.stayStartDt
      }
    );
  if (n.kind === "NoChargeCancelableInfoDisplayable")
    return /* @__PURE__ */ l.jsx(e3e, { lang: n.lang });
  if (n.kind === "NotCancelableInfoDisplayable")
    return /* @__PURE__ */ l.jsx(n3e, { lang: n.lang });
  if (n.kind === "OnlyOptionCancelableInfoDisplayable")
    return /* @__PURE__ */ l.jsx(
      o3e,
      {
        lang: n.lang,
        cancelPolicy: n.cancelPolicy,
        stayStartDate: n.stayStartDt
      }
    );
}), d3e = (e) => {
  var r, o, d;
  const n = e.sessionStateContext.lang;
  if (e.sessionStateContext.reservationPolicy.isDayTrip) {
    const c = (r = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : r.stayStartDt;
    return Ke(c) ? {
      kind: "NotDisplayable"
    } : {
      kind: "DayTripInfoDisplayable",
      lang: n,
      stayDate: c
    };
  }
  const t = (o = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : o.stayStartDt, a = (d = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : d.stayLastDt;
  if (Ke(t) || Ke(a))
    return {
      kind: "NotDisplayable"
    };
  {
    const c = Ci({ date: a, inc: 1 });
    return {
      kind: "OverNightTripInfoDisplayable",
      lang: n,
      checkInDate: t,
      checkInStartTime: e.sessionStateContext.reservationPolicy.checkInOutPolicy.checkInStart,
      checkInEndTime: e.sessionStateContext.reservationPolicy.checkInOutPolicy.checkInEnd,
      checkOutDate: c,
      checkOutEndTime: e.sessionStateContext.reservationPolicy.checkInOutPolicy.checkOut
    };
  }
}, c3e = (e) => ({
  state: v(() => d3e(e), [e])
}), u3e = ({ lang: e, checkInDate: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: i });
}, m3e = ({ checkInStartTime: e, checkInEndTime: n }) => {
  const i = v(() => `${e} ~ ${n}`, [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: i });
}, I2 = ({ text: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: e }), k3e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "チェックイン日" : "Check-in Date", [e]);
  return /* @__PURE__ */ l.jsx(I2, { text: n });
}, f3e = ({ lang: e, checkInDate: n, checkInStartTime: i, checkInEndTime: t }) => /* @__PURE__ */ l.jsxs("div", { children: [
  /* @__PURE__ */ l.jsx(k3e, { lang: e }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-4", children: [
    /* @__PURE__ */ l.jsx(u3e, { lang: e, checkInDate: n }),
    /* @__PURE__ */ l.jsx(m3e, { checkInStartTime: i, checkInEndTime: t })
  ] })
] }), v3e = ({ lang: e, checkOutDate: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: i });
}, h3e = ({ checkOutEndTime: e }) => {
  const n = v(() => `~ ${e}`, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: n });
}, p3e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "チェックアウト日" : "Check-out Date", [e]);
  return /* @__PURE__ */ l.jsx(I2, { text: n });
}, N3e = ({ lang: e, checkOutDate: n, checkOutEndTime: i }) => /* @__PURE__ */ l.jsxs("div", { children: [
  /* @__PURE__ */ l.jsx(p3e, { lang: e }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-4", children: [
    /* @__PURE__ */ l.jsx(v3e, { lang: e, checkOutDate: n }),
    /* @__PURE__ */ l.jsx(h3e, { checkOutEndTime: i })
  ] })
] }), S3e = ({
  lang: e,
  checkInDate: n,
  checkInStartTime: i,
  checkInEndTime: t,
  checkOutDate: a,
  checkOutEndTime: s
}) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(
    f3e,
    {
      lang: e,
      checkInDate: n,
      checkInStartTime: i,
      checkInEndTime: t
    }
  ),
  /* @__PURE__ */ l.jsx(N3e, { lang: e, checkOutDate: a, checkOutEndTime: s })
] }), g3e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "滞在日" : "Stay Date", [e]);
  return /* @__PURE__ */ l.jsx(I2, { text: n });
}, F3e = ({ lang: e, stayDate: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: i });
}, I3e = ({ lang: e, stayDate: n }) => /* @__PURE__ */ l.jsxs("div", { children: [
  /* @__PURE__ */ l.jsx(g3e, { lang: e }),
  /* @__PURE__ */ l.jsx(F3e, { lang: e, stayDate: n })
] }), y3e = ({ ...e }) => {
  const { state: n } = c3e(e);
  return n.kind === "OverNightTripInfoDisplayable" ? /* @__PURE__ */ l.jsx(
    S3e,
    {
      lang: n.lang,
      checkInDate: n.checkInDate,
      checkInStartTime: n.checkInStartTime,
      checkInEndTime: n.checkInEndTime,
      checkOutDate: n.checkOutDate,
      checkOutEndTime: n.checkOutEndTime
    }
  ) : n.kind === "DayTripInfoDisplayable" ? /* @__PURE__ */ l.jsx(I3e, { lang: n.lang, stayDate: n.stayDate }) : null;
}, b3e = ({ sessionStateContext: e }) => {
  const n = v(() => {
    const i = e.currentState.groupInfo.length;
    return e.lang === D.Default ? `${i} 部屋` : `${i} rooms`;
  }, [e.currentState.groupInfo.length, e.lang]);
  return vs(e) ? null : /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: n });
}, C3e = ({ sessionStateContext: e }) => {
  const n = v(() => {
    const i = e.currentState.groupInfo.reduce(
      (t, a) => t + a.adultNum,
      0
    );
    return e.lang === D.Default ? `大人 ${i} 名` : `${i} adults`;
  }, [e.currentState.groupInfo, e.lang]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-0.5 ch-text-base", children: [
    !vs(e) && /* @__PURE__ */ l.jsx("p", { children: "/" }),
    /* @__PURE__ */ l.jsx("p", { children: n })
  ] });
}, x3e = (e) => {
  const n = e.sessionStateContext.currentState.groupInfo.reduce(
    (t, a) => t + a.kidsNum.length,
    0
  );
  return n >= 1 ? {
    kind: "Displayable",
    lang: e.sessionStateContext.lang,
    totalChildNum: n
  } : {
    kind: "NotDisplayable"
  };
}, D3e = (e) => ({
  state: v(() => x3e(e), [e])
}), w3e = ({ lang: e, totalChildNum: n }) => {
  const i = v(() => e === D.Default ? `子ども ${n} 名` : `${n} children`, [e, n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-0.5 ch-text-base", children: [
    /* @__PURE__ */ l.jsx("p", { children: "/" }),
    /* @__PURE__ */ l.jsx("p", { children: i })
  ] });
}, P3e = (e) => {
  const { state: n } = D3e(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx(w3e, { lang: n.lang, totalChildNum: n.totalChildNum }) : null;
}, R3e = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "予約人数" : "Number of Guests", [e]);
  return /* @__PURE__ */ l.jsx(I2, { text: n });
}, T3e = ({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { children: [
  /* @__PURE__ */ l.jsx(R3e, { lang: e.lang }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-space-x-0.5", children: [
    /* @__PURE__ */ l.jsx(b3e, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(C3e, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(P3e, { sessionStateContext: e })
  ] })
] }), tp = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(y3e, { ...e }),
  /* @__PURE__ */ l.jsx(T3e, { ...e })
] });
tp.displayName = "Presenter";
const j3e = ({ sessionStateContext: e }) => {
  const n = v(() => `¥ ${e.priceInfo.totalGuestCharge.toLocaleString()}`, [e.priceInfo.totalGuestCharge]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-2xl ch-font-semibold", children: n });
}, A3e = (e) => e.sessionStateContext.priceInfo.totalPriceBeforeDiscount !== e.sessionStateContext.priceInfo.totalGuestCharge ? {
  kind: "Displayable",
  totalPriceBeforeDiscount: e.sessionStateContext.priceInfo.totalPriceBeforeDiscount
} : {
  kind: "NotDisplayable"
}, O3e = (e) => ({
  state: v(() => A3e(e), [e])
}), E3e = ({ totalPriceBeforeDiscount: e }) => {
  const n = v(() => `¥ ${e.toLocaleString()}`, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400 ch-line-through", children: n });
}, J3e = ({ ...e }) => {
  const { state: n } = O3e(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx(E3e, { totalPriceBeforeDiscount: n.totalPriceBeforeDiscount }) : null;
}, _3e = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "合計金額" : "Total Price", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold", children: n });
}, Y7 = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
  /* @__PURE__ */ l.jsx(_3e, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-items-end ch-space-y-1", children: [
    /* @__PURE__ */ l.jsx(j3e, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(J3e, { sessionStateContext: e })
  ] })
] })), Q3e = g(({ sessionStateContext: e, disabled: n }) => /* @__PURE__ */ l.jsx(
  zd,
  {
    trackingTarget: "group",
    disabled: n,
    triggerSlot: /* @__PURE__ */ l.jsx(H7, { sessionStateContext: e }),
    contentContext: {
      titleSlot: /* @__PURE__ */ l.jsx(qce, { sessionStateContext: e }),
      bodySlot: /* @__PURE__ */ l.jsx(Xh, { sessionStateContext: e }),
      footerSlot: ({ onCloseDrawer: i }) => /* @__PURE__ */ l.jsx(
        aue,
        {
          sessionStateContext: e,
          callbackContext: { onSubmitCallback: i }
        }
      )
    }
  }
)), M3e = ({ callbackContext: e, sessionStateContext: n }) => {
  const i = v(() => n.lang === D.Default ? "決定する" : "Confirm", [n.lang]), t = v(() => P(n.currentState.planInfo.willReserve), [n.currentState.planInfo.willReserve]), a = I(() => {
    e.onSubmitCallback();
  }, [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-py-4", children: /* @__PURE__ */ l.jsx(ae, { disabled: t, className: "ch-w-full", size: "md", onClick: a, children: i }) });
}, L3e = ({ sessionStateContext: e }) => {
  const n = v(() => !!(e.reservationPolicy.isDayTrip || e.clientContext.planQueryFilter === It.OnlyDayTripPlans), [e.clientContext.planQueryFilter, e.reservationPolicy.isDayTrip]), i = v(() => kn(n ? {
    lang: e.lang,
    i18nString: {
      default: "日帰りプラン",
      en: "Day Trip Plan"
    }
  } : {
    lang: e.lang,
    i18nString: {
      default: "プラン",
      en: "Plan"
    }
  }), [e.lang, n]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-text-black", children: i });
}, $3e = g(({ sessionStateContext: e, disabled: n }) => /* @__PURE__ */ l.jsx(
  zd,
  {
    trackingTarget: "plan",
    disabled: n,
    triggerSlot: /* @__PURE__ */ l.jsx(z7, { sessionStateContext: e }),
    contentContext: {
      titleSlot: /* @__PURE__ */ l.jsx(L3e, { sessionStateContext: e }),
      bodySlot: /* @__PURE__ */ l.jsx(S2, { sessionStateContext: e }),
      footerSlot: ({ onCloseDrawer: i }) => /* @__PURE__ */ l.jsx(
        M3e,
        {
          sessionStateContext: e,
          callbackContext: { onSubmitCallback: i }
        }
      )
    }
  }
)), U3e = ({ callbackContext: e, sessionStateContext: n }) => {
  const i = v(() => n.lang === D.Default ? "決定する" : "Confirm", [n.lang]), t = I(() => {
    e.onSubmitCallback();
  }, [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-py-4", children: /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", onClick: t, children: i }) });
}, V3e = (e) => e.sessionStateContext.currentState.groupInfo.length >= 2 ? {
  kind: "Displayable",
  roomIdx: e.roomIdx,
  lang: e.sessionStateContext.lang
} : {
  kind: "NotDisplayable"
}, H3e = (e) => ({
  state: v(() => V3e(e), [e])
}), z3e = (e) => {
  const { state: n } = H3e(e), i = v(() => {
    if (n.kind === "Displayable")
      switch (n.lang) {
        case D.Default:
          return `（部屋${n.roomIdx}）`;
        case D.En:
          return `(Room ${n.roomIdx})`;
        default: {
          const t = n.lang;
          throw new Error(`Unexpected lang code: ${t}`);
        }
      }
  }, [n]);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("p", { children: i }) : null;
}, B3e = g(({ sessionStateContext: e }) => {
  const n = v(() => e.reservationPolicy.customTypeRoomTitle === _a.Tent ? "テント" : "お部屋", [e.reservationPolicy.customTypeRoomTitle]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}), q3e = g(({ sessionStateContext: e }) => {
  const n = v(() => e.reservationPolicy.customTypeRoomTitle === _a.Tent ? "Tent" : "Room", [e.reservationPolicy.customTypeRoomTitle]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}), G3e = ({ sessionStateContext: e }) => {
  if (e.lang === D.Default)
    return /* @__PURE__ */ l.jsx(B3e, { sessionStateContext: e });
  if (e.lang === D.En)
    return /* @__PURE__ */ l.jsx(q3e, { sessionStateContext: e });
  throw new Error("Invalid lang code.");
}, W3e = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1 ch-text-black", children: [
  /* @__PURE__ */ l.jsx(G3e, { ...e }),
  /* @__PURE__ */ l.jsx(z3e, { ...e })
] }), K3e = ({ roomIdx: e, uniqueRoomID: n, sessionStateContext: i, disabled: t }) => /* @__PURE__ */ l.jsx(
  zd,
  {
    trackingTarget: "room",
    disabled: t || !i.reserveStatus.isCompleteDate,
    triggerSlot: /* @__PURE__ */ l.jsx(
      B7,
      {
        roomIdx: e,
        uniqueRoomID: n,
        sessionStateContext: i
      }
    ),
    contentContext: {
      titleSlot: /* @__PURE__ */ l.jsx(W3e, { roomIdx: e, sessionStateContext: i }),
      bodySlot: /* @__PURE__ */ l.jsx(
        np,
        {
          uniqueRoomID: n,
          sessionStateContext: i
        }
      ),
      footerSlot: (a) => /* @__PURE__ */ l.jsx(
        U3e,
        {
          callbackContext: { onSubmitCallback: a.onCloseDrawer },
          sessionStateContext: i
        }
      )
    }
  }
), Y3e = (e) => e.sessionStateContext.reservationPolicy.isShowPlanFilter ? {
  kind: "Displayable",
  sessionStateContext: e.sessionStateContext,
  onUpdatePlanQueryFilterType: e.onUpdatePlanQueryFilterType
} : {
  kind: "NotDisplayable"
}, X3e = (e) => ({
  state: v(() => Y3e(e), [e])
}), Z3e = (e) => e.sessionStateContext.clientContext.planQueryFilter === e.planQueryFilterSelf ? {
  kind: "Selected",
  sessionStateContext: {
    lang: e.sessionStateContext.lang
  }
} : {
  kind: "NotSelected",
  onUpdatePlanQueryFilterType: e.callbackContext.onUpdatePlanQueryFilterType(e.planQueryFilterSelf),
  sessionStateContext: {
    lang: e.sessionStateContext.lang
  }
}, eke = (e) => ({
  state: v(() => Z3e(e), [e])
}), ap = ({ modelContext: e, buttonI18nText: n }) => {
  const { state: i } = eke(e), { onShowLoadingScreenCallback: t, onHideLoadingScreenCallback: a } = fn(), s = I(async () => {
    i.kind === "NotSelected" && (t(), await i.onUpdatePlanQueryFilterType().finally(() => {
      a();
    }));
  }, [a, t, i]);
  return /* @__PURE__ */ l.jsx(
    ae,
    {
      variant: "minimal",
      className: ce(
        "ch-h-12 ch-whitespace-pre-line ch-rounded-none ch-border-b-2 !ch-px-0 !ch-py-0 ch-text-sm ch-font-semibold tablet:ch-h-14",
        i.kind === "Selected" ? "ch-border-b-primary ch-text-black" : "ch-border-b-transparent ch-text-gray-400"
      ),
      onClick: s,
      children: /* @__PURE__ */ l.jsx("p", { children: n })
    }
  );
}, nke = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = v(() => e.lang === D.Default ? "全てのプラン" : "All Plans", [e.lang]);
  return /* @__PURE__ */ l.jsx(
    ap,
    {
      modelContext: {
        planQueryFilterSelf: It.AllPlans,
        callbackContext: n,
        sessionStateContext: e
      },
      buttonI18nText: i
    }
  );
}, ike = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = v(() => e.lang === D.Default ? "日帰りプラン" : "Day Use Plans", [e.lang]);
  return /* @__PURE__ */ l.jsx(
    ap,
    {
      modelContext: {
        planQueryFilterSelf: It.OnlyDayTripPlans,
        callbackContext: n,
        sessionStateContext: e
      },
      buttonI18nText: i
    }
  );
}, tke = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = v(() => e.lang === D.Default ? "宿泊プラン" : "Accommodation Plans", [e.lang]);
  return /* @__PURE__ */ l.jsx(
    ap,
    {
      modelContext: {
        planQueryFilterSelf: It.OnlyAccommodationPlans,
        callbackContext: n,
        sessionStateContext: e
      },
      buttonI18nText: i
    }
  );
}, ake = ({ state: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-cols-3 ch-gap-x-2 ch-border-b ch-px-5", children: [
  /* @__PURE__ */ l.jsx(
    nke,
    {
      sessionStateContext: e.sessionStateContext,
      callbackContext: { onUpdatePlanQueryFilterType: e.onUpdatePlanQueryFilterType }
    }
  ),
  /* @__PURE__ */ l.jsx(
    tke,
    {
      sessionStateContext: e.sessionStateContext,
      callbackContext: { onUpdatePlanQueryFilterType: e.onUpdatePlanQueryFilterType }
    }
  ),
  /* @__PURE__ */ l.jsx(
    ike,
    {
      sessionStateContext: e.sessionStateContext,
      callbackContext: { onUpdatePlanQueryFilterType: e.onUpdatePlanQueryFilterType }
    }
  )
] }), lke = g((e) => {
  const { state: n } = X3e(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx(ake, { state: n }) : null;
}), ske = Ve(
  /* GraphQL */
  `
	mutation RCPlanSetQueryFilter($baseInfo: BaseInfoInput!, $filterType: PlanQueryFilterType!) {
		planSetQueryFilter(baseInfo: $baseInfo, filterType: $filterType) {
			...ReservationSessionStateFragment
		}
	}
`
), rke = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(ske);
  return {
    onUpdatePlanQueryFilterType: I(
      (t) => async () => {
        const { data: a } = await n({
          variables: {
            baseInfo: e.baseInfoInput,
            filterType: t
          }
        });
        e.onUpdateSession(a.planSetQueryFilter), le(
          yn({
            target: "plan_filter",
            action: "update",
            plan_filter: t.toLowerCase()
          })
        );
      },
      [n, e]
    )
  };
}, oke = g((e) => {
  const { onUpdatePlanQueryFilterType: n } = rke({
    sessionStateContext: e.sessionStateContext
  });
  return /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-max-w-screen-tablet", children: /* @__PURE__ */ l.jsx(
    lke,
    {
      ...e,
      onUpdatePlanQueryFilterType: n
    }
  ) });
}), X7 = (e, n) => n.map((t) => {
  var c, u;
  if (t == null || t.amount <= 0) return null;
  const a = e.find((k) => k.optionID === t.optionID);
  if (a == null) return null;
  let s, r, o, d = Number.MAX_SAFE_INTEGER;
  if (a.detail.__typename === "SubOptionBillingPerDate") {
    const k = a.detail.dailyItems.find((h) => h.date === t.date), m = ((c = k == null ? void 0 : k.subOptionItems) != null ? c : []).findIndex((h) => h.subOptionID === t.subOptionID), f = m >= 0 ? k == null ? void 0 : k.subOptionItems[m] : void 0;
    s = f == null ? void 0 : f.name, zx({
      isShowTimeSchedule: f == null ? void 0 : f.isShowTimeSchedule,
      startAt: f == null ? void 0 : f.startAt,
      endAt: f == null ? void 0 : f.endAt
    }) && (r = f == null ? void 0 : f.startAt, o = f == null ? void 0 : f.endAt), m >= 0 && (d = m);
  }
  return {
    // optionID + subOptionID + date で一意（同一サブオプションを別泊日で選べるため date も含める）。
    key: `${t.optionID}-${(u = t.subOptionID) != null ? u : ""}-${t.date}`,
    date: t.date,
    sortIndex: d,
    optionName: a.name,
    subOptionName: s,
    startAt: r,
    endAt: o,
    amount: t.amount
  };
}).filter((t) => t != null).sort((t, a) => t.date !== a.date ? t.date < a.date ? -1 : 1 : t.sortIndex - a.sortIndex), dke = ({ summaries: e }) => e.length === 0 ? null : /* @__PURE__ */ l.jsx("ul", { className: "ch-min-w-0 ch-space-y-1", children: e.map((n) => /* @__PURE__ */ l.jsxs("li", { className: "ch-flex ch-w-full ch-items-center ch-gap-2", children: [
  /* @__PURE__ */ l.jsxs("span", { className: "ch-min-w-0 ch-flex-1 ch-truncate ch-text-lg ch-text-black", children: [
    n.optionName,
    n.subOptionName ? /* @__PURE__ */ l.jsxs("span", { className: "ch-text-base ch-text-gray-500", children: [
      " / ",
      n.subOptionName
    ] }) : null
  ] }),
  n.startAt && n.endAt && /* @__PURE__ */ l.jsxs("span", { className: "ch-flex-shrink-0 ch-text-sm ch-tabular-nums ch-text-gray-500", children: [
    n.startAt,
    "〜",
    n.endAt
  ] }),
  /* @__PURE__ */ l.jsxs("span", { className: "ch-flex-shrink-0 ch-text-base ch-font-semibold ch-text-gray-600", children: [
    "× ",
    n.amount
  ] })
] }, n.key)) }), cke = ({ lang: e, dates: n, selectedIndex: i, onSelectDate: t }) => {
  const a = e === D.Default;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      role: "tablist",
      "aria-label": a ? "表示中の日付" : "Selected date",
      className: "ch-flex ch-gap-2 ch-overflow-x-auto ch-pb-1",
      children: n.map((s, r) => {
        const o = r === i, d = Ne(
          s,
          a ? "MM月DD日 (ddd)" : "MMM D (ddd)",
          a ? "ja" : "en"
        );
        return /* @__PURE__ */ l.jsxs(
          "button",
          {
            type: "button",
            role: "tab",
            "aria-selected": o,
            onClick: () => t(r),
            className: [
              "ch-flex ch-shrink-0 ch-items-center ch-gap-1.5 ch-whitespace-nowrap ch-rounded-full ch-border ch-px-3.5 ch-py-2 ch-text-sm ch-transition-colors",
              o ? "ch-border-primary ch-bg-primary ch-font-semibold ch-text-white" : "ch-text-gray-700 ch-border-gray-300 ch-bg-white hover:ch-border-primary"
            ].join(" "),
            children: [
              /* @__PURE__ */ l.jsx("span", { children: d }),
              n.length > 1 && /* @__PURE__ */ l.jsx(
                "span",
                {
                  className: [
                    "ch-text-[11px]",
                    o ? "ch-text-white/80" : "ch-text-gray-400"
                  ].join(" "),
                  children: a ? `${r + 1}/${n.length}日目` : `Day ${r + 1}/${n.length}`
                }
              )
            ]
          },
          s
        );
      })
    }
  );
}, uke = ({ lang: e, option: n, onClose: i }) => {
  var o, d;
  const t = (c) => {
    c || i();
  }, a = e === D.Default, s = (o = n.keyVisuals) != null ? o : [], r = ((d = n.cancelPolicy) != null ? d : []).filter((c) => c != null);
  return /* @__PURE__ */ l.jsx(br, { open: !0, onOpenChange: t, children: /* @__PURE__ */ l.jsxs(o5, { children: [
    /* @__PURE__ */ l.jsx(Qv, { style: { backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 300 } }),
    /* @__PURE__ */ l.jsxs(
      Jm,
      {
        "aria-describedby": void 0,
        className: "ch-fixed ch-left-[50%] ch-top-[50%] ch-w-[calc(100%-3rem)] ch-max-w-sm laptop:ch-max-w-2xl ch-translate-x-[-50%] ch-translate-y-[-50%] ch-overflow-hidden ch-rounded-lg ch-border ch-border-zinc-200 ch-bg-white ch-shadow-lg ch-duration-200 data-[state=open]:ch-animate-in data-[state=closed]:ch-animate-out data-[state=closed]:ch-fade-out-0 data-[state=open]:ch-fade-in-0 data-[state=closed]:ch-zoom-out-95 data-[state=open]:ch-zoom-in-95 data-[state=closed]:ch-slide-out-to-left-1/2 data-[state=closed]:ch-slide-out-to-top-[48%] data-[state=open]:ch-slide-in-from-left-1/2 data-[state=open]:ch-slide-in-from-top-[48%]",
        style: {
          display: "flex",
          flexDirection: "column",
          maxHeight: "85vh",
          overflow: "hidden",
          zIndex: 310
        },
        children: [
          /* @__PURE__ */ l.jsxs("div", { className: "ch-min-h-0 ch-flex-1 ch-overflow-y-auto", children: [
            s.length > 0 ? /* @__PURE__ */ l.jsx(
              Ut,
              {
                modelContext: { imageUrls: s },
                styleContext: { borderRadius: "0px" }
              }
            ) : /* @__PURE__ */ l.jsx("div", { className: "ch-aspect-image ch-w-full ch-bg-gray-100" }),
            /* @__PURE__ */ l.jsxs("div", { className: "ch-whitespace-pre-wrap ch-px-5 ch-pb-8 ch-pt-6 ch-text-left", children: [
              /* @__PURE__ */ l.jsx(d5, { className: "ch-mb-6 ch-text-left", children: /* @__PURE__ */ l.jsx(t1, { className: "ch-text-xl ch-font-semibold ch-text-black", children: n.name }) }),
              /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
                n.description && /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-black ch-opacity-90", children: n.description }),
                r.length > 0 && /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-rounded-md ch-bg-gray-100 ch-p-4", children: [
                  /* @__PURE__ */ l.jsx("h4", { className: "ch-text-base", children: a ? "キャンセルポリシー" : "Cancel Policy" }),
                  /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-1", children: r.map((c, u) => /* @__PURE__ */ l.jsx(
                    "p",
                    {
                      className: c.beforeDays === 0 ? "ch-text-xs ch-font-medium" : "ch-text-xs",
                      children: c.beforeDays === 0 ? a ? `ご利用日 当日 00時00分から: 税込オプション料金の${c.chargeRatio}%` : `On the day of use: ${c.chargeRatio}% of tax-included option fee` : a ? `ご利用日の${c.beforeDays}日前 00時00分以降: 税込オプション料金の${c.chargeRatio}%` : `Before ${c.beforeDays} days of use date 00:00:00: ${c.chargeRatio}% of tax-included option fee`
                    },
                    `${c.beforeDays}-${c.chargeRatio}-${u}`
                  )) })
                ] })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ l.jsx("div", { className: "ch-shrink-0 ch-border-t ch-border-gray-200 ch-px-6 ch-py-4", children: /* @__PURE__ */ l.jsx(ae, { variant: "outline", size: "md", className: "ch-w-full", onClick: i, children: a ? "閉じる" : "Close" }) })
        ]
      }
    )
  ] }) });
}, mke = ({ keyVisuals: e }) => {
  const n = e != null ? e : [];
  return /* @__PURE__ */ l.jsx("div", { className: "ch-px-3 ch-pb-2 ch-pt-4", children: n.length > 0 ? /* @__PURE__ */ l.jsx(
    Ut,
    {
      modelContext: { imageUrls: n },
      styleContext: { borderRadius: "8px" }
    }
  ) : /* @__PURE__ */ l.jsx("div", { className: "ch-aspect-image ch-w-full ch-rounded-md ch-bg-gray-200" }) });
}, kke = ({
  option: e,
  lang: n,
  onClick: i
}) => /* @__PURE__ */ l.jsxs(
  "button",
  {
    type: "button",
    onClick: i,
    className: "hover:ch-bg-gray-50 ch-flex ch-w-full ch-flex-col ch-items-start ch-gap-1.5 ch-px-3 ch-pt-2 ch-text-left",
    children: [
      /* @__PURE__ */ l.jsx("span", { className: "ch-line-clamp-2 ch-min-h-[2.5em] ch-text-[15px] ch-font-semibold ch-leading-tight ch-text-black", children: e.name }),
      /* @__PURE__ */ l.jsx("span", { className: "ch-text-[13px] ch-text-gray-400 ch-underline ch-underline-offset-2", children: n === D.Default ? "詳細" : "Details" })
    ]
  }
), fke = ({
  lang: e,
  subOptionName: n,
  isShowTimeSchedule: i,
  startAt: t,
  endAt: a,
  price: s,
  currentAmount: r,
  maxAmount: o,
  minAmount: d,
  soldOut: c,
  onChangeAmount: u,
  disabled: k = !1
}) => {
  const m = e === D.Default, f = r > 0, p = c && r === 0, h = r < o, N = zx({ isShowTimeSchedule: i, startAt: t, endAt: a }), S = r <= d;
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: ce(
        "ch-relative ch-flex ch-min-h-[76px] ch-w-full ch-flex-col ch-justify-between ch-gap-2 ch-rounded-lg ch-border ch-p-3 ch-transition-colors",
        p ? "ch-border-gray-200 ch-bg-gray-100" : f ? "ch-border-primary ch-bg-primary/5" : "ch-border-gray-300 ch-bg-white"
      ),
      children: [
        /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-gap-0.5", children: [
          n && /* @__PURE__ */ l.jsx(
            "span",
            {
              className: ce(
                "ch-text-[15px] ch-font-semibold ch-leading-tight",
                p ? "ch-text-gray-400" : "ch-text-gray-800"
              ),
              children: n
            }
          ),
          N && /* @__PURE__ */ l.jsxs(
            "span",
            {
              className: ce(
                "ch-text-[15px] ch-font-semibold ch-tabular-nums ch-leading-none",
                p ? "ch-text-gray-400" : "ch-text-gray-800"
              ),
              children: [
                t,
                /* @__PURE__ */ l.jsx("span", { className: "ch-mx-0.5 ch-opacity-70", children: "〜" }),
                a
              ]
            }
          ),
          /* @__PURE__ */ l.jsxs("span", { className: "ch-text-[13px] ch-tabular-nums ch-text-gray-500", children: [
            "¥",
            s.toLocaleString()
          ] })
        ] }),
        /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-h-9 ch-items-center ch-justify-end", children: p ? /* @__PURE__ */ l.jsx("span", { className: "ch-text-[12px] ch-text-gray-400", children: m ? "満枠" : "Sold out" }) : f ? /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-0.5 ch-rounded-full ch-border ch-border-gray-300 ch-bg-white ch-p-1 ch-shadow-sm", children: [
          /* @__PURE__ */ l.jsx(
            "button",
            {
              type: "button",
              "aria-label": S ? m ? "削除" : "Remove" : m ? "1 減らす" : "Decrease",
              disabled: k,
              onClick: () => u(S ? 0 : r - 1),
              className: "ch-flex ch-h-7 ch-w-7 ch-items-center ch-justify-center ch-rounded-full ch-text-gray-700 hover:ch-bg-gray-100 disabled:ch-opacity-40",
              children: S ? /* @__PURE__ */ l.jsx(UP, { size: "sm", className: "ch-h-4 ch-w-4" }) : /* @__PURE__ */ l.jsx(eR, { size: "sm", className: "ch-h-5 ch-w-5" })
            }
          ),
          /* @__PURE__ */ l.jsx("span", { className: "ch-min-w-[18px] ch-text-center ch-text-[15px] ch-font-bold ch-tabular-nums ch-text-gray-900", children: r }),
          /* @__PURE__ */ l.jsx(
            "button",
            {
              type: "button",
              "aria-label": m ? "1 増やす" : "Increase",
              disabled: k || !h,
              onClick: () => u(r + 1),
              className: "ch-flex ch-h-7 ch-w-7 ch-items-center ch-justify-center ch-rounded-full ch-text-gray-700 hover:ch-bg-gray-100 disabled:ch-opacity-40",
              children: /* @__PURE__ */ l.jsx(jp, { size: "sm", className: "ch-h-5 ch-w-5" })
            }
          )
        ] }) : /* @__PURE__ */ l.jsx(
          "button",
          {
            type: "button",
            "aria-label": m ? "追加" : "Add",
            disabled: k || !h,
            onClick: () => u(d),
            className: "ch-flex ch-h-9 ch-w-9 ch-items-center ch-justify-center ch-rounded-full ch-border ch-border-gray-300 ch-bg-white ch-text-gray-700 hover:ch-border-primary hover:ch-text-primary disabled:ch-opacity-40",
            children: /* @__PURE__ */ l.jsx(jp, { size: "sm", className: "ch-h-5 ch-w-5" })
          }
        ) })
      ]
    }
  );
}, vke = 50, hke = 600, I9 = 60, y3 = 650, Dc = 200, pke = ({ onNextDate: e, onPrevDate: n }) => {
  const i = Ye(null), [t, a] = se(null), s = Ye(!1), r = Ye(null), o = Ye(0), d = Ye(0), c = Ye(0), u = Ye({ startX: 0, startY: 0, startAt: 0, atLeft: !1, atRight: !1, tracking: !1 }), k = I(
    (h) => {
      if (s.current) return;
      const N = h === "next" ? e : n;
      N && (s.current = !0, a(h), r.current = window.setTimeout(() => {
        N();
      }, y3));
    },
    [e, n]
  ), m = I(
    (h) => {
      const N = i.current;
      if (!N || !e && !n) return;
      const S = Math.abs(h.deltaX) >= Math.abs(h.deltaY) ? h.deltaX : 0;
      if (S === 0) return;
      const F = Date.now();
      if (F < o.current) {
        o.current = F + Dc, d.current = 0, c.current = F;
        return;
      }
      F - c.current > Dc && (d.current = 0), c.current = F;
      const y = N.scrollLeft + N.clientWidth >= N.scrollWidth - 1, x = N.scrollLeft <= 0;
      S > 0 && y && e ? (d.current += S, d.current >= I9 && (d.current = 0, o.current = F + y3 + Dc, k("next"))) : S < 0 && x && n ? (d.current -= S, d.current >= I9 && (d.current = 0, o.current = F + y3 + Dc, k("prev"))) : d.current = 0;
    },
    [e, n, k]
  ), f = I((h) => {
    const N = i.current;
    if (!N) return;
    const S = h.touches[0];
    if (!S) return;
    const F = N.scrollLeft <= 0, y = N.scrollLeft + N.clientWidth >= N.scrollWidth - 1;
    u.current = {
      startX: S.clientX,
      startY: S.clientY,
      startAt: Date.now(),
      atLeft: F,
      atRight: y,
      // 端から始まったスワイプだけをページング候補として追跡する
      tracking: F || y
    };
  }, []), p = I(
    (h) => {
      const N = i.current;
      if (!N) return;
      const S = u.current;
      if (!S.tracking) return;
      S.tracking = !1;
      const F = h.changedTouches[0];
      if (!F) return;
      const y = F.clientX - S.startX, x = F.clientY - S.startY;
      if (Date.now() - S.startAt > hke || Math.abs(y) <= Math.abs(x) || Math.abs(y) < vke) return;
      const R = N.scrollLeft <= 0, T = N.scrollLeft + N.clientWidth >= N.scrollWidth - 1;
      S.atRight && T && y < 0 && e ? k("next") : S.atLeft && R && y > 0 && n && k("prev");
    },
    [e, n, k]
  );
  return {
    /** スクロール領域の div に付ける ref */
    scrollRef: i,
    /** 前日への矢印を出すか */
    showPrevArrow: t === "prev",
    /** 翌日への矢印を出すか */
    showNextArrow: t === "next",
    onWheel: m,
    onTouchStart: f,
    onTouchEnd: p
  };
}, Nke = 160, Ske = (e) => e == null ? !0 : e.filter((n) => n > 0).length === 0, gke = ({
  targetOptions: e,
  lang: n,
  displayDate: i,
  optionPerDateInfo: t,
  onSelectOptionInfo: a,
  onChangeSlotAmount: s,
  isUpdating: r,
  onNextDate: o,
  onPrevDate: d,
  prevDateLabel: c,
  nextDateLabel: u
}) => {
  const k = Ci({ date: i, inc: -1 }), { scrollRef: m, showPrevArrow: f, showNextArrow: p, onWheel: h, onTouchStart: N, onTouchEnd: S } = pke({
    onNextDate: o,
    onPrevDate: d
  }), y = e.map((T) => {
    var M, L;
    const j = T.detail, A = j.__typename === "SubOptionBillingPerDate" ? j.dailyItems : [], B = A.find((_) => _.date === i), W = A.find((_) => _.date === k), E = [
      ...((M = B == null ? void 0 : B.subOptionItems) != null ? M : []).filter((_) => !_.isNextMorning).map((_) => {
        var z;
        return {
          subOptionID: _.subOptionID,
          subOptionName: _.name,
          isShowTimeSchedule: _.isShowTimeSchedule,
          bookingDate: i,
          isNextMorning: !1,
          startAt: _.startAt,
          endAt: _.endAt,
          price: _.price,
          availableChoices: (z = _.availableChoices) != null ? z : []
        };
      }),
      ...((L = W == null ? void 0 : W.subOptionItems) != null ? L : []).filter((_) => _.isNextMorning).map((_) => {
        var z;
        return {
          subOptionID: _.subOptionID,
          subOptionName: _.name,
          isShowTimeSchedule: _.isShowTimeSchedule,
          bookingDate: k,
          isNextMorning: !0,
          startAt: _.startAt,
          endAt: _.endAt,
          price: _.price,
          availableChoices: (z = _.availableChoices) != null ? z : []
        };
      })
    ], $ = j.__typename === "SubOptionBillingPerDate" ? j.minimumSoldAmount : 0, V = (_) => {
      var ne;
      const z = A.find((Se) => Se.date === _);
      return ((ne = z == null ? void 0 : z.subOptionItems) != null ? ne : []).reduce((Se, he) => {
        var oe, $e;
        const ue = ($e = (oe = t.willReserve.find(
          (we) => (we == null ? void 0 : we.optionID) === T.optionID && we.date === _ && we.subOptionID === he.subOptionID
        )) == null ? void 0 : oe.amount) != null ? $e : 0;
        return Se + ue;
      }, 0);
    }, H = [...new Set(E.map((_) => _.bookingDate))], O = T.isRequired && $ > 0 && H.some((_) => V(_) < $);
    return { opt: T, slots: E, minimumSoldAmount: $, showRequiredMessage: O };
  }).filter((T) => T.slots.length > 0), x = `repeat(${Math.max(y.length, 1)}, minmax(${Nke}px, 1fr))`, R = y.some(
    (T) => T.opt.isRequired && T.minimumSoldAmount > 0
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-relative ch-flex ch-min-h-0 ch-flex-1 ch-flex-col ch-bg-white", children: [
    /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: m,
        onWheel: h,
        onTouchStart: N,
        onTouchEnd: S,
        className: "ch-relative ch-min-h-0 ch-flex-1 ch-overflow-auto ch-rounded-md ch-border ch-border-gray-200",
        children: y.length === 0 ? /* @__PURE__ */ l.jsx("p", { className: "ch-py-10 ch-text-center ch-text-sm ch-text-gray-400", children: n === D.Default ? "選択可能なオプションがありません。別の日付を選択してください。" : "No available options for this date. Please choose another date." }) : /* @__PURE__ */ l.jsx("div", { className: "ch-grid", style: { gridTemplateColumns: x }, children: y.map(({ opt: T, slots: j, showRequiredMessage: A, minimumSoldAmount: B }, W) => {
          var E;
          return /* @__PURE__ */ l.jsxs(
            "div",
            {
              className: ce(
                "ch-flex ch-flex-col ch-border-gray-200",
                // 最終列は外枠の border と重なって二重に太くなるため border-r を出さない
                W < y.length - 1 && "ch-border-r"
              ),
              children: [
                /* @__PURE__ */ l.jsx(mke, { keyVisuals: (E = T.keyVisuals) != null ? E : void 0 }),
                /* @__PURE__ */ l.jsxs("div", { className: "ch-sticky ch-top-0 ch-z-20 ch-flex ch-flex-col ch-border-b ch-border-gray-200 ch-bg-white ch-pb-3", children: [
                  /* @__PURE__ */ l.jsx(kke, { option: T, lang: n, onClick: () => a(T) }),
                  R && /* @__PURE__ */ l.jsx(
                    "div",
                    {
                      className: ce(
                        "ch-px-3 ch-pt-2 ch-text-left",
                        !A && "ch-invisible"
                      ),
                      "aria-hidden": !A,
                      children: /* @__PURE__ */ l.jsx(qd, { lang: n, amount: B })
                    }
                  )
                ] }),
                /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-flex-col ch-gap-2 ch-p-3.5", children: j.map(($) => {
                  var z, ne, Se;
                  const V = Ske($.availableChoices), H = (ne = (z = t.willReserve.find(
                    (he) => (he == null ? void 0 : he.optionID) === T.optionID && he.date === $.bookingDate && he.subOptionID === $.subOptionID
                  )) == null ? void 0 : z.amount) != null ? ne : 0, O = $.availableChoices.filter((he) => he > 0), M = O.length > 0 ? Math.max(...O) : H, L = O.length > 0 ? Math.min(...O) : 1, _ = {
                    optionID: T.optionID,
                    optionName: T.name,
                    optionKeyVisualUrl: (Se = T.keyVisuals) == null ? void 0 : Se[0],
                    optionDescription: T.description,
                    cancelPolicy: T.cancelPolicy,
                    subOptionID: $.subOptionID,
                    subOptionName: $.subOptionName,
                    date: $.bookingDate,
                    isNextMorning: $.isNextMorning,
                    startAt: $.startAt,
                    endAt: $.endAt,
                    price: $.price,
                    availableChoices: $.availableChoices,
                    currentAmount: H
                  };
                  return /* @__PURE__ */ l.jsx(
                    fke,
                    {
                      lang: n,
                      subOptionName: $.subOptionName,
                      isShowTimeSchedule: $.isShowTimeSchedule,
                      startAt: $.startAt,
                      endAt: $.endAt,
                      price: $.price,
                      currentAmount: H,
                      maxAmount: M,
                      minAmount: L,
                      soldOut: V,
                      disabled: r,
                      onChangeAmount: (he) => s(_, he)
                    },
                    `${$.bookingDate}-${$.subOptionID}`
                  );
                }) })
              ]
            },
            T.optionID
          );
        }) })
      }
    ),
    f && /* @__PURE__ */ l.jsxs(
      "div",
      {
        "aria-hidden": !0,
        className: "ch-text-gray-700 ch-pointer-events-none ch-absolute ch-left-1 ch-top-1/2 ch-flex ch--translate-y-1/2 ch-items-center ch-gap-1 ch-rounded-full ch-bg-white/95 ch-py-1.5 ch-pl-1.5 ch-pr-3 ch-shadow-md ch-ring-1 ch-ring-gray-200",
        children: [
          /* @__PURE__ */ l.jsx(zl, { size: "sm", className: "ch-h-5 ch-w-5 ch-rotate-180" }),
          c && /* @__PURE__ */ l.jsx("span", { className: "ch-text-xs ch-font-semibold", children: c })
        ]
      }
    ),
    p && /* @__PURE__ */ l.jsxs(
      "div",
      {
        "aria-hidden": !0,
        className: "ch-text-gray-700 ch-pointer-events-none ch-absolute ch-right-1 ch-top-1/2 ch-flex ch--translate-y-1/2 ch-items-center ch-gap-1 ch-rounded-full ch-bg-white/95 ch-py-1.5 ch-pl-3 ch-pr-1.5 ch-shadow-md ch-ring-1 ch-ring-gray-200",
        children: [
          u && /* @__PURE__ */ l.jsx("span", { className: "ch-text-xs ch-font-semibold", children: u }),
          /* @__PURE__ */ l.jsx(zl, { size: "sm", className: "ch-h-5 ch-w-5" })
        ]
      }
    )
  ] });
}, Fke = (e, n) => {
  var t;
  if (e.detail.__typename !== "SubOptionBillingPerDate") return !1;
  const i = e.detail.dailyItems.find((a) => a.date === n);
  return ((t = i == null ? void 0 : i.subOptionItems) != null ? t : []).some((a) => a.isNextMorning);
}, Ike = (e, n) => e === 0 ? "add" : n === 0 ? "remove" : n > e ? "increase" : "decrease", yke = ({ targetOptions: e, sessionStateContext: n }) => {
  var R;
  const { onUpdateOptionAmount: i } = D7({ sessionStateContext: n, isInputEventPushedByCaller: !0 }), t = v(() => {
    var j;
    const T = n.currentState.dateInfo;
    return T != null && T.stayStartDt ? Hv({
      startDate: T.stayStartDt,
      endDate: (j = T.stayLastDt) != null ? j : T.stayStartDt
    }) : [];
  }, [n.currentState.dateInfo]), a = v(() => {
    if (t.length === 0) return [];
    const T = t[t.length - 1];
    return T == null || !e.some((A) => Fke(A, T)) ? t : [...t, Ci({ date: T, inc: 1 })];
  }, [t, e]), [s, r] = se(0), [o, d] = se(null), [c, u] = se(!1), { onShowLoadingScreenCallback: k, onHideLoadingScreenCallback: m } = fn(), f = (R = a[s]) != null ? R : a[0], p = n.lang === D.Default, h = p ? "MM月DD日 (ddd)" : "MMM D (ddd)", N = p ? "ja" : "en", S = v(() => {
    const T = a[s - 1];
    return T != null ? Ne(T, h, N) : void 0;
  }, [a, s, h, N]), F = v(() => {
    const T = a[s + 1];
    return T != null ? Ne(T, h, N) : void 0;
  }, [a, s, h, N]), y = I(
    async (T, j) => {
      var A;
      if (!c) {
        u(!0), k();
        try {
          await i({ optionID: T.optionID })({
            subOptionID: T.subOptionID,
            date: T.date
          })(j), le(
            yn({
              target: "time_slot",
              action: Ike(T.currentAmount, j),
              option_id: T.optionID,
              slot_time: (A = T.startAt) != null ? A : void 0,
              quantity: j
            })
          );
        } finally {
          m(), u(!1);
        }
      }
    },
    [c, i, k, m]
  ), x = I(
    (T) => {
      le(Pn({ target: T }));
    },
    []
  );
  return a.length === 0 || f == null ? /* @__PURE__ */ l.jsx("div", { className: "ch-py-6 ch-text-center ch-text-sm ch-text-gray-500", children: p ? "日付が選択されていません" : "No date selected" }) : /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-min-h-0 ch-min-w-0 ch-flex-1 ch-flex-col ch-gap-3", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-shrink-0 ch-bg-white ch-pb-1 ch-pt-1", children: /* @__PURE__ */ l.jsx(
      cke,
      {
        lang: n.lang,
        dates: a,
        selectedIndex: s,
        onSelectDate: (T) => {
          x("time_slot.date_tab"), r(T);
        }
      }
    ) }),
    /* @__PURE__ */ l.jsx(
      gke,
      {
        targetOptions: e,
        lang: n.lang,
        displayDate: f,
        optionPerDateInfo: n.currentState.optionPerDateInfo,
        onSelectOptionInfo: (T) => {
          x("time_slot.option_info"), d(T);
        },
        onChangeSlotAmount: y,
        isUpdating: c,
        onNextDate: s < a.length - 1 ? () => r((T) => Math.min(T + 1, a.length - 1)) : void 0,
        onPrevDate: s > 0 ? () => r((T) => Math.max(T - 1, 0)) : void 0,
        prevDateLabel: S,
        nextDateLabel: F
      },
      f
    ),
    o != null && /* @__PURE__ */ l.jsx(
      uke,
      {
        lang: n.lang,
        option: o,
        onClose: () => {
          x("time_slot.option_info_close"), d(null);
        }
      }
    )
  ] });
}, lp = ({ lang: e, optionNames: n }) => {
  const i = n != null ? n : [], t = i.length > 0 ? e === D.Default ? `${i.map((a) => `「${a}」`).join("")}のうち、いずれか1つ以上を選択してください。` : `Please select at least one of: ${i.join(", ")}.` : e === D.Default ? "必須オプションのうち、いずれか1つ以上を選択してください。" : "Please select at least one of the required options.";
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-text-urgent-400", children: t });
}, Z7 = Ve(
  /* GraphQL */
  `
	query RCScreen2Initialize($baseInfo: BaseInfoInput!) {
		optionAvailable(baseInfo: $baseInfo) {
			...SelectOptionAvailableOptionsFragment
		}
	}
`
), bke = ({
  lang: e,
  targetOptions: n,
  optionPerDateInfo: i,
  isRequiredOptionGroupComplete: t
}) => {
  const a = e === D.Default, s = X7(n, i.willReserve), r = n.some((d) => d.isOneOfRequired), o = n.some((d) => d.isRequired) || r && !t;
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-min-w-0 ch-flex-col ch-gap-2 ch-text-left", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: a ? "時間帯" : "Time slot" }),
    s.length > 0 ? /* @__PURE__ */ l.jsx(dke, { summaries: s }) : o ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-text-urgent-400", children: a ? "未選択（必須）" : "Not selected (required)" }) : /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-text-gray-400", children: a ? "未選択" : "Not selected" })
  ] });
}, Cke = ({ sessionStateContext: e }) => {
  const { reserveStatus: n, reservationPolicy: i } = e, t = v(() => {
    var y, x, R, T;
    const { planInfo: h, roomInfo: N, groupInfo: S, dateInfo: F } = e.currentState;
    return JSON.stringify({
      planID: (x = (y = h.willReserve) == null ? void 0 : y.planID) != null ? x : null,
      stayStartDt: (R = F == null ? void 0 : F.stayStartDt) != null ? R : null,
      stayLastDt: (T = F == null ? void 0 : F.stayLastDt) != null ? T : null,
      rooms: N.willReserve.map((j) => {
        var A, B, W, E;
        return {
          uniqueRoomID: (A = j == null ? void 0 : j.uniqueRoomID) != null ? A : null,
          baseRoomID: (W = (B = j == null ? void 0 : j.baseRoomInfo) == null ? void 0 : B.baseRoomID) != null ? W : null,
          dailyRoomIDs: ((E = j == null ? void 0 : j.dailyItems) != null ? E : []).map(($) => {
            var V, H;
            return (H = (V = $.roomInfo) == null ? void 0 : V.roomID) != null ? H : null;
          })
        };
      }),
      groups: S.map((j) => ({
        uniqueRoomID: j.uniqueRoomID,
        adultNum: j.adultNum,
        kidsAges: j.kidsNum.map((A) => A.age)
      }))
    });
  }, [e.currentState]), { data: a, error: s, refetch: r } = k2(Z7, {
    variables: { baseInfo: e.baseInfoInput },
    errorPolicy: "all",
    fetchPolicy: "network-only",
    queryKey: [t]
  }), o = v(() => {
    if (!(a != null && a.optionAvailable)) return null;
    const { availableOptions: h } = Wu(
      Zh,
      a.optionAvailable
    );
    return h;
  }, [a]), d = v(
    () => (o != null ? o : []).filter((h) => h.isDateTabbedTimeSelectionTarget === !0),
    [o]
  ), c = v(
    () => (o != null ? o : []).filter((h) => h.isOneOfRequired === !0 && h.isDateTabbedTimeSelectionTarget === !0).map((h) => h.name),
    [o]
  ), u = v(
    () => d.some((h) => h.detail.__typename !== "SubOptionBillingPerDate" ? !1 : h.detail.dailyItems.some(
      (N) => {
        var S;
        return ((S = N.subOptionItems) != null ? S : []).some(
          (F) => {
            var y;
            return ((y = F.availableChoices) != null ? y : []).some((x) => x > 0);
          }
        );
      }
    )),
    [d]
  ), k = i.optionSelectionMode === Z.TimeSlotAndRegular || i.optionSelectionMode === Z.TimeSlotOnly;
  if (s && k) {
    const h = e.lang === D.Default;
    return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-flex-col ch-items-start ch-gap-2 ch-px-5 ch-py-4 ch-text-left", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: h ? "時間帯" : "Time slot" }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: h ? "時間帯オプションの読み込みに失敗しました" : "Failed to load time slot options" }),
      /* @__PURE__ */ l.jsx(
        ae,
        {
          variant: "outline",
          size: "sm",
          className: "ch-w-fit",
          onClick: () => {
            le(
              Pn({
                target: "time_slot.refetch"
              })
            ), r();
          },
          children: h ? "再試行" : "Retry"
        }
      )
    ] });
  }
  if (d.length === 0 || !u) return null;
  const m = X7(d, e.currentState.optionPerDateInfo.willReserve).length === 0 && (d.some((h) => h.isRequired) || d.some((h) => h.isOneOfRequired) && !n.isCompleteRequiredOptionGroup), f = e.lang === D.Default ? "決定する" : "Confirm", p = d.length === 1;
  return /* @__PURE__ */ l.jsx(
    zd,
    {
      contentWidthClassName: p ? "ch-max-w-screen-tablet" : "ch-max-w-screen-tablet laptop:ch-max-w-screen-laptop",
      onOpenChange: (h) => {
        h && le(
          Pn({
            target: "time_slot.open",
            is_required_unselected: m
          })
        );
      },
      triggerSlot: /* @__PURE__ */ l.jsx(
        bke,
        {
          lang: e.lang,
          targetOptions: d,
          optionPerDateInfo: e.currentState.optionPerDateInfo,
          isRequiredOptionGroupComplete: n.isCompleteRequiredOptionGroup
        }
      ),
      contentContext: {
        titleSlot: /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-items-center ch-gap-x-1 ch-text-black", children: /* @__PURE__ */ l.jsx("span", { className: "ch-text-base ch-font-bold", children: e.lang === D.Default ? "時間帯" : "Time slot" }) }),
        bodySlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-h-full ch-min-h-0 ch-flex-col ch-px-1 ch-py-4", children: [
          c.length > 0 && /* @__PURE__ */ l.jsx(
            "div",
            {
              className: ce(
                "ch-mb-4 ch-shrink-0",
                // 充足後は非表示にするが高さは確保し、赤字の消滅でレイアウトシフトが起きないようにする
                n.isCompleteRequiredOptionGroup && "ch-invisible"
              ),
              children: /* @__PURE__ */ l.jsx(
                lp,
                {
                  lang: e.lang,
                  optionNames: c
                }
              )
            }
          ),
          /* @__PURE__ */ l.jsx(yke, { targetOptions: d, sessionStateContext: e })
        ] }),
        footerSlot: ({ onCloseDrawer: h }) => /* @__PURE__ */ l.jsx("div", { className: "ch-py-4", children: /* @__PURE__ */ l.jsx(
          ae,
          {
            className: "ch-w-full",
            size: "md",
            onClick: () => {
              le(
                Pn({
                  target: "time_slot.confirm",
                  is_complete: !m
                })
              ), h();
            },
            children: f
          }
        ) })
      }
    }
  );
}, sp = ({ sessionStateContext: e }) => {
  const { reserveStatus: n, reservationPolicy: i } = e;
  return v(() => !(!n.isCompletePlan || !n.isCompleteGroup || !n.isCompleteDate || i.isShowRoomSelect && !n.isCompleteRoom), [
    n.isCompletePlan,
    n.isCompleteGroup,
    n.isCompleteDate,
    n.isCompleteRoom,
    i.isShowRoomSelect
  ]) ? /* @__PURE__ */ l.jsx(E8, { fallback: null, children: /* @__PURE__ */ l.jsx(Cke, { sessionStateContext: e }) }) : null;
}, xke = g((e) => {
  const n = v(() => e.displayContext.sessionStateContext.reservationPolicy.isShowPlanSelect, [e.displayContext.sessionStateContext.reservationPolicy.isShowPlanSelect]), i = v(() => e.displayContext.sessionStateContext.reservationPolicy.isShowRoomSelect, [e.displayContext.sessionStateContext.reservationPolicy.isShowRoomSelect]), { reservationContext: t, reservationPolicy: a } = e.displayContext.sessionStateContext, s = v(() => {
    const r = a.optionSelectionMode === Z.TimeSlotAndRegular || a.optionSelectionMode === Z.TimeSlotOnly;
    return t.reservationEditMode === X.EditReservationOptionUpdateOnly && r;
  }, [t.reservationEditMode, a.optionSelectionMode]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-10", children: [
    /* @__PURE__ */ l.jsx(oke, { ...e.tabPlanFilterContext }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3 ch-px-5", children: [
      /* @__PURE__ */ l.jsx(tce, {}),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-divide-y ch-rounded-xl ch-border-[0.5px] ch-border-gray-300", children: [
        n && /* @__PURE__ */ l.jsx($3e, { ...e.drawerPlanContext, disabled: s }),
        /* @__PURE__ */ l.jsx(Q3e, { ...e.drawerGroupContext, disabled: s }),
        /* @__PURE__ */ l.jsx(Bce, { ...e.drawerDateContext, disabled: s }),
        i ? e.displayContext.sessionStateContext.currentState.groupInfo.map(
          ({ uniqueRoomID: r }, o) => {
            const d = `select-room-${r}`, c = o + 1;
            return /* @__PURE__ */ l.jsx(
              K3e,
              {
                roomIdx: c,
                uniqueRoomID: r,
                disabled: s,
                ...e.drawerRoomContext
              },
              d
            );
          }
        ) : null,
        /* @__PURE__ */ l.jsx(sp, { ...e.dateTabbedOptionContext })
      ] })
    ] })
  ] });
}), Dke = g(({ buttonText: e, canNextScreen: n, onNextScreen: i }) => {
  const t = I(
    (s) => {
      s.stopPropagation(), i();
    },
    [i]
  ), a = v(() => !n, [n]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: a, variant: "default", size: "md", onClick: t, children: e });
}), wke = g((e) => e.kind === "HasNotNextScreen" ? null : /* @__PURE__ */ l.jsx(Dke, { ...e })), Pke = Li(({ sessionStateContext: e, ...n }, i) => {
  const t = v(() => e.lang === D.Default ? "内訳" : "Details", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { size: "xs", variant: "outline", ref: i, ...n, children: t });
}), Rke = ({ sessionStateContext: e }) => {
  const { isOpen: n, close: i, handleOpenChange: t } = ks(), a = I(
    (s) => {
      s && le(Pn({ target: "total.detail" })), t(s);
    },
    [t]
  );
  return /* @__PURE__ */ l.jsxs(fl, { open: n, onOpenChange: a, children: [
    /* @__PURE__ */ l.jsx(Et, { asChild: !0, children: /* @__PURE__ */ l.jsx(Pke, { sessionStateContext: e }) }),
    /* @__PURE__ */ l.jsxs(
      vl,
      {
        className: "ch-h-full ch-rounded-t-none ch-font-system-ui",
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ l.jsx(yt, { className: "ch-sr-only" }),
          /* @__PURE__ */ l.jsx(
            F2,
            {
              sessionStateContext: e,
              displayContext: {
                headerSectionContext: {
                  leftSlot: /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", onClick: i, children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) }) })
                }
              }
            }
          )
        ]
      }
    )
  ] });
}, Tke = ({ displayContext: e, sessionStateContext: n }) => {
  const i = v(() => {
    var t;
    return e.isShowZeroTotalPrice ? "¥ 0" : `¥ ${((t = n.priceInfo.totalGuestCharge) != null ? t : 0).toLocaleString()}`;
  }, [e.isShowZeroTotalPrice, n.priceInfo.totalGuestCharge]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-2xl ch-font-semibold", children: i });
}, jke = (e) => e.sessionStateContext.priceInfo.totalPriceBeforeDiscount !== e.sessionStateContext.priceInfo.totalGuestCharge ? {
  kind: "Displayable",
  totalPriceBeforeDiscount: e.sessionStateContext.priceInfo.totalPriceBeforeDiscount
} : {
  kind: "NotDisplayable"
}, Ake = (e) => ({
  state: v(() => jke(e), [e])
}), Oke = g(({ totalPriceBeforeDiscount: e }) => {
  const n = v(() => `¥ ${e.toLocaleString()}`, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400 ch-line-through", children: n });
}), Eke = (e) => {
  const { state: n } = Ake(e);
  return n.kind === "NotDisplayable" ? null : /* @__PURE__ */ l.jsx(Oke, { ...n });
}, Jke = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "合計金額" : "Total Price", [e.lang]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-block ch-text-sm ch-font-semibold", children: n });
}, _ke = g((e) => {
  const { reservationPolicy: n } = Ua(), { reserveStatus: i } = m1(), t = v(() => n.isShowPlanIncludedPrice && !(i.isCompleteDate && i.isCompleteRoom), [n.isShowPlanIncludedPrice, i.isCompleteDate, i.isCompleteRoom]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5", children: [
    /* @__PURE__ */ l.jsx(Jke, { ...e }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1.5", children: [
        /* @__PURE__ */ l.jsx(Tke, { ...e, displayContext: { isShowZeroTotalPrice: t } }),
        !t && /* @__PURE__ */ l.jsx(Rke, { ...e })
      ] }),
      !t && /* @__PURE__ */ l.jsx(Eke, { ...e })
    ] })
  ] });
}), gs = g((e) => /* @__PURE__ */ l.jsx("footer", { className: "ch-sticky ch-bottom-0 ch-z-[100] ch-w-full ch-border-t ch-border-zinc-200 ch-bg-white ch-px-4 ch-py-3", children: /* @__PURE__ */ l.jsx("div", { className: "w-full ch-relative ch-m-auto ch-max-w-screen-tablet", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
  /* @__PURE__ */ l.jsx(_ke, { ...e.totalPriceForReservationContext }),
  /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(wke, { ...e.nextButtonContext }) })
] }) }) })), Qke = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "予約を進める" : "Next", [e.sessionStateContext.lang]), t = v(() => e.sessionStateContext.reserveStatus.isCompletePlan && e.sessionStateContext.reserveStatus.isCompleteGroup && e.sessionStateContext.reserveStatus.isCompleteDate && e.sessionStateContext.reserveStatus.isCompleteRoom, [
    e.sessionStateContext.reserveStatus.isCompleteDate,
    e.sessionStateContext.reserveStatus.isCompleteGroup,
    e.sessionStateContext.reserveStatus.isCompletePlan,
    e.sessionStateContext.reserveStatus.isCompleteRoom
  ]) && e.sessionStateContext.reserveStatus.isCompleteDateTabbedTimeSelectionOption && (e.sessionStateContext.reserveStatus.isCompleteRequiredOptionGroup || e.sessionStateContext.reservationPolicy.isRequiredOptionGroupSatisfiableWithRegularOption), { reservationCart: a } = Va(), { onNextScreen: s } = e, r = I(() => {
    le(
      jr({
        hotel_name: e.sessionStateContext.hotelName,
        requires_options: e.sessionStateContext.reservationPolicy.isShowOptionSelect
      })
    ), Ar(a).forEach(bt), s();
  }, [
    e.sessionStateContext.hotelName,
    e.sessionStateContext.reservationPolicy.isShowOptionSelect,
    a,
    s
  ]);
  return /* @__PURE__ */ l.jsx(
    gs,
    {
      totalPriceForReservationContext: e,
      nextButtonContext: {
        kind: "HasNextScreen",
        ...e,
        onNextScreen: r,
        buttonText: n,
        canNextScreen: t
      }
    }
  );
}), Mke = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-static ch-m-auto ch-flex ch-w-full ch-max-w-screen-tablet ch-items-center ch-justify-center ch-border-b ch-border-zinc-200 ch-px-5 ch-py-1.5 ch-text-center", children: /* @__PURE__ */ l.jsx("p", { className: "ch-line-clamp-3 ch-break-keep ch-text-2xs ch-text-zinc-400", children: e.hotelName }) })), od = 100, y9 = od / 2, b9 = od / 2, ff = 9, vf = (od - ff) / 2, C9 = 2 * vf * Math.PI, Lke = g(({ currentStep: e, totalStep: n }) => {
  const i = v(() => e / n, [e, n]), t = v(() => i * C9, [i]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-relative", children: [
    /* @__PURE__ */ l.jsxs(
      "svg",
      {
        viewBox: `0 0 ${od} ${od}`,
        className: "ch-size-full -ch-rotate-90",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ l.jsx(
            "circle",
            {
              className: "ch-fill-white ch-stroke-current ch-text-gray-200",
              cx: y9,
              cy: b9,
              r: vf,
              strokeWidth: ff
            }
          ),
          /* @__PURE__ */ l.jsx(
            "circle",
            {
              className: "ch-fill-none ch-stroke-current ch-text-primary",
              cx: y9,
              cy: b9,
              r: vf,
              strokeWidth: ff,
              strokeDasharray: `${t} ${C9}`
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ l.jsx("div", { className: "ch-absolute ch-left-1/2 ch-top-1/2 ch--translate-x-1/2 ch--translate-y-1/2 ch-transform ch-tabular-nums", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-leading-none ch-text-black", children: e }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-flex ch-self-end ch-text-xs ch-text-gray-400", children: "/" }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-leading-none ch-text-gray-400", children: n })
    ] }) })
  ] });
}), $ke = g((e) => {
  const n = I(
    (i) => {
      const t = kn({
        lang: e.sessionStateContext.lang,
        i18nString: {
          default: `予約ページを離れますか？
行った変更は保存されません。`,
          en: `Are you sure you want to leave the reservation page? 
The changes you made will not be saved.`
        }
      });
      i.stopPropagation(), P(e.onCloseScreen) || window.confirm(t) && (le(Pn({ target: "header.close" })), e.onCloseScreen());
    },
    [e]
  );
  return /* @__PURE__ */ l.jsx(ae, { variant: "minimal", size: "icon", onClick: n, children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) });
}), Uke = g(({ onPrevScreen: e }) => {
  const n = I(
    (i) => {
      i.stopPropagation(), le(Pn({ target: "header.prev" })), e();
    },
    [e]
  );
  return /* @__PURE__ */ l.jsx(ae, { variant: "minimal", size: "icon", onClick: n, children: /* @__PURE__ */ l.jsx(lm, { size: "lg" }) });
}), Vke = g((e) => {
  switch (e.currentStep) {
    case 1:
      return /* @__PURE__ */ l.jsx($ke, { ...e });
    default:
      return /* @__PURE__ */ l.jsx(Uke, { ...e });
  }
}), Hke = g((e) => /* @__PURE__ */ l.jsx("h2", { className: "ch-text-xl ch-font-semibold desktop:ch-text-2xl", children: e.titleText })), Fs = g(({ prevButtonContext: e, titleContext: n, stepIndicatorContext: i }) => /* @__PURE__ */ l.jsx("header", { className: "ch-sticky ch-top-0 ch-z-[100] ch-w-full ch-bg-white", children: /* @__PURE__ */ l.jsxs("div", { className: "w-full ch-m-auto ch-flex ch-max-w-screen-tablet ch-items-center ch-border-b ch-border-zinc-200 ch-px-4 ch-py-3", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-w-[max-content]", children: /* @__PURE__ */ l.jsx(Vke, { ...e }) }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-flex-1 ch-text-center", children: /* @__PURE__ */ l.jsx(Hke, { ...n }) }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-size-[48px]", children: /* @__PURE__ */ l.jsx(Lke, { ...i }) })
] }) })), zke = g((e) => {
  const n = v(() => {
    switch (e.sessionStateContext.lang) {
      case D.Default:
        return "予定を立てる";
      case D.En:
        return "Plan Your Stay";
      default:
        return "";
    }
  }, [e.sessionStateContext.lang]);
  return /* @__PURE__ */ l.jsx(
    Fs,
    {
      prevButtonContext: e,
      titleContext: {
        titleText: n
      },
      stepIndicatorContext: e
    }
  );
}), Is = g(({ staticHeaderSlot: e, stickyHeaderSlot: n, bodyContentSlot: i, footerContentSlot: t }) => {
  const a = !!e, s = yr();
  return /* @__PURE__ */ l.jsx(Lv, { container: s, className: "ch-fixed ch-inset-0 ch-z-[100] ch-overflow-y-scroll ch-bg-white ch-font-system-ui", children: /* @__PURE__ */ l.jsxs(
    "div",
    {
      className: ce(
        "ch-grid ch-min-h-screen ch-grid-cols-[100%]",
        a ? "ch-grid-rows-[auto_auto_1fr_auto]" : "ch-grid-rows-[auto_1fr_auto]"
      ),
      children: [
        a && e,
        n,
        /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet", children: i }),
        t
      ]
    }
  ) });
}), rp = g((e) => /* @__PURE__ */ l.jsx(
  Is,
  {
    staticHeaderSlot: /* @__PURE__ */ l.jsx(Mke, { ...e.headerContext.static }),
    stickyHeaderSlot: /* @__PURE__ */ l.jsx(zke, { ...e.headerContext.sticky }),
    bodyContentSlot: /* @__PURE__ */ l.jsx(xke, { ...e.bodyContext }),
    footerContentSlot: /* @__PURE__ */ l.jsx(Qke, { ...e.footerContext })
  }
)), Bke = g((e) => /* @__PURE__ */ l.jsx(T7, { ...e })), qke = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "予約を進める" : "Next", [e.sessionStateContext.lang]), i = v(() => e.sessionStateContext.reserveStatus.isCompleteOption && e.sessionStateContext.reserveStatus.isCompleteRequiredOptionGroup, [
    e.sessionStateContext.reserveStatus.isCompleteOption,
    e.sessionStateContext.reserveStatus.isCompleteRequiredOptionGroup
  ]), { onNextScreen: t } = e, a = I(() => {
    le(hC()), t();
  }, [t]);
  return /* @__PURE__ */ l.jsx(
    gs,
    {
      totalPriceForReservationContext: e,
      nextButtonContext: {
        kind: "HasNextScreen",
        ...e,
        onNextScreen: a,
        buttonText: n,
        canNextScreen: i
      }
    }
  );
}), Gke = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "オプションを追加する" : "Add on", [e.sessionStateContext.lang]);
  return /* @__PURE__ */ l.jsx(Fs, { prevButtonContext: e, titleContext: { titleText: n }, stepIndicatorContext: e });
}), Wke = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), ew = (e) => () => ({
  kind: "Initialized",
  availableOptionList: e.availableOptionList
}), nw = (e) => () => ({
  kind: "Errored",
  lang: e.sessionStateContext.lang,
  onInitialize: e.onInitialize
}), Kke = ({ state: e, onChangeState: n, erroredInputContext: i }) => {
  const t = Ye(!1);
  be(() => {
    t.current || e.kind !== "NotInitialized" || (t.current = !0, e.onInitialize().then((a) => {
      n(ew(a)(e));
    }).catch(() => {
      n(nw(i)(e));
    }));
  }, [i, n, e]);
}, Yke = ({ onChangeState: e, erroredInputContext: n }) => ({
  onReInitialize: I(
    (t) => async () => {
      try {
        const a = await t.onInitialize();
        e(ew(a)(t));
      } catch (a) {
        e(nw(n)(t));
      }
    },
    [n, e]
  )
}), Xke = (e) => {
  const [n, i] = se(Wke(e)), t = I((s) => {
    i(s);
  }, []);
  Kke({ state: n, onChangeState: t, erroredInputContext: e });
  const { onReInitialize: a } = Yke({ onChangeState: t, erroredInputContext: e });
  return {
    state: n,
    onReInitialize: a
  };
}, Zke = ({ sessionStateContext: e }) => {
  const { refetch: n } = qn(Z7, void 0, !0);
  return {
    onInitialize: I(async () => {
      const { data: t } = await n({ baseInfo: e.baseInfoInput });
      return {
        availableOptionList: efe(t)
      };
    }, [n, e.baseInfoInput])
  };
}, efe = (e) => {
  const { availableOptions: n } = Wu(
    Zh,
    e.optionAvailable
  );
  return n;
}, nfe = (e) => {
  const n = I(async () => {
    le(Pn({ target: "refetch", area: "screen2" })), await e.onRefetch();
  }, [e]), i = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: n, children: i });
}, ife = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "データが正しく取得できませんでした。" : "Failed to fetch data.", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, tfe = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-max-w-screen-tablet ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(ife, { ...e }),
  /* @__PURE__ */ l.jsx(nfe, { ...e })
] }), afe = () => /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-max-w-screen-tablet ch-space-y-4 ch-px-5 ch-pt-[calc(24px+72px)]", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-aspect-video ch-w-full ch-animate-pulse ch-rounded-xl ch-bg-gray-200" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-[52px] ch-w-5/6 ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5", children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-h-10 ch-w-full ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
      /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-1/4 ch-min-w-20 ch-animate-pulse ch-rounded-md ch-bg-gray-200" })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-11 ch-w-24 ch-animate-pulse ch-rounded-md ch-bg-gray-200" })
  ] })
] }), lfe = g((e) => {
  const { onInitialize: n } = Zke(e), { state: i, onReInitialize: t } = Xke({ ...e, onInitialize: n });
  return i.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(afe, {}) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(tfe, { lang: i.lang, onRefetch: t(i) }) : e.children({ state: i });
}), y2 = g((e) => /* @__PURE__ */ l.jsx("div", { className: "ch-h-full ch-bg-white ch-font-system-ui", children: /* @__PURE__ */ l.jsx(lfe, { ...e.initializerContext, children: ({ state: n }) => {
  const i = n.availableOptionList.filter(
    (t) => !t.isDateTabbedTimeSelectionTarget
  );
  return /* @__PURE__ */ l.jsx(
    Is,
    {
      stickyHeaderSlot: /* @__PURE__ */ l.jsx(Gke, { ...e.headerContext }),
      bodyContentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
        !e.footerContext.sessionStateContext.reserveStatus.isCompleteRequiredOptionGroup && /* @__PURE__ */ l.jsx("div", { className: "ch-px-5 ch-pt-4", children: /* @__PURE__ */ l.jsx(
          lp,
          {
            lang: e.footerContext.sessionStateContext.lang
          }
        ) }),
        /* @__PURE__ */ l.jsx(Bke, { ...e.bodyContext, availableOptions: i })
      ] }),
      footerContentSlot: /* @__PURE__ */ l.jsx(qke, { ...e.footerContext })
    }
  );
} }) })), sfe = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), iw = (e) => () => ({
  kind: "Initialized",
  hotelInfo: e.hotelInfo,
  availableQuestionAndAnswerList: e.availableQuestionAndAnswerList
}), tw = (e) => () => ({
  kind: "Errored",
  onInitialize: e.onInitialize,
  lang: e.sessionStateContext.lang
}), rfe = ({ state: e, onChangeState: n, erroredInputContext: i }) => {
  be(() => {
    e.kind === "NotInitialized" && e.onInitialize().then((t) => {
      const a = iw(t)(e);
      n(a);
    }).catch(() => {
      const t = tw(i)(e);
      n(t);
    });
  }, [i, n, e]);
}, ofe = ({ onChangeState: e, erroredInputContext: n }) => ({
  onReInitialize: I(
    (t) => async () => {
      try {
        const a = await t.onInitialize(), s = iw(a)(t);
        e(s);
      } catch (a) {
        const s = tw(n)(t);
        e(s);
      }
    },
    [n, e]
  )
}), dfe = (e) => {
  const [n, i] = se(sfe(e)), t = I((s) => {
    i(s);
  }, []);
  rfe({ state: n, onChangeState: t, erroredInputContext: e });
  const { onReInitialize: a } = ofe({ onChangeState: t, erroredInputContext: e });
  return {
    state: n,
    onReInitialize: a
  };
}, cfe = Ve(
  /* GraphQL */
  `
	query RCScreen3InitializeQuery($baseInfo: BaseInfoInput!) {
		questionAndAnswerAvailable(baseInfo: $baseInfo) {
			availableQuestionAndAnswers {
				questionID
				isRequired
				questionText
				questionType
				answerChoices
			}
		}
		hotelInfo(baseInfo: $baseInfo) {
			hotelInfo {
				notes {
					title
					description
				}
				keyVisual
			}
		}
	}
`
), ufe = ({ sessionStateContext: e }) => {
  const { refetch: n } = qn(cfe, void 0, !0);
  return {
    onInitialize: I(async () => {
      const { data: t } = await n({ baseInfo: e.baseInfoInput });
      return {
        hotelInfo: t.hotelInfo.hotelInfo,
        availableQuestionAndAnswerList: t.questionAndAnswerAvailable.availableQuestionAndAnswers
      };
    }, [n, e.baseInfoInput])
  };
}, mfe = (e) => {
  const n = I(async () => {
    le(Pn({ target: "refetch", area: "screen3" })), await e.onRefetch();
  }, [e]), i = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: n, children: i });
}, kfe = (e) => {
  const n = v(() => e.lang === D.Default ? "データが正しく取得できませんでした。" : "Failed to fetch data.", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, ffe = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-max-w-screen-tablet ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(kfe, { ...e }),
  /* @__PURE__ */ l.jsx(mfe, { ...e })
] }), vfe = () => /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-max-w-screen-tablet ch-space-y-6 ch-pt-[73px]", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-aspect-video ch-w-full ch-animate-pulse ch-bg-gray-200" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6 ch-px-5 ch-py-8", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-7 ch-w-[120px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: Array.from({ length: 3 }).map((e, n) => /* @__PURE__ */ l.jsx(
        "div",
        {
          className: "ch-h-11 ch-w-4/5 ch-min-w-64 ch-animate-pulse ch-rounded-md ch-bg-gray-200"
        },
        n
      )) }),
      /* @__PURE__ */ l.jsxs("div", { children: [
        /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-3/4 ch-min-w-60 ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
        /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-space-y-3", children: [
          /* @__PURE__ */ l.jsx("div", { className: "ch-h-6 ch-w-[65px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
          /* @__PURE__ */ l.jsx("div", { className: "ch-h-7 ch-w-[86px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" })
        ] })
      ] })
    ] })
  ] })
] }), hfe = g((e) => {
  const { onInitialize: n } = ufe(e), { state: i, onReInitialize: t } = dfe({ ...e, onInitialize: n });
  return i.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(vfe, {}) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(ffe, { lang: i.lang, onRefetch: t(i) }) : e.children({ state: i });
}), aw = ({ title: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black", children: e }), pfe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "規約への同意" : "Acceptance of Terms and Conditions", [e.lang]);
  return /* @__PURE__ */ l.jsx(aw, { title: n });
}, Nfe = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8 ch-bg-white ch-px-5 ch-py-8", children: [
  /* @__PURE__ */ l.jsx(pfe, { ...e }),
  /* @__PURE__ */ l.jsx(m7, { ...e })
] })), Sfe = ({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx(h7, { sessionStateContext: e }), gfe = (e) => /* @__PURE__ */ l.jsx(p7, { ...e }), Ffe = g(({ hotelInfo: e }) => /* @__PURE__ */ l.jsx(Nd, { displayContext: { imageUrl: e.keyVisual } })), Ife = g((e) => /* @__PURE__ */ l.jsx(q7, { ...e })), yfe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "宿泊券 / チケット" : "Apply accommodation voucher", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: n });
}, bfe = "voucher-item", Cfe = ({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, children: /* @__PURE__ */ l.jsxs(it, { value: bfe, borderBottom: !1, children: [
  /* @__PURE__ */ l.jsx(tt, { className: "ch-h-11 ch-gap-x-2 ch-px-0 ch-py-0", hover: !1, children: /* @__PURE__ */ l.jsx(yfe, { sessionStateContext: e }) }),
  /* @__PURE__ */ l.jsx(at, { className: "ch-h-full ch-space-y-8 ch-px-0 ch-pb-6 ch-pt-2 tablet:ch-px-0 tablet:ch-pb-6 tablet:ch-pt-2", children: /* @__PURE__ */ l.jsx(N7, { sessionStateContext: e }) })
] }) }), xfe = Li(({ sessionStateContext: e, ...n }, i) => {
  const t = v(() => e.lang === D.Default ? "内訳を見る" : "Details", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { size: "md", variant: "outline", className: "ch-w-full", ref: i, ...n, children: t });
}), Dfe = ({ sessionStateContext: e }) => {
  const { isOpen: n, close: i, handleOpenChange: t } = ks(), a = I(
    (s) => {
      s && le(Pn({ target: "reservation.detail" })), t(s);
    },
    [t]
  );
  return /* @__PURE__ */ l.jsxs(fl, { open: n, onOpenChange: a, children: [
    /* @__PURE__ */ l.jsx(Et, { asChild: !0, children: /* @__PURE__ */ l.jsx(xfe, { sessionStateContext: e }) }),
    /* @__PURE__ */ l.jsxs(
      vl,
      {
        className: "ch-h-full ch-rounded-t-none ch-font-system-ui",
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ l.jsx(yt, { className: "ch-sr-only" }),
          /* @__PURE__ */ l.jsx(
            F2,
            {
              sessionStateContext: e,
              displayContext: {
                headerSectionContext: {
                  leftSlot: /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", onClick: i, children: /* @__PURE__ */ l.jsx(Ei, { size: "md" }) })
                }
              }
            }
          )
        ]
      }
    )
  ] });
}, wfe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "予約確認" : "Reservation Information", [e.lang]);
  return /* @__PURE__ */ l.jsx(aw, { title: n });
}, Pfe = ({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8 ch-bg-white ch-px-5 ch-py-8", children: [
  /* @__PURE__ */ l.jsx(wfe, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(tp, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx(k7, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(Cfe, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(Y7, { sessionStateContext: e })
  ] }),
  /* @__PURE__ */ l.jsx(K7, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(Dfe, { sessionStateContext: e })
] }), Rfe = g(({ availableDataContext: e, sessionStateContext: n }) => /* @__PURE__ */ l.jsxs(Xs, { children: [
  /* @__PURE__ */ l.jsx(Ffe, { ...e }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-bg-gray-100", children: [
    /* @__PURE__ */ l.jsx(Pfe, { sessionStateContext: n }),
    /* @__PURE__ */ l.jsx(Sfe, { sessionStateContext: n }),
    /* @__PURE__ */ l.jsx(gfe, { ...e, sessionStateContext: n }),
    /* @__PURE__ */ l.jsx(Ife, { ...e, sessionStateContext: n }),
    /* @__PURE__ */ l.jsx(Nfe, { sessionStateContext: n })
  ] })
] })), Tfe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "決済方法を選択" : "Continue to payment", [e.sessionStateContext.lang]), i = v(() => e.sessionStateContext.reserveStatus.isCompleteGuestInfo && e.sessionStateContext.reserveStatus.isCompleteQuestionAndAnswer && e.sessionStateContext.reserveStatus.isCompleteAgreementOfTermsOfService, [
    e.sessionStateContext.reserveStatus.isCompleteAgreementOfTermsOfService,
    e.sessionStateContext.reserveStatus.isCompleteGuestInfo,
    e.sessionStateContext.reserveStatus.isCompleteQuestionAndAnswer
  ]), { onNextScreen: t } = e, a = I(() => {
    le(pC()), t();
  }, [t]);
  return /* @__PURE__ */ l.jsx(
    gs,
    {
      totalPriceForReservationContext: e,
      nextButtonContext: {
        kind: "HasNextScreen",
        ...e,
        onNextScreen: a,
        buttonText: n,
        canNextScreen: i
      }
    }
  );
}), jfe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "予約内容の確認" : "Confirmation of reservation details", [e.sessionStateContext.lang]);
  return /* @__PURE__ */ l.jsx(Fs, { prevButtonContext: e, titleContext: { titleText: n }, stepIndicatorContext: e });
}), b2 = g((e) => /* @__PURE__ */ l.jsx("div", { className: "ch-h-full ch-bg-white ch-font-system-ui", children: /* @__PURE__ */ l.jsx(hfe, { ...e.initializerContext, children: ({ state: n }) => /* @__PURE__ */ l.jsx(
  Is,
  {
    stickyHeaderSlot: /* @__PURE__ */ l.jsx(jfe, { ...e.headerContext }),
    bodyContentSlot: /* @__PURE__ */ l.jsx(Rfe, { ...e.bodyContext, availableDataContext: n }),
    footerContentSlot: /* @__PURE__ */ l.jsx(Tfe, { ...e.footerContext })
  }
) }) })), lw = (e) => () => ({
  kind: "Initialized",
  selectablePaymentMethodList: e.selectablePaymentMethodList
}), Afe = (e) => ({
  kind: "NotInitialized",
  lang: e.sessionStateContext.lang,
  onInitialize: e.onInitialize
}), sw = (e) => () => ({
  kind: "Errored",
  lang: e.sessionStateContext.lang,
  onInitialize: e.onInitialize
}), Ofe = ({ state: e, onChangeState: n, erroredInputContext: i }) => {
  const t = I(
    (s) => {
      s.onInitialize().then((r) => {
        if (s.kind === "NotInitialized") {
          const o = lw(r)(s);
          n(o);
        }
      }).catch(() => {
        const r = sw(i)(s);
        n(r);
      });
    },
    [i, n]
  ), a = Ye(!1);
  be(() => {
    a.current || e.kind !== "NotInitialized" || (a.current = !0, t(e));
  }, [t, e]);
}, Efe = ({ onChangeState: e, erroredInputContext: n }) => ({
  onReInitialize: I(
    (t) => async () => {
      try {
        const a = await t.onInitialize(), s = lw(a)(t);
        e(s);
      } catch (a) {
        const s = sw(n)(t);
        e(s);
      }
    },
    [n, e]
  )
}), Jfe = (e) => {
  const [n, i] = se(Afe(e)), t = I((s) => {
    i(s);
  }, []);
  Ofe({
    state: n,
    onChangeState: t,
    erroredInputContext: e
  });
  const { onReInitialize: a } = Efe({
    onChangeState: t,
    erroredInputContext: e
  });
  return {
    state: n,
    onReInitialize: a
  };
}, _fe = Ve(
  /* GraphQL */
  `
	query RCScreen4Initialize($baseInfo: BaseInfoInput!) {
		paymentMethodAvailable(baseInfo: $baseInfo) {
			availableMethods
		}
	}
`
), Qfe = ({ sessionStateContext: e }) => {
  const { refetch: n } = qn(_fe, void 0, !0);
  return {
    onInitialize: I(async () => {
      const { data: t } = await n({ baseInfo: e.baseInfoInput });
      return {
        selectablePaymentMethodList: t.paymentMethodAvailable.availableMethods
      };
    }, [n, e.baseInfoInput])
  };
}, Mfe = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = I(async () => {
    le(Pn({ target: "refetch", area: "screen4" })), await n.onRefetchCallback();
  }, [n]), t = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: i, children: t });
}, Lfe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "選択可能な決済方法が正しく取得できませんでした。" : "Failed to get the available payment methods.", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, $fe = ({ sessionStateContext: e, callbackContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(Lfe, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(Mfe, { sessionStateContext: e, callbackContext: n })
] }), Ufe = g(() => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-max-w-screen-tablet ch-bg-white ch-pt-[73px]", children: /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-mt-5 ch-h-fit ch-max-h-80 ch-min-h-80 ch-w-full ch-animate-pulse ch-rounded-lg ch-bg-gray-200" }) })), Vfe = g((e) => {
  const { onInitialize: n } = Qfe(e), { state: i, onReInitialize: t } = Jfe({ ...e, onInitialize: n });
  return i.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(Ufe, {}) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(
    $fe,
    {
      sessionStateContext: { lang: i.lang },
      callbackContext: { onRefetchCallback: t(i) }
    }
  ) : e.children({ state: i });
}), Hfe = ({ sessionStateContext: e }) => {
  const {
    reservationPolicy: { isRequestReservation: n },
    lang: i
  } = e, t = v(
    () => kn({
      lang: i,
      i18nString: {
        default: "本予約はリクエスト予約になります",
        en: "This reservation is a request reservation"
      }
    }),
    [i]
  ), a = v(
    () => kn({
      lang: i,
      i18nString: {
        default: "本予約はリクエスト予約になります。施設からの承認後に予約が確定されます。",
        en: "This reservation is made on request. The reservation will be confirmed upon approval from the facility."
      }
    }),
    [i]
  );
  return n ? /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-[14px] ch-rounded-lg ch-bg-yellow-50 ch-p-4", children: [
    /* @__PURE__ */ l.jsx(lI, { className: "ch-text-yellow-400" }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: t }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-text-gray-600", children: a })
    ] })
  ] }) : null;
}, zfe = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6 ch-px-5 ch-py-6", children: [
  /* @__PURE__ */ l.jsx(Hfe, { ...e }),
  /* @__PURE__ */ l.jsx(oae, { ...e })
] })), Bfe = g((e) => /* @__PURE__ */ l.jsx(
  gs,
  {
    totalPriceForReservationContext: e,
    nextButtonContext: { kind: "HasNotNextScreen" }
  }
)), qfe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "支払い" : "Payment", [e.sessionStateContext.lang]);
  return /* @__PURE__ */ l.jsx(Fs, { prevButtonContext: e, titleContext: { titleText: n }, stepIndicatorContext: e });
}), C2 = g((e) => /* @__PURE__ */ l.jsx("div", { className: "ch-h-full ch-bg-white ch-font-system-ui", children: /* @__PURE__ */ l.jsx(Vfe, { ...e.initializerContext, children: ({ state: n }) => /* @__PURE__ */ l.jsx(
  Is,
  {
    stickyHeaderSlot: /* @__PURE__ */ l.jsx(qfe, { ...e.headerContext }),
    bodyContentSlot: /* @__PURE__ */ l.jsx(zfe, { ...e.bodyContext, availableDataContext: n }),
    footerContentSlot: /* @__PURE__ */ l.jsx(Bfe, { ...e.footerContext })
  }
) }) })), Gfe = g(() => /* @__PURE__ */ l.jsx(x7, {})), Wfe = g(({ sessionStateContext: e, onNextScreen: n }) => {
  const { reservationCart: i } = Va(), t = I(() => {
    le(
      jr({
        hotel_name: e.hotelName,
        requires_options: e.reservationPolicy.isShowOptionSelect
      })
    ), Ar(i).forEach(bt), n();
  }, [
    n,
    i,
    e.hotelName,
    e.reservationPolicy.isShowOptionSelect
  ]), a = v(() => {
    var s, r;
    return P((s = e.currentState.dateInfo) == null ? void 0 : s.stayStartDt) && P((r = e.currentState.dateInfo) == null ? void 0 : r.stayLastDt) ? e.lang === D.Default ? "日程を決めずに進める" : "Next without setting a date" : e.lang === D.Default ? "予約を進める" : "Next";
  }, [e.currentState.dateInfo, e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { variant: "default", size: "md", onClick: t, children: a });
}), Kfe = g((e) => /* @__PURE__ */ l.jsx("div", { className: "ch-px-4 ch-py-4 ch-text-right tablet:ch-px-14", children: /* @__PURE__ */ l.jsx(Wfe, { ...e }) })), Yfe = g(({ footerContext: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6 ch-rounded-[10px] ch-bg-white ch-font-system-ui", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-divide-y ch-divide-solid ch-divide-gray-200 ch-rounded-[10px] ch-border ch-border-solid ch-border-gray-200", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto", children: /* @__PURE__ */ l.jsx(Gfe, {}) }),
  /* @__PURE__ */ l.jsx(Kfe, { ...e })
] }) })), x2 = ({ isSelectable: e = !0, trackingTarget: n, triggerSlot: i, contentContext: t }) => {
  const { close: a, isOpen: s, handleOpenChange: r } = ks(), o = I(
    (m) => {
      n && le(
        Pn({
          target: `drawer.${n}.${m ? "open" : "close"}`
        })
      );
    },
    [n]
  ), d = I(
    (m) => {
      o(m), r(m);
    },
    [r, o]
  ), c = v(() => !e, [e]), u = I(
    (m) => {
      m.preventDefault(), o(!1), a();
    },
    [a, o]
  ), k = I((m) => {
    m.preventDefault();
  }, []);
  return /* @__PURE__ */ l.jsxs(fl, { open: s, onOpenChange: d, children: [
    /* @__PURE__ */ l.jsx(
      Et,
      {
        disabled: c,
        className: ce(
          "ch-px-5 ch-py-4 hover:ch-no-underline",
          c ? "ch-opacity-30" : "ch-opacity-100"
        ),
        children: i
      }
    ),
    /* @__PURE__ */ l.jsxs(
      vl,
      {
        className: "ch-h-drawer-almost-full ch-max-h-drawer-almost-full ch-rounded-t-2xl ch-font-system-ui",
        onClick: k,
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ l.jsxs(yt, { className: "ch-mx-auto ch-grid ch-w-full ch-max-w-screen-tablet ch-grid-cols-[1fr_40px] ch-items-center ch-border-b ch-border-t-gray-200 ch-px-5 ch-pb-5", children: [
            t.titleSlot,
            /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", onClick: u, children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) })
          ] }),
          /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-overflow-y-scroll", children: t.bodySlot }),
          /* @__PURE__ */ l.jsx(_m, { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-border-t ch-border-t-gray-200 ch-px-5", children: t.footerSlot({ onCloseDrawer: a }) })
        ]
      }
    )
  ] });
}, Xfe = Ve(
  /* GraphQL */
  `
	mutation RCSelectDateDateRemove($baseInfo: BaseInfoInput!) {
		dateRemove(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
);
Ve(
  /* GraphQL */
  `
	mutation RCSelectDateDateUpdate($baseInfo: BaseInfoInput!, $dateInfo: DateUpdateInput!) {
		dataUpdate(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			...ReservationSessionStateFragment
		}
	}
`
);
const Zfe = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(Xfe);
  return {
    onRemoveReservationStayDt: I(async () => {
      const { data: t } = await n({
        variables: { baseInfo: e.baseInfoInput }
      });
      e.onUpdateSession(t.dateRemove), le(
        yn({
          target: "date",
          action: "remove"
        })
      );
    }, [n, e])
  };
}, eve = (e) => e.sessionStateContext.reservationPolicy.isDayTrip && !P(e.selectedDtContext.cinDt) ? {
  kind: "DayTripDtSelected",
  lang: e.sessionStateContext.lang,
  dt: e.selectedDtContext.cinDt,
  onSubmitCallback: e.onSubmit,
  onResetCallback: e.onResetForDayTripDt
} : !P(e.selectedDtContext.cinDt) && !P(e.selectedDtContext.coutDt) ? {
  kind: "ReservationCinOutSelected",
  lang: e.sessionStateContext.lang,
  cinDt: e.selectedDtContext.cinDt,
  coutDt: e.selectedDtContext.coutDt,
  onSubmitCallback: e.onSubmit,
  onResetCallback: e.onResetForStayDt(e.selectedDtContext.coutDt)
} : P(e.selectedDtContext.cinDt) ? {
  kind: "NotSelected",
  lang: e.sessionStateContext.lang
} : {
  kind: "ReservationCinSelected",
  lang: e.sessionStateContext.lang,
  cinDt: e.selectedDtContext.cinDt,
  onResetCallback: e.onResetForStayDt()
}, nve = (e) => ({
  state: v(() => eve(e), [e])
}), ive = g(({ state: e }) => {
  const n = v(() => kn({
    lang: e.lang,
    i18nString: {
      default: "日付のリセット",
      en: "Reset date"
    }
  }), [e]), i = v(() => e.kind === "NotSelected", [e.kind]), { onShowLoadingScreenCallback: t, onHideLoadingScreenCallback: a } = fn(), s = I(async () => {
    e.kind !== "NotSelected" && (t(), await e.onResetCallback().finally(() => {
      a();
    }));
  }, [a, t, e]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: i, variant: "outline", size: "md", onClick: s, children: n });
}), tve = g(({ state: e }) => {
  const n = v(() => {
    switch (e.lang) {
      case D.Default:
        return "決定する";
      case D.En:
        return "Confirm";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]), i = v(() => e.kind === "NotSelected" || e.kind === "ReservationCinSelected", [e.kind]), t = I(() => {
    e.kind === "NotSelected" || e.kind === "ReservationCinSelected" || e.onSubmitCallback();
  }, [e]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: i, variant: "default", size: "md", onClick: t, children: n });
}), ave = g(({ state: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-cols-2 ch-gap-x-4 ch-py-4", children: [
  /* @__PURE__ */ l.jsx(ive, { state: e }),
  /* @__PURE__ */ l.jsx(tve, { state: e })
] })), lve = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "滞在日";
      case D.En:
        return "Stay date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), sve = g(({ lang: e, dt: n }) => {
  const i = v(() => {
    switch (e) {
      case D.Default:
        return `${Ne(n, "YYYY年MM月DD日")}（日帰り）`;
      case D.En:
        return `${Ne(n, "D MMM YYYY", "en")} (Day trip)`;
      default:
        throw new Error("Invalid lang code");
    }
  }, [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), rve = g(({ lang: e, dt: n }) => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pt-4 ch-text-center", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
  /* @__PURE__ */ l.jsx(lve, { lang: e }),
  /* @__PURE__ */ l.jsx(sve, { lang: e, dt: n })
] }) })), ove = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "日付を選択してください";
      case D.En:
        return "Please select a date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pb-3 ch-pt-7 ch-text-center", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-urgent-400", children: n }) });
}), dve = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックイン";
      case D.En:
        return "Check-in";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), cve = g(({ lang: e, dt: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), uve = g(({ lang: e, cinDt: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(dve, { lang: e }),
  /* @__PURE__ */ l.jsx(cve, { dt: n, lang: e })
] })), mve = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックアウト";
      case D.En:
        return "Check-out";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), kve = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "日付を選択してください";
      case D.En:
        return "Please select a date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-leading-5 ch-text-urgent-400", children: n });
}), fve = g(({ lang: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(mve, { lang: e }),
  /* @__PURE__ */ l.jsx(kve, { lang: e })
] })), vve = g(({ lang: e, cinDt: n }) => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pt-4 ch-text-center", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-gap-x-6", children: [
  /* @__PURE__ */ l.jsx(uve, { lang: e, cinDt: n }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-bold", children: "→" }),
  /* @__PURE__ */ l.jsx(fve, { lang: e })
] }) })), hve = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックイン";
      case D.En:
        return "Check-in";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), pve = g(({ lang: e, dt: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), Nve = g(({ lang: e, cinDt: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(hve, { lang: e }),
  /* @__PURE__ */ l.jsx(pve, { lang: e, dt: n })
] })), Sve = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックアウト";
      case D.En:
        return "Check-out";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), gve = g(({ lang: e, dt: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), Fve = g(({ lang: e, coutDt: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(Sve, { lang: e }),
  /* @__PURE__ */ l.jsx(gve, { lang: e, dt: n })
] })), Ive = g(({ lang: e, cinDt: n, coutDt: i }) => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pt-4 ch-text-center", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-gap-x-6", children: [
  /* @__PURE__ */ l.jsx(Nve, { lang: e, cinDt: n }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-bold", children: "→" }),
  /* @__PURE__ */ l.jsx(Fve, { lang: e, coutDt: i })
] }) })), yve = g(({ state: e }) => e.kind === "DayTripDtSelected" ? /* @__PURE__ */ l.jsx(rve, { lang: e.lang, dt: e.dt }) : e.kind === "ReservationCinSelected" ? /* @__PURE__ */ l.jsx(vve, { lang: e.lang, cinDt: e.cinDt }) : e.kind === "ReservationCinOutSelected" ? /* @__PURE__ */ l.jsx(Ive, { lang: e.lang, cinDt: e.cinDt, coutDt: e.coutDt }) : /* @__PURE__ */ l.jsx(ove, { lang: e.lang })), bve = g(({ modelContext: e }) => {
  const { state: n } = nve(e);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-grid", children: [
    /* @__PURE__ */ l.jsx(yve, { state: n }),
    /* @__PURE__ */ l.jsx(ave, { state: n })
  ] });
}), Cve = g(({ sessionStateContext: e }) => {
  const n = v(() => {
    switch (e.lang) {
      case D.Default:
        return "日付を選択";
      case D.En:
        return "Select date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-bold ch-text-black ch-opacity-80", children: n });
});
function xve(e) {
  const n = Tr();
  return e.isDayTrip ? {
    cinDt: e.stayStartDt,
    coutDt: void 0,
    resetAt: n
  } : P(e.stayStartDt) || P(e.stayLastDt) ? {
    cinDt: e.stayStartDt,
    coutDt: void 0,
    resetAt: n
  } : {
    cinDt: e.stayStartDt,
    /**
     * StayLastDt は宿泊最終日なので +1 日する必要がある
     */
    coutDt: Ci({ date: e.stayLastDt, inc: 1 }),
    resetAt: n
  };
}
const Dve = (e) => {
  const n = v(() => {
    var d, c, u, k;
    return xve({
      isDayTrip: e.sessionStateContext.reservationPolicy.isDayTrip,
      stayStartDt: (c = (d = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : d.stayStartDt) != null ? c : void 0,
      stayLastDt: (k = (u = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : u.stayLastDt) != null ? k : void 0
    });
  }, [e.sessionStateContext]), [i, t] = se(n), a = I(() => {
    t(n);
  }, [n]), s = I(() => {
    t({
      cinDt: void 0,
      coutDt: void 0,
      resetAt: Tr()
    });
  }, []), r = I((d) => {
    t((c) => ({
      ...c,
      cinDt: d,
      coutDt: void 0
    }));
  }, []), o = I((d) => {
    t((c) => ({
      ...c,
      coutDt: d
    }));
  }, []);
  return {
    checkDtState: i,
    onSelectCinDt: r,
    onSelectCoutDt: o,
    onRestoreCheckDt: a,
    onResetCheckDt: s
  };
}, wve = g((e) => {
  const { onRemoveReservationStayDt: n } = Zfe(e), i = I(
    (c) => async () => {
      await n().then(() => {
        c();
      });
    },
    [n]
  ), t = I(
    (c) => (u) => async () => {
      await (async () => {
        P(u) || await n();
      })().then(() => {
        c();
      });
    },
    [n]
  ), { checkDtState: a, onSelectCinDt: s, onSelectCoutDt: r, onResetCheckDt: o } = Dve(e), d = v(() => {
    var c;
    return (c = a.resetAt) != null ? c : "";
  }, [a.resetAt]);
  return /* @__PURE__ */ l.jsx(
    x2,
    {
      trackingTarget: "date",
      triggerSlot: /* @__PURE__ */ l.jsx(l2e, { ...e }),
      contentContext: {
        titleSlot: /* @__PURE__ */ l.jsx(Cve, { ...e }),
        bodySlot: /* @__PURE__ */ l.jsx(
          Kh,
          {
            ...e,
            onSelectCinDtCallback: s,
            onSelectCoutDtCallback: r,
            onRemoveReservationStayDt: n
          },
          d
        ),
        footerSlot: ({ onCloseDrawer: c }) => /* @__PURE__ */ l.jsx(
          bve,
          {
            modelContext: {
              ...e,
              selectedDtContext: {
                cinDt: a.cinDt,
                coutDt: a.coutDt
              },
              onSubmit: c,
              onResetForDayTripDt: i(o),
              onResetForStayDt: t(o)
            }
          }
        )
      }
    }
  );
});
g(() => /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-animate-pulse ch-space-y-6 ch-rounded ch-border-gray-300 ch-bg-white ch-px-6 ch-py-3", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-h-7 ch-w-28 ch-rounded-md ch-bg-gray-300" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-20 ch-rounded ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-24 ch-rounded ch-bg-gray-200" })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-20 ch-rounded ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-24 ch-rounded ch-bg-gray-200" })
  ] })
] }));
const Pve = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "人数" : "Guests", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-black", children: n });
}, Rve = ({ sessionStateContext: e }) => {
  const n = v(() => {
    const t = e.currentState.groupInfo.reduce(
      (s, r) => s + r.adultNum,
      0
    ), a = e.currentState.groupInfo.reduce(
      (s, r) => s + r.kidsNum.length,
      0
    );
    return t + a;
  }, [e.currentState.groupInfo]), i = v(() => e.lang === D.Default ? `${n} 名` : `${n} guests`, [e.lang, n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}, Tve = ({ sessionStateContext: e }) => {
  const n = v(() => e.currentState.groupInfo.length, [e.currentState.groupInfo.length]), i = v(() => e.lang === D.Default ? `${n} 部屋` : `${n} rooms`, [e.lang, n]);
  return vs(e) ? null : /* @__PURE__ */ l.jsx("p", { children: i });
}, jve = ({ sessionStateContext: e }) => {
  const n = v(
    () => e.currentState.groupInfo.reduce((t, a) => t + a.adultNum, 0),
    [e.currentState.groupInfo]
  ), i = v(() => e.lang === D.Default ? `大人 ${n} 名` : `${n} adults`, [e.lang, n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}, Ave = (e) => {
  const n = e.sessionStateContext.currentState.groupInfo.reduce(
    (t, a) => t + a.kidsNum.length,
    0
  );
  return n >= 1 ? {
    kind: "Displayable",
    totalChildNum: n
  } : {
    kind: "NotDisplayable"
  };
}, Ove = (e) => ({
  state: v(() => Ave(e), [e])
}), Eve = "・", Jve = ({ sessionStateContext: e, totalChildNum: n }) => {
  const i = v(() => e.lang === D.Default ? `子ども ${n} 名` : `${n} children`, [e.lang, n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-[1px]", children: [
    /* @__PURE__ */ l.jsx("p", { children: Eve }),
    /* @__PURE__ */ l.jsx("p", { children: i })
  ] });
}, _ve = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = Ove(n);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsx(Jve, { sessionStateContext: e, totalChildNum: i.totalChildNum }) : null;
}, Qve = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-justify-end ch-space-x-3", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-space-x-2 ch-text-base", children: [
    /* @__PURE__ */ l.jsx(Tve, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(Rve, { sessionStateContext: e })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-space-x-[1px] ch-text-xs", children: [
    /* @__PURE__ */ l.jsx(jve, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(
      _ve,
      {
        sessionStateContext: e,
        modelContext: { sessionStateContext: e }
      }
    )
  ] })
] })), Mve = g(({ sessionStateContext: e, callbackContext: n }) => {
  const i = v(() => e.lang === D.Default ? "決定する" : "Confirm", [e.lang]), t = I(() => {
    n.onSubmitCallback();
  }, [n]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", onClick: t, children: i });
}), Lve = ({ callbackContext: e, sessionStateContext: n }) => /* @__PURE__ */ l.jsxs("div", { children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-pb-2 ch-pt-4", children: /* @__PURE__ */ l.jsx(Qve, { sessionStateContext: n }) }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-pb-8 ch-pt-4", children: /* @__PURE__ */ l.jsx(Mve, { sessionStateContext: n, callbackContext: e }) })
] }), $ve = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx(
  x2,
  {
    trackingTarget: "group",
    triggerSlot: /* @__PURE__ */ l.jsx(w2e, { sessionStateContext: e }),
    contentContext: {
      titleSlot: /* @__PURE__ */ l.jsx(Pve, { sessionStateContext: e }),
      bodySlot: /* @__PURE__ */ l.jsx(Xh, { sessionStateContext: e }),
      footerSlot: ({ onCloseDrawer: n }) => /* @__PURE__ */ l.jsx(
        Lve,
        {
          sessionStateContext: e,
          callbackContext: { onSubmitCallback: n }
        }
      )
    }
  }
)), Uve = ({ callbackContext: e, sessionStateContext: n }) => {
  const i = v(() => n.lang === D.Default ? "決定する" : "Confirm", [n.lang]), t = v(() => P(n.currentState.planInfo.willReserve), [n.currentState.planInfo.willReserve]), a = I(() => {
    e.onSubmitCallback();
  }, [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-pb-8 ch-pt-4", children: /* @__PURE__ */ l.jsx(ae, { disabled: t, className: "ch-w-full", size: "md", onClick: a, children: i }) });
}, Vve = ({ sessionStateContext: e }) => {
  const n = v(() => !!(e.reservationPolicy.isDayTrip || e.clientContext.planQueryFilter === It.OnlyDayTripPlans), [e.clientContext.planQueryFilter, e.reservationPolicy.isDayTrip]), i = v(() => kn(n ? {
    lang: e.lang,
    i18nString: {
      default: "日帰りプラン",
      en: "Day Trip Plan"
    }
  } : {
    lang: e.lang,
    i18nString: {
      default: "プラン",
      en: "Plan"
    }
  }), [e.lang, n]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-text-black", children: i });
}, Hve = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx(
  x2,
  {
    trackingTarget: "plan",
    triggerSlot: /* @__PURE__ */ l.jsx(U2e, { sessionStateContext: e }),
    contentContext: {
      titleSlot: /* @__PURE__ */ l.jsx(Vve, { sessionStateContext: e }),
      bodySlot: /* @__PURE__ */ l.jsx(S2, { sessionStateContext: e }),
      footerSlot: ({ onCloseDrawer: n }) => /* @__PURE__ */ l.jsx(
        Uve,
        {
          sessionStateContext: e,
          callbackContext: { onSubmitCallback: n }
        }
      )
    }
  }
)), zve = ({ callbackContext: e, sessionStateContext: n }) => {
  const i = v(() => n.lang === D.Default ? "決定する" : "Confirm", [n.lang]), t = I(() => {
    e.onSubmitCallback();
  }, [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-pb-8 ch-pt-4", children: /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", onClick: t, children: i }) });
}, Bve = (e) => e.sessionStateContext.currentState.groupInfo.length >= 2 ? {
  kind: "Displayable",
  roomIdx: e.roomIdx
} : {
  kind: "NotDisplayable"
}, qve = (e) => ({
  state: v(() => Bve(e), [e])
}), Gve = ({ modelContext: e }) => {
  const { state: n } = qve(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("p", { children: n.roomIdx }) : null;
}, Wve = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "お部屋" : "Room", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, Kve = ({ roomIdx: e, sessionStateContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1 ch-text-black", children: [
  /* @__PURE__ */ l.jsx(Wve, { sessionStateContext: n }),
  /* @__PURE__ */ l.jsx(
    Gve,
    {
      modelContext: {
        roomIdx: e,
        sessionStateContext: {
          currentState: { groupInfo: n.currentState.groupInfo }
        }
      }
    }
  )
] }), Yve = ({ roomIdx: e, uniqueRoomID: n, sessionStateContext: i }) => /* @__PURE__ */ l.jsx(
  x2,
  {
    trackingTarget: "room",
    isSelectable: i.reserveStatus.isCompleteDate,
    triggerSlot: /* @__PURE__ */ l.jsx(
      i0e,
      {
        roomIdx: e,
        uniqueRoomID: n,
        sessionStateContext: i
      }
    ),
    contentContext: {
      titleSlot: /* @__PURE__ */ l.jsx(Kve, { roomIdx: e, sessionStateContext: i }),
      bodySlot: /* @__PURE__ */ l.jsx(
        np,
        {
          uniqueRoomID: n,
          sessionStateContext: i
        }
      ),
      footerSlot: (t) => /* @__PURE__ */ l.jsx(
        zve,
        {
          callbackContext: { onSubmitCallback: t.onCloseDrawer },
          sessionStateContext: i
        }
      )
    }
  }
), Xve = g(({ buttonText: e, canNextScreen: n, onNextScreen: i }) => {
  const t = I(
    (s) => {
      s.stopPropagation(), i();
    },
    [i]
  ), a = v(() => !n, [n]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: a, variant: "default", size: "md", onClick: t, children: e });
}), Zve = g((e) => e.kind === "HasNotNextScreen" ? null : /* @__PURE__ */ l.jsx(Xve, { ...e })), ehe = Li(({ sessionStateContext: e, ...n }, i) => {
  const t = v(() => kn({
    lang: e.lang,
    i18nString: {
      default: "内訳",
      en: "Details"
    }
  }), [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { size: "xs", variant: "outline", ref: i, ...n, children: t });
}), nhe = ({ sessionStateContext: e }) => {
  const { isOpen: n, close: i, handleOpenChange: t } = ks(), a = I(
    (s) => {
      s && le(Pn({ target: "total.detail" })), t(s);
    },
    [t]
  );
  return /* @__PURE__ */ l.jsxs(fl, { open: n, onOpenChange: a, children: [
    /* @__PURE__ */ l.jsx(Et, { asChild: !0, children: /* @__PURE__ */ l.jsx(ehe, { sessionStateContext: e }) }),
    /* @__PURE__ */ l.jsxs(
      vl,
      {
        className: "ch-h-full ch-rounded-t-none ch-font-system-ui",
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ l.jsx(yt, { className: "ch-sr-only" }),
          /* @__PURE__ */ l.jsx(
            F2,
            {
              sessionStateContext: e,
              displayContext: {
                headerSectionContext: {
                  leftSlot: /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", onClick: i, children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) }) })
                }
              }
            }
          )
        ]
      }
    )
  ] });
}, ihe = ({ displayContext: e, sessionStateContext: n }) => {
  const i = v(() => {
    var t;
    return e.isShowZeroTotalPrice ? "¥ 0" : `¥ ${((t = n.priceInfo.totalGuestCharge) != null ? t : 0).toLocaleString()}`;
  }, [e.isShowZeroTotalPrice, n.priceInfo.totalGuestCharge]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-2xl ch-font-semibold", children: i });
}, the = (e) => e.sessionStateContext.priceInfo.totalPriceBeforeDiscount !== e.sessionStateContext.priceInfo.totalGuestCharge ? {
  kind: "Displayable",
  totalPriceBeforeDiscount: e.sessionStateContext.priceInfo.totalPriceBeforeDiscount
} : {
  kind: "NotDisplayable"
}, ahe = (e) => ({
  state: v(() => the(e), [e])
}), lhe = g(({ totalPriceBeforeDiscount: e }) => {
  const n = v(() => `¥ ${e.toLocaleString()}`, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400 ch-line-through", children: n });
}), she = (e) => {
  const { state: n } = ahe(e);
  return n.kind === "NotDisplayable" ? null : /* @__PURE__ */ l.jsx(lhe, { ...n });
}, rhe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "合計金額" : "Total Price", [e.lang]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-block ch-text-sm ch-font-semibold", children: n });
}, ohe = g((e) => {
  const { reservationPolicy: n } = Ua(), { reserveStatus: i } = m1(), t = v(() => n.isShowPlanIncludedPrice && !(i.isCompleteDate && i.isCompleteRoom), [n.isShowPlanIncludedPrice, i.isCompleteDate, i.isCompleteRoom]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(rhe, { ...e }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1.5", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5", children: [
        /* @__PURE__ */ l.jsx(ihe, { ...e, displayContext: { isShowZeroTotalPrice: t } }),
        !t && /* @__PURE__ */ l.jsx(she, { ...e })
      ] }),
      !t && /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(nhe, { ...e }) })
    ] })
  ] });
}), dhe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "予約を進める" : "Next", [e.sessionStateContext.lang]), t = v(() => e.sessionStateContext.reserveStatus.isCompletePlan && e.sessionStateContext.reserveStatus.isCompleteGroup && e.sessionStateContext.reserveStatus.isCompleteDate && e.sessionStateContext.reserveStatus.isCompleteRoom, [
    e.sessionStateContext.reserveStatus.isCompleteDate,
    e.sessionStateContext.reserveStatus.isCompleteGroup,
    e.sessionStateContext.reserveStatus.isCompletePlan,
    e.sessionStateContext.reserveStatus.isCompleteRoom
  ]) && e.sessionStateContext.reserveStatus.isCompleteDateTabbedTimeSelectionOption && (e.sessionStateContext.reserveStatus.isCompleteRequiredOptionGroup || e.sessionStateContext.reservationPolicy.isRequiredOptionGroupSatisfiableWithRegularOption), { reservationCart: a } = Va(), { onNextScreen: s } = e, r = I(() => {
    le(
      jr({
        hotel_name: e.sessionStateContext.hotelName,
        requires_options: e.sessionStateContext.reservationPolicy.isShowOptionSelect
      })
    ), Ar(a).forEach(bt), s();
  }, [
    e.sessionStateContext.hotelName,
    e.sessionStateContext.reservationPolicy.isShowOptionSelect,
    a,
    s
  ]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-start ch-justify-between ch-px-8 ch-py-4", children: [
    /* @__PURE__ */ l.jsx(ohe, { ...e }),
    /* @__PURE__ */ l.jsx(
      Zve,
      {
        kind: "HasNextScreen",
        ...e,
        onNextScreen: r,
        canNextScreen: t,
        buttonText: n
      }
    )
  ] });
}), che = g((e) => {
  const n = v(() => e.displayContext.sessionStateContext.reservationPolicy.isShowPlanSelect, [e.displayContext.sessionStateContext.reservationPolicy.isShowPlanSelect]), i = v(() => e.displayContext.sessionStateContext.reservationPolicy.isShowRoomSelect, [e.displayContext.sessionStateContext.reservationPolicy.isShowRoomSelect]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-divide-y ch-rounded-lg ch-border-[0.5px] ch-border-gray-300 ch-bg-white ch-font-system-ui", children: [
    n && /* @__PURE__ */ l.jsx(Hve, { ...e.drawerPlanContext }),
    /* @__PURE__ */ l.jsx($ve, { ...e.drawerGroupContext }),
    /* @__PURE__ */ l.jsx(wve, { ...e.drawerDateContext }),
    i ? e.displayContext.sessionStateContext.currentState.groupInfo.map(({ uniqueRoomID: t }, a) => {
      const s = `select-room-${t}`, r = a + 1;
      return /* @__PURE__ */ l.jsx(
        Yve,
        {
          roomIdx: r,
          uniqueRoomID: t,
          ...e.drawerRoomContext
        },
        s
      );
    }) : null,
    /* @__PURE__ */ l.jsx(sp, { ...e.dateTabbedOptionContext }),
    /* @__PURE__ */ l.jsx(dhe, { ...e.footerContext })
  ] });
}), uhe = g(() => /* @__PURE__ */ l.jsx(x7, { className: "ch-bg-transparent", forceSingleCalendar: !0 })), mhe = g(({ sessionStateContext: e, onNextScreen: n }) => {
  const { reservationCart: i } = Va(), t = I(() => {
    le(
      jr({
        hotel_name: e.hotelName,
        requires_options: e.reservationPolicy.isShowOptionSelect
      })
    ), Ar(i).forEach(bt), n();
  }, [
    n,
    i,
    e.hotelName,
    e.reservationPolicy.isShowOptionSelect
  ]);
  if (!v(
    () => {
      var r, o;
      return !P((r = e.currentState.dateInfo) == null ? void 0 : r.stayStartDt) || !P((o = e.currentState.dateInfo) == null ? void 0 : o.stayLastDt);
    },
    [e.currentState.dateInfo]
  ))
    return null;
  const s = e.lang === D.Default ? "予約を進める" : "Next";
  return /* @__PURE__ */ l.jsx(ae, { variant: "default", size: "md", onClick: t, children: s });
});
g((e) => /* @__PURE__ */ l.jsx("div", { className: "ch-px-4 ch-py-4 ch-text-right tablet:ch-px-14", children: /* @__PURE__ */ l.jsx(mhe, { ...e }) }));
const khe = g(() => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6 ch-rounded-[10px] ch-bg-transparent ch-font-system-ui", children: /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto", children: /* @__PURE__ */ l.jsx(uhe, {}) }) })), D2 = ({ isSelectable: e = !0, trackingTarget: n, triggerSlot: i, contentContext: t }) => {
  const { close: a, isOpen: s, handleOpenChange: r } = ks(), o = I(
    (m) => {
      n && le(
        Pn({
          target: `drawer.${n}.${m ? "open" : "close"}`
        })
      );
    },
    [n]
  ), d = I(
    (m) => {
      o(m), r(m);
    },
    [r, o]
  ), c = v(() => !e, [e]), u = I(
    (m) => {
      m.preventDefault(), o(!1), a();
    },
    [a, o]
  ), k = I((m) => {
    m.preventDefault();
  }, []);
  return /* @__PURE__ */ l.jsxs(fl, { open: s, onOpenChange: d, children: [
    /* @__PURE__ */ l.jsx(
      Et,
      {
        disabled: c,
        className: ce(
          "ch-px-5 ch-py-4 hover:ch-no-underline",
          c ? "ch-opacity-30" : "ch-opacity-100"
        ),
        children: i
      }
    ),
    /* @__PURE__ */ l.jsxs(
      vl,
      {
        className: "ch-h-drawer-almost-full ch-max-h-drawer-almost-full ch-rounded-t-2xl ch-font-system-ui",
        onClick: k,
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ l.jsxs(yt, { className: "ch-mx-auto ch-grid ch-w-full ch-max-w-screen-tablet ch-grid-cols-[1fr_40px] ch-items-center ch-border-b ch-border-t-gray-200 ch-px-5 ch-pb-5", children: [
            t.titleSlot,
            /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", onClick: u, children: /* @__PURE__ */ l.jsx(Ei, { size: "lg" }) })
          ] }),
          /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-overflow-y-scroll", children: t.bodySlot }),
          /* @__PURE__ */ l.jsx(_m, { className: "ch-mx-auto ch-w-full ch-max-w-screen-tablet ch-border-t ch-border-t-gray-200 ch-px-5", children: t.footerSlot({ onCloseDrawer: a }) })
        ]
      }
    )
  ] });
}, fhe = Ve(
  /* GraphQL */
  `
	mutation RCSelectDateDateRemove($baseInfo: BaseInfoInput!) {
		dateRemove(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
);
Ve(
  /* GraphQL */
  `
	mutation RCSelectDateDateUpdate($baseInfo: BaseInfoInput!, $dateInfo: DateUpdateInput!) {
		dataUpdate(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			...ReservationSessionStateFragment
		}
	}
`
);
const vhe = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(fhe);
  return {
    onRemoveReservationStayDt: I(async () => {
      const { data: t } = await n({
        variables: { baseInfo: e.baseInfoInput }
      });
      e.onUpdateSession(t.dateRemove), le(
        yn({
          target: "date",
          action: "remove"
        })
      );
    }, [n, e])
  };
}, hhe = (e) => e.sessionStateContext.reservationPolicy.isDayTrip && !P(e.selectedDtContext.cinDt) ? {
  kind: "DayTripDtSelected",
  lang: e.sessionStateContext.lang,
  dt: e.selectedDtContext.cinDt,
  onSubmitCallback: e.onSubmit,
  onResetCallback: e.onResetForDayTripDt
} : !P(e.selectedDtContext.cinDt) && !P(e.selectedDtContext.coutDt) ? {
  kind: "ReservationCinOutSelected",
  lang: e.sessionStateContext.lang,
  cinDt: e.selectedDtContext.cinDt,
  coutDt: e.selectedDtContext.coutDt,
  onSubmitCallback: e.onSubmit,
  onResetCallback: e.onResetForStayDt(e.selectedDtContext.coutDt)
} : P(e.selectedDtContext.cinDt) ? {
  kind: "NotSelected",
  lang: e.sessionStateContext.lang
} : {
  kind: "ReservationCinSelected",
  lang: e.sessionStateContext.lang,
  cinDt: e.selectedDtContext.cinDt,
  onResetCallback: e.onResetForStayDt()
}, phe = (e) => ({
  state: v(() => hhe(e), [e])
}), Nhe = g(({ state: e }) => {
  const n = v(() => kn({
    lang: e.lang,
    i18nString: {
      default: "日付のリセット",
      en: "Reset date"
    }
  }), [e]), i = v(() => e.kind === "NotSelected", [e.kind]), { onShowLoadingScreenCallback: t, onHideLoadingScreenCallback: a } = fn(), s = I(async () => {
    e.kind !== "NotSelected" && (t(), await e.onResetCallback().finally(() => {
      a();
    }));
  }, [a, t, e]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: i, variant: "outline", size: "md", onClick: s, children: n });
}), She = g(({ state: e }) => {
  const n = v(() => {
    switch (e.lang) {
      case D.Default:
        return "決定する";
      case D.En:
        return "Confirm";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]), i = v(() => e.kind === "NotSelected" || e.kind === "ReservationCinSelected", [e.kind]), t = I(() => {
    e.kind === "NotSelected" || e.kind === "ReservationCinSelected" || e.onSubmitCallback();
  }, [e]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: i, variant: "default", size: "md", onClick: t, children: n });
}), ghe = g(({ state: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-cols-2 ch-gap-x-4 ch-py-4", children: [
  /* @__PURE__ */ l.jsx(Nhe, { state: e }),
  /* @__PURE__ */ l.jsx(She, { state: e })
] })), Fhe = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "滞在日";
      case D.En:
        return "Stay date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), Ihe = g(({ lang: e, dt: n }) => {
  const i = v(() => {
    switch (e) {
      case D.Default:
        return `${Ne(n, "YYYY年MM月DD日")}（日帰り）`;
      case D.En:
        return `${Ne(n, "D MMM YYYY", "en")} (Day trip)`;
      default:
        throw new Error("Invalid lang code");
    }
  }, [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), yhe = g(({ lang: e, dt: n }) => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pt-4 ch-text-center", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
  /* @__PURE__ */ l.jsx(Fhe, { lang: e }),
  /* @__PURE__ */ l.jsx(Ihe, { lang: e, dt: n })
] }) })), bhe = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "日付を選択してください";
      case D.En:
        return "Please select a date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pb-3 ch-pt-7 ch-text-center", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-urgent-400", children: n }) });
}), Che = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックイン";
      case D.En:
        return "Check-in";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), xhe = g(({ lang: e, dt: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), Dhe = g(({ lang: e, cinDt: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(Che, { lang: e }),
  /* @__PURE__ */ l.jsx(xhe, { dt: n, lang: e })
] })), whe = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックアウト";
      case D.En:
        return "Check-out";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), Phe = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "日付を選択してください";
      case D.En:
        return "Please select a date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-leading-5 ch-text-urgent-400", children: n });
}), Rhe = g(({ lang: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(whe, { lang: e }),
  /* @__PURE__ */ l.jsx(Phe, { lang: e })
] })), The = g(({ lang: e, cinDt: n }) => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pt-4 ch-text-center", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-gap-x-6", children: [
  /* @__PURE__ */ l.jsx(Dhe, { lang: e, cinDt: n }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-bold", children: "→" }),
  /* @__PURE__ */ l.jsx(Rhe, { lang: e })
] }) })), jhe = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックイン";
      case D.En:
        return "Check-in";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), Ahe = g(({ lang: e, dt: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), Ohe = g(({ lang: e, cinDt: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(jhe, { lang: e }),
  /* @__PURE__ */ l.jsx(Ahe, { lang: e, dt: n })
] })), Ehe = g(({ lang: e }) => {
  const n = v(() => {
    switch (e) {
      case D.Default:
        return "チェックアウト";
      case D.En:
        return "Check-out";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e]);
  return /* @__PURE__ */ l.jsx("label", { className: "ch-text-sm ch-font-semibold ch-text-gray-400", children: n });
}), Jhe = g(({ lang: e, dt: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), _he = g(({ lang: e, coutDt: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(Ehe, { lang: e }),
  /* @__PURE__ */ l.jsx(Jhe, { lang: e, dt: n })
] })), Qhe = g(({ lang: e, cinDt: n, coutDt: i }) => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-pt-4 ch-text-center", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-gap-x-6", children: [
  /* @__PURE__ */ l.jsx(Ohe, { lang: e, cinDt: n }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-bold", children: "→" }),
  /* @__PURE__ */ l.jsx(_he, { lang: e, coutDt: i })
] }) })), Mhe = g(({ state: e }) => e.kind === "DayTripDtSelected" ? /* @__PURE__ */ l.jsx(yhe, { lang: e.lang, dt: e.dt }) : e.kind === "ReservationCinSelected" ? /* @__PURE__ */ l.jsx(The, { lang: e.lang, cinDt: e.cinDt }) : e.kind === "ReservationCinOutSelected" ? /* @__PURE__ */ l.jsx(Qhe, { lang: e.lang, cinDt: e.cinDt, coutDt: e.coutDt }) : /* @__PURE__ */ l.jsx(bhe, { lang: e.lang })), Lhe = g(({ modelContext: e }) => {
  const { state: n } = phe(e);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-grid", children: [
    /* @__PURE__ */ l.jsx(Mhe, { state: n }),
    /* @__PURE__ */ l.jsx(ghe, { state: n })
  ] });
}), $he = g(({ sessionStateContext: e }) => {
  const n = v(() => {
    switch (e.lang) {
      case D.Default:
        return "日付を選択";
      case D.En:
        return "Select date";
      default:
        throw new Error("Invalid lang code");
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-bold ch-text-black ch-opacity-80", children: n });
}), Uhe = g(({ lang: e }) => v(() => {
  switch (e) {
    case D.Default:
      return "日付(日帰り)";
    case D.En:
      return "Date (Day Trip)";
    default:
      throw new Error("Invalid lang code");
  }
}, [e])), Vhe = g(({ lang: e }) => v(() => {
  switch (e) {
    case D.Default:
      return "日付";
    case D.En:
      return "Date";
    default:
      throw new Error("Invalid lang code");
  }
}, [e])), Hhe = g(({ displayContext: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-light ch-text-black ch-opacity-80", children: e.sessionStateContext.reservationPolicy.isDayTrip ? /* @__PURE__ */ l.jsx(Uhe, { lang: e.sessionStateContext.lang }) : /* @__PURE__ */ l.jsx(Vhe, { lang: e.sessionStateContext.lang }) })), b3 = (e) => !(P(e) || Ke(e)), zhe = (e) => e.sessionStateContext.reservationPolicy.isDayTrip && !P(e.sessionStateContext.currentState.dateInfo) && b3(e.sessionStateContext.currentState.dateInfo.stayStartDt) ? {
  kind: "DayTripSelected",
  dt: e.sessionStateContext.currentState.dateInfo.stayStartDt
} : !P(e.sessionStateContext.currentState.dateInfo) && b3(e.sessionStateContext.currentState.dateInfo.stayStartDt) && b3(e.sessionStateContext.currentState.dateInfo.stayLastDt) ? {
  kind: "ReservationSelected",
  cInDt: e.sessionStateContext.currentState.dateInfo.stayStartDt,
  /**
   * StayLastDt を CheckoutDt へ変換
   */
  cOutDt: Ci({
    date: e.sessionStateContext.currentState.dateInfo.stayLastDt,
    inc: 1
  })
} : {
  kind: "NotSelected",
  lang: e.sessionStateContext.lang
}, Bhe = (e) => ({ state: v(() => zhe(e), [e]) }), qhe = g(({ dt: e }) => v(() => Ne(e, "YYYY年MM月DD日"), [e])), Ghe = g(({ lang: e }) => v(() => {
  switch (e) {
    case D.Default:
      return "未選択";
    case D.En:
      return "Not selected";
    default:
      throw new Error("Invalid lang code");
  }
}, [e])), Whe = g(({ cInDt: e, cOutDt: n }) => v(() => {
  const i = Ne(e, "YYYY年MM月DD日"), t = Ne(n, "YYYY年MM月DD日");
  return `${i} ~ ${t}`;
}, [e, n])), Khe = g((e) => {
  const { state: n } = Bhe(e.modelContext);
  return /* @__PURE__ */ l.jsxs(
    "p",
    {
      className: ce(
        "ch-text-base",
        n.kind !== "NotSelected" ? "ch-text-black ch-opacity-90" : "ch-text-gray-400"
      ),
      children: [
        n.kind === "DayTripSelected" ? /* @__PURE__ */ l.jsx(qhe, { dt: n.dt }) : null,
        n.kind === "ReservationSelected" ? /* @__PURE__ */ l.jsx(Whe, { cInDt: n.cInDt, cOutDt: n.cOutDt }) : null,
        n.kind === "NotSelected" ? /* @__PURE__ */ l.jsx(Ghe, { lang: n.lang }) : null
      ]
    }
  );
}), Yhe = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3 ch-text-left", children: [
  /* @__PURE__ */ l.jsx(
    Hhe,
    {
      displayContext: {
        sessionStateContext: e
      }
    }
  ),
  /* @__PURE__ */ l.jsx(
    Khe,
    {
      modelContext: {
        sessionStateContext: e
      }
    }
  )
] }));
function Xhe(e) {
  const n = Tr();
  return e.isDayTrip ? {
    cinDt: e.stayStartDt,
    coutDt: void 0,
    resetAt: n
  } : P(e.stayStartDt) || P(e.stayLastDt) ? {
    cinDt: e.stayStartDt,
    coutDt: void 0,
    resetAt: n
  } : {
    cinDt: e.stayStartDt,
    /**
     * StayLastDt は宿泊最終日なので +1 日する必要がある
     */
    coutDt: Ci({ date: e.stayLastDt, inc: 1 }),
    resetAt: n
  };
}
const Zhe = (e) => {
  const n = v(() => {
    var d, c, u, k;
    return Xhe({
      isDayTrip: e.sessionStateContext.reservationPolicy.isDayTrip,
      stayStartDt: (c = (d = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : d.stayStartDt) != null ? c : void 0,
      stayLastDt: (k = (u = e.sessionStateContext.currentState.dateInfo) == null ? void 0 : u.stayLastDt) != null ? k : void 0
    });
  }, [e.sessionStateContext]), [i, t] = se(n), a = I(() => {
    t(n);
  }, [n]), s = I(() => {
    t({
      cinDt: void 0,
      coutDt: void 0,
      resetAt: Tr()
    });
  }, []), r = I((d) => {
    t((c) => ({
      ...c,
      cinDt: d,
      coutDt: void 0
    }));
  }, []), o = I((d) => {
    t((c) => ({
      ...c,
      coutDt: d
    }));
  }, []);
  return {
    checkDtState: i,
    onSelectCinDt: r,
    onSelectCoutDt: o,
    onRestoreCheckDt: a,
    onResetCheckDt: s
  };
}, epe = g((e) => {
  const { onRemoveReservationStayDt: n } = vhe(e), i = I(
    (c) => async () => {
      await n().then(() => {
        c();
      });
    },
    [n]
  ), t = I(
    (c) => (u) => async () => {
      await (async () => {
        P(u) || await n();
      })().then(() => {
        c();
      });
    },
    [n]
  ), { checkDtState: a, onSelectCinDt: s, onSelectCoutDt: r, onResetCheckDt: o } = Zhe(e), d = v(() => {
    var c;
    return (c = a.resetAt) != null ? c : "";
  }, [a.resetAt]);
  return /* @__PURE__ */ l.jsx(
    D2,
    {
      trackingTarget: "date",
      triggerSlot: /* @__PURE__ */ l.jsx(Yhe, { ...e }),
      contentContext: {
        titleSlot: /* @__PURE__ */ l.jsx($he, { ...e }),
        bodySlot: /* @__PURE__ */ l.jsx(
          Kh,
          {
            ...e,
            onSelectCinDtCallback: s,
            onSelectCoutDtCallback: r,
            onRemoveReservationStayDt: n
          },
          d
        ),
        footerSlot: ({ onCloseDrawer: c }) => /* @__PURE__ */ l.jsx(
          Lhe,
          {
            modelContext: {
              ...e,
              selectedDtContext: {
                cinDt: a.cinDt,
                coutDt: a.coutDt
              },
              onSubmit: c,
              onResetForDayTripDt: i(o),
              onResetForStayDt: t(o)
            }
          }
        )
      }
    }
  );
});
g(() => /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-animate-pulse ch-space-y-6 ch-rounded ch-border-gray-300 ch-bg-white ch-px-6 ch-py-3", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-h-7 ch-w-28 ch-rounded-md ch-bg-gray-300" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-20 ch-rounded ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-24 ch-rounded ch-bg-gray-200" })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-20 ch-rounded ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-24 ch-rounded ch-bg-gray-200" })
  ] })
] }));
const npe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "人数" : "Guests", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-black", children: n });
}, ipe = ({ sessionStateContext: e }) => {
  const n = v(() => {
    const t = e.currentState.groupInfo.reduce(
      (s, r) => s + r.adultNum,
      0
    ), a = e.currentState.groupInfo.reduce(
      (s, r) => s + r.kidsNum.length,
      0
    );
    return t + a;
  }, [e.currentState.groupInfo]), i = v(() => e.lang === D.Default ? `${n} 名` : `${n} guests`, [e.lang, n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}, tpe = ({ sessionStateContext: e }) => {
  const n = v(() => e.currentState.groupInfo.length, [e.currentState.groupInfo.length]), i = v(() => e.lang === D.Default ? `${n} 部屋` : `${n} rooms`, [e.lang, n]);
  return vs(e) ? null : /* @__PURE__ */ l.jsx("p", { children: i });
}, ape = ({ sessionStateContext: e }) => {
  const n = v(
    () => e.currentState.groupInfo.reduce((t, a) => t + a.adultNum, 0),
    [e.currentState.groupInfo]
  ), i = v(() => e.lang === D.Default ? `大人 ${n} 名` : `${n} adults`, [e.lang, n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}, lpe = (e) => {
  const n = e.sessionStateContext.currentState.groupInfo.reduce(
    (t, a) => t + a.kidsNum.length,
    0
  );
  return n >= 1 ? {
    kind: "Displayable",
    totalChildNum: n
  } : {
    kind: "NotDisplayable"
  };
}, spe = (e) => ({
  state: v(() => lpe(e), [e])
}), rpe = "・", ope = ({ sessionStateContext: e, totalChildNum: n }) => {
  const i = v(() => e.lang === D.Default ? `子ども ${n} 名` : `${n} children`, [e.lang, n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-[1px]", children: [
    /* @__PURE__ */ l.jsx("p", { children: rpe }),
    /* @__PURE__ */ l.jsx("p", { children: i })
  ] });
}, dpe = ({ sessionStateContext: e, modelContext: n }) => {
  const { state: i } = spe(n);
  return i.kind === "Displayable" ? /* @__PURE__ */ l.jsx(ope, { sessionStateContext: e, totalChildNum: i.totalChildNum }) : null;
}, cpe = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-justify-end ch-space-x-3", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-baseline ch-space-x-2 ch-text-base", children: [
    /* @__PURE__ */ l.jsx(tpe, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(ipe, { sessionStateContext: e })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-space-x-[1px] ch-text-xs", children: [
    /* @__PURE__ */ l.jsx(ape, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(
      dpe,
      {
        sessionStateContext: e,
        modelContext: { sessionStateContext: e }
      }
    )
  ] })
] })), upe = g(({ sessionStateContext: e, callbackContext: n }) => {
  const i = v(() => e.lang === D.Default ? "決定する" : "Confirm", [e.lang]), t = I(() => {
    n.onSubmitCallback();
  }, [n]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", onClick: t, children: i });
}), mpe = ({ callbackContext: e, sessionStateContext: n }) => /* @__PURE__ */ l.jsxs("div", { children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-pb-2 ch-pt-4", children: /* @__PURE__ */ l.jsx(cpe, { sessionStateContext: n }) }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-pb-8 ch-pt-4", children: /* @__PURE__ */ l.jsx(upe, { sessionStateContext: n, callbackContext: e }) })
] }), kpe = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx(
  D2,
  {
    trackingTarget: "group",
    triggerSlot: /* @__PURE__ */ l.jsx(H7, { sessionStateContext: e }),
    contentContext: {
      titleSlot: /* @__PURE__ */ l.jsx(npe, { sessionStateContext: e }),
      bodySlot: /* @__PURE__ */ l.jsx(Xh, { sessionStateContext: e }),
      footerSlot: ({ onCloseDrawer: n }) => /* @__PURE__ */ l.jsx(
        mpe,
        {
          sessionStateContext: e,
          callbackContext: { onSubmitCallback: n }
        }
      )
    }
  }
)), fpe = ({ callbackContext: e, sessionStateContext: n }) => {
  const i = v(() => n.lang === D.Default ? "決定する" : "Confirm", [n.lang]), t = v(() => P(n.currentState.planInfo.willReserve), [n.currentState.planInfo.willReserve]), a = I(() => {
    e.onSubmitCallback();
  }, [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-pb-8 ch-pt-4", children: /* @__PURE__ */ l.jsx(ae, { disabled: t, className: "ch-w-full", size: "md", onClick: a, children: i }) });
}, vpe = ({ sessionStateContext: e }) => {
  const n = v(() => !!(e.reservationPolicy.isDayTrip || e.clientContext.planQueryFilter === It.OnlyDayTripPlans), [e.clientContext.planQueryFilter, e.reservationPolicy.isDayTrip]), i = v(() => kn(n ? {
    lang: e.lang,
    i18nString: {
      default: "日帰りプラン",
      en: "Day Trip Plan"
    }
  } : {
    lang: e.lang,
    i18nString: {
      default: "プラン",
      en: "Plan"
    }
  }), [e.lang, n]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-text-black", children: i });
}, hpe = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx(
  D2,
  {
    trackingTarget: "plan",
    triggerSlot: /* @__PURE__ */ l.jsx(z7, { sessionStateContext: e }),
    contentContext: {
      titleSlot: /* @__PURE__ */ l.jsx(vpe, { sessionStateContext: e }),
      bodySlot: /* @__PURE__ */ l.jsx(S2, { sessionStateContext: e }),
      footerSlot: ({ onCloseDrawer: n }) => /* @__PURE__ */ l.jsx(
        fpe,
        {
          sessionStateContext: e,
          callbackContext: { onSubmitCallback: n }
        }
      )
    }
  }
)), ppe = ({ callbackContext: e, sessionStateContext: n }) => {
  const i = v(() => n.lang === D.Default ? "決定する" : "Confirm", [n.lang]), t = I(() => {
    e.onSubmitCallback();
  }, [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-pb-8 ch-pt-4", children: /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", onClick: t, children: i }) });
}, Npe = (e) => e.sessionStateContext.currentState.groupInfo.length >= 2 ? {
  kind: "Displayable",
  roomIdx: e.roomIdx
} : {
  kind: "NotDisplayable"
}, Spe = (e) => ({
  state: v(() => Npe(e), [e])
}), gpe = ({ modelContext: e }) => {
  const { state: n } = Spe(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx("p", { children: n.roomIdx }) : null;
}, Fpe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "お部屋" : "Room", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { children: n });
}, Ipe = ({ roomIdx: e, sessionStateContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1 ch-text-black", children: [
  /* @__PURE__ */ l.jsx(Fpe, { sessionStateContext: n }),
  /* @__PURE__ */ l.jsx(
    gpe,
    {
      modelContext: {
        roomIdx: e,
        sessionStateContext: {
          currentState: { groupInfo: n.currentState.groupInfo }
        }
      }
    }
  )
] }), ype = ({ roomIdx: e, uniqueRoomID: n, sessionStateContext: i }) => /* @__PURE__ */ l.jsx(
  D2,
  {
    trackingTarget: "room",
    isSelectable: i.reserveStatus.isCompleteDate,
    triggerSlot: /* @__PURE__ */ l.jsx(
      B7,
      {
        roomIdx: e,
        uniqueRoomID: n,
        sessionStateContext: i
      }
    ),
    contentContext: {
      titleSlot: /* @__PURE__ */ l.jsx(Ipe, { roomIdx: e, sessionStateContext: i }),
      bodySlot: /* @__PURE__ */ l.jsx(
        np,
        {
          uniqueRoomID: n,
          sessionStateContext: i
        }
      ),
      footerSlot: (t) => /* @__PURE__ */ l.jsx(
        ppe,
        {
          callbackContext: { onSubmitCallback: t.onCloseDrawer },
          sessionStateContext: i
        }
      )
    }
  }
), bpe = (e) => e.sessionStateContext.reservationPolicy.isShowPlanFilter ? {
  kind: "Displayable",
  onUpdatePlanQueryFilterType: e.onUpdatePlanQueryFilterType,
  sessionStateContext: e.sessionStateContext
} : {
  kind: "NotDisplayable"
}, Cpe = (e) => ({
  state: v(() => bpe(e), [e])
}), xpe = (e) => e.sessionStateContext.clientContext.planQueryFilter === e.planQueryFilterSelf ? {
  kind: "Selected",
  sessionStateContext: {
    lang: e.sessionStateContext.lang
  }
} : {
  kind: "NotSelected",
  onUpdatePlanQueryFilterType: e.callbackContext.onUpdatePlanQueryFilterType(e.planQueryFilterSelf),
  sessionStateContext: {
    lang: e.sessionStateContext.lang
  }
}, Dpe = (e) => ({
  state: v(() => xpe(e), [e])
}), op = ({ modelContext: e, buttonI18nText: n }) => {
  const { state: i } = Dpe(e), { onShowLoadingScreenCallback: t, onHideLoadingScreenCallback: a } = fn(), s = I(async () => {
    i.kind === "NotSelected" && (t(), await i.onUpdatePlanQueryFilterType().finally(() => {
      a();
    }));
  }, [a, t, i]);
  return /* @__PURE__ */ l.jsx(
    ae,
    {
      variant: "minimal",
      className: ce(
        "ch-h-12 ch-whitespace-pre-line ch-rounded-none ch-border-b-2 !ch-px-0 !ch-py-0 ch-text-sm ch-font-semibold tablet:ch-h-14",
        i.kind === "Selected" ? "ch-border-b-primary ch-text-black" : "ch-border-b-transparent ch-text-gray-400"
      ),
      onClick: s,
      children: /* @__PURE__ */ l.jsx("p", { children: n })
    }
  );
}, wpe = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = v(() => e.lang === D.Default ? "全てのプラン" : "All Plans", [e.lang]);
  return /* @__PURE__ */ l.jsx(
    op,
    {
      modelContext: {
        planQueryFilterSelf: It.AllPlans,
        callbackContext: n,
        sessionStateContext: e
      },
      buttonI18nText: i
    }
  );
}, Ppe = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = v(() => e.lang === D.Default ? "日帰りプラン" : "Day Use Plans", [e.lang]);
  return /* @__PURE__ */ l.jsx(
    op,
    {
      modelContext: {
        planQueryFilterSelf: It.OnlyDayTripPlans,
        callbackContext: n,
        sessionStateContext: e
      },
      buttonI18nText: i
    }
  );
}, Rpe = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = v(() => e.lang === D.Default ? "宿泊プラン" : "Accommodation Plans", [e.lang]);
  return /* @__PURE__ */ l.jsx(
    op,
    {
      modelContext: {
        planQueryFilterSelf: It.OnlyAccommodationPlans,
        callbackContext: n,
        sessionStateContext: e
      },
      buttonI18nText: i
    }
  );
}, Tpe = ({ state: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-grid-cols-3 ch-gap-x-2 ch-border-b ch-px-5", children: [
  /* @__PURE__ */ l.jsx(
    wpe,
    {
      sessionStateContext: e.sessionStateContext,
      callbackContext: { onUpdatePlanQueryFilterType: e.onUpdatePlanQueryFilterType }
    }
  ),
  /* @__PURE__ */ l.jsx(
    Rpe,
    {
      sessionStateContext: e.sessionStateContext,
      callbackContext: { onUpdatePlanQueryFilterType: e.onUpdatePlanQueryFilterType }
    }
  ),
  /* @__PURE__ */ l.jsx(
    Ppe,
    {
      sessionStateContext: e.sessionStateContext,
      callbackContext: { onUpdatePlanQueryFilterType: e.onUpdatePlanQueryFilterType }
    }
  )
] }), jpe = g((e) => {
  const { state: n } = Cpe(e);
  return n.kind === "Displayable" ? /* @__PURE__ */ l.jsx(Tpe, { state: n }) : null;
}), Ape = Ve(
  /* GraphQL */
  `
	mutation RCPlanSetQueryFilter($baseInfo: BaseInfoInput!, $filterType: PlanQueryFilterType!) {
		planSetQueryFilter(baseInfo: $baseInfo, filterType: $filterType) {
			...ReservationSessionStateFragment
		}
	}
`
), Ope = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(Ape);
  return {
    onUpdatePlanQueryFilterType: I(
      (t) => async () => {
        const { data: a } = await n({
          variables: {
            baseInfo: e.baseInfoInput,
            filterType: t
          }
        });
        e.onUpdateSession(a.planSetQueryFilter), le(
          yn({
            target: "plan_filter",
            action: "update",
            plan_filter: t.toLowerCase()
          })
        );
      },
      [n, e]
    )
  };
}, Epe = g((e) => {
  const { onUpdatePlanQueryFilterType: n } = Ope({
    sessionStateContext: e.sessionStateContext
  });
  return /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-max-w-screen-tablet", children: /* @__PURE__ */ l.jsx(
    jpe,
    {
      ...e,
      onUpdatePlanQueryFilterType: n
    }
  ) });
}), Jpe = g((e) => {
  const n = v(() => e.displayContext.sessionStateContext.reservationPolicy.isShowPlanSelect, [e.displayContext.sessionStateContext.reservationPolicy.isShowPlanSelect]), i = v(() => e.displayContext.sessionStateContext.reservationPolicy.isShowRoomSelect, [e.displayContext.sessionStateContext.reservationPolicy.isShowRoomSelect]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-10", children: [
    /* @__PURE__ */ l.jsx(Epe, { ...e.tabPlanFilterContext }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-px-5", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-divide-y ch-rounded-lg ch-border-[0.5px] ch-border-gray-300", children: [
      n && /* @__PURE__ */ l.jsx(hpe, { ...e.drawerPlanContext }),
      /* @__PURE__ */ l.jsx(kpe, { ...e.drawerGroupContext }),
      /* @__PURE__ */ l.jsx(epe, { ...e.drawerDateContext }),
      i ? e.displayContext.sessionStateContext.currentState.groupInfo.map(
        ({ uniqueRoomID: t }, a) => {
          const s = `select-room-${t}`, r = a + 1;
          return /* @__PURE__ */ l.jsx(
            ype,
            {
              roomIdx: r,
              uniqueRoomID: t,
              ...e.drawerRoomContext
            },
            s
          );
        }
      ) : null,
      /* @__PURE__ */ l.jsx(sp, { ...e.dateTabbedOptionContext })
    ] }) })
  ] });
}), _pe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "予約を進める" : "Next", [e.sessionStateContext.lang]), t = v(() => e.sessionStateContext.reserveStatus.isCompletePlan && e.sessionStateContext.reserveStatus.isCompleteGroup && e.sessionStateContext.reserveStatus.isCompleteDate && e.sessionStateContext.reserveStatus.isCompleteRoom, [
    e.sessionStateContext.reserveStatus.isCompleteDate,
    e.sessionStateContext.reserveStatus.isCompleteGroup,
    e.sessionStateContext.reserveStatus.isCompletePlan,
    e.sessionStateContext.reserveStatus.isCompleteRoom
  ]) && e.sessionStateContext.reserveStatus.isCompleteDateTabbedTimeSelectionOption && (e.sessionStateContext.reserveStatus.isCompleteRequiredOptionGroup || e.sessionStateContext.reservationPolicy.isRequiredOptionGroupSatisfiableWithRegularOption), { reservationCart: a } = Va(), { onNextScreen: s } = e, r = I(() => {
    le(
      jr({
        hotel_name: e.sessionStateContext.hotelName,
        requires_options: e.sessionStateContext.reservationPolicy.isShowOptionSelect
      })
    ), Ar(a).forEach(bt), s();
  }, [
    e.sessionStateContext.hotelName,
    e.sessionStateContext.reservationPolicy.isShowOptionSelect,
    a,
    s
  ]);
  return /* @__PURE__ */ l.jsx(
    gs,
    {
      totalPriceForReservationContext: e,
      nextButtonContext: {
        kind: "HasNextScreen",
        ...e,
        onNextScreen: r,
        buttonText: n,
        canNextScreen: t
      }
    }
  );
}), Qpe = g(({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx("div", { className: "ch-static ch-m-auto ch-flex ch-w-full ch-max-w-screen-tablet ch-items-center ch-justify-center ch-border-b ch-border-zinc-200 ch-px-5 ch-py-1.5 ch-text-center", children: /* @__PURE__ */ l.jsx("p", { className: "ch-line-clamp-3 ch-break-keep ch-text-2xs ch-text-zinc-400", children: e.hotelName }) })), Mpe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "[テスト]予定を立てる" : "[Test]Plan Your Stay", [e.sessionStateContext.lang]);
  return /* @__PURE__ */ l.jsx(Fs, { prevButtonContext: e, titleContext: { titleText: n }, stepIndicatorContext: e });
}), Lpe = g((e) => /* @__PURE__ */ l.jsx(
  Is,
  {
    staticHeaderSlot: /* @__PURE__ */ l.jsx(Qpe, { ...e.headerContext.static }),
    stickyHeaderSlot: /* @__PURE__ */ l.jsx(Mpe, { ...e.headerContext.sticky }),
    bodyContentSlot: /* @__PURE__ */ l.jsx(Jpe, { ...e.bodyContext }),
    footerContentSlot: /* @__PURE__ */ l.jsx(_pe, { ...e.footerContext })
  }
)), $pe = g((e) => /* @__PURE__ */ l.jsx(T7, { ...e })), Upe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "予約を進める" : "Next", [e.sessionStateContext.lang]), i = v(() => e.sessionStateContext.reserveStatus.isCompleteOption && e.sessionStateContext.reserveStatus.isCompleteRequiredOptionGroup, [
    e.sessionStateContext.reserveStatus.isCompleteOption,
    e.sessionStateContext.reserveStatus.isCompleteRequiredOptionGroup
  ]), { onNextScreen: t } = e, a = I(() => {
    le(hC()), t();
  }, [t]);
  return /* @__PURE__ */ l.jsx(
    gs,
    {
      totalPriceForReservationContext: e,
      nextButtonContext: {
        kind: "HasNextScreen",
        ...e,
        onNextScreen: a,
        buttonText: n,
        canNextScreen: i
      }
    }
  );
}), Vpe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "[テスト]オプションを追加する" : "[Test]Add on", [e.sessionStateContext.lang]);
  return /* @__PURE__ */ l.jsx(Fs, { prevButtonContext: e, titleContext: { titleText: n }, stepIndicatorContext: e });
}), Hpe = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), rw = (e) => () => ({
  kind: "Initialized",
  availableOptionList: e.availableOptionList
}), ow = (e) => () => ({
  kind: "Errored",
  lang: e.sessionStateContext.lang,
  onInitialize: e.onInitialize
}), zpe = ({ state: e, onChangeState: n, erroredInputContext: i }) => {
  be(() => {
    e.kind === "NotInitialized" && e.onInitialize().then((t) => {
      n(rw(t)(e));
    }).catch(() => {
      n(ow(i)(e));
    });
  }, [i, n, e]);
}, Bpe = ({ onChangeState: e, erroredInputContext: n }) => ({
  onReInitialize: I(
    (t) => async () => {
      try {
        const a = await t.onInitialize();
        e(rw(a)(t));
      } catch (a) {
        e(ow(n)(t));
      }
    },
    [n, e]
  )
}), qpe = (e) => {
  const [n, i] = se(Hpe(e)), t = I((s) => {
    i(s);
  }, []);
  zpe({ state: n, onChangeState: t, erroredInputContext: e });
  const { onReInitialize: a } = Bpe({ onChangeState: t, erroredInputContext: e });
  return {
    state: n,
    onReInitialize: a
  };
}, Gpe = Ve(
  /* GraphQL */
  `
	query RCScreen2TestInitialize($baseInfo: BaseInfoInput!) {
		optionAvailable(baseInfo: $baseInfo) {
			...SelectOptionAvailableOptionsFragment
		}
	}
`
), Wpe = ({ sessionStateContext: e }) => {
  const { refetch: n } = qn(Gpe, void 0, !0);
  return {
    onInitialize: I(async () => {
      const { data: t } = await n({ baseInfo: e.baseInfoInput });
      return {
        availableOptionList: Kpe(t)
      };
    }, [n, e.baseInfoInput])
  };
}, Kpe = (e) => {
  const { availableOptions: n } = Wu(
    Zh,
    e.optionAvailable
  );
  return n;
}, Ype = (e) => {
  const n = I(async () => {
    le(Pn({ target: "refetch", area: "screen2" })), await e.onRefetch();
  }, [e]), i = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: n, children: i });
}, Xpe = ({ lang: e }) => {
  const n = v(() => e === D.Default ? "データが正しく取得できませんでした。" : "Failed to fetch data.", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, Zpe = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(Xpe, { ...e }),
  /* @__PURE__ */ l.jsx(Ype, { ...e })
] }), eNe = () => /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-max-w-screen-tablet ch-space-y-4 ch-px-5 ch-pt-8", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-aspect-video ch-w-full ch-animate-pulse ch-rounded-xl ch-bg-gray-200" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-[52px] ch-w-5/6 ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5", children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-h-10 ch-w-full ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
      /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-1/4 ch-min-w-20 ch-animate-pulse ch-rounded-md ch-bg-gray-200" })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-11 ch-w-24 ch-animate-pulse ch-rounded-md ch-bg-gray-200" })
  ] })
] }), nNe = g((e) => {
  const { onInitialize: n } = Wpe(e), { state: i, onReInitialize: t } = qpe({ ...e, onInitialize: n });
  return i.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(eNe, {}) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(Zpe, { lang: i.lang, onRefetch: t(i) }) : e.children({ state: i });
}), iNe = g((e) => /* @__PURE__ */ l.jsx("div", { className: "ch-h-full ch-bg-white ch-font-system-ui", children: /* @__PURE__ */ l.jsx(nNe, { ...e.initializerContext, children: ({ state: n }) => {
  const i = n.availableOptionList.filter(
    (t) => !t.isDateTabbedTimeSelectionTarget
  );
  return /* @__PURE__ */ l.jsx(
    Is,
    {
      stickyHeaderSlot: /* @__PURE__ */ l.jsx(Vpe, { ...e.headerContext }),
      bodyContentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
        !e.footerContext.sessionStateContext.reserveStatus.isCompleteRequiredOptionGroup && /* @__PURE__ */ l.jsx("div", { className: "ch-px-5 ch-pt-4", children: /* @__PURE__ */ l.jsx(
          lp,
          {
            lang: e.footerContext.sessionStateContext.lang
          }
        ) }),
        /* @__PURE__ */ l.jsx($pe, { ...e.bodyContext, availableOptions: i })
      ] }),
      footerContentSlot: /* @__PURE__ */ l.jsx(Upe, { ...e.footerContext })
    }
  );
} }) })), tNe = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), dw = (e) => () => ({
  kind: "Initialized",
  hotelInfo: e.hotelInfo,
  availableQuestionAndAnswerList: e.availableQuestionAndAnswerList
}), cw = (e) => () => ({
  kind: "Errored",
  onInitialize: e.onInitialize,
  lang: e.sessionStateContext.lang
}), aNe = ({ state: e, onChangeState: n, erroredInputContext: i }) => {
  be(() => {
    e.kind === "NotInitialized" && e.onInitialize().then((t) => {
      const a = dw(t)(e);
      n(a);
    }).catch(() => {
      const t = cw(i)(e);
      n(t);
    });
  }, [i, n, e]);
}, lNe = ({ onChangeState: e, erroredInputContext: n }) => ({
  onReInitialize: I(
    (t) => async () => {
      try {
        const a = await t.onInitialize(), s = dw(a)(t);
        e(s);
      } catch (a) {
        const s = cw(n)(t);
        e(s);
      }
    },
    [n, e]
  )
}), sNe = (e) => {
  const [n, i] = se(tNe(e)), t = I((s) => {
    i(s);
  }, []);
  aNe({ state: n, onChangeState: t, erroredInputContext: e });
  const { onReInitialize: a } = lNe({ onChangeState: t, erroredInputContext: e });
  return {
    state: n,
    onReInitialize: a
  };
}, rNe = (e) => {
  const n = I(async () => {
    le(Pn({ target: "refetch", area: "screen3" })), await e.onRefetch();
  }, [e]), i = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: n, children: i });
}, oNe = (e) => {
  const n = v(() => e.lang === D.Default ? "データが正しく取得できませんでした。" : "Failed to fetch data.", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, dNe = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(oNe, { ...e }),
  /* @__PURE__ */ l.jsx(rNe, { ...e })
] }), cNe = () => /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-max-w-screen-tablet ch-space-y-6", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-aspect-video ch-w-full ch-animate-pulse ch-bg-gray-200" }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6 ch-px-5 ch-py-8", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-h-7 ch-w-[120px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: Array.from({ length: 3 }).map((e, n) => /* @__PURE__ */ l.jsx(
        "div",
        {
          className: "ch-h-11 ch-w-4/5 ch-min-w-64 ch-animate-pulse ch-rounded-md ch-bg-gray-200"
        },
        n
      )) }),
      /* @__PURE__ */ l.jsxs("div", { children: [
        /* @__PURE__ */ l.jsx("div", { className: "ch-h-8 ch-w-3/4 ch-min-w-60 ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
        /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-space-y-3", children: [
          /* @__PURE__ */ l.jsx("div", { className: "ch-h-6 ch-w-[65px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" }),
          /* @__PURE__ */ l.jsx("div", { className: "ch-h-7 ch-w-[86px] ch-animate-pulse ch-rounded-md ch-bg-gray-200" })
        ] })
      ] })
    ] })
  ] })
] }), uNe = Ve(
  /* GraphQL */
  `
	query RCScreen3TestInitializeQuery($baseInfo: BaseInfoInput!) {
		questionAndAnswerAvailable(baseInfo: $baseInfo) {
			availableQuestionAndAnswers {
				questionID
				isRequired
				questionText
				questionType
				answerChoices
			}
		}
		hotelInfo(baseInfo: $baseInfo) {
			hotelInfo {
				notes {
					title
					description
				}
				keyVisual
			}
		}
	}
`
), mNe = ({ sessionStateContext: e }) => {
  const { refetch: n } = qn(uNe, void 0, !0);
  return {
    onInitialize: I(async () => {
      const { data: t } = await n({ baseInfo: e.baseInfoInput });
      return {
        hotelInfo: t.hotelInfo.hotelInfo,
        availableQuestionAndAnswerList: t.questionAndAnswerAvailable.availableQuestionAndAnswers
      };
    }, [n, e.baseInfoInput])
  };
}, kNe = g((e) => {
  const { onInitialize: n } = mNe(e), { state: i, onReInitialize: t } = sNe({ ...e, onInitialize: n });
  return i.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(cNe, {}) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(dNe, { lang: i.lang, onRefetch: t(i) }) : e.children({ state: i });
}), uw = ({ title: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold ch-text-black", children: e }), fNe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "規約への同意" : "Acceptance of Terms and Conditions", [e.lang]);
  return /* @__PURE__ */ l.jsx(uw, { title: n });
}, vNe = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8 ch-bg-white ch-px-5 ch-py-8", children: [
  /* @__PURE__ */ l.jsx(fNe, { ...e }),
  /* @__PURE__ */ l.jsx(m7, { ...e })
] })), hNe = ({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx(h7, { sessionStateContext: e }), pNe = (e) => /* @__PURE__ */ l.jsx(p7, { ...e }), NNe = g(({ hotelInfo: e }) => /* @__PURE__ */ l.jsx(Nd, { displayContext: { imageUrl: e.keyVisual } })), SNe = g((e) => /* @__PURE__ */ l.jsx(q7, { ...e })), gNe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "ディスカウント・宿泊券 / チケットを適用する" : "Apply discount coupon/accommodation voucher", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold", children: n });
}, FNe = "discount-and-voucher-item", INe = ({ sessionStateContext: e }) => /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, children: /* @__PURE__ */ l.jsxs(it, { value: FNe, borderBottom: !1, children: [
  /* @__PURE__ */ l.jsx(tt, { className: "ch-h-11 ch-gap-x-2 ch-px-0 ch-py-0", hover: !1, children: /* @__PURE__ */ l.jsx(gNe, { sessionStateContext: e }) }),
  /* @__PURE__ */ l.jsxs(at, { className: "ch-h-full ch-space-y-8 ch-px-0 ch-pb-6 ch-pt-2 tablet:ch-px-0 tablet:ch-pb-6 tablet:ch-pt-2", children: [
    /* @__PURE__ */ l.jsx(k7, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(N7, { sessionStateContext: e })
  ] })
] }) }), yNe = Li(({ sessionStateContext: e, ...n }, i) => {
  const t = v(() => e.lang === D.Default ? "内訳を見る" : "Details", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { size: "md", variant: "outline", className: "ch-w-full", ref: i, ...n, children: t });
}), bNe = ({ sessionStateContext: e }) => {
  const { isOpen: n, close: i, handleOpenChange: t } = ks(), a = I(
    (s) => {
      s && le(Pn({ target: "reservation.detail" })), t(s);
    },
    [t]
  );
  return /* @__PURE__ */ l.jsxs(fl, { open: n, onOpenChange: a, children: [
    /* @__PURE__ */ l.jsx(Et, { asChild: !0, children: /* @__PURE__ */ l.jsx(yNe, { sessionStateContext: e }) }),
    /* @__PURE__ */ l.jsxs(
      vl,
      {
        className: "ch-h-full ch-rounded-t-none ch-font-system-ui",
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ l.jsx(yt, { className: "ch-sr-only" }),
          /* @__PURE__ */ l.jsx(
            F2,
            {
              sessionStateContext: e,
              displayContext: {
                headerSectionContext: {
                  leftSlot: /* @__PURE__ */ l.jsx(ae, { size: "icon", variant: "minimal", onClick: i, children: /* @__PURE__ */ l.jsx(Ei, { size: "md" }) })
                }
              }
            }
          )
        ]
      }
    )
  ] });
}, CNe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "予約確認" : "Reservation Information", [e.lang]);
  return /* @__PURE__ */ l.jsx(uw, { title: n });
}, xNe = ({ sessionStateContext: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8 ch-bg-white ch-px-5 ch-py-8", children: [
  /* @__PURE__ */ l.jsx(CNe, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(tp, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(INe, { sessionStateContext: e }),
    /* @__PURE__ */ l.jsx(Y7, { sessionStateContext: e })
  ] }),
  /* @__PURE__ */ l.jsx(K7, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(bNe, { sessionStateContext: e })
] }), DNe = g(({ availableDataContext: e, sessionStateContext: n }) => /* @__PURE__ */ l.jsxs(Xs, { children: [
  /* @__PURE__ */ l.jsx(NNe, { ...e }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-bg-gray-100", children: [
    /* @__PURE__ */ l.jsx(xNe, { sessionStateContext: n }),
    /* @__PURE__ */ l.jsx(hNe, { sessionStateContext: n }),
    /* @__PURE__ */ l.jsx(pNe, { ...e, sessionStateContext: n }),
    /* @__PURE__ */ l.jsx(SNe, { ...e, sessionStateContext: n }),
    /* @__PURE__ */ l.jsx(vNe, { sessionStateContext: n })
  ] })
] })), wNe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "決済方法を選択" : "Continue to payment", [e.sessionStateContext.lang]), i = v(() => e.sessionStateContext.reserveStatus.isCompleteGuestInfo && e.sessionStateContext.reserveStatus.isCompleteQuestionAndAnswer && e.sessionStateContext.reserveStatus.isCompleteAgreementOfTermsOfService, [
    e.sessionStateContext.reserveStatus.isCompleteAgreementOfTermsOfService,
    e.sessionStateContext.reserveStatus.isCompleteGuestInfo,
    e.sessionStateContext.reserveStatus.isCompleteQuestionAndAnswer
  ]), { onNextScreen: t } = e, a = I(() => {
    le(pC()), t();
  }, [t]);
  return /* @__PURE__ */ l.jsx(
    gs,
    {
      totalPriceForReservationContext: e,
      nextButtonContext: {
        kind: "HasNextScreen",
        ...e,
        onNextScreen: a,
        buttonText: n,
        canNextScreen: i
      }
    }
  );
}), PNe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "[テスト]予約内容の確認" : "[Test]Confirmation of reservation details", [e.sessionStateContext.lang]);
  return /* @__PURE__ */ l.jsx(Fs, { prevButtonContext: e, titleContext: { titleText: n }, stepIndicatorContext: e });
}), RNe = g((e) => /* @__PURE__ */ l.jsx("div", { className: "ch-h-full ch-bg-white ch-font-system-ui", children: /* @__PURE__ */ l.jsx(kNe, { ...e.initializerContext, children: ({ state: n }) => /* @__PURE__ */ l.jsx(
  Is,
  {
    stickyHeaderSlot: /* @__PURE__ */ l.jsx(PNe, { ...e.headerContext }),
    bodyContentSlot: /* @__PURE__ */ l.jsx(DNe, { ...e.bodyContext, availableDataContext: n }),
    footerContentSlot: /* @__PURE__ */ l.jsx(wNe, { ...e.footerContext })
  }
) }) })), mw = (e) => () => ({
  kind: "Initialized",
  selectablePaymentMethodList: e.selectablePaymentMethodList
}), TNe = (e) => ({
  kind: "NotInitialized",
  lang: e.sessionStateContext.lang,
  onInitialize: e.onInitialize
}), kw = (e) => () => ({
  kind: "Errored",
  lang: e.sessionStateContext.lang,
  onInitialize: e.onInitialize
}), jNe = ({ state: e, onChangeState: n, erroredInputContext: i }) => {
  const t = I(
    (s) => {
      s.onInitialize().then((r) => {
        if (s.kind === "NotInitialized") {
          const o = mw(r)(s);
          n(o);
        }
      }).catch(() => {
        const r = kw(i)(s);
        n(r);
      });
    },
    [i, n]
  ), a = Ye(!1);
  be(() => {
    a.current || e.kind !== "NotInitialized" || (a.current = !0, t(e));
  }, [t, e]);
}, ANe = ({ onChangeState: e, erroredInputContext: n }) => ({
  onReInitialize: I(
    (t) => async () => {
      try {
        const a = await t.onInitialize(), s = mw(a)(t);
        e(s);
      } catch (a) {
        const s = kw(n)(t);
        e(s);
      }
    },
    [n, e]
  )
}), ONe = (e) => {
  const [n, i] = se(TNe(e)), t = I((s) => {
    i(s);
  }, []);
  jNe({
    state: n,
    onChangeState: t,
    erroredInputContext: e
  });
  const { onReInitialize: a } = ANe({
    onChangeState: t,
    erroredInputContext: e
  });
  return {
    state: n,
    onReInitialize: a
  };
}, ENe = Ve(
  /* GraphQL */
  `
	query RCScreen4TestInitialize($baseInfo: BaseInfoInput!) {
		paymentMethodAvailable(baseInfo: $baseInfo) {
			availableMethods
		}
	}
`
), JNe = ({ sessionStateContext: e }) => {
  const { refetch: n } = qn(ENe, void 0, !0);
  return {
    onInitialize: I(async () => {
      const { data: t } = await n({ baseInfo: e.baseInfoInput });
      return {
        selectablePaymentMethodList: t.paymentMethodAvailable.availableMethods
      };
    }, [n, e.baseInfoInput])
  };
}, _Ne = ({ sessionStateContext: e, callbackContext: n }) => {
  const i = I(async () => {
    le(Pn({ target: "refetch", area: "screen4" })), await n.onRefetchCallback();
  }, [n]), t = v(() => e.lang === D.Default ? "再読み込み" : "Reload", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { onClick: i, children: t });
}, QNe = ({ sessionStateContext: e }) => {
  const n = v(() => e.lang === D.Default ? "選択可能な決済方法が正しく取得できませんでした。" : "Failed to get the available payment methods.", [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-text-urgent-400", children: n });
}, MNe = ({ sessionStateContext: e, callbackContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(QNe, { sessionStateContext: e }),
  /* @__PURE__ */ l.jsx(_Ne, { sessionStateContext: e, callbackContext: n })
] }), LNe = g(() => /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-mt-20 ch-h-fit ch-max-h-80 ch-min-h-80 ch-w-full ch-max-w-screen-tablet ch-animate-pulse ch-rounded-lg ch-bg-gray-200 ch-px-5" })), $Ne = g((e) => {
  const { onInitialize: n } = JNe(e), { state: i, onReInitialize: t } = ONe({ ...e, onInitialize: n });
  return i.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(LNe, {}) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(
    MNe,
    {
      sessionStateContext: { lang: i.lang },
      callbackContext: { onRefetchCallback: t(i) }
    }
  ) : e.children({ state: i });
}), UNe = g((e) => /* @__PURE__ */ l.jsx(kae, { ...e })), VNe = g((e) => /* @__PURE__ */ l.jsx(
  gs,
  {
    totalPriceForReservationContext: e,
    nextButtonContext: { kind: "HasNotNextScreen" }
  }
)), HNe = g((e) => {
  const n = v(() => e.sessionStateContext.lang === D.Default ? "[テスト]支払い" : "[Test]Payment", [e.sessionStateContext.lang]);
  return /* @__PURE__ */ l.jsx(Fs, { prevButtonContext: e, titleContext: { titleText: n }, stepIndicatorContext: e });
}), zNe = g((e) => /* @__PURE__ */ l.jsx("div", { className: "ch-h-full ch-bg-white ch-font-system-ui", children: /* @__PURE__ */ l.jsx($Ne, { ...e.initializerContext, children: ({ state: n }) => /* @__PURE__ */ l.jsx(
  Is,
  {
    stickyHeaderSlot: /* @__PURE__ */ l.jsx(HNe, { ...e.headerContext }),
    bodyContentSlot: /* @__PURE__ */ l.jsx(UNe, { ...e.bodyContext, availableDataContext: n }),
    footerContentSlot: /* @__PURE__ */ l.jsx(VNe, { ...e.footerContext })
  }
) }) })), BNe = g(({ callbackContext: e, libContext: n }) => {
  const i = YX();
  Pd(i.sessionState.lang);
  const { currentScreen: t, onNextScreen: a, onPrevScreen: s, currentStep: r, totalStep: o } = tZ({
    sessionStateContext: i.sessionState
  });
  if (t === "Screen1")
    return /* @__PURE__ */ l.jsx(
      rp,
      {
        headerContext: {
          sticky: {
            sessionStateContext: i.sessionState,
            currentStep: r,
            totalStep: o,
            onPrevScreen: s,
            onCloseScreen: e.onHideCallback
          },
          static: {
            sessionStateContext: i.sessionState
          }
        },
        bodyContext: {
          displayContext: {
            sessionStateContext: i.sessionState
          },
          drawerPlanContext: {
            sessionStateContext: i.sessionState
          },
          drawerGroupContext: {
            sessionStateContext: i.sessionState
          },
          drawerDateContext: {
            sessionStateContext: i.sessionState
          },
          drawerRoomContext: {
            sessionStateContext: i.sessionState
          },
          tabPlanFilterContext: {
            sessionStateContext: i.sessionState
          },
          dateTabbedOptionContext: {
            sessionStateContext: i.sessionState
          }
        },
        footerContext: {
          sessionStateContext: i.sessionState,
          onNextScreen: a
        }
      }
    );
  if (t === "Screen2")
    return /* @__PURE__ */ l.jsx(
      y2,
      {
        initializerContext: {
          sessionStateContext: i.sessionState
        },
        headerContext: {
          sessionStateContext: i.sessionState,
          currentStep: r,
          totalStep: o,
          onPrevScreen: s,
          onCloseScreen: e.onHideCallback
        },
        bodyContext: {
          sessionStateContext: i.sessionState
        },
        footerContext: {
          sessionStateContext: i.sessionState,
          onNextScreen: a
        }
      }
    );
  if (t === "Screen3")
    return /* @__PURE__ */ l.jsx(
      b2,
      {
        initializerContext: {
          sessionStateContext: i.sessionState
        },
        headerContext: {
          sessionStateContext: i.sessionState,
          currentStep: r,
          totalStep: o,
          onPrevScreen: s,
          onCloseScreen: e.onHideCallback
        },
        bodyContext: {
          sessionStateContext: i.sessionState
        },
        footerContext: {
          sessionStateContext: i.sessionState,
          onNextScreen: a
        }
      }
    );
  if (t === "Screen4")
    return /* @__PURE__ */ l.jsx(
      C2,
      {
        initializerContext: {
          sessionStateContext: i.sessionState
        },
        headerContext: {
          sessionStateContext: i.sessionState,
          currentStep: r,
          totalStep: o,
          onPrevScreen: s
        },
        bodyContext: {
          sessionStateContext: i.sessionState,
          callbackContext: e,
          libContext: n
        },
        footerContext: {
          sessionStateContext: i.sessionState
        }
      }
    );
  throw new Error("Invalid current screen.");
}), qNe = ({ initializeContext: e }) => {
  as(() => {
    if (!P(e.hotelPlainSettings))
      return document.documentElement.style.setProperty(
        "--color-primary",
        e.hotelPlainSettings.primaryColor
      ), document.documentElement.style.accentColor = e.hotelPlainSettings.primaryColor, () => {
        document.documentElement.style.setProperty(
          "--color-primary",
          gh.theme.colors.black
        ), document.documentElement.style.accentColor = "auto";
      };
  }, [e.hotelPlainSettings]);
}, GNe = ({ lang: e, resetErrorBoundary: n }) => {
  be(() => {
    const r = new URL(window.location.href);
    for (const o of r.searchParams.keys())
      r.searchParams.delete(o);
    window.history.replaceState({}, "", r.toString());
  }, []);
  const i = I(() => {
    n();
  }, [n]), t = v(() => kn({
    lang: e,
    i18nString: {
      default: "システムエラーが発生しました。",
      en: "A system error has occurred."
    }
  }), [e]), a = v(() => kn({
    lang: e,
    i18nString: {
      default: "時間をおいてからページを再読み込みしてください。",
      en: "Please reload the page after a while."
    }
  }), [e]), s = v(() => kn({
    lang: e,
    i18nString: {
      default: "再読み込み",
      en: "Reload"
    }
  }), [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-h-screen ch-place-content-center ch-place-items-start ch-gap-y-6 ch-px-8 ch-tabular-nums", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-gap-y-2", children: [
      /* @__PURE__ */ l.jsx("h1", { children: t }),
      /* @__PURE__ */ l.jsx("p", { children: a })
    ] }),
    /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full tablet:ch-w-auto", onClick: i, children: s })
  ] });
}, $r = ({ children: e, ...n }) => {
  const i = I((t, a) => {
  }, []);
  return /* @__PURE__ */ l.jsx(
    Nf,
    {
      fallbackRender: (t) => /* @__PURE__ */ l.jsx(GNe, { ...n, ...t }),
      onError: i,
      children: e
    }
  );
}, WNe = (e, n) => n === void 0 ? { uri: e } : {
  uri: e,
  fetch: CC(n)
}, KNe = (e) => LX({ ...e, httpOptions: WNe(e.uri, e.reservationID) }), Ur = ({
  children: e,
  ...n
}) => {
  const i = KNe(n);
  return /* @__PURE__ */ l.jsx(zh, { client: i, children: e });
}, YNe = ({ initializeContext: e, callbackContext: n, libContext: i, envContext: t }) => (Nl({ stage: t.stage, componentType: "full", user: t.user }), qNe({ initializeContext: e }), r1(), Vm({
  hotelID: e.sessionStateContext.hotelID,
  uiType: "full"
}), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx($r, { lang: e.sessionStateContext.lang, children: /* @__PURE__ */ l.jsx(Rd, { children: /* @__PURE__ */ l.jsx(
    rs,
    {
      className: "ch-fixed ch-inset-0 ch-z-[100]",
      slideUp: !0,
      initial: { opacity: 1, transform: "translateY(100%)" },
      animate: { opacity: 1, transform: "translateY(0)" },
      exit: { opacity: 1, transform: "translateY(100%)" },
      children: /* @__PURE__ */ l.jsx(
        Ur,
        {
          ...i.apolloClient,
          lang: e.sessionStateContext.lang,
          reservationID: e.sessionStateContext.reservationID,
          children: /* @__PURE__ */ l.jsx(s1, { children: /* @__PURE__ */ l.jsx(o1, { children: /* @__PURE__ */ l.jsx(
            KX,
            {
              initializeContext: e,
              children: /* @__PURE__ */ l.jsx(
                BNe,
                {
                  callbackContext: n,
                  libContext: i
                },
                e.sessionStateContext.lang
              )
            },
            e.sessionStateContext.lang
          ) }) })
        }
      )
    }
  ) }) }),
  /* @__PURE__ */ l.jsx(l1, {})
] })), XNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Presenter: YNe
}, Symbol.toStringTag, { value: "Module" })), ZNe = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), e4e = () => ({
  kind: "Initialized"
}), n4e = (e) => {
  const { showBoundary: n } = hr(), [i, t] = se(ZNe(e)), a = I((r) => {
    t(r);
  }, []), s = Ye(!1);
  return be(() => {
    s.current || i.kind !== "NotInitialized" || (s.current = !0, i.onInitialize().then(() => {
      const r = e4e();
      a(r);
    }).catch(() => {
      n(new Error());
    }));
  }, [a, e, i, n]), {
    state: i
  };
}, i4e = Ve(
  /* GraphQL */
  `
	query RCIReservationCurrentSessionState($baseInfo: BaseInfoInput!) {
		reservationCurrentSessionState(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), t4e = Ve(
  /* GraphQL */
  `
	query RCIReservationInitialSessionState(
		$hotelId: ID!
		$lang: LangCode!
		$reservationId: ID
		$reservationIdOfReplicationSource: ID
		$optionInfo: SessionInitializeOptionInfoInput
	) {
		reservationInitialSessionState(
			hotelID: $hotelId
			lang: $lang
			reservationID: $reservationId
			reservationIDOfReplicationSource: $reservationIdOfReplicationSource
			optionInfo: $optionInfo
		) {
			...ReservationSessionStateFragment
		}
	}
`
), a4e = ({ sessionStateContext: e }) => {
  const { onUpdateSession: n } = Ji(), { refetch: i } = qn(
    t4e,
    void 0,
    !0
  ), t = v(() => ({
    dateInfo: P(e.cinDt) || P(e.coutDt) ? void 0 : {
      stayStartDt: e.cinDt,
      stayLastDt: La({
        date: e.coutDt,
        amount: 1
      })
    },
    groupInfo: P(e.adultNum) || P(e.kidsNum) ? void 0 : { adultNum: e.adultNum, kidsNum: e.kidsNum },
    planID: e.planID,
    roomID: e.roomID,
    voucherCode: e.voucherCode
  }), [
    e.adultNum,
    e.cinDt,
    e.coutDt,
    e.kidsNum,
    e.planID,
    e.roomID,
    e.voucherCode
  ]);
  return {
    onInitSession: I(async () => {
      const { data: s } = await i({
        hotelId: e.hotelID,
        reservationId: e.reservationID,
        reservationIdOfReplicationSource: e.reservationIDOfReplicationSource,
        lang: e.lang,
        optionInfo: t
      });
      n(s.reservationInitialSessionState), le(
        pl({
          ...ct(
            Ss(s.reservationInitialSessionState)
          ),
          trigger: "init"
        })
      );
    }, [
      i,
      n,
      t,
      e.hotelID,
      e.lang,
      e.reservationID,
      e.reservationIDOfReplicationSource
    ])
  };
}, l4e = ({ sessionStateContext: e }) => {
  const { onUpdateSession: n } = Ji(), { refetch: i } = qn(
    i4e,
    void 0,
    !0
  );
  return {
    onRestoreSession: I(async () => {
      if (!P(e.sessionID) && !P(e.lastUpdatedAt)) {
        const { data: a } = await i({
          baseInfo: {
            hotelID: e.hotelID,
            sessionID: e.sessionID,
            lastUpdatedAt: e.lastUpdatedAt
          }
        });
        n(a.reservationCurrentSessionState), le(
          pl({
            ...ct({
              hotelID: e.hotelID,
              sessionID: e.sessionID
            }),
            trigger: "restore"
          })
        );
      }
    }, [
      i,
      n,
      e.hotelID,
      e.lastUpdatedAt,
      e.sessionID
    ])
  };
}, s4e = ({ sessionStateContext: e }) => {
  const { onInitSession: n } = a4e({ sessionStateContext: e }), { onRestoreSession: i } = l4e({ sessionStateContext: e });
  return {
    onInitialize: I(async () => {
      if (!P(e.sessionID) && !P(e.lastUpdatedAt))
        try {
          await i();
        } catch (a) {
          if (h2(a) && v2(a))
            if (a.extensions.code === "Reservation_SessionNotFound")
              await n();
            else
              throw a;
        }
      else
        await n();
    }, [e.sessionID, e.lastUpdatedAt, i, n])
  };
}, r4e = g(() => /* @__PURE__ */ l.jsx("div", { className: "ch-h-[400px] ch-w-full ch-animate-pulse ch-rounded-lg ch-bg-gray-200" })), o4e = g(({ children: e, initializeContext: n }) => {
  const { onInitialize: i } = s4e(n), { state: t } = n4e({ onInitialize: i });
  return t.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(r4e, {}) : e;
}), d4e = () => {
  const { agreementOfTermsOfService: e } = Od(), { clientContext: n } = Ed(), { dateInfo: i } = Lr(), { discountInfo: t } = Jd(), { groupInfo: a } = _d(), { guestInfo: s } = Qd(), { optionPerDateInfo: r, optionPerReservationInfo: o } = Md(), { planInfo: d } = Ld(), { priceInfo: c } = $d(), { questionAnswerInfo: u } = Ud(), { roomInfo: k } = Vd(), { voucherInfo: m } = Hd(), { baseInfoInput: f } = lt(), { lang: p } = u1(), { hotelName: h } = Td(), { reservationContext: N } = Er(), { reservationPolicy: S } = Ua(), { reserveStatus: F } = m1(), { onUpdateSession: y } = Ji();
  return {
    sessionState: {
      currentState: {
        agreementOfTermsOfService: e,
        dateInfo: i,
        discountInfo: t,
        guestInfo: s,
        groupInfo: a,
        optionPerDateInfo: r,
        optionPerReservationInfo: o,
        planInfo: d,
        questionAnswerInfo: u,
        roomInfo: k,
        voucherInfo: m
      },
      clientContext: n,
      baseInfoInput: f,
      lang: p,
      reservationContext: N,
      reservationPolicy: S,
      priceInfo: c,
      reserveStatus: F,
      hotelName: h,
      onUpdateSession: y
    }
  };
};
function c4e({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === Ce.screen4)
    return 1;
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === Ce.screen0)
      return 0;
    if (e === Ce.screen2)
      return 2;
    if (e === Ce.screen3)
      return 3;
    if (e === Ce.screen4)
      return 4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === Ce.screen0)
      return 0;
    if (e === Ce.screen3)
      return 2;
    if (e === Ce.screen4)
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === Ce.screen2)
      return 1;
    if (e === Ce.screen3)
      return 2;
    if (e === Ce.screen4)
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === Ce.screen3)
      return 1;
    if (e === Ce.screen4)
      return 2;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === Ce.screen0)
      return 0;
    if (e === Ce.screen3)
      return 2;
    if (e === Ce.screen4)
      return 3;
    throw new Error("Invalid current step.");
  }
  if (e === Ce.screen0)
    return 0;
  if (e === Ce.screen2)
    return 2;
  if (e === Ce.screen3)
    return 3;
  if (e === Ce.screen4)
    return 4;
  throw new Error("Invalid current step.");
}
function u4e({
  sessionStateContext: {
    reservationContext: { reservationEditMode: e },
    reservationPolicy: { optionSelectionMode: n },
    clientContext: { reserveFailedReason: i }
  }
}) {
  return e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotAndRegular || e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotOnly ? Ce.screen0 : e === X.EditReservationOptionUpdateOnly && n === Z.RegularOnly ? Ce.screen2 : e === X.EditReservationOptionUpdateOnly && n === Z.None ? Ce.screen3 : e === X.EditReservationCreditCardOnly || i === ml.PaymentFailed ? Ce.screen4 : Ce.screen0;
}
function m4e({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === Ce.screen4)
    throw new Error("Invalid current screen.");
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === Ce.screen0)
      return Ce.screen2;
    if (e === Ce.screen2)
      return Ce.screen3;
    if (e === Ce.screen3)
      return Ce.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === Ce.screen0)
      return Ce.screen3;
    if (e === Ce.screen3)
      return Ce.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === Ce.screen2)
      return Ce.screen3;
    if (e === Ce.screen3)
      return Ce.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === Ce.screen3)
      return Ce.screen4;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === Ce.screen0)
      return Ce.screen3;
    if (e === Ce.screen3)
      return Ce.screen4;
    throw new Error("Invalid current screen.");
  }
  if (e === Ce.screen0)
    return Ce.screen2;
  if (e === Ce.screen2)
    return Ce.screen3;
  if (e === Ce.screen3)
    return Ce.screen4;
  throw new Error("Invalid current screen.");
}
function k4e({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === Ce.screen4)
    throw new Error("Invalid current screen.");
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === Ce.screen4)
      return Ce.screen3;
    if (e === Ce.screen3)
      return Ce.screen2;
    if (e === Ce.screen2)
      return Ce.screen0;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === Ce.screen4)
      return Ce.screen3;
    if (e === Ce.screen3)
      return Ce.screen0;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === Ce.screen4)
      return Ce.screen3;
    if (e === Ce.screen3)
      return Ce.screen2;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === Ce.screen4)
      return Ce.screen3;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === Ce.screen4)
      return Ce.screen3;
    if (e === Ce.screen3)
      return Ce.screen0;
    throw new Error("Invalid current screen.");
  }
  if (e === Ce.screen4)
    return Ce.screen3;
  if (e === Ce.screen3)
    return Ce.screen2;
  if (e === Ce.screen2)
    return Ce.screen0;
  throw new Error("Invalid current screen.");
}
function f4e({
  sessionStateContext: {
    reservationContext: { reservationEditMode: e },
    reservationPolicy: { optionSelectionMode: n }
  }
}) {
  return e === X.EditReservationAuthorizedFailed || e === X.EditReservationCreditCardOnly ? 1 : e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotAndRegular ? 4 : e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotOnly || e === X.EditReservationOptionUpdateOnly && n === Z.RegularOnly ? 3 : e === X.EditReservationOptionUpdateOnly && n === Z.None ? 2 : n === Z.TimeSlotOnly || n === Z.None ? 3 : 4;
}
const Ce = {
  screen0: "Screen0",
  // Inline を Screen0 として解釈する
  screen2: "Screen2",
  screen3: "Screen3",
  screen4: "Screen4"
}, x9 = {
  Screen0: "entry",
  Screen2: "option",
  Screen3: "guest_info",
  Screen4: "payment"
}, v4e = ({ sessionStateContext: e }) => {
  const [n, i] = se(
    u4e({ sessionStateContext: e })
  ), t = I(() => {
    const o = m4e({ currentScreen: n, sessionStateContext: e });
    i(o), le(
      Ja({
        reservation_component_ui_type: "inline",
        screen: x9[o],
        direction: "next"
      })
    );
  }, [n, e]), a = I(() => {
    const o = k4e({ currentScreen: n, sessionStateContext: e });
    i(o), le(
      Ja({
        reservation_component_ui_type: "inline",
        screen: x9[o],
        direction: "prev"
      })
    );
  }, [n, e]), s = v(() => c4e({ currentScreen: n, sessionStateContext: e }), [n, e]), r = v(() => f4e({ sessionStateContext: e }), [e]);
  return {
    currentScreen: n,
    onNextScreen: t,
    onPrevScreen: a,
    currentStep: s,
    totalStep: r
  };
}, h4e = g(({ callbackContext: e, libContext: n }) => {
  const i = d4e();
  Pd(i.sessionState.lang);
  const { currentScreen: t, onNextScreen: a, onPrevScreen: s, currentStep: r, totalStep: o } = v4e({
    sessionStateContext: i.sessionState
  });
  return r1(t !== "Screen0"), t === "Screen0" ? /* @__PURE__ */ l.jsx(
    che,
    {
      displayContext: {
        sessionStateContext: i.sessionState
      },
      drawerPlanContext: {
        sessionStateContext: i.sessionState
      },
      drawerGroupContext: {
        sessionStateContext: i.sessionState
      },
      drawerDateContext: {
        sessionStateContext: i.sessionState
      },
      drawerRoomContext: {
        sessionStateContext: i.sessionState
      },
      dateTabbedOptionContext: {
        sessionStateContext: i.sessionState
      },
      footerContext: {
        sessionStateContext: i.sessionState,
        onNextScreen: a
      }
    }
  ) : /* @__PURE__ */ l.jsxs(
    rs,
    {
      className: "ch-fixed ch-inset-0 ch-z-[100]",
      slideUp: !0,
      initial: { opacity: 1, transform: "translateY(100%)" },
      animate: { opacity: 1, transform: "translateY(0)" },
      exit: { opacity: 1, transform: "translateY(100%)" },
      children: [
        t === "Screen2" ? /* @__PURE__ */ l.jsx(
          y2,
          {
            initializerContext: {
              sessionStateContext: i.sessionState
            },
            headerContext: {
              sessionStateContext: i.sessionState,
              currentStep: r,
              totalStep: o,
              onPrevScreen: s
            },
            bodyContext: {
              sessionStateContext: i.sessionState
            },
            footerContext: {
              sessionStateContext: i.sessionState,
              onNextScreen: a
            }
          }
        ) : null,
        t === "Screen3" ? /* @__PURE__ */ l.jsx(
          b2,
          {
            initializerContext: {
              sessionStateContext: i.sessionState
            },
            headerContext: {
              sessionStateContext: i.sessionState,
              currentStep: r,
              totalStep: o,
              onPrevScreen: s
            },
            bodyContext: {
              sessionStateContext: i.sessionState
            },
            footerContext: {
              sessionStateContext: i.sessionState,
              onNextScreen: a
            }
          }
        ) : null,
        t === "Screen4" ? /* @__PURE__ */ l.jsx(
          C2,
          {
            initializerContext: {
              sessionStateContext: i.sessionState
            },
            headerContext: {
              sessionStateContext: i.sessionState,
              currentStep: r,
              totalStep: o,
              onPrevScreen: s
            },
            bodyContext: {
              sessionStateContext: i.sessionState,
              libContext: n,
              callbackContext: e
            },
            footerContext: {
              sessionStateContext: i.sessionState
            }
          }
        ) : null
      ]
    }
  );
}), p4e = ({ initializeContext: e }) => {
  as(() => (document.documentElement.style.setProperty(
    "--color-primary",
    e.hotelPlainSettings.primaryColor
  ), document.documentElement.style.accentColor = e.hotelPlainSettings.primaryColor, () => {
    document.documentElement.style.setProperty(
      "--color-primary",
      gh.theme.colors.black
    ), document.documentElement.style.accentColor = "auto";
  }), [e.hotelPlainSettings.primaryColor]);
}, N4e = ({ initializeContext: e, callbackContext: n, libContext: i, envContext: t }) => (Nl({
  stage: t.stage,
  user: t.user,
  componentType: "inline"
}), p4e({ initializeContext: e }), Vm({
  hotelID: e.sessionStateContext.hotelID,
  uiType: "inline"
}), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx($r, { lang: e.sessionStateContext.lang, children: /* @__PURE__ */ l.jsx(Rd, { children: /* @__PURE__ */ l.jsx(
    Ur,
    {
      ...i.apolloClient,
      lang: e.sessionStateContext.lang,
      reservationID: e.sessionStateContext.reservationID,
      children: /* @__PURE__ */ l.jsx(s1, { children: /* @__PURE__ */ l.jsx(o1, { children: /* @__PURE__ */ l.jsx(
        o4e,
        {
          initializeContext: e,
          children: /* @__PURE__ */ l.jsx(h4e, { callbackContext: n, libContext: i })
        },
        e.sessionStateContext.lang
      ) }) })
    }
  ) }) }),
  /* @__PURE__ */ l.jsx(l1, {})
] })), S4e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Presenter: N4e
}, Symbol.toStringTag, { value: "Module" })), g4e = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), F4e = () => ({
  kind: "Initialized"
}), I4e = (e) => {
  const { showBoundary: n } = hr(), [i, t] = se(g4e(e)), a = I((r) => {
    t(r);
  }, []), s = Ye(!1);
  return be(() => {
    s.current || i.kind !== "NotInitialized" || (s.current = !0, i.onInitialize().then(() => {
      const r = F4e();
      a(r);
    }).catch(() => {
      n(new Error());
    }));
  }, [a, e, i, n]), {
    state: i
  };
}, y4e = Ve(
  /* GraphQL */
  `
	query RCICReservationCurrentSessionState($baseInfo: BaseInfoInput!) {
		reservationCurrentSessionState(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), b4e = Ve(
  /* GraphQL */
  `
	query RCICReservationInitialSessionState(
		$hotelId: ID!
		$lang: LangCode!
		$reservationId: ID
		$reservationIdOfReplicationSource: ID
		$optionInfo: SessionInitializeOptionInfoInput
	) {
		reservationInitialSessionState(
			hotelID: $hotelId
			lang: $lang
			reservationID: $reservationId
			reservationIDOfReplicationSource: $reservationIdOfReplicationSource
			optionInfo: $optionInfo
		) {
			...ReservationSessionStateFragment
		}
	}
`
), C4e = ({ sessionStateContext: e }) => {
  const { onUpdateSession: n } = Ji(), { refetch: i } = qn(
    b4e,
    void 0,
    !0
  ), t = v(() => ({
    dateInfo: P(e.cinDt) || P(e.coutDt) ? void 0 : {
      stayStartDt: e.cinDt,
      stayLastDt: La({
        date: e.coutDt,
        amount: 1
      })
    },
    groupInfo: P(e.adultNum) || P(e.kidsNum) ? void 0 : { adultNum: e.adultNum, kidsNum: e.kidsNum },
    planID: e.planID,
    roomID: e.roomID,
    voucherCode: e.voucherCode
  }), [
    e.adultNum,
    e.cinDt,
    e.coutDt,
    e.kidsNum,
    e.planID,
    e.roomID,
    e.voucherCode
  ]);
  return {
    onInitSession: I(async () => {
      const { data: s } = await i({
        hotelId: e.hotelID,
        reservationId: e.reservationID,
        reservationIdOfReplicationSource: e.reservationIDOfReplicationSource,
        lang: e.lang,
        optionInfo: t
      });
      n(s.reservationInitialSessionState), le(
        pl({
          ...ct(
            Ss(s.reservationInitialSessionState)
          ),
          trigger: "init"
        })
      );
    }, [
      i,
      n,
      t,
      e.hotelID,
      e.lang,
      e.reservationID,
      e.reservationIDOfReplicationSource
    ])
  };
}, x4e = ({ sessionStateContext: e }) => {
  const { onUpdateSession: n } = Ji(), { refetch: i } = qn(
    y4e,
    void 0,
    !0
  );
  return {
    onRestoreSession: I(async () => {
      if (!P(e.sessionID) && !P(e.lastUpdatedAt)) {
        const { data: a } = await i({
          baseInfo: {
            hotelID: e.hotelID,
            sessionID: e.sessionID,
            lastUpdatedAt: e.lastUpdatedAt
          }
        });
        n(a.reservationCurrentSessionState), le(
          pl({
            ...ct({
              hotelID: e.hotelID,
              sessionID: e.sessionID
            }),
            trigger: "restore"
          })
        );
      }
    }, [
      i,
      n,
      e.hotelID,
      e.lastUpdatedAt,
      e.sessionID
    ])
  };
}, D4e = ({ sessionStateContext: e }) => {
  const { onInitSession: n } = C4e({ sessionStateContext: e }), { onRestoreSession: i } = x4e({ sessionStateContext: e });
  return {
    onInitialize: I(async () => {
      if (!P(e.sessionID) && !P(e.lastUpdatedAt))
        try {
          await i();
        } catch (a) {
          if (h2(a) && v2(a))
            if (a.extensions.code === "Reservation_SessionNotFound")
              await n();
            else
              throw a;
        }
      else
        await n();
    }, [e.sessionID, e.lastUpdatedAt, i, n])
  };
}, w4e = g(() => /* @__PURE__ */ l.jsx("div", { className: "ch-h-[500px] ch-w-full ch-animate-pulse ch-rounded-lg ch-bg-gray-200" })), P4e = g(({ children: e, initializeContext: n }) => {
  const { onInitialize: i } = D4e(n), { state: t } = I4e({ onInitialize: i });
  return t.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(w4e, {}) : e;
}), R4e = () => {
  const { agreementOfTermsOfService: e } = Od(), { clientContext: n } = Ed(), { dateInfo: i } = Lr(), { discountInfo: t } = Jd(), { groupInfo: a } = _d(), { guestInfo: s } = Qd(), { optionPerDateInfo: r, optionPerReservationInfo: o } = Md(), { planInfo: d } = Ld(), { priceInfo: c } = $d(), { questionAnswerInfo: u } = Ud(), { roomInfo: k } = Vd(), { voucherInfo: m } = Hd(), { baseInfoInput: f } = lt(), { lang: p } = u1(), { hotelName: h } = Td(), { reservationContext: N } = Er(), { reservationPolicy: S } = Ua(), { reserveStatus: F } = m1(), { onUpdateSession: y } = Ji();
  return {
    sessionState: {
      currentState: {
        agreementOfTermsOfService: e,
        dateInfo: i,
        discountInfo: t,
        guestInfo: s,
        groupInfo: a,
        optionPerDateInfo: r,
        optionPerReservationInfo: o,
        planInfo: d,
        questionAnswerInfo: u,
        roomInfo: k,
        voucherInfo: m
      },
      clientContext: n,
      baseInfoInput: f,
      lang: p,
      reservationContext: N,
      reservationPolicy: S,
      priceInfo: c,
      reserveStatus: F,
      hotelName: h,
      onUpdateSession: y
    }
  };
};
function T4e({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === pe.screen4)
    return 1;
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === pe.screen1)
      return 1;
    if (e === pe.screen2)
      return 2;
    if (e === pe.screen3)
      return 3;
    if (e === pe.screen4)
      return 4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === pe.screen1)
      return 1;
    if (e === pe.screen3)
      return 2;
    if (e === pe.screen4)
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === pe.screen2)
      return 1;
    if (e === pe.screen3)
      return 2;
    if (e === pe.screen4)
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === pe.screen3)
      return 1;
    if (e === pe.screen4)
      return 2;
    throw new Error("Invalid current screen.");
  }
  if (e === pe.screen0)
    return 0;
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === pe.screen1)
      return 1;
    if (e === pe.screen3)
      return 2;
    if (e === pe.screen4)
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (e === pe.screen1)
    return 1;
  if (e === pe.screen2)
    return 2;
  if (e === pe.screen3)
    return 3;
  if (e === pe.screen4)
    return 4;
  throw new Error("Invalid current screen.");
}
function j4e({
  sessionStateContext: {
    reservationContext: { reservationEditMode: e },
    reservationPolicy: { optionSelectionMode: n },
    clientContext: { reserveFailedReason: i }
  }
}) {
  return e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotAndRegular || e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotOnly ? pe.screen1 : e === X.EditReservationOptionUpdateOnly && n === Z.RegularOnly ? pe.screen2 : e === X.EditReservationOptionUpdateOnly && n === Z.None ? pe.screen3 : e === X.EditReservationCreditCardOnly || i === ml.PaymentFailed ? pe.screen4 : pe.screen0;
}
function A4e({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === pe.screen4)
    throw new Error("Invalid current screen.");
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === pe.screen1)
      return pe.screen2;
    if (e === pe.screen2)
      return pe.screen3;
    if (e === pe.screen3)
      return pe.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === pe.screen1)
      return pe.screen3;
    if (e === pe.screen3)
      return pe.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === pe.screen2)
      return pe.screen3;
    if (e === pe.screen3)
      return pe.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === pe.screen3)
      return pe.screen4;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === pe.screen0)
      return pe.screen1;
    if (e === pe.screen1)
      return pe.screen3;
    if (e === pe.screen3)
      return pe.screen4;
    throw new Error("Invalid current screen.");
  }
  if (e === pe.screen0)
    return pe.screen1;
  if (e === pe.screen1)
    return pe.screen2;
  if (e === pe.screen2)
    return pe.screen3;
  if (e === pe.screen3)
    return pe.screen4;
  throw new Error("Invalid current screen.");
}
function O4e({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === pe.screen4)
    throw new Error("Invalid current screen.");
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === pe.screen4)
      return pe.screen3;
    if (e === pe.screen3)
      return pe.screen2;
    if (e === pe.screen2)
      return pe.screen1;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === pe.screen4)
      return pe.screen3;
    if (e === pe.screen3)
      return pe.screen1;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === pe.screen4)
      return pe.screen3;
    if (e === pe.screen3)
      return pe.screen2;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === pe.screen4)
      return pe.screen3;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === pe.screen4)
      return pe.screen3;
    if (e === pe.screen3)
      return pe.screen1;
    if (e === pe.screen1)
      return pe.screen0;
    throw new Error("Invalid current screen.");
  }
  if (e === pe.screen4)
    return pe.screen3;
  if (e === pe.screen3)
    return pe.screen2;
  if (e === pe.screen2)
    return pe.screen1;
  if (e === pe.screen1)
    return pe.screen0;
  throw new Error("Invalid current screen.");
}
function E4e({
  currentScreen: e,
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  return n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly ? 1 : n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular ? 4 : n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly || n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly ? 3 : n === X.EditReservationOptionUpdateOnly && i === Z.None ? 2 : e === pe.screen0 ? 0 : i === Z.TimeSlotOnly || i === Z.None ? 3 : 4;
}
const pe = {
  screen0: "Screen0",
  screen1: "Screen1",
  screen2: "Screen2",
  screen3: "Screen3",
  screen4: "Screen4"
}, D9 = {
  Screen0: "entry",
  Screen1: "selection",
  Screen2: "option",
  Screen3: "guest_info",
  Screen4: "payment"
}, J4e = (e) => {
  const [n, i] = se(j4e(e)), t = I(() => {
    const o = A4e({ currentScreen: n, ...e });
    i(o), le(
      Ja({
        reservation_component_ui_type: "inline_calendar",
        screen: D9[o],
        direction: "next"
      })
    );
  }, [n, e]), a = I(() => {
    const o = O4e({ currentScreen: n, ...e });
    i(o), le(
      Ja({
        reservation_component_ui_type: "inline_calendar",
        screen: D9[o],
        direction: "prev"
      })
    );
  }, [n, e]), s = v(() => T4e({ currentScreen: n, ...e }), [n, e]), r = v(() => E4e({ currentScreen: n, ...e }), [n, e]);
  return {
    currentScreen: n,
    onNextScreen: t,
    onPrevScreen: a,
    currentStep: s,
    totalStep: r
  };
}, _4e = g(({ callbackContext: e, libContext: n }) => {
  const i = R4e();
  Pd(i.sessionState.lang);
  const { currentScreen: t, onNextScreen: a, onPrevScreen: s, currentStep: r, totalStep: o } = J4e({
    sessionStateContext: i.sessionState
  });
  return r1(t !== "Screen0"), t === "Screen0" ? /* @__PURE__ */ l.jsx(
    Yfe,
    {
      footerContext: {
        sessionStateContext: i.sessionState,
        onNextScreen: a
      }
    }
  ) : /* @__PURE__ */ l.jsx(
    rs,
    {
      className: "ch-fixed ch-inset-0 ch-z-[100]",
      slideUp: !0,
      initial: { opacity: 1, transform: "translateY(100%)" },
      animate: { opacity: 1, transform: "translateY(0)" },
      exit: { opacity: 1, transform: "translateY(100%)" },
      children: /* @__PURE__ */ l.jsxs(Xs, { children: [
        t === "Screen1" ? /* @__PURE__ */ l.jsx(
          rp,
          {
            headerContext: {
              sticky: {
                sessionStateContext: i.sessionState,
                currentStep: r,
                totalStep: o,
                onPrevScreen: s,
                onCloseScreen: s
              },
              static: {
                sessionStateContext: i.sessionState
              }
            },
            bodyContext: {
              displayContext: {
                sessionStateContext: i.sessionState
              },
              drawerPlanContext: {
                sessionStateContext: i.sessionState
              },
              drawerGroupContext: {
                sessionStateContext: i.sessionState
              },
              drawerDateContext: {
                sessionStateContext: i.sessionState
              },
              drawerRoomContext: {
                sessionStateContext: i.sessionState
              },
              tabPlanFilterContext: {
                sessionStateContext: i.sessionState
              },
              dateTabbedOptionContext: {
                sessionStateContext: i.sessionState
              }
            },
            footerContext: {
              sessionStateContext: i.sessionState,
              onNextScreen: a
            }
          }
        ) : null,
        t === "Screen2" ? /* @__PURE__ */ l.jsx(
          y2,
          {
            initializerContext: {
              sessionStateContext: i.sessionState
            },
            headerContext: {
              sessionStateContext: i.sessionState,
              currentStep: r,
              totalStep: o,
              onPrevScreen: s
            },
            bodyContext: {
              sessionStateContext: i.sessionState
            },
            footerContext: {
              sessionStateContext: i.sessionState,
              onNextScreen: a
            }
          }
        ) : null,
        t === "Screen3" ? /* @__PURE__ */ l.jsx(
          b2,
          {
            initializerContext: {
              sessionStateContext: i.sessionState
            },
            headerContext: {
              sessionStateContext: i.sessionState,
              currentStep: r,
              totalStep: o,
              onPrevScreen: s
            },
            bodyContext: {
              sessionStateContext: i.sessionState
            },
            footerContext: {
              sessionStateContext: i.sessionState,
              onNextScreen: a
            }
          }
        ) : null,
        t === "Screen4" ? /* @__PURE__ */ l.jsx(
          C2,
          {
            initializerContext: {
              sessionStateContext: i.sessionState
            },
            headerContext: {
              sessionStateContext: i.sessionState,
              currentStep: r,
              totalStep: o,
              onPrevScreen: s
            },
            bodyContext: {
              sessionStateContext: i.sessionState,
              libContext: n,
              callbackContext: e
            },
            footerContext: {
              sessionStateContext: i.sessionState
            }
          }
        ) : null
      ] })
    }
  );
}), Q4e = ({ initializeContext: e }) => {
  as(() => (document.documentElement.style.setProperty(
    "--color-primary",
    e.hotelPlainSettings.primaryColor
  ), document.documentElement.style.accentColor = e.hotelPlainSettings.primaryColor, () => {
    document.documentElement.style.setProperty(
      "--color-primary",
      gh.theme.colors.black
    ), document.documentElement.style.accentColor = "auto";
  }), [e.hotelPlainSettings.primaryColor]);
}, M4e = ({ initializeContext: e, callbackContext: n, libContext: i, envContext: t }) => (Nl({
  stage: t.stage,
  user: t.user,
  componentType: "inline-calendar"
}), Q4e({ initializeContext: e }), Vm({
  hotelID: e.sessionStateContext.hotelID,
  uiType: "inline_calendar"
}), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx($r, { lang: e.sessionStateContext.lang, children: /* @__PURE__ */ l.jsx(Rd, { children: /* @__PURE__ */ l.jsx(
    Ur,
    {
      ...i.apolloClient,
      lang: e.sessionStateContext.lang,
      reservationID: e.sessionStateContext.reservationID,
      children: /* @__PURE__ */ l.jsx(s1, { children: /* @__PURE__ */ l.jsx(o1, { children: /* @__PURE__ */ l.jsx(
        P4e,
        {
          initializeContext: e,
          children: /* @__PURE__ */ l.jsx(_4e, { callbackContext: n, libContext: i })
        },
        e.sessionStateContext.lang
      ) }) })
    }
  ) }) }),
  /* @__PURE__ */ l.jsx(l1, {})
] })), L4e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Presenter: M4e
}, Symbol.toStringTag, { value: "Module" })), $4e = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), U4e = () => ({
  kind: "Initialized"
}), V4e = (e) => {
  const { showBoundary: n } = hr(), [i, t] = se($4e(e)), a = I((r) => {
    t(r);
  }, []), s = Ye(!1);
  return be(() => {
    s.current || i.kind !== "NotInitialized" || (s.current = !0, i.onInitialize().then(() => {
      const r = U4e();
      a(r);
    }).catch(() => {
      n(new Error());
    }));
  }, [a, e, i, n]), {
    state: i
  };
}, H4e = Ve(
  /* GraphQL */
  `
	query RCICReservationCurrentSessionState($baseInfo: BaseInfoInput!) {
		reservationCurrentSessionState(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), z4e = Ve(
  /* GraphQL */
  `
	query RCICReservationInitialSessionState(
		$hotelId: ID!
		$lang: LangCode!
		$reservationId: ID
		$reservationIdOfReplicationSource: ID
		$optionInfo: SessionInitializeOptionInfoInput
	) {
		reservationInitialSessionState(
			hotelID: $hotelId
			lang: $lang
			reservationID: $reservationId
			reservationIDOfReplicationSource: $reservationIdOfReplicationSource
			optionInfo: $optionInfo
		) {
			...ReservationSessionStateFragment
		}
	}
`
), B4e = ({ sessionStateContext: e }) => {
  const { onUpdateSession: n } = Ji(), { refetch: i } = qn(
    z4e,
    void 0,
    !0
  ), t = v(() => ({
    dateInfo: P(e.cinDt) || P(e.coutDt) ? void 0 : {
      stayStartDt: e.cinDt,
      stayLastDt: La({
        date: e.coutDt,
        amount: 1
      })
    },
    groupInfo: P(e.adultNum) || P(e.kidsNum) ? void 0 : { adultNum: e.adultNum, kidsNum: e.kidsNum },
    planID: e.planID,
    roomID: e.roomID,
    voucherCode: e.voucherCode
  }), [
    e.adultNum,
    e.cinDt,
    e.coutDt,
    e.kidsNum,
    e.planID,
    e.roomID,
    e.voucherCode
  ]);
  return {
    onInitSession: I(async () => {
      const { data: s } = await i({
        hotelId: e.hotelID,
        reservationId: e.reservationID,
        reservationIdOfReplicationSource: e.reservationIDOfReplicationSource,
        lang: e.lang,
        optionInfo: t
      });
      n(s.reservationInitialSessionState), le(
        pl({
          ...ct(
            Ss(s.reservationInitialSessionState)
          ),
          trigger: "init"
        })
      );
    }, [
      i,
      n,
      t,
      e.hotelID,
      e.lang,
      e.reservationID,
      e.reservationIDOfReplicationSource
    ])
  };
}, q4e = ({ sessionStateContext: e }) => {
  const { onUpdateSession: n } = Ji(), { refetch: i } = qn(
    H4e,
    void 0,
    !0
  );
  return {
    onRestoreSession: I(async () => {
      if (!P(e.sessionID) && !P(e.lastUpdatedAt)) {
        const { data: a } = await i({
          baseInfo: {
            hotelID: e.hotelID,
            sessionID: e.sessionID,
            lastUpdatedAt: e.lastUpdatedAt
          }
        });
        n(a.reservationCurrentSessionState), le(
          pl({
            ...ct({
              hotelID: e.hotelID,
              sessionID: e.sessionID
            }),
            trigger: "restore"
          })
        );
      }
    }, [
      i,
      n,
      e.hotelID,
      e.lastUpdatedAt,
      e.sessionID
    ])
  };
}, G4e = ({ sessionStateContext: e }) => {
  const { onInitSession: n } = B4e({ sessionStateContext: e }), { onRestoreSession: i } = q4e({ sessionStateContext: e });
  return {
    onInitialize: I(async () => {
      if (!P(e.sessionID) && !P(e.lastUpdatedAt))
        try {
          await i();
        } catch (a) {
          if (h2(a) && v2(a))
            if (a.extensions.code === "Reservation_SessionNotFound")
              await n();
            else
              throw a;
        }
      else
        await n();
    }, [e.sessionID, e.lastUpdatedAt, i, n])
  };
}, W4e = g(() => /* @__PURE__ */ l.jsx("div", { className: "ch-h-[500px] ch-w-full ch-animate-pulse ch-rounded-lg ch-bg-gray-200" })), K4e = g(({ children: e, initializeContext: n }) => {
  const { onInitialize: i } = G4e(n), { state: t } = V4e({ onInitialize: i });
  return t.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(W4e, {}) : e;
}), Y4e = () => {
  const { agreementOfTermsOfService: e } = Od(), { clientContext: n } = Ed(), { dateInfo: i } = Lr(), { discountInfo: t } = Jd(), { groupInfo: a } = _d(), { guestInfo: s } = Qd(), { optionPerDateInfo: r, optionPerReservationInfo: o } = Md(), { planInfo: d } = Ld(), { priceInfo: c } = $d(), { questionAnswerInfo: u } = Ud(), { roomInfo: k } = Vd(), { voucherInfo: m } = Hd(), { baseInfoInput: f } = lt(), { lang: p } = u1(), { hotelName: h } = Td(), { reservationContext: N } = Er(), { reservationPolicy: S } = Ua(), { reserveStatus: F } = m1(), { onUpdateSession: y } = Ji();
  return {
    sessionState: {
      currentState: {
        agreementOfTermsOfService: e,
        dateInfo: i,
        discountInfo: t,
        guestInfo: s,
        groupInfo: a,
        optionPerDateInfo: r,
        optionPerReservationInfo: o,
        planInfo: d,
        questionAnswerInfo: u,
        roomInfo: k,
        voucherInfo: m
      },
      clientContext: n,
      baseInfoInput: f,
      lang: p,
      reservationContext: N,
      reservationPolicy: S,
      priceInfo: c,
      reserveStatus: F,
      hotelName: h,
      onUpdateSession: y
    }
  };
};
function X4e({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === ve.screen4)
    return 1;
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === ve.screen1)
      return 1;
    if (e === ve.screen2)
      return 2;
    if (e === ve.screen3)
      return 3;
    if (e === ve.screen4)
      return 4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === ve.screen1)
      return 1;
    if (e === ve.screen3)
      return 2;
    if (e === ve.screen4)
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === ve.screen2)
      return 1;
    if (e === ve.screen3)
      return 2;
    if (e === ve.screen4)
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === ve.screen3)
      return 1;
    if (e === ve.screen4)
      return 2;
    throw new Error("Invalid current screen.");
  }
  if (e === ve.screen0)
    return 0;
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === ve.screen1)
      return 1;
    if (e === ve.screen3)
      return 2;
    if (e === ve.screen4)
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (e === ve.screen1)
    return 1;
  if (e === ve.screen2)
    return 2;
  if (e === ve.screen3)
    return 3;
  if (e === ve.screen4)
    return 4;
  throw new Error("Invalid current screen.");
}
function Z4e({
  sessionStateContext: {
    reservationContext: { reservationEditMode: e },
    reservationPolicy: { optionSelectionMode: n },
    clientContext: { reserveFailedReason: i }
  }
}) {
  return e === X.EditReservationAuthorizedFailed || e === X.EditReservationCreditCardOnly ? ve.screen4 : e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotAndRegular || e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotOnly ? ve.screen1 : e === X.EditReservationOptionUpdateOnly && n === Z.RegularOnly ? ve.screen2 : e === X.EditReservationOptionUpdateOnly && n === Z.None ? ve.screen3 : i === ml.PaymentFailed ? ve.screen4 : ve.screen0;
}
function eSe({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === ve.screen4)
    throw new Error("Invalid current screen.");
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === ve.screen1)
      return ve.screen2;
    if (e === ve.screen2)
      return ve.screen3;
    if (e === ve.screen3)
      return ve.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === ve.screen1)
      return ve.screen3;
    if (e === ve.screen3)
      return ve.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === ve.screen2)
      return ve.screen3;
    if (e === ve.screen3)
      return ve.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === ve.screen3)
      return ve.screen4;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === ve.screen0)
      return ve.screen1;
    if (e === ve.screen1)
      return ve.screen3;
    if (e === ve.screen3)
      return ve.screen4;
    throw new Error("Invalid current screen.");
  }
  if (e === ve.screen0)
    return ve.screen1;
  if (e === ve.screen1)
    return ve.screen2;
  if (e === ve.screen2)
    return ve.screen3;
  if (e === ve.screen3)
    return ve.screen4;
  throw new Error("Invalid current screen.");
}
function nSe({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === ve.screen4)
    throw new Error("Invalid current screen.");
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === ve.screen4)
      return ve.screen3;
    if (e === ve.screen3)
      return ve.screen2;
    if (e === ve.screen2)
      return ve.screen1;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === ve.screen4)
      return ve.screen3;
    if (e === ve.screen3)
      return ve.screen1;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === ve.screen4)
      return ve.screen3;
    if (e === ve.screen3)
      return ve.screen2;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === ve.screen4)
      return ve.screen3;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === ve.screen4)
      return ve.screen3;
    if (e === ve.screen3)
      return ve.screen1;
    if (e === ve.screen1)
      return ve.screen0;
    throw new Error("Invalid current screen.");
  }
  if (e === ve.screen4)
    return ve.screen3;
  if (e === ve.screen3)
    return ve.screen2;
  if (e === ve.screen2)
    return ve.screen1;
  if (e === ve.screen1)
    return ve.screen0;
  throw new Error("Invalid current screen.");
}
function iSe({
  currentScreen: e,
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  return n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly ? 1 : n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular ? 4 : n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly || n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly ? 3 : n === X.EditReservationOptionUpdateOnly && i === Z.None ? 2 : e === ve.screen0 ? 0 : i === Z.TimeSlotOnly || i === Z.None ? 3 : 4;
}
const ve = {
  screen0: "Screen0",
  screen1: "Screen1",
  screen2: "Screen2",
  screen3: "Screen3",
  screen4: "Screen4"
}, w9 = {
  Screen0: "entry",
  Screen1: "selection",
  Screen2: "option",
  Screen3: "guest_info",
  Screen4: "payment"
}, tSe = (e) => {
  const [n, i] = se(Z4e(e)), t = I(() => {
    const o = eSe({ currentScreen: n, ...e });
    i(o), le(
      Ja({
        reservation_component_ui_type: "snack",
        screen: w9[o],
        direction: "next"
      })
    );
  }, [n, e]), a = I(() => {
    const o = nSe({ currentScreen: n, ...e });
    i(o), le(
      Ja({
        reservation_component_ui_type: "snack",
        screen: w9[o],
        direction: "prev"
      })
    );
  }, [n, e]), s = v(() => X4e({ currentScreen: n, ...e }), [n, e]), r = v(() => iSe({ currentScreen: n, ...e }), [n, e]);
  return {
    currentScreen: n,
    onNextScreen: t,
    onPrevScreen: a,
    currentStep: s,
    totalStep: r
  };
}, aSe = g(({ callbackContext: e, libContext: n }) => {
  const i = Y4e(), { reservationCart: t } = Va();
  Pd(i.sessionState.lang);
  const { currentScreen: a, onNextScreen: s, onPrevScreen: r, currentStep: o, totalStep: d } = tSe({
    sessionStateContext: i.sessionState
  });
  r1(a !== "Screen0");
  const c = Ye(!0);
  return be(() => {
    if (a !== "Screen0") {
      c.current = !0;
      return;
    }
    if (c.current) {
      c.current = !1;
      return;
    }
    const u = i.sessionState.currentState.dateInfo;
    !P(u == null ? void 0 : u.stayStartDt) && !P(u == null ? void 0 : u.stayLastDt) && (le(
      jr({
        hotel_name: i.sessionState.hotelName,
        requires_options: i.sessionState.reservationPolicy.isShowOptionSelect
      })
    ), Ar(t).forEach(bt), s());
  }, [a, i.sessionState, t, s]), a === "Screen0" ? /* @__PURE__ */ l.jsx(khe, {}) : /* @__PURE__ */ l.jsx(
    rs,
    {
      className: "ch-fixed ch-inset-0 ch-z-[100]",
      slideUp: !0,
      initial: { opacity: 1, transform: "translateY(100%)" },
      animate: { opacity: 1, transform: "translateY(0)" },
      exit: { opacity: 1, transform: "translateY(100%)" },
      children: /* @__PURE__ */ l.jsxs(Xs, { children: [
        a === "Screen1" ? /* @__PURE__ */ l.jsx(
          rp,
          {
            headerContext: {
              sticky: {
                sessionStateContext: i.sessionState,
                currentStep: o,
                totalStep: d,
                onPrevScreen: r,
                onCloseScreen: r
              },
              static: {
                sessionStateContext: i.sessionState
              }
            },
            bodyContext: {
              displayContext: {
                sessionStateContext: i.sessionState
              },
              drawerPlanContext: {
                sessionStateContext: i.sessionState
              },
              drawerGroupContext: {
                sessionStateContext: i.sessionState
              },
              drawerDateContext: {
                sessionStateContext: i.sessionState
              },
              drawerRoomContext: {
                sessionStateContext: i.sessionState
              },
              tabPlanFilterContext: {
                sessionStateContext: i.sessionState
              },
              dateTabbedOptionContext: {
                sessionStateContext: i.sessionState
              }
            },
            footerContext: {
              sessionStateContext: i.sessionState,
              onNextScreen: s
            }
          }
        ) : null,
        a === "Screen2" ? /* @__PURE__ */ l.jsx(
          y2,
          {
            initializerContext: {
              sessionStateContext: i.sessionState
            },
            headerContext: {
              sessionStateContext: i.sessionState,
              currentStep: o,
              totalStep: d,
              onPrevScreen: r
            },
            bodyContext: {
              sessionStateContext: i.sessionState
            },
            footerContext: {
              sessionStateContext: i.sessionState,
              onNextScreen: s
            }
          }
        ) : null,
        a === "Screen3" ? /* @__PURE__ */ l.jsx(
          b2,
          {
            initializerContext: {
              sessionStateContext: i.sessionState
            },
            headerContext: {
              sessionStateContext: i.sessionState,
              currentStep: o,
              totalStep: d,
              onPrevScreen: r
            },
            bodyContext: {
              sessionStateContext: i.sessionState
            },
            footerContext: {
              sessionStateContext: i.sessionState,
              onNextScreen: s
            }
          }
        ) : null,
        a === "Screen4" ? /* @__PURE__ */ l.jsx(
          C2,
          {
            initializerContext: {
              sessionStateContext: i.sessionState
            },
            headerContext: {
              sessionStateContext: i.sessionState,
              currentStep: o,
              totalStep: d,
              onPrevScreen: r
            },
            bodyContext: {
              sessionStateContext: i.sessionState,
              libContext: n,
              callbackContext: e
            },
            footerContext: {
              sessionStateContext: i.sessionState
            }
          }
        ) : null
      ] })
    }
  );
}), lSe = ({ initializeContext: e, callbackContext: n, libContext: i, envContext: t }) => (Nl({
  stage: t.stage,
  user: t.user,
  componentType: "snack"
}), Vm({
  hotelID: e.sessionStateContext.hotelID,
  uiType: "snack"
}), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx($r, { lang: e.sessionStateContext.lang, children: /* @__PURE__ */ l.jsx(Rd, { children: /* @__PURE__ */ l.jsx(
    Ur,
    {
      ...i.apolloClient,
      lang: e.sessionStateContext.lang,
      reservationID: e.sessionStateContext.reservationID,
      children: /* @__PURE__ */ l.jsx(s1, { children: /* @__PURE__ */ l.jsx(o1, { children: /* @__PURE__ */ l.jsx(
        K4e,
        {
          initializeContext: e,
          children: /* @__PURE__ */ l.jsx(aSe, { callbackContext: n, libContext: i })
        },
        e.sessionStateContext.lang
      ) }) })
    }
  ) }) }),
  /* @__PURE__ */ l.jsx(l1, {})
] })), sSe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Presenter: lSe
}, Symbol.toStringTag, { value: "Module" })), rSe = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), oSe = () => ({
  kind: "Initialized"
}), dSe = (e) => {
  const { showBoundary: n } = hr(), [i, t] = se(rSe(e)), a = I((r) => {
    t(r);
  }, []), s = Ye(!1);
  return be(() => {
    s.current || i.kind !== "NotInitialized" || (s.current = !0, i.onInitialize().then(() => {
      const r = oSe();
      a(r);
    }).catch(() => {
      n(new Error());
    }));
  }, [a, e, i, n]), {
    state: i
  };
}, cSe = Ve(
  /* GraphQL */
  `
	query RCReservationInitialSessionState(
		$hotelId: ID!
		$lang: LangCode!
		$reservationId: ID
		$reservationIdOfReplicationSource: ID
		$optionInfo: SessionInitializeOptionInfoInput
	) {
		reservationInitialSessionState(
			hotelID: $hotelId
			lang: $lang
			reservationID: $reservationId
			reservationIDOfReplicationSource: $reservationIdOfReplicationSource
			optionInfo: $optionInfo
		) {
			...ReservationSessionStateFragment
		}
	}
`
), uSe = ({ sessionStateContext: e }) => {
  const { onUpdateSession: n } = Ji(), { refetch: i } = qn(
    cSe,
    void 0,
    !0
  ), t = v(() => ({
    dateInfo: P(e.cinDt) || P(e.coutDt) ? void 0 : {
      stayStartDt: e.cinDt,
      stayLastDt: La({
        date: e.coutDt,
        amount: 1
      })
    },
    groupInfo: P(e.adultNum) || P(e.kidsNum) ? void 0 : { adultNum: e.adultNum, kidsNum: e.kidsNum },
    planID: e.planID,
    roomID: e.roomID,
    voucherCode: e.voucherCode
  }), [
    e.adultNum,
    e.cinDt,
    e.coutDt,
    e.kidsNum,
    e.planID,
    e.roomID,
    e.voucherCode
  ]);
  return {
    onInitialize: I(async () => {
      const { data: s } = await i({
        hotelId: e.hotelID,
        reservationId: e.reservationID,
        reservationIdOfReplicationSource: e.reservationIDOfReplicationSource,
        lang: e.lang,
        optionInfo: t
      });
      n(s.reservationInitialSessionState), le(
        pl({
          ...ct(
            Ss(s.reservationInitialSessionState)
          ),
          trigger: "init"
        })
      );
    }, [
      i,
      n,
      t,
      e.hotelID,
      e.lang,
      e.reservationID,
      e.reservationIDOfReplicationSource
    ])
  };
}, mSe = g(({ children: e, initializeContext: n }) => {
  const { onInitialize: i } = uSe(n), { state: t } = dSe({ onInitialize: i });
  return t.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(Sd, {}) : e;
}), kSe = () => {
  const { agreementOfTermsOfService: e } = Od(), { clientContext: n } = Ed(), { dateInfo: i } = Lr(), { discountInfo: t } = Jd(), { groupInfo: a } = _d(), { guestInfo: s } = Qd(), { optionPerDateInfo: r, optionPerReservationInfo: o } = Md(), { planInfo: d } = Ld(), { priceInfo: c } = $d(), { questionAnswerInfo: u } = Ud(), { roomInfo: k } = Vd(), { voucherInfo: m } = Hd(), { baseInfoInput: f } = lt(), { lang: p } = u1(), { hotelName: h } = Td(), { reservationContext: N } = Er(), { reservationPolicy: S } = Ua(), { reserveStatus: F } = m1(), { onUpdateSession: y } = Ji();
  return {
    sessionState: {
      currentState: {
        agreementOfTermsOfService: e,
        dateInfo: i,
        discountInfo: t,
        guestInfo: s,
        groupInfo: a,
        optionPerDateInfo: r,
        optionPerReservationInfo: o,
        planInfo: d,
        questionAnswerInfo: u,
        roomInfo: k,
        voucherInfo: m
      },
      clientContext: n,
      baseInfoInput: f,
      lang: p,
      reservationContext: N,
      reservationPolicy: S,
      priceInfo: c,
      reserveStatus: F,
      hotelName: h,
      onUpdateSession: y
    }
  };
};
function fSe({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === "Screen4")
    return 1;
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === xe.screen1)
      return 1;
    if (e === xe.screen2)
      return 2;
    if (e === xe.screen3)
      return 3;
    if (e === xe.screen4)
      return 4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === xe.screen1)
      return 1;
    if (e === xe.screen3)
      return 2;
    if (e === xe.screen4)
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === xe.screen2)
      return 1;
    if (e === xe.screen3)
      return 2;
    if (e === xe.screen4)
      return 3;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === xe.screen3)
      return 1;
    if (e === xe.screen4)
      return 2;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === xe.screen1)
      return 1;
    if (e === xe.screen3)
      return 2;
    if (e === xe.screen4)
      return 3;
    throw new Error("Invalid current step.");
  }
  if (e === xe.screen1)
    return 1;
  if (e === xe.screen2)
    return 2;
  if (e === xe.screen3)
    return 3;
  if (e === xe.screen4)
    return 4;
  throw new Error("Invalid current step.");
}
function vSe({
  sessionStateContext: {
    reservationContext: { reservationEditMode: e },
    reservationPolicy: { optionSelectionMode: n },
    clientContext: { reserveFailedReason: i }
  }
}) {
  return e === X.EditReservationAuthorizedFailed || e === X.EditReservationCreditCardOnly ? xe.screen4 : e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotAndRegular || e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotOnly ? xe.screen1 : e === X.EditReservationOptionUpdateOnly && n === Z.RegularOnly ? xe.screen2 : e === X.EditReservationOptionUpdateOnly && n === Z.None ? xe.screen3 : i === ml.PaymentFailed ? xe.screen4 : xe.screen1;
}
function hSe({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === xe.screen4)
    throw new Error("Invalid current screen.");
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === xe.screen1)
      return xe.screen2;
    if (e === xe.screen2)
      return xe.screen3;
    if (e === xe.screen3)
      return xe.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === xe.screen1)
      return xe.screen3;
    if (e === xe.screen3)
      return xe.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === xe.screen2)
      return xe.screen3;
    if (e === xe.screen3)
      return xe.screen4;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === xe.screen3)
      return xe.screen4;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === xe.screen1)
      return xe.screen3;
    if (e === xe.screen3)
      return xe.screen4;
    throw new Error("Invalid current step.");
  }
  if (e === xe.screen1)
    return xe.screen2;
  if (e === xe.screen2)
    return xe.screen3;
  if (e === xe.screen3)
    return xe.screen4;
  throw new Error("Invalid next screen.");
}
function pSe({
  currentScreen: e,
  //
  sessionStateContext: {
    reservationContext: { reservationEditMode: n },
    reservationPolicy: { optionSelectionMode: i }
  }
}) {
  if ((n === X.EditReservationAuthorizedFailed || n === X.EditReservationCreditCardOnly) && e === xe.screen4)
    throw new Error("Invalid current screen.");
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotAndRegular) {
    if (e === xe.screen4)
      return xe.screen3;
    if (e === xe.screen3)
      return xe.screen2;
    if (e === xe.screen2)
      return xe.screen1;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.TimeSlotOnly) {
    if (e === xe.screen4)
      return xe.screen3;
    if (e === xe.screen3)
      return xe.screen1;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.RegularOnly) {
    if (e === xe.screen4)
      return xe.screen3;
    if (e === xe.screen3)
      return xe.screen2;
    throw new Error("Invalid current screen.");
  }
  if (n === X.EditReservationOptionUpdateOnly && i === Z.None) {
    if (e === xe.screen4)
      return xe.screen3;
    throw new Error("Invalid current screen.");
  }
  if (i === Z.TimeSlotOnly || i === Z.None) {
    if (e === xe.screen4)
      return xe.screen3;
    if (e === xe.screen3)
      return xe.screen1;
    throw new Error("Invalid current step.");
  }
  if (e === xe.screen4)
    return xe.screen3;
  if (e === xe.screen3)
    return xe.screen2;
  if (e === xe.screen2)
    return xe.screen1;
  throw new Error("Invalid next screen.");
}
function NSe({
  sessionStateContext: {
    reservationContext: { reservationEditMode: e },
    //
    reservationPolicy: { optionSelectionMode: n }
  }
}) {
  return e === X.EditReservationAuthorizedFailed || e === X.EditReservationCreditCardOnly ? 1 : e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotAndRegular ? 4 : e === X.EditReservationOptionUpdateOnly && n === Z.TimeSlotOnly || e === X.EditReservationOptionUpdateOnly && n === Z.RegularOnly ? 3 : e === X.EditReservationOptionUpdateOnly && n === Z.None ? 2 : n === Z.TimeSlotOnly || n === Z.None ? 3 : 4;
}
const xe = {
  screen1: "Screen1",
  screen2: "Screen2",
  screen3: "Screen3",
  screen4: "Screen4"
}, P9 = {
  Screen1: "selection",
  Screen2: "option",
  Screen3: "guest_info",
  Screen4: "payment"
}, SSe = (e) => {
  const [n, i] = se(vSe(e)), t = I(() => {
    const o = hSe({ currentScreen: n, ...e });
    i(o), le(
      Ja({
        reservation_component_ui_type: "test_reservation",
        screen: P9[o],
        direction: "next"
      })
    );
  }, [n, e]), a = I(() => {
    const o = pSe({ currentScreen: n, ...e });
    i(o), le(
      Ja({
        reservation_component_ui_type: "test_reservation",
        screen: P9[o],
        direction: "prev"
      })
    );
  }, [n, e]), s = v(() => fSe({ currentScreen: n, ...e }), [n, e]), r = v(() => NSe(e), [e]);
  return {
    currentScreen: n,
    onNextScreen: t,
    onPrevScreen: a,
    currentStep: s,
    totalStep: r
  };
}, gSe = g(({ callbackContext: e }) => {
  const n = kSe();
  Pd(n.sessionState.lang);
  const { currentScreen: i, onNextScreen: t, onPrevScreen: a, currentStep: s, totalStep: r } = SSe({
    sessionStateContext: n.sessionState
  });
  if (i === "Screen1")
    return /* @__PURE__ */ l.jsx(
      Lpe,
      {
        headerContext: {
          sticky: {
            sessionStateContext: n.sessionState,
            currentStep: s,
            totalStep: r,
            onPrevScreen: a,
            onCloseScreen: e.onHideCallback
          },
          static: {
            sessionStateContext: n.sessionState
          }
        },
        bodyContext: {
          displayContext: {
            sessionStateContext: n.sessionState
          },
          drawerPlanContext: {
            sessionStateContext: n.sessionState
          },
          drawerGroupContext: {
            sessionStateContext: n.sessionState
          },
          drawerDateContext: {
            sessionStateContext: n.sessionState
          },
          drawerRoomContext: {
            sessionStateContext: n.sessionState
          },
          tabPlanFilterContext: {
            sessionStateContext: n.sessionState
          },
          dateTabbedOptionContext: {
            sessionStateContext: n.sessionState
          }
        },
        footerContext: {
          sessionStateContext: n.sessionState,
          onNextScreen: t
        }
      }
    );
  if (i === "Screen2")
    return /* @__PURE__ */ l.jsx(
      iNe,
      {
        initializerContext: {
          sessionStateContext: n.sessionState
        },
        headerContext: {
          sessionStateContext: n.sessionState,
          currentStep: s,
          totalStep: r,
          onPrevScreen: a,
          onCloseScreen: e.onHideCallback
        },
        bodyContext: {
          sessionStateContext: n.sessionState
        },
        footerContext: {
          sessionStateContext: n.sessionState,
          onNextScreen: t
        }
      }
    );
  if (i === "Screen3")
    return /* @__PURE__ */ l.jsx(
      RNe,
      {
        initializerContext: {
          sessionStateContext: n.sessionState
        },
        headerContext: {
          sessionStateContext: n.sessionState,
          currentStep: s,
          totalStep: r,
          onPrevScreen: a,
          onCloseScreen: e.onHideCallback
        },
        bodyContext: {
          sessionStateContext: n.sessionState
        },
        footerContext: {
          sessionStateContext: n.sessionState,
          onNextScreen: t
        }
      }
    );
  if (i === "Screen4")
    return /* @__PURE__ */ l.jsx(
      zNe,
      {
        initializerContext: {
          sessionStateContext: n.sessionState
        },
        headerContext: {
          sessionStateContext: n.sessionState,
          currentStep: s,
          totalStep: r,
          onPrevScreen: a
        },
        bodyContext: {
          sessionStateContext: n.sessionState,
          callbackContext: e
        },
        footerContext: {
          sessionStateContext: n.sessionState
        }
      }
    );
  throw new Error("Invalid current screen.");
}), FSe = ({ initializeContext: e, callbackContext: n, libContext: i, envContext: t }) => (Nl({ stage: t.stage, user: t.user, componentType: "test" }), r1(), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx($r, { lang: e.sessionStateContext.lang, children: /* @__PURE__ */ l.jsx(Rd, { children: /* @__PURE__ */ l.jsx(
    rs,
    {
      className: "ch-fixed ch-inset-0 ch-z-[100]",
      slideUp: !0,
      initial: { opacity: 1, transform: "translateY(100%)" },
      animate: { opacity: 1, transform: "translateY(0)" },
      exit: { opacity: 1, transform: "translateY(100%)" },
      children: /* @__PURE__ */ l.jsx(
        Ur,
        {
          ...i.apolloClient,
          lang: e.sessionStateContext.lang,
          reservationID: e.sessionStateContext.reservationID,
          children: /* @__PURE__ */ l.jsx(s1, { children: /* @__PURE__ */ l.jsx(o1, { children: /* @__PURE__ */ l.jsx(
            mSe,
            {
              initializeContext: e,
              children: /* @__PURE__ */ l.jsx(
                gSe,
                {
                  callbackContext: n
                },
                e.sessionStateContext.lang
              )
            },
            e.sessionStateContext.lang
          ) }) })
        }
      )
    }
  ) }) }),
  /* @__PURE__ */ l.jsx(l1, {})
] })), ISe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Presenter: FSe
}, Symbol.toStringTag, { value: "Module" })), ySe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Full: XNe,
  Inline: S4e,
  InlineCalendar: L4e,
  Snack: sSe,
  Test: ISe
}, Symbol.toStringTag, { value: "Module" })), bSe = Ve(
  /* GraphQL */
  `
	mutation TDSCReserveWithCreditPaymentForConfirm($baseInfoInput: BaseInfoInput!) {
		reserveWithCreditPaymentForConfirm(baseInfo: $baseInfoInput) {
			hotelID
			reservationID
		}
	}
`
), CSe = ({ sessionStateContext: e }) => {
  const { mutationFunc: n } = Gn(bSe);
  return {
    onUpdateCreditPaymentForConfirm: I(async () => {
      const { data: t } = await n({
        variables: {
          baseInfoInput: e.baseInfoInput
        }
      });
      return {
        kind: "Success",
        hotelID: t.reserveWithCreditPaymentForConfirm.hotelID,
        reservationID: t.reserveWithCreditPaymentForConfirm.reservationID
      };
    }, [e.baseInfoInput, n])
  };
}, xSe = (e) => Array.isArray(e) && e.some((i) => {
  if (typeof i != "object" || i === null || !("extensions" in i)) return !1;
  const { extensions: t } = i;
  return typeof t == "object" && t !== null && "chillnnErrorMessageForUser" in t && "chillnnStatusCode" in t;
}) ? "three_d_secure_chillnn_error" : "three_d_secure_error", DSe = (e) => () => ({
  kind: "ChillnnErrored",
  lang: e.sessionStateContext.lang,
  errorMessageForUser: e.errorMessageForUser,
  onFailureCallback: e.callbackContext.onFailureCallback
}), wSe = (e) => () => ({
  kind: "Errored",
  lang: e.sessionStateContext.lang,
  onFailureCallback: e.callbackContext.onFailureCallback
}), PSe = (e) => ({
  kind: "Initialized",
  lang: e.sessionStateContext.lang,
  onUpdateCreditPaymentForConfirmCallback: e.callbackContext.onUpdateCreditPaymentForConfirmCallback
}), RSe = (e) => () => ({
  kind: "Succeeded",
  lang: e.sessionStateContext.lang,
  onSuccessCallback: e.callbackContext.onSuccessCallback(e.reservationID)
}), TSe = (e) => {
  const [n, i] = se(PSe(e)), t = I((s) => {
    i(s);
  }, []), a = Ye(!1);
  return be(() => {
    if (a.current || n.kind !== "Initialized")
      return;
    a.current = !0;
    const s = ct(e.sessionStateContext.baseInfoInput);
    n.onUpdateCreditPaymentForConfirmCallback().then((r) => {
      if (n.kind === "Initialized") {
        if (r.kind === "Success") {
          const o = {
            ...e,
            reservationID: r.reservationID
          }, d = RSe(o)(n);
          t(d);
          const c = YV(e.sessionStateContext.baseInfoInput.sessionID);
          c && SC({ ...c, reservationID: r.reservationID }).forEach(
            bt
          ), le(
            yn({
              target: "reserve",
              action: "three_d_secure_confirm",
              ok: !0
            })
          ), le(
            Mm({
              ...s,
              reservation_id: r.reservationID
            })
          );
          return;
        }
        if (r.kind === "ChillnnError") {
          const o = {
            ...e,
            errorMessageForUser: r.errorMessageForUser
          }, d = DSe(o)(n);
          t(d), le(
            yn({
              target: "reserve",
              action: "three_d_secure_confirm",
              ok: !1
            })
          ), le(
            bu({ ...s, reason: "three_d_secure_chillnn_error" })
          );
          return;
        }
      }
    }).catch((r) => {
      if (n.kind !== "Initialized")
        return;
      const o = wSe(e)(n);
      t(o), le(
        yn({
          target: "reserve",
          action: "three_d_secure_confirm",
          ok: !1,
          error_code: k1(r)
        })
      ), le(bu({ ...s, reason: xSe(r) }));
    });
  }, [t, e, n]), {
    state: n
  };
}, jSe = 1e4, ASe = g(({ lang: e, errorMessageForUser: n, callbackContext: i }) => {
  const t = Ye();
  be(() => (t.current = setTimeout(() => {
    i.onFailureCallback();
  }, jSe), () => {
    t.current && clearTimeout(t.current);
  }), [i]);
  const a = I(() => {
    t.current && (clearTimeout(t.current), i.onFailureCallback());
  }, [i]), s = v(() => e === D.Default ? n.ja : n.en, [n, e]), r = v(() => e === D.Default ? "予約画面に自動で10秒後に遷移します。" : "In approximately 10 seconds, you will be automatically redirected to the reservation page.", [e]), o = v(() => e === D.Default ? "手動で遷移" : "Manual transition", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-text-center", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-font-bold", children: s }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-text-sm ch-text-gray-500", children: r })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-text-center", children: /* @__PURE__ */ l.jsx(ae, { variant: "default", size: "default", onClick: a, children: o }) })
  ] });
}), OSe = 1e4, ESe = g(({ lang: e, callbackContext: n }) => {
  const i = Ye();
  be(() => (i.current = setTimeout(() => {
    n.onFailureCallback();
  }, OSe), () => {
    i.current && clearTimeout(i.current);
  }), [n]);
  const t = I(() => {
    i.current && (clearTimeout(i.current), n.onFailureCallback());
  }, [n]), a = v(() => e === D.Default ? `予約に失敗しました。
お手数をおかけしますが、再度お試しください。` : `We apologize, but we were unable to complete your reservation at this time.
Please try again.`, [e]), s = v(() => e === D.Default ? "予約画面に自動で10秒後に遷移します。" : "In approximately 10 seconds, you will be automatically redirected to the reservation page.", [e]), r = v(() => e === D.Default ? "手動で遷移" : "Manual transition", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-text-center", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-font-bold", children: a }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-text-sm ch-text-gray-500", children: s })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-text-center", children: /* @__PURE__ */ l.jsx(ae, { variant: "default", size: "default", onClick: t, children: r }) })
  ] });
}), JSe = g(({ lang: e }) => {
  const n = v(() => kn({
    lang: e,
    i18nString: {
      default: "予約処理実行中",
      en: "Reservation process in progress"
    }
  }), [e]), i = v(() => kn({
    lang: e,
    i18nString: {
      default: "処理が完了するまでブラウザやタブを閉じないでください。予約処理が正常に完了しない場合があります。",
      en: "Please do not close the browser or tab until the process is complete. The reservation process may not be completed properly."
    }
  }), [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-justify-center ch-space-y-5", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
        "svg",
        {
          "aria-hidden": "true",
          focusable: "false",
          "data-prefix": "far",
          "data-icon": "spinner",
          className: "ch-mx-auto ch-h-10 ch-w-10 ch-animate-spin",
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 512 512",
          children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M296 48c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-40 376c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm248-168c0-22.091-17.909-40-40-40s-40 17.909-40 40 17.909 40 40 40 40-17.909 40-40zm-416 0c0-22.091-17.909-40-40-40S8 233.909 8 256s17.909 40 40 40 40-17.909 40-40zm20.922-187.078c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40c0-22.092-17.909-40-40-40zm294.156 294.156c-22.091 0-40 17.909-40 40s17.909 40 40 40c22.092 0 40-17.909 40-40s-17.908-40-40-40zm-294.156 0c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40z"
            }
          )
        }
      ) }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-center", children: n })
    ] }),
    /* @__PURE__ */ l.jsx(hd, { variant: "warning", children: i })
  ] });
}), _Se = 4e3, QSe = g(({ lang: e, callbackContext: n }) => {
  be(() => {
    const a = setTimeout(() => {
      n.onSuccessCallback();
    }, _Se);
    return () => {
      clearTimeout(a);
    };
  }, [n]);
  const i = v(() => e === D.Default ? "認証に成功しました。また、メールもご確認ください。" : `We have successfully authenticated your information.
Please check your email for further details.`, [e]), t = v(() => e === D.Default ? "予約詳細画面に自動で3~5秒後に遷移します。" : "In approximately 3-5 seconds, you will be automatically redirected to the reservation details page.", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-text-center", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-font-bold", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-text-sm ch-text-gray-500", children: t })
  ] });
}), MSe = g(({ sessionStateContext: e, callbackContext: n }) => {
  const { onUpdateCreditPaymentForConfirm: i } = CSe({ sessionStateContext: e }), { onDisableBeforeUnload: t } = gd(), { state: a } = TSe({
    sessionStateContext: e,
    callbackContext: {
      ...n,
      onUpdateCreditPaymentForConfirmCallback: i
    }
  });
  return a.kind === "Succeeded" ? (t(), /* @__PURE__ */ l.jsx(
    QSe,
    {
      lang: a.lang,
      callbackContext: {
        onSuccessCallback: a.onSuccessCallback
      }
    }
  )) : a.kind === "ChillnnErrored" ? (t(), /* @__PURE__ */ l.jsx(
    ASe,
    {
      lang: a.lang,
      errorMessageForUser: a.errorMessageForUser,
      callbackContext: {
        onFailureCallback: a.onFailureCallback
      }
    }
  )) : a.kind === "Errored" ? (t(), /* @__PURE__ */ l.jsx(
    ESe,
    {
      lang: a.lang,
      callbackContext: {
        onFailureCallback: a.onFailureCallback
      }
    }
  )) : /* @__PURE__ */ l.jsx(JSe, { lang: a.lang });
}), LSe = ({ libContext: e, envContext: n, ...i }) => {
  var t;
  return Nl({
    stage: n.stage,
    user: n.user,
    componentType: "three-d-secure-confirm"
  }), r1(), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx($r, { lang: i.sessionStateContext.lang, children: /* @__PURE__ */ l.jsx(
      Ur,
      {
        ...e.apolloClient,
        lang: i.sessionStateContext.lang,
        reservationID: (t = i.sessionStateContext.baseInfoInput.reservationID) != null ? t : void 0,
        children: /* @__PURE__ */ l.jsx(s1, { children: /* @__PURE__ */ l.jsx(
          rs,
          {
            className: "ch-fixed ch-inset-0 ch-z-[100]",
            slideUp: !0,
            initial: { opacity: 1, transform: "translateY(100%)" },
            animate: { opacity: 1, transform: "translateY(0)" },
            exit: { opacity: 1, transform: "translateY(100%)" },
            children: /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-h-screen ch-w-full ch-items-center ch-justify-center ch-bg-black/60 ch-px-4", children: /* @__PURE__ */ l.jsx("div", { className: "ch-w-full ch-max-w-md ch-rounded-lg ch-border ch-border-gray-200 ch-bg-white ch-p-6 ch-shadow-lg", children: /* @__PURE__ */ l.jsx(MSe, { ...i }) }) })
          }
        ) })
      }
    ) }),
    /* @__PURE__ */ l.jsx(l1, {})
  ] });
}, $Se = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Presenter: LSe
}, Symbol.toStringTag, { value: "Module" })), NDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get BillingTypeTarget() {
    return $l;
  },
  get BillingTypeTargetForOption() {
    return Qt;
  },
  get BillingTypeTerm() {
    return nt;
  },
  get CurrencyType() {
    return Ku;
  },
  get CurrentViewStateWhenCoutSelect() {
    return Rt;
  },
  get CurrentViewStateWhenStayStartSelect() {
    return Un;
  },
  get CustomTypeRoomTitle() {
    return _a;
  },
  EditDateDateRemoveDocument: cF,
  EditDateDateUpdateDocument: uF,
  InputAotosaotosUpdateDocument: B9,
  InputDiscountDiscountUpdateDocument: q9,
  InputGuestInfoGuestInfoUpdateDocument: G9,
  InputQaaaqaaUpdateDocument: eF,
  InputVoucherVoucherRemoveDocument: nF,
  InputVoucherVoucherUpdateDocument: iF,
  get KidsPolicyType() {
    return Qs;
  },
  get LangCode() {
    return D;
  },
  get MealType() {
    return _l;
  },
  get OptionSelectionMode() {
    return Z;
  },
  get OptionType() {
    return Zs;
  },
  get PaymentMethod() {
    return Yu;
  },
  get PlanQueryFilterType() {
    return It;
  },
  get QuestionType() {
    return Ms;
  },
  RcFullReservationCurrentSessionStateDocument: TF,
  RcFullReservationInitialSessionStateDocument: jF,
  RcGroupAddDocument: rF,
  RcGroupAvailableDocument: dF,
  RcGroupUpdateDocument: oF,
  RcPlanAvailableDocument: pF,
  RcPlanSetQueryFilterDocument: yF,
  RcPlanUpdateDocument: hF,
  RcReservationDetailQueryDocument: RF,
  RcReservationInitialSessionStateDocument: z9,
  RcReserveWithCreditPaymentEncodeCallBackForNewReservationDocument: K9,
  RcReserveWithCreditPaymentEncodeCallBackUrlForExistingReservationDocument: W9,
  RcReserveWithFreePaymentDocument: Y9,
  RcReserveWithLocalPaymentDocument: X9,
  RcReserveWithTestPaymentDocument: Z9,
  RcRoomBaseAvailableDocument: gF,
  RcRoomBaseUpdateDocument: NF,
  RcRoomEachAvailableDocument: FF,
  RcRoomEachUpdateDocument: SF,
  RcScreen2InitializeDocument: bF,
  RcScreen2TestInitializeDocument: DF,
  RcScreen3InitializeQueryDocument: CF,
  RcScreen3TestInitializeQueryDocument: wF,
  RcScreen4InitializeDocument: xF,
  RcScreen4TestInitializeDocument: PF,
  RcSelectDateDateRemoveDocument: IF,
  RcSelectDateDateUpdateDocument: tF,
  RciReservationCurrentSessionStateDocument: EF,
  RciReservationInitialSessionStateDocument: JF,
  RcicReservationCurrentSessionStateDocument: AF,
  RcicReservationInitialSessionStateDocument: OF,
  ReservationComponent: ySe,
  get ReservationEditMode() {
    return X;
  },
  ReservationSessionStateFragmentFragmentDoc: V9,
  get ReserveFailedReasonType() {
    return ml;
  },
  SelectDateDateCoutAvailableDocument: aF,
  SelectDateDateStayStartAvailableDocument: sF,
  SelectDateDateStayStartAvailableInitialDocument: lF,
  SelectInlineDateDateCoutAvailableDocument: mF,
  SelectInlineDateDateStayStartAvailableDocument: kF,
  SelectInlineDateInitializeDocument: fF,
  SelectOptionAvailableOptionsFragmentFragmentDoc: H9,
  SelectOptionOptionUpdateDocument: vF,
  get SelectablePaymentMethod() {
    return pn;
  },
  get StockPreviewGrade() {
    return Ul;
  },
  TdscReserveWithCreditPaymentForConfirmDocument: _F,
  ThreeDSecureConfirmComponent: $Se
}, Symbol.toStringTag, { value: "Module" })), Dl = g(
  ({
    itemKey: e,
    triggerSlot: n,
    contentSlot: i
  }) => /* @__PURE__ */ l.jsxs(it, { value: e, className: "ch-rounded ch-border ch-border-zinc-200", children: [
    /* @__PURE__ */ l.jsx(tt, { hideArrow: !0, className: "ch-m-2 ch-rounded hover:ch-bg-zinc-50", children: n }),
    /* @__PURE__ */ l.jsx(at, { className: "ch-mx-4 ch-mb-4", children: i })
  ] })
);
function USe(e, n, i, t) {
  return !ke(e) || !ke(n) || !ke(i) || !ke(t);
}
const VSe = (e) => {
  const n = USe(
    e.sessionState.currentState.optionPerDateWillCancel,
    e.sessionState.currentState.optionPerReservationWillCancel,
    e.sessionState.prevState.optionPerDateCanceled,
    e.sessionState.prevState.optionPerReservationCanceled
  );
  return e.sessionState.sessionPolicy.isShowOptionSelect ? {
    kind: "Displayable"
  } : !e.sessionState.sessionPolicy.isShowOptionSelect && n ? {
    kind: "Displayable"
  } : {
    kind: "NotDisplayable"
  };
}, HSe = (e) => ({
  state: v(() => VSe(e), [e])
}), zSe = g(({ slot: e, ...n }) => {
  const { state: i } = HSe(n);
  return i.kind === "Displayable" ? e : null;
}), BSe = () => ({
  kind: "Initialized"
}), qSe = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), GSe = (e) => {
  const [n, i] = se(qSe(e)), t = I((a) => {
    i(a);
  }, []);
  return be(() => {
    if (n.kind === "Initialized")
      return;
    (async () => {
      await n.onInitialize();
      const s = BSe();
      t(s);
    })();
  }, [t, n]), {
    state: n
  };
}, WSe = g(({ slot: e, ...n }) => {
  const { state: i } = GSe(n);
  return i.kind === "Initialized" ? e : /* @__PURE__ */ l.jsx(Sd, {});
}), KSe = g(({ headerRightContentSlot: e, bodyContentSlot: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-h-screen ch-flex-col ch-bg-zinc-50", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-h-16 ch-w-full ch-border-b ch-border-zinc-100 ch-bg-white ch-px-4 tablet:ch-px-12", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-h-full ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("h3", { className: "ch-text-lg ch-font-bold", children: "予約内容の変更" }),
    /* @__PURE__ */ l.jsx("div", { children: e })
  ] }) }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-relative ch-flex-1 ch-overflow-y-scroll ch-px-4 tablet:ch-px-12", children: n })
] }));
function YSe(e) {
  var n, i;
  return {
    name: e.name,
    price: e.price,
    priceDiscounted: (n = e.priceDiscounted) != null ? n : void 0,
    priceHostInserted: (i = e.priceHostInserted) != null ? i : void 0,
    sessionResourceUUID: e.sessionResourceUUID
  };
}
const XSe = (e) => ke(e.currentState.additionalFee) ? {
  kind: "NotDisplayed"
} : {
  kind: "Displayed",
  additionalFeeList: e.currentState.additionalFee.map(YSe)
}, ZSe = (e) => ({
  state: v(() => XSe(e), [e])
});
function ege(e, n) {
  return n;
}
var w2 = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.Room = "ROOM", e))(w2 || {}), ga = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.PersonOnlyKids = "PERSON_ONLY_KIDS", e.Room = "ROOM", e))(ga || {}), P2 = /* @__PURE__ */ ((e) => (e.PerDate = "PER_DATE", e.PerReservation = "PER_RESERVATION", e))(P2 || {}), R2 = /* @__PURE__ */ ((e) => (e.Jpy = "jpy", e))(R2 || {}), T2 = /* @__PURE__ */ ((e) => (e.Cin = "CIN", e.MiddleDay = "MIDDLE_DAY", e.NotSelected = "NOT_SELECTED", e))(T2 || {}), j2 = /* @__PURE__ */ ((e) => (e.Cin = "CIN", e.Cout = "COUT", e.DayTripSelected = "DAY_TRIP_SELECTED", e.MiddleDay = "MIDDLE_DAY", e.NotSelected = "NOT_SELECTED", e))(j2 || {}), Gd = /* @__PURE__ */ ((e) => (e.Building = "Building", e.Cottage = "Cottage", e.Room = "Room", e.Space = "Space", e.Tent = "Tent", e))(Gd || {}), A2 = /* @__PURE__ */ ((e) => (e.Minus = "minus", e.NotAvailable = "not_available", e.Ratio = "ratio", e.Static = "static", e))(A2 || {}), Vr = /* @__PURE__ */ ((e) => (e.Default = "default", e.En = "en", e))(Vr || {}), O2 = /* @__PURE__ */ ((e) => (e.Breakfast = "BREAKFAST", e.Dinner = "DINNER", e.Lunch = "LUNCH", e.RoomOnly = "ROOM_ONLY", e))(O2 || {}), E2 = /* @__PURE__ */ ((e) => (e.None = "None", e.RegularOnly = "RegularOnly", e.TimeSlotAndRegular = "TimeSlotAndRegular", e.TimeSlotOnly = "TimeSlotOnly", e))(E2 || {}), kr = /* @__PURE__ */ ((e) => (e.Goods = "GOODS", e.Service = "SERVICE", e))(kr || {}), J2 = /* @__PURE__ */ ((e) => (e.Credit = "CREDIT", e.Free = "FREE", e.Local = "LOCAL", e.Test = "TEST", e))(J2 || {}), _2 = /* @__PURE__ */ ((e) => (e.AllPlans = "ALL_PLANS", e.OnlyAccommodationPlans = "ONLY_ACCOMMODATION_PLANS", e.OnlyDayTripPlans = "ONLY_DAY_TRIP_PLANS", e))(_2 || {}), Q2 = /* @__PURE__ */ ((e) => (e.Check = "CHECK", e.Free = "FREE", e.Radio = "RADIO", e.Select = "SELECT", e))(Q2 || {}), M2 = /* @__PURE__ */ ((e) => (e.EditReservation = "EDIT_RESERVATION", e.EditReservationAuthorizedFailed = "EDIT_RESERVATION_AUTHORIZED_FAILED", e.EditReservationCreditCardOnly = "EDIT_RESERVATION_CREDIT_CARD_ONLY", e.EditReservationOptionUpdateOnly = "EDIT_RESERVATION_OPTION_UPDATE_ONLY", e.NewReservation = "NEW_RESERVATION", e))(M2 || {}), L2 = /* @__PURE__ */ ((e) => (e.PaymentFailed = "PAYMENT_FAILED", e.StockIsNotAvailable = "STOCK_IS_NOT_AVAILABLE", e))(L2 || {}), $2 = /* @__PURE__ */ ((e) => (e.CreditCardContinuedUse = "CREDIT_CARD_CONTINUED_USE", e.CreditCardNewlyRegistration = "CREDIT_CARD_NEWLY_REGISTRATION", e.Free = "FREE", e.Local = "LOCAL", e.Test = "TEST", e))($2 || {}), U2 = /* @__PURE__ */ ((e) => (e.Available = "AVAILABLE", e.Few = "FEW", e.Full = "FULL", e))(U2 || {});
const fw = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, vw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCEReservationInitialSessionState" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationInitialSessionStateForEdit" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationSessionState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, hw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "PriceUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priceInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PriceUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priceUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "priceInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "priceInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, pw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "EditDateDateRemove" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateRemove" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, Nw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "EditDateDateUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dataUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "dateInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, Sw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "EditDateDateCoutAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateCoutAvailableInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateCoutAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "dateInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableCoutDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "currentViewState" } }, { kind: "Field", name: { kind: "Name", value: "selectable" } }, { kind: "Field", name: { kind: "Name", value: "available" } }, { kind: "Field", name: { kind: "Name", value: "dailyMinimumPrice" } }] } }] } }] } }] }, gw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "EditDateDateStayStartAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DateStayStartAvailableInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "dateStayStartAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "dateInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "dateInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableStayStartDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "currentViewState" } }, { kind: "Field", name: { kind: "Name", value: "selectable" } }, { kind: "Field", name: { kind: "Name", value: "available" } }, { kind: "Field", name: { kind: "Name", value: "dailyMinimumPrice" } }] } }] } }] } }] }, Fw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "EditDateInitialize" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "metaData" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "metaData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isDayTrip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "staticPriceDataAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableStaticPriceData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planBillingPricePerDate" } }, { kind: "Field", name: { kind: "Name", value: "planBillingPricePerReservation" } }, { kind: "Field", name: { kind: "Name", value: "requiredOptionBillingMinimumPricePerDate" } }, { kind: "Field", name: { kind: "Name", value: "requiredOptionBillingMinimumPricePerReservation" } }] } }] } }] } }] }, Iw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "EditDiscountDiscountRemove" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountRemove" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, yw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "EditDiscountDiscountUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "discountInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "DiscountUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "discountInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "discountInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, bw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "EditDiscountDiscountAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableDiscounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountName" } }, { kind: "Field", name: { kind: "Name", value: "discountCode" } }] } }] } }] } }] }, Cw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "EditGroupGroupAdd" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupAdd" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, xw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "EditGroupGroupUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "groupInfo" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GroupUpdateInput" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "groupInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "groupInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, Dw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "EditGroupGroupAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableGroup" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "minimumGroupNum" } }, { kind: "Field", name: { kind: "Name", value: "maximumGroupNum" } }, { kind: "Field", name: { kind: "Name", value: "maximumTotalNumPerGroup" } }, { kind: "Field", name: { kind: "Name", value: "maximumAdultNumPerGroup" } }, { kind: "Field", name: { kind: "Name", value: "maximumChildNumPerGroup" } }, { kind: "Field", name: { kind: "Name", value: "maximumChildAge" } }, { kind: "Field", name: { kind: "Name", value: "maximumCoSleepingAge" } }] } }] } }] } }] }, ww = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "EditOptionOptionUpdateMutation" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "OptionUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "optionInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "optionInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, Pw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "EditOptionAvailableOptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableOptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTerm" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTarget" } }, { kind: "Field", name: { kind: "Name", value: "optionType" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "isRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDateTabbedTimeSelectionEnabled" } }, { kind: "Field", name: { kind: "Name", value: "isDateTabbedTimeSelectionTarget" } }, { kind: "Field", name: { kind: "Name", value: "isOneOfRequired" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "detail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionBillingPerDate" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isNextMorning" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "OptionBillingPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubOptionBillingPerDate" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multiSelectAvailable" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "maxSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "subOptionItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }, { kind: "Field", name: { kind: "Name", value: "isNextMorning" } }, { kind: "Field", name: { kind: "Name", value: "startAt" } }, { kind: "Field", name: { kind: "Name", value: "endAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowTimeSchedule" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "SubOptionBillingPerReservation" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multiSelectAvailable" } }, { kind: "Field", name: { kind: "Name", value: "maxSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "minimumSoldAmount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "availableChoices" } }, { kind: "Field", name: { kind: "Name", value: "startAt" } }, { kind: "Field", name: { kind: "Name", value: "endAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowTimeSchedule" } }] } }] } }] } }] } }] } }] } }] }, Rw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCEPlanUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "planInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "PlanUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "planInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "planInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, Tw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCEPlanAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availablePlans" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "includedMeals" } }, { kind: "Field", name: { kind: "Name", value: "minRoomNum" } }, { kind: "Field", name: { kind: "Name", value: "requiredOptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priceType" } }, { kind: "Field", name: { kind: "Name", value: "priceTarget" } }, { kind: "Field", name: { kind: "Name", value: "optionType" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "minimumPrice" } }, { kind: "Field", name: { kind: "Name", value: "isOneOfRequired" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceType" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "article" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "kidsPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsMaxAge" } }, { kind: "Field", name: { kind: "Name", value: "kidsDiscountType" } }, { kind: "Field", name: { kind: "Name", value: "ratio" } }, { kind: "Field", name: { kind: "Name", value: "static" } }, { kind: "Field", name: { kind: "Name", value: "unavailable" } }] } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStartTime" } }, { kind: "Field", name: { kind: "Name", value: "checkInEndTime" } }, { kind: "Field", name: { kind: "Name", value: "checkOutEndTime" } }] } }, { kind: "Field", name: { kind: "Name", value: "isUnCancelable" } }, { kind: "Field", name: { kind: "Name", value: "priceTarget" } }] } }] } }] } }] }, jw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "EditRoomRoomEachUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "roomEachInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RoomEachUpdateInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomEachUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "roomEachInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "roomEachInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, Aw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "EditRoomRoomEachAvailable" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "roomInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "RoomAvailableInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomEachAvailable" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }, { kind: "Argument", name: { kind: "Name", value: "roomInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "roomInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "availableRoomsList" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "availableRooms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "capacityPeopleMaximum" } }, { kind: "Field", name: { kind: "Name", value: "isDormitory" } }, { kind: "Field", name: { kind: "Name", value: "keyVisuals" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "roomSize" } }, { kind: "Field", name: { kind: "Name", value: "beds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bedType" } }, { kind: "Field", name: { kind: "Name", value: "bedNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "capacityPeopleMaximum" } }] } }] } }] } }] } }] }, Ow = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RCEReservationReset" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationInitialSessionStateForEdit" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationSessionState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] }, Ew = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RCEReservationUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "BaseInfoInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveWithoutPaymentMethodChange" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "baseInfo" }, value: { kind: "Variable", name: { kind: "Name", value: "baseInfo" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ReservationSessionStateFragment" } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ReservationSessionStateFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ReservationSessionState" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "sessionID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "lang" } }, { kind: "Field", name: { kind: "Name", value: "hotelName" } }, { kind: "Field", name: { kind: "Name", value: "isShowBestRateNotice" } }, { kind: "Field", name: { kind: "Name", value: "clientContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserveFailedReason" } }, { kind: "Field", name: { kind: "Name", value: "planQueryFilter" } }] } }, { kind: "Field", name: { kind: "Name", value: "prevState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "reservedStock" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "roomGroupID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentState" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "planID" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "baseRoomID" } }, { kind: "Field", name: { kind: "Name", value: "baseRoomName" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "dailyItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "consumedStock" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomID" } }, { kind: "Field", name: { kind: "Name", value: "uniqueGroupID" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerDateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "optionPerReservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "willReserve" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "willCancel" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "optionID" } }, { kind: "Field", name: { kind: "Name", value: "subOptionID" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "stayDates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "cancelPrice" } }, { kind: "Field", name: { kind: "Name", value: "cancelPriceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "stayStartDt" } }, { kind: "Field", name: { kind: "Name", value: "stayLastDt" } }] } }, { kind: "Field", name: { kind: "Name", value: "groupInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "asCosleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "uniqueRoomID" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "voucherCode" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionAnswerInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "questionID" } }, { kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalFeeID" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "priceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "priceHostInserted" } }, { kind: "Field", name: { kind: "Name", value: "sessionResourceUUID" } }] } }, { kind: "Field", name: { kind: "Name", value: "agreementOfTermsOfService" } }, { kind: "Field", name: { kind: "Name", value: "isMailMagazineAccept" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "prevTotalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceBeforeDiscount" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceDiscounted" } }, { kind: "Field", name: { kind: "Name", value: "voucherDiscountPrice" } }, { kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "rawPricePlan" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceRoom" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceOption" } }, { kind: "Field", name: { kind: "Name", value: "rawPriceAdditionalFee" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationContext" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isTestReservation" } }, { kind: "Field", name: { kind: "Name", value: "reservationEditMode" } }] } }, { kind: "Field", name: { kind: "Name", value: "reserveStatus" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCompleteDate" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompletePlan" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRoom" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteDateTabbedTimeSelectionOption" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteRequiredOptionGroup" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteGuestInfo" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteQuestionAndAnswer" } }, { kind: "Field", name: { kind: "Name", value: "isCompleteAgreementOfTermsOfService" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isPlanSelectRequired" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomSelect" } }, { kind: "Field", name: { kind: "Name", value: "isShowRoomForGuest" } }, { kind: "Field", name: { kind: "Name", value: "isShowDiscountInput" } }, { kind: "Field", name: { kind: "Name", value: "isShowOptionSelect" } }, { kind: "Field", name: { kind: "Name", value: "optionSelectionMode" } }, { kind: "Field", name: { kind: "Name", value: "isRequiredOptionGroupSatisfiableWithRegularOption" } }, { kind: "Field", name: { kind: "Name", value: "isAddressInputRequired" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanFilter" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanSelect" } }, { kind: "Field", name: { kind: "Name", value: "isRequestReservation" } }, { kind: "Field", name: { kind: "Name", value: "isShowCalendarPrice" } }, { kind: "Field", name: { kind: "Name", value: "isShowPlanIncludedPrice" } }, { kind: "Field", name: { kind: "Name", value: "canCancelReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateReservation" } }, { kind: "Field", name: { kind: "Name", value: "canUpdateOnlyOptionReservation" } }, { kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "checkInOutPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "checkInStart" } }, { kind: "Field", name: { kind: "Name", value: "checkInEnd" } }, { kind: "Field", name: { kind: "Name", value: "checkOut" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultCancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lastUpdatedAt" } }] } }] };
var w2 = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.Room = "ROOM", e))(w2 || {}), ga = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.PersonOnlyKids = "PERSON_ONLY_KIDS", e.Room = "ROOM", e))(ga || {}), P2 = /* @__PURE__ */ ((e) => (e.PerDate = "PER_DATE", e.PerReservation = "PER_RESERVATION", e))(P2 || {}), R2 = /* @__PURE__ */ ((e) => (e.Jpy = "jpy", e))(R2 || {}), T2 = /* @__PURE__ */ ((e) => (e.Cin = "CIN", e.MiddleDay = "MIDDLE_DAY", e.NotSelected = "NOT_SELECTED", e))(T2 || {}), j2 = /* @__PURE__ */ ((e) => (e.Cin = "CIN", e.Cout = "COUT", e.DayTripSelected = "DAY_TRIP_SELECTED", e.MiddleDay = "MIDDLE_DAY", e.NotSelected = "NOT_SELECTED", e))(j2 || {}), Gd = /* @__PURE__ */ ((e) => (e.Building = "Building", e.Cottage = "Cottage", e.Room = "Room", e.Space = "Space", e.Tent = "Tent", e))(Gd || {}), A2 = /* @__PURE__ */ ((e) => (e.Minus = "minus", e.NotAvailable = "not_available", e.Ratio = "ratio", e.Static = "static", e))(A2 || {}), Vr = /* @__PURE__ */ ((e) => (e.Default = "default", e.En = "en", e))(Vr || {}), O2 = /* @__PURE__ */ ((e) => (e.Breakfast = "BREAKFAST", e.Dinner = "DINNER", e.Lunch = "LUNCH", e.RoomOnly = "ROOM_ONLY", e))(O2 || {}), E2 = /* @__PURE__ */ ((e) => (e.None = "None", e.RegularOnly = "RegularOnly", e.TimeSlotAndRegular = "TimeSlotAndRegular", e.TimeSlotOnly = "TimeSlotOnly", e))(E2 || {}), kr = /* @__PURE__ */ ((e) => (e.Goods = "GOODS", e.Service = "SERVICE", e))(kr || {}), J2 = /* @__PURE__ */ ((e) => (e.Credit = "CREDIT", e.Free = "FREE", e.Local = "LOCAL", e.Test = "TEST", e))(J2 || {}), _2 = /* @__PURE__ */ ((e) => (e.AllPlans = "ALL_PLANS", e.OnlyAccommodationPlans = "ONLY_ACCOMMODATION_PLANS", e.OnlyDayTripPlans = "ONLY_DAY_TRIP_PLANS", e))(_2 || {}), Q2 = /* @__PURE__ */ ((e) => (e.Check = "CHECK", e.Free = "FREE", e.Radio = "RADIO", e.Select = "SELECT", e))(Q2 || {}), M2 = /* @__PURE__ */ ((e) => (e.EditReservation = "EDIT_RESERVATION", e.EditReservationAuthorizedFailed = "EDIT_RESERVATION_AUTHORIZED_FAILED", e.EditReservationCreditCardOnly = "EDIT_RESERVATION_CREDIT_CARD_ONLY", e.EditReservationOptionUpdateOnly = "EDIT_RESERVATION_OPTION_UPDATE_ONLY", e.NewReservation = "NEW_RESERVATION", e))(M2 || {}), L2 = /* @__PURE__ */ ((e) => (e.PaymentFailed = "PAYMENT_FAILED", e.StockIsNotAvailable = "STOCK_IS_NOT_AVAILABLE", e))(L2 || {}), $2 = /* @__PURE__ */ ((e) => (e.CreditCardContinuedUse = "CREDIT_CARD_CONTINUED_USE", e.CreditCardNewlyRegistration = "CREDIT_CARD_NEWLY_REGISTRATION", e.Free = "FREE", e.Local = "LOCAL", e.Test = "TEST", e))($2 || {}), U2 = /* @__PURE__ */ ((e) => (e.Available = "AVAILABLE", e.Few = "FEW", e.Full = "FULL", e))(U2 || {});
const nge = {
  "\n	query RCEReservationInitialSessionState($hotelId: ID!, $reservationId: ID!) {\n		reservationInitialSessionStateForEdit(hotelID: $hotelId, reservationID: $reservationId) {\n			reservationSessionState {\n				...ReservationSessionStateFragment\n			}\n		}\n	}\n": vw,
  "\n	fragment ReservationSessionStateFragment on ReservationSessionState {\n		id\n		hotelID\n		sessionID\n		reservationID\n		lang\n		hotelName\n		isShowBestRateNotice\n		clientContext {\n			reserveFailedReason\n			planQueryFilter\n		}\n		prevState {\n			groupInfo {\n				uniqueRoomID\n				adultNum\n				kidsNum {\n					age\n					asCosleeping\n				}\n			}\n			dateInfo {\n				stayStartDt\n				stayLastDt\n			}\n			defaultCancelPolicy {\n				beforeDays\n				chargeRatio\n			}\n			planInfo {\n				reserved {\n					planID\n					cancelPolicy {\n						beforeDays\n						chargeRatio\n					}\n					amount\n					price\n					priceDiscounted\n					priceHostInserted\n					sessionResourceUUID\n				}\n				canceled {\n					planID\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n					name\n					sessionResourceUUID\n				}\n			}\n			roomInfo {\n				reserved {\n					uniqueGroupID\n					dailyInfo {\n						sessionResourceUUID\n						roomID\n						date\n						reservedStock\n						price\n						priceDiscounted\n						priceHostInserted\n					}\n				}\n				canceled {\n					roomID\n					date\n					name\n					roomGroupID\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n					sessionResourceUUID\n				}\n			}\n			optionPerDateInfo {\n				reserved {\n					optionID\n					subOptionID\n					amount\n					date\n					price\n					priceDiscounted\n					priceHostInserted\n					sessionResourceUUID\n					cancelPolicy {\n						beforeDays\n						chargeRatio\n					}\n				}\n				canceled {\n					sessionResourceUUID\n					optionID\n					subOptionID\n					amount\n					date\n					name\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n				}\n			}\n			optionPerReservationInfo {\n				reserved {\n					optionID\n					subOptionID\n					amount\n					price\n					priceDiscounted\n					priceHostInserted\n					sessionResourceUUID\n					cancelPolicy {\n						beforeDays\n						chargeRatio\n					}\n				}\n				canceled {\n					sessionResourceUUID\n					optionID\n					subOptionID\n					amount\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n					name\n				}\n			}\n			guestInfo {\n				name\n				nameKana\n				email\n				postalCode\n				address\n				tel\n			}\n			discountInfo {\n				discountID\n				discountPrice\n				name\n			}\n			voucherInfo {\n				voucherCode\n				discountPrice\n			}\n			questionAnswerInfo {\n				questionID\n				question\n				answers\n			}\n		}\n		currentState {\n			planInfo {\n				willReserve {\n					planID\n					name\n					cancelPolicy {\n						beforeDays\n						chargeRatio\n					}\n					sessionResourceUUID\n					price\n					priceDiscounted\n					priceHostInserted\n				}\n				willCancel {\n					planID\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					sessionResourceUUID\n					cancelPriceHostInserted\n					name\n				}\n			}\n			roomInfo {\n				willReserve {\n					baseRoomInfo {\n						baseRoomID\n						baseRoomName\n					}\n					uniqueRoomID\n					dailyItems {\n						date\n						roomInfo {\n							roomID\n							name\n							consumedStock\n							name\n							price\n							priceDiscounted\n							sessionResourceUUID\n							priceHostInserted\n						}\n					}\n				}\n				willCancel {\n					roomID\n					uniqueGroupID\n					date\n					name\n					cancelPrice\n					sessionResourceUUID\n					cancelPriceHostInserted\n				}\n			}\n			optionPerDateInfo {\n				willReserve {\n					optionID\n					subOptionID\n					amount\n					date\n					name\n					price\n					priceDiscounted\n					priceHostInserted\n					name\n					sessionResourceUUID\n				}\n				willCancel {\n					optionID\n					subOptionID\n					amount\n					date\n					name\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n					sessionResourceUUID\n				}\n			}\n			optionPerReservationInfo {\n				willReserve {\n					optionID\n					subOptionID\n					amount\n					name\n					price\n					priceDiscounted\n					priceHostInserted\n					name\n					sessionResourceUUID\n				}\n				willCancel {\n					optionID\n					subOptionID\n					amount\n					stayDates {\n						stayStartDt\n						stayLastDt\n					}\n					price\n					priceDiscounted\n					priceHostInserted\n					cancelPrice\n					cancelPriceHostInserted\n					name\n					sessionResourceUUID\n				}\n			}\n			dateInfo {\n				stayStartDt\n				stayLastDt\n			}\n			groupInfo {\n				kidsNum {\n					age\n					asCosleeping\n				}\n				uniqueRoomID\n				adultNum\n			}\n			guestInfo {\n				name\n				nameKana\n				email\n				postalCode\n				address\n				tel\n			}\n			discountInfo {\n				discountID\n				name\n				discountPrice\n			}\n			voucherInfo {\n				voucherCode\n				discountPrice\n				name\n			}\n			questionAnswerInfo {\n				questionID\n				question\n				answers\n			}\n			additionalFeeInfo {\n				additionalFeeID\n				name\n				price\n				priceDiscounted\n				priceHostInserted\n				sessionResourceUUID\n			}\n			agreementOfTermsOfService\n			isMailMagazineAccept\n		}\n		priceInfo {\n			prevTotalGuestCharge\n			totalPriceBeforeDiscount\n			totalPriceDiscounted\n			voucherDiscountPrice\n			totalGuestCharge\n			rawPricePlan\n			rawPriceRoom\n			rawPriceOption\n			rawPriceAdditionalFee\n		}\n		reservationContext {\n			isTestReservation\n			reservationEditMode\n		}\n		reserveStatus {\n			isCompleteDate\n			isCompleteGroup\n			isCompletePlan\n			isCompleteRoom\n			isCompleteOption\n			isCompleteDateTabbedTimeSelectionOption\n			isCompleteRequiredOptionGroup\n			isCompleteGuestInfo\n			isCompleteQuestionAndAnswer\n			isCompleteAgreementOfTermsOfService\n		}\n		reservationPolicy {\n			isPlanSelectRequired\n			isDayTrip\n			isShowRoomSelect\n			isShowRoomForGuest\n			isShowDiscountInput\n			isShowOptionSelect\n			optionSelectionMode\n			isRequiredOptionGroupSatisfiableWithRegularOption\n			isAddressInputRequired\n			isShowPlanFilter\n			isShowPlanSelect\n			isRequestReservation\n			isShowCalendarPrice\n			isShowPlanIncludedPrice\n			canCancelReservation\n			canUpdateReservation\n			canUpdateOnlyOptionReservation\n			customTypeRoomTitle\n			checkInOutPolicy {\n				checkInStart\n				checkInEnd\n				checkOut\n			}\n			defaultCancelPolicy {\n				beforeDays\n				chargeRatio\n			}\n		}\n		lastUpdatedAt\n	}\n": fw,
  "\n	mutation PriceUpdate($baseInfo: BaseInfoInput!, $priceInfo: PriceUpdateInput!) {\n		priceUpdate(baseInfo: $baseInfo, priceInfo: $priceInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": hw,
  "\n	mutation EditDateDateRemove($baseInfo: BaseInfoInput!) {\n		dateRemove(baseInfo: $baseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": pw,
  "\n	mutation EditDateDateUpdate($baseInfo: BaseInfoInput!, $dateInfo: DateUpdateInput!) {\n		dataUpdate(baseInfo: $baseInfo, dateInfo: $dateInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": Nw,
  "\n	query EditDateDateCoutAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateCoutAvailableInput!) {\n		dateCoutAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {\n			availableCoutDates {\n				date\n				currentViewState\n				selectable\n				available\n				dailyMinimumPrice\n			}\n		}\n	}\n": Sw,
  "\n	query EditDateDateStayStartAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateStayStartAvailableInput!) {\n		dateStayStartAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {\n			availableStayStartDates {\n				date\n				currentViewState\n				selectable\n				available\n				dailyMinimumPrice\n			}\n		}\n	}\n": gw,
  "\n	query EditDateInitialize($baseInfo: BaseInfoInput!) {\n		metaData(baseInfo: $baseInfo) {\n			metaData {\n				isDayTrip\n			}\n		}\n		staticPriceDataAvailable(baseInfo: $baseInfo) {\n			availableStaticPriceData {\n				planBillingPricePerDate\n				planBillingPricePerReservation\n				requiredOptionBillingMinimumPricePerDate\n				requiredOptionBillingMinimumPricePerReservation\n			}\n		}\n	}\n": Fw,
  "\n	mutation EditDiscountDiscountRemove($baseInfo: BaseInfoInput!) {\n		discountRemove(baseInfo: $baseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": Iw,
  "\n	mutation EditDiscountDiscountUpdate($baseInfo: BaseInfoInput!, $discountInfo: DiscountUpdateInput!) {\n		discountUpdate(baseInfo: $baseInfo, discountInfo: $discountInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": yw,
  "\n	query EditDiscountDiscountAvailable($baseInfo: BaseInfoInput!) {\n		discountAvailable(baseInfo: $baseInfo) {\n			availableDiscounts {\n				discountName\n				discountCode\n			}\n		}\n	}\n": bw,
  "\n	mutation EditGroupGroupAdd($baseInfo: BaseInfoInput!) {\n		groupAdd(baseInfo: $baseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": Cw,
  "\n	mutation EditGroupGroupUpdate($baseInfo: BaseInfoInput!, $groupInfo: [GroupUpdateInput!]!) {\n		groupUpdate(baseInfo: $baseInfo, groupInfo: $groupInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": xw,
  "\n	query EditGroupGroupAvailable($baseInfo: BaseInfoInput!) {\n		groupAvailable(baseInfo: $baseInfo) {\n			availableGroup {\n				minimumGroupNum\n				maximumGroupNum\n				maximumTotalNumPerGroup\n				maximumAdultNumPerGroup\n				maximumChildNumPerGroup\n				maximumChildAge\n				maximumCoSleepingAge\n			}\n		}\n	}\n": Dw,
  "\n	mutation EditOptionOptionUpdateMutation($baseInfo: BaseInfoInput!, $optionInfo: OptionUpdateInput!) {\n		optionUpdate(baseInfo: $baseInfo, optionInfo: $optionInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": ww,
  "\n	query EditOptionAvailableOptions($baseInfo: BaseInfoInput!) {\n		optionAvailable(baseInfo: $baseInfo) {\n			availableOptions {\n				optionID\n				billingTypeTerm\n				billingTypeTarget\n				optionType\n				name\n				description\n				isRequired\n				isDateTabbedTimeSelectionEnabled\n				isDateTabbedTimeSelectionTarget\n				isOneOfRequired\n				keyVisuals\n				cancelPolicy {\n					beforeDays\n					chargeRatio\n				}\n				detail {\n					... on OptionBillingPerDate {\n						isNextMorning\n						price\n						minimumSoldAmount\n						dailyItems {\n							date\n							availableChoices\n						}\n					}\n					... on OptionBillingPerReservation {\n						price\n						minimumSoldAmount\n						availableChoices\n					}\n					... on SubOptionBillingPerDate {\n						multiSelectAvailable\n						minimumSoldAmount\n						dailyItems {\n							date\n							maxSoldAmount\n							subOptionItems {\n								subOptionID\n								name\n								price\n								availableChoices\n								isNextMorning\n								startAt\n								endAt\n								isShowTimeSchedule\n							}\n						}\n					}\n					... on SubOptionBillingPerReservation {\n						multiSelectAvailable\n						maxSoldAmount\n						minimumSoldAmount\n						items {\n							subOptionID\n							name\n							price\n							availableChoices\n							startAt\n							endAt\n							isShowTimeSchedule\n						}\n					}\n				}\n			}\n		}\n	}\n": Pw,
  "\n	mutation RCEPlanUpdate($baseInfo: BaseInfoInput!, $planInfo: PlanUpdateInput!) {\n		planUpdate(baseInfo: $baseInfo, planInfo: $planInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": Rw,
  "\n	query RCEPlanAvailable($baseInfo: BaseInfoInput!) {\n		planAvailable(baseInfo: $baseInfo) {\n			availablePlans {\n				planID\n				name\n				description\n				isDayTrip\n				includedMeals\n				minRoomNum\n				requiredOptions {\n					priceType\n					priceTarget\n					optionType\n					optionID\n					name\n					minimumPrice\n					isOneOfRequired\n				}\n				price\n				priceType\n				keyVisuals\n				article\n				cancelPolicy {\n					beforeDays\n					chargeRatio\n				}\n				kidsPolicy {\n					kidsMaxAge\n					kidsDiscountType\n					ratio\n					static\n					unavailable\n				}\n				checkInOutPolicy {\n					checkInStartTime\n					checkInEndTime\n					checkOutEndTime\n				}\n				isUnCancelable\n				priceTarget\n			}\n		}\n	}\n": Tw,
  "\n	mutation EditRoomRoomEachUpdate($baseInfo: BaseInfoInput!, $roomEachInfo: RoomEachUpdateInput!) {\n		roomEachUpdate(baseInfo: $baseInfo, roomEachInfo: $roomEachInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": jw,
  "\n	query EditRoomRoomEachAvailable($baseInfo: BaseInfoInput!, $roomInfo: RoomAvailableInput!) {\n		roomEachAvailable(baseInfo: $baseInfo, roomInfo: $roomInfo) {\n			availableRoomsList {\n				date\n				availableRooms {\n					roomID\n					name\n					capacityPeopleMaximum\n					isDormitory\n					keyVisuals\n					price\n					roomSize\n					beds {\n						bedType\n						bedNum\n					}\n					capacityPeopleMaximum\n				}\n			}\n		}\n	}\n": Aw,
  "\n	query RCEReservationReset($hotelId: ID!, $reservationId: ID!) {\n		reservationInitialSessionStateForEdit(hotelID: $hotelId, reservationID: $reservationId) {\n			reservationSessionState {\n				...ReservationSessionStateFragment\n			}\n		}\n	}\n": Ow,
  "\n	mutation RCEReservationUpdate($baseInfo: BaseInfoInput!) {\n		reserveWithoutPaymentMethodChange(baseInfo: $baseInfo) {\n			...ReservationSessionStateFragment\n		}\n	}\n": Ew
};
function hi(e) {
  var n;
  return (n = nge[e]) != null ? n : {};
}
const ige = hi(
  /* GraphQL */
  `
	mutation PriceUpdate($baseInfo: BaseInfoInput!, $priceInfo: PriceUpdateInput!) {
		priceUpdate(baseInfo: $baseInfo, priceInfo: $priceInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), tge = {}, R9 = (e) => {
  let n;
  const i = /* @__PURE__ */ new Set(), t = (u, k) => {
    const m = typeof u == "function" ? u(n) : u;
    if (!Object.is(m, n)) {
      const f = n;
      n = (k != null ? k : typeof m != "object" || m === null) ? m : Object.assign({}, n, m), i.forEach((p) => p(n, f));
    }
  }, a = () => n, d = { setState: t, getState: a, getInitialState: () => c, subscribe: (u) => (i.add(u), () => i.delete(u)), destroy: () => {
    (tge ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), i.clear();
  } }, c = n = e(t, a, d);
  return d;
}, age = (e) => e ? R9(e) : R9;
var hf = { exports: {} }, C3 = {}, wc = { exports: {} }, x3 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var T9;
function lge() {
  if (T9) return x3;
  T9 = 1;
  var e = K;
  function n(k, m) {
    return k === m && (k !== 0 || 1 / k === 1 / m) || k !== k && m !== m;
  }
  var i = typeof Object.is == "function" ? Object.is : n, t = e.useState, a = e.useEffect, s = e.useLayoutEffect, r = e.useDebugValue;
  function o(k, m) {
    var f = m(), p = t({ inst: { value: f, getSnapshot: m } }), h = p[0].inst, N = p[1];
    return s(
      function() {
        h.value = f, h.getSnapshot = m, d(h) && N({ inst: h });
      },
      [k, f, m]
    ), a(
      function() {
        return d(h) && N({ inst: h }), k(function() {
          d(h) && N({ inst: h });
        });
      },
      [k]
    ), r(f), f;
  }
  function d(k) {
    var m = k.getSnapshot;
    k = k.value;
    try {
      var f = m();
      return !i(k, f);
    } catch (p) {
      return !0;
    }
  }
  function c(k, m) {
    return m();
  }
  var u = typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined" ? c : o;
  return x3.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, x3;
}
var D3 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j9;
function sge() {
  return j9 || (j9 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(f, p) {
      return f === p && (f !== 0 || 1 / f === 1 / p) || f !== f && p !== p;
    }
    function n(f, p) {
      u || a.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var h = p();
      if (!k) {
        var N = p();
        s(h, N) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), k = !0);
      }
      N = r({
        inst: { value: h, getSnapshot: p }
      });
      var S = N[0].inst, F = N[1];
      return d(
        function() {
          S.value = h, S.getSnapshot = p, i(S) && F({ inst: S });
        },
        [f, h, p]
      ), o(
        function() {
          return i(S) && F({ inst: S }), f(function() {
            i(S) && F({ inst: S });
          });
        },
        [f]
      ), c(h), h;
    }
    function i(f) {
      var p = f.getSnapshot;
      f = f.value;
      try {
        var h = p();
        return !s(f, h);
      } catch (N) {
        return !0;
      }
    }
    function t(f, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var a = K, s = typeof Object.is == "function" ? Object.is : e, r = a.useState, o = a.useEffect, d = a.useLayoutEffect, c = a.useDebugValue, u = !1, k = !1, m = typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined" ? t : n;
    D3.useSyncExternalStore = a.useSyncExternalStore !== void 0 ? a.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), D3;
}
var A9;
function Jw() {
  return A9 || (A9 = 1, process.env.NODE_ENV === "production" ? wc.exports = lge() : wc.exports = sge()), wc.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var O9;
function rge() {
  if (O9) return C3;
  O9 = 1;
  var e = K, n = Jw();
  function i(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var t = typeof Object.is == "function" ? Object.is : i, a = n.useSyncExternalStore, s = e.useRef, r = e.useEffect, o = e.useMemo, d = e.useDebugValue;
  return C3.useSyncExternalStoreWithSelector = function(c, u, k, m, f) {
    var p = s(null);
    if (p.current === null) {
      var h = { hasValue: !1, value: null };
      p.current = h;
    } else h = p.current;
    p = o(
      function() {
        function S(T) {
          if (!F) {
            if (F = !0, y = T, T = m(T), f !== void 0 && h.hasValue) {
              var j = h.value;
              if (f(j, T))
                return x = j;
            }
            return x = T;
          }
          if (j = x, t(y, T)) return j;
          var A = m(T);
          return f !== void 0 && f(j, A) ? (y = T, j) : (y = T, x = A);
        }
        var F = !1, y, x, R = k === void 0 ? null : k;
        return [
          function() {
            return S(u());
          },
          R === null ? void 0 : function() {
            return S(R());
          }
        ];
      },
      [u, k, m, f]
    );
    var N = a(c, p[0], p[1]);
    return r(
      function() {
        h.hasValue = !0, h.value = N;
      },
      [N]
    ), d(N), N;
  }, C3;
}
var w3 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var E9;
function oge() {
  return E9 || (E9 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var n = K, i = Jw(), t = typeof Object.is == "function" ? Object.is : e, a = i.useSyncExternalStore, s = n.useRef, r = n.useEffect, o = n.useMemo, d = n.useDebugValue;
    w3.useSyncExternalStoreWithSelector = function(c, u, k, m, f) {
      var p = s(null);
      if (p.current === null) {
        var h = { hasValue: !1, value: null };
        p.current = h;
      } else h = p.current;
      p = o(
        function() {
          function S(T) {
            if (!F) {
              if (F = !0, y = T, T = m(T), f !== void 0 && h.hasValue) {
                var j = h.value;
                if (f(j, T))
                  return x = j;
              }
              return x = T;
            }
            if (j = x, t(y, T))
              return j;
            var A = m(T);
            return f !== void 0 && f(j, A) ? (y = T, j) : (y = T, x = A);
          }
          var F = !1, y, x, R = k === void 0 ? null : k;
          return [
            function() {
              return S(u());
            },
            R === null ? void 0 : function() {
              return S(R());
            }
          ];
        },
        [u, k, m, f]
      );
      var N = a(c, p[0], p[1]);
      return r(
        function() {
          h.hasValue = !0, h.value = N;
        },
        [N]
      ), d(N), N;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), w3;
}
process.env.NODE_ENV === "production" ? hf.exports = rge() : hf.exports = oge();
var dge = hf.exports;
const cge = /* @__PURE__ */ ls(dge), _w = {}, { useDebugValue: uge } = K, { useSyncExternalStoreWithSelector: mge } = cge;
let J9 = !1;
const kge = (e) => e;
function fge(e, n = kge, i) {
  (_w ? "production" : void 0) !== "production" && i && !J9 && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), J9 = !0);
  const t = mge(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    n,
    i
  );
  return uge(t), t;
}
const vge = (e) => {
  (_w ? "production" : void 0) !== "production" && typeof e != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const n = typeof e == "function" ? age(e) : e, i = (t, a) => fge(n, t, a);
  return Object.assign(i, n), i;
}, Qw = (e) => vge, Mw = Qw()((e) => ({
  session: null,
  updateSession: (n) => e({ session: n }),
  reset: () => e({ session: null })
})), rt = () => {
  const e = Mw((n) => n.session);
  if (P(e))
    throw new Error("Session is null.");
  return {
    session: e
  };
}, $i = () => {
  const { session: e } = rt();
  return {
    baseInfoInput: v(
      () => ({
        hotelID: e.hotelID,
        sessionID: e.sessionID,
        reservationID: e.reservationID,
        lastUpdatedAt: e.lastUpdatedAt
      }),
      [e.hotelID, e.lastUpdatedAt, e.reservationID, e.sessionID]
    )
  };
}, hge = () => {
  const { session: e } = rt();
  return {
    lang: v(() => e.lang, [e.lang])
  };
}, pge = () => {
  const { session: e } = rt();
  return {
    reservationPriceInfo: v(
      () => e.priceInfo,
      [e.priceInfo]
    )
  };
}, V2 = () => {
  const { session: e } = rt();
  return {
    reservationPolicy: v(
      () => e.reservationPolicy,
      [e.reservationPolicy]
    )
  };
}, Nge = () => {
  const { session: e } = rt();
  return {
    reserveStatus: v(
      () => e.reserveStatus,
      [e.reserveStatus]
    )
  };
}, Sge = (e, n) => {
  const [i, { data: t, loading: a }] = qh(e, { ...n, errorPolicy: "all" });
  return {
    mutationFunc: i,
    mutationResult: {
      data: t,
      loading: a
    }
  };
}, gge = ({ getToken: e }) => u7(async (n, { headers: i = {} }) => {
  if (!e) return { headers: i };
  const t = await e();
  return {
    headers: {
      ...i,
      authorization: `Bearer ${t}`
    }
  };
}), Fge = (e) => e.extensions != null && "chillnnErrorMessageForUser" in e.extensions && "chillnnStatusCode" in e.extensions, Ige = (e) => e === Vr.Default ? "ja" : "en", _9 = {
  ja: "エラーが発生しました。時間をおいて再度お試しください。",
  en: "An error occurred. Please try again later."
}, yge = ({ lang: e }) => f2(({ graphQLErrors: n, networkError: i }) => {
  const t = Ige(e);
  if (n != null && n.length) {
    const a = n[0];
    Fge(a) ? window.alert(`${a.extensions.chillnnErrorMessageForUser[t]}`) : window.alert(`${_9[t]}`);
  }
  i && window.alert(_9[t]);
}), bge = ({ httpOptions: e }) => d2(e), Cge = () => Gh(), xge = (e) => new u2({
  link: Mh([
    gge(e),
    yge(e),
    Cge(),
    // httpLinkは最後に設定する必要がある（@see https://www.apollographql.com/docs/react/api/link/introduction#the-terminating-link）
    bge(e)
  ]),
  cache: new c2()
  // connectToDevTools: true,
}), Dge = (e, n, i) => {
  const { data: t, error: a, refetch: s } = k2(e, i ? m2 : { ...n, errorPolicy: "all" });
  return { data: t, refetch: s, error: a };
}, wge = hi(`
	fragment ReservationSessionStateFragment on ReservationSessionState {
		id
		hotelID
		sessionID
		reservationID
		lang
		hotelName
		isShowBestRateNotice
		clientContext {
			reserveFailedReason
			planQueryFilter
		}
		prevState {
			groupInfo {
				uniqueRoomID
				adultNum
				kidsNum {
					age
					asCosleeping
				}
			}
			dateInfo {
				stayStartDt
				stayLastDt
			}
			defaultCancelPolicy {
				beforeDays
				chargeRatio
			}
			planInfo {
				reserved {
					planID
					cancelPolicy {
						beforeDays
						chargeRatio
					}
					amount
					price
					priceDiscounted
					priceHostInserted
					sessionResourceUUID
				}
				canceled {
					planID
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
					name
					sessionResourceUUID
				}
			}
			roomInfo {
				reserved {
					uniqueGroupID
					dailyInfo {
						sessionResourceUUID
						roomID
						date
						reservedStock
						price
						priceDiscounted
						priceHostInserted
					}
				}
				canceled {
					roomID
					date
					name
					roomGroupID
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
					sessionResourceUUID
				}
			}
			optionPerDateInfo {
				reserved {
					optionID
					subOptionID
					amount
					date
					price
					priceDiscounted
					priceHostInserted
					sessionResourceUUID
					cancelPolicy {
						beforeDays
						chargeRatio
					}
				}
				canceled {
					sessionResourceUUID
					optionID
					subOptionID
					amount
					date
					name
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
				}
			}
			optionPerReservationInfo {
				reserved {
					optionID
					subOptionID
					amount
					price
					priceDiscounted
					priceHostInserted
					sessionResourceUUID
					cancelPolicy {
						beforeDays
						chargeRatio
					}
				}
				canceled {
					sessionResourceUUID
					optionID
					subOptionID
					amount
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
					name
				}
			}
			guestInfo {
				name
				nameKana
				email
				postalCode
				address
				tel
			}
			discountInfo {
				discountID
				discountPrice
				name
			}
			voucherInfo {
				voucherCode
				discountPrice
			}
			questionAnswerInfo {
				questionID
				question
				answers
			}
		}
		currentState {
			planInfo {
				willReserve {
					planID
					name
					cancelPolicy {
						beforeDays
						chargeRatio
					}
					sessionResourceUUID
					price
					priceDiscounted
					priceHostInserted
				}
				willCancel {
					planID
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					sessionResourceUUID
					cancelPriceHostInserted
					name
				}
			}
			roomInfo {
				willReserve {
					baseRoomInfo {
						baseRoomID
						baseRoomName
					}
					uniqueRoomID
					dailyItems {
						date
						roomInfo {
							roomID
							name
							consumedStock
							name
							price
							priceDiscounted
							sessionResourceUUID
							priceHostInserted
						}
					}
				}
				willCancel {
					roomID
					uniqueGroupID
					date
					name
					cancelPrice
					sessionResourceUUID
					cancelPriceHostInserted
				}
			}
			optionPerDateInfo {
				willReserve {
					optionID
					subOptionID
					amount
					date
					name
					price
					priceDiscounted
					priceHostInserted
					name
					sessionResourceUUID
				}
				willCancel {
					optionID
					subOptionID
					amount
					date
					name
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
					sessionResourceUUID
				}
			}
			optionPerReservationInfo {
				willReserve {
					optionID
					subOptionID
					amount
					name
					price
					priceDiscounted
					priceHostInserted
					name
					sessionResourceUUID
				}
				willCancel {
					optionID
					subOptionID
					amount
					stayDates {
						stayStartDt
						stayLastDt
					}
					price
					priceDiscounted
					priceHostInserted
					cancelPrice
					cancelPriceHostInserted
					name
					sessionResourceUUID
				}
			}
			dateInfo {
				stayStartDt
				stayLastDt
			}
			groupInfo {
				kidsNum {
					age
					asCosleeping
				}
				uniqueRoomID
				adultNum
			}
			guestInfo {
				name
				nameKana
				email
				postalCode
				address
				tel
			}
			discountInfo {
				discountID
				name
				discountPrice
			}
			voucherInfo {
				voucherCode
				discountPrice
				name
			}
			questionAnswerInfo {
				questionID
				question
				answers
			}
			additionalFeeInfo {
				additionalFeeID
				name
				price
				priceDiscounted
				priceHostInserted
				sessionResourceUUID
			}
			agreementOfTermsOfService
			isMailMagazineAccept
		}
		priceInfo {
			prevTotalGuestCharge
			totalPriceBeforeDiscount
			totalPriceDiscounted
			voucherDiscountPrice
			totalGuestCharge
			rawPricePlan
			rawPriceRoom
			rawPriceOption
			rawPriceAdditionalFee
		}
		reservationContext {
			isTestReservation
			reservationEditMode
		}
		reserveStatus {
			isCompleteDate
			isCompleteGroup
			isCompletePlan
			isCompleteRoom
			isCompleteOption
			isCompleteDateTabbedTimeSelectionOption
			isCompleteRequiredOptionGroup
			isCompleteGuestInfo
			isCompleteQuestionAndAnswer
			isCompleteAgreementOfTermsOfService
		}
		reservationPolicy {
			isPlanSelectRequired
			isDayTrip
			isShowRoomSelect
			isShowRoomForGuest
			isShowDiscountInput
			isShowOptionSelect
			optionSelectionMode
			isRequiredOptionGroupSatisfiableWithRegularOption
			isAddressInputRequired
			isShowPlanFilter
			isShowPlanSelect
			isRequestReservation
			isShowCalendarPrice
			isShowPlanIncludedPrice
			canCancelReservation
			canUpdateReservation
			canUpdateOnlyOptionReservation
			customTypeRoomTitle
			checkInOutPolicy {
				checkInStart
				checkInEnd
				checkOut
			}
			defaultCancelPolicy {
				beforeDays
				chargeRatio
			}
		}
		lastUpdatedAt
	}
`), Pge = (e) => ege(
  wge,
  e
), Rge = (e) => Pge(e), ka = () => {
  const e = Mw((i) => i.updateSession);
  return {
    onUpdateSession: I(
      (i) => {
        const t = Rge(i);
        e(t);
      },
      [e]
    )
  };
}, Lw = () => {
  const { session: e } = rt();
  return {
    additionalFeeInfo: v(
      () => e.currentState.additionalFeeInfo,
      [e.currentState.additionalFeeInfo]
    )
  };
}, $w = () => {
  const { session: e } = rt(), n = v(() => P(e.currentState.dateInfo) ? null : e.currentState.dateInfo, [e.currentState.dateInfo]), i = I(() => Ke(n == null ? void 0 : n.stayStartDt) ? null : n.stayStartDt, [n == null ? void 0 : n.stayStartDt]), t = I(
    ({ isDayTrip: a }) => {
      const s = i();
      return P(s) || Ke(n == null ? void 0 : n.stayLastDt) ? null : a ? s : Ci({ date: n.stayLastDt, inc: 1 });
    },
    [n == null ? void 0 : n.stayLastDt, i]
  );
  return {
    dateInfo: n,
    onGetStayStartDt: i,
    onGetStayLastDt: t
  };
}, Uw = () => {
  const { session: e } = rt();
  return {
    discountInfo: v(
      () => {
        var i;
        return (i = e.currentState.discountInfo) != null ? i : null;
      },
      [e.currentState.discountInfo]
    )
  };
}, H2 = () => {
  const { session: e } = rt();
  return {
    groupInfo: v(
      () => e.currentState.groupInfo,
      [e.currentState.groupInfo]
    )
  };
}, dp = () => {
  const {
    session: {
      currentState: { optionPerDateInfo: e, optionPerReservationInfo: n }
    }
  } = rt();
  return {
    optionPerDateInfo: e,
    optionPerReservationInfo: n
  };
}, Vw = () => {
  const { session: e } = rt();
  return {
    planInfo: v(() => e.currentState.planInfo, [e.currentState.planInfo])
  };
}, Hw = () => {
  const { session: e } = rt();
  return {
    roomInfo: v(() => e.currentState.roomInfo, [e.currentState.roomInfo])
  };
}, zw = () => {
  const { session: e } = rt();
  return {
    voucherInfo: v(
      () => e.currentState.voucherInfo,
      [e.currentState.voucherInfo]
    )
  };
}, cp = () => {
  const {
    session: { prevState: e }
  } = rt(), n = v(() => {
    var t;
    return (t = e == null ? void 0 : e.optionPerDateInfo) != null ? t : null;
  }, [e == null ? void 0 : e.optionPerDateInfo]), i = v(() => {
    var t;
    return (t = e == null ? void 0 : e.optionPerReservationInfo) != null ? t : null;
  }, [e == null ? void 0 : e.optionPerReservationInfo]);
  return {
    optionPerDateInfo: n,
    optionPerReservationInfo: i
  };
}, Bw = () => {
  var i;
  const { session: e } = rt();
  return {
    planInfo: v(() => {
      var t, a;
      return (a = (t = e.prevState) == null ? void 0 : t.planInfo) != null ? a : null;
    }, [(i = e.prevState) == null ? void 0 : i.planInfo])
  };
}, qw = () => {
  var i;
  const { session: e } = rt();
  return {
    roomInfo: v(
      () => {
        var t, a;
        return (a = (t = e.prevState) == null ? void 0 : t.roomInfo) != null ? a : null;
      },
      [(i = e.prevState) == null ? void 0 : i.roomInfo]
    )
  };
}, fa = Sge, za = Dge, Tge = ({ sessionResourceUUID: e }) => {
  const { baseInfoInput: n } = $i(), { onUpdateSession: i } = ka(), { mutationFunc: t } = fa(ige);
  return {
    onUpdatePriceHostInserted: I(
      async (s) => {
        await t({
          variables: {
            baseInfo: n,
            priceInfo: {
              sessionResourceUUID: e,
              price: Ke(s) ? void 0 : Number(s)
            }
          }
        }).then((r) => {
          if (P(r.data))
            throw new Error("data is null or undefined");
          i(r.data.priceUpdate);
        }).catch(() => {
        });
      },
      [n, t, i, e]
    )
  };
}, f1 = g(({ initData: e }) => {
  var r;
  const { onUpdatePriceHostInserted: n } = Tge({
    sessionResourceUUID: e.sessionResourceUUID
  }), [i, t] = se((r = e.priceHostInserted) != null ? r : void 0), a = I((o) => {
    if (Ke(o.currentTarget.value)) {
      t(void 0);
      return;
    }
    const d = Number(o.currentTarget.value);
    isNaN(d) || d < 0 ? t(void 0) : t(d);
  }, []), s = I(
    (o) => {
      o.preventDefault();
      const d = o.currentTarget.value;
      n(d);
    },
    [n]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-4", children: [
    /* @__PURE__ */ l.jsxs("p", { className: "ch-text-bold ch-text-lg", children: [
      "¥",
      e.staticRawPrice.toLocaleString()
    ] }),
    /* @__PURE__ */ l.jsx(Ap, {}),
    P(e.priceDiscounted) ? null : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsxs("p", { className: "ch-text-bold ch-text-lg", children: [
        "¥",
        e.priceDiscounted.toLocaleString()
      ] }),
      /* @__PURE__ */ l.jsx(Ap, {})
    ] }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-2", children: [
      /* @__PURE__ */ l.jsx(
        Qa,
        {
          type: "number",
          min: 0,
          inputMode: "numeric",
          value: i != null ? i : "",
          onChange: a,
          onBlur: s
        }
      ),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg", children: "円" })
    ] })
  ] });
}), jge = g((e) => {
  const { state: n } = ZSe(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx("div", { className: "ch-rounded ch-px-4 ch-py-6", style: { background: "rgba(236,237,229)" }, children: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: n.additionalFeeList.map((i, t) => {
    const a = `${i.name}-${t}`;
    return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
      /* @__PURE__ */ l.jsx("p", { children: i.name }),
      /* @__PURE__ */ l.jsx(
        f1,
        {
          initData: {
            sessionResourceUUID: i.sessionResourceUUID,
            staticRawPrice: i.price,
            priceDiscounted: i.priceDiscounted,
            priceHostInserted: i.priceHostInserted
          }
        }
      )
    ] }, a);
  }) }) }) : null;
}), Age = g(() => {
  const { additionalFeeInfo: e } = Lw();
  return /* @__PURE__ */ l.jsx(
    jge,
    {
      currentState: {
        additionalFee: e
      }
    }
  );
}), Oge = hi(
  /* GraphQL */
  `
	query EditDateDateCoutAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateCoutAvailableInput!) {
		dateCoutAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			availableCoutDates {
				date
				currentViewState
				selectable
				available
				dailyMinimumPrice
			}
		}
	}
`
), Ege = hi(
  /* GraphQL */
  `
	query EditDateDateStayStartAvailable($baseInfo: BaseInfoInput!, $dateInfo: DateStayStartAvailableInput!) {
		dateStayStartAvailable(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			availableStayStartDates {
				date
				currentViewState
				selectable
				available
				dailyMinimumPrice
			}
		}
	}
`
), Jge = hi(
  /* GraphQL */
  `
	query EditDateInitialize($baseInfo: BaseInfoInput!) {
		metaData(baseInfo: $baseInfo) {
			metaData {
				isDayTrip
			}
		}
		staticPriceDataAvailable(baseInfo: $baseInfo) {
			availableStaticPriceData {
				planBillingPricePerDate
				planBillingPricePerReservation
				requiredOptionBillingMinimumPricePerDate
				requiredOptionBillingMinimumPricePerReservation
			}
		}
	}
`
), _ge = hi(
  /* GraphQL */
  `
	mutation EditDateDateRemove($baseInfo: BaseInfoInput!) {
		dateRemove(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Qge = hi(
  /* GraphQL */
  `
	mutation EditDateDateUpdate($baseInfo: BaseInfoInput!, $dateInfo: DateUpdateInput!) {
		dataUpdate(baseInfo: $baseInfo, dateInfo: $dateInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), Mge = ({ baseInfoInput: e, onSetAvailableCoutDateList: n }) => {
  const i = I(
    (s) => (r) => (o) => {
      if (Ht({ targetDate: s, compareDate: r })) {
        const { lastDate: c } = gt(s);
        return {
          stayStartDt: o,
          endDt: c
        };
      }
      const { lastDate: d } = gt(r);
      return {
        stayStartDt: o,
        endDt: d
      };
    },
    []
  ), { refetch: t } = za(Oge, void 0, !0);
  return {
    onAvailableCoutDateListQuery: I(
      (s) => (r) => async () => {
        const o = i(s.from)(s.to)(r), d = await t({
          baseInfo: e,
          dateInfo: o
        });
        if (P(d.data))
          throw new Error("availableStayLastDates is null or undefined.");
        n(d.data.dateCoutAvailable.availableCoutDates);
      },
      [i, t, e, n]
    )
  };
}, Lge = ({ baseInfoInput: e, onSetAvailableStayStartDateList: n }) => {
  const i = I(
    (s) => (r) => {
      if (Ht({ targetDate: s, compareDate: r })) {
        const { firstDate: c, lastDate: u } = gt(s);
        return {
          startDt: c,
          endDt: u
        };
      }
      const { firstDate: o } = gt(s), { lastDate: d } = gt(r);
      return {
        startDt: o,
        endDt: d
      };
    },
    []
  ), { refetch: t } = za(
    Ege,
    void 0,
    !0
  );
  return {
    onAvailableStayStartDateListQuery: I(
      (s) => async () => {
        const r = i(s.from)(s.to);
        await t({
          baseInfo: e,
          dateInfo: r
        }).then(({ data: o }) => {
          if (P(o))
            throw new Error("availableStayStartDates is null or undefined.");
          n(o.dateStayStartAvailable.availableStayStartDates);
        }).catch(() => {
        });
      },
      [i, e, n, t]
    )
  };
}, $ge = () => {
  const [e, n] = se([]), i = I((c) => {
    n(c);
  }, []), [t, a] = se([]), s = I((c) => {
    a(c);
  }, []), { baseInfoInput: r } = $i(), { onAvailableStayStartDateListQuery: o } = Lge({
    baseInfoInput: r,
    onSetAvailableStayStartDateList: i
  }), { onAvailableCoutDateListQuery: d } = Mge({
    baseInfoInput: r,
    onSetAvailableCoutDateList: s
  });
  return {
    availableStayStartDateList: e,
    availableCoutDateList: t,
    onAvailableStayStartDateListQuery: o,
    onAvailableCoutDateListQuery: d
  };
}, Uge = () => {
  const { baseInfoInput: e } = $i(), { refetch: n } = za(Jge, void 0, !0);
  return {
    onInitializeDataQuery: I(async () => {
      const t = await n({ baseInfo: e });
      if (t.error || !P(t.errors) && !ke([...t.errors]) || P(t.data))
        throw new Error("Failed to fetch initialize data for date.");
      return {
        metaData: t.data.metaData.metaData,
        availableStaticPriceData: t.data.staticPriceDataAvailable.availableStaticPriceData
      };
    }, [e, n])
  };
}, Vge = () => {
  const { lang: e } = hge(), { reservationPolicy: n } = V2(), { dateInfo: i } = $w();
  return {
    lang: e,
    reservationPolicy: n,
    currentState: {
      dateInfo: i
    }
  };
}, Hge = ({ baseInfoInput: e, onUpdateSession: n }) => {
  const { mutationFunc: i } = fa(_ge);
  return {
    onRemoveReservationStayDt: I(async () => {
      await i({
        variables: { baseInfo: e }
      }).then((a) => {
        if (P(a.data))
          throw new Error("dateRemove is null or undefined.");
        n(a.data.dateRemove);
      }).catch(() => {
      });
    }, [e, i, n])
  };
}, zge = ({ baseInfoInput: e, onUpdateSession: n }) => {
  const { mutationFunc: i } = fa(Qge);
  return {
    onUpdateReservationStayDt: I(
      async (a) => {
        await i({
          variables: { baseInfo: e, dateInfo: a }
        }).then((s) => {
          if (P(s.data))
            throw new Error("updateDate is null or undefined.");
          n(s.data.dataUpdate);
        }).catch(() => {
        });
      },
      [e, i, n]
    )
  };
}, Bge = () => {
  const { baseInfoInput: e } = $i(), { onUpdateSession: n } = ka(), { onRemoveReservationStayDt: i } = Hge({ baseInfoInput: e, onUpdateSession: n }), { onUpdateReservationStayDt: t } = zge({ baseInfoInput: e, onUpdateSession: n });
  return {
    onRemoveReservationStayDt: i,
    onUpdateReservationStayDt: t
  };
}, qge = g(() => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: ce(
      "ch-h-fit ch-max-h-80 ch-min-h-80 ch-w-full ch-animate-pulse ch-rounded-md ch-border-2 ch-border-zinc-200 ch-bg-zinc-300/70"
    )
  }
)), Gw = (e) => e.kind === "NotInitialized" ? {
  kind: "Errored",
  tryCount: 0,
  onRetry: e.onInitialize
} : {
  ...e,
  tryCount: e.tryCount + 1
}, Gge = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitializeDataQuery
}), Ww = () => (e) => ({
  kind: "Initialized",
  metaData: e.metaData,
  availableStaticPriceData: e.availableStaticPriceData
}), Wge = ({ state: e, callbackContext: n }) => {
  const i = I(
    async (a) => {
      try {
        const s = await a.onInitialize();
        n.onChangeState(Ww(a)(s));
      } catch (s) {
        n.onChangeState(Gw(a));
      }
    },
    [n]
  ), t = Ye(!1);
  be(() => {
    t.current || e.kind !== "NotInitialized" || (t.current = !0, i(e));
  }, [i, e]);
}, Kge = (e) => ({
  onRetry: I(
    async (i) => {
      if (i.tryCount >= 3) {
        window.alert("ブラウザを再読み込みしてください");
        return;
      }
      try {
        const t = await i.onRetry();
        e.callbackContext.onChangeState(Ww(i)(t));
      } catch (t) {
        e.callbackContext.onChangeState(Gw(i));
      }
    },
    [e.callbackContext]
  )
}), Yge = (e) => {
  const [n, i] = se(Gge(e)), t = I((s) => {
    i(s);
  }, []);
  Wge({ state: n, callbackContext: { onChangeState: t } });
  const { onRetry: a } = Kge({ callbackContext: { onChangeState: t } });
  return {
    state: n,
    onRetry: a
  };
}, Xge = g(({ children: e, ...n }) => {
  const {
    state: i
    // onRetry
  } = Yge(n);
  return i.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(qge, {}) : i.kind === "Errored" ? /* @__PURE__ */ l.jsx(l.Fragment, {}) : e({ metaData: i.metaData, availableStaticPriceData: i.availableStaticPriceData });
}), Zge = g(() => {
  const {
    availableStayStartDateList: e,
    availableCoutDateList: n,
    onAvailableStayStartDateListQuery: i,
    onAvailableCoutDateListQuery: t
  } = $ge(), a = Vge(), { onRemoveReservationStayDt: s, onUpdateReservationStayDt: r } = Bge(), { onInitializeDataQuery: o } = Uge(), d = I(
    (m) => async (f) => {
      await r({ stayStartDt: f, stayLastDt: f }), await i(m)();
    },
    [i, r]
  ), c = I(
    (m) => async (f) => {
      await t(m)(f)();
    },
    [t]
  ), u = I(
    (m) => (f) => async (p) => {
      await r({
        stayStartDt: f,
        stayLastDt: p
      }), await i(m)();
    },
    [i, r]
  ), k = I(
    async (m) => {
      await s(), await i(m)();
    },
    [i, s]
  );
  return /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: /* @__PURE__ */ l.jsx(Xge, { onInitializeDataQuery: o, children: ({ metaData: m }) => {
    var f, p, h, N;
    return /* @__PURE__ */ l.jsx(
      K5,
      {
        initialDate: Id(),
        onAvailableStayLastDateListQuery: t,
        onAvailableStayStartDateListQuery: i,
        modelContext: {
          lang: a.lang,
          isDayTrip: m.isDayTrip,
          stayStartDt: (p = (f = a.currentState.dateInfo) == null ? void 0 : f.stayStartDt) != null ? p : null,
          stayLastDt: (N = (h = a.currentState.dateInfo) == null ? void 0 : h.stayLastDt) != null ? N : null,
          onSelectDayTripDateCallback: d,
          onSelectDayTripUnSelectableDateCallback: k,
          onSelectStayCinDateCallback: c,
          onSelectStayCoutDateCallback: u,
          onSelectStayUnSelectableDateCallback: k
        },
        calendarContext: {
          sessionStateContext: a,
          availableStayStartDateList: e,
          availableCoutDateList: n
        }
      }
    );
  } }) });
}), e9e = (e) => P(e.currentState.discountInfo) ? {
  kind: "NotDisplayed"
} : {
  kind: "Displayed"
}, n9e = (e) => ({
  state: v(() => e9e(e), [e])
}), i9e = g((e) => {
  const { state: n } = n9e(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-urgent-400", children: "※ディスカウント金額は、上書き前の料金に対して算出されています。" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-urgent-400", children: "※金額に数円の誤差が出る可能性がございます。商品の金額を変更することでご対応ください。" })
  ] }) : null;
}), t9e = g(() => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: ce(
      "ch-h-fit ch-max-h-80 ch-min-h-80 ch-w-full ch-animate-pulse ch-rounded-md ch-border-2 ch-border-zinc-200 ch-bg-zinc-300/70"
    )
  }
)), a9e = (e) => P(e.currentState.discountInfo) ? {
  kind: "NotDisplayed"
} : {
  kind: "Displayed",
  discountPrice: e.currentState.discountInfo.discountPrice
}, l9e = (e) => ({
  state: v(() => a9e(e), [e])
}), s9e = g((e) => {
  const { state: n } = l9e(e), i = v(() => {
    if (n.kind === "Displayed")
      return `- ¥${n.discountPrice.toLocaleString()}`;
  }, [n]);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-bold", children: i }) : null;
}), r9e = (e) => P(e.currentState.discountInfo) ? {
  kind: "NotSelected",
  onSelect: (n) => e.onUpdateDiscount(n)
} : {
  kind: "Selected",
  selectedDiscountName: e.currentState.discountInfo.name,
  onSelect: (n) => e.onUpdateDiscount(n),
  onCancel: () => e.onRemoveDiscount()
}, o9e = (e) => ({
  state: v(() => r9e(e), [e])
}), y1 = {
  discountCode: "no-item",
  discountName: "未選択"
}, d9e = g(({ availableDiscountList: e, ...n }) => {
  const { state: i } = o9e(n), t = I(
    (d) => {
      if (i.kind !== "NotSelected")
        return e.find((c) => c.discountName === d);
    },
    [e, i.kind]
  ), a = I(
    (d) => {
      i.kind === "Selected" ? d !== y1.discountCode ? i.onSelect(d) : i.onCancel() : i.onSelect(d);
    },
    [i]
  ), s = v(() => [y1, ...e], [e]), r = v(() => i.kind === "NotSelected" || P(i.selectedDiscountName) ? y1.discountName : i.selectedDiscountName, [i]), o = v(() => {
    if (i.kind === "NotSelected")
      return y1.discountName;
    const d = t(i.selectedDiscountName);
    return P(d) ? y1.discountName : d.discountName;
  }, [t, i]);
  return /* @__PURE__ */ l.jsxs(n1, { value: r, onValueChange: a, children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-w-full", children: /* @__PURE__ */ l.jsx(cs, { children: /* @__PURE__ */ l.jsx("div", { children: o }) }) }),
    /* @__PURE__ */ l.jsx(us, { children: s.map((d, c) => {
      var m;
      const u = `${d.discountName}_${c}`, k = d.discountName;
      return /* @__PURE__ */ l.jsx(ms, { value: (m = d.discountCode) != null ? m : "", children: k }, u);
    }) })
  ] });
}), c9e = (e) => ({
  kind: "AvailableDataFetched",
  availableDiscountList: e.availableDiscountList
}), u9e = (e) => ({
  kind: "AvailableDataNotFetched",
  onAvailableDiscountListQuery: e.onAvailableDiscountListQuery
}), m9e = (e) => {
  const [n, i] = se(u9e(e)), t = I((a) => {
    i(a);
  }, []);
  return be(() => {
    if (n.kind === "AvailableDataFetched")
      return;
    (async () => {
      const s = await n.onAvailableDiscountListQuery(), r = c9e({ availableDiscountList: s });
      t(r);
    })();
  }, [t, n]), {
    state: n
  };
}, k9e = g(({ currentState: e, onUpdateDiscount: n, onRemoveDiscount: i, ...t }) => {
  const { state: a } = m9e(t);
  return a.kind === "AvailableDataFetched" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-gap-x-6", children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-min-w-[max-content]", children: /* @__PURE__ */ l.jsx(
        d9e,
        {
          availableDiscountList: a.availableDiscountList,
          currentState: e,
          onUpdateDiscount: n,
          onRemoveDiscount: i
        }
      ) }),
      /* @__PURE__ */ l.jsx(s9e, { currentState: e })
    ] }),
    /* @__PURE__ */ l.jsx(i9e, { currentState: e })
  ] }) : /* @__PURE__ */ l.jsx(t9e, {});
}), f9e = hi(
  /* GraphQL */
  `
	query EditDiscountDiscountAvailable($baseInfo: BaseInfoInput!) {
		discountAvailable(baseInfo: $baseInfo) {
			availableDiscounts {
				discountName
				discountCode
			}
		}
	}
`
), v9e = hi(
  /* GraphQL */
  `
	mutation EditDiscountDiscountRemove($baseInfo: BaseInfoInput!) {
		discountRemove(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), h9e = hi(
  /* GraphQL */
  `
	mutation EditDiscountDiscountUpdate($baseInfo: BaseInfoInput!, $discountInfo: DiscountUpdateInput!) {
		discountUpdate(baseInfo: $baseInfo, discountInfo: $discountInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), p9e = () => {
  const { baseInfoInput: e } = $i(), { refetch: n } = za(f9e, void 0, !0);
  return {
    onAvailableDiscountListQuery: I(async () => {
      const { data: t } = await n({ baseInfo: e });
      if (P(t))
        throw new Error("Failed to fetch plan available.");
      return t.discountAvailable.availableDiscounts;
    }, [e, n])
  };
}, N9e = () => {
  const { baseInfoInput: e } = $i(), { onUpdateSession: n } = ka(), { mutationFunc: i } = fa(v9e);
  return {
    onRemoveDiscount: I(async () => {
      await i({
        variables: {
          baseInfo: e
        }
      }).then((a) => {
        if (P(a.data))
          throw new Error();
        n(a.data.discountRemove);
      }).catch(() => {
      });
    }, [e, i, n])
  };
}, S9e = () => {
  const { baseInfoInput: e } = $i(), { onUpdateSession: n } = ka(), { mutationFunc: i } = fa(h9e);
  return {
    onUpdateDiscount: I(
      async (a) => {
        await i({
          variables: {
            baseInfo: e,
            discountInfo: {
              discountCode: a
            }
          }
        }).then((s) => {
          if (P(s.data))
            throw new Error();
          n(s.data.discountUpdate);
        }).catch(() => {
        });
      },
      [e, i, n]
    )
  };
}, g9e = g(() => {
  const { onAvailableDiscountListQuery: e } = p9e(), { onUpdateDiscount: n } = S9e(), { onRemoveDiscount: i } = N9e(), { discountInfo: t } = Uw();
  return /* @__PURE__ */ l.jsx(
    k9e,
    {
      currentState: {
        discountInfo: t
      },
      onAvailableDiscountListQuery: e,
      onUpdateDiscount: n,
      onRemoveDiscount: i
    }
  );
}), F9e = (e) => e.groupInfo.length < e.availableGroup.maximumGroupNum ? {
  kind: "Selectable",
  onSelect: e.onAddGroup
} : {
  kind: "NotSelectable"
}, I9e = (e) => ({
  state: v(() => F9e(e), [e])
}), y9e = g((e) => {
  const { state: n } = I9e(e), i = v(() => n.kind === "NotSelectable", [n.kind]), t = I(() => {
    n.kind === "Selectable" && n.onSelect();
  }, [n]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: i, size: "icon", variant: "outline", onClick: t, children: "新しく部屋を追加する" });
}), b9e = g(() => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-text-right", children: /* @__PURE__ */ l.jsx(
    "div",
    {
      className: ce(
        "ch-h-fit ch-max-h-10 ch-min-h-10 ch-w-40 ch-animate-pulse ch-rounded-md ch-border-2 ch-border-zinc-200 ch-bg-zinc-300/70"
      )
    }
  ) }),
  /* @__PURE__ */ l.jsx(
    "div",
    {
      className: ce(
        "ch-h-fit ch-max-h-80 ch-min-h-80 ch-w-full ch-animate-pulse ch-rounded-md ch-border-2 ch-border-zinc-200 ch-bg-zinc-300/70"
      )
    }
  )
] })), C9e = (e) => ({
  kind: "AvailableDataFetched",
  availableGroup: e.availableGroup
}), x9e = (e) => ({
  kind: "AvailableDataNotFetched",
  onAvailableGroupQuery: e.onAvailableGroupQuery
}), D9e = (e) => {
  const [n, i] = se(x9e(e)), t = I((a) => {
    i(a);
  }, []);
  return be(() => {
    if (n.kind === "AvailableDataFetched")
      return;
    (async () => {
      const s = await n.onAvailableGroupQuery(), r = C9e({ availableGroup: s });
      t(r);
    })();
  }, [t, n]), {
    state: n
  };
}, w9e = g(({ groupSlot: e, ...n }) => {
  const { state: i } = D9e(n);
  return i.kind === "AvailableDataFetched" ? e({ availableGroup: i.availableGroup }) : /* @__PURE__ */ l.jsx(b9e, {});
}), up = g(
  ({
    keyPrefix: e,
    //
    value: n,
    onChange: i,
    optionList: t
  }) => /* @__PURE__ */ l.jsxs(n1, { onValueChange: i, value: String(n), children: [
    /* @__PURE__ */ l.jsx(cs, { children: /* @__PURE__ */ l.jsx("div", { children: n }) }),
    /* @__PURE__ */ l.jsx(us, { children: t.map((a, s) => {
      const r = `${e}_${a}_${s}`;
      return /* @__PURE__ */ l.jsx(ms, { value: String(a), children: a }, r);
    }) })
  ] })
), P9e = g((e) => {
  const n = v(() => {
    const a = e.kidsNum, s = e.availableGroup.maximumAdultNumPerGroup, r = e.availableGroup.maximumChildNumPerGroup, o = e.availableGroup.maximumTotalNumPerGroup;
    if (o >= s + r)
      return s;
    const d = o - a.length;
    return d <= 0 ? 1 : d < s ? d : s;
  }, [
    e.availableGroup.maximumAdultNumPerGroup,
    e.availableGroup.maximumChildNumPerGroup,
    e.availableGroup.maximumTotalNumPerGroup,
    e.kidsNum
  ]), i = v(() => {
    const a = ja(n + 1);
    return a.shift(), a;
  }, [n]), t = I(
    (a) => {
      e.onChangeAdultNum(Number(a));
    },
    [e]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-3", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: "大人：" }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1", children: [
      /* @__PURE__ */ l.jsx(
        up,
        {
          keyPrefix: "adult-num",
          optionList: i,
          value: e.adultNum,
          onChange: t
        }
      ),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: "人" })
    ] })
  ] });
}), R9e = g((e) => {
  const n = v(() => {
    const t = e.availableGroup.maximumChildAge;
    return P(t) || t < 0 ? [] : ja(t + 1);
  }, [e.availableGroup.maximumChildAge]), i = I(
    (t) => {
      e.onChangeKidsAge(Number(t));
    },
    [e]
  );
  return /* @__PURE__ */ l.jsx(
    up,
    {
      keyPrefix: `kids-age-${e.kidsIdx}`,
      value: e.kidsAge,
      onChange: i,
      optionList: n
    }
  );
});
function T9e({
  maximumCoSleepingAge: e,
  kidsAge: n
}) {
  return P(e) ? !1 : n <= e;
}
const j9e = (e) => T9e({
  maximumCoSleepingAge: e.availableGroup.maximumCoSleepingAge,
  kidsAge: e.kidsAge
}) ? {
  kind: "Selectable",
  asCosleeping: e.asCosleeping,
  onChangeAsCosleeping: e.onUpdateAsCosleeping
} : {
  kind: "NotSelectable"
}, A9e = (e) => ({
  state: v(() => j9e(e), [e])
}), O9e = g((e) => {
  const { state: n } = A9e(e), i = I(
    (t) => {
      n.kind === "Selectable" && n.onChangeAsCosleeping(t);
    },
    [n]
  );
  return n.kind === "Selectable" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-[10px] ch-text-zinc-500", children: "添い寝" }),
    /* @__PURE__ */ l.jsx(pv, { checked: n.asCosleeping, onCheckedChange: i })
  ] }) : null;
}), E9e = g((e) => {
  const n = v(() => {
    const s = e.adultNum, r = e.availableGroup.maximumAdultNumPerGroup, o = e.availableGroup.maximumChildNumPerGroup, d = e.availableGroup.maximumTotalNumPerGroup;
    if (d >= r + o)
      return o;
    const c = d - s;
    return c < o ? c : o;
  }, [
    e.adultNum,
    e.availableGroup.maximumAdultNumPerGroup,
    e.availableGroup.maximumChildNumPerGroup,
    e.availableGroup.maximumTotalNumPerGroup
  ]), i = v(() => ja(n + 1), [n]), t = I(
    (s) => {
      e.onChangeKidsNum(Number(s));
    },
    [e]
  ), a = v(() => e.kidsNum.length, [e.kidsNum.length]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-3", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: "子ども：" }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1", children: [
      /* @__PURE__ */ l.jsx(
        up,
        {
          keyPrefix: "kids-num",
          optionList: i,
          value: a,
          onChange: t
        }
      ),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: "人" })
    ] })
  ] });
}), J9e = (e) => e.groupInfoLength > 1 ? {
  kind: "Selectable",
  onSelect: e.onRemoveGroup
} : {
  kind: "NotSelectable"
}, _9e = (e) => ({
  state: v(() => J9e(e), [e])
}), Q9e = g((e) => {
  const { state: n } = _9e(e), i = I(() => {
    n.kind === "Selectable" && n.onSelect();
  }, [n]);
  return n.kind === "Selectable" ? /* @__PURE__ */ l.jsx(ae, { variant: "outline", size: "icon", onClick: i, children: /* @__PURE__ */ l.jsx(Ei, { className: "ch-h-4 ch-w-4" }) }) : null;
}), M9e = g(
  ({
    availableGroup: e,
    groupInfoLength: n,
    roomNum: i,
    adultNum: t,
    kidsNum: a,
    onChangeAdultNum: s,
    onChangeKidsAge: r,
    onChangeKidsAsCoSleeping: o,
    onChangeKidsNum: d,
    onRemoveGroup: c
  }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3 ch-rounded ch-px-4 ch-py-6", style: { background: "rgba(236,237,229)" }, children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
      /* @__PURE__ */ l.jsxs("h4", { className: "ch-text-lg ch-font-semibold ch-text-black", children: [
        "お部屋 ",
        i
      ] }),
      /* @__PURE__ */ l.jsx(Q9e, { groupInfoLength: n, onRemoveGroup: c })
    ] }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-full ch-items-center ch-gap-x-8", children: [
      /* @__PURE__ */ l.jsx(
        P9e,
        {
          availableGroup: e,
          adultNum: t,
          kidsNum: a,
          onChangeAdultNum: s
        }
      ),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-w-max ch-items-center ch-justify-between ch-gap-x-4", children: [
        /* @__PURE__ */ l.jsx(
          E9e,
          {
            availableGroup: e,
            adultNum: t,
            kidsNum: a,
            onChangeKidsNum: d
          }
        ),
        ke(a) ? null : /* @__PURE__ */ l.jsx("div", { className: "ch-divide-y ch-divide-dotted ch-divide-black", children: a.map((u, k) => {
          const m = `kids-age-${k}`, f = `お子様${k + 1}の年齢`;
          return /* @__PURE__ */ l.jsx("div", { className: "ch-py-2", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-2", children: [
            /* @__PURE__ */ l.jsx("h5", { className: "ch-text-base ch-text-black", children: f }),
            /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1", children: [
              /* @__PURE__ */ l.jsx(
                R9e,
                {
                  kidsIdx: k,
                  availableGroup: e,
                  kidsAge: u.age,
                  onChangeKidsAge: r(k)
                }
              ),
              /* @__PURE__ */ l.jsx("p", { children: "歳" }),
              /* @__PURE__ */ l.jsx(
                O9e,
                {
                  availableGroup: e,
                  kidsAge: u.age,
                  asCosleeping: u.asCosleeping,
                  onUpdateAsCosleeping: o(k)
                }
              )
            ] })
          ] }) }, m);
        }) })
      ] })
    ] })
  ] })
), L9e = hi(
  /* GraphQL */
  `
	mutation EditGroupGroupAdd($baseInfo: BaseInfoInput!) {
		groupAdd(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), $9e = hi(
  /* GraphQL */
  `
	mutation EditGroupGroupUpdate($baseInfo: BaseInfoInput!, $groupInfo: [GroupUpdateInput!]!) {
		groupUpdate(baseInfo: $baseInfo, groupInfo: $groupInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), U9e = hi(
  /* GraphQL */
  `
	query EditGroupGroupAvailable($baseInfo: BaseInfoInput!) {
		groupAvailable(baseInfo: $baseInfo) {
			availableGroup {
				minimumGroupNum
				maximumGroupNum
				maximumTotalNumPerGroup
				maximumAdultNumPerGroup
				maximumChildNumPerGroup
				maximumChildAge
				maximumCoSleepingAge
			}
		}
	}
`
), V9e = () => {
  const { baseInfoInput: e } = $i(), { onUpdateSession: n } = ka(), { mutationFunc: i } = fa(L9e);
  return {
    onAddReservationGroup: I(async () => {
      await i({
        variables: { baseInfo: e }
      }).then((a) => {
        if (P(a.data))
          throw new Error();
        n(a.data.groupAdd);
      }).catch(() => {
      });
    }, [i, e, n])
  };
}, H9e = () => {
  const { baseInfoInput: e } = $i(), { refetch: n } = za(
    U9e,
    void 0,
    !0
  );
  return {
    onAvailableGroupQuery: I(async () => {
      const t = await n({ baseInfo: e });
      if (P(t.data) || !P(t.errors))
        throw new Error("Failed to fetch reservation group.");
      return t.data.groupAvailable.availableGroup;
    }, [n, e])
  };
}, z9e = () => {
  const { groupInfo: e } = H2();
  return {
    currentState: {
      groupInfo: e
    }
  };
}, B9e = () => {
  const { baseInfoInput: e } = $i(), { groupInfo: n } = H2(), { onUpdateSession: i } = ka(), { mutationFunc: t } = fa($9e), a = I(
    async (u) => {
      await t({
        variables: { baseInfo: e, groupInfo: u }
      }).then((k) => {
        if (P(k.data))
          throw new Error();
        i(k.data.groupUpdate);
      }).catch(() => {
      });
    },
    [t, e, i]
  ), s = I(
    (u) => async (k) => {
      const m = n.map(
        (f) => f.uniqueRoomID === u ? {
          ...f,
          adultNum: k
        } : f
      );
      await a(m);
    },
    [n, a]
  ), r = I(
    (u) => (k) => async (m) => {
      const p = ja(m).map(() => {
        var N;
        return {
          age: (N = u.maximumChildAge) != null ? N : 0,
          asCosleeping: !1
        };
      }), h = n.map(
        (N) => N.uniqueRoomID === k ? {
          ...N,
          kidsNum: p
        } : N
      );
      await a(h);
    },
    [n, a]
  ), o = I(
    (u) => (k) => (m) => async (f) => {
      const p = n.map(
        (h) => h.uniqueRoomID === k ? {
          ...h,
          kidsNum: h.kidsNum.map(
            (N, S) => S === m ? {
              ...N,
              age: f,
              asCosleeping: !P(u.maximumCoSleepingAge) && N.age >= u.maximumCoSleepingAge ? N.asCosleeping : !1
            } : N
          )
        } : h
      );
      await a(p);
    },
    [n, a]
  ), d = I(
    (u) => (k) => async (m) => {
      const f = n.map(
        (p) => p.uniqueRoomID === u ? {
          ...p,
          kidsNum: p.kidsNum.map(
            (h, N) => N === k ? {
              ...h,
              asCosleeping: m
            } : h
          )
        } : p
      );
      await a(f);
    },
    [n, a]
  ), c = I(
    (u) => async () => {
      if (n.length > 1) {
        const k = n.filter((m) => m.uniqueRoomID !== u);
        await a(k);
      }
    },
    [n, a]
  );
  return {
    onChangeAdultNum: s,
    onChangeKidsNum: r,
    onChangeKidsAge: o,
    onChangeKidsAsCoSleeping: d,
    onRemoveGroup: c
  };
}, q9e = g(() => {
  const { onAvailableGroupQuery: e } = H9e(), { onAddReservationGroup: n } = V9e(), { onChangeAdultNum: i, onChangeKidsAge: t, onChangeKidsAsCoSleeping: a, onChangeKidsNum: s, onRemoveGroup: r } = B9e(), o = z9e();
  return /* @__PURE__ */ l.jsx(
    w9e,
    {
      onAvailableGroupQuery: e,
      groupSlot: (d) => /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-4", children: [
        /* @__PURE__ */ l.jsx("div", { className: "ch-text-right", children: /* @__PURE__ */ l.jsx(
          y9e,
          {
            availableGroup: d.availableGroup,
            groupInfo: o.currentState.groupInfo,
            onAddGroup: n
          }
        ) }),
        /* @__PURE__ */ l.jsx("div", { className: "ch-w-full ch-space-y-3", children: o.currentState.groupInfo.map(({ adultNum: c, uniqueRoomID: u, kidsNum: k }, m) => {
          const f = m + 1;
          return /* @__PURE__ */ l.jsx(
            M9e,
            {
              availableGroup: d.availableGroup,
              groupInfoLength: o.currentState.groupInfo.length,
              roomNum: f,
              adultNum: c,
              kidsNum: k,
              onChangeAdultNum: i(u),
              onChangeKidsAge: t(d.availableGroup)(u),
              onChangeKidsAsCoSleeping: a(u),
              onChangeKidsNum: s(d.availableGroup)(u),
              onRemoveGroup: r(u)
            },
            u
          );
        }) })
      ] })
    }
  );
});
function Pc(e) {
  var n;
  return {
    amount: e.amount,
    name: e.name,
    price: e.price,
    cancelPrice: e.cancelPrice,
    cancelPriceHostInserted: (n = e.cancelPriceHostInserted) != null ? n : null,
    sessionResourceUUID: e.sessionResourceUUID
  };
}
const G9e = (e) => {
  const { optionPerDateWillCancelList: n, optionPerReservationWillCancelList: i } = e.sessionCurrentState, { optionPerDateCanceledList: t, optionPerReservationCanceledList: a } = e.sessionPrevState;
  if (!ke(n) || !ke(i) || !ke(t) || !ke(a)) {
    const s = n.map(Pc), r = i.map(Pc), o = t.map(Pc), d = a.map(Pc);
    return {
      kind: "CancelOptionDisplayed",
      canceledOptionList: [
        ...s,
        ...r,
        ...o,
        ...d
      ]
    };
  } else
    return {
      kind: "CancelOptionNotDisplayed"
    };
}, W9e = (e) => ({
  state: v(() => G9e(e), [e])
}), K9e = g((e) => {
  const { state: n } = W9e(e);
  return n.kind === "CancelOptionDisplayed" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-label-red-200 ch-px-5 ch-py-1.5 ch-text-label-pink-600", children: "キャンセル" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-rounded ch-px-4 ch-py-6", style: { background: "rgba(236,237,229)" }, children: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: n.canceledOptionList.map((i, t) => {
      var r;
      const a = `${i.sessionResourceUUID}-${t}`, s = `${i.name} ${i.amount}個`;
      return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
        /* @__PURE__ */ l.jsx("p", { children: s }),
        /* @__PURE__ */ l.jsx(
          f1,
          {
            initData: {
              sessionResourceUUID: i.sessionResourceUUID,
              staticRawPrice: i.cancelPrice,
              priceHostInserted: (r = i.cancelPriceHostInserted) != null ? r : void 0
            }
          }
        )
      ] }, a);
    }) }) })
  ] }) : null;
}), Y9e = g(() => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: ce(
      "ch-h-fit ch-max-h-80 ch-min-h-80 ch-w-full ch-animate-pulse ch-rounded-md ch-border-2 ch-border-zinc-200 ch-bg-zinc-300/70"
    )
  }
)), X9e = (e) => ({
  kind: "AvailableDataFetched",
  availableOptionList: e.availableOptionList
}), Z9e = (e) => ({
  kind: "AvailableDataNotFetched",
  onAvailableOptionListQuery: e.onAvailableOptionListQuery
}), eFe = (e) => {
  const [n, i] = se(Z9e(e)), t = I((a) => {
    i(a);
  }, []);
  return be(() => {
    if (n.kind === "AvailableDataFetched")
      return;
    (async () => {
      const s = await n.onAvailableOptionListQuery(), r = X9e({ availableOptionList: s });
      t(r);
    })();
  }, [t, n]), {
    state: n
  };
}, nFe = g(({ optionDetailSlot: e, ...n }) => {
  const { state: i } = eFe(n);
  return i.kind === "AvailableDataFetched" ? e({ availableOptionList: i.availableOptionList }) : /* @__PURE__ */ l.jsx(Y9e, {});
}), iFe = (e) => {
  var t, a, s, r;
  const n = {
    billingTypeTerm: e.availableOption.billingTypeTerm,
    billingTypeTarget: e.availableOption.billingTypeTarget,
    optionType: e.availableOption.optionType,
    isRequired: e.availableOption.isRequired,
    name: e.availableOption.name,
    optionID: e.availableOption.optionID
  }, i = e.availableOption.detail;
  if (i.__typename === "OptionBillingPerDate")
    return {
      ...n,
      kind: "OptionWithOptionPerDateIncluded",
      detail: {
        minimumSoldAmount: i.minimumSoldAmount,
        dailyItemList: i.dailyItems.map((o) => {
          var c, u, k, m;
          const d = e.onFindOptionPerDateInfo(o.date);
          return {
            date: o.date,
            availableChoices: o.availableChoices,
            price: i.price,
            selectedAmount: (c = d == null ? void 0 : d.amount) != null ? c : 0,
            priceDiscounted: (u = d == null ? void 0 : d.priceDiscounted) != null ? u : void 0,
            priceHostInserted: (k = d == null ? void 0 : d.priceHostInserted) != null ? k : void 0,
            sessionResourceUUID: (m = d == null ? void 0 : d.sessionResourceUUID) != null ? m : ""
          };
        })
      }
    };
  if (i.__typename === "OptionBillingPerReservation") {
    const o = e.onFindOptionPerReservationInfo();
    return {
      ...n,
      kind: "OptionWithOptionPerReservationIncluded",
      detail: {
        availableChoices: i.availableChoices,
        minimumSoldAmount: i.minimumSoldAmount,
        price: i.price,
        selectedAmount: (t = o == null ? void 0 : o.amount) != null ? t : 0,
        priceDiscounted: (a = o == null ? void 0 : o.priceDiscounted) != null ? a : void 0,
        priceHostInserted: (s = o == null ? void 0 : o.priceHostInserted) != null ? s : void 0,
        sessionResourceUUID: (r = o == null ? void 0 : o.sessionResourceUUID) != null ? r : ""
      }
    };
  } else {
    if (i.__typename === "SubOptionBillingPerDate")
      return {
        ...n,
        kind: "OptionWithSubOptionPerDateIncluded",
        detail: {
          minimumSoldAmount: i.minimumSoldAmount,
          dailyItemList: i.dailyItems.map((o) => ({
            date: o.date,
            subOptionItemList: o.subOptionItems.map((d) => {
              var u, k, m, f;
              const c = e.onFindSubOptionPerDateInfo(o.date)(
                d.subOptionID
              );
              return {
                availableChoices: d.availableChoices,
                name: d.name,
                price: d.price,
                subOptionID: d.subOptionID,
                selectedAmount: (u = c == null ? void 0 : c.amount) != null ? u : 0,
                priceDiscounted: (k = c == null ? void 0 : c.priceDiscounted) != null ? k : void 0,
                priceHostInserted: (m = c == null ? void 0 : c.priceHostInserted) != null ? m : void 0,
                sessionResourceUUID: (f = c == null ? void 0 : c.sessionResourceUUID) != null ? f : ""
              };
            })
          }))
        }
      };
    if (i.__typename === "SubOptionBillingPerReservation")
      return {
        ...n,
        kind: "OptionWithSubOptionPerReservationIncluded",
        detail: {
          minimumSoldAmount: i.minimumSoldAmount,
          itemList: i.items.map((o) => {
            var c, u, k, m;
            const d = e.onFindSubOptionPerReservationInfo(o.subOptionID);
            return {
              availableChoices: o.availableChoices,
              name: o.name,
              price: o.price,
              subOptionID: o.subOptionID,
              selectedAmount: (c = d == null ? void 0 : d.amount) != null ? c : 0,
              priceDiscounted: (u = d == null ? void 0 : d.priceDiscounted) != null ? u : void 0,
              priceHostInserted: (k = d == null ? void 0 : d.priceHostInserted) != null ? k : void 0,
              sessionResourceUUID: (m = d == null ? void 0 : d.sessionResourceUUID) != null ? m : ""
            };
          })
        }
      };
    throw new Error("unknown typename");
  }
}, tFe = (e) => e.selectedAmount === 0 || P(e.availableChoices) ? {
  kind: "OptionPriceNotEditable"
} : {
  kind: "OptionPriceEditable",
  price: e.price * e.selectedAmount,
  priceDiscounted: e.priceDiscounted,
  priceHostInserted: e.priceHostInserted,
  resourceSessionUUID: e.resourceSessionUUID
}, aFe = (e) => ({
  state: v(() => tFe(e), [e])
}), z2 = g((e) => {
  const { state: n } = aFe(e);
  return n.kind === "OptionPriceNotEditable" ? null : /* @__PURE__ */ l.jsx(
    f1,
    {
      initData: {
        staticRawPrice: n.price,
        priceDiscounted: n.priceDiscounted,
        priceHostInserted: n.priceHostInserted,
        sessionResourceUUID: n.resourceSessionUUID
      }
    }
  );
}), lFe = (e) => {
  const { optionType: n, billingTypeTarget: i } = e.optionDetailState;
  return e.optionDetailState.kind === "OptionWithOptionPerReservationIncluded" || e.optionDetailState.kind === "OptionWithSubOptionPerReservationIncluded" ? i === ga.Group ? {
    kind: "ReservationGroup"
  } : i === ga.Room ? {
    kind: "ReservationRoom"
  } : i === ga.Person && n === kr.Goods ? {
    kind: "ReservationItem"
  } : {
    kind: "ReservationPerson"
  } : i === ga.Group ? {
    kind: "DateGroup"
  } : i === ga.Room ? {
    kind: "DateRoom"
  } : i === ga.Person && n === kr.Goods ? {
    kind: "DateItem"
  } : {
    kind: "DatePerson"
  };
}, sFe = (e) => ({
  state: v(() => lFe(e), [e])
}), B2 = g((e) => {
  const { state: n } = sFe(e), i = v(() => {
    if (n.kind === "ReservationGroup")
      return "宿泊を通して";
    if (n.kind === "ReservationRoom")
      return "宿泊を通して1部屋あたり";
    if (n.kind === "ReservationItem")
      return "宿泊を通してお1つあたり";
    if (n.kind === "ReservationPerson")
      return "宿泊を通してお1人様あたり";
    if (n.kind === "DateGroup")
      return "1日毎に";
    if (n.kind === "DateRoom")
      return "1日毎に1部屋あたり";
    if (n.kind === "DateItem")
      return "1日毎にお1つあたり";
    if (n.kind === "DatePerson")
      return "1日毎にお1人様あたり";
    throw new Error("Invalid state");
  }, [n.kind]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base", children: i });
}), q2 = g((e) => {
  const n = I(
    (i) => {
      e.onChangeCallback(Number(i)).catch(() => {
        window.alert("個数の変更に失敗しました。再度お試しください。");
      });
    },
    [e]
  );
  return P(e.availableChoices) ? /* @__PURE__ */ l.jsx("p", { children: "sold out" }) : /* @__PURE__ */ l.jsxs(n1, { value: String(e.selectedAmount), onValueChange: n, children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-w-full", children: /* @__PURE__ */ l.jsx(cs, { children: /* @__PURE__ */ l.jsx("div", { children: e.selectedAmount }) }) }),
    /* @__PURE__ */ l.jsx(us, { children: e.availableChoices.map((i, t) => {
      const a = `${i}_${t}`;
      return /* @__PURE__ */ l.jsx(ms, { value: String(i), children: i }, a);
    }) })
  ] });
}), rFe = (e) => e.optionDetailState.isRequired ? {
  kind: "Displayed"
} : {
  kind: "NotDisplayed"
}, oFe = (e) => ({
  state: v(() => rFe(e), [e])
}), dFe = g((e) => {
  const { state: n } = oFe(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-items-center ch-justify-center ch-rounded ch-bg-label-red-200 ch-px-4 ch-py-2 ch-text-label-red-600", children: "必須" }) : null;
}), cFe = (e) => {
  const { minimumSoldAmount: n, dailyItemList: i } = e.optionDetailState.detail;
  return i.some((a) => a.selectedAmount === 0 ? !1 : a.selectedAmount >= n) ? {
    kind: "Displayed"
  } : {
    kind: "NotDisplayed"
  };
}, uFe = (e) => ({
  state: v(() => cFe(e), [e])
}), mFe = g((e) => {
  const { state: n } = uFe(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-items-center ch-justify-center ch-rounded ch-bg-label-green-200 ch-px-4 ch-py-2 ch-text-label-green-600", children: "選択中" }) : null;
}), kFe = g(({ optionDetailState: e, onUpdateOptionAmount: n }) => {
  const i = v(() => {
    var t, a;
    return (a = (t = e.detail.dailyItemList[0]) == null ? void 0 : t.price) != null ? a : 0;
  }, [e.detail.dailyItemList]);
  return /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, children: /* @__PURE__ */ l.jsxs(
    it,
    {
      value: e.name,
      className: "ch-rounded ch-border ch-border-zinc-200",
      children: [
        /* @__PURE__ */ l.jsx(tt, { className: "ch-m-2 ch-rounded hover:ch-bg-zinc-50", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
          /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-3", children: [
            /* @__PURE__ */ l.jsx(mFe, { optionDetailState: e }),
            /* @__PURE__ */ l.jsx(dFe, { optionDetailState: e })
          ] }),
          /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-bold", children: e.name }),
          /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-3", children: [
            /* @__PURE__ */ l.jsx(B2, { optionDetailState: e }),
            /* @__PURE__ */ l.jsxs("p", { className: "ch-font-bold", children: [
              "¥",
              i.toLocaleString()
            ] })
          ] })
        ] }) }),
        /* @__PURE__ */ l.jsx(at, { className: "ch-p-2", children: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-3", children: e.detail.dailyItemList.map((t, a) => {
          const s = `${t.date}-${a}`;
          return /* @__PURE__ */ l.jsxs(
            "div",
            {
              className: "ch-space-y-2 ch-rounded-md ch-px-4 ch-py-3",
              style: { background: "rgba(236,237,229)" },
              children: [
                /* @__PURE__ */ l.jsx("p", { children: t.date }),
                /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-gap-x-6", children: [
                  /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
                    q2,
                    {
                      availableChoices: t.availableChoices,
                      selectedAmount: t.selectedAmount,
                      onChangeCallback: n(t.date)
                    }
                  ) }),
                  /* @__PURE__ */ l.jsx(
                    z2,
                    {
                      availableChoices: t.availableChoices,
                      selectedAmount: t.selectedAmount,
                      price: t.price,
                      priceDiscounted: t.priceDiscounted,
                      priceHostInserted: t.priceHostInserted,
                      resourceSessionUUID: t.sessionResourceUUID
                    }
                  )
                ] })
              ]
            },
            s
          );
        }) }) })
      ]
    }
  ) });
}), fFe = (e) => e.optionDetailState.isRequired ? {
  kind: "Displayed"
} : {
  kind: "NotDisplayed"
}, vFe = (e) => ({
  state: v(() => fFe(e), [e])
}), hFe = g((e) => {
  const { state: n } = vFe(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-items-center ch-justify-center ch-rounded ch-bg-label-red-200 ch-px-4 ch-py-2 ch-text-label-red-600", children: "必須" }) : null;
}), pFe = (e) => {
  const { selectedAmount: n, minimumSoldAmount: i } = e.optionDetailState.detail;
  return (n > 0 ? n >= i : !1) ? {
    kind: "Displayed"
  } : {
    kind: "NotDisplayed"
  };
}, NFe = (e) => ({
  state: v(() => pFe(e), [e])
}), SFe = g((e) => {
  const { state: n } = NFe(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-items-center ch-justify-center ch-rounded ch-bg-label-green-200 ch-px-4 ch-py-2 ch-text-label-green-600", children: "選択中" }) : null;
}), gFe = g(({ optionDetailState: e, onUpdateOptionAmount: n }) => {
  const i = v(() => e.detail.price, [e.detail.price]);
  return /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, children: /* @__PURE__ */ l.jsxs(
    it,
    {
      value: e.name,
      className: "ch-rounded ch-border ch-border-zinc-200",
      children: [
        /* @__PURE__ */ l.jsx(tt, { className: "ch-m-2 ch-rounded hover:ch-bg-zinc-50", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
          /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-3", children: [
            /* @__PURE__ */ l.jsx(SFe, { optionDetailState: e }),
            /* @__PURE__ */ l.jsx(hFe, { optionDetailState: e })
          ] }),
          /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-bold", children: e.name }),
          /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-3", children: [
            /* @__PURE__ */ l.jsx(B2, { optionDetailState: e }),
            /* @__PURE__ */ l.jsxs("p", { className: "ch-font-bold", children: [
              "¥",
              i.toLocaleString()
            ] })
          ] })
        ] }) }),
        /* @__PURE__ */ l.jsx(at, { className: "ch-p-2", children: /* @__PURE__ */ l.jsxs(
          "div",
          {
            className: "ch-flex ch-items-center ch-justify-between ch-gap-x-6 ch-rounded-md ch-px-4 ch-py-3",
            style: { background: "rgba(236,237,229)" },
            children: [
              /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
                q2,
                {
                  availableChoices: e.detail.availableChoices,
                  selectedAmount: e.detail.selectedAmount,
                  onChangeCallback: n
                }
              ) }),
              /* @__PURE__ */ l.jsx(
                z2,
                {
                  availableChoices: e.detail.availableChoices,
                  selectedAmount: e.detail.selectedAmount,
                  price: e.detail.price,
                  priceDiscounted: e.detail.priceDiscounted,
                  priceHostInserted: e.detail.priceHostInserted,
                  resourceSessionUUID: e.detail.sessionResourceUUID
                }
              )
            ]
          }
        ) })
      ]
    }
  ) });
}), FFe = (e) => e.optionDetailState.isRequired ? {
  kind: "Displayed"
} : {
  kind: "NotDisplayed"
}, IFe = (e) => ({
  state: v(() => FFe(e), [e])
}), yFe = g((e) => {
  const { state: n } = IFe(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-items-center ch-justify-center ch-rounded ch-bg-label-green-200 ch-px-4 ch-py-2 ch-text-label-green-600", children: "必須" }) : null;
}), bFe = (e) => {
  const { minimumSoldAmount: n, dailyItemList: i } = e.optionDetailState.detail;
  return i.map((s) => s.subOptionItemList).some((s) => s.some((r) => r.selectedAmount === 0 ? !1 : r.selectedAmount >= n)) ? {
    kind: "Displayed"
  } : {
    kind: "NotDisplayed"
  };
}, CFe = (e) => ({
  state: v(() => bFe(e), [e])
}), xFe = g((e) => {
  const { state: n } = CFe(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-items-center ch-justify-center ch-rounded ch-bg-label-green-200 ch-px-4 ch-py-2 ch-text-label-green-600", children: "選択中" }) : null;
}), DFe = g(({ optionDetailState: e, onUpdateOptionAmount: n }) => {
  const i = v(() => {
    var t, a, s;
    return (s = (a = (t = e.detail.dailyItemList[0]) == null ? void 0 : t.subOptionItemList[0]) == null ? void 0 : a.price) != null ? s : 0;
  }, [e.detail.dailyItemList]);
  return /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, children: /* @__PURE__ */ l.jsxs(
    it,
    {
      value: e.name,
      className: "ch-rounded ch-border ch-border-zinc-200",
      children: [
        /* @__PURE__ */ l.jsx(tt, { className: "ch-m-2 ch-rounded hover:ch-bg-zinc-50", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
          /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-3", children: [
            /* @__PURE__ */ l.jsx(xFe, { optionDetailState: e }),
            /* @__PURE__ */ l.jsx(yFe, { optionDetailState: e })
          ] }),
          /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-bold", children: e.name }),
          /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-3", children: [
            /* @__PURE__ */ l.jsx(B2, { optionDetailState: e }),
            /* @__PURE__ */ l.jsxs("p", { className: "ch-font-bold", children: [
              "¥",
              i.toLocaleString(),
              "〜"
            ] })
          ] })
        ] }) }),
        /* @__PURE__ */ l.jsx(at, { className: "ch-p-2", children: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-3 ch-px-6", children: e.detail.dailyItemList.map((t, a) => {
          const s = `${t.date}-${a}`;
          return /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, children: /* @__PURE__ */ l.jsxs(
            it,
            {
              value: e.name,
              className: "ch-rounded ch-border ch-border-zinc-200",
              children: [
                /* @__PURE__ */ l.jsx(tt, { className: "ch-m-2 ch-rounded hover:ch-bg-zinc-50", children: /* @__PURE__ */ l.jsxs("p", { className: "ch-text-base ch-font-bold", children: [
                  t.date,
                  " ",
                  /* @__PURE__ */ l.jsx("span", { className: "ch-font-normal", children: "の詳細" })
                ] }) }),
                /* @__PURE__ */ l.jsx(at, { className: "ch-p-2", children: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-3", children: t.subOptionItemList.map((r, o) => {
                  const d = `${t.date}-${r.name}-${o}`;
                  return /* @__PURE__ */ l.jsxs(
                    "div",
                    {
                      className: "ch-space-y-2 ch-rounded-md ch-px-4 ch-py-3",
                      style: { background: "rgba(236,237,229)" },
                      children: [
                        /* @__PURE__ */ l.jsxs("p", { children: [
                          t.date,
                          " ",
                          r.name
                        ] }),
                        /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-gap-x-6", children: [
                          /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
                            q2,
                            {
                              availableChoices: r.availableChoices,
                              selectedAmount: r.selectedAmount,
                              onChangeCallback: n(
                                t.date
                              )(r.subOptionID)
                            }
                          ) }),
                          /* @__PURE__ */ l.jsx(
                            z2,
                            {
                              availableChoices: r.availableChoices,
                              selectedAmount: r.selectedAmount,
                              price: r.price,
                              priceDiscounted: r.priceDiscounted,
                              priceHostInserted: r.priceHostInserted,
                              resourceSessionUUID: r.sessionResourceUUID
                            }
                          )
                        ] })
                      ]
                    },
                    d
                  );
                }) }) })
              ]
            }
          ) }, s);
        }) }) })
      ]
    }
  ) });
}), wFe = (e) => e.optionDetailState.isRequired ? {
  kind: "Displayed"
} : {
  kind: "NotDisplayed"
}, PFe = (e) => ({
  state: v(() => wFe(e), [e])
}), RFe = g((e) => {
  const { state: n } = PFe(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-items-center ch-justify-center ch-rounded ch-bg-label-green-200 ch-px-4 ch-py-2 ch-text-label-green-600", children: "必須" }) : null;
}), TFe = (e) => {
  const { minimumSoldAmount: n, itemList: i } = e.optionDetailState.detail;
  return i.some((a) => a.selectedAmount === 0 ? !1 : a.selectedAmount >= n) ? {
    kind: "Displayed"
  } : {
    kind: "NotDisplayed"
  };
}, jFe = (e) => ({
  state: v(() => TFe(e), [e])
}), AFe = g((e) => {
  const { state: n } = jFe(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-items-center ch-justify-center ch-rounded ch-bg-label-green-200 ch-px-4 ch-py-2 ch-text-label-green-600", children: "選択中" }) : null;
}), OFe = g(({ optionDetailState: e, onUpdateOptionAmount: n }) => {
  const i = v(() => {
    var t, a;
    return (a = (t = e.detail.itemList[0]) == null ? void 0 : t.price) != null ? a : 0;
  }, [e.detail.itemList]);
  return /* @__PURE__ */ l.jsx(qi, { type: "single", collapsible: !0, children: /* @__PURE__ */ l.jsxs(
    it,
    {
      value: e.name,
      className: "ch-rounded ch-border ch-border-zinc-200",
      children: [
        /* @__PURE__ */ l.jsx(tt, { className: "ch-m-2 ch-rounded hover:ch-bg-zinc-50", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
          /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-3", children: [
            /* @__PURE__ */ l.jsx(AFe, { optionDetailState: e }),
            /* @__PURE__ */ l.jsx(RFe, { optionDetailState: e })
          ] }),
          /* @__PURE__ */ l.jsxs("p", { className: "ch-text-base ch-font-bold", children: [
            e.name,
            " ",
            /* @__PURE__ */ l.jsx("span", { className: "ch-font-normal", children: "[サブオプション]" })
          ] }),
          /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-3", children: [
            /* @__PURE__ */ l.jsx(B2, { optionDetailState: e }),
            /* @__PURE__ */ l.jsxs("p", { className: "ch-font-bold", children: [
              "¥",
              i.toLocaleString(),
              "〜"
            ] })
          ] })
        ] }) }),
        /* @__PURE__ */ l.jsx(at, { className: "ch-p-2", children: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-3", children: e.detail.itemList.map((t, a) => {
          const s = `${t.name}-${a}`;
          return /* @__PURE__ */ l.jsxs(
            "div",
            {
              className: "ch-space-y-2 ch-rounded-md ch-px-4 ch-py-3",
              style: { background: "rgba(236,237,229)" },
              children: [
                /* @__PURE__ */ l.jsx("p", { children: t.name }),
                /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-gap-x-6", children: [
                  /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
                    q2,
                    {
                      availableChoices: t.availableChoices,
                      selectedAmount: t.selectedAmount,
                      onChangeCallback: n(t.subOptionID)
                    }
                  ) }),
                  /* @__PURE__ */ l.jsx(
                    z2,
                    {
                      availableChoices: t.availableChoices,
                      selectedAmount: t.selectedAmount,
                      price: t.price,
                      priceDiscounted: t.priceDiscounted,
                      priceHostInserted: t.priceHostInserted,
                      resourceSessionUUID: t.sessionResourceUUID
                    }
                  )
                ] })
              ]
            },
            s
          );
        }) }) })
      ]
    }
  ) });
}), EFe = (e) => ({
  state: v(() => iFe(e), [e])
}), JFe = g(
  ({
    onUpdateOptionPerDateInfoAmount: e,
    onUpdateOptionPerReservationInfoAmount: n,
    onUpdateSubOptionPerDateInfoAmount: i,
    onUpdateSubOptionPerReservationInfoAmount: t,
    ...a
  }) => {
    const { state: s } = EFe(a);
    return s.kind === "OptionWithOptionPerReservationIncluded" ? /* @__PURE__ */ l.jsx(
      gFe,
      {
        optionDetailState: s,
        onUpdateOptionAmount: n
      }
    ) : s.kind === "OptionWithSubOptionPerReservationIncluded" ? /* @__PURE__ */ l.jsx(
      OFe,
      {
        optionDetailState: s,
        onUpdateOptionAmount: t
      }
    ) : s.kind === "OptionWithOptionPerDateIncluded" ? /* @__PURE__ */ l.jsx(kFe, { optionDetailState: s, onUpdateOptionAmount: e }) : s.kind === "OptionWithSubOptionPerDateIncluded" ? /* @__PURE__ */ l.jsx(DFe, { optionDetailState: s, onUpdateOptionAmount: i }) : null;
  }
), _Fe = g(
  ({
    onFindOptionPerDateInfo: e,
    onFindOptionPerReservationInfo: n,
    onFindSubOptionPerDateInfo: i,
    onFindSubOptionPerReservationInfo: t,
    onUpdateOptionPerDateInfoAmount: a,
    onUpdateOptionPerReservationInfoAmount: s,
    onUpdateSubOptionPerDateInfoAmount: r,
    onUpdateSubOptionPerReservationInfoAmount: o,
    onAvailableOptionListQuery: d
  }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-3", children: /* @__PURE__ */ l.jsx(
    nFe,
    {
      onAvailableOptionListQuery: d,
      optionDetailSlot: (c) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-3", children: c.availableOptionList.map((u, k) => {
        const m = `${u.__typename}-${u.name}-${k}`;
        return /* @__PURE__ */ l.jsx(
          JFe,
          {
            availableOption: u,
            onFindOptionPerDateInfo: e(u.optionID),
            onFindOptionPerReservationInfo: n(u.optionID),
            onFindSubOptionPerDateInfo: i(u.optionID),
            onFindSubOptionPerReservationInfo: t(
              u.optionID
            ),
            onUpdateOptionPerDateInfoAmount: a(
              u.optionID
            ),
            onUpdateOptionPerReservationInfoAmount: s(
              u.optionID
            ),
            onUpdateSubOptionPerDateInfoAmount: r(
              u.optionID
            ),
            onUpdateSubOptionPerReservationInfoAmount: o(
              u.optionID
            )
          },
          m
        );
      }) })
    }
  ) })
), QFe = hi(
  /* GraphQL */
  `
	mutation EditOptionOptionUpdateMutation($baseInfo: BaseInfoInput!, $optionInfo: OptionUpdateInput!) {
		optionUpdate(baseInfo: $baseInfo, optionInfo: $optionInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), MFe = hi(
  /* GraphQL */
  `
	query EditOptionAvailableOptions($baseInfo: BaseInfoInput!) {
		optionAvailable(baseInfo: $baseInfo) {
			availableOptions {
				optionID
				billingTypeTerm
				billingTypeTarget
				optionType
				name
				description
				isRequired
				isDateTabbedTimeSelectionEnabled
				isDateTabbedTimeSelectionTarget
				isOneOfRequired
				keyVisuals
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				detail {
					... on OptionBillingPerDate {
						isNextMorning
						price
						minimumSoldAmount
						dailyItems {
							date
							availableChoices
						}
					}
					... on OptionBillingPerReservation {
						price
						minimumSoldAmount
						availableChoices
					}
					... on SubOptionBillingPerDate {
						multiSelectAvailable
						minimumSoldAmount
						dailyItems {
							date
							maxSoldAmount
							subOptionItems {
								subOptionID
								name
								price
								availableChoices
								isNextMorning
								startAt
								endAt
								isShowTimeSchedule
							}
						}
					}
					... on SubOptionBillingPerReservation {
						multiSelectAvailable
						maxSoldAmount
						minimumSoldAmount
						items {
							subOptionID
							name
							price
							availableChoices
							startAt
							endAt
							isShowTimeSchedule
						}
					}
				}
			}
		}
	}
`
), LFe = () => {
  const { baseInfoInput: e } = $i(), { refetch: n } = za(
    MFe,
    void 0,
    !0
  );
  return {
    onAvailableOptionListQuery: I(async () => {
      const { data: t, errors: a } = await n({ baseInfo: e });
      if (P(t) || !P(a))
        throw new Error("Failed to fetch available option data.");
      return t.optionAvailable.availableOptions;
    }, [n, e])
  };
}, $Fe = () => {
  const { optionPerDateInfo: e, optionPerReservationInfo: n } = dp(), i = v(() => e.willCancel.filter((d) => !P(d)), [e.willCancel]), t = v(() => n.willCancel.filter((d) => !P(d)), [n.willCancel]), a = I(
    (d) => (c) => {
      if (P(e.willReserve))
        return;
      const u = e.willReserve.find(
        (k) => (k == null ? void 0 : k.optionID) === d && k.date === c
      );
      return P(u) ? void 0 : u;
    },
    [e.willReserve]
  ), s = I(
    (d) => () => {
      if (P(n.willReserve))
        return;
      const c = n.willReserve.find((u) => (u == null ? void 0 : u.optionID) === d);
      return P(c) ? void 0 : c;
    },
    [n.willReserve]
  ), r = I(
    (d) => (c) => (u) => {
      if (P(e.willReserve))
        return;
      const k = e.willReserve.find(
        (m) => (m == null ? void 0 : m.optionID) === d && m.date === c && m.subOptionID === u
      );
      return P(k) ? void 0 : k;
    },
    [e.willReserve]
  ), o = I(
    (d) => (c) => {
      if (P(n.willReserve))
        return;
      const u = n.willReserve.find(
        (k) => (k == null ? void 0 : k.optionID) === d && k.subOptionID === c
      );
      return P(u) ? void 0 : u;
    },
    [n.willReserve]
  );
  return {
    willReserve: {
      onFindOptionPerDateInfoWillReserve: a,
      onFindOptionPerReservationInfoWillReserve: s,
      onFindSubOptionPerDateInfoWillReserve: r,
      onFindSubOptionPerReservationInfoWillReserve: o
    },
    willCancel: {
      extractMaybeOptionPerDateInfoWillCancel: i,
      extractMaybeOptionPerReservationInfoWillCancel: t
    }
  };
}, UFe = () => {
  const { optionPerDateInfo: e, optionPerReservationInfo: n } = cp(), i = v(() => P(e) ? [] : e.canceled.filter((a) => !P(a)), [e]), t = v(() => P(n == null ? void 0 : n.canceled) ? [] : n.canceled.filter((a) => !P(a)), [n == null ? void 0 : n.canceled]);
  return {
    canceled: {
      extractMaybeOptionPerDateInfoCanceled: i,
      extractMaybeOptionPerReservationInfoCanceled: t
    }
  };
}, VFe = () => {
  const e = $Fe(), n = UFe();
  return {
    currentState: e,
    prevState: n
  };
}, HFe = () => {
  const { baseInfoInput: e } = $i(), { onUpdateSession: n } = ka(), { mutationFunc: i } = fa(QFe), t = I(
    (d) => (c) => (u) => async (k) => {
      await i({
        variables: {
          baseInfo: e,
          optionInfo: {
            optionID: d,
            subOptionID: u,
            date: c,
            amount: k
          }
        }
      }).then((m) => {
        if (m.errors)
          throw new Error("Failed to update current plan.");
        if (P(m.data))
          throw new Error("Failed to update current plan.");
        n(m.data.optionUpdate);
      });
    },
    [e, i, n]
  ), a = I(
    (d) => (c) => async (u) => {
      await t(d)(c)(void 0)(u);
    },
    [t]
  ), s = I(
    (d) => async (c) => {
      await t(d)(void 0)(void 0)(c);
    },
    [t]
  ), r = I(
    (d) => (c) => (u) => async (k) => {
      await t(d)(c)(u)(k);
    },
    [t]
  ), o = I(
    (d) => (c) => async (u) => {
      await t(d)(void 0)(c)(u);
    },
    [t]
  );
  return {
    onUpdateOptionPerDateInfoAmount: a,
    onUpdateOptionPerReservationInfoAmount: s,
    onUpdateSubOptionPerDateInfoAmount: r,
    onUpdateSubOptionPerReservationInfoAmount: o
  };
}, zFe = g(() => {
  const {
    onUpdateOptionPerDateInfoAmount: e,
    onUpdateOptionPerReservationInfoAmount: n,
    onUpdateSubOptionPerDateInfoAmount: i,
    onUpdateSubOptionPerReservationInfoAmount: t
  } = HFe(), { onAvailableOptionListQuery: a } = LFe(), s = VFe();
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx(
      _Fe,
      {
        onFindOptionPerDateInfo: s.currentState.willReserve.onFindOptionPerDateInfoWillReserve,
        onFindOptionPerReservationInfo: s.currentState.willReserve.onFindOptionPerReservationInfoWillReserve,
        onFindSubOptionPerDateInfo: s.currentState.willReserve.onFindSubOptionPerDateInfoWillReserve,
        onFindSubOptionPerReservationInfo: s.currentState.willReserve.onFindSubOptionPerReservationInfoWillReserve,
        onUpdateOptionPerDateInfoAmount: e,
        onUpdateOptionPerReservationInfoAmount: n,
        onUpdateSubOptionPerDateInfoAmount: i,
        onUpdateSubOptionPerReservationInfoAmount: t,
        onAvailableOptionListQuery: a
      }
    ),
    /* @__PURE__ */ l.jsx(
      K9e,
      {
        sessionCurrentState: {
          optionPerDateWillCancelList: s.currentState.willCancel.extractMaybeOptionPerDateInfoWillCancel,
          optionPerReservationWillCancelList: s.currentState.willCancel.extractMaybeOptionPerReservationInfoWillCancel
        },
        sessionPrevState: {
          optionPerDateCanceledList: s.prevState.canceled.extractMaybeOptionPerDateInfoCanceled,
          optionPerReservationCanceledList: s.prevState.canceled.extractMaybeOptionPerReservationInfoCanceled
        }
      }
    )
  ] });
});
function Rc(e) {
  var n;
  return {
    name: e.name,
    price: e.price,
    cancelPrice: e.cancelPrice,
    cancelPriceHostInserted: (n = e.cancelPriceHostInserted) != null ? n : void 0,
    sessionResourceUUID: e.sessionResourceUUID
  };
}
const BFe = (e) => {
  const { planInfoWillCancel: n } = e.currentState, { planInfoCanceled: i } = e.prevState;
  return P(n) && ke(i) ? {
    kind: "CancelPlanNotDisplayed"
  } : !P(n) && ke(i) ? {
    kind: "CancelPlanDisplayed",
    canceledPlanList: [Rc(n)]
  } : P(n) && !ke(i) ? {
    kind: "CancelPlanDisplayed",
    canceledPlanList: i.map(Rc)
  } : !P(n) && !ke(i) ? {
    kind: "CancelPlanDisplayed",
    canceledPlanList: [
      Rc(n),
      ...i.map(Rc)
    ]
  } : {
    kind: "CancelPlanDisplayed",
    canceledPlanList: []
  };
}, qFe = (e) => ({
  state: v(() => BFe(e), [e])
}), GFe = g((e) => {
  const { state: n } = qFe(e);
  return n.kind === "CancelPlanDisplayed" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-label-red-200 ch-px-5 ch-py-1.5 ch-text-label-red-600", children: "キャンセル" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-rounded ch-px-4 ch-py-6", style: { background: "rgba(236,237,229)" }, children: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: n.canceledPlanList.map((i, t) => {
      const a = `${i.name}-${t}`;
      return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
        /* @__PURE__ */ l.jsx("p", { children: i.name }),
        /* @__PURE__ */ l.jsx(
          f1,
          {
            initData: {
              sessionResourceUUID: i.sessionResourceUUID,
              staticRawPrice: i.cancelPrice,
              priceHostInserted: i.cancelPriceHostInserted
            }
          }
        )
      ] }, a);
    }) }) })
  ] }) : null;
}), WFe = (e) => P(e.planInfo) ? {
  kind: "NotCancelable"
} : {
  kind: "Cancelable",
  onSelect: e.onCancelCurrentPlan
}, KFe = (e) => ({
  state: v(() => WFe(e), [e])
}), YFe = g((e) => {
  const { state: n } = KFe(e), i = I(() => {
    n.kind === "Cancelable" && n.onSelect();
  }, [n]);
  return n.kind === "Cancelable" ? /* @__PURE__ */ l.jsx(ae, { variant: "outline", size: "icon", onClick: i, children: /* @__PURE__ */ l.jsx(Ei, { size: "sm" }) }) : null;
}), XFe = (e) => {
  var n, i;
  return P(e.planInfo) ? {
    kind: "NotEditable"
  } : {
    kind: "Editable",
    price: e.planInfo.price,
    priceDiscounted: (n = e.planInfo.priceDiscounted) != null ? n : void 0,
    priceHostInserted: (i = e.planInfo.priceHostInserted) != null ? i : void 0,
    sessionResourceUUID: e.planInfo.sessionResourceUUID
  };
}, ZFe = (e) => ({
  state: v(() => XFe(e), [e])
}), eIe = g((e) => {
  var i;
  const { state: n } = ZFe(e);
  return n.kind === "Editable" ? /* @__PURE__ */ l.jsx(
    f1,
    {
      initData: {
        sessionResourceUUID: n.sessionResourceUUID,
        staticRawPrice: n.price,
        priceDiscounted: n.priceDiscounted,
        priceHostInserted: (i = n.priceHostInserted) != null ? i : void 0
      }
    },
    n.sessionResourceUUID
  ) : null;
}), nIe = g(() => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: ce(
      "ch-h-fit ch-max-h-80 ch-min-h-80 ch-w-full ch-animate-pulse ch-rounded-md ch-border-2 ch-border-zinc-200 ch-bg-zinc-300/70"
    )
  }
)), iIe = (e) => P(e.planInfo) ? {
  kind: "NotSelected",
  onSelect: (n) => e.onUpdateCurrentPlan(n)()
} : {
  kind: "Selected",
  selectedPlanID: e.planInfo.planID,
  onSelect: (n) => e.onUpdateCurrentPlan(n)(),
  onCancel: () => e.onUpdateCurrentPlan(null)()
}, tIe = (e) => ({
  state: v(() => iIe(e), [e])
}), b1 = {
  planID: "no-item",
  name: "未選択",
  price: 1 / 0
}, aIe = g(({ availablePlanList: e, ...n }) => {
  const { state: i } = tIe(n), t = I(
    (d) => {
      if (i.kind !== "NotSelected")
        return e.find((c) => c.planID === d);
    },
    [e, i.kind]
  ), a = I(
    (d) => {
      i.kind === "Selected" ? d !== b1.planID ? i.onSelect(d) : i.onCancel() : i.onSelect(d);
    },
    [i]
  ), s = v(() => [b1, ...e], [e]), r = v(() => i.kind === "NotSelected" || P(i.selectedPlanID) ? b1.planID : i.selectedPlanID, [i]), o = v(() => {
    if (i.kind === "NotSelected")
      return b1.name;
    const d = t(i.selectedPlanID);
    return P(d) ? b1.name : d.name;
  }, [t, i]);
  return /* @__PURE__ */ l.jsxs(n1, { value: r, onValueChange: a, children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-w-full", children: /* @__PURE__ */ l.jsx(cs, { children: /* @__PURE__ */ l.jsx("div", { children: o }) }) }),
    /* @__PURE__ */ l.jsx(us, { children: s.map((d, c) => {
      const u = `${d.name}_${c}`, k = d.name;
      return /* @__PURE__ */ l.jsx(ms, { value: d.planID, children: k }, u);
    }) })
  ] });
}), lIe = (e) => ({
  kind: "AvailableDataFetched",
  availablePlanList: e.availablePlanList
}), sIe = (e) => ({
  kind: "AvailableDataNotFetched",
  onAvailablePlanListQuery: e.onAvailablePlanListQuery
}), rIe = (e) => {
  const [n, i] = se(sIe(e)), t = I((a) => {
    i(a);
  }, []);
  return be(() => {
    if (n.kind === "AvailableDataFetched")
      return;
    (async () => {
      const s = await n.onAvailablePlanListQuery(), r = lIe({ availablePlanList: s });
      t(r);
    })();
  }, [t, n]), {
    state: n
  };
}, oIe = g(({ currentState: e, onUpdateCurrentPlan: n, ...i }) => {
  var a, s, r;
  const { state: t } = rIe(i);
  return t.kind === "AvailableDataFetched" ? /* @__PURE__ */ l.jsx("div", { className: "ch-rounded ch-px-4 ch-py-6", style: { background: "rgba(236,237,229)" }, children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-1", children: [
      /* @__PURE__ */ l.jsx(
        aIe,
        {
          planInfo: (a = e.planInfoWillReserve) != null ? a : void 0,
          availablePlanList: t.availablePlanList,
          onUpdateCurrentPlan: n
        }
      ),
      /* @__PURE__ */ l.jsx(
        YFe,
        {
          planInfo: (s = e.planInfoWillReserve) != null ? s : void 0,
          onCancelCurrentPlan: n(null)
        }
      )
    ] }),
    /* @__PURE__ */ l.jsx(eIe, { planInfo: (r = e.planInfoWillReserve) != null ? r : void 0 })
  ] }) }) : /* @__PURE__ */ l.jsx(nIe, {});
}), dIe = hi(
  /* GraphQL */
  `
	query RCEPlanAvailable($baseInfo: BaseInfoInput!) {
		planAvailable(baseInfo: $baseInfo) {
			availablePlans {
				planID
				name
				description
				isDayTrip
				includedMeals
				minRoomNum
				requiredOptions {
					priceType
					priceTarget
					optionType
					optionID
					name
					minimumPrice
					isOneOfRequired
				}
				price
				priceType
				keyVisuals
				article
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					ratio
					static
					unavailable
				}
				checkInOutPolicy {
					checkInStartTime
					checkInEndTime
					checkOutEndTime
				}
				isUnCancelable
				priceTarget
			}
		}
	}
`
), cIe = hi(
  /* GraphQL */
  `
	mutation RCEPlanUpdate($baseInfo: BaseInfoInput!, $planInfo: PlanUpdateInput!) {
		planUpdate(baseInfo: $baseInfo, planInfo: $planInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), uIe = () => {
  const { baseInfoInput: e } = $i(), { refetch: n } = za(dIe, void 0, !0);
  return {
    onAvailablePlanListQuery: I(async () => {
      const { data: t } = await n({ baseInfo: e });
      if (P(t))
        throw new Error("Failed to fetch plan available.");
      return t.planAvailable.availablePlans;
    }, [e, n])
  };
}, mIe = () => {
  const { baseInfoInput: e } = $i(), { onUpdateSession: n } = ka(), { mutationFunc: i } = fa(cIe);
  return {
    onUpdateCurrentPlan: I(
      (a) => async () => {
        await i({
          variables: {
            baseInfo: e,
            planInfo: {
              planID: a
            }
          }
        }).then((s) => {
          if (s.errors)
            throw new Error("Failed to update current plan.");
          if (P(s.data))
            throw new Error("Failed to update current plan.");
          n(s.data.planUpdate);
        });
      },
      [e, i, n]
    )
  };
}, kIe = g(() => {
  var s, r, o;
  const { onAvailablePlanListQuery: e } = uIe(), { onUpdateCurrentPlan: n } = mIe(), i = Vw(), t = Bw(), a = v(() => {
    var d;
    return P((d = t.planInfo) == null ? void 0 : d.canceled) ? [] : t.planInfo.canceled.filter((c) => !P(c));
  }, [(s = t.planInfo) == null ? void 0 : s.canceled]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx(
      oIe,
      {
        currentState: {
          planInfoWillReserve: (r = i.planInfo.willReserve) != null ? r : null
        },
        onAvailablePlanListQuery: e,
        onUpdateCurrentPlan: n
      }
    ),
    /* @__PURE__ */ l.jsx(
      GFe,
      {
        currentState: {
          planInfoWillCancel: (o = i.planInfo.willCancel) != null ? o : void 0
        },
        prevState: {
          planInfoCanceled: a
        }
      }
    )
  ] });
});
function Tc(e) {
  var n;
  return {
    date: e.date,
    name: e.name,
    cancelPrice: e.cancelPrice,
    cancelPriceHostInserted: (n = e.cancelPriceHostInserted) != null ? n : void 0,
    sessionResourceUUID: e.sessionResourceUUID
  };
}
const fIe = (e) => {
  const { roomInfoWillCancel: n } = e.currentState, { roomInfoCanceled: i } = e.prevState;
  return ke(n) && ke(i) ? {
    kind: "CancelRoomNotDisplayed"
  } : !ke(n) && ke(i) ? {
    kind: "CancelRoomDisplayed",
    canceledRoomList: n.map(Tc)
  } : ke(n) && !ke(i) ? {
    kind: "CancelRoomDisplayed",
    canceledRoomList: i.map(Tc)
  } : !ke(n) && !ke(i) ? {
    kind: "CancelRoomDisplayed",
    canceledRoomList: [
      ...n.map(Tc),
      ...i.map(Tc)
    ]
  } : {
    kind: "CancelRoomDisplayed",
    canceledRoomList: []
  };
}, vIe = (e) => ({
  state: v(() => fIe(e), [e])
}), hIe = g((e) => {
  const { state: n } = vIe(e);
  return n.kind === "CancelRoomDisplayed" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-label-red-200 ch-px-5 ch-py-1.5 ch-text-label-red-600", children: "キャンセル" }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-3", children: n.canceledRoomList.map((i, t) => {
      const a = `${i.name}-${t}`, s = `${Ne(i.date, "YYYY/MM/DD")} ${i.name}`;
      return /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: "ch-flex ch-items-center ch-justify-between ch-rounded ch-px-4 ch-py-6",
          style: { background: "rgba(236,237,229)" },
          children: [
            /* @__PURE__ */ l.jsx("p", { children: s }),
            /* @__PURE__ */ l.jsx(
              f1,
              {
                initData: {
                  sessionResourceUUID: i.sessionResourceUUID,
                  staticRawPrice: i.cancelPrice,
                  priceHostInserted: i.cancelPriceHostInserted
                }
              },
              i.sessionResourceUUID
            )
          ]
        },
        a
      );
    }) })
  ] }) : null;
}), pIe = (e) => ({
  kind: "AvailableDataFetched",
  availableEachRoomList: e.availableEachRoomList
}), NIe = (e) => ({
  kind: "AvailableDataNotFetched",
  onAvailableEachRoomListQuery: e.onAvailableEachRoomListQuery
}), SIe = (e) => {
  const [n, i] = se(NIe(e)), t = I((a) => {
    i(a);
  }, []);
  return be(() => {
    if (n.kind === "AvailableDataFetched")
      return;
    (async () => {
      const s = await n.onAvailableEachRoomListQuery(), r = pIe({ availableEachRoomList: s });
      t(r);
    })();
  }, [t, n]), {
    state: n
  };
}, gIe = g(({ date: e }) => {
  const n = v(() => Ne(e, "YYYY年MM月DD日"), [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-font-semibold", children: n });
}), FIe = (e) => {
  var n, i;
  return P(e.roomInfo) ? {
    kind: "RoomPriceNotEditable"
  } : {
    kind: "RoomPriceEditable",
    price: e.roomInfo.price,
    priceDiscounted: (n = e.roomInfo.priceDiscounted) != null ? n : void 0,
    priceHostInserted: (i = e.roomInfo.priceHostInserted) != null ? i : void 0,
    sessionResourceUUID: e.roomInfo.sessionResourceUUID
  };
}, IIe = (e) => ({
  state: v(() => FIe(e), [e])
}), yIe = g((e) => {
  var i;
  const { state: n } = IIe(e);
  return n.kind === "RoomPriceEditable" ? /* @__PURE__ */ l.jsx(
    f1,
    {
      initData: {
        sessionResourceUUID: n.sessionResourceUUID,
        staticRawPrice: n.price,
        priceDiscounted: n.priceDiscounted,
        priceHostInserted: (i = n.priceHostInserted) != null ? i : void 0
      }
    },
    n.sessionResourceUUID
  ) : null;
}), bIe = (e) => {
  const { selectedRoomID: n, onUpdateRoom: i } = e;
  return P(n) ? {
    kind: "RoomNotSelected",
    onSelect: (t) => i(t)
  } : {
    kind: "RoomSelected",
    selectedRoomID: n,
    onSelect: (t) => i(t)
  };
}, CIe = (e) => ({
  state: v(() => bIe(e), [e])
}), wl = {
  roomID: "no-item",
  name: "未選択",
  price: 1 / 0
}, xIe = g(({ availableEachRoomList: e, ...n }) => {
  const { state: i } = CIe(n), t = I(
    (c) => {
      if (i.kind !== "RoomNotSelected")
        return e.find((u) => u.roomID === c);
    },
    [e, i.kind]
  ), a = I(
    (c) => {
      c !== wl.roomID && i.onSelect(c);
    },
    [i]
  ), s = v(() => i.kind === "RoomNotSelected" ? [wl, ...e] : e, [e, i.kind]), r = I((c, u) => `${c} ¥${u.toLocaleString()}円〜`, []), o = v(() => i.kind === "RoomNotSelected" || P(i.selectedRoomID) ? wl.roomID : i.selectedRoomID, [i]), d = v(() => {
    if (i.kind === "RoomNotSelected")
      return wl.name;
    const c = t(i.selectedRoomID);
    return P(c) ? wl.name : r(c.name, c.price);
  }, [r, t, i]);
  return /* @__PURE__ */ l.jsxs(n1, { value: o, onValueChange: a, children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-w-full", children: /* @__PURE__ */ l.jsx(cs, { children: /* @__PURE__ */ l.jsx("div", { children: d }) }) }),
    /* @__PURE__ */ l.jsx(us, { children: s.map((c, u) => {
      const k = `${c.name}_${u}`, m = wl.roomID !== c.roomID ? r(c.name, c.price) : c.name, f = wl.roomID === c.roomID;
      return /* @__PURE__ */ l.jsx(ms, { disabled: f, value: c.roomID, children: m }, k);
    }) })
  ] });
}), DIe = g(({ onUpdateCurrentRoom: e, roomItem: n, availableEachRoomList: i }) => {
  var t, a;
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-spacey-y-2", children: [
    /* @__PURE__ */ l.jsx(gIe, { date: n.date }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-gap-x-6", children: [
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
        xIe,
        {
          availableEachRoomList: i,
          selectedRoomID: (t = n.roomInfo) == null ? void 0 : t.roomID,
          onUpdateRoom: e
        }
      ) }),
      /* @__PURE__ */ l.jsx(yIe, { roomInfo: (a = n.roomInfo) != null ? a : void 0 })
    ] })
  ] });
}), wIe = (e) => ke(e.kidsNum) ? {
  kind: "Adult",
  adultNum: e.adultNum
} : {
  kind: "AdultAndKids",
  adultNum: e.adultNum,
  kidsNum: e.kidsNum.length,
  kidsAge: e.kidsNum.map((n) => n.age)
}, PIe = (e) => ({
  state: v(() => wIe(e), [e])
}), RIe = g((e) => {
  const { state: n } = PIe(e), i = v(() => n.kind === "Adult" ? `大人${n.adultNum}名` : `大人${n.adultNum}名 お子様${n.kidsNum}名`, [n]), t = v(() => n.kind === "Adult" ? "" : n.kidsAge.map((a) => `${a}歳`).join(", "), [n]);
  return /* @__PURE__ */ l.jsxs("p", { className: "ch-text-base ch-font-bold", children: [
    i,
    " ",
    /* @__PURE__ */ l.jsx("span", { className: "ch-text-sm", children: t })
  ] });
}), TIe = g(() => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: ce(
      "ch-h-fit ch-max-h-80 ch-min-h-80 ch-w-full ch-animate-pulse ch-rounded-md ch-border-2 ch-border-zinc-200 ch-bg-zinc-300/70"
    )
  }
)), jIe = (e) => e.onValidIsSomeRoomNotSelected() ? {
  kind: "Displayed"
} : {
  kind: "NotDisplayed"
}, AIe = (e) => ({
  state: v(() => jIe(e), [e])
}), OIe = g((e) => {
  const { state: n } = AIe(e);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-urgent-400", children: "※お部屋が選択されていません。" }) : null;
}), EIe = g(({ onUpdateCurrentRoom: e, roomDailyItemList: n, adultNum: i, kidsNum: t, ...a }) => {
  const { state: s } = SIe(a), r = I(() => n.filter((c) => !P(c.roomInfo)).length !== n.length, [n]), o = I(
    (d) => {
      var c, u;
      return s.kind === "AvailableDataNotFetched" ? [] : (u = (c = s.availableEachRoomList.find((k) => k.date === d)) == null ? void 0 : c.availableRooms) != null ? u : [];
    },
    [s]
  );
  return s.kind === "AvailableDataFetched" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-rounded ch-px-4 ch-py-6", style: { background: "rgba(236,237,229)" }, children: [
    /* @__PURE__ */ l.jsx(OIe, { onValidIsSomeRoomNotSelected: r }),
    /* @__PURE__ */ l.jsx(RIe, { adultNum: i, kidsNum: t }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-3", children: n.map((d, c) => {
      var k;
      const u = `${(k = d.roomInfo) == null ? void 0 : k.name}-${d.date}-${c}`;
      return /* @__PURE__ */ l.jsx(
        DIe,
        {
          onUpdateCurrentRoom: e(d.date),
          roomItem: d,
          availableEachRoomList: o(d.date)
        },
        u
      );
    }) })
  ] }) : /* @__PURE__ */ l.jsx(TIe, {});
}), JIe = g(({ onAvailableEachRoomListQuery: e, onUpdateCurrentRoom: n, currentState: i }) => /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6", children: i.groupInfo.map((t, a) => {
  var o;
  const s = `${t.uniqueRoomID}-${a}`, r = (o = i.roomInfoWillReserve.find(
    (d) => d.uniqueRoomID === t.uniqueRoomID
  )) == null ? void 0 : o.dailyItems;
  return /* @__PURE__ */ l.jsx(
    EIe,
    {
      onAvailableEachRoomListQuery: e(t.uniqueRoomID),
      onUpdateCurrentRoom: n(t.uniqueRoomID),
      roomDailyItemList: r != null ? r : [],
      adultNum: t.adultNum,
      kidsNum: t.kidsNum
    },
    s
  );
}) })), _Ie = hi(
  /* GraphQL */
  `
	mutation EditRoomRoomEachUpdate($baseInfo: BaseInfoInput!, $roomEachInfo: RoomEachUpdateInput!) {
		roomEachUpdate(baseInfo: $baseInfo, roomEachInfo: $roomEachInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), QIe = hi(
  /* GraphQL */
  `
	query EditRoomRoomEachAvailable($baseInfo: BaseInfoInput!, $roomInfo: RoomAvailableInput!) {
		roomEachAvailable(baseInfo: $baseInfo, roomInfo: $roomInfo) {
			availableRoomsList {
				date
				availableRooms {
					roomID
					name
					capacityPeopleMaximum
					isDormitory
					keyVisuals
					price
					roomSize
					beds {
						bedType
						bedNum
					}
					capacityPeopleMaximum
				}
			}
		}
	}
`
), MIe = () => {
  const { baseInfoInput: e } = $i(), { refetch: n } = za(QIe, void 0, !0);
  return {
    onAvailableEachRoomListQuery: I(
      (t) => async () => {
        const { data: a } = await n({ baseInfo: e, roomInfo: { uniqueRoomID: t } });
        if (P(a))
          throw new Error("Failed to fetch room base available.");
        return a.roomEachAvailable.availableRoomsList;
      },
      [e, n]
    )
  };
}, LIe = () => {
  var o;
  const e = H2(), n = Hw(), i = v(() => {
    const d = n.roomInfo.willReserve;
    return ke(d) ? [] : d.filter((c) => !P(c));
  }, [n.roomInfo.willReserve]), t = v(() => {
    const d = n.roomInfo.willCancel;
    return ke(d) ? [] : d.filter((c) => !P(c));
  }, [n.roomInfo.willCancel]), a = qw(), s = v(() => ({
    roomInfoWillReserve: i,
    roomInfoWillCancel: t,
    groupInfo: e.groupInfo
  }), [e.groupInfo, t, i]), r = v(() => {
    var d, c;
    return {
      roomInfoCanceled: (c = (d = a.roomInfo) == null ? void 0 : d.canceled) != null ? c : []
    };
  }, [(o = a.roomInfo) == null ? void 0 : o.canceled]);
  return {
    currentState: s,
    prevState: r
  };
}, $Ie = () => {
  const { baseInfoInput: e } = $i(), { onUpdateSession: n } = ka(), { mutationFunc: i } = fa(_Ie);
  return {
    onUpdateCurrentRoom: I(
      (a) => (s) => async (r) => {
        await i({
          variables: {
            baseInfo: e,
            roomEachInfo: {
              groupID: a,
              date: s,
              roomID: r != null ? r : null
            }
          }
        }).then((o) => {
          if (o.errors)
            throw new Error("Failed to update current plan.");
          if (P(o.data))
            throw new Error("Failed to update current plan.");
          n(o.data.roomEachUpdate);
        });
      },
      [e, i, n]
    )
  };
}, UIe = g(() => {
  const { onAvailableEachRoomListQuery: e } = MIe(), { onUpdateCurrentRoom: n } = $Ie(), { currentState: i, prevState: t } = LIe();
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx(
      JIe,
      {
        onAvailableEachRoomListQuery: e,
        onUpdateCurrentRoom: n,
        currentState: {
          groupInfo: i.groupInfo,
          roomInfoWillReserve: i.roomInfoWillReserve
        }
      }
    ),
    /* @__PURE__ */ l.jsx(
      hIe,
      {
        currentState: {
          roomInfoWillCancel: i.roomInfoWillCancel
        },
        prevState: {
          roomInfoCanceled: t.roomInfoCanceled
        }
      }
    )
  ] });
}), VIe = hi(
  /* GraphQL */
  `
	query RCEReservationReset($hotelId: ID!, $reservationId: ID!) {
		reservationInitialSessionStateForEdit(hotelID: $hotelId, reservationID: $reservationId) {
			reservationSessionState {
				...ReservationSessionStateFragment
			}
		}
	}
`
), HIe = ({ hotelID: e, reservationID: n }) => {
  const { onUpdateSession: i } = ka(), { refetch: t } = za(VIe, void 0, !0);
  return {
    onResetReservationSession: I(async () => {
      await t({ hotelId: e, reservationId: n }).then((s) => {
        if (P(s.data))
          throw new Error();
        i(s.data.reservationInitialSessionStateForEdit.reservationSessionState);
      }).catch(() => {
      });
    }, [t, e, n, i])
  };
}, zIe = (e) => e.prevLastUpdatedAt === e.lastUpdatedAt ? {
  kind: "not-selectable"
} : {
  kind: "selectable",
  onSubmit: e.onResetReservation
}, BIe = (e) => {
  const n = Ye(e.lastUpdatedAt).current;
  return {
    state: v(() => zIe({ ...e, prevLastUpdatedAt: n }), [n, e])
  };
}, qIe = g((e) => {
  const { state: n } = BIe(e), i = I(() => {
    n.kind === "selectable" && n.onSubmit().catch(() => {
      window.alert("更新に失敗しました。再度お試しください。");
    });
  }, [n]), t = v(() => n.kind === "not-selectable", [n.kind]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: t, variant: "outline", size: "md", onClick: i, children: "もとに戻す" });
}), GIe = ({ hotelID: e, reservationID: n }) => {
  const {
    baseInfoInput: { sessionID: i, lastUpdatedAt: t }
  } = $i(), { onResetReservationSession: a } = HIe({ hotelID: e, reservationID: n }), s = v(() => i, [i]);
  return /* @__PURE__ */ l.jsx(qIe, { lastUpdatedAt: t, onResetReservation: a }, s);
}, WIe = (e) => !e.reserveStatus.isCompleteAgreementOfTermsOfService || !e.reserveStatus.isCompleteGroup || !e.reserveStatus.isCompleteGuestInfo || !e.reserveStatus.isCompleteOption || !e.reserveStatus.isCompletePlan || !e.reserveStatus.isCompleteQuestionAndAnswer || !e.reserveStatus.isCompleteRoom ? {
  kind: "not-selectable"
} : {
  kind: "selectable",
  onSubmit: e.onUpdateReservation
}, KIe = (e) => ({
  state: v(() => WIe(e), [e])
}), YIe = g((e) => {
  const { state: n } = KIe(e), i = I(() => {
    n.kind === "selectable" && n.onSubmit().catch(() => {
      window.alert("更新に失敗しました。再度お試しください。");
    });
  }, [n]), t = v(() => n.kind === "not-selectable", [n.kind]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: t, variant: "default", size: "md", onClick: i, children: "更新" });
}), XIe = hi(
  /* GraphQL */
  `
	mutation RCEReservationUpdate($baseInfo: BaseInfoInput!) {
		reserveWithoutPaymentMethodChange(baseInfo: $baseInfo) {
			...ReservationSessionStateFragment
		}
	}
`
), ZIe = ({ onSuccessCallback: e }) => {
  const { baseInfoInput: n } = $i(), { mutationFunc: i } = fa(XIe), { onShowLoadingScreenCallback: t, onHideLoadingScreenCallback: a } = fn();
  return {
    onUpdateReservation: I(async () => {
      t(), await i({
        variables: {
          baseInfo: n
        }
      }).then((r) => {
        var o;
        P(r.errors) ? e() : (o = r.errors) != null && o.some(
          (c) => c.message === "The level of configured provisioned throughput for the table was exceeded. Consider increasing your provisioning level with the UpdateTable API."
        ) && window.alert("provisioned error が発生しました。");
      }).catch(() => {
      }).finally(() => {
        a();
      });
    }, [n, i, a, t, e])
  };
}, eye = (e) => {
  const { reserveStatus: n } = Nge(), { onUpdateReservation: i } = ZIe(e);
  return /* @__PURE__ */ l.jsx(YIe, { reserveStatus: n, onUpdateReservation: i });
}, nye = (e) => ke(e.currentState.additionalFeeInfo) ? {
  kind: "NotDisplayed"
} : {
  kind: "Displayed",
  additionalFeeNameList: e.currentState.additionalFeeInfo.map(
    (n) => n.name
  )
}, iye = (e) => ({
  state: v(() => nye(e), [e])
}), tye = g((e) => {
  const { state: n } = iye(e), i = v(() => {
    if (n.kind === "Displayed")
      return n.additionalFeeNameList.join("、");
  }, [n]);
  return n.kind === "Displayed" ? /* @__PURE__ */ l.jsx("p", { children: i }) : null;
}), aye = g(({ currentState: e }) => {
  const n = v(() => ke(e.additionalFeeInfo) ? 0 : e.additionalFeeInfo.reduce((i, t) => P(t.priceHostInserted) ? P(t.priceDiscounted) ? i + t.price : i + t.priceDiscounted : i + t.priceHostInserted, 0), [e.additionalFeeInfo]);
  return /* @__PURE__ */ l.jsxs("p", { children: [
    "合計料金",
    /* @__PURE__ */ l.jsxs("span", { className: "ch-font-bold", children: [
      " ¥",
      n.toLocaleString()
    ] })
  ] });
}), lye = g(() => {
  const e = Lw();
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-justify-between", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-4", children: [
      /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-zinc-200 ch-px-5 ch-py-1.5 ch-text-zinc-600", children: "基本料金" }),
      /* @__PURE__ */ l.jsx(
        tye,
        {
          currentState: {
            additionalFeeInfo: e.additionalFeeInfo
          }
        }
      )
    ] }) }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-text-right", children: /* @__PURE__ */ l.jsx(
      aye,
      {
        currentState: {
          additionalFeeInfo: e.additionalFeeInfo
        }
      }
    ) })
  ] });
}), sye = g(() => {
  const { dateInfo: e } = $w(), { reservationPolicy: n } = V2(), i = v(() => {
    if (P(e))
      return "日付を選択してください";
    if (n.isDayTrip && !Ke(e.stayStartDt))
      return Ne(e.stayStartDt, "YYYY年MM月DD日");
    if (!Ke(e.stayStartDt) && !Ke(e.stayLastDt)) {
      const t = Ne(e.stayStartDt, "YYYY年MM月DD日"), a = Ci({ date: e.stayLastDt, inc: 1 }), s = Ne(a, "YYYY年MM月DD日");
      return `${t} 〜 ${s}`;
    }
    return "";
  }, [e, n.isDayTrip]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-4", children: [
    /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-zinc-200 ch-px-5 ch-py-1.5 ch-text-zinc-600", children: "日付" }),
    /* @__PURE__ */ l.jsx("p", { children: i })
  ] });
}), rye = () => {
  const { discountInfo: e } = Uw(), n = v(() => P(e) ? "" : e.name, [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-4", children: [
    /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-zinc-200 ch-px-5 ch-py-1.5 ch-text-zinc-600", children: "ディスカウント" }),
    /* @__PURE__ */ l.jsx("p", { children: n })
  ] });
}, oye = () => {
  const { groupInfo: e } = H2(), n = v(() => {
    const i = e.reduce((s, r) => s + r.adultNum, 0), t = e.reduce((s, r) => s + r.kidsNum.length, 0), a = e.reduce(
      (s, r) => s + r.kidsNum.filter((o) => o.asCosleeping).length,
      0
    );
    return `大人${i}人 ${t > 0 ? `子ども${t}人` : ""}${a > 0 ? `（内、添い寝${a}人）` : ""}`;
  }, [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-4", children: [
    /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-label-pink-200 ch-px-5 ch-py-1.5 ch-text-label-pink-600", children: "人数" }),
    /* @__PURE__ */ l.jsx("p", { children: n })
  ] });
}, dye = (e) => !ke(e.currentState.optionInfoPerDateWillCancel) || !ke(e.currentState.optionInfoPerReservationWillCancel) || !ke(e.prevState.optionInfoPerDateCanceled) || !ke(e.prevState.optionInfoPerReservationCanceled) ? {
  kind: "Canceled"
} : {
  kind: "NotCanceled"
}, cye = ({ currentState: e, prevState: n }) => ({
  state: v(() => dye({ currentState: e, prevState: n }), [e, n])
}), uye = g(({ currentState: e, prevState: n }) => {
  const { state: i } = cye({ currentState: e, prevState: n });
  return i.kind === "Canceled" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-urgent-400 ch-underline", children: "キャンセル有り" }) : null;
}), mye = (e) => {
  const { optionInfoPerDateWillReserve: n, optionInfoPerReservationWillReserve: i } = e.currentState;
  if (ke(n) && ke(i))
    return {
      kind: "NotSelected"
    };
  {
    const t = n.map((s) => s.name), a = i.map((s) => s.name);
    return {
      kind: "Selected",
      optionNameList: [...t, ...a]
    };
  }
}, kye = ({ currentState: e }) => ({
  state: v(() => mye({ currentState: e }), [e])
}), fye = g((e) => {
  const { state: n } = kye(e), i = v(() => n.kind === "NotSelected" ? "未選択" : [...new Set(n.optionNameList)].join("、"), [n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}), vye = g(({ currentState: e, prevState: n }) => {
  const i = v(() => ke(e.optionInfoPerDate.willReserve) ? null : e.optionInfoPerDate.willReserve.reduce((c, u) => P(u.priceHostInserted) ? P(u.priceDiscounted) ? c + u.price : c + u.priceDiscounted : c + u.priceHostInserted, 0), [e.optionInfoPerDate.willReserve]), t = v(() => ke(e.optionInfoPerReservation.willReserve) ? null : e.optionInfoPerReservation.willReserve.reduce((c, u) => P(u.priceHostInserted) ? P(u.priceDiscounted) ? c + u.price : c + u.priceDiscounted : c + u.priceHostInserted, 0), [e.optionInfoPerReservation.willReserve]), a = v(() => ke(e.optionInfoPerDate.willCancel) ? null : e.optionInfoPerDate.willCancel.reduce((c, u) => P(u.cancelPriceHostInserted) ? c + u.cancelPrice : c + u.cancelPriceHostInserted, 0), [e.optionInfoPerDate.willCancel]), s = v(() => ke(e.optionInfoPerReservation.willCancel) ? null : e.optionInfoPerReservation.willCancel.reduce((c, u) => P(u.cancelPriceHostInserted) ? c + u.cancelPrice : c + u.cancelPriceHostInserted, 0), [e.optionInfoPerReservation.willCancel]), r = v(() => ke(n.canceled.optionInfoPerDate) ? null : n.canceled.optionInfoPerDate.reduce((c, u) => P(u.cancelPriceHostInserted) ? c + u.cancelPrice : c + u.cancelPriceHostInserted, 0), [n.canceled.optionInfoPerDate]), o = v(() => ke(n.canceled.optionInfoPerReservation) ? null : n.canceled.optionInfoPerReservation.reduce((c, u) => P(u.cancelPriceHostInserted) ? c + u.cancelPrice : c + u.cancelPriceHostInserted, 0), [n.canceled.optionInfoPerReservation]), d = v(() => {
    let c = 0;
    return P(i) || (c += i), P(t) || (c += t), P(a) || (c += a), P(s) || (c += s), P(r) || (c += r), P(o) || (c += o), c;
  }, [
    r,
    a,
    i,
    o,
    s,
    t
  ]);
  return /* @__PURE__ */ l.jsxs("p", { children: [
    "合計料金",
    /* @__PURE__ */ l.jsxs("span", { className: "ch-font-bold", children: [
      " ¥",
      d.toLocaleString()
    ] })
  ] });
}), hye = g(() => {
  const e = dp(), n = cp(), i = v(() => e.optionPerDateInfo.willReserve.filter((d) => !P(d)), [e.optionPerDateInfo.willReserve]), t = v(() => e.optionPerReservationInfo.willReserve.filter(
    (d) => !P(d)
  ), [e.optionPerReservationInfo.willReserve]), a = v(() => e.optionPerDateInfo.willCancel.filter((d) => !P(d)), [e.optionPerDateInfo.willCancel]), s = v(() => e.optionPerReservationInfo.willCancel.filter(
    (d) => !P(d)
  ), [e.optionPerReservationInfo.willCancel]), r = v(() => P(n.optionPerDateInfo) ? [] : n.optionPerDateInfo.canceled.filter((d) => !P(d)), [n]), o = v(() => {
    var d;
    return P((d = n.optionPerReservationInfo) == null ? void 0 : d.canceled) ? [] : n.optionPerReservationInfo.canceled.filter((c) => !P(c));
  }, [n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-4", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-4", children: [
        /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-label-blue-200 ch-px-5 ch-py-1.5 ch-text-label-blue-600", children: "オプション" }),
        /* @__PURE__ */ l.jsx(
          fye,
          {
            currentState: {
              optionInfoPerDateWillReserve: i,
              optionInfoPerReservationWillReserve: t
            }
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx(
        uye,
        {
          currentState: {
            optionInfoPerDateWillCancel: a,
            optionInfoPerReservationWillCancel: s
          },
          prevState: {
            optionInfoPerDateCanceled: r,
            optionInfoPerReservationCanceled: o
          }
        }
      )
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-text-right", children: /* @__PURE__ */ l.jsx(
      vye,
      {
        currentState: {
          optionInfoPerDate: {
            willCancel: a,
            willReserve: i
          },
          optionInfoPerReservation: {
            willCancel: s,
            willReserve: t
          }
        },
        prevState: {
          canceled: {
            optionInfoPerDate: r,
            optionInfoPerReservation: o
          }
        }
      }
    ) })
  ] });
}), pye = (e) => !P(e.currentState.planInfoWillCancel) || !ke(e.prevState.planInfoCanceled) ? {
  kind: "Canceled"
} : {
  kind: "NotCanceled"
}, Nye = ({ currentState: e, prevState: n }) => ({
  state: v(() => pye({ currentState: e, prevState: n }), [e, n])
}), Sye = g(({ currentState: e, prevState: n }) => {
  const { state: i } = Nye({ currentState: e, prevState: n });
  return i.kind === "Canceled" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-urgent-400 ch-underline", children: "キャンセル有り" }) : null;
}), gye = (e) => {
  const { isDayTrip: n } = e.reservationPolicy;
  return n ? {
    kind: "DayTrip"
  } : {
    kind: "Reservation"
  };
}, Fye = (e) => ({
  state: v(() => gye(e), [e])
}), Iye = g((e) => {
  const { state: n } = Fye(e), i = v(() => n.kind === "DayTrip" ? "日帰りプラン" : "プラン", [n.kind]);
  return /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-label-green-200 ch-px-5 ch-py-1.5 ch-text-label-green-600", children: i });
}), yye = (e) => P(e.currentState.planInfoWillReserve) ? {
  kind: "NotSelected"
} : {
  kind: "Selected",
  planName: e.currentState.planInfoWillReserve.name
}, bye = ({ currentState: e }) => ({
  state: v(() => yye({ currentState: e }), [e])
}), Cye = g(({ currentState: e }) => {
  const { state: n } = bye({ currentState: e }), i = v(() => n.kind === "NotSelected" ? "未選択" : n.planName, [n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}), xye = g(({ currentState: e, prevState: n }) => {
  const i = v(() => P(e.planInfoWillReserve) ? null : P(e.planInfoWillReserve.priceHostInserted) ? P(e.planInfoWillReserve.priceDiscounted) ? e.planInfoWillReserve.price : e.planInfoWillReserve.priceDiscounted : e.planInfoWillReserve.priceHostInserted, [e.planInfoWillReserve]), t = v(() => P(e.planInfoWillCancel) ? null : P(e.planInfoWillCancel.cancelPriceHostInserted) ? e.planInfoWillCancel.cancelPrice : e.planInfoWillCancel.cancelPriceHostInserted, [e.planInfoWillCancel]), a = v(() => ke(n.planInfoCanceled) ? null : n.planInfoCanceled.reduce((r, o) => P(o.cancelPriceHostInserted) ? r + o.cancelPrice : r + o.cancelPriceHostInserted, 0), [n.planInfoCanceled]), s = v(() => {
    let r = 0;
    return P(i) || (r += i), P(t) || (r += t), P(a) || (r += a), r;
  }, [a, t, i]);
  return /* @__PURE__ */ l.jsxs("p", { children: [
    "合計料金",
    /* @__PURE__ */ l.jsxs("span", { className: "ch-font-bold", children: [
      " ¥",
      s.toLocaleString()
    ] })
  ] });
}), Dye = g(() => {
  var a, s, r, o, d;
  const e = Vw(), n = Bw(), { reservationPolicy: i } = V2(), t = v(() => {
    var c;
    return P((c = n.planInfo) == null ? void 0 : c.canceled) ? [] : n.planInfo.canceled.filter((u) => !P(u));
  }, [(a = n.planInfo) == null ? void 0 : a.canceled]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-4", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-4", children: [
        /* @__PURE__ */ l.jsx(Iye, { reservationPolicy: i }),
        /* @__PURE__ */ l.jsx(
          Cye,
          {
            currentState: {
              planInfoWillReserve: (s = e.planInfo.willReserve) != null ? s : void 0
            }
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx(
        Sye,
        {
          currentState: {
            planInfoWillCancel: (r = e.planInfo.willCancel) != null ? r : void 0
          },
          prevState: {
            planInfoCanceled: t
          }
        }
      )
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-text-right", children: /* @__PURE__ */ l.jsx(
      xye,
      {
        currentState: {
          planInfoWillReserve: (o = e.planInfo.willReserve) != null ? o : void 0,
          planInfoWillCancel: (d = e.planInfo.willCancel) != null ? d : void 0
        },
        prevState: {
          planInfoCanceled: t
        }
      }
    ) })
  ] });
}), wye = (e) => !ke(e.currentState.roomInfoWillCancel) || !ke(e.prevState.roomInfoCanceled) ? {
  kind: "Canceled"
} : {
  kind: "NotCanceled"
}, Pye = (e) => ({
  state: v(() => wye(e), [e])
}), Rye = g((e) => {
  const { state: n } = Pye(e);
  return n.kind === "Canceled" ? /* @__PURE__ */ l.jsx("p", { className: "ch-text-urgent-400 ch-underline", children: "キャンセル有り" }) : null;
}), Tye = g(({ sessionStateContext: e }) => {
  const n = v(() => e.reservationPolicy.customTypeRoomTitle === Gd.Tent ? "テント" : "部屋", [e.reservationPolicy.customTypeRoomTitle]);
  return /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-label-pink-200 ch-px-5 ch-py-1.5 ch-text-label-pink-600", children: n });
}), jye = (e) => ke(e.currentState.roomInfoWillReserve) ? {
  kind: "NotSelected"
} : {
  kind: "Selected",
  roomNameList: e.currentState.roomInfoWillReserve.map((i) => i.dailyItems.map((a) => a.roomInfo).filter((a) => !P(a)).map((a) => a.name)).flat()
}, Aye = (e) => ({
  state: v(() => jye(e), [e])
}), Oye = g((e) => {
  const { state: n } = Aye(e), i = v(() => n.kind === "NotSelected" ? "未選択" : [...new Set(n.roomNameList)].join("、"), [n]);
  return /* @__PURE__ */ l.jsx("p", { children: i });
}), Eye = g(({ currentState: e, prevState: n }) => {
  const i = v(() => ke(e.roomInfoWillReserve) ? null : e.roomInfoWillReserve.map((o) => o.dailyItems.map((d) => d.roomInfo).filter((d) => !P(d))).flat().reduce((o, d) => P(d.priceHostInserted) ? P(d.priceDiscounted) ? o + d.price : o + d.priceDiscounted : o + d.priceHostInserted, 0), [e.roomInfoWillReserve]), t = v(() => ke(e.roomInfoWillCancel) ? null : e.roomInfoWillCancel.reduce((r, o) => P(o.cancelPriceHostInserted) ? r + o.cancelPrice : r + o.cancelPriceHostInserted, 0), [e.roomInfoWillCancel]), a = v(() => ke(n.roomInfoCanceled) ? null : n.roomInfoCanceled.reduce((r, o) => P(o.cancelPriceHostInserted) ? r + o.cancelPrice : r + o.cancelPriceHostInserted, 0), [n.roomInfoCanceled]), s = v(() => {
    let r = 0;
    return P(i) || (r += i), P(t) || (r += t), P(a) || (r += a), r;
  }, [i, t, a]);
  return /* @__PURE__ */ l.jsxs("p", { children: [
    "合計料金",
    /* @__PURE__ */ l.jsxs("span", { className: "ch-font-bold", children: [
      " ¥",
      s.toLocaleString()
    ] })
  ] });
}), Jye = g(({ sessionStateContext: e }) => {
  const n = Hw(), i = qw(), t = v(() => P(n.roomInfo.willReserve) ? [] : n.roomInfo.willReserve.filter((r) => !P(r)), [n.roomInfo.willReserve]), a = v(() => P(n.roomInfo.willCancel) ? [] : n.roomInfo.willCancel.filter((r) => !P(r)), [n.roomInfo.willCancel]), s = v(() => {
    var r;
    return P((r = i.roomInfo) == null ? void 0 : r.canceled) ? [] : i.roomInfo.canceled;
  }, [i]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-4", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-4", children: [
        /* @__PURE__ */ l.jsx(Tye, { sessionStateContext: e }),
        /* @__PURE__ */ l.jsx(
          Oye,
          {
            currentState: {
              roomInfoWillReserve: t
            }
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx(
        Rye,
        {
          currentState: {
            roomInfoWillCancel: a
          },
          prevState: {
            roomInfoCanceled: s
          }
        }
      )
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-text-right", children: /* @__PURE__ */ l.jsx(
      Eye,
      {
        currentState: {
          roomInfoWillReserve: t,
          roomInfoWillCancel: a
        },
        prevState: {
          roomInfoCanceled: s
        }
      }
    ) })
  ] });
}), _ye = g(() => {
  const { voucherInfo: e } = zw(), n = I((i) => `-¥${i.toLocaleString()}`, []);
  return ke(e) ? null : /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: e.map((i, t) => {
    const a = `voucher-${t}`, s = n(i.discountPrice);
    return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
      /* @__PURE__ */ l.jsx("p", { children: i.name }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-font-bold", children: s })
    ] }, a);
  }) });
}), Qye = g(() => {
  const { voucherInfo: e } = zw(), n = v(() => {
    if (!ke(e))
      return e.map((i) => i.name).join(", ");
  }, [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-4", children: [
    /* @__PURE__ */ l.jsx(Qn, { className: "ch-inline-flex ch-min-w-[40px] ch-items-center ch-justify-center ch-rounded ch-bg-zinc-200 ch-px-5 ch-py-1.5 ch-text-zinc-600", children: "宿泊券 / チケット" }),
    /* @__PURE__ */ l.jsx("p", { children: n })
  ] });
}), Mye = (e) => {
  const n = e.priceInfo.prevTotalGuestCharge, i = e.priceInfo.totalGuestCharge;
  return P(n) ? {
    kind: "NotEdited",
    finallyTotalPrice: i
  } : i === n ? {
    kind: "NotEdited",
    finallyTotalPrice: i
  } : {
    kind: "Edited",
    beforeTotalPrice: n,
    finallyTotalPrice: i
  };
}, Lye = (e) => ({
  state: v(() => Mye(e), [e])
}), $ye = g(() => {
  const { reservationPriceInfo: e } = pge(), { state: n } = Lye({ priceInfo: e });
  return /* @__PURE__ */ l.jsx("div", { className: "ch-rounded-md ch-px-4 ch-py-2", children: n.kind === "NotEdited" ? /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-10", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-underline", children: "最終的にお支払い頂く合計料金" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-3xl ch-font-bold", children: `¥${n.finallyTotalPrice.toLocaleString()}` })
  ] }) : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between ch-text-zinc-300", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-underline", children: "編集前の合計料金" }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-font-bold", children: `¥${n.beforeTotalPrice.toLocaleString()}` })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-text-center", children: "↓" }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-10", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-underline", children: "最終的にお支払い頂く合計料金" }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-3xl ch-font-bold", children: `¥${n.finallyTotalPrice.toLocaleString()}` })
    ] })
  ] }) });
}), Uye = hi(
  /* GraphQL */
  `
	query RCEReservationInitialSessionState($hotelId: ID!, $reservationId: ID!) {
		reservationInitialSessionStateForEdit(hotelID: $hotelId, reservationID: $reservationId) {
			reservationSessionState {
				...ReservationSessionStateFragment
			}
		}
	}
`
), Vye = (e) => {
  const { onUpdateSession: n } = ka(), { refetch: i } = za(
    Uye,
    void 0,
    !0
  );
  return {
    onInitialize: I(async () => {
      await i(e).then(({ data: a, errors: s }) => {
        if (P(a) || !P(s))
          throw new Error("Failed to initialized.");
        n(a.reservationInitialSessionStateForEdit.reservationSessionState);
      }).catch(() => {
      });
    }, [i, n, e])
  };
}, Hye = () => {
  const { optionPerDateInfo: e, optionPerReservationInfo: n } = dp(), i = v(() => e.willCancel.filter((a) => !P(a)), [e.willCancel]), t = v(() => n.willCancel.filter((a) => !P(a)), [n.willCancel]);
  return {
    willCancel: {
      extractMaybeOptionPerDateInfoWillCancel: i,
      extractMaybeOptionPerReservationInfoWillCancel: t
    }
  };
}, zye = () => {
  const { optionPerDateInfo: e, optionPerReservationInfo: n } = cp(), i = v(() => P(e) ? [] : e.canceled.filter((a) => !P(a)), [e]), t = v(() => P(n == null ? void 0 : n.canceled) ? [] : n.canceled.filter((a) => !P(a)), [n == null ? void 0 : n.canceled]);
  return {
    canceled: {
      extractMaybeOptionPerDateInfoCanceled: i,
      extractMaybeOptionPerReservationInfoCanceled: t
    }
  };
}, Bye = () => {
  const e = Hye(), n = zye();
  return {
    currentState: e,
    prevState: n
  };
}, qye = ({ hotelID: e, reservationID: n }) => {
  const i = Bye(), { reservationPolicy: t } = V2();
  return {
    hotelID: e,
    reservationID: n,
    option: i,
    reservationPolicy: t
  };
}, Gye = g(({ sessionStateContext: e, callbackContext: n }) => {
  const i = qye(e), [t, a] = se();
  return /* @__PURE__ */ l.jsx(
    KSe,
    {
      headerRightContentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-x-6", children: [
        /* @__PURE__ */ l.jsx(
          GIe,
          {
            hotelID: i.hotelID,
            reservationID: i.reservationID
          }
        ),
        /* @__PURE__ */ l.jsx(eye, { onSuccessCallback: n.onSuccessCallback })
      ] }),
      bodyContentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6 ch-py-8", children: [
        /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-wrap ch-justify-between ch-gap-4", children: [
          /* @__PURE__ */ l.jsxs("div", { children: [
            /* @__PURE__ */ l.jsx("p", { children: "予約内容の変更と、金額の増減を行うことができます。" }),
            /* @__PURE__ */ l.jsx("p", { children: "金額を上書きした商品はディスカウントが適応されなくなります。" }),
            /* @__PURE__ */ l.jsx("p", { children: "一方、上書きしていない商品へのディスカウントは継続されます。" })
          ] }),
          /* @__PURE__ */ l.jsx("div", { className: "ch-fixed ch-right-8 ch-top-16 ch-z-max ch-w-[max-content] ch-bg-zinc-50", children: /* @__PURE__ */ l.jsx($ye, {}) })
        ] }),
        /* @__PURE__ */ l.jsx("div", { className: "ch-rounded ch-bg-white ch-p-5 ch-shadow-sm desktop:ch-p-12", children: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-16", children: /* @__PURE__ */ l.jsx(
          qi,
          {
            type: "single",
            collapsible: !0,
            value: t,
            onValueChange: a,
            children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
              /* @__PURE__ */ l.jsx(
                Dl,
                {
                  itemKey: "edit-plan",
                  triggerSlot: /* @__PURE__ */ l.jsx(Dye, {}),
                  contentSlot: /* @__PURE__ */ l.jsx(kIe, {})
                }
              ),
              /* @__PURE__ */ l.jsx(
                Dl,
                {
                  itemKey: "edit-date",
                  triggerSlot: /* @__PURE__ */ l.jsx(sye, {}),
                  contentSlot: /* @__PURE__ */ l.jsx(Zge, {})
                }
              ),
              /* @__PURE__ */ l.jsx(
                Dl,
                {
                  itemKey: "edit-group",
                  triggerSlot: /* @__PURE__ */ l.jsx(oye, {}),
                  contentSlot: /* @__PURE__ */ l.jsx(q9e, {})
                }
              ),
              /* @__PURE__ */ l.jsx(
                Dl,
                {
                  itemKey: "edit-room",
                  triggerSlot: /* @__PURE__ */ l.jsx(Jye, { sessionStateContext: i }),
                  contentSlot: /* @__PURE__ */ l.jsx(UIe, {})
                }
              ),
              /* @__PURE__ */ l.jsx(
                zSe,
                {
                  sessionState: {
                    sessionPolicy: i.reservationPolicy,
                    currentState: {
                      optionPerDateWillCancel: i.option.currentState.willCancel.extractMaybeOptionPerDateInfoWillCancel,
                      optionPerReservationWillCancel: i.option.currentState.willCancel.extractMaybeOptionPerReservationInfoWillCancel
                    },
                    prevState: {
                      optionPerDateCanceled: i.option.prevState.canceled.extractMaybeOptionPerDateInfoCanceled,
                      optionPerReservationCanceled: i.option.prevState.canceled.extractMaybeOptionPerReservationInfoCanceled
                    }
                  },
                  slot: /* @__PURE__ */ l.jsx(
                    Dl,
                    {
                      itemKey: "edit-option",
                      triggerSlot: /* @__PURE__ */ l.jsx(hye, {}),
                      contentSlot: /* @__PURE__ */ l.jsx(zFe, {})
                    }
                  )
                }
              ),
              /* @__PURE__ */ l.jsx(
                Dl,
                {
                  itemKey: "edit-additional-fee",
                  triggerSlot: /* @__PURE__ */ l.jsx(lye, {}),
                  contentSlot: /* @__PURE__ */ l.jsx(Age, {})
                }
              ),
              /* @__PURE__ */ l.jsx(
                Dl,
                {
                  itemKey: "edit-voucher",
                  triggerSlot: /* @__PURE__ */ l.jsx(Qye, {}),
                  contentSlot: /* @__PURE__ */ l.jsx(_ye, {})
                }
              ),
              /* @__PURE__ */ l.jsx(
                Dl,
                {
                  itemKey: "edit-discount",
                  triggerSlot: /* @__PURE__ */ l.jsx(rye, {}),
                  contentSlot: /* @__PURE__ */ l.jsx(g9e, {})
                }
              )
            ] })
          }
        ) }) })
      ] })
    }
  );
}), Kw = g(({ sessionStateContext: e, callbackContext: n }) => {
  const { onInitialize: i } = Vye({
    hotelId: e.hotelID,
    reservationId: e.reservationID
  });
  return /* @__PURE__ */ l.jsx(
    WSe,
    {
      onInitialize: i,
      slot: /* @__PURE__ */ l.jsx(Gye, { sessionStateContext: e, callbackContext: n })
    }
  );
});
Kw.displayName = "Presenter";
const Wye = ({ resetErrorBoundary: e }) => {
  const n = I(() => {
    e();
  }, [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-h-screen ch-place-content-center ch-place-items-start ch-gap-y-6 ch-px-8 ch-tabular-nums", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-gap-y-2", children: [
      /* @__PURE__ */ l.jsx("h1", { children: "システムエラーが発生しました。" }),
      /* @__PURE__ */ l.jsx("p", { children: "時間をおいてからページを再読み込みしてください。" })
    ] }),
    /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full tablet:ch-w-auto", onClick: n, children: "再読み込み" })
  ] });
}, Kye = ({ children: e, ...n }) => {
  const i = I((t, a) => {
    console.error({ error: t }, { info: a });
  }, []);
  return /* @__PURE__ */ l.jsx(
    Nf,
    {
      fallbackRender: (t) => /* @__PURE__ */ l.jsx(Wye, { ...n, ...t }),
      onError: i,
      children: e
    }
  );
}, Yye = (e) => ({
  uri: e
}), Xye = (e) => xge({ ...e, httpOptions: Yye(e.uri) }), Zye = ({
  children: e,
  ...n
}) => {
  const i = Xye(n);
  return /* @__PURE__ */ l.jsx(zh, { client: i, children: e });
}, e6e = g(({ sessionStateContext: e, callbackContext: n, libContext: i, envContext: t }) => (Nl({
  stage: t.stage,
  componentType: "price-editable",
  user: t.user
}), /* @__PURE__ */ l.jsx(Kye, { children: /* @__PURE__ */ l.jsx(Zye, { ...i.apolloClient, lang: Vr.Default, children: /* @__PURE__ */ l.jsx(o1, { children: /* @__PURE__ */ l.jsx(Kw, { sessionStateContext: e, callbackContext: n }) }) }) }))), n6e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Presenter: e6e
}, Symbol.toStringTag, { value: "Module" })), i6e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PriceEditable: n6e
}, Symbol.toStringTag, { value: "Module" })), SDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get BillingTypeTarget() {
    return w2;
  },
  get BillingTypeTargetForOption() {
    return ga;
  },
  get BillingTypeTerm() {
    return P2;
  },
  get CurrencyType() {
    return R2;
  },
  get CurrentViewStateWhenCoutSelect() {
    return T2;
  },
  get CurrentViewStateWhenStayStartSelect() {
    return j2;
  },
  get CustomTypeRoomTitle() {
    return Gd;
  },
  EditDateDateCoutAvailableDocument: Sw,
  EditDateDateRemoveDocument: pw,
  EditDateDateStayStartAvailableDocument: gw,
  EditDateDateUpdateDocument: Nw,
  EditDateInitializeDocument: Fw,
  EditDiscountDiscountAvailableDocument: bw,
  EditDiscountDiscountRemoveDocument: Iw,
  EditDiscountDiscountUpdateDocument: yw,
  EditGroupGroupAddDocument: Cw,
  EditGroupGroupAvailableDocument: Dw,
  EditGroupGroupUpdateDocument: xw,
  EditOptionAvailableOptionsDocument: Pw,
  EditOptionOptionUpdateMutationDocument: ww,
  EditRoomRoomEachAvailableDocument: Aw,
  EditRoomRoomEachUpdateDocument: jw,
  get KidsPolicyType() {
    return A2;
  },
  get LangCode() {
    return Vr;
  },
  get MealType() {
    return O2;
  },
  get OptionSelectionMode() {
    return E2;
  },
  get OptionType() {
    return kr;
  },
  get PaymentMethod() {
    return J2;
  },
  get PlanQueryFilterType() {
    return _2;
  },
  PriceUpdateDocument: hw,
  get QuestionType() {
    return Q2;
  },
  RcePlanAvailableDocument: Tw,
  RcePlanUpdateDocument: Rw,
  RceReservationInitialSessionStateDocument: vw,
  RceReservationResetDocument: Ow,
  RceReservationUpdateDocument: Ew,
  ReservationComponent: i6e,
  get ReservationEditMode() {
    return M2;
  },
  ReservationSessionStateFragmentFragmentDoc: fw,
  get ReserveFailedReasonType() {
    return L2;
  },
  get SelectablePaymentMethod() {
    return $2;
  },
  get StockPreviewGrade() {
    return U2;
  }
}, Symbol.toStringTag, { value: "Module" })), t6e = (e, n) => {
  const [i, { data: t, loading: a }] = qh(e, { ...n, errorPolicy: "all" });
  return {
    mutationFunc: I(
      async (r) => {
        const { data: o, errors: d } = await i(r);
        if (!P(d))
          throw d;
        if (P(o))
          throw new Error("data is null");
        return {
          data: o
        };
      },
      [i]
    ),
    mutationResult: {
      data: t,
      loading: a
    }
  };
}, Yw = (e) => e.extensions != null && "chillnnErrorMessageForUser" in e.extensions && "chillnnStatusCode" in e.extensions, Xw = (e) => Yw(e) && e.extensions.code === "Reservation_AccessUnauthorized", tu = /* @__PURE__ */ new Map(), a6e = (e, n) => {
  var t;
  const i = (t = tu.get(e)) != null ? t : /* @__PURE__ */ new Set();
  return i.add(n), tu.set(e, i), () => {
    i.delete(n), i.size === 0 && tu.delete(e);
  };
}, Zw = (e) => {
  var n;
  for (const i of (n = tu.get(e)) != null ? n : [])
    i();
}, l6e = (e) => e instanceof Sa && e.graphQLErrors.some(Xw);
var fr = /* @__PURE__ */ ((e) => (e.Confirmed = "CONFIRMED", e.Pending = "PENDING", e.RequiredAction = "REQUIRED_ACTION", e))(fr || {}), $s = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.Room = "ROOM", e))($s || {}), G2 = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.PersonOnlyKids = "PERSON_ONLY_KIDS", e.Room = "ROOM", e))(G2 || {}), vr = /* @__PURE__ */ ((e) => (e.PerDate = "PER_DATE", e.PerReservation = "PER_RESERVATION", e))(vr || {}), W2 = /* @__PURE__ */ ((e) => (e.Jpy = "jpy", e))(W2 || {}), ys = /* @__PURE__ */ ((e) => (e.Building = "Building", e.Cottage = "Cottage", e.Room = "Room", e.Space = "Space", e.Tent = "Tent", e))(ys || {}), Y = /* @__PURE__ */ ((e) => (e.Default = "default", e.En = "en", e))(Y || {}), K2 = /* @__PURE__ */ ((e) => (e.Breakfast = "BREAKFAST", e.Dinner = "DINNER", e.Lunch = "LUNCH", e.RoomOnly = "ROOM_ONLY", e))(K2 || {}), Y2 = /* @__PURE__ */ ((e) => (e.Goods = "GOODS", e.Service = "SERVICE", e))(Y2 || {}), X2 = /* @__PURE__ */ ((e) => (e.Credit = "CREDIT", e.Free = "FREE", e.Local = "LOCAL", e.Test = "TEST", e))(X2 || {}), Z2 = /* @__PURE__ */ ((e) => (e.Check = "CHECK", e.Free = "FREE", e.Radio = "RADIO", e.Select = "SELECT", e))(Z2 || {}), Fa = /* @__PURE__ */ ((e) => (e.Confirmed = "CONFIRMED", e.Declined = "DECLINED", e.Unnoticed = "UNNOTICED", e))(Fa || {}), Ys = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Unauthorized = "UNAUTHORIZED", e))(Ys || {});
const e8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RDGReservationAccessTelLast4Send" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationAccessTelLast4Send" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }] }] } }] }, n8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RDGReservationAccessTokenIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "telLast4" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationAccessTokenIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }, { kind: "Argument", name: { kind: "Name", value: "telLast4" }, value: { kind: "Variable", name: { kind: "Name", value: "telLast4" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "accessToken" } }] } }] } }] }, i8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RDGReservationAccessCheck" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationAccessCheck" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "status" } }] } }] } }] }, t8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "RDGReservationInitialDetail" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lang" } }, type: { kind: "NamedType", name: { kind: "Name", value: "LangCode" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationInitialDetail" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }, { kind: "Argument", name: { kind: "Name", value: "lang" }, value: { kind: "Variable", name: { kind: "Name", value: "lang" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationDetail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "reservationStatusInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCanceled" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "requestStatus" } }, { kind: "Field", name: { kind: "Name", value: "authorizeScheduleNotice" } }] } }, { kind: "Field", name: { kind: "Name", value: "hotelInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "roomFacilities" } }, { kind: "Field", name: { kind: "Name", value: "addressInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "coordinate" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lon" } }] } }, { kind: "Field", name: { kind: "Name", value: "address" } }] } }, { kind: "Field", name: { kind: "Name", value: "tel" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "cautions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }, { kind: "Field", name: { kind: "Name", value: "bathroomFacilities" } }, { kind: "Field", name: { kind: "Name", value: "amenities" } }] } }, { kind: "Field", name: { kind: "Name", value: "availableActionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "canCancel" } }, { kind: "Field", name: { kind: "Name", value: "canEdit" } }, { kind: "Field", name: { kind: "Name", value: "canEditCreditCard" } }, { kind: "Field", name: { kind: "Name", value: "canIssueReceipt" } }, { kind: "Field", name: { kind: "Name", value: "requiredCollectCancelFee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "transferLimitDt" } }, { kind: "Field", name: { kind: "Name", value: "bankTransferStatus" } }, { kind: "Field", name: { kind: "Name", value: "bankTransferDestination" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "branchName" } }, { kind: "Field", name: { kind: "Name", value: "bankName" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountType" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountNumber" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountHolderName" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "requiredCollectCreditCancelFee" } }, { kind: "Field", name: { kind: "Name", value: "isCreditCancelFeePendingHostCharge" } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "willCancelPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "checkInDt" } }, { kind: "Field", name: { kind: "Name", value: "checkInStartAt" } }, { kind: "Field", name: { kind: "Name", value: "checkInEndAt" } }, { kind: "Field", name: { kind: "Name", value: "checkOutDt" } }, { kind: "Field", name: { kind: "Name", value: "checkOutEndAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowCheckInOutTime" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "chargeRatio" } }, { kind: "Field", name: { kind: "Name", value: "beforeDays" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "planCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupCount" } }, { kind: "Field", name: { kind: "Name", value: "totalPeopleCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "isCoSleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "isCoSleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "optionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "time" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "timeSlotOptionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "time" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "optionCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "billingTypeTerm" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTarget" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyType" } }] } }] } }] } }] } }] } }] } }] }, a8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RDGReservationCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lang" } }, type: { kind: "NamedType", name: { kind: "Name", value: "LangCode" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }, { kind: "Argument", name: { kind: "Name", value: "lang" }, value: { kind: "Variable", name: { kind: "Name", value: "lang" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationDetail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "reservationStatusInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCanceled" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "requestStatus" } }, { kind: "Field", name: { kind: "Name", value: "authorizeScheduleNotice" } }] } }, { kind: "Field", name: { kind: "Name", value: "hotelInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "roomFacilities" } }, { kind: "Field", name: { kind: "Name", value: "addressInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "coordinate" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lon" } }] } }, { kind: "Field", name: { kind: "Name", value: "address" } }] } }, { kind: "Field", name: { kind: "Name", value: "tel" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "cautions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }, { kind: "Field", name: { kind: "Name", value: "bathroomFacilities" } }, { kind: "Field", name: { kind: "Name", value: "amenities" } }] } }, { kind: "Field", name: { kind: "Name", value: "availableActionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "canCancel" } }, { kind: "Field", name: { kind: "Name", value: "canEdit" } }, { kind: "Field", name: { kind: "Name", value: "canEditCreditCard" } }, { kind: "Field", name: { kind: "Name", value: "canIssueReceipt" } }, { kind: "Field", name: { kind: "Name", value: "requiredCollectCreditCancelFee" } }, { kind: "Field", name: { kind: "Name", value: "isCreditCancelFeePendingHostCharge" } }, { kind: "Field", name: { kind: "Name", value: "requiredCollectCancelFee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "transferLimitDt" } }, { kind: "Field", name: { kind: "Name", value: "bankTransferStatus" } }, { kind: "Field", name: { kind: "Name", value: "bankTransferDestination" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "branchName" } }, { kind: "Field", name: { kind: "Name", value: "bankName" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountType" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountNumber" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountHolderName" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "willCancelPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "checkInDt" } }, { kind: "Field", name: { kind: "Name", value: "checkInStartAt" } }, { kind: "Field", name: { kind: "Name", value: "checkInEndAt" } }, { kind: "Field", name: { kind: "Name", value: "checkOutDt" } }, { kind: "Field", name: { kind: "Name", value: "checkOutEndAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowCheckInOutTime" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "chargeRatio" } }, { kind: "Field", name: { kind: "Name", value: "beforeDays" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "planCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupCount" } }, { kind: "Field", name: { kind: "Name", value: "totalPeopleCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "isCoSleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "isCoSleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "optionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "time" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "timeSlotOptionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "time" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "optionCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "billingTypeTerm" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTarget" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyType" } }] } }] } }] } }] } }] } }] } }] }, l8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RDGReservationCollectLocalCancelFeeWithBankTransfer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lang" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LangCode" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bankAccountName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bankTransferDate" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationCollectLocalCancelFeeWithBankTransfer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }, { kind: "Argument", name: { kind: "Name", value: "lang" }, value: { kind: "Variable", name: { kind: "Name", value: "lang" } } }, { kind: "Argument", name: { kind: "Name", value: "bankAccountName" }, value: { kind: "Variable", name: { kind: "Name", value: "bankAccountName" } } }, { kind: "Argument", name: { kind: "Name", value: "bankTransferDate" }, value: { kind: "Variable", name: { kind: "Name", value: "bankTransferDate" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationDetail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "reservationStatusInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCanceled" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "requestStatus" } }, { kind: "Field", name: { kind: "Name", value: "authorizeScheduleNotice" } }] } }, { kind: "Field", name: { kind: "Name", value: "hotelInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "roomFacilities" } }, { kind: "Field", name: { kind: "Name", value: "addressInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "coordinate" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lon" } }] } }, { kind: "Field", name: { kind: "Name", value: "address" } }] } }, { kind: "Field", name: { kind: "Name", value: "tel" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "cautions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }, { kind: "Field", name: { kind: "Name", value: "bathroomFacilities" } }, { kind: "Field", name: { kind: "Name", value: "amenities" } }] } }, { kind: "Field", name: { kind: "Name", value: "availableActionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "canCancel" } }, { kind: "Field", name: { kind: "Name", value: "canEdit" } }, { kind: "Field", name: { kind: "Name", value: "canEditCreditCard" } }, { kind: "Field", name: { kind: "Name", value: "canIssueReceipt" } }, { kind: "Field", name: { kind: "Name", value: "requiredCollectCancelFee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "transferLimitDt" } }, { kind: "Field", name: { kind: "Name", value: "bankTransferStatus" } }, { kind: "Field", name: { kind: "Name", value: "bankTransferDestination" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "branchName" } }, { kind: "Field", name: { kind: "Name", value: "bankName" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountType" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountNumber" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountHolderName" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "willCancelPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "checkInDt" } }, { kind: "Field", name: { kind: "Name", value: "checkInStartAt" } }, { kind: "Field", name: { kind: "Name", value: "checkInEndAt" } }, { kind: "Field", name: { kind: "Name", value: "checkOutDt" } }, { kind: "Field", name: { kind: "Name", value: "checkOutEndAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowCheckInOutTime" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "chargeRatio" } }, { kind: "Field", name: { kind: "Name", value: "beforeDays" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "planCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupCount" } }, { kind: "Field", name: { kind: "Name", value: "totalPeopleCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "isCoSleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "isCoSleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "optionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "time" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "timeSlotOptionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "time" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "optionCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "billingTypeTerm" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTarget" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyType" } }] } }] } }] } }] } }] } }] } }] }, s8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RDGReservationCollectLocalCancelFeeWithCreditStart" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lang" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LangCode" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "paymentToken" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "callbackUrl" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationCollectLocalCancelFeeWithCreditStart" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }, { kind: "Argument", name: { kind: "Name", value: "lang" }, value: { kind: "Variable", name: { kind: "Name", value: "lang" } } }, { kind: "Argument", name: { kind: "Name", value: "paymentToken" }, value: { kind: "Variable", name: { kind: "Name", value: "paymentToken" } } }, { kind: "Argument", name: { kind: "Name", value: "callbackURL" }, value: { kind: "Variable", name: { kind: "Name", value: "callbackUrl" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "paymentToken" } }, { kind: "Field", name: { kind: "Name", value: "callbackUrlJWS" } }] } }] } }] }, r8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "RDGReservationIssuedReceipt" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "lang" } }, type: { kind: "NamedType", name: { kind: "Name", value: "LangCode" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "address" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationIssuedReceipt" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }, { kind: "Argument", name: { kind: "Name", value: "lang" }, value: { kind: "Variable", name: { kind: "Name", value: "lang" } } }, { kind: "Argument", name: { kind: "Name", value: "address" }, value: { kind: "Variable", name: { kind: "Name", value: "address" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pdfUrl" } }, { kind: "Field", name: { kind: "Name", value: "reservationDetail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "reservationStatusInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCanceled" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "requestStatus" } }, { kind: "Field", name: { kind: "Name", value: "authorizeScheduleNotice" } }] } }, { kind: "Field", name: { kind: "Name", value: "hotelInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customTypeRoomTitle" } }, { kind: "Field", name: { kind: "Name", value: "roomFacilities" } }, { kind: "Field", name: { kind: "Name", value: "addressInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "coordinate" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lon" } }] } }, { kind: "Field", name: { kind: "Name", value: "address" } }] } }, { kind: "Field", name: { kind: "Name", value: "tel" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "cautions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }, { kind: "Field", name: { kind: "Name", value: "bathroomFacilities" } }, { kind: "Field", name: { kind: "Name", value: "amenities" } }] } }, { kind: "Field", name: { kind: "Name", value: "availableActionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "canCancel" } }, { kind: "Field", name: { kind: "Name", value: "canEdit" } }, { kind: "Field", name: { kind: "Name", value: "canEditCreditCard" } }, { kind: "Field", name: { kind: "Name", value: "canIssueReceipt" } }, { kind: "Field", name: { kind: "Name", value: "requiredCollectCancelFee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "transferLimitDt" } }, { kind: "Field", name: { kind: "Name", value: "bankTransferStatus" } }, { kind: "Field", name: { kind: "Name", value: "bankTransferDestination" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "branchName" } }, { kind: "Field", name: { kind: "Name", value: "bankName" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountType" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountNumber" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountHolderName" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "willCancelPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "checkInDt" } }, { kind: "Field", name: { kind: "Name", value: "checkInStartAt" } }, { kind: "Field", name: { kind: "Name", value: "checkInEndAt" } }, { kind: "Field", name: { kind: "Name", value: "checkOutDt" } }, { kind: "Field", name: { kind: "Name", value: "checkOutEndAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowCheckInOutTime" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "chargeRatio" } }, { kind: "Field", name: { kind: "Name", value: "beforeDays" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "planCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupCount" } }, { kind: "Field", name: { kind: "Name", value: "totalPeopleCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "isCoSleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "isCoSleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "optionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "time" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "timeSlotOptionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "time" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "optionCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "billingTypeTerm" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTarget" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyType" } }] } }] } }] } }] } }] } }] } }] }, o8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "TdsccReservationCollectLocalCancelFeeWithCreditComplete" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hotelId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reservationId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationCollectLocalCancelFeeWithCreditComplete" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "hotelID" }, value: { kind: "Variable", name: { kind: "Name", value: "hotelId" } } }, { kind: "Argument", name: { kind: "Name", value: "reservationID" }, value: { kind: "Variable", name: { kind: "Name", value: "reservationId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "reservationDetail" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hotelID" } }, { kind: "Field", name: { kind: "Name", value: "reservationID" } }, { kind: "Field", name: { kind: "Name", value: "reservationStatusInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isCanceled" } }, { kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "requestStatus" } }, { kind: "Field", name: { kind: "Name", value: "authorizeScheduleNotice" } }] } }, { kind: "Field", name: { kind: "Name", value: "hotelInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "roomFacilities" } }, { kind: "Field", name: { kind: "Name", value: "addressInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "coordinate" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lon" } }] } }, { kind: "Field", name: { kind: "Name", value: "address" } }] } }, { kind: "Field", name: { kind: "Name", value: "tel" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "cautions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }, { kind: "Field", name: { kind: "Name", value: "bathroomFacilities" } }, { kind: "Field", name: { kind: "Name", value: "amenities" } }] } }, { kind: "Field", name: { kind: "Name", value: "availableActionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "canCancel" } }, { kind: "Field", name: { kind: "Name", value: "canEdit" } }, { kind: "Field", name: { kind: "Name", value: "canEditCreditCard" } }, { kind: "Field", name: { kind: "Name", value: "canIssueReceipt" } }, { kind: "Field", name: { kind: "Name", value: "requiredCollectCancelFee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "transferLimitDt" } }, { kind: "Field", name: { kind: "Name", value: "bankTransferStatus" } }, { kind: "Field", name: { kind: "Name", value: "bankTransferDestination" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "branchName" } }, { kind: "Field", name: { kind: "Name", value: "bankName" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountType" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountNumber" } }, { kind: "Field", name: { kind: "Name", value: "bankAccountHolderName" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "reservationInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "guestInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "nameKana" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "postalCode" } }, { kind: "Field", name: { kind: "Name", value: "address" } }, { kind: "Field", name: { kind: "Name", value: "tel" } }] } }, { kind: "Field", name: { kind: "Name", value: "questionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "question" } }, { kind: "Field", name: { kind: "Name", value: "answers" } }] } }, { kind: "Field", name: { kind: "Name", value: "priceInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalGuestCharge" } }, { kind: "Field", name: { kind: "Name", value: "willCancelPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "voucherInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "discountPrice" } }] } }, { kind: "Field", name: { kind: "Name", value: "dateInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "isDayTrip" } }, { kind: "Field", name: { kind: "Name", value: "checkInDt" } }, { kind: "Field", name: { kind: "Name", value: "checkInStartAt" } }, { kind: "Field", name: { kind: "Name", value: "checkInEndAt" } }, { kind: "Field", name: { kind: "Name", value: "checkOutDt" } }, { kind: "Field", name: { kind: "Name", value: "checkOutEndAt" } }, { kind: "Field", name: { kind: "Name", value: "isShowCheckInOutTime" } }] } }, { kind: "Field", name: { kind: "Name", value: "planInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "chargeRatio" } }, { kind: "Field", name: { kind: "Name", value: "beforeDays" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "planCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "roomInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "groupCount" } }, { kind: "Field", name: { kind: "Name", value: "totalPeopleCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "isCoSleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "dailyInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }] } }, { kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "roomCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "kidsNum" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "age" } }, { kind: "Field", name: { kind: "Name", value: "isCoSleeping" } }] } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "adultNum" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "optionInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelPolicy" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "beforeDays" } }, { kind: "Field", name: { kind: "Name", value: "chargeRatio" } }] } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "optionCanceledInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "canceledPrice" } }, { kind: "Field", name: { kind: "Name", value: "canceledAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalFeeInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "billingTypeTerm" } }, { kind: "Field", name: { kind: "Name", value: "billingTypeTarget" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyType" } }] } }] } }] } }] } }] } }] } }] };
var fr = /* @__PURE__ */ ((e) => (e.Confirmed = "CONFIRMED", e.Pending = "PENDING", e.RequiredAction = "REQUIRED_ACTION", e))(fr || {}), $s = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.Room = "ROOM", e))($s || {}), G2 = /* @__PURE__ */ ((e) => (e.Group = "GROUP", e.Person = "PERSON", e.PersonOnlyKids = "PERSON_ONLY_KIDS", e.Room = "ROOM", e))(G2 || {}), vr = /* @__PURE__ */ ((e) => (e.PerDate = "PER_DATE", e.PerReservation = "PER_RESERVATION", e))(vr || {}), W2 = /* @__PURE__ */ ((e) => (e.Jpy = "jpy", e))(W2 || {}), ys = /* @__PURE__ */ ((e) => (e.Building = "Building", e.Cottage = "Cottage", e.Room = "Room", e.Space = "Space", e.Tent = "Tent", e))(ys || {}), Y = /* @__PURE__ */ ((e) => (e.Default = "default", e.En = "en", e))(Y || {}), K2 = /* @__PURE__ */ ((e) => (e.Breakfast = "BREAKFAST", e.Dinner = "DINNER", e.Lunch = "LUNCH", e.RoomOnly = "ROOM_ONLY", e))(K2 || {}), Y2 = /* @__PURE__ */ ((e) => (e.Goods = "GOODS", e.Service = "SERVICE", e))(Y2 || {}), X2 = /* @__PURE__ */ ((e) => (e.Credit = "CREDIT", e.Free = "FREE", e.Local = "LOCAL", e.Test = "TEST", e))(X2 || {}), Z2 = /* @__PURE__ */ ((e) => (e.Check = "CHECK", e.Free = "FREE", e.Radio = "RADIO", e.Select = "SELECT", e))(Z2 || {}), Fa = /* @__PURE__ */ ((e) => (e.Confirmed = "CONFIRMED", e.Declined = "DECLINED", e.Unnoticed = "UNNOTICED", e))(Fa || {}), Ys = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Unauthorized = "UNAUTHORIZED", e))(Ys || {});
const s6e = (e) => e === Y.Default ? "ja" : "en", Q9 = {
  ja: "エラーが発生しました。時間をおいて再度お試しください。",
  en: "An error occurred. Please try again later."
}, r6e = ({ lang: e, reservationID: n }) => f2(({ graphQLErrors: i, networkError: t }) => {
  const a = s6e(e), { addError: s } = $1();
  if (i != null && i.length) {
    const r = i[0];
    Xw(r) && (Yv(n), Zw(n)), Yw(r) ? s(`${r.extensions.chillnnErrorMessageForUser[a]}`) : s(`${Q9[a]}`);
  }
  t && s(Q9[a]);
}), o6e = ({ httpOptions: e }) => d2(e), d6e = () => Gh(), c6e = (e) => new u2({
  link: Mh([
    r6e(e),
    d6e(),
    // httpLinkは最後に設定する必要がある（@see https://www.apollographql.com/docs/react/api/link/introduction#the-terminating-link）
    o6e(e)
  ]),
  cache: new c2(),
  connectToDevTools: !0
}), u6e = (e, n, i) => {
  const {
    data: t,
    error: a,
    refetch: s
  } = k2(e, i ? m2 : { ...n, errorPolicy: "all" }), r = I(
    async (o) => {
      try {
        const { data: d, error: c, errors: u } = await s(o);
        if (!P(c))
          throw c;
        if (!P(u))
          throw u;
        if (P(d))
          throw new Error("data is null");
        return { data: d };
      } catch (d) {
        throw d;
      }
    },
    [s]
  );
  return { data: t, refetch: r, error: a };
}, m6e = {
  "\n	mutation RDGReservationAccessTelLast4Send($hotelId: ID!, $reservationId: ID!) {\n		reservationAccessTelLast4Send(hotelID: $hotelId, reservationID: $reservationId)\n	}\n": e8,
  "\n	mutation RDGReservationAccessTokenIssue($hotelId: ID!, $reservationId: ID!, $telLast4: String!) {\n		reservationAccessTokenIssue(hotelID: $hotelId, reservationID: $reservationId, telLast4: $telLast4) {\n			reservationID\n			accessToken\n		}\n	}\n": n8,
  "\n	query RDGReservationAccessCheck($hotelId: ID!, $reservationId: ID!) {\n		reservationAccessCheck(hotelID: $hotelId, reservationID: $reservationId) {\n			status\n		}\n	}\n": i8,
  "\n	query RDGReservationInitialDetail($hotelId: ID!, $reservationId: ID!, $lang: LangCode) {\n		reservationInitialDetail(hotelID: $hotelId, reservationID: $reservationId, lang: $lang) {\n			reservationDetail {\n				hotelID\n				reservationID\n				reservationStatusInfo {\n					isCanceled\n					isDayTrip\n					requestStatus\n					authorizeScheduleNotice\n				}\n				hotelInfo {\n					customTypeRoomTitle\n					roomFacilities\n					addressInfo {\n						postalCode\n						coordinate {\n							lat\n							lon\n						}\n						address\n					}\n					tel\n					name\n					email\n					cautions {\n						title\n						description\n					}\n					bathroomFacilities\n					amenities\n				}\n				availableActionInfo {\n					canCancel\n					canEdit\n					canEditCreditCard\n					canIssueReceipt\n					requiredCollectCancelFee {\n						transferLimitDt\n						bankTransferStatus\n						bankTransferDestination {\n							branchName\n							bankName\n							bankAccountType\n							bankAccountNumber\n							bankAccountHolderName\n						}\n					}\n					requiredCollectCreditCancelFee\n					isCreditCancelFeePendingHostCharge\n				}\n				reservationInfo {\n					guestInfo {\n						name\n						nameKana\n						email\n						postalCode\n						address\n						tel\n					}\n					questionInfo {\n						question\n						answers\n					}\n					priceInfo {\n						totalGuestCharge\n						willCancelPrice\n					}\n					discountInfo {\n						name\n						discountPrice\n					}\n					voucherInfo {\n						name\n						discountPrice\n					}\n					dateInfo {\n						isDayTrip\n						checkInDt\n						checkInStartAt\n						checkInEndAt\n						checkOutDt\n						checkOutEndAt\n						isShowCheckInOutTime\n					}\n					planInfo {\n						cancelPolicy {\n							chargeRatio\n							beforeDays\n						}\n						price\n						name\n					}\n					planCanceledInfo {\n						name\n						canceledPrice\n						canceledAt\n					}\n					roomInfo {\n						groupCount\n						totalPeopleCount\n						items {\n							kidsNum {\n								age\n								isCoSleeping\n							}\n							dailyInfo {\n								date\n								name\n								price\n							}\n							adultNum\n						}\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n					}\n					roomCanceledInfo {\n						kidsNum {\n							age\n							isCoSleeping\n						}\n						name\n						date\n						canceledPrice\n						adultNum\n						canceledAt\n					}\n					optionInfo {\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n						price\n						name\n						time\n						date\n						amount\n					}\n					timeSlotOptionInfo {\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n						price\n						name\n						time\n						date\n						amount\n					}\n					optionCanceledInfo {\n						date\n						name\n						amount\n						canceledPrice\n						canceledAt\n					}\n					additionalFeeInfo {\n						billingTypeTerm\n						billingTypeTarget\n						name\n						price {\n							amount\n							currencyType\n						}\n					}\n				}\n			}\n		}\n	}\n": t8,
  "\n	mutation RDGReservationCancel($hotelId: ID!, $reservationId: ID!, $lang: LangCode) {\n		reservationCancel(hotelID: $hotelId, reservationID: $reservationId, lang: $lang) {\n			reservationDetail {\n				hotelID\n				reservationID\n				reservationStatusInfo {\n					isCanceled\n					isDayTrip\n					requestStatus\n					authorizeScheduleNotice\n				}\n				hotelInfo {\n					customTypeRoomTitle\n					roomFacilities\n					addressInfo {\n						postalCode\n						coordinate {\n							lat\n							lon\n						}\n						address\n					}\n					tel\n					name\n					email\n					cautions {\n						title\n						description\n					}\n					bathroomFacilities\n					amenities\n				}\n				availableActionInfo {\n					canCancel\n					canEdit\n					canEditCreditCard\n					canIssueReceipt\n					requiredCollectCreditCancelFee\n					isCreditCancelFeePendingHostCharge\n					requiredCollectCancelFee {\n						transferLimitDt\n						bankTransferStatus\n						bankTransferDestination {\n							branchName\n							bankName\n							bankAccountType\n							bankAccountNumber\n							bankAccountHolderName\n						}\n					}\n				}\n				reservationInfo {\n					guestInfo {\n						name\n						nameKana\n						email\n						postalCode\n						address\n						tel\n					}\n					questionInfo {\n						question\n						answers\n					}\n					priceInfo {\n						totalGuestCharge\n						willCancelPrice\n					}\n					discountInfo {\n						name\n						discountPrice\n					}\n					voucherInfo {\n						name\n						discountPrice\n					}\n					dateInfo {\n						isDayTrip\n						checkInDt\n						checkInStartAt\n						checkInEndAt\n						checkOutDt\n						checkOutEndAt\n						isShowCheckInOutTime\n					}\n					planInfo {\n						cancelPolicy {\n							chargeRatio\n							beforeDays\n						}\n						price\n						name\n					}\n					planCanceledInfo {\n						name\n						canceledPrice\n						canceledAt\n					}\n					roomInfo {\n						groupCount\n						totalPeopleCount\n						items {\n							kidsNum {\n								age\n								isCoSleeping\n							}\n							dailyInfo {\n								date\n								name\n								price\n							}\n							adultNum\n						}\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n					}\n					roomCanceledInfo {\n						kidsNum {\n							age\n							isCoSleeping\n						}\n						name\n						date\n						canceledPrice\n						adultNum\n						canceledAt\n					}\n					optionInfo {\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n						price\n						name\n						time\n						date\n						amount\n					}\n					timeSlotOptionInfo {\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n						price\n						name\n						time\n						date\n						amount\n					}\n					optionCanceledInfo {\n						date\n						name\n						amount\n						canceledPrice\n						canceledAt\n					}\n					additionalFeeInfo {\n						billingTypeTerm\n						billingTypeTarget\n						name\n						price {\n							amount\n							currencyType\n						}\n					}\n				}\n			}\n		}\n	}\n": a8,
  "\n	mutation RDGReservationCollectLocalCancelFeeWithBankTransfer(\n		$hotelId: ID!\n		$reservationId: ID!\n		$lang: LangCode!\n		$bankAccountName: String!\n		$bankTransferDate: String!\n	) {\n		reservationCollectLocalCancelFeeWithBankTransfer(\n			hotelID: $hotelId\n			reservationID: $reservationId\n			lang: $lang\n			bankAccountName: $bankAccountName\n			bankTransferDate: $bankTransferDate\n		) {\n			reservationDetail {\n				hotelID\n				reservationID\n				reservationStatusInfo {\n					isCanceled\n					isDayTrip\n					requestStatus\n					authorizeScheduleNotice\n				}\n				hotelInfo {\n					customTypeRoomTitle\n					roomFacilities\n					addressInfo {\n						postalCode\n						coordinate {\n							lat\n							lon\n						}\n						address\n					}\n					tel\n					name\n					email\n					cautions {\n						title\n						description\n					}\n					bathroomFacilities\n					amenities\n				}\n				availableActionInfo {\n					canCancel\n					canEdit\n					canEditCreditCard\n					canIssueReceipt\n					requiredCollectCancelFee {\n						transferLimitDt\n						bankTransferStatus\n						bankTransferDestination {\n							branchName\n							bankName\n							bankAccountType\n							bankAccountNumber\n							bankAccountHolderName\n						}\n					}\n				}\n				reservationInfo {\n					guestInfo {\n						name\n						nameKana\n						email\n						postalCode\n						address\n						tel\n					}\n					questionInfo {\n						question\n						answers\n					}\n					priceInfo {\n						totalGuestCharge\n						willCancelPrice\n					}\n					discountInfo {\n						name\n						discountPrice\n					}\n					voucherInfo {\n						name\n						discountPrice\n					}\n					dateInfo {\n						isDayTrip\n						checkInDt\n						checkInStartAt\n						checkInEndAt\n						checkOutDt\n						checkOutEndAt\n						isShowCheckInOutTime\n					}\n					planInfo {\n						cancelPolicy {\n							chargeRatio\n							beforeDays\n						}\n						price\n						name\n					}\n					planCanceledInfo {\n						name\n						canceledPrice\n						canceledAt\n					}\n					roomInfo {\n						groupCount\n						totalPeopleCount\n						items {\n							kidsNum {\n								age\n								isCoSleeping\n							}\n							dailyInfo {\n								date\n								name\n								price\n							}\n							adultNum\n						}\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n					}\n					roomCanceledInfo {\n						kidsNum {\n							age\n							isCoSleeping\n						}\n						name\n						date\n						canceledPrice\n						adultNum\n						canceledAt\n					}\n					optionInfo {\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n						price\n						name\n						time\n						date\n						amount\n					}\n					timeSlotOptionInfo {\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n						price\n						name\n						time\n						date\n						amount\n					}\n					optionCanceledInfo {\n						date\n						name\n						amount\n						canceledPrice\n						canceledAt\n					}\n					additionalFeeInfo {\n						billingTypeTerm\n						billingTypeTarget\n						name\n						price {\n							amount\n							currencyType\n						}\n					}\n				}\n			}\n		}\n	}\n": l8,
  "\n	mutation RDGReservationCollectLocalCancelFeeWithCreditStart(\n		$hotelId: ID!\n		$reservationId: ID!\n		$lang: LangCode!\n		$paymentToken: String!\n		$callbackUrl: String!\n	) {\n		reservationCollectLocalCancelFeeWithCreditStart(\n			hotelID: $hotelId\n			reservationID: $reservationId\n			lang: $lang\n			paymentToken: $paymentToken\n			callbackURL: $callbackUrl\n		) {\n			paymentToken\n			callbackUrlJWS\n		}\n	}\n": s8,
  "\n	mutation RDGReservationIssuedReceipt($hotelId: ID!, $reservationId: ID!, $lang: LangCode, $address: String) {\n		reservationIssuedReceipt(hotelID: $hotelId, reservationID: $reservationId, lang: $lang, address: $address) {\n			pdfUrl\n			reservationDetail {\n				hotelID\n				reservationID\n				reservationStatusInfo {\n					isCanceled\n					isDayTrip\n					requestStatus\n					authorizeScheduleNotice\n				}\n				hotelInfo {\n					customTypeRoomTitle\n					roomFacilities\n					addressInfo {\n						postalCode\n						coordinate {\n							lat\n							lon\n						}\n						address\n					}\n					tel\n					name\n					email\n					cautions {\n						title\n						description\n					}\n					bathroomFacilities\n					amenities\n				}\n				availableActionInfo {\n					canCancel\n					canEdit\n					canEditCreditCard\n					canIssueReceipt\n					requiredCollectCancelFee {\n						transferLimitDt\n						bankTransferStatus\n						bankTransferDestination {\n							branchName\n							bankName\n							bankAccountType\n							bankAccountNumber\n							bankAccountHolderName\n						}\n					}\n				}\n				reservationInfo {\n					guestInfo {\n						name\n						nameKana\n						email\n						postalCode\n						address\n						tel\n					}\n					questionInfo {\n						question\n						answers\n					}\n					priceInfo {\n						totalGuestCharge\n						willCancelPrice\n					}\n					discountInfo {\n						name\n						discountPrice\n					}\n					voucherInfo {\n						name\n						discountPrice\n					}\n					dateInfo {\n						isDayTrip\n						checkInDt\n						checkInStartAt\n						checkInEndAt\n						checkOutDt\n						checkOutEndAt\n						isShowCheckInOutTime\n					}\n					planInfo {\n						cancelPolicy {\n							chargeRatio\n							beforeDays\n						}\n						price\n						name\n					}\n					planCanceledInfo {\n						name\n						canceledPrice\n						canceledAt\n					}\n					roomInfo {\n						groupCount\n						totalPeopleCount\n						items {\n							kidsNum {\n								age\n								isCoSleeping\n							}\n							dailyInfo {\n								date\n								name\n								price\n							}\n							adultNum\n						}\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n					}\n					roomCanceledInfo {\n						kidsNum {\n							age\n							isCoSleeping\n						}\n						name\n						date\n						canceledPrice\n						adultNum\n						canceledAt\n					}\n					optionInfo {\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n						price\n						name\n						time\n						date\n						amount\n					}\n					timeSlotOptionInfo {\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n						price\n						name\n						time\n						date\n						amount\n					}\n					optionCanceledInfo {\n						date\n						name\n						amount\n						canceledPrice\n						canceledAt\n					}\n					additionalFeeInfo {\n						billingTypeTerm\n						billingTypeTarget\n						name\n						price {\n							amount\n							currencyType\n						}\n					}\n				}\n			}\n		}\n	}\n": r8,
  "\n	mutation TdsccReservationCollectLocalCancelFeeWithCreditComplete($hotelId: ID!, $reservationId: ID!) {\n		reservationCollectLocalCancelFeeWithCreditComplete(hotelID: $hotelId, reservationID: $reservationId) {\n			reservationDetail {\n				hotelID\n				reservationID\n				reservationStatusInfo {\n					isCanceled\n					isDayTrip\n					requestStatus\n					authorizeScheduleNotice\n				}\n				hotelInfo {\n					roomFacilities\n					addressInfo {\n						postalCode\n						coordinate {\n							lat\n							lon\n						}\n						address\n					}\n					tel\n					name\n					email\n					cautions {\n						title\n						description\n					}\n					bathroomFacilities\n					amenities\n				}\n				availableActionInfo {\n					canCancel\n					canEdit\n					canEditCreditCard\n					canIssueReceipt\n					requiredCollectCancelFee {\n						transferLimitDt\n						bankTransferStatus\n						bankTransferDestination {\n							branchName\n							bankName\n							bankAccountType\n							bankAccountNumber\n							bankAccountHolderName\n						}\n					}\n				}\n				reservationInfo {\n					guestInfo {\n						name\n						nameKana\n						email\n						postalCode\n						address\n						tel\n					}\n					questionInfo {\n						question\n						answers\n					}\n					priceInfo {\n						totalGuestCharge\n						willCancelPrice\n					}\n					discountInfo {\n						name\n						discountPrice\n					}\n					voucherInfo {\n						name\n						discountPrice\n					}\n					dateInfo {\n						isDayTrip\n						checkInDt\n						checkInStartAt\n						checkInEndAt\n						checkOutDt\n						checkOutEndAt\n						isShowCheckInOutTime\n					}\n					planInfo {\n						cancelPolicy {\n							chargeRatio\n							beforeDays\n						}\n						price\n						name\n					}\n					planCanceledInfo {\n						name\n						canceledPrice\n						canceledAt\n					}\n					roomInfo {\n						groupCount\n						totalPeopleCount\n						items {\n							kidsNum {\n								age\n								isCoSleeping\n							}\n							dailyInfo {\n								date\n								name\n								price\n							}\n							adultNum\n						}\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n					}\n					roomCanceledInfo {\n						kidsNum {\n							age\n							isCoSleeping\n						}\n						name\n						date\n						canceledPrice\n						adultNum\n						canceledAt\n					}\n					optionInfo {\n						cancelPolicy {\n							beforeDays\n							chargeRatio\n						}\n						price\n						name\n						date\n						amount\n					}\n					optionCanceledInfo {\n						date\n						name\n						amount\n						canceledPrice\n						canceledAt\n					}\n					additionalFeeInfo {\n						billingTypeTerm\n						billingTypeTarget\n						name\n						price {\n							amount\n							currencyType\n						}\n					}\n				}\n			}\n		}\n	}\n": o8
};
function bl(e) {
  var n;
  return (n = m6e[e]) != null ? n : {};
}
const k6e = (e, n) => ({
  uri: e,
  // 予約へのアクセストークンを API に送る（CHILLNN のドメインは Cookie、施設の独自ドメインは SessionStorage のトークンをヘッダーで）
  fetch: CC(n)
}), f6e = (e) => c6e({ ...e, httpOptions: k6e(e.uri, e.reservationID) }), d8 = ({
  children: e,
  ...n
}) => {
  const i = f6e(n);
  return /* @__PURE__ */ l.jsx(zh, { client: i, children: e });
}, wn = ({ lang: e, i18nString: n }) => n[e], mp = (e) => ({
  title: wn({
    lang: e,
    i18nString: { [Y.Default]: "ご予約内容の確認", [Y.En]: "View your reservation" }
  }),
  description: wn({
    lang: e,
    i18nString: {
      [Y.Default]: "ご予約時に入力された電話番号の下4桁を入力してください。",
      [Y.En]: "Enter the last 4 digits of the phone number you used when booking."
    }
  }),
  telLast4Label: wn({
    lang: e,
    i18nString: {
      [Y.Default]: "電話番号の下4桁（半角数字）",
      [Y.En]: "Last 4 digits of your phone number"
    }
  }),
  telLast4Invalid: wn({
    lang: e,
    i18nString: {
      [Y.Default]: "半角数字で入力してください。",
      [Y.En]: "Enter half-width digits only."
    }
  }),
  tokenNotUsable: wn({
    lang: e,
    i18nString: {
      [Y.Default]: "確認はできましたが、お使いのブラウザがこの端末への保存を許可していないようです。Cookie を許可して、もう一度お試しください。",
      [Y.En]: "Your details were verified, but your browser does not seem to allow saving it on this device. Please allow cookies and try again."
    }
  }),
  submit: wn({
    lang: e,
    i18nString: { [Y.Default]: "確認する", [Y.En]: "Continue" }
  }),
  submitting: wn({
    lang: e,
    i18nString: { [Y.Default]: "確認中...", [Y.En]: "Verifying..." }
  }),
  /** 予約の変更を開く前に、トークンが使えなかったとき（キャンセルなどで出る、サーバーの Reservation_AccessUnauthorized の文言と同じ） */
  accessUnauthorized: wn({
    lang: e,
    i18nString: {
      [Y.Default]: "ご本人確認の有効期限が切れました。お手数ですが、もう一度ご本人確認をお願いします。",
      [Y.En]: "Your verification has expired. Please verify your identity again."
    }
  }),
  telLast4SendLead: wn({
    lang: e,
    i18nString: {
      [Y.Default]: "電話番号がわからない場合は、メールで下4桁を受け取れます。",
      [Y.En]: "If you don't know the phone number, you can get the last 4 digits by email."
    }
  }),
  telLast4Send: wn({
    lang: e,
    i18nString: {
      [Y.Default]: "メールで下4桁を受け取る",
      [Y.En]: "Get the last 4 digits by email"
    }
  }),
  telLast4Confirm: wn({
    lang: e,
    i18nString: {
      [Y.Default]: "ご予約時のメールアドレスに、電話番号の下4桁をお送りします。",
      [Y.En]: "We will send the last 4 digits of the phone number to the email address you used when booking."
    }
  }),
  telLast4Return: wn({
    lang: e,
    i18nString: { [Y.Default]: "戻る", [Y.En]: "Return" }
  }),
  telLast4Submit: wn({
    lang: e,
    i18nString: { [Y.Default]: "送信する", [Y.En]: "Send" }
  }),
  telLast4Sent: wn({
    lang: e,
    i18nString: {
      [Y.Default]: "ご予約時のメールアドレスに、電話番号の下4桁をお送りしています。メールが見つからない場合は、施設に直接お問い合わせください。",
      [Y.En]: "We have sent the last 4 digits of the phone number to the email address you used when booking. If you cannot find the email, please contact the property directly."
    }
  })
}), v6e = bl(
  /* GraphQL */
  `
	mutation RDGReservationAccessTelLast4Send($hotelId: ID!, $reservationId: ID!) {
		reservationAccessTelLast4Send(hotelID: $hotelId, reservationID: $reservationId)
	}
`
), h6e = bl(
  /* GraphQL */
  `
	mutation RDGReservationAccessTokenIssue($hotelId: ID!, $reservationId: ID!, $telLast4: String!) {
		reservationAccessTokenIssue(hotelID: $hotelId, reservationID: $reservationId, telLast4: $telLast4) {
			reservationID
			accessToken
		}
	}
`
), c8 = bl(
  /* GraphQL */
  `
	query RDGReservationAccessCheck($hotelId: ID!, $reservationId: ID!) {
		reservationAccessCheck(hotelID: $hotelId, reservationID: $reservationId) {
			status
		}
	}
`
), p6e = (e) => /^\d{4}$/.test(e), N6e = (e) => /[^0-9]/.test(e), v1 = t6e, kp = u6e, S6e = g(({ hotelID: e, reservationID: n, lang: i }) => {
  const t = mp(i), { mutationFunc: a } = v1(v6e), { onShowLoadingScreenCallback: s, onHideLoadingScreenCallback: r } = fn(), [o, d] = se(!1), [c, u] = se(!1), k = I(() => d(!0), []), m = I(() => d(!1), []), f = I(async () => {
    s();
    try {
      await a({ variables: { hotelId: e, reservationId: n } }), u(!0);
    } catch (p) {
    } finally {
      r(), d(!1);
    }
  }, [e, r, s, n, a]);
  return c ? /* @__PURE__ */ l.jsx("p", { role: "status", className: "ch-text-sm ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: t.telLast4Sent }) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-center ch-text-sm ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: t.telLast4SendLead }),
      /* @__PURE__ */ l.jsx(ae, { type: "button", variant: "outline", className: "ch-w-full", onClick: k, children: t.telLast4Send })
    ] }),
    o && /* @__PURE__ */ l.jsx(br, { open: !0, modal: !0, children: /* @__PURE__ */ l.jsxs(Cr, { className: "ch-px-6 ch-py-8", "aria-describedby": void 0, children: [
      /* @__PURE__ */ l.jsx(t1, {}),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-9", children: [
        /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: t.telLast4Confirm }),
        /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
          /* @__PURE__ */ l.jsx(
            ae,
            {
              type: "button",
              className: "ch-w-full",
              variant: "outline",
              size: "md",
              onClick: m,
              children: t.telLast4Return
            }
          ),
          /* @__PURE__ */ l.jsx(
            ae,
            {
              type: "button",
              className: "ch-w-full",
              variant: "default",
              size: "md",
              onClick: () => void f(),
              children: t.telLast4Submit
            }
          )
        ] })
      ] })
    ] }) })
  ] });
}), g6e = g(({ children: e, initializeContext: n }) => {
  const { hotelID: i, reservationID: t, lang: a } = n, [s, r] = se("Checking"), [o, d] = se(null), [c, u] = se(""), [k, m] = se(!1), { refetch: f } = kp(c8, void 0, !0), { mutationFunc: p } = v1(h6e), [h, N] = se(!1), S = Ye({ checkAccess: f });
  S.current = { checkAccess: f }, be(() => {
    let T = !1;
    return (async () => {
      try {
        const { data: A } = await S.current.checkAccess({ hotelId: i, reservationId: t });
        if (T)
          return;
        if (A.reservationAccessCheck.status === Ys.Authorized) {
          r("Authorized");
          return;
        }
        Yv(t), r("Unauthorized");
      } catch (A) {
        T || d(A instanceof Error ? A : new Error("reservationAccessCheck failed"));
      }
    })(), () => {
      T = !0;
    };
  }, [i, t]), be(() => a6e(t, () => r("Unauthorized")), [t]);
  const F = p6e(c), y = N6e(c), x = I(
    async (T) => {
      if (T.preventDefault(), !(h || !F)) {
        N(!0);
        try {
          const { data: j } = await p({
            variables: { hotelId: i, reservationId: t, telLast4: c }
          });
          bC(t, j.reservationAccessTokenIssue.accessToken);
          const { data: A } = await f({ hotelId: i, reservationId: t });
          A.reservationAccessCheck.status === Ys.Authorized ? (m(!1), r("Authorized")) : m(!0);
        } catch (j) {
        } finally {
          N(!1);
        }
      }
    },
    [f, i, F, h, p, t, c]
  );
  if (o !== null)
    throw o;
  if (s === "Checking")
    return /* @__PURE__ */ l.jsx(Sd, {});
  if (s === "Authorized")
    return e;
  const R = mp(a);
  return (
    // 親が flex（magazine の body など）でも、中身の幅に縮まず、画面の幅に収まるよう、幅を指定する
    /* @__PURE__ */ l.jsxs("form", { className: "ch-mx-auto ch-w-full ch-max-w-md ch-space-y-6 ch-px-4 ch-py-12", onSubmit: x, children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
        /* @__PURE__ */ l.jsx("h2", { className: "ch-text-xl ch-font-semibold ch-text-black ch-opacity-90", children: R.title }),
        /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: R.description })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
        /* @__PURE__ */ l.jsx(Qn, { htmlFor: "reservation-access-tel-last4", children: R.telLast4Label }),
        /* @__PURE__ */ l.jsx(
          Qa,
          {
            id: "reservation-access-tel-last4",
            type: "text",
            inputMode: "numeric",
            autoComplete: "off",
            maxLength: 4,
            value: c,
            onChange: (T) => {
              u(T.target.value), m(!1);
            },
            disabled: h
          }
        ),
        y && /* @__PURE__ */ l.jsx("p", { role: "alert", className: "ch-text-urgent-400 ch-text-sm", children: R.telLast4Invalid }),
        k && /* @__PURE__ */ l.jsx("p", { role: "alert", className: "ch-text-urgent-400 ch-text-sm", children: R.tokenNotUsable })
      ] }),
      /* @__PURE__ */ l.jsx(ae, { type: "submit", className: "ch-w-full", disabled: h || !F, children: h ? R.submitting : R.submit }),
      /* @__PURE__ */ l.jsx(S6e, { hotelID: i, reservationID: t, lang: a })
    ] })
  );
}), F6e = (e, n, i) => {
  const { refetch: t } = kp(c8, void 0, !0);
  return I(
    async (a) => {
      try {
        const { data: s } = await t({ hotelId: e, reservationId: n });
        if (s.reservationAccessCheck.status !== Ys.Authorized) {
          $1().addError(mp(i).accessUnauthorized), Yv(n), Zw(n);
          return;
        }
      } catch (s) {
        return;
      }
      a();
    },
    [t, e, i, n]
  );
}, I6e = () => ({
  kind: "Initialized"
}), y6e = (e) => ({
  kind: "NotInitialized",
  onInitialize: e.onInitialize
}), b6e = (e) => {
  const [n, i] = se(y6e(e)), t = I((s) => {
    i(s);
  }, []), { showBoundary: a } = hr();
  return be(() => {
    if (n.kind === "Initialized")
      return;
    (async () => {
      try {
        await n.onInitialize();
        const r = I6e(n);
        t(r);
      } catch (r) {
        if (l6e(r))
          return;
        throw a(r), r;
      }
    })();
  }, [t, a, n]), {
    state: n
  };
}, fp = Qw()((e) => ({
  kind: "UnInitialized",
  initialize: (n, i, t) => (a, s, r, o) => e({
    kind: "Initialized",
    hotelID: n,
    reservationID: i,
    lang: t,
    hotelInfo: a,
    actionInfo: s,
    reservationInfo: r,
    reservationStatusInfo: o
  }),
  reset: (n, i, t, a) => e({ hotelInfo: n, actionInfo: i, reservationInfo: t, reservationStatusInfo: a }),
  restore: () => e({ kind: "UnInitialized" })
})), C6e = () => {
  const { initialize: e } = fp();
  return {
    onInitialize: I(
      (i, t, a) => (s) => {
        const {
          reservationDetail: { hotelInfo: r, availableActionInfo: o, reservationInfo: d, reservationStatusInfo: c }
        } = s;
        e(i, t, a)(
          r,
          o,
          d,
          c
        );
      },
      [e]
    )
  };
}, x6e = () => {
  const e = fp();
  if (e.kind === "UnInitialized")
    throw new Error("useReservationDetailData: store is not initialized");
  return v(() => ({
    hotelID: e.hotelID,
    reservationID: e.reservationID,
    lang: e.lang,
    hotelInfo: e.hotelInfo,
    actionInfo: e.actionInfo,
    reservationInfo: e.reservationInfo,
    reservationStatusInfo: e.reservationStatusInfo
  }), [
    e.actionInfo,
    e.hotelID,
    e.hotelInfo,
    e.lang,
    e.reservationID,
    e.reservationInfo,
    e.reservationStatusInfo
  ]);
}, D6e = () => {
  const { reset: e } = fp();
  return {
    onUpdateReservationDetail: I(
      (i) => {
        e(i.hotelInfo, i.actionInfo, i.reservationInfo, i.reservationStatusInfo);
      },
      [e]
    )
  };
}, w6e = bl(
  /* GraphQL */
  `
	query RDGReservationInitialDetail($hotelId: ID!, $reservationId: ID!, $lang: LangCode) {
		reservationInitialDetail(hotelID: $hotelId, reservationID: $reservationId, lang: $lang) {
			reservationDetail {
				hotelID
				reservationID
				reservationStatusInfo {
					isCanceled
					isDayTrip
					requestStatus
					authorizeScheduleNotice
				}
				hotelInfo {
					customTypeRoomTitle
					roomFacilities
					addressInfo {
						postalCode
						coordinate {
							lat
							lon
						}
						address
					}
					tel
					name
					email
					cautions {
						title
						description
					}
					bathroomFacilities
					amenities
				}
				availableActionInfo {
					canCancel
					canEdit
					canEditCreditCard
					canIssueReceipt
					requiredCollectCancelFee {
						transferLimitDt
						bankTransferStatus
						bankTransferDestination {
							branchName
							bankName
							bankAccountType
							bankAccountNumber
							bankAccountHolderName
						}
					}
					requiredCollectCreditCancelFee
					isCreditCancelFeePendingHostCharge
				}
				reservationInfo {
					guestInfo {
						name
						nameKana
						email
						postalCode
						address
						tel
					}
					questionInfo {
						question
						answers
					}
					priceInfo {
						totalGuestCharge
						willCancelPrice
					}
					discountInfo {
						name
						discountPrice
					}
					voucherInfo {
						name
						discountPrice
					}
					dateInfo {
						isDayTrip
						checkInDt
						checkInStartAt
						checkInEndAt
						checkOutDt
						checkOutEndAt
						isShowCheckInOutTime
					}
					planInfo {
						cancelPolicy {
							chargeRatio
							beforeDays
						}
						price
						name
					}
					planCanceledInfo {
						name
						canceledPrice
						canceledAt
					}
					roomInfo {
						groupCount
						totalPeopleCount
						items {
							kidsNum {
								age
								isCoSleeping
							}
							dailyInfo {
								date
								name
								price
							}
							adultNum
						}
						cancelPolicy {
							beforeDays
							chargeRatio
						}
					}
					roomCanceledInfo {
						kidsNum {
							age
							isCoSleeping
						}
						name
						date
						canceledPrice
						adultNum
						canceledAt
					}
					optionInfo {
						cancelPolicy {
							beforeDays
							chargeRatio
						}
						price
						name
						time
						date
						amount
					}
					timeSlotOptionInfo {
						cancelPolicy {
							beforeDays
							chargeRatio
						}
						price
						name
						time
						date
						amount
					}
					optionCanceledInfo {
						date
						name
						amount
						canceledPrice
						canceledAt
					}
					additionalFeeInfo {
						billingTypeTerm
						billingTypeTarget
						name
						price {
							amount
							currencyType
						}
					}
				}
			}
		}
	}
`
), P6e = ({ initializeContext: e }) => {
  const { onInitialize: n } = C6e(), { refetch: i } = kp(w6e, void 0, !0);
  return {
    onInitialize: I(async () => {
      var s;
      const { data: a } = await i({
        hotelId: e.hotelID,
        reservationId: e.reservationID,
        lang: e.lang
      });
      n(
        e.hotelID,
        e.reservationID,
        (s = e.lang) != null ? s : Y.Default
      )(a.reservationInitialDetail);
    }, [n, i, e])
  };
}, R6e = g(({ children: e, initializeContext: n }) => {
  const { onInitialize: i } = P6e({ initializeContext: n }), { state: t } = b6e({ onInitialize: i });
  return t.kind === "NotInitialized" ? /* @__PURE__ */ l.jsx(Sd, {}) : e;
}), T6e = bl(
  /* GraphQL */
  `
	mutation RDGReservationCancel($hotelId: ID!, $reservationId: ID!, $lang: LangCode) {
		reservationCancel(hotelID: $hotelId, reservationID: $reservationId, lang: $lang) {
			reservationDetail {
				hotelID
				reservationID
				reservationStatusInfo {
					isCanceled
					isDayTrip
					requestStatus
					authorizeScheduleNotice
				}
				hotelInfo {
					customTypeRoomTitle
					roomFacilities
					addressInfo {
						postalCode
						coordinate {
							lat
							lon
						}
						address
					}
					tel
					name
					email
					cautions {
						title
						description
					}
					bathroomFacilities
					amenities
				}
				availableActionInfo {
					canCancel
					canEdit
					canEditCreditCard
					canIssueReceipt
					requiredCollectCreditCancelFee
					isCreditCancelFeePendingHostCharge
					requiredCollectCancelFee {
						transferLimitDt
						bankTransferStatus
						bankTransferDestination {
							branchName
							bankName
							bankAccountType
							bankAccountNumber
							bankAccountHolderName
						}
					}
				}
				reservationInfo {
					guestInfo {
						name
						nameKana
						email
						postalCode
						address
						tel
					}
					questionInfo {
						question
						answers
					}
					priceInfo {
						totalGuestCharge
						willCancelPrice
					}
					discountInfo {
						name
						discountPrice
					}
					voucherInfo {
						name
						discountPrice
					}
					dateInfo {
						isDayTrip
						checkInDt
						checkInStartAt
						checkInEndAt
						checkOutDt
						checkOutEndAt
						isShowCheckInOutTime
					}
					planInfo {
						cancelPolicy {
							chargeRatio
							beforeDays
						}
						price
						name
					}
					planCanceledInfo {
						name
						canceledPrice
						canceledAt
					}
					roomInfo {
						groupCount
						totalPeopleCount
						items {
							kidsNum {
								age
								isCoSleeping
							}
							dailyInfo {
								date
								name
								price
							}
							adultNum
						}
						cancelPolicy {
							beforeDays
							chargeRatio
						}
					}
					roomCanceledInfo {
						kidsNum {
							age
							isCoSleeping
						}
						name
						date
						canceledPrice
						adultNum
						canceledAt
					}
					optionInfo {
						cancelPolicy {
							beforeDays
							chargeRatio
						}
						price
						name
						time
						date
						amount
					}
					timeSlotOptionInfo {
						cancelPolicy {
							beforeDays
							chargeRatio
						}
						price
						name
						time
						date
						amount
					}
					optionCanceledInfo {
						date
						name
						amount
						canceledPrice
						canceledAt
					}
					additionalFeeInfo {
						billingTypeTerm
						billingTypeTarget
						name
						price {
							amount
							currencyType
						}
					}
				}
			}
		}
	}
`
), j6e = bl(
  /* GraphQL */
  `
	mutation RDGReservationCollectLocalCancelFeeWithBankTransfer(
		$hotelId: ID!
		$reservationId: ID!
		$lang: LangCode!
		$bankAccountName: String!
		$bankTransferDate: String!
	) {
		reservationCollectLocalCancelFeeWithBankTransfer(
			hotelID: $hotelId
			reservationID: $reservationId
			lang: $lang
			bankAccountName: $bankAccountName
			bankTransferDate: $bankTransferDate
		) {
			reservationDetail {
				hotelID
				reservationID
				reservationStatusInfo {
					isCanceled
					isDayTrip
					requestStatus
					authorizeScheduleNotice
				}
				hotelInfo {
					customTypeRoomTitle
					roomFacilities
					addressInfo {
						postalCode
						coordinate {
							lat
							lon
						}
						address
					}
					tel
					name
					email
					cautions {
						title
						description
					}
					bathroomFacilities
					amenities
				}
				availableActionInfo {
					canCancel
					canEdit
					canEditCreditCard
					canIssueReceipt
					requiredCollectCancelFee {
						transferLimitDt
						bankTransferStatus
						bankTransferDestination {
							branchName
							bankName
							bankAccountType
							bankAccountNumber
							bankAccountHolderName
						}
					}
				}
				reservationInfo {
					guestInfo {
						name
						nameKana
						email
						postalCode
						address
						tel
					}
					questionInfo {
						question
						answers
					}
					priceInfo {
						totalGuestCharge
						willCancelPrice
					}
					discountInfo {
						name
						discountPrice
					}
					voucherInfo {
						name
						discountPrice
					}
					dateInfo {
						isDayTrip
						checkInDt
						checkInStartAt
						checkInEndAt
						checkOutDt
						checkOutEndAt
						isShowCheckInOutTime
					}
					planInfo {
						cancelPolicy {
							chargeRatio
							beforeDays
						}
						price
						name
					}
					planCanceledInfo {
						name
						canceledPrice
						canceledAt
					}
					roomInfo {
						groupCount
						totalPeopleCount
						items {
							kidsNum {
								age
								isCoSleeping
							}
							dailyInfo {
								date
								name
								price
							}
							adultNum
						}
						cancelPolicy {
							beforeDays
							chargeRatio
						}
					}
					roomCanceledInfo {
						kidsNum {
							age
							isCoSleeping
						}
						name
						date
						canceledPrice
						adultNum
						canceledAt
					}
					optionInfo {
						cancelPolicy {
							beforeDays
							chargeRatio
						}
						price
						name
						time
						date
						amount
					}
					timeSlotOptionInfo {
						cancelPolicy {
							beforeDays
							chargeRatio
						}
						price
						name
						time
						date
						amount
					}
					optionCanceledInfo {
						date
						name
						amount
						canceledPrice
						canceledAt
					}
					additionalFeeInfo {
						billingTypeTerm
						billingTypeTarget
						name
						price {
							amount
							currencyType
						}
					}
				}
			}
		}
	}
`
), A6e = bl(
  /* GraphQL */
  `
	mutation RDGReservationCollectLocalCancelFeeWithCreditStart(
		$hotelId: ID!
		$reservationId: ID!
		$lang: LangCode!
		$paymentToken: String!
		$callbackUrl: String!
	) {
		reservationCollectLocalCancelFeeWithCreditStart(
			hotelID: $hotelId
			reservationID: $reservationId
			lang: $lang
			paymentToken: $paymentToken
			callbackURL: $callbackUrl
		) {
			paymentToken
			callbackUrlJWS
		}
	}
`
), O6e = bl(
  /* GraphQL */
  `
	mutation RDGReservationIssuedReceipt($hotelId: ID!, $reservationId: ID!, $lang: LangCode, $address: String) {
		reservationIssuedReceipt(hotelID: $hotelId, reservationID: $reservationId, lang: $lang, address: $address) {
			pdfUrl
			reservationDetail {
				hotelID
				reservationID
				reservationStatusInfo {
					isCanceled
					isDayTrip
					requestStatus
					authorizeScheduleNotice
				}
				hotelInfo {
					customTypeRoomTitle
					roomFacilities
					addressInfo {
						postalCode
						coordinate {
							lat
							lon
						}
						address
					}
					tel
					name
					email
					cautions {
						title
						description
					}
					bathroomFacilities
					amenities
				}
				availableActionInfo {
					canCancel
					canEdit
					canEditCreditCard
					canIssueReceipt
					requiredCollectCancelFee {
						transferLimitDt
						bankTransferStatus
						bankTransferDestination {
							branchName
							bankName
							bankAccountType
							bankAccountNumber
							bankAccountHolderName
						}
					}
				}
				reservationInfo {
					guestInfo {
						name
						nameKana
						email
						postalCode
						address
						tel
					}
					questionInfo {
						question
						answers
					}
					priceInfo {
						totalGuestCharge
						willCancelPrice
					}
					discountInfo {
						name
						discountPrice
					}
					voucherInfo {
						name
						discountPrice
					}
					dateInfo {
						isDayTrip
						checkInDt
						checkInStartAt
						checkInEndAt
						checkOutDt
						checkOutEndAt
						isShowCheckInOutTime
					}
					planInfo {
						cancelPolicy {
							chargeRatio
							beforeDays
						}
						price
						name
					}
					planCanceledInfo {
						name
						canceledPrice
						canceledAt
					}
					roomInfo {
						groupCount
						totalPeopleCount
						items {
							kidsNum {
								age
								isCoSleeping
							}
							dailyInfo {
								date
								name
								price
							}
							adultNum
						}
						cancelPolicy {
							beforeDays
							chargeRatio
						}
					}
					roomCanceledInfo {
						kidsNum {
							age
							isCoSleeping
						}
						name
						date
						canceledPrice
						adultNum
						canceledAt
					}
					optionInfo {
						cancelPolicy {
							beforeDays
							chargeRatio
						}
						price
						name
						time
						date
						amount
					}
					timeSlotOptionInfo {
						cancelPolicy {
							beforeDays
							chargeRatio
						}
						price
						name
						time
						date
						amount
					}
					optionCanceledInfo {
						date
						name
						amount
						canceledPrice
						canceledAt
					}
					additionalFeeInfo {
						billingTypeTerm
						billingTypeTarget
						name
						price {
							amount
							currencyType
						}
					}
				}
			}
		}
	}
`
), E6e = ({ hotelID: e, reservationID: n, lang: i, callbackContext: t }) => {
  const { mutationFunc: a } = v1(T6e);
  return {
    onReservationCancel: I(async () => {
      const { data: r } = await a({ variables: { hotelId: e, reservationId: n, lang: i } }), { hotelInfo: o, availableActionInfo: d, reservationInfo: c, reservationStatusInfo: u } = r.reservationCancel.reservationDetail;
      t.onUpdateReservationDetailCallback({
        hotelInfo: o,
        actionInfo: d,
        reservationInfo: c,
        reservationStatusInfo: u
      });
    }, [t, e, i, a, n])
  };
}, J6e = ({
  hotelID: e,
  reservationID: n,
  lang: i,
  callbackContext: t
}) => {
  const { mutationFunc: a } = v1(
    j6e
  );
  return {
    onReservationCollectLocalCancelFeeWithBankTransfer: I(
      async (r, o) => {
        const { data: d } = await a({
          variables: {
            hotelId: e,
            reservationId: n,
            lang: i,
            bankAccountName: r,
            bankTransferDate: o
          }
        }), { hotelInfo: c, availableActionInfo: u, reservationInfo: k, reservationStatusInfo: m } = d.reservationCollectLocalCancelFeeWithBankTransfer.reservationDetail;
        t.onUpdateReservationDetailCallback({
          hotelInfo: c,
          actionInfo: u,
          reservationInfo: k,
          reservationStatusInfo: m
        });
      },
      [t, e, i, a, n]
    )
  };
}, _6e = ({
  hotelID: e,
  reservationID: n,
  lang: i,
  callbackContext: t,
  libContext: a
}) => {
  const { onGet3DSecureStartUrl: s } = IC({ instance: a.payjp.instance }), { mutationFunc: r } = v1(
    A6e
  );
  return {
    onReservationCollectLocalCancelFeeWithCreditStart: I(
      async (d) => {
        const c = {
          hotelId: e,
          reservationId: n,
          lang: i,
          paymentToken: d,
          callbackUrl: t.onGetPayjpBackUrlForCollectCancelFeeCallback(e, n, i)
        }, { data: u } = await r({ variables: c }), { callbackUrlJWS: k, paymentToken: m } = u.reservationCollectLocalCancelFeeWithCreditStart, f = s(m)(k);
        window.location.href = f;
      },
      [t, e, i, r, s, n]
    )
  };
}, Q6e = (e) => {
  const { onReservationCollectLocalCancelFeeWithCreditStart: n } = _6e(e), { onReservationCollectLocalCancelFeeWithBankTransfer: i } = J6e(e);
  return {
    onReservationCollectLocalCancelFeeWithCreditStart: n,
    onReservationCollectLocalCancelFeeWithBankTransfer: i
  };
}, M6e = ({ hotelID: e, reservationID: n, lang: i, callbackContext: t }) => {
  const { mutationFunc: a } = v1(O6e);
  return {
    onReservationIssuedReceipt: I(
      async (r) => {
        const { data: o } = await a({
          variables: {
            hotelId: e,
            reservationId: n,
            lang: i,
            address: r
          }
        }), {
          reservationDetail: { hotelInfo: d, availableActionInfo: c, reservationInfo: u, reservationStatusInfo: k },
          pdfUrl: m
        } = o.reservationIssuedReceipt;
        return t.onUpdateReservationDetailCallback({
          hotelInfo: d,
          actionInfo: c,
          reservationInfo: u,
          reservationStatusInfo: k
        }), {
          pdfUrl: m
        };
      },
      [t, e, i, a, n]
    )
  };
}, M9 = "https://support.chillnn.com/faq/guest/payment/699fffe15c578304835d81d58dda6f01", L6e = g(({ displayContext: e }) => e.reservationStatusInfo.isCanceled || P(e.reservationStatusInfo.authorizeScheduleNotice) ? null : /* @__PURE__ */ l.jsxs(hd, { variant: "warning", children: [
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: e.reservationStatusInfo.authorizeScheduleNotice }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: e.lang === Y.En ? /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    "Please check",
    /* @__PURE__ */ l.jsx(
      "a",
      {
        className: "ch-mx-1 ch-font-semibold ch-text-link-400 ch-underline",
        href: M9,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "this page"
      }
    ),
    "for details on the payment timing."
  ] }) : /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    "決済タイミングについては",
    /* @__PURE__ */ l.jsx(
      "a",
      {
        className: "ch-font-semibold ch-text-link-400 ch-underline",
        href: M9,
        target: "_blank",
        rel: "noopener noreferrer",
        children: "こちら"
      }
    ),
    "をご確認ください。"
  ] }) })
] })), h1 = g(({ titleTextSlot: e, contentSlot: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6 ch-bg-white ch-px-5 ch-py-8", children: [
  /* @__PURE__ */ l.jsx("h3", { className: "ch-text-xl ch-font-semibold ch-text-black ch-opacity-90", children: e }),
  n
] })), $6e = (e) => {
  var n;
  if (e.actionInfo.requiredCollectCreditCancelFee)
    return {
      kind: "CreditCancelFeePayable",
      lang: e.lang,
      cancelPrice: e.priceInfo.totalGuestCharge,
      reservationStatusInfo: e.reservationStatusInfo,
      guestInfo: e.guestInfo,
      onPayCreditCancelFeeCallback: e.callbackContext.onPayCreditCancelFee
    };
  if (!P(e.actionInfo.requiredCollectCancelFee)) {
    if (e.actionInfo.requiredCollectCancelFee.bankTransferStatus === fr.RequiredAction)
      return {
        kind: "CancelPricePayable",
        lang: e.lang,
        reservationStatusInfo: e.reservationStatusInfo,
        cancelPrice: e.priceInfo.totalGuestCharge,
        bankTransferDestination: e.actionInfo.requiredCollectCancelFee.bankTransferDestination,
        transferLimitDt: e.actionInfo.requiredCollectCancelFee.transferLimitDt,
        guestInfo: e.guestInfo,
        onPayCancelPriceForBankTransferCallback: e.callbackContext.onPayCancelPriceForBankTransfer,
        onPayCancelPriceForCreditCallback: e.callbackContext.onPayCancelPriceForCredit
      };
    if (e.actionInfo.requiredCollectCancelFee.bankTransferStatus === fr.Pending)
      return {
        kind: "TransferStatusCheckable",
        lang: e.lang,
        willCancelPrice: (n = e.priceInfo.willCancelPrice) != null ? n : 0,
        transferLimitDt: e.actionInfo.requiredCollectCancelFee.transferLimitDt
      };
  }
  return {
    kind: "CancelPriceInfoCheckable",
    lang: e.lang,
    actionInfo: e.actionInfo,
    guestInfo: e.guestInfo,
    cancelPrice: e.priceInfo.totalGuestCharge,
    canIssueReceipt: e.actionInfo.canIssueReceipt,
    // 与信失敗強制キャンセルで未徴収（施設の請求待ち）のとき、「発生しています」表示＋領収書非表示にする。
    isPendingHostCharge: !!e.actionInfo.isCreditCancelFeePendingHostCharge,
    onIssuedReceiptCallback: e.callbackContext.onIssuedReceipt
  };
}, U6e = (e) => ({
  state: v(() => $6e(e), [e])
}), V6e = g(({ lang: e, isPendingHostCharge: n }) => {
  const i = v(() => e === Y.Default ? n ? `キャンセルポリシーに基づき、以下に示す料金が発生しています。
施設からキャンセル料の請求がある場合があります。` : "キャンセルポリシーに基づき、以下に示す料金を徴収いたしました。" : n ? `Based on the cancellation policy, the following charges have been incurred.
The facility may request payment of the cancellation fee.` : "Based on the cancellation policy, the following charges have been collected.", [e, n]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-break-spaces ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: i });
}), H6e = g(({ lang: e, price: n }) => {
  const i = v(() => e === Y.Default ? "キャンセル料金/合計" : "Cancellation fee/Total", [e]), t = v(() => `¥ ${n.toLocaleString()}`, [n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-black", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black ch-opacity-90", children: t })
  ] });
}), z6e = (e) => ({
  kind: "Initialized",
  lang: e.lang,
  canIssueReceipt: e.actionInfo.canIssueReceipt
}), B6e = (e) => () => ({
  kind: "Issued",
  lang: e.lang,
  pdfUrl: e.pdfUrl,
  canIssueReceipt: e.actionInfo.canIssueReceipt
}), q6e = (e) => () => ({
  kind: "Initialized",
  lang: e.lang,
  canIssueReceipt: e.actionInfo.canIssueReceipt
}), G6e = (e) => () => ({
  kind: "Started",
  lang: e.lang,
  guestInfo: e.guestInfo,
  onIssuedReceiptCallback: e.onIssuedReceiptCallback
}), W6e = (e) => ({
  onInitialize: I(() => z6e(e.initializeInputContext), [e.initializeInputContext])
}), K6e = (e) => ({
  onIssue: I(
    (i) => async (t) => {
      const a = await i.onIssuedReceiptCallback(t);
      if (Ke(a.pdfUrl))
        throw new Error("Failed to issue receipt.");
      const s = {
        ...e.issueInputContext,
        pdfUrl: a.pdfUrl
      }, r = B6e(s)(i);
      e.callbackContext.onChangeStateCallback(r), window.open(a.pdfUrl);
    },
    [e]
  )
}), Y6e = (e) => ({
  onReturn: I(
    (i) => () => {
      const t = q6e(e.returnInputContext)(i);
      e.callbackContext.onChangeStateCallback(t);
    },
    [e]
  )
}), X6e = (e) => ({
  onStart: I(
    (i) => () => {
      const t = G6e(e.startInputContext)(i);
      e.callbackContext.onChangeStateCallback(t);
    },
    [e]
  )
}), Z6e = (e) => {
  const { onInitialize: n } = W6e({
    initializeInputContext: e.modelContext
  }), [i, t] = se(n()), a = I((d) => {
    t(d);
  }, []), { onStart: s } = X6e({
    startInputContext: e.modelContext,
    callbackContext: {
      onChangeStateCallback: a
    }
  }), { onIssue: r } = K6e({
    issueInputContext: e.modelContext,
    callbackContext: {
      onChangeStateCallback: a
    }
  }), { onReturn: o } = Y6e({
    returnInputContext: e.modelContext,
    callbackContext: {
      onChangeStateCallback: a
    }
  });
  return {
    state: i,
    onStart: s,
    onIssue: r,
    onReturn: o
  };
}, ebe = g(({ state: e, onSubmitCallback: n }) => {
  const i = v(() => e.lang === Y.Default ? "領収書を発行する" : "Issue Receipt", [e.lang]), t = I(() => {
    n();
  }, [n]);
  return e.canIssueReceipt ? /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "default", size: "md", onClick: t, children: i }) : null;
}), nbe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "領収書を表示する";
      case Y.En:
        return "Show Receipt";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx(
    "a",
    {
      className: "ch-text-sm ch-font-semibold ch-text-black ch-underline ch-underline-offset-4 ch-opacity-90",
      href: e.pdfUrl,
      target: "_blank",
      children: n
    }
  );
}), ibe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "領収書を再発行する";
      case Y.En:
        return "Re-issue Receipt";
      default:
        return "";
    }
  }, [e.lang]), i = I(() => {
    e.onSubmitCallback();
  }, [e]);
  return e.canIssueReceipt ? null : /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "default", size: "md", onClick: i, children: n });
}), tbe = (e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
  /* @__PURE__ */ l.jsx(ibe, { ...e.state, onSubmitCallback: e.onSubmitCallback }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-text-right", children: /* @__PURE__ */ l.jsx(nbe, { ...e.state }) })
] }), abe = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? "宛名が空欄の場合は、予約者の名前が入ります。" : "If the addressee is blank, the name of the person who made the reservation will be entered.", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: n });
}), lbe = g(({ lang: e, value: n, onChangeCallback: i }) => {
  const t = v(() => e === Y.Default ? "領収書の宛名" : "Addresse", [e]), a = I(
    (s) => {
      const r = s.target.value;
      i(r);
    },
    [i]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: t }),
    /* @__PURE__ */ l.jsx(Qa, { placeholder: "TARO YAMADA", value: n, onChange: a })
  ] });
}), sbe = g(({ lang: e, onSubmitCallback: n }) => {
  const i = v(() => e === Y.Default ? "戻る" : "Return", [e]), t = I(() => {
    n();
  }, [n]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "outline", size: "md", onClick: t, children: i });
}), rbe = g(({ lang: e, onSubmitCallback: n }) => {
  const i = v(() => e === Y.Default ? "発行する" : "Issue Receipt", [e]), t = I(() => {
    n();
  }, [n]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "default", size: "md", onClick: t, children: i });
}), obe = g(({ children: e }) => /* @__PURE__ */ l.jsx(br, { open: !0, modal: !0, children: /* @__PURE__ */ l.jsxs(Cr, { className: "ch-px-6 ch-py-8", "aria-describedby": void 0, children: [
  /* @__PURE__ */ l.jsx(t1, {}),
  e
] }) })), dbe = g(({ state: e, onIssue: n, onReturn: i }) => {
  const [t, a] = se(e.guestInfo.name), s = I((c) => {
    a(c);
  }, []), { onHideLoadingScreenCallback: r, onShowLoadingScreenCallback: o } = fn(), d = I(async () => {
    o(), await n(t).finally(() => {
      r();
    });
  }, [o, n, t, r]);
  return /* @__PURE__ */ l.jsx(obe, { children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-9", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
      /* @__PURE__ */ l.jsx(lbe, { lang: e.lang, value: t, onChangeCallback: s }),
      /* @__PURE__ */ l.jsx(abe, { lang: e.lang })
    ] }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
      /* @__PURE__ */ l.jsx(sbe, { lang: e.lang, onSubmitCallback: i }),
      /* @__PURE__ */ l.jsx(rbe, { lang: e.lang, onSubmitCallback: d })
    ] })
  ] }) });
}), u8 = g((e) => {
  const {
    state: n,
    onStart: i,
    onIssue: t,
    onReturn: a
  } = Z6e(e);
  return n.kind === "Started" ? /* @__PURE__ */ l.jsx(dbe, { state: n, onReturn: a(n), onIssue: t(n) }) : n.kind === "Issued" ? /* @__PURE__ */ l.jsx(tbe, { state: n, onSubmitCallback: i(n) }) : /* @__PURE__ */ l.jsx(ebe, { state: n, onSubmitCallback: i(n) });
}), cbe = g(({ state: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx(V6e, { lang: e.lang, isPendingHostCharge: e.isPendingHostCharge }),
    /* @__PURE__ */ l.jsx(H6e, { lang: e.lang, price: e.cancelPrice })
  ] }),
  e.canIssueReceipt && !e.isPendingHostCharge ? /* @__PURE__ */ l.jsx(
    u8,
    {
      modelContext: {
        lang: e.lang,
        actionInfo: e.actionInfo,
        guestInfo: e.guestInfo,
        onIssuedReceiptCallback: e.onIssuedReceiptCallback
      }
    }
  ) : null
] })), ube = (e) => () => ({
  kind: "Finished",
  lang: e.lang,
  onPayCancelPriceForBankTransferCallback: e.onPayCancelPriceForBankTransferCallback
}), mbe = (e) => ({
  kind: "Initialized",
  lang: e.lang
}), kbe = (e) => (n) => n.kind === "Finished" ? {
  kind: "Started",
  lang: e.lang,
  cancelPrice: e.cancelPrice,
  bankTransferDestination: e.bankTransferDestination
} : {
  kind: "Initialized",
  lang: e.lang
}, fbe = (e) => () => ({
  kind: "Started",
  lang: e.lang,
  cancelPrice: e.cancelPrice,
  bankTransferDestination: e.bankTransferDestination
}), vbe = ({ finishInputContext: e, stateContext: n }) => ({
  onFinish: I(
    (t) => () => {
      const a = ube(e)(t);
      n.onChangeStateCallback(a);
    },
    [n, e]
  )
}), hbe = ({ prevBackInputContext: e, stateContext: n }) => ({
  onPrevBack: I(
    (t) => () => {
      const a = kbe(e)(t);
      n.onChangeStateCallback(a);
    },
    [e, n]
  )
}), pbe = (e) => ({
  onStart: I(
    (i) => () => {
      const t = fbe(e.startInputContext)(i);
      e.stateContext.onChangeStateCallback(t);
    },
    [e.startInputContext, e.stateContext]
  )
}), Nbe = (e) => {
  const [n, i] = se(mbe(e)), t = I((o) => {
    i(o);
  }, []), { onStart: a } = pbe({
    startInputContext: e,
    stateContext: { onChangeStateCallback: t }
  }), { onFinish: s } = vbe({
    finishInputContext: e,
    stateContext: { onChangeStateCallback: t }
  }), { onPrevBack: r } = hbe({
    prevBackInputContext: e,
    stateContext: { onChangeStateCallback: t }
  });
  return {
    state: n,
    onStart: a,
    onFinish: s,
    onPrevBack: r
  };
}, Sbe = g(({ lang: e, value: n, onChangeCallback: i }) => {
  const t = v(() => e === Y.Default ? "振込名義" : "Payee Name", [e]), a = I(
    (s) => {
      const r = s.target.value;
      i(r);
    },
    [i]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-text-black ch-opacity-90", children: t }),
    /* @__PURE__ */ l.jsx(Qa, { placeholder: "TARO YAMADA", value: n, onChange: a })
  ] });
}), gbe = g(({ lang: e, value: n, onChangeCallback: i }) => {
  const t = v(() => e === Y.Default ? "振込日" : "Transfer date", [e]), a = I(
    (s) => {
      const r = s.target.value;
      i(r);
    },
    [i]
  );
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-text-black ch-opacity-90", children: t }),
    /* @__PURE__ */ l.jsx(Qa, { placeholder: "2024/11/05", type: "date", value: n, onChange: a })
  ] });
}), Fbe = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? "振り込み元の情報を記入してください。" : "Please fill in the remittance information.", [e]);
  return /* @__PURE__ */ l.jsx("div", { className: "ch-text-center", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm-ch-font-light ch-text-black ch-opacity-90", children: n }) });
}), Ibe = g(({ lang: e, onClickCallback: n }) => {
  const i = v(() => e === Y.Default ? "戻る" : "Return", [e]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "outline", onClick: n, children: i });
}), ybe = g(({ lang: e, inputState: n, onPayCancelPriceForBankTransferCallback: i }) => {
  const t = v(() => e === Y.Default ? "施設に通知を送る" : "Notify the facility", [e]), { onHideLoadingScreenCallback: a, onShowLoadingScreenCallback: s } = fn(), r = I(async () => {
    P(n.payeeName) || P(n.transferDt) || (s(), await i(n.payeeName, n.transferDt).finally(() => {
      a();
    }));
  }, [
    n.payeeName,
    n.transferDt,
    a,
    i,
    s
  ]), o = v(() => P(n.payeeName) || P(n.transferDt), [n]);
  return /* @__PURE__ */ l.jsx(ae, { disabled: o, className: "ch-w-full", variant: "default", onClick: r, children: t });
}), bbe = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? "送金情報" : "Bank Transfer", [e]);
  return /* @__PURE__ */ l.jsx(t1, { children: n });
}), m8 = g(({ titleSlot: e, contentSlot: n }) => /* @__PURE__ */ l.jsx(br, { open: !0, modal: !0, children: /* @__PURE__ */ l.jsxs(Cr, { className: "ch-px-6 ch-py-8", "aria-describedby": void 0, children: [
  e,
  n
] }) })), Cbe = g(({ state: e, callbackContext: n }) => {
  const [i, t] = se({ payeeName: void 0, transferDt: void 0 }), a = I(
    (s) => (r) => {
      t((o) => ({ ...o, [s]: r }));
    },
    []
  );
  return /* @__PURE__ */ l.jsx(
    m8,
    {
      titleSlot: /* @__PURE__ */ l.jsx(bbe, { lang: e.lang }),
      contentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-9", children: [
        /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
          /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(Fbe, { lang: e.lang }) }),
          /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
            /* @__PURE__ */ l.jsx(
              Sbe,
              {
                lang: e.lang,
                value: i.payeeName,
                onChangeCallback: a("payeeName")
              }
            ),
            /* @__PURE__ */ l.jsx(
              gbe,
              {
                lang: e.lang,
                value: i.transferDt,
                onChangeCallback: a("transferDt")
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
          /* @__PURE__ */ l.jsx(Ibe, { lang: e.lang, onClickCallback: n.onReturn }),
          /* @__PURE__ */ l.jsx(
            ybe,
            {
              lang: e.lang,
              inputState: i,
              onPayCancelPriceForBankTransferCallback: e.onPayCancelPriceForBankTransferCallback
            }
          )
        ] })
      ] })
    }
  );
}), xbe = g(({ state: e, onClickCallback: n }) => {
  const i = v(() => e.lang === Y.Default ? "銀行振り込みで支払う" : "Pay by bank transfer", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "default", size: "md", onClick: n, children: i });
}), Dbe = g(({ bankInfo: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: "銀行名" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: e.bankName })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: "支店名" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: e.branchName })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: "口座タイプ" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: e.bankAccountType })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: "口座番号" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: e.bankAccountNumber })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: "口座名義" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: e.bankAccountHolderName })
  ] })
] })), wbe = g(({ bankInfo: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: "Bank name" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: e.bankName })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: "Branch name" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: e.branchName })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: "Bank account type" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: e.bankAccountType })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: "Bank account number" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: e.bankAccountNumber })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: "Bank account holder name" }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: e.bankAccountHolderName })
  ] })
] })), Pbe = g(({ lang: e, bankInfo: n }) => {
  if (e === Y.Default)
    return /* @__PURE__ */ l.jsx(Dbe, { bankInfo: n });
  if (e === Y.En)
    return /* @__PURE__ */ l.jsx(wbe, { bankInfo: n });
  throw new Error("Invalid lang code");
}), Rbe = g(({ price: e }) => {
  const n = v(() => `¥ ${e.toLocaleString()}-`, [e]);
  return /* @__PURE__ */ l.jsxs("p", { className: "ch-text-sm-ch-font-light ch-text-black ch-opacity-90", children: [
    "下記の口座に",
    /* @__PURE__ */ l.jsx("span", { className: "ch-mx-1 ch-text-xl ch-font-semibold ch-leading-7 ch-text-black ch-opacity-90", children: n }),
    "を振り込んでください。"
  ] });
}), Tbe = g(({ price: e }) => {
  const n = v(() => `¥ ${e.toLocaleString()}-`, [e]);
  return /* @__PURE__ */ l.jsxs("p", { className: "ch-text-sm-ch-font-light ch-text-black ch-opacity-90", children: [
    "Please transfer",
    /* @__PURE__ */ l.jsx("span", { className: "ch-mx-1 ch-text-xl ch-font-semibold ch-leading-7 ch-text-black ch-opacity-90", children: n }),
    "to the account below."
  ] });
}), jbe = g(({ lang: e, cancelPrice: n }) => {
  if (e === Y.Default)
    return /* @__PURE__ */ l.jsx(Rbe, { price: n });
  if (e === Y.En)
    return /* @__PURE__ */ l.jsx(Tbe, { price: n });
  throw new Error("Not implemented");
}), Abe = g(({ lang: e, onClickCallback: n }) => {
  const i = v(() => e === Y.Default ? "戻る" : "Return", [e]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "outline", onClick: n, children: i });
}), Obe = g(({ lang: e, onClickCallback: n }) => {
  const i = v(() => e === Y.Default ? "振り込み完了" : "Bank Transfer Completed", [e]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "default", onClick: n, children: i });
}), Ebe = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? "振込先情報" : "Bank Transfer", [e]);
  return /* @__PURE__ */ l.jsx(t1, { children: n });
}), Jbe = g(({ state: e, callbackContext: n }) => /* @__PURE__ */ l.jsx(
  m8,
  {
    titleSlot: /* @__PURE__ */ l.jsx(Ebe, { lang: e.lang }),
    contentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-9", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
        /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(jbe, { lang: e.lang, cancelPrice: e.cancelPrice }) }),
        /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(Pbe, { lang: e.lang, bankInfo: e.bankTransferDestination }) })
      ] }),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
        /* @__PURE__ */ l.jsx(Abe, { lang: e.lang, onClickCallback: n.onReturn }),
        /* @__PURE__ */ l.jsx(Obe, { lang: e.lang, onClickCallback: n.onSubmit })
      ] })
    ] })
  }
)), _be = g((e) => {
  const { state: n, onStart: i, onFinish: t, onPrevBack: a } = Nbe(e);
  return n.kind === "Finished" ? (
    // 送金情報を施設へ通知
    /* @__PURE__ */ l.jsx(
      Cbe,
      {
        state: n,
        callbackContext: {
          onReturn: a(n)
        }
      }
    )
  ) : n.kind === "Started" ? /* @__PURE__ */ l.jsx(
    Jbe,
    {
      state: n,
      callbackContext: {
        onReturn: a(n),
        onSubmit: t(n)
      }
    }
  ) : /* @__PURE__ */ l.jsx(xbe, { state: n, onClickCallback: i(n) });
}), Qbe = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? "現時点でキャンセル料金の支払い確認が取れていません。疑問点がある場合は、下記の連絡先より施設にお問い合わせください。" : "We have not confirmed the payment of the cancellation fee at this time. If you have any questions, please contact the facility using the contact information below.", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-break-spaces ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: n });
}), Mbe = g(({ lang: e, dt: n }) => {
  const i = v(() => e === Y.Default ? "支払い期限" : "Transfer limit date", [e]), t = v(() => e === Y.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-black", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: t })
  ] });
}), k8 = g(({ lang: e, price: n }) => {
  const i = v(() => e === Y.Default ? "キャンセル料金/合計" : "Cancellation fee/Total", [e]), t = v(() => `¥ ${n.toLocaleString()}`, [n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-text-black", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black ch-opacity-90", children: t })
  ] });
}), Lbe = (e) => ({
  kind: "Initialized",
  lang: e.lang,
  isDayTrip: e.reservationStatusInfo.isDayTrip
}), $be = (e) => (n) => ({
  kind: "Initialized",
  lang: e.lang,
  isDayTrip: n.isDayTrip
}), Ube = (e) => (n) => ({
  kind: "Started",
  lang: e.lang,
  isDayTrip: n.isDayTrip,
  guestEmail: e.guestInfo.email,
  onPayCancelPriceForCreditCallback: e.onPayCancelPriceForCreditCallback
}), Vbe = ({ prevBackInputContext: e, stateContext: n }) => ({
  onPrevBack: I(
    (t) => () => {
      const a = $be(e)(t);
      n.onChangeStateCallback(a);
    },
    [e, n]
  )
}), Hbe = (e) => ({
  onStart: I(
    (i) => () => {
      const t = Ube(e.startInputContext)(i);
      e.stateContext.onChangeStateCallback(t);
    },
    [e.startInputContext, e.stateContext]
  )
}), zbe = (e) => {
  const [n, i] = se(Lbe(e)), t = I((r) => {
    i(r);
  }, []), { onStart: a } = Hbe({
    startInputContext: e,
    stateContext: { onChangeStateCallback: t }
  }), { onPrevBack: s } = Vbe({
    prevBackInputContext: e,
    stateContext: { onChangeStateCallback: t }
  });
  return {
    state: n,
    onStart: a,
    onPrevBack: s
  };
}, Bbe = g(({ state: e, onClickCallback: n }) => {
  const i = v(() => e.lang === Y.Default ? "クレジットカードで支払う" : "Pay by credit card", [e.lang]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "default", size: "md", onClick: n, children: i });
}), qbe = g(({ lang: e, isDayTrip: n }) => {
  const i = v(() => kn(n ? {
    lang: e,
    i18nString: {
      default: "滞在日まで有効なカードをご利用ください。",
      en: "Please use a card that is valid until the day of use."
    }
  } : {
    lang: e,
    i18nString: {
      default: "チェックイン日まで有効なカードをご利用ください。",
      en: "Please use a card that is valid until the day of check-in."
    }
  }), [e, n]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal", children: i });
}), Gbe = g(({ lang: e, onClickCallback: n }) => {
  const i = v(() => e === Y.Default ? "戻る" : "Return", [e]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "outline", onClick: n, children: i });
}), Wbe = g(({ titleSlot: e, contentSlot: n }) => /* @__PURE__ */ l.jsx(br, { open: !0, modal: !0, children: /* @__PURE__ */ l.jsxs(Cr, { className: "ch-px-6 ch-py-8", "aria-describedby": void 0, children: [
  e,
  n
] }) })), Kbe = g(({ state: e, libContext: n, callbackContext: i }) => /* @__PURE__ */ l.jsx(
  Wbe,
  {
    titleSlot: /* @__PURE__ */ l.jsx(t1, {}),
    contentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-9", children: [
      /* @__PURE__ */ l.jsx(
        FC,
        {
          lang: e.lang,
          payjpInstance: n.payjp.instance,
          createTokenContext: {
            guestEmail: e.guestEmail,
            onCreateTokenCallback: e.onPayCancelPriceForCreditCallback
          },
          cautionChildren: /* @__PURE__ */ l.jsx(qbe, { lang: e.lang, isDayTrip: e.isDayTrip })
        }
      ),
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(Gbe, { lang: e.lang, onClickCallback: i.onReturn }) })
    ] })
  }
)), f8 = g((e) => {
  const { state: n, onStart: i, onPrevBack: t } = zbe(e);
  return n.kind === "Started" ? /* @__PURE__ */ l.jsx(
    Kbe,
    {
      state: n,
      libContext: e.libContext,
      callbackContext: {
        onReturn: t(n)
      }
    }
  ) : /* @__PURE__ */ l.jsx(Bbe, { state: n, onClickCallback: i(n) });
}), Ybe = g(({ state: e, libContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx(Qbe, { lang: e.lang }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
      /* @__PURE__ */ l.jsx(k8, { lang: e.lang, price: e.cancelPrice }),
      /* @__PURE__ */ l.jsx(Mbe, { lang: e.lang, dt: e.transferLimitDt })
    ] })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-3 ch-text-center", children: [
    /* @__PURE__ */ l.jsx(
      f8,
      {
        lang: e.lang,
        reservationStatusInfo: e.reservationStatusInfo,
        libContext: n,
        guestInfo: e.guestInfo,
        onPayCancelPriceForCreditCallback: e.onPayCancelPriceForCreditCallback
      }
    ),
    /* @__PURE__ */ l.jsx(
      _be,
      {
        lang: e.lang,
        cancelPrice: e.cancelPrice,
        bankTransferDestination: e.bankTransferDestination,
        onPayCancelPriceForBankTransferCallback: e.onPayCancelPriceForBankTransferCallback
      }
    )
  ] })
] })), Xbe = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? `ご予約時に登録されたクレジットカードでキャンセル料金を決済できませんでした。
お手数ですが、下記より別途お支払いください。` : `We were unable to charge the cancellation fee to the credit card registered at the time of booking.
Please pay the fee separately using the payment option below.`, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-break-spaces ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: n });
}), Zbe = g(({ state: e, libContext: n }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx(Xbe, { lang: e.lang }),
    /* @__PURE__ */ l.jsx(k8, { lang: e.lang, price: e.cancelPrice })
  ] }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-w-full ch-space-y-3 ch-text-center", children: /* @__PURE__ */ l.jsx(
    f8,
    {
      lang: e.lang,
      reservationStatusInfo: e.reservationStatusInfo,
      libContext: n,
      guestInfo: e.guestInfo,
      onPayCancelPriceForCreditCallback: e.onPayCreditCancelFeeCallback
    }
  ) })
] })), e5e = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? `銀行振り込み内容の確認中です。
今しばらくお待ちください。` : `We are currently confirming the bank transfer details.
Please wait a moment.`, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-break-spaces ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: n });
}), n5e = g(({ lang: e, dt: n }) => {
  const i = v(() => e === Y.Default ? "支払い期限" : "Transfer limit date", [e]), t = v(() => e === Y.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-leading-6 ch-text-black", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: t })
  ] });
}), i5e = g(({ lang: e, price: n }) => {
  const i = v(() => e === Y.Default ? "キャンセル料金/合計" : "Cancellation fee/Total", [e]), t = v(() => `¥ ${n.toLocaleString()}`, [n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-black", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-xl ch-font-semibold ch-text-black ch-opacity-90", children: t })
  ] });
}), t5e = g(({ state: e }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(e5e, { lang: e.lang }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
    /* @__PURE__ */ l.jsx(i5e, { lang: e.lang, price: e.willCancelPrice }),
    /* @__PURE__ */ l.jsx(n5e, { lang: e.lang, dt: e.transferLimitDt })
  ] })
] })), a5e = g(({ state: e, libContext: n }) => {
  if (e.kind === "CreditCancelFeePayable")
    return /* @__PURE__ */ l.jsx(Zbe, { state: e, libContext: n });
  if (e.kind === "CancelPricePayable")
    return /* @__PURE__ */ l.jsx(Ybe, { state: e, libContext: n });
  if (e.kind === "TransferStatusCheckable")
    return /* @__PURE__ */ l.jsx(t5e, { state: e });
  if (e.kind === "CancelPriceInfoCheckable")
    return /* @__PURE__ */ l.jsx(cbe, { state: e });
  throw new Error("Invalid state");
}), l5e = g(({ lang: e }) => v(() => e === Y.Default ? "キャンセル料について" : "About cancellation fee", [e])), s5e = g((e) => {
  const { state: n } = U6e(e);
  return /* @__PURE__ */ l.jsx(
    h1,
    {
      titleTextSlot: /* @__PURE__ */ l.jsx(l5e, { lang: n.lang }),
      contentSlot: /* @__PURE__ */ l.jsx(a5e, { state: n, libContext: e.libContext })
    }
  );
}), r5e = g(({ lang: e, mail: n }) => {
  const i = wn({
    lang: e,
    i18nString: {
      [Y.Default]: "メールアドレス",
      [Y.En]: "Email"
    }
  });
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
    /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: o5e(n) })
  ] });
}), o5e = (e) => {
  const n = e.trim();
  if (n.length === 0)
    return "";
  const i = n.indexOf("@");
  if (i === -1)
    return n;
  const t = n.slice(0, i), a = n.slice(i);
  return t.length <= 1 ? `${t}***${a}` : `${t.charAt(0)}***${a}`;
}, d5e = g(({ lang: e, name: n }) => {
  const i = v(() => e === Y.Default ? "予約者名" : "Reservation name", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
    /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: n })
  ] });
}), c5e = g(({ lang: e, tel: n }) => {
  const i = v(() => e === Y.Default ? "電話番号" : "Phone number", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
    /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: n })
  ] });
}), u5e = g(({ lang: e, reservationID: n }) => {
  const i = v(() => e === Y.Default ? "予約ID" : "Reservation ID", [e]), t = v(() => e === Y.Default ? "ご予約された施設にお問い合わせする際、予約IDをお伝えください。" : "When contacting the building where you made your reservation, please provide your Reservation ID.", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
    /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-leading-7 ch-text-black ch-opacity-90", children: i }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
      /* @__PURE__ */ l.jsx("h5", { className: "ch-text-base ch-font-semibold ch-leading-5 ch-text-black ch-opacity-90", children: n }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-text-black ch-opacity-90", children: t })
    ] })
  ] });
}), m5e = g(({ lang: e }) => v(() => e === Y.Default ? "予約者情報" : "Guest Information", [e])), k5e = g(({ displayContext: e }) => {
  var n;
  return /* @__PURE__ */ l.jsx(
    h1,
    {
      titleTextSlot: /* @__PURE__ */ l.jsx(m5e, { lang: e.lang }),
      contentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-9", children: [
        /* @__PURE__ */ l.jsx(
          u5e,
          {
            lang: e.lang,
            reservationID: e.reservationID
          }
        ),
        /* @__PURE__ */ l.jsx(
          d5e,
          {
            lang: e.lang,
            name: e.guestInfo.name,
            nameKana: (n = e.guestInfo.nameKana) != null ? n : void 0
          }
        ),
        /* @__PURE__ */ l.jsx(c5e, { lang: e.lang, tel: e.guestInfo.tel }),
        /* @__PURE__ */ l.jsx(r5e, { lang: e.lang, mail: e.guestInfo.email })
      ] })
    }
  );
}), f5e = g(({ stateContext: e, callbackContext: n }) => {
  const [i, t] = se(e.initLang), a = I(() => {
    t(Y.Default), n.onChangeLangCallback(Y.Default);
  }, [n]), s = I(() => {
    t(Y.En), n.onChangeLangCallback(Y.En);
  }, [n]), r = v(() => i === Y.Default, [i]), o = v(() => i === Y.En, [i]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-end ch-gap-x-1", children: [
    /* @__PURE__ */ l.jsx("button", { disabled: r, onClick: a, children: /* @__PURE__ */ l.jsx(
      "p",
      {
        className: ce(
          "ch-text-sm ch-font-medium",
          r ? "ch-text-[#262626]" : "ch-text-[#a3a3a3a3]"
        ),
        children: "JP"
      }
    ) }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-light ch-text-[#a3a3a3a3]", children: "/" }),
    /* @__PURE__ */ l.jsx("button", { disabled: o, onClick: s, children: /* @__PURE__ */ l.jsx(
      "p",
      {
        className: ce(
          "ch-text-sm ch-font-medium",
          o ? "ch-text-[#262626]" : "ch-text-[#a3a3a3a3]"
        ),
        children: "EN"
      }
    ) })
  ] });
}), v5e = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? "予約内容を確認する" : "Check your reservation details", [e]);
  return /* @__PURE__ */ l.jsx("h2", { className: "ch-text-xl ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), h5e = g(({ displayContext: e, callbackContext: n }) => /* @__PURE__ */ l.jsx("header", { className: "ch-fixed ch-left-0 ch-top-0 ch-z-[100] ch-w-full ch-border-b ch-border-gray-200 ch-bg-white", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-mx-auto ch-flex ch-w-full ch-max-w-[390px] ch-justify-end ch-p-4 ch-text-center", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-w-[269px] ch-text-center", children: /* @__PURE__ */ l.jsx(v5e, { lang: e.lang }) }),
  /* @__PURE__ */ l.jsx(
    f5e,
    {
      stateContext: {
        initLang: e.lang
      },
      callbackContext: n
    }
  )
] }) })), p5e = g(({ lang: e }) => v(() => e === Y.Default ? "施設に関する注意事項" : "Caution about hotel information", [e])), N5e = g(({ displayContext: e }) => /* @__PURE__ */ l.jsx(
  h1,
  {
    titleTextSlot: /* @__PURE__ */ l.jsx(p5e, { lang: e.lang }),
    contentSlot: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6", children: e.hotelInfo.cautions.map((n, i) => {
      const t = `caution-${n.title}-${i}`;
      return /* @__PURE__ */ l.jsxs(
        "div",
        {
          className: "ch-space-y-6 ch-border-b ch-border-solid ch-border-gray-200 ch-pb-6",
          children: [
            /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-bold ch-leading-6 ch-text-black ch-opacity-90", children: n.title }) }),
            /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-leading-6 ch-text-black ch-opacity-90", children: n.description }) })
          ]
        },
        t
      );
    }) })
  }
)), S5e = g(({ question: e, idx: n }) => {
  const i = v(() => `Q${n + 1}.`, [n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-border-b ch-border-solid ch-border-gray-200 ch-pb-6", children: [
    /* @__PURE__ */ l.jsx("h5", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: i }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
        "p",
        {
          className: ce(
            "ch-whitespace-pre-line ch-text-base ch-font-extralight ch-leading-6 ch-text-black ch-opacity-90",
            //
            "[&>a]:ch-text-link-400 [&>a]:ch-underline-offset-2 [&>a]:hover:ch-underline"
            // aタグを含んでいた場合のスタイルを指定する
          ),
          dangerouslySetInnerHTML: { __html: Nh(e.question) }
        }
      ) }),
      /* @__PURE__ */ l.jsx("div", { children: e.answers.map((t, a) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: t }, a)) })
    ] })
  ] });
}), g5e = g(({ lang: e }) => v(() => e === Y.Default ? "ご利用にあたっての確認事項" : "Confirmation for the use of facilities", [e])), F5e = g(({ displayContext: e }) => /* @__PURE__ */ l.jsx(
  h1,
  {
    titleTextSlot: /* @__PURE__ */ l.jsx(g5e, { lang: e.lang }),
    contentSlot: /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6", children: e.questionInfo.map((n, i) => {
      const t = `question-${i}`;
      return /* @__PURE__ */ l.jsx(
        S5e,
        {
          question: n,
          lang: e.lang,
          idx: i
        },
        t
      );
    }) })
  }
)), I5e = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? "住所" : "Address", [e]);
  return /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), y5e = g(({ address: e, coordinate: n }) => {
  const i = v(() => !P(n) && (n.lat > 0 || n.lon > 0) ? `https://www.google.com/maps/embed/v1/place?key=AIzaSyAdBEmdyqDVBOJVirt5FwS7ztn_gFmFIKU&q=${n.lat},${n.lon}` : `https://www.google.com/maps/embed/v1/place?key=AIzaSyAdBEmdyqDVBOJVirt5FwS7ztn_gFmFIKU&q=${encodeURIComponent(e)}`, [e, n]);
  return /* @__PURE__ */ l.jsx("iframe", { className: "ch-w-full ch-rounded-md", height: 320, src: i, frameBorder: "0", allowFullScreen: !0 });
}), b5e = g(({ lang: e, address: n, coordinate: i }) => Ke(n) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
  /* @__PURE__ */ l.jsx(I5e, { lang: e }),
  /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: n }),
  /* @__PURE__ */ l.jsx(y5e, { address: n, coordinate: i })
] })), C5e = g(({ lang: e, amenityList: n }) => {
  const i = v(() => e === Y.Default ? "アメニティ" : "Amenity", [e]);
  return ke(n) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-2", children: [
      /* @__PURE__ */ l.jsx(wf, { size: "md" }),
      /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: i })
    ] }),
    /* @__PURE__ */ l.jsx("ul", { className: "ch-grid ch-grid-cols-2 ch-gap-x-4 ch-gap-y-2", children: n.map((t, a) => {
      const s = `amenity-${t}-${a}`;
      return /* @__PURE__ */ l.jsxs("li", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: [
        "・",
        t
      ] }, s);
    }) })
  ] });
}), x5e = g(({ lang: e, bathRoomFacilityList: n }) => {
  const i = v(() => e === Y.Default ? "バスルームの設備" : "Bathroom facility", [e]);
  return ke(n) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-2", children: [
      /* @__PURE__ */ l.jsx(im, { size: "md" }),
      /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: i })
    ] }),
    /* @__PURE__ */ l.jsx("ul", { className: "ch-grid ch-grid-cols-2 ch-gap-x-4 ch-gap-y-2", children: n.map((t, a) => {
      const s = `amenity-${t}-${a}`;
      return /* @__PURE__ */ l.jsxs("li", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: [
        "・",
        t
      ] }, s);
    }) })
  ] });
}), D5e = g(({ lang: e, email: n }) => {
  const i = v(() => e === Y.Default ? "メールアドレス" : "Email", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
    /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-5 ch-text-black ch-opacity-90", children: n })
  ] });
}), w5e = g(({ lang: e, roomFacilityList: n }) => {
  const i = v(() => e === Y.Default ? "お部屋の設備" : "Room facility", [e]);
  return ke(n) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-gap-x-2", children: [
      /* @__PURE__ */ l.jsx(im, { size: "md" }),
      /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: i })
    ] }),
    /* @__PURE__ */ l.jsx("ul", { className: "ch-grid ch-grid-cols-2 ch-gap-x-4 ch-gap-y-2", children: n.map((t, a) => {
      const s = `amenity-${t}-${a}`;
      return /* @__PURE__ */ l.jsxs("li", { className: "ch-text-base ch-font-light ch-leading-6 ch-text-black ch-opacity-90", children: [
        "・",
        t
      ] }, s);
    }) })
  ] });
}), P5e = g(({ lang: e, name: n }) => {
  const i = v(() => e === Y.Default ? "施設名" : "Hotel name", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
    /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-5 ch-text-black ch-opacity-90", children: n })
  ] });
}), R5e = g(({ lang: e, tel: n }) => {
  const i = v(() => e === Y.Default ? "電話番号" : "Phone number", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
    /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-5 ch-text-black ch-opacity-90", children: n })
  ] });
}), T5e = g(({ lang: e }) => v(() => e === Y.Default ? "施設情報" : "Information", [e])), j5e = g(({ displayContext: e }) => {
  var n;
  return /* @__PURE__ */ l.jsx(
    h1,
    {
      titleTextSlot: /* @__PURE__ */ l.jsx(T5e, { lang: e.lang }),
      contentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-14", children: [
        /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-9", children: [
          /* @__PURE__ */ l.jsx(P5e, { lang: e.lang, name: e.hotelInfo.name }),
          /* @__PURE__ */ l.jsx(R5e, { lang: e.lang, tel: e.hotelInfo.tel }),
          /* @__PURE__ */ l.jsx(D5e, { lang: e.lang, email: e.hotelInfo.email })
        ] }),
        !ke(e.hotelInfo.amenities) || !ke(e.hotelInfo.bathroomFacilities) || !ke(e.hotelInfo.roomFacilities) ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
          /* @__PURE__ */ l.jsx(
            C5e,
            {
              lang: e.lang,
              amenityList: e.hotelInfo.amenities
            }
          ),
          /* @__PURE__ */ l.jsx(
            x5e,
            {
              lang: e.lang,
              bathRoomFacilityList: e.hotelInfo.bathroomFacilities
            }
          ),
          /* @__PURE__ */ l.jsx(
            w5e,
            {
              lang: e.lang,
              roomFacilityList: e.hotelInfo.roomFacilities
            }
          )
        ] }) : null,
        /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
          b5e,
          {
            lang: e.lang,
            address: e.hotelInfo.addressInfo.address,
            coordinate: (n = e.hotelInfo.addressInfo.coordinate) != null ? n : void 0
          }
        ) })
      ] })
    }
  );
}), A5e = (e) => () => ({
  kind: "Completed",
  lang: e.lang,
  hasCanceledPrice: P(e.priceInfo.willCancelPrice) ? !1 : e.priceInfo.willCancelPrice > 0
}), O5e = (e) => () => ({
  kind: "Confirmed",
  lang: e.lang,
  onCancelSubmitCallback: e.onCancelSubmitCallback
}), E5e = (e) => ({
  kind: "Initialized",
  lang: e.lang,
  canCancel: e.actionInfo.canCancel
}), J5e = (e) => () => ({
  kind: "Initialized",
  lang: e.lang,
  canCancel: e.actionInfo.canCancel
}), _5e = (e) => () => ({
  kind: "Started",
  lang: e.lang,
  priceInfo: e.priceInfo,
  hotelInfo: e.hotelInfo
}), Q5e = (e) => ({
  onReturn: I(
    (i) => () => {
      const t = J5e(e.returnInputContext)(i);
      e.callbackContext.onChangeStateCallback(t);
    },
    [e]
  )
}), M5e = (e) => ({
  onComplete: I(
    (i) => async () => {
      await i.onCancelSubmitCallback();
      const t = A5e(e.completeInputContext)(i);
      e.callbackContext.onChangeStateCallback(t);
    },
    [e]
  )
}), L5e = (e) => ({
  onConfirm: I(
    (i) => () => {
      const t = O5e(e.confirmInputContext)(i);
      e.callbackContext.onChangeStateCallback(t);
    },
    [e]
  )
}), $5e = (e) => ({
  onInitialize: I(() => E5e(e.initializeInputContext), [e.initializeInputContext])
}), U5e = (e) => ({
  onStart: I(
    (i) => () => {
      const t = _5e(e.startInputContext)(i);
      e.callbackContext.onChangeStateCallback(t);
    },
    [e]
  )
}), V5e = (e) => {
  const { onInitialize: n } = $5e({
    initializeInputContext: {
      lang: e.modelContext.lang,
      actionInfo: e.modelContext.actionInfo
    }
  }), [i, t] = se(n()), a = I((c) => {
    t(c);
  }, []), { onStart: s } = U5e({
    startInputContext: {
      lang: e.modelContext.lang,
      priceInfo: e.modelContext.priceInfo,
      hotelInfo: e.modelContext.hotelInfo
    },
    callbackContext: {
      onChangeStateCallback: a
    }
  }), { onConfirm: r } = L5e({
    confirmInputContext: {
      lang: e.modelContext.lang,
      onCancelSubmitCallback: e.modelContext.onCancelSubmitCallback
    },
    callbackContext: {
      onChangeStateCallback: a
    }
  }), { onComplete: o } = M5e({
    completeInputContext: {
      lang: e.modelContext.lang,
      priceInfo: e.modelContext.priceInfo
    },
    callbackContext: {
      onChangeStateCallback: a
    }
  }), { onReturn: d } = Q5e({
    returnInputContext: {
      lang: e.modelContext.lang,
      actionInfo: e.modelContext.actionInfo
    },
    callbackContext: {
      onChangeStateCallback: a
    }
  });
  return {
    state: i,
    onStart: s,
    onConfirm: r,
    onComplete: o,
    onReturn: d
  };
}, H5e = g(({ state: e, onClickCallback: n }) => {
  const i = v(() => e.lang === Y.Default ? "予約をキャンセルする" : "Cancel reservation", [e.lang]);
  return e.canCancel ? /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", variant: "outline", size: "md", onClick: n, children: i }) : null;
}), z5e = g(({ lang: e, priceInfo: n }) => {
  const i = v(() => {
    var a;
    const t = (a = n.willCancelPrice) != null ? a : 0;
    return e === Y.Default ? `キャンセル料金：${t.toLocaleString()}円` : `Cancellation fee: ¥${t.toLocaleString()}`;
  }, [e, n.willCancelPrice]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-break-spaces ch-text-xl ch-font-semibold ch-text-black ch-opacity-90", children: i });
}), B5e = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? `キャンセルポリシーに応じてキャンセル料金が発生します。
確認事項がある場合は、事前に施設にご連絡くださいませ。
(行政判断によるGoToトラベルキャンペーンのキャンセルについても上記に含まれます)` : `A cancellation fee will be charged according to the cancellation policy. 
Please contact the hotel in advance if you need any confirmations. 
(Cancellation of GoTo Travel Campaign due to administrative decision is also included in the above)`, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-break-spaces ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: n });
}), q5e = g(({ hotelInfo: e }) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: e.name })), G5e = g(({ lang: e, hotelInfo: n }) => {
  const i = v(() => e === Y.Default ? `電話番号：${n.tel}` : `Phone number: ${n.tel}`, [e, n.tel]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: i });
}), W5e = g(({ lang: e, hotelInfo: n }) => {
  const i = v(() => e === Y.Default ? `メールアドレス：${n.email}` : `Email: ${n.email}`, [e, n.email]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: i });
}), K5e = g(({ lang: e, onSubmit: n }) => {
  const i = v(() => e === Y.Default ? "予約をキャンセル" : "Cancel the reservation", [e]), t = I(() => {
    n();
  }, [n]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", onClick: t, children: i });
}), vp = g(({ children: e }) => /* @__PURE__ */ l.jsx(br, { open: !0, modal: !0, children: /* @__PURE__ */ l.jsx(Cr, { className: "ch-px-6 ch-py-8", "aria-describedby": void 0, children: e }) })), hp = g(({ lang: e, onSubmit: n }) => {
  const i = v(() => e === Y.Default ? "戻る" : "Return", [e]), t = I(() => {
    n();
  }, [n]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", variant: "outline", onClick: t, children: i });
}), Y5e = g(({ state: e, onNextCallback: n, onReturnCallback: i }) => /* @__PURE__ */ l.jsx(vp, { children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-9", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4 ch-text-center", children: [
      /* @__PURE__ */ l.jsx(z5e, { lang: e.lang, priceInfo: e.priceInfo }),
      /* @__PURE__ */ l.jsx(B5e, { lang: e.lang })
    ] }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-text-center", children: [
      /* @__PURE__ */ l.jsx(q5e, { hotelInfo: e.hotelInfo }),
      /* @__PURE__ */ l.jsx(G5e, { lang: e.lang, hotelInfo: e.hotelInfo }),
      /* @__PURE__ */ l.jsx(W5e, { lang: e.lang, hotelInfo: e.hotelInfo })
    ] })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx(hp, { lang: e.lang, onSubmit: i }),
    /* @__PURE__ */ l.jsx(K5e, { lang: e.lang, onSubmit: n })
  ] })
] }) })), X5e = ({ lang: e }) => {
  const n = v(() => e === Y.Default ? `キャンセルが完了しました。
キャンセル通知メールにしたがって、キャンセル料金の支払いを行ってください。` : `The cancellation has been completed. 
Please check your cancellation notification email.`, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-wrap ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: n });
}, Z5e = ({ lang: e }) => {
  const n = v(() => e === Y.Default ? `キャンセルが完了しました。
キャンセル通知メールをご確認ください。` : `Your cancellation has been completed. 
Please follow the cancellation notification email to pay the cancellation fee.`, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-wrap ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: n });
}, eCe = g(({ lang: e, hasCanceledPrice: n }) => n ? /* @__PURE__ */ l.jsx(X5e, { lang: e }) : /* @__PURE__ */ l.jsx(Z5e, { lang: e })), nCe = g(({ state: e, onReturnCallback: n }) => /* @__PURE__ */ l.jsx(vp, { children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-2 ch-text-center", children: /* @__PURE__ */ l.jsx(eCe, { lang: e.lang, hasCanceledPrice: e.hasCanceledPrice }) }),
  /* @__PURE__ */ l.jsx(hp, { lang: e.lang, onSubmit: n })
] }) })), iCe = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? "本当に予約のキャンセルを行いますか？" : "Would you really like to cancel your reservation?", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: n });
}), tCe = g(({ lang: e, onSubmit: n }) => {
  const { onShowLoadingScreenCallback: i, onHideLoadingScreenCallback: t } = fn(), { addInfo: a } = Uv(), s = I(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []), r = I(async () => {
    const d = wn({
      lang: e,
      i18nString: { default: "予約をキャンセルしました", en: "Reservation canceled." }
    });
    try {
      i(), await n(), s(), a(d);
    } catch (c) {
    }
    t();
  }, [a, e, t, s, i, n]), o = v(() => wn({ lang: e, i18nString: { default: "はい", en: "OK" } }), [e]);
  return /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", onClick: r, children: o });
}), aCe = g(({ state: e, onNextCallback: n, onReturnCallback: i }) => /* @__PURE__ */ l.jsx(vp, { children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-text-center", children: /* @__PURE__ */ l.jsx(iCe, { lang: e.lang }) }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-gap-x-4", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-w-1/2", children: /* @__PURE__ */ l.jsx(hp, { lang: e.lang, onSubmit: i }) }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-w-1/2", children: /* @__PURE__ */ l.jsx(tCe, { lang: e.lang, onSubmit: n }) })
  ] })
] }) })), lCe = g(({ modelContext: e }) => {
  const {
    state: n,
    onStart: i,
    onConfirm: t,
    onComplete: a,
    onReturn: s
  } = V5e({ modelContext: e });
  return n.kind === "Started" ? /* @__PURE__ */ l.jsx(
    Y5e,
    {
      state: n,
      onNextCallback: t(n),
      onReturnCallback: s(n)
    }
  ) : n.kind === "Confirmed" ? /* @__PURE__ */ l.jsx(
    aCe,
    {
      state: n,
      onNextCallback: a(n),
      onReturnCallback: s(n)
    }
  ) : n.kind === "Completed" ? /* @__PURE__ */ l.jsx(nCe, { state: n, onReturnCallback: s(n) }) : /* @__PURE__ */ l.jsx(H5e, { state: n, onClickCallback: i(n) });
}), sCe = g((e) => {
  const n = I(() => {
    e.onSubmitCallback();
  }, [e]), i = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "予約内容の変更";
      case Y.En:
        return "Change reservation details";
      default:
        return "";
    }
  }, [e.lang]);
  return e.actionInfo.canEdit ? /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", onClick: n, children: i }) : null;
}), rCe = g((e) => {
  const n = I(() => {
    e.onSubmitCallback();
  }, [e]), i = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "クレジットカード情報の変更";
      case Y.En:
        return "Update credit card";
      default:
        return "";
    }
  }, [e.lang]), t = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "※宿泊内容・オプション等の変更はできません。お支払いに登録するカードのみ変更できます。";
      case Y.En:
        return "*Stay details and options cannot be changed. You can only update the card on file.";
      default:
        return "";
    }
  }, [e.lang]);
  return e.actionInfo.canEditCreditCard ? /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
    /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full", size: "md", onClick: n, children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-leading-relaxed ch-text-neutral-500", children: t })
  ] }) : null;
}), oCe = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(sCe, { ...e, onSubmitCallback: e.onChangeReservationCallback }),
  /* @__PURE__ */ l.jsx(rCe, { ...e, onSubmitCallback: e.onChangeReservationCallback }),
  e.actionInfo.canCancel || e.actionInfo.canIssueReceipt ? /* @__PURE__ */ l.jsxs("div", { className: "ch-w-full ch-space-y-4", children: [
    e.actionInfo.canCancel ? /* @__PURE__ */ l.jsx(lCe, { modelContext: { ...e } }) : null,
    e.actionInfo.canIssueReceipt ? /* @__PURE__ */ l.jsx(u8, { modelContext: { ...e } }) : null
  ] }) : null
] })), dCe = g((e) => {
  const n = v(() => e.roomInfo.groupCount, [e.roomInfo.groupCount]);
  return v(() => {
    switch (e.lang) {
      case Y.Default:
        return `${n}部屋`;
      case Y.En:
        return `${n} room(s)`;
      default:
        return "";
    }
  }, [e.lang, n]);
}), cCe = g((e) => {
  const n = v(() => e.roomInfo.totalPeopleCount, [e.roomInfo.totalPeopleCount]);
  return v(() => {
    switch (e.lang) {
      case Y.Default:
        return `${n}名様`;
      case Y.En:
        return `${n} person(s)`;
      default:
        return "";
    }
  }, [n, e.lang]);
}), uCe = g((e) => {
  const n = v(() => e.roomInfo.groupCount, [e.roomInfo.groupCount]);
  return v(() => {
    switch (e.lang) {
      case Y.Default:
        return `${n}部屋`;
      case Y.En:
        return `${n} room(s)`;
      default:
        return "";
    }
  }, [e.lang, n]);
}), mCe = g((e) => {
  switch (e.billingTypeTarget) {
    case $s.Group:
      return /* @__PURE__ */ l.jsx(dCe, { ...e });
    case $s.Room:
      return /* @__PURE__ */ l.jsx(uCe, { ...e });
    case $s.Person:
      return /* @__PURE__ */ l.jsx(cCe, { ...e });
    default:
      return null;
  }
}), kCe = g((e) => {
  const n = v(() => e.dateInfo.isDayTrip || Ht({
    targetDate: e.dateInfo.checkInDt,
    compareDate: e.dateInfo.checkOutDt
  }) ? 1 : Math.abs(
    fk({
      from: e.dateInfo.checkInDt,
      to: e.dateInfo.checkOutDt,
      format: "day"
    })
  ), [e.dateInfo.checkInDt, e.dateInfo.checkOutDt, e.dateInfo.isDayTrip]);
  return v(() => {
    switch (e.lang) {
      case Y.Default:
        return `${n}泊`;
      case Y.En:
        return `${n} night(s)`;
      default:
        return "";
    }
  }, [n, e.lang]);
}), fCe = g((e) => {
  switch (e.lang) {
    case Y.Default:
      return "1予約";
    case Y.En:
      return "1 reservation";
    default:
      return "";
  }
}), vCe = g((e) => {
  switch (e.billingTypeTerm) {
    case vr.PerDate:
      return /* @__PURE__ */ l.jsx(kCe, { ...e });
    case vr.PerReservation:
      return /* @__PURE__ */ l.jsx(fCe, { ...e });
    default:
      return null;
  }
}), hCe = g(({ lang: e, additionalFee: n, roomInfo: i, dateInfo: t }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[222px] ch-flex-1", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black", children: n.name }) }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-max-w-[88px] ch-flex-1 ch-text-right", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: n.price.amount }),
    /* @__PURE__ */ l.jsxs("p", { className: "ch-black ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: [
      /* @__PURE__ */ l.jsx(
        mCe,
        {
          lang: e,
          billingTypeTarget: n.billingTypeTarget,
          roomInfo: i
        }
      ),
      "×",
      /* @__PURE__ */ l.jsx(
        vCe,
        {
          lang: e,
          billingTypeTerm: n.billingTypeTerm,
          dateInfo: t
        }
      )
    ] })
  ] })
] })), pCe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "基本料金";
      case Y.En:
        return "Basic Charge";
      default:
        return "";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), NCe = g((e) => ke(e.additionalFeeInfo) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsx(pCe, { ...e }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-8", children: e.additionalFeeInfo.map((n, i) => {
    const t = `additional-fee-${n.name}-${i}`;
    return /* @__PURE__ */ l.jsx(hCe, { ...e, additionalFee: n }, t);
  }) })
] })), SCe = g((e) => {
  const n = v(() => e.optionCanceledInfo.reduce((s, r) => s + r.canceledPrice, 0), [e.optionCanceledInfo]), i = v(() => e.planCanceledInfo.reduce((s, r) => s + r.canceledPrice, 0), [e.planCanceledInfo]), t = v(() => e.roomCanceledInfo.reduce((s, r) => s + r.canceledPrice, 0), [e.roomCanceledInfo]), a = v(() => `¥ ${(n + i + t).toLocaleString()}`, [n, i, t]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: a });
}), gCe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "変更に伴うキャンセル料";
      case Y.En:
        return "Cancellation fees due to changes";
      default:
        return "";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: n });
}), FCe = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
  /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[222px] ch-flex-1", children: /* @__PURE__ */ l.jsx(gCe, { ...e }) }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[88px] ch-flex-1 ch-text-right", children: /* @__PURE__ */ l.jsx(SCe, { ...e }) })
] })), ICe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "キャンセル料金";
      case Y.En:
        return "Cancellation fee";
      default:
        return "";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), yCe = g((e) => ke(e.optionCanceledInfo) || ke(e.planCanceledInfo) || ke(e.roomCanceledInfo) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(ICe, { ...e }) }),
  /* @__PURE__ */ l.jsx(FCe, { ...e })
] })), bCe = g(({ lang: e, checkInEndAt: n, checkInStartAt: i }) => {
  const t = v(() => e === Y.Default ? "チェックイン" : "Check-in", [e]), a = v(() => `${i} ~ ${n}`, [n, i]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: t }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-5 ch-text-black ch-opacity-90", children: a })
  ] });
}), CCe = g(({ lang: e, checkOutEndAt: n }) => {
  const i = v(() => e === Y.Default ? "チェックアウト" : "Check-out", [e]), t = v(() => `~ ${n}`, [n]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-5 ch-text-black ch-opacity-90", children: t })
  ] });
}), xCe = g((e) => e.dateInfo.isDayTrip || !e.dateInfo.isShowCheckInOutTime ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1.5", children: [
  /* @__PURE__ */ l.jsx(
    bCe,
    {
      ...e,
      checkInStartAt: e.dateInfo.checkInStartAt,
      checkInEndAt: e.dateInfo.checkInEndAt
    }
  ),
  /* @__PURE__ */ l.jsx(CCe, { ...e, checkOutEndAt: e.dateInfo.checkOutEndAt })
] })), DCe = g((e) => {
  const n = v(() => e.lang === Y.Default ? Ne(e.dateInfo.checkInDt, "YYYY年MM月DD日") : Ne(e.dateInfo.checkInDt, "D MMM YYYY", "en"), [e.dateInfo.checkInDt, e.lang]), i = v(() => e.lang === Y.Default ? Ne(e.dateInfo.checkOutDt, "YYYY年MM月DD日") : Ne(e.dateInfo.checkOutDt, "D MMM YYYY", "en"), [e.dateInfo.checkOutDt, e.lang]), t = v(() => e.dateInfo.isDayTrip ? n : `${n} - ${i}`, [e.dateInfo.isDayTrip, i, n]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-5 ch-text-black ch-opacity-90", children: t });
}), wCe = g(({ dateInfo: e }) => {
  const n = v(() => e.isDayTrip ? "日程（日帰り）" : "日程", [e.isDayTrip]);
  return /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), PCe = g(({ dateInfo: e }) => {
  const n = v(() => e.isDayTrip ? "Schedule(Day trip)" : "Schedule", [e.isDayTrip]);
  return /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), RCe = g((e) => {
  switch (e.lang) {
    case Y.Default:
      return /* @__PURE__ */ l.jsx(wCe, { dateInfo: e.dateInfo });
    case Y.En:
      return /* @__PURE__ */ l.jsx(PCe, { dateInfo: e.dateInfo });
    default:
      return null;
  }
}), Wd = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "変更する";
      case Y.En:
        return "Change";
      default:
        return "";
    }
  }, [e.lang]), i = I(() => {
    e.onSubmitCallback();
  }, [e]);
  return e.actionInfo.canEdit ? /* @__PURE__ */ l.jsx("button", { className: "ch-py-[6px]", onClick: i, children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-semibold ch-text-black ch-underline ch-underline-offset-4 ch-opacity-90", children: n }) }) : null;
}), TCe = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx(RCe, { ...e }),
    /* @__PURE__ */ l.jsx(Wd, { ...e, onSubmitCallback: e.onChangeReservationCallback })
  ] }),
  /* @__PURE__ */ l.jsx(DCe, { ...e }),
  /* @__PURE__ */ l.jsx(xCe, { ...e })
] })), jCe = g(({ item: e }) => {
  const n = v(() => `¥ -${e.discountPrice.toLocaleString()}`, [e.discountPrice]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[222px] ch-flex-1", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: e.name }) }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[88px] ch-flex-1 ch-text-right", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: n }) })
  ] });
}), ACe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "ディスカウント";
      case Y.En:
        return "Discount";
      default:
        return "";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), OCe = g((e) => P(e.discountInfo) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsx(ACe, { ...e }),
  /* @__PURE__ */ l.jsx(jCe, { item: e.discountInfo })
] }));
g(({ lang: e, amount: n }) => {
  const i = v(() => e === Y.Default ? "個" : "piece(s)", [e]), t = v(() => `${n}${i}`, [n, i]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-normal ch-leading-5", children: t });
});
const ECe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case D.Default:
        return Ne(e.date, "YYYY年MM月DD日");
      case D.En:
        return Ne(e.date, "D MMM YYYY", "en");
      default:
        return "";
    }
  }, [e.date, e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: n });
}), JCe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "その他";
      case Y.En:
        return "Others";
      default:
        return "";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: n });
}), _Ce = g((e) => P(e.date) ? /* @__PURE__ */ l.jsx(JCe, { ...e }) : /* @__PURE__ */ l.jsx(ECe, { ...e, date: e.date })), QCe = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? "キャンセルポリシー" : "Cancel Policy", [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal", children: n });
}), MCe = g((e) => {
  const [n, i] = se(void 0), t = I((s) => {
    i(s);
  }, []), a = v(() => `${e.kind}-cancel-policy`, [e.kind]);
  return /* @__PURE__ */ l.jsx(
    qi,
    {
      type: "single",
      collapsible: !0,
      defaultValue: void 0,
      value: n,
      onValueChange: t,
      children: /* @__PURE__ */ l.jsxs(it, { value: a, children: [
        /* @__PURE__ */ l.jsx(tt, { children: /* @__PURE__ */ l.jsx(QCe, { lang: e.lang }) }),
        /* @__PURE__ */ l.jsx(at, { children: e.children })
      ] })
    }
  );
}), LCe = (e) => {
  const n = v(() => {
    switch (e.kind) {
      case "option":
        return "税込オプション料金";
      case "plan":
        return "税込プラン料金";
      case "room":
        return "税込お部屋料金";
      default:
        return "";
    }
  }, [e.kind]), i = v(() => `${e.dateInfo.isDayTrip ? "当日" : "ご滞在日当日"} 00時00分から${n}の${e.cancelPolicy.chargeRatio}%`, [e.dateInfo.isDayTrip, e.cancelPolicy.chargeRatio, n]), t = v(() => `${Ci({
    date: e.dateInfo.checkInDt,
    inc: -e.cancelPolicy.beforeDays,
    format: "YYYY年MM月DD日"
  })} 00時00分から${n}の${e.cancelPolicy.chargeRatio}%`, [n, e.cancelPolicy.beforeDays, e.cancelPolicy.chargeRatio, e.dateInfo.checkInDt]);
  return v(() => e.cancelPolicy.beforeDays === 0 ? i : t, [t, e.cancelPolicy.beforeDays, i]);
}, $Ce = (e) => {
  const n = v(() => {
    switch (e.kind) {
      case "plan":
        return "plan price including tax";
      case "room":
        return e.dateInfo.isDayTrip ? "group price including tax" : "room price including tax";
      case "option":
        return "option price including tax";
    }
  }, [e.dateInfo.isDayTrip, e.kind]), i = v(() => `After 00:00 on ${e.dateInfo.isDayTrip ? "today" : "the day of check-in"}, ${e.cancelPolicy.chargeRatio}% of ${n}`, [n, e.cancelPolicy.chargeRatio, e.dateInfo.isDayTrip]), t = v(() => `From ${Ci({
    date: e.dateInfo.checkInDt,
    inc: -e.cancelPolicy.beforeDays,
    format: "YYYY-MM-DD"
  })} 00:00分, ${e.cancelPolicy.chargeRatio}% of ${n}`, [n, e.cancelPolicy.beforeDays, e.cancelPolicy.chargeRatio, e.dateInfo.checkInDt]);
  return v(() => e.cancelPolicy.beforeDays === 0 ? i : t, [t, e.cancelPolicy.beforeDays, i]);
}, UCe = g(({ lang: e, forDefaultSlot: n, forEnSlot: i }) => {
  if (e === D.Default)
    return n;
  if (e === D.En)
    return i;
  throw new Error("Invalid lang code");
}), VCe = g((e) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-light ch-text-black ch-opacity-90", children: /* @__PURE__ */ l.jsx(
  UCe,
  {
    ...e,
    forDefaultSlot: /* @__PURE__ */ l.jsx(LCe, { ...e.childrenContext }),
    forEnSlot: /* @__PURE__ */ l.jsx($Ce, { ...e.childrenContext })
  }
) })), HCe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "※日程変更などの予約内容変更の場合もキャンセル料が発生いたします。";
      case Y.En:
        return "*Cancellation fees will be charged for any changes to the reservation, such as schedule changes.";
      default:
        return "";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-light ch-leading-4 ch-text-black ch-opacity-90", children: n });
}), zCe = ({ kind: e, hotelInfo: n }) => {
  const i = v(() => e === "plan" ? "プラン" : e === "room" ? n.customTypeRoomTitle === ys.Tent ? "テント" : "お部屋" : "オプション", [e, n]);
  return v(() => `${i}のキャンセルポリシー`, [i]);
}, BCe = ({ kind: e, hotelInfo: n }) => {
  const i = v(() => e === "plan" ? "plan" : e === "room" ? n.customTypeRoomTitle === ys.Tent ? "tent" : "room" : "option", [e, n]);
  return v(() => `Cancellation policy of ${i}`, [i]);
}, qCe = g(({ lang: e, childrenContext: n }) => /* @__PURE__ */ l.jsxs("h5", { className: "ch-text-base ch-font-bold ch-leading-6 ch-text-black ch-opacity-90", children: [
  e === Y.Default ? /* @__PURE__ */ l.jsx(zCe, { ...n }) : null,
  e === Y.En ? /* @__PURE__ */ l.jsx(BCe, { ...n }) : null
] })), pp = g((e) => /* @__PURE__ */ l.jsx(MCe, { ...e, children: /* @__PURE__ */ l.jsx("div", { className: "ch-rounded-lg ch-bg-gray-100 ch-p-4", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
  /* @__PURE__ */ l.jsx(qCe, { ...e, childrenContext: { ...e } }),
  /* @__PURE__ */ l.jsxs("div", { children: [
    e.cancelPolicyInfo.map((n, i) => {
      const t = `${n.chargeRatio}${n.beforeDays}-${i}`;
      return /* @__PURE__ */ l.jsx(
        VCe,
        {
          ...e,
          childrenContext: {
            ...e,
            cancelPolicy: n
          }
        },
        t
      );
    }),
    /* @__PURE__ */ l.jsx(HCe, { ...e })
  ] })
] }) }) })), v8 = g((e) => {
  const n = v(() => `¥ ${e.option.price.toLocaleString()}`, [e.option.price]), i = v(() => `× ${e.option.amount}`, [e.option.amount]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
      /* @__PURE__ */ l.jsx(_Ce, { ...e }),
      /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
        /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[222px] ch-flex-1", children: /* @__PURE__ */ l.jsxs("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: [
          e.option.name,
          e.option.time && /* @__PURE__ */ l.jsx("span", { className: "ch-ml-1 ch-text-sm ch-text-gray-500", children: e.option.time })
        ] }) }),
        /* @__PURE__ */ l.jsxs("div", { className: "ch-max-w-[88px] ch-flex-1 ch-text-right", children: [
          /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: n }),
          /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: i })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ l.jsx(pp, { kind: "option", ...e, cancelPolicyInfo: e.option.cancelPolicy })
  ] });
}), GCe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "オプション";
      case Y.En:
        return "Addition";
      default:
        return "";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), WCe = 1, KCe = g((e) => e.optionInfo.length < WCe ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx(GCe, { ...e }),
    /* @__PURE__ */ l.jsx(Wd, { ...e, onSubmitCallback: e.onChangeReservationCallback })
  ] }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6", children: e.optionInfo.map((n, i) => {
    const t = `option-${n.price}-${n.name}-${i}`;
    return /* @__PURE__ */ l.jsx(v8, { ...e, option: n }, t);
  }) })
] })), YCe = g((e) => /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: e.planInfo.name })), XCe = g(({ planInfo: e }) => {
  const n = v(() => `¥ ${e.price.toLocaleString()}`, [e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: n });
}), ZCe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "プラン";
      case Y.En:
        return "Plan";
      default:
        return "";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), exe = g((e) => P(e.planInfo) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx(ZCe, { ...e }),
    /* @__PURE__ */ l.jsx(Wd, { ...e, onSubmitCallback: e.onChangeReservationCallback })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[222px] ch-flex-1", children: /* @__PURE__ */ l.jsx(YCe, { planInfo: e.planInfo }) }),
      /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[88px] ch-flex-1 ch-text-right", children: /* @__PURE__ */ l.jsx(XCe, { ...e, planInfo: e.planInfo }) })
    ] }),
    /* @__PURE__ */ l.jsx(pp, { kind: "plan", ...e, cancelPolicyInfo: e.planInfo.cancelPolicy })
  ] })
] })), nxe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "合計料金";
      case Y.En:
        return "Total price";
      default:
        return "";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), ixe = g((e) => {
  const n = v(() => `¥ ${e.priceInfo.totalGuestCharge.toLocaleString()}`, [e.priceInfo.totalGuestCharge]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-2xl ch-font-semibold ch-leading-5 ch-text-black ch-opacity-90", children: n });
}), txe = g((e) => /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
  /* @__PURE__ */ l.jsx(nxe, { ...e }),
  /* @__PURE__ */ l.jsx(ixe, { ...e })
] })), axe = g(({ lang: e, date: n }) => {
  const i = v(() => e === D.Default ? Ne(n, "YYYY年MM月DD日") : Ne(n, "D MMM YYYY", "en"), [n, e]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-xs ch-font-semibold ch-text-black ch-opacity-90", children: i });
}), lxe = g(({ lang: e, daily: n }) => {
  const i = v(() => `¥ ${n.price.toLocaleString()}`, [n.price]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(axe, { lang: e, date: n.date }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
      /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[222px] ch-flex-1", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: n.name }) }),
      /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[88px] ch-flex-1 ch-text-right", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: i }) })
    ] })
  ] });
}), sxe = g(({ lang: e, adultNum: n, kidsNum: i }) => {
  const t = v(() => e === Y.Default ? `大人${n}名` : `${n} adult(s)`, [n, e]), a = v(() => {
    if (ke(i))
      return;
    const o = i.length;
    return e === Y.Default ? `子ども${o}名` : `${o} kid(s)`;
  }, [i, e]), s = v(() => {
    if (ke(i))
      return;
    const o = i.filter((d) => d.isCoSleeping).length;
    if (o !== 0)
      return e === Y.Default ? `（内 添い寝${o}名）` : `(${o} co-sleeping)`;
  }, [i, e]), r = v(() => P(a) ? t : P(s) ? `${t}/${a}` : `${t}/${a}${s}`, [t, s, a]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm ch-font-light ch-text-black ch-opacity-90", children: r });
}), rxe = g(({ idx: e, lang: n }) => {
  const i = v(() => n === Y.Default ? `部屋-${e + 1}` : `Room-${e + 1}`, [e, n]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: i });
}), oxe = g(({ idx: e, lang: n, room: i }) => /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsx(rxe, { lang: n, idx: e }),
    /* @__PURE__ */ l.jsx(sxe, { lang: n, adultNum: i.adultNum, kidsNum: i.kidsNum })
  ] }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-4", children: i.dailyInfo.map((t, a) => {
    const s = `daily-${t.date}-${a}`;
    return /* @__PURE__ */ l.jsx(lxe, { lang: n, daily: t }, s);
  }) })
] })), dxe = g(({ hotelInfo: e }) => {
  const n = v(() => e.customTypeRoomTitle === ys.Tent ? "テント" : "お部屋", [e.customTypeRoomTitle]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), cxe = g(({ hotelInfo: e }) => {
  const n = v(() => e.customTypeRoomTitle === ys.Tent ? "Tent" : "Room", [e.customTypeRoomTitle]);
  return /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), uxe = g(({ lang: e, hotelInfo: n }) => {
  if (e === Y.Default)
    return /* @__PURE__ */ l.jsx(dxe, { hotelInfo: n });
  if (e === Y.En)
    return /* @__PURE__ */ l.jsx(cxe, { hotelInfo: n });
  throw new Error("Invalid lang code.");
}), mxe = g((e) => P(e.roomInfo.items) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
    /* @__PURE__ */ l.jsx(uxe, { ...e }),
    /* @__PURE__ */ l.jsx(Wd, { ...e, onSubmitCallback: e.onChangeReservationCallback })
  ] }),
  /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6", children: e.roomInfo.items.map((n, i) => {
      const t = `room-${i}`;
      return /* @__PURE__ */ au(oxe, { ...e, key: t, idx: i, room: n });
    }) }),
    /* @__PURE__ */ l.jsx(pp, { kind: "room", ...e, cancelPolicyInfo: e.roomInfo.cancelPolicy })
  ] })
] })), kxe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "時間帯";
      case Y.En:
        return "Time slot";
      default:
        return "";
    }
  }, [e.lang]);
  return e.timeSlotOptionInfo.length === 0 ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-items-center ch-justify-between", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n }),
      /* @__PURE__ */ l.jsx(Wd, { ...e, onSubmitCallback: e.onChangeReservationCallback })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-6", children: e.timeSlotOptionInfo.map((i, t) => {
      const a = `time-slot-option-${i.price}-${i.name}-${t}`;
      return /* @__PURE__ */ l.jsx(v8, { ...e, option: i }, a);
    }) })
  ] });
}), fxe = g((e) => {
  const n = v(() => {
    switch (e.lang) {
      case Y.Default:
        return "ホテルチケット";
      case Y.En:
        return "Hotel ticket";
      default:
        return "";
    }
  }, [e.lang]);
  return /* @__PURE__ */ l.jsx("h4", { className: "ch-text-lg ch-font-semibold ch-text-black ch-opacity-90", children: n });
}), vxe = g(({ item: e }) => {
  const n = v(() => `¥ -${e.discountPrice.toLocaleString()}`, [e.discountPrice]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-justify-between", children: [
    /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[222px] ch-flex-1", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-normal ch-leading-6 ch-text-black ch-opacity-90", children: e.name }) }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-max-w-[88px] ch-flex-1 ch-text-right", children: /* @__PURE__ */ l.jsx("p", { className: "ch-text-base ch-font-semibold ch-leading-6 ch-text-black ch-opacity-90", children: n }) })
  ] });
}), hxe = g((e) => ke(e.voucherInfo) ? null : /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-3", children: [
  /* @__PURE__ */ l.jsx(fxe, { ...e }),
  /* @__PURE__ */ l.jsx("div", { className: "ch-space-y-2", children: e.voucherInfo.map((n, i) => {
    const t = `voucher-info-${i}`;
    return /* @__PURE__ */ l.jsx(vxe, { item: n }, t);
  }) })
] })), pxe = g(({ lang: e }) => v(() => e === Y.Default ? "予約内容の確認" : "Check your reservation details", [e])), Nxe = g((e) => /* @__PURE__ */ l.jsx(
  h1,
  {
    titleTextSlot: /* @__PURE__ */ l.jsx(pxe, { ...e }),
    contentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-8", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-14", children: [
        /* @__PURE__ */ l.jsx(TCe, { ...e }),
        /* @__PURE__ */ l.jsx(exe, { ...e }),
        /* @__PURE__ */ l.jsx(mxe, { ...e }),
        /* @__PURE__ */ l.jsx(kxe, { ...e }),
        /* @__PURE__ */ l.jsx(KCe, { ...e }),
        /* @__PURE__ */ l.jsx(NCe, { ...e }),
        /* @__PURE__ */ l.jsx(OCe, { ...e }),
        /* @__PURE__ */ l.jsx(hxe, { ...e }),
        /* @__PURE__ */ l.jsx(yCe, { ...e }),
        /* @__PURE__ */ l.jsx(txe, { ...e })
      ] }),
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(oCe, { ...e }) })
    ] })
  }
)), Sxe = ({ displayContext: e }) => {
  const n = v(() => wn({
    lang: e.lang,
    i18nString: {
      default: "リクエスト予約情報",
      en: "Request Reservation Information"
    }
  }), [e.lang]), i = v(() => {
    switch (e.requestStatus) {
      case Fa.Unnoticed:
        return wn({
          lang: e.lang,
          i18nString: {
            default: "承認待ち",
            en: "Waiting for approval"
          }
        });
      case Fa.Confirmed:
        return wn({
          lang: e.lang,
          i18nString: {
            default: "承認済み（予約確定）",
            en: "Approved (Reservation confirmed)"
          }
        });
      case Fa.Declined:
        return wn({
          lang: e.lang,
          i18nString: {
            default: "非承認",
            en: "Not approved"
          }
        });
      default:
        return "";
    }
  }, [e.lang, e.requestStatus]), t = v(() => {
    switch (e.requestStatus) {
      case Fa.Unnoticed:
        return wn({
          lang: e.lang,
          i18nString: {
            default: "宿泊日が近づいても「承認待ち」の場合は、施設までお問い合わせください。",
            en: "If the check-in date is approaching and the status is still 'Waiting for approval', please contact the facility."
          }
        });
      case Fa.Confirmed:
        return wn({
          lang: e.lang,
          i18nString: {
            default: "予約が確定しました。不明な点がある場合は、施設までお問い合わせください。",
            en: "The reservation has been confirmed. If you have any questions, please contact the facility."
          }
        });
      case Fa.Declined:
        return wn({
          lang: e.lang,
          i18nString: {
            default: "予約は承認されませんでした。またのご予約を心よりお待ちしております。",
            en: "The reservation was not approved. We look forward to your next reservation."
          }
        });
      default:
        return "";
    }
  }, [e.lang, e.requestStatus]);
  return P(e.requestStatus) ? null : /* @__PURE__ */ l.jsx(
    h1,
    {
      titleTextSlot: /* @__PURE__ */ l.jsx(l.Fragment, { children: n }),
      contentSlot: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
        /* @__PURE__ */ l.jsx("p", { className: "ch-text-lg ch-font-bold", children: i }),
        /* @__PURE__ */ l.jsx("p", { className: "ch-text-sm", children: t })
      ] })
    }
  );
}, gxe = g(({ displayContext: e }) => {
  const n = v(() => wn({
    lang: e.lang,
    i18nString: {
      default: "この予約は、ゲストページでの予約内容の変更ができません。",
      en: "This reservation cannot be modified on the guest page."
    }
  }), [e.lang]), i = v(() => wn({
    lang: e.lang,
    i18nString: {
      default: "予約内容の変更については施設へ直接ご連絡ください。",
      en: "Please contact the facility directly for changes to the reservation details."
    }
  }), [e.lang]), t = v(() => wn({
    lang: e.lang,
    i18nString: {
      default: "考えられる理由",
      en: "Possible reasons"
    }
  }), [e.lang]), a = v(() => wn({
    lang: e.lang,
    i18nString: {
      default: "施設が過去にこの予約の内容を変更した",
      en: "The facility has previously modified this reservation."
    }
  }), [e.lang]), s = v(() => wn({
    lang: e.lang,
    i18nString: {
      default: "予約内容が変更できない設定がされている",
      en: "The reservation settings are configured to prevent modifications."
    }
  }), [e.lang]), r = v(() => wn({
    lang: e.lang,
    i18nString: {
      default: "予約内容が変更できない商品がある",
      en: "There are items within the reservation that cannot be changed."
    }
  }), [e.lang]), o = v(() => [a, s, r], [a, s, r]);
  return e.reservationStatusInfo.isCanceled || e.actionInfo.canEdit || e.actionInfo.canEditCreditCard ? null : /* @__PURE__ */ l.jsx(hd, { variant: "warning", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
    /* @__PURE__ */ l.jsxs("p", { className: "ch-text-sm ch-font-semibold laptop:ch-text-base", children: [
      n,
      /* @__PURE__ */ l.jsx("br", {}),
      i
    ] }),
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-1", children: [
      /* @__PURE__ */ l.jsx("p", { children: t }),
      /* @__PURE__ */ l.jsx("ul", { className: "ch-inner-list ch-list-inside ch-list-disc ch-space-y-1 ch-text-xs", children: o.map((d, c) => /* @__PURE__ */ l.jsx("li", { children: d }, c)) })
    ] })
  ] }) });
}), Fxe = g(({ callbackContext: e, libContext: n }) => {
  const i = x6e(), t = F6e(i.hotelID, i.reservationID, i.lang), a = I(() => {
    t(e.onChangeReservationCallback);
  }, [e.onChangeReservationCallback, t]), { onUpdateReservationDetail: s } = D6e(), { onReservationCancel: r } = E6e({
    ...i,
    callbackContext: {
      onUpdateReservationDetailCallback: s
    }
  }), { onReservationCollectLocalCancelFeeWithBankTransfer: o, onReservationCollectLocalCancelFeeWithCreditStart: d } = Q6e({
    ...i,
    libContext: n,
    callbackContext: {
      ...e,
      onUpdateReservationDetailCallback: s
    }
  }), { onReservationIssuedReceipt: c } = M6e({
    ...i,
    callbackContext: {
      onUpdateReservationDetailCallback: s
    }
  });
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-relative ch-bg-gray-100 ch-pt-20", children: [
    /* @__PURE__ */ l.jsx(
      h5e,
      {
        displayContext: {
          lang: i.lang
        },
        callbackContext: e
      }
    ),
    /* @__PURE__ */ l.jsx("div", { className: "ch-mx-auto ch-space-y-4 tablet:ch-max-w-3xl tablet:ch-px-4", children: /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-4", children: [
      /* @__PURE__ */ l.jsx(
        Sxe,
        {
          displayContext: {
            lang: i.lang,
            requestStatus: i.reservationStatusInfo.requestStatus
          }
        }
      ),
      /* @__PURE__ */ l.jsx(
        gxe,
        {
          displayContext: {
            lang: i.lang,
            actionInfo: i.actionInfo,
            reservationStatusInfo: i.reservationStatusInfo
          }
        }
      ),
      /* @__PURE__ */ l.jsx(
        L6e,
        {
          displayContext: {
            lang: i.lang,
            reservationStatusInfo: i.reservationStatusInfo
          }
        }
      ),
      /* @__PURE__ */ l.jsx(
        k5e,
        {
          displayContext: {
            lang: i.lang,
            reservationID: i.reservationID,
            guestInfo: i.reservationInfo.guestInfo
          }
        }
      ),
      i.reservationStatusInfo.isCanceled ? (
        // キャンセル情報
        /* @__PURE__ */ l.jsx(
          s5e,
          {
            lang: i.lang,
            reservationStatusInfo: i.reservationStatusInfo,
            actionInfo: i.actionInfo,
            priceInfo: i.reservationInfo.priceInfo,
            guestInfo: i.reservationInfo.guestInfo,
            libContext: n,
            callbackContext: {
              onIssuedReceipt: c,
              onPayCancelPriceForCredit: d,
              onPayCancelPriceForBankTransfer: o,
              // 事前決済キャプチャ失敗のキャンセル料も同じミューテーションで徴収する
              // （現地決済との分岐はバックエンドが予約状態から判定する）
              onPayCreditCancelFee: d
            }
          }
        )
      ) : /* @__PURE__ */ l.jsxs(Xs, { children: [
        ke(i.reservationInfo.questionInfo) ? null : (
          // ご利用にあたっての注意事項
          /* @__PURE__ */ l.jsx(
            F5e,
            {
              displayContext: {
                lang: i.lang,
                questionInfo: i.reservationInfo.questionInfo
              }
            }
          )
        ),
        /* @__PURE__ */ l.jsx(
          Nxe,
          {
            lang: i.lang,
            actionInfo: i.actionInfo,
            hotelInfo: i.hotelInfo,
            guestInfo: i.reservationInfo.guestInfo,
            additionalFeeInfo: i.reservationInfo.additionalFeeInfo,
            dateInfo: i.reservationInfo.dateInfo,
            optionInfo: i.reservationInfo.optionInfo,
            timeSlotOptionInfo: i.reservationInfo.timeSlotOptionInfo,
            optionCanceledInfo: i.reservationInfo.optionCanceledInfo,
            planInfo: i.reservationInfo.planInfo,
            planCanceledInfo: i.reservationInfo.planCanceledInfo,
            roomInfo: i.reservationInfo.roomInfo,
            roomCanceledInfo: i.reservationInfo.roomCanceledInfo,
            priceInfo: i.reservationInfo.priceInfo,
            discountInfo: i.reservationInfo.discountInfo,
            voucherInfo: i.reservationInfo.voucherInfo,
            onCancelSubmitCallback: r,
            onIssuedReceiptCallback: c,
            onChangeReservationCallback: a
          }
        )
      ] }),
      /* @__PURE__ */ l.jsx(
        j5e,
        {
          displayContext: {
            lang: i.lang,
            hotelInfo: i.hotelInfo
          }
        }
      ),
      ke(i.hotelInfo.cautions) ? null : /* @__PURE__ */ l.jsx(
        N5e,
        {
          displayContext: {
            lang: i.lang,
            hotelInfo: i.hotelInfo
          }
        }
      )
    ] }) })
  ] });
}), Ixe = ({ lang: e, resetErrorBoundary: n }) => {
  const i = I(() => {
    n();
  }, [n]), t = v(() => wn({
    lang: e,
    i18nString: {
      default: "システムエラーが発生しました。",
      en: "A system error has occurred."
    }
  }), [e]), a = v(() => wn({
    lang: e,
    i18nString: {
      default: "時間をおいてからページを再読み込みしてください。",
      en: "Please reload the page after a while."
    }
  }), [e]), s = v(() => wn({
    lang: e,
    i18nString: {
      default: "再読み込み",
      en: "Reload"
    }
  }), [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-grid ch-h-screen ch-place-content-center ch-place-items-start ch-gap-y-6 ch-px-8 ch-tabular-nums", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-gap-y-2", children: [
      /* @__PURE__ */ l.jsx("h1", { children: t }),
      /* @__PURE__ */ l.jsx("p", { children: a })
    ] }),
    /* @__PURE__ */ l.jsx(ae, { className: "ch-w-full tablet:ch-w-auto", onClick: i, children: s })
  ] });
}, h8 = ({ children: e, ...n }) => {
  const i = I((t, a) => {
    console.error({ error: t }, { info: a });
  }, []);
  return /* @__PURE__ */ l.jsx(
    Nf,
    {
      fallbackRender: (t) => /* @__PURE__ */ l.jsx(Ixe, { ...n, ...t }),
      onError: i,
      children: e
    }
  );
}, yxe = ({ initializeContext: e, callbackContext: n, libContext: i, envContext: t }) => (Nl({
  stage: t.stage,
  componentType: "reservation-detail",
  user: t.user
}), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
  /* @__PURE__ */ l.jsx(h8, { lang: e.lang, children: /* @__PURE__ */ l.jsx(
    d8,
    {
      uri: i.apolloClient.uri,
      lang: e.lang,
      reservationID: e.reservationID,
      children: /* @__PURE__ */ l.jsx(o1, { children: /* @__PURE__ */ l.jsx(g6e, { initializeContext: e, children: /* @__PURE__ */ l.jsx(R6e, { initializeContext: e, children: /* @__PURE__ */ l.jsx(Fxe, { callbackContext: n, libContext: i }) }, e.lang) }) })
    }
  ) }),
  /* @__PURE__ */ l.jsx(l1, {})
] })), bxe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Presenter: yxe
}, Symbol.toStringTag, { value: "Module" })), Cxe = (
  /* GraphQL */
  `
	mutation ReservationAccessTokenClaim($hotelID: ID!, $reservationID: ID!) {
		reservationAccessTokenClaim(hotelID: $hotelID, reservationID: $reservationID) {
			reservationID
			accessToken
		}
	}
`
), xxe = async (e) => {
  var a, s;
  const { uri: n, hotelID: i, reservationID: t } = e;
  try {
    const o = await (await fetch(n, {
      method: "POST",
      headers: { "content-type": "application/json" },
      // Cookie で渡されるトークンを、ブラウザに保存させるため
      ...yC() ? { credentials: "include" } : {},
      body: JSON.stringify({
        query: Cxe,
        variables: { hotelID: i, reservationID: t }
      })
    })).json();
    bC(t, (s = (a = o.data) == null ? void 0 : a.reservationAccessTokenClaim) == null ? void 0 : s.accessToken);
  } catch (r) {
  }
}, Dxe = (e) => () => ({
  kind: "ChillnnErrored",
  lang: e.lang,
  errorMessageForUser: e.errorMessageForUser,
  onFailureCallback: e.callbackContext.onFailureCallback
}), wxe = (e) => () => ({
  kind: "Errored",
  lang: e.lang,
  onFailureCallback: e.callbackContext.onFailureCallback
}), Pxe = (e) => ({
  kind: "Initialized",
  lang: e.lang,
  onReservationCollectLocalCancelFeeWithCreditConfirmCallback: e.callbackContext.onReservationCollectLocalCancelFeeWithCreditConfirm
}), Rxe = (e) => () => ({
  kind: "Succeeded",
  lang: e.lang,
  onSuccessCallback: e.callbackContext.onSuccessCallback
}), Txe = (e) => {
  const [n, i] = se(Pxe(e)), t = I((s) => {
    i(s);
  }, []), a = Ye(!1);
  return be(() => {
    a.current || n.kind !== "Initialized" || (a.current = !0, n.onReservationCollectLocalCancelFeeWithCreditConfirmCallback().then((s) => {
      if (n.kind === "Initialized") {
        if (s.kind === "Success") {
          const r = Rxe(e)(n);
          t(r);
          return;
        }
        if (s.kind === "Error") {
          const r = { ...e, errorMessageForUser: s.errorMessageForUser }, o = Dxe(r)(n);
          t(o);
          return;
        }
      }
    }).catch(() => {
      if (n.kind !== "Initialized")
        return;
      const s = wxe(e)(n);
      t(s);
    }));
  }, [e, n, t]), {
    state: n
  };
}, jxe = bl(
  /* GraphQL */
  `
	mutation TdsccReservationCollectLocalCancelFeeWithCreditComplete($hotelId: ID!, $reservationId: ID!) {
		reservationCollectLocalCancelFeeWithCreditComplete(hotelID: $hotelId, reservationID: $reservationId) {
			reservationDetail {
				hotelID
				reservationID
				reservationStatusInfo {
					isCanceled
					isDayTrip
					requestStatus
					authorizeScheduleNotice
				}
				hotelInfo {
					roomFacilities
					addressInfo {
						postalCode
						coordinate {
							lat
							lon
						}
						address
					}
					tel
					name
					email
					cautions {
						title
						description
					}
					bathroomFacilities
					amenities
				}
				availableActionInfo {
					canCancel
					canEdit
					canEditCreditCard
					canIssueReceipt
					requiredCollectCancelFee {
						transferLimitDt
						bankTransferStatus
						bankTransferDestination {
							branchName
							bankName
							bankAccountType
							bankAccountNumber
							bankAccountHolderName
						}
					}
				}
				reservationInfo {
					guestInfo {
						name
						nameKana
						email
						postalCode
						address
						tel
					}
					questionInfo {
						question
						answers
					}
					priceInfo {
						totalGuestCharge
						willCancelPrice
					}
					discountInfo {
						name
						discountPrice
					}
					voucherInfo {
						name
						discountPrice
					}
					dateInfo {
						isDayTrip
						checkInDt
						checkInStartAt
						checkInEndAt
						checkOutDt
						checkOutEndAt
						isShowCheckInOutTime
					}
					planInfo {
						cancelPolicy {
							chargeRatio
							beforeDays
						}
						price
						name
					}
					planCanceledInfo {
						name
						canceledPrice
						canceledAt
					}
					roomInfo {
						groupCount
						totalPeopleCount
						items {
							kidsNum {
								age
								isCoSleeping
							}
							dailyInfo {
								date
								name
								price
							}
							adultNum
						}
						cancelPolicy {
							beforeDays
							chargeRatio
						}
					}
					roomCanceledInfo {
						kidsNum {
							age
							isCoSleeping
						}
						name
						date
						canceledPrice
						adultNum
						canceledAt
					}
					optionInfo {
						cancelPolicy {
							beforeDays
							chargeRatio
						}
						price
						name
						date
						amount
					}
					optionCanceledInfo {
						date
						name
						amount
						canceledPrice
						canceledAt
					}
					additionalFeeInfo {
						billingTypeTerm
						billingTypeTarget
						name
						price {
							amount
							currencyType
						}
					}
				}
			}
		}
	}
`
), Axe = ({ hotelID: e, reservationID: n }) => {
  const { mutationFunc: i } = v1(
    jxe
  );
  return {
    onReservationCollectLocalCancelFeeWithCreditConfirm: I(async () => {
      try {
        return await i({ variables: { hotelId: e, reservationId: n } }), {
          kind: "Success"
        };
      } catch (a) {
        if (Array.isArray(a)) {
          const s = (o) => o instanceof tD && "chillnnStatusCode" in o.extensions && "chillnnErrorMessageForUser" in o.extensions, r = a.find(s);
          if (r)
            return {
              kind: "Error",
              errorMessageForUser: r.extensions.chillnnErrorMessageForUser
            };
        }
        throw a;
      }
    }, [e, i, n])
  };
}, Oxe = 1e4, Exe = g(({ lang: e, errorMessageForUser: n, callbackContext: i }) => {
  const t = Ye();
  be(() => (t.current = setTimeout(() => {
    i.onFailureCallback();
  }, Oxe), () => {
    t.current && clearTimeout(t.current);
  }), [i]);
  const a = I(() => {
    t.current && (clearTimeout(t.current), i.onFailureCallback());
  }, [i]), s = v(() => e === Y.Default ? n.ja : n.en, [n.en, n.ja, e]), r = v(() => e === Y.Default ? "予約詳細画面に自動で10秒後に遷移します。" : "In approximately 10 seconds, you will be automatically redirected to the reservation details page.", [e]), o = v(() => e === Y.Default ? "手動で遷移" : "Manual transition", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-text-center", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-font-bold", children: s }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-text-sm ch-text-gray-500", children: r })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-text-center", children: /* @__PURE__ */ l.jsx(ae, { variant: "default", size: "default", onClick: a, children: o }) })
  ] });
}), Jxe = 1e4, _xe = g(({ lang: e, callbackContext: n }) => {
  const i = Ye();
  be(() => (i.current = setTimeout(() => {
    n.onFailureCallback();
  }, Jxe), () => {
    i.current && clearTimeout(i.current);
  }), [n]);
  const t = I(() => {
    i.current && (clearTimeout(i.current), n.onFailureCallback());
  }, [n]), a = v(() => e === Y.Default ? `キャンセル料金の支払いに失敗しました。
お手数をおかけしますが、再度お試しください。` : `Failed to process payment of cancellation fee.
We apologize for the inconvenience, please try again.`, [e]), s = v(() => e === Y.Default ? "予約詳細画面に自動で10秒後に遷移します。" : "In approximately 10 seconds, you will be automatically redirected to the reservation details page.", [e]), r = v(() => e === Y.Default ? "手動で遷移" : "Manual transition", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-6", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-text-center", children: [
      /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-font-bold", children: a }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-text-sm ch-text-gray-500", children: s })
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "ch-text-center", children: /* @__PURE__ */ l.jsx(ae, { variant: "default", size: "default", onClick: t, children: r }) })
  ] });
}), Qxe = g(({ lang: e }) => {
  const n = v(() => e === Y.Default ? "キャンセル料金支払い処理実行中" : "Processing payment of cancellation fee", [e]), i = v(() => kn({
    lang: e,
    i18nString: {
      default: "処理が完了するまでブラウザやタブを閉じないでください。キャンセル料金支払い処理が正常に完了しない場合があります。",
      en: "Please do not close the browser or tab until the process is complete. The reservation process may not be completed properly."
    }
  }), [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-flex ch-flex-col ch-justify-center ch-space-y-5", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2", children: [
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
        "svg",
        {
          "aria-hidden": "true",
          focusable: "false",
          "data-prefix": "far",
          "data-icon": "spinner",
          className: "ch-mx-auto ch-h-10 ch-w-10 ch-animate-spin",
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 512 512",
          children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M296 48c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-40 376c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm248-168c0-22.091-17.909-40-40-40s-40 17.909-40 40 17.909 40 40 40 40-17.909 40-40zm-416 0c0-22.091-17.909-40-40-40S8 233.909 8 256s17.909 40 40 40 40-17.909 40-40zm20.922-187.078c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40c0-22.092-17.909-40-40-40zm294.156 294.156c-22.091 0-40 17.909-40 40s17.909 40 40 40c22.092 0 40-17.909 40-40s-17.908-40-40-40zm-294.156 0c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40z"
            }
          )
        }
      ) }),
      /* @__PURE__ */ l.jsx("p", { className: "ch-text-center", children: n })
    ] }),
    /* @__PURE__ */ l.jsx(hd, { variant: "warning", children: i })
  ] });
}), Mxe = 4e3, Lxe = g(({ lang: e, callbackContext: n }) => {
  be(() => {
    const a = setTimeout(() => {
      n.onSuccessCallback();
    }, Mxe);
    return () => {
      clearTimeout(a);
    };
  }, [n]);
  const i = v(() => e === Y.Default ? "認証に成功しました。また、メールもご確認ください。" : `We have successfully authenticated your information.
Please check your email for further details.`, [e]), t = v(() => e === Y.Default ? "予約詳細画面に自動で3~5秒後に遷移します。" : "In approximately 3-5 seconds, you will be automatically redirected to the reservation details page.", [e]);
  return /* @__PURE__ */ l.jsxs("div", { className: "ch-space-y-2 ch-text-center", children: [
    /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-font-bold", children: i }),
    /* @__PURE__ */ l.jsx("p", { className: "ch-whitespace-pre-line ch-text-sm ch-text-gray-500", children: t })
  ] });
}), $xe = g(({ hotelID: e, reservationID: n, lang: i, callbackContext: t }) => {
  const { onReservationCollectLocalCancelFeeWithCreditConfirm: a } = Axe({ hotelID: e, reservationID: n }), { onDisableBeforeUnload: s } = gd(), { state: r } = Txe({
    lang: i,
    callbackContext: {
      onReservationCollectLocalCancelFeeWithCreditConfirm: a,
      onSuccessCallback: t.onSuccessCallback,
      onFailureCallback: t.onFailureCallback
    }
  });
  return r.kind === "Succeeded" ? (s(), /* @__PURE__ */ l.jsx(
    Lxe,
    {
      lang: i,
      callbackContext: {
        onSuccessCallback: r.onSuccessCallback
      }
    }
  )) : r.kind === "ChillnnErrored" ? (s(), /* @__PURE__ */ l.jsx(
    Exe,
    {
      lang: i,
      errorMessageForUser: r.errorMessageForUser,
      callbackContext: {
        onFailureCallback: r.onFailureCallback
      }
    }
  )) : r.kind === "Errored" ? (s(), /* @__PURE__ */ l.jsx(
    _xe,
    {
      lang: i,
      callbackContext: {
        onFailureCallback: r.onFailureCallback
      }
    }
  )) : /* @__PURE__ */ l.jsx(Qxe, { lang: i });
}), Uxe = ({ libContext: e, envContext: n, ...i }) => (Nl({
  stage: n.stage,
  componentType: "three-d-secure-confirm",
  user: n.user
}), r1(), /* @__PURE__ */ l.jsx(h8, { lang: i.lang, children: /* @__PURE__ */ l.jsx(d8, { uri: e.apolloClient.uri, lang: i.lang, reservationID: i.reservationID, children: /* @__PURE__ */ l.jsx(s1, { children: /* @__PURE__ */ l.jsx(
  rs,
  {
    className: "ch-fixed ch-inset-0 ch-z-[100]",
    slideUp: !0,
    initial: { opacity: 1, transform: "translateY(100%)" },
    animate: { opacity: 1, transform: "translateY(0)" },
    exit: { opacity: 1, transform: "translateY(100%)" },
    children: /* @__PURE__ */ l.jsx("div", { className: "ch-flex ch-h-screen ch-w-full ch-items-center ch-justify-center ch-bg-black/60 ch-px-4", children: /* @__PURE__ */ l.jsx("div", { className: "ch-w-full ch-max-w-md ch-rounded-lg ch-border ch-border-gray-200 ch-bg-white ch-p-6 ch-shadow-lg", children: /* @__PURE__ */ l.jsx($xe, { ...i }) }) })
  }
) }) }) })), Vxe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Presenter: Uxe
}, Symbol.toStringTag, { value: "Module" })), Hxe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get BankTransferStatus() {
    return fr;
  },
  get BillingTypeTarget() {
    return $s;
  },
  get BillingTypeTargetForOption() {
    return G2;
  },
  get BillingTypeTerm() {
    return vr;
  },
  get CurrencyType() {
    return W2;
  },
  get CustomTypeRoomTitle() {
    return ys;
  },
  get LangCode() {
    return Y;
  },
  get MealType() {
    return K2;
  },
  get OptionType() {
    return Y2;
  },
  get PaymentMethod() {
    return X2;
  },
  get QuestionType() {
    return Z2;
  },
  RdgReservationAccessCheckDocument: i8,
  RdgReservationAccessTelLast4SendDocument: e8,
  RdgReservationAccessTokenIssueDocument: n8,
  RdgReservationCancelDocument: a8,
  RdgReservationCollectLocalCancelFeeWithBankTransferDocument: l8,
  RdgReservationCollectLocalCancelFeeWithCreditStartDocument: s8,
  RdgReservationInitialDetailDocument: t8,
  RdgReservationIssuedReceiptDocument: r8,
  get RequestStatus() {
    return Fa;
  },
  get ReservationAccessStatus() {
    return Ys;
  },
  ReservationDetailComponent: bxe,
  TdsccReservationCollectLocalCancelFeeWithCreditCompleteDocument: o8,
  ThreeDSecureConfirmToCollectCancelFeeComponent: Vxe,
  claimReservationAccessToken: xxe
}, Symbol.toStringTag, { value: "Module" })), gDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Guest: Hxe
}, Symbol.toStringTag, { value: "Module" }));
export {
  Yxe as BeforeUnloadPolicyProvider,
  Xxe as BestRateNoticePolicyProvider,
  NDe as Guest,
  SDe as Host,
  Wxe as PortalContainerProvider,
  gDe as ReservationDetail,
  yr as usePortalContainer
};
